import * as p from "react";
import xe, { isValidElement as $le, version as _le, useContext as Cr, createContext as Ws, useRef as ct, useLayoutEffect as Ele, useEffect as St, useState as He, forwardRef as Aa, useMemo as dr, createRef as wle, Children as Ole, useCallback as Bt, useImperativeHandle as fo, cloneElement as Tle, createElement as _3, Component as Ile } from "react";
import * as Mle from "react-dom";
import xb, { createPortal as _F, unstable_batchedUpdates as EF, flushSync as e2 } from "react-dom";
var Ue = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ut(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function p1(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var t2 = { exports: {} }, ff = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var E3;
function Ale() {
  if (E3) return ff;
  E3 = 1;
  var e = xe, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, l, c) {
    var u, d = {}, f = null, m = null;
    c !== void 0 && (f = "" + c), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (m = l.ref);
    for (u in l) n.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps) for (u in l = s.defaultProps, l) d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: f, ref: m, props: d, _owner: a.current };
  }
  return ff.Fragment = r, ff.jsx = o, ff.jsxs = o, ff;
}
var pf = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var w3;
function Ple() {
  return w3 || (w3 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = xe, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), h = Symbol.iterator, g = "@@iterator";
    function y(_e) {
      if (_e === null || typeof _e != "object")
        return null;
      var Ke = h && _e[h] || _e[g];
      return typeof Ke == "function" ? Ke : null;
    }
    var S = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(_e) {
      {
        for (var Ke = arguments.length, nt = new Array(Ke > 1 ? Ke - 1 : 0), Ve = 1; Ve < Ke; Ve++)
          nt[Ve - 1] = arguments[Ve];
        b("error", _e, nt);
      }
    }
    function b(_e, Ke, nt) {
      {
        var Ve = S.ReactDebugCurrentFrame, ke = Ve.getStackAddendum();
        ke !== "" && (Ke += "%s", nt = nt.concat([ke]));
        var ut = nt.map(function(st) {
          return String(st);
        });
        ut.unshift("Warning: " + Ke), Function.prototype.apply.call(console[_e], console, ut);
      }
    }
    var _ = !1, $ = !1, w = !1, O = !1, T = !1, I;
    I = Symbol.for("react.module.reference");
    function P(_e) {
      return !!(typeof _e == "string" || typeof _e == "function" || _e === n || _e === i || T || _e === a || _e === c || _e === u || O || _e === m || _ || $ || w || typeof _e == "object" && _e !== null && (_e.$$typeof === f || _e.$$typeof === d || _e.$$typeof === o || _e.$$typeof === s || _e.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      _e.$$typeof === I || _e.getModuleId !== void 0));
    }
    function D(_e, Ke, nt) {
      var Ve = _e.displayName;
      if (Ve)
        return Ve;
      var ke = Ke.displayName || Ke.name || "";
      return ke !== "" ? nt + "(" + ke + ")" : nt;
    }
    function B(_e) {
      return _e.displayName || "Context";
    }
    function L(_e) {
      if (_e == null)
        return null;
      if (typeof _e.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof _e == "function")
        return _e.displayName || _e.name || null;
      if (typeof _e == "string")
        return _e;
      switch (_e) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof _e == "object")
        switch (_e.$$typeof) {
          case s:
            var Ke = _e;
            return B(Ke) + ".Consumer";
          case o:
            var nt = _e;
            return B(nt._context) + ".Provider";
          case l:
            return D(_e, _e.render, "ForwardRef");
          case d:
            var Ve = _e.displayName || null;
            return Ve !== null ? Ve : L(_e.type) || "Memo";
          case f: {
            var ke = _e, ut = ke._payload, st = ke._init;
            try {
              return L(st(ut));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var N = Object.assign, z = 0, F, j, H, U, G, V, K;
    function Z() {
    }
    Z.__reactDisabledLog = !0;
    function ee() {
      {
        if (z === 0) {
          F = console.log, j = console.info, H = console.warn, U = console.error, G = console.group, V = console.groupCollapsed, K = console.groupEnd;
          var _e = {
            configurable: !0,
            enumerable: !0,
            value: Z,
            writable: !0
          };
          Object.defineProperties(console, {
            info: _e,
            log: _e,
            warn: _e,
            error: _e,
            group: _e,
            groupCollapsed: _e,
            groupEnd: _e
          });
        }
        z++;
      }
    }
    function ae() {
      {
        if (z--, z === 0) {
          var _e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: N({}, _e, {
              value: F
            }),
            info: N({}, _e, {
              value: j
            }),
            warn: N({}, _e, {
              value: H
            }),
            error: N({}, _e, {
              value: U
            }),
            group: N({}, _e, {
              value: G
            }),
            groupCollapsed: N({}, _e, {
              value: V
            }),
            groupEnd: N({}, _e, {
              value: K
            })
          });
        }
        z < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ue = S.ReactCurrentDispatcher, re;
    function oe(_e, Ke, nt) {
      {
        if (re === void 0)
          try {
            throw Error();
          } catch (ke) {
            var Ve = ke.stack.trim().match(/\n( *(at )?)/);
            re = Ve && Ve[1] || "";
          }
        return `
` + re + _e;
      }
    }
    var fe = !1, le;
    {
      var se = typeof WeakMap == "function" ? WeakMap : Map;
      le = new se();
    }
    function Q(_e, Ke) {
      if (!_e || fe)
        return "";
      {
        var nt = le.get(_e);
        if (nt !== void 0)
          return nt;
      }
      var Ve;
      fe = !0;
      var ke = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ut;
      ut = ue.current, ue.current = null, ee();
      try {
        if (Ke) {
          var st = function() {
            throw Error();
          };
          if (Object.defineProperty(st.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(st, []);
            } catch (ir) {
              Ve = ir;
            }
            Reflect.construct(_e, [], st);
          } else {
            try {
              st.call();
            } catch (ir) {
              Ve = ir;
            }
            _e.call(st.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ir) {
            Ve = ir;
          }
          _e();
        }
      } catch (ir) {
        if (ir && Ve && typeof ir.stack == "string") {
          for (var Et = ir.stack.split(`
`), zt = Ve.stack.split(`
`), Be = Et.length - 1, ft = zt.length - 1; Be >= 1 && ft >= 0 && Et[Be] !== zt[ft]; )
            ft--;
          for (; Be >= 1 && ft >= 0; Be--, ft--)
            if (Et[Be] !== zt[ft]) {
              if (Be !== 1 || ft !== 1)
                do
                  if (Be--, ft--, ft < 0 || Et[Be] !== zt[ft]) {
                    var yt = `
` + Et[Be].replace(" at new ", " at ");
                    return _e.displayName && yt.includes("<anonymous>") && (yt = yt.replace("<anonymous>", _e.displayName)), typeof _e == "function" && le.set(_e, yt), yt;
                  }
                while (Be >= 1 && ft >= 0);
              break;
            }
        }
      } finally {
        fe = !1, ue.current = ut, ae(), Error.prepareStackTrace = ke;
      }
      var Rt = _e ? _e.displayName || _e.name : "", Ht = Rt ? oe(Rt) : "";
      return typeof _e == "function" && le.set(_e, Ht), Ht;
    }
    function he(_e, Ke, nt) {
      return Q(_e, !1);
    }
    function ne(_e) {
      var Ke = _e.prototype;
      return !!(Ke && Ke.isReactComponent);
    }
    function me(_e, Ke, nt) {
      if (_e == null)
        return "";
      if (typeof _e == "function")
        return Q(_e, ne(_e));
      if (typeof _e == "string")
        return oe(_e);
      switch (_e) {
        case c:
          return oe("Suspense");
        case u:
          return oe("SuspenseList");
      }
      if (typeof _e == "object")
        switch (_e.$$typeof) {
          case l:
            return he(_e.render);
          case d:
            return me(_e.type, Ke, nt);
          case f: {
            var Ve = _e, ke = Ve._payload, ut = Ve._init;
            try {
              return me(ut(ke), Ke, nt);
            } catch {
            }
          }
        }
      return "";
    }
    var k = Object.prototype.hasOwnProperty, M = {}, R = S.ReactDebugCurrentFrame;
    function q(_e) {
      if (_e) {
        var Ke = _e._owner, nt = me(_e.type, _e._source, Ke ? Ke.type : null);
        R.setExtraStackFrame(nt);
      } else
        R.setExtraStackFrame(null);
    }
    function Y(_e, Ke, nt, Ve, ke) {
      {
        var ut = Function.call.bind(k);
        for (var st in _e)
          if (ut(_e, st)) {
            var Et = void 0;
            try {
              if (typeof _e[st] != "function") {
                var zt = Error((Ve || "React class") + ": " + nt + " type `" + st + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof _e[st] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw zt.name = "Invariant Violation", zt;
              }
              Et = _e[st](Ke, st, Ve, nt, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Be) {
              Et = Be;
            }
            Et && !(Et instanceof Error) && (q(ke), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ve || "React class", nt, st, typeof Et), q(null)), Et instanceof Error && !(Et.message in M) && (M[Et.message] = !0, q(ke), x("Failed %s type: %s", nt, Et.message), q(null));
          }
      }
    }
    var X = Array.isArray;
    function pe(_e) {
      return X(_e);
    }
    function $e(_e) {
      {
        var Ke = typeof Symbol == "function" && Symbol.toStringTag, nt = Ke && _e[Symbol.toStringTag] || _e.constructor.name || "Object";
        return nt;
      }
    }
    function J(_e) {
      try {
        return de(_e), !1;
      } catch {
        return !0;
      }
    }
    function de(_e) {
      return "" + _e;
    }
    function Se(_e) {
      if (J(_e))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $e(_e)), de(_e);
    }
    var Ee = S.ReactCurrentOwner, Te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Le, Ie;
    function De(_e) {
      if (k.call(_e, "ref")) {
        var Ke = Object.getOwnPropertyDescriptor(_e, "ref").get;
        if (Ke && Ke.isReactWarning)
          return !1;
      }
      return _e.ref !== void 0;
    }
    function Ae(_e) {
      if (k.call(_e, "key")) {
        var Ke = Object.getOwnPropertyDescriptor(_e, "key").get;
        if (Ke && Ke.isReactWarning)
          return !1;
      }
      return _e.key !== void 0;
    }
    function Fe(_e, Ke) {
      typeof _e.ref == "string" && Ee.current;
    }
    function Ne(_e, Ke) {
      {
        var nt = function() {
          Le || (Le = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ke));
        };
        nt.isReactWarning = !0, Object.defineProperty(_e, "key", {
          get: nt,
          configurable: !0
        });
      }
    }
    function qe(_e, Ke) {
      {
        var nt = function() {
          Ie || (Ie = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ke));
        };
        nt.isReactWarning = !0, Object.defineProperty(_e, "ref", {
          get: nt,
          configurable: !0
        });
      }
    }
    var Qe = function(_e, Ke, nt, Ve, ke, ut, st) {
      var Et = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: _e,
        key: Ke,
        ref: nt,
        props: st,
        // Record the component responsible for creating this element.
        _owner: ut
      };
      return Et._store = {}, Object.defineProperty(Et._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Et, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ve
      }), Object.defineProperty(Et, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ke
      }), Object.freeze && (Object.freeze(Et.props), Object.freeze(Et)), Et;
    };
    function tt(_e, Ke, nt, Ve, ke) {
      {
        var ut, st = {}, Et = null, zt = null;
        nt !== void 0 && (Se(nt), Et = "" + nt), Ae(Ke) && (Se(Ke.key), Et = "" + Ke.key), De(Ke) && (zt = Ke.ref, Fe(Ke, ke));
        for (ut in Ke)
          k.call(Ke, ut) && !Te.hasOwnProperty(ut) && (st[ut] = Ke[ut]);
        if (_e && _e.defaultProps) {
          var Be = _e.defaultProps;
          for (ut in Be)
            st[ut] === void 0 && (st[ut] = Be[ut]);
        }
        if (Et || zt) {
          var ft = typeof _e == "function" ? _e.displayName || _e.name || "Unknown" : _e;
          Et && Ne(st, ft), zt && qe(st, ft);
        }
        return Qe(_e, Et, zt, ke, Ve, Ee.current, st);
      }
    }
    var Ge = S.ReactCurrentOwner, it = S.ReactDebugCurrentFrame;
    function ht(_e) {
      if (_e) {
        var Ke = _e._owner, nt = me(_e.type, _e._source, Ke ? Ke.type : null);
        it.setExtraStackFrame(nt);
      } else
        it.setExtraStackFrame(null);
    }
    var It;
    It = !1;
    function xt(_e) {
      return typeof _e == "object" && _e !== null && _e.$$typeof === t;
    }
    function Xe() {
      {
        if (Ge.current) {
          var _e = L(Ge.current.type);
          if (_e)
            return `

Check the render method of \`` + _e + "`.";
        }
        return "";
      }
    }
    function pt(_e) {
      return "";
    }
    var Ze = {};
    function wt(_e) {
      {
        var Ke = Xe();
        if (!Ke) {
          var nt = typeof _e == "string" ? _e : _e.displayName || _e.name;
          nt && (Ke = `

Check the top-level render call using <` + nt + ">.");
        }
        return Ke;
      }
    }
    function bt(_e, Ke) {
      {
        if (!_e._store || _e._store.validated || _e.key != null)
          return;
        _e._store.validated = !0;
        var nt = wt(Ke);
        if (Ze[nt])
          return;
        Ze[nt] = !0;
        var Ve = "";
        _e && _e._owner && _e._owner !== Ge.current && (Ve = " It was passed a child from " + L(_e._owner.type) + "."), ht(_e), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', nt, Ve), ht(null);
      }
    }
    function Je(_e, Ke) {
      {
        if (typeof _e != "object")
          return;
        if (pe(_e))
          for (var nt = 0; nt < _e.length; nt++) {
            var Ve = _e[nt];
            xt(Ve) && bt(Ve, Ke);
          }
        else if (xt(_e))
          _e._store && (_e._store.validated = !0);
        else if (_e) {
          var ke = y(_e);
          if (typeof ke == "function" && ke !== _e.entries)
            for (var ut = ke.call(_e), st; !(st = ut.next()).done; )
              xt(st.value) && bt(st.value, Ke);
        }
      }
    }
    function _t(_e) {
      {
        var Ke = _e.type;
        if (Ke == null || typeof Ke == "string")
          return;
        var nt;
        if (typeof Ke == "function")
          nt = Ke.propTypes;
        else if (typeof Ke == "object" && (Ke.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Ke.$$typeof === d))
          nt = Ke.propTypes;
        else
          return;
        if (nt) {
          var Ve = L(Ke);
          Y(nt, _e.props, "prop", Ve, _e);
        } else if (Ke.PropTypes !== void 0 && !It) {
          It = !0;
          var ke = L(Ke);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ke || "Unknown");
        }
        typeof Ke.getDefaultProps == "function" && !Ke.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vt(_e) {
      {
        for (var Ke = Object.keys(_e.props), nt = 0; nt < Ke.length; nt++) {
          var Ve = Ke[nt];
          if (Ve !== "children" && Ve !== "key") {
            ht(_e), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ve), ht(null);
            break;
          }
        }
        _e.ref !== null && (ht(_e), x("Invalid attribute `ref` supplied to `React.Fragment`."), ht(null));
      }
    }
    function ot(_e, Ke, nt, Ve, ke, ut) {
      {
        var st = P(_e);
        if (!st) {
          var Et = "";
          (_e === void 0 || typeof _e == "object" && _e !== null && Object.keys(_e).length === 0) && (Et += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var zt = pt();
          zt ? Et += zt : Et += Xe();
          var Be;
          _e === null ? Be = "null" : pe(_e) ? Be = "array" : _e !== void 0 && _e.$$typeof === t ? (Be = "<" + (L(_e.type) || "Unknown") + " />", Et = " Did you accidentally export a JSX literal instead of a component?") : Be = typeof _e, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Be, Et);
        }
        var ft = tt(_e, Ke, nt, ke, ut);
        if (ft == null)
          return ft;
        if (st) {
          var yt = Ke.children;
          if (yt !== void 0)
            if (Ve)
              if (pe(yt)) {
                for (var Rt = 0; Rt < yt.length; Rt++)
                  Je(yt[Rt], _e);
                Object.freeze && Object.freeze(yt);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Je(yt, _e);
        }
        return _e === n ? Vt(ft) : _t(ft), ft;
      }
    }
    function Ct(_e, Ke, nt) {
      return ot(_e, Ke, nt, !0);
    }
    function rt(_e, Ke, nt) {
      return ot(_e, Ke, nt, !1);
    }
    var $t = rt, Wt = Ct;
    pf.Fragment = n, pf.jsx = $t, pf.jsxs = Wt;
  }()), pf;
}
process.env.NODE_ENV === "production" ? t2.exports = Ale() : t2.exports = Ple();
var E = t2.exports;
function qZe(e) {
  return /* @__PURE__ */ E.jsx("div", { className: "text-red-500", children: /* @__PURE__ */ E.jsx("h1", { children: "Welcome to TestUI!" }) });
}
var wF = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var i = "", o = 0; o < arguments.length; o++) {
        var s = arguments[o];
        s && (i = a(i, n(s)));
      }
      return i;
    }
    function n(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return r.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var o = "";
      for (var s in i)
        t.call(i, s) && i[s] && (o = a(o, s));
      return o;
    }
    function a(i, o) {
      return o ? i ? i + " " + o : i + o : i;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(wF);
var Rle = wF.exports;
const be = /* @__PURE__ */ Ut(Rle);
function Pe() {
  return Pe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pe.apply(null, arguments);
}
var r2 = { exports: {} }, on = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var O3;
function Nle() {
  if (O3) return on;
  O3 = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), h;
  h = Symbol.for("react.module.reference");
  function g(y) {
    if (typeof y == "object" && y !== null) {
      var S = y.$$typeof;
      switch (S) {
        case e:
          switch (y = y.type, y) {
            case r:
            case a:
            case n:
            case c:
            case u:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case o:
                case l:
                case f:
                case d:
                case i:
                  return y;
                default:
                  return S;
              }
          }
        case t:
          return S;
      }
    }
  }
  return on.ContextConsumer = o, on.ContextProvider = i, on.Element = e, on.ForwardRef = l, on.Fragment = r, on.Lazy = f, on.Memo = d, on.Portal = t, on.Profiler = a, on.StrictMode = n, on.Suspense = c, on.SuspenseList = u, on.isAsyncMode = function() {
    return !1;
  }, on.isConcurrentMode = function() {
    return !1;
  }, on.isContextConsumer = function(y) {
    return g(y) === o;
  }, on.isContextProvider = function(y) {
    return g(y) === i;
  }, on.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, on.isForwardRef = function(y) {
    return g(y) === l;
  }, on.isFragment = function(y) {
    return g(y) === r;
  }, on.isLazy = function(y) {
    return g(y) === f;
  }, on.isMemo = function(y) {
    return g(y) === d;
  }, on.isPortal = function(y) {
    return g(y) === t;
  }, on.isProfiler = function(y) {
    return g(y) === a;
  }, on.isStrictMode = function(y) {
    return g(y) === n;
  }, on.isSuspense = function(y) {
    return g(y) === c;
  }, on.isSuspenseList = function(y) {
    return g(y) === u;
  }, on.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === r || y === a || y === n || y === c || y === u || y === m || typeof y == "object" && y !== null && (y.$$typeof === f || y.$$typeof === d || y.$$typeof === i || y.$$typeof === o || y.$$typeof === l || y.$$typeof === h || y.getModuleId !== void 0);
  }, on.typeOf = g, on;
}
var sn = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var T3;
function Dle() {
  return T3 || (T3 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), h = !1, g = !1, y = !1, S = !1, x = !1, b;
    b = Symbol.for("react.module.reference");
    function _(ne) {
      return !!(typeof ne == "string" || typeof ne == "function" || ne === r || ne === a || x || ne === n || ne === c || ne === u || S || ne === m || h || g || y || typeof ne == "object" && ne !== null && (ne.$$typeof === f || ne.$$typeof === d || ne.$$typeof === i || ne.$$typeof === o || ne.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ne.$$typeof === b || ne.getModuleId !== void 0));
    }
    function $(ne) {
      if (typeof ne == "object" && ne !== null) {
        var me = ne.$$typeof;
        switch (me) {
          case e:
            var k = ne.type;
            switch (k) {
              case r:
              case a:
              case n:
              case c:
              case u:
                return k;
              default:
                var M = k && k.$$typeof;
                switch (M) {
                  case s:
                  case o:
                  case l:
                  case f:
                  case d:
                  case i:
                    return M;
                  default:
                    return me;
                }
            }
          case t:
            return me;
        }
      }
    }
    var w = o, O = i, T = e, I = l, P = r, D = f, B = d, L = t, N = a, z = n, F = c, j = u, H = !1, U = !1;
    function G(ne) {
      return H || (H = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function V(ne) {
      return U || (U = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function K(ne) {
      return $(ne) === o;
    }
    function Z(ne) {
      return $(ne) === i;
    }
    function ee(ne) {
      return typeof ne == "object" && ne !== null && ne.$$typeof === e;
    }
    function ae(ne) {
      return $(ne) === l;
    }
    function ue(ne) {
      return $(ne) === r;
    }
    function re(ne) {
      return $(ne) === f;
    }
    function oe(ne) {
      return $(ne) === d;
    }
    function fe(ne) {
      return $(ne) === t;
    }
    function le(ne) {
      return $(ne) === a;
    }
    function se(ne) {
      return $(ne) === n;
    }
    function Q(ne) {
      return $(ne) === c;
    }
    function he(ne) {
      return $(ne) === u;
    }
    sn.ContextConsumer = w, sn.ContextProvider = O, sn.Element = T, sn.ForwardRef = I, sn.Fragment = P, sn.Lazy = D, sn.Memo = B, sn.Portal = L, sn.Profiler = N, sn.StrictMode = z, sn.Suspense = F, sn.SuspenseList = j, sn.isAsyncMode = G, sn.isConcurrentMode = V, sn.isContextConsumer = K, sn.isContextProvider = Z, sn.isElement = ee, sn.isForwardRef = ae, sn.isFragment = ue, sn.isLazy = re, sn.isMemo = oe, sn.isPortal = fe, sn.isProfiler = le, sn.isStrictMode = se, sn.isSuspense = Q, sn.isSuspenseList = he, sn.isValidElementType = _, sn.typeOf = $;
  }()), sn;
}
process.env.NODE_ENV === "production" ? r2.exports = Nle() : r2.exports = Dle();
var T0 = r2.exports;
function Ma(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [];
  return xe.Children.forEach(e, function(n) {
    n == null && !t.keepEmpty || (Array.isArray(n) ? r = r.concat(Ma(n)) : T0.isFragment(n) && n.props ? r = r.concat(Ma(n.props.children, t)) : r.push(n));
  }), r;
}
var n2 = {}, gT = [], jle = function(t) {
  gT.push(t);
};
function ls(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var r = gT.reduce(function(n, a) {
      return a(n ?? "", "warning");
    }, t);
    r && console.error("Warning: ".concat(r));
  }
}
function Lle(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var r = gT.reduce(function(n, a) {
      return a(n ?? "", "note");
    }, t);
    r && console.warn("Note: ".concat(r));
  }
}
function OF() {
  n2 = {};
}
function TF(e, t, r) {
  !t && !n2[r] && (e(!1, r), n2[r] = !0);
}
function jt(e, t) {
  TF(ls, e, t);
}
function $b(e, t) {
  TF(Lle, e, t);
}
jt.preMessage = jle;
jt.resetWarned = OF;
jt.noteOnce = $b;
function kt(e) {
  "@babel/helpers - typeof";
  return kt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, kt(e);
}
function kle(e, t) {
  if (kt(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (kt(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function IF(e) {
  var t = kle(e, "string");
  return kt(t) == "symbol" ? t : t + "";
}
function te(e, t, r) {
  return (t = IF(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function I3(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ce(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? I3(Object(r), !0).forEach(function(n) {
      te(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : I3(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function F0(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function MF(e) {
  return e && kt(e) === "object" && F0(e.nativeElement) ? e.nativeElement : F0(e) ? e : null;
}
function I0(e) {
  var t = MF(e);
  if (t)
    return t;
  if (e instanceof xe.Component) {
    var r;
    return (r = xb.findDOMNode) === null || r === void 0 ? void 0 : r.call(xb, e);
  }
  return null;
}
function Pc(e, t, r) {
  var n = p.useRef({});
  return (!("value" in n.current) || r(n.current.condition, t)) && (n.current.value = e(), n.current.condition = t), n.current.value;
}
var B0 = function(t, r) {
  typeof t == "function" ? t(r) : kt(t) === "object" && t && "current" in t && (t.current = r);
}, Za = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var a = r.filter(Boolean);
  return a.length <= 1 ? a[0] : function(i) {
    r.forEach(function(o) {
      B0(o, i);
    });
  };
}, qs = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return Pc(function() {
    return Za.apply(void 0, r);
  }, r, function(a, i) {
    return a.length !== i.length || a.every(function(o, s) {
      return o !== i[s];
    });
  });
}, No = function(t) {
  var r, n, a = T0.isMemo(t) ? t.type.type : t.type;
  return !(typeof a == "function" && !((r = a.prototype) !== null && r !== void 0 && r.render) && a.$$typeof !== T0.ForwardRef || typeof t == "function" && !((n = t.prototype) !== null && n !== void 0 && n.render) && t.$$typeof !== T0.ForwardRef);
};
function a2(e) {
  return /* @__PURE__ */ $le(e) && !T0.isFragment(e);
}
var Fle = function(t) {
  return a2(t) && No(t);
};
Number(_le.split(".")[0]) >= 19;
var i2 = /* @__PURE__ */ p.createContext(null);
function Ble(e) {
  var t = e.children, r = e.onBatchResize, n = p.useRef(0), a = p.useRef([]), i = p.useContext(i2), o = p.useCallback(function(s, l, c) {
    n.current += 1;
    var u = n.current;
    a.current.push({
      size: s,
      element: l,
      data: c
    }), Promise.resolve().then(function() {
      u === n.current && (r?.(a.current), a.current = []);
    }), i?.(s, l, c);
  }, [r, i]);
  return /* @__PURE__ */ p.createElement(i2.Provider, {
    value: o
  }, t);
}
var AF = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, r) {
    var n = -1;
    return t.some(function(a, i) {
      return a[0] === r ? (n = i, !0) : !1;
    }), n;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(r) {
        var n = e(this.__entries__, r), a = this.__entries__[n];
        return a && a[1];
      }, t.prototype.set = function(r, n) {
        var a = e(this.__entries__, r);
        ~a ? this.__entries__[a][1] = n : this.__entries__.push([r, n]);
      }, t.prototype.delete = function(r) {
        var n = this.__entries__, a = e(n, r);
        ~a && n.splice(a, 1);
      }, t.prototype.has = function(r) {
        return !!~e(this.__entries__, r);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(r, n) {
        n === void 0 && (n = null);
        for (var a = 0, i = this.__entries__; a < i.length; a++) {
          var o = i[a];
          r.call(n, o[1], o[0]);
        }
      }, t;
    }()
  );
}(), o2 = typeof window < "u" && typeof document < "u" && window.document === document, _b = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), zle = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(_b) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), Hle = 2;
function Vle(e, t) {
  var r = !1, n = !1, a = 0;
  function i() {
    r && (r = !1, e()), n && s();
  }
  function o() {
    zle(i);
  }
  function s() {
    var l = Date.now();
    if (r) {
      if (l - a < Hle)
        return;
      n = !0;
    } else
      r = !0, n = !1, setTimeout(o, t);
    a = l;
  }
  return s;
}
var Gle = 20, Ule = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], Wle = typeof MutationObserver < "u", qle = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = Vle(this.refresh.bind(this), Gle);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var r = this.observers_, n = r.indexOf(t);
      ~n && r.splice(n, 1), !r.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(r) {
        return r.gatherActive(), r.hasActive();
      });
      return t.forEach(function(r) {
        return r.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !o2 || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Wle ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !o2 || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var r = t.propertyName, n = r === void 0 ? "" : r, a = Ule.some(function(i) {
        return !!~n.indexOf(i);
      });
      a && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), PF = function(e, t) {
  for (var r = 0, n = Object.keys(t); r < n.length; r++) {
    var a = n[r];
    Object.defineProperty(e, a, {
      value: t[a],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, ad = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || _b;
}, RF = m1(0, 0, 0, 0);
function Eb(e) {
  return parseFloat(e) || 0;
}
function M3(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return t.reduce(function(n, a) {
    var i = e["border-" + a + "-width"];
    return n + Eb(i);
  }, 0);
}
function Kle(e) {
  for (var t = ["top", "right", "bottom", "left"], r = {}, n = 0, a = t; n < a.length; n++) {
    var i = a[n], o = e["padding-" + i];
    r[i] = Eb(o);
  }
  return r;
}
function Yle(e) {
  var t = e.getBBox();
  return m1(0, 0, t.width, t.height);
}
function Zle(e) {
  var t = e.clientWidth, r = e.clientHeight;
  if (!t && !r)
    return RF;
  var n = ad(e).getComputedStyle(e), a = Kle(n), i = a.left + a.right, o = a.top + a.bottom, s = Eb(n.width), l = Eb(n.height);
  if (n.boxSizing === "border-box" && (Math.round(s + i) !== t && (s -= M3(n, "left", "right") + i), Math.round(l + o) !== r && (l -= M3(n, "top", "bottom") + o)), !Jle(e)) {
    var c = Math.round(s + i) - t, u = Math.round(l + o) - r;
    Math.abs(c) !== 1 && (s -= c), Math.abs(u) !== 1 && (l -= u);
  }
  return m1(a.left, a.top, s, l);
}
var Xle = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof ad(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof ad(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function Jle(e) {
  return e === ad(e).document.documentElement;
}
function Qle(e) {
  return o2 ? Xle(e) ? Yle(e) : Zle(e) : RF;
}
function ece(e) {
  var t = e.x, r = e.y, n = e.width, a = e.height, i = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, o = Object.create(i.prototype);
  return PF(o, {
    x: t,
    y: r,
    width: n,
    height: a,
    top: r,
    right: t + n,
    bottom: a + r,
    left: t
  }), o;
}
function m1(e, t, r, n) {
  return { x: e, y: t, width: r, height: n };
}
var tce = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = m1(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = Qle(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), rce = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, r) {
      var n = ece(r);
      PF(this, { target: t, contentRect: n });
    }
    return e;
  }()
), nce = (
  /** @class */
  function() {
    function e(t, r, n) {
      if (this.activeObservations_ = [], this.observations_ = new AF(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = r, this.callbackCtx_ = n;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof ad(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) || (r.set(t, new tce(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof ad(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) && (r.delete(t), r.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(r) {
        r.isActive() && t.activeObservations_.push(r);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, r = this.activeObservations_.map(function(n) {
          return new rce(n.target, n.broadcastRect());
        });
        this.callback_.call(t, r, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), NF = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new AF(), DF = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var r = qle.getInstance(), n = new nce(t, r, this);
      NF.set(this, n);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  DF.prototype[e] = function() {
    var t;
    return (t = NF.get(this))[e].apply(t, arguments);
  };
});
var ace = function() {
  return typeof _b.ResizeObserver < "u" ? _b.ResizeObserver : DF;
}(), Ls = /* @__PURE__ */ new Map();
function jF(e) {
  e.forEach(function(t) {
    var r, n = t.target;
    (r = Ls.get(n)) === null || r === void 0 || r.forEach(function(a) {
      return a(n);
    });
  });
}
var LF = new ace(jF);
process.env.NODE_ENV;
process.env.NODE_ENV;
function ice(e, t) {
  Ls.has(e) || (Ls.set(e, /* @__PURE__ */ new Set()), LF.observe(e)), Ls.get(e).add(t);
}
function oce(e, t) {
  Ls.has(e) && (Ls.get(e).delete(t), Ls.get(e).size || (LF.unobserve(e), Ls.delete(e)));
}
function Hn(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function A3(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, IF(n.key), n);
  }
}
function Vn(e, t, r) {
  return t && A3(e.prototype, t), r && A3(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function z0(e, t) {
  return z0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, z0(e, t);
}
function ds(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && z0(e, t);
}
function H0(e) {
  return H0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, H0(e);
}
function yT() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (yT = function() {
    return !!e;
  })();
}
function at(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function sce(e, t) {
  if (t && (kt(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return at(e);
}
function fs(e) {
  var t = yT();
  return function() {
    var r, n = H0(e);
    if (t) {
      var a = H0(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return sce(this, r);
  };
}
var lce = /* @__PURE__ */ function(e) {
  ds(r, e);
  var t = fs(r);
  function r() {
    return Hn(this, r), t.apply(this, arguments);
  }
  return Vn(r, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), r;
}(p.Component);
function cce(e, t) {
  var r = e.children, n = e.disabled, a = p.useRef(null), i = p.useRef(null), o = p.useContext(i2), s = typeof r == "function", l = s ? r(a) : r, c = p.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), u = !s && /* @__PURE__ */ p.isValidElement(l) && No(l), d = u ? l.ref : null, f = qs(d, a), m = function() {
    var S;
    return I0(a.current) || // Support `nativeElement` format
    (a.current && kt(a.current) === "object" ? I0((S = a.current) === null || S === void 0 ? void 0 : S.nativeElement) : null) || I0(i.current);
  };
  p.useImperativeHandle(t, function() {
    return m();
  });
  var h = p.useRef(e);
  h.current = e;
  var g = p.useCallback(function(y) {
    var S = h.current, x = S.onResize, b = S.data, _ = y.getBoundingClientRect(), $ = _.width, w = _.height, O = y.offsetWidth, T = y.offsetHeight, I = Math.floor($), P = Math.floor(w);
    if (c.current.width !== I || c.current.height !== P || c.current.offsetWidth !== O || c.current.offsetHeight !== T) {
      var D = {
        width: I,
        height: P,
        offsetWidth: O,
        offsetHeight: T
      };
      c.current = D;
      var B = O === Math.round($) ? $ : O, L = T === Math.round(w) ? w : T, N = ce(ce({}, D), {}, {
        offsetWidth: B,
        offsetHeight: L
      });
      o?.(N, y, b), x && Promise.resolve().then(function() {
        x(N, y);
      });
    }
  }, []);
  return p.useEffect(function() {
    var y = m();
    return y && !n && ice(y, g), function() {
      return oce(y, g);
    };
  }, [a.current, n]), /* @__PURE__ */ p.createElement(lce, {
    ref: i
  }, u ? /* @__PURE__ */ p.cloneElement(l, {
    ref: f
  }) : l);
}
var kF = /* @__PURE__ */ p.forwardRef(cce);
process.env.NODE_ENV !== "production" && (kF.displayName = "SingleObserver");
var uce = "rc-observer-key";
function dce(e, t) {
  var r = e.children, n = typeof r == "function" ? [r] : Ma(r);
  return process.env.NODE_ENV !== "production" && (n.length > 1 ? ls(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : n.length === 0 && ls(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), n.map(function(a, i) {
    var o = a?.key || "".concat(uce, "-").concat(i);
    return /* @__PURE__ */ p.createElement(kF, Pe({}, e, {
      key: o,
      ref: i === 0 ? t : void 0
    }), a);
  });
}
var Ia = /* @__PURE__ */ p.forwardRef(dce);
process.env.NODE_ENV !== "production" && (Ia.displayName = "ResizeObserver");
Ia.Collection = Ble;
function bn(e, t) {
  var r = Object.assign({}, e);
  return Array.isArray(t) && t.forEach(function(n) {
    delete r[n];
  }), r;
}
function s2(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function fce(e) {
  if (Array.isArray(e)) return s2(e);
}
function FF(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function bT(e, t) {
  if (e) {
    if (typeof e == "string") return s2(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? s2(e, t) : void 0;
  }
}
function pce() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ze(e) {
  return fce(e) || FF(e) || bT(e) || pce();
}
var BF = function(t) {
  return +setTimeout(t, 16);
}, zF = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (BF = function(t) {
  return window.requestAnimationFrame(t);
}, zF = function(t) {
  return window.cancelAnimationFrame(t);
});
var P3 = 0, v1 = /* @__PURE__ */ new Map();
function HF(e) {
  v1.delete(e);
}
var vr = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  P3 += 1;
  var n = P3;
  function a(i) {
    if (i === 0)
      HF(n), t();
    else {
      var o = BF(function() {
        a(i - 1);
      });
      v1.set(n, o);
    }
  }
  return a(r), n;
};
vr.cancel = function(e) {
  var t = v1.get(e);
  return HF(e), zF(t);
};
process.env.NODE_ENV !== "production" && (vr.ids = function() {
  return v1;
});
function VF(e) {
  if (Array.isArray(e)) return e;
}
function mce(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        l = !1;
      } else for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); l = !0) ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return s;
  }
}
function GF() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ye(e, t) {
  return VF(e) || mce(e, t) || bT(e, t) || GF();
}
function V0(e) {
  for (var t = 0, r, n = 0, a = e.length; a >= 4; ++n, a -= 4)
    r = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
function Ca() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function l2(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var r = t; r; ) {
    if (r === e)
      return !0;
    r = r.parentNode;
  }
  return !1;
}
var R3 = "data-rc-order", N3 = "data-rc-priority", vce = "rc-util-key", c2 = /* @__PURE__ */ new Map();
function UF() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : vce;
}
function h1(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function hce(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function CT(e) {
  return Array.from((c2.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function WF(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!Ca())
    return null;
  var r = t.csp, n = t.prepend, a = t.priority, i = a === void 0 ? 0 : a, o = hce(n), s = o === "prependQueue", l = document.createElement("style");
  l.setAttribute(R3, o), s && i && l.setAttribute(N3, "".concat(i)), r != null && r.nonce && (l.nonce = r?.nonce), l.innerHTML = e;
  var c = h1(t), u = c.firstChild;
  if (n) {
    if (s) {
      var d = (t.styles || CT(c)).filter(function(f) {
        if (!["prepend", "prependQueue"].includes(f.getAttribute(R3)))
          return !1;
        var m = Number(f.getAttribute(N3) || 0);
        return i >= m;
      });
      if (d.length)
        return c.insertBefore(l, d[d.length - 1].nextSibling), l;
    }
    c.insertBefore(l, u);
  } else
    c.appendChild(l);
  return l;
}
function qF(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = h1(t);
  return (t.styles || CT(r)).find(function(n) {
    return n.getAttribute(UF(t)) === e;
  });
}
function G0(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = qF(e, t);
  if (r) {
    var n = h1(t);
    n.removeChild(r);
  }
}
function gce(e, t) {
  var r = c2.get(e);
  if (!r || !l2(document, r)) {
    var n = WF("", t), a = n.parentNode;
    c2.set(e, a), e.removeChild(n);
  }
}
function ks(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = h1(r), a = CT(n), i = ce(ce({}, r), {}, {
    styles: a
  });
  gce(n, i);
  var o = qF(t, i);
  if (o) {
    var s, l;
    if ((s = i.csp) !== null && s !== void 0 && s.nonce && o.nonce !== ((l = i.csp) === null || l === void 0 ? void 0 : l.nonce)) {
      var c;
      o.nonce = (c = i.csp) === null || c === void 0 ? void 0 : c.nonce;
    }
    return o.innerHTML !== e && (o.innerHTML = e), o;
  }
  var u = WF(e, i);
  return u.setAttribute(UF(i), t), u;
}
function yce(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.includes(n)) continue;
    r[n] = e[n];
  }
  return r;
}
function Kt(e, t) {
  if (e == null) return {};
  var r, n, a = yce(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (a[r] = e[r]);
  }
  return a;
}
function Do(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = /* @__PURE__ */ new Set();
  function a(i, o) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, l = n.has(i);
    if (jt(!l, "Warning: There may be circular references"), l)
      return !1;
    if (i === o)
      return !0;
    if (r && s > 1)
      return !1;
    n.add(i);
    var c = s + 1;
    if (Array.isArray(i)) {
      if (!Array.isArray(o) || i.length !== o.length)
        return !1;
      for (var u = 0; u < i.length; u++)
        if (!a(i[u], o[u], c))
          return !1;
      return !0;
    }
    if (i && o && kt(i) === "object" && kt(o) === "object") {
      var d = Object.keys(i);
      return d.length !== Object.keys(o).length ? !1 : d.every(function(f) {
        return a(i[f], o[f], c);
      });
    }
    return !1;
  }
  return a(e, t);
}
var bce = "%";
function u2(e) {
  return e.join(bce);
}
var Cce = /* @__PURE__ */ function() {
  function e(t) {
    Hn(this, e), te(this, "instanceId", void 0), te(this, "cache", /* @__PURE__ */ new Map()), this.instanceId = t;
  }
  return Vn(e, [{
    key: "get",
    value: function(r) {
      return this.opGet(u2(r));
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opGet",
    value: function(r) {
      return this.cache.get(r) || null;
    }
  }, {
    key: "update",
    value: function(r, n) {
      return this.opUpdate(u2(r), n);
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opUpdate",
    value: function(r, n) {
      var a = this.cache.get(r), i = n(a);
      i === null ? this.cache.delete(r) : this.cache.set(r, i);
    }
  }]), e;
}(), id = "data-token-hash", Ao = "data-css-hash", Sce = "data-cache-path", yl = "__cssinjs_instance__";
function xce() {
  var e = Math.random().toString(12).slice(2);
  if (typeof document < "u" && document.head && document.body) {
    var t = document.body.querySelectorAll("style[".concat(Ao, "]")) || [], r = document.head.firstChild;
    Array.from(t).forEach(function(a) {
      a[yl] = a[yl] || e, a[yl] === e && document.head.insertBefore(a, r);
    });
    var n = {};
    Array.from(document.querySelectorAll("style[".concat(Ao, "]"))).forEach(function(a) {
      var i = a.getAttribute(Ao);
      if (n[i]) {
        if (a[yl] === e) {
          var o;
          (o = a.parentNode) === null || o === void 0 || o.removeChild(a);
        }
      } else
        n[i] = !0;
    });
  }
  return new Cce(e);
}
var g1 = /* @__PURE__ */ p.createContext({
  hashPriority: "low",
  cache: xce(),
  defaultCache: !0
}), KF = /* @__PURE__ */ Vn(function e() {
  Hn(this, e);
}), YF = "CALC_UNIT", $ce = new RegExp(YF, "g");
function GS(e) {
  return typeof e == "number" ? "".concat(e).concat(YF) : e;
}
var _ce = /* @__PURE__ */ function(e) {
  ds(r, e);
  var t = fs(r);
  function r(n, a) {
    var i;
    Hn(this, r), i = t.call(this), te(at(i), "result", ""), te(at(i), "unitlessCssVar", void 0), te(at(i), "lowPriority", void 0);
    var o = kt(n);
    return i.unitlessCssVar = a, n instanceof r ? i.result = "(".concat(n.result, ")") : o === "number" ? i.result = GS(n) : o === "string" && (i.result = n), i;
  }
  return Vn(r, [{
    key: "add",
    value: function(a) {
      return a instanceof r ? this.result = "".concat(this.result, " + ").concat(a.getResult()) : (typeof a == "number" || typeof a == "string") && (this.result = "".concat(this.result, " + ").concat(GS(a))), this.lowPriority = !0, this;
    }
  }, {
    key: "sub",
    value: function(a) {
      return a instanceof r ? this.result = "".concat(this.result, " - ").concat(a.getResult()) : (typeof a == "number" || typeof a == "string") && (this.result = "".concat(this.result, " - ").concat(GS(a))), this.lowPriority = !0, this;
    }
  }, {
    key: "mul",
    value: function(a) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), a instanceof r ? this.result = "".concat(this.result, " * ").concat(a.getResult(!0)) : (typeof a == "number" || typeof a == "string") && (this.result = "".concat(this.result, " * ").concat(a)), this.lowPriority = !1, this;
    }
  }, {
    key: "div",
    value: function(a) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), a instanceof r ? this.result = "".concat(this.result, " / ").concat(a.getResult(!0)) : (typeof a == "number" || typeof a == "string") && (this.result = "".concat(this.result, " / ").concat(a)), this.lowPriority = !1, this;
    }
  }, {
    key: "getResult",
    value: function(a) {
      return this.lowPriority || a ? "(".concat(this.result, ")") : this.result;
    }
  }, {
    key: "equal",
    value: function(a) {
      var i = this, o = a || {}, s = o.unit, l = !0;
      return typeof s == "boolean" ? l = s : Array.from(this.unitlessCssVar).some(function(c) {
        return i.result.includes(c);
      }) && (l = !1), this.result = this.result.replace($ce, l ? "px" : ""), typeof this.lowPriority < "u" ? "calc(".concat(this.result, ")") : this.result;
    }
  }]), r;
}(KF), Ece = /* @__PURE__ */ function(e) {
  ds(r, e);
  var t = fs(r);
  function r(n) {
    var a;
    return Hn(this, r), a = t.call(this), te(at(a), "result", 0), n instanceof r ? a.result = n.result : typeof n == "number" && (a.result = n), a;
  }
  return Vn(r, [{
    key: "add",
    value: function(a) {
      return a instanceof r ? this.result += a.result : typeof a == "number" && (this.result += a), this;
    }
  }, {
    key: "sub",
    value: function(a) {
      return a instanceof r ? this.result -= a.result : typeof a == "number" && (this.result -= a), this;
    }
  }, {
    key: "mul",
    value: function(a) {
      return a instanceof r ? this.result *= a.result : typeof a == "number" && (this.result *= a), this;
    }
  }, {
    key: "div",
    value: function(a) {
      return a instanceof r ? this.result /= a.result : typeof a == "number" && (this.result /= a), this;
    }
  }, {
    key: "equal",
    value: function() {
      return this.result;
    }
  }]), r;
}(KF), wce = function(t, r) {
  var n = t === "css" ? _ce : Ece;
  return function(a) {
    return new n(a, r);
  };
};
function Oce(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
var ST = /* @__PURE__ */ function() {
  function e() {
    Hn(this, e), te(this, "cache", void 0), te(this, "keys", void 0), te(this, "cacheCallTimes", void 0), this.cache = /* @__PURE__ */ new Map(), this.keys = [], this.cacheCallTimes = 0;
  }
  return Vn(e, [{
    key: "size",
    value: function() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function(r) {
      var n, a, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, o = {
        map: this.cache
      };
      return r.forEach(function(s) {
        if (!o)
          o = void 0;
        else {
          var l;
          o = (l = o) === null || l === void 0 || (l = l.map) === null || l === void 0 ? void 0 : l.get(s);
        }
      }), (n = o) !== null && n !== void 0 && n.value && i && (o.value[1] = this.cacheCallTimes++), (a = o) === null || a === void 0 ? void 0 : a.value;
    }
  }, {
    key: "get",
    value: function(r) {
      var n;
      return (n = this.internalGet(r, !0)) === null || n === void 0 ? void 0 : n[0];
    }
  }, {
    key: "has",
    value: function(r) {
      return !!this.internalGet(r);
    }
  }, {
    key: "set",
    value: function(r, n) {
      var a = this;
      if (!this.has(r)) {
        if (this.size() + 1 > e.MAX_CACHE_SIZE + e.MAX_CACHE_OFFSET) {
          var i = this.keys.reduce(function(c, u) {
            var d = ye(c, 2), f = d[1];
            return a.internalGet(u)[1] < f ? [u, a.internalGet(u)[1]] : c;
          }, [this.keys[0], this.cacheCallTimes]), o = ye(i, 1), s = o[0];
          this.delete(s);
        }
        this.keys.push(r);
      }
      var l = this.cache;
      r.forEach(function(c, u) {
        if (u === r.length - 1)
          l.set(c, {
            value: [n, a.cacheCallTimes++]
          });
        else {
          var d = l.get(c);
          d ? d.map || (d.map = /* @__PURE__ */ new Map()) : l.set(c, {
            map: /* @__PURE__ */ new Map()
          }), l = l.get(c).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function(r, n) {
      var a = r.get(n[0]);
      if (n.length === 1) {
        var i;
        return a.map ? r.set(n[0], {
          map: a.map
        }) : r.delete(n[0]), (i = a.value) === null || i === void 0 ? void 0 : i[0];
      }
      var o = this.deleteByPath(a.map, n.slice(1));
      return (!a.map || a.map.size === 0) && !a.value && r.delete(n[0]), o;
    }
  }, {
    key: "delete",
    value: function(r) {
      if (this.has(r))
        return this.keys = this.keys.filter(function(n) {
          return !Oce(n, r);
        }), this.deleteByPath(this.cache, r);
    }
  }]), e;
}();
te(ST, "MAX_CACHE_SIZE", 20);
te(ST, "MAX_CACHE_OFFSET", 5);
var D3 = 0, ZF = /* @__PURE__ */ function() {
  function e(t) {
    Hn(this, e), te(this, "derivatives", void 0), te(this, "id", void 0), this.derivatives = Array.isArray(t) ? t : [t], this.id = D3, t.length === 0 && ls(t.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function."), D3 += 1;
  }
  return Vn(e, [{
    key: "getDerivativeToken",
    value: function(r) {
      return this.derivatives.reduce(function(n, a) {
        return a(r, n);
      }, void 0);
    }
  }]), e;
}(), US = new ST();
function d2(e) {
  var t = Array.isArray(e) ? e : [e];
  return US.has(t) || US.set(t, new ZF(t)), US.get(t);
}
var Tce = /* @__PURE__ */ new WeakMap(), WS = {};
function Ice(e, t) {
  for (var r = Tce, n = 0; n < t.length; n += 1) {
    var a = t[n];
    r.has(a) || r.set(a, /* @__PURE__ */ new WeakMap()), r = r.get(a);
  }
  return r.has(WS) || r.set(WS, e()), r.get(WS);
}
var j3 = /* @__PURE__ */ new WeakMap();
function M0(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = j3.get(e) || "";
  return r || (Object.keys(e).forEach(function(n) {
    var a = e[n];
    r += n, a instanceof ZF ? r += a.id : a && kt(a) === "object" ? r += M0(a, t) : r += a;
  }), t && (r = V0(r)), j3.set(e, r)), r;
}
function L3(e, t) {
  return V0("".concat(t, "_").concat(M0(e, !0)));
}
var f2 = Ca();
function ve(e) {
  return typeof e == "number" ? "".concat(e, "px") : e;
}
function wb(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  if (a)
    return e;
  var i = ce(ce({}, n), {}, te(te({}, id, t), Ao, r)), o = Object.keys(i).map(function(s) {
    var l = i[s];
    return l ? "".concat(s, '="').concat(l, '"') : null;
  }).filter(function(s) {
    return s;
  }).join(" ");
  return "<style ".concat(o, ">").concat(e, "</style>");
}
var eb = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return "--".concat(r ? "".concat(r, "-") : "").concat(t).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
}, Mce = function(t, r, n) {
  return Object.keys(t).length ? ".".concat(r).concat(n != null && n.scope ? ".".concat(n.scope) : "", "{").concat(Object.entries(t).map(function(a) {
    var i = ye(a, 2), o = i[0], s = i[1];
    return "".concat(o, ":").concat(s, ";");
  }).join(""), "}") : "";
}, XF = function(t, r, n) {
  var a = {}, i = {};
  return Object.entries(t).forEach(function(o) {
    var s, l, c = ye(o, 2), u = c[0], d = c[1];
    if (n != null && (s = n.preserve) !== null && s !== void 0 && s[u])
      i[u] = d;
    else if ((typeof d == "string" || typeof d == "number") && !(n != null && (l = n.ignore) !== null && l !== void 0 && l[u])) {
      var f, m = eb(u, n?.prefix);
      a[m] = typeof d == "number" && !(n != null && (f = n.unitless) !== null && f !== void 0 && f[u]) ? "".concat(d, "px") : String(d), i[u] = "var(".concat(m, ")");
    }
  }), [i, Mce(a, r, {
    scope: n?.scope
  })];
}, k3 = process.env.NODE_ENV !== "test" && Ca() ? p.useLayoutEffect : p.useEffect, hr = function(t, r) {
  var n = p.useRef(!0);
  k3(function() {
    return t(n.current);
  }, r), k3(function() {
    return n.current = !1, function() {
      n.current = !0;
    };
  }, []);
}, vc = function(t, r) {
  hr(function(n) {
    if (!n)
      return t();
  }, r);
}, Ace = ce({}, p), F3 = Ace.useInsertionEffect, Pce = function(t, r, n) {
  p.useMemo(t, n), hr(function() {
    return r(!0);
  }, n);
}, Rce = F3 ? function(e, t, r) {
  return F3(function() {
    return e(), t();
  }, r);
} : Pce, Nce = ce({}, p), Dce = Nce.useInsertionEffect, jce = function(t) {
  var r = [], n = !1;
  function a(i) {
    if (n) {
      process.env.NODE_ENV !== "production" && ls(!1, "[Ant Design CSS-in-JS] You are registering a cleanup function after unmount, which will not have any effect.");
      return;
    }
    r.push(i);
  }
  return p.useEffect(function() {
    return n = !1, function() {
      n = !0, r.length && r.forEach(function(i) {
        return i();
      });
    };
  }, t), a;
}, Lce = function() {
  return function(t) {
    t();
  };
}, kce = typeof Dce < "u" ? jce : Lce;
function Fce() {
  return !1;
}
var p2 = !1;
function Bce() {
  return p2;
}
const zce = process.env.NODE_ENV === "production" ? Fce : Bce;
if (process.env.NODE_ENV !== "production" && typeof module < "u" && module && module.hot && typeof window < "u") {
  var qS = window;
  if (typeof qS.webpackHotUpdate == "function") {
    var Hce = qS.webpackHotUpdate;
    qS.webpackHotUpdate = function() {
      return p2 = !0, setTimeout(function() {
        p2 = !1;
      }, 0), Hce.apply(void 0, arguments);
    };
  }
}
function xT(e, t, r, n, a) {
  var i = p.useContext(g1), o = i.cache, s = [e].concat(ze(t)), l = u2(s), c = kce([l]), u = zce(), d = function(g) {
    o.opUpdate(l, function(y) {
      var S = y || [void 0, void 0], x = ye(S, 2), b = x[0], _ = b === void 0 ? 0 : b, $ = x[1], w = $;
      process.env.NODE_ENV !== "production" && $ && u && (n?.(w, u), w = null);
      var O = w || r(), T = [_, O];
      return g ? g(T) : T;
    });
  };
  p.useMemo(
    function() {
      d();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [l]
    /* eslint-enable */
  );
  var f = o.opGet(l);
  process.env.NODE_ENV !== "production" && !f && (d(), f = o.opGet(l));
  var m = f[1];
  return Rce(function() {
    a?.(m);
  }, function(h) {
    return d(function(g) {
      var y = ye(g, 2), S = y[0], x = y[1];
      return h && S === 0 && a?.(m), [S + 1, x];
    }), function() {
      o.opUpdate(l, function(g) {
        var y = g || [], S = ye(y, 2), x = S[0], b = x === void 0 ? 0 : x, _ = S[1], $ = b - 1;
        return $ === 0 ? (c(function() {
          (h || !o.opGet(l)) && n?.(_, !1);
        }), null) : [b - 1, _];
      });
    };
  }, [l]), m;
}
var Vce = {}, Gce = process.env.NODE_ENV !== "production" ? "css-dev-only-do-not-override" : "css", lc = /* @__PURE__ */ new Map();
function Uce(e) {
  lc.set(e, (lc.get(e) || 0) + 1);
}
function Wce(e, t) {
  if (typeof document < "u") {
    var r = document.querySelectorAll("style[".concat(id, '="').concat(e, '"]'));
    r.forEach(function(n) {
      if (n[yl] === t) {
        var a;
        (a = n.parentNode) === null || a === void 0 || a.removeChild(n);
      }
    });
  }
}
var qce = 0;
function Kce(e, t) {
  lc.set(e, (lc.get(e) || 0) - 1);
  var r = Array.from(lc.keys()), n = r.filter(function(a) {
    var i = lc.get(a) || 0;
    return i <= 0;
  });
  r.length - n.length > qce && n.forEach(function(a) {
    Wce(a, t), lc.delete(a);
  });
}
var Yce = function(t, r, n, a) {
  var i = n.getDerivativeToken(t), o = ce(ce({}, i), r);
  return a && (o = a(o)), o;
}, JF = "token";
function Zce(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = Cr(g1), a = n.cache.instanceId, i = n.container, o = r.salt, s = o === void 0 ? "" : o, l = r.override, c = l === void 0 ? Vce : l, u = r.formatToken, d = r.getComputedToken, f = r.cssVar, m = Ice(function() {
    return Object.assign.apply(Object, [{}].concat(ze(t)));
  }, t), h = M0(m), g = M0(c), y = f ? M0(f) : "", S = xT(JF, [s, e.id, h, g, y], function() {
    var x, b = d ? d(m, c, e) : Yce(m, c, e, u), _ = ce({}, b), $ = "";
    if (f) {
      var w = XF(b, f.key, {
        prefix: f.prefix,
        ignore: f.ignore,
        unitless: f.unitless,
        preserve: f.preserve
      }), O = ye(w, 2);
      b = O[0], $ = O[1];
    }
    var T = L3(b, s);
    b._tokenKey = T, _._tokenKey = L3(_, s);
    var I = (x = f?.key) !== null && x !== void 0 ? x : T;
    b._themeKey = I, Uce(I);
    var P = "".concat(Gce, "-").concat(V0(T));
    return b._hashId = P, [b, P, _, $, f?.key || ""];
  }, function(x) {
    Kce(x[0]._themeKey, a);
  }, function(x) {
    var b = ye(x, 4), _ = b[0], $ = b[3];
    if (f && $) {
      var w = ks($, V0("css-variables-".concat(_._themeKey)), {
        mark: Ao,
        prepend: "queue",
        attachTo: i,
        priority: -999
      });
      w[yl] = a, w.setAttribute(id, _._themeKey);
    }
  });
  return S;
}
var Xce = function(t, r, n) {
  var a = ye(t, 5), i = a[2], o = a[3], s = a[4], l = n || {}, c = l.plain;
  if (!o)
    return null;
  var u = i._tokenKey, d = -999, f = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(d)
  }, m = wb(o, s, u, f, c);
  return [d, u, m];
}, Jce = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, QF = "comm", eB = "rule", tB = "decl", Qce = "@import", eue = "@keyframes", tue = "@layer", rB = Math.abs, $T = String.fromCharCode;
function nB(e) {
  return e.trim();
}
function tb(e, t, r) {
  return e.replace(t, r);
}
function rue(e, t, r) {
  return e.indexOf(t, r);
}
function U0(e, t) {
  return e.charCodeAt(t) | 0;
}
function W0(e, t, r) {
  return e.slice(t, r);
}
function Ns(e) {
  return e.length;
}
function nue(e) {
  return e.length;
}
function Fg(e, t) {
  return t.push(e), e;
}
var y1 = 1, od = 1, aB = 0, so = 0, ca = 0, md = "";
function _T(e, t, r, n, a, i, o, s) {
  return { value: e, root: t, parent: r, type: n, props: a, children: i, line: y1, column: od, length: o, return: "", siblings: s };
}
function aue() {
  return ca;
}
function iue() {
  return ca = so > 0 ? U0(md, --so) : 0, od--, ca === 10 && (od = 1, y1--), ca;
}
function Po() {
  return ca = so < aB ? U0(md, so++) : 0, od++, ca === 10 && (od = 1, y1++), ca;
}
function hc() {
  return U0(md, so);
}
function rb() {
  return so;
}
function b1(e, t) {
  return W0(md, e, t);
}
function m2(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function oue(e) {
  return y1 = od = 1, aB = Ns(md = e), so = 0, [];
}
function sue(e) {
  return md = "", e;
}
function KS(e) {
  return nB(b1(so - 1, v2(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function lue(e) {
  for (; (ca = hc()) && ca < 33; )
    Po();
  return m2(e) > 2 || m2(ca) > 3 ? "" : " ";
}
function cue(e, t) {
  for (; --t && Po() && !(ca < 48 || ca > 102 || ca > 57 && ca < 65 || ca > 70 && ca < 97); )
    ;
  return b1(e, rb() + (t < 6 && hc() == 32 && Po() == 32));
}
function v2(e) {
  for (; Po(); )
    switch (ca) {
      case e:
        return so;
      case 34:
      case 39:
        e !== 34 && e !== 39 && v2(ca);
        break;
      case 40:
        e === 41 && v2(e);
        break;
      case 92:
        Po();
        break;
    }
  return so;
}
function uue(e, t) {
  for (; Po() && e + ca !== 57; )
    if (e + ca === 84 && hc() === 47)
      break;
  return "/*" + b1(t, so - 1) + "*" + $T(e === 47 ? e : Po());
}
function due(e) {
  for (; !m2(hc()); )
    Po();
  return b1(e, so);
}
function fue(e) {
  return sue(nb("", null, null, null, [""], e = oue(e), 0, [0], e));
}
function nb(e, t, r, n, a, i, o, s, l) {
  for (var c = 0, u = 0, d = o, f = 0, m = 0, h = 0, g = 1, y = 1, S = 1, x = 0, b = "", _ = a, $ = i, w = n, O = b; y; )
    switch (h = x, x = Po()) {
      case 40:
        if (h != 108 && U0(O, d - 1) == 58) {
          rue(O += tb(KS(x), "&", "&\f"), "&\f", rB(c ? s[c - 1] : 0)) != -1 && (S = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        O += KS(x);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        O += lue(h);
        break;
      case 92:
        O += cue(rb() - 1, 7);
        continue;
      case 47:
        switch (hc()) {
          case 42:
          case 47:
            Fg(pue(uue(Po(), rb()), t, r, l), l);
            break;
          default:
            O += "/";
        }
        break;
      case 123 * g:
        s[c++] = Ns(O) * S;
      case 125 * g:
      case 59:
      case 0:
        switch (x) {
          case 0:
          case 125:
            y = 0;
          case 59 + u:
            S == -1 && (O = tb(O, /\f/g, "")), m > 0 && Ns(O) - d && Fg(m > 32 ? z3(O + ";", n, r, d - 1, l) : z3(tb(O, " ", "") + ";", n, r, d - 2, l), l);
            break;
          case 59:
            O += ";";
          default:
            if (Fg(w = B3(O, t, r, c, u, a, s, b, _ = [], $ = [], d, i), i), x === 123)
              if (u === 0)
                nb(O, t, w, w, _, i, d, s, $);
              else
                switch (f === 99 && U0(O, 3) === 110 ? 100 : f) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    nb(e, w, w, n && Fg(B3(e, w, w, 0, 0, a, s, b, a, _ = [], d, $), $), a, $, d, s, n ? _ : $);
                    break;
                  default:
                    nb(O, w, w, w, [""], $, 0, s, $);
                }
        }
        c = u = m = 0, g = S = 1, b = O = "", d = o;
        break;
      case 58:
        d = 1 + Ns(O), m = h;
      default:
        if (g < 1) {
          if (x == 123)
            --g;
          else if (x == 125 && g++ == 0 && iue() == 125)
            continue;
        }
        switch (O += $T(x), x * g) {
          case 38:
            S = u > 0 ? 1 : (O += "\f", -1);
            break;
          case 44:
            s[c++] = (Ns(O) - 1) * S, S = 1;
            break;
          case 64:
            hc() === 45 && (O += KS(Po())), f = hc(), u = d = Ns(b = O += due(rb())), x++;
            break;
          case 45:
            h === 45 && Ns(O) == 2 && (g = 0);
        }
    }
  return i;
}
function B3(e, t, r, n, a, i, o, s, l, c, u, d) {
  for (var f = a - 1, m = a === 0 ? i : [""], h = nue(m), g = 0, y = 0, S = 0; g < n; ++g)
    for (var x = 0, b = W0(e, f + 1, f = rB(y = o[g])), _ = e; x < h; ++x)
      (_ = nB(y > 0 ? m[x] + " " + b : tb(b, /&\f/g, m[x]))) && (l[S++] = _);
  return _T(e, t, r, a === 0 ? eB : s, l, c, u, d);
}
function pue(e, t, r, n) {
  return _T(e, t, r, QF, $T(aue()), W0(e, 2, -2), 0, n);
}
function z3(e, t, r, n, a) {
  return _T(e, t, r, tB, W0(e, 0, n), W0(e, n + 1, -1), n, a);
}
function h2(e, t) {
  for (var r = "", n = 0; n < e.length; n++)
    r += t(e[n], n, e, t) || "";
  return r;
}
function mue(e, t, r, n) {
  switch (e.type) {
    case tue:
      if (e.children.length) break;
    case Qce:
    case tB:
      return e.return = e.return || e.value;
    case QF:
      return "";
    case eue:
      return e.return = e.value + "{" + h2(e.children, n) + "}";
    case eB:
      if (!Ns(e.value = e.props.join(","))) return "";
  }
  return Ns(r = h2(e.children, n)) ? e.return = e.value + "{" + r + "}" : "";
}
function iB(e, t) {
  var r = t.path, n = t.parentSelectors;
  jt(!1, "[Ant Design CSS-in-JS] ".concat(r ? "Error in ".concat(r, ": ") : "").concat(e).concat(n.length ? " Selector: ".concat(n.join(" | ")) : ""));
}
var vue = function(t, r, n) {
  if (t === "content") {
    var a = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, i = ["normal", "none", "initial", "inherit", "unset"];
    (typeof r != "string" || i.indexOf(r) === -1 && !a.test(r) && (r.charAt(0) !== r.charAt(r.length - 1) || r.charAt(0) !== '"' && r.charAt(0) !== "'")) && iB("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(r, "\"'`."), n);
  }
}, hue = function(t, r, n) {
  t === "animation" && n.hashId && r !== "none" && iB("You seem to be using hashed animation '".concat(r, "', in which case 'animationName' with Keyframe as value is recommended."), n);
}, H3 = "data-ant-cssinjs-cache-path", oB = "_FILE_STYLE__", gc, sB = !0;
function gue() {
  if (!gc && (gc = {}, Ca())) {
    var e = document.createElement("div");
    e.className = H3, e.style.position = "fixed", e.style.visibility = "hidden", e.style.top = "-9999px", document.body.appendChild(e);
    var t = getComputedStyle(e).content || "";
    t = t.replace(/^"/, "").replace(/"$/, ""), t.split(";").forEach(function(a) {
      var i = a.split(":"), o = ye(i, 2), s = o[0], l = o[1];
      gc[s] = l;
    });
    var r = document.querySelector("style[".concat(H3, "]"));
    if (r) {
      var n;
      sB = !1, (n = r.parentNode) === null || n === void 0 || n.removeChild(r);
    }
    document.body.removeChild(e);
  }
}
function yue(e) {
  return gue(), !!gc[e];
}
function bue(e) {
  var t = gc[e], r = null;
  if (t && Ca())
    if (sB)
      r = oB;
    else {
      var n = document.querySelector("style[".concat(Ao, '="').concat(gc[e], '"]'));
      n ? r = n.innerHTML : delete gc[e];
    }
  return [r, t];
}
var lB = "_skip_check_", cB = "_multi_value_";
function ab(e) {
  var t = h2(fue(e), mue);
  return t.replace(/\{%%%\:[^;];}/g, ";");
}
function Cue(e) {
  return kt(e) === "object" && e && (lB in e || cB in e);
}
function Sue(e, t, r) {
  if (!t)
    return e;
  var n = ".".concat(t), a = r === "low" ? ":where(".concat(n, ")") : n, i = e.split(",").map(function(o) {
    var s, l = o.trim().split(/\s+/), c = l[0] || "", u = ((s = c.match(/^\w+/)) === null || s === void 0 ? void 0 : s[0]) || "";
    return c = "".concat(u).concat(a).concat(c.slice(u.length)), [c].concat(ze(l.slice(1))).join(" ");
  });
  return i.join(",");
}
var xue = function e(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: !0,
    parentSelectors: []
  }, a = n.root, i = n.injectHash, o = n.parentSelectors, s = r.hashId, l = r.layer, c = r.path, u = r.hashPriority, d = r.transformers, f = d === void 0 ? [] : d, m = r.linters, h = m === void 0 ? [] : m, g = "", y = {};
  function S(_) {
    var $ = _.getName(s);
    if (!y[$]) {
      var w = e(_.style, r, {
        root: !1,
        parentSelectors: o
      }), O = ye(w, 1), T = O[0];
      y[$] = "@keyframes ".concat(_.getName(s)).concat(T);
    }
  }
  function x(_) {
    var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return _.forEach(function(w) {
      Array.isArray(w) ? x(w, $) : w && $.push(w);
    }), $;
  }
  var b = x(Array.isArray(t) ? t : [t]);
  return b.forEach(function(_) {
    var $ = typeof _ == "string" && !a ? {} : _;
    if (typeof $ == "string")
      g += "".concat($, `
`);
    else if ($._keyframe)
      S($);
    else {
      var w = f.reduce(function(O, T) {
        var I;
        return (T == null || (I = T.visit) === null || I === void 0 ? void 0 : I.call(T, O)) || O;
      }, $);
      Object.keys(w).forEach(function(O) {
        var T = w[O];
        if (kt(T) === "object" && T && (O !== "animationName" || !T._keyframe) && !Cue(T)) {
          var I = !1, P = O.trim(), D = !1;
          (a || i) && s ? P.startsWith("@") ? I = !0 : P = Sue(O, s, u) : a && !s && (P === "&" || P === "") && (P = "", D = !0);
          var B = e(T, r, {
            root: D,
            injectHash: I,
            parentSelectors: [].concat(ze(o), [P])
          }), L = ye(B, 2), N = L[0], z = L[1];
          y = ce(ce({}, y), z), g += "".concat(P).concat(N);
        } else {
          let H = function(U, G) {
            process.env.NODE_ENV !== "production" && (kt(T) !== "object" || !(T != null && T[lB])) && [vue, hue].concat(ze(h)).forEach(function(Z) {
              return Z(U, G, {
                path: c,
                hashId: s,
                parentSelectors: o
              });
            });
            var V = U.replace(/[A-Z]/g, function(Z) {
              return "-".concat(Z.toLowerCase());
            }), K = G;
            !Jce[U] && typeof K == "number" && K !== 0 && (K = "".concat(K, "px")), U === "animationName" && G !== null && G !== void 0 && G._keyframe && (S(G), K = G.getName(s)), g += "".concat(V, ":").concat(K, ";");
          };
          var F, j = (F = T?.value) !== null && F !== void 0 ? F : T;
          kt(T) === "object" && T !== null && T !== void 0 && T[cB] && Array.isArray(j) ? j.forEach(function(U) {
            H(O, U);
          }) : H(O, j);
        }
      });
    }
  }), a ? l && (g = "@layer ".concat(l.name, " {").concat(g, "}"), l.dependencies && (y["@layer ".concat(l.name)] = l.dependencies.map(function(_) {
    return "@layer ".concat(_, ", ").concat(l.name, ";");
  }).join(`
`))) : g = "{".concat(g, "}"), [g, y];
};
function uB(e, t) {
  return V0("".concat(e.join("%")).concat(t));
}
function $ue() {
  return null;
}
var dB = "style";
function g2(e, t) {
  var r = e.token, n = e.path, a = e.hashId, i = e.layer, o = e.nonce, s = e.clientOnly, l = e.order, c = l === void 0 ? 0 : l, u = p.useContext(g1), d = u.autoClear, f = u.mock, m = u.defaultCache, h = u.hashPriority, g = u.container, y = u.ssrInline, S = u.transformers, x = u.linters, b = u.cache, _ = u.layer, $ = r._tokenKey, w = [$];
  _ && w.push("layer"), w.push.apply(w, ze(n));
  var O = f2;
  process.env.NODE_ENV !== "production" && f !== void 0 && (O = f === "client");
  var T = xT(
    dB,
    w,
    // Create cache if needed
    function() {
      var L = w.join("|");
      if (yue(L)) {
        var N = bue(L), z = ye(N, 2), F = z[0], j = z[1];
        if (F)
          return [F, $, j, {}, s, c];
      }
      var H = t(), U = xue(H, {
        hashId: a,
        hashPriority: h,
        layer: _ ? i : void 0,
        path: n.join("-"),
        transformers: S,
        linters: x
      }), G = ye(U, 2), V = G[0], K = G[1], Z = ab(V), ee = uB(w, Z);
      return [Z, $, ee, K, s, c];
    },
    // Remove cache if no need
    function(L, N) {
      var z = ye(L, 3), F = z[2];
      (N || d) && f2 && G0(F, {
        mark: Ao
      });
    },
    // Effect: Inject style here
    function(L) {
      var N = ye(L, 4), z = N[0];
      N[1];
      var F = N[2], j = N[3];
      if (O && z !== oB) {
        var H = {
          mark: Ao,
          prepend: _ ? !1 : "queue",
          attachTo: g,
          priority: c
        }, U = typeof o == "function" ? o() : o;
        U && (H.csp = {
          nonce: U
        });
        var G = [], V = [];
        Object.keys(j).forEach(function(Z) {
          Z.startsWith("@layer") ? G.push(Z) : V.push(Z);
        }), G.forEach(function(Z) {
          ks(ab(j[Z]), "_layer-".concat(Z), ce(ce({}, H), {}, {
            prepend: !0
          }));
        });
        var K = ks(z, F, H);
        K[yl] = b.instanceId, K.setAttribute(id, $), process.env.NODE_ENV !== "production" && K.setAttribute(Sce, w.join("|")), V.forEach(function(Z) {
          ks(ab(j[Z]), "_effect-".concat(Z), H);
        });
      }
    }
  ), I = ye(T, 3), P = I[0], D = I[1], B = I[2];
  return function(L) {
    var N;
    return !y || O || !m ? N = /* @__PURE__ */ p.createElement($ue, null) : N = /* @__PURE__ */ p.createElement("style", Pe({}, te(te({}, id, D), Ao, B), {
      dangerouslySetInnerHTML: {
        __html: P
      }
    })), /* @__PURE__ */ p.createElement(p.Fragment, null, N, L);
  };
}
var _ue = function(t, r, n) {
  var a = ye(t, 6), i = a[0], o = a[1], s = a[2], l = a[3], c = a[4], u = a[5], d = n || {}, f = d.plain;
  if (c)
    return null;
  var m = i, h = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(u)
  };
  return m = wb(i, o, s, h, f), l && Object.keys(l).forEach(function(g) {
    if (!r[g]) {
      r[g] = !0;
      var y = ab(l[g]), S = wb(y, o, "_effect-".concat(g), h, f);
      g.startsWith("@layer") ? m = S + m : m += S;
    }
  }), [u, s, m];
}, fB = "cssVar", Eue = function(t, r) {
  var n = t.key, a = t.prefix, i = t.unitless, o = t.ignore, s = t.token, l = t.scope, c = l === void 0 ? "" : l, u = Cr(g1), d = u.cache.instanceId, f = u.container, m = s._tokenKey, h = [].concat(ze(t.path), [n, c, m]), g = xT(fB, h, function() {
    var y = r(), S = XF(y, n, {
      prefix: a,
      unitless: i,
      ignore: o,
      scope: c
    }), x = ye(S, 2), b = x[0], _ = x[1], $ = uB(h, _);
    return [b, _, $, n];
  }, function(y) {
    var S = ye(y, 3), x = S[2];
    f2 && G0(x, {
      mark: Ao
    });
  }, function(y) {
    var S = ye(y, 3), x = S[1], b = S[2];
    if (x) {
      var _ = ks(x, b, {
        mark: Ao,
        prepend: "queue",
        attachTo: f,
        priority: -999
      });
      _[yl] = d, _.setAttribute(id, n);
    }
  });
  return g;
}, wue = function(t, r, n) {
  var a = ye(t, 4), i = a[1], o = a[2], s = a[3], l = n || {}, c = l.plain;
  if (!i)
    return null;
  var u = -999, d = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(u)
  }, f = wb(i, s, o, d, c);
  return [u, o, f];
};
te(te(te({}, dB, _ue), JF, Xce), fB, wue);
var Pr = /* @__PURE__ */ function() {
  function e(t, r) {
    Hn(this, e), te(this, "name", void 0), te(this, "style", void 0), te(this, "_keyframe", !0), this.name = t, this.style = r;
  }
  return Vn(e, [{
    key: "getName",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return r ? "".concat(r, "-").concat(this.name) : this.name;
    }
  }]), e;
}();
function mu(e) {
  return e.notSplit = !0, e;
}
mu(["borderTop", "borderBottom"]), mu(["borderTop"]), mu(["borderBottom"]), mu(["borderLeft", "borderRight"]), mu(["borderLeft"]), mu(["borderRight"]);
var ET = /* @__PURE__ */ Ws({});
function pB(e) {
  return VF(e) || FF(e) || bT(e) || GF();
}
function Bi(e, t) {
  for (var r = e, n = 0; n < t.length; n += 1) {
    if (r == null)
      return;
    r = r[t[n]];
  }
  return r;
}
function mB(e, t, r, n) {
  if (!t.length)
    return r;
  var a = pB(t), i = a[0], o = a.slice(1), s;
  return !e && typeof i == "number" ? s = [] : Array.isArray(e) ? s = ze(e) : s = ce({}, e), n && r === void 0 && o.length === 1 ? delete s[i][o[0]] : s[i] = mB(s[i], o, r, n), s;
}
function Oo(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return t.length && n && r === void 0 && !Bi(e, t.slice(0, -1)) ? e : mB(e, t, r, n);
}
function Oue(e) {
  return kt(e) === "object" && e !== null && Object.getPrototypeOf(e) === Object.prototype;
}
function V3(e) {
  return Array.isArray(e) ? [] : {};
}
var Tue = typeof Reflect > "u" ? Object.keys : Reflect.ownKeys;
function Yu() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var n = V3(t[0]);
  return t.forEach(function(a) {
    function i(o, s) {
      var l = new Set(s), c = Bi(a, o), u = Array.isArray(c);
      if (u || Oue(c)) {
        if (!l.has(c)) {
          l.add(c);
          var d = Bi(n, o);
          u ? n = Oo(n, o, []) : (!d || kt(d) !== "object") && (n = Oo(n, o, V3(c))), Tue(c).forEach(function(f) {
            i([].concat(ze(o), [f]), l);
          });
        }
      } else
        n = Oo(n, o, c);
    }
    i([]);
  }), n;
}
function vB() {
}
let As = null;
function Iue() {
  As = null, OF();
}
let wT = vB;
process.env.NODE_ENV !== "production" && (wT = (e, t, r) => {
  jt(e, `[antd: ${t}] ${r}`), process.env.NODE_ENV === "test" && Iue();
});
const hB = /* @__PURE__ */ p.createContext({}), xr = process.env.NODE_ENV !== "production" ? (e) => {
  const {
    strict: t
  } = p.useContext(hB), r = (n, a, i) => {
    if (!n)
      if (t === !1 && a === "deprecated") {
        const o = As;
        As || (As = {}), As[e] = As[e] || [], As[e].includes(i || "") || As[e].push(i || ""), o || console.warn("[antd] There exists deprecated usage in your code:", As);
      } else
        process.env.NODE_ENV !== "production" && wT(n, e, i);
  };
  return r.deprecated = (n, a, i, o) => {
    r(n, "deprecated", `\`${a}\` is deprecated. Please use \`${i}\` instead.${o ? ` ${o}` : ""}`);
  }, r;
} : () => {
  const e = () => {
  };
  return e.deprecated = vB, e;
}, Rc = wT, gB = /* @__PURE__ */ Ws(void 0);
var yB = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
}, Mue = {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  yearFormat: "YYYY",
  dateFormat: "M/D/YYYY",
  dayFormat: "D",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  monthBeforeYear: !0,
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
};
const bB = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
}, Ob = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, Mue),
  timePickerLocale: Object.assign({}, bB)
}, Ni = "${label} is not a valid ${type}", jo = {
  locale: "en",
  Pagination: yB,
  DatePicker: Ob,
  TimePicker: bB,
  Calendar: Ob,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    deselectAll: "Deselect all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand",
    collapse: "Collapse"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: Ni,
        method: Ni,
        array: Ni,
        object: Ni,
        number: Ni,
        date: Ni,
        boolean: Ni,
        integer: Ni,
        float: Ni,
        regexp: Ni,
        email: Ni,
        url: Ni,
        hex: Ni
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  },
  ColorPicker: {
    presetEmpty: "Empty"
  }
};
let ib = Object.assign({}, jo.Modal), ob = [];
const G3 = () => ob.reduce((e, t) => Object.assign(Object.assign({}, e), t), jo.Modal);
function Aue(e) {
  if (e) {
    const t = Object.assign({}, e);
    return ob.push(t), ib = G3(), () => {
      ob = ob.filter((r) => r !== t), ib = G3();
    };
  }
  ib = Object.assign({}, jo.Modal);
}
function CB() {
  return ib;
}
const OT = /* @__PURE__ */ Ws(void 0), Ks = (e, t) => {
  const r = p.useContext(OT), n = p.useMemo(() => {
    var i;
    const o = t || jo[e], s = (i = r?.[e]) !== null && i !== void 0 ? i : {};
    return Object.assign(Object.assign({}, typeof o == "function" ? o() : o), s || {});
  }, [e, t, r]), a = p.useMemo(() => {
    const i = r?.locale;
    return r?.exist && !i ? jo.locale : i;
  }, [r]);
  return [n, a];
}, SB = "internalMark", xB = (e) => {
  const {
    locale: t = {},
    children: r,
    _ANT_MARK__: n
  } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = xr("LocaleProvider");
    process.env.NODE_ENV !== "production" && i(n === SB, "deprecated", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale");
  }
  p.useEffect(() => Aue(t && t.Modal), [t]);
  const a = p.useMemo(() => Object.assign(Object.assign({}, t), {
    exist: !0
  }), [t]);
  return /* @__PURE__ */ p.createElement(OT.Provider, {
    value: a
  }, r);
};
process.env.NODE_ENV !== "production" && (xB.displayName = "LocaleProvider");
function ka(e, t) {
  Pue(e) && (e = "100%");
  var r = Rue(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), r && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function Bg(e) {
  return Math.min(1, Math.max(0, e));
}
function Pue(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function Rue(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function $B(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function zg(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function cc(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function Nue(e, t, r) {
  return {
    r: ka(e, 255) * 255,
    g: ka(t, 255) * 255,
    b: ka(r, 255) * 255
  };
}
function U3(e, t, r) {
  e = ka(e, 255), t = ka(t, 255), r = ka(r, 255);
  var n = Math.max(e, t, r), a = Math.min(e, t, r), i = 0, o = 0, s = (n + a) / 2;
  if (n === a)
    o = 0, i = 0;
  else {
    var l = n - a;
    switch (o = s > 0.5 ? l / (2 - n - a) : l / (n + a), n) {
      case e:
        i = (t - r) / l + (t < r ? 6 : 0);
        break;
      case t:
        i = (r - e) / l + 2;
        break;
      case r:
        i = (e - t) / l + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: o, l: s };
}
function YS(e, t, r) {
  return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? e + (t - e) * (6 * r) : r < 1 / 2 ? t : r < 2 / 3 ? e + (t - e) * (2 / 3 - r) * 6 : e;
}
function Due(e, t, r) {
  var n, a, i;
  if (e = ka(e, 360), t = ka(t, 100), r = ka(r, 100), t === 0)
    a = r, i = r, n = r;
  else {
    var o = r < 0.5 ? r * (1 + t) : r + t - r * t, s = 2 * r - o;
    n = YS(s, o, e + 1 / 3), a = YS(s, o, e), i = YS(s, o, e - 1 / 3);
  }
  return { r: n * 255, g: a * 255, b: i * 255 };
}
function y2(e, t, r) {
  e = ka(e, 255), t = ka(t, 255), r = ka(r, 255);
  var n = Math.max(e, t, r), a = Math.min(e, t, r), i = 0, o = n, s = n - a, l = n === 0 ? 0 : s / n;
  if (n === a)
    i = 0;
  else {
    switch (n) {
      case e:
        i = (t - r) / s + (t < r ? 6 : 0);
        break;
      case t:
        i = (r - e) / s + 2;
        break;
      case r:
        i = (e - t) / s + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: l, v: o };
}
function jue(e, t, r) {
  e = ka(e, 360) * 6, t = ka(t, 100), r = ka(r, 100);
  var n = Math.floor(e), a = e - n, i = r * (1 - t), o = r * (1 - a * t), s = r * (1 - (1 - a) * t), l = n % 6, c = [r, o, i, i, s, r][l], u = [s, r, r, o, i, i][l], d = [i, i, s, r, r, o][l];
  return { r: c * 255, g: u * 255, b: d * 255 };
}
function b2(e, t, r, n) {
  var a = [
    cc(Math.round(e).toString(16)),
    cc(Math.round(t).toString(16)),
    cc(Math.round(r).toString(16))
  ];
  return n && a[0].startsWith(a[0].charAt(1)) && a[1].startsWith(a[1].charAt(1)) && a[2].startsWith(a[2].charAt(1)) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) : a.join("");
}
function Lue(e, t, r, n, a) {
  var i = [
    cc(Math.round(e).toString(16)),
    cc(Math.round(t).toString(16)),
    cc(Math.round(r).toString(16)),
    cc(kue(n))
  ];
  return a && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) && i[3].startsWith(i[3].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) + i[3].charAt(0) : i.join("");
}
function kue(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function W3(e) {
  return ki(e) / 255;
}
function ki(e) {
  return parseInt(e, 16);
}
function Fue(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var C2 = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function Wu(e) {
  var t = { r: 0, g: 0, b: 0 }, r = 1, n = null, a = null, i = null, o = !1, s = !1;
  return typeof e == "string" && (e = Hue(e)), typeof e == "object" && (ws(e.r) && ws(e.g) && ws(e.b) ? (t = Nue(e.r, e.g, e.b), o = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : ws(e.h) && ws(e.s) && ws(e.v) ? (n = zg(e.s), a = zg(e.v), t = jue(e.h, n, a), o = !0, s = "hsv") : ws(e.h) && ws(e.s) && ws(e.l) && (n = zg(e.s), i = zg(e.l), t = Due(e.h, n, i), o = !0, s = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (r = e.a)), r = $B(r), {
    ok: o,
    format: e.format || s,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: r
  };
}
var Bue = "[-\\+]?\\d+%?", zue = "[-\\+]?\\d*\\.\\d+%?", bl = "(?:".concat(zue, ")|(?:").concat(Bue, ")"), ZS = "[\\s|\\(]+(".concat(bl, ")[,|\\s]+(").concat(bl, ")[,|\\s]+(").concat(bl, ")\\s*\\)?"), XS = "[\\s|\\(]+(".concat(bl, ")[,|\\s]+(").concat(bl, ")[,|\\s]+(").concat(bl, ")[,|\\s]+(").concat(bl, ")\\s*\\)?"), $o = {
  CSS_UNIT: new RegExp(bl),
  rgb: new RegExp("rgb" + ZS),
  rgba: new RegExp("rgba" + XS),
  hsl: new RegExp("hsl" + ZS),
  hsla: new RegExp("hsla" + XS),
  hsv: new RegExp("hsv" + ZS),
  hsva: new RegExp("hsva" + XS),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function Hue(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var t = !1;
  if (C2[e])
    e = C2[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var r = $o.rgb.exec(e);
  return r ? { r: r[1], g: r[2], b: r[3] } : (r = $o.rgba.exec(e), r ? { r: r[1], g: r[2], b: r[3], a: r[4] } : (r = $o.hsl.exec(e), r ? { h: r[1], s: r[2], l: r[3] } : (r = $o.hsla.exec(e), r ? { h: r[1], s: r[2], l: r[3], a: r[4] } : (r = $o.hsv.exec(e), r ? { h: r[1], s: r[2], v: r[3] } : (r = $o.hsva.exec(e), r ? { h: r[1], s: r[2], v: r[3], a: r[4] } : (r = $o.hex8.exec(e), r ? {
    r: ki(r[1]),
    g: ki(r[2]),
    b: ki(r[3]),
    a: W3(r[4]),
    format: t ? "name" : "hex8"
  } : (r = $o.hex6.exec(e), r ? {
    r: ki(r[1]),
    g: ki(r[2]),
    b: ki(r[3]),
    format: t ? "name" : "hex"
  } : (r = $o.hex4.exec(e), r ? {
    r: ki(r[1] + r[1]),
    g: ki(r[2] + r[2]),
    b: ki(r[3] + r[3]),
    a: W3(r[4] + r[4]),
    format: t ? "name" : "hex8"
  } : (r = $o.hex3.exec(e), r ? {
    r: ki(r[1] + r[1]),
    g: ki(r[2] + r[2]),
    b: ki(r[3] + r[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function ws(e) {
  return !!$o.CSS_UNIT.exec(String(e));
}
var Br = (
  /** @class */
  function() {
    function e(t, r) {
      t === void 0 && (t = ""), r === void 0 && (r = {});
      var n;
      if (t instanceof e)
        return t;
      typeof t == "number" && (t = Fue(t)), this.originalInput = t;
      var a = Wu(t);
      this.originalInput = t, this.r = a.r, this.g = a.g, this.b = a.b, this.a = a.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (n = r.format) !== null && n !== void 0 ? n : a.format, this.gradientType = r.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = a.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var t = this.toRgb();
      return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var t = this.toRgb(), r, n, a, i = t.r / 255, o = t.g / 255, s = t.b / 255;
      return i <= 0.03928 ? r = i / 12.92 : r = Math.pow((i + 0.055) / 1.055, 2.4), o <= 0.03928 ? n = o / 12.92 : n = Math.pow((o + 0.055) / 1.055, 2.4), s <= 0.03928 ? a = s / 12.92 : a = Math.pow((s + 0.055) / 1.055, 2.4), 0.2126 * r + 0.7152 * n + 0.0722 * a;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(t) {
      return this.a = $B(t), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var t = this.toHsl().s;
      return t === 0;
    }, e.prototype.toHsv = function() {
      var t = y2(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, v: t.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var t = y2(this.r, this.g, this.b), r = Math.round(t.h * 360), n = Math.round(t.s * 100), a = Math.round(t.v * 100);
      return this.a === 1 ? "hsv(".concat(r, ", ").concat(n, "%, ").concat(a, "%)") : "hsva(".concat(r, ", ").concat(n, "%, ").concat(a, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var t = U3(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, l: t.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var t = U3(this.r, this.g, this.b), r = Math.round(t.h * 360), n = Math.round(t.s * 100), a = Math.round(t.l * 100);
      return this.a === 1 ? "hsl(".concat(r, ", ").concat(n, "%, ").concat(a, "%)") : "hsla(".concat(r, ", ").concat(n, "%, ").concat(a, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(t) {
      return t === void 0 && (t = !1), b2(this.r, this.g, this.b, t);
    }, e.prototype.toHexString = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex(t);
    }, e.prototype.toHex8 = function(t) {
      return t === void 0 && (t = !1), Lue(this.r, this.g, this.b, this.a, t);
    }, e.prototype.toHex8String = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex8(t);
    }, e.prototype.toHexShortString = function(t) {
      return t === void 0 && (t = !1), this.a === 1 ? this.toHexString(t) : this.toHex8String(t);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var t = Math.round(this.r), r = Math.round(this.g), n = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(t, ", ").concat(r, ", ").concat(n, ")") : "rgba(".concat(t, ", ").concat(r, ", ").concat(n, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var t = function(r) {
        return "".concat(Math.round(ka(r, 255) * 100), "%");
      };
      return {
        r: t(this.r),
        g: t(this.g),
        b: t(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var t = function(r) {
        return Math.round(ka(r, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%)") : "rgba(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var t = "#" + b2(this.r, this.g, this.b, !1), r = 0, n = Object.entries(C2); r < n.length; r++) {
        var a = n[r], i = a[0], o = a[1];
        if (t === o)
          return i;
      }
      return !1;
    }, e.prototype.toString = function(t) {
      var r = !!t;
      t = t ?? this.format;
      var n = !1, a = this.a < 1 && this.a >= 0, i = !r && a && (t.startsWith("hex") || t === "name");
      return i ? t === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (n = this.toRgbString()), t === "prgb" && (n = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (n = this.toHexString()), t === "hex3" && (n = this.toHexString(!0)), t === "hex4" && (n = this.toHex8String(!0)), t === "hex8" && (n = this.toHex8String()), t === "name" && (n = this.toName()), t === "hsl" && (n = this.toHslString()), t === "hsv" && (n = this.toHsvString()), n || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(t) {
      t === void 0 && (t = 10);
      var r = this.toHsl();
      return r.l += t / 100, r.l = Bg(r.l), new e(r);
    }, e.prototype.brighten = function(t) {
      t === void 0 && (t = 10);
      var r = this.toRgb();
      return r.r = Math.max(0, Math.min(255, r.r - Math.round(255 * -(t / 100)))), r.g = Math.max(0, Math.min(255, r.g - Math.round(255 * -(t / 100)))), r.b = Math.max(0, Math.min(255, r.b - Math.round(255 * -(t / 100)))), new e(r);
    }, e.prototype.darken = function(t) {
      t === void 0 && (t = 10);
      var r = this.toHsl();
      return r.l -= t / 100, r.l = Bg(r.l), new e(r);
    }, e.prototype.tint = function(t) {
      return t === void 0 && (t = 10), this.mix("white", t);
    }, e.prototype.shade = function(t) {
      return t === void 0 && (t = 10), this.mix("black", t);
    }, e.prototype.desaturate = function(t) {
      t === void 0 && (t = 10);
      var r = this.toHsl();
      return r.s -= t / 100, r.s = Bg(r.s), new e(r);
    }, e.prototype.saturate = function(t) {
      t === void 0 && (t = 10);
      var r = this.toHsl();
      return r.s += t / 100, r.s = Bg(r.s), new e(r);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(t) {
      var r = this.toHsl(), n = (r.h + t) % 360;
      return r.h = n < 0 ? 360 + n : n, new e(r);
    }, e.prototype.mix = function(t, r) {
      r === void 0 && (r = 50);
      var n = this.toRgb(), a = new e(t).toRgb(), i = r / 100, o = {
        r: (a.r - n.r) * i + n.r,
        g: (a.g - n.g) * i + n.g,
        b: (a.b - n.b) * i + n.b,
        a: (a.a - n.a) * i + n.a
      };
      return new e(o);
    }, e.prototype.analogous = function(t, r) {
      t === void 0 && (t = 6), r === void 0 && (r = 30);
      var n = this.toHsl(), a = 360 / r, i = [this];
      for (n.h = (n.h - (a * t >> 1) + 720) % 360; --t; )
        n.h = (n.h + a) % 360, i.push(new e(n));
      return i;
    }, e.prototype.complement = function() {
      var t = this.toHsl();
      return t.h = (t.h + 180) % 360, new e(t);
    }, e.prototype.monochromatic = function(t) {
      t === void 0 && (t = 6);
      for (var r = this.toHsv(), n = r.h, a = r.s, i = r.v, o = [], s = 1 / t; t--; )
        o.push(new e({ h: n, s: a, v: i })), i = (i + s) % 1;
      return o;
    }, e.prototype.splitcomplement = function() {
      var t = this.toHsl(), r = t.h;
      return [
        this,
        new e({ h: (r + 72) % 360, s: t.s, l: t.l }),
        new e({ h: (r + 216) % 360, s: t.s, l: t.l })
      ];
    }, e.prototype.onBackground = function(t) {
      var r = this.toRgb(), n = new e(t).toRgb(), a = r.a + n.a * (1 - r.a);
      return new e({
        r: (r.r * r.a + n.r * n.a * (1 - r.a)) / a,
        g: (r.g * r.a + n.g * n.a * (1 - r.a)) / a,
        b: (r.b * r.a + n.b * n.a * (1 - r.a)) / a,
        a
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(t) {
      for (var r = this.toHsl(), n = r.h, a = [this], i = 360 / t, o = 1; o < t; o++)
        a.push(new e({ h: (n + o * i) % 360, s: r.s, l: r.l }));
      return a;
    }, e.prototype.equals = function(t) {
      return this.toRgbString() === new e(t).toRgbString();
    }, e;
  }()
), Hg = 2, q3 = 0.16, Vue = 0.05, Gue = 0.05, Uue = 0.15, _B = 5, EB = 4, Wue = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function K3(e) {
  var t = e.r, r = e.g, n = e.b, a = y2(t, r, n);
  return {
    h: a.h * 360,
    s: a.s,
    v: a.v
  };
}
function Vg(e) {
  var t = e.r, r = e.g, n = e.b;
  return "#".concat(b2(t, r, n, !1));
}
function que(e, t, r) {
  var n = r / 100, a = {
    r: (t.r - e.r) * n + e.r,
    g: (t.g - e.g) * n + e.g,
    b: (t.b - e.b) * n + e.b
  };
  return a;
}
function Y3(e, t, r) {
  var n;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? n = r ? Math.round(e.h) - Hg * t : Math.round(e.h) + Hg * t : n = r ? Math.round(e.h) + Hg * t : Math.round(e.h) - Hg * t, n < 0 ? n += 360 : n >= 360 && (n -= 360), n;
}
function Z3(e, t, r) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var n;
  return r ? n = e.s - q3 * t : t === EB ? n = e.s + q3 : n = e.s + Vue * t, n > 1 && (n = 1), r && t === _B && n > 0.1 && (n = 0.1), n < 0.06 && (n = 0.06), Number(n.toFixed(2));
}
function X3(e, t, r) {
  var n;
  return r ? n = e.v + Gue * t : n = e.v - Uue * t, n > 1 && (n = 1), Number(n.toFixed(2));
}
function Cc(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [], n = Wu(e), a = _B; a > 0; a -= 1) {
    var i = K3(n), o = Vg(Wu({
      h: Y3(i, a, !0),
      s: Z3(i, a, !0),
      v: X3(i, a, !0)
    }));
    r.push(o);
  }
  r.push(Vg(n));
  for (var s = 1; s <= EB; s += 1) {
    var l = K3(n), c = Vg(Wu({
      h: Y3(l, s),
      s: Z3(l, s),
      v: X3(l, s)
    }));
    r.push(c);
  }
  return t.theme === "dark" ? Wue.map(function(u) {
    var d = u.index, f = u.opacity, m = Vg(que(Wu(t.backgroundColor || "#141414"), Wu(r[d]), f * 100));
    return m;
  }) : r;
}
var JS = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, Fa = {}, QS = {};
Object.keys(JS).forEach(function(e) {
  Fa[e] = Cc(JS[e]), Fa[e].primary = Fa[e][5], QS[e] = Cc(JS[e], {
    theme: "dark",
    backgroundColor: "#141414"
  }), QS[e].primary = QS[e][5];
});
Fa.red;
Fa.volcano;
var Kue = Fa.gold;
Fa.orange;
Fa.yellow;
Fa.lime;
Fa.green;
Fa.cyan;
var Yue = Fa.blue;
Fa.geekblue;
Fa.purple;
Fa.magenta;
Fa.grey;
Fa.grey;
const wB = {
  blue: "#1677ff",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  pink: "#eb2f96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, q0 = Object.assign(Object.assign({}, wB), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1,
  // Motion
  motion: !0
});
function Zue(e, t) {
  let {
    generateColorPalettes: r,
    generateNeutralColorPalettes: n
  } = t;
  const {
    colorSuccess: a,
    colorWarning: i,
    colorError: o,
    colorInfo: s,
    colorPrimary: l,
    colorBgBase: c,
    colorTextBase: u
  } = e, d = r(l), f = r(a), m = r(i), h = r(o), g = r(s), y = n(c, u), S = e.colorLink || e.colorInfo, x = r(S);
  return Object.assign(Object.assign({}, y), {
    colorPrimaryBg: d[1],
    colorPrimaryBgHover: d[2],
    colorPrimaryBorder: d[3],
    colorPrimaryBorderHover: d[4],
    colorPrimaryHover: d[5],
    colorPrimary: d[6],
    colorPrimaryActive: d[7],
    colorPrimaryTextHover: d[8],
    colorPrimaryText: d[9],
    colorPrimaryTextActive: d[10],
    colorSuccessBg: f[1],
    colorSuccessBgHover: f[2],
    colorSuccessBorder: f[3],
    colorSuccessBorderHover: f[4],
    colorSuccessHover: f[4],
    colorSuccess: f[6],
    colorSuccessActive: f[7],
    colorSuccessTextHover: f[8],
    colorSuccessText: f[9],
    colorSuccessTextActive: f[10],
    colorErrorBg: h[1],
    colorErrorBgHover: h[2],
    colorErrorBgActive: h[3],
    colorErrorBorder: h[3],
    colorErrorBorderHover: h[4],
    colorErrorHover: h[5],
    colorError: h[6],
    colorErrorActive: h[7],
    colorErrorTextHover: h[8],
    colorErrorText: h[9],
    colorErrorTextActive: h[10],
    colorWarningBg: m[1],
    colorWarningBgHover: m[2],
    colorWarningBorder: m[3],
    colorWarningBorderHover: m[4],
    colorWarningHover: m[4],
    colorWarning: m[6],
    colorWarningActive: m[7],
    colorWarningTextHover: m[8],
    colorWarningText: m[9],
    colorWarningTextActive: m[10],
    colorInfoBg: g[1],
    colorInfoBgHover: g[2],
    colorInfoBorder: g[3],
    colorInfoBorderHover: g[4],
    colorInfoHover: g[4],
    colorInfo: g[6],
    colorInfoActive: g[7],
    colorInfoTextHover: g[8],
    colorInfoText: g[9],
    colorInfoTextActive: g[10],
    colorLinkHover: x[4],
    colorLink: x[6],
    colorLinkActive: x[7],
    colorBgMask: new Br("#000").setAlpha(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
const Xue = (e) => {
  let t = e, r = e, n = e, a = e;
  return e < 6 && e >= 5 ? t = e + 1 : e < 16 && e >= 6 ? t = e + 2 : e >= 16 && (t = 16), e < 7 && e >= 5 ? r = 4 : e < 8 && e >= 7 ? r = 5 : e < 14 && e >= 8 ? r = 6 : e < 16 && e >= 14 ? r = 7 : e >= 16 && (r = 8), e < 6 && e >= 2 ? n = 1 : e >= 6 && (n = 2), e > 4 && e < 8 ? a = 4 : e >= 8 && (a = 6), {
    borderRadius: e,
    borderRadiusXS: n,
    borderRadiusSM: r,
    borderRadiusLG: t,
    borderRadiusOuter: a
  };
};
function Jue(e) {
  const {
    motionUnit: t,
    motionBase: r,
    borderRadius: n,
    lineWidth: a
  } = e;
  return Object.assign({
    // motion
    motionDurationFast: `${(r + t).toFixed(1)}s`,
    motionDurationMid: `${(r + t * 2).toFixed(1)}s`,
    motionDurationSlow: `${(r + t * 3).toFixed(1)}s`,
    // line
    lineWidthBold: a + 1
  }, Xue(n));
}
const Que = (e) => {
  const {
    controlHeight: t
  } = e;
  return {
    controlHeightSM: t * 0.75,
    controlHeightXS: t * 0.5,
    controlHeightLG: t * 1.25
  };
};
function sb(e) {
  return (e + 8) / e;
}
function ede(e) {
  const t = new Array(10).fill(null).map((r, n) => {
    const a = n - 1, i = e * Math.pow(2.71828, a / 5), o = n > 1 ? Math.floor(i) : Math.ceil(i);
    return Math.floor(o / 2) * 2;
  });
  return t[1] = e, t.map((r) => ({
    size: r,
    lineHeight: sb(r)
  }));
}
const tde = (e) => {
  const t = ede(e), r = t.map((u) => u.size), n = t.map((u) => u.lineHeight), a = r[1], i = r[0], o = r[2], s = n[1], l = n[0], c = n[2];
  return {
    fontSizeSM: i,
    fontSize: a,
    fontSizeLG: o,
    fontSizeXL: r[3],
    fontSizeHeading1: r[6],
    fontSizeHeading2: r[5],
    fontSizeHeading3: r[4],
    fontSizeHeading4: r[3],
    fontSizeHeading5: r[2],
    lineHeight: s,
    lineHeightLG: c,
    lineHeightSM: l,
    fontHeight: Math.round(s * a),
    fontHeightLG: Math.round(c * o),
    fontHeightSM: Math.round(l * i),
    lineHeightHeading1: n[6],
    lineHeightHeading2: n[5],
    lineHeightHeading3: n[4],
    lineHeightHeading4: n[3],
    lineHeightHeading5: n[2]
  };
};
function rde(e) {
  const {
    sizeUnit: t,
    sizeStep: r
  } = e;
  return {
    sizeXXL: t * (r + 8),
    // 48
    sizeXL: t * (r + 4),
    // 32
    sizeLG: t * (r + 2),
    // 24
    sizeMD: t * (r + 1),
    // 20
    sizeMS: t * r,
    // 16
    size: t * r,
    // 16
    sizeSM: t * (r - 1),
    // 12
    sizeXS: t * (r - 2),
    // 8
    sizeXXS: t * (r - 3)
    // 4
  };
}
const Os = (e, t) => new Br(e).setAlpha(t).toRgbString(), mf = (e, t) => new Br(e).darken(t).toHexString(), nde = (e) => {
  const t = Cc(e);
  return {
    1: t[0],
    2: t[1],
    3: t[2],
    4: t[3],
    5: t[4],
    6: t[5],
    7: t[6],
    8: t[4],
    9: t[5],
    10: t[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
}, ade = (e, t) => {
  const r = e || "#fff", n = t || "#000";
  return {
    colorBgBase: r,
    colorTextBase: n,
    colorText: Os(n, 0.88),
    colorTextSecondary: Os(n, 0.65),
    colorTextTertiary: Os(n, 0.45),
    colorTextQuaternary: Os(n, 0.25),
    colorFill: Os(n, 0.15),
    colorFillSecondary: Os(n, 0.06),
    colorFillTertiary: Os(n, 0.04),
    colorFillQuaternary: Os(n, 0.02),
    colorBgLayout: mf(r, 4),
    colorBgContainer: mf(r, 0),
    colorBgElevated: mf(r, 0),
    colorBgSpotlight: Os(n, 0.85),
    colorBgBlur: "transparent",
    colorBorder: mf(r, 15),
    colorBorderSecondary: mf(r, 6)
  };
};
function ide(e) {
  const t = Object.keys(wB).map((r) => {
    const n = Cc(e[r]);
    return new Array(10).fill(1).reduce((a, i, o) => (a[`${r}-${o + 1}`] = n[o], a[`${r}${o + 1}`] = n[o], a), {});
  }).reduce((r, n) => (r = Object.assign(Object.assign({}, r), n), r), {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, e), t), Zue(e, {
    generateColorPalettes: nde,
    generateNeutralColorPalettes: ade
  })), tde(e.fontSize)), rde(e)), Que(e)), Jue(e));
}
const OB = d2(ide), S2 = {
  token: q0,
  override: {
    override: q0
  },
  hashed: !0
}, TB = /* @__PURE__ */ xe.createContext(S2), TT = "anticon", ode = (e, t) => t || (e ? `ant-${e}` : "ant"), Lt = /* @__PURE__ */ p.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: ode,
  iconPrefixCls: TT
}), {
  Consumer: KZe
} = Lt, sde = `-ant-${Date.now()}-${Math.random()}`;
function lde(e, t) {
  const r = {}, n = (o, s) => {
    let l = o.clone();
    return l = s?.(l) || l, l.toRgbString();
  }, a = (o, s) => {
    const l = new Br(o), c = Cc(l.toRgbString());
    r[`${s}-color`] = n(l), r[`${s}-color-disabled`] = c[1], r[`${s}-color-hover`] = c[4], r[`${s}-color-active`] = c[6], r[`${s}-color-outline`] = l.clone().setAlpha(0.2).toRgbString(), r[`${s}-color-deprecated-bg`] = c[0], r[`${s}-color-deprecated-border`] = c[2];
  };
  if (t.primaryColor) {
    a(t.primaryColor, "primary");
    const o = new Br(t.primaryColor), s = Cc(o.toRgbString());
    s.forEach((c, u) => {
      r[`primary-${u + 1}`] = c;
    }), r["primary-color-deprecated-l-35"] = n(o, (c) => c.lighten(35)), r["primary-color-deprecated-l-20"] = n(o, (c) => c.lighten(20)), r["primary-color-deprecated-t-20"] = n(o, (c) => c.tint(20)), r["primary-color-deprecated-t-50"] = n(o, (c) => c.tint(50)), r["primary-color-deprecated-f-12"] = n(o, (c) => c.setAlpha(c.getAlpha() * 0.12));
    const l = new Br(s[0]);
    r["primary-color-active-deprecated-f-30"] = n(l, (c) => c.setAlpha(c.getAlpha() * 0.3)), r["primary-color-active-deprecated-d-02"] = n(l, (c) => c.darken(2));
  }
  return t.successColor && a(t.successColor, "success"), t.warningColor && a(t.warningColor, "warning"), t.errorColor && a(t.errorColor, "error"), t.infoColor && a(t.infoColor, "info"), `
  :root {
    ${Object.keys(r).map((o) => `--${e}-${o}: ${r[o]};`).join(`
`)}
  }
  `.trim();
}
function cde(e, t) {
  const r = lde(e, t);
  Ca() ? ks(r, `${sde}-dynamic-theme`) : process.env.NODE_ENV !== "production" && Rc(!1, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}
const Vi = /* @__PURE__ */ p.createContext(!1), IT = (e) => {
  let {
    children: t,
    disabled: r
  } = e;
  const n = p.useContext(Vi);
  return /* @__PURE__ */ p.createElement(Vi.Provider, {
    value: r ?? n
  }, t);
}, Sc = /* @__PURE__ */ p.createContext(void 0), ude = (e) => {
  let {
    children: t,
    size: r
  } = e;
  const n = p.useContext(Sc);
  return /* @__PURE__ */ p.createElement(Sc.Provider, {
    value: r || n
  }, t);
};
function dde() {
  const e = Cr(Vi), t = Cr(Sc);
  return {
    componentDisabled: e,
    componentSize: t
  };
}
const Tb = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"], fde = "5.18.3";
function ex(e) {
  return e >= 0 && e <= 255;
}
function Gg(e, t) {
  const {
    r,
    g: n,
    b: a,
    a: i
  } = new Br(e).toRgb();
  if (i < 1)
    return e;
  const {
    r: o,
    g: s,
    b: l
  } = new Br(t).toRgb();
  for (let c = 0.01; c <= 1; c += 0.01) {
    const u = Math.round((r - o * (1 - c)) / c), d = Math.round((n - s * (1 - c)) / c), f = Math.round((a - l * (1 - c)) / c);
    if (ex(u) && ex(d) && ex(f))
      return new Br({
        r: u,
        g: d,
        b: f,
        a: Math.round(c * 100) / 100
      }).toRgbString();
  }
  return new Br({
    r,
    g: n,
    b: a,
    a: 1
  }).toRgbString();
}
var pde = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function IB(e) {
  const {
    override: t
  } = e, r = pde(e, ["override"]), n = Object.assign({}, t);
  Object.keys(q0).forEach((f) => {
    delete n[f];
  });
  const a = Object.assign(Object.assign({}, r), n), i = 480, o = 576, s = 768, l = 992, c = 1200, u = 1600;
  if (a.motion === !1) {
    const f = "0s";
    a.motionDurationFast = f, a.motionDurationMid = f, a.motionDurationSlow = f;
  }
  return Object.assign(Object.assign(Object.assign({}, a), {
    // ============== Background ============== //
    colorFillContent: a.colorFillSecondary,
    colorFillContentHover: a.colorFill,
    colorFillAlter: a.colorFillQuaternary,
    colorBgContainerDisabled: a.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: a.colorBgContainer,
    colorSplit: Gg(a.colorBorderSecondary, a.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: a.colorTextQuaternary,
    colorTextDisabled: a.colorTextQuaternary,
    colorTextHeading: a.colorText,
    colorTextLabel: a.colorTextSecondary,
    colorTextDescription: a.colorTextTertiary,
    colorTextLightSolid: a.colorWhite,
    colorHighlight: a.colorError,
    colorBgTextHover: a.colorFillSecondary,
    colorBgTextActive: a.colorFill,
    colorIcon: a.colorTextTertiary,
    colorIconHover: a.colorText,
    colorErrorOutline: Gg(a.colorErrorBg, a.colorBgContainer),
    colorWarningOutline: Gg(a.colorWarningBg, a.colorBgContainer),
    // Font
    fontSizeIcon: a.fontSizeSM,
    // Line
    lineWidthFocus: a.lineWidth * 4,
    // Control
    lineWidth: a.lineWidth,
    controlOutlineWidth: a.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: a.controlHeight / 2,
    controlItemBgHover: a.colorFillTertiary,
    controlItemBgActive: a.colorPrimaryBg,
    controlItemBgActiveHover: a.colorPrimaryBgHover,
    controlItemBgActiveDisabled: a.colorFill,
    controlTmpOutline: a.colorFillQuaternary,
    controlOutline: Gg(a.colorPrimaryBg, a.colorBgContainer),
    lineType: a.lineType,
    borderRadius: a.borderRadius,
    borderRadiusXS: a.borderRadiusXS,
    borderRadiusSM: a.borderRadiusSM,
    borderRadiusLG: a.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: a.sizeXXS,
    paddingXS: a.sizeXS,
    paddingSM: a.sizeSM,
    padding: a.size,
    paddingMD: a.sizeMD,
    paddingLG: a.sizeLG,
    paddingXL: a.sizeXL,
    paddingContentHorizontalLG: a.sizeLG,
    paddingContentVerticalLG: a.sizeMS,
    paddingContentHorizontal: a.sizeMS,
    paddingContentVertical: a.sizeSM,
    paddingContentHorizontalSM: a.size,
    paddingContentVerticalSM: a.sizeXS,
    marginXXS: a.sizeXXS,
    marginXS: a.sizeXS,
    marginSM: a.sizeSM,
    margin: a.size,
    marginMD: a.sizeMD,
    marginLG: a.sizeLG,
    marginXL: a.sizeXL,
    marginXXL: a.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: i,
    screenXSMin: i,
    screenXSMax: o - 1,
    screenSM: o,
    screenSMMin: o,
    screenSMMax: s - 1,
    screenMD: s,
    screenMDMin: s,
    screenMDMax: l - 1,
    screenLG: l,
    screenLGMin: l,
    screenLGMax: c - 1,
    screenXL: c,
    screenXLMin: c,
    screenXLMax: u - 1,
    screenXXL: u,
    screenXXLMin: u,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new Br("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new Br("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new Br("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), n);
}
var J3 = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const MB = {
  lineHeight: !0,
  lineHeightSM: !0,
  lineHeightLG: !0,
  lineHeightHeading1: !0,
  lineHeightHeading2: !0,
  lineHeightHeading3: !0,
  lineHeightHeading4: !0,
  lineHeightHeading5: !0,
  opacityLoading: !0,
  fontWeightStrong: !0,
  zIndexPopupBase: !0,
  zIndexBase: !0
}, AB = {
  size: !0,
  sizeSM: !0,
  sizeLG: !0,
  sizeMD: !0,
  sizeXS: !0,
  sizeXXS: !0,
  sizeMS: !0,
  sizeXL: !0,
  sizeXXL: !0,
  sizeUnit: !0,
  sizeStep: !0,
  motionBase: !0,
  motionUnit: !0
}, mde = {
  screenXS: !0,
  screenXSMin: !0,
  screenXSMax: !0,
  screenSM: !0,
  screenSMMin: !0,
  screenSMMax: !0,
  screenMD: !0,
  screenMDMin: !0,
  screenMDMax: !0,
  screenLG: !0,
  screenLGMin: !0,
  screenLGMax: !0,
  screenXL: !0,
  screenXLMin: !0,
  screenXLMax: !0,
  screenXXL: !0,
  screenXXLMin: !0
}, PB = (e, t, r) => {
  const n = r.getDerivativeToken(e), {
    override: a
  } = t, i = J3(t, ["override"]);
  let o = Object.assign(Object.assign({}, n), {
    override: a
  });
  return o = IB(o), i && Object.entries(i).forEach((s) => {
    let [l, c] = s;
    const {
      theme: u
    } = c, d = J3(c, ["theme"]);
    let f = d;
    u && (f = PB(Object.assign(Object.assign({}, o), d), {
      override: d
    }, u)), o[l] = f;
  }), o;
};
function ua() {
  const {
    token: e,
    hashed: t,
    theme: r,
    override: n,
    cssVar: a
  } = xe.useContext(TB), i = `${fde}-${t || ""}`, o = r || OB, [s, l, c] = Zce(o, [q0, e], {
    salt: i,
    override: n,
    getComputedToken: PB,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: IB,
    cssVar: a && {
      prefix: a.prefix,
      key: a.key,
      unitless: MB,
      ignore: AB,
      preserve: mde
    }
  });
  return [o, c, t ? l : "", s, a];
}
const vde = 1e3 * 60 * 10;
let hde = /* @__PURE__ */ function() {
  function e() {
    Hn(this, e), this.map = /* @__PURE__ */ new Map(), this.objectIDMap = /* @__PURE__ */ new WeakMap(), this.nextID = 0, this.lastAccessBeat = /* @__PURE__ */ new Map(), this.accessBeat = 0;
  }
  return Vn(e, [{
    key: "set",
    value: function(r, n) {
      this.clear();
      const a = this.getCompositeKey(r);
      this.map.set(a, n), this.lastAccessBeat.set(a, Date.now());
    }
  }, {
    key: "get",
    value: function(r) {
      const n = this.getCompositeKey(r), a = this.map.get(n);
      return this.lastAccessBeat.set(n, Date.now()), this.accessBeat += 1, a;
    }
  }, {
    key: "getCompositeKey",
    value: function(r) {
      return r.map((a) => a && typeof a == "object" ? `obj_${this.getObjectID(a)}` : `${typeof a}_${a}`).join("|");
    }
  }, {
    key: "getObjectID",
    value: function(r) {
      if (this.objectIDMap.has(r))
        return this.objectIDMap.get(r);
      const n = this.nextID;
      return this.objectIDMap.set(r, n), this.nextID += 1, n;
    }
  }, {
    key: "clear",
    value: function() {
      if (this.accessBeat > 1e4) {
        const r = Date.now();
        this.lastAccessBeat.forEach((n, a) => {
          r - n > vde && (this.map.delete(a), this.lastAccessBeat.delete(a));
        }), this.accessBeat = 0;
      }
    }
  }]);
}();
const Q3 = new hde();
function gde(e, t) {
  return xe.useMemo(() => {
    const r = Q3.get(t);
    if (r)
      return r;
    const n = e();
    return Q3.set(t, n), n;
  }, t);
}
function br(e) {
  var t = p.useRef();
  t.current = e;
  var r = p.useCallback(function() {
    for (var n, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return (n = t.current) === null || n === void 0 ? void 0 : n.call.apply(n, [t].concat(i));
  }, []);
  return r;
}
function xc(e) {
  var t = p.useRef(!1), r = p.useState(e), n = ye(r, 2), a = n[0], i = n[1];
  p.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function o(s, l) {
    l && t.current || i(s);
  }
  return [a, o];
}
function tx(e) {
  return e !== void 0;
}
function Kr(e, t) {
  var r = t || {}, n = r.defaultValue, a = r.value, i = r.onChange, o = r.postState, s = xc(function() {
    return tx(a) ? a : tx(n) ? typeof n == "function" ? n() : n : typeof e == "function" ? e() : e;
  }), l = ye(s, 2), c = l[0], u = l[1], d = a !== void 0 ? a : c, f = o ? o(d) : d, m = br(i), h = xc([d]), g = ye(h, 2), y = g[0], S = g[1];
  vc(function() {
    var b = y[0];
    c !== b && m(c, b);
  }, [y]), vc(function() {
    tx(a) || u(a);
  }, [a]);
  var x = br(function(b, _) {
    u(b, _), S([d], _);
  });
  return [f, x];
}
const MT = (e) => ({
  // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
  // And Typography use this to generate link style which should not do this.
  color: e.colorLink,
  textDecoration: "none",
  outline: "none",
  cursor: "pointer",
  transition: `color ${e.motionDurationSlow}`,
  "&:focus, &:hover": {
    color: e.colorLinkHover
  },
  "&:active": {
    color: e.colorLinkActive
  }
}), cs = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
}, Yr = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return {
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    color: e.colorText,
    fontSize: e.fontSize,
    // font-variant: @font-variant-base;
    lineHeight: e.lineHeight,
    listStyle: "none",
    // font-feature-settings: @font-feature-settings-base;
    fontFamily: t ? "inherit" : e.fontFamily
  };
}, ih = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
}), Bs = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
}), yde = (e) => ({
  a: {
    color: e.colorLink,
    textDecoration: e.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${e.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: e.colorLinkHover
    },
    "&:active": {
      color: e.colorLinkActive
    },
    "&:active,\n  &:hover": {
      textDecoration: e.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: e.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: e.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
}), bde = (e, t, r, n) => {
  const a = `[class^="${t}"], [class*=" ${t}"]`, i = r ? `.${r}` : a, o = {
    boxSizing: "border-box",
    "&::before, &::after": {
      boxSizing: "border-box"
    }
  };
  let s = {};
  return n !== !1 && (s = {
    fontFamily: e.fontFamily,
    fontSize: e.fontSize
  }), {
    [i]: Object.assign(Object.assign(Object.assign({}, s), o), {
      [a]: o
    })
  };
}, Sl = (e) => ({
  outline: `${ve(e.lineWidthFocus)} solid ${e.colorPrimaryBorder}`,
  outlineOffset: 1,
  transition: "outline-offset 0s, outline 0s"
}), zs = (e) => ({
  "&:focus-visible": Object.assign({}, Sl(e))
});
function Cde(e) {
  return e === "js" ? {
    max: Math.max,
    min: Math.min
  } : {
    max: function() {
      for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
        r[n] = arguments[n];
      return `max(${r.map((a) => ve(a)).join(",")})`;
    },
    min: function() {
      for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
        r[n] = arguments[n];
      return `min(${r.map((a) => ve(a)).join(",")})`;
    }
  };
}
const RB = process.env.NODE_ENV !== "production" || typeof CSSINJS_STATISTIC < "u";
let x2 = !0;
function $r() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  if (!RB)
    return Object.assign.apply(Object, [{}].concat(t));
  x2 = !1;
  const n = {};
  return t.forEach((a) => {
    Object.keys(a).forEach((o) => {
      Object.defineProperty(n, o, {
        configurable: !0,
        enumerable: !0,
        get: () => a[o]
      });
    });
  }), x2 = !0, n;
}
const eR = {};
function Sde() {
}
const xde = (e) => {
  let t, r = e, n = Sde;
  return RB && typeof Proxy < "u" && (t = /* @__PURE__ */ new Set(), r = new Proxy(e, {
    get(a, i) {
      return x2 && t.add(i), a[i];
    }
  }), n = (a, i) => {
    var o;
    eR[a] = {
      global: Array.from(t),
      component: Object.assign(Object.assign({}, (o = eR[a]) === null || o === void 0 ? void 0 : o.component), i)
    };
  }), {
    token: r,
    keys: t,
    flush: n
  };
}, NB = (e, t) => {
  const [r, n] = ua();
  return g2({
    token: n,
    hashId: "",
    path: ["ant-design-icons", e],
    nonce: () => t?.nonce,
    layer: {
      name: "antd"
    }
  }, () => [{
    [`.${e}`]: Object.assign(Object.assign({}, ih()), {
      [`.${e} .${e}-icon`]: {
        display: "block"
      }
    })
  }]);
}, DB = (e, t, r) => {
  var n;
  return typeof r == "function" ? r($r(t, (n = t[e]) !== null && n !== void 0 ? n : {})) : r ?? {};
}, jB = (e, t, r, n) => {
  const a = Object.assign({}, t[e]);
  if (n?.deprecatedTokens) {
    const {
      deprecatedTokens: o
    } = n;
    o.forEach((s) => {
      let [l, c] = s;
      var u;
      process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && jt(!a?.[l], `Component Token \`${String(l)}\` of ${e} is deprecated. Please use \`${String(c)}\` instead.`), (a?.[l] || a?.[c]) && ((u = a[c]) !== null && u !== void 0 || (a[c] = a?.[l]));
    });
  }
  const i = Object.assign(Object.assign({}, r), a);
  return Object.keys(i).forEach((o) => {
    i[o] === t[o] && delete i[o];
  }), i;
}, tR = (e, t) => `${[t, e.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-")}`;
function AT(e, t, r) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  const a = Array.isArray(e) ? e : [e, e], [i] = a, o = a.join("-");
  return function(s) {
    let l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : s;
    const [c, u, d, f, m] = ua(), {
      getPrefixCls: h,
      iconPrefixCls: g,
      csp: y
    } = Cr(Lt), S = h(), x = m ? "css" : "js", b = gde(() => {
      const T = /* @__PURE__ */ new Set();
      return m && Object.keys(n.unitless || {}).forEach((I) => {
        T.add(eb(I, m.prefix)), T.add(eb(I, tR(i, m.prefix)));
      }), wce(x, T);
    }, [x, i, m && m.prefix]), {
      max: _,
      min: $
    } = Cde(x), w = {
      theme: c,
      token: f,
      hashId: d,
      nonce: () => y?.nonce,
      clientOnly: n.clientOnly,
      layer: {
        name: "antd"
      },
      // antd is always at top of styles
      order: n.order || -999
    };
    return g2(Object.assign(Object.assign({}, w), {
      clientOnly: !1,
      path: ["Shared", S]
    }), () => [{
      // Link
      "&": yde(f)
    }]), NB(g, y), [g2(Object.assign(Object.assign({}, w), {
      path: [o, s, g]
    }), () => {
      if (n.injectStyle === !1)
        return [];
      const {
        token: T,
        flush: I
      } = xde(f), P = DB(i, u, r), D = `.${s}`, B = jB(i, u, P, {
        deprecatedTokens: n.deprecatedTokens
      });
      m && Object.keys(P).forEach((z) => {
        P[z] = `var(${eb(z, tR(i, m.prefix))})`;
      });
      const L = $r(T, {
        componentCls: D,
        prefixCls: s,
        iconCls: `.${g}`,
        antCls: `.${S}`,
        calc: b,
        // @ts-ignore
        max: _,
        // @ts-ignore
        min: $
      }, m ? P : B), N = t(L, {
        hashId: d,
        prefixCls: s,
        rootPrefixCls: S,
        iconPrefixCls: g
      });
      return I(i, B), [n.resetStyle === !1 ? null : bde(L, s, l, n.resetFont), N];
    }), d];
  };
}
const vd = (e, t, r, n) => {
  const a = AT(e, t, r, Object.assign({
    resetStyle: !1,
    // Sub Style should default after root one
    order: -998
  }, n)), i = (o) => {
    let {
      prefixCls: s,
      rootCls: l = s
    } = o;
    return a(s, l), null;
  };
  return process.env.NODE_ENV !== "production" && (i.displayName = `SubStyle_${Array.isArray(e) ? e.join(".") : e}`), i;
}, $de = (e, t, r) => {
  const {
    unitless: n,
    injectStyle: a = !0,
    prefixToken: i
  } = r, o = (l) => {
    let {
      rootCls: c,
      cssVar: u
    } = l;
    const [, d] = ua();
    return Eue({
      path: [e],
      prefix: u.prefix,
      key: u?.key,
      unitless: n,
      ignore: AB,
      token: d,
      scope: c
    }, () => {
      const f = DB(e, d, t), m = jB(e, d, f, {
        deprecatedTokens: r?.deprecatedTokens
      });
      return Object.keys(f).forEach((h) => {
        m[i(h)] = m[h], delete m[h];
      }), m;
    }), null;
  };
  return (l) => {
    const [, , , , c] = ua();
    return [(u) => a && c ? /* @__PURE__ */ xe.createElement(xe.Fragment, null, /* @__PURE__ */ xe.createElement(o, {
      rootCls: l,
      cssVar: c,
      component: e
    }), u) : u, c?.key];
  };
}, Zr = (e, t, r, n) => {
  const a = Array.isArray(e) ? e[0] : e;
  function i(d) {
    return `${a}${d.slice(0, 1).toUpperCase()}${d.slice(1)}`;
  }
  const o = n && n.unitless || {}, s = Object.assign(Object.assign({}, MB), {
    [i("zIndexPopup")]: !0
  });
  Object.keys(o).forEach((d) => {
    s[i(d)] = o[d];
  });
  const l = Object.assign(Object.assign({}, n), {
    unitless: s,
    prefixToken: i
  }), c = AT(e, t, r, l), u = $de(a, r, l);
  return function(d) {
    let f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : d;
    const [, m] = c(d, f), [h, g] = u(f);
    return [h, m, g];
  };
};
function LB(e, t) {
  return Tb.reduce((r, n) => {
    const a = e[`${n}1`], i = e[`${n}3`], o = e[`${n}6`], s = e[`${n}7`];
    return Object.assign(Object.assign({}, r), t(n, {
      lightColor: a,
      lightBorderColor: i,
      darkColor: o,
      textColor: s
    }));
  }, {});
}
const _de = Object.assign({}, p), {
  useId: rR
} = _de, Ede = () => "", wde = typeof rR > "u" ? Ede : rR;
function Ode(e, t, r) {
  var n, a;
  const i = xr("ConfigProvider"), o = e || {}, s = o.inherit === !1 || !t ? Object.assign(Object.assign({}, S2), {
    hashed: (n = t?.hashed) !== null && n !== void 0 ? n : S2.hashed,
    cssVar: t?.cssVar
  }) : t, l = wde();
  if (process.env.NODE_ENV !== "production") {
    const c = o.cssVar || s.cssVar, u = !!(typeof o.cssVar == "object" && (!((a = o.cssVar) === null || a === void 0) && a.key) || l);
    process.env.NODE_ENV !== "production" && i(!c || u, "breaking", "Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.");
  }
  return Pc(() => {
    var c, u;
    if (!e)
      return t;
    const d = Object.assign({}, s.components);
    Object.keys(e.components || {}).forEach((h) => {
      d[h] = Object.assign(Object.assign({}, d[h]), e.components[h]);
    });
    const f = `css-var-${l.replace(/:/g, "")}`, m = ((c = o.cssVar) !== null && c !== void 0 ? c : s.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: r?.prefixCls
    }, typeof s.cssVar == "object" ? s.cssVar : {}), typeof o.cssVar == "object" ? o.cssVar : {}), {
      key: typeof o.cssVar == "object" && ((u = o.cssVar) === null || u === void 0 ? void 0 : u.key) || f
    });
    return Object.assign(Object.assign(Object.assign({}, s), o), {
      token: Object.assign(Object.assign({}, s.token), o.token),
      components: d,
      cssVar: m
    });
  }, [o, s], (c, u) => c.some((d, f) => {
    const m = u[f];
    return !Do(d, m, !0);
  }));
}
var Tde = ["children"], kB = /* @__PURE__ */ p.createContext({});
function Ide(e) {
  var t = e.children, r = Kt(e, Tde);
  return /* @__PURE__ */ p.createElement(kB.Provider, {
    value: r
  }, t);
}
var Mde = /* @__PURE__ */ function(e) {
  ds(r, e);
  var t = fs(r);
  function r() {
    return Hn(this, r), t.apply(this, arguments);
  }
  return Vn(r, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), r;
}(p.Component);
function Ade(e) {
  var t = p.useReducer(function(s) {
    return s + 1;
  }, 0), r = ye(t, 2), n = r[1], a = p.useRef(e), i = br(function() {
    return a.current;
  }), o = br(function(s) {
    a.current = typeof s == "function" ? s(a.current) : s, n();
  });
  return [i, o];
}
var dl = "none", Ug = "appear", Wg = "enter", qg = "leave", nR = "none", To = "prepare", Zu = "start", Xu = "active", PT = "end", FB = "prepared";
function aR(e, t) {
  var r = {};
  return r[e.toLowerCase()] = t.toLowerCase(), r["Webkit".concat(e)] = "webkit".concat(t), r["Moz".concat(e)] = "moz".concat(t), r["ms".concat(e)] = "MS".concat(t), r["O".concat(e)] = "o".concat(t.toLowerCase()), r;
}
function Pde(e, t) {
  var r = {
    animationend: aR("Animation", "AnimationEnd"),
    transitionend: aR("Transition", "TransitionEnd")
  };
  return e && ("AnimationEvent" in t || delete r.animationend.animation, "TransitionEvent" in t || delete r.transitionend.transition), r;
}
var Rde = Pde(Ca(), typeof window < "u" ? window : {}), BB = {};
if (Ca()) {
  var Nde = document.createElement("div");
  BB = Nde.style;
}
var Kg = {};
function zB(e) {
  if (Kg[e])
    return Kg[e];
  var t = Rde[e];
  if (t)
    for (var r = Object.keys(t), n = r.length, a = 0; a < n; a += 1) {
      var i = r[a];
      if (Object.prototype.hasOwnProperty.call(t, i) && i in BB)
        return Kg[e] = t[i], Kg[e];
    }
  return "";
}
var HB = zB("animationend"), VB = zB("transitionend"), GB = !!(HB && VB), iR = HB || "animationend", oR = VB || "transitionend";
function sR(e, t) {
  if (!e) return null;
  if (kt(e) === "object") {
    var r = t.replace(/-\w/g, function(n) {
      return n[1].toUpperCase();
    });
    return e[r];
  }
  return "".concat(e, "-").concat(t);
}
const Dde = function(e) {
  var t = ct();
  function r(a) {
    a && (a.removeEventListener(oR, e), a.removeEventListener(iR, e));
  }
  function n(a) {
    t.current && t.current !== a && r(t.current), a && a !== t.current && (a.addEventListener(oR, e), a.addEventListener(iR, e), t.current = a);
  }
  return p.useEffect(function() {
    return function() {
      r(t.current);
    };
  }, []), [n, r];
};
var UB = Ca() ? Ele : St;
const jde = function() {
  var e = p.useRef(null);
  function t() {
    vr.cancel(e.current);
  }
  function r(n) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    t();
    var i = vr(function() {
      a <= 1 ? n({
        isCanceled: function() {
          return i !== e.current;
        }
      }) : r(n, a - 1);
    });
    e.current = i;
  }
  return p.useEffect(function() {
    return function() {
      t();
    };
  }, []), [r, t];
};
var Lde = [To, Zu, Xu, PT], kde = [To, FB], WB = !1, Fde = !0;
function qB(e) {
  return e === Xu || e === PT;
}
const Bde = function(e, t, r) {
  var n = xc(nR), a = ye(n, 2), i = a[0], o = a[1], s = jde(), l = ye(s, 2), c = l[0], u = l[1];
  function d() {
    o(To, !0);
  }
  var f = t ? kde : Lde;
  return UB(function() {
    if (i !== nR && i !== PT) {
      var m = f.indexOf(i), h = f[m + 1], g = r(i);
      g === WB ? o(h, !0) : h && c(function(y) {
        function S() {
          y.isCanceled() || o(h, !0);
        }
        g === !0 ? S() : Promise.resolve(g).then(S);
      });
    }
  }, [e, i]), p.useEffect(function() {
    return function() {
      u();
    };
  }, []), [d, i];
};
function zde(e, t, r, n) {
  var a = n.motionEnter, i = a === void 0 ? !0 : a, o = n.motionAppear, s = o === void 0 ? !0 : o, l = n.motionLeave, c = l === void 0 ? !0 : l, u = n.motionDeadline, d = n.motionLeaveImmediately, f = n.onAppearPrepare, m = n.onEnterPrepare, h = n.onLeavePrepare, g = n.onAppearStart, y = n.onEnterStart, S = n.onLeaveStart, x = n.onAppearActive, b = n.onEnterActive, _ = n.onLeaveActive, $ = n.onAppearEnd, w = n.onEnterEnd, O = n.onLeaveEnd, T = n.onVisibleChanged, I = xc(), P = ye(I, 2), D = P[0], B = P[1], L = Ade(dl), N = ye(L, 2), z = N[0], F = N[1], j = xc(null), H = ye(j, 2), U = H[0], G = H[1], V = z(), K = ct(!1), Z = ct(null);
  function ee() {
    return r();
  }
  var ae = ct(!1);
  function ue() {
    F(dl), G(null, !0);
  }
  var re = br(function(Y) {
    var X = z();
    if (X !== dl) {
      var pe = ee();
      if (!(Y && !Y.deadline && Y.target !== pe)) {
        var $e = ae.current, J;
        X === Ug && $e ? J = $?.(pe, Y) : X === Wg && $e ? J = w?.(pe, Y) : X === qg && $e && (J = O?.(pe, Y)), $e && J !== !1 && ue();
      }
    }
  }), oe = Dde(re), fe = ye(oe, 1), le = fe[0], se = function(X) {
    switch (X) {
      case Ug:
        return te(te(te({}, To, f), Zu, g), Xu, x);
      case Wg:
        return te(te(te({}, To, m), Zu, y), Xu, b);
      case qg:
        return te(te(te({}, To, h), Zu, S), Xu, _);
      default:
        return {};
    }
  }, Q = p.useMemo(function() {
    return se(V);
  }, [V]), he = Bde(V, !e, function(Y) {
    if (Y === To) {
      var X = Q[To];
      return X ? X(ee()) : WB;
    }
    if (k in Q) {
      var pe;
      G(((pe = Q[k]) === null || pe === void 0 ? void 0 : pe.call(Q, ee(), null)) || null);
    }
    return k === Xu && V !== dl && (le(ee()), u > 0 && (clearTimeout(Z.current), Z.current = setTimeout(function() {
      re({
        deadline: !0
      });
    }, u))), k === FB && ue(), Fde;
  }), ne = ye(he, 2), me = ne[0], k = ne[1], M = qB(k);
  ae.current = M, UB(function() {
    B(t);
    var Y = K.current;
    K.current = !0;
    var X;
    !Y && t && s && (X = Ug), Y && t && i && (X = Wg), (Y && !t && c || !Y && d && !t && c) && (X = qg);
    var pe = se(X);
    X && (e || pe[To]) ? (F(X), me()) : F(dl);
  }, [t]), St(function() {
    // Cancel appear
    (V === Ug && !s || // Cancel enter
    V === Wg && !i || // Cancel leave
    V === qg && !c) && F(dl);
  }, [s, i, c]), St(function() {
    return function() {
      K.current = !1, clearTimeout(Z.current);
    };
  }, []);
  var R = p.useRef(!1);
  St(function() {
    D && (R.current = !0), D !== void 0 && V === dl && ((R.current || D) && T?.(D), R.current = !0);
  }, [D, V]);
  var q = U;
  return Q[To] && k === Zu && (q = ce({
    transition: "none"
  }, q)), [V, k, q, D ?? t];
}
function Hde(e) {
  var t = e;
  kt(e) === "object" && (t = e.transitionSupport);
  function r(a, i) {
    return !!(a.motionName && t && i !== !1);
  }
  var n = /* @__PURE__ */ p.forwardRef(function(a, i) {
    var o = a.visible, s = o === void 0 ? !0 : o, l = a.removeOnLeave, c = l === void 0 ? !0 : l, u = a.forceRender, d = a.children, f = a.motionName, m = a.leavedClassName, h = a.eventProps, g = p.useContext(kB), y = g.motion, S = r(a, y), x = ct(), b = ct();
    function _() {
      try {
        return x.current instanceof HTMLElement ? x.current : I0(b.current);
      } catch {
        return null;
      }
    }
    var $ = zde(S, s, _, a), w = ye($, 4), O = w[0], T = w[1], I = w[2], P = w[3], D = p.useRef(P);
    P && (D.current = !0);
    var B = p.useCallback(function(U) {
      x.current = U, B0(i, U);
    }, [i]), L, N = ce(ce({}, h), {}, {
      visible: s
    });
    if (!d)
      L = null;
    else if (O === dl)
      P ? L = d(ce({}, N), B) : !c && D.current && m ? L = d(ce(ce({}, N), {}, {
        className: m
      }), B) : u || !c && !m ? L = d(ce(ce({}, N), {}, {
        style: {
          display: "none"
        }
      }), B) : L = null;
    else {
      var z;
      T === To ? z = "prepare" : qB(T) ? z = "active" : T === Zu && (z = "start");
      var F = sR(f, "".concat(O, "-").concat(z));
      L = d(ce(ce({}, N), {}, {
        className: be(sR(f, O), te(te({}, F, F && z), f, typeof f == "string")),
        style: I
      }), B);
    }
    if (/* @__PURE__ */ p.isValidElement(L) && No(L)) {
      var j = L, H = j.ref;
      H || (L = /* @__PURE__ */ p.cloneElement(L, {
        ref: B
      }));
    }
    return /* @__PURE__ */ p.createElement(Mde, {
      ref: b
    }, L);
  });
  return n.displayName = "CSSMotion", n;
}
const Ci = Hde(GB);
var $2 = "add", _2 = "keep", E2 = "remove", rx = "removed";
function Vde(e) {
  var t;
  return e && kt(e) === "object" && "key" in e ? t = e : t = {
    key: e
  }, ce(ce({}, t), {}, {
    key: String(t.key)
  });
}
function w2() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return e.map(Vde);
}
function Gde() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = [], n = 0, a = t.length, i = w2(e), o = w2(t);
  i.forEach(function(c) {
    for (var u = !1, d = n; d < a; d += 1) {
      var f = o[d];
      if (f.key === c.key) {
        n < d && (r = r.concat(o.slice(n, d).map(function(m) {
          return ce(ce({}, m), {}, {
            status: $2
          });
        })), n = d), r.push(ce(ce({}, f), {}, {
          status: _2
        })), n += 1, u = !0;
        break;
      }
    }
    u || r.push(ce(ce({}, c), {}, {
      status: E2
    }));
  }), n < a && (r = r.concat(o.slice(n).map(function(c) {
    return ce(ce({}, c), {}, {
      status: $2
    });
  })));
  var s = {};
  r.forEach(function(c) {
    var u = c.key;
    s[u] = (s[u] || 0) + 1;
  });
  var l = Object.keys(s).filter(function(c) {
    return s[c] > 1;
  });
  return l.forEach(function(c) {
    r = r.filter(function(u) {
      var d = u.key, f = u.status;
      return d !== c || f !== E2;
    }), r.forEach(function(u) {
      u.key === c && (u.status = _2);
    });
  }), r;
}
var Ude = ["component", "children", "onVisibleChanged", "onAllRemoved"], Wde = ["status"], qde = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function Kde(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ci, r = /* @__PURE__ */ function(n) {
    ds(i, n);
    var a = fs(i);
    function i() {
      var o;
      Hn(this, i);
      for (var s = arguments.length, l = new Array(s), c = 0; c < s; c++)
        l[c] = arguments[c];
      return o = a.call.apply(a, [this].concat(l)), te(at(o), "state", {
        keyEntities: []
      }), te(at(o), "removeKey", function(u) {
        var d = o.state.keyEntities, f = d.map(function(m) {
          return m.key !== u ? m : ce(ce({}, m), {}, {
            status: rx
          });
        });
        return o.setState({
          keyEntities: f
        }), f.filter(function(m) {
          var h = m.status;
          return h !== rx;
        }).length;
      }), o;
    }
    return Vn(i, [{
      key: "render",
      value: function() {
        var s = this, l = this.state.keyEntities, c = this.props, u = c.component, d = c.children, f = c.onVisibleChanged, m = c.onAllRemoved, h = Kt(c, Ude), g = u || p.Fragment, y = {};
        return qde.forEach(function(S) {
          y[S] = h[S], delete h[S];
        }), delete h.keys, /* @__PURE__ */ p.createElement(g, h, l.map(function(S, x) {
          var b = S.status, _ = Kt(S, Wde), $ = b === $2 || b === _2;
          return /* @__PURE__ */ p.createElement(t, Pe({}, y, {
            key: _.key,
            visible: $,
            eventProps: _,
            onVisibleChanged: function(O) {
              if (f?.(O, {
                key: _.key
              }), !O) {
                var T = s.removeKey(_.key);
                T === 0 && m && m();
              }
            }
          }), function(w, O) {
            return d(ce(ce({}, w), {}, {
              index: x
            }), O);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(s, l) {
        var c = s.keys, u = l.keyEntities, d = w2(c), f = Gde(u, d);
        return {
          keyEntities: f.filter(function(m) {
            var h = u.find(function(g) {
              var y = g.key;
              return m.key === y;
            });
            return !(h && h.status === rx && m.status === E2);
          })
        };
      }
    }]), i;
  }(p.Component);
  return te(r, "defaultProps", {
    component: "div"
  }), r;
}
const KB = Kde(GB);
function Yde(e) {
  const {
    children: t
  } = e, [, r] = ua(), {
    motion: n
  } = r, a = p.useRef(!1);
  return a.current = a.current || n === !1, a.current ? /* @__PURE__ */ p.createElement(Ide, {
    motion: n
  }, t) : t;
}
const YB = /* @__PURE__ */ p.memo((e) => {
  let {
    dropdownMatchSelectWidth: t
  } = e;
  return xr("ConfigProvider").deprecated(t === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), null;
});
process.env.NODE_ENV !== "production" && (YB.displayName = "PropWarning");
const Zde = process.env.NODE_ENV !== "production" ? YB : () => null;
var Xde = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
let O2 = !1;
const ZB = process.env.NODE_ENV !== "production" ? (e) => {
  process.env.NODE_ENV !== "production" && Rc(!O2, e, "Static function can not consume context like dynamic theme. Please use 'App' component instead.");
} : (
  /* istanbul ignore next */
  null
), Jde = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"], XB = "ant";
let Ib, JB, QB, ez;
function lb() {
  return Ib || XB;
}
function Qde() {
  return JB || TT;
}
function efe(e) {
  return Object.keys(e).some((t) => t.endsWith("Color"));
}
const tfe = (e) => {
  const {
    prefixCls: t,
    iconPrefixCls: r,
    theme: n,
    holderRender: a
  } = e;
  t !== void 0 && (Ib = t), r !== void 0 && (JB = r), "holderRender" in e && (ez = a), n && (efe(n) ? (process.env.NODE_ENV !== "production" && Rc(!1, "ConfigProvider", "`config` of css variable theme is not work in v5. Please use new `theme` config instead."), cde(lb(), n)) : QB = n);
}, RT = () => ({
  getPrefixCls: (e, t) => t || (e ? `${lb()}-${e}` : lb()),
  getIconPrefixCls: Qde,
  getRootPrefixCls: () => Ib || lb(),
  getTheme: () => QB,
  holderRender: ez
}), rfe = (e) => {
  const {
    children: t,
    csp: r,
    autoInsertSpaceInButton: n,
    alert: a,
    anchor: i,
    form: o,
    locale: s,
    componentSize: l,
    direction: c,
    space: u,
    virtual: d,
    dropdownMatchSelectWidth: f,
    popupMatchSelectWidth: m,
    popupOverflow: h,
    legacyLocale: g,
    parentContext: y,
    iconPrefixCls: S,
    theme: x,
    componentDisabled: b,
    segmented: _,
    statistic: $,
    spin: w,
    calendar: O,
    carousel: T,
    cascader: I,
    collapse: P,
    typography: D,
    checkbox: B,
    descriptions: L,
    divider: N,
    drawer: z,
    skeleton: F,
    steps: j,
    image: H,
    layout: U,
    list: G,
    mentions: V,
    modal: K,
    progress: Z,
    result: ee,
    slider: ae,
    breadcrumb: ue,
    menu: re,
    pagination: oe,
    input: fe,
    textArea: le,
    empty: se,
    badge: Q,
    radio: he,
    rate: ne,
    switch: me,
    transfer: k,
    avatar: M,
    message: R,
    tag: q,
    table: Y,
    card: X,
    tabs: pe,
    timeline: $e,
    timePicker: J,
    upload: de,
    notification: Se,
    tree: Ee,
    colorPicker: Te,
    datePicker: Le,
    rangePicker: Ie,
    flex: De,
    wave: Ae,
    dropdown: Fe,
    warning: Ne,
    tour: qe,
    floatButtonGroup: Qe
  } = e, tt = p.useCallback((Je, _t) => {
    const {
      prefixCls: Vt
    } = e;
    if (_t)
      return _t;
    const ot = Vt || y.getPrefixCls("");
    return Je ? `${ot}-${Je}` : ot;
  }, [y.getPrefixCls, e.prefixCls]), Ge = S || y.iconPrefixCls || TT, it = r || y.csp;
  NB(Ge, it);
  const ht = Ode(x, y.theme, {
    prefixCls: tt("")
  });
  process.env.NODE_ENV !== "production" && (O2 = O2 || !!ht);
  const It = {
    csp: it,
    autoInsertSpaceInButton: n,
    alert: a,
    anchor: i,
    locale: s || g,
    direction: c,
    space: u,
    virtual: d,
    popupMatchSelectWidth: m ?? f,
    popupOverflow: h,
    getPrefixCls: tt,
    iconPrefixCls: Ge,
    theme: ht,
    segmented: _,
    statistic: $,
    spin: w,
    calendar: O,
    carousel: T,
    cascader: I,
    collapse: P,
    typography: D,
    checkbox: B,
    descriptions: L,
    divider: N,
    drawer: z,
    skeleton: F,
    steps: j,
    image: H,
    input: fe,
    textArea: le,
    layout: U,
    list: G,
    mentions: V,
    modal: K,
    progress: Z,
    result: ee,
    slider: ae,
    breadcrumb: ue,
    menu: re,
    pagination: oe,
    empty: se,
    badge: Q,
    radio: he,
    rate: ne,
    switch: me,
    transfer: k,
    avatar: M,
    message: R,
    tag: q,
    table: Y,
    card: X,
    tabs: pe,
    timeline: $e,
    timePicker: J,
    upload: de,
    notification: Se,
    tree: Ee,
    colorPicker: Te,
    datePicker: Le,
    rangePicker: Ie,
    flex: De,
    wave: Ae,
    dropdown: Fe,
    warning: Ne,
    tour: qe,
    floatButtonGroup: Qe
  };
  process.env.NODE_ENV !== "production" && xr("ConfigProvider")(!("autoInsertSpaceInButton" in e), "deprecated", "`autoInsertSpaceInButton` is deprecated. Please use `{ button: { autoInsertSpace: boolean }}` instead.");
  const xt = Object.assign({}, y);
  Object.keys(It).forEach((Je) => {
    It[Je] !== void 0 && (xt[Je] = It[Je]);
  }), Jde.forEach((Je) => {
    const _t = e[Je];
    _t && (xt[Je] = _t);
  }), typeof n < "u" && (xt.button = Object.assign({
    autoInsertSpace: n
  }, xt.button));
  const Xe = Pc(() => xt, xt, (Je, _t) => {
    const Vt = Object.keys(Je), ot = Object.keys(_t);
    return Vt.length !== ot.length || Vt.some((Ct) => Je[Ct] !== _t[Ct]);
  }), pt = p.useMemo(() => ({
    prefixCls: Ge,
    csp: it
  }), [Ge, it]);
  let Ze = /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement(Zde, {
    dropdownMatchSelectWidth: f
  }), t);
  const wt = p.useMemo(() => {
    var Je, _t, Vt, ot;
    return Yu(((Je = jo.Form) === null || Je === void 0 ? void 0 : Je.defaultValidateMessages) || {}, ((Vt = (_t = Xe.locale) === null || _t === void 0 ? void 0 : _t.Form) === null || Vt === void 0 ? void 0 : Vt.defaultValidateMessages) || {}, ((ot = Xe.form) === null || ot === void 0 ? void 0 : ot.validateMessages) || {}, o?.validateMessages || {});
  }, [Xe, o?.validateMessages]);
  Object.keys(wt).length > 0 && (Ze = /* @__PURE__ */ p.createElement(gB.Provider, {
    value: wt
  }, Ze)), s && (Ze = /* @__PURE__ */ p.createElement(xB, {
    locale: s,
    _ANT_MARK__: SB
  }, Ze)), Ze = /* @__PURE__ */ p.createElement(ET.Provider, {
    value: pt
  }, Ze), l && (Ze = /* @__PURE__ */ p.createElement(ude, {
    size: l
  }, Ze)), Ze = /* @__PURE__ */ p.createElement(Yde, null, Ze);
  const bt = p.useMemo(() => {
    const Je = ht || {}, {
      algorithm: _t,
      token: Vt,
      components: ot,
      cssVar: Ct
    } = Je, rt = Xde(Je, ["algorithm", "token", "components", "cssVar"]), $t = _t && (!Array.isArray(_t) || _t.length > 0) ? d2(_t) : OB, Wt = {};
    Object.entries(ot || {}).forEach((Ke) => {
      let [nt, Ve] = Ke;
      const ke = Object.assign({}, Ve);
      "algorithm" in ke && (ke.algorithm === !0 ? ke.theme = $t : (Array.isArray(ke.algorithm) || typeof ke.algorithm == "function") && (ke.theme = d2(ke.algorithm)), delete ke.algorithm), Wt[nt] = ke;
    });
    const _e = Object.assign(Object.assign({}, q0), Vt);
    return Object.assign(Object.assign({}, rt), {
      theme: $t,
      token: _e,
      components: Wt,
      override: Object.assign({
        override: _e
      }, Wt),
      cssVar: Ct
    });
  }, [ht]);
  return x && (Ze = /* @__PURE__ */ p.createElement(TB.Provider, {
    value: bt
  }, Ze)), Xe.warning && (Ze = /* @__PURE__ */ p.createElement(hB.Provider, {
    value: Xe.warning
  }, Ze)), b !== void 0 && (Ze = /* @__PURE__ */ p.createElement(IT, {
    disabled: b
  }, Ze)), /* @__PURE__ */ p.createElement(Lt.Provider, {
    value: Xe
  }, Ze);
}, Fo = (e) => {
  const t = p.useContext(Lt), r = p.useContext(OT);
  return /* @__PURE__ */ p.createElement(rfe, Object.assign({
    parentContext: t,
    legacyLocale: r
  }, e));
};
Fo.ConfigContext = Lt;
Fo.SizeContext = Sc;
Fo.config = tfe;
Fo.useConfig = dde;
Object.defineProperty(Fo, "SizeContext", {
  get: () => (process.env.NODE_ENV !== "production" && Rc(!1, "ConfigProvider", "ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead."), Sc)
});
process.env.NODE_ENV !== "production" && (Fo.displayName = "ConfigProvider");
var nfe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, name: "check-circle", theme: "filled" };
function tz(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
}
function afe(e) {
  return tz(e) instanceof ShadowRoot;
}
function Mb(e) {
  return afe(e) ? tz(e) : null;
}
function ife(e) {
  return e.replace(/-(.)/g, function(t, r) {
    return r.toUpperCase();
  });
}
function ofe(e, t) {
  jt(e, "[@ant-design/icons] ".concat(t));
}
function lR(e) {
  return kt(e) === "object" && typeof e.name == "string" && typeof e.theme == "string" && (kt(e.icon) === "object" || typeof e.icon == "function");
}
function cR() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(e).reduce(function(t, r) {
    var n = e[r];
    switch (r) {
      case "class":
        t.className = n, delete t.class;
        break;
      default:
        delete t[r], t[ife(r)] = n;
    }
    return t;
  }, {});
}
function T2(e, t, r) {
  return r ? /* @__PURE__ */ xe.createElement(e.tag, ce(ce({
    key: t
  }, cR(e.attrs)), r), (e.children || []).map(function(n, a) {
    return T2(n, "".concat(t, "-").concat(e.tag, "-").concat(a));
  })) : /* @__PURE__ */ xe.createElement(e.tag, ce({
    key: t
  }, cR(e.attrs)), (e.children || []).map(function(n, a) {
    return T2(n, "".concat(t, "-").concat(e.tag, "-").concat(a));
  }));
}
function rz(e) {
  return Cc(e)[0];
}
function nz(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var sfe = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, lfe = function(t) {
  var r = Cr(ET), n = r.csp, a = r.prefixCls, i = sfe;
  a && (i = i.replace(/anticon/g, a)), St(function() {
    var o = t.current, s = Mb(o);
    ks(i, "@ant-design-icons", {
      prepend: !0,
      csp: n,
      attachTo: s
    });
  }, []);
}, cfe = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], A0 = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function ufe(e) {
  var t = e.primaryColor, r = e.secondaryColor;
  A0.primaryColor = t, A0.secondaryColor = r || rz(t), A0.calculated = !!r;
}
function dfe() {
  return ce({}, A0);
}
var hd = function(t) {
  var r = t.icon, n = t.className, a = t.onClick, i = t.style, o = t.primaryColor, s = t.secondaryColor, l = Kt(t, cfe), c = p.useRef(), u = A0;
  if (o && (u = {
    primaryColor: o,
    secondaryColor: s || rz(o)
  }), lfe(c), ofe(lR(r), "icon should be icon definiton, but got ".concat(r)), !lR(r))
    return null;
  var d = r;
  return d && typeof d.icon == "function" && (d = ce(ce({}, d), {}, {
    icon: d.icon(u.primaryColor, u.secondaryColor)
  })), T2(d.icon, "svg-".concat(d.name), ce(ce({
    className: n,
    onClick: a,
    style: i,
    "data-icon": d.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, l), {}, {
    ref: c
  }));
};
hd.displayName = "IconReact";
hd.getTwoToneColors = dfe;
hd.setTwoToneColors = ufe;
function az(e) {
  var t = nz(e), r = ye(t, 2), n = r[0], a = r[1];
  return hd.setTwoToneColors({
    primaryColor: n,
    secondaryColor: a
  });
}
function ffe() {
  var e = hd.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var pfe = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
az(Yue.primary);
var Er = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.className, n = e.icon, a = e.spin, i = e.rotate, o = e.tabIndex, s = e.onClick, l = e.twoToneColor, c = Kt(e, pfe), u = p.useContext(ET), d = u.prefixCls, f = d === void 0 ? "anticon" : d, m = u.rootClassName, h = be(m, f, te(te({}, "".concat(f, "-").concat(n.name), !!n.name), "".concat(f, "-spin"), !!a || n.name === "loading"), r), g = o;
  g === void 0 && s && (g = -1);
  var y = i ? {
    msTransform: "rotate(".concat(i, "deg)"),
    transform: "rotate(".concat(i, "deg)")
  } : void 0, S = nz(l), x = ye(S, 2), b = x[0], _ = x[1];
  return /* @__PURE__ */ p.createElement("span", Pe({
    role: "img",
    "aria-label": n.name
  }, c, {
    ref: t,
    tabIndex: g,
    onClick: s,
    className: h
  }), /* @__PURE__ */ p.createElement(hd, {
    icon: n,
    primaryColor: b,
    secondaryColor: _,
    style: y
  }));
});
Er.displayName = "AntdIcon";
Er.getTwoToneColor = ffe;
Er.setTwoToneColor = az;
var mfe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: nfe
  }));
}, oh = /* @__PURE__ */ p.forwardRef(mfe);
process.env.NODE_ENV !== "production" && (oh.displayName = "CheckCircleFilled");
var vfe = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, name: "close-circle", theme: "filled" }, hfe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: vfe
  }));
}, Nc = /* @__PURE__ */ p.forwardRef(hfe);
process.env.NODE_ENV !== "production" && (Nc.displayName = "CloseCircleFilled");
var gfe = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" }, yfe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: gfe
  }));
}, Ys = /* @__PURE__ */ p.forwardRef(yfe);
process.env.NODE_ENV !== "production" && (Ys.displayName = "CloseOutlined");
var bfe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "exclamation-circle", theme: "filled" }, Cfe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: bfe
  }));
}, sh = /* @__PURE__ */ p.forwardRef(Cfe);
process.env.NODE_ENV !== "production" && (sh.displayName = "ExclamationCircleFilled");
var Sfe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "info-circle", theme: "filled" }, xfe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: Sfe
  }));
}, C1 = /* @__PURE__ */ p.forwardRef(xfe);
process.env.NODE_ENV !== "production" && (C1.displayName = "InfoCircleFilled");
var $fe = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, _fe = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, Efe = "".concat($fe, " ").concat(_fe).split(/[\s\n]+/), wfe = "aria-", Ofe = "data-";
function uR(e, t) {
  return e.indexOf(t) === 0;
}
function aa(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r;
  t === !1 ? r = {
    aria: !0,
    data: !0,
    attr: !0
  } : t === !0 ? r = {
    aria: !0
  } : r = ce({}, t);
  var n = {};
  return Object.keys(e).forEach(function(a) {
    // Aria
    (r.aria && (a === "role" || uR(a, wfe)) || // Data
    r.data && uR(a, Ofe) || // Attr
    r.attr && Efe.includes(a)) && (n[a] = e[a]);
  }), n;
}
function iz(e) {
  return e && /* @__PURE__ */ xe.isValidElement(e) && e.type === xe.Fragment;
}
const oz = (e, t, r) => /* @__PURE__ */ xe.isValidElement(e) ? /* @__PURE__ */ xe.cloneElement(e, typeof r == "function" ? r(e.props || {}) : r) : t;
function Si(e, t) {
  return oz(e, e, t);
}
const dR = (e) => typeof e == "object" && e != null && e.nodeType === 1, fR = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", nx = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const r = getComputedStyle(e, null);
    return fR(r.overflowY, t) || fR(r.overflowX, t) || ((n) => {
      const a = ((i) => {
        if (!i.ownerDocument || !i.ownerDocument.defaultView) return null;
        try {
          return i.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(n);
      return !!a && (a.clientHeight < n.scrollHeight || a.clientWidth < n.scrollWidth);
    })(e);
  }
  return !1;
}, Yg = (e, t, r, n, a, i, o, s) => i < e && o > t || i > e && o < t ? 0 : i <= e && s <= r || o >= t && s >= r ? i - e - n : o > t && s < r || i < e && s > r ? o - t + a : 0, Tfe = (e) => {
  const t = e.parentElement;
  return t ?? (e.getRootNode().host || null);
}, pR = (e, t) => {
  var r, n, a, i;
  if (typeof document > "u") return [];
  const { scrollMode: o, block: s, inline: l, boundary: c, skipOverflowHiddenElements: u } = t, d = typeof c == "function" ? c : (F) => F !== c;
  if (!dR(e)) throw new TypeError("Invalid target");
  const f = document.scrollingElement || document.documentElement, m = [];
  let h = e;
  for (; dR(h) && d(h); ) {
    if (h = Tfe(h), h === f) {
      m.push(h);
      break;
    }
    h != null && h === document.body && nx(h) && !nx(document.documentElement) || h != null && nx(h, u) && m.push(h);
  }
  const g = (n = (r = window.visualViewport) == null ? void 0 : r.width) != null ? n : innerWidth, y = (i = (a = window.visualViewport) == null ? void 0 : a.height) != null ? i : innerHeight, { scrollX: S, scrollY: x } = window, { height: b, width: _, top: $, right: w, bottom: O, left: T } = e.getBoundingClientRect(), { top: I, right: P, bottom: D, left: B } = ((F) => {
    const j = window.getComputedStyle(F);
    return { top: parseFloat(j.scrollMarginTop) || 0, right: parseFloat(j.scrollMarginRight) || 0, bottom: parseFloat(j.scrollMarginBottom) || 0, left: parseFloat(j.scrollMarginLeft) || 0 };
  })(e);
  let L = s === "start" || s === "nearest" ? $ - I : s === "end" ? O + D : $ + b / 2 - I + D, N = l === "center" ? T + _ / 2 - B + P : l === "end" ? w + P : T - B;
  const z = [];
  for (let F = 0; F < m.length; F++) {
    const j = m[F], { height: H, width: U, top: G, right: V, bottom: K, left: Z } = j.getBoundingClientRect();
    if (o === "if-needed" && $ >= 0 && T >= 0 && O <= y && w <= g && $ >= G && O <= K && T >= Z && w <= V) return z;
    const ee = getComputedStyle(j), ae = parseInt(ee.borderLeftWidth, 10), ue = parseInt(ee.borderTopWidth, 10), re = parseInt(ee.borderRightWidth, 10), oe = parseInt(ee.borderBottomWidth, 10);
    let fe = 0, le = 0;
    const se = "offsetWidth" in j ? j.offsetWidth - j.clientWidth - ae - re : 0, Q = "offsetHeight" in j ? j.offsetHeight - j.clientHeight - ue - oe : 0, he = "offsetWidth" in j ? j.offsetWidth === 0 ? 0 : U / j.offsetWidth : 0, ne = "offsetHeight" in j ? j.offsetHeight === 0 ? 0 : H / j.offsetHeight : 0;
    if (f === j) fe = s === "start" ? L : s === "end" ? L - y : s === "nearest" ? Yg(x, x + y, y, ue, oe, x + L, x + L + b, b) : L - y / 2, le = l === "start" ? N : l === "center" ? N - g / 2 : l === "end" ? N - g : Yg(S, S + g, g, ae, re, S + N, S + N + _, _), fe = Math.max(0, fe + x), le = Math.max(0, le + S);
    else {
      fe = s === "start" ? L - G - ue : s === "end" ? L - K + oe + Q : s === "nearest" ? Yg(G, K, H, ue, oe + Q, L, L + b, b) : L - (G + H / 2) + Q / 2, le = l === "start" ? N - Z - ae : l === "center" ? N - (Z + U / 2) + se / 2 : l === "end" ? N - V + re + se : Yg(Z, V, U, ae, re + se, N, N + _, _);
      const { scrollLeft: me, scrollTop: k } = j;
      fe = ne === 0 ? 0 : Math.max(0, Math.min(k + fe / ne, j.scrollHeight - H / ne + Q)), le = he === 0 ? 0 : Math.max(0, Math.min(me + le / he, j.scrollWidth - U / he + se)), L += k - fe, N += me - le;
    }
    z.push({ el: j, top: fe, left: le });
  }
  return z;
}, Ife = (e) => e === !1 ? { block: "end", inline: "nearest" } : ((t) => t === Object(t) && Object.keys(t).length !== 0)(e) ? e : { block: "start", inline: "nearest" };
function Mfe(e, t) {
  if (!e.isConnected || !((a) => {
    let i = a;
    for (; i && i.parentNode; ) {
      if (i.parentNode === document) return !0;
      i = i.parentNode instanceof ShadowRoot ? i.parentNode.host : i.parentNode;
    }
    return !1;
  })(e)) return;
  const r = ((a) => {
    const i = window.getComputedStyle(a);
    return { top: parseFloat(i.scrollMarginTop) || 0, right: parseFloat(i.scrollMarginRight) || 0, bottom: parseFloat(i.scrollMarginBottom) || 0, left: parseFloat(i.scrollMarginLeft) || 0 };
  })(e);
  if (((a) => typeof a == "object" && typeof a.behavior == "function")(t)) return t.behavior(pR(e, t));
  const n = typeof t == "boolean" || t == null ? void 0 : t.behavior;
  for (const { el: a, top: i, left: o } of pR(e, Ife(t))) {
    const s = i - r.top + r.bottom, l = o - r.left + r.right;
    a.scroll({ top: s, left: l, behavior: n });
  }
}
function I2(e) {
  return e != null && e === e.window;
}
const Afe = (e) => {
  var t, r;
  if (typeof window > "u")
    return 0;
  let n = 0;
  return I2(e) ? n = e.pageYOffset : e instanceof Document ? n = e.documentElement.scrollTop : (e instanceof HTMLElement || e) && (n = e.scrollTop), e && !I2(e) && typeof n != "number" && (n = (r = ((t = e.ownerDocument) !== null && t !== void 0 ? t : e).documentElement) === null || r === void 0 ? void 0 : r.scrollTop), n;
};
function Pfe(e, t, r, n) {
  const a = r - t;
  return e /= n / 2, e < 1 ? a / 2 * e * e * e + t : a / 2 * ((e -= 2) * e * e + 2) + t;
}
function Rfe(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    getContainer: r = () => window,
    callback: n,
    duration: a = 450
  } = t, i = r(), o = Afe(i), s = Date.now(), l = () => {
    const u = Date.now() - s, d = Pfe(u > a ? a : u, o, e, a);
    I2(i) ? i.scrollTo(window.pageXOffset, d) : i instanceof Document || i.constructor.name === "HTMLDocument" ? i.documentElement.scrollTop = d : i.scrollTop = d, u < a ? vr(l) : typeof n == "function" && n();
  };
  vr(l);
}
const Mn = (e) => {
  const [, , , , t] = ua();
  return t ? `${e}-css-var` : "";
};
var Mt = {
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  /**
   * N
   */
  N: 78,
  /**
   * P
   */
  P: 80,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224
}, sz = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.style, a = e.className, i = e.duration, o = i === void 0 ? 4.5 : i, s = e.showProgress, l = e.pauseOnHover, c = l === void 0 ? !0 : l, u = e.eventKey, d = e.content, f = e.closable, m = e.closeIcon, h = m === void 0 ? "x" : m, g = e.props, y = e.onClick, S = e.onNoticeClose, x = e.times, b = e.hovering, _ = p.useState(!1), $ = ye(_, 2), w = $[0], O = $[1], T = p.useState(0), I = ye(T, 2), P = I[0], D = I[1], B = p.useState(0), L = ye(B, 2), N = L[0], z = L[1], F = b || w, j = o > 0 && s, H = function() {
    S(u);
  }, U = function(ae) {
    (ae.key === "Enter" || ae.code === "Enter" || ae.keyCode === Mt.ENTER) && H();
  };
  p.useEffect(function() {
    if (!F && o > 0) {
      var ee = Date.now() - N, ae = setTimeout(function() {
        H();
      }, o * 1e3 - N);
      return function() {
        c && clearTimeout(ae), z(Date.now() - ee);
      };
    }
  }, [o, F, x]), p.useEffect(function() {
    if (!F && j && (c || N === 0)) {
      var ee = performance.now(), ae, ue = function re() {
        cancelAnimationFrame(ae), ae = requestAnimationFrame(function(oe) {
          var fe = oe + N - ee, le = Math.min(fe / (o * 1e3), 1);
          D(le * 100), le < 1 && re();
        });
      };
      return ue(), function() {
        c && cancelAnimationFrame(ae);
      };
    }
  }, [o, N, F, j, x]);
  var G = p.useMemo(function() {
    return kt(f) === "object" && f !== null ? f : f ? {
      closeIcon: h
    } : {};
  }, [f, h]), V = aa(G, !0), K = 100 - (!P || P < 0 ? 0 : P > 100 ? 100 : P), Z = "".concat(r, "-notice");
  return /* @__PURE__ */ p.createElement("div", Pe({}, g, {
    ref: t,
    className: be(Z, a, te({}, "".concat(Z, "-closable"), f)),
    style: n,
    onMouseEnter: function(ae) {
      var ue;
      O(!0), g == null || (ue = g.onMouseEnter) === null || ue === void 0 || ue.call(g, ae);
    },
    onMouseLeave: function(ae) {
      var ue;
      O(!1), g == null || (ue = g.onMouseLeave) === null || ue === void 0 || ue.call(g, ae);
    },
    onClick: y
  }), /* @__PURE__ */ p.createElement("div", {
    className: "".concat(Z, "-content")
  }, d), f && /* @__PURE__ */ p.createElement("a", Pe({
    tabIndex: 0,
    className: "".concat(Z, "-close"),
    onKeyDown: U,
    "aria-label": "Close"
  }, V, {
    onClick: function(ae) {
      ae.preventDefault(), ae.stopPropagation(), H();
    }
  }), G.closeIcon), j && /* @__PURE__ */ p.createElement("progress", {
    className: "".concat(Z, "-progress"),
    max: "100",
    value: K
  }, K + "%"));
}), lz = /* @__PURE__ */ xe.createContext({}), cz = function(t) {
  var r = t.children, n = t.classNames;
  return /* @__PURE__ */ xe.createElement(lz.Provider, {
    value: {
      classNames: n
    }
  }, r);
}, mR = 8, vR = 3, hR = 16, Nfe = function(t) {
  var r = {
    offset: mR,
    threshold: vR,
    gap: hR
  };
  if (t && kt(t) === "object") {
    var n, a, i;
    r.offset = (n = t.offset) !== null && n !== void 0 ? n : mR, r.threshold = (a = t.threshold) !== null && a !== void 0 ? a : vR, r.gap = (i = t.gap) !== null && i !== void 0 ? i : hR;
  }
  return [!!t, r];
}, Dfe = ["className", "style", "classNames", "styles"], uz = function(t) {
  var r = t.configList, n = t.placement, a = t.prefixCls, i = t.className, o = t.style, s = t.motion, l = t.onAllNoticeRemoved, c = t.onNoticeClose, u = t.stack, d = Cr(lz), f = d.classNames, m = ct({}), h = He(null), g = ye(h, 2), y = g[0], S = g[1], x = He([]), b = ye(x, 2), _ = b[0], $ = b[1], w = r.map(function(F) {
    return {
      config: F,
      key: String(F.key)
    };
  }), O = Nfe(u), T = ye(O, 2), I = T[0], P = T[1], D = P.offset, B = P.threshold, L = P.gap, N = I && (_.length > 0 || w.length <= B), z = typeof s == "function" ? s(n) : s;
  return St(function() {
    I && _.length > 1 && $(function(F) {
      return F.filter(function(j) {
        return w.some(function(H) {
          var U = H.key;
          return j === U;
        });
      });
    });
  }, [_, w, I]), St(function() {
    var F;
    if (I && m.current[(F = w[w.length - 1]) === null || F === void 0 ? void 0 : F.key]) {
      var j;
      S(m.current[(j = w[w.length - 1]) === null || j === void 0 ? void 0 : j.key]);
    }
  }, [w, I]), /* @__PURE__ */ xe.createElement(KB, Pe({
    key: n,
    className: be(a, "".concat(a, "-").concat(n), f?.list, i, te(te({}, "".concat(a, "-stack"), !!I), "".concat(a, "-stack-expanded"), N)),
    style: o,
    keys: w,
    motionAppear: !0
  }, z, {
    onAllRemoved: function() {
      l(n);
    }
  }), function(F, j) {
    var H = F.config, U = F.className, G = F.style, V = F.index, K = H, Z = K.key, ee = K.times, ae = String(Z), ue = H, re = ue.className, oe = ue.style, fe = ue.classNames, le = ue.styles, se = Kt(ue, Dfe), Q = w.findIndex(function(J) {
      return J.key === ae;
    }), he = {};
    if (I) {
      var ne = w.length - 1 - (Q > -1 ? Q : V - 1), me = n === "top" || n === "bottom" ? "-50%" : "0";
      if (ne > 0) {
        var k, M, R;
        he.height = N ? (k = m.current[ae]) === null || k === void 0 ? void 0 : k.offsetHeight : y?.offsetHeight;
        for (var q = 0, Y = 0; Y < ne; Y++) {
          var X;
          q += ((X = m.current[w[w.length - 1 - Y].key]) === null || X === void 0 ? void 0 : X.offsetHeight) + L;
        }
        var pe = (N ? q : ne * D) * (n.startsWith("top") ? 1 : -1), $e = !N && y !== null && y !== void 0 && y.offsetWidth && (M = m.current[ae]) !== null && M !== void 0 && M.offsetWidth ? (y?.offsetWidth - D * 2 * (ne < 3 ? ne : 3)) / ((R = m.current[ae]) === null || R === void 0 ? void 0 : R.offsetWidth) : 1;
        he.transform = "translate3d(".concat(me, ", ").concat(pe, "px, 0) scaleX(").concat($e, ")");
      } else
        he.transform = "translate3d(".concat(me, ", 0, 0)");
    }
    return /* @__PURE__ */ xe.createElement("div", {
      ref: j,
      className: be("".concat(a, "-notice-wrapper"), U, fe?.wrapper),
      style: ce(ce(ce({}, G), he), le?.wrapper),
      onMouseEnter: function() {
        return $(function(de) {
          return de.includes(ae) ? de : [].concat(ze(de), [ae]);
        });
      },
      onMouseLeave: function() {
        return $(function(de) {
          return de.filter(function(Se) {
            return Se !== ae;
          });
        });
      }
    }, /* @__PURE__ */ xe.createElement(sz, Pe({}, se, {
      ref: function(de) {
        Q > -1 ? m.current[ae] = de : delete m.current[ae];
      },
      prefixCls: a,
      classNames: fe,
      styles: le,
      className: be(re, f?.notice),
      style: oe,
      times: ee,
      key: Z,
      eventKey: Z,
      onNoticeClose: c,
      hovering: I && _.length > 0
    })));
  });
};
process.env.NODE_ENV !== "production" && (uz.displayName = "NoticeList");
var dz = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.prefixCls, n = r === void 0 ? "rc-notification" : r, a = e.container, i = e.motion, o = e.maxCount, s = e.className, l = e.style, c = e.onAllRemoved, u = e.stack, d = e.renderNotifications, f = p.useState([]), m = ye(f, 2), h = m[0], g = m[1], y = function(I) {
    var P, D = h.find(function(B) {
      return B.key === I;
    });
    D == null || (P = D.onClose) === null || P === void 0 || P.call(D), g(function(B) {
      return B.filter(function(L) {
        return L.key !== I;
      });
    });
  };
  p.useImperativeHandle(t, function() {
    return {
      open: function(I) {
        g(function(P) {
          var D = ze(P), B = D.findIndex(function(z) {
            return z.key === I.key;
          }), L = ce({}, I);
          if (B >= 0) {
            var N;
            L.times = (((N = P[B]) === null || N === void 0 ? void 0 : N.times) || 0) + 1, D[B] = L;
          } else
            L.times = 0, D.push(L);
          return o > 0 && D.length > o && (D = D.slice(-o)), D;
        });
      },
      close: function(I) {
        y(I);
      },
      destroy: function() {
        g([]);
      }
    };
  });
  var S = p.useState({}), x = ye(S, 2), b = x[0], _ = x[1];
  p.useEffect(function() {
    var T = {};
    h.forEach(function(I) {
      var P = I.placement, D = P === void 0 ? "topRight" : P;
      D && (T[D] = T[D] || [], T[D].push(I));
    }), Object.keys(b).forEach(function(I) {
      T[I] = T[I] || [];
    }), _(T);
  }, [h]);
  var $ = function(I) {
    _(function(P) {
      var D = ce({}, P), B = D[I] || [];
      return B.length || delete D[I], D;
    });
  }, w = p.useRef(!1);
  if (p.useEffect(function() {
    Object.keys(b).length > 0 ? w.current = !0 : w.current && (c?.(), w.current = !1);
  }, [b]), !a)
    return null;
  var O = Object.keys(b);
  return /* @__PURE__ */ _F(/* @__PURE__ */ p.createElement(p.Fragment, null, O.map(function(T) {
    var I = b[T], P = /* @__PURE__ */ p.createElement(uz, {
      key: T,
      configList: I,
      placement: T,
      prefixCls: n,
      className: s?.(T),
      style: l?.(T),
      motion: i,
      onNoticeClose: y,
      onAllNoticeRemoved: $,
      stack: u
    });
    return d ? d(P, {
      prefixCls: n,
      key: T
    }) : P;
  })), a);
});
process.env.NODE_ENV !== "production" && (dz.displayName = "Notifications");
var jfe = ["getContainer", "motion", "prefixCls", "maxCount", "className", "style", "onAllRemoved", "stack", "renderNotifications"], Lfe = function() {
  return document.body;
}, gR = 0;
function kfe() {
  for (var e = {}, t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return r.forEach(function(a) {
    a && Object.keys(a).forEach(function(i) {
      var o = a[i];
      o !== void 0 && (e[i] = o);
    });
  }), e;
}
function fz() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.getContainer, r = t === void 0 ? Lfe : t, n = e.motion, a = e.prefixCls, i = e.maxCount, o = e.className, s = e.style, l = e.onAllRemoved, c = e.stack, u = e.renderNotifications, d = Kt(e, jfe), f = p.useState(), m = ye(f, 2), h = m[0], g = m[1], y = p.useRef(), S = /* @__PURE__ */ p.createElement(dz, {
    container: h,
    ref: y,
    prefixCls: a,
    motion: n,
    maxCount: i,
    className: o,
    style: s,
    onAllRemoved: l,
    stack: c,
    renderNotifications: u
  }), x = p.useState([]), b = ye(x, 2), _ = b[0], $ = b[1], w = p.useMemo(function() {
    return {
      open: function(T) {
        var I = kfe(d, T);
        (I.key === null || I.key === void 0) && (I.key = "rc-notification-".concat(gR), gR += 1), $(function(P) {
          return [].concat(ze(P), [{
            type: "open",
            config: I
          }]);
        });
      },
      close: function(T) {
        $(function(I) {
          return [].concat(ze(I), [{
            type: "close",
            key: T
          }]);
        });
      },
      destroy: function() {
        $(function(T) {
          return [].concat(ze(T), [{
            type: "destroy"
          }]);
        });
      }
    };
  }, []);
  return p.useEffect(function() {
    g(r());
  }), p.useEffect(function() {
    y.current && _.length && (_.forEach(function(O) {
      switch (O.type) {
        case "open":
          y.current.open(O.config);
          break;
        case "close":
          y.current.close(O.key);
          break;
        case "destroy":
          y.current.destroy();
          break;
      }
    }), $(function(O) {
      return O.filter(function(T) {
        return !_.includes(T);
      });
    }));
  }, [_]), [w, S];
}
var Ffe = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" }, Bfe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: Ffe
  }));
}, Dc = /* @__PURE__ */ p.forwardRef(Bfe);
process.env.NODE_ENV !== "production" && (Dc.displayName = "LoadingOutlined");
const gd = /* @__PURE__ */ xe.createContext(void 0);
process.env.NODE_ENV !== "production" && (gd.displayName = "zIndexContext");
const ic = 100, zfe = 10, S1 = ic * zfe, pz = {
  Modal: ic,
  Drawer: ic,
  Popover: ic,
  Popconfirm: ic,
  Tooltip: ic,
  Tour: ic
}, Hfe = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function Vfe(e) {
  return e in pz;
}
function ps(e, t) {
  const [, r] = ua(), n = xe.useContext(gd), a = Vfe(e);
  if (t !== void 0)
    return [t, t];
  let i = n ?? 0;
  return a ? (i += // Use preset token zIndex by default but not stack when has parent container
  (n ? 0 : r.zIndexPopupBase) + // Container offset
  pz[e], i = Math.min(i, r.zIndexPopupBase + S1)) : i += Hfe[e], [n === void 0 ? t : i, i];
}
const Gfe = (e) => {
  const {
    componentCls: t,
    iconCls: r,
    boxShadow: n,
    colorText: a,
    colorSuccess: i,
    colorError: o,
    colorWarning: s,
    colorInfo: l,
    fontSizeLG: c,
    motionEaseInOutCirc: u,
    motionDurationSlow: d,
    marginXS: f,
    paddingXS: m,
    borderRadiusLG: h,
    zIndexPopup: g,
    // Custom token
    contentPadding: y,
    contentBg: S
  } = e, x = `${t}-notice`, b = new Pr("MessageMoveIn", {
    "0%": {
      padding: 0,
      transform: "translateY(-100%)",
      opacity: 0
    },
    "100%": {
      padding: m,
      transform: "translateY(0)",
      opacity: 1
    }
  }), _ = new Pr("MessageMoveOut", {
    "0%": {
      maxHeight: e.height,
      padding: m,
      opacity: 1
    },
    "100%": {
      maxHeight: 0,
      padding: 0,
      opacity: 0
    }
  }), $ = {
    padding: m,
    textAlign: "center",
    [`${t}-custom-content`]: {
      display: "flex",
      alignItems: "center"
    },
    [`${t}-custom-content > ${r}`]: {
      marginInlineEnd: f,
      // affected by ltr or rtl
      fontSize: c
    },
    [`${x}-content`]: {
      display: "inline-block",
      padding: y,
      background: S,
      borderRadius: h,
      boxShadow: n,
      pointerEvents: "all"
    },
    [`${t}-success > ${r}`]: {
      color: i
    },
    [`${t}-error > ${r}`]: {
      color: o
    },
    [`${t}-warning > ${r}`]: {
      color: s
    },
    [`${t}-info > ${r},
      ${t}-loading > ${r}`]: {
      color: l
    }
  };
  return [
    // ============================ Holder ============================
    {
      [t]: Object.assign(Object.assign({}, Yr(e)), {
        color: a,
        position: "fixed",
        top: f,
        width: "100%",
        pointerEvents: "none",
        zIndex: g,
        [`${t}-move-up`]: {
          animationFillMode: "forwards"
        },
        [`
        ${t}-move-up-appear,
        ${t}-move-up-enter
      `]: {
          animationName: b,
          animationDuration: d,
          animationPlayState: "paused",
          animationTimingFunction: u
        },
        [`
        ${t}-move-up-appear${t}-move-up-appear-active,
        ${t}-move-up-enter${t}-move-up-enter-active
      `]: {
          animationPlayState: "running"
        },
        [`${t}-move-up-leave`]: {
          animationName: _,
          animationDuration: d,
          animationPlayState: "paused",
          animationTimingFunction: u
        },
        [`${t}-move-up-leave${t}-move-up-leave-active`]: {
          animationPlayState: "running"
        },
        "&-rtl": {
          direction: "rtl",
          span: {
            direction: "rtl"
          }
        }
      })
    },
    // ============================ Notice ============================
    {
      [t]: {
        [`${x}-wrapper`]: Object.assign({}, $)
      }
    },
    // ============================= Pure =============================
    {
      [`${t}-notice-pure-panel`]: Object.assign(Object.assign({}, $), {
        padding: 0,
        textAlign: "start"
      })
    }
  ];
}, Ufe = (e) => ({
  zIndexPopup: e.zIndexPopupBase + S1 + 10,
  contentBg: e.colorBgElevated,
  contentPadding: `${(e.controlHeightLG - e.fontSize * e.lineHeight) / 2}px ${e.paddingSM}px`
}), mz = Zr("Message", (e) => {
  const t = $r(e, {
    height: 150
  });
  return [Gfe(t)];
}, Ufe);
var Wfe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const qfe = {
  info: /* @__PURE__ */ p.createElement(C1, null),
  success: /* @__PURE__ */ p.createElement(oh, null),
  error: /* @__PURE__ */ p.createElement(Nc, null),
  warning: /* @__PURE__ */ p.createElement(sh, null),
  loading: /* @__PURE__ */ p.createElement(Dc, null)
}, vz = (e) => {
  let {
    prefixCls: t,
    type: r,
    icon: n,
    children: a
  } = e;
  return /* @__PURE__ */ p.createElement("div", {
    className: be(`${t}-custom-content`, `${t}-${r}`)
  }, n || qfe[r], /* @__PURE__ */ p.createElement("span", null, a));
}, Kfe = (e) => {
  const {
    prefixCls: t,
    className: r,
    type: n,
    icon: a,
    content: i
  } = e, o = Wfe(e, ["prefixCls", "className", "type", "icon", "content"]), {
    getPrefixCls: s
  } = p.useContext(Lt), l = t || s("message"), c = Mn(l), [u, d, f] = mz(l, c);
  return u(/* @__PURE__ */ p.createElement(sz, Object.assign({}, o, {
    prefixCls: l,
    className: be(r, d, `${l}-notice-pure-panel`, f, c),
    eventKey: "pure",
    duration: null,
    content: /* @__PURE__ */ p.createElement(vz, {
      prefixCls: l,
      type: n,
      icon: a
    }, i)
  })));
};
function Yfe(e, t) {
  return {
    motionName: t ?? `${e}-move-up`
  };
}
function NT(e) {
  let t;
  const r = new Promise((a) => {
    t = e(() => {
      a(!0);
    });
  }), n = () => {
    t?.();
  };
  return n.then = (a, i) => r.then(a, i), n.promise = r, n;
}
var Zfe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const Xfe = 8, Jfe = 3, Qfe = (e) => {
  let {
    children: t,
    prefixCls: r
  } = e;
  const n = Mn(r), [a, i, o] = mz(r, n);
  return a(/* @__PURE__ */ p.createElement(cz, {
    classNames: {
      list: be(i, o, n)
    }
  }, t));
}, epe = (e, t) => {
  let {
    prefixCls: r,
    key: n
  } = t;
  return /* @__PURE__ */ p.createElement(Qfe, {
    prefixCls: r,
    key: n
  }, e);
}, tpe = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    top: r,
    prefixCls: n,
    getContainer: a,
    maxCount: i,
    duration: o = Jfe,
    rtl: s,
    transitionName: l,
    onAllRemoved: c
  } = e, {
    getPrefixCls: u,
    getPopupContainer: d,
    message: f,
    direction: m
  } = p.useContext(Lt), h = n || u("message"), g = () => ({
    left: "50%",
    transform: "translateX(-50%)",
    top: r ?? Xfe
  }), y = () => be({
    [`${h}-rtl`]: s ?? m === "rtl"
  }), S = () => Yfe(h, l), x = /* @__PURE__ */ p.createElement("span", {
    className: `${h}-close-x`
  }, /* @__PURE__ */ p.createElement(Ys, {
    className: `${h}-close-icon`
  })), [b, _] = fz({
    prefixCls: h,
    style: g,
    className: y,
    motion: S,
    closable: !1,
    closeIcon: x,
    duration: o,
    getContainer: () => a?.() || d?.() || document.body,
    maxCount: i,
    onAllRemoved: c,
    renderNotifications: epe
  });
  return p.useImperativeHandle(t, () => Object.assign(Object.assign({}, b), {
    prefixCls: h,
    message: f
  })), _;
});
let yR = 0;
function hz(e) {
  const t = p.useRef(null), r = xr("Message");
  return [p.useMemo(() => {
    const a = (c) => {
      var u;
      (u = t.current) === null || u === void 0 || u.close(c);
    }, i = (c) => {
      if (!t.current) {
        process.env.NODE_ENV !== "production" && r(!1, "usage", "You are calling notice in render which will break in React 18 concurrent mode. Please trigger in effect instead.");
        const O = () => {
        };
        return O.then = () => {
        }, O;
      }
      const {
        open: u,
        prefixCls: d,
        message: f
      } = t.current, m = `${d}-notice`, {
        content: h,
        icon: g,
        type: y,
        key: S,
        className: x,
        style: b,
        onClose: _
      } = c, $ = Zfe(c, ["content", "icon", "type", "key", "className", "style", "onClose"]);
      let w = S;
      return w == null && (yR += 1, w = `antd-message-${yR}`), NT((O) => (u(Object.assign(Object.assign({}, $), {
        key: w,
        content: /* @__PURE__ */ p.createElement(vz, {
          prefixCls: d,
          type: y,
          icon: g
        }, h),
        placement: "top",
        className: be(y && `${m}-${y}`, x, f?.className),
        style: Object.assign(Object.assign({}, f?.style), b),
        onClose: () => {
          _?.(), O();
        }
      })), () => {
        a(w);
      }));
    }, s = {
      open: i,
      destroy: (c) => {
        var u;
        c !== void 0 ? a(c) : (u = t.current) === null || u === void 0 || u.destroy();
      }
    };
    return ["info", "success", "warning", "error", "loading"].forEach((c) => {
      const u = (d, f, m) => {
        let h;
        d && typeof d == "object" && "content" in d ? h = d : h = {
          content: d
        };
        let g, y;
        typeof f == "function" ? y = f : (g = f, y = m);
        const S = Object.assign(Object.assign({
          onClose: y,
          duration: g
        }, h), {
          type: c
        });
        return i(S);
      };
      s[c] = u;
    }), s;
  }, []), /* @__PURE__ */ p.createElement(tpe, Object.assign({
    key: "message-holder"
  }, e, {
    ref: t
  }))];
}
function gz(e) {
  return hz(e);
}
function rpe() {
  const [e, t] = p.useState([]), r = p.useCallback((n) => (t((a) => [].concat(ze(a), [n])), () => {
    t((a) => a.filter((i) => i !== n));
  }), []);
  return [e, r];
}
function ai() {
  ai = function() {
    return t;
  };
  var e, t = {}, r = Object.prototype, n = r.hasOwnProperty, a = Object.defineProperty || function(F, j, H) {
    F[j] = H.value;
  }, i = typeof Symbol == "function" ? Symbol : {}, o = i.iterator || "@@iterator", s = i.asyncIterator || "@@asyncIterator", l = i.toStringTag || "@@toStringTag";
  function c(F, j, H) {
    return Object.defineProperty(F, j, {
      value: H,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), F[j];
  }
  try {
    c({}, "");
  } catch {
    c = function(H, U, G) {
      return H[U] = G;
    };
  }
  function u(F, j, H, U) {
    var G = j && j.prototype instanceof S ? j : S, V = Object.create(G.prototype), K = new N(U || []);
    return a(V, "_invoke", {
      value: P(F, H, K)
    }), V;
  }
  function d(F, j, H) {
    try {
      return {
        type: "normal",
        arg: F.call(j, H)
      };
    } catch (U) {
      return {
        type: "throw",
        arg: U
      };
    }
  }
  t.wrap = u;
  var f = "suspendedStart", m = "suspendedYield", h = "executing", g = "completed", y = {};
  function S() {
  }
  function x() {
  }
  function b() {
  }
  var _ = {};
  c(_, o, function() {
    return this;
  });
  var $ = Object.getPrototypeOf, w = $ && $($(z([])));
  w && w !== r && n.call(w, o) && (_ = w);
  var O = b.prototype = S.prototype = Object.create(_);
  function T(F) {
    ["next", "throw", "return"].forEach(function(j) {
      c(F, j, function(H) {
        return this._invoke(j, H);
      });
    });
  }
  function I(F, j) {
    function H(G, V, K, Z) {
      var ee = d(F[G], F, V);
      if (ee.type !== "throw") {
        var ae = ee.arg, ue = ae.value;
        return ue && kt(ue) == "object" && n.call(ue, "__await") ? j.resolve(ue.__await).then(function(re) {
          H("next", re, K, Z);
        }, function(re) {
          H("throw", re, K, Z);
        }) : j.resolve(ue).then(function(re) {
          ae.value = re, K(ae);
        }, function(re) {
          return H("throw", re, K, Z);
        });
      }
      Z(ee.arg);
    }
    var U;
    a(this, "_invoke", {
      value: function(V, K) {
        function Z() {
          return new j(function(ee, ae) {
            H(V, K, ee, ae);
          });
        }
        return U = U ? U.then(Z, Z) : Z();
      }
    });
  }
  function P(F, j, H) {
    var U = f;
    return function(G, V) {
      if (U === h) throw Error("Generator is already running");
      if (U === g) {
        if (G === "throw") throw V;
        return {
          value: e,
          done: !0
        };
      }
      for (H.method = G, H.arg = V; ; ) {
        var K = H.delegate;
        if (K) {
          var Z = D(K, H);
          if (Z) {
            if (Z === y) continue;
            return Z;
          }
        }
        if (H.method === "next") H.sent = H._sent = H.arg;
        else if (H.method === "throw") {
          if (U === f) throw U = g, H.arg;
          H.dispatchException(H.arg);
        } else H.method === "return" && H.abrupt("return", H.arg);
        U = h;
        var ee = d(F, j, H);
        if (ee.type === "normal") {
          if (U = H.done ? g : m, ee.arg === y) continue;
          return {
            value: ee.arg,
            done: H.done
          };
        }
        ee.type === "throw" && (U = g, H.method = "throw", H.arg = ee.arg);
      }
    };
  }
  function D(F, j) {
    var H = j.method, U = F.iterator[H];
    if (U === e) return j.delegate = null, H === "throw" && F.iterator.return && (j.method = "return", j.arg = e, D(F, j), j.method === "throw") || H !== "return" && (j.method = "throw", j.arg = new TypeError("The iterator does not provide a '" + H + "' method")), y;
    var G = d(U, F.iterator, j.arg);
    if (G.type === "throw") return j.method = "throw", j.arg = G.arg, j.delegate = null, y;
    var V = G.arg;
    return V ? V.done ? (j[F.resultName] = V.value, j.next = F.nextLoc, j.method !== "return" && (j.method = "next", j.arg = e), j.delegate = null, y) : V : (j.method = "throw", j.arg = new TypeError("iterator result is not an object"), j.delegate = null, y);
  }
  function B(F) {
    var j = {
      tryLoc: F[0]
    };
    1 in F && (j.catchLoc = F[1]), 2 in F && (j.finallyLoc = F[2], j.afterLoc = F[3]), this.tryEntries.push(j);
  }
  function L(F) {
    var j = F.completion || {};
    j.type = "normal", delete j.arg, F.completion = j;
  }
  function N(F) {
    this.tryEntries = [{
      tryLoc: "root"
    }], F.forEach(B, this), this.reset(!0);
  }
  function z(F) {
    if (F || F === "") {
      var j = F[o];
      if (j) return j.call(F);
      if (typeof F.next == "function") return F;
      if (!isNaN(F.length)) {
        var H = -1, U = function G() {
          for (; ++H < F.length; ) if (n.call(F, H)) return G.value = F[H], G.done = !1, G;
          return G.value = e, G.done = !0, G;
        };
        return U.next = U;
      }
    }
    throw new TypeError(kt(F) + " is not iterable");
  }
  return x.prototype = b, a(O, "constructor", {
    value: b,
    configurable: !0
  }), a(b, "constructor", {
    value: x,
    configurable: !0
  }), x.displayName = c(b, l, "GeneratorFunction"), t.isGeneratorFunction = function(F) {
    var j = typeof F == "function" && F.constructor;
    return !!j && (j === x || (j.displayName || j.name) === "GeneratorFunction");
  }, t.mark = function(F) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(F, b) : (F.__proto__ = b, c(F, l, "GeneratorFunction")), F.prototype = Object.create(O), F;
  }, t.awrap = function(F) {
    return {
      __await: F
    };
  }, T(I.prototype), c(I.prototype, s, function() {
    return this;
  }), t.AsyncIterator = I, t.async = function(F, j, H, U, G) {
    G === void 0 && (G = Promise);
    var V = new I(u(F, j, H, U), G);
    return t.isGeneratorFunction(j) ? V : V.next().then(function(K) {
      return K.done ? K.value : V.next();
    });
  }, T(O), c(O, l, "Generator"), c(O, o, function() {
    return this;
  }), c(O, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(F) {
    var j = Object(F), H = [];
    for (var U in j) H.push(U);
    return H.reverse(), function G() {
      for (; H.length; ) {
        var V = H.pop();
        if (V in j) return G.value = V, G.done = !1, G;
      }
      return G.done = !0, G;
    };
  }, t.values = z, N.prototype = {
    constructor: N,
    reset: function(j) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(L), !j) for (var H in this) H.charAt(0) === "t" && n.call(this, H) && !isNaN(+H.slice(1)) && (this[H] = e);
    },
    stop: function() {
      this.done = !0;
      var j = this.tryEntries[0].completion;
      if (j.type === "throw") throw j.arg;
      return this.rval;
    },
    dispatchException: function(j) {
      if (this.done) throw j;
      var H = this;
      function U(ae, ue) {
        return K.type = "throw", K.arg = j, H.next = ae, ue && (H.method = "next", H.arg = e), !!ue;
      }
      for (var G = this.tryEntries.length - 1; G >= 0; --G) {
        var V = this.tryEntries[G], K = V.completion;
        if (V.tryLoc === "root") return U("end");
        if (V.tryLoc <= this.prev) {
          var Z = n.call(V, "catchLoc"), ee = n.call(V, "finallyLoc");
          if (Z && ee) {
            if (this.prev < V.catchLoc) return U(V.catchLoc, !0);
            if (this.prev < V.finallyLoc) return U(V.finallyLoc);
          } else if (Z) {
            if (this.prev < V.catchLoc) return U(V.catchLoc, !0);
          } else {
            if (!ee) throw Error("try statement without catch or finally");
            if (this.prev < V.finallyLoc) return U(V.finallyLoc);
          }
        }
      }
    },
    abrupt: function(j, H) {
      for (var U = this.tryEntries.length - 1; U >= 0; --U) {
        var G = this.tryEntries[U];
        if (G.tryLoc <= this.prev && n.call(G, "finallyLoc") && this.prev < G.finallyLoc) {
          var V = G;
          break;
        }
      }
      V && (j === "break" || j === "continue") && V.tryLoc <= H && H <= V.finallyLoc && (V = null);
      var K = V ? V.completion : {};
      return K.type = j, K.arg = H, V ? (this.method = "next", this.next = V.finallyLoc, y) : this.complete(K);
    },
    complete: function(j, H) {
      if (j.type === "throw") throw j.arg;
      return j.type === "break" || j.type === "continue" ? this.next = j.arg : j.type === "return" ? (this.rval = this.arg = j.arg, this.method = "return", this.next = "end") : j.type === "normal" && H && (this.next = H), y;
    },
    finish: function(j) {
      for (var H = this.tryEntries.length - 1; H >= 0; --H) {
        var U = this.tryEntries[H];
        if (U.finallyLoc === j) return this.complete(U.completion, U.afterLoc), L(U), y;
      }
    },
    catch: function(j) {
      for (var H = this.tryEntries.length - 1; H >= 0; --H) {
        var U = this.tryEntries[H];
        if (U.tryLoc === j) {
          var G = U.completion;
          if (G.type === "throw") {
            var V = G.arg;
            L(U);
          }
          return V;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function(j, H, U) {
      return this.delegate = {
        iterator: z(j),
        resultName: H,
        nextLoc: U
      }, this.method === "next" && (this.arg = e), y;
    }
  }, t;
}
function bR(e, t, r, n, a, i, o) {
  try {
    var s = e[i](o), l = s.value;
  } catch (c) {
    return void r(c);
  }
  s.done ? t(l) : Promise.resolve(l).then(n, a);
}
function jc(e) {
  return function() {
    var t = this, r = arguments;
    return new Promise(function(n, a) {
      var i = e.apply(t, r);
      function o(l) {
        bR(i, n, a, o, s, "next", l);
      }
      function s(l) {
        bR(i, n, a, o, s, "throw", l);
      }
      o(void 0);
    });
  };
}
var lh = ce({}, Mle), npe = lh.version, ape = lh.render, ipe = lh.unmountComponentAtNode, x1;
try {
  var ope = Number((npe || "").split(".")[0]);
  ope >= 18 && (x1 = lh.createRoot);
} catch {
}
function CR(e) {
  var t = lh.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  t && kt(t) === "object" && (t.usingClientEntryPoint = e);
}
var Ab = "__rc_react_root__";
function spe(e, t) {
  CR(!0);
  var r = t[Ab] || x1(t);
  CR(!1), r.render(e), t[Ab] = r;
}
function lpe(e, t) {
  ape(e, t);
}
function DT(e, t) {
  if (x1) {
    spe(e, t);
    return;
  }
  lpe(e, t);
}
function cpe(e) {
  return M2.apply(this, arguments);
}
function M2() {
  return M2 = jc(/* @__PURE__ */ ai().mark(function e(t) {
    return ai().wrap(function(n) {
      for (; ; ) switch (n.prev = n.next) {
        case 0:
          return n.abrupt("return", Promise.resolve().then(function() {
            var a;
            (a = t[Ab]) === null || a === void 0 || a.unmount(), delete t[Ab];
          }));
        case 1:
        case "end":
          return n.stop();
      }
    }, e);
  })), M2.apply(this, arguments);
}
function upe(e) {
  ipe(e);
}
function yz(e) {
  return A2.apply(this, arguments);
}
function A2() {
  return A2 = jc(/* @__PURE__ */ ai().mark(function e(t) {
    return ai().wrap(function(n) {
      for (; ; ) switch (n.prev = n.next) {
        case 0:
          if (x1 === void 0) {
            n.next = 2;
            break;
          }
          return n.abrupt("return", cpe(t));
        case 2:
          upe(t);
        case 3:
        case "end":
          return n.stop();
      }
    }, e);
  })), A2.apply(this, arguments);
}
const ax = () => ({
  height: 0,
  opacity: 0
}), SR = (e) => {
  const {
    scrollHeight: t
  } = e;
  return {
    height: t,
    opacity: 1
  };
}, dpe = (e) => ({
  height: e ? e.offsetHeight : 0
}), ix = (e, t) => t?.deadline === !0 || t.propertyName === "height", Pb = function() {
  return {
    motionName: `${arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ant"}-motion-collapse`,
    onAppearStart: ax,
    onEnterStart: ax,
    onAppearActive: SR,
    onEnterActive: SR,
    onLeaveStart: dpe,
    onLeaveActive: ax,
    onAppearEnd: ix,
    onEnterEnd: ix,
    onLeaveEnd: ix,
    motionDeadline: 500
  };
}, Gi = (e, t, r) => r !== void 0 ? r : `${e}-${t}`, yd = function(e) {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      var t = e.getBBox(), r = t.width, n = t.height;
      if (r || n)
        return !0;
    }
    if (e.getBoundingClientRect) {
      var a = e.getBoundingClientRect(), i = a.width, o = a.height;
      if (i || o)
        return !0;
    }
  }
  return !1;
}, fpe = (e) => {
  const {
    componentCls: t,
    colorPrimary: r
  } = e;
  return {
    [t]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${r})`,
      boxShadow: "0 0 0 0 currentcolor",
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${e.motionEaseOutCirc}`, `opacity 2s ${e.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: "0 0 0 6px currentcolor",
          opacity: 0
        },
        "&.wave-quick": {
          transition: [`box-shadow ${e.motionDurationSlow} ${e.motionEaseInOut}`, `opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`].join(",")
        }
      }
    }
  };
}, ppe = AT("Wave", (e) => [fpe(e)]), $1 = `${XB}-wave-target`;
function mpe(e) {
  const t = (e || "").match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
  return t && t[1] && t[2] && t[3] ? !(t[1] === t[2] && t[2] === t[3]) : !0;
}
function ox(e) {
  return e && e !== "#fff" && e !== "#ffffff" && e !== "rgb(255, 255, 255)" && e !== "rgba(255, 255, 255, 1)" && mpe(e) && !/rgba\((?:\d*, ){3}0\)/.test(e) && // any transparent rgba color
  e !== "transparent";
}
function vpe(e) {
  const {
    borderTopColor: t,
    borderColor: r,
    backgroundColor: n
  } = getComputedStyle(e);
  return ox(t) ? t : ox(r) ? r : ox(n) ? n : null;
}
function sx(e) {
  return Number.isNaN(e) ? 0 : e;
}
const hpe = (e) => {
  const {
    className: t,
    target: r,
    component: n
  } = e, a = p.useRef(null), [i, o] = p.useState(null), [s, l] = p.useState([]), [c, u] = p.useState(0), [d, f] = p.useState(0), [m, h] = p.useState(0), [g, y] = p.useState(0), [S, x] = p.useState(!1), b = {
    left: c,
    top: d,
    width: m,
    height: g,
    borderRadius: s.map((w) => `${w}px`).join(" ")
  };
  i && (b["--wave-color"] = i);
  function _() {
    const w = getComputedStyle(r);
    o(vpe(r));
    const O = w.position === "static", {
      borderLeftWidth: T,
      borderTopWidth: I
    } = w;
    u(O ? r.offsetLeft : sx(-parseFloat(T))), f(O ? r.offsetTop : sx(-parseFloat(I))), h(r.offsetWidth), y(r.offsetHeight);
    const {
      borderTopLeftRadius: P,
      borderTopRightRadius: D,
      borderBottomLeftRadius: B,
      borderBottomRightRadius: L
    } = w;
    l([P, D, L, B].map((N) => sx(parseFloat(N))));
  }
  if (p.useEffect(() => {
    if (r) {
      const w = vr(() => {
        _(), x(!0);
      });
      let O;
      return typeof ResizeObserver < "u" && (O = new ResizeObserver(_), O.observe(r)), () => {
        vr.cancel(w), O?.disconnect();
      };
    }
  }, []), !S)
    return null;
  const $ = (n === "Checkbox" || n === "Radio") && r?.classList.contains($1);
  return /* @__PURE__ */ p.createElement(Ci, {
    visible: !0,
    motionAppear: !0,
    motionName: "wave-motion",
    motionDeadline: 5e3,
    onAppearEnd: (w, O) => {
      var T;
      if (O.deadline || O.propertyName === "opacity") {
        const I = (T = a.current) === null || T === void 0 ? void 0 : T.parentElement;
        yz(I).then(() => {
          I?.remove();
        });
      }
      return !1;
    }
  }, (w, O) => {
    let {
      className: T
    } = w;
    return /* @__PURE__ */ p.createElement("div", {
      ref: Za(a, O),
      className: be(t, T, {
        "wave-quick": $
      }),
      style: b
    });
  });
}, gpe = (e, t) => {
  var r;
  const {
    component: n
  } = t;
  if (n === "Checkbox" && !(!((r = e.querySelector("input")) === null || r === void 0) && r.checked))
    return;
  const a = document.createElement("div");
  a.style.position = "absolute", a.style.left = "0px", a.style.top = "0px", e?.insertBefore(a, e?.firstChild), DT(/* @__PURE__ */ p.createElement(hpe, Object.assign({}, t, {
    target: e
  })), a);
}, ype = (e, t, r) => {
  const {
    wave: n
  } = p.useContext(Lt), [, a, i] = ua(), o = br((c) => {
    const u = e.current;
    if (n?.disabled || !u)
      return;
    const d = u.querySelector(`.${$1}`) || u, {
      showEffect: f
    } = n || {};
    (f || gpe)(d, {
      className: t,
      token: a,
      component: r,
      event: c,
      hashId: i
    });
  }), s = p.useRef();
  return (c) => {
    vr.cancel(s.current), s.current = vr(() => {
      o(c);
    });
  };
}, ch = (e) => {
  const {
    children: t,
    disabled: r,
    component: n
  } = e, {
    getPrefixCls: a
  } = Cr(Lt), i = ct(null), o = a("wave"), [, s] = ppe(o), l = ype(i, be(o, s), n);
  if (xe.useEffect(() => {
    const u = i.current;
    if (!u || u.nodeType !== 1 || r)
      return;
    const d = (f) => {
      !yd(f.target) || // No need wave
      !u.getAttribute || u.getAttribute("disabled") || u.disabled || u.className.includes("disabled") || u.className.includes("-leave") || l(f);
    };
    return u.addEventListener("click", d, !0), () => {
      u.removeEventListener("click", d, !0);
    };
  }, [r]), !/* @__PURE__ */ xe.isValidElement(t))
    return t ?? null;
  const c = No(t) ? Za(t.ref, i) : i;
  return Si(t, {
    ref: c
  });
};
process.env.NODE_ENV !== "production" && (ch.displayName = "Wave");
const Xa = (e) => {
  const t = xe.useContext(Sc);
  return xe.useMemo(() => e ? typeof e == "string" ? e ?? t : e instanceof Function ? e(t) : t : t, [e, t]);
}, bpe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-block": {
        display: "flex",
        width: "100%"
      },
      "&-vertical": {
        flexDirection: "column"
      }
    }
  };
}, Cpe = (e) => {
  const {
    componentCls: t,
    antCls: r
  } = e;
  return {
    [t]: {
      display: "inline-flex",
      "&-rtl": {
        direction: "rtl"
      },
      "&-vertical": {
        flexDirection: "column"
      },
      "&-align": {
        flexDirection: "column",
        "&-center": {
          alignItems: "center"
        },
        "&-start": {
          alignItems: "flex-start"
        },
        "&-end": {
          alignItems: "flex-end"
        },
        "&-baseline": {
          alignItems: "baseline"
        }
      },
      [`${t}-item:empty`]: {
        display: "none"
      },
      // https://github.com/ant-design/ant-design/issues/47875
      [`${t}-item > ${r}-badge-not-a-wrapper:only-child`]: {
        display: "block"
      }
    }
  };
}, Spe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-gap-row-small": {
        rowGap: e.spaceGapSmallSize
      },
      "&-gap-row-middle": {
        rowGap: e.spaceGapMiddleSize
      },
      "&-gap-row-large": {
        rowGap: e.spaceGapLargeSize
      },
      "&-gap-col-small": {
        columnGap: e.spaceGapSmallSize
      },
      "&-gap-col-middle": {
        columnGap: e.spaceGapMiddleSize
      },
      "&-gap-col-large": {
        columnGap: e.spaceGapLargeSize
      }
    }
  };
}, bz = Zr("Space", (e) => {
  const t = $r(e, {
    spaceGapSmallSize: e.paddingXS,
    spaceGapMiddleSize: e.padding,
    spaceGapLargeSize: e.paddingLG
  });
  return [Cpe(t), Spe(t), bpe(t)];
}, () => ({}), {
  // Space component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/40315
  resetStyle: !1
});
var Cz = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const _1 = /* @__PURE__ */ p.createContext(null), El = (e, t) => {
  const r = p.useContext(_1), n = p.useMemo(() => {
    if (!r)
      return "";
    const {
      compactDirection: a,
      isFirstItem: i,
      isLastItem: o
    } = r, s = a === "vertical" ? "-vertical-" : "-";
    return be(`${e}-compact${s}item`, {
      [`${e}-compact${s}first-item`]: i,
      [`${e}-compact${s}last-item`]: o,
      [`${e}-compact${s}item-rtl`]: t === "rtl"
    });
  }, [e, t, r]);
  return {
    compactSize: r?.compactSize,
    compactDirection: r?.compactDirection,
    compactItemClassnames: n
  };
}, Lc = (e) => {
  let {
    children: t
  } = e;
  return /* @__PURE__ */ p.createElement(_1.Provider, {
    value: null
  }, t);
}, xpe = (e) => {
  var {
    children: t
  } = e, r = Cz(e, ["children"]);
  return /* @__PURE__ */ p.createElement(_1.Provider, {
    value: r
  }, t);
}, $pe = (e) => {
  const {
    getPrefixCls: t,
    direction: r
  } = p.useContext(Lt), {
    size: n,
    direction: a,
    block: i,
    prefixCls: o,
    className: s,
    rootClassName: l,
    children: c
  } = e, u = Cz(e, ["size", "direction", "block", "prefixCls", "className", "rootClassName", "children"]), d = Xa((b) => n ?? b), f = t("space-compact", o), [m, h] = bz(f), g = be(f, h, {
    [`${f}-rtl`]: r === "rtl",
    [`${f}-block`]: i,
    [`${f}-vertical`]: a === "vertical"
  }, s, l), y = p.useContext(_1), S = Ma(c), x = p.useMemo(() => S.map((b, _) => {
    const $ = b && b.key || `${f}-item-${_}`;
    return /* @__PURE__ */ p.createElement(xpe, {
      key: $,
      compactSize: d,
      compactDirection: a,
      isFirstItem: _ === 0 && (!y || y?.isFirstItem),
      isLastItem: _ === S.length - 1 && (!y || y?.isLastItem)
    }, b);
  }), [n, S, y]);
  return S.length === 0 ? null : m(/* @__PURE__ */ p.createElement("div", Object.assign({
    className: g
  }, u), x));
};
var _pe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const Sz = /* @__PURE__ */ p.createContext(void 0), Epe = (e) => {
  const {
    getPrefixCls: t,
    direction: r
  } = p.useContext(Lt), {
    prefixCls: n,
    size: a,
    className: i
  } = e, o = _pe(e, ["prefixCls", "size", "className"]), s = t("btn-group", n), [, , l] = ua();
  let c = "";
  switch (a) {
    case "large":
      c = "lg";
      break;
    case "small":
      c = "sm";
      break;
  }
  if (process.env.NODE_ENV !== "production") {
    const d = xr("Button.Group");
    process.env.NODE_ENV !== "production" && d(!a || ["large", "small", "middle"].includes(a), "usage", "Invalid prop `size`.");
  }
  const u = be(s, {
    [`${s}-${c}`]: c,
    [`${s}-rtl`]: r === "rtl"
  }, i, l);
  return /* @__PURE__ */ p.createElement(Sz.Provider, {
    value: a
  }, /* @__PURE__ */ p.createElement("div", Object.assign({}, o, {
    className: u
  })));
}, xR = /^[\u4e00-\u9fa5]{2}$/, P2 = xR.test.bind(xR);
function xz(e) {
  return e === "danger" ? {
    danger: !0
  } : {
    type: e
  };
}
function $R(e) {
  return typeof e == "string";
}
function Zg(e) {
  return e === "text" || e === "link";
}
function wpe(e, t) {
  if (e == null)
    return;
  const r = t ? " " : "";
  return typeof e != "string" && typeof e != "number" && $R(e.type) && P2(e.props.children) ? Si(e, {
    children: e.props.children.split("").join(r)
  }) : $R(e) ? P2(e) ? /* @__PURE__ */ xe.createElement("span", null, e.split("").join(r)) : /* @__PURE__ */ xe.createElement("span", null, e) : iz(e) ? /* @__PURE__ */ xe.createElement("span", null, e) : e;
}
function Ope(e, t) {
  let r = !1;
  const n = [];
  return xe.Children.forEach(e, (a) => {
    const i = typeof a, o = i === "string" || i === "number";
    if (r && o) {
      const s = n.length - 1, l = n[s];
      n[s] = `${l}${a}`;
    } else
      n.push(a);
    r = o;
  }), xe.Children.map(n, (a) => wpe(a, t));
}
const $z = /* @__PURE__ */ Aa((e, t) => {
  const {
    className: r,
    style: n,
    children: a,
    prefixCls: i
  } = e, o = be(`${i}-icon`, r);
  return /* @__PURE__ */ xe.createElement("span", {
    ref: t,
    className: o,
    style: n
  }, a);
}), _R = /* @__PURE__ */ Aa((e, t) => {
  const {
    prefixCls: r,
    className: n,
    style: a,
    iconClassName: i
  } = e, o = be(`${r}-loading-icon`, n);
  return /* @__PURE__ */ xe.createElement($z, {
    prefixCls: r,
    className: o,
    style: a,
    ref: t
  }, /* @__PURE__ */ xe.createElement(Dc, {
    className: i
  }));
}), lx = () => ({
  width: 0,
  opacity: 0,
  transform: "scale(0)"
}), cx = (e) => ({
  width: e.scrollWidth,
  opacity: 1,
  transform: "scale(1)"
}), Tpe = (e) => {
  const {
    prefixCls: t,
    loading: r,
    existIcon: n,
    className: a,
    style: i
  } = e, o = !!r;
  return n ? /* @__PURE__ */ xe.createElement(_R, {
    prefixCls: t,
    className: a,
    style: i
  }) : /* @__PURE__ */ xe.createElement(Ci, {
    visible: o,
    // We do not really use this motionName
    motionName: `${t}-loading-icon-motion`,
    motionLeave: o,
    removeOnLeave: !0,
    onAppearStart: lx,
    onAppearActive: cx,
    onEnterStart: lx,
    onEnterActive: cx,
    onLeaveStart: cx,
    onLeaveActive: lx
  }, (s, l) => {
    let {
      className: c,
      style: u
    } = s;
    return /* @__PURE__ */ xe.createElement(_R, {
      prefixCls: t,
      className: a,
      style: Object.assign(Object.assign({}, i), u),
      ref: l,
      iconClassName: c
    });
  });
}, ER = (e, t) => ({
  // Border
  [`> span, > ${e}`]: {
    "&:not(:last-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineEndColor: t
        }
      }
    },
    "&:not(:first-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineStartColor: t
        }
      }
    }
  }
}), Ipe = (e) => {
  const {
    componentCls: t,
    fontSize: r,
    lineWidth: n,
    groupBorderColor: a,
    colorErrorHover: i
  } = e;
  return {
    [`${t}-group`]: [
      {
        position: "relative",
        display: "inline-flex",
        // Border
        [`> span, > ${t}`]: {
          "&:not(:last-child)": {
            [`&, & > ${t}`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          "&:not(:first-child)": {
            marginInlineStart: e.calc(n).mul(-1).equal(),
            [`&, & > ${t}`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        },
        [t]: {
          position: "relative",
          zIndex: 1,
          "&:hover,\n          &:focus,\n          &:active": {
            zIndex: 2
          },
          "&[disabled]": {
            zIndex: 0
          }
        },
        [`${t}-icon-only`]: {
          fontSize: r
        }
      },
      // Border Color
      ER(`${t}-primary`, a),
      ER(`${t}-danger`, i)
    ]
  };
}, _z = (e) => {
  const {
    paddingInline: t,
    onlyIconSize: r,
    paddingBlock: n
  } = e;
  return $r(e, {
    buttonPaddingHorizontal: t,
    buttonPaddingVertical: n,
    buttonIconOnlyFontSize: r
  });
}, Ez = (e) => {
  var t, r, n, a, i, o;
  const s = (t = e.contentFontSize) !== null && t !== void 0 ? t : e.fontSize, l = (r = e.contentFontSizeSM) !== null && r !== void 0 ? r : e.fontSize, c = (n = e.contentFontSizeLG) !== null && n !== void 0 ? n : e.fontSizeLG, u = (a = e.contentLineHeight) !== null && a !== void 0 ? a : sb(s), d = (i = e.contentLineHeightSM) !== null && i !== void 0 ? i : sb(l), f = (o = e.contentLineHeightLG) !== null && o !== void 0 ? o : sb(c);
  return {
    fontWeight: 400,
    defaultShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlTmpOutline}`,
    primaryShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlOutline}`,
    dangerShadow: `0 ${e.controlOutlineWidth}px 0 ${e.colorErrorOutline}`,
    primaryColor: e.colorTextLightSolid,
    dangerColor: e.colorTextLightSolid,
    borderColorDisabled: e.colorBorder,
    defaultGhostColor: e.colorBgContainer,
    ghostBg: "transparent",
    defaultGhostBorderColor: e.colorBgContainer,
    paddingInline: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineLG: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineSM: 8 - e.lineWidth,
    onlyIconSize: e.fontSizeLG,
    onlyIconSizeSM: e.fontSizeLG - 2,
    onlyIconSizeLG: e.fontSizeLG + 2,
    groupBorderColor: e.colorPrimaryHover,
    linkHoverBg: "transparent",
    textHoverBg: e.colorBgTextHover,
    defaultColor: e.colorText,
    defaultBg: e.colorBgContainer,
    defaultBorderColor: e.colorBorder,
    defaultBorderColorDisabled: e.colorBorder,
    defaultHoverBg: e.colorBgContainer,
    defaultHoverColor: e.colorPrimaryHover,
    defaultHoverBorderColor: e.colorPrimaryHover,
    defaultActiveBg: e.colorBgContainer,
    defaultActiveColor: e.colorPrimaryActive,
    defaultActiveBorderColor: e.colorPrimaryActive,
    contentFontSize: s,
    contentFontSizeSM: l,
    contentFontSizeLG: c,
    contentLineHeight: u,
    contentLineHeightSM: d,
    contentLineHeightLG: f,
    paddingBlock: Math.max((e.controlHeight - s * u) / 2 - e.lineWidth, 0),
    paddingBlockSM: Math.max((e.controlHeightSM - l * d) / 2 - e.lineWidth, 0),
    paddingBlockLG: Math.max((e.controlHeightLG - c * f) / 2 - e.lineWidth, 0)
  };
}, Mpe = (e) => {
  const {
    componentCls: t,
    iconCls: r,
    fontWeight: n
  } = e;
  return {
    [t]: {
      outline: "none",
      position: "relative",
      display: "inline-flex",
      gap: e.marginXS,
      alignItems: "center",
      justifyContent: "center",
      fontWeight: n,
      whiteSpace: "nowrap",
      textAlign: "center",
      backgroundImage: "none",
      background: "transparent",
      border: `${ve(e.lineWidth)} ${e.lineType} transparent`,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
      userSelect: "none",
      touchAction: "manipulation",
      color: e.colorText,
      "&:disabled > *": {
        pointerEvents: "none"
      },
      "> span": {
        display: "inline-block"
      },
      [`${t}-icon`]: {
        lineHeight: 1
      },
      "> a": {
        color: "currentColor"
      },
      "&:not(:disabled)": Object.assign({}, zs(e)),
      [`&${t}-two-chinese-chars::first-letter`]: {
        letterSpacing: "0.34em"
      },
      [`&${t}-two-chinese-chars > *:not(${r})`]: {
        marginInlineEnd: "-0.34em",
        letterSpacing: "0.34em"
      },
      // iconPosition="end"
      "&-icon-end": {
        flexDirection: "row-reverse"
      }
    }
  };
}, Hs = (e, t, r) => ({
  [`&:not(:disabled):not(${e}-disabled)`]: {
    "&:hover": t,
    "&:active": r
  }
}), Ape = (e) => ({
  minWidth: e.controlHeight,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: "50%"
}), Ppe = (e) => ({
  borderRadius: e.controlHeight,
  paddingInlineStart: e.calc(e.controlHeight).div(2).equal(),
  paddingInlineEnd: e.calc(e.controlHeight).div(2).equal()
}), Rpe = (e) => ({
  cursor: "not-allowed",
  borderColor: e.borderColorDisabled,
  color: e.colorTextDisabled,
  background: e.colorBgContainerDisabled,
  boxShadow: "none"
}), K0 = (e, t, r, n, a, i, o, s) => ({
  [`&${e}-background-ghost`]: Object.assign(Object.assign({
    color: r || void 0,
    background: t,
    borderColor: n || void 0,
    boxShadow: "none"
  }, Hs(e, Object.assign({
    background: t
  }, o), Object.assign({
    background: t
  }, s))), {
    "&:disabled": {
      cursor: "not-allowed",
      color: a || void 0,
      borderColor: i || void 0
    }
  })
}), jT = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: Object.assign({}, Rpe(e))
}), wz = (e) => Object.assign({}, jT(e)), Rb = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: {
    cursor: "not-allowed",
    color: e.colorTextDisabled
  }
}), Oz = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, wz(e)), {
  background: e.defaultBg,
  borderColor: e.defaultBorderColor,
  color: e.defaultColor,
  boxShadow: e.defaultShadow
}), Hs(e.componentCls, {
  color: e.defaultHoverColor,
  borderColor: e.defaultHoverBorderColor,
  background: e.defaultHoverBg
}, {
  color: e.defaultActiveColor,
  borderColor: e.defaultActiveBorderColor,
  background: e.defaultActiveBg
})), K0(e.componentCls, e.ghostBg, e.defaultGhostColor, e.defaultGhostBorderColor, e.colorTextDisabled, e.colorBorder)), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
    color: e.colorError,
    borderColor: e.colorError
  }, Hs(e.componentCls, {
    color: e.colorErrorHover,
    borderColor: e.colorErrorBorderHover
  }, {
    color: e.colorErrorActive,
    borderColor: e.colorErrorActive
  })), K0(e.componentCls, e.ghostBg, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder)), jT(e))
}), Npe = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, wz(e)), {
  color: e.primaryColor,
  background: e.colorPrimary,
  boxShadow: e.primaryShadow
}), Hs(e.componentCls, {
  color: e.colorTextLightSolid,
  background: e.colorPrimaryHover
}, {
  color: e.colorTextLightSolid,
  background: e.colorPrimaryActive
})), K0(e.componentCls, e.ghostBg, e.colorPrimary, e.colorPrimary, e.colorTextDisabled, e.colorBorder, {
  color: e.colorPrimaryHover,
  borderColor: e.colorPrimaryHover
}, {
  color: e.colorPrimaryActive,
  borderColor: e.colorPrimaryActive
})), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
    background: e.colorError,
    boxShadow: e.dangerShadow,
    color: e.dangerColor
  }, Hs(e.componentCls, {
    background: e.colorErrorHover
  }, {
    background: e.colorErrorActive
  })), K0(e.componentCls, e.ghostBg, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder, {
    color: e.colorErrorHover,
    borderColor: e.colorErrorHover
  }, {
    color: e.colorErrorActive,
    borderColor: e.colorErrorActive
  })), jT(e))
}), Dpe = (e) => Object.assign(Object.assign({}, Oz(e)), {
  borderStyle: "dashed"
}), jpe = (e) => Object.assign(Object.assign(Object.assign({
  color: e.colorLink
}, Hs(e.componentCls, {
  color: e.colorLinkHover,
  background: e.linkHoverBg
}, {
  color: e.colorLinkActive
})), Rb(e)), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign({
    color: e.colorError
  }, Hs(e.componentCls, {
    color: e.colorErrorHover
  }, {
    color: e.colorErrorActive
  })), Rb(e))
}), Lpe = (e) => Object.assign(Object.assign(Object.assign({}, Hs(e.componentCls, {
  color: e.colorText,
  background: e.textHoverBg
}, {
  color: e.colorText,
  background: e.colorBgTextActive
})), Rb(e)), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign({
    color: e.colorError
  }, Rb(e)), Hs(e.componentCls, {
    color: e.colorErrorHover,
    background: e.colorErrorBg
  }, {
    color: e.colorErrorHover,
    background: e.colorErrorBgActive
  }))
}), kpe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-default`]: Oz(e),
    [`${t}-primary`]: Npe(e),
    [`${t}-dashed`]: Dpe(e),
    [`${t}-link`]: jpe(e),
    [`${t}-text`]: Lpe(e),
    [`${t}-ghost`]: K0(e.componentCls, e.ghostBg, e.colorBgContainer, e.colorBgContainer, e.colorTextDisabled, e.colorBorder)
  };
}, LT = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  const {
    componentCls: r,
    controlHeight: n,
    fontSize: a,
    lineHeight: i,
    borderRadius: o,
    buttonPaddingHorizontal: s,
    iconCls: l,
    buttonPaddingVertical: c
  } = e, u = `${r}-icon-only`;
  return [
    {
      [`${t}`]: {
        fontSize: a,
        lineHeight: i,
        height: n,
        padding: `${ve(c)} ${ve(s)}`,
        borderRadius: o,
        [`&${u}`]: {
          width: n,
          paddingInline: 0,
          // make `btn-icon-only` not too narrow
          [`&${r}-compact-item`]: {
            flex: "none"
          },
          [`&${r}-round`]: {
            width: "auto"
          },
          [l]: {
            fontSize: e.buttonIconOnlyFontSize
          }
        },
        // Loading
        [`&${r}-loading`]: {
          opacity: e.opacityLoading,
          cursor: "default"
        },
        [`${r}-loading-icon`]: {
          transition: `width ${e.motionDurationSlow} ${e.motionEaseInOut}, opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`
        }
      }
    },
    // Shape - patch prefixCls again to override solid border radius style
    {
      [`${r}${r}-circle${t}`]: Ape(e)
    },
    {
      [`${r}${r}-round${t}`]: Ppe(e)
    }
  ];
}, Fpe = (e) => {
  const t = $r(e, {
    fontSize: e.contentFontSize,
    lineHeight: e.contentLineHeight
  });
  return LT(t, e.componentCls);
}, Bpe = (e) => {
  const t = $r(e, {
    controlHeight: e.controlHeightSM,
    fontSize: e.contentFontSizeSM,
    lineHeight: e.contentLineHeightSM,
    padding: e.paddingXS,
    buttonPaddingHorizontal: e.paddingInlineSM,
    buttonPaddingVertical: e.paddingBlockSM,
    borderRadius: e.borderRadiusSM,
    buttonIconOnlyFontSize: e.onlyIconSizeSM
  });
  return LT(t, `${e.componentCls}-sm`);
}, zpe = (e) => {
  const t = $r(e, {
    controlHeight: e.controlHeightLG,
    fontSize: e.contentFontSizeLG,
    lineHeight: e.contentLineHeightLG,
    buttonPaddingHorizontal: e.paddingInlineLG,
    buttonPaddingVertical: e.paddingBlockLG,
    borderRadius: e.borderRadiusLG,
    buttonIconOnlyFontSize: e.onlyIconSizeLG
  });
  return LT(t, `${e.componentCls}-lg`);
}, Hpe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      [`&${t}-block`]: {
        width: "100%"
      }
    }
  };
}, Vpe = Zr("Button", (e) => {
  const t = _z(e);
  return [
    // Shared
    Mpe(t),
    // Size
    Fpe(t),
    Bpe(t),
    zpe(t),
    // Block
    Hpe(t),
    // Group (type, ghost, danger, loading)
    kpe(t),
    // Button Group
    Ipe(t)
  ];
}, Ez, {
  unitless: {
    fontWeight: !0,
    contentLineHeight: !0,
    contentLineHeightSM: !0,
    contentLineHeightLG: !0
  }
});
function Gpe(e, t, r) {
  const {
    focusElCls: n,
    focus: a,
    borderElCls: i
  } = r, o = i ? "> *" : "", s = ["hover", a ? "focus" : null, "active"].filter(Boolean).map((l) => `&:${l} ${o}`).join(",");
  return {
    [`&-item:not(${t}-last-item)`]: {
      marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": Object.assign(Object.assign({
      [s]: {
        zIndex: 2
      }
    }, n ? {
      [`&${n}`]: {
        zIndex: 2
      }
    } : {}), {
      [`&[disabled] ${o}`]: {
        zIndex: 0
      }
    })
  };
}
function Upe(e, t, r) {
  const {
    borderElCls: n
  } = r, a = n ? `> ${n}` : "";
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item) ${a}`]: {
      borderRadius: 0
    },
    [`&-item:not(${t}-last-item)${t}-first-item`]: {
      [`& ${a}, &${e}-sm ${a}, &${e}-lg ${a}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${t}-first-item)${t}-last-item`]: {
      [`& ${a}, &${e}-sm ${a}, &${e}-lg ${a}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function uh(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    focus: !0
  };
  const {
    componentCls: r
  } = e, n = `${r}-compact`;
  return {
    [n]: Object.assign(Object.assign({}, Gpe(e, n, t)), Upe(r, n, t))
  };
}
function Wpe(e, t) {
  return {
    // border collapse
    [`&-item:not(${t}-last-item)`]: {
      marginBottom: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": {
      "&:hover,&:focus,&:active": {
        zIndex: 2
      },
      "&[disabled]": {
        zIndex: 0
      }
    }
  };
}
function qpe(e, t) {
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${t}-first-item:not(${t}-last-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${t}-last-item:not(${t}-first-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function Kpe(e) {
  const t = `${e.componentCls}-compact-vertical`;
  return {
    [t]: Object.assign(Object.assign({}, Wpe(e, t)), qpe(e.componentCls, t))
  };
}
const Ype = (e) => {
  const {
    componentCls: t,
    calc: r
  } = e;
  return {
    [t]: {
      // Special styles for Primary Button
      [`&-compact-item${t}-primary`]: {
        [`&:not([disabled]) + ${t}-compact-item${t}-primary:not([disabled])`]: {
          position: "relative",
          "&:before": {
            position: "absolute",
            top: r(e.lineWidth).mul(-1).equal(),
            insetInlineStart: r(e.lineWidth).mul(-1).equal(),
            display: "inline-block",
            width: e.lineWidth,
            height: `calc(100% + ${ve(e.lineWidth)} * 2)`,
            backgroundColor: e.colorPrimaryHover,
            content: '""'
          }
        }
      },
      // Special styles for Primary Button
      "&-compact-vertical-item": {
        [`&${t}-primary`]: {
          [`&:not([disabled]) + ${t}-compact-vertical-item${t}-primary:not([disabled])`]: {
            position: "relative",
            "&:before": {
              position: "absolute",
              top: r(e.lineWidth).mul(-1).equal(),
              insetInlineStart: r(e.lineWidth).mul(-1).equal(),
              display: "inline-block",
              width: `calc(100% + ${ve(e.lineWidth)} * 2)`,
              height: e.lineWidth,
              backgroundColor: e.colorPrimaryHover,
              content: '""'
            }
          }
        }
      }
    }
  };
}, Zpe = vd(["Button", "compact"], (e) => {
  const t = _z(e);
  return [
    // Space Compact
    uh(t),
    Kpe(t),
    Ype(t)
  ];
}, Ez);
var Xpe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function Jpe(e) {
  if (typeof e == "object" && e) {
    let t = e?.delay;
    return t = !Number.isNaN(t) && typeof t == "number" ? t : 0, {
      loading: t <= 0,
      delay: t
    };
  }
  return {
    loading: !!e,
    delay: 0
  };
}
const Qpe = /* @__PURE__ */ xe.forwardRef((e, t) => {
  var r, n, a;
  const {
    loading: i = !1,
    prefixCls: o,
    type: s,
    danger: l = !1,
    shape: c = "default",
    size: u,
    styles: d,
    disabled: f,
    className: m,
    rootClassName: h,
    children: g,
    icon: y,
    iconPosition: S = "start",
    ghost: x = !1,
    block: b = !1,
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType: _ = "button",
    classNames: $,
    style: w = {},
    autoInsertSpace: O
  } = e, T = Xpe(e, ["loading", "prefixCls", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "iconPosition", "ghost", "block", "htmlType", "classNames", "style", "autoInsertSpace"]), I = s || "default", {
    getPrefixCls: P,
    direction: D,
    button: B
  } = Cr(Lt), L = (r = O ?? B?.autoInsertSpace) !== null && r !== void 0 ? r : !0, N = P("btn", o), [z, F, j] = Vpe(N), H = Cr(Vi), U = f ?? H, G = Cr(Sz), V = dr(() => Jpe(i), [i]), [K, Z] = He(V.loading), [ee, ae] = He(!1), re = Za(t, /* @__PURE__ */ wle()), oe = Ole.count(g) === 1 && !y && !Zg(I);
  St(() => {
    let J = null;
    V.delay > 0 ? J = setTimeout(() => {
      J = null, Z(!0);
    }, V.delay) : Z(V.loading);
    function de() {
      J && (clearTimeout(J), J = null);
    }
    return de;
  }, [V]), St(() => {
    if (!re || !re.current || !L)
      return;
    const J = re.current.textContent;
    oe && P2(J) ? ee || ae(!0) : ee && ae(!1);
  }, [re]);
  const fe = (J) => {
    const {
      onClick: de
    } = e;
    if (K || U) {
      J.preventDefault();
      return;
    }
    de?.(J);
  };
  if (process.env.NODE_ENV !== "production") {
    const J = xr("Button");
    process.env.NODE_ENV !== "production" && J(!(typeof y == "string" && y.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${y}\` at https://ant.design/components/icon`), process.env.NODE_ENV !== "production" && J(!(x && Zg(I)), "usage", "`link` or `text` button can't be a `ghost` button.");
  }
  const {
    compactSize: le,
    compactItemClassnames: se
  } = El(N, D), Q = {
    large: "lg",
    small: "sm",
    middle: void 0
  }, he = Xa((J) => {
    var de, Se;
    return (Se = (de = u ?? le) !== null && de !== void 0 ? de : G) !== null && Se !== void 0 ? Se : J;
  }), ne = he && Q[he] || "", me = K ? "loading" : y, k = bn(T, ["navigate"]), M = be(N, F, j, {
    [`${N}-${c}`]: c !== "default" && c,
    [`${N}-${I}`]: I,
    [`${N}-${ne}`]: ne,
    [`${N}-icon-only`]: !g && g !== 0 && !!me,
    [`${N}-background-ghost`]: x && !Zg(I),
    [`${N}-loading`]: K,
    [`${N}-two-chinese-chars`]: ee && L && !K,
    [`${N}-block`]: b,
    [`${N}-dangerous`]: l,
    [`${N}-rtl`]: D === "rtl",
    [`${N}-icon-end`]: S === "end"
  }, se, m, h, B?.className), R = Object.assign(Object.assign({}, B?.style), w), q = be($?.icon, (n = B?.classNames) === null || n === void 0 ? void 0 : n.icon), Y = Object.assign(Object.assign({}, d?.icon || {}), ((a = B?.styles) === null || a === void 0 ? void 0 : a.icon) || {}), X = y && !K ? /* @__PURE__ */ xe.createElement($z, {
    prefixCls: N,
    className: q,
    style: Y
  }, y) : /* @__PURE__ */ xe.createElement(Tpe, {
    existIcon: !!y,
    prefixCls: N,
    loading: K
  }), pe = g || g === 0 ? Ope(g, oe && L) : null;
  if (k.href !== void 0)
    return z(/* @__PURE__ */ xe.createElement("a", Object.assign({}, k, {
      className: be(M, {
        [`${N}-disabled`]: U
      }),
      href: U ? void 0 : k.href,
      style: R,
      onClick: fe,
      ref: re,
      tabIndex: U ? -1 : 0
    }), X, pe));
  let $e = /* @__PURE__ */ xe.createElement("button", Object.assign({}, T, {
    type: _,
    className: M,
    style: R,
    onClick: fe,
    disabled: U,
    ref: re
  }), X, pe, !!se && /* @__PURE__ */ xe.createElement(Zpe, {
    key: "compact",
    prefixCls: N
  }));
  return Zg(I) || ($e = /* @__PURE__ */ xe.createElement(ch, {
    component: "Button",
    disabled: K
  }, $e)), z($e);
}), Nt = Qpe;
Nt.Group = Epe;
Nt.__ANT_BUTTON = !0;
process.env.NODE_ENV !== "production" && (Nt.displayName = "Button");
function ux(e) {
  return !!(e && e.then);
}
const Tz = (e) => {
  const {
    type: t,
    children: r,
    prefixCls: n,
    buttonProps: a,
    close: i,
    autoFocus: o,
    emitEvent: s,
    isSilent: l,
    quitOnNullishReturnValue: c,
    actionFn: u
  } = e, d = p.useRef(!1), f = p.useRef(null), [m, h] = xc(!1), g = function() {
    i?.apply(void 0, arguments);
  };
  p.useEffect(() => {
    let x = null;
    return o && (x = setTimeout(() => {
      var b;
      (b = f.current) === null || b === void 0 || b.focus();
    })), () => {
      x && clearTimeout(x);
    };
  }, []);
  const y = (x) => {
    ux(x) && (h(!0), x.then(function() {
      h(!1, !0), g.apply(void 0, arguments), d.current = !1;
    }, (b) => {
      if (h(!1, !0), d.current = !1, !l?.())
        return Promise.reject(b);
    }));
  }, S = (x) => {
    if (d.current)
      return;
    if (d.current = !0, !u) {
      g();
      return;
    }
    let b;
    if (s) {
      if (b = u(x), c && !ux(b)) {
        d.current = !1, g(x);
        return;
      }
    } else if (u.length)
      b = u(i), d.current = !1;
    else if (b = u(), !ux(b)) {
      g();
      return;
    }
    y(b);
  };
  return /* @__PURE__ */ p.createElement(Nt, Object.assign({}, xz(t), {
    onClick: S,
    loading: m,
    prefixCls: n
  }, a, {
    ref: f
  }), r);
}, dh = /* @__PURE__ */ xe.createContext({}), {
  Provider: Iz
} = dh, wR = () => {
  const {
    autoFocusButton: e,
    cancelButtonProps: t,
    cancelTextLocale: r,
    isSilent: n,
    mergedOkCancel: a,
    rootPrefixCls: i,
    close: o,
    onCancel: s,
    onConfirm: l
  } = Cr(dh);
  return a ? /* @__PURE__ */ xe.createElement(Tz, {
    isSilent: n,
    actionFn: s,
    close: function() {
      o?.apply(void 0, arguments), l?.(!1);
    },
    autoFocus: e === "cancel",
    buttonProps: t,
    prefixCls: `${i}-btn`
  }, r) : null;
}, OR = () => {
  const {
    autoFocusButton: e,
    close: t,
    isSilent: r,
    okButtonProps: n,
    rootPrefixCls: a,
    okTextLocale: i,
    okType: o,
    onConfirm: s,
    onOk: l
  } = Cr(dh);
  return /* @__PURE__ */ xe.createElement(Tz, {
    isSilent: r,
    type: o || "primary",
    actionFn: l,
    close: function() {
      t?.apply(void 0, arguments), s?.(!0);
    },
    autoFocus: e === "ok",
    buttonProps: n,
    prefixCls: `${a}-btn`
  }, i);
};
var Mz = /* @__PURE__ */ p.createContext(null), TR = [];
function eme(e, t) {
  var r = p.useState(function() {
    if (!Ca())
      return null;
    var h = document.createElement("div");
    return process.env.NODE_ENV !== "production" && t && h.setAttribute("data-debug", t), h;
  }), n = ye(r, 1), a = n[0], i = p.useRef(!1), o = p.useContext(Mz), s = p.useState(TR), l = ye(s, 2), c = l[0], u = l[1], d = o || (i.current ? void 0 : function(h) {
    u(function(g) {
      var y = [h].concat(ze(g));
      return y;
    });
  });
  function f() {
    a.parentElement || document.body.appendChild(a), i.current = !0;
  }
  function m() {
    var h;
    (h = a.parentElement) === null || h === void 0 || h.removeChild(a), i.current = !1;
  }
  return hr(function() {
    return e ? o ? o(f) : f() : m(), m;
  }, [e]), hr(function() {
    c.length && (c.forEach(function(h) {
      return h();
    }), u(TR));
  }, [c]), [a, d];
}
var dx;
function Az(e) {
  var t = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7)), r = document.createElement("div");
  r.id = t;
  var n = r.style;
  n.position = "absolute", n.left = "0", n.top = "0", n.width = "100px", n.height = "100px", n.overflow = "scroll";
  var a, i;
  if (e) {
    var o = getComputedStyle(e);
    n.scrollbarColor = o.scrollbarColor, n.scrollbarWidth = o.scrollbarWidth;
    var s = getComputedStyle(e, "::-webkit-scrollbar"), l = parseInt(s.width, 10), c = parseInt(s.height, 10);
    try {
      var u = l ? "width: ".concat(s.width, ";") : "", d = c ? "height: ".concat(s.height, ";") : "";
      ks(`
#`.concat(t, `::-webkit-scrollbar {
`).concat(u, `
`).concat(d, `
}`), t);
    } catch (h) {
      console.error(h), a = l, i = c;
    }
  }
  document.body.appendChild(r);
  var f = e && a && !isNaN(a) ? a : r.offsetWidth - r.clientWidth, m = e && i && !isNaN(i) ? i : r.offsetHeight - r.clientHeight;
  return document.body.removeChild(r), G0(t), {
    width: f,
    height: m
  };
}
function IR(e) {
  return typeof document > "u" ? 0 : (dx === void 0 && (dx = Az()), dx.width);
}
function R2(e) {
  return typeof document > "u" || !e || !(e instanceof Element) ? {
    width: 0,
    height: 0
  } : Az(e);
}
function tme() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var rme = "rc-util-locker-".concat(Date.now()), MR = 0;
function nme(e) {
  var t = !!e, r = p.useState(function() {
    return MR += 1, "".concat(rme, "_").concat(MR);
  }), n = ye(r, 1), a = n[0];
  hr(function() {
    if (t) {
      var i = R2(document.body).width, o = tme();
      ks(`
html body {
  overflow-y: hidden;
  `.concat(o ? "width: calc(100% - ".concat(i, "px);") : "", `
}`), a);
    } else
      G0(a);
    return function() {
      G0(a);
    };
  }, [t, a]);
}
var ame = !1;
function ime(e) {
  return ame;
}
var AR = function(t) {
  return t === !1 ? !1 : !Ca() || !t ? null : typeof t == "string" ? document.querySelector(t) : typeof t == "function" ? t() : t;
}, bd = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.open, n = e.autoLock, a = e.getContainer, i = e.debug, o = e.autoDestroy, s = o === void 0 ? !0 : o, l = e.children, c = p.useState(r), u = ye(c, 2), d = u[0], f = u[1], m = d || r;
  process.env.NODE_ENV !== "production" && jt(Ca() || !r, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), p.useEffect(function() {
    (s || r) && f(r);
  }, [r, s]);
  var h = p.useState(function() {
    return AR(a);
  }), g = ye(h, 2), y = g[0], S = g[1];
  p.useEffect(function() {
    var B = AR(a);
    S(B ?? null);
  });
  var x = eme(m && !y, i), b = ye(x, 2), _ = b[0], $ = b[1], w = y ?? _;
  nme(n && r && Ca() && (w === _ || w === document.body));
  var O = null;
  if (l && No(l) && t) {
    var T = l;
    O = T.ref;
  }
  var I = qs(O, t);
  if (!m || !Ca() || y === void 0)
    return null;
  var P = w === !1 || ime(), D = l;
  return t && (D = /* @__PURE__ */ p.cloneElement(l, {
    ref: I
  })), /* @__PURE__ */ p.createElement(Mz.Provider, {
    value: $
  }, P ? D : /* @__PURE__ */ _F(D, w));
});
process.env.NODE_ENV !== "production" && (bd.displayName = "Portal");
var Pz = /* @__PURE__ */ p.createContext({});
function ome() {
  var e = ce({}, p);
  return e.useId;
}
var PR = 0, RR = ome();
const Rz = RR ? (
  // Use React `useId`
  function(t) {
    var r = RR();
    return t || (process.env.NODE_ENV === "test" ? "test-id" : r);
  }
) : (
  // Use compatible of `useId`
  function(t) {
    var r = p.useState("ssr-id"), n = ye(r, 2), a = n[0], i = n[1];
    return p.useEffect(function() {
      var o = PR;
      PR += 1, i("rc_unique_".concat(o));
    }, []), t || (process.env.NODE_ENV === "test" ? "test-id" : a);
  }
);
function NR(e, t, r) {
  var n = t;
  return !n && r && (n = "".concat(e, "-").concat(r)), n;
}
function DR(e, t) {
  var r = e["page".concat(t ? "Y" : "X", "Offset")], n = "scroll".concat(t ? "Top" : "Left");
  if (typeof r != "number") {
    var a = e.document;
    r = a.documentElement[n], typeof r != "number" && (r = a.body[n]);
  }
  return r;
}
function sme(e) {
  var t = e.getBoundingClientRect(), r = {
    left: t.left,
    top: t.top
  }, n = e.ownerDocument, a = n.defaultView || n.parentWindow;
  return r.left += DR(a), r.top += DR(a, !0), r;
}
const lme = /* @__PURE__ */ p.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  var r = t.shouldUpdate;
  return !r;
});
var jR = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none"
}, cme = {
  outline: "none"
}, kT = /* @__PURE__ */ xe.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.className, a = e.style, i = e.title, o = e.ariaId, s = e.footer, l = e.closable, c = e.closeIcon, u = e.onClose, d = e.children, f = e.bodyStyle, m = e.bodyProps, h = e.modalRender, g = e.onMouseDown, y = e.onMouseUp, S = e.holderRef, x = e.visible, b = e.forceRender, _ = e.width, $ = e.height, w = e.classNames, O = e.styles, T = xe.useContext(Pz), I = T.panel, P = qs(S, I), D = ct(), B = ct(), L = ct();
  xe.useImperativeHandle(t, function() {
    return {
      focus: function() {
        var Z;
        (Z = L.current) === null || Z === void 0 || Z.focus({
          preventScroll: !0
        });
      },
      changeActive: function(Z) {
        var ee = document, ae = ee.activeElement;
        Z && ae === B.current ? D.current.focus({
          preventScroll: !0
        }) : !Z && ae === D.current && B.current.focus({
          preventScroll: !0
        });
      }
    };
  });
  var N = {};
  _ !== void 0 && (N.width = _), $ !== void 0 && (N.height = $);
  var z = s ? /* @__PURE__ */ xe.createElement("div", {
    className: be("".concat(r, "-footer"), w?.footer),
    style: ce({}, O?.footer)
  }, s) : null, F = i ? /* @__PURE__ */ xe.createElement("div", {
    className: be("".concat(r, "-header"), w?.header),
    style: ce({}, O?.header)
  }, /* @__PURE__ */ xe.createElement("div", {
    className: "".concat(r, "-title"),
    id: o
  }, i)) : null, j = dr(function() {
    return kt(l) === "object" && l !== null ? l : l ? {
      closeIcon: c ?? /* @__PURE__ */ xe.createElement("span", {
        className: "".concat(r, "-close-x")
      })
    } : {};
  }, [l, c, r]), H = aa(j, !0), U = kt(l) === "object" && l.disabled, G = l ? /* @__PURE__ */ xe.createElement("button", Pe({
    type: "button",
    onClick: u,
    "aria-label": "Close"
  }, H, {
    className: "".concat(r, "-close"),
    disabled: U
  }), j.closeIcon) : null, V = /* @__PURE__ */ xe.createElement("div", {
    className: be("".concat(r, "-content"), w?.content),
    style: O?.content
  }, G, F, /* @__PURE__ */ xe.createElement("div", Pe({
    className: be("".concat(r, "-body"), w?.body),
    style: ce(ce({}, f), O?.body)
  }, m), d), z);
  return /* @__PURE__ */ xe.createElement("div", {
    key: "dialog-element",
    role: "dialog",
    "aria-labelledby": i ? o : null,
    "aria-modal": "true",
    ref: P,
    style: ce(ce({}, a), N),
    className: be(r, n),
    onMouseDown: g,
    onMouseUp: y
  }, /* @__PURE__ */ xe.createElement("div", {
    tabIndex: 0,
    ref: D,
    style: jR,
    "aria-hidden": "true"
  }), /* @__PURE__ */ xe.createElement("div", {
    ref: L,
    tabIndex: -1,
    style: cme
  }, /* @__PURE__ */ xe.createElement(lme, {
    shouldUpdate: x || b
  }, h ? h(V) : V)), /* @__PURE__ */ xe.createElement("div", {
    tabIndex: 0,
    ref: B,
    style: jR,
    "aria-hidden": "true"
  }));
});
process.env.NODE_ENV !== "production" && (kT.displayName = "Panel");
var Nz = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.title, a = e.style, i = e.className, o = e.visible, s = e.forceRender, l = e.destroyOnClose, c = e.motionName, u = e.ariaId, d = e.onVisibleChanged, f = e.mousePosition, m = ct(), h = p.useState(), g = ye(h, 2), y = g[0], S = g[1], x = {};
  y && (x.transformOrigin = y);
  function b() {
    var _ = sme(m.current);
    S(f && (f.x || f.y) ? "".concat(f.x - _.left, "px ").concat(f.y - _.top, "px") : "");
  }
  return /* @__PURE__ */ p.createElement(Ci, {
    visible: o,
    onVisibleChanged: d,
    onAppearPrepare: b,
    onEnterPrepare: b,
    forceRender: s,
    motionName: c,
    removeOnLeave: l,
    ref: m
  }, function(_, $) {
    var w = _.className, O = _.style;
    return /* @__PURE__ */ p.createElement(kT, Pe({}, e, {
      ref: t,
      title: n,
      ariaId: u,
      prefixCls: r,
      holderRef: $,
      style: ce(ce(ce({}, O), a), x),
      className: be(i, w)
    }));
  });
});
Nz.displayName = "Content";
var ume = function(t) {
  var r = t.prefixCls, n = t.style, a = t.visible, i = t.maskProps, o = t.motionName, s = t.className;
  return /* @__PURE__ */ p.createElement(Ci, {
    key: "mask",
    visible: a,
    motionName: o,
    leavedClassName: "".concat(r, "-mask-hidden")
  }, function(l, c) {
    var u = l.className, d = l.style;
    return /* @__PURE__ */ p.createElement("div", Pe({
      ref: c,
      style: ce(ce({}, d), n),
      className: be("".concat(r, "-mask"), u, s)
    }, i));
  });
}, dme = function(t) {
  var r = t.prefixCls, n = r === void 0 ? "rc-dialog" : r, a = t.zIndex, i = t.visible, o = i === void 0 ? !1 : i, s = t.keyboard, l = s === void 0 ? !0 : s, c = t.focusTriggerAfterClose, u = c === void 0 ? !0 : c, d = t.wrapStyle, f = t.wrapClassName, m = t.wrapProps, h = t.onClose, g = t.afterOpenChange, y = t.afterClose, S = t.transitionName, x = t.animation, b = t.closable, _ = b === void 0 ? !0 : b, $ = t.mask, w = $ === void 0 ? !0 : $, O = t.maskTransitionName, T = t.maskAnimation, I = t.maskClosable, P = I === void 0 ? !0 : I, D = t.maskStyle, B = t.maskProps, L = t.rootClassName, N = t.classNames, z = t.styles;
  process.env.NODE_ENV !== "production" && (["wrapStyle", "bodyStyle", "maskStyle"].forEach(function(me) {
    ls(!(me in t), "".concat(me, " is deprecated, please use styles instead."));
  }), "wrapClassName" in t && ls(!1, "wrapClassName is deprecated, please use classNames instead."));
  var F = ct(), j = ct(), H = ct(), U = p.useState(o), G = ye(U, 2), V = G[0], K = G[1], Z = Rz();
  function ee() {
    l2(j.current, document.activeElement) || (F.current = document.activeElement);
  }
  function ae() {
    if (!l2(j.current, document.activeElement)) {
      var me;
      (me = H.current) === null || me === void 0 || me.focus();
    }
  }
  function ue(me) {
    if (me)
      ae();
    else {
      if (K(!1), w && F.current && u) {
        try {
          F.current.focus({
            preventScroll: !0
          });
        } catch {
        }
        F.current = null;
      }
      V && y?.();
    }
    g?.(me);
  }
  function re(me) {
    h?.(me);
  }
  var oe = ct(!1), fe = ct(), le = function() {
    clearTimeout(fe.current), oe.current = !0;
  }, se = function() {
    fe.current = setTimeout(function() {
      oe.current = !1;
    });
  }, Q = null;
  P && (Q = function(k) {
    oe.current ? oe.current = !1 : j.current === k.target && re(k);
  });
  function he(me) {
    if (l && me.keyCode === Mt.ESC) {
      me.stopPropagation(), re(me);
      return;
    }
    o && me.keyCode === Mt.TAB && H.current.changeActive(!me.shiftKey);
  }
  St(function() {
    o && (K(!0), ee());
  }, [o]), St(function() {
    return function() {
      clearTimeout(fe.current);
    };
  }, []);
  var ne = ce(ce(ce({
    zIndex: a
  }, d), z?.wrapper), {}, {
    display: V ? null : "none"
  });
  return /* @__PURE__ */ p.createElement("div", Pe({
    className: be("".concat(n, "-root"), L)
  }, aa(t, {
    data: !0
  })), /* @__PURE__ */ p.createElement(ume, {
    prefixCls: n,
    visible: w && o,
    motionName: NR(n, O, T),
    style: ce(ce({
      zIndex: a
    }, D), z?.mask),
    maskProps: B,
    className: N?.mask
  }), /* @__PURE__ */ p.createElement("div", Pe({
    tabIndex: -1,
    onKeyDown: he,
    className: be("".concat(n, "-wrap"), f, N?.wrapper),
    ref: j,
    onClick: Q,
    style: ne
  }, m), /* @__PURE__ */ p.createElement(Nz, Pe({}, t, {
    onMouseDown: le,
    onMouseUp: se,
    ref: H,
    closable: _,
    ariaId: Z,
    prefixCls: n,
    visible: o && V,
    onClose: re,
    onVisibleChanged: ue,
    motionName: NR(n, S, x)
  }))));
}, FT = function(t) {
  var r = t.visible, n = t.getContainer, a = t.forceRender, i = t.destroyOnClose, o = i === void 0 ? !1 : i, s = t.afterClose, l = t.panelRef, c = p.useState(r), u = ye(c, 2), d = u[0], f = u[1], m = p.useMemo(function() {
    return {
      panel: l
    };
  }, [l]);
  return p.useEffect(function() {
    r && f(!0);
  }, [r]), !a && o && !d ? null : /* @__PURE__ */ p.createElement(Pz.Provider, {
    value: m
  }, /* @__PURE__ */ p.createElement(bd, {
    open: r || a || d,
    autoDestroy: !1,
    getContainer: n,
    autoLock: r || d
  }, /* @__PURE__ */ p.createElement(dme, Pe({}, t, {
    destroyOnClose: o,
    afterClose: function() {
      s?.(), f(!1);
    }
  }))));
};
FT.displayName = "Dialog";
function sd(e) {
  if (e)
    return {
      closable: e.closable,
      closeIcon: e.closeIcon
    };
}
function LR(e) {
  const {
    closable: t,
    closeIcon: r
  } = e || {};
  return xe.useMemo(() => {
    if (
      // If `closable`, whatever rest be should be true
      !t && (t === !1 || r === !1 || r === null)
    )
      return !1;
    if (t === void 0 && r === void 0)
      return null;
    let n = {
      closeIcon: typeof r != "boolean" && r !== null ? r : void 0
    };
    return t && typeof t == "object" && (n = Object.assign(Object.assign({}, n), t)), n;
  }, [t, r]);
}
function kR() {
  const e = {};
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return r.forEach((a) => {
    a && Object.keys(a).forEach((i) => {
      a[i] !== void 0 && (e[i] = a[i]);
    });
  }), e;
}
const fme = {};
function BT(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : fme;
  const n = LR(e), a = LR(t), i = xe.useMemo(() => Object.assign({
    closeIcon: /* @__PURE__ */ xe.createElement(Ys, null)
  }, r), [r]), o = xe.useMemo(() => n === !1 ? !1 : n ? kR(i, a, n) : a === !1 ? !1 : a ? kR(i, a) : i.closable ? i : !1, [n, a, i]);
  return xe.useMemo(() => {
    if (o === !1)
      return [!1, null];
    const {
      closeIconRender: s
    } = i, {
      closeIcon: l
    } = o;
    let c = l;
    if (c != null) {
      s && (c = s(l));
      const u = aa(o, !0);
      Object.keys(u).length && (c = /* @__PURE__ */ xe.isValidElement(c) ? /* @__PURE__ */ xe.cloneElement(c, u) : /* @__PURE__ */ xe.createElement("span", Object.assign({}, u), c));
    }
    return [!0, c];
  }, [o, i]);
}
var Dz = function(t) {
  if (Ca() && window.document.documentElement) {
    var r = Array.isArray(t) ? t : [t], n = window.document.documentElement;
    return r.some(function(a) {
      return a in n.style;
    });
  }
  return !1;
}, pme = function(t, r) {
  if (!Dz(t))
    return !1;
  var n = document.createElement("div"), a = n.style[t];
  return n.style[t] = r, n.style[t] !== a;
};
function N2(e, t) {
  return !Array.isArray(e) && t !== void 0 ? pme(e, t) : Dz(e);
}
const mme = () => Ca() && window.document.documentElement;
var uc = "RC_FORM_INTERNAL_HOOKS", yn = function() {
  jt(!1, "Can not find FormContext. Please make sure you wrap Field under Form.");
}, $c = /* @__PURE__ */ p.createContext({
  getFieldValue: yn,
  getFieldsValue: yn,
  getFieldError: yn,
  getFieldWarning: yn,
  getFieldsError: yn,
  isFieldsTouched: yn,
  isFieldTouched: yn,
  isFieldValidating: yn,
  isFieldsValidating: yn,
  resetFields: yn,
  setFields: yn,
  setFieldValue: yn,
  setFieldsValue: yn,
  validateFields: yn,
  submit: yn,
  getInternalHooks: function() {
    return yn(), {
      dispatch: yn,
      initEntityValue: yn,
      registerField: yn,
      useSubscribe: yn,
      setInitialValues: yn,
      destroyForm: yn,
      setCallbacks: yn,
      registerWatch: yn,
      getFields: yn,
      setValidateMessages: yn,
      setPreserve: yn,
      getInitialValue: yn
    };
  }
}), Y0 = /* @__PURE__ */ p.createContext(null);
function D2(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function vme(e) {
  return e && !!e._init;
}
function j2() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var t = JSON.parse(JSON.stringify(this));
      return t.clone = this.clone, t;
    }
  };
}
var L2 = j2();
function hme(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function gme(e, t, r) {
  if (yT()) return Reflect.construct.apply(null, arguments);
  var n = [null];
  n.push.apply(n, t);
  var a = new (e.bind.apply(e, n))();
  return r && z0(a, r.prototype), a;
}
function k2(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return k2 = function(n) {
    if (n === null || !hme(n)) return n;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(n)) return t.get(n);
      t.set(n, a);
    }
    function a() {
      return gme(n, arguments, H0(this).constructor);
    }
    return a.prototype = Object.create(n.prototype, {
      constructor: {
        value: a,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), z0(a, n);
  }, k2(e);
}
var yme = /%[sdj%]/g, jz = function() {
};
typeof process < "u" && process.env && process.env.NODE_ENV !== "production" && typeof window < "u" && typeof document < "u" && (jz = function(t, r) {
  typeof console < "u" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING > "u" && r.every(function(n) {
    return typeof n == "string";
  }) && console.warn(t, r);
});
function F2(e) {
  if (!e || !e.length) return null;
  var t = {};
  return e.forEach(function(r) {
    var n = r.field;
    t[n] = t[n] || [], t[n].push(r);
  }), t;
}
function zi(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  var a = 0, i = r.length;
  if (typeof e == "function")
    return e.apply(null, r);
  if (typeof e == "string") {
    var o = e.replace(yme, function(s) {
      if (s === "%%")
        return "%";
      if (a >= i)
        return s;
      switch (s) {
        case "%s":
          return String(r[a++]);
        case "%d":
          return Number(r[a++]);
        case "%j":
          try {
            return JSON.stringify(r[a++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return s;
      }
    });
    return o;
  }
  return e;
}
function bme(e) {
  return e === "string" || e === "url" || e === "hex" || e === "email" || e === "date" || e === "pattern";
}
function Sa(e, t) {
  return !!(e == null || t === "array" && Array.isArray(e) && !e.length || bme(t) && typeof e == "string" && !e);
}
function Cme(e, t, r) {
  var n = [], a = 0, i = e.length;
  function o(s) {
    n.push.apply(n, ze(s || [])), a++, a === i && r(n);
  }
  e.forEach(function(s) {
    t(s, o);
  });
}
function FR(e, t, r) {
  var n = 0, a = e.length;
  function i(o) {
    if (o && o.length) {
      r(o);
      return;
    }
    var s = n;
    n = n + 1, s < a ? t(e[s], i) : r([]);
  }
  i([]);
}
function Sme(e) {
  var t = [];
  return Object.keys(e).forEach(function(r) {
    t.push.apply(t, ze(e[r] || []));
  }), t;
}
var BR = /* @__PURE__ */ function(e) {
  ds(r, e);
  var t = fs(r);
  function r(n, a) {
    var i;
    return Hn(this, r), i = t.call(this, "Async Validation Error"), te(at(i), "errors", void 0), te(at(i), "fields", void 0), i.errors = n, i.fields = a, i;
  }
  return Vn(r);
}(/* @__PURE__ */ k2(Error));
function xme(e, t, r, n, a) {
  if (t.first) {
    var i = new Promise(function(f, m) {
      var h = function(S) {
        return n(S), S.length ? m(new BR(S, F2(S))) : f(a);
      }, g = Sme(e);
      FR(g, r, h);
    });
    return i.catch(function(f) {
      return f;
    }), i;
  }
  var o = t.firstFields === !0 ? Object.keys(e) : t.firstFields || [], s = Object.keys(e), l = s.length, c = 0, u = [], d = new Promise(function(f, m) {
    var h = function(y) {
      if (u.push.apply(u, y), c++, c === l)
        return n(u), u.length ? m(new BR(u, F2(u))) : f(a);
    };
    s.length || (n(u), f(a)), s.forEach(function(g) {
      var y = e[g];
      o.indexOf(g) !== -1 ? FR(y, r, h) : Cme(y, r, h);
    });
  });
  return d.catch(function(f) {
    return f;
  }), d;
}
function $me(e) {
  return !!(e && e.message !== void 0);
}
function _me(e, t) {
  for (var r = e, n = 0; n < t.length; n++) {
    if (r == null)
      return r;
    r = r[t[n]];
  }
  return r;
}
function zR(e, t) {
  return function(r) {
    var n;
    return e.fullFields ? n = _me(t, e.fullFields) : n = t[r.field || e.fullField], $me(r) ? (r.field = r.field || e.fullField, r.fieldValue = n, r) : {
      message: typeof r == "function" ? r() : r,
      fieldValue: n,
      field: r.field || e.fullField
    };
  };
}
function HR(e, t) {
  if (t) {
    for (var r in t)
      if (t.hasOwnProperty(r)) {
        var n = t[r];
        kt(n) === "object" && kt(e[r]) === "object" ? e[r] = ce(ce({}, e[r]), n) : e[r] = n;
      }
  }
  return e;
}
var vu = "enum", Eme = function(t, r, n, a, i) {
  t[vu] = Array.isArray(t[vu]) ? t[vu] : [], t[vu].indexOf(r) === -1 && a.push(zi(i.messages[vu], t.fullField, t[vu].join(", ")));
}, wme = function(t, r, n, a, i) {
  if (t.pattern) {
    if (t.pattern instanceof RegExp)
      t.pattern.lastIndex = 0, t.pattern.test(r) || a.push(zi(i.messages.pattern.mismatch, t.fullField, r, t.pattern));
    else if (typeof t.pattern == "string") {
      var o = new RegExp(t.pattern);
      o.test(r) || a.push(zi(i.messages.pattern.mismatch, t.fullField, r, t.pattern));
    }
  }
}, Ome = function(t, r, n, a, i) {
  var o = typeof t.len == "number", s = typeof t.min == "number", l = typeof t.max == "number", c = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, u = r, d = null, f = typeof r == "number", m = typeof r == "string", h = Array.isArray(r);
  if (f ? d = "number" : m ? d = "string" : h && (d = "array"), !d)
    return !1;
  h && (u = r.length), m && (u = r.replace(c, "_").length), o ? u !== t.len && a.push(zi(i.messages[d].len, t.fullField, t.len)) : s && !l && u < t.min ? a.push(zi(i.messages[d].min, t.fullField, t.min)) : l && !s && u > t.max ? a.push(zi(i.messages[d].max, t.fullField, t.max)) : s && l && (u < t.min || u > t.max) && a.push(zi(i.messages[d].range, t.fullField, t.min, t.max));
}, Lz = function(t, r, n, a, i, o) {
  t.required && (!n.hasOwnProperty(t.field) || Sa(r, o || t.type)) && a.push(zi(i.messages.required, t.fullField));
}, Xg;
const Tme = function() {
  if (Xg)
    return Xg;
  var e = "[a-fA-F\\d:]", t = function(w) {
    return w && w.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(e, ")|(?<=").concat(e, ")(?=\\s|$))") : "";
  }, r = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", n = "[a-fA-F\\d]{1,4}", a = [
    "(?:".concat(n, ":){7}(?:").concat(n, "|:)"),
    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
    "(?:".concat(n, ":){6}(?:").concat(r, "|:").concat(n, "|:)"),
    // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::
    "(?:".concat(n, ":){5}(?::").concat(r, "|(?::").concat(n, "){1,2}|:)"),
    // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::
    "(?:".concat(n, ":){4}(?:(?::").concat(n, "){0,1}:").concat(r, "|(?::").concat(n, "){1,3}|:)"),
    // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::
    "(?:".concat(n, ":){3}(?:(?::").concat(n, "){0,2}:").concat(r, "|(?::").concat(n, "){1,4}|:)"),
    // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::
    "(?:".concat(n, ":){2}(?:(?::").concat(n, "){0,3}:").concat(r, "|(?::").concat(n, "){1,5}|:)"),
    // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::
    "(?:".concat(n, ":){1}(?:(?::").concat(n, "){0,4}:").concat(r, "|(?::").concat(n, "){1,6}|:)"),
    // 1::              1::3:4:5:6:7:8   1::8            1::
    "(?::(?:(?::".concat(n, "){0,5}:").concat(r, "|(?::").concat(n, "){1,7}|:))")
    // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
  ], i = "(?:%[0-9a-zA-Z]{1,})?", o = "(?:".concat(a.join("|"), ")").concat(i), s = new RegExp("(?:^".concat(r, "$)|(?:^").concat(o, "$)")), l = new RegExp("^".concat(r, "$")), c = new RegExp("^".concat(o, "$")), u = function(w) {
    return w && w.exact ? s : new RegExp("(?:".concat(t(w)).concat(r).concat(t(w), ")|(?:").concat(t(w)).concat(o).concat(t(w), ")"), "g");
  };
  u.v4 = function($) {
    return $ && $.exact ? l : new RegExp("".concat(t($)).concat(r).concat(t($)), "g");
  }, u.v6 = function($) {
    return $ && $.exact ? c : new RegExp("".concat(t($)).concat(o).concat(t($)), "g");
  };
  var d = "(?:(?:[a-z]+:)?//)", f = "(?:\\S+(?::\\S*)?@)?", m = u.v4().source, h = u.v6().source, g = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", y = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", S = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", x = "(?::\\d{2,5})?", b = '(?:[/?#][^\\s"]*)?', _ = "(?:".concat(d, "|www\\.)").concat(f, "(?:localhost|").concat(m, "|").concat(h, "|").concat(g).concat(y).concat(S, ")").concat(x).concat(b);
  return Xg = new RegExp("(?:^".concat(_, "$)"), "i"), Xg;
};
var VR = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, $0 = {
  integer: function(t) {
    return $0.number(t) && parseInt(t, 10) === t;
  },
  float: function(t) {
    return $0.number(t) && !$0.integer(t);
  },
  array: function(t) {
    return Array.isArray(t);
  },
  regexp: function(t) {
    if (t instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(t);
    } catch {
      return !1;
    }
  },
  date: function(t) {
    return typeof t.getTime == "function" && typeof t.getMonth == "function" && typeof t.getYear == "function" && !isNaN(t.getTime());
  },
  number: function(t) {
    return isNaN(t) ? !1 : typeof t == "number";
  },
  object: function(t) {
    return kt(t) === "object" && !$0.array(t);
  },
  method: function(t) {
    return typeof t == "function";
  },
  email: function(t) {
    return typeof t == "string" && t.length <= 320 && !!t.match(VR.email);
  },
  url: function(t) {
    return typeof t == "string" && t.length <= 2048 && !!t.match(Tme());
  },
  hex: function(t) {
    return typeof t == "string" && !!t.match(VR.hex);
  }
}, Ime = function(t, r, n, a, i) {
  if (t.required && r === void 0) {
    Lz(t, r, n, a, i);
    return;
  }
  var o = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], s = t.type;
  o.indexOf(s) > -1 ? $0[s](r) || a.push(zi(i.messages.types[s], t.fullField, t.type)) : s && kt(r) !== t.type && a.push(zi(i.messages.types[s], t.fullField, t.type));
}, Mme = function(t, r, n, a, i) {
  (/^\s+$/.test(r) || r === "") && a.push(zi(i.messages.whitespace, t.fullField));
};
const Vr = {
  required: Lz,
  whitespace: Mme,
  type: Ime,
  range: Ome,
  enum: Eme,
  pattern: wme
};
var Ame = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Sa(r) && !t.required)
      return n();
    Vr.required(t, r, a, o, i);
  }
  n(o);
}, Pme = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (r == null && !t.required)
      return n();
    Vr.required(t, r, a, o, i, "array"), r != null && (Vr.type(t, r, a, o, i), Vr.range(t, r, a, o, i));
  }
  n(o);
}, Rme = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Sa(r) && !t.required)
      return n();
    Vr.required(t, r, a, o, i), r !== void 0 && Vr.type(t, r, a, o, i);
  }
  n(o);
}, Nme = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Sa(r, "date") && !t.required)
      return n();
    if (Vr.required(t, r, a, o, i), !Sa(r, "date")) {
      var l;
      r instanceof Date ? l = r : l = new Date(r), Vr.type(t, l, a, o, i), l && Vr.range(t, l.getTime(), a, o, i);
    }
  }
  n(o);
}, Dme = "enum", jme = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Sa(r) && !t.required)
      return n();
    Vr.required(t, r, a, o, i), r !== void 0 && Vr[Dme](t, r, a, o, i);
  }
  n(o);
}, Lme = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Sa(r) && !t.required)
      return n();
    Vr.required(t, r, a, o, i), r !== void 0 && (Vr.type(t, r, a, o, i), Vr.range(t, r, a, o, i));
  }
  n(o);
}, kme = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Sa(r) && !t.required)
      return n();
    Vr.required(t, r, a, o, i), r !== void 0 && (Vr.type(t, r, a, o, i), Vr.range(t, r, a, o, i));
  }
  n(o);
}, Fme = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Sa(r) && !t.required)
      return n();
    Vr.required(t, r, a, o, i), r !== void 0 && Vr.type(t, r, a, o, i);
  }
  n(o);
}, Bme = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (r === "" && (r = void 0), Sa(r) && !t.required)
      return n();
    Vr.required(t, r, a, o, i), r !== void 0 && (Vr.type(t, r, a, o, i), Vr.range(t, r, a, o, i));
  }
  n(o);
}, zme = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Sa(r) && !t.required)
      return n();
    Vr.required(t, r, a, o, i), r !== void 0 && Vr.type(t, r, a, o, i);
  }
  n(o);
}, Hme = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Sa(r, "string") && !t.required)
      return n();
    Vr.required(t, r, a, o, i), Sa(r, "string") || Vr.pattern(t, r, a, o, i);
  }
  n(o);
}, Vme = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Sa(r) && !t.required)
      return n();
    Vr.required(t, r, a, o, i), Sa(r) || Vr.type(t, r, a, o, i);
  }
  n(o);
}, Gme = function(t, r, n, a, i) {
  var o = [], s = Array.isArray(r) ? "array" : kt(r);
  Vr.required(t, r, a, o, i, s), n(o);
}, Ume = function(t, r, n, a, i) {
  var o = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Sa(r, "string") && !t.required)
      return n();
    Vr.required(t, r, a, o, i, "string"), Sa(r, "string") || (Vr.type(t, r, a, o, i), Vr.range(t, r, a, o, i), Vr.pattern(t, r, a, o, i), t.whitespace === !0 && Vr.whitespace(t, r, a, o, i));
  }
  n(o);
}, fx = function(t, r, n, a, i) {
  var o = t.type, s = [], l = t.required || !t.required && a.hasOwnProperty(t.field);
  if (l) {
    if (Sa(r, o) && !t.required)
      return n();
    Vr.required(t, r, a, s, i, o), Sa(r, o) || Vr.type(t, r, a, s, i);
  }
  n(s);
};
const P0 = {
  string: Ume,
  method: Fme,
  number: Bme,
  boolean: Rme,
  regexp: Vme,
  integer: kme,
  float: Lme,
  array: Pme,
  object: zme,
  enum: jme,
  pattern: Hme,
  date: Nme,
  url: fx,
  hex: fx,
  email: fx,
  required: Gme,
  any: Ame
};
var fh = /* @__PURE__ */ function() {
  function e(t) {
    Hn(this, e), te(this, "rules", null), te(this, "_messages", L2), this.define(t);
  }
  return Vn(e, [{
    key: "define",
    value: function(r) {
      var n = this;
      if (!r)
        throw new Error("Cannot configure a schema with no rules");
      if (kt(r) !== "object" || Array.isArray(r))
        throw new Error("Rules must be an object");
      this.rules = {}, Object.keys(r).forEach(function(a) {
        var i = r[a];
        n.rules[a] = Array.isArray(i) ? i : [i];
      });
    }
  }, {
    key: "messages",
    value: function(r) {
      return r && (this._messages = HR(j2(), r)), this._messages;
    }
  }, {
    key: "validate",
    value: function(r) {
      var n = this, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
      }, o = r, s = a, l = i;
      if (typeof s == "function" && (l = s, s = {}), !this.rules || Object.keys(this.rules).length === 0)
        return l && l(null, o), Promise.resolve(o);
      function c(h) {
        var g = [], y = {};
        function S(b) {
          if (Array.isArray(b)) {
            var _;
            g = (_ = g).concat.apply(_, ze(b));
          } else
            g.push(b);
        }
        for (var x = 0; x < h.length; x++)
          S(h[x]);
        g.length ? (y = F2(g), l(g, y)) : l(null, o);
      }
      if (s.messages) {
        var u = this.messages();
        u === L2 && (u = j2()), HR(u, s.messages), s.messages = u;
      } else
        s.messages = this.messages();
      var d = {}, f = s.keys || Object.keys(this.rules);
      f.forEach(function(h) {
        var g = n.rules[h], y = o[h];
        g.forEach(function(S) {
          var x = S;
          typeof x.transform == "function" && (o === r && (o = ce({}, o)), y = o[h] = x.transform(y), y != null && (x.type = x.type || (Array.isArray(y) ? "array" : kt(y)))), typeof x == "function" ? x = {
            validator: x
          } : x = ce({}, x), x.validator = n.getValidationMethod(x), x.validator && (x.field = h, x.fullField = x.fullField || h, x.type = n.getType(x), d[h] = d[h] || [], d[h].push({
            rule: x,
            value: y,
            source: o,
            field: h
          }));
        });
      });
      var m = {};
      return xme(d, s, function(h, g) {
        var y = h.rule, S = (y.type === "object" || y.type === "array") && (kt(y.fields) === "object" || kt(y.defaultField) === "object");
        S = S && (y.required || !y.required && h.value), y.field = h.field;
        function x(O, T) {
          return ce(ce({}, T), {}, {
            fullField: "".concat(y.fullField, ".").concat(O),
            fullFields: y.fullFields ? [].concat(ze(y.fullFields), [O]) : [O]
          });
        }
        function b() {
          var O = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], T = Array.isArray(O) ? O : [O];
          !s.suppressWarning && T.length && e.warning("async-validator:", T), T.length && y.message !== void 0 && (T = [].concat(y.message));
          var I = T.map(zR(y, o));
          if (s.first && I.length)
            return m[y.field] = 1, g(I);
          if (!S)
            g(I);
          else {
            if (y.required && !h.value)
              return y.message !== void 0 ? I = [].concat(y.message).map(zR(y, o)) : s.error && (I = [s.error(y, zi(s.messages.required, y.field))]), g(I);
            var P = {};
            y.defaultField && Object.keys(h.value).map(function(L) {
              P[L] = y.defaultField;
            }), P = ce(ce({}, P), h.rule.fields);
            var D = {};
            Object.keys(P).forEach(function(L) {
              var N = P[L], z = Array.isArray(N) ? N : [N];
              D[L] = z.map(x.bind(null, L));
            });
            var B = new e(D);
            B.messages(s.messages), h.rule.options && (h.rule.options.messages = s.messages, h.rule.options.error = s.error), B.validate(h.value, h.rule.options || s, function(L) {
              var N = [];
              I && I.length && N.push.apply(N, ze(I)), L && L.length && N.push.apply(N, ze(L)), g(N.length ? N : null);
            });
          }
        }
        var _;
        if (y.asyncValidator)
          _ = y.asyncValidator(y, h.value, b, h.source, s);
        else if (y.validator) {
          try {
            _ = y.validator(y, h.value, b, h.source, s);
          } catch (O) {
            var $, w;
            ($ = (w = console).error) === null || $ === void 0 || $.call(w, O), s.suppressValidatorError || setTimeout(function() {
              throw O;
            }, 0), b(O.message);
          }
          _ === !0 ? b() : _ === !1 ? b(typeof y.message == "function" ? y.message(y.fullField || y.field) : y.message || "".concat(y.fullField || y.field, " fails")) : _ instanceof Array ? b(_) : _ instanceof Error && b(_.message);
        }
        _ && _.then && _.then(function() {
          return b();
        }, function(O) {
          return b(O);
        });
      }, function(h) {
        c(h);
      }, o);
    }
  }, {
    key: "getType",
    value: function(r) {
      if (r.type === void 0 && r.pattern instanceof RegExp && (r.type = "pattern"), typeof r.validator != "function" && r.type && !P0.hasOwnProperty(r.type))
        throw new Error(zi("Unknown rule type %s", r.type));
      return r.type || "string";
    }
  }, {
    key: "getValidationMethod",
    value: function(r) {
      if (typeof r.validator == "function")
        return r.validator;
      var n = Object.keys(r), a = n.indexOf("message");
      return a !== -1 && n.splice(a, 1), n.length === 1 && n[0] === "required" ? P0.required : P0[this.getType(r)] || void 0;
    }
  }]), e;
}();
te(fh, "register", function(t, r) {
  if (typeof r != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  P0[t] = r;
});
te(fh, "warning", jz);
te(fh, "messages", L2);
te(fh, "validators", P0);
var Di = "'${name}' is not a valid ${type}", kz = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: Di,
    method: Di,
    array: Di,
    object: Di,
    number: Di,
    date: Di,
    boolean: Di,
    integer: Di,
    float: Di,
    regexp: Di,
    email: Di,
    url: Di,
    hex: Di
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
}, GR = fh;
function Wme(e, t) {
  return e.replace(/\$\{\w+\}/g, function(r) {
    var n = r.slice(2, -1);
    return t[n];
  });
}
var UR = "CODE_LOGIC_ERROR";
function B2(e, t, r, n, a) {
  return z2.apply(this, arguments);
}
function z2() {
  return z2 = jc(/* @__PURE__ */ ai().mark(function e(t, r, n, a, i) {
    var o, s, l, c, u, d, f, m, h;
    return ai().wrap(function(y) {
      for (; ; ) switch (y.prev = y.next) {
        case 0:
          return o = ce({}, n), delete o.ruleIndex, GR.warning = function() {
          }, o.validator && (s = o.validator, o.validator = function() {
            try {
              return s.apply(void 0, arguments);
            } catch (S) {
              return console.error(S), Promise.reject(UR);
            }
          }), l = null, o && o.type === "array" && o.defaultField && (l = o.defaultField, delete o.defaultField), c = new GR(te({}, t, [o])), u = Yu(kz, a.validateMessages), c.messages(u), d = [], y.prev = 10, y.next = 13, Promise.resolve(c.validate(te({}, t, r), ce({}, a)));
        case 13:
          y.next = 18;
          break;
        case 15:
          y.prev = 15, y.t0 = y.catch(10), y.t0.errors && (d = y.t0.errors.map(function(S, x) {
            var b = S.message, _ = b === UR ? u.default : b;
            return /* @__PURE__ */ p.isValidElement(_) ? (
              // Wrap ReactNode with `key`
              /* @__PURE__ */ p.cloneElement(_, {
                key: "error_".concat(x)
              })
            ) : _;
          }));
        case 18:
          if (!(!d.length && l)) {
            y.next = 23;
            break;
          }
          return y.next = 21, Promise.all(r.map(function(S, x) {
            return B2("".concat(t, ".").concat(x), S, l, a, i);
          }));
        case 21:
          return f = y.sent, y.abrupt("return", f.reduce(function(S, x) {
            return [].concat(ze(S), ze(x));
          }, []));
        case 23:
          return m = ce(ce({}, n), {}, {
            name: t,
            enum: (n.enum || []).join(", ")
          }, i), h = d.map(function(S) {
            return typeof S == "string" ? Wme(S, m) : S;
          }), y.abrupt("return", h);
        case 26:
        case "end":
          return y.stop();
      }
    }, e, null, [[10, 15]]);
  })), z2.apply(this, arguments);
}
function qme(e, t, r, n, a, i) {
  var o = e.join("."), s = r.map(function(u, d) {
    var f = u.validator, m = ce(ce({}, u), {}, {
      ruleIndex: d
    });
    return f && (m.validator = function(h, g, y) {
      var S = !1, x = function() {
        for (var $ = arguments.length, w = new Array($), O = 0; O < $; O++)
          w[O] = arguments[O];
        Promise.resolve().then(function() {
          jt(!S, "Your validator function has already return a promise. `callback` will be ignored."), S || y.apply(void 0, w);
        });
      }, b = f(h, g, x);
      S = b && typeof b.then == "function" && typeof b.catch == "function", jt(S, "`callback` is deprecated. Please return a promise instead."), S && b.then(function() {
        y();
      }).catch(function(_) {
        y(_ || " ");
      });
    }), m;
  }).sort(function(u, d) {
    var f = u.warningOnly, m = u.ruleIndex, h = d.warningOnly, g = d.ruleIndex;
    return !!f == !!h ? m - g : f ? 1 : -1;
  }), l;
  if (a === !0)
    l = new Promise(/* @__PURE__ */ function() {
      var u = jc(/* @__PURE__ */ ai().mark(function d(f, m) {
        var h, g, y;
        return ai().wrap(function(x) {
          for (; ; ) switch (x.prev = x.next) {
            case 0:
              h = 0;
            case 1:
              if (!(h < s.length)) {
                x.next = 12;
                break;
              }
              return g = s[h], x.next = 5, B2(o, t, g, n, i);
            case 5:
              if (y = x.sent, !y.length) {
                x.next = 9;
                break;
              }
              return m([{
                errors: y,
                rule: g
              }]), x.abrupt("return");
            case 9:
              h += 1, x.next = 1;
              break;
            case 12:
              f([]);
            case 13:
            case "end":
              return x.stop();
          }
        }, d);
      }));
      return function(d, f) {
        return u.apply(this, arguments);
      };
    }());
  else {
    var c = s.map(function(u) {
      return B2(o, t, u, n, i).then(function(d) {
        return {
          errors: d,
          rule: u
        };
      });
    });
    l = (a ? Yme(c) : Kme(c)).then(function(u) {
      return Promise.reject(u);
    });
  }
  return l.catch(function(u) {
    return u;
  }), l;
}
function Kme(e) {
  return H2.apply(this, arguments);
}
function H2() {
  return H2 = jc(/* @__PURE__ */ ai().mark(function e(t) {
    return ai().wrap(function(n) {
      for (; ; ) switch (n.prev = n.next) {
        case 0:
          return n.abrupt("return", Promise.all(t).then(function(a) {
            var i, o = (i = []).concat.apply(i, ze(a));
            return o;
          }));
        case 1:
        case "end":
          return n.stop();
      }
    }, e);
  })), H2.apply(this, arguments);
}
function Yme(e) {
  return V2.apply(this, arguments);
}
function V2() {
  return V2 = jc(/* @__PURE__ */ ai().mark(function e(t) {
    var r;
    return ai().wrap(function(a) {
      for (; ; ) switch (a.prev = a.next) {
        case 0:
          return r = 0, a.abrupt("return", new Promise(function(i) {
            t.forEach(function(o) {
              o.then(function(s) {
                s.errors.length && i([s]), r += 1, r === t.length && i([]);
              });
            });
          }));
        case 2:
        case "end":
          return a.stop();
      }
    }, e);
  })), V2.apply(this, arguments);
}
function ra(e) {
  return D2(e);
}
function WR(e, t) {
  var r = {};
  return t.forEach(function(n) {
    var a = Bi(e, n);
    r = Oo(r, n, a);
  }), r;
}
function ed(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return e && e.some(function(n) {
    return Fz(t, n, r);
  });
}
function Fz(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return !e || !t || !r && e.length !== t.length ? !1 : t.every(function(n, a) {
    return e[a] === n;
  });
}
function Zme(e, t) {
  if (e === t)
    return !0;
  if (!e && t || e && !t || !e || !t || kt(e) !== "object" || kt(t) !== "object")
    return !1;
  var r = Object.keys(e), n = Object.keys(t), a = new Set([].concat(r, n));
  return ze(a).every(function(i) {
    var o = e[i], s = t[i];
    return typeof o == "function" && typeof s == "function" ? !0 : o === s;
  });
}
function Xme(e) {
  var t = arguments.length <= 1 ? void 0 : arguments[1];
  return t && t.target && kt(t.target) === "object" && e in t.target ? t.target[e] : t;
}
function qR(e, t, r) {
  var n = e.length;
  if (t < 0 || t >= n || r < 0 || r >= n)
    return e;
  var a = e[t], i = t - r;
  return i > 0 ? [].concat(ze(e.slice(0, r)), [a], ze(e.slice(r, t)), ze(e.slice(t + 1, n))) : i < 0 ? [].concat(ze(e.slice(0, t)), ze(e.slice(t + 1, r + 1)), [a], ze(e.slice(r + 1, n))) : e;
}
var Jme = ["name"], to = [];
function KR(e, t, r, n, a, i) {
  return typeof e == "function" ? e(t, r, "source" in i ? {
    source: i.source
  } : {}) : n !== a;
}
var zT = /* @__PURE__ */ function(e) {
  ds(r, e);
  var t = fs(r);
  function r(n) {
    var a;
    if (Hn(this, r), a = t.call(this, n), te(at(a), "state", {
      resetCount: 0
    }), te(at(a), "cancelRegisterFunc", null), te(at(a), "mounted", !1), te(at(a), "touched", !1), te(at(a), "dirty", !1), te(at(a), "validatePromise", void 0), te(at(a), "prevValidating", void 0), te(at(a), "errors", to), te(at(a), "warnings", to), te(at(a), "cancelRegister", function() {
      var l = a.props, c = l.preserve, u = l.isListField, d = l.name;
      a.cancelRegisterFunc && a.cancelRegisterFunc(u, c, ra(d)), a.cancelRegisterFunc = null;
    }), te(at(a), "getNamePath", function() {
      var l = a.props, c = l.name, u = l.fieldContext, d = u.prefixName, f = d === void 0 ? [] : d;
      return c !== void 0 ? [].concat(ze(f), ze(c)) : [];
    }), te(at(a), "getRules", function() {
      var l = a.props, c = l.rules, u = c === void 0 ? [] : c, d = l.fieldContext;
      return u.map(function(f) {
        return typeof f == "function" ? f(d) : f;
      });
    }), te(at(a), "refresh", function() {
      a.mounted && a.setState(function(l) {
        var c = l.resetCount;
        return {
          resetCount: c + 1
        };
      });
    }), te(at(a), "metaCache", null), te(at(a), "triggerMetaEvent", function(l) {
      var c = a.props.onMetaChange;
      if (c) {
        var u = ce(ce({}, a.getMeta()), {}, {
          destroy: l
        });
        Do(a.metaCache, u) || c(u), a.metaCache = u;
      } else
        a.metaCache = null;
    }), te(at(a), "onStoreChange", function(l, c, u) {
      var d = a.props, f = d.shouldUpdate, m = d.dependencies, h = m === void 0 ? [] : m, g = d.onReset, y = u.store, S = a.getNamePath(), x = a.getValue(l), b = a.getValue(y), _ = c && ed(c, S);
      switch (u.type === "valueUpdate" && u.source === "external" && !Do(x, b) && (a.touched = !0, a.dirty = !0, a.validatePromise = null, a.errors = to, a.warnings = to, a.triggerMetaEvent()), u.type) {
        case "reset":
          if (!c || _) {
            a.touched = !1, a.dirty = !1, a.validatePromise = void 0, a.errors = to, a.warnings = to, a.triggerMetaEvent(), g?.(), a.refresh();
            return;
          }
          break;
        case "remove": {
          if (f) {
            a.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var $ = u.data;
          if (_) {
            "touched" in $ && (a.touched = $.touched), "validating" in $ && !("originRCField" in $) && (a.validatePromise = $.validating ? Promise.resolve([]) : null), "errors" in $ && (a.errors = $.errors || to), "warnings" in $ && (a.warnings = $.warnings || to), a.dirty = !0, a.triggerMetaEvent(), a.reRender();
            return;
          } else if ("value" in $ && ed(c, S, !0)) {
            a.reRender();
            return;
          }
          if (f && !S.length && KR(f, l, y, x, b, u)) {
            a.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var w = h.map(ra);
          if (w.some(function(O) {
            return ed(u.relatedFields, O);
          })) {
            a.reRender();
            return;
          }
          break;
        }
        default:
          if (_ || (!h.length || S.length || f) && KR(f, l, y, x, b, u)) {
            a.reRender();
            return;
          }
          break;
      }
      f === !0 && a.reRender();
    }), te(at(a), "validateRules", function(l) {
      var c = a.getNamePath(), u = a.getValue(), d = l || {}, f = d.triggerName, m = d.validateOnly, h = m === void 0 ? !1 : m, g = Promise.resolve().then(/* @__PURE__ */ jc(/* @__PURE__ */ ai().mark(function y() {
        var S, x, b, _, $, w, O;
        return ai().wrap(function(I) {
          for (; ; ) switch (I.prev = I.next) {
            case 0:
              if (a.mounted) {
                I.next = 2;
                break;
              }
              return I.abrupt("return", []);
            case 2:
              if (S = a.props, x = S.validateFirst, b = x === void 0 ? !1 : x, _ = S.messageVariables, $ = S.validateDebounce, w = a.getRules(), f && (w = w.filter(function(P) {
                return P;
              }).filter(function(P) {
                var D = P.validateTrigger;
                if (!D)
                  return !0;
                var B = D2(D);
                return B.includes(f);
              })), !($ && f)) {
                I.next = 10;
                break;
              }
              return I.next = 8, new Promise(function(P) {
                setTimeout(P, $);
              });
            case 8:
              if (a.validatePromise === g) {
                I.next = 10;
                break;
              }
              return I.abrupt("return", []);
            case 10:
              return O = qme(c, u, w, l, b, _), O.catch(function(P) {
                return P;
              }).then(function() {
                var P = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : to;
                if (a.validatePromise === g) {
                  var D;
                  a.validatePromise = null;
                  var B = [], L = [];
                  (D = P.forEach) === null || D === void 0 || D.call(P, function(N) {
                    var z = N.rule.warningOnly, F = N.errors, j = F === void 0 ? to : F;
                    z ? L.push.apply(L, ze(j)) : B.push.apply(B, ze(j));
                  }), a.errors = B, a.warnings = L, a.triggerMetaEvent(), a.reRender();
                }
              }), I.abrupt("return", O);
            case 13:
            case "end":
              return I.stop();
          }
        }, y);
      })));
      return h || (a.validatePromise = g, a.dirty = !0, a.errors = to, a.warnings = to, a.triggerMetaEvent(), a.reRender()), g;
    }), te(at(a), "isFieldValidating", function() {
      return !!a.validatePromise;
    }), te(at(a), "isFieldTouched", function() {
      return a.touched;
    }), te(at(a), "isFieldDirty", function() {
      if (a.dirty || a.props.initialValue !== void 0)
        return !0;
      var l = a.props.fieldContext, c = l.getInternalHooks(uc), u = c.getInitialValue;
      return u(a.getNamePath()) !== void 0;
    }), te(at(a), "getErrors", function() {
      return a.errors;
    }), te(at(a), "getWarnings", function() {
      return a.warnings;
    }), te(at(a), "isListField", function() {
      return a.props.isListField;
    }), te(at(a), "isList", function() {
      return a.props.isList;
    }), te(at(a), "isPreserve", function() {
      return a.props.preserve;
    }), te(at(a), "getMeta", function() {
      a.prevValidating = a.isFieldValidating();
      var l = {
        touched: a.isFieldTouched(),
        validating: a.prevValidating,
        errors: a.errors,
        warnings: a.warnings,
        name: a.getNamePath(),
        validated: a.validatePromise === null
      };
      return l;
    }), te(at(a), "getOnlyChild", function(l) {
      if (typeof l == "function") {
        var c = a.getMeta();
        return ce(ce({}, a.getOnlyChild(l(a.getControlled(), c, a.props.fieldContext))), {}, {
          isFunction: !0
        });
      }
      var u = Ma(l);
      return u.length !== 1 || !/* @__PURE__ */ p.isValidElement(u[0]) ? {
        child: u,
        isFunction: !1
      } : {
        child: u[0],
        isFunction: !1
      };
    }), te(at(a), "getValue", function(l) {
      var c = a.props.fieldContext.getFieldsValue, u = a.getNamePath();
      return Bi(l || c(!0), u);
    }), te(at(a), "getControlled", function() {
      var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = a.props, u = c.name, d = c.trigger, f = c.validateTrigger, m = c.getValueFromEvent, h = c.normalize, g = c.valuePropName, y = c.getValueProps, S = c.fieldContext, x = f !== void 0 ? f : S.validateTrigger, b = a.getNamePath(), _ = S.getInternalHooks, $ = S.getFieldsValue, w = _(uc), O = w.dispatch, T = a.getValue(), I = y || function(N) {
        return te({}, g, N);
      }, P = l[d], D = u !== void 0 ? I(T) : {};
      process.env.NODE_ENV !== "production" && D && Object.keys(D).forEach(function(N) {
        jt(typeof D[N] != "function", "It's not recommended to generate dynamic function prop by `getValueProps`. Please pass it to child component directly (prop: ".concat(N, ")"));
      });
      var B = ce(ce({}, l), D);
      B[d] = function() {
        a.touched = !0, a.dirty = !0, a.triggerMetaEvent();
        for (var N, z = arguments.length, F = new Array(z), j = 0; j < z; j++)
          F[j] = arguments[j];
        m ? N = m.apply(void 0, F) : N = Xme.apply(void 0, [g].concat(F)), h && (N = h(N, T, $(!0))), O({
          type: "updateValue",
          namePath: b,
          value: N
        }), P && P.apply(void 0, F);
      };
      var L = D2(x || []);
      return L.forEach(function(N) {
        var z = B[N];
        B[N] = function() {
          z && z.apply(void 0, arguments);
          var F = a.props.rules;
          F && F.length && O({
            type: "validateField",
            namePath: b,
            triggerName: N
          });
        };
      }), B;
    }), n.fieldContext) {
      var i = n.fieldContext.getInternalHooks, o = i(uc), s = o.initEntityValue;
      s(at(a));
    }
    return a;
  }
  return Vn(r, [{
    key: "componentDidMount",
    value: function() {
      var a = this.props, i = a.shouldUpdate, o = a.fieldContext;
      if (this.mounted = !0, o) {
        var s = o.getInternalHooks, l = s(uc), c = l.registerField;
        this.cancelRegisterFunc = c(this);
      }
      i === !0 && this.reRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.cancelRegister(), this.triggerMetaEvent(!0), this.mounted = !1;
    }
  }, {
    key: "reRender",
    value: function() {
      this.mounted && this.forceUpdate();
    }
  }, {
    key: "render",
    value: function() {
      var a = this.state.resetCount, i = this.props.children, o = this.getOnlyChild(i), s = o.child, l = o.isFunction, c;
      return l ? c = s : /* @__PURE__ */ p.isValidElement(s) ? c = /* @__PURE__ */ p.cloneElement(s, this.getControlled(s.props)) : (jt(!s, "`children` of Field is not validate ReactElement."), c = s), /* @__PURE__ */ p.createElement(p.Fragment, {
        key: a
      }, c);
    }
  }]), r;
}(p.Component);
te(zT, "contextType", $c);
te(zT, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function HT(e) {
  var t = e.name, r = Kt(e, Jme), n = p.useContext($c), a = p.useContext(Y0), i = t !== void 0 ? ra(t) : void 0, o = "keep";
  return r.isListField || (o = "_".concat((i || []).join("_"))), process.env.NODE_ENV !== "production" && r.preserve === !1 && r.isListField && i.length <= 1 && jt(!1, "`preserve` should not apply on Form.List fields."), /* @__PURE__ */ p.createElement(zT, Pe({
    key: o,
    name: i,
    isListField: !!a
  }, r, {
    fieldContext: n
  }));
}
function Bz(e) {
  var t = e.name, r = e.initialValue, n = e.children, a = e.rules, i = e.validateTrigger, o = e.isListField, s = p.useContext($c), l = p.useContext(Y0), c = p.useRef({
    keys: [],
    id: 0
  }), u = c.current, d = p.useMemo(function() {
    var g = ra(s.prefixName) || [];
    return [].concat(ze(g), ze(ra(t)));
  }, [s.prefixName, t]), f = p.useMemo(function() {
    return ce(ce({}, s), {}, {
      prefixName: d
    });
  }, [s, d]), m = p.useMemo(function() {
    return {
      getKey: function(y) {
        var S = d.length, x = y[S];
        return [u.keys[x], y.slice(S + 1)];
      }
    };
  }, [d]);
  if (typeof n != "function")
    return jt(!1, "Form.List only accepts function as children."), null;
  var h = function(y, S, x) {
    var b = x.source;
    return b === "internal" ? !1 : y !== S;
  };
  return /* @__PURE__ */ p.createElement(Y0.Provider, {
    value: m
  }, /* @__PURE__ */ p.createElement($c.Provider, {
    value: f
  }, /* @__PURE__ */ p.createElement(HT, {
    name: [],
    shouldUpdate: h,
    rules: a,
    validateTrigger: i,
    initialValue: r,
    isList: !0,
    isListField: o ?? !!l
  }, function(g, y) {
    var S = g.value, x = S === void 0 ? [] : S, b = g.onChange, _ = s.getFieldValue, $ = function() {
      var I = _(d || []);
      return I || [];
    }, w = {
      add: function(I, P) {
        var D = $();
        P >= 0 && P <= D.length ? (u.keys = [].concat(ze(u.keys.slice(0, P)), [u.id], ze(u.keys.slice(P))), b([].concat(ze(D.slice(0, P)), [I], ze(D.slice(P))))) : (process.env.NODE_ENV !== "production" && (P < 0 || P > D.length) && jt(!1, "The second parameter of the add function should be a valid positive number."), u.keys = [].concat(ze(u.keys), [u.id]), b([].concat(ze(D), [I]))), u.id += 1;
      },
      remove: function(I) {
        var P = $(), D = new Set(Array.isArray(I) ? I : [I]);
        D.size <= 0 || (u.keys = u.keys.filter(function(B, L) {
          return !D.has(L);
        }), b(P.filter(function(B, L) {
          return !D.has(L);
        })));
      },
      move: function(I, P) {
        if (I !== P) {
          var D = $();
          I < 0 || I >= D.length || P < 0 || P >= D.length || (u.keys = qR(u.keys, I, P), b(qR(D, I, P)));
        }
      }
    }, O = x || [];
    return Array.isArray(O) || (O = [], process.env.NODE_ENV !== "production" && jt(!1, "Current value of '".concat(d.join(" > "), "' is not an array type."))), n(O.map(function(T, I) {
      var P = u.keys[I];
      return P === void 0 && (u.keys[I] = u.id, P = u.keys[I], u.id += 1), {
        name: I,
        key: P,
        isListField: !0
      };
    }), w, y);
  })));
}
function Qme(e) {
  var t = !1, r = e.length, n = [];
  return e.length ? new Promise(function(a, i) {
    e.forEach(function(o, s) {
      o.catch(function(l) {
        return t = !0, l;
      }).then(function(l) {
        r -= 1, n[s] = l, !(r > 0) && (t && i(n), a(n));
      });
    });
  }) : Promise.resolve([]);
}
var zz = "__@field_split__";
function px(e) {
  return e.map(function(t) {
    return "".concat(kt(t), ":").concat(t);
  }).join(zz);
}
var hu = /* @__PURE__ */ function() {
  function e() {
    Hn(this, e), te(this, "kvs", /* @__PURE__ */ new Map());
  }
  return Vn(e, [{
    key: "set",
    value: function(r, n) {
      this.kvs.set(px(r), n);
    }
  }, {
    key: "get",
    value: function(r) {
      return this.kvs.get(px(r));
    }
  }, {
    key: "update",
    value: function(r, n) {
      var a = this.get(r), i = n(a);
      i ? this.set(r, i) : this.delete(r);
    }
  }, {
    key: "delete",
    value: function(r) {
      this.kvs.delete(px(r));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function(r) {
      return ze(this.kvs.entries()).map(function(n) {
        var a = ye(n, 2), i = a[0], o = a[1], s = i.split(zz);
        return r({
          key: s.map(function(l) {
            var c = l.match(/^([^:]*):(.*)$/), u = ye(c, 3), d = u[1], f = u[2];
            return d === "number" ? Number(f) : f;
          }),
          value: o
        });
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      var r = {};
      return this.map(function(n) {
        var a = n.key, i = n.value;
        return r[a.join(".")] = i, null;
      }), r;
    }
  }]), e;
}(), eve = ["name"], tve = /* @__PURE__ */ Vn(function e(t) {
  var r = this;
  Hn(this, e), te(this, "formHooked", !1), te(this, "forceRootUpdate", void 0), te(this, "subscribable", !0), te(this, "store", {}), te(this, "fieldEntities", []), te(this, "initialValues", {}), te(this, "callbacks", {}), te(this, "validateMessages", null), te(this, "preserve", null), te(this, "lastValidatePromise", null), te(this, "getForm", function() {
    return {
      getFieldValue: r.getFieldValue,
      getFieldsValue: r.getFieldsValue,
      getFieldError: r.getFieldError,
      getFieldWarning: r.getFieldWarning,
      getFieldsError: r.getFieldsError,
      isFieldsTouched: r.isFieldsTouched,
      isFieldTouched: r.isFieldTouched,
      isFieldValidating: r.isFieldValidating,
      isFieldsValidating: r.isFieldsValidating,
      resetFields: r.resetFields,
      setFields: r.setFields,
      setFieldValue: r.setFieldValue,
      setFieldsValue: r.setFieldsValue,
      validateFields: r.validateFields,
      submit: r.submit,
      _init: !0,
      getInternalHooks: r.getInternalHooks
    };
  }), te(this, "getInternalHooks", function(n) {
    return n === uc ? (r.formHooked = !0, {
      dispatch: r.dispatch,
      initEntityValue: r.initEntityValue,
      registerField: r.registerField,
      useSubscribe: r.useSubscribe,
      setInitialValues: r.setInitialValues,
      destroyForm: r.destroyForm,
      setCallbacks: r.setCallbacks,
      setValidateMessages: r.setValidateMessages,
      getFields: r.getFields,
      setPreserve: r.setPreserve,
      getInitialValue: r.getInitialValue,
      registerWatch: r.registerWatch
    }) : (jt(!1, "`getInternalHooks` is internal usage. Should not call directly."), null);
  }), te(this, "useSubscribe", function(n) {
    r.subscribable = n;
  }), te(this, "prevWithoutPreserves", null), te(this, "setInitialValues", function(n, a) {
    if (r.initialValues = n || {}, a) {
      var i, o = Yu(n, r.store);
      (i = r.prevWithoutPreserves) === null || i === void 0 || i.map(function(s) {
        var l = s.key;
        o = Oo(o, l, Bi(n, l));
      }), r.prevWithoutPreserves = null, r.updateStore(o);
    }
  }), te(this, "destroyForm", function(n) {
    if (n)
      r.updateStore({});
    else {
      var a = new hu();
      r.getFieldEntities(!0).forEach(function(i) {
        r.isMergedPreserve(i.isPreserve()) || a.set(i.getNamePath(), !0);
      }), r.prevWithoutPreserves = a;
    }
  }), te(this, "getInitialValue", function(n) {
    var a = Bi(r.initialValues, n);
    return n.length ? Yu(a) : a;
  }), te(this, "setCallbacks", function(n) {
    r.callbacks = n;
  }), te(this, "setValidateMessages", function(n) {
    r.validateMessages = n;
  }), te(this, "setPreserve", function(n) {
    r.preserve = n;
  }), te(this, "watchList", []), te(this, "registerWatch", function(n) {
    return r.watchList.push(n), function() {
      r.watchList = r.watchList.filter(function(a) {
        return a !== n;
      });
    };
  }), te(this, "notifyWatch", function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (r.watchList.length) {
      var a = r.getFieldsValue(), i = r.getFieldsValue(!0);
      r.watchList.forEach(function(o) {
        o(a, i, n);
      });
    }
  }), te(this, "timeoutId", null), te(this, "warningUnhooked", function() {
    process.env.NODE_ENV !== "production" && !r.timeoutId && typeof window < "u" && (r.timeoutId = setTimeout(function() {
      r.timeoutId = null, r.formHooked || jt(!1, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
    }));
  }), te(this, "updateStore", function(n) {
    r.store = n;
  }), te(this, "getFieldEntities", function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return n ? r.fieldEntities.filter(function(a) {
      return a.getNamePath().length;
    }) : r.fieldEntities;
  }), te(this, "getFieldsMap", function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, a = new hu();
    return r.getFieldEntities(n).forEach(function(i) {
      var o = i.getNamePath();
      a.set(o, i);
    }), a;
  }), te(this, "getFieldEntitiesForNamePathList", function(n) {
    if (!n)
      return r.getFieldEntities(!0);
    var a = r.getFieldsMap(!0);
    return n.map(function(i) {
      var o = ra(i);
      return a.get(o) || {
        INVALIDATE_NAME_PATH: ra(i)
      };
    });
  }), te(this, "getFieldsValue", function(n, a) {
    r.warningUnhooked();
    var i, o, s;
    if (n === !0 || Array.isArray(n) ? (i = n, o = a) : n && kt(n) === "object" && (s = n.strict, o = n.filter), i === !0 && !o)
      return r.store;
    var l = r.getFieldEntitiesForNamePathList(Array.isArray(i) ? i : null), c = [];
    return l.forEach(function(u) {
      var d, f, m = "INVALIDATE_NAME_PATH" in u ? u.INVALIDATE_NAME_PATH : u.getNamePath();
      if (s) {
        var h, g;
        if ((h = (g = u).isList) !== null && h !== void 0 && h.call(g))
          return;
      } else if (!i && (d = (f = u).isListField) !== null && d !== void 0 && d.call(f))
        return;
      if (!o)
        c.push(m);
      else {
        var y = "getMeta" in u ? u.getMeta() : null;
        o(y) && c.push(m);
      }
    }), WR(r.store, c.map(ra));
  }), te(this, "getFieldValue", function(n) {
    r.warningUnhooked();
    var a = ra(n);
    return Bi(r.store, a);
  }), te(this, "getFieldsError", function(n) {
    r.warningUnhooked();
    var a = r.getFieldEntitiesForNamePathList(n);
    return a.map(function(i, o) {
      return i && !("INVALIDATE_NAME_PATH" in i) ? {
        name: i.getNamePath(),
        errors: i.getErrors(),
        warnings: i.getWarnings()
      } : {
        name: ra(n[o]),
        errors: [],
        warnings: []
      };
    });
  }), te(this, "getFieldError", function(n) {
    r.warningUnhooked();
    var a = ra(n), i = r.getFieldsError([a])[0];
    return i.errors;
  }), te(this, "getFieldWarning", function(n) {
    r.warningUnhooked();
    var a = ra(n), i = r.getFieldsError([a])[0];
    return i.warnings;
  }), te(this, "isFieldsTouched", function() {
    r.warningUnhooked();
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    var o = a[0], s = a[1], l, c = !1;
    a.length === 0 ? l = null : a.length === 1 ? Array.isArray(o) ? (l = o.map(ra), c = !1) : (l = null, c = o) : (l = o.map(ra), c = s);
    var u = r.getFieldEntities(!0), d = function(y) {
      return y.isFieldTouched();
    };
    if (!l)
      return c ? u.every(function(g) {
        return d(g) || g.isList();
      }) : u.some(d);
    var f = new hu();
    l.forEach(function(g) {
      f.set(g, []);
    }), u.forEach(function(g) {
      var y = g.getNamePath();
      l.forEach(function(S) {
        S.every(function(x, b) {
          return y[b] === x;
        }) && f.update(S, function(x) {
          return [].concat(ze(x), [g]);
        });
      });
    });
    var m = function(y) {
      return y.some(d);
    }, h = f.map(function(g) {
      var y = g.value;
      return y;
    });
    return c ? h.every(m) : h.some(m);
  }), te(this, "isFieldTouched", function(n) {
    return r.warningUnhooked(), r.isFieldsTouched([n]);
  }), te(this, "isFieldsValidating", function(n) {
    r.warningUnhooked();
    var a = r.getFieldEntities();
    if (!n)
      return a.some(function(o) {
        return o.isFieldValidating();
      });
    var i = n.map(ra);
    return a.some(function(o) {
      var s = o.getNamePath();
      return ed(i, s) && o.isFieldValidating();
    });
  }), te(this, "isFieldValidating", function(n) {
    return r.warningUnhooked(), r.isFieldsValidating([n]);
  }), te(this, "resetWithFieldInitialValue", function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = new hu(), i = r.getFieldEntities(!0);
    i.forEach(function(l) {
      var c = l.props.initialValue, u = l.getNamePath();
      if (c !== void 0) {
        var d = a.get(u) || /* @__PURE__ */ new Set();
        d.add({
          entity: l,
          value: c
        }), a.set(u, d);
      }
    });
    var o = function(c) {
      c.forEach(function(u) {
        var d = u.props.initialValue;
        if (d !== void 0) {
          var f = u.getNamePath(), m = r.getInitialValue(f);
          if (m !== void 0)
            jt(!1, "Form already set 'initialValues' with path '".concat(f.join("."), "'. Field can not overwrite it."));
          else {
            var h = a.get(f);
            if (h && h.size > 1)
              jt(!1, "Multiple Field with path '".concat(f.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            else if (h) {
              var g = r.getFieldValue(f), y = u.isListField();
              !y && (!n.skipExist || g === void 0) && r.updateStore(Oo(r.store, f, ze(h)[0].value));
            }
          }
        }
      });
    }, s;
    n.entities ? s = n.entities : n.namePathList ? (s = [], n.namePathList.forEach(function(l) {
      var c = a.get(l);
      if (c) {
        var u;
        (u = s).push.apply(u, ze(ze(c).map(function(d) {
          return d.entity;
        })));
      }
    })) : s = i, o(s);
  }), te(this, "resetFields", function(n) {
    r.warningUnhooked();
    var a = r.store;
    if (!n) {
      r.updateStore(Yu(r.initialValues)), r.resetWithFieldInitialValue(), r.notifyObservers(a, null, {
        type: "reset"
      }), r.notifyWatch();
      return;
    }
    var i = n.map(ra);
    i.forEach(function(o) {
      var s = r.getInitialValue(o);
      r.updateStore(Oo(r.store, o, s));
    }), r.resetWithFieldInitialValue({
      namePathList: i
    }), r.notifyObservers(a, i, {
      type: "reset"
    }), r.notifyWatch(i);
  }), te(this, "setFields", function(n) {
    r.warningUnhooked();
    var a = r.store, i = [];
    n.forEach(function(o) {
      var s = o.name, l = Kt(o, eve), c = ra(s);
      i.push(c), "value" in l && r.updateStore(Oo(r.store, c, l.value)), r.notifyObservers(a, [c], {
        type: "setField",
        data: o
      });
    }), r.notifyWatch(i);
  }), te(this, "getFields", function() {
    var n = r.getFieldEntities(!0), a = n.map(function(i) {
      var o = i.getNamePath(), s = i.getMeta(), l = ce(ce({}, s), {}, {
        name: o,
        value: r.getFieldValue(o)
      });
      return Object.defineProperty(l, "originRCField", {
        value: !0
      }), l;
    });
    return a;
  }), te(this, "initEntityValue", function(n) {
    var a = n.props.initialValue;
    if (a !== void 0) {
      var i = n.getNamePath(), o = Bi(r.store, i);
      o === void 0 && r.updateStore(Oo(r.store, i, a));
    }
  }), te(this, "isMergedPreserve", function(n) {
    var a = n !== void 0 ? n : r.preserve;
    return a ?? !0;
  }), te(this, "registerField", function(n) {
    r.fieldEntities.push(n);
    var a = n.getNamePath();
    if (r.notifyWatch([a]), n.props.initialValue !== void 0) {
      var i = r.store;
      r.resetWithFieldInitialValue({
        entities: [n],
        skipExist: !0
      }), r.notifyObservers(i, [n.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(o, s) {
      var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (r.fieldEntities = r.fieldEntities.filter(function(d) {
        return d !== n;
      }), !r.isMergedPreserve(s) && (!o || l.length > 1)) {
        var c = o ? void 0 : r.getInitialValue(a);
        if (a.length && r.getFieldValue(a) !== c && r.fieldEntities.every(function(d) {
          return (
            // Only reset when no namePath exist
            !Fz(d.getNamePath(), a)
          );
        })) {
          var u = r.store;
          r.updateStore(Oo(u, a, c, !0)), r.notifyObservers(u, [a], {
            type: "remove"
          }), r.triggerDependenciesUpdate(u, a);
        }
      }
      r.notifyWatch([a]);
    };
  }), te(this, "dispatch", function(n) {
    switch (n.type) {
      case "updateValue": {
        var a = n.namePath, i = n.value;
        r.updateValue(a, i);
        break;
      }
      case "validateField": {
        var o = n.namePath, s = n.triggerName;
        r.validateFields([o], {
          triggerName: s
        });
        break;
      }
    }
  }), te(this, "notifyObservers", function(n, a, i) {
    if (r.subscribable) {
      var o = ce(ce({}, i), {}, {
        store: r.getFieldsValue(!0)
      });
      r.getFieldEntities().forEach(function(s) {
        var l = s.onStoreChange;
        l(n, a, o);
      });
    } else
      r.forceRootUpdate();
  }), te(this, "triggerDependenciesUpdate", function(n, a) {
    var i = r.getDependencyChildrenFields(a);
    return i.length && r.validateFields(i), r.notifyObservers(n, i, {
      type: "dependenciesUpdate",
      relatedFields: [a].concat(ze(i))
    }), i;
  }), te(this, "updateValue", function(n, a) {
    var i = ra(n), o = r.store;
    r.updateStore(Oo(r.store, i, a)), r.notifyObservers(o, [i], {
      type: "valueUpdate",
      source: "internal"
    }), r.notifyWatch([i]);
    var s = r.triggerDependenciesUpdate(o, i), l = r.callbacks.onValuesChange;
    if (l) {
      var c = WR(r.store, [i]);
      l(c, r.getFieldsValue());
    }
    r.triggerOnFieldsChange([i].concat(ze(s)));
  }), te(this, "setFieldsValue", function(n) {
    r.warningUnhooked();
    var a = r.store;
    if (n) {
      var i = Yu(r.store, n);
      r.updateStore(i);
    }
    r.notifyObservers(a, null, {
      type: "valueUpdate",
      source: "external"
    }), r.notifyWatch();
  }), te(this, "setFieldValue", function(n, a) {
    r.setFields([{
      name: n,
      value: a
    }]);
  }), te(this, "getDependencyChildrenFields", function(n) {
    var a = /* @__PURE__ */ new Set(), i = [], o = new hu();
    r.getFieldEntities().forEach(function(l) {
      var c = l.props.dependencies;
      (c || []).forEach(function(u) {
        var d = ra(u);
        o.update(d, function() {
          var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          return f.add(l), f;
        });
      });
    });
    var s = function l(c) {
      var u = o.get(c) || /* @__PURE__ */ new Set();
      u.forEach(function(d) {
        if (!a.has(d)) {
          a.add(d);
          var f = d.getNamePath();
          d.isFieldDirty() && f.length && (i.push(f), l(f));
        }
      });
    };
    return s(n), i;
  }), te(this, "triggerOnFieldsChange", function(n, a) {
    var i = r.callbacks.onFieldsChange;
    if (i) {
      var o = r.getFields();
      if (a) {
        var s = new hu();
        a.forEach(function(c) {
          var u = c.name, d = c.errors;
          s.set(u, d);
        }), o.forEach(function(c) {
          c.errors = s.get(c.name) || c.errors;
        });
      }
      var l = o.filter(function(c) {
        var u = c.name;
        return ed(n, u);
      });
      l.length && i(l, o);
    }
  }), te(this, "validateFields", function(n, a) {
    r.warningUnhooked();
    var i, o;
    Array.isArray(n) || typeof n == "string" || typeof a == "string" ? (i = n, o = a) : o = n;
    var s = !!i, l = s ? i.map(ra) : [], c = [], u = String(Date.now()), d = /* @__PURE__ */ new Set(), f = o || {}, m = f.recursive, h = f.dirty;
    r.getFieldEntities(!0).forEach(function(x) {
      if (s || l.push(x.getNamePath()), !(!x.props.rules || !x.props.rules.length) && !(h && !x.isFieldDirty())) {
        var b = x.getNamePath();
        if (d.add(b.join(u)), !s || ed(l, b, m)) {
          var _ = x.validateRules(ce({
            validateMessages: ce(ce({}, kz), r.validateMessages)
          }, o));
          c.push(_.then(function() {
            return {
              name: b,
              errors: [],
              warnings: []
            };
          }).catch(function($) {
            var w, O = [], T = [];
            return (w = $.forEach) === null || w === void 0 || w.call($, function(I) {
              var P = I.rule.warningOnly, D = I.errors;
              P ? T.push.apply(T, ze(D)) : O.push.apply(O, ze(D));
            }), O.length ? Promise.reject({
              name: b,
              errors: O,
              warnings: T
            }) : {
              name: b,
              errors: O,
              warnings: T
            };
          }));
        }
      }
    });
    var g = Qme(c);
    r.lastValidatePromise = g, g.catch(function(x) {
      return x;
    }).then(function(x) {
      var b = x.map(function(_) {
        var $ = _.name;
        return $;
      });
      r.notifyObservers(r.store, b, {
        type: "validateFinish"
      }), r.triggerOnFieldsChange(b, x);
    });
    var y = g.then(function() {
      return r.lastValidatePromise === g ? Promise.resolve(r.getFieldsValue(l)) : Promise.reject([]);
    }).catch(function(x) {
      var b = x.filter(function(_) {
        return _ && _.errors.length;
      });
      return Promise.reject({
        values: r.getFieldsValue(l),
        errorFields: b,
        outOfDate: r.lastValidatePromise !== g
      });
    });
    y.catch(function(x) {
      return x;
    });
    var S = l.filter(function(x) {
      return d.has(x.join(u));
    });
    return r.triggerOnFieldsChange(S), y;
  }), te(this, "submit", function() {
    r.warningUnhooked(), r.validateFields().then(function(n) {
      var a = r.callbacks.onFinish;
      if (a)
        try {
          a(n);
        } catch (i) {
          console.error(i);
        }
    }).catch(function(n) {
      var a = r.callbacks.onFinishFailed;
      a && a(n);
    });
  }), this.forceRootUpdate = t;
});
function VT(e) {
  var t = p.useRef(), r = p.useState({}), n = ye(r, 2), a = n[1];
  if (!t.current)
    if (e)
      t.current = e;
    else {
      var i = function() {
        a({});
      }, o = new tve(i);
      t.current = o.getForm();
    }
  return [t.current];
}
var G2 = /* @__PURE__ */ p.createContext({
  triggerFormChange: function() {
  },
  triggerFormFinish: function() {
  },
  registerForm: function() {
  },
  unregisterForm: function() {
  }
}), Hz = function(t) {
  var r = t.validateMessages, n = t.onFormChange, a = t.onFormFinish, i = t.children, o = p.useContext(G2), s = p.useRef({});
  return /* @__PURE__ */ p.createElement(G2.Provider, {
    value: ce(ce({}, o), {}, {
      validateMessages: ce(ce({}, o.validateMessages), r),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function(c, u) {
        n && n(c, {
          changedFields: u,
          forms: s.current
        }), o.triggerFormChange(c, u);
      },
      triggerFormFinish: function(c, u) {
        a && a(c, {
          values: u,
          forms: s.current
        }), o.triggerFormFinish(c, u);
      },
      registerForm: function(c, u) {
        c && (s.current = ce(ce({}, s.current), {}, te({}, c, u))), o.registerForm(c, u);
      },
      unregisterForm: function(c) {
        var u = ce({}, s.current);
        delete u[c], s.current = u, o.unregisterForm(c);
      }
    })
  }, i);
}, rve = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed", "clearOnDestroy"], nve = function(t, r) {
  var n = t.name, a = t.initialValues, i = t.fields, o = t.form, s = t.preserve, l = t.children, c = t.component, u = c === void 0 ? "form" : c, d = t.validateMessages, f = t.validateTrigger, m = f === void 0 ? "onChange" : f, h = t.onValuesChange, g = t.onFieldsChange, y = t.onFinish, S = t.onFinishFailed, x = t.clearOnDestroy, b = Kt(t, rve), _ = p.useRef(null), $ = p.useContext(G2), w = VT(o), O = ye(w, 1), T = O[0], I = T.getInternalHooks(uc), P = I.useSubscribe, D = I.setInitialValues, B = I.setCallbacks, L = I.setValidateMessages, N = I.setPreserve, z = I.destroyForm;
  p.useImperativeHandle(r, function() {
    return ce(ce({}, T), {}, {
      nativeElement: _.current
    });
  }), p.useEffect(function() {
    return $.registerForm(n, T), function() {
      $.unregisterForm(n);
    };
  }, [$, T, n]), L(ce(ce({}, $.validateMessages), d)), B({
    onValuesChange: h,
    onFieldsChange: function(ee) {
      if ($.triggerFormChange(n, ee), g) {
        for (var ae = arguments.length, ue = new Array(ae > 1 ? ae - 1 : 0), re = 1; re < ae; re++)
          ue[re - 1] = arguments[re];
        g.apply(void 0, [ee].concat(ue));
      }
    },
    onFinish: function(ee) {
      $.triggerFormFinish(n, ee), y && y(ee);
    },
    onFinishFailed: S
  }), N(s);
  var F = p.useRef(null);
  D(a, !F.current), F.current || (F.current = !0), p.useEffect(
    function() {
      return function() {
        return z(x);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var j, H = typeof l == "function";
  if (H) {
    var U = T.getFieldsValue(!0);
    j = l(U, T);
  } else
    j = l;
  P(!H);
  var G = p.useRef();
  p.useEffect(function() {
    Zme(G.current || [], i || []) || T.setFields(i || []), G.current = i;
  }, [i, T]);
  var V = p.useMemo(function() {
    return ce(ce({}, T), {}, {
      validateTrigger: m
    });
  }, [T, m]), K = /* @__PURE__ */ p.createElement(Y0.Provider, {
    value: null
  }, /* @__PURE__ */ p.createElement($c.Provider, {
    value: V
  }, j));
  return u === !1 ? K : /* @__PURE__ */ p.createElement(u, Pe({}, b, {
    ref: _,
    onSubmit: function(ee) {
      ee.preventDefault(), ee.stopPropagation(), T.submit();
    },
    onReset: function(ee) {
      var ae;
      ee.preventDefault(), T.resetFields(), (ae = b.onReset) === null || ae === void 0 || ae.call(b, ee);
    }
  }), K);
};
function YR(e) {
  try {
    return JSON.stringify(e);
  } catch {
    return Math.random();
  }
}
var ave = process.env.NODE_ENV !== "production" ? function(e) {
  var t = e.join("__RC_FIELD_FORM_SPLIT__"), r = ct(t);
  jt(r.current === t, "`useWatch` is not support dynamic `namePath`. Please provide static instead.");
} : function() {
};
function Vz() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var n = t[0], a = t[1], i = a === void 0 ? {} : a, o = vme(i) ? {
    form: i
  } : i, s = o.form, l = He(), c = ye(l, 2), u = c[0], d = c[1], f = dr(function() {
    return YR(u);
  }, [u]), m = ct(f);
  m.current = f;
  var h = Cr($c), g = s || h, y = g && g._init;
  process.env.NODE_ENV !== "production" && jt(t.length === 2 ? s ? y : !0 : y, "useWatch requires a form instance since it can not auto detect from context.");
  var S = ra(n), x = ct(S);
  return x.current = S, ave(S), St(
    function() {
      if (y) {
        var b = g.getFieldsValue, _ = g.getInternalHooks, $ = _(uc), w = $.registerWatch, O = function(D, B) {
          var L = o.preserve ? B : D;
          return typeof n == "function" ? n(L) : Bi(L, x.current);
        }, T = w(function(P, D) {
          var B = O(P, D), L = YR(B);
          m.current !== L && (m.current = L, d(B));
        }), I = O(b(), b(!0));
        return u !== I && d(I), T;
      }
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [y]
  ), u;
}
var ive = /* @__PURE__ */ p.forwardRef(nve), Cd = ive;
Cd.FormProvider = Hz;
Cd.Field = HT;
Cd.List = Bz;
Cd.useForm = VT;
Cd.useWatch = Vz;
const Vs = /* @__PURE__ */ p.createContext({
  labelAlign: "right",
  vertical: !1,
  itemRef: () => {
  }
}), Gz = /* @__PURE__ */ p.createContext(null), Uz = (e) => {
  const t = bn(e, ["prefixCls"]);
  return /* @__PURE__ */ p.createElement(Hz, Object.assign({}, t));
}, GT = /* @__PURE__ */ p.createContext({
  prefixCls: ""
}), xa = /* @__PURE__ */ p.createContext({});
process.env.NODE_ENV !== "production" && (xa.displayName = "FormItemInputContext");
const UT = (e) => {
  let {
    children: t,
    status: r,
    override: n
  } = e;
  const a = Cr(xa), i = dr(() => {
    const o = Object.assign({}, a);
    return n && delete o.isFormItemInput, r && (delete o.status, delete o.hasFeedback, delete o.feedbackIcon), o;
  }, [r, n, a]);
  return /* @__PURE__ */ p.createElement(xa.Provider, {
    value: i
  }, t);
}, Wz = /* @__PURE__ */ Ws(void 0), E1 = (e) => {
  const {
    prefixCls: t,
    className: r,
    style: n,
    size: a,
    shape: i
  } = e, o = be({
    [`${t}-lg`]: a === "large",
    [`${t}-sm`]: a === "small"
  }), s = be({
    [`${t}-circle`]: i === "circle",
    [`${t}-square`]: i === "square",
    [`${t}-round`]: i === "round"
  }), l = p.useMemo(() => typeof a == "number" ? {
    width: a,
    height: a,
    lineHeight: `${a}px`
  } : {}, [a]);
  return /* @__PURE__ */ p.createElement("span", {
    className: be(t, o, s, r),
    style: Object.assign(Object.assign({}, l), n)
  });
}, ove = new Pr("ant-skeleton-loading", {
  "0%": {
    backgroundPosition: "100% 50%"
  },
  "100%": {
    backgroundPosition: "0 50%"
  }
}), w1 = (e) => ({
  height: e,
  lineHeight: ve(e)
}), td = (e) => Object.assign({
  width: e
}, w1(e)), sve = (e) => ({
  background: e.skeletonLoadingBackground,
  backgroundSize: "400% 100%",
  animationName: ove,
  animationDuration: e.skeletonLoadingMotionDuration,
  animationTimingFunction: "ease",
  animationIterationCount: "infinite"
}), mx = (e, t) => Object.assign({
  width: t(e).mul(5).equal(),
  minWidth: t(e).mul(5).equal()
}, w1(e)), lve = (e) => {
  const {
    skeletonAvatarCls: t,
    gradientFromColor: r,
    controlHeight: n,
    controlHeightLG: a,
    controlHeightSM: i
  } = e;
  return {
    [`${t}`]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: r
    }, td(n)),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    },
    [`${t}${t}-lg`]: Object.assign({}, td(a)),
    [`${t}${t}-sm`]: Object.assign({}, td(i))
  };
}, cve = (e) => {
  const {
    controlHeight: t,
    borderRadiusSM: r,
    skeletonInputCls: n,
    controlHeightLG: a,
    controlHeightSM: i,
    gradientFromColor: o,
    calc: s
  } = e;
  return {
    [`${n}`]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: o,
      borderRadius: r
    }, mx(t, s)),
    [`${n}-lg`]: Object.assign({}, mx(a, s)),
    [`${n}-sm`]: Object.assign({}, mx(i, s))
  };
}, ZR = (e) => Object.assign({
  width: e
}, w1(e)), uve = (e) => {
  const {
    skeletonImageCls: t,
    imageSizeBase: r,
    gradientFromColor: n,
    borderRadiusSM: a,
    calc: i
  } = e;
  return {
    [`${t}`]: Object.assign(Object.assign({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      verticalAlign: "top",
      background: n,
      borderRadius: a
    }, ZR(i(r).mul(2).equal())), {
      [`${t}-path`]: {
        fill: "#bfbfbf"
      },
      [`${t}-svg`]: Object.assign(Object.assign({}, ZR(r)), {
        maxWidth: i(r).mul(4).equal(),
        maxHeight: i(r).mul(4).equal()
      }),
      [`${t}-svg${t}-svg-circle`]: {
        borderRadius: "50%"
      }
    }),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    }
  };
}, vx = (e, t, r) => {
  const {
    skeletonButtonCls: n
  } = e;
  return {
    [`${r}${n}-circle`]: {
      width: t,
      minWidth: t,
      borderRadius: "50%"
    },
    [`${r}${n}-round`]: {
      borderRadius: t
    }
  };
}, hx = (e, t) => Object.assign({
  width: t(e).mul(2).equal(),
  minWidth: t(e).mul(2).equal()
}, w1(e)), dve = (e) => {
  const {
    borderRadiusSM: t,
    skeletonButtonCls: r,
    controlHeight: n,
    controlHeightLG: a,
    controlHeightSM: i,
    gradientFromColor: o,
    calc: s
  } = e;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    [`${r}`]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: o,
      borderRadius: t,
      width: s(n).mul(2).equal(),
      minWidth: s(n).mul(2).equal()
    }, hx(n, s))
  }, vx(e, n, r)), {
    [`${r}-lg`]: Object.assign({}, hx(a, s))
  }), vx(e, a, `${r}-lg`)), {
    [`${r}-sm`]: Object.assign({}, hx(i, s))
  }), vx(e, i, `${r}-sm`));
}, fve = (e) => {
  const {
    componentCls: t,
    skeletonAvatarCls: r,
    skeletonTitleCls: n,
    skeletonParagraphCls: a,
    skeletonButtonCls: i,
    skeletonInputCls: o,
    skeletonImageCls: s,
    controlHeight: l,
    controlHeightLG: c,
    controlHeightSM: u,
    gradientFromColor: d,
    padding: f,
    marginSM: m,
    borderRadius: h,
    titleHeight: g,
    blockRadius: y,
    paragraphLiHeight: S,
    controlHeightXS: x,
    paragraphMarginTop: b
  } = e;
  return {
    [`${t}`]: {
      display: "table",
      width: "100%",
      [`${t}-header`]: {
        display: "table-cell",
        paddingInlineEnd: f,
        verticalAlign: "top",
        // Avatar
        [`${r}`]: Object.assign({
          display: "inline-block",
          verticalAlign: "top",
          background: d
        }, td(l)),
        [`${r}-circle`]: {
          borderRadius: "50%"
        },
        [`${r}-lg`]: Object.assign({}, td(c)),
        [`${r}-sm`]: Object.assign({}, td(u))
      },
      [`${t}-content`]: {
        display: "table-cell",
        width: "100%",
        verticalAlign: "top",
        // Title
        [`${n}`]: {
          width: "100%",
          height: g,
          background: d,
          borderRadius: y,
          [`+ ${a}`]: {
            marginBlockStart: u
          }
        },
        // paragraph
        [`${a}`]: {
          padding: 0,
          "> li": {
            width: "100%",
            height: S,
            listStyle: "none",
            background: d,
            borderRadius: y,
            "+ li": {
              marginBlockStart: x
            }
          }
        },
        [`${a}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
          width: "61%"
        }
      },
      [`&-round ${t}-content`]: {
        [`${n}, ${a} > li`]: {
          borderRadius: h
        }
      }
    },
    [`${t}-with-avatar ${t}-content`]: {
      // Title
      [`${n}`]: {
        marginBlockStart: m,
        [`+ ${a}`]: {
          marginBlockStart: b
        }
      }
    },
    // Skeleton element
    [`${t}${t}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
      display: "inline-block",
      width: "auto"
    }, dve(e)), lve(e)), cve(e)), uve(e)),
    // Skeleton Block Button, Input
    [`${t}${t}-block`]: {
      width: "100%",
      [`${i}`]: {
        width: "100%"
      },
      [`${o}`]: {
        width: "100%"
      }
    },
    // With active animation
    [`${t}${t}-active`]: {
      [`
        ${n},
        ${a} > li,
        ${r},
        ${i},
        ${o},
        ${s}
      `]: Object.assign({}, sve(e))
    }
  };
}, pve = (e) => {
  const {
    colorFillContent: t,
    colorFill: r
  } = e, n = t, a = r;
  return {
    color: n,
    colorGradientEnd: a,
    gradientFromColor: n,
    gradientToColor: a,
    titleHeight: e.controlHeight / 2,
    blockRadius: e.borderRadiusSM,
    paragraphMarginTop: e.marginLG + e.marginXXS,
    paragraphLiHeight: e.controlHeight / 2
  };
}, Sd = Zr("Skeleton", (e) => {
  const {
    componentCls: t,
    calc: r
  } = e, n = $r(e, {
    skeletonAvatarCls: `${t}-avatar`,
    skeletonTitleCls: `${t}-title`,
    skeletonParagraphCls: `${t}-paragraph`,
    skeletonButtonCls: `${t}-button`,
    skeletonInputCls: `${t}-input`,
    skeletonImageCls: `${t}-image`,
    imageSizeBase: r(e.controlHeight).mul(1.5).equal(),
    borderRadius: 100,
    // Large number to make capsule shape
    skeletonLoadingBackground: `linear-gradient(90deg, ${e.gradientFromColor} 25%, ${e.gradientToColor} 37%, ${e.gradientFromColor} 63%)`,
    skeletonLoadingMotionDuration: "1.4s"
  });
  return [fve(n)];
}, pve, {
  deprecatedTokens: [["color", "gradientFromColor"], ["colorGradientEnd", "gradientToColor"]]
}), mve = (e) => {
  const {
    prefixCls: t,
    className: r,
    rootClassName: n,
    active: a,
    shape: i = "circle",
    size: o = "default"
  } = e, {
    getPrefixCls: s
  } = p.useContext(Lt), l = s("skeleton", t), [c, u, d] = Sd(l), f = bn(e, ["prefixCls", "className"]), m = be(l, `${l}-element`, {
    [`${l}-active`]: a
  }, r, n, u, d);
  return c(/* @__PURE__ */ p.createElement("div", {
    className: m
  }, /* @__PURE__ */ p.createElement(E1, Object.assign({
    prefixCls: `${l}-avatar`,
    shape: i,
    size: o
  }, f))));
}, vve = (e) => {
  const {
    prefixCls: t,
    className: r,
    rootClassName: n,
    active: a,
    block: i = !1,
    size: o = "default"
  } = e, {
    getPrefixCls: s
  } = p.useContext(Lt), l = s("skeleton", t), [c, u, d] = Sd(l), f = bn(e, ["prefixCls"]), m = be(l, `${l}-element`, {
    [`${l}-active`]: a,
    [`${l}-block`]: i
  }, r, n, u, d);
  return c(/* @__PURE__ */ p.createElement("div", {
    className: m
  }, /* @__PURE__ */ p.createElement(E1, Object.assign({
    prefixCls: `${l}-button`,
    size: o
  }, f))));
}, hve = "M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z", gve = (e) => {
  const {
    prefixCls: t,
    className: r,
    rootClassName: n,
    style: a,
    active: i
  } = e, {
    getPrefixCls: o
  } = p.useContext(Lt), s = o("skeleton", t), [l, c, u] = Sd(s), d = be(s, `${s}-element`, {
    [`${s}-active`]: i
  }, r, n, c, u);
  return l(/* @__PURE__ */ p.createElement("div", {
    className: d
  }, /* @__PURE__ */ p.createElement("div", {
    className: be(`${s}-image`, r),
    style: a
  }, /* @__PURE__ */ p.createElement("svg", {
    viewBox: "0 0 1098 1024",
    xmlns: "http://www.w3.org/2000/svg",
    className: `${s}-image-svg`
  }, /* @__PURE__ */ p.createElement("path", {
    d: hve,
    className: `${s}-image-path`
  })))));
}, yve = (e) => {
  const {
    prefixCls: t,
    className: r,
    rootClassName: n,
    active: a,
    block: i,
    size: o = "default"
  } = e, {
    getPrefixCls: s
  } = p.useContext(Lt), l = s("skeleton", t), [c, u, d] = Sd(l), f = bn(e, ["prefixCls"]), m = be(l, `${l}-element`, {
    [`${l}-active`]: a,
    [`${l}-block`]: i
  }, r, n, u, d);
  return c(/* @__PURE__ */ p.createElement("div", {
    className: m
  }, /* @__PURE__ */ p.createElement(E1, Object.assign({
    prefixCls: `${l}-input`,
    size: o
  }, f))));
};
var bve = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 10128 0 64 64 0 10-128 0zm118-224a48 48 0 1096 0 48 48 0 10-96 0zm158 228a96 96 0 10192 0 96 96 0 10-192 0zm148-314a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "dot-chart", theme: "outlined" }, Cve = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: bve
  }));
}, qz = /* @__PURE__ */ p.forwardRef(Cve);
process.env.NODE_ENV !== "production" && (qz.displayName = "DotChartOutlined");
const Sve = (e) => {
  const {
    prefixCls: t,
    className: r,
    rootClassName: n,
    style: a,
    active: i,
    children: o
  } = e, {
    getPrefixCls: s
  } = p.useContext(Lt), l = s("skeleton", t), [c, u, d] = Sd(l), f = be(l, `${l}-element`, {
    [`${l}-active`]: i
  }, u, r, n, d), m = o ?? /* @__PURE__ */ p.createElement(qz, null);
  return c(/* @__PURE__ */ p.createElement("div", {
    className: f
  }, /* @__PURE__ */ p.createElement("div", {
    className: be(`${l}-image`, r),
    style: a
  }, m)));
}, xve = (e, t) => {
  const {
    width: r,
    rows: n = 2
  } = t;
  if (Array.isArray(r))
    return r[e];
  if (n - 1 === e)
    return r;
}, $ve = (e) => {
  const {
    prefixCls: t,
    className: r,
    style: n,
    rows: a
  } = e, i = ze(Array(a)).map((o, s) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ p.createElement("li", {
      key: s,
      style: {
        width: xve(s, e)
      }
    })
  ));
  return /* @__PURE__ */ p.createElement("ul", {
    className: be(t, r),
    style: n
  }, i);
}, _ve = (e) => {
  let {
    prefixCls: t,
    className: r,
    width: n,
    style: a
  } = e;
  return /* @__PURE__ */ p.createElement("h3", {
    className: be(t, r),
    style: Object.assign({
      width: n
    }, a)
  });
};
function gx(e) {
  return e && typeof e == "object" ? e : {};
}
function Eve(e, t) {
  return e && !t ? {
    size: "large",
    shape: "square"
  } : {
    size: "large",
    shape: "circle"
  };
}
function wve(e, t) {
  return !e && t ? {
    width: "38%"
  } : e && t ? {
    width: "50%"
  } : {};
}
function Ove(e, t) {
  const r = {};
  return (!e || !t) && (r.width = "61%"), !e && t ? r.rows = 3 : r.rows = 2, r;
}
const Ui = (e) => {
  const {
    prefixCls: t,
    loading: r,
    className: n,
    rootClassName: a,
    style: i,
    children: o,
    avatar: s = !1,
    title: l = !0,
    paragraph: c = !0,
    active: u,
    round: d
  } = e, {
    getPrefixCls: f,
    direction: m,
    skeleton: h
  } = p.useContext(Lt), g = f("skeleton", t), [y, S, x] = Sd(g);
  if (r || !("loading" in e)) {
    const b = !!s, _ = !!l, $ = !!c;
    let w;
    if (b) {
      const I = Object.assign(Object.assign({
        prefixCls: `${g}-avatar`
      }, Eve(_, $)), gx(s));
      w = /* @__PURE__ */ p.createElement("div", {
        className: `${g}-header`
      }, /* @__PURE__ */ p.createElement(E1, Object.assign({}, I)));
    }
    let O;
    if (_ || $) {
      let I;
      if (_) {
        const D = Object.assign(Object.assign({
          prefixCls: `${g}-title`
        }, wve(b, $)), gx(l));
        I = /* @__PURE__ */ p.createElement(_ve, Object.assign({}, D));
      }
      let P;
      if ($) {
        const D = Object.assign(Object.assign({
          prefixCls: `${g}-paragraph`
        }, Ove(b, _)), gx(c));
        P = /* @__PURE__ */ p.createElement($ve, Object.assign({}, D));
      }
      O = /* @__PURE__ */ p.createElement("div", {
        className: `${g}-content`
      }, I, P);
    }
    const T = be(g, {
      [`${g}-with-avatar`]: b,
      [`${g}-active`]: u,
      [`${g}-rtl`]: m === "rtl",
      [`${g}-round`]: d
    }, h?.className, n, a, S, x);
    return y(/* @__PURE__ */ p.createElement("div", {
      className: T,
      style: Object.assign(Object.assign({}, h?.style), i)
    }, w, O));
  }
  return o ?? null;
};
Ui.Button = vve;
Ui.Avatar = mve;
Ui.Input = yve;
Ui.Image = gve;
Ui.Node = Sve;
process.env.NODE_ENV !== "production" && (Ui.displayName = "Skeleton");
function XR() {
}
const Tve = /* @__PURE__ */ p.createContext({
  add: XR,
  remove: XR
});
function Kz(e) {
  const t = p.useContext(Tve), r = p.useRef();
  return br((a) => {
    if (a) {
      const i = e ? a.querySelector(e) : a;
      t.add(i), r.current = i;
    } else
      t.remove(r.current);
  });
}
const JR = () => {
  const {
    cancelButtonProps: e,
    cancelTextLocale: t,
    onCancel: r
  } = Cr(dh);
  return /* @__PURE__ */ xe.createElement(Nt, Object.assign({
    onClick: r
  }, e), t);
}, QR = () => {
  const {
    confirmLoading: e,
    okButtonProps: t,
    okType: r,
    okTextLocale: n,
    onOk: a
  } = Cr(dh);
  return /* @__PURE__ */ xe.createElement(Nt, Object.assign({}, xz(r), {
    loading: e,
    onClick: a
  }, t), n);
};
function Yz(e, t) {
  return /* @__PURE__ */ xe.createElement("span", {
    className: `${e}-close-x`
  }, t || /* @__PURE__ */ xe.createElement(Ys, {
    className: `${e}-close-icon`
  }));
}
const Zz = (e) => {
  const {
    okText: t,
    okType: r = "primary",
    cancelText: n,
    confirmLoading: a,
    onOk: i,
    onCancel: o,
    okButtonProps: s,
    cancelButtonProps: l,
    footer: c
  } = e, [u] = Ks("Modal", CB()), d = t || u?.okText, f = n || u?.cancelText, m = {
    confirmLoading: a,
    okButtonProps: s,
    cancelButtonProps: l,
    okTextLocale: d,
    cancelTextLocale: f,
    okType: r,
    onOk: i,
    onCancel: o
  }, h = xe.useMemo(() => m, ze(Object.values(m)));
  let g;
  return typeof c == "function" || typeof c > "u" ? (g = /* @__PURE__ */ xe.createElement(xe.Fragment, null, /* @__PURE__ */ xe.createElement(JR, null), /* @__PURE__ */ xe.createElement(QR, null)), typeof c == "function" && (g = c(g, {
    OkBtn: QR,
    CancelBtn: JR
  })), g = /* @__PURE__ */ xe.createElement(Iz, {
    value: h
  }, g)) : g = c, /* @__PURE__ */ xe.createElement(IT, {
    disabled: !1
  }, g);
}, WT = (e) => ({
  [e.componentCls]: {
    // For common/openAnimation
    [`${e.antCls}-motion-collapse-legacy`]: {
      overflow: "hidden",
      "&-active": {
        transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
      }
    },
    [`${e.antCls}-motion-collapse`]: {
      overflow: "hidden",
      transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
    }
  }
}), Ive = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), Mve = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), O1 = function(e, t, r, n) {
  const i = (arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1) ? "&" : "";
  return {
    [`
      ${i}${e}-enter,
      ${i}${e}-appear
    `]: Object.assign(Object.assign({}, Ive(n)), {
      animationPlayState: "paused"
    }),
    [`${i}${e}-leave`]: Object.assign(Object.assign({}, Mve(n)), {
      animationPlayState: "paused"
    }),
    [`
      ${i}${e}-enter${e}-enter-active,
      ${i}${e}-appear${e}-appear-active
    `]: {
      animationName: t,
      animationPlayState: "running"
    },
    [`${i}${e}-leave${e}-leave-active`]: {
      animationName: r,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
}, Ave = new Pr("antFadeIn", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), Pve = new Pr("antFadeOut", {
  "0%": {
    opacity: 1
  },
  "100%": {
    opacity: 0
  }
}), Xz = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  const {
    antCls: r
  } = e, n = `${r}-fade`, a = t ? "&" : "";
  return [O1(n, Ave, Pve, e.motionDurationMid, t), {
    [`
        ${a}${n}-enter,
        ${a}${n}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: "linear"
    },
    [`${a}${n}-leave`]: {
      animationTimingFunction: "linear"
    }
  }];
}, Rve = new Pr("antMoveDownIn", {
  "0%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), Nve = new Pr("antMoveDownOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), Dve = new Pr("antMoveLeftIn", {
  "0%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), jve = new Pr("antMoveLeftOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), Lve = new Pr("antMoveRightIn", {
  "0%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), kve = new Pr("antMoveRightOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), Fve = new Pr("antMoveUpIn", {
  "0%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), Bve = new Pr("antMoveUpOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), zve = {
  "move-up": {
    inKeyframes: Fve,
    outKeyframes: Bve
  },
  "move-down": {
    inKeyframes: Rve,
    outKeyframes: Nve
  },
  "move-left": {
    inKeyframes: Dve,
    outKeyframes: jve
  },
  "move-right": {
    inKeyframes: Lve,
    outKeyframes: kve
  }
}, ld = (e, t) => {
  const {
    antCls: r
  } = e, n = `${r}-${t}`, {
    inKeyframes: a,
    outKeyframes: i
  } = zve[t];
  return [O1(n, a, i, e.motionDurationMid), {
    [`
        ${n}-enter,
        ${n}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc
    },
    [`${n}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, T1 = new Pr("antSlideUpIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), I1 = new Pr("antSlideUpOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), M1 = new Pr("antSlideDownIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  }
}), A1 = new Pr("antSlideDownOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  }
}), Hve = new Pr("antSlideLeftIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), Vve = new Pr("antSlideLeftOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), Gve = new Pr("antSlideRightIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  }
}), Uve = new Pr("antSlideRightOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  }
}), Wve = {
  "slide-up": {
    inKeyframes: T1,
    outKeyframes: I1
  },
  "slide-down": {
    inKeyframes: M1,
    outKeyframes: A1
  },
  "slide-left": {
    inKeyframes: Hve,
    outKeyframes: Vve
  },
  "slide-right": {
    inKeyframes: Gve,
    outKeyframes: Uve
  }
}, us = (e, t) => {
  const {
    antCls: r
  } = e, n = `${r}-${t}`, {
    inKeyframes: a,
    outKeyframes: i
  } = Wve[t];
  return [O1(n, a, i, e.motionDurationMid), {
    [`
      ${n}-enter,
      ${n}-appear
    `]: {
      transform: "scale(0)",
      transformOrigin: "0% 0%",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutQuint,
      "&-prepare": {
        transform: "scale(1)"
      }
    },
    [`${n}-leave`]: {
      animationTimingFunction: e.motionEaseInQuint
    }
  }];
}, qT = new Pr("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), qve = new Pr("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
}), eN = new Pr("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), tN = new Pr("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
}), Kve = new Pr("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
}), Yve = new Pr("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
}), Zve = new Pr("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
}), Xve = new Pr("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
}), Jve = new Pr("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
}), Qve = new Pr("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
}), e0e = new Pr("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
}), t0e = new Pr("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
}), r0e = {
  zoom: {
    inKeyframes: qT,
    outKeyframes: qve
  },
  "zoom-big": {
    inKeyframes: eN,
    outKeyframes: tN
  },
  "zoom-big-fast": {
    inKeyframes: eN,
    outKeyframes: tN
  },
  "zoom-left": {
    inKeyframes: Zve,
    outKeyframes: Xve
  },
  "zoom-right": {
    inKeyframes: Jve,
    outKeyframes: Qve
  },
  "zoom-up": {
    inKeyframes: Kve,
    outKeyframes: Yve
  },
  "zoom-down": {
    inKeyframes: e0e,
    outKeyframes: t0e
  }
}, ph = (e, t) => {
  const {
    antCls: r
  } = e, n = `${r}-${t}`, {
    inKeyframes: a,
    outKeyframes: i
  } = r0e[t];
  return [O1(n, a, i, t === "zoom-big-fast" ? e.motionDurationFast : e.motionDurationMid), {
    [`
        ${n}-enter,
        ${n}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${n}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
};
function rN(e) {
  return {
    position: e,
    inset: 0
  };
}
const Jz = (e) => {
  const {
    componentCls: t,
    antCls: r
  } = e;
  return [{
    [`${t}-root`]: {
      [`${t}${r}-zoom-enter, ${t}${r}-zoom-appear`]: {
        // reset scale avoid mousePosition bug
        transform: "none",
        opacity: 0,
        animationDuration: e.motionDurationSlow,
        // https://github.com/ant-design/ant-design/issues/11777
        userSelect: "none"
      },
      // https://github.com/ant-design/ant-design/issues/37329
      // https://github.com/ant-design/ant-design/issues/40272
      [`${t}${r}-zoom-leave ${t}-content`]: {
        pointerEvents: "none"
      },
      [`${t}-mask`]: Object.assign(Object.assign({}, rN("fixed")), {
        zIndex: e.zIndexPopupBase,
        height: "100%",
        backgroundColor: e.colorBgMask,
        pointerEvents: "none",
        [`${t}-hidden`]: {
          display: "none"
        }
      }),
      [`${t}-wrap`]: Object.assign(Object.assign({}, rN("fixed")), {
        zIndex: e.zIndexPopupBase,
        overflow: "auto",
        outline: 0,
        WebkitOverflowScrolling: "touch"
      })
    }
  }, {
    [`${t}-root`]: Xz(e)
  }];
}, n0e = (e) => {
  const {
    componentCls: t
  } = e;
  return [
    // ======================== Root =========================
    {
      [`${t}-root`]: {
        [`${t}-wrap-rtl`]: {
          direction: "rtl"
        },
        [`${t}-centered`]: {
          textAlign: "center",
          "&::before": {
            display: "inline-block",
            width: 0,
            height: "100%",
            verticalAlign: "middle",
            content: '""'
          },
          [t]: {
            top: 0,
            display: "inline-block",
            paddingBottom: 0,
            textAlign: "start",
            verticalAlign: "middle"
          }
        },
        [`@media (max-width: ${e.screenSMMax}px)`]: {
          [t]: {
            maxWidth: "calc(100vw - 16px)",
            margin: `${ve(e.marginXS)} auto`
          },
          [`${t}-centered`]: {
            [t]: {
              flex: 1
            }
          }
        }
      }
    },
    // ======================== Modal ========================
    {
      [t]: Object.assign(Object.assign({}, Yr(e)), {
        pointerEvents: "none",
        position: "relative",
        top: 100,
        width: "auto",
        maxWidth: `calc(100vw - ${ve(e.calc(e.margin).mul(2).equal())})`,
        margin: "0 auto",
        paddingBottom: e.paddingLG,
        [`${t}-title`]: {
          margin: 0,
          color: e.titleColor,
          fontWeight: e.fontWeightStrong,
          fontSize: e.titleFontSize,
          lineHeight: e.titleLineHeight,
          wordWrap: "break-word"
        },
        [`${t}-content`]: {
          position: "relative",
          backgroundColor: e.contentBg,
          backgroundClip: "padding-box",
          border: 0,
          borderRadius: e.borderRadiusLG,
          boxShadow: e.boxShadow,
          pointerEvents: "auto",
          padding: e.contentPadding
        },
        [`${t}-close`]: Object.assign({
          position: "absolute",
          top: e.calc(e.modalHeaderHeight).sub(e.modalCloseBtnSize).div(2).equal(),
          insetInlineEnd: e.calc(e.modalHeaderHeight).sub(e.modalCloseBtnSize).div(2).equal(),
          zIndex: e.calc(e.zIndexPopupBase).add(10).equal(),
          padding: 0,
          color: e.modalCloseIconColor,
          fontWeight: e.fontWeightStrong,
          lineHeight: 1,
          textDecoration: "none",
          background: "transparent",
          borderRadius: e.borderRadiusSM,
          width: e.modalCloseBtnSize,
          height: e.modalCloseBtnSize,
          border: 0,
          outline: 0,
          cursor: "pointer",
          transition: `color ${e.motionDurationMid}, background-color ${e.motionDurationMid}`,
          "&-x": {
            display: "flex",
            fontSize: e.fontSizeLG,
            fontStyle: "normal",
            lineHeight: `${ve(e.modalCloseBtnSize)}`,
            justifyContent: "center",
            textTransform: "none",
            textRendering: "auto"
          },
          "&:hover": {
            color: e.modalCloseIconHoverColor,
            backgroundColor: e.colorBgTextHover,
            textDecoration: "none"
          },
          "&:active": {
            backgroundColor: e.colorBgTextActive
          }
        }, zs(e)),
        [`${t}-header`]: {
          color: e.colorText,
          background: e.headerBg,
          borderRadius: `${ve(e.borderRadiusLG)} ${ve(e.borderRadiusLG)} 0 0`,
          marginBottom: e.headerMarginBottom,
          padding: e.headerPadding,
          borderBottom: e.headerBorderBottom
        },
        [`${t}-body`]: {
          fontSize: e.fontSize,
          lineHeight: e.lineHeight,
          wordWrap: "break-word",
          padding: e.bodyPadding,
          [`${t}-body-skeleton`]: {
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: `${ve(e.margin)} auto`
          }
        },
        [`${t}-footer`]: {
          textAlign: "end",
          background: e.footerBg,
          marginTop: e.footerMarginTop,
          padding: e.footerPadding,
          borderTop: e.footerBorderTop,
          borderRadius: e.footerBorderRadius,
          [`> ${e.antCls}-btn + ${e.antCls}-btn`]: {
            marginInlineStart: e.marginXS
          }
        },
        [`${t}-open`]: {
          overflow: "hidden"
        }
      })
    },
    // ======================== Pure =========================
    {
      [`${t}-pure-panel`]: {
        top: "auto",
        padding: 0,
        display: "flex",
        flexDirection: "column",
        [`${t}-content,
          ${t}-body,
          ${t}-confirm-body-wrapper`]: {
          display: "flex",
          flexDirection: "column",
          flex: "auto"
        },
        [`${t}-confirm-body`]: {
          marginBottom: "auto"
        }
      }
    }
  ];
}, a0e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-root`]: {
      [`${t}-wrap-rtl`]: {
        direction: "rtl",
        [`${t}-confirm-body`]: {
          direction: "rtl"
        }
      }
    }
  };
}, Qz = (e) => {
  const t = e.padding, r = e.fontSizeHeading5, n = e.lineHeightHeading5;
  return $r(e, {
    modalHeaderHeight: e.calc(e.calc(n).mul(r).equal()).add(e.calc(t).mul(2).equal()).equal(),
    modalFooterBorderColorSplit: e.colorSplit,
    modalFooterBorderStyle: e.lineType,
    modalFooterBorderWidth: e.lineWidth,
    modalCloseIconColor: e.colorIcon,
    modalCloseIconHoverColor: e.colorIconHover,
    modalCloseBtnSize: e.controlHeight,
    modalConfirmIconSize: e.fontHeight,
    modalTitleHeight: e.calc(e.titleFontSize).mul(e.titleLineHeight).equal()
  });
}, eH = (e) => ({
  footerBg: "transparent",
  headerBg: e.colorBgElevated,
  titleLineHeight: e.lineHeightHeading5,
  titleFontSize: e.fontSizeHeading5,
  contentBg: e.colorBgElevated,
  titleColor: e.colorTextHeading,
  // internal
  contentPadding: e.wireframe ? 0 : `${ve(e.paddingMD)} ${ve(e.paddingContentHorizontalLG)}`,
  headerPadding: e.wireframe ? `${ve(e.padding)} ${ve(e.paddingLG)}` : 0,
  headerBorderBottom: e.wireframe ? `${ve(e.lineWidth)} ${e.lineType} ${e.colorSplit}` : "none",
  headerMarginBottom: e.wireframe ? 0 : e.marginXS,
  bodyPadding: e.wireframe ? e.paddingLG : 0,
  footerPadding: e.wireframe ? `${ve(e.paddingXS)} ${ve(e.padding)}` : 0,
  footerBorderTop: e.wireframe ? `${ve(e.lineWidth)} ${e.lineType} ${e.colorSplit}` : "none",
  footerBorderRadius: e.wireframe ? `0 0 ${ve(e.borderRadiusLG)} ${ve(e.borderRadiusLG)}` : 0,
  footerMarginTop: e.wireframe ? 0 : e.marginSM,
  confirmBodyPadding: e.wireframe ? `${ve(e.padding * 2)} ${ve(e.padding * 2)} ${ve(e.paddingLG)}` : 0,
  confirmIconMarginInlineEnd: e.wireframe ? e.margin : e.marginSM,
  confirmBtnsMarginTop: e.wireframe ? e.marginLG : e.marginSM
}), tH = Zr("Modal", (e) => {
  const t = Qz(e);
  return [n0e(t), a0e(t), Jz(t), ph(t, "zoom")];
}, eH, {
  unitless: {
    titleLineHeight: !0
  }
});
var i0e = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
let U2;
const o0e = (e) => {
  U2 = {
    x: e.pageX,
    y: e.pageY
  }, setTimeout(() => {
    U2 = null;
  }, 100);
};
mme() && document.documentElement.addEventListener("click", o0e, !0);
const rH = (e) => {
  var t;
  const {
    getPopupContainer: r,
    getPrefixCls: n,
    direction: a,
    modal: i
  } = p.useContext(Lt), o = (K) => {
    const {
      onCancel: Z
    } = e;
    Z?.(K);
  }, s = (K) => {
    const {
      onOk: Z
    } = e;
    Z?.(K);
  };
  if (process.env.NODE_ENV !== "production") {
    const K = xr("Modal");
    [["visible", "open"], ["bodyStyle", "styles.body"], ["maskStyle", "styles.mask"]].forEach((Z) => {
      let [ee, ae] = Z;
      K.deprecated(!(ee in e), ee, ae);
    });
  }
  const {
    prefixCls: l,
    className: c,
    rootClassName: u,
    open: d,
    wrapClassName: f,
    centered: m,
    getContainer: h,
    focusTriggerAfterClose: g = !0,
    style: y,
    // Deprecated
    visible: S,
    width: x = 520,
    footer: b,
    classNames: _,
    styles: $,
    children: w,
    loading: O
  } = e, T = i0e(e, ["prefixCls", "className", "rootClassName", "open", "wrapClassName", "centered", "getContainer", "focusTriggerAfterClose", "style", "visible", "width", "footer", "classNames", "styles", "children", "loading"]), I = n("modal", l), P = n(), D = Mn(I), [B, L, N] = tH(I, D), z = be(f, {
    [`${I}-centered`]: !!m,
    [`${I}-wrap-rtl`]: a === "rtl"
  }), F = b !== null && !O ? /* @__PURE__ */ p.createElement(Zz, Object.assign({}, e, {
    onOk: s,
    onCancel: o
  })) : null, [j, H] = BT(sd(e), sd(i), {
    closable: !0,
    closeIcon: /* @__PURE__ */ p.createElement(Ys, {
      className: `${I}-close-icon`
    }),
    closeIconRender: (K) => Yz(I, K)
  }), U = Kz(`.${I}-content`), [G, V] = ps("Modal", T.zIndex);
  return B(/* @__PURE__ */ p.createElement(Lc, null, /* @__PURE__ */ p.createElement(UT, {
    status: !0,
    override: !0
  }, /* @__PURE__ */ p.createElement(gd.Provider, {
    value: V
  }, /* @__PURE__ */ p.createElement(FT, Object.assign({
    width: x
  }, T, {
    zIndex: G,
    getContainer: h === void 0 ? r : h,
    prefixCls: I,
    rootClassName: be(L, u, N, D),
    footer: F,
    visible: d ?? S,
    mousePosition: (t = T.mousePosition) !== null && t !== void 0 ? t : U2,
    onClose: o,
    closable: j,
    closeIcon: H,
    focusTriggerAfterClose: g,
    transitionName: Gi(P, "zoom", e.transitionName),
    maskTransitionName: Gi(P, "fade", e.maskTransitionName),
    className: be(L, c, i?.className),
    style: Object.assign(Object.assign({}, i?.style), y),
    classNames: Object.assign(Object.assign(Object.assign({}, i?.classNames), _), {
      wrapper: be(z, _?.wrapper)
    }),
    styles: Object.assign(Object.assign({}, i?.styles), $),
    panelRef: U
  }), O ? /* @__PURE__ */ p.createElement(Ui, {
    active: !0,
    title: !1,
    paragraph: {
      rows: 4
    },
    className: `${I}-body-skeleton`
  }) : w)))));
}, s0e = (e) => {
  const {
    componentCls: t,
    titleFontSize: r,
    titleLineHeight: n,
    modalConfirmIconSize: a,
    fontSize: i,
    lineHeight: o,
    modalTitleHeight: s,
    fontHeight: l,
    confirmBodyPadding: c
  } = e, u = `${t}-confirm`;
  return {
    [u]: {
      "&-rtl": {
        direction: "rtl"
      },
      [`${e.antCls}-modal-header`]: {
        display: "none"
      },
      [`${u}-body-wrapper`]: Object.assign({}, Bs()),
      [`&${t} ${t}-body`]: {
        padding: c
      },
      // ====================== Body ======================
      [`${u}-body`]: {
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "start",
        [`> ${e.iconCls}`]: {
          flex: "none",
          fontSize: a,
          marginInlineEnd: e.confirmIconMarginInlineEnd,
          marginTop: e.calc(e.calc(l).sub(a).equal()).div(2).equal()
        },
        [`&-has-title > ${e.iconCls}`]: {
          marginTop: e.calc(e.calc(s).sub(a).equal()).div(2).equal()
        }
      },
      [`${u}-paragraph`]: {
        display: "flex",
        flexDirection: "column",
        flex: "auto",
        rowGap: e.marginXS
      },
      // https://github.com/ant-design/ant-design/issues/48159
      [`${e.iconCls} + ${u}-paragraph`]: {
        maxWidth: `calc(100% - ${ve(e.calc(e.modalConfirmIconSize).add(e.marginSM).equal())})`
      },
      [`${u}-title`]: {
        color: e.colorTextHeading,
        fontWeight: e.fontWeightStrong,
        fontSize: r,
        lineHeight: n
      },
      [`${u}-content`]: {
        color: e.colorText,
        fontSize: i,
        lineHeight: o
      },
      // ===================== Footer =====================
      [`${u}-btns`]: {
        textAlign: "end",
        marginTop: e.confirmBtnsMarginTop,
        [`${e.antCls}-btn + ${e.antCls}-btn`]: {
          marginBottom: 0,
          marginInlineStart: e.marginXS
        }
      }
    },
    [`${u}-error ${u}-body > ${e.iconCls}`]: {
      color: e.colorError
    },
    [`${u}-warning ${u}-body > ${e.iconCls},
        ${u}-confirm ${u}-body > ${e.iconCls}`]: {
      color: e.colorWarning
    },
    [`${u}-info ${u}-body > ${e.iconCls}`]: {
      color: e.colorInfo
    },
    [`${u}-success ${u}-body > ${e.iconCls}`]: {
      color: e.colorSuccess
    }
  };
}, l0e = vd(["Modal", "confirm"], (e) => {
  const t = Qz(e);
  return [s0e(t)];
}, eH, {
  // confirm is weak than modal since no conflict here
  order: -1e3
});
var c0e = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function nH(e) {
  const {
    prefixCls: t,
    icon: r,
    okText: n,
    cancelText: a,
    confirmPrefixCls: i,
    type: o,
    okCancel: s,
    footer: l,
    // Legacy for static function usage
    locale: c
  } = e, u = c0e(e, ["prefixCls", "icon", "okText", "cancelText", "confirmPrefixCls", "type", "okCancel", "footer", "locale"]);
  if (process.env.NODE_ENV !== "production") {
    const O = xr("Modal");
    process.env.NODE_ENV !== "production" && O(!(typeof r == "string" && r.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${r}\` at https://ant.design/components/icon`);
  }
  let d = r;
  if (!r && r !== null)
    switch (o) {
      case "info":
        d = /* @__PURE__ */ p.createElement(C1, null);
        break;
      case "success":
        d = /* @__PURE__ */ p.createElement(oh, null);
        break;
      case "error":
        d = /* @__PURE__ */ p.createElement(Nc, null);
        break;
      default:
        d = /* @__PURE__ */ p.createElement(sh, null);
    }
  const f = s ?? o === "confirm", m = e.autoFocusButton === null ? !1 : e.autoFocusButton || "ok", [h] = Ks("Modal"), g = c || h, y = n || (f ? g?.okText : g?.justOkText), S = a || g?.cancelText, x = Object.assign({
    autoFocusButton: m,
    cancelTextLocale: S,
    okTextLocale: y,
    mergedOkCancel: f
  }, u), b = p.useMemo(() => x, ze(Object.values(x))), _ = /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement(wR, null), /* @__PURE__ */ p.createElement(OR, null)), $ = e.title !== void 0 && e.title !== null, w = `${i}-body`;
  return /* @__PURE__ */ p.createElement("div", {
    className: `${i}-body-wrapper`
  }, /* @__PURE__ */ p.createElement("div", {
    className: be(w, {
      [`${w}-has-title`]: $
    })
  }, d, /* @__PURE__ */ p.createElement("div", {
    className: `${i}-paragraph`
  }, $ && /* @__PURE__ */ p.createElement("span", {
    className: `${i}-title`
  }, e.title), /* @__PURE__ */ p.createElement("div", {
    className: `${i}-content`
  }, e.content))), l === void 0 || typeof l == "function" ? /* @__PURE__ */ p.createElement(Iz, {
    value: b
  }, /* @__PURE__ */ p.createElement("div", {
    className: `${i}-btns`
  }, typeof l == "function" ? l(_, {
    OkBtn: OR,
    CancelBtn: wR
  }) : _)) : l, /* @__PURE__ */ p.createElement(l0e, {
    prefixCls: t
  }));
}
const aH = (e) => {
  const {
    close: t,
    zIndex: r,
    afterClose: n,
    open: a,
    keyboard: i,
    centered: o,
    getContainer: s,
    maskStyle: l,
    direction: c,
    prefixCls: u,
    wrapClassName: d,
    rootPrefixCls: f,
    bodyStyle: m,
    closable: h = !1,
    closeIcon: g,
    modalRender: y,
    focusTriggerAfterClose: S,
    onConfirm: x,
    styles: b
  } = e;
  if (process.env.NODE_ENV !== "production") {
    const B = xr("Modal");
    [["visible", "open"], ["bodyStyle", "styles.body"], ["maskStyle", "styles.mask"]].forEach((L) => {
      let [N, z] = L;
      B.deprecated(!(N in e), N, z);
    });
  }
  const _ = `${u}-confirm`, $ = e.width || 416, w = e.style || {}, O = e.mask === void 0 ? !0 : e.mask, T = e.maskClosable === void 0 ? !1 : e.maskClosable, I = be(_, `${_}-${e.type}`, {
    [`${_}-rtl`]: c === "rtl"
  }, e.className), [, P] = ua(), D = p.useMemo(() => r !== void 0 ? r : P.zIndexPopupBase + S1, [r, P]);
  return /* @__PURE__ */ p.createElement(rH, {
    prefixCls: u,
    className: I,
    wrapClassName: be({
      [`${_}-centered`]: !!e.centered
    }, d),
    onCancel: () => {
      t?.({
        triggerCancel: !0
      }), x?.(!1);
    },
    open: a,
    title: "",
    footer: null,
    transitionName: Gi(f || "", "zoom", e.transitionName),
    maskTransitionName: Gi(f || "", "fade", e.maskTransitionName),
    mask: O,
    maskClosable: T,
    style: w,
    styles: Object.assign({
      body: m,
      mask: l
    }, b),
    width: $,
    zIndex: D,
    afterClose: n,
    keyboard: i,
    centered: o,
    getContainer: s,
    closable: h,
    closeIcon: g,
    modalRender: y,
    focusTriggerAfterClose: S
  }, /* @__PURE__ */ p.createElement(nH, Object.assign({}, e, {
    confirmPrefixCls: _
  })));
}, KT = (e) => {
  const {
    rootPrefixCls: t,
    iconPrefixCls: r,
    direction: n,
    theme: a
  } = e;
  return /* @__PURE__ */ p.createElement(Fo, {
    prefixCls: t,
    iconPrefixCls: r,
    direction: n,
    theme: a
  }, /* @__PURE__ */ p.createElement(aH, Object.assign({}, e)));
};
process.env.NODE_ENV !== "production" && (aH.displayName = "ConfirmDialog", KT.displayName = "ConfirmDialogWrapper");
const dc = [];
let iH = "";
function oH() {
  return iH;
}
const u0e = (e) => {
  var t, r;
  const {
    prefixCls: n,
    getContainer: a,
    direction: i
  } = e, o = CB(), s = Cr(Lt), l = oH() || s.getPrefixCls(), c = n || `${l}-modal`;
  let u = a;
  return u === !1 && (u = void 0, process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && Rc(!1, "Modal", "Static method not support `getContainer` to be `false` since it do not have context env.")), /* @__PURE__ */ xe.createElement(KT, Object.assign({}, e, {
    rootPrefixCls: l,
    prefixCls: c,
    iconPrefixCls: s.iconPrefixCls,
    theme: s.theme,
    direction: i ?? s.direction,
    locale: (r = (t = s.locale) === null || t === void 0 ? void 0 : t.Modal) !== null && r !== void 0 ? r : o,
    getContainer: u
  }));
};
function mh(e) {
  const t = RT();
  process.env.NODE_ENV !== "production" && !t.holderRender && ZB("Modal");
  const r = document.createDocumentFragment();
  let n = Object.assign(Object.assign({}, e), {
    close: s,
    open: !0
  }), a;
  function i() {
    for (var c = arguments.length, u = new Array(c), d = 0; d < c; d++)
      u[d] = arguments[d];
    const f = u.some((m) => m && m.triggerCancel);
    e.onCancel && f && e.onCancel.apply(e, [() => {
    }].concat(ze(u.slice(1))));
    for (let m = 0; m < dc.length; m++)
      if (dc[m] === s) {
        dc.splice(m, 1);
        break;
      }
    yz(r);
  }
  function o(c) {
    clearTimeout(a), a = setTimeout(() => {
      const u = t.getPrefixCls(void 0, oH()), d = t.getIconPrefixCls(), f = t.getTheme(), m = /* @__PURE__ */ xe.createElement(u0e, Object.assign({}, c));
      DT(/* @__PURE__ */ xe.createElement(Fo, {
        prefixCls: u,
        iconPrefixCls: d,
        theme: f
      }, t.holderRender ? t.holderRender(m) : m), r);
    });
  }
  function s() {
    for (var c = arguments.length, u = new Array(c), d = 0; d < c; d++)
      u[d] = arguments[d];
    n = Object.assign(Object.assign({}, n), {
      open: !1,
      afterClose: () => {
        typeof e.afterClose == "function" && e.afterClose(), i.apply(this, u);
      }
    }), n.visible && delete n.visible, o(n);
  }
  function l(c) {
    typeof c == "function" ? n = c(n) : n = Object.assign(Object.assign({}, n), c), o(n);
  }
  return o(n), dc.push(s), {
    destroy: s,
    update: l
  };
}
function sH(e) {
  return Object.assign(Object.assign({}, e), {
    type: "warning"
  });
}
function lH(e) {
  return Object.assign(Object.assign({}, e), {
    type: "info"
  });
}
function cH(e) {
  return Object.assign(Object.assign({}, e), {
    type: "success"
  });
}
function uH(e) {
  return Object.assign(Object.assign({}, e), {
    type: "error"
  });
}
function dH(e) {
  return Object.assign(Object.assign({}, e), {
    type: "confirm"
  });
}
function d0e(e) {
  let {
    rootPrefixCls: t
  } = e;
  process.env.NODE_ENV !== "production" && Rc(!1, "Modal", "Modal.config is deprecated. Please use ConfigProvider.config instead."), iH = t;
}
var f0e = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const p0e = (e, t) => {
  var r, {
    afterClose: n,
    config: a
  } = e, i = f0e(e, ["afterClose", "config"]);
  const [o, s] = p.useState(!0), [l, c] = p.useState(a), {
    direction: u,
    getPrefixCls: d
  } = p.useContext(Lt), f = d("modal"), m = d(), h = () => {
    var x;
    n(), (x = l.afterClose) === null || x === void 0 || x.call(l);
  }, g = function() {
    s(!1);
    for (var x = arguments.length, b = new Array(x), _ = 0; _ < x; _++)
      b[_] = arguments[_];
    const $ = b.some((w) => w && w.triggerCancel);
    l.onCancel && $ && l.onCancel.apply(l, [() => {
    }].concat(ze(b.slice(1))));
  };
  p.useImperativeHandle(t, () => ({
    destroy: g,
    update: (x) => {
      c((b) => Object.assign(Object.assign({}, b), x));
    }
  }));
  const y = (r = l.okCancel) !== null && r !== void 0 ? r : l.type === "confirm", [S] = Ks("Modal", jo.Modal);
  return /* @__PURE__ */ p.createElement(KT, Object.assign({
    prefixCls: f,
    rootPrefixCls: m
  }, l, {
    close: g,
    open: o,
    afterClose: h,
    okText: l.okText || (y ? S?.okText : S?.justOkText),
    direction: l.direction || u,
    cancelText: l.cancelText || S?.cancelText
  }, i));
}, m0e = /* @__PURE__ */ p.forwardRef(p0e);
let nN = 0;
const v0e = /* @__PURE__ */ p.memo(/* @__PURE__ */ p.forwardRef((e, t) => {
  const [r, n] = rpe();
  return p.useImperativeHandle(t, () => ({
    patchElement: n
  }), []), /* @__PURE__ */ p.createElement(p.Fragment, null, r);
}));
function fH() {
  const e = p.useRef(null), [t, r] = p.useState([]);
  p.useEffect(() => {
    t.length && (ze(t).forEach((o) => {
      o();
    }), r([]));
  }, [t]);
  const n = p.useCallback((i) => function(s) {
    var l;
    nN += 1;
    const c = /* @__PURE__ */ p.createRef();
    let u;
    const d = new Promise((y) => {
      u = y;
    });
    let f = !1, m;
    const h = /* @__PURE__ */ p.createElement(m0e, {
      key: `modal-${nN}`,
      config: i(s),
      ref: c,
      afterClose: () => {
        m?.();
      },
      isSilent: () => f,
      onConfirm: (y) => {
        u(y);
      }
    });
    return m = (l = e.current) === null || l === void 0 ? void 0 : l.patchElement(h), m && dc.push(m), {
      destroy: () => {
        function y() {
          var S;
          (S = c.current) === null || S === void 0 || S.destroy();
        }
        c.current ? y() : r((S) => [].concat(ze(S), [y]));
      },
      update: (y) => {
        function S() {
          var x;
          (x = c.current) === null || x === void 0 || x.update(y);
        }
        c.current ? S() : r((x) => [].concat(ze(x), [S]));
      },
      then: (y) => (f = !0, d.then(y))
    };
  }, []);
  return [p.useMemo(() => ({
    info: n(lH),
    success: n(cH),
    error: n(uH),
    warning: n(sH),
    confirm: n(dH)
  }), []), /* @__PURE__ */ p.createElement(v0e, {
    key: "modal-holder",
    ref: e
  })];
}
const h0e = (e) => {
  const {
    componentCls: t,
    notificationMarginEdge: r,
    animationMaxHeight: n
  } = e, a = `${t}-notice`, i = new Pr("antNotificationFadeIn", {
    "0%": {
      transform: "translate3d(100%, 0, 0)",
      opacity: 0
    },
    "100%": {
      transform: "translate3d(0, 0, 0)",
      opacity: 1
    }
  }), o = new Pr("antNotificationTopFadeIn", {
    "0%": {
      top: -n,
      opacity: 0
    },
    "100%": {
      top: 0,
      opacity: 1
    }
  }), s = new Pr("antNotificationBottomFadeIn", {
    "0%": {
      bottom: e.calc(n).mul(-1).equal(),
      opacity: 0
    },
    "100%": {
      bottom: 0,
      opacity: 1
    }
  }), l = new Pr("antNotificationLeftFadeIn", {
    "0%": {
      transform: "translate3d(-100%, 0, 0)",
      opacity: 0
    },
    "100%": {
      transform: "translate3d(0, 0, 0)",
      opacity: 1
    }
  });
  return {
    [t]: {
      [`&${t}-top, &${t}-bottom`]: {
        marginInline: 0,
        [a]: {
          marginInline: "auto auto"
        }
      },
      [`&${t}-top`]: {
        [`${t}-fade-enter${t}-fade-enter-active, ${t}-fade-appear${t}-fade-appear-active`]: {
          animationName: o
        }
      },
      [`&${t}-bottom`]: {
        [`${t}-fade-enter${t}-fade-enter-active, ${t}-fade-appear${t}-fade-appear-active`]: {
          animationName: s
        }
      },
      [`&${t}-topRight, &${t}-bottomRight`]: {
        [`${t}-fade-enter${t}-fade-enter-active, ${t}-fade-appear${t}-fade-appear-active`]: {
          animationName: i
        }
      },
      [`&${t}-topLeft, &${t}-bottomLeft`]: {
        marginRight: {
          value: 0,
          _skip_check_: !0
        },
        marginLeft: {
          value: r,
          _skip_check_: !0
        },
        [a]: {
          marginInlineEnd: "auto",
          marginInlineStart: 0
        },
        [`${t}-fade-enter${t}-fade-enter-active, ${t}-fade-appear${t}-fade-appear-active`]: {
          animationName: l
        }
      }
    }
  };
}, g0e = ["top", "topLeft", "topRight", "bottom", "bottomLeft", "bottomRight"], y0e = {
  topLeft: "left",
  topRight: "right",
  bottomLeft: "left",
  bottomRight: "right",
  top: "left",
  bottom: "left"
}, b0e = (e, t) => {
  const {
    componentCls: r
  } = e;
  return {
    [`${r}-${t}`]: {
      [`&${r}-stack > ${r}-notice-wrapper`]: {
        [t.startsWith("top") ? "top" : "bottom"]: 0,
        [y0e[t]]: {
          value: 0,
          _skip_check_: !0
        }
      }
    }
  };
}, C0e = (e) => {
  const t = {};
  for (let r = 1; r < e.notificationStackLayer; r++)
    t[`&:nth-last-child(${r + 1})`] = {
      overflow: "hidden",
      [`& > ${e.componentCls}-notice`]: {
        opacity: 0,
        transition: `opacity ${e.motionDurationMid}`
      }
    };
  return Object.assign({
    [`&:not(:nth-last-child(-n+${e.notificationStackLayer}))`]: {
      opacity: 0,
      overflow: "hidden",
      color: "transparent",
      pointerEvents: "none"
    }
  }, t);
}, S0e = (e) => {
  const t = {};
  for (let r = 1; r < e.notificationStackLayer; r++)
    t[`&:nth-last-child(${r + 1})`] = {
      background: e.colorBgBlur,
      backdropFilter: "blur(10px)",
      "-webkit-backdrop-filter": "blur(10px)"
    };
  return Object.assign({}, t);
}, x0e = (e) => {
  const {
    componentCls: t
  } = e;
  return Object.assign({
    [`${t}-stack`]: {
      [`& > ${t}-notice-wrapper`]: Object.assign({
        transition: `all ${e.motionDurationSlow}, backdrop-filter 0s`,
        position: "absolute"
      }, C0e(e))
    },
    [`${t}-stack:not(${t}-stack-expanded)`]: {
      [`& > ${t}-notice-wrapper`]: Object.assign({}, S0e(e))
    },
    [`${t}-stack${t}-stack-expanded`]: {
      [`& > ${t}-notice-wrapper`]: {
        "&:not(:nth-last-child(-n + 1))": {
          opacity: 1,
          overflow: "unset",
          color: "inherit",
          pointerEvents: "auto",
          [`& > ${e.componentCls}-notice`]: {
            opacity: 1
          }
        },
        "&:after": {
          content: '""',
          position: "absolute",
          height: e.margin,
          width: "100%",
          insetInline: 0,
          bottom: e.calc(e.margin).mul(-1).equal(),
          background: "transparent",
          pointerEvents: "auto"
        }
      }
    }
  }, g0e.map((r) => b0e(e, r)).reduce((r, n) => Object.assign(Object.assign({}, r), n), {}));
}, $0e = (e) => {
  const {
    iconCls: t,
    componentCls: r,
    // .ant-notification
    boxShadow: n,
    fontSizeLG: a,
    notificationMarginBottom: i,
    borderRadiusLG: o,
    colorSuccess: s,
    colorInfo: l,
    colorWarning: c,
    colorError: u,
    colorTextHeading: d,
    notificationBg: f,
    notificationPadding: m,
    notificationMarginEdge: h,
    notificationProgressBg: g,
    notificationProgressHeight: y,
    fontSize: S,
    lineHeight: x,
    width: b,
    notificationIconSize: _,
    colorText: $
  } = e, w = `${r}-notice`;
  return {
    position: "relative",
    marginBottom: i,
    marginInlineStart: "auto",
    background: f,
    borderRadius: o,
    boxShadow: n,
    [w]: {
      padding: m,
      width: b,
      maxWidth: `calc(100vw - ${ve(e.calc(h).mul(2).equal())})`,
      overflow: "hidden",
      lineHeight: x,
      wordWrap: "break-word"
    },
    [`${w}-message`]: {
      marginBottom: e.marginXS,
      color: d,
      fontSize: a,
      lineHeight: e.lineHeightLG
    },
    [`${w}-description`]: {
      fontSize: S,
      color: $
    },
    [`${w}-closable ${w}-message`]: {
      paddingInlineEnd: e.paddingLG
    },
    [`${w}-with-icon ${w}-message`]: {
      marginBottom: e.marginXS,
      marginInlineStart: e.calc(e.marginSM).add(_).equal(),
      fontSize: a
    },
    [`${w}-with-icon ${w}-description`]: {
      marginInlineStart: e.calc(e.marginSM).add(_).equal(),
      fontSize: S
    },
    // Icon & color style in different selector level
    // https://github.com/ant-design/ant-design/issues/16503
    // https://github.com/ant-design/ant-design/issues/15512
    [`${w}-icon`]: {
      position: "absolute",
      fontSize: _,
      lineHeight: 1,
      // icon-font
      [`&-success${t}`]: {
        color: s
      },
      [`&-info${t}`]: {
        color: l
      },
      [`&-warning${t}`]: {
        color: c
      },
      [`&-error${t}`]: {
        color: u
      }
    },
    [`${w}-close`]: Object.assign({
      position: "absolute",
      top: e.notificationPaddingVertical,
      insetInlineEnd: e.notificationPaddingHorizontal,
      color: e.colorIcon,
      outline: "none",
      width: e.notificationCloseButtonSize,
      height: e.notificationCloseButtonSize,
      borderRadius: e.borderRadiusSM,
      transition: `background-color ${e.motionDurationMid}, color ${e.motionDurationMid}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover": {
        color: e.colorIconHover,
        backgroundColor: e.colorBgTextHover
      },
      "&:active": {
        backgroundColor: e.colorBgTextActive
      }
    }, zs(e)),
    [`${w}-progress`]: {
      position: "absolute",
      display: "block",
      appearance: "none",
      WebkitAppearance: "none",
      inlineSize: `calc(100% - ${ve(o)} * 2)`,
      left: {
        _skip_check_: !0,
        value: o
      },
      right: {
        _skip_check_: !0,
        value: o
      },
      bottom: 0,
      blockSize: y,
      border: 0,
      "&, &::-webkit-progress-bar": {
        borderRadius: o,
        backgroundColor: "rgba(0, 0, 0, 0.04)"
      },
      "&::-moz-progress-bar": {
        background: g
      },
      "&::-webkit-progress-value": {
        borderRadius: o,
        background: g
      }
    },
    [`${w}-btn`]: {
      float: "right",
      marginTop: e.marginSM
    }
  };
}, _0e = (e) => {
  const {
    componentCls: t,
    // .ant-notification
    notificationMarginBottom: r,
    notificationMarginEdge: n,
    motionDurationMid: a,
    motionEaseInOut: i
  } = e, o = `${t}-notice`, s = new Pr("antNotificationFadeOut", {
    "0%": {
      maxHeight: e.animationMaxHeight,
      marginBottom: r
    },
    "100%": {
      maxHeight: 0,
      marginBottom: 0,
      paddingTop: 0,
      paddingBottom: 0,
      opacity: 0
    }
  });
  return [
    // ============================ Holder ============================
    {
      [t]: Object.assign(Object.assign({}, Yr(e)), {
        position: "fixed",
        zIndex: e.zIndexPopup,
        marginRight: {
          value: n,
          _skip_check_: !0
        },
        [`${t}-hook-holder`]: {
          position: "relative"
        },
        //  animation
        [`${t}-fade-appear-prepare`]: {
          opacity: "0 !important"
        },
        [`${t}-fade-enter, ${t}-fade-appear`]: {
          animationDuration: e.motionDurationMid,
          animationTimingFunction: i,
          animationFillMode: "both",
          opacity: 0,
          animationPlayState: "paused"
        },
        [`${t}-fade-leave`]: {
          animationTimingFunction: i,
          animationFillMode: "both",
          animationDuration: a,
          animationPlayState: "paused"
        },
        [`${t}-fade-enter${t}-fade-enter-active, ${t}-fade-appear${t}-fade-appear-active`]: {
          animationPlayState: "running"
        },
        [`${t}-fade-leave${t}-fade-leave-active`]: {
          animationName: s,
          animationPlayState: "running"
        },
        // RTL
        "&-rtl": {
          direction: "rtl",
          [`${o}-btn`]: {
            float: "left"
          }
        }
      })
    },
    // ============================ Notice ============================
    {
      [t]: {
        [`${o}-wrapper`]: Object.assign({}, $0e(e))
      }
    }
  ];
}, E0e = (e) => ({
  zIndexPopup: e.zIndexPopupBase + S1 + 50,
  width: 384
}), w0e = (e) => {
  const t = e.paddingMD, r = e.paddingLG;
  return $r(e, {
    notificationBg: e.colorBgElevated,
    notificationPaddingVertical: t,
    notificationPaddingHorizontal: r,
    notificationIconSize: e.calc(e.fontSizeLG).mul(e.lineHeightLG).equal(),
    notificationCloseButtonSize: e.calc(e.controlHeightLG).mul(0.55).equal(),
    notificationMarginBottom: e.margin,
    notificationPadding: `${ve(e.paddingMD)} ${ve(e.paddingContentHorizontalLG)}`,
    notificationMarginEdge: e.marginLG,
    animationMaxHeight: 150,
    notificationStackLayer: 3,
    notificationProgressHeight: 2,
    notificationProgressBg: `linear-gradient(90deg, ${e.colorPrimaryBorderHover}, ${e.colorPrimary})`
  });
}, O0e = Zr("Notification", (e) => {
  const t = w0e(e);
  return [_0e(t), h0e(t), x0e(t)];
}, E0e);
function pH(e, t) {
  return t === null || t === !1 ? null : t || /* @__PURE__ */ p.createElement(Ys, {
    className: `${e}-close-icon`
  });
}
const T0e = {
  success: oh,
  info: C1,
  error: Nc,
  warning: sh
}, I0e = (e) => {
  const {
    prefixCls: t,
    icon: r,
    type: n,
    message: a,
    description: i,
    btn: o,
    role: s = "alert"
  } = e;
  let l = null;
  return r ? l = /* @__PURE__ */ p.createElement("span", {
    className: `${t}-icon`
  }, r) : n && (l = /* @__PURE__ */ p.createElement(T0e[n] || null, {
    className: be(`${t}-icon`, `${t}-icon-${n}`)
  })), /* @__PURE__ */ p.createElement("div", {
    className: be({
      [`${t}-with-icon`]: l
    }),
    role: s
  }, l, /* @__PURE__ */ p.createElement("div", {
    className: `${t}-message`
  }, a), /* @__PURE__ */ p.createElement("div", {
    className: `${t}-description`
  }, i), o && /* @__PURE__ */ p.createElement("div", {
    className: `${t}-btn`
  }, o));
};
function M0e(e, t, r) {
  let n;
  switch (e) {
    case "top":
      n = {
        left: "50%",
        transform: "translateX(-50%)",
        right: "auto",
        top: t,
        bottom: "auto"
      };
      break;
    case "topLeft":
      n = {
        left: 0,
        top: t,
        bottom: "auto"
      };
      break;
    case "topRight":
      n = {
        right: 0,
        top: t,
        bottom: "auto"
      };
      break;
    case "bottom":
      n = {
        left: "50%",
        transform: "translateX(-50%)",
        right: "auto",
        top: "auto",
        bottom: r
      };
      break;
    case "bottomLeft":
      n = {
        left: 0,
        top: "auto",
        bottom: r
      };
      break;
    default:
      n = {
        right: 0,
        top: "auto",
        bottom: r
      };
      break;
  }
  return n;
}
function A0e(e) {
  return {
    motionName: `${e}-fade`
  };
}
var P0e = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const aN = 24, R0e = 4.5, N0e = "topRight", D0e = (e) => {
  let {
    children: t,
    prefixCls: r
  } = e;
  const n = Mn(r), [a, i, o] = O0e(r, n);
  return a(/* @__PURE__ */ xe.createElement(cz, {
    classNames: {
      list: be(i, o, n)
    }
  }, t));
}, j0e = (e, t) => {
  let {
    prefixCls: r,
    key: n
  } = t;
  return /* @__PURE__ */ xe.createElement(D0e, {
    prefixCls: r,
    key: n
  }, e);
}, L0e = /* @__PURE__ */ xe.forwardRef((e, t) => {
  const {
    top: r,
    bottom: n,
    prefixCls: a,
    getContainer: i,
    maxCount: o,
    rtl: s,
    onAllRemoved: l,
    stack: c,
    duration: u,
    pauseOnHover: d = !0,
    showProgress: f
  } = e, {
    getPrefixCls: m,
    getPopupContainer: h,
    notification: g,
    direction: y
  } = Cr(Lt), [, S] = ua(), x = a || m("notification"), b = (T) => M0e(T, r ?? aN, n ?? aN), _ = () => be({
    [`${x}-rtl`]: s ?? y === "rtl"
  }), $ = () => A0e(x), [w, O] = fz({
    prefixCls: x,
    style: b,
    className: _,
    motion: $,
    closable: !0,
    closeIcon: pH(x),
    duration: u ?? R0e,
    getContainer: () => i?.() || h?.() || document.body,
    maxCount: o,
    pauseOnHover: d,
    showProgress: f,
    onAllRemoved: l,
    renderNotifications: j0e,
    stack: c === !1 ? !1 : {
      threshold: typeof c == "object" ? c?.threshold : void 0,
      offset: 8,
      gap: S.margin
    }
  });
  return xe.useImperativeHandle(t, () => Object.assign(Object.assign({}, w), {
    prefixCls: x,
    notification: g
  })), O;
});
function k0e(e) {
  const t = xe.useRef(null), r = xr("Notification");
  return [xe.useMemo(() => {
    const a = (l) => {
      var c;
      if (!t.current) {
        process.env.NODE_ENV !== "production" && r(!1, "usage", "You are calling notice in render which will break in React 18 concurrent mode. Please trigger in effect instead.");
        return;
      }
      const {
        open: u,
        prefixCls: d,
        notification: f
      } = t.current, m = `${d}-notice`, {
        message: h,
        description: g,
        icon: y,
        type: S,
        btn: x,
        className: b,
        style: _,
        role: $ = "alert",
        closeIcon: w,
        closable: O
      } = l, T = P0e(l, ["message", "description", "icon", "type", "btn", "className", "style", "role", "closeIcon", "closable"]), I = pH(m, typeof w < "u" ? w : f?.closeIcon);
      return u(Object.assign(Object.assign({
        // use placement from props instead of hard-coding "topRight"
        placement: (c = e?.placement) !== null && c !== void 0 ? c : N0e
      }, T), {
        content: /* @__PURE__ */ xe.createElement(I0e, {
          prefixCls: m,
          icon: y,
          type: S,
          message: h,
          description: g,
          btn: x,
          role: $
        }),
        className: be(S && `${m}-${S}`, b, f?.className),
        style: Object.assign(Object.assign({}, f?.style), _),
        closeIcon: I,
        closable: O ?? !!I
      }));
    }, o = {
      open: a,
      destroy: (l) => {
        var c, u;
        l !== void 0 ? (c = t.current) === null || c === void 0 || c.close(l) : (u = t.current) === null || u === void 0 || u.destroy();
      }
    };
    return ["success", "info", "warning", "error"].forEach((l) => {
      o[l] = (c) => a(Object.assign(Object.assign({}, c), {
        type: l
      }));
    }), o;
  }, []), /* @__PURE__ */ xe.createElement(L0e, Object.assign({
    key: "notification-holder"
  }, e, {
    ref: t
  }))];
}
function F0e(e) {
  return k0e(e);
}
const W2 = /* @__PURE__ */ xe.createContext({}), mH = /* @__PURE__ */ xe.createContext({
  message: {},
  notification: {},
  modal: {}
}), B0e = (e) => {
  const {
    componentCls: t,
    colorText: r,
    fontSize: n,
    lineHeight: a,
    fontFamily: i
  } = e;
  return {
    [t]: {
      color: r,
      fontSize: n,
      lineHeight: a,
      fontFamily: i
    }
  };
}, z0e = () => ({}), H0e = Zr("App", B0e, z0e), V0e = () => xe.useContext(mH), YT = (e) => {
  const {
    prefixCls: t,
    children: r,
    className: n,
    rootClassName: a,
    message: i,
    notification: o,
    style: s,
    component: l = "div"
  } = e, {
    getPrefixCls: c
  } = Cr(Lt), u = c("app", t), [d, f, m] = H0e(u), h = be(f, u, n, a, m), g = Cr(W2), y = xe.useMemo(() => ({
    message: Object.assign(Object.assign({}, g.message), i),
    notification: Object.assign(Object.assign({}, g.notification), o)
  }), [i, o, g.message, g.notification]), [S, x] = gz(y.message), [b, _] = F0e(y.notification), [$, w] = fH(), O = xe.useMemo(() => ({
    message: S,
    notification: b,
    modal: $
  }), [S, b, $]);
  xr("App")(!(m && l === !1), "usage", "When using cssVar, ensure `component` is assigned a valid React component string.");
  const T = l === !1 ? xe.Fragment : l, I = {
    className: h,
    style: s
  };
  return d(/* @__PURE__ */ xe.createElement(mH.Provider, {
    value: O
  }, /* @__PURE__ */ xe.createElement(W2.Provider, {
    value: y
  }, /* @__PURE__ */ xe.createElement(T, Object.assign({}, l === !1 ? void 0 : I), w, x, _, r))));
};
process.env.NODE_ENV !== "production" && (YT.displayName = "App");
YT.useApp = V0e;
function vH(e) {
  return (t) => /* @__PURE__ */ p.createElement(Fo, {
    theme: {
      token: {
        motion: !1,
        zIndexPopupBase: 0
      }
    }
  }, /* @__PURE__ */ p.createElement(e, Object.assign({}, t)));
}
const P1 = (e, t, r, n) => vH((i) => {
  const {
    prefixCls: o,
    style: s
  } = i, l = p.useRef(null), [c, u] = p.useState(0), [d, f] = p.useState(0), [m, h] = Kr(!1, {
    value: i.open
  }), {
    getPrefixCls: g
  } = p.useContext(Lt), y = g(t || "select", o);
  p.useEffect(() => {
    if (h(!0), typeof ResizeObserver < "u") {
      const b = new ResizeObserver(($) => {
        const w = $[0].target;
        u(w.offsetHeight + 8), f(w.offsetWidth);
      }), _ = setInterval(() => {
        var $;
        const w = r ? `.${r(y)}` : `.${y}-dropdown`, O = ($ = l.current) === null || $ === void 0 ? void 0 : $.querySelector(w);
        O && (clearInterval(_), b.observe(O));
      }, 10);
      return () => {
        clearInterval(_), b.disconnect();
      };
    }
  }, []);
  let S = Object.assign(Object.assign({}, i), {
    style: Object.assign(Object.assign({}, s), {
      margin: 0
    }),
    open: m,
    visible: m,
    getPopupContainer: () => l.current
  });
  n && (S = n(S));
  const x = {
    paddingBottom: c,
    position: "relative",
    minWidth: d
  };
  return /* @__PURE__ */ p.createElement("div", {
    ref: l,
    style: x
  }, /* @__PURE__ */ p.createElement(e, Object.assign({}, S)));
}), R1 = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var e = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e?.substr(0, 4));
};
var N1 = function(t) {
  var r = t.className, n = t.customizeIcon, a = t.customizeIconProps, i = t.children, o = t.onMouseDown, s = t.onClick, l = typeof n == "function" ? n(a) : n;
  return /* @__PURE__ */ p.createElement("span", {
    className: r,
    onMouseDown: function(u) {
      u.preventDefault(), o?.(u);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick: s,
    "aria-hidden": !0
  }, l !== void 0 ? l : /* @__PURE__ */ p.createElement("span", {
    className: be(r.split(/\s+/).map(function(c) {
      return "".concat(c, "-icon");
    }))
  }, i));
}, G0e = function(t, r, n, a, i) {
  var o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, s = arguments.length > 6 ? arguments[6] : void 0, l = arguments.length > 7 ? arguments[7] : void 0, c = xe.useMemo(function() {
    if (kt(a) === "object")
      return a.clearIcon;
    if (i)
      return i;
  }, [a, i]), u = xe.useMemo(function() {
    return !!(!o && a && (n.length || s) && !(l === "combobox" && s === ""));
  }, [a, o, n.length, s, l]);
  return {
    allowClear: u,
    clearIcon: /* @__PURE__ */ xe.createElement(N1, {
      className: "".concat(t, "-clear"),
      onMouseDown: r,
      customizeIcon: c
    }, "×")
  };
}, hH = /* @__PURE__ */ p.createContext(null);
function U0e() {
  return p.useContext(hH);
}
function W0e() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, t = p.useState(!1), r = ye(t, 2), n = r[0], a = r[1], i = p.useRef(null), o = function() {
    window.clearTimeout(i.current);
  };
  p.useEffect(function() {
    return o;
  }, []);
  var s = function(c, u) {
    o(), i.current = window.setTimeout(function() {
      a(c), u && u();
    }, e);
  };
  return [n, s, o];
}
function gH() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250, t = p.useRef(null), r = p.useRef(null);
  p.useEffect(function() {
    return function() {
      window.clearTimeout(r.current);
    };
  }, []);
  function n(a) {
    (a || t.current === null) && (t.current = a), window.clearTimeout(r.current), r.current = window.setTimeout(function() {
      t.current = null;
    }, e);
  }
  return [function() {
    return t.current;
  }, n];
}
function q0e(e, t, r, n) {
  var a = p.useRef(null);
  a.current = {
    open: t,
    triggerOpen: r,
    customizedTrigger: n
  }, p.useEffect(function() {
    function i(o) {
      var s;
      if (!((s = a.current) !== null && s !== void 0 && s.customizedTrigger)) {
        var l = o.target;
        l.shadowRoot && o.composed && (l = o.composedPath()[0] || l), a.current.open && e().filter(function(c) {
          return c;
        }).every(function(c) {
          return !c.contains(l) && c !== l;
        }) && a.current.triggerOpen(!1);
      }
    }
    return window.addEventListener("mousedown", i), function() {
      return window.removeEventListener("mousedown", i);
    };
  }, []);
}
function K0e(e) {
  return ![
    // System function button
    Mt.ESC,
    Mt.SHIFT,
    Mt.BACKSPACE,
    Mt.TAB,
    Mt.WIN_KEY,
    Mt.ALT,
    Mt.META,
    Mt.WIN_KEY_RIGHT,
    Mt.CTRL,
    Mt.SEMICOLON,
    Mt.EQUALS,
    Mt.CAPS_LOCK,
    Mt.CONTEXT_MENU,
    // F1-F12
    Mt.F1,
    Mt.F2,
    Mt.F3,
    Mt.F4,
    Mt.F5,
    Mt.F6,
    Mt.F7,
    Mt.F8,
    Mt.F9,
    Mt.F10,
    Mt.F11,
    Mt.F12
  ].includes(e);
}
var Y0e = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], gu = void 0;
function Z0e(e, t) {
  var r = e.prefixCls, n = e.invalidate, a = e.item, i = e.renderItem, o = e.responsive, s = e.responsiveDisabled, l = e.registerSize, c = e.itemKey, u = e.className, d = e.style, f = e.children, m = e.display, h = e.order, g = e.component, y = g === void 0 ? "div" : g, S = Kt(e, Y0e), x = o && !m;
  function b(T) {
    l(c, T);
  }
  p.useEffect(function() {
    return function() {
      b(null);
    };
  }, []);
  var _ = i && a !== gu ? i(a) : f, $;
  n || ($ = {
    opacity: x ? 0 : 1,
    height: x ? 0 : gu,
    overflowY: x ? "hidden" : gu,
    order: o ? h : gu,
    pointerEvents: x ? "none" : gu,
    position: x ? "absolute" : gu
  });
  var w = {};
  x && (w["aria-hidden"] = !0);
  var O = /* @__PURE__ */ p.createElement(y, Pe({
    className: be(!n && r, u),
    style: ce(ce({}, $), d)
  }, w, S, {
    ref: t
  }), _);
  return o && (O = /* @__PURE__ */ p.createElement(Ia, {
    onResize: function(I) {
      var P = I.offsetWidth;
      b(P);
    },
    disabled: s
  }, O)), O;
}
var R0 = /* @__PURE__ */ p.forwardRef(Z0e);
R0.displayName = "Item";
function X0e(e) {
  if (typeof MessageChannel > "u")
    vr(e);
  else {
    var t = new MessageChannel();
    t.port1.onmessage = function() {
      return e();
    }, t.port2.postMessage(void 0);
  }
}
function J0e() {
  var e = p.useRef(null), t = function(n) {
    e.current || (e.current = [], X0e(function() {
      EF(function() {
        e.current.forEach(function(a) {
          a();
        }), e.current = null;
      });
    })), e.current.push(n);
  };
  return t;
}
function vf(e, t) {
  var r = p.useState(t), n = ye(r, 2), a = n[0], i = n[1], o = br(function(s) {
    e(function() {
      i(s);
    });
  });
  return [a, o];
}
var Nb = /* @__PURE__ */ xe.createContext(null), Q0e = ["component"], ehe = ["className"], the = ["className"], rhe = function(t, r) {
  var n = p.useContext(Nb);
  if (!n) {
    var a = t.component, i = a === void 0 ? "div" : a, o = Kt(t, Q0e);
    return /* @__PURE__ */ p.createElement(i, Pe({}, o, {
      ref: r
    }));
  }
  var s = n.className, l = Kt(n, ehe), c = t.className, u = Kt(t, the);
  return /* @__PURE__ */ p.createElement(Nb.Provider, {
    value: null
  }, /* @__PURE__ */ p.createElement(R0, Pe({
    ref: r,
    className: be(s, c)
  }, l, u)));
}, yH = /* @__PURE__ */ p.forwardRef(rhe);
yH.displayName = "RawItem";
var nhe = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"], bH = "responsive", CH = "invalidate";
function ahe(e) {
  return "+ ".concat(e.length, " ...");
}
function ihe(e, t) {
  var r = e.prefixCls, n = r === void 0 ? "rc-overflow" : r, a = e.data, i = a === void 0 ? [] : a, o = e.renderItem, s = e.renderRawItem, l = e.itemKey, c = e.itemWidth, u = c === void 0 ? 10 : c, d = e.ssr, f = e.style, m = e.className, h = e.maxCount, g = e.renderRest, y = e.renderRawRest, S = e.suffix, x = e.component, b = x === void 0 ? "div" : x, _ = e.itemComponent, $ = e.onVisibleChange, w = Kt(e, nhe), O = d === "full", T = J0e(), I = vf(T, null), P = ye(I, 2), D = P[0], B = P[1], L = D || 0, N = vf(T, /* @__PURE__ */ new Map()), z = ye(N, 2), F = z[0], j = z[1], H = vf(T, 0), U = ye(H, 2), G = U[0], V = U[1], K = vf(T, 0), Z = ye(K, 2), ee = Z[0], ae = Z[1], ue = vf(T, 0), re = ye(ue, 2), oe = re[0], fe = re[1], le = He(null), se = ye(le, 2), Q = se[0], he = se[1], ne = He(null), me = ye(ne, 2), k = me[0], M = me[1], R = p.useMemo(function() {
    return k === null && O ? Number.MAX_SAFE_INTEGER : k || 0;
  }, [k, D]), q = He(!1), Y = ye(q, 2), X = Y[0], pe = Y[1], $e = "".concat(n, "-item"), J = Math.max(G, ee), de = h === bH, Se = i.length && de, Ee = h === CH, Te = Se || typeof h == "number" && i.length > h, Le = dr(function() {
    var bt = i;
    return Se ? D === null && O ? bt = i : bt = i.slice(0, Math.min(i.length, L / u)) : typeof h == "number" && (bt = i.slice(0, h)), bt;
  }, [i, u, D, h, Se]), Ie = dr(function() {
    return Se ? i.slice(R + 1) : i.slice(Le.length);
  }, [i, Le, Se, R]), De = Bt(function(bt, Je) {
    var _t;
    return typeof l == "function" ? l(bt) : (_t = l && bt?.[l]) !== null && _t !== void 0 ? _t : Je;
  }, [l]), Ae = Bt(o || function(bt) {
    return bt;
  }, [o]);
  function Fe(bt, Je, _t) {
    k === bt && (Je === void 0 || Je === Q) || (M(bt), _t || (pe(bt < i.length - 1), $?.(bt)), Je !== void 0 && he(Je));
  }
  function Ne(bt, Je) {
    B(Je.clientWidth);
  }
  function qe(bt, Je) {
    j(function(_t) {
      var Vt = new Map(_t);
      return Je === null ? Vt.delete(bt) : Vt.set(bt, Je), Vt;
    });
  }
  function Qe(bt, Je) {
    ae(Je), V(ee);
  }
  function tt(bt, Je) {
    fe(Je);
  }
  function Ge(bt) {
    return F.get(De(Le[bt], bt));
  }
  hr(function() {
    if (L && typeof J == "number" && Le) {
      var bt = oe, Je = Le.length, _t = Je - 1;
      if (!Je) {
        Fe(0, null);
        return;
      }
      for (var Vt = 0; Vt < Je; Vt += 1) {
        var ot = Ge(Vt);
        if (O && (ot = ot || 0), ot === void 0) {
          Fe(Vt - 1, void 0, !0);
          break;
        }
        if (bt += ot, // Only one means `totalWidth` is the final width
        _t === 0 && bt <= L || // Last two width will be the final width
        Vt === _t - 1 && bt + Ge(_t) <= L) {
          Fe(_t, null);
          break;
        } else if (bt + J > L) {
          Fe(Vt - 1, bt - ot - oe + ee);
          break;
        }
      }
      S && Ge(0) + oe > L && he(null);
    }
  }, [L, F, ee, oe, De, Le]);
  var it = X && !!Ie.length, ht = {};
  Q !== null && Se && (ht = {
    position: "absolute",
    left: Q,
    top: 0
  });
  var It = {
    prefixCls: $e,
    responsive: Se,
    component: _,
    invalidate: Ee
  }, xt = s ? function(bt, Je) {
    var _t = De(bt, Je);
    return /* @__PURE__ */ p.createElement(Nb.Provider, {
      key: _t,
      value: ce(ce({}, It), {}, {
        order: Je,
        item: bt,
        itemKey: _t,
        registerSize: qe,
        display: Je <= R
      })
    }, s(bt, Je));
  } : function(bt, Je) {
    var _t = De(bt, Je);
    return /* @__PURE__ */ p.createElement(R0, Pe({}, It, {
      order: Je,
      key: _t,
      item: bt,
      renderItem: Ae,
      itemKey: _t,
      registerSize: qe,
      display: Je <= R
    }));
  }, Xe, pt = {
    order: it ? R : Number.MAX_SAFE_INTEGER,
    className: "".concat($e, "-rest"),
    registerSize: Qe,
    display: it
  };
  if (y)
    y && (Xe = /* @__PURE__ */ p.createElement(Nb.Provider, {
      value: ce(ce({}, It), pt)
    }, y(Ie)));
  else {
    var Ze = g || ahe;
    Xe = /* @__PURE__ */ p.createElement(R0, Pe({}, It, pt), typeof Ze == "function" ? Ze(Ie) : Ze);
  }
  var wt = /* @__PURE__ */ p.createElement(b, Pe({
    className: be(!Ee && n, m),
    style: f,
    ref: t
  }, w), Le.map(xt), Te ? Xe : null, S && /* @__PURE__ */ p.createElement(R0, Pe({}, It, {
    responsive: de,
    responsiveDisabled: !Se,
    order: R,
    className: "".concat($e, "-suffix"),
    registerSize: tt,
    display: !0,
    style: ht
  }), S));
  return de && (wt = /* @__PURE__ */ p.createElement(Ia, {
    onResize: Ne,
    disabled: !Se
  }, wt)), wt;
}
var Ro = /* @__PURE__ */ p.forwardRef(ihe);
Ro.displayName = "Overflow";
Ro.Item = yH;
Ro.RESPONSIVE = bH;
Ro.INVALIDATE = CH;
var ohe = function(t, r) {
  var n, a = t.prefixCls, i = t.id, o = t.inputElement, s = t.disabled, l = t.tabIndex, c = t.autoFocus, u = t.autoComplete, d = t.editable, f = t.activeDescendantId, m = t.value, h = t.maxLength, g = t.onKeyDown, y = t.onMouseDown, S = t.onChange, x = t.onPaste, b = t.onCompositionStart, _ = t.onCompositionEnd, $ = t.open, w = t.attrs, O = o || /* @__PURE__ */ p.createElement("input", null), T = O, I = T.ref, P = T.props, D = P.onKeyDown, B = P.onChange, L = P.onMouseDown, N = P.onCompositionStart, z = P.onCompositionEnd, F = P.style;
  return ls(!("maxLength" in O.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled."), O = /* @__PURE__ */ p.cloneElement(O, ce(ce(ce({
    type: "search"
  }, P), {}, {
    // Override over origin props
    id: i,
    ref: Za(r, I),
    disabled: s,
    tabIndex: l,
    autoComplete: u || "off",
    autoFocus: c,
    className: be("".concat(a, "-selection-search-input"), (n = O) === null || n === void 0 || (n = n.props) === null || n === void 0 ? void 0 : n.className),
    role: "combobox",
    "aria-expanded": $ || !1,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(i, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(i, "_list"),
    "aria-activedescendant": $ ? f : void 0
  }, w), {}, {
    value: d ? m : "",
    maxLength: h,
    readOnly: !d,
    unselectable: d ? null : "on",
    style: ce(ce({}, F), {}, {
      opacity: d ? null : 0
    }),
    onKeyDown: function(H) {
      g(H), D && D(H);
    },
    onMouseDown: function(H) {
      y(H), L && L(H);
    },
    onChange: function(H) {
      S(H), B && B(H);
    },
    onCompositionStart: function(H) {
      b(H), N && N(H);
    },
    onCompositionEnd: function(H) {
      _(H), z && z(H);
    },
    onPaste: x
  })), O;
}, ZT = /* @__PURE__ */ p.forwardRef(ohe);
process.env.NODE_ENV !== "production" && (ZT.displayName = "Input");
function XT(e) {
  return Array.isArray(e) ? e : e !== void 0 ? [e] : [];
}
var she = typeof window < "u" && window.document && window.document.documentElement, lhe = process.env.NODE_ENV !== "test" && she;
function che(e) {
  return e != null;
}
function uhe(e) {
  return !e && e !== 0;
}
function iN(e) {
  return ["string", "number"].includes(kt(e));
}
function SH(e) {
  var t = void 0;
  return e && (iN(e.title) ? t = e.title.toString() : iN(e.label) && (t = e.label.toString())), t;
}
function dhe(e, t) {
  lhe ? p.useLayoutEffect(e, t) : p.useEffect(e, t);
}
function fhe(e) {
  var t;
  return (t = e.key) !== null && t !== void 0 ? t : e.value;
}
var oN = function(t) {
  t.preventDefault(), t.stopPropagation();
}, phe = function(t) {
  var r = t.id, n = t.prefixCls, a = t.values, i = t.open, o = t.searchValue, s = t.autoClearSearchValue, l = t.inputRef, c = t.placeholder, u = t.disabled, d = t.mode, f = t.showSearch, m = t.autoFocus, h = t.autoComplete, g = t.activeDescendantId, y = t.tabIndex, S = t.removeIcon, x = t.maxTagCount, b = t.maxTagTextLength, _ = t.maxTagPlaceholder, $ = _ === void 0 ? function(he) {
    return "+ ".concat(he.length, " ...");
  } : _, w = t.tagRender, O = t.onToggleOpen, T = t.onRemove, I = t.onInputChange, P = t.onInputPaste, D = t.onInputKeyDown, B = t.onInputMouseDown, L = t.onInputCompositionStart, N = t.onInputCompositionEnd, z = p.useRef(null), F = He(0), j = ye(F, 2), H = j[0], U = j[1], G = He(!1), V = ye(G, 2), K = V[0], Z = V[1], ee = "".concat(n, "-selection"), ae = i || d === "multiple" && s === !1 || d === "tags" ? o : "", ue = d === "tags" || d === "multiple" && s === !1 || f && (i || K);
  dhe(function() {
    U(z.current.scrollWidth);
  }, [ae]);
  var re = function(ne, me, k, M, R) {
    return /* @__PURE__ */ p.createElement("span", {
      title: SH(ne),
      className: be("".concat(ee, "-item"), te({}, "".concat(ee, "-item-disabled"), k))
    }, /* @__PURE__ */ p.createElement("span", {
      className: "".concat(ee, "-item-content")
    }, me), M && /* @__PURE__ */ p.createElement(N1, {
      className: "".concat(ee, "-item-remove"),
      onMouseDown: oN,
      onClick: R,
      customizeIcon: S
    }, "×"));
  }, oe = function(ne, me, k, M, R, q) {
    var Y = function(pe) {
      oN(pe), O(!i);
    };
    return /* @__PURE__ */ p.createElement("span", {
      onMouseDown: Y
    }, w({
      label: me,
      value: ne,
      disabled: k,
      closable: M,
      onClose: R,
      isMaxTag: !!q
    }));
  }, fe = function(ne) {
    var me = ne.disabled, k = ne.label, M = ne.value, R = !u && !me, q = k;
    if (typeof b == "number" && (typeof k == "string" || typeof k == "number")) {
      var Y = String(q);
      Y.length > b && (q = "".concat(Y.slice(0, b), "..."));
    }
    var X = function($e) {
      $e && $e.stopPropagation(), T(ne);
    };
    return typeof w == "function" ? oe(M, q, me, R, X) : re(ne, q, me, R, X);
  }, le = function(ne) {
    var me = typeof $ == "function" ? $(ne) : $;
    return typeof w == "function" ? oe(void 0, me, !1, !1, void 0, !0) : re({
      title: me
    }, me, !1);
  }, se = /* @__PURE__ */ p.createElement("div", {
    className: "".concat(ee, "-search"),
    style: {
      width: H
    },
    onFocus: function() {
      Z(!0);
    },
    onBlur: function() {
      Z(!1);
    }
  }, /* @__PURE__ */ p.createElement(ZT, {
    ref: l,
    open: i,
    prefixCls: n,
    id: r,
    inputElement: null,
    disabled: u,
    autoFocus: m,
    autoComplete: h,
    editable: ue,
    activeDescendantId: g,
    value: ae,
    onKeyDown: D,
    onMouseDown: B,
    onChange: I,
    onPaste: P,
    onCompositionStart: L,
    onCompositionEnd: N,
    tabIndex: y,
    attrs: aa(t, !0)
  }), /* @__PURE__ */ p.createElement("span", {
    ref: z,
    className: "".concat(ee, "-search-mirror"),
    "aria-hidden": !0
  }, ae, " ")), Q = /* @__PURE__ */ p.createElement(Ro, {
    prefixCls: "".concat(ee, "-overflow"),
    data: a,
    renderItem: fe,
    renderRest: le,
    suffix: se,
    itemKey: fhe,
    maxCount: x
  });
  return /* @__PURE__ */ p.createElement(p.Fragment, null, Q, !a.length && !ae && /* @__PURE__ */ p.createElement("span", {
    className: "".concat(ee, "-placeholder")
  }, c));
}, mhe = function(t) {
  var r = t.inputElement, n = t.prefixCls, a = t.id, i = t.inputRef, o = t.disabled, s = t.autoFocus, l = t.autoComplete, c = t.activeDescendantId, u = t.mode, d = t.open, f = t.values, m = t.placeholder, h = t.tabIndex, g = t.showSearch, y = t.searchValue, S = t.activeValue, x = t.maxLength, b = t.onInputKeyDown, _ = t.onInputMouseDown, $ = t.onInputChange, w = t.onInputPaste, O = t.onInputCompositionStart, T = t.onInputCompositionEnd, I = t.title, P = p.useState(!1), D = ye(P, 2), B = D[0], L = D[1], N = u === "combobox", z = N || g, F = f[0], j = y || "";
  N && S && !B && (j = S), p.useEffect(function() {
    N && L(!1);
  }, [N, S]);
  var H = u !== "combobox" && !d && !g ? !1 : !!j, U = I === void 0 ? SH(F) : I, G = p.useMemo(function() {
    return F ? null : /* @__PURE__ */ p.createElement("span", {
      className: "".concat(n, "-selection-placeholder"),
      style: H ? {
        visibility: "hidden"
      } : void 0
    }, m);
  }, [F, H, m, n]);
  return /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement("span", {
    className: "".concat(n, "-selection-search")
  }, /* @__PURE__ */ p.createElement(ZT, {
    ref: i,
    prefixCls: n,
    id: a,
    open: d,
    inputElement: r,
    disabled: o,
    autoFocus: s,
    autoComplete: l,
    editable: z,
    activeDescendantId: c,
    value: j,
    onKeyDown: b,
    onMouseDown: _,
    onChange: function(K) {
      L(!0), $(K);
    },
    onPaste: w,
    onCompositionStart: O,
    onCompositionEnd: T,
    tabIndex: h,
    attrs: aa(t, !0),
    maxLength: N ? x : void 0
  })), !N && F ? /* @__PURE__ */ p.createElement("span", {
    className: "".concat(n, "-selection-item"),
    title: U,
    style: H ? {
      visibility: "hidden"
    } : void 0
  }, F.label) : null, G);
}, vhe = function(t, r) {
  var n = ct(null), a = ct(!1), i = t.prefixCls, o = t.open, s = t.mode, l = t.showSearch, c = t.tokenWithEnter, u = t.disabled, d = t.autoClearSearchValue, f = t.onSearch, m = t.onSearchSubmit, h = t.onToggleOpen, g = t.onInputKeyDown, y = t.domRef;
  p.useImperativeHandle(r, function() {
    return {
      focus: function(H) {
        n.current.focus(H);
      },
      blur: function() {
        n.current.blur();
      }
    };
  });
  var S = gH(0), x = ye(S, 2), b = x[0], _ = x[1], $ = function(H) {
    var U = H.which;
    (U === Mt.UP || U === Mt.DOWN) && H.preventDefault(), g && g(H), U === Mt.ENTER && s === "tags" && !a.current && !o && m?.(H.target.value), K0e(U) && h(!0);
  }, w = function() {
    _(!0);
  }, O = ct(null), T = function(H) {
    f(H, !0, a.current) !== !1 && h(!0);
  }, I = function() {
    a.current = !0;
  }, P = function(H) {
    a.current = !1, s !== "combobox" && T(H.target.value);
  }, D = function(H) {
    var U = H.target.value;
    if (c && O.current && /[\r\n]/.test(O.current)) {
      var G = O.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      U = U.replace(G, O.current);
    }
    O.current = null, T(U);
  }, B = function(H) {
    var U = H.clipboardData, G = U?.getData("text");
    O.current = G || "";
  }, L = function(H) {
    var U = H.target;
    if (U !== n.current) {
      var G = document.body.style.msTouchAction !== void 0;
      G ? setTimeout(function() {
        n.current.focus();
      }) : n.current.focus();
    }
  }, N = function(H) {
    var U = b();
    H.target !== n.current && !U && !(s === "combobox" && u) && H.preventDefault(), (s !== "combobox" && (!l || !U) || !o) && (o && d !== !1 && f("", !0, !1), h());
  }, z = {
    inputRef: n,
    onInputKeyDown: $,
    onInputMouseDown: w,
    onInputChange: D,
    onInputPaste: B,
    onInputCompositionStart: I,
    onInputCompositionEnd: P
  }, F = s === "multiple" || s === "tags" ? /* @__PURE__ */ p.createElement(phe, Pe({}, t, z)) : /* @__PURE__ */ p.createElement(mhe, Pe({}, t, z));
  return /* @__PURE__ */ p.createElement("div", {
    ref: y,
    className: "".concat(i, "-selector"),
    onClick: L,
    onMouseDown: N
  }, F);
}, xH = /* @__PURE__ */ p.forwardRef(vhe);
process.env.NODE_ENV !== "production" && (xH.displayName = "Selector");
function hhe(e) {
  var t = e.prefixCls, r = e.align, n = e.arrow, a = e.arrowPos, i = n || {}, o = i.className, s = i.content, l = a.x, c = l === void 0 ? 0 : l, u = a.y, d = u === void 0 ? 0 : u, f = p.useRef();
  if (!r || !r.points)
    return null;
  var m = {
    position: "absolute"
  };
  if (r.autoArrow !== !1) {
    var h = r.points[0], g = r.points[1], y = h[0], S = h[1], x = g[0], b = g[1];
    y === x || !["t", "b"].includes(y) ? m.top = d : y === "t" ? m.top = 0 : m.bottom = 0, S === b || !["l", "r"].includes(S) ? m.left = c : S === "l" ? m.left = 0 : m.right = 0;
  }
  return /* @__PURE__ */ p.createElement("div", {
    ref: f,
    className: be("".concat(t, "-arrow"), o),
    style: m
  }, s);
}
function ghe(e) {
  var t = e.prefixCls, r = e.open, n = e.zIndex, a = e.mask, i = e.motion;
  return a ? /* @__PURE__ */ p.createElement(Ci, Pe({}, i, {
    motionAppear: !0,
    visible: r,
    removeOnLeave: !0
  }), function(o) {
    var s = o.className;
    return /* @__PURE__ */ p.createElement("div", {
      style: {
        zIndex: n
      },
      className: be("".concat(t, "-mask"), s)
    });
  }) : null;
}
var $H = /* @__PURE__ */ p.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  return t.cache;
});
process.env.NODE_ENV !== "production" && ($H.displayName = "PopupContent");
var _H = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.popup, n = e.className, a = e.prefixCls, i = e.style, o = e.target, s = e.onVisibleChanged, l = e.open, c = e.keepDom, u = e.fresh, d = e.onClick, f = e.mask, m = e.arrow, h = e.arrowPos, g = e.align, y = e.motion, S = e.maskMotion, x = e.forceRender, b = e.getPopupContainer, _ = e.autoDestroy, $ = e.portal, w = e.zIndex, O = e.onMouseEnter, T = e.onMouseLeave, I = e.onPointerEnter, P = e.ready, D = e.offsetX, B = e.offsetY, L = e.offsetR, N = e.offsetB, z = e.onAlign, F = e.onPrepare, j = e.stretch, H = e.targetWidth, U = e.targetHeight, G = typeof r == "function" ? r() : r, V = l || c, K = b?.length > 0, Z = p.useState(!b || !K), ee = ye(Z, 2), ae = ee[0], ue = ee[1];
  if (hr(function() {
    !ae && K && o && ue(!0);
  }, [ae, K, o]), !ae)
    return null;
  var re = "auto", oe = {
    left: "-1000vw",
    top: "-1000vh",
    right: re,
    bottom: re
  };
  if (P || !l) {
    var fe, le = g.points, se = g.dynamicInset || ((fe = g._experimental) === null || fe === void 0 ? void 0 : fe.dynamicInset), Q = se && le[0][1] === "r", he = se && le[0][0] === "b";
    Q ? (oe.right = L, oe.left = re) : (oe.left = D, oe.right = re), he ? (oe.bottom = N, oe.top = re) : (oe.top = B, oe.bottom = re);
  }
  var ne = {};
  return j && (j.includes("height") && U ? ne.height = U : j.includes("minHeight") && U && (ne.minHeight = U), j.includes("width") && H ? ne.width = H : j.includes("minWidth") && H && (ne.minWidth = H)), l || (ne.pointerEvents = "none"), /* @__PURE__ */ p.createElement($, {
    open: x || V,
    getContainer: b && function() {
      return b(o);
    },
    autoDestroy: _
  }, /* @__PURE__ */ p.createElement(ghe, {
    prefixCls: a,
    open: l,
    zIndex: w,
    mask: f,
    motion: S
  }), /* @__PURE__ */ p.createElement(Ia, {
    onResize: z,
    disabled: !l
  }, function(me) {
    return /* @__PURE__ */ p.createElement(Ci, Pe({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: x,
      leavedClassName: "".concat(a, "-hidden")
    }, y, {
      onAppearPrepare: F,
      onEnterPrepare: F,
      visible: l,
      onVisibleChanged: function(M) {
        var R;
        y == null || (R = y.onVisibleChanged) === null || R === void 0 || R.call(y, M), s(M);
      }
    }), function(k, M) {
      var R = k.className, q = k.style, Y = be(a, R, n);
      return /* @__PURE__ */ p.createElement("div", {
        ref: Za(me, t, M),
        className: Y,
        style: ce(ce(ce(ce({
          "--arrow-x": "".concat(h.x || 0, "px"),
          "--arrow-y": "".concat(h.y || 0, "px")
        }, oe), ne), q), {}, {
          boxSizing: "border-box",
          zIndex: w
        }, i),
        onMouseEnter: O,
        onMouseLeave: T,
        onPointerEnter: I,
        onClick: d
      }, m && /* @__PURE__ */ p.createElement(hhe, {
        prefixCls: a,
        arrow: m,
        arrowPos: h,
        align: g
      }), /* @__PURE__ */ p.createElement($H, {
        cache: !l && !u
      }, G));
    });
  }));
});
process.env.NODE_ENV !== "production" && (_H.displayName = "Popup");
var EH = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.children, n = e.getTriggerDOMNode, a = No(r), i = p.useCallback(function(s) {
    B0(t, n ? n(s) : s);
  }, [n]), o = qs(i, r.ref);
  return a ? /* @__PURE__ */ p.cloneElement(r, {
    ref: o
  }) : r;
});
process.env.NODE_ENV !== "production" && (EH.displayName = "TriggerWrapper");
var sN = /* @__PURE__ */ p.createContext(null);
function lN(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function yhe(e, t, r, n) {
  return p.useMemo(function() {
    var a = lN(r ?? t), i = lN(n ?? t), o = new Set(a), s = new Set(i);
    return e && (o.has("hover") && (o.delete("hover"), o.add("click")), s.has("hover") && (s.delete("hover"), s.add("click"))), [o, s];
  }, [e, t, r, n]);
}
function bhe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = arguments.length > 2 ? arguments[2] : void 0;
  return r ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function Che(e, t, r, n) {
  for (var a = r.points, i = Object.keys(e), o = 0; o < i.length; o += 1) {
    var s, l = i[o];
    if (bhe((s = e[l]) === null || s === void 0 ? void 0 : s.points, a, n))
      return "".concat(t, "-placement-").concat(l);
  }
  return "";
}
function cN(e, t, r, n) {
  return t || (r ? {
    motionName: "".concat(e, "-").concat(r)
  } : n ? {
    motionName: n
  } : null);
}
function vh(e) {
  return e.ownerDocument.defaultView;
}
function q2(e) {
  for (var t = [], r = e?.parentElement, n = ["hidden", "scroll", "clip", "auto"]; r; ) {
    var a = vh(r).getComputedStyle(r), i = a.overflowX, o = a.overflowY, s = a.overflow;
    [i, o, s].some(function(l) {
      return n.includes(l);
    }) && t.push(r), r = r.parentElement;
  }
  return t;
}
function Z0(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(e) ? t : e;
}
function hf(e) {
  return Z0(parseFloat(e), 0);
}
function uN(e, t) {
  var r = ce({}, e);
  return (t || []).forEach(function(n) {
    if (!(n instanceof HTMLBodyElement || n instanceof HTMLHtmlElement)) {
      var a = vh(n).getComputedStyle(n), i = a.overflow, o = a.overflowClipMargin, s = a.borderTopWidth, l = a.borderBottomWidth, c = a.borderLeftWidth, u = a.borderRightWidth, d = n.getBoundingClientRect(), f = n.offsetHeight, m = n.clientHeight, h = n.offsetWidth, g = n.clientWidth, y = hf(s), S = hf(l), x = hf(c), b = hf(u), _ = Z0(Math.round(d.width / h * 1e3) / 1e3), $ = Z0(Math.round(d.height / f * 1e3) / 1e3), w = (h - g - x - b) * _, O = (f - m - y - S) * $, T = y * $, I = S * $, P = x * _, D = b * _, B = 0, L = 0;
      if (i === "clip") {
        var N = hf(o);
        B = N * _, L = N * $;
      }
      var z = d.x + P - B, F = d.y + T - L, j = z + d.width + 2 * B - P - D - w, H = F + d.height + 2 * L - T - I - O;
      r.left = Math.max(r.left, z), r.top = Math.max(r.top, F), r.right = Math.min(r.right, j), r.bottom = Math.min(r.bottom, H);
    }
  }), r;
}
function dN(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = "".concat(t), n = r.match(/^(.*)\%$/);
  return n ? e * (parseFloat(n[1]) / 100) : parseFloat(r);
}
function fN(e, t) {
  var r = t || [], n = ye(r, 2), a = n[0], i = n[1];
  return [dN(e.width, a), dN(e.height, i)];
}
function pN() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [e[0], e[1]];
}
function yu(e, t) {
  var r = t[0], n = t[1], a, i;
  return r === "t" ? i = e.y : r === "b" ? i = e.y + e.height : i = e.y + e.height / 2, n === "l" ? a = e.x : n === "r" ? a = e.x + e.width : a = e.x + e.width / 2, {
    x: a,
    y: i
  };
}
function sl(e, t) {
  var r = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return e.map(function(n, a) {
    return a === t ? r[n] || "c" : n;
  }).join("");
}
function She(e, t, r, n, a, i, o) {
  var s = p.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: a[n] || {}
  }), l = ye(s, 2), c = l[0], u = l[1], d = p.useRef(0), f = p.useMemo(function() {
    return t ? q2(t) : [];
  }, [t]), m = p.useRef({}), h = function() {
    m.current = {};
  };
  e || h();
  var g = br(function() {
    if (t && r && e) {
      let qt = function(Ft, rr) {
        var pn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Y, Wn = G.x + Ft, $n = G.y + rr, di = Wn + fe, fi = $n + oe, Oi = Math.max(Wn, pn.left), Wi = Math.max($n, pn.top), hs = Math.min(di, pn.right), Kd = Math.min(fi, pn.bottom);
        return Math.max(0, (hs - Oi) * (Kd - Wi));
      }, gr = function() {
        nt = G.y + Ze, Ve = nt + oe, ke = G.x + pt, ut = ke + fe;
      };
      var x, b, _ = t, $ = _.ownerDocument, w = vh(_), O = w.getComputedStyle(_), T = O.width, I = O.height, P = O.position, D = _.style.left, B = _.style.top, L = _.style.right, N = _.style.bottom, z = _.style.overflow, F = ce(ce({}, a[n]), i), j = $.createElement("div");
      (x = _.parentElement) === null || x === void 0 || x.appendChild(j), j.style.left = "".concat(_.offsetLeft, "px"), j.style.top = "".concat(_.offsetTop, "px"), j.style.position = P, j.style.height = "".concat(_.offsetHeight, "px"), j.style.width = "".concat(_.offsetWidth, "px"), _.style.left = "0", _.style.top = "0", _.style.right = "auto", _.style.bottom = "auto", _.style.overflow = "hidden";
      var H;
      if (Array.isArray(r))
        H = {
          x: r[0],
          y: r[1],
          width: 0,
          height: 0
        };
      else {
        var U = r.getBoundingClientRect();
        H = {
          x: U.x,
          y: U.y,
          width: U.width,
          height: U.height
        };
      }
      var G = _.getBoundingClientRect(), V = $.documentElement, K = V.clientWidth, Z = V.clientHeight, ee = V.scrollWidth, ae = V.scrollHeight, ue = V.scrollTop, re = V.scrollLeft, oe = G.height, fe = G.width, le = H.height, se = H.width, Q = {
        left: 0,
        top: 0,
        right: K,
        bottom: Z
      }, he = {
        left: -re,
        top: -ue,
        right: ee - re,
        bottom: ae - ue
      }, ne = F.htmlRegion, me = "visible", k = "visibleFirst";
      ne !== "scroll" && ne !== k && (ne = me);
      var M = ne === k, R = uN(he, f), q = uN(Q, f), Y = ne === me ? q : R, X = M ? q : Y;
      _.style.left = "auto", _.style.top = "auto", _.style.right = "0", _.style.bottom = "0";
      var pe = _.getBoundingClientRect();
      _.style.left = D, _.style.top = B, _.style.right = L, _.style.bottom = N, _.style.overflow = z, (b = _.parentElement) === null || b === void 0 || b.removeChild(j);
      var $e = Z0(Math.round(fe / parseFloat(T) * 1e3) / 1e3), J = Z0(Math.round(oe / parseFloat(I) * 1e3) / 1e3);
      if ($e === 0 || J === 0 || F0(r) && !yd(r))
        return;
      var de = F.offset, Se = F.targetOffset, Ee = fN(G, de), Te = ye(Ee, 2), Le = Te[0], Ie = Te[1], De = fN(H, Se), Ae = ye(De, 2), Fe = Ae[0], Ne = Ae[1];
      H.x -= Fe, H.y -= Ne;
      var qe = F.points || [], Qe = ye(qe, 2), tt = Qe[0], Ge = Qe[1], it = pN(Ge), ht = pN(tt), It = yu(H, it), xt = yu(G, ht), Xe = ce({}, F), pt = It.x - xt.x + Le, Ze = It.y - xt.y + Ie, wt = qt(pt, Ze), bt = qt(pt, Ze, q), Je = yu(H, ["t", "l"]), _t = yu(G, ["t", "l"]), Vt = yu(H, ["b", "r"]), ot = yu(G, ["b", "r"]), Ct = F.overflow || {}, rt = Ct.adjustX, $t = Ct.adjustY, Wt = Ct.shiftX, _e = Ct.shiftY, Ke = function(rr) {
        return typeof rr == "boolean" ? rr : rr >= 0;
      }, nt, Ve, ke, ut;
      gr();
      var st = Ke($t), Et = ht[0] === it[0];
      if (st && ht[0] === "t" && (Ve > X.bottom || m.current.bt)) {
        var zt = Ze;
        Et ? zt -= oe - le : zt = Je.y - ot.y - Ie;
        var Be = qt(pt, zt), ft = qt(pt, zt, q);
        // Of course use larger one
        Be > wt || Be === wt && (!M || // Choose recommend one
        ft >= bt) ? (m.current.bt = !0, Ze = zt, Ie = -Ie, Xe.points = [sl(ht, 0), sl(it, 0)]) : m.current.bt = !1;
      }
      if (st && ht[0] === "b" && (nt < X.top || m.current.tb)) {
        var yt = Ze;
        Et ? yt += oe - le : yt = Vt.y - _t.y - Ie;
        var Rt = qt(pt, yt), Ht = qt(pt, yt, q);
        // Of course use larger one
        Rt > wt || Rt === wt && (!M || // Choose recommend one
        Ht >= bt) ? (m.current.tb = !0, Ze = yt, Ie = -Ie, Xe.points = [sl(ht, 0), sl(it, 0)]) : m.current.tb = !1;
      }
      var ir = Ke(rt), ar = ht[1] === it[1];
      if (ir && ht[1] === "l" && (ut > X.right || m.current.rl)) {
        var Nr = pt;
        ar ? Nr -= fe - se : Nr = Je.x - ot.x - Le;
        var Xr = qt(Nr, Ze), Qr = qt(Nr, Ze, q);
        // Of course use larger one
        Xr > wt || Xr === wt && (!M || // Choose recommend one
        Qr >= bt) ? (m.current.rl = !0, pt = Nr, Le = -Le, Xe.points = [sl(ht, 1), sl(it, 1)]) : m.current.rl = !1;
      }
      if (ir && ht[1] === "r" && (ke < X.left || m.current.lr)) {
        var Ur = pt;
        ar ? Ur += fe - se : Ur = Vt.x - _t.x - Le;
        var gn = qt(Ur, Ze), Zt = qt(Ur, Ze, q);
        // Of course use larger one
        gn > wt || gn === wt && (!M || // Choose recommend one
        Zt >= bt) ? (m.current.lr = !0, pt = Ur, Le = -Le, Xe.points = [sl(ht, 1), sl(it, 1)]) : m.current.lr = !1;
      }
      gr();
      var er = Wt === !0 ? 0 : Wt;
      typeof er == "number" && (ke < q.left && (pt -= ke - q.left - Le, H.x + se < q.left + er && (pt += H.x - q.left + se - er)), ut > q.right && (pt -= ut - q.right - Le, H.x > q.right - er && (pt += H.x - q.right + er)));
      var _r = _e === !0 ? 0 : _e;
      typeof _r == "number" && (nt < q.top && (Ze -= nt - q.top - Ie, H.y + le < q.top + _r && (Ze += H.y - q.top + le - _r)), Ve > q.bottom && (Ze -= Ve - q.bottom - Ie, H.y > q.bottom - _r && (Ze += H.y - q.bottom + _r)));
      var Sn = G.x + pt, On = Sn + fe, Un = G.y + Ze, oa = Un + oe, va = H.x, Fn = va + se, or = H.y, tr = or + le, Jr = Math.max(Sn, va), tn = Math.min(On, Fn), zr = (Jr + tn) / 2, cr = zr - Sn, Ot = Math.max(Un, or), Tt = Math.min(oa, tr), Sr = (Ot + Tt) / 2, Mr = Sr - Un;
      o?.(t, Xe);
      var en = pe.right - G.x - (pt + G.width), Rn = pe.bottom - G.y - (Ze + G.height);
      $e === 1 && (pt = Math.round(pt), en = Math.round(en)), J === 1 && (Ze = Math.round(Ze), Rn = Math.round(Rn));
      var sr = {
        ready: !0,
        offsetX: pt / $e,
        offsetY: Ze / J,
        offsetR: en / $e,
        offsetB: Rn / J,
        arrowX: cr / $e,
        arrowY: Mr / J,
        scaleX: $e,
        scaleY: J,
        align: Xe
      };
      u(sr);
    }
  }), y = function() {
    d.current += 1;
    var b = d.current;
    Promise.resolve().then(function() {
      d.current === b && g();
    });
  }, S = function() {
    u(function(b) {
      return ce(ce({}, b), {}, {
        ready: !1
      });
    });
  };
  return hr(S, [n]), hr(function() {
    e || S();
  }, [e]), [c.ready, c.offsetX, c.offsetY, c.offsetR, c.offsetB, c.arrowX, c.arrowY, c.scaleX, c.scaleY, c.align, y];
}
function xhe(e, t, r, n, a) {
  hr(function() {
    if (e && t && r) {
      let d = function() {
        n(), a();
      };
      var i = t, o = r, s = q2(i), l = q2(o), c = vh(o), u = new Set([c].concat(ze(s), ze(l)));
      return u.forEach(function(f) {
        f.addEventListener("scroll", d, {
          passive: !0
        });
      }), c.addEventListener("resize", d, {
        passive: !0
      }), n(), function() {
        u.forEach(function(f) {
          f.removeEventListener("scroll", d), c.removeEventListener("resize", d);
        });
      };
    }
  }, [e, t, r]);
}
function $he(e, t, r, n, a, i, o, s) {
  var l = p.useRef(e);
  l.current = e, p.useEffect(function() {
    if (t && n && (!a || i)) {
      var c = function(S) {
        var x = S.target;
        l.current && !o(x) && s(!1);
      }, u = vh(n);
      u.addEventListener("mousedown", c, !0), u.addEventListener("contextmenu", c, !0);
      var d = Mb(r);
      if (d && (d.addEventListener("mousedown", c, !0), d.addEventListener("contextmenu", c, !0)), process.env.NODE_ENV !== "production") {
        var f, m, h = r == null || (f = r.getRootNode) === null || f === void 0 ? void 0 : f.call(r), g = (m = n.getRootNode) === null || m === void 0 ? void 0 : m.call(n);
        ls(h === g, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        u.removeEventListener("mousedown", c, !0), u.removeEventListener("contextmenu", c, !0), d && (d.removeEventListener("mousedown", c, !0), d.removeEventListener("contextmenu", c, !0));
      };
    }
  }, [t, r, n, a, i]);
}
var _he = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function Ehe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : bd, t = /* @__PURE__ */ p.forwardRef(function(r, n) {
    var a = r.prefixCls, i = a === void 0 ? "rc-trigger-popup" : a, o = r.children, s = r.action, l = s === void 0 ? "hover" : s, c = r.showAction, u = r.hideAction, d = r.popupVisible, f = r.defaultPopupVisible, m = r.onPopupVisibleChange, h = r.afterPopupVisibleChange, g = r.mouseEnterDelay, y = r.mouseLeaveDelay, S = y === void 0 ? 0.1 : y, x = r.focusDelay, b = r.blurDelay, _ = r.mask, $ = r.maskClosable, w = $ === void 0 ? !0 : $, O = r.getPopupContainer, T = r.forceRender, I = r.autoDestroy, P = r.destroyPopupOnHide, D = r.popup, B = r.popupClassName, L = r.popupStyle, N = r.popupPlacement, z = r.builtinPlacements, F = z === void 0 ? {} : z, j = r.popupAlign, H = r.zIndex, U = r.stretch, G = r.getPopupClassNameFromAlign, V = r.fresh, K = r.alignPoint, Z = r.onPopupClick, ee = r.onPopupAlign, ae = r.arrow, ue = r.popupMotion, re = r.maskMotion, oe = r.popupTransitionName, fe = r.popupAnimation, le = r.maskTransitionName, se = r.maskAnimation, Q = r.className, he = r.getTriggerDOMNode, ne = Kt(r, _he), me = I || P || !1, k = p.useState(!1), M = ye(k, 2), R = M[0], q = M[1];
    hr(function() {
      q(R1());
    }, []);
    var Y = p.useRef({}), X = p.useContext(sN), pe = p.useMemo(function() {
      return {
        registerSubPopup: function(yr, _n) {
          Y.current[yr] = _n, X?.registerSubPopup(yr, _n);
        }
      };
    }, [X]), $e = Rz(), J = p.useState(null), de = ye(J, 2), Se = de[0], Ee = de[1], Te = p.useRef(null), Le = br(function(Jt) {
      Te.current = Jt, F0(Jt) && Se !== Jt && Ee(Jt), X?.registerSubPopup($e, Jt);
    }), Ie = p.useState(null), De = ye(Ie, 2), Ae = De[0], Fe = De[1], Ne = p.useRef(null), qe = br(function(Jt) {
      F0(Jt) && Ae !== Jt && (Fe(Jt), Ne.current = Jt);
    }), Qe = p.Children.only(o), tt = Qe?.props || {}, Ge = {}, it = br(function(Jt) {
      var yr, _n, Jn = Ae;
      return Jn?.contains(Jt) || ((yr = Mb(Jn)) === null || yr === void 0 ? void 0 : yr.host) === Jt || Jt === Jn || Se?.contains(Jt) || ((_n = Mb(Se)) === null || _n === void 0 ? void 0 : _n.host) === Jt || Jt === Se || Object.values(Y.current).some(function(Nn) {
        return Nn?.contains(Jt) || Jt === Nn;
      });
    }), ht = cN(i, ue, fe, oe), It = cN(i, re, se, le), xt = p.useState(f || !1), Xe = ye(xt, 2), pt = Xe[0], Ze = Xe[1], wt = d ?? pt, bt = br(function(Jt) {
      d === void 0 && Ze(Jt);
    });
    hr(function() {
      Ze(d || !1);
    }, [d]);
    var Je = p.useRef(wt);
    Je.current = wt;
    var _t = p.useRef([]);
    _t.current = [];
    var Vt = br(function(Jt) {
      var yr;
      bt(Jt), ((yr = _t.current[_t.current.length - 1]) !== null && yr !== void 0 ? yr : wt) !== Jt && (_t.current.push(Jt), m?.(Jt));
    }), ot = p.useRef(), Ct = function() {
      clearTimeout(ot.current);
    }, rt = function(yr) {
      var _n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      Ct(), _n === 0 ? Vt(yr) : ot.current = setTimeout(function() {
        Vt(yr);
      }, _n * 1e3);
    };
    p.useEffect(function() {
      return Ct;
    }, []);
    var $t = p.useState(!1), Wt = ye($t, 2), _e = Wt[0], Ke = Wt[1];
    hr(function(Jt) {
      (!Jt || wt) && Ke(!0);
    }, [wt]);
    var nt = p.useState(null), Ve = ye(nt, 2), ke = Ve[0], ut = Ve[1], st = p.useState([0, 0]), Et = ye(st, 2), zt = Et[0], Be = Et[1], ft = function(yr) {
      Be([yr.clientX, yr.clientY]);
    }, yt = She(wt, Se, K ? zt : Ae, N, F, j, ee), Rt = ye(yt, 11), Ht = Rt[0], ir = Rt[1], ar = Rt[2], Nr = Rt[3], Xr = Rt[4], Qr = Rt[5], Ur = Rt[6], gn = Rt[7], Zt = Rt[8], er = Rt[9], _r = Rt[10], Sn = yhe(R, l, c, u), On = ye(Sn, 2), Un = On[0], oa = On[1], va = Un.has("click"), Fn = oa.has("click") || oa.has("contextMenu"), or = br(function() {
      _e || _r();
    }), tr = function() {
      Je.current && K && Fn && rt(!1);
    };
    xhe(wt, Ae, Se, or, tr), hr(function() {
      or();
    }, [zt, N]), hr(function() {
      wt && !(F != null && F[N]) && or();
    }, [JSON.stringify(j)]);
    var Jr = p.useMemo(function() {
      var Jt = Che(F, i, er, K);
      return be(Jt, G?.(er));
    }, [er, G, F, i, K]);
    p.useImperativeHandle(n, function() {
      return {
        nativeElement: Ne.current,
        popupElement: Te.current,
        forceAlign: or
      };
    });
    var tn = p.useState(0), zr = ye(tn, 2), cr = zr[0], Ot = zr[1], Tt = p.useState(0), Sr = ye(Tt, 2), Mr = Sr[0], en = Sr[1], Rn = function() {
      if (U && Ae) {
        var yr = Ae.getBoundingClientRect();
        Ot(yr.width), en(yr.height);
      }
    }, sr = function() {
      Rn(), or();
    }, qt = function(yr) {
      Ke(!1), _r(), h?.(yr);
    }, gr = function() {
      return new Promise(function(yr) {
        Rn(), ut(function() {
          return yr;
        });
      });
    };
    hr(function() {
      ke && (_r(), ke(), ut(null));
    }, [ke]);
    function Ft(Jt, yr, _n, Jn) {
      Ge[Jt] = function(Nn) {
        var eu;
        Jn?.(Nn), rt(yr, _n);
        for (var Yd = arguments.length, Qh = new Array(Yd > 1 ? Yd - 1 : 0), nn = 1; nn < Yd; nn++)
          Qh[nn - 1] = arguments[nn];
        (eu = tt[Jt]) === null || eu === void 0 || eu.call.apply(eu, [tt, Nn].concat(Qh));
      };
    }
    (va || Fn) && (Ge.onClick = function(Jt) {
      var yr;
      Je.current && Fn ? rt(!1) : !Je.current && va && (ft(Jt), rt(!0));
      for (var _n = arguments.length, Jn = new Array(_n > 1 ? _n - 1 : 0), Nn = 1; Nn < _n; Nn++)
        Jn[Nn - 1] = arguments[Nn];
      (yr = tt.onClick) === null || yr === void 0 || yr.call.apply(yr, [tt, Jt].concat(Jn));
    }), $he(wt, Fn, Ae, Se, _, w, it, rt);
    var rr = Un.has("hover"), pn = oa.has("hover"), Wn, $n;
    rr && (Ft("onMouseEnter", !0, g, function(Jt) {
      ft(Jt);
    }), Ft("onPointerEnter", !0, g, function(Jt) {
      ft(Jt);
    }), Wn = function(yr) {
      (wt || _e) && Se !== null && Se !== void 0 && Se.contains(yr.target) && rt(!0, g);
    }, K && (Ge.onMouseMove = function(Jt) {
      var yr;
      (yr = tt.onMouseMove) === null || yr === void 0 || yr.call(tt, Jt);
    })), pn && (Ft("onMouseLeave", !1, S), Ft("onPointerLeave", !1, S), $n = function() {
      rt(!1, S);
    }), Un.has("focus") && Ft("onFocus", !0, x), oa.has("focus") && Ft("onBlur", !1, b), Un.has("contextMenu") && (Ge.onContextMenu = function(Jt) {
      var yr;
      Je.current && oa.has("contextMenu") ? rt(!1) : (ft(Jt), rt(!0)), Jt.preventDefault();
      for (var _n = arguments.length, Jn = new Array(_n > 1 ? _n - 1 : 0), Nn = 1; Nn < _n; Nn++)
        Jn[Nn - 1] = arguments[Nn];
      (yr = tt.onContextMenu) === null || yr === void 0 || yr.call.apply(yr, [tt, Jt].concat(Jn));
    }), Q && (Ge.className = be(tt.className, Q));
    var di = ce(ce({}, tt), Ge), fi = {}, Oi = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    Oi.forEach(function(Jt) {
      ne[Jt] && (fi[Jt] = function() {
        for (var yr, _n = arguments.length, Jn = new Array(_n), Nn = 0; Nn < _n; Nn++)
          Jn[Nn] = arguments[Nn];
        (yr = di[Jt]) === null || yr === void 0 || yr.call.apply(yr, [di].concat(Jn)), ne[Jt].apply(ne, Jn);
      });
    });
    var Wi = /* @__PURE__ */ p.cloneElement(Qe, ce(ce({}, di), fi)), hs = {
      x: Qr,
      y: Ur
    }, Kd = ae ? ce({}, ae !== !0 ? ae : {}) : null;
    return /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement(Ia, {
      disabled: !wt,
      ref: qe,
      onResize: sr
    }, /* @__PURE__ */ p.createElement(EH, {
      getTriggerDOMNode: he
    }, Wi)), /* @__PURE__ */ p.createElement(sN.Provider, {
      value: pe
    }, /* @__PURE__ */ p.createElement(_H, {
      portal: e,
      ref: Le,
      prefixCls: i,
      popup: D,
      className: be(B, Jr),
      style: L,
      target: Ae,
      onMouseEnter: Wn,
      onMouseLeave: $n,
      onPointerEnter: Wn,
      zIndex: H,
      open: wt,
      keepDom: _e,
      fresh: V,
      onClick: Z,
      mask: _,
      motion: ht,
      maskMotion: It,
      onVisibleChanged: qt,
      onPrepare: gr,
      forceRender: T,
      autoDestroy: me,
      getPopupContainer: O,
      align: er,
      arrow: Kd,
      arrowPos: hs,
      ready: Ht,
      offsetX: ir,
      offsetY: ar,
      offsetR: Nr,
      offsetB: Xr,
      onAlign: or,
      stretch: U,
      targetWidth: cr / gn,
      targetHeight: Mr / Zt
    })));
  });
  return process.env.NODE_ENV !== "production" && (t.displayName = "Trigger"), t;
}
const hh = Ehe(bd);
var whe = ["prefixCls", "disabled", "visible", "children", "popupElement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"], Ohe = function(t) {
  var r = t === !0 ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX: r,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX: r,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX: r,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX: r,
        adjustY: 1
      },
      htmlRegion: "scroll"
    }
  };
}, The = function(t, r) {
  var n = t.prefixCls;
  t.disabled;
  var a = t.visible, i = t.children, o = t.popupElement, s = t.animation, l = t.transitionName, c = t.dropdownStyle, u = t.dropdownClassName, d = t.direction, f = d === void 0 ? "ltr" : d, m = t.placement, h = t.builtinPlacements, g = t.dropdownMatchSelectWidth, y = t.dropdownRender, S = t.dropdownAlign, x = t.getPopupContainer, b = t.empty, _ = t.getTriggerDOMNode, $ = t.onPopupVisibleChange, w = t.onPopupMouseEnter, O = Kt(t, whe), T = "".concat(n, "-dropdown"), I = o;
  y && (I = y(o));
  var P = p.useMemo(function() {
    return h || Ohe(g);
  }, [h, g]), D = s ? "".concat(T, "-").concat(s) : l, B = typeof g == "number", L = p.useMemo(function() {
    return B ? null : g === !1 ? "minWidth" : "width";
  }, [g, B]), N = c;
  B && (N = ce(ce({}, N), {}, {
    width: g
  }));
  var z = p.useRef(null);
  return p.useImperativeHandle(r, function() {
    return {
      getPopupElement: function() {
        var j;
        return (j = z.current) === null || j === void 0 ? void 0 : j.popupElement;
      }
    };
  }), /* @__PURE__ */ p.createElement(hh, Pe({}, O, {
    showAction: $ ? ["click"] : [],
    hideAction: $ ? ["click"] : [],
    popupPlacement: m || (f === "rtl" ? "bottomRight" : "bottomLeft"),
    builtinPlacements: P,
    prefixCls: T,
    popupTransitionName: D,
    popup: /* @__PURE__ */ p.createElement("div", {
      onMouseEnter: w
    }, I),
    ref: z,
    stretch: L,
    popupAlign: S,
    popupVisible: a,
    getPopupContainer: x,
    popupClassName: be(u, te({}, "".concat(T, "-empty"), b)),
    popupStyle: N,
    getTriggerDOMNode: _,
    onPopupVisibleChange: $
  }), i);
}, wH = /* @__PURE__ */ p.forwardRef(The);
process.env.NODE_ENV !== "production" && (wH.displayName = "SelectTrigger");
function mN(e, t) {
  var r = e.key, n;
  return "value" in e && (n = e.value), r ?? (n !== void 0 ? n : "rc-index-key-".concat(t));
}
function K2(e) {
  return typeof e < "u" && !Number.isNaN(e);
}
function OH(e, t) {
  var r = e || {}, n = r.label, a = r.value, i = r.options, o = r.groupLabel, s = n || (t ? "children" : "label");
  return {
    label: s,
    value: a || "value",
    options: i || "options",
    groupLabel: o || s
  };
}
function Ihe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.fieldNames, n = t.childrenAsData, a = [], i = OH(r, !1), o = i.label, s = i.value, l = i.options, c = i.groupLabel;
  function u(d, f) {
    Array.isArray(d) && d.forEach(function(m) {
      if (f || !(l in m)) {
        var h = m[s];
        a.push({
          key: mN(m, a.length),
          groupOption: f,
          data: m,
          label: m[o],
          value: h
        });
      } else {
        var g = m[c];
        g === void 0 && n && (g = m.label), a.push({
          key: mN(m, a.length),
          group: !0,
          data: m,
          label: g
        }), u(m[l], !0);
      }
    });
  }
  return u(e, !1), a;
}
function Y2(e) {
  var t = ce({}, e);
  return "props" in t || Object.defineProperty(t, "props", {
    get: function() {
      return jt(!1, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`."), t;
    }
  }), t;
}
var Mhe = function(t, r, n) {
  if (!r || !r.length)
    return null;
  var a = !1, i = function s(l, c) {
    var u = pB(c), d = u[0], f = u.slice(1);
    if (!d)
      return [l];
    var m = l.split(d);
    return a = a || m.length > 1, m.reduce(function(h, g) {
      return [].concat(ze(h), ze(s(g, f)));
    }, []).filter(Boolean);
  }, o = i(t, r);
  return a ? typeof n < "u" ? o.slice(0, n) : o : null;
}, JT = /* @__PURE__ */ p.createContext(null);
function Ahe(e) {
  var t = e.visible, r = e.values;
  if (!t)
    return null;
  var n = 50;
  return /* @__PURE__ */ p.createElement("span", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "".concat(r.slice(0, n).map(function(a) {
    var i = a.label, o = a.value;
    return ["number", "string"].includes(kt(i)) ? i : o;
  }).join(", ")), r.length > n ? ", ..." : null);
}
var Phe = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "suffixIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"], Rhe = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"], Db = function(t) {
  return t === "tags" || t === "multiple";
}, TH = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r, n = e.id, a = e.prefixCls, i = e.className, o = e.showSearch, s = e.tagRender, l = e.direction, c = e.omitDomProps, u = e.displayValues, d = e.onDisplayValuesChange, f = e.emptyOptions, m = e.notFoundContent, h = m === void 0 ? "Not Found" : m, g = e.onClear, y = e.mode, S = e.disabled, x = e.loading, b = e.getInputElement, _ = e.getRawInputElement, $ = e.open, w = e.defaultOpen, O = e.onDropdownVisibleChange, T = e.activeValue, I = e.onActiveValueChange, P = e.activeDescendantId, D = e.searchValue, B = e.autoClearSearchValue, L = e.onSearch, N = e.onSearchSplit, z = e.tokenSeparators, F = e.allowClear, j = e.suffixIcon, H = e.clearIcon, U = e.OptionList, G = e.animation, V = e.transitionName, K = e.dropdownStyle, Z = e.dropdownClassName, ee = e.dropdownMatchSelectWidth, ae = e.dropdownRender, ue = e.dropdownAlign, re = e.placement, oe = e.builtinPlacements, fe = e.getPopupContainer, le = e.showAction, se = le === void 0 ? [] : le, Q = e.onFocus, he = e.onBlur, ne = e.onKeyUp, me = e.onKeyDown, k = e.onMouseDown, M = Kt(e, Phe), R = Db(y), q = (o !== void 0 ? o : R) || y === "combobox", Y = ce({}, M);
  Rhe.forEach(function(or) {
    delete Y[or];
  }), c?.forEach(function(or) {
    delete Y[or];
  });
  var X = p.useState(!1), pe = ye(X, 2), $e = pe[0], J = pe[1];
  p.useEffect(function() {
    J(R1());
  }, []);
  var de = p.useRef(null), Se = p.useRef(null), Ee = p.useRef(null), Te = p.useRef(null), Le = p.useRef(null), Ie = p.useRef(!1), De = W0e(), Ae = ye(De, 3), Fe = Ae[0], Ne = Ae[1], qe = Ae[2];
  p.useImperativeHandle(t, function() {
    var or, tr;
    return {
      focus: (or = Te.current) === null || or === void 0 ? void 0 : or.focus,
      blur: (tr = Te.current) === null || tr === void 0 ? void 0 : tr.blur,
      scrollTo: function(tn) {
        var zr;
        return (zr = Le.current) === null || zr === void 0 ? void 0 : zr.scrollTo(tn);
      },
      nativeElement: de.current || Se.current
    };
  });
  var Qe = p.useMemo(function() {
    var or;
    if (y !== "combobox")
      return D;
    var tr = (or = u[0]) === null || or === void 0 ? void 0 : or.value;
    return typeof tr == "string" || typeof tr == "number" ? String(tr) : "";
  }, [D, y, u]), tt = y === "combobox" && typeof b == "function" && b() || null, Ge = typeof _ == "function" && _(), it = qs(Se, Ge == null || (r = Ge.props) === null || r === void 0 ? void 0 : r.ref), ht = p.useState(!1), It = ye(ht, 2), xt = It[0], Xe = It[1];
  hr(function() {
    Xe(!0);
  }, []);
  var pt = Kr(!1, {
    defaultValue: w,
    value: $
  }), Ze = ye(pt, 2), wt = Ze[0], bt = Ze[1], Je = xt ? wt : !1, _t = !h && f;
  (S || _t && Je && y === "combobox") && (Je = !1);
  var Vt = _t ? !1 : Je, ot = p.useCallback(function(or) {
    var tr = or !== void 0 ? or : !Je;
    S || (bt(tr), Je !== tr && O?.(tr));
  }, [S, Je, bt, O]), Ct = p.useMemo(function() {
    return (z || []).some(function(or) {
      return [`
`, `\r
`].includes(or);
    });
  }, [z]), rt = p.useContext(JT) || {}, $t = rt.maxCount, Wt = rt.rawValues, _e = function(tr, Jr, tn) {
    if (!(R && K2($t) && Wt?.size >= $t)) {
      var zr = !0, cr = tr;
      I?.(null);
      var Ot = Mhe(tr, z, K2($t) ? $t - Wt.size : void 0), Tt = tn ? null : Ot;
      return y !== "combobox" && Tt && (cr = "", N?.(Tt), ot(!1), zr = !1), L && Qe !== cr && L(cr, {
        source: Jr ? "typing" : "effect"
      }), zr;
    }
  }, Ke = function(tr) {
    !tr || !tr.trim() || L(tr, {
      source: "submit"
    });
  };
  p.useEffect(function() {
    !Je && !R && y !== "combobox" && _e("", !1, !1);
  }, [Je]), p.useEffect(function() {
    wt && S && bt(!1), S && !Ie.current && Ne(!1);
  }, [S]);
  var nt = gH(), Ve = ye(nt, 2), ke = Ve[0], ut = Ve[1], st = function(tr) {
    var Jr = ke(), tn = tr.which;
    if (tn === Mt.ENTER && (y !== "combobox" && tr.preventDefault(), Je || ot(!0)), ut(!!Qe), tn === Mt.BACKSPACE && !Jr && R && !Qe && u.length) {
      for (var zr = ze(u), cr = null, Ot = zr.length - 1; Ot >= 0; Ot -= 1) {
        var Tt = zr[Ot];
        if (!Tt.disabled) {
          zr.splice(Ot, 1), cr = Tt;
          break;
        }
      }
      cr && d(zr, {
        type: "remove",
        values: [cr]
      });
    }
    for (var Sr = arguments.length, Mr = new Array(Sr > 1 ? Sr - 1 : 0), en = 1; en < Sr; en++)
      Mr[en - 1] = arguments[en];
    if (Je) {
      var Rn;
      (Rn = Le.current) === null || Rn === void 0 || Rn.onKeyDown.apply(Rn, [tr].concat(Mr));
    }
    me?.apply(void 0, [tr].concat(Mr));
  }, Et = function(tr) {
    for (var Jr = arguments.length, tn = new Array(Jr > 1 ? Jr - 1 : 0), zr = 1; zr < Jr; zr++)
      tn[zr - 1] = arguments[zr];
    if (Je) {
      var cr;
      (cr = Le.current) === null || cr === void 0 || cr.onKeyUp.apply(cr, [tr].concat(tn));
    }
    ne?.apply(void 0, [tr].concat(tn));
  }, zt = function(tr) {
    var Jr = u.filter(function(tn) {
      return tn !== tr;
    });
    d(Jr, {
      type: "remove",
      values: [tr]
    });
  }, Be = p.useRef(!1), ft = function() {
    Ne(!0), S || (Q && !Be.current && Q.apply(void 0, arguments), se.includes("focus") && ot(!0)), Be.current = !0;
  }, yt = function() {
    Ie.current = !0, Ne(!1, function() {
      Be.current = !1, Ie.current = !1, ot(!1);
    }), !S && (Qe && (y === "tags" ? L(Qe, {
      source: "submit"
    }) : y === "multiple" && L("", {
      source: "blur"
    })), he && he.apply(void 0, arguments));
  }, Rt = [];
  p.useEffect(function() {
    return function() {
      Rt.forEach(function(or) {
        return clearTimeout(or);
      }), Rt.splice(0, Rt.length);
    };
  }, []);
  var Ht = function(tr) {
    var Jr, tn = tr.target, zr = (Jr = Ee.current) === null || Jr === void 0 ? void 0 : Jr.getPopupElement();
    if (zr && zr.contains(tn)) {
      var cr = setTimeout(function() {
        var Mr = Rt.indexOf(cr);
        if (Mr !== -1 && Rt.splice(Mr, 1), qe(), !$e && !zr.contains(document.activeElement)) {
          var en;
          (en = Te.current) === null || en === void 0 || en.focus();
        }
      });
      Rt.push(cr);
    }
    for (var Ot = arguments.length, Tt = new Array(Ot > 1 ? Ot - 1 : 0), Sr = 1; Sr < Ot; Sr++)
      Tt[Sr - 1] = arguments[Sr];
    k?.apply(void 0, [tr].concat(Tt));
  }, ir = p.useState({}), ar = ye(ir, 2), Nr = ar[1];
  function Xr() {
    Nr({});
  }
  var Qr;
  Ge && (Qr = function(tr) {
    ot(tr);
  }), q0e(function() {
    var or;
    return [de.current, (or = Ee.current) === null || or === void 0 ? void 0 : or.getPopupElement()];
  }, Vt, ot, !!Ge);
  var Ur = p.useMemo(function() {
    return ce(ce({}, e), {}, {
      notFoundContent: h,
      open: Je,
      triggerOpen: Vt,
      id: n,
      showSearch: q,
      multiple: R,
      toggleOpen: ot
    });
  }, [e, h, Vt, Je, n, q, R, ot]), gn = !!j || x, Zt;
  gn && (Zt = /* @__PURE__ */ p.createElement(N1, {
    className: be("".concat(a, "-arrow"), te({}, "".concat(a, "-arrow-loading"), x)),
    customizeIcon: j,
    customizeIconProps: {
      loading: x,
      searchValue: Qe,
      open: Je,
      focused: Fe,
      showSearch: q
    }
  }));
  var er = function() {
    var tr;
    g?.(), (tr = Te.current) === null || tr === void 0 || tr.focus(), d([], {
      type: "clear",
      values: u
    }), _e("", !1, !1);
  }, _r = G0e(a, er, u, F, H, S, Qe, y), Sn = _r.allowClear, On = _r.clearIcon, Un = /* @__PURE__ */ p.createElement(U, {
    ref: Le
  }), oa = be(a, i, te(te(te(te(te(te(te(te(te(te({}, "".concat(a, "-focused"), Fe), "".concat(a, "-multiple"), R), "".concat(a, "-single"), !R), "".concat(a, "-allow-clear"), F), "".concat(a, "-show-arrow"), gn), "".concat(a, "-disabled"), S), "".concat(a, "-loading"), x), "".concat(a, "-open"), Je), "".concat(a, "-customize-input"), tt), "".concat(a, "-show-search"), q)), va = /* @__PURE__ */ p.createElement(wH, {
    ref: Ee,
    disabled: S,
    prefixCls: a,
    visible: Vt,
    popupElement: Un,
    animation: G,
    transitionName: V,
    dropdownStyle: K,
    dropdownClassName: Z,
    direction: l,
    dropdownMatchSelectWidth: ee,
    dropdownRender: ae,
    dropdownAlign: ue,
    placement: re,
    builtinPlacements: oe,
    getPopupContainer: fe,
    empty: f,
    getTriggerDOMNode: function(tr) {
      return (
        // TODO: This is workaround and should be removed in `rc-select`
        // And use new standard `nativeElement` for ref.
        // But we should update `rc-resize-observer` first.
        Se.current || tr
      );
    },
    onPopupVisibleChange: Qr,
    onPopupMouseEnter: Xr
  }, Ge ? /* @__PURE__ */ p.cloneElement(Ge, {
    ref: it
  }) : /* @__PURE__ */ p.createElement(xH, Pe({}, e, {
    domRef: Se,
    prefixCls: a,
    inputElement: tt,
    ref: Te,
    id: n,
    showSearch: q,
    autoClearSearchValue: B,
    mode: y,
    activeDescendantId: P,
    tagRender: s,
    values: u,
    open: Je,
    onToggleOpen: ot,
    activeValue: T,
    searchValue: Qe,
    onSearch: _e,
    onSearchSubmit: Ke,
    onRemove: zt,
    tokenWithEnter: Ct
  }))), Fn;
  return Ge ? Fn = va : Fn = /* @__PURE__ */ p.createElement("div", Pe({
    className: oa
  }, Y, {
    ref: de,
    onMouseDown: Ht,
    onKeyDown: st,
    onKeyUp: Et,
    onFocus: ft,
    onBlur: yt
  }), /* @__PURE__ */ p.createElement(Ahe, {
    visible: Fe && !Je,
    values: u
  }), va, Zt, Sn && On), /* @__PURE__ */ p.createElement(hH.Provider, {
    value: Ur
  }, Fn);
});
process.env.NODE_ENV !== "production" && (TH.displayName = "BaseSelect");
var QT = function() {
  return null;
};
QT.isSelectOptGroup = !0;
var eI = function() {
  return null;
};
eI.isSelectOption = !0;
var IH = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.height, n = e.offsetY, a = e.offsetX, i = e.children, o = e.prefixCls, s = e.onInnerResize, l = e.innerProps, c = e.rtl, u = e.extra, d = {}, f = {
    display: "flex",
    flexDirection: "column"
  };
  return n !== void 0 && (d = {
    height: r,
    position: "relative",
    overflow: "hidden"
  }, f = ce(ce({}, f), {}, te(te(te(te(te({
    transform: "translateY(".concat(n, "px)")
  }, c ? "marginRight" : "marginLeft", -a), "position", "absolute"), "left", 0), "right", 0), "top", 0))), /* @__PURE__ */ p.createElement("div", {
    style: d
  }, /* @__PURE__ */ p.createElement(Ia, {
    onResize: function(h) {
      var g = h.offsetHeight;
      g && s && s();
    }
  }, /* @__PURE__ */ p.createElement("div", Pe({
    style: f,
    className: be(te({}, "".concat(o, "-holder-inner"), o)),
    ref: t
  }, l), i, u)));
});
IH.displayName = "Filler";
function Nhe(e) {
  var t = e.children, r = e.setRef, n = p.useCallback(function(a) {
    r(a);
  }, []);
  return /* @__PURE__ */ p.cloneElement(t, {
    ref: n
  });
}
function Dhe(e, t, r, n, a, i, o, s) {
  var l = s.getKey;
  return e.slice(t, r + 1).map(function(c, u) {
    var d = t + u, f = o(c, d, {
      style: {
        width: n
      },
      offsetX: a
    }), m = l(c);
    return /* @__PURE__ */ p.createElement(Nhe, {
      key: m,
      setRef: function(g) {
        return i(c, g);
      }
    }, f);
  });
}
function jhe(e, t, r) {
  var n = e.length, a = t.length, i, o;
  if (n === 0 && a === 0)
    return null;
  n < a ? (i = e, o = t) : (i = t, o = e);
  var s = {
    __EMPTY_ITEM__: !0
  };
  function l(h) {
    return h !== void 0 ? r(h) : s;
  }
  for (var c = null, u = Math.abs(n - a) !== 1, d = 0; d < o.length; d += 1) {
    var f = l(i[d]), m = l(o[d]);
    if (f !== m) {
      c = d, u = u || f !== l(o[d + 1]);
      break;
    }
  }
  return c === null ? null : {
    index: c,
    multiple: u
  };
}
function Lhe(e, t, r) {
  var n = p.useState(e), a = ye(n, 2), i = a[0], o = a[1], s = p.useState(null), l = ye(s, 2), c = l[0], u = l[1];
  return p.useEffect(function() {
    var d = jhe(i || [], e || [], t);
    d?.index !== void 0 && u(e[d.index]), o(e);
  }, [e]), [c];
}
var vN = (typeof navigator > "u" ? "undefined" : kt(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
const MH = function(e, t, r, n) {
  var a = ct(!1), i = ct(null);
  function o() {
    clearTimeout(i.current), a.current = !0, i.current = setTimeout(function() {
      a.current = !1;
    }, 50);
  }
  var s = ct({
    top: e,
    bottom: t,
    left: r,
    right: n
  });
  return s.current.top = e, s.current.bottom = t, s.current.left = r, s.current.right = n, function(l, c) {
    var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, d = l ? (
      // Pass origin wheel when on the left
      c < 0 && s.current.left || // Pass origin wheel when on the right
      c > 0 && s.current.right
    ) : c < 0 && s.current.top || // Pass origin wheel when on the bottom
    c > 0 && s.current.bottom;
    return u && d ? (clearTimeout(i.current), a.current = !1) : (!d || a.current) && o(), !a.current && d;
  };
};
function khe(e, t, r, n, a, i, o) {
  var s = ct(0), l = ct(null), c = ct(null), u = ct(!1), d = MH(t, r, n, a);
  function f(x, b) {
    vr.cancel(l.current), s.current += b, c.current = b, !d(!1, b) && (vN || x.preventDefault(), l.current = vr(function() {
      var _ = u.current ? 10 : 1;
      o(s.current * _), s.current = 0;
    }));
  }
  function m(x, b) {
    o(b, !0), vN || x.preventDefault();
  }
  var h = ct(null), g = ct(null);
  function y(x) {
    if (e) {
      vr.cancel(g.current), g.current = vr(function() {
        h.current = null;
      }, 2);
      var b = x.deltaX, _ = x.deltaY, $ = x.shiftKey, w = b, O = _;
      (h.current === "sx" || !h.current && $ && _ && !b) && (w = _, O = 0, h.current = "sx");
      var T = Math.abs(w), I = Math.abs(O);
      h.current === null && (h.current = i && T > I ? "x" : "y"), h.current === "y" ? f(x, O) : m(x, w);
    }
  }
  function S(x) {
    e && (u.current = x.detail === c.current);
  }
  return [y, S];
}
function Fhe(e, t, r, n) {
  var a = p.useMemo(function() {
    return [/* @__PURE__ */ new Map(), []];
  }, [e, r.id, n]), i = ye(a, 2), o = i[0], s = i[1], l = function(u) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : u, f = o.get(u), m = o.get(d);
    if (f === void 0 || m === void 0)
      for (var h = e.length, g = s.length; g < h; g += 1) {
        var y, S = e[g], x = t(S);
        o.set(x, g);
        var b = (y = r.get(x)) !== null && y !== void 0 ? y : n;
        if (s[g] = (s[g - 1] || 0) + b, x === u && (f = g), x === d && (m = g), f !== void 0 && m !== void 0)
          break;
      }
    return {
      top: s[f - 1] || 0,
      bottom: s[m]
    };
  };
  return l;
}
var Bhe = /* @__PURE__ */ function() {
  function e() {
    Hn(this, e), te(this, "maps", void 0), te(this, "id", 0), this.maps = /* @__PURE__ */ Object.create(null);
  }
  return Vn(e, [{
    key: "set",
    value: function(r, n) {
      this.maps[r] = n, this.id += 1;
    }
  }, {
    key: "get",
    value: function(r) {
      return this.maps[r];
    }
  }]), e;
}();
function zhe(e, t, r) {
  var n = p.useState(0), a = ye(n, 2), i = a[0], o = a[1], s = ct(/* @__PURE__ */ new Map()), l = ct(new Bhe()), c = ct();
  function u() {
    vr.cancel(c.current);
  }
  function d() {
    var m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    u();
    var h = function() {
      s.current.forEach(function(y, S) {
        if (y && y.offsetParent) {
          var x = I0(y), b = x.offsetHeight;
          l.current.get(S) !== b && l.current.set(S, x.offsetHeight);
        }
      }), o(function(y) {
        return y + 1;
      });
    };
    m ? h() : c.current = vr(h);
  }
  function f(m, h) {
    var g = e(m);
    s.current.get(g), h ? (s.current.set(g, h), d()) : s.current.delete(g);
  }
  return St(function() {
    return u;
  }, []), [f, d, l.current, i];
}
var hN = 14 / 15;
function Hhe(e, t, r) {
  var n = ct(!1), a = ct(0), i = ct(0), o = ct(null), s = ct(null), l, c = function(m) {
    if (n.current) {
      var h = Math.ceil(m.touches[0].pageX), g = Math.ceil(m.touches[0].pageY), y = a.current - h, S = i.current - g, x = Math.abs(y) > Math.abs(S);
      x ? a.current = h : i.current = g, r(x, x ? y : S) && m.preventDefault(), clearInterval(s.current), s.current = setInterval(function() {
        x ? y *= hN : S *= hN;
        var b = Math.floor(x ? y : S);
        (!r(x, b, !0) || Math.abs(b) <= 0.1) && clearInterval(s.current);
      }, 16);
    }
  }, u = function() {
    n.current = !1, l();
  }, d = function(m) {
    l(), m.touches.length === 1 && !n.current && (n.current = !0, a.current = Math.ceil(m.touches[0].pageX), i.current = Math.ceil(m.touches[0].pageY), o.current = m.target, o.current.addEventListener("touchmove", c), o.current.addEventListener("touchend", u));
  };
  l = function() {
    o.current && (o.current.removeEventListener("touchmove", c), o.current.removeEventListener("touchend", u));
  }, hr(function() {
    return e && t.current.addEventListener("touchstart", d), function() {
      var f;
      (f = t.current) === null || f === void 0 || f.removeEventListener("touchstart", d), l(), clearInterval(s.current);
    };
  }, [e]);
}
var gN = 10;
function Vhe(e, t, r, n, a, i, o, s) {
  var l = p.useRef(), c = p.useState(null), u = ye(c, 2), d = u[0], f = u[1];
  return hr(function() {
    if (d && d.times < gN) {
      if (!e.current) {
        f(function(U) {
          return ce({}, U);
        });
        return;
      }
      i();
      var m = d.targetAlign, h = d.originAlign, g = d.index, y = d.offset, S = e.current.clientHeight, x = !1, b = m, _ = null;
      if (S) {
        for (var $ = m || h, w = 0, O = 0, T = 0, I = Math.min(t.length - 1, g), P = 0; P <= I; P += 1) {
          var D = a(t[P]);
          O = w;
          var B = r.get(D);
          T = O + (B === void 0 ? n : B), w = T;
        }
        for (var L = $ === "top" ? y : S - y, N = I; N >= 0; N -= 1) {
          var z = a(t[N]), F = r.get(z);
          if (F === void 0) {
            x = !0;
            break;
          }
          if (L -= F, L <= 0)
            break;
        }
        switch ($) {
          case "top":
            _ = O - y;
            break;
          case "bottom":
            _ = T - S + y;
            break;
          default: {
            var j = e.current.scrollTop, H = j + S;
            O < j ? b = "top" : T > H && (b = "bottom");
          }
        }
        _ !== null && o(_), _ !== d.lastTop && (x = !0);
      }
      x && f(ce(ce({}, d), {}, {
        times: d.times + 1,
        targetAlign: b,
        lastTop: _
      }));
    } else process.env.NODE_ENV !== "production" && d?.times === gN && jt(!1, "Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.");
  }, [d, e.current]), function(m) {
    if (m == null) {
      s();
      return;
    }
    if (vr.cancel(l.current), typeof m == "number")
      o(m);
    else if (m && kt(m) === "object") {
      var h, g = m.align;
      "index" in m ? h = m.index : h = t.findIndex(function(x) {
        return a(x) === m.key;
      });
      var y = m.offset, S = y === void 0 ? 0 : y;
      f({
        times: 0,
        index: h,
        offset: S,
        originAlign: g
      });
    }
  };
}
function yN(e, t) {
  var r = "touches" in e ? e.touches[0] : e;
  return r[t ? "pageX" : "pageY"];
}
var Z2 = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.rtl, a = e.scrollOffset, i = e.scrollRange, o = e.onStartMove, s = e.onStopMove, l = e.onScroll, c = e.horizontal, u = e.spinSize, d = e.containerSize, f = e.style, m = e.thumbStyle, h = p.useState(!1), g = ye(h, 2), y = g[0], S = g[1], x = p.useState(null), b = ye(x, 2), _ = b[0], $ = b[1], w = p.useState(null), O = ye(w, 2), T = O[0], I = O[1], P = !n, D = p.useRef(), B = p.useRef(), L = p.useState(!1), N = ye(L, 2), z = N[0], F = N[1], j = p.useRef(), H = function() {
    clearTimeout(j.current), F(!0), j.current = setTimeout(function() {
      F(!1);
    }, 3e3);
  }, U = i - d || 0, G = d - u || 0, V = p.useMemo(function() {
    if (a === 0 || U === 0)
      return 0;
    var le = a / U;
    return le * G;
  }, [a, U, G]), K = function(se) {
    se.stopPropagation(), se.preventDefault();
  }, Z = p.useRef({
    top: V,
    dragging: y,
    pageY: _,
    startTop: T
  });
  Z.current = {
    top: V,
    dragging: y,
    pageY: _,
    startTop: T
  };
  var ee = function(se) {
    S(!0), $(yN(se, c)), I(Z.current.top), o(), se.stopPropagation(), se.preventDefault();
  };
  p.useEffect(function() {
    var le = function(ne) {
      ne.preventDefault();
    }, se = D.current, Q = B.current;
    return se.addEventListener("touchstart", le), Q.addEventListener("touchstart", ee), function() {
      se.removeEventListener("touchstart", le), Q.removeEventListener("touchstart", ee);
    };
  }, []);
  var ae = p.useRef();
  ae.current = U;
  var ue = p.useRef();
  ue.current = G, p.useEffect(function() {
    if (y) {
      var le, se = function(ne) {
        var me = Z.current, k = me.dragging, M = me.pageY, R = me.startTop;
        vr.cancel(le);
        var q = d / D.current.getBoundingClientRect().height;
        if (k) {
          var Y = (yN(ne, c) - M) * q, X = R;
          !P && c ? X -= Y : X += Y;
          var pe = ae.current, $e = ue.current, J = $e ? X / $e : 0, de = Math.ceil(J * pe);
          de = Math.max(de, 0), de = Math.min(de, pe), le = vr(function() {
            l(de, c);
          });
        }
      }, Q = function() {
        S(!1), s();
      };
      return window.addEventListener("mousemove", se), window.addEventListener("touchmove", se), window.addEventListener("mouseup", Q), window.addEventListener("touchend", Q), function() {
        window.removeEventListener("mousemove", se), window.removeEventListener("touchmove", se), window.removeEventListener("mouseup", Q), window.removeEventListener("touchend", Q), vr.cancel(le);
      };
    }
  }, [y]), p.useEffect(function() {
    H();
  }, [a]), p.useImperativeHandle(t, function() {
    return {
      delayHidden: H
    };
  });
  var re = "".concat(r, "-scrollbar"), oe = {
    position: "absolute",
    visibility: z ? null : "hidden"
  }, fe = {
    position: "absolute",
    background: "rgba(0, 0, 0, 0.5)",
    borderRadius: 99,
    cursor: "pointer",
    userSelect: "none"
  };
  return c ? (oe.height = 8, oe.left = 0, oe.right = 0, oe.bottom = 0, fe.height = "100%", fe.width = u, P ? fe.left = V : fe.right = V) : (oe.width = 8, oe.top = 0, oe.bottom = 0, P ? oe.right = 0 : oe.left = 0, fe.width = "100%", fe.height = u, fe.top = V), /* @__PURE__ */ p.createElement("div", {
    ref: D,
    className: be(re, te(te(te({}, "".concat(re, "-horizontal"), c), "".concat(re, "-vertical"), !c), "".concat(re, "-visible"), z)),
    style: ce(ce({}, oe), f),
    onMouseDown: K,
    onMouseMove: H
  }, /* @__PURE__ */ p.createElement("div", {
    ref: B,
    className: be("".concat(re, "-thumb"), te({}, "".concat(re, "-thumb-moving"), y)),
    style: ce(ce({}, fe), m),
    onMouseDown: ee
  }));
});
process.env.NODE_ENV !== "production" && (Z2.displayName = "ScrollBar");
var Ghe = 20;
function bN() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = e / t * e;
  return isNaN(r) && (r = 0), r = Math.max(r, Ghe), Math.floor(r);
}
var Uhe = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles"], Whe = [], qhe = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function Khe(e, t) {
  var r = e.prefixCls, n = r === void 0 ? "rc-virtual-list" : r, a = e.className, i = e.height, o = e.itemHeight, s = e.fullHeight, l = s === void 0 ? !0 : s, c = e.style, u = e.data, d = e.children, f = e.itemKey, m = e.virtual, h = e.direction, g = e.scrollWidth, y = e.component, S = y === void 0 ? "div" : y, x = e.onScroll, b = e.onVirtualScroll, _ = e.onVisibleChange, $ = e.innerProps, w = e.extraRender, O = e.styles, T = Kt(e, Uhe), I = p.useCallback(function(ft) {
    return typeof f == "function" ? f(ft) : ft?.[f];
  }, [f]), P = zhe(I), D = ye(P, 4), B = D[0], L = D[1], N = D[2], z = D[3], F = !!(m !== !1 && i && o), j = p.useMemo(function() {
    return Object.values(N.maps).reduce(function(ft, yt) {
      return ft + yt;
    }, 0);
  }, [N.id, N.maps]), H = F && u && (Math.max(o * u.length, j) > i || !!g), U = h === "rtl", G = be(n, te({}, "".concat(n, "-rtl"), U), a), V = u || Whe, K = ct(), Z = ct(), ee = ct(), ae = He(0), ue = ye(ae, 2), re = ue[0], oe = ue[1], fe = He(0), le = ye(fe, 2), se = le[0], Q = le[1], he = He(!1), ne = ye(he, 2), me = ne[0], k = ne[1], M = function() {
    k(!0);
  }, R = function() {
    k(!1);
  }, q = {
    getKey: I
  };
  function Y(ft) {
    oe(function(yt) {
      var Rt;
      typeof ft == "function" ? Rt = ft(yt) : Rt = ft;
      var Ht = xt(Rt);
      return K.current.scrollTop = Ht, Ht;
    });
  }
  var X = ct({
    start: 0,
    end: V.length
  }), pe = ct(), $e = Lhe(V, I), J = ye($e, 1), de = J[0];
  pe.current = de;
  var Se = p.useMemo(function() {
    if (!F)
      return {
        scrollHeight: void 0,
        start: 0,
        end: V.length - 1,
        offset: void 0
      };
    if (!H) {
      var ft;
      return {
        scrollHeight: ((ft = Z.current) === null || ft === void 0 ? void 0 : ft.offsetHeight) || 0,
        start: 0,
        end: V.length - 1,
        offset: void 0
      };
    }
    for (var yt = 0, Rt, Ht, ir, ar = V.length, Nr = 0; Nr < ar; Nr += 1) {
      var Xr = V[Nr], Qr = I(Xr), Ur = N.get(Qr), gn = yt + (Ur === void 0 ? o : Ur);
      gn >= re && Rt === void 0 && (Rt = Nr, Ht = yt), gn > re + i && ir === void 0 && (ir = Nr), yt = gn;
    }
    return Rt === void 0 && (Rt = 0, Ht = 0, ir = Math.ceil(i / o)), ir === void 0 && (ir = V.length - 1), ir = Math.min(ir + 1, V.length - 1), {
      scrollHeight: yt,
      start: Rt,
      end: ir,
      offset: Ht
    };
  }, [H, F, re, V, z, i]), Ee = Se.scrollHeight, Te = Se.start, Le = Se.end, Ie = Se.offset;
  X.current.start = Te, X.current.end = Le;
  var De = p.useState({
    width: 0,
    height: i
  }), Ae = ye(De, 2), Fe = Ae[0], Ne = Ae[1], qe = function(yt) {
    Ne({
      width: yt.offsetWidth,
      height: yt.offsetHeight
    });
  }, Qe = ct(), tt = ct(), Ge = p.useMemo(function() {
    return bN(Fe.width, g);
  }, [Fe.width, g]), it = p.useMemo(function() {
    return bN(Fe.height, Ee);
  }, [Fe.height, Ee]), ht = Ee - i, It = ct(ht);
  It.current = ht;
  function xt(ft) {
    var yt = ft;
    return Number.isNaN(It.current) || (yt = Math.min(yt, It.current)), yt = Math.max(yt, 0), yt;
  }
  var Xe = re <= 0, pt = re >= ht, Ze = se <= 0, wt = se >= g, bt = MH(Xe, pt, Ze, wt), Je = function() {
    return {
      x: U ? -se : se,
      y: re
    };
  }, _t = ct(Je()), Vt = br(function(ft) {
    if (b) {
      var yt = ce(ce({}, Je()), ft);
      (_t.current.x !== yt.x || _t.current.y !== yt.y) && (b(yt), _t.current = yt);
    }
  });
  function ot(ft, yt) {
    var Rt = ft;
    yt ? (e2(function() {
      Q(Rt);
    }), Vt()) : Y(Rt);
  }
  function Ct(ft) {
    var yt = ft.currentTarget.scrollTop;
    yt !== re && Y(yt), x?.(ft), Vt();
  }
  var rt = function(yt) {
    var Rt = yt, Ht = g ? g - Fe.width : 0;
    return Rt = Math.max(Rt, 0), Rt = Math.min(Rt, Ht), Rt;
  }, $t = br(function(ft, yt) {
    yt ? (e2(function() {
      Q(function(Rt) {
        var Ht = Rt + (U ? -ft : ft);
        return rt(Ht);
      });
    }), Vt()) : Y(function(Rt) {
      var Ht = Rt + ft;
      return Ht;
    });
  }), Wt = khe(F, Xe, pt, Ze, wt, !!g, $t), _e = ye(Wt, 2), Ke = _e[0], nt = _e[1];
  Hhe(F, K, function(ft, yt, Rt) {
    return bt(ft, yt, Rt) ? !1 : (Ke({
      preventDefault: function() {
      },
      deltaX: ft ? yt : 0,
      deltaY: ft ? 0 : yt
    }), !0);
  }), hr(function() {
    function ft(Rt) {
      F && Rt.preventDefault();
    }
    var yt = K.current;
    return yt.addEventListener("wheel", Ke), yt.addEventListener("DOMMouseScroll", nt), yt.addEventListener("MozMousePixelScroll", ft), function() {
      yt.removeEventListener("wheel", Ke), yt.removeEventListener("DOMMouseScroll", nt), yt.removeEventListener("MozMousePixelScroll", ft);
    };
  }, [F]), hr(function() {
    if (g) {
      var ft = rt(se);
      Q(ft), Vt({
        x: ft
      });
    }
  }, [Fe.width, g]);
  var Ve = function() {
    var yt, Rt;
    (yt = Qe.current) === null || yt === void 0 || yt.delayHidden(), (Rt = tt.current) === null || Rt === void 0 || Rt.delayHidden();
  }, ke = Vhe(K, V, N, o, I, function() {
    return L(!0);
  }, Y, Ve);
  p.useImperativeHandle(t, function() {
    return {
      nativeElement: ee.current,
      getScrollInfo: Je,
      scrollTo: function(yt) {
        function Rt(Ht) {
          return Ht && kt(Ht) === "object" && ("left" in Ht || "top" in Ht);
        }
        Rt(yt) ? (yt.left !== void 0 && Q(rt(yt.left)), ke(yt.top)) : ke(yt);
      }
    };
  }), hr(function() {
    if (_) {
      var ft = V.slice(Te, Le + 1);
      _(ft, V);
    }
  }, [Te, Le, V]);
  var ut = Fhe(V, I, N, o), st = w?.({
    start: Te,
    end: Le,
    virtual: H,
    offsetX: se,
    offsetY: Ie,
    rtl: U,
    getSize: ut
  }), Et = Dhe(V, Te, Le, g, se, B, d, q), zt = null;
  i && (zt = ce(te({}, l ? "height" : "maxHeight", i), qhe), F && (zt.overflowY = "hidden", g && (zt.overflowX = "hidden"), me && (zt.pointerEvents = "none")));
  var Be = {};
  return U && (Be.dir = "rtl"), /* @__PURE__ */ p.createElement("div", Pe({
    ref: ee,
    style: ce(ce({}, c), {}, {
      position: "relative"
    }),
    className: G
  }, Be, T), /* @__PURE__ */ p.createElement(Ia, {
    onResize: qe
  }, /* @__PURE__ */ p.createElement(S, {
    className: "".concat(n, "-holder"),
    style: zt,
    ref: K,
    onScroll: Ct,
    onMouseEnter: Ve
  }, /* @__PURE__ */ p.createElement(IH, {
    prefixCls: n,
    height: Ee,
    offsetX: se,
    offsetY: Ie,
    scrollWidth: g,
    onInnerResize: L,
    ref: Z,
    innerProps: $,
    rtl: U,
    extra: st
  }, Et))), H && Ee > i && /* @__PURE__ */ p.createElement(Z2, {
    ref: Qe,
    prefixCls: n,
    scrollOffset: re,
    scrollRange: Ee,
    rtl: U,
    onScroll: ot,
    onStartMove: M,
    onStopMove: R,
    spinSize: it,
    containerSize: Fe.height,
    style: O?.verticalScrollBar,
    thumbStyle: O?.verticalScrollBarThumb
  }), H && g > Fe.width && /* @__PURE__ */ p.createElement(Z2, {
    ref: tt,
    prefixCls: n,
    scrollOffset: se,
    scrollRange: g,
    rtl: U,
    onScroll: ot,
    onStartMove: M,
    onStopMove: R,
    spinSize: Ge,
    containerSize: Fe.width,
    horizontal: !0,
    style: O?.horizontalScrollBar,
    thumbStyle: O?.horizontalScrollBarThumb
  }));
}
var D1 = /* @__PURE__ */ p.forwardRef(Khe);
D1.displayName = "List";
function Yhe() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
var Zhe = ["disabled", "title", "children", "style", "className"];
function CN(e) {
  return typeof e == "string" || typeof e == "number";
}
var Xhe = function(t, r) {
  var n = U0e(), a = n.prefixCls, i = n.id, o = n.open, s = n.multiple, l = n.mode, c = n.searchValue, u = n.toggleOpen, d = n.notFoundContent, f = n.onPopupScroll, m = p.useContext(JT), h = m.maxCount, g = m.flattenOptions, y = m.onActiveValue, S = m.defaultActiveFirstOption, x = m.onSelect, b = m.menuItemSelectedIcon, _ = m.rawValues, $ = m.fieldNames, w = m.virtual, O = m.direction, T = m.listHeight, I = m.listItemHeight, P = m.optionRender, D = "".concat(a, "-item"), B = Pc(function() {
    return g;
  }, [o, g], function(le, se) {
    return se[0] && le[1] !== se[1];
  }), L = p.useRef(null), N = p.useMemo(function() {
    return s && K2(h) && _?.size >= h;
  }, [s, h, _?.size]), z = function(se) {
    se.preventDefault();
  }, F = function(se) {
    var Q;
    (Q = L.current) === null || Q === void 0 || Q.scrollTo(typeof se == "number" ? {
      index: se
    } : se);
  }, j = function(se) {
    for (var Q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, he = B.length, ne = 0; ne < he; ne += 1) {
      var me = (se + ne * Q + he) % he, k = B[me] || {}, M = k.group, R = k.data;
      if (!M && !(R != null && R.disabled) && !N)
        return me;
    }
    return -1;
  }, H = p.useState(function() {
    return j(0);
  }), U = ye(H, 2), G = U[0], V = U[1], K = function(se) {
    var Q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    V(se);
    var he = {
      source: Q ? "keyboard" : "mouse"
    }, ne = B[se];
    if (!ne) {
      y(null, -1, he);
      return;
    }
    y(ne.value, se, he);
  };
  St(function() {
    K(S !== !1 ? j(0) : -1);
  }, [B.length, c]);
  var Z = p.useCallback(function(le) {
    return _.has(le) && l !== "combobox";
  }, [l, ze(_).toString(), _.size]);
  St(function() {
    var le = setTimeout(function() {
      if (!s && o && _.size === 1) {
        var Q = Array.from(_)[0], he = B.findIndex(function(ne) {
          var me = ne.data;
          return me.value === Q;
        });
        he !== -1 && (K(he), F(he));
      }
    });
    if (o) {
      var se;
      (se = L.current) === null || se === void 0 || se.scrollTo(void 0);
    }
    return function() {
      return clearTimeout(le);
    };
  }, [o, c]);
  var ee = function(se) {
    se !== void 0 && x(se, {
      selected: !_.has(se)
    }), s || u(!1);
  };
  if (p.useImperativeHandle(r, function() {
    return {
      onKeyDown: function(se) {
        var Q = se.which, he = se.ctrlKey;
        switch (Q) {
          case Mt.N:
          case Mt.P:
          case Mt.UP:
          case Mt.DOWN: {
            var ne = 0;
            if (Q === Mt.UP ? ne = -1 : Q === Mt.DOWN ? ne = 1 : Yhe() && he && (Q === Mt.N ? ne = 1 : Q === Mt.P && (ne = -1)), ne !== 0) {
              var me = j(G + ne, ne);
              F(me), K(me, !0);
            }
            break;
          }
          case Mt.ENTER: {
            var k, M = B[G];
            M && !(M != null && (k = M.data) !== null && k !== void 0 && k.disabled) && !N ? ee(M.value) : ee(void 0), o && se.preventDefault();
            break;
          }
          case Mt.ESC:
            u(!1), o && se.stopPropagation();
        }
      },
      onKeyUp: function() {
      },
      scrollTo: function(se) {
        F(se);
      }
    };
  }), B.length === 0)
    return /* @__PURE__ */ p.createElement("div", {
      role: "listbox",
      id: "".concat(i, "_list"),
      className: "".concat(D, "-empty"),
      onMouseDown: z
    }, d);
  var ae = Object.keys($).map(function(le) {
    return $[le];
  }), ue = function(se) {
    return se.label;
  };
  function re(le, se) {
    var Q = le.group;
    return {
      role: Q ? "presentation" : "option",
      id: "".concat(i, "_list_").concat(se)
    };
  }
  var oe = function(se) {
    var Q = B[se];
    if (!Q)
      return null;
    var he = Q.data || {}, ne = he.value, me = Q.group, k = aa(he, !0), M = ue(Q);
    return Q ? /* @__PURE__ */ p.createElement("div", Pe({
      "aria-label": typeof M == "string" && !me ? M : null
    }, k, {
      key: se
    }, re(Q, se), {
      "aria-selected": Z(ne)
    }), ne) : null;
  }, fe = {
    role: "listbox",
    id: "".concat(i, "_list")
  };
  return /* @__PURE__ */ p.createElement(p.Fragment, null, w && /* @__PURE__ */ p.createElement("div", Pe({}, fe, {
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }), oe(G - 1), oe(G), oe(G + 1)), /* @__PURE__ */ p.createElement(D1, {
    itemKey: "key",
    ref: L,
    data: B,
    height: T,
    itemHeight: I,
    fullHeight: !1,
    onMouseDown: z,
    onScroll: f,
    virtual: w,
    direction: O,
    innerProps: w ? null : fe
  }, function(le, se) {
    var Q = le.group, he = le.groupOption, ne = le.data, me = le.label, k = le.value, M = ne.key;
    if (Q) {
      var R, q = (R = ne.title) !== null && R !== void 0 ? R : CN(me) ? me.toString() : void 0;
      return /* @__PURE__ */ p.createElement("div", {
        className: be(D, "".concat(D, "-group"), ne.className),
        title: q
      }, me !== void 0 ? me : M);
    }
    var Y = ne.disabled, X = ne.title;
    ne.children;
    var pe = ne.style, $e = ne.className, J = Kt(ne, Zhe), de = bn(J, ae), Se = Z(k), Ee = Y || !Se && N, Te = "".concat(D, "-option"), Le = be(D, Te, $e, te(te(te(te({}, "".concat(Te, "-grouped"), he), "".concat(Te, "-active"), G === se && !Ee), "".concat(Te, "-disabled"), Ee), "".concat(Te, "-selected"), Se)), Ie = ue(le), De = !b || typeof b == "function" || Se, Ae = typeof Ie == "number" ? Ie : Ie || k, Fe = CN(Ae) ? Ae.toString() : void 0;
    return X !== void 0 && (Fe = X), /* @__PURE__ */ p.createElement("div", Pe({}, aa(de), w ? {} : re(le, se), {
      "aria-selected": Se,
      className: Le,
      title: Fe,
      onMouseMove: function() {
        G === se || Ee || K(se);
      },
      onClick: function() {
        Ee || ee(k);
      },
      style: pe
    }), /* @__PURE__ */ p.createElement("div", {
      className: "".concat(Te, "-content")
    }, typeof P == "function" ? P(le, {
      index: se
    }) : Ae), /* @__PURE__ */ p.isValidElement(b) || Se, De && /* @__PURE__ */ p.createElement(N1, {
      className: "".concat(D, "-option-state"),
      customizeIcon: b,
      customizeIconProps: {
        value: k,
        disabled: Ee,
        isSelected: Se
      }
    }, Se ? "✓" : null));
  }));
}, AH = /* @__PURE__ */ p.forwardRef(Xhe);
process.env.NODE_ENV !== "production" && (AH.displayName = "OptionList");
const Jhe = function(e, t) {
  var r = p.useRef({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  }), n = p.useMemo(function() {
    var i = r.current, o = i.values, s = i.options, l = e.map(function(d) {
      if (d.label === void 0) {
        var f;
        return ce(ce({}, d), {}, {
          label: (f = o.get(d.value)) === null || f === void 0 ? void 0 : f.label
        });
      }
      return d;
    }), c = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map();
    return l.forEach(function(d) {
      c.set(d.value, d), u.set(d.value, t.get(d.value) || s.get(d.value));
    }), r.current.values = c, r.current.options = u, l;
  }, [e, t]), a = p.useCallback(function(i) {
    return t.get(i) || r.current.options.get(i);
  }, [t]);
  return [n, a];
};
function yx(e, t) {
  return XT(e).join("").toUpperCase().includes(t);
}
const Qhe = function(e, t, r, n, a) {
  return p.useMemo(function() {
    if (!r || n === !1)
      return e;
    var i = t.options, o = t.label, s = t.value, l = [], c = typeof n == "function", u = r.toUpperCase(), d = c ? n : function(m, h) {
      return a ? yx(h[a], u) : h[i] ? yx(h[o !== "children" ? o : "label"], u) : yx(h[s], u);
    }, f = c ? function(m) {
      return Y2(m);
    } : function(m) {
      return m;
    };
    return e.forEach(function(m) {
      if (m[i]) {
        var h = d(r, f(m));
        if (h)
          l.push(m);
        else {
          var g = m[i].filter(function(y) {
            return d(r, f(y));
          });
          g.length && l.push(ce(ce({}, m), {}, te({}, i, g)));
        }
        return;
      }
      d(r, f(m)) && l.push(m);
    }), l;
  }, [e, n, a, r, t]);
};
var SN = 0, ege = process.env.NODE_ENV !== "test" && Ca();
function tge() {
  var e;
  return ege ? (e = SN, SN += 1) : e = "TEST_OR_SSR", e;
}
function rge(e) {
  var t = p.useState(), r = ye(t, 2), n = r[0], a = r[1];
  return p.useEffect(function() {
    a("rc_select_".concat(tge()));
  }, []), e || n;
}
var nge = ["children", "value"], age = ["children"];
function ige(e) {
  var t = e, r = t.key, n = t.props, a = n.children, i = n.value, o = Kt(n, nge);
  return ce({
    key: r,
    value: i !== void 0 ? i : r,
    children: a
  }, o);
}
function tI(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return Ma(e).map(function(r, n) {
    if (!/* @__PURE__ */ p.isValidElement(r) || !r.type)
      return null;
    var a = r, i = a.type.isSelectOptGroup, o = a.key, s = a.props, l = s.children, c = Kt(s, age);
    return t || !i ? ige(r) : ce(ce({
      key: "__RC_SELECT_GRP__".concat(o === null ? n : o, "__"),
      label: o
    }, c), {}, {
      options: tI(l)
    });
  }).filter(function(r) {
    return r;
  });
}
var oge = function(t, r, n, a, i) {
  return p.useMemo(function() {
    var o = t, s = !t;
    s && (o = tI(r));
    var l = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map(), u = function(m, h, g) {
      g && typeof g == "string" && m.set(h[g], h);
    }, d = function f(m) {
      for (var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, g = 0; g < m.length; g += 1) {
        var y = m[g];
        !y[n.options] || h ? (l.set(y[n.value], y), u(c, y, n.label), u(c, y, a), u(c, y, i)) : f(y[n.options], !0);
      }
    };
    return d(o), {
      options: o,
      valueOptions: l,
      labelOptions: c
    };
  }, [t, r, n, a, i]);
};
function xN(e) {
  var t = p.useRef();
  t.current = e;
  var r = p.useCallback(function() {
    return t.current.apply(t, arguments);
  }, []);
  return r;
}
function sge(e) {
  var t = e.mode, r = e.options, n = e.children, a = e.backfill, i = e.allowClear, o = e.placeholder, s = e.getInputElement, l = e.showSearch, c = e.onSearch, u = e.defaultOpen, d = e.autoFocus, f = e.labelInValue, m = e.value, h = e.inputValue, g = e.optionLabelProp, y = Db(t), S = l !== void 0 ? l : y || t === "combobox", x = r || tI(n);
  if (jt(t !== "tags" || x.every(function(w) {
    return !w.disabled;
  }), "Please avoid setting option to disabled in tags mode since user can always type text as tag."), t === "tags" || t === "combobox") {
    var b = x.some(function(w) {
      return w.options ? w.options.some(function(O) {
        return typeof ("value" in O ? O.value : O.key) == "number";
      }) : typeof ("value" in w ? w.value : w.key) == "number";
    });
    jt(!b, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
  }
  if (jt(t !== "combobox" || !g, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly."), jt(t === "combobox" || !a, "`backfill` only works with `combobox` mode."), jt(t === "combobox" || !s, "`getInputElement` only work with `combobox` mode."), $b(t !== "combobox" || !s || !i || !o, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`."), c && !S && t !== "combobox" && t !== "tags" && jt(!1, "`onSearch` should work with `showSearch` instead of use alone."), $b(!u || d, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed."), m != null) {
    var _ = XT(m);
    jt(!f || _.every(function(w) {
      return kt(w) === "object" && ("key" in w || "value" in w);
    }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`"), jt(!y || Array.isArray(m), "`value` should be array when `mode` is `multiple` or `tags`");
  }
  if (n) {
    var $ = null;
    Ma(n).some(function(w) {
      if (!/* @__PURE__ */ p.isValidElement(w) || !w.type)
        return !1;
      var O = w, T = O.type;
      if (T.isSelectOption)
        return !1;
      if (T.isSelectOptGroup) {
        var I = Ma(w.props.children).every(function(P) {
          return !/* @__PURE__ */ p.isValidElement(P) || !w.type || P.type.isSelectOption ? !0 : ($ = P.type, !1);
        });
        return !I;
      }
      return $ = T, !0;
    }), $ && jt(!1, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat($.displayName || $.name || $, "`.")), jt(h === void 0, "`inputValue` is deprecated, please use `searchValue` instead.");
  }
}
function lge(e, t) {
  if (e) {
    var r = function n(a) {
      for (var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, o = 0; o < a.length; o++) {
        var s = a[o];
        if (s[t?.value] === null)
          return jt(!1, "`value` in Select options should not be `null`."), !0;
        if (!i && Array.isArray(s[t?.options]) && n(s[t?.options], !0))
          break;
      }
    };
    r(e);
  }
}
var cge = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "optionRender", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "labelRender", "value", "defaultValue", "labelInValue", "onChange", "maxCount"], uge = ["inputValue"];
function dge(e) {
  return !e || kt(e) !== "object";
}
var PH = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.id, n = e.mode, a = e.prefixCls, i = a === void 0 ? "rc-select" : a, o = e.backfill, s = e.fieldNames, l = e.inputValue, c = e.searchValue, u = e.onSearch, d = e.autoClearSearchValue, f = d === void 0 ? !0 : d, m = e.onSelect, h = e.onDeselect, g = e.dropdownMatchSelectWidth, y = g === void 0 ? !0 : g, S = e.filterOption, x = e.filterSort, b = e.optionFilterProp, _ = e.optionLabelProp, $ = e.options, w = e.optionRender, O = e.children, T = e.defaultActiveFirstOption, I = e.menuItemSelectedIcon, P = e.virtual, D = e.direction, B = e.listHeight, L = B === void 0 ? 200 : B, N = e.listItemHeight, z = N === void 0 ? 20 : N, F = e.labelRender, j = e.value, H = e.defaultValue, U = e.labelInValue, G = e.onChange, V = e.maxCount, K = Kt(e, cge), Z = rge(r), ee = Db(n), ae = !!(!$ && O), ue = p.useMemo(function() {
    return S === void 0 && n === "combobox" ? !1 : S;
  }, [S, n]), re = p.useMemo(
    function() {
      return OH(s, ae);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [
      // We stringify fieldNames to avoid unnecessary re-renders.
      JSON.stringify(s),
      ae
    ]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), oe = Kr("", {
    value: c !== void 0 ? c : l,
    postState: function(Ct) {
      return Ct || "";
    }
  }), fe = ye(oe, 2), le = fe[0], se = fe[1], Q = oge($, O, re, b, _), he = Q.valueOptions, ne = Q.labelOptions, me = Q.options, k = p.useCallback(function(ot) {
    var Ct = XT(ot);
    return Ct.map(function(rt) {
      var $t, Wt, _e, Ke, nt;
      if (dge(rt))
        $t = rt;
      else {
        var Ve;
        _e = rt.key, Wt = rt.label, $t = (Ve = rt.value) !== null && Ve !== void 0 ? Ve : _e;
      }
      var ke = he.get($t);
      if (ke) {
        var ut;
        if (Wt === void 0 && (Wt = ke?.[_ || re.label]), _e === void 0 && (_e = (ut = ke?.key) !== null && ut !== void 0 ? ut : $t), Ke = ke?.disabled, nt = ke?.title, process.env.NODE_ENV !== "production" && !_) {
          var st = ke?.[re.label];
          st !== void 0 && !/* @__PURE__ */ p.isValidElement(st) && !/* @__PURE__ */ p.isValidElement(Wt) && st !== Wt && jt(!1, "`label` of `value` is not same as `label` in Select options.");
        }
      }
      return {
        label: Wt,
        value: $t,
        key: _e,
        disabled: Ke,
        title: nt
      };
    });
  }, [re, _, he]), M = Kr(H, {
    value: j
  }), R = ye(M, 2), q = R[0], Y = R[1], X = p.useMemo(function() {
    var ot, Ct = ee && q === null ? [] : q, rt = k(Ct);
    return n === "combobox" && uhe((ot = rt[0]) === null || ot === void 0 ? void 0 : ot.value) ? [] : rt;
  }, [q, k, n, ee]), pe = Jhe(X, he), $e = ye(pe, 2), J = $e[0], de = $e[1], Se = p.useMemo(function() {
    if (!n && J.length === 1) {
      var ot = J[0];
      if (ot.value === null && (ot.label === null || ot.label === void 0))
        return [];
    }
    return J.map(function(Ct) {
      var rt;
      return ce(ce({}, Ct), {}, {
        label: (rt = typeof F == "function" ? F(Ct) : Ct.label) !== null && rt !== void 0 ? rt : Ct.value
      });
    });
  }, [n, J, F]), Ee = p.useMemo(function() {
    return new Set(J.map(function(ot) {
      return ot.value;
    }));
  }, [J]);
  p.useEffect(function() {
    if (n === "combobox") {
      var ot, Ct = (ot = J[0]) === null || ot === void 0 ? void 0 : ot.value;
      se(che(Ct) ? String(Ct) : "");
    }
  }, [J]);
  var Te = xN(function(ot, Ct) {
    var rt = Ct ?? ot;
    return te(te({}, re.value, ot), re.label, rt);
  }), Le = p.useMemo(function() {
    if (n !== "tags")
      return me;
    var ot = ze(me), Ct = function($t) {
      return he.has($t);
    };
    return ze(J).sort(function(rt, $t) {
      return rt.value < $t.value ? -1 : 1;
    }).forEach(function(rt) {
      var $t = rt.value;
      Ct($t) || ot.push(Te($t, rt.label));
    }), ot;
  }, [Te, me, he, J, n]), Ie = Qhe(Le, re, le, ue, b), De = p.useMemo(function() {
    return n !== "tags" || !le || Ie.some(function(ot) {
      return ot[b || "value"] === le;
    }) || Ie.some(function(ot) {
      return ot[re.value] === le;
    }) ? Ie : [Te(le)].concat(ze(Ie));
  }, [Te, b, n, Ie, le, re]), Ae = p.useMemo(function() {
    return x ? ze(De).sort(function(ot, Ct) {
      return x(ot, Ct);
    }) : De;
  }, [De, x]), Fe = p.useMemo(function() {
    return Ihe(Ae, {
      fieldNames: re,
      childrenAsData: ae
    });
  }, [Ae, re, ae]), Ne = function(Ct) {
    var rt = k(Ct);
    if (Y(rt), G && // Trigger event only when value changed
    (rt.length !== J.length || rt.some(function(_e, Ke) {
      var nt;
      return ((nt = J[Ke]) === null || nt === void 0 ? void 0 : nt.value) !== _e?.value;
    }))) {
      var $t = U ? rt : rt.map(function(_e) {
        return _e.value;
      }), Wt = rt.map(function(_e) {
        return Y2(de(_e.value));
      });
      G(
        // Value
        ee ? $t : $t[0],
        // Option
        ee ? Wt : Wt[0]
      );
    }
  }, qe = p.useState(null), Qe = ye(qe, 2), tt = Qe[0], Ge = Qe[1], it = p.useState(0), ht = ye(it, 2), It = ht[0], xt = ht[1], Xe = T !== void 0 ? T : n !== "combobox", pt = p.useCallback(function(ot, Ct) {
    var rt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, $t = rt.source, Wt = $t === void 0 ? "keyboard" : $t;
    xt(Ct), o && n === "combobox" && ot !== null && Wt === "keyboard" && Ge(String(ot));
  }, [o, n]), Ze = function(Ct, rt, $t) {
    var Wt = function() {
      var Be, ft = de(Ct);
      return [U ? {
        label: ft?.[re.label],
        value: Ct,
        key: (Be = ft?.key) !== null && Be !== void 0 ? Be : Ct
      } : Ct, Y2(ft)];
    };
    if (rt && m) {
      var _e = Wt(), Ke = ye(_e, 2), nt = Ke[0], Ve = Ke[1];
      m(nt, Ve);
    } else if (!rt && h && $t !== "clear") {
      var ke = Wt(), ut = ye(ke, 2), st = ut[0], Et = ut[1];
      h(st, Et);
    }
  }, wt = xN(function(ot, Ct) {
    var rt, $t = ee ? Ct.selected : !0;
    $t ? rt = ee ? [].concat(ze(J), [ot]) : [ot] : rt = J.filter(function(Wt) {
      return Wt.value !== ot;
    }), Ne(rt), Ze(ot, $t), n === "combobox" ? Ge("") : (!Db || f) && (se(""), Ge(""));
  }), bt = function(Ct, rt) {
    Ne(Ct);
    var $t = rt.type, Wt = rt.values;
    ($t === "remove" || $t === "clear") && Wt.forEach(function(_e) {
      Ze(_e.value, !1, $t);
    });
  }, Je = function(Ct, rt) {
    if (se(Ct), Ge(null), rt.source === "submit") {
      var $t = (Ct || "").trim();
      if ($t) {
        var Wt = Array.from(new Set([].concat(ze(Ee), [$t])));
        Ne(Wt), Ze($t, !0), se("");
      }
      return;
    }
    rt.source !== "blur" && (n === "combobox" && Ne(Ct), u?.(Ct));
  }, _t = function(Ct) {
    var rt = Ct;
    n !== "tags" && (rt = Ct.map(function(Wt) {
      var _e = ne.get(Wt);
      return _e?.value;
    }).filter(function(Wt) {
      return Wt !== void 0;
    }));
    var $t = Array.from(new Set([].concat(ze(Ee), ze(rt))));
    Ne($t), $t.forEach(function(Wt) {
      Ze(Wt, !0);
    });
  }, Vt = p.useMemo(function() {
    var ot = P !== !1 && y !== !1;
    return ce(ce({}, Q), {}, {
      flattenOptions: Fe,
      onActiveValue: pt,
      defaultActiveFirstOption: Xe,
      onSelect: wt,
      menuItemSelectedIcon: I,
      rawValues: Ee,
      fieldNames: re,
      virtual: ot,
      direction: D,
      listHeight: L,
      listItemHeight: z,
      childrenAsData: ae,
      maxCount: V,
      optionRender: w
    });
  }, [V, Q, Fe, pt, Xe, wt, I, Ee, re, P, y, D, L, z, ae, w]);
  return process.env.NODE_ENV !== "production" && (sge(e), lge(me, re)), /* @__PURE__ */ p.createElement(JT.Provider, {
    value: Vt
  }, /* @__PURE__ */ p.createElement(TH, Pe({}, K, {
    // >>> MISC
    id: Z,
    prefixCls: i,
    ref: t,
    omitDomProps: uge,
    mode: n,
    displayValues: Se,
    onDisplayValuesChange: bt,
    direction: D,
    searchValue: le,
    onSearch: Je,
    autoClearSearchValue: f,
    onSearchSplit: _t,
    dropdownMatchSelectWidth: y,
    OptionList: AH,
    emptyOptions: !Fe.length,
    activeValue: tt,
    activeDescendantId: "".concat(Z, "_list_").concat(It)
  })));
});
process.env.NODE_ENV !== "production" && (PH.displayName = "Select");
var rI = PH;
rI.Option = eI;
rI.OptGroup = QT;
function xl(e, t, r) {
  return be({
    [`${e}-status-success`]: t === "success",
    [`${e}-status-warning`]: t === "warning",
    [`${e}-status-error`]: t === "error",
    [`${e}-status-validating`]: t === "validating",
    [`${e}-has-feedback`]: r
  });
}
const kc = (e, t) => t || e, RH = () => {
  const [, e] = ua(), r = new Br(e.colorBgBase).toHsl().l < 0.5 ? {
    opacity: 0.65
  } : {};
  return /* @__PURE__ */ p.createElement("svg", {
    style: r,
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ p.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ p.createElement("g", {
    transform: "translate(24 31.67)"
  }, /* @__PURE__ */ p.createElement("ellipse", {
    fillOpacity: ".8",
    fill: "#F5F5F7",
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
    fill: "#AEB8C2"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    fill: "url(#linearGradient-1)",
    transform: "translate(13.56)"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fill: "#F5F5F7"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
    fill: "#DCE0E6"
  })), /* @__PURE__ */ p.createElement("path", {
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
    fill: "#DCE0E6"
  }), /* @__PURE__ */ p.createElement("g", {
    transform: "translate(149.65 15.383)",
    fill: "#FFF"
  }, /* @__PURE__ */ p.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
};
process.env.NODE_ENV !== "production" && (RH.displayName = "EmptyImage");
const NH = () => {
  const [, e] = ua(), {
    colorFill: t,
    colorFillTertiary: r,
    colorFillQuaternary: n,
    colorBgContainer: a
  } = e, {
    borderColor: i,
    shadowColor: o,
    contentColor: s
  } = dr(() => ({
    borderColor: new Br(t).onBackground(a).toHexShortString(),
    shadowColor: new Br(r).onBackground(a).toHexShortString(),
    contentColor: new Br(n).onBackground(a).toHexShortString()
  }), [t, r, n, a]);
  return /* @__PURE__ */ p.createElement("svg", {
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ p.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ p.createElement("ellipse", {
    fill: o,
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), /* @__PURE__ */ p.createElement("g", {
    fillRule: "nonzero",
    stroke: i
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    fill: s
  }))));
};
process.env.NODE_ENV !== "production" && (NH.displayName = "SimpleImage");
const fge = (e) => {
  const {
    componentCls: t,
    margin: r,
    marginXS: n,
    marginXL: a,
    fontSize: i,
    lineHeight: o
  } = e;
  return {
    [t]: {
      marginInline: n,
      fontSize: i,
      lineHeight: o,
      textAlign: "center",
      // 原来 &-image 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
      [`${t}-image`]: {
        height: e.emptyImgHeight,
        marginBottom: n,
        opacity: e.opacityImage,
        img: {
          height: "100%"
        },
        svg: {
          maxWidth: "100%",
          height: "100%",
          margin: "auto"
        }
      },
      [`${t}-description`]: {
        color: e.colorTextDescription
      },
      // 原来 &-footer 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
      [`${t}-footer`]: {
        marginTop: r
      },
      "&-normal": {
        marginBlock: a,
        color: e.colorTextDescription,
        [`${t}-description`]: {
          color: e.colorTextDescription
        },
        [`${t}-image`]: {
          height: e.emptyImgHeightMD
        }
      },
      "&-small": {
        marginBlock: n,
        color: e.colorTextDescription,
        [`${t}-image`]: {
          height: e.emptyImgHeightSM
        }
      }
    }
  };
}, pge = Zr("Empty", (e) => {
  const {
    componentCls: t,
    controlHeightLG: r,
    calc: n
  } = e, a = $r(e, {
    emptyImgCls: `${t}-img`,
    emptyImgHeight: n(r).mul(2.5).equal(),
    emptyImgHeightMD: r,
    emptyImgHeightSM: n(r).mul(0.875).equal()
  });
  return [fge(a)];
});
var mge = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const DH = /* @__PURE__ */ p.createElement(RH, null), jH = /* @__PURE__ */ p.createElement(NH, null), Io = (e) => {
  var {
    className: t,
    rootClassName: r,
    prefixCls: n,
    image: a = DH,
    description: i,
    children: o,
    imageStyle: s,
    style: l
  } = e, c = mge(e, ["className", "rootClassName", "prefixCls", "image", "description", "children", "imageStyle", "style"]);
  const {
    getPrefixCls: u,
    direction: d,
    empty: f
  } = p.useContext(Lt), m = u("empty", n), [h, g, y] = pge(m), [S] = Ks("Empty"), x = typeof i < "u" ? i : S?.description, b = typeof x == "string" ? x : "empty";
  let _ = null;
  return typeof a == "string" ? _ = /* @__PURE__ */ p.createElement("img", {
    alt: b,
    src: a
  }) : _ = a, h(/* @__PURE__ */ p.createElement("div", Object.assign({
    className: be(g, y, m, f?.className, {
      [`${m}-normal`]: a === jH,
      [`${m}-rtl`]: d === "rtl"
    }, t, r),
    style: Object.assign(Object.assign({}, f?.style), l)
  }, c), /* @__PURE__ */ p.createElement("div", {
    className: `${m}-image`,
    style: s
  }, _), x && /* @__PURE__ */ p.createElement("div", {
    className: `${m}-description`
  }, x), o && /* @__PURE__ */ p.createElement("div", {
    className: `${m}-footer`
  }, o)));
};
Io.PRESENTED_IMAGE_DEFAULT = DH;
Io.PRESENTED_IMAGE_SIMPLE = jH;
process.env.NODE_ENV !== "production" && (Io.displayName = "Empty");
const LH = (e) => {
  const {
    componentName: t
  } = e, {
    getPrefixCls: r
  } = Cr(Lt), n = r("empty");
  switch (t) {
    case "Table":
    case "List":
      return /* @__PURE__ */ xe.createElement(Io, {
        image: Io.PRESENTED_IMAGE_SIMPLE
      });
    case "Select":
    case "TreeSelect":
    case "Cascader":
    case "Transfer":
    case "Mentions":
      return /* @__PURE__ */ xe.createElement(Io, {
        image: Io.PRESENTED_IMAGE_SIMPLE,
        className: `${n}-small`
      });
    default:
      return /* @__PURE__ */ xe.createElement(Io, null);
  }
}, vge = ["outlined", "borderless", "filled"], xd = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
  const r = Cr(Wz);
  let n;
  typeof e < "u" ? n = e : t === !1 ? n = "borderless" : n = r ?? "outlined";
  const a = vge.includes(n);
  return [n, a];
}, hge = (e) => {
  const r = {
    overflow: {
      adjustX: !0,
      adjustY: !0,
      shiftY: !0
    },
    htmlRegion: e === "scroll" ? "scroll" : "visible",
    dynamicInset: !0
  };
  return {
    bottomLeft: Object.assign(Object.assign({}, r), {
      points: ["tl", "bl"],
      offset: [0, 4]
    }),
    bottomRight: Object.assign(Object.assign({}, r), {
      points: ["tr", "br"],
      offset: [0, 4]
    }),
    topLeft: Object.assign(Object.assign({}, r), {
      points: ["bl", "tl"],
      offset: [0, -4]
    }),
    topRight: Object.assign(Object.assign({}, r), {
      points: ["br", "tr"],
      offset: [0, -4]
    })
  };
};
function gge(e, t) {
  return e || hge(t);
}
const $N = (e) => {
  const {
    optionHeight: t,
    optionFontSize: r,
    optionLineHeight: n,
    optionPadding: a
  } = e;
  return {
    position: "relative",
    display: "block",
    minHeight: t,
    padding: a,
    color: e.colorText,
    fontWeight: "normal",
    fontSize: r,
    lineHeight: n,
    boxSizing: "border-box"
  };
}, yge = (e) => {
  const {
    antCls: t,
    componentCls: r
  } = e, n = `${r}-item`, a = `&${t}-slide-up-enter${t}-slide-up-enter-active`, i = `&${t}-slide-up-appear${t}-slide-up-appear-active`, o = `&${t}-slide-up-leave${t}-slide-up-leave-active`, s = `${r}-dropdown-placement-`;
  return [
    {
      [`${r}-dropdown`]: Object.assign(Object.assign({}, Yr(e)), {
        position: "absolute",
        top: -9999,
        zIndex: e.zIndexPopup,
        boxSizing: "border-box",
        padding: e.paddingXXS,
        overflow: "hidden",
        fontSize: e.fontSize,
        // Fix select render lag of long text in chrome
        // https://github.com/ant-design/ant-design/issues/11456
        // https://github.com/ant-design/ant-design/issues/11843
        fontVariant: "initial",
        backgroundColor: e.colorBgElevated,
        borderRadius: e.borderRadiusLG,
        outline: "none",
        boxShadow: e.boxShadowSecondary,
        [`
          ${a}${s}bottomLeft,
          ${i}${s}bottomLeft
        `]: {
          animationName: T1
        },
        [`
          ${a}${s}topLeft,
          ${i}${s}topLeft,
          ${a}${s}topRight,
          ${i}${s}topRight
        `]: {
          animationName: M1
        },
        [`${o}${s}bottomLeft`]: {
          animationName: I1
        },
        [`
          ${o}${s}topLeft,
          ${o}${s}topRight
        `]: {
          animationName: A1
        },
        "&-hidden": {
          display: "none"
        },
        [`${n}`]: Object.assign(Object.assign({}, $N(e)), {
          cursor: "pointer",
          transition: `background ${e.motionDurationSlow} ease`,
          borderRadius: e.borderRadiusSM,
          // =========== Group ============
          "&-group": {
            color: e.colorTextDescription,
            fontSize: e.fontSizeSM,
            cursor: "default"
          },
          // =========== Option ===========
          "&-option": {
            display: "flex",
            "&-content": Object.assign({
              flex: "auto"
            }, cs),
            "&-state": {
              flex: "none",
              display: "flex",
              alignItems: "center"
            },
            [`&-active:not(${n}-option-disabled)`]: {
              backgroundColor: e.optionActiveBg
            },
            [`&-selected:not(${n}-option-disabled)`]: {
              color: e.optionSelectedColor,
              fontWeight: e.optionSelectedFontWeight,
              backgroundColor: e.optionSelectedBg,
              [`${n}-option-state`]: {
                color: e.colorPrimary
              },
              [`&:has(+ ${n}-option-selected:not(${n}-option-disabled))`]: {
                borderEndStartRadius: 0,
                borderEndEndRadius: 0,
                [`& + ${n}-option-selected:not(${n}-option-disabled)`]: {
                  borderStartStartRadius: 0,
                  borderStartEndRadius: 0
                }
              }
            },
            "&-disabled": {
              [`&${n}-option-selected`]: {
                backgroundColor: e.colorBgContainerDisabled
              },
              color: e.colorTextDisabled,
              cursor: "not-allowed"
            },
            "&-grouped": {
              paddingInlineStart: e.calc(e.controlPaddingHorizontal).mul(2).equal()
            }
          },
          "&-empty": Object.assign(Object.assign({}, $N(e)), {
            color: e.colorTextDisabled
          })
        }),
        // =========================== RTL ===========================
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Follow code may reuse in other components
    us(e, "slide-up"),
    us(e, "slide-down"),
    ld(e, "move-up"),
    ld(e, "move-down")
  ];
}, kH = (e) => {
  const {
    multipleSelectItemHeight: t,
    paddingXXS: r,
    lineWidth: n,
    INTERNAL_FIXED_ITEM_MARGIN: a
  } = e, i = e.max(e.calc(r).sub(n).equal(), 0), o = e.max(e.calc(i).sub(a).equal(), 0);
  return {
    basePadding: i,
    containerPadding: o,
    itemHeight: ve(t),
    itemLineHeight: ve(e.calc(t).sub(e.calc(e.lineWidth).mul(2)).equal())
  };
}, bge = (e) => {
  const {
    multipleSelectItemHeight: t,
    selectHeight: r,
    lineWidth: n
  } = e;
  return e.calc(r).sub(t).div(2).sub(n).equal();
}, FH = (e) => {
  const {
    componentCls: t,
    iconCls: r,
    borderRadiusSM: n,
    motionDurationSlow: a,
    paddingXS: i,
    multipleItemColorDisabled: o,
    multipleItemBorderColorDisabled: s,
    colorIcon: l,
    colorIconHover: c,
    INTERNAL_FIXED_ITEM_MARGIN: u
  } = e;
  return {
    /**
     * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
     * may update to redesign with its align logic.
     */
    // =========================== Overflow ===========================
    [`${t}-selection-overflow`]: {
      position: "relative",
      display: "flex",
      flex: "auto",
      flexWrap: "wrap",
      maxWidth: "100%",
      "&-item": {
        flex: "none",
        alignSelf: "center",
        maxWidth: "100%",
        display: "inline-flex"
      },
      // ======================== Selections ==========================
      [`${t}-selection-item`]: {
        display: "flex",
        alignSelf: "center",
        flex: "none",
        boxSizing: "border-box",
        maxWidth: "100%",
        marginBlock: u,
        borderRadius: n,
        cursor: "default",
        transition: `font-size ${a}, line-height ${a}, height ${a}`,
        marginInlineEnd: e.calc(u).mul(2).equal(),
        paddingInlineStart: i,
        paddingInlineEnd: e.calc(i).div(2).equal(),
        [`${t}-disabled&`]: {
          color: o,
          borderColor: s,
          cursor: "not-allowed"
        },
        // It's ok not to do this, but 24px makes bottom narrow in view should adjust
        "&-content": {
          display: "inline-block",
          marginInlineEnd: e.calc(i).div(2).equal(),
          overflow: "hidden",
          whiteSpace: "pre",
          // fix whitespace wrapping. custom tags display all whitespace within.
          textOverflow: "ellipsis"
        },
        "&-remove": Object.assign(Object.assign({}, ih()), {
          display: "inline-flex",
          alignItems: "center",
          color: l,
          fontWeight: "bold",
          fontSize: 10,
          lineHeight: "inherit",
          cursor: "pointer",
          [`> ${r}`]: {
            verticalAlign: "-0.2em"
          },
          "&:hover": {
            color: c
          }
        })
      }
    }
  };
}, Cge = (e, t) => {
  const {
    componentCls: r,
    INTERNAL_FIXED_ITEM_MARGIN: n
  } = e, a = `${r}-selection-overflow`, i = e.multipleSelectItemHeight, o = bge(e), s = t ? `${r}-${t}` : "", l = kH(e);
  return {
    [`${r}-multiple${s}`]: Object.assign(Object.assign({}, FH(e)), {
      // ========================= Selector =========================
      [`${r}-selector`]: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        height: "100%",
        // Multiple is little different that horizontal is follow the vertical
        paddingInline: l.basePadding,
        paddingBlock: l.containerPadding,
        borderRadius: e.borderRadius,
        [`${r}-disabled&`]: {
          background: e.multipleSelectorBgDisabled,
          cursor: "not-allowed"
        },
        "&:after": {
          display: "inline-block",
          width: 0,
          margin: `${ve(n)} 0`,
          lineHeight: ve(i),
          visibility: "hidden",
          content: '"\\a0"'
        }
      },
      // ======================== Selections ========================
      [`${r}-selection-item`]: {
        height: l.itemHeight,
        lineHeight: ve(l.itemLineHeight)
      },
      // ========================== Input ==========================
      [`${a}-item + ${a}-item`]: {
        [`${r}-selection-search`]: {
          marginInlineStart: 0
        }
      },
      // https://github.com/ant-design/ant-design/issues/44754
      [`${a}-item-suffix`]: {
        height: "100%"
      },
      [`${r}-selection-search`]: {
        display: "inline-flex",
        position: "relative",
        maxWidth: "100%",
        marginInlineStart: e.calc(e.inputPaddingHorizontalBase).sub(o).equal(),
        "\n          &-input,\n          &-mirror\n        ": {
          height: i,
          fontFamily: e.fontFamily,
          lineHeight: ve(i),
          transition: `all ${e.motionDurationSlow}`
        },
        "&-input": {
          width: "100%",
          minWidth: 4.1
          // fix search cursor missing
        },
        "&-mirror": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          insetInlineEnd: "auto",
          zIndex: 999,
          whiteSpace: "pre",
          // fix whitespace wrapping caused width calculation bug
          visibility: "hidden"
        }
      },
      // ======================= Placeholder =======================
      [`${r}-selection-placeholder`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: e.inputPaddingHorizontalBase,
        insetInlineEnd: e.inputPaddingHorizontalBase,
        transform: "translateY(-50%)",
        transition: `all ${e.motionDurationSlow}`
      }
    })
  };
};
function bx(e, t) {
  const {
    componentCls: r
  } = e, n = t ? `${r}-${t}` : "", a = {
    [`${r}-multiple${n}`]: {
      fontSize: e.fontSize,
      // ========================= Selector =========================
      [`${r}-selector`]: {
        [`${r}-show-search&`]: {
          cursor: "text"
        }
      },
      [`
        &${r}-show-arrow ${r}-selector,
        &${r}-allow-clear ${r}-selector
      `]: {
        paddingInlineEnd: e.calc(e.fontSizeIcon).add(e.controlPaddingHorizontal).equal()
      }
    }
  };
  return [Cge(e, t), a];
}
const Sge = (e) => {
  const {
    componentCls: t
  } = e, r = $r(e, {
    selectHeight: e.controlHeightSM,
    multipleSelectItemHeight: e.multipleItemHeightSM,
    borderRadius: e.borderRadiusSM,
    borderRadiusSM: e.borderRadiusXS
  }), n = $r(e, {
    fontSize: e.fontSizeLG,
    selectHeight: e.controlHeightLG,
    multipleSelectItemHeight: e.multipleItemHeightLG,
    borderRadius: e.borderRadiusLG,
    borderRadiusSM: e.borderRadius
  });
  return [
    bx(e),
    // ======================== Small ========================
    bx(r, "sm"),
    // Padding
    {
      [`${t}-multiple${t}-sm`]: {
        [`${t}-selection-placeholder`]: {
          insetInline: e.calc(e.controlPaddingHorizontalSM).sub(e.lineWidth).equal()
        },
        // https://github.com/ant-design/ant-design/issues/29559
        [`${t}-selection-search`]: {
          marginInlineStart: 2
          // Magic Number
        }
      }
    },
    // ======================== Large ========================
    bx(n, "lg")
  ];
};
function Cx(e, t) {
  const {
    componentCls: r,
    inputPaddingHorizontalBase: n,
    borderRadius: a
  } = e, i = e.calc(e.controlHeight).sub(e.calc(e.lineWidth).mul(2)).equal(), o = t ? `${r}-${t}` : "";
  return {
    [`${r}-single${o}`]: {
      fontSize: e.fontSize,
      height: e.controlHeight,
      // ========================= Selector =========================
      [`${r}-selector`]: Object.assign(Object.assign({}, Yr(e, !0)), {
        display: "flex",
        borderRadius: a,
        [`${r}-selection-search`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: n,
          insetInlineEnd: n,
          bottom: 0,
          "&-input": {
            width: "100%",
            WebkitAppearance: "textfield"
          }
        },
        [`
          ${r}-selection-item,
          ${r}-selection-placeholder
        `]: {
          padding: 0,
          lineHeight: ve(i),
          transition: `all ${e.motionDurationSlow}, visibility 0s`,
          alignSelf: "center"
        },
        [`${r}-selection-placeholder`]: {
          transition: "none",
          pointerEvents: "none"
        },
        // For common baseline align
        [[
          "&:after",
          /* For '' value baseline align */
          `${r}-selection-item:empty:after`,
          /* For undefined value baseline align */
          `${r}-selection-placeholder:empty:after`
        ].join(",")]: {
          display: "inline-block",
          width: 0,
          visibility: "hidden",
          content: '"\\a0"'
        }
      }),
      [`
        &${r}-show-arrow ${r}-selection-item,
        &${r}-show-arrow ${r}-selection-placeholder
      `]: {
        paddingInlineEnd: e.showArrowPaddingInlineEnd
      },
      // Opacity selection if open
      [`&${r}-open ${r}-selection-item`]: {
        color: e.colorTextPlaceholder
      },
      // ========================== Input ==========================
      // We only change the style of non-customize input which is only support by `combobox` mode.
      // Not customize
      [`&:not(${r}-customize-input)`]: {
        [`${r}-selector`]: {
          width: "100%",
          height: "100%",
          padding: `0 ${ve(n)}`,
          [`${r}-selection-search-input`]: {
            height: i
          },
          "&:after": {
            lineHeight: ve(i)
          }
        }
      },
      [`&${r}-customize-input`]: {
        [`${r}-selector`]: {
          "&:after": {
            display: "none"
          },
          [`${r}-selection-search`]: {
            position: "static",
            width: "100%"
          },
          [`${r}-selection-placeholder`]: {
            position: "absolute",
            insetInlineStart: 0,
            insetInlineEnd: 0,
            padding: `0 ${ve(n)}`,
            "&:after": {
              display: "none"
            }
          }
        }
      }
    }
  };
}
function xge(e) {
  const {
    componentCls: t
  } = e, r = e.calc(e.controlPaddingHorizontalSM).sub(e.lineWidth).equal();
  return [
    Cx(e),
    // ======================== Small ========================
    // Shared
    Cx($r(e, {
      controlHeight: e.controlHeightSM,
      borderRadius: e.borderRadiusSM
    }), "sm"),
    // padding
    {
      [`${t}-single${t}-sm`]: {
        [`&:not(${t}-customize-input)`]: {
          [`${t}-selection-search`]: {
            insetInlineStart: r,
            insetInlineEnd: r
          },
          [`${t}-selector`]: {
            padding: `0 ${ve(r)}`
          },
          // With arrow should provides `padding-right` to show the arrow
          [`&${t}-show-arrow ${t}-selection-search`]: {
            insetInlineEnd: e.calc(r).add(e.calc(e.fontSize).mul(1.5)).equal()
          },
          [`
            &${t}-show-arrow ${t}-selection-item,
            &${t}-show-arrow ${t}-selection-placeholder
          `]: {
            paddingInlineEnd: e.calc(e.fontSize).mul(1.5).equal()
          }
        }
      }
    },
    // ======================== Large ========================
    // Shared
    Cx($r(e, {
      controlHeight: e.singleItemHeightLG,
      fontSize: e.fontSizeLG,
      borderRadius: e.borderRadiusLG
    }), "lg")
  ];
}
const $ge = (e) => {
  const {
    fontSize: t,
    lineHeight: r,
    lineWidth: n,
    controlHeight: a,
    controlHeightSM: i,
    controlHeightLG: o,
    paddingXXS: s,
    controlPaddingHorizontal: l,
    zIndexPopupBase: c,
    colorText: u,
    fontWeightStrong: d,
    controlItemBgActive: f,
    controlItemBgHover: m,
    colorBgContainer: h,
    colorFillSecondary: g,
    colorBgContainerDisabled: y,
    colorTextDisabled: S
  } = e, x = s * 2, b = n * 2, _ = Math.min(a - x, a - b), $ = Math.min(i - x, i - b), w = Math.min(o - x, o - b);
  return {
    INTERNAL_FIXED_ITEM_MARGIN: Math.floor(s / 2),
    zIndexPopup: c + 50,
    optionSelectedColor: u,
    optionSelectedFontWeight: d,
    optionSelectedBg: f,
    optionActiveBg: m,
    optionPadding: `${(a - t * r) / 2}px ${l}px`,
    optionFontSize: t,
    optionLineHeight: r,
    optionHeight: a,
    selectorBg: h,
    clearBg: h,
    singleItemHeightLG: o,
    multipleItemBg: g,
    multipleItemBorderColor: "transparent",
    multipleItemHeight: _,
    multipleItemHeightSM: $,
    multipleItemHeightLG: w,
    multipleSelectorBgDisabled: y,
    multipleItemColorDisabled: S,
    multipleItemBorderColorDisabled: "transparent",
    showArrowPaddingInlineEnd: Math.ceil(e.fontSize * 1.25)
  };
}, BH = (e, t) => {
  const {
    componentCls: r,
    antCls: n,
    controlOutlineWidth: a
  } = e;
  return {
    [`&:not(${r}-customize-input) ${r}-selector`]: {
      border: `${ve(e.lineWidth)} ${e.lineType} ${t.borderColor}`,
      background: e.selectorBg
    },
    [`&:not(${r}-disabled):not(${r}-customize-input):not(${n}-pagination-size-changer)`]: {
      [`&:hover ${r}-selector`]: {
        borderColor: t.hoverBorderHover
      },
      [`${r}-focused& ${r}-selector`]: {
        borderColor: t.activeBorderColor,
        boxShadow: `0 0 0 ${ve(a)} ${t.activeShadowColor}`,
        outline: 0
      }
    }
  };
}, _N = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, BH(e, t))
}), _ge = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign({}, BH(e, {
    borderColor: e.colorBorder,
    hoverBorderHover: e.colorPrimaryHover,
    activeBorderColor: e.colorPrimary,
    activeShadowColor: e.controlOutline
  })), _N(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderHover: e.colorErrorHover,
    activeBorderColor: e.colorError,
    activeShadowColor: e.colorErrorOutline
  })), _N(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderHover: e.colorWarningHover,
    activeBorderColor: e.colorWarning,
    activeShadowColor: e.colorWarningOutline
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        background: e.colorBgContainerDisabled,
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${ve(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    }
  })
}), zH = (e, t) => {
  const {
    componentCls: r,
    antCls: n
  } = e;
  return {
    [`&:not(${r}-customize-input) ${r}-selector`]: {
      background: t.bg,
      border: `${ve(e.lineWidth)} ${e.lineType} transparent`,
      color: t.color
    },
    [`&:not(${r}-disabled):not(${r}-customize-input):not(${n}-pagination-size-changer)`]: {
      [`&:hover ${r}-selector`]: {
        background: t.hoverBg
      },
      [`${r}-focused& ${r}-selector`]: {
        background: e.selectorBg,
        borderColor: t.activeBorderColor,
        outline: 0
      }
    }
  };
}, EN = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, zH(e, t))
}), Ege = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign({}, zH(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.colorPrimary,
    color: e.colorText
  })), EN(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    color: e.colorError
  })), EN(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    color: e.colorWarning
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        borderColor: e.colorBorder,
        background: e.colorBgContainerDisabled,
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.colorBgContainer,
      border: `${ve(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
    }
  })
}), wge = (e) => ({
  "&-borderless": {
    [`${e.componentCls}-selector`]: {
      background: "transparent",
      borderColor: "transparent"
    },
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${ve(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    }
  }
}), Oge = (e) => ({
  [e.componentCls]: Object.assign(Object.assign(Object.assign({}, _ge(e)), Ege(e)), wge(e))
}), Tge = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    position: "relative",
    transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
    input: {
      cursor: "pointer"
    },
    [`${t}-show-search&`]: {
      cursor: "text",
      input: {
        cursor: "auto",
        color: "inherit",
        height: "100%"
      }
    },
    [`${t}-disabled&`]: {
      cursor: "not-allowed",
      input: {
        cursor: "not-allowed"
      }
    }
  };
}, Ige = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-selection-search-input`]: {
      margin: 0,
      padding: 0,
      background: "transparent",
      border: "none",
      outline: "none",
      appearance: "none",
      fontFamily: "inherit",
      "&::-webkit-search-cancel-button": {
        display: "none",
        "-webkit-appearance": "none"
      }
    }
  };
}, Mge = (e) => {
  const {
    antCls: t,
    componentCls: r,
    inputPaddingHorizontalBase: n,
    iconCls: a
  } = e;
  return {
    [r]: Object.assign(Object.assign({}, Yr(e)), {
      position: "relative",
      display: "inline-block",
      cursor: "pointer",
      [`&:not(${r}-customize-input) ${r}-selector`]: Object.assign(Object.assign({}, Tge(e)), Ige(e)),
      // ======================== Selection ========================
      [`${r}-selection-item`]: Object.assign(Object.assign({
        flex: 1,
        fontWeight: "normal",
        position: "relative",
        userSelect: "none"
      }, cs), {
        // https://github.com/ant-design/ant-design/issues/40421
        [`> ${t}-typography`]: {
          display: "inline"
        }
      }),
      // ======================= Placeholder =======================
      [`${r}-selection-placeholder`]: Object.assign(Object.assign({}, cs), {
        flex: 1,
        color: e.colorTextPlaceholder,
        pointerEvents: "none"
      }),
      // ========================== Arrow ==========================
      [`${r}-arrow`]: Object.assign(Object.assign({}, ih()), {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: n,
        height: e.fontSizeIcon,
        marginTop: e.calc(e.fontSizeIcon).mul(-1).div(2).equal(),
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        lineHeight: 1,
        textAlign: "center",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        transition: `opacity ${e.motionDurationSlow} ease`,
        [a]: {
          verticalAlign: "top",
          transition: `transform ${e.motionDurationSlow}`,
          "> svg": {
            verticalAlign: "top"
          },
          [`&:not(${r}-suffix)`]: {
            pointerEvents: "auto"
          }
        },
        [`${r}-disabled &`]: {
          cursor: "not-allowed"
        },
        "> *:not(:last-child)": {
          marginInlineEnd: 8
          // FIXME: magic
        }
      }),
      // ========================== Clear ==========================
      [`${r}-clear`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: n,
        zIndex: 1,
        display: "inline-block",
        width: e.fontSizeIcon,
        height: e.fontSizeIcon,
        marginTop: e.calc(e.fontSizeIcon).mul(-1).div(2).equal(),
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        cursor: "pointer",
        opacity: 0,
        transition: `color ${e.motionDurationMid} ease, opacity ${e.motionDurationSlow} ease`,
        textRendering: "auto",
        "&:before": {
          display: "block"
        },
        "&:hover": {
          color: e.colorTextTertiary
        }
      },
      "&:hover": {
        [`${r}-clear`]: {
          opacity: 1
        },
        // Should use the following selector, but since `:has` has poor compatibility,
        // we use `:not(:last-child)` instead, which may cause some problems in some cases.
        // [`${componentCls}-arrow:has(+ ${componentCls}-clear)`]: {
        [`${r}-arrow:not(:last-child)`]: {
          opacity: 0
        }
      }
    }),
    // ========================= Feedback ==========================
    [`${r}-has-feedback`]: {
      [`${r}-clear`]: {
        insetInlineEnd: e.calc(n).add(e.fontSize).add(e.paddingXS).equal()
      }
    }
  };
}, Age = (e) => {
  const {
    componentCls: t
  } = e;
  return [
    {
      [t]: {
        // ==================== In Form ====================
        [`&${t}-in-form-item`]: {
          width: "100%"
        }
      }
    },
    // =====================================================
    // ==                       LTR                       ==
    // =====================================================
    // Base
    Mge(e),
    // Single
    xge(e),
    // Multiple
    Sge(e),
    // Dropdown
    yge(e),
    // =====================================================
    // ==                       RTL                       ==
    // =====================================================
    {
      [`${t}-rtl`]: {
        direction: "rtl"
      }
    },
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    uh(e, {
      borderElCls: `${t}-selector`,
      focusElCls: `${t}-focused`
    })
  ];
}, Pge = Zr("Select", (e, t) => {
  let {
    rootPrefixCls: r
  } = t;
  const n = $r(e, {
    rootPrefixCls: r,
    inputPaddingHorizontalBase: e.calc(e.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: e.multipleItemHeight,
    selectHeight: e.controlHeight
  });
  return [Age(n), Oge(n)];
}, $ge, {
  unitless: {
    optionLineHeight: !0,
    optionSelectedFontWeight: !0
  }
});
var Rge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, name: "check", theme: "outlined" }, Nge = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: Rge
  }));
}, nI = /* @__PURE__ */ p.forwardRef(Nge);
process.env.NODE_ENV !== "production" && (nI.displayName = "CheckOutlined");
var Dge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, name: "down", theme: "outlined" }, jge = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: Dge
  }));
}, j1 = /* @__PURE__ */ p.forwardRef(jge);
process.env.NODE_ENV !== "production" && (j1.displayName = "DownOutlined");
var Lge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, name: "search", theme: "outlined" }, kge = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: Lge
  }));
}, L1 = /* @__PURE__ */ p.forwardRef(kge);
process.env.NODE_ENV !== "production" && (L1.displayName = "SearchOutlined");
function HH(e) {
  let {
    suffixIcon: t,
    clearIcon: r,
    menuItemSelectedIcon: n,
    removeIcon: a,
    loading: i,
    multiple: o,
    hasFeedback: s,
    prefixCls: l,
    showSuffixIcon: c,
    feedbackIcon: u,
    showArrow: d,
    componentName: f
  } = e;
  process.env.NODE_ENV !== "production" && xr(f).deprecated(!r, "clearIcon", "allowClear={{ clearIcon: React.ReactNode }}");
  const m = r ?? /* @__PURE__ */ p.createElement(Nc, null), h = (x) => t === null && !s && !d ? null : /* @__PURE__ */ p.createElement(p.Fragment, null, c !== !1 && x, s && u);
  let g = null;
  if (t !== void 0)
    g = h(t);
  else if (i)
    g = h(/* @__PURE__ */ p.createElement(Dc, {
      spin: !0
    }));
  else {
    const x = `${l}-suffix`;
    g = (b) => {
      let {
        open: _,
        showSearch: $
      } = b;
      return h(_ && $ ? /* @__PURE__ */ p.createElement(L1, {
        className: x
      }) : /* @__PURE__ */ p.createElement(j1, {
        className: x
      }));
    };
  }
  let y = null;
  n !== void 0 ? y = n : o ? y = /* @__PURE__ */ p.createElement(nI, null) : y = null;
  let S = null;
  return a !== void 0 ? S = a : S = /* @__PURE__ */ p.createElement(Ys, null), {
    clearIcon: m,
    suffixIcon: g,
    itemIcon: y,
    removeIcon: S
  };
}
function Fge(e, t) {
  return t !== void 0 ? t : e !== null;
}
var Bge = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const VH = "SECRET_COMBOBOX_MODE_DO_NOT_USE", GH = (e, t) => {
  var r;
  const {
    prefixCls: n,
    bordered: a,
    className: i,
    rootClassName: o,
    getPopupContainer: s,
    popupClassName: l,
    dropdownClassName: c,
    listHeight: u = 256,
    placement: d,
    listItemHeight: f,
    size: m,
    disabled: h,
    notFoundContent: g,
    status: y,
    builtinPlacements: S,
    dropdownMatchSelectWidth: x,
    popupMatchSelectWidth: b,
    direction: _,
    style: $,
    allowClear: w,
    variant: O,
    dropdownStyle: T,
    transitionName: I,
    tagRender: P,
    maxCount: D
  } = e, B = Bge(e, ["prefixCls", "bordered", "className", "rootClassName", "getPopupContainer", "popupClassName", "dropdownClassName", "listHeight", "placement", "listItemHeight", "size", "disabled", "notFoundContent", "status", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "direction", "style", "allowClear", "variant", "dropdownStyle", "transitionName", "tagRender", "maxCount"]), {
    getPopupContainer: L,
    getPrefixCls: N,
    renderEmpty: z,
    direction: F,
    virtual: j,
    popupMatchSelectWidth: H,
    popupOverflow: U,
    select: G
  } = p.useContext(Lt), [, V] = ua(), K = f ?? V?.controlHeight, Z = N("select", n), ee = N(), ae = _ ?? F, {
    compactSize: ue,
    compactItemClassnames: re
  } = El(Z, ae), [oe, fe] = xd(O, a), le = Mn(Z), [se, Q, he] = Pge(Z, le), ne = p.useMemo(() => {
    const {
      mode: tt
    } = e;
    if (tt !== "combobox")
      return tt === VH ? "combobox" : tt;
  }, [e.mode]), me = ne === "multiple" || ne === "tags", k = Fge(e.suffixIcon, e.showArrow), M = (r = b ?? x) !== null && r !== void 0 ? r : H, {
    status: R,
    hasFeedback: q,
    isFormItemInput: Y,
    feedbackIcon: X
  } = p.useContext(xa), pe = kc(R, y);
  let $e;
  g !== void 0 ? $e = g : ne === "combobox" ? $e = null : $e = z?.("Select") || /* @__PURE__ */ p.createElement(LH, {
    componentName: "Select"
  });
  const {
    suffixIcon: J,
    itemIcon: de,
    removeIcon: Se,
    clearIcon: Ee
  } = HH(Object.assign(Object.assign({}, B), {
    multiple: me,
    hasFeedback: q,
    feedbackIcon: X,
    showSuffixIcon: k,
    prefixCls: Z,
    componentName: "Select"
  })), Te = w === !0 ? {
    clearIcon: Ee
  } : w, Le = bn(B, ["suffixIcon", "itemIcon"]), Ie = be(l || c, {
    [`${Z}-dropdown-${ae}`]: ae === "rtl"
  }, o, he, le, Q), De = Xa((tt) => {
    var Ge;
    return (Ge = m ?? ue) !== null && Ge !== void 0 ? Ge : tt;
  }), Ae = p.useContext(Vi), Fe = h ?? Ae, Ne = be({
    [`${Z}-lg`]: De === "large",
    [`${Z}-sm`]: De === "small",
    [`${Z}-rtl`]: ae === "rtl",
    [`${Z}-${oe}`]: fe,
    [`${Z}-in-form-item`]: Y
  }, xl(Z, pe, q), re, G?.className, i, o, he, le, Q), qe = p.useMemo(() => d !== void 0 ? d : ae === "rtl" ? "bottomRight" : "bottomLeft", [d, ae]);
  if (process.env.NODE_ENV !== "production") {
    const tt = xr("Select");
    tt.deprecated(!c, "dropdownClassName", "popupClassName"), tt.deprecated(x === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), process.env.NODE_ENV !== "production" && tt(!("showArrow" in e), "deprecated", "`showArrow` is deprecated which will be removed in next major version. It will be a default behavior, you can hide it by setting `suffixIcon` to null."), tt.deprecated(!("bordered" in e), "bordered", "variant"), process.env.NODE_ENV !== "production" && tt(!(typeof D < "u" && !me), "usage", "`maxCount` only works with mode `multiple` or `tags`");
  }
  const [Qe] = ps("SelectLike", T?.zIndex);
  return se(/* @__PURE__ */ p.createElement(rI, Object.assign({
    ref: t,
    virtual: j,
    showSearch: G?.showSearch
  }, Le, {
    style: Object.assign(Object.assign({}, G?.style), $),
    dropdownMatchSelectWidth: M,
    transitionName: Gi(ee, "slide-up", I),
    builtinPlacements: gge(S, U),
    listHeight: u,
    listItemHeight: K,
    mode: ne,
    prefixCls: Z,
    placement: qe,
    direction: ae,
    suffixIcon: J,
    menuItemSelectedIcon: de,
    removeIcon: Se,
    allowClear: Te,
    notFoundContent: $e,
    className: Ne,
    getPopupContainer: s || L,
    dropdownClassName: Ie,
    disabled: Fe,
    dropdownStyle: Object.assign(Object.assign({}, T), {
      zIndex: Qe
    }),
    maxCount: me ? D : void 0,
    tagRender: me ? P : void 0
  })));
};
process.env.NODE_ENV !== "production" && (GH.displayName = "Select");
const Kn = /* @__PURE__ */ p.forwardRef(GH), zge = P1(Kn);
Kn.SECRET_COMBOBOX_MODE_DO_NOT_USE = VH;
Kn.Option = eI;
Kn.OptGroup = QT;
Kn._InternalPanelDoNotUseOrYouWillBeFired = zge;
process.env.NODE_ENV !== "production" && (Kn.displayName = "Select");
const X0 = ["xxl", "xl", "lg", "md", "sm", "xs"], Hge = (e) => ({
  xs: `(max-width: ${e.screenXSMax}px)`,
  sm: `(min-width: ${e.screenSM}px)`,
  md: `(min-width: ${e.screenMD}px)`,
  lg: `(min-width: ${e.screenLG}px)`,
  xl: `(min-width: ${e.screenXL}px)`,
  xxl: `(min-width: ${e.screenXXL}px)`
}), Vge = (e) => {
  const t = e, r = [].concat(X0).reverse();
  return r.forEach((n, a) => {
    const i = n.toUpperCase(), o = `screen${i}Min`, s = `screen${i}`;
    if (!(t[o] <= t[s]))
      throw new Error(`${o}<=${s} fails : !(${t[o]}<=${t[s]})`);
    if (a < r.length - 1) {
      const l = `screen${i}Max`;
      if (!(t[s] <= t[l]))
        throw new Error(`${s}<=${l} fails : !(${t[s]}<=${t[l]})`);
      const u = `screen${r[a + 1].toUpperCase()}Min`;
      if (!(t[l] <= t[u]))
        throw new Error(`${l}<=${u} fails : !(${t[l]}<=${t[u]})`);
    }
  }), e;
};
function UH() {
  const [, e] = ua(), t = Hge(Vge(e));
  return xe.useMemo(() => {
    const r = /* @__PURE__ */ new Map();
    let n = -1, a = {};
    return {
      matchHandlers: {},
      dispatch(i) {
        return a = i, r.forEach((o) => o(a)), r.size >= 1;
      },
      subscribe(i) {
        return r.size || this.register(), n += 1, r.set(n, i), i(a), n;
      },
      unsubscribe(i) {
        r.delete(i), r.size || this.unregister();
      },
      unregister() {
        Object.keys(t).forEach((i) => {
          const o = t[i], s = this.matchHandlers[o];
          s?.mql.removeListener(s?.listener);
        }), r.clear();
      },
      register() {
        Object.keys(t).forEach((i) => {
          const o = t[i], s = (c) => {
            let {
              matches: u
            } = c;
            this.dispatch(Object.assign(Object.assign({}, a), {
              [i]: u
            }));
          }, l = window.matchMedia(o);
          l.addListener(s), this.matchHandlers[o] = {
            mql: l,
            listener: s
          }, s(l);
        });
      },
      responsiveMap: t
    };
  }, [e]);
}
function WH() {
  const [, e] = p.useReducer((t) => t + 1, 0);
  return e;
}
function qH() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
  const t = ct({}), r = WH(), n = UH();
  return hr(() => {
    const a = n.subscribe((i) => {
      t.current = i, e && r();
    });
    return () => n.unsubscribe(a);
  }, []), t.current;
}
function KH(e) {
  var t = e.children, r = e.prefixCls, n = e.id, a = e.overlayInnerStyle, i = e.className, o = e.style;
  return /* @__PURE__ */ p.createElement("div", {
    className: be("".concat(r, "-content"), i),
    style: o
  }, /* @__PURE__ */ p.createElement("div", {
    className: "".concat(r, "-inner"),
    id: n,
    role: "tooltip",
    style: a
  }, typeof t == "function" ? t() : t));
}
var bu = {
  shiftX: 64,
  adjustY: 1
}, Cu = {
  adjustX: 1,
  shiftY: !0
}, ro = [0, 0], Gge = {
  left: {
    points: ["cr", "cl"],
    overflow: Cu,
    offset: [-4, 0],
    targetOffset: ro
  },
  right: {
    points: ["cl", "cr"],
    overflow: Cu,
    offset: [4, 0],
    targetOffset: ro
  },
  top: {
    points: ["bc", "tc"],
    overflow: bu,
    offset: [0, -4],
    targetOffset: ro
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: bu,
    offset: [0, 4],
    targetOffset: ro
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: bu,
    offset: [0, -4],
    targetOffset: ro
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: Cu,
    offset: [-4, 0],
    targetOffset: ro
  },
  topRight: {
    points: ["br", "tr"],
    overflow: bu,
    offset: [0, -4],
    targetOffset: ro
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: Cu,
    offset: [4, 0],
    targetOffset: ro
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: bu,
    offset: [0, 4],
    targetOffset: ro
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: Cu,
    offset: [4, 0],
    targetOffset: ro
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: bu,
    offset: [0, 4],
    targetOffset: ro
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: Cu,
    offset: [-4, 0],
    targetOffset: ro
  }
}, Uge = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"], Wge = function(t, r) {
  var n = t.overlayClassName, a = t.trigger, i = a === void 0 ? ["hover"] : a, o = t.mouseEnterDelay, s = o === void 0 ? 0 : o, l = t.mouseLeaveDelay, c = l === void 0 ? 0.1 : l, u = t.overlayStyle, d = t.prefixCls, f = d === void 0 ? "rc-tooltip" : d, m = t.children, h = t.onVisibleChange, g = t.afterVisibleChange, y = t.transitionName, S = t.animation, x = t.motion, b = t.placement, _ = b === void 0 ? "right" : b, $ = t.align, w = $ === void 0 ? {} : $, O = t.destroyTooltipOnHide, T = O === void 0 ? !1 : O, I = t.defaultVisible, P = t.getTooltipContainer, D = t.overlayInnerStyle;
  t.arrowContent;
  var B = t.overlay, L = t.id, N = t.showArrow, z = N === void 0 ? !0 : N, F = Kt(t, Uge), j = ct(null);
  fo(r, function() {
    return j.current;
  });
  var H = ce({}, F);
  "visible" in t && (H.popupVisible = t.visible);
  var U = function() {
    return /* @__PURE__ */ p.createElement(KH, {
      key: "content",
      prefixCls: f,
      id: L,
      overlayInnerStyle: D
    }, B);
  };
  return /* @__PURE__ */ p.createElement(hh, Pe({
    popupClassName: n,
    prefixCls: f,
    popup: U,
    action: i,
    builtinPlacements: Gge,
    popupPlacement: _,
    ref: j,
    popupAlign: w,
    getPopupContainer: P,
    onPopupVisibleChange: h,
    afterPopupVisibleChange: g,
    popupTransitionName: y,
    popupAnimation: S,
    popupMotion: x,
    defaultPopupVisible: I,
    autoDestroy: T,
    mouseLeaveDelay: c,
    popupStyle: u,
    mouseEnterDelay: s,
    arrow: z
  }, H), m);
};
const qge = /* @__PURE__ */ Aa(Wge);
function aI(e) {
  const {
    sizePopupArrow: t,
    borderRadiusXS: r,
    borderRadiusOuter: n
  } = e, a = t / 2, i = 0, o = a, s = n * 1 / Math.sqrt(2), l = a - n * (1 - 1 / Math.sqrt(2)), c = a - r * (1 / Math.sqrt(2)), u = n * (Math.sqrt(2) - 1) + r * (1 / Math.sqrt(2)), d = 2 * a - c, f = u, m = 2 * a - s, h = l, g = 2 * a - i, y = o, S = a * Math.sqrt(2) + n * (Math.sqrt(2) - 2), x = n * (Math.sqrt(2) - 1), b = `polygon(${x}px 100%, 50% ${x}px, ${2 * a - x}px 100%, ${x}px 100%)`, _ = `path('M ${i} ${o} A ${n} ${n} 0 0 0 ${s} ${l} L ${c} ${u} A ${r} ${r} 0 0 1 ${d} ${f} L ${m} ${h} A ${n} ${n} 0 0 0 ${g} ${y} Z')`;
  return {
    arrowShadowWidth: S,
    arrowPath: _,
    arrowPolygon: b
  };
}
const YH = (e, t, r) => {
  const {
    sizePopupArrow: n,
    arrowPolygon: a,
    arrowPath: i,
    arrowShadowWidth: o,
    borderRadiusXS: s,
    calc: l
  } = e;
  return {
    pointerEvents: "none",
    width: n,
    height: n,
    overflow: "hidden",
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: n,
      height: l(n).div(2).equal(),
      background: t,
      clipPath: {
        _multi_value_: !0,
        value: [a, i]
      },
      content: '""'
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: o,
      height: o,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: !0,
        value: `0 0 ${ve(s)} 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow: r,
      zIndex: 0,
      background: "transparent"
    }
  };
}, ZH = 8;
function iI(e) {
  const {
    contentRadius: t,
    limitVerticalRadius: r
  } = e, n = t > 12 ? t + 2 : 12;
  return {
    arrowOffsetHorizontal: n,
    arrowOffsetVertical: r ? ZH : n
  };
}
function Jg(e, t) {
  return e ? t : {};
}
function XH(e, t, r) {
  const {
    componentCls: n,
    boxShadowPopoverArrow: a,
    arrowOffsetVertical: i,
    arrowOffsetHorizontal: o
  } = e, {
    arrowDistance: s = 0,
    arrowPlacement: l = {
      left: !0,
      right: !0,
      top: !0,
      bottom: !0
    }
  } = r || {};
  return {
    [n]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${n}-arrow`]: [Object.assign(Object.assign({
        position: "absolute",
        zIndex: 1,
        display: "block"
      }, YH(e, t, a)), {
        "&:before": {
          background: t
        }
      })]
    }, Jg(!!l.top, {
      [[`&-placement-top > ${n}-arrow`, `&-placement-topLeft > ${n}-arrow`, `&-placement-topRight > ${n}-arrow`].join(",")]: {
        bottom: s,
        transform: "translateY(100%) rotate(180deg)"
      },
      [`&-placement-top > ${n}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
      },
      [`&-placement-topLeft > ${n}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: o
        }
      },
      [`&-placement-topRight > ${n}-arrow`]: {
        right: {
          _skip_check_: !0,
          value: o
        }
      }
    })), Jg(!!l.bottom, {
      [[`&-placement-bottom > ${n}-arrow`, `&-placement-bottomLeft > ${n}-arrow`, `&-placement-bottomRight > ${n}-arrow`].join(",")]: {
        top: s,
        transform: "translateY(-100%)"
      },
      [`&-placement-bottom > ${n}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(-100%)"
      },
      [`&-placement-bottomLeft > ${n}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: o
        }
      },
      [`&-placement-bottomRight > ${n}-arrow`]: {
        right: {
          _skip_check_: !0,
          value: o
        }
      }
    })), Jg(!!l.left, {
      [[`&-placement-left > ${n}-arrow`, `&-placement-leftTop > ${n}-arrow`, `&-placement-leftBottom > ${n}-arrow`].join(",")]: {
        right: {
          _skip_check_: !0,
          value: s
        },
        transform: "translateX(100%) rotate(90deg)"
      },
      [`&-placement-left > ${n}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
      },
      [`&-placement-leftTop > ${n}-arrow`]: {
        top: i
      },
      [`&-placement-leftBottom > ${n}-arrow`]: {
        bottom: i
      }
    })), Jg(!!l.right, {
      [[`&-placement-right > ${n}-arrow`, `&-placement-rightTop > ${n}-arrow`, `&-placement-rightBottom > ${n}-arrow`].join(",")]: {
        left: {
          _skip_check_: !0,
          value: s
        },
        transform: "translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-right > ${n}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-rightTop > ${n}-arrow`]: {
        top: i
      },
      [`&-placement-rightBottom > ${n}-arrow`]: {
        bottom: i
      }
    }))
  };
}
function Kge(e, t, r, n) {
  if (n === !1)
    return {
      adjustX: !1,
      adjustY: !1
    };
  const a = n && typeof n == "object" ? n : {}, i = {};
  switch (e) {
    case "top":
    case "bottom":
      i.shiftX = t.arrowOffsetHorizontal * 2 + r, i.shiftY = !0, i.adjustY = !0;
      break;
    case "left":
    case "right":
      i.shiftY = t.arrowOffsetVertical * 2 + r, i.shiftX = !0, i.adjustX = !0;
      break;
  }
  const o = Object.assign(Object.assign({}, i), a);
  return o.shiftX || (o.adjustX = !0), o.shiftY || (o.adjustY = !0), o;
}
const wN = {
  left: {
    points: ["cr", "cl"]
  },
  right: {
    points: ["cl", "cr"]
  },
  top: {
    points: ["bc", "tc"]
  },
  bottom: {
    points: ["tc", "bc"]
  },
  topLeft: {
    points: ["bl", "tl"]
  },
  leftTop: {
    points: ["tr", "tl"]
  },
  topRight: {
    points: ["br", "tr"]
  },
  rightTop: {
    points: ["tl", "tr"]
  },
  bottomRight: {
    points: ["tr", "br"]
  },
  rightBottom: {
    points: ["bl", "br"]
  },
  bottomLeft: {
    points: ["tl", "bl"]
  },
  leftBottom: {
    points: ["br", "bl"]
  }
}, Yge = {
  topLeft: {
    points: ["bl", "tc"]
  },
  leftTop: {
    points: ["tr", "cl"]
  },
  topRight: {
    points: ["br", "tc"]
  },
  rightTop: {
    points: ["tl", "cr"]
  },
  bottomRight: {
    points: ["tr", "bc"]
  },
  rightBottom: {
    points: ["bl", "cr"]
  },
  bottomLeft: {
    points: ["tl", "bc"]
  },
  leftBottom: {
    points: ["br", "cl"]
  }
}, Zge = /* @__PURE__ */ new Set(["topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"]);
function JH(e) {
  const {
    arrowWidth: t,
    autoAdjustOverflow: r,
    arrowPointAtCenter: n,
    offset: a,
    borderRadius: i,
    visibleFirst: o
  } = e, s = t / 2, l = {};
  return Object.keys(wN).forEach((c) => {
    const u = n && Yge[c] || wN[c], d = Object.assign(Object.assign({}, u), {
      offset: [0, 0],
      dynamicInset: !0
    });
    switch (l[c] = d, Zge.has(c) && (d.autoArrow = !1), c) {
      case "top":
      case "topLeft":
      case "topRight":
        d.offset[1] = -s - a;
        break;
      case "bottom":
      case "bottomLeft":
      case "bottomRight":
        d.offset[1] = s + a;
        break;
      case "left":
      case "leftTop":
      case "leftBottom":
        d.offset[0] = -s - a;
        break;
      case "right":
      case "rightTop":
      case "rightBottom":
        d.offset[0] = s + a;
        break;
    }
    const f = iI({
      contentRadius: i,
      limitVerticalRadius: !0
    });
    if (n)
      switch (c) {
        case "topLeft":
        case "bottomLeft":
          d.offset[0] = -f.arrowOffsetHorizontal - s;
          break;
        case "topRight":
        case "bottomRight":
          d.offset[0] = f.arrowOffsetHorizontal + s;
          break;
        case "leftTop":
        case "rightTop":
          d.offset[1] = -f.arrowOffsetHorizontal - s;
          break;
        case "leftBottom":
        case "rightBottom":
          d.offset[1] = f.arrowOffsetHorizontal + s;
          break;
      }
    d.overflow = Kge(c, f, t, r), o && (d.htmlRegion = "visibleFirst");
  }), l;
}
const Xge = (e) => {
  const {
    componentCls: t,
    // ant-tooltip
    tooltipMaxWidth: r,
    tooltipColor: n,
    tooltipBg: a,
    tooltipBorderRadius: i,
    zIndexPopup: o,
    controlHeight: s,
    boxShadowSecondary: l,
    paddingSM: c,
    paddingXS: u
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign(Object.assign(Object.assign({}, Yr(e)), {
        position: "absolute",
        zIndex: o,
        display: "block",
        width: "max-content",
        maxWidth: r,
        visibility: "visible",
        transformOrigin: "var(--arrow-x, 50%) var(--arrow-y, 50%)",
        "&-hidden": {
          display: "none"
        },
        "--antd-arrow-background-color": a,
        // Wrapper for the tooltip content
        [`${t}-inner`]: {
          minWidth: "1em",
          minHeight: s,
          padding: `${ve(e.calc(c).div(2).equal())} ${ve(u)}`,
          color: n,
          textAlign: "start",
          textDecoration: "none",
          wordWrap: "break-word",
          backgroundColor: a,
          borderRadius: i,
          boxShadow: l,
          boxSizing: "border-box"
        },
        // Limit left and right placement radius
        [["&-placement-left", "&-placement-leftTop", "&-placement-leftBottom", "&-placement-right", "&-placement-rightTop", "&-placement-rightBottom"].join(",")]: {
          [`${t}-inner`]: {
            borderRadius: e.min(i, ZH)
          }
        },
        [`${t}-content`]: {
          position: "relative"
        }
      }), LB(e, (d, f) => {
        let {
          darkColor: m
        } = f;
        return {
          [`&${t}-${d}`]: {
            [`${t}-inner`]: {
              backgroundColor: m
            },
            [`${t}-arrow`]: {
              "--antd-arrow-background-color": m
            }
          }
        };
      })), {
        // RTL
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Arrow Style
    XH(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${t}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow
      }
    }
  ];
}, Jge = (e) => Object.assign(Object.assign({
  zIndexPopup: e.zIndexPopupBase + 70
}, iI({
  contentRadius: e.borderRadius,
  limitVerticalRadius: !0
})), aI($r(e, {
  borderRadiusOuter: Math.min(e.borderRadiusOuter, 4)
}))), QH = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return Zr("Tooltip", (n) => {
    const {
      borderRadius: a,
      colorTextLightSolid: i,
      colorBgSpotlight: o
    } = n, s = $r(n, {
      // default variables
      tooltipMaxWidth: 250,
      tooltipColor: i,
      tooltipBorderRadius: a,
      tooltipBg: o
    });
    return [Xge(s), ph(n, "zoom-big-fast")];
  }, Jge, {
    resetStyle: !1,
    // Popover use Tooltip as internal component. We do not need to handle this.
    injectStyle: t
  })(e);
}, Qge = Tb.map((e) => `${e}-inverse`), eye = ["success", "processing", "error", "default", "warning"];
function eV(e) {
  return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0) ? [].concat(ze(Qge), ze(Tb)).includes(e) : Tb.includes(e);
}
function tye(e) {
  return eye.includes(e);
}
function tV(e, t) {
  const r = eV(t), n = be({
    [`${e}-${t}`]: t && r
  }), a = {}, i = {};
  return t && !r && (a.background = t, i["--antd-arrow-background-color"] = t), {
    className: n,
    overlayStyle: a,
    arrowStyle: i
  };
}
const rye = (e) => {
  const {
    prefixCls: t,
    className: r,
    placement: n = "top",
    title: a,
    color: i,
    overlayInnerStyle: o
  } = e, {
    getPrefixCls: s
  } = p.useContext(Lt), l = s("tooltip", t), [c, u, d] = QH(l), f = tV(l, i), m = f.arrowStyle, h = Object.assign(Object.assign({}, o), f.overlayStyle), g = be(u, d, l, `${l}-pure`, `${l}-placement-${n}`, r, f.className);
  return c(/* @__PURE__ */ p.createElement("div", {
    className: g,
    style: m
  }, /* @__PURE__ */ p.createElement("div", {
    className: `${l}-arrow`
  }), /* @__PURE__ */ p.createElement(KH, Object.assign({}, e, {
    className: u,
    prefixCls: l,
    overlayInnerStyle: h
  }), a)));
};
var nye = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const aye = /* @__PURE__ */ p.forwardRef((e, t) => {
  var r, n;
  const {
    prefixCls: a,
    openClassName: i,
    getTooltipContainer: o,
    overlayClassName: s,
    color: l,
    overlayInnerStyle: c,
    children: u,
    afterOpenChange: d,
    afterVisibleChange: f,
    destroyTooltipOnHide: m,
    arrow: h = !0,
    title: g,
    overlay: y,
    builtinPlacements: S,
    arrowPointAtCenter: x = !1,
    autoAdjustOverflow: b = !0
  } = e, _ = !!h, [, $] = ua(), {
    getPopupContainer: w,
    getPrefixCls: O,
    direction: T
  } = p.useContext(Lt), I = xr("Tooltip"), P = p.useRef(null), D = () => {
    var $e;
    ($e = P.current) === null || $e === void 0 || $e.forceAlign();
  };
  p.useImperativeHandle(t, () => {
    var $e;
    return {
      forceAlign: D,
      forcePopupAlign: () => {
        I.deprecated(!1, "forcePopupAlign", "forceAlign"), D();
      },
      nativeElement: ($e = P.current) === null || $e === void 0 ? void 0 : $e.nativeElement
    };
  }), process.env.NODE_ENV !== "production" && ([["visible", "open"], ["defaultVisible", "defaultOpen"], ["onVisibleChange", "onOpenChange"], ["afterVisibleChange", "afterOpenChange"], ["arrowPointAtCenter", "arrow={{ pointAtCenter: true }}"]].forEach(($e) => {
    let [J, de] = $e;
    I.deprecated(!(J in e), J, de);
  }), process.env.NODE_ENV !== "production" && I(!m || typeof m == "boolean", "usage", "`destroyTooltipOnHide` no need config `keepParent` anymore. Please use `boolean` value directly."), process.env.NODE_ENV !== "production" && I(!h || typeof h == "boolean" || !("arrowPointAtCenter" in h), "deprecated", "`arrowPointAtCenter` in `arrow` is deprecated. Please use `pointAtCenter` instead."));
  const [B, L] = Kr(!1, {
    value: (r = e.open) !== null && r !== void 0 ? r : e.visible,
    defaultValue: (n = e.defaultOpen) !== null && n !== void 0 ? n : e.defaultVisible
  }), N = !g && !y && g !== 0, z = ($e) => {
    var J, de;
    L(N ? !1 : $e), N || ((J = e.onOpenChange) === null || J === void 0 || J.call(e, $e), (de = e.onVisibleChange) === null || de === void 0 || de.call(e, $e));
  }, F = p.useMemo(() => {
    var $e, J;
    let de = x;
    return typeof h == "object" && (de = (J = ($e = h.pointAtCenter) !== null && $e !== void 0 ? $e : h.arrowPointAtCenter) !== null && J !== void 0 ? J : x), S || JH({
      arrowPointAtCenter: de,
      autoAdjustOverflow: b,
      arrowWidth: _ ? $.sizePopupArrow : 0,
      borderRadius: $.borderRadius,
      offset: $.marginXXS,
      visibleFirst: !0
    });
  }, [x, h, S, $]), j = p.useMemo(() => g === 0 ? g : y || g || "", [y, g]), H = /* @__PURE__ */ p.createElement(Lc, null, typeof j == "function" ? j() : j), {
    getPopupContainer: U,
    placement: G = "top",
    mouseEnterDelay: V = 0.1,
    mouseLeaveDelay: K = 0.1,
    overlayStyle: Z,
    rootClassName: ee
  } = e, ae = nye(e, ["getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName"]), ue = O("tooltip", a), re = O(), oe = e["data-popover-inject"];
  let fe = B;
  !("open" in e) && !("visible" in e) && N && (fe = !1);
  const le = /* @__PURE__ */ p.isValidElement(u) && !iz(u) ? u : /* @__PURE__ */ p.createElement("span", null, u), se = le.props, Q = !se.className || typeof se.className == "string" ? be(se.className, i || `${ue}-open`) : se.className, [he, ne, me] = QH(ue, !oe), k = tV(ue, l), M = k.arrowStyle, R = Object.assign(Object.assign({}, c), k.overlayStyle), q = be(s, {
    [`${ue}-rtl`]: T === "rtl"
  }, k.className, ee, ne, me), [Y, X] = ps("Tooltip", ae.zIndex), pe = /* @__PURE__ */ p.createElement(qge, Object.assign({}, ae, {
    zIndex: Y,
    showArrow: _,
    placement: G,
    mouseEnterDelay: V,
    mouseLeaveDelay: K,
    prefixCls: ue,
    overlayClassName: q,
    overlayStyle: Object.assign(Object.assign({}, M), Z),
    getTooltipContainer: U || o || w,
    ref: P,
    builtinPlacements: F,
    overlay: H,
    visible: fe,
    onVisibleChange: z,
    afterVisibleChange: d ?? f,
    overlayInnerStyle: R,
    arrowContent: /* @__PURE__ */ p.createElement("span", {
      className: `${ue}-arrow-content`
    }),
    motion: {
      motionName: Gi(re, "zoom-big-fast", e.transitionName),
      motionDeadline: 1e3
    },
    destroyTooltipOnHide: !!m
  }), fe ? Si(le, {
    className: Q
  }) : le);
  return he(/* @__PURE__ */ p.createElement(gd.Provider, {
    value: X
  }, pe));
}), lo = aye;
process.env.NODE_ENV !== "production" && (lo.displayName = "Tooltip");
lo._InternalPanelDoNotUseOrYouWillBeFired = rye;
var iye = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, name: "right", theme: "outlined" }, oye = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: iye
  }));
}, _c = /* @__PURE__ */ p.forwardRef(oye);
process.env.NODE_ENV !== "production" && (_c.displayName = "RightOutlined");
var sye = Mt.ESC, lye = Mt.TAB;
function cye(e) {
  var t = e.visible, r = e.triggerRef, n = e.onVisibleChange, a = e.autoFocus, i = e.overlayRef, o = p.useRef(!1), s = function() {
    if (t) {
      var d, f;
      (d = r.current) === null || d === void 0 || (f = d.focus) === null || f === void 0 || f.call(d), n?.(!1);
    }
  }, l = function() {
    var d;
    return (d = i.current) !== null && d !== void 0 && d.focus ? (i.current.focus(), o.current = !0, !0) : !1;
  }, c = function(d) {
    switch (d.keyCode) {
      case sye:
        s();
        break;
      case lye: {
        var f = !1;
        o.current || (f = l()), f ? d.preventDefault() : s();
        break;
      }
    }
  };
  p.useEffect(function() {
    return t ? (window.addEventListener("keydown", c), a && vr(l, 3), function() {
      window.removeEventListener("keydown", c), o.current = !1;
    }) : function() {
      o.current = !1;
    };
  }, [t]);
}
var uye = /* @__PURE__ */ Aa(function(e, t) {
  var r = e.overlay, n = e.arrow, a = e.prefixCls, i = dr(function() {
    var s;
    return typeof r == "function" ? s = r() : s = r, s;
  }, [r]), o = Za(t, i?.ref);
  return /* @__PURE__ */ xe.createElement(xe.Fragment, null, n && /* @__PURE__ */ xe.createElement("div", {
    className: "".concat(a, "-arrow")
  }), /* @__PURE__ */ xe.cloneElement(i, {
    ref: No(i) ? o : void 0
  }));
}), Su = {
  adjustX: 1,
  adjustY: 1
}, xu = [0, 0], dye = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: Su,
    offset: [0, -4],
    targetOffset: xu
  },
  top: {
    points: ["bc", "tc"],
    overflow: Su,
    offset: [0, -4],
    targetOffset: xu
  },
  topRight: {
    points: ["br", "tr"],
    overflow: Su,
    offset: [0, -4],
    targetOffset: xu
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Su,
    offset: [0, 4],
    targetOffset: xu
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: Su,
    offset: [0, 4],
    targetOffset: xu
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: Su,
    offset: [0, 4],
    targetOffset: xu
  }
}, fye = ["arrow", "prefixCls", "transitionName", "animation", "align", "placement", "placements", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "visible", "trigger", "autoFocus", "overlay", "children", "onVisibleChange"];
function pye(e, t) {
  var r, n = e.arrow, a = n === void 0 ? !1 : n, i = e.prefixCls, o = i === void 0 ? "rc-dropdown" : i, s = e.transitionName, l = e.animation, c = e.align, u = e.placement, d = u === void 0 ? "bottomLeft" : u, f = e.placements, m = f === void 0 ? dye : f, h = e.getPopupContainer, g = e.showAction, y = e.hideAction, S = e.overlayClassName, x = e.overlayStyle, b = e.visible, _ = e.trigger, $ = _ === void 0 ? ["hover"] : _, w = e.autoFocus, O = e.overlay, T = e.children, I = e.onVisibleChange, P = Kt(e, fye), D = xe.useState(), B = ye(D, 2), L = B[0], N = B[1], z = "visible" in e ? b : L, F = xe.useRef(null), j = xe.useRef(null), H = xe.useRef(null);
  xe.useImperativeHandle(t, function() {
    return F.current;
  });
  var U = function(oe) {
    N(oe), I?.(oe);
  };
  cye({
    visible: z,
    triggerRef: H,
    onVisibleChange: U,
    autoFocus: w,
    overlayRef: j
  });
  var G = function(oe) {
    var fe = e.onOverlayClick;
    N(!1), fe && fe(oe);
  }, V = function() {
    return /* @__PURE__ */ xe.createElement(uye, {
      ref: j,
      overlay: O,
      prefixCls: o,
      arrow: a
    });
  }, K = function() {
    return typeof O == "function" ? V : V();
  }, Z = function() {
    var oe = e.minOverlayWidthMatchTrigger, fe = e.alignPoint;
    return "minOverlayWidthMatchTrigger" in e ? oe : !fe;
  }, ee = function() {
    var oe = e.openClassName;
    return oe !== void 0 ? oe : "".concat(o, "-open");
  }, ae = /* @__PURE__ */ xe.cloneElement(T, {
    className: be((r = T.props) === null || r === void 0 ? void 0 : r.className, z && ee()),
    ref: No(T) ? Za(H, T.ref) : void 0
  }), ue = y;
  return !ue && $.indexOf("contextMenu") !== -1 && (ue = ["click"]), /* @__PURE__ */ xe.createElement(hh, Pe({
    builtinPlacements: m
  }, P, {
    prefixCls: o,
    ref: F,
    popupClassName: be(S, te({}, "".concat(o, "-show-arrow"), a)),
    popupStyle: x,
    action: $,
    showAction: g,
    hideAction: ue,
    popupPlacement: d,
    popupAlign: c,
    popupTransitionName: s,
    popupAnimation: l,
    popupVisible: z,
    stretch: Z() ? "minWidth" : "",
    popup: K(),
    onPopupVisibleChange: U,
    onPopupClick: G,
    getPopupContainer: h
  }), ae);
}
const rV = /* @__PURE__ */ xe.forwardRef(pye);
var nV = /* @__PURE__ */ p.createContext(null);
function aV(e, t) {
  return e === void 0 ? null : "".concat(e, "-").concat(t);
}
function iV(e) {
  var t = p.useContext(nV);
  return aV(t, e);
}
var mye = ["children", "locked"], Lo = /* @__PURE__ */ p.createContext(null);
function vye(e, t) {
  var r = ce({}, e);
  return Object.keys(t).forEach(function(n) {
    var a = t[n];
    a !== void 0 && (r[n] = a);
  }), r;
}
function J0(e) {
  var t = e.children, r = e.locked, n = Kt(e, mye), a = p.useContext(Lo), i = Pc(function() {
    return vye(a, n);
  }, [a, n], function(o, s) {
    return !r && (o[0] !== s[0] || !Do(o[1], s[1], !0));
  });
  return /* @__PURE__ */ p.createElement(Lo.Provider, {
    value: i
  }, t);
}
var hye = [], oV = /* @__PURE__ */ p.createContext(null);
function k1() {
  return p.useContext(oV);
}
var sV = /* @__PURE__ */ p.createContext(hye);
function $d(e) {
  var t = p.useContext(sV);
  return p.useMemo(function() {
    return e !== void 0 ? [].concat(ze(t), [e]) : t;
  }, [t, e]);
}
var lV = /* @__PURE__ */ p.createContext(null), oI = /* @__PURE__ */ p.createContext({});
function ON(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (yd(e)) {
    var r = e.nodeName.toLowerCase(), n = (
      // Focusable element
      ["input", "select", "textarea", "button"].includes(r) || // Editable element
      e.isContentEditable || // Anchor with href element
      r === "a" && !!e.getAttribute("href")
    ), a = e.getAttribute("tabindex"), i = Number(a), o = null;
    return a && !Number.isNaN(i) ? o = i : n && o === null && (o = 0), n && e.disabled && (o = null), o !== null && (o >= 0 || t && o < 0);
  }
  return !1;
}
function gye(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = ze(e.querySelectorAll("*")).filter(function(n) {
    return ON(n, t);
  });
  return ON(e, t) && r.unshift(e), r;
}
var X2 = Mt.LEFT, J2 = Mt.RIGHT, Q2 = Mt.UP, cb = Mt.DOWN, ub = Mt.ENTER, cV = Mt.ESC, gf = Mt.HOME, yf = Mt.END, TN = [Q2, cb, X2, J2];
function yye(e, t, r, n) {
  var a, i, o, s, l = "prev", c = "next", u = "children", d = "parent";
  if (e === "inline" && n === ub)
    return {
      inlineTrigger: !0
    };
  var f = (a = {}, te(a, Q2, l), te(a, cb, c), a), m = (i = {}, te(i, X2, r ? c : l), te(i, J2, r ? l : c), te(i, cb, u), te(i, ub, u), i), h = (o = {}, te(o, Q2, l), te(o, cb, c), te(o, ub, u), te(o, cV, d), te(o, X2, r ? u : d), te(o, J2, r ? d : u), o), g = {
    inline: f,
    horizontal: m,
    vertical: h,
    inlineSub: f,
    horizontalSub: h,
    verticalSub: h
  }, y = (s = g["".concat(e).concat(t ? "" : "Sub")]) === null || s === void 0 ? void 0 : s[n];
  switch (y) {
    case l:
      return {
        offset: -1,
        sibling: !0
      };
    case c:
      return {
        offset: 1,
        sibling: !0
      };
    case d:
      return {
        offset: -1,
        sibling: !1
      };
    case u:
      return {
        offset: 1,
        sibling: !1
      };
    default:
      return null;
  }
}
function bye(e) {
  for (var t = e; t; ) {
    if (t.getAttribute("data-menu-list"))
      return t;
    t = t.parentElement;
  }
  return null;
}
function Cye(e, t) {
  for (var r = e || document.activeElement; r; ) {
    if (t.has(r))
      return r;
    r = r.parentElement;
  }
  return null;
}
function sI(e, t) {
  var r = gye(e, !0);
  return r.filter(function(n) {
    return t.has(n);
  });
}
function IN(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  if (!e)
    return null;
  var a = sI(e, t), i = a.length, o = a.findIndex(function(s) {
    return r === s;
  });
  return n < 0 ? o === -1 ? o = i - 1 : o -= 1 : n > 0 && (o += 1), o = (o + i) % i, a[o];
}
var eE = function(t, r) {
  var n = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  return t.forEach(function(o) {
    var s = document.querySelector("[data-menu-id='".concat(aV(r, o), "']"));
    s && (n.add(s), i.set(s, o), a.set(o, s));
  }), {
    elements: n,
    key2element: a,
    element2key: i
  };
};
function Sye(e, t, r, n, a, i, o, s, l, c) {
  var u = p.useRef(), d = p.useRef();
  d.current = t;
  var f = function() {
    vr.cancel(u.current);
  };
  return p.useEffect(function() {
    return function() {
      f();
    };
  }, []), function(m) {
    var h = m.which;
    if ([].concat(TN, [ub, cV, gf, yf]).includes(h)) {
      var g = i(), y = eE(g, n), S = y, x = S.elements, b = S.key2element, _ = S.element2key, $ = b.get(t), w = Cye($, x), O = _.get(w), T = yye(e, o(O, !0).length === 1, r, h);
      if (!T && h !== gf && h !== yf)
        return;
      (TN.includes(h) || [gf, yf].includes(h)) && m.preventDefault();
      var I = function(j) {
        if (j) {
          var H = j, U = j.querySelector("a");
          U != null && U.getAttribute("href") && (H = U);
          var G = _.get(j);
          s(G), f(), u.current = vr(function() {
            d.current === G && H.focus();
          });
        }
      };
      if ([gf, yf].includes(h) || T.sibling || !w) {
        var P;
        !w || e === "inline" ? P = a.current : P = bye(w);
        var D, B = sI(P, x);
        h === gf ? D = B[0] : h === yf ? D = B[B.length - 1] : D = IN(P, x, w, T.offset), I(D);
      } else if (T.inlineTrigger)
        l(O);
      else if (T.offset > 0)
        l(O, !0), f(), u.current = vr(function() {
          y = eE(g, n);
          var F = w.getAttribute("aria-controls"), j = document.getElementById(F), H = IN(j, y.elements);
          I(H);
        }, 5);
      else if (T.offset < 0) {
        var L = o(O, !0), N = L[L.length - 2], z = b.get(N);
        l(N, !1), I(z);
      }
    }
    c?.(m);
  };
}
function xye(e) {
  Promise.resolve().then(e);
}
var lI = "__RC_UTIL_PATH_SPLIT__", MN = function(t) {
  return t.join(lI);
}, $ye = function(t) {
  return t.split(lI);
}, tE = "rc-menu-more";
function _ye() {
  var e = p.useState({}), t = ye(e, 2), r = t[1], n = ct(/* @__PURE__ */ new Map()), a = ct(/* @__PURE__ */ new Map()), i = p.useState([]), o = ye(i, 2), s = o[0], l = o[1], c = ct(0), u = ct(!1), d = function() {
    u.current || r({});
  }, f = Bt(function(b, _) {
    process.env.NODE_ENV !== "production" && jt(!n.current.has(b), "Duplicated key '".concat(b, "' used in Menu by path [").concat(_.join(" > "), "]"));
    var $ = MN(_);
    a.current.set($, b), n.current.set(b, $), c.current += 1;
    var w = c.current;
    xye(function() {
      w === c.current && d();
    });
  }, []), m = Bt(function(b, _) {
    var $ = MN(_);
    a.current.delete($), n.current.delete(b);
  }, []), h = Bt(function(b) {
    l(b);
  }, []), g = Bt(function(b, _) {
    var $ = n.current.get(b) || "", w = $ye($);
    return _ && s.includes(w[0]) && w.unshift(tE), w;
  }, [s]), y = Bt(function(b, _) {
    return b.filter(function($) {
      return $ !== void 0;
    }).some(function($) {
      var w = g($, !0);
      return w.includes(_);
    });
  }, [g]), S = function() {
    var _ = ze(n.current.keys());
    return s.length && _.push(tE), _;
  }, x = Bt(function(b) {
    var _ = "".concat(n.current.get(b)).concat(lI), $ = /* @__PURE__ */ new Set();
    return ze(a.current.keys()).forEach(function(w) {
      w.startsWith(_) && $.add(a.current.get(w));
    }), $;
  }, []);
  return p.useEffect(function() {
    return function() {
      u.current = !0;
    };
  }, []), {
    // Register
    registerPath: f,
    unregisterPath: m,
    refreshOverflowKeys: h,
    // Util
    isSubPathKey: y,
    getKeyPath: g,
    getKeys: S,
    getSubPathKeys: x
  };
}
function _0(e) {
  var t = p.useRef(e);
  t.current = e;
  var r = p.useCallback(function() {
    for (var n, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return (n = t.current) === null || n === void 0 ? void 0 : n.call.apply(n, [t].concat(i));
  }, []);
  return e ? r : void 0;
}
var Eye = Math.random().toFixed(5).toString().slice(2), AN = 0;
function wye(e) {
  var t = Kr(e, {
    value: e
  }), r = ye(t, 2), n = r[0], a = r[1];
  return p.useEffect(function() {
    AN += 1;
    var i = process.env.NODE_ENV === "test" ? "test" : "".concat(Eye, "-").concat(AN);
    a("rc-menu-uuid-".concat(i));
  }, []), n;
}
function uV(e, t, r, n) {
  var a = p.useContext(Lo), i = a.activeKey, o = a.onActive, s = a.onInactive, l = {
    active: i === e
  };
  return t || (l.onMouseEnter = function(c) {
    r?.({
      key: e,
      domEvent: c
    }), o(e);
  }, l.onMouseLeave = function(c) {
    n?.({
      key: e,
      domEvent: c
    }), s(e);
  }), l;
}
function dV(e) {
  var t = p.useContext(Lo), r = t.mode, n = t.rtl, a = t.inlineIndent;
  if (r !== "inline")
    return null;
  var i = e;
  return n ? {
    paddingRight: i * a
  } : {
    paddingLeft: i * a
  };
}
function fV(e) {
  var t = e.icon, r = e.props, n = e.children, a;
  return t === null || t === !1 ? null : (typeof t == "function" ? a = /* @__PURE__ */ p.createElement(t, ce({}, r)) : typeof t != "boolean" && (a = t), a || n || null);
}
var Oye = ["item"];
function jb(e) {
  var t = e.item, r = Kt(e, Oye);
  return Object.defineProperty(r, "item", {
    get: function() {
      return jt(!1, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future."), t;
    }
  }), r;
}
var Tye = ["title", "attribute", "elementRef"], Iye = ["style", "className", "eventKey", "warnKey", "disabled", "itemIcon", "children", "role", "onMouseEnter", "onMouseLeave", "onClick", "onKeyDown", "onFocus"], Mye = ["active"], Aye = /* @__PURE__ */ function(e) {
  ds(r, e);
  var t = fs(r);
  function r() {
    return Hn(this, r), t.apply(this, arguments);
  }
  return Vn(r, [{
    key: "render",
    value: function() {
      var a = this.props, i = a.title, o = a.attribute, s = a.elementRef, l = Kt(a, Tye), c = bn(l, ["eventKey", "popupClassName", "popupOffset", "onTitleClick"]);
      return jt(!o, "`attribute` of Menu.Item is deprecated. Please pass attribute directly."), /* @__PURE__ */ p.createElement(Ro.Item, Pe({}, o, {
        title: typeof i == "string" ? i : void 0
      }, c, {
        ref: s
      }));
    }
  }]), r;
}(p.Component), Pye = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r, n = e.style, a = e.className, i = e.eventKey, o = e.warnKey, s = e.disabled, l = e.itemIcon, c = e.children, u = e.role, d = e.onMouseEnter, f = e.onMouseLeave, m = e.onClick, h = e.onKeyDown, g = e.onFocus, y = Kt(e, Iye), S = iV(i), x = p.useContext(Lo), b = x.prefixCls, _ = x.onItemClick, $ = x.disabled, w = x.overflowDisabled, O = x.itemIcon, T = x.selectedKeys, I = x.onActive, P = p.useContext(oI), D = P._internalRenderMenuItem, B = "".concat(b, "-item"), L = p.useRef(), N = p.useRef(), z = $ || s, F = qs(t, N), j = $d(i);
  process.env.NODE_ENV !== "production" && o && jt(!1, "MenuItem should not leave undefined `key`.");
  var H = function(se) {
    return {
      key: i,
      // Note: For legacy code is reversed which not like other antd component
      keyPath: ze(j).reverse(),
      item: L.current,
      domEvent: se
    };
  }, U = l || O, G = uV(i, z, d, f), V = G.active, K = Kt(G, Mye), Z = T.includes(i), ee = dV(j.length), ae = function(se) {
    if (!z) {
      var Q = H(se);
      m?.(jb(Q)), _(Q);
    }
  }, ue = function(se) {
    if (h?.(se), se.which === Mt.ENTER) {
      var Q = H(se);
      m?.(jb(Q)), _(Q);
    }
  }, re = function(se) {
    I(i), g?.(se);
  }, oe = {};
  e.role === "option" && (oe["aria-selected"] = Z);
  var fe = /* @__PURE__ */ p.createElement(Aye, Pe({
    ref: L,
    elementRef: F,
    role: u === null ? "none" : u || "menuitem",
    tabIndex: s ? null : -1,
    "data-menu-id": w && S ? null : S
  }, y, K, oe, {
    component: "li",
    "aria-disabled": s,
    style: ce(ce({}, ee), n),
    className: be(B, (r = {}, te(r, "".concat(B, "-active"), V), te(r, "".concat(B, "-selected"), Z), te(r, "".concat(B, "-disabled"), z), r), a),
    onClick: ae,
    onKeyDown: ue,
    onFocus: re
  }), c, /* @__PURE__ */ p.createElement(fV, {
    props: ce(ce({}, e), {}, {
      isSelected: Z
    }),
    icon: U
  }));
  return D && (fe = D(fe, e, {
    selected: Z
  })), fe;
});
function Rye(e, t) {
  var r = e.eventKey, n = k1(), a = $d(r);
  return p.useEffect(function() {
    if (n)
      return n.registerPath(r, a), function() {
        n.unregisterPath(r, a);
      };
  }, [a]), n ? null : /* @__PURE__ */ p.createElement(Pye, Pe({}, e, {
    ref: t
  }));
}
const gh = /* @__PURE__ */ p.forwardRef(Rye);
var Nye = ["className", "children"], Dye = function(t, r) {
  var n = t.className, a = t.children, i = Kt(t, Nye), o = p.useContext(Lo), s = o.prefixCls, l = o.mode, c = o.rtl;
  return /* @__PURE__ */ p.createElement("ul", Pe({
    className: be(s, c && "".concat(s, "-rtl"), "".concat(s, "-sub"), "".concat(s, "-").concat(l === "inline" ? "inline" : "vertical"), n),
    role: "menu"
  }, i, {
    "data-menu-list": !0,
    ref: r
  }), a);
}, cI = /* @__PURE__ */ p.forwardRef(Dye);
cI.displayName = "SubMenuList";
function uI(e, t) {
  return Ma(e).map(function(r, n) {
    if (/* @__PURE__ */ p.isValidElement(r)) {
      var a, i, o = r.key, s = (a = (i = r.props) === null || i === void 0 ? void 0 : i.eventKey) !== null && a !== void 0 ? a : o, l = s == null;
      l && (s = "tmp_key-".concat([].concat(ze(t), [n]).join("-")));
      var c = {
        key: s,
        eventKey: s
      };
      return process.env.NODE_ENV !== "production" && l && (c.warnKey = !0), /* @__PURE__ */ p.cloneElement(r, c);
    }
    return r;
  });
}
var Ua = {
  adjustX: 1,
  adjustY: 1
}, jye = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: Ua
  },
  topRight: {
    points: ["br", "tr"],
    overflow: Ua
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Ua
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: Ua
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: Ua
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: Ua
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: Ua
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: Ua
  }
}, Lye = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: Ua
  },
  topRight: {
    points: ["br", "tr"],
    overflow: Ua
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Ua
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: Ua
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: Ua
  },
  rightBottom: {
    points: ["br", "bl"],
    overflow: Ua
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: Ua
  },
  leftBottom: {
    points: ["bl", "br"],
    overflow: Ua
  }
};
function pV(e, t, r) {
  if (t)
    return t;
  if (r)
    return r[e] || r.other;
}
var kye = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
};
function Fye(e) {
  var t = e.prefixCls, r = e.visible, n = e.children, a = e.popup, i = e.popupStyle, o = e.popupClassName, s = e.popupOffset, l = e.disabled, c = e.mode, u = e.onVisibleChange, d = p.useContext(Lo), f = d.getPopupContainer, m = d.rtl, h = d.subMenuOpenDelay, g = d.subMenuCloseDelay, y = d.builtinPlacements, S = d.triggerSubMenuAction, x = d.forceSubMenuRender, b = d.rootClassName, _ = d.motion, $ = d.defaultMotions, w = p.useState(!1), O = ye(w, 2), T = O[0], I = O[1], P = ce(m ? ce({}, Lye) : ce({}, jye), y), D = kye[c], B = pV(c, _, $), L = p.useRef(B);
  c !== "inline" && (L.current = B);
  var N = ce(ce({}, L.current), {}, {
    leavedClassName: "".concat(t, "-hidden"),
    removeOnLeave: !1,
    motionAppear: !0
  }), z = p.useRef();
  return p.useEffect(function() {
    return z.current = vr(function() {
      I(r);
    }), function() {
      vr.cancel(z.current);
    };
  }, [r]), /* @__PURE__ */ p.createElement(hh, {
    prefixCls: t,
    popupClassName: be("".concat(t, "-popup"), te({}, "".concat(t, "-rtl"), m), o, b),
    stretch: c === "horizontal" ? "minWidth" : null,
    getPopupContainer: f,
    builtinPlacements: P,
    popupPlacement: D,
    popupVisible: T,
    popup: a,
    popupStyle: i,
    popupAlign: s && {
      offset: s
    },
    action: l ? [] : [S],
    mouseEnterDelay: h,
    mouseLeaveDelay: g,
    onPopupVisibleChange: u,
    forceRender: x,
    popupMotion: N,
    fresh: !0
  }, n);
}
function Bye(e) {
  var t = e.id, r = e.open, n = e.keyPath, a = e.children, i = "inline", o = p.useContext(Lo), s = o.prefixCls, l = o.forceSubMenuRender, c = o.motion, u = o.defaultMotions, d = o.mode, f = p.useRef(!1);
  f.current = d === i;
  var m = p.useState(!f.current), h = ye(m, 2), g = h[0], y = h[1], S = f.current ? r : !1;
  p.useEffect(function() {
    f.current && y(!1);
  }, [d]);
  var x = ce({}, pV(i, c, u));
  n.length > 1 && (x.motionAppear = !1);
  var b = x.onVisibleChanged;
  return x.onVisibleChanged = function(_) {
    return !f.current && !_ && y(!0), b?.(_);
  }, g ? null : /* @__PURE__ */ p.createElement(J0, {
    mode: i,
    locked: !f.current
  }, /* @__PURE__ */ p.createElement(Ci, Pe({
    visible: S
  }, x, {
    forceRender: l,
    removeOnLeave: !1,
    leavedClassName: "".concat(s, "-hidden")
  }), function(_) {
    var $ = _.className, w = _.style;
    return /* @__PURE__ */ p.createElement(cI, {
      id: t,
      className: $,
      style: w
    }, a);
  }));
}
var zye = ["style", "className", "title", "eventKey", "warnKey", "disabled", "internalPopupClose", "children", "itemIcon", "expandIcon", "popupClassName", "popupOffset", "popupStyle", "onClick", "onMouseEnter", "onMouseLeave", "onTitleClick", "onTitleMouseEnter", "onTitleMouseLeave"], Hye = ["active"], Vye = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r, n = e.style, a = e.className, i = e.title, o = e.eventKey, s = e.warnKey, l = e.disabled, c = e.internalPopupClose, u = e.children, d = e.itemIcon, f = e.expandIcon, m = e.popupClassName, h = e.popupOffset, g = e.popupStyle, y = e.onClick, S = e.onMouseEnter, x = e.onMouseLeave, b = e.onTitleClick, _ = e.onTitleMouseEnter, $ = e.onTitleMouseLeave, w = Kt(e, zye), O = iV(o), T = p.useContext(Lo), I = T.prefixCls, P = T.mode, D = T.openKeys, B = T.disabled, L = T.overflowDisabled, N = T.activeKey, z = T.selectedKeys, F = T.itemIcon, j = T.expandIcon, H = T.onItemClick, U = T.onOpenChange, G = T.onActive, V = p.useContext(oI), K = V._internalRenderSubMenuItem, Z = p.useContext(lV), ee = Z.isSubPathKey, ae = $d(), ue = "".concat(I, "-submenu"), re = B || l, oe = p.useRef(), fe = p.useRef();
  process.env.NODE_ENV !== "production" && s && jt(!1, "SubMenu should not leave undefined `key`.");
  var le = d ?? F, se = f ?? j, Q = D.includes(o), he = !L && Q, ne = ee(z, o), me = uV(o, re, _, $), k = me.active, M = Kt(me, Hye), R = p.useState(!1), q = ye(R, 2), Y = q[0], X = q[1], pe = function(tt) {
    re || X(tt);
  }, $e = function(tt) {
    pe(!0), S?.({
      key: o,
      domEvent: tt
    });
  }, J = function(tt) {
    pe(!1), x?.({
      key: o,
      domEvent: tt
    });
  }, de = p.useMemo(function() {
    return k || (P !== "inline" ? Y || ee([N], o) : !1);
  }, [P, k, N, Y, o, ee]), Se = dV(ae.length), Ee = function(tt) {
    re || (b?.({
      key: o,
      domEvent: tt
    }), P === "inline" && U(o, !Q));
  }, Te = _0(function(Qe) {
    y?.(jb(Qe)), H(Qe);
  }), Le = function(tt) {
    P !== "inline" && U(o, tt);
  }, Ie = function() {
    G(o);
  }, De = O && "".concat(O, "-popup"), Ae = /* @__PURE__ */ p.createElement("div", Pe({
    role: "menuitem",
    style: Se,
    className: "".concat(ue, "-title"),
    tabIndex: re ? null : -1,
    ref: oe,
    title: typeof i == "string" ? i : null,
    "data-menu-id": L && O ? null : O,
    "aria-expanded": he,
    "aria-haspopup": !0,
    "aria-controls": De,
    "aria-disabled": re,
    onClick: Ee,
    onFocus: Ie
  }, M), i, /* @__PURE__ */ p.createElement(fV, {
    icon: P !== "horizontal" ? se : void 0,
    props: ce(ce({}, e), {}, {
      isOpen: he,
      // [Legacy] Not sure why need this mark
      isSubMenu: !0
    })
  }, /* @__PURE__ */ p.createElement("i", {
    className: "".concat(ue, "-arrow")
  }))), Fe = p.useRef(P);
  if (P !== "inline" && ae.length > 1 ? Fe.current = "vertical" : Fe.current = P, !L) {
    var Ne = Fe.current;
    Ae = /* @__PURE__ */ p.createElement(Fye, {
      mode: Ne,
      prefixCls: ue,
      visible: !c && he && P !== "inline",
      popupClassName: m,
      popupOffset: h,
      popupStyle: g,
      popup: /* @__PURE__ */ p.createElement(
        J0,
        {
          mode: Ne === "horizontal" ? "vertical" : Ne
        },
        /* @__PURE__ */ p.createElement(cI, {
          id: De,
          ref: fe
        }, u)
      ),
      disabled: re,
      onVisibleChange: Le
    }, Ae);
  }
  var qe = /* @__PURE__ */ p.createElement(Ro.Item, Pe({
    ref: t,
    role: "none"
  }, w, {
    component: "li",
    style: n,
    className: be(ue, "".concat(ue, "-").concat(P), a, (r = {}, te(r, "".concat(ue, "-open"), he), te(r, "".concat(ue, "-active"), de), te(r, "".concat(ue, "-selected"), ne), te(r, "".concat(ue, "-disabled"), re), r)),
    onMouseEnter: $e,
    onMouseLeave: J
  }), Ae, !L && /* @__PURE__ */ p.createElement(Bye, {
    id: De,
    open: he,
    keyPath: ae
  }, u));
  return K && (qe = K(qe, e, {
    selected: ne,
    active: de,
    open: he,
    disabled: re
  })), /* @__PURE__ */ p.createElement(J0, {
    onItemClick: Te,
    mode: P === "horizontal" ? "vertical" : P,
    itemIcon: le,
    expandIcon: se
  }, qe);
}), yh = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.eventKey, n = e.children, a = $d(r), i = uI(n, a), o = k1();
  p.useEffect(function() {
    if (o)
      return o.registerPath(r, a), function() {
        o.unregisterPath(r, a);
      };
  }, [a]);
  var s;
  return o ? s = i : s = /* @__PURE__ */ p.createElement(Vye, Pe({
    ref: t
  }, e), i), /* @__PURE__ */ p.createElement(sV.Provider, {
    value: a
  }, s);
});
process.env.NODE_ENV !== "production" && (yh.displayName = "SubMenu");
function dI(e) {
  var t = e.className, r = e.style, n = p.useContext(Lo), a = n.prefixCls, i = k1();
  return i ? null : /* @__PURE__ */ p.createElement("li", {
    role: "separator",
    className: be("".concat(a, "-item-divider"), t),
    style: r
  });
}
var Gye = ["className", "title", "eventKey", "children"], Uye = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.className, n = e.title;
  e.eventKey;
  var a = e.children, i = Kt(e, Gye), o = p.useContext(Lo), s = o.prefixCls, l = "".concat(s, "-item-group");
  return /* @__PURE__ */ p.createElement("li", Pe({
    ref: t,
    role: "presentation"
  }, i, {
    onClick: function(u) {
      return u.stopPropagation();
    },
    className: be(l, r)
  }), /* @__PURE__ */ p.createElement("div", {
    role: "presentation",
    className: "".concat(l, "-title"),
    title: typeof n == "string" ? n : void 0
  }, n), /* @__PURE__ */ p.createElement("ul", {
    role: "group",
    className: "".concat(l, "-list")
  }, a));
}), F1 = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.eventKey, n = e.children, a = $d(r), i = uI(n, a), o = k1();
  return o ? i : /* @__PURE__ */ p.createElement(Uye, Pe({
    ref: t
  }, bn(e, ["warnKey"])), i);
});
process.env.NODE_ENV !== "production" && (F1.displayName = "MenuItemGroup");
var Wye = ["label", "children", "key", "type"];
function rE(e, t) {
  var r = t.item, n = t.group, a = t.submenu, i = t.divider;
  return (e || []).map(function(o, s) {
    if (o && kt(o) === "object") {
      var l = o, c = l.label, u = l.children, d = l.key, f = l.type, m = Kt(l, Wye), h = d ?? "tmp-".concat(s);
      return u || f === "group" ? f === "group" ? /* @__PURE__ */ p.createElement(n, Pe({
        key: h
      }, m, {
        title: c
      }), rE(u, t)) : /* @__PURE__ */ p.createElement(a, Pe({
        key: h
      }, m, {
        title: c
      }), rE(u, t)) : f === "divider" ? /* @__PURE__ */ p.createElement(i, Pe({
        key: h
      }, m)) : /* @__PURE__ */ p.createElement(r, Pe({
        key: h
      }, m), c);
    }
    return null;
  }).filter(function(o) {
    return o;
  });
}
function PN(e, t, r, n) {
  var a = e, i = ce({
    divider: dI,
    item: gh,
    group: F1,
    submenu: yh
  }, n);
  return t && (a = rE(t, i)), uI(a, r);
}
var qye = ["prefixCls", "rootClassName", "style", "className", "tabIndex", "items", "children", "direction", "id", "mode", "inlineCollapsed", "disabled", "disabledOverflow", "subMenuOpenDelay", "subMenuCloseDelay", "forceSubMenuRender", "defaultOpenKeys", "openKeys", "activeKey", "defaultActiveFirst", "selectable", "multiple", "defaultSelectedKeys", "selectedKeys", "onSelect", "onDeselect", "inlineIndent", "motion", "defaultMotions", "triggerSubMenuAction", "builtinPlacements", "itemIcon", "expandIcon", "overflowedIndicator", "overflowedIndicatorPopupClassName", "getPopupContainer", "onClick", "onOpenChange", "onKeyDown", "openAnimation", "openTransitionName", "_internalRenderMenuItem", "_internalRenderSubMenuItem", "_internalComponents"], Hl = [], Kye = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r, n, a = e, i = a.prefixCls, o = i === void 0 ? "rc-menu" : i, s = a.rootClassName, l = a.style, c = a.className, u = a.tabIndex, d = u === void 0 ? 0 : u, f = a.items, m = a.children, h = a.direction, g = a.id, y = a.mode, S = y === void 0 ? "vertical" : y, x = a.inlineCollapsed, b = a.disabled, _ = a.disabledOverflow, $ = a.subMenuOpenDelay, w = $ === void 0 ? 0.1 : $, O = a.subMenuCloseDelay, T = O === void 0 ? 0.1 : O, I = a.forceSubMenuRender, P = a.defaultOpenKeys, D = a.openKeys, B = a.activeKey, L = a.defaultActiveFirst, N = a.selectable, z = N === void 0 ? !0 : N, F = a.multiple, j = F === void 0 ? !1 : F, H = a.defaultSelectedKeys, U = a.selectedKeys, G = a.onSelect, V = a.onDeselect, K = a.inlineIndent, Z = K === void 0 ? 24 : K, ee = a.motion, ae = a.defaultMotions, ue = a.triggerSubMenuAction, re = ue === void 0 ? "hover" : ue, oe = a.builtinPlacements, fe = a.itemIcon, le = a.expandIcon, se = a.overflowedIndicator, Q = se === void 0 ? "..." : se, he = a.overflowedIndicatorPopupClassName, ne = a.getPopupContainer, me = a.onClick, k = a.onOpenChange, M = a.onKeyDown, R = a.openAnimation, q = a.openTransitionName, Y = a._internalRenderMenuItem, X = a._internalRenderSubMenuItem, pe = a._internalComponents, $e = Kt(a, qye), J = p.useMemo(function() {
    return [PN(m, f, Hl, pe), PN(m, f, Hl, {})];
  }, [m, f, pe]), de = ye(J, 2), Se = de[0], Ee = de[1], Te = p.useState(!1), Le = ye(Te, 2), Ie = Le[0], De = Le[1], Ae = p.useRef(), Fe = wye(g), Ne = h === "rtl";
  process.env.NODE_ENV !== "production" && jt(!R && !q, "`openAnimation` and `openTransitionName` is removed. Please use `motion` or `defaultMotion` instead.");
  var qe = Kr(P, {
    value: D,
    postState: function(Ot) {
      return Ot || Hl;
    }
  }), Qe = ye(qe, 2), tt = Qe[0], Ge = Qe[1], it = function(Ot) {
    var Tt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    function Sr() {
      Ge(Ot), k?.(Ot);
    }
    Tt ? e2(Sr) : Sr();
  }, ht = p.useState(tt), It = ye(ht, 2), xt = It[0], Xe = It[1], pt = p.useRef(!1), Ze = p.useMemo(function() {
    return (S === "inline" || S === "vertical") && x ? ["vertical", x] : [S, !1];
  }, [S, x]), wt = ye(Ze, 2), bt = wt[0], Je = wt[1], _t = bt === "inline", Vt = p.useState(bt), ot = ye(Vt, 2), Ct = ot[0], rt = ot[1], $t = p.useState(Je), Wt = ye($t, 2), _e = Wt[0], Ke = Wt[1];
  p.useEffect(function() {
    rt(bt), Ke(Je), pt.current && (_t ? Ge(xt) : it(Hl));
  }, [bt, Je]);
  var nt = p.useState(0), Ve = ye(nt, 2), ke = Ve[0], ut = Ve[1], st = ke >= Se.length - 1 || Ct !== "horizontal" || _;
  p.useEffect(function() {
    _t && Xe(tt);
  }, [tt]), p.useEffect(function() {
    return pt.current = !0, function() {
      pt.current = !1;
    };
  }, []);
  var Et = _ye(), zt = Et.registerPath, Be = Et.unregisterPath, ft = Et.refreshOverflowKeys, yt = Et.isSubPathKey, Rt = Et.getKeyPath, Ht = Et.getKeys, ir = Et.getSubPathKeys, ar = p.useMemo(function() {
    return {
      registerPath: zt,
      unregisterPath: Be
    };
  }, [zt, Be]), Nr = p.useMemo(function() {
    return {
      isSubPathKey: yt
    };
  }, [yt]);
  p.useEffect(function() {
    ft(st ? Hl : Se.slice(ke + 1).map(function(cr) {
      return cr.key;
    }));
  }, [ke, st]);
  var Xr = Kr(B || L && ((r = Se[0]) === null || r === void 0 ? void 0 : r.key), {
    value: B
  }), Qr = ye(Xr, 2), Ur = Qr[0], gn = Qr[1], Zt = _0(function(cr) {
    gn(cr);
  }), er = _0(function() {
    gn(void 0);
  });
  fo(t, function() {
    return {
      list: Ae.current,
      focus: function(Ot) {
        var Tt, Sr = Ht(), Mr = eE(Sr, Fe), en = Mr.elements, Rn = Mr.key2element, sr = Mr.element2key, qt = sI(Ae.current, en), gr = Ur ?? (qt[0] ? sr.get(qt[0]) : (Tt = Se.find(function(pn) {
          return !pn.props.disabled;
        })) === null || Tt === void 0 ? void 0 : Tt.key), Ft = Rn.get(gr);
        if (gr && Ft) {
          var rr;
          Ft == null || (rr = Ft.focus) === null || rr === void 0 || rr.call(Ft, Ot);
        }
      }
    };
  });
  var _r = Kr(H || [], {
    value: U,
    // Legacy convert key to array
    postState: function(Ot) {
      return Array.isArray(Ot) ? Ot : Ot == null ? Hl : [Ot];
    }
  }), Sn = ye(_r, 2), On = Sn[0], Un = Sn[1], oa = function(Ot) {
    if (z) {
      var Tt = Ot.key, Sr = On.includes(Tt), Mr;
      j ? Sr ? Mr = On.filter(function(Rn) {
        return Rn !== Tt;
      }) : Mr = [].concat(ze(On), [Tt]) : Mr = [Tt], Un(Mr);
      var en = ce(ce({}, Ot), {}, {
        selectedKeys: Mr
      });
      Sr ? V?.(en) : G?.(en);
    }
    !j && tt.length && Ct !== "inline" && it(Hl);
  }, va = _0(function(cr) {
    me?.(jb(cr)), oa(cr);
  }), Fn = _0(function(cr, Ot) {
    var Tt = tt.filter(function(Mr) {
      return Mr !== cr;
    });
    if (Ot)
      Tt.push(cr);
    else if (Ct !== "inline") {
      var Sr = ir(cr);
      Tt = Tt.filter(function(Mr) {
        return !Sr.has(Mr);
      });
    }
    Do(tt, Tt, !0) || it(Tt, !0);
  }), or = function(Ot, Tt) {
    var Sr = Tt ?? !tt.includes(Ot);
    Fn(Ot, Sr);
  }, tr = Sye(Ct, Ur, Ne, Fe, Ae, Ht, Rt, gn, or, M);
  p.useEffect(function() {
    De(!0);
  }, []);
  var Jr = p.useMemo(function() {
    return {
      _internalRenderMenuItem: Y,
      _internalRenderSubMenuItem: X
    };
  }, [Y, X]), tn = Ct !== "horizontal" || _ ? Se : (
    // Need wrap for overflow dropdown that do not response for open
    Se.map(function(cr, Ot) {
      return (
        // Always wrap provider to avoid sub node re-mount
        /* @__PURE__ */ p.createElement(J0, {
          key: cr.key,
          overflowDisabled: Ot > ke
        }, cr)
      );
    })
  ), zr = /* @__PURE__ */ p.createElement(Ro, Pe({
    id: g,
    ref: Ae,
    prefixCls: "".concat(o, "-overflow"),
    component: "ul",
    itemComponent: gh,
    className: be(o, "".concat(o, "-root"), "".concat(o, "-").concat(Ct), c, (n = {}, te(n, "".concat(o, "-inline-collapsed"), _e), te(n, "".concat(o, "-rtl"), Ne), n), s),
    dir: h,
    style: l,
    role: "menu",
    tabIndex: d,
    data: tn,
    renderRawItem: function(Ot) {
      return Ot;
    },
    renderRawRest: function(Ot) {
      var Tt = Ot.length, Sr = Tt ? Se.slice(-Tt) : null;
      return /* @__PURE__ */ p.createElement(yh, {
        eventKey: tE,
        title: Q,
        disabled: st,
        internalPopupClose: Tt === 0,
        popupClassName: he
      }, Sr);
    },
    maxCount: Ct !== "horizontal" || _ ? Ro.INVALIDATE : Ro.RESPONSIVE,
    ssr: "full",
    "data-menu-list": !0,
    onVisibleChange: function(Ot) {
      ut(Ot);
    },
    onKeyDown: tr
  }, $e));
  return /* @__PURE__ */ p.createElement(oI.Provider, {
    value: Jr
  }, /* @__PURE__ */ p.createElement(nV.Provider, {
    value: Fe
  }, /* @__PURE__ */ p.createElement(J0, {
    prefixCls: o,
    rootClassName: s,
    mode: Ct,
    openKeys: tt,
    rtl: Ne,
    disabled: b,
    motion: Ie ? ee : null,
    defaultMotions: Ie ? ae : null,
    activeKey: Ur,
    onActive: Zt,
    onInactive: er,
    selectedKeys: On,
    inlineIndent: Z,
    subMenuOpenDelay: w,
    subMenuCloseDelay: T,
    forceSubMenuRender: I,
    builtinPlacements: oe,
    triggerSubMenuAction: re,
    getPopupContainer: ne,
    itemIcon: fe,
    expandIcon: le,
    onItemClick: va,
    onOpenChange: Fn
  }, /* @__PURE__ */ p.createElement(lV.Provider, {
    value: Nr
  }, zr), /* @__PURE__ */ p.createElement("div", {
    style: {
      display: "none"
    },
    "aria-hidden": !0
  }, /* @__PURE__ */ p.createElement(oV.Provider, {
    value: ar
  }, Ee)))));
}), _d = Kye;
_d.Item = gh;
_d.SubMenu = yh;
_d.ItemGroup = F1;
_d.Divider = dI;
var Yye = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "bars", theme: "outlined" }, Zye = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: Yye
  }));
}, mV = /* @__PURE__ */ p.forwardRef(Zye);
process.env.NODE_ENV !== "production" && (mV.displayName = "BarsOutlined");
var Xye = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, name: "left", theme: "outlined" }, Jye = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: Xye
  }));
}, cd = /* @__PURE__ */ p.forwardRef(Jye);
process.env.NODE_ENV !== "production" && (cd.displayName = "LeftOutlined");
const Qye = (e) => !isNaN(parseFloat(e)) && isFinite(e), vV = /* @__PURE__ */ p.createContext({
  siderHook: {
    addSider: () => null,
    removeSider: () => null
  }
});
var ebe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const RN = {
  xs: "479.98px",
  sm: "575.98px",
  md: "767.98px",
  lg: "991.98px",
  xl: "1199.98px",
  xxl: "1599.98px"
}, B1 = /* @__PURE__ */ p.createContext({}), tbe = /* @__PURE__ */ (() => {
  let e = 0;
  return function() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return e += 1, `${t}${e}`;
  };
})(), fI = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    prefixCls: r,
    className: n,
    trigger: a,
    children: i,
    defaultCollapsed: o = !1,
    theme: s = "dark",
    style: l = {},
    collapsible: c = !1,
    reverseArrow: u = !1,
    width: d = 200,
    collapsedWidth: f = 80,
    zeroWidthTriggerStyle: m,
    breakpoint: h,
    onCollapse: g,
    onBreakpoint: y
  } = e, S = ebe(e, ["prefixCls", "className", "trigger", "children", "defaultCollapsed", "theme", "style", "collapsible", "reverseArrow", "width", "collapsedWidth", "zeroWidthTriggerStyle", "breakpoint", "onCollapse", "onBreakpoint"]), {
    siderHook: x
  } = Cr(vV), [b, _] = He("collapsed" in e ? e.collapsed : o), [$, w] = He(!1);
  St(() => {
    "collapsed" in e && _(e.collapsed);
  }, [e.collapsed]);
  const O = (L, N) => {
    "collapsed" in e || _(L), g?.(L, N);
  }, T = ct();
  T.current = (L) => {
    w(L.matches), y?.(L.matches), b !== L.matches && O(L.matches, "responsive");
  }, St(() => {
    function L(z) {
      return T.current(z);
    }
    let N;
    if (typeof window < "u") {
      const {
        matchMedia: z
      } = window;
      if (z && h && h in RN) {
        N = z(`screen and (max-width: ${RN[h]})`);
        try {
          N.addEventListener("change", L);
        } catch {
          N.addListener(L);
        }
        L(N);
      }
    }
    return () => {
      try {
        N?.removeEventListener("change", L);
      } catch {
        N?.removeListener(L);
      }
    };
  }, [h]), St(() => {
    const L = tbe("ant-sider-");
    return x.addSider(L), () => x.removeSider(L);
  }, []);
  const I = () => {
    O(!b, "clickTrigger");
  }, {
    getPrefixCls: P
  } = Cr(Lt), D = () => {
    const L = P("layout-sider", r), N = bn(S, ["collapsed"]), z = b ? f : d, F = Qye(z) ? `${z}px` : String(z), j = parseFloat(String(f || 0)) === 0 ? /* @__PURE__ */ p.createElement("span", {
      onClick: I,
      className: be(`${L}-zero-width-trigger`, `${L}-zero-width-trigger-${u ? "right" : "left"}`),
      style: m
    }, a || /* @__PURE__ */ p.createElement(mV, null)) : null, G = {
      expanded: u ? /* @__PURE__ */ p.createElement(_c, null) : /* @__PURE__ */ p.createElement(cd, null),
      collapsed: u ? /* @__PURE__ */ p.createElement(cd, null) : /* @__PURE__ */ p.createElement(_c, null)
    }[b ? "collapsed" : "expanded"], V = a !== null ? j || /* @__PURE__ */ p.createElement("div", {
      className: `${L}-trigger`,
      onClick: I,
      style: {
        width: F
      }
    }, a || G) : null, K = Object.assign(Object.assign({}, l), {
      flex: `0 0 ${F}`,
      maxWidth: F,
      minWidth: F,
      width: F
    }), Z = be(L, `${L}-${s}`, {
      [`${L}-collapsed`]: !!b,
      [`${L}-has-trigger`]: c && a !== null && !j,
      [`${L}-below`]: !!$,
      [`${L}-zero-width`]: parseFloat(F) === 0
    }, n);
    return /* @__PURE__ */ p.createElement("aside", Object.assign({
      className: Z
    }, N, {
      style: K,
      ref: t
    }), /* @__PURE__ */ p.createElement("div", {
      className: `${L}-children`
    }, i), c || $ && j ? V : null);
  }, B = p.useMemo(() => ({
    siderCollapsed: b
  }), [b]);
  return /* @__PURE__ */ p.createElement(B1.Provider, {
    value: B
  }, D());
});
process.env.NODE_ENV !== "production" && (fI.displayName = "Sider");
var rbe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "ellipsis", theme: "outlined" }, nbe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: rbe
  }));
}, z1 = /* @__PURE__ */ p.forwardRef(nbe);
process.env.NODE_ENV !== "production" && (z1.displayName = "EllipsisOutlined");
var abe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const hV = (e) => {
  const {
    prefixCls: t,
    className: r,
    dashed: n
  } = e, a = abe(e, ["prefixCls", "className", "dashed"]), {
    getPrefixCls: i
  } = p.useContext(Lt), o = i("menu", t), s = be({
    [`${o}-item-divider-dashed`]: !!n
  }, r);
  return /* @__PURE__ */ p.createElement(dI, Object.assign({
    className: s
  }, a));
}, Lb = /* @__PURE__ */ Ws({
  prefixCls: "",
  firstLevel: !0,
  inlineCollapsed: !1
}), gV = (e) => {
  var t;
  const {
    className: r,
    children: n,
    icon: a,
    title: i,
    danger: o
  } = e, {
    prefixCls: s,
    firstLevel: l,
    direction: c,
    disableMenuItemTitleTooltip: u,
    inlineCollapsed: d
  } = p.useContext(Lb), f = (x) => {
    const b = /* @__PURE__ */ p.createElement("span", {
      className: `${s}-title-content`
    }, n);
    return (!a || /* @__PURE__ */ p.isValidElement(n) && n.type === "span") && n && x && l && typeof n == "string" ? /* @__PURE__ */ p.createElement("div", {
      className: `${s}-inline-collapsed-noicon`
    }, n.charAt(0)) : b;
  }, {
    siderCollapsed: m
  } = p.useContext(B1);
  let h = i;
  typeof i > "u" ? h = l ? n : "" : i === !1 && (h = "");
  const g = {
    title: h
  };
  !m && !d && (g.title = null, g.open = !1);
  const y = Ma(n).length;
  let S = /* @__PURE__ */ p.createElement(gh, Object.assign({}, bn(e, ["title", "icon", "danger"]), {
    className: be({
      [`${s}-item-danger`]: o,
      [`${s}-item-only-child`]: (a ? y + 1 : y) === 1
    }, r),
    title: typeof i == "string" ? i : void 0
  }), Si(a, {
    className: be(/* @__PURE__ */ p.isValidElement(a) ? (t = a.props) === null || t === void 0 ? void 0 : t.className : "", `${s}-item-icon`)
  }), f(d));
  return u || (S = /* @__PURE__ */ p.createElement(lo, Object.assign({}, g, {
    placement: c === "rtl" ? "left" : "right",
    overlayClassName: `${s}-inline-collapsed-tooltip`
  }), S)), S;
};
var ibe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const kb = /* @__PURE__ */ p.createContext(null), yV = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    children: r
  } = e, n = ibe(e, ["children"]), a = p.useContext(kb), i = p.useMemo(() => Object.assign(Object.assign({}, a), n), [
    a,
    n.prefixCls,
    // restProps.expandIcon, Not mark as deps since this is a ReactNode
    n.mode,
    n.selectable,
    n.rootClassName
    // restProps.validator, Not mark as deps since this is a function
  ]), o = Fle(r), s = qs(t, o ? r.ref : null);
  return /* @__PURE__ */ p.createElement(kb.Provider, {
    value: i
  }, /* @__PURE__ */ p.createElement(Lc, null, o ? /* @__PURE__ */ p.cloneElement(r, {
    ref: s
  }) : r));
}), obe = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: r,
    horizontalLineHeight: n,
    colorSplit: a,
    lineWidth: i,
    lineType: o,
    itemPaddingInline: s
  } = e;
  return {
    [`${t}-horizontal`]: {
      lineHeight: n,
      border: 0,
      borderBottom: `${ve(i)} ${o} ${a}`,
      boxShadow: "none",
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        content: '"\\20"'
      },
      // ======================= Item =======================
      [`${t}-item, ${t}-submenu`]: {
        position: "relative",
        display: "inline-block",
        verticalAlign: "bottom",
        paddingInline: s
      },
      [`> ${t}-item:hover,
        > ${t}-item-active,
        > ${t}-submenu ${t}-submenu-title:hover`]: {
        backgroundColor: "transparent"
      },
      [`${t}-item, ${t}-submenu-title`]: {
        transition: [`border-color ${r}`, `background ${r}`].join(",")
      },
      // ===================== Sub Menu =====================
      [`${t}-submenu-arrow`]: {
        display: "none"
      }
    }
  };
}, sbe = (e) => {
  let {
    componentCls: t,
    menuArrowOffset: r,
    calc: n
  } = e;
  return {
    [`${t}-rtl`]: {
      direction: "rtl"
    },
    [`${t}-submenu-rtl`]: {
      transformOrigin: "100% 0"
    },
    // Vertical Arrow
    [`${t}-rtl${t}-vertical,
    ${t}-submenu-rtl ${t}-vertical`]: {
      [`${t}-submenu-arrow`]: {
        "&::before": {
          transform: `rotate(-45deg) translateY(${ve(n(r).mul(-1).equal())})`
        },
        "&::after": {
          transform: `rotate(45deg) translateY(${ve(r)})`
        }
      }
    }
  };
}, NN = (e) => Object.assign({}, Sl(e)), DN = (e, t) => {
  const {
    componentCls: r,
    itemColor: n,
    itemSelectedColor: a,
    groupTitleColor: i,
    itemBg: o,
    subMenuItemBg: s,
    itemSelectedBg: l,
    activeBarHeight: c,
    activeBarWidth: u,
    activeBarBorderWidth: d,
    motionDurationSlow: f,
    motionEaseInOut: m,
    motionEaseOut: h,
    itemPaddingInline: g,
    motionDurationMid: y,
    itemHoverColor: S,
    lineType: x,
    colorSplit: b,
    // Disabled
    itemDisabledColor: _,
    // Danger
    dangerItemColor: $,
    dangerItemHoverColor: w,
    dangerItemSelectedColor: O,
    dangerItemActiveBg: T,
    dangerItemSelectedBg: I,
    // Bg
    popupBg: P,
    itemHoverBg: D,
    itemActiveBg: B,
    menuSubMenuBg: L,
    // Horizontal
    horizontalItemSelectedColor: N,
    horizontalItemSelectedBg: z,
    horizontalItemBorderRadius: F,
    horizontalItemHoverBg: j
  } = e;
  return {
    [`${r}-${t}, ${r}-${t} > ${r}`]: {
      color: n,
      background: o,
      [`&${r}-root:focus-visible`]: Object.assign({}, NN(e)),
      // ======================== Item ========================
      [`${r}-item-group-title`]: {
        color: i
      },
      [`${r}-submenu-selected`]: {
        [`> ${r}-submenu-title`]: {
          color: a
        }
      },
      [`${r}-item, ${r}-submenu-title`]: {
        color: n,
        [`&:not(${r}-item-disabled):focus-visible`]: Object.assign({}, NN(e))
      },
      // Disabled
      [`${r}-item-disabled, ${r}-submenu-disabled`]: {
        color: `${_} !important`
      },
      // Hover
      [`${r}-item:not(${r}-item-selected):not(${r}-submenu-selected)`]: {
        [`&:hover, > ${r}-submenu-title:hover`]: {
          color: S
        }
      },
      [`&:not(${r}-horizontal)`]: {
        [`${r}-item:not(${r}-item-selected)`]: {
          "&:hover": {
            backgroundColor: D
          },
          "&:active": {
            backgroundColor: B
          }
        },
        [`${r}-submenu-title`]: {
          "&:hover": {
            backgroundColor: D
          },
          "&:active": {
            backgroundColor: B
          }
        }
      },
      // Danger - only Item has
      [`${r}-item-danger`]: {
        color: $,
        [`&${r}-item:hover`]: {
          [`&:not(${r}-item-selected):not(${r}-submenu-selected)`]: {
            color: w
          }
        },
        [`&${r}-item:active`]: {
          background: T
        }
      },
      [`${r}-item a`]: {
        "&, &:hover": {
          color: "inherit"
        }
      },
      [`${r}-item-selected`]: {
        color: a,
        // Danger
        [`&${r}-item-danger`]: {
          color: O
        },
        "a, a:hover": {
          color: "inherit"
        }
      },
      [`& ${r}-item-selected`]: {
        backgroundColor: l,
        // Danger
        [`&${r}-item-danger`]: {
          backgroundColor: I
        }
      },
      [`&${r}-submenu > ${r}`]: {
        backgroundColor: L
      },
      // ===== 设置浮层的颜色 =======
      // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
      [`&${r}-popup > ${r}`]: {
        backgroundColor: P
      },
      [`&${r}-submenu-popup > ${r}`]: {
        backgroundColor: P
      },
      // ===== 设置浮层的颜色 end =======
      // ====================== Horizontal ======================
      [`&${r}-horizontal`]: Object.assign(Object.assign({}, t === "dark" ? {
        borderBottom: 0
      } : {}), {
        [`> ${r}-item, > ${r}-submenu`]: {
          top: d,
          marginTop: e.calc(d).mul(-1).equal(),
          marginBottom: 0,
          borderRadius: F,
          "&::after": {
            position: "absolute",
            insetInline: g,
            bottom: 0,
            borderBottom: `${ve(c)} solid transparent`,
            transition: `border-color ${f} ${m}`,
            content: '""'
          },
          "&:hover, &-active, &-open": {
            background: j,
            "&::after": {
              borderBottomWidth: c,
              borderBottomColor: N
            }
          },
          "&-selected": {
            color: N,
            backgroundColor: z,
            "&:hover": {
              backgroundColor: z
            },
            "&::after": {
              borderBottomWidth: c,
              borderBottomColor: N
            }
          }
        }
      }),
      // ================== Inline & Vertical ===================
      //
      [`&${r}-root`]: {
        [`&${r}-inline, &${r}-vertical`]: {
          borderInlineEnd: `${ve(d)} ${x} ${b}`
        }
      },
      // ======================== Inline ========================
      [`&${r}-inline`]: {
        // Sub
        [`${r}-sub${r}-inline`]: {
          background: s
        },
        [`${r}-item`]: {
          position: "relative",
          "&::after": {
            position: "absolute",
            insetBlock: 0,
            insetInlineEnd: 0,
            borderInlineEnd: `${ve(u)} solid ${a}`,
            transform: "scaleY(0.0001)",
            opacity: 0,
            transition: [`transform ${y} ${h}`, `opacity ${y} ${h}`].join(","),
            content: '""'
          },
          // Danger
          [`&${r}-item-danger`]: {
            "&::after": {
              borderInlineEndColor: O
            }
          }
        },
        [`${r}-selected, ${r}-item-selected`]: {
          "&::after": {
            transform: "scaleY(1)",
            opacity: 1,
            transition: [`transform ${y} ${m}`, `opacity ${y} ${m}`].join(",")
          }
        }
      }
    }
  };
}, jN = (e) => {
  const {
    componentCls: t,
    itemHeight: r,
    itemMarginInline: n,
    padding: a,
    menuArrowSize: i,
    marginXS: o,
    itemMarginBlock: s,
    itemWidth: l
  } = e, c = e.calc(i).add(a).add(o).equal();
  return {
    [`${t}-item`]: {
      position: "relative",
      overflow: "hidden"
    },
    [`${t}-item, ${t}-submenu-title`]: {
      height: r,
      lineHeight: ve(r),
      paddingInline: a,
      overflow: "hidden",
      textOverflow: "ellipsis",
      marginInline: n,
      marginBlock: s,
      width: l
    },
    [`> ${t}-item,
            > ${t}-submenu > ${t}-submenu-title`]: {
      height: r,
      lineHeight: ve(r)
    },
    [`${t}-item-group-list ${t}-submenu-title,
            ${t}-submenu-title`]: {
      paddingInlineEnd: c
    }
  };
}, lbe = (e) => {
  const {
    componentCls: t,
    iconCls: r,
    itemHeight: n,
    colorTextLightSolid: a,
    dropdownWidth: i,
    controlHeightLG: o,
    motionDurationMid: s,
    motionEaseOut: l,
    paddingXL: c,
    itemMarginInline: u,
    fontSizeLG: d,
    motionDurationSlow: f,
    paddingXS: m,
    boxShadowSecondary: h,
    collapsedWidth: g,
    collapsedIconSize: y
  } = e, S = {
    height: n,
    lineHeight: ve(n),
    listStylePosition: "inside",
    listStyleType: "disc"
  };
  return [
    {
      [t]: {
        "&-inline, &-vertical": Object.assign({
          [`&${t}-root`]: {
            boxShadow: "none"
          }
        }, jN(e))
      },
      [`${t}-submenu-popup`]: {
        [`${t}-vertical`]: Object.assign(Object.assign({}, jN(e)), {
          boxShadow: h
        })
      }
    },
    // Vertical only
    {
      [`${t}-submenu-popup ${t}-vertical${t}-sub`]: {
        minWidth: i,
        maxHeight: `calc(100vh - ${ve(e.calc(o).mul(2.5).equal())})`,
        padding: "0",
        overflow: "hidden",
        borderInlineEnd: 0,
        // https://github.com/ant-design/ant-design/issues/22244
        // https://github.com/ant-design/ant-design/issues/26812
        "&:not([class*='-active'])": {
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    },
    // Inline Only
    {
      [`${t}-inline`]: {
        width: "100%",
        // Motion enhance for first level
        [`&${t}-root`]: {
          [`${t}-item, ${t}-submenu-title`]: {
            display: "flex",
            alignItems: "center",
            transition: [`border-color ${f}`, `background ${f}`, `padding ${s} ${l}`, `padding-inline calc(50% - ${ve(e.calc(d).div(2).equal())} - ${ve(u)})`].join(","),
            [`> ${t}-title-content`]: {
              flex: "auto",
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            "> *": {
              flex: "none"
            }
          }
        },
        // >>>>> Sub
        [`${t}-sub${t}-inline`]: {
          padding: 0,
          border: 0,
          borderRadius: 0,
          boxShadow: "none",
          [`& > ${t}-submenu > ${t}-submenu-title`]: S,
          [`& ${t}-item-group-title`]: {
            paddingInlineStart: c
          }
        },
        // >>>>> Item
        [`${t}-item`]: S
      }
    },
    // Inline Collapse Only
    {
      [`${t}-inline-collapsed`]: {
        width: g,
        [`&${t}-root`]: {
          [`${t}-item, ${t}-submenu ${t}-submenu-title`]: {
            [`> ${t}-inline-collapsed-noicon`]: {
              fontSize: d,
              textAlign: "center"
            }
          }
        },
        [`> ${t}-item,
          > ${t}-item-group > ${t}-item-group-list > ${t}-item,
          > ${t}-item-group > ${t}-item-group-list > ${t}-submenu > ${t}-submenu-title,
          > ${t}-submenu > ${t}-submenu-title`]: {
          insetInlineStart: 0,
          paddingInline: `calc(50% - ${ve(e.calc(d).div(2).equal())} - ${ve(u)})`,
          textOverflow: "clip",
          [`
            ${t}-submenu-arrow,
            ${t}-submenu-expand-icon
          `]: {
            opacity: 0
          },
          [`${t}-item-icon, ${r}`]: {
            margin: 0,
            fontSize: y,
            lineHeight: ve(n),
            "+ span": {
              display: "inline-block",
              opacity: 0
            }
          }
        },
        [`${t}-item-icon, ${r}`]: {
          display: "inline-block"
        },
        "&-tooltip": {
          pointerEvents: "none",
          [`${t}-item-icon, ${r}`]: {
            display: "none"
          },
          "a, a:hover": {
            color: a
          }
        },
        [`${t}-item-group-title`]: Object.assign(Object.assign({}, cs), {
          paddingInline: m
        })
      }
    }
  ];
}, LN = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: r,
    motionDurationMid: n,
    motionEaseInOut: a,
    motionEaseOut: i,
    iconCls: o,
    iconSize: s,
    iconMarginInlineEnd: l
  } = e;
  return {
    // >>>>> Item
    [`${t}-item, ${t}-submenu-title`]: {
      position: "relative",
      display: "block",
      margin: 0,
      whiteSpace: "nowrap",
      cursor: "pointer",
      transition: [`border-color ${r}`, `background ${r}`, `padding ${r} ${a}`].join(","),
      [`${t}-item-icon, ${o}`]: {
        minWidth: s,
        fontSize: s,
        transition: [`font-size ${n} ${i}`, `margin ${r} ${a}`, `color ${r}`].join(","),
        "+ span": {
          marginInlineStart: l,
          opacity: 1,
          transition: [`opacity ${r} ${a}`, `margin ${r}`, `color ${r}`].join(",")
        }
      },
      [`${t}-item-icon`]: Object.assign({}, ih()),
      [`&${t}-item-only-child`]: {
        [`> ${o}, > ${t}-item-icon`]: {
          marginInlineEnd: 0
        }
      }
    },
    // Disabled state sets text to gray and nukes hover/tab effects
    [`${t}-item-disabled, ${t}-submenu-disabled`]: {
      background: "none !important",
      cursor: "not-allowed",
      "&::after": {
        borderColor: "transparent !important"
      },
      a: {
        color: "inherit !important"
      },
      [`> ${t}-submenu-title`]: {
        color: "inherit !important",
        cursor: "not-allowed"
      }
    }
  };
}, kN = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: r,
    motionEaseInOut: n,
    borderRadius: a,
    menuArrowSize: i,
    menuArrowOffset: o
  } = e;
  return {
    [`${t}-submenu`]: {
      "&-expand-icon, &-arrow": {
        position: "absolute",
        top: "50%",
        insetInlineEnd: e.margin,
        width: i,
        color: "currentcolor",
        transform: "translateY(-50%)",
        transition: `transform ${r} ${n}, opacity ${r}`
      },
      "&-arrow": {
        // →
        "&::before, &::after": {
          position: "absolute",
          width: e.calc(i).mul(0.6).equal(),
          height: e.calc(i).mul(0.15).equal(),
          backgroundColor: "currentcolor",
          borderRadius: a,
          transition: [`background ${r} ${n}`, `transform ${r} ${n}`, `top ${r} ${n}`, `color ${r} ${n}`].join(","),
          content: '""'
        },
        "&::before": {
          transform: `rotate(45deg) translateY(${ve(e.calc(o).mul(-1).equal())})`
        },
        "&::after": {
          transform: `rotate(-45deg) translateY(${ve(o)})`
        }
      }
    }
  };
}, cbe = (e) => {
  const {
    antCls: t,
    componentCls: r,
    fontSize: n,
    motionDurationSlow: a,
    motionDurationMid: i,
    motionEaseInOut: o,
    paddingXS: s,
    padding: l,
    colorSplit: c,
    lineWidth: u,
    zIndexPopup: d,
    borderRadiusLG: f,
    subMenuItemBorderRadius: m,
    menuArrowSize: h,
    menuArrowOffset: g,
    lineType: y,
    groupTitleLineHeight: S,
    groupTitleFontSize: x
  } = e;
  return [
    // Misc
    {
      "": {
        [`${r}`]: Object.assign(Object.assign({}, Bs()), {
          // Hidden
          "&-hidden": {
            display: "none"
          }
        })
      },
      [`${r}-submenu-hidden`]: {
        display: "none"
      }
    },
    {
      [r]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Yr(e)), Bs()), {
        marginBottom: 0,
        paddingInlineStart: 0,
        // Override default ul/ol
        fontSize: n,
        lineHeight: 0,
        listStyle: "none",
        outline: "none",
        // Magic cubic here but smooth transition
        transition: `width ${a} cubic-bezier(0.2, 0, 0, 1) 0s`,
        "ul, ol": {
          margin: 0,
          padding: 0,
          listStyle: "none"
        },
        // Overflow ellipsis
        "&-overflow": {
          display: "flex",
          [`${r}-item`]: {
            flex: "none"
          }
        },
        [`${r}-item, ${r}-submenu, ${r}-submenu-title`]: {
          borderRadius: e.itemBorderRadius
        },
        [`${r}-item-group-title`]: {
          padding: `${ve(s)} ${ve(l)}`,
          fontSize: x,
          lineHeight: S,
          transition: `all ${a}`
        },
        [`&-horizontal ${r}-submenu`]: {
          transition: [`border-color ${a} ${o}`, `background ${a} ${o}`].join(",")
        },
        [`${r}-submenu, ${r}-submenu-inline`]: {
          transition: [`border-color ${a} ${o}`, `background ${a} ${o}`, `padding ${i} ${o}`].join(",")
        },
        [`${r}-submenu ${r}-sub`]: {
          cursor: "initial",
          transition: [`background ${a} ${o}`, `padding ${a} ${o}`].join(",")
        },
        [`${r}-title-content`]: {
          transition: `color ${a}`,
          // https://github.com/ant-design/ant-design/issues/41143
          [`> ${t}-typography-ellipsis-single-line`]: {
            display: "inline",
            verticalAlign: "unset"
          }
        },
        [`${r}-item a`]: {
          "&::before": {
            position: "absolute",
            inset: 0,
            backgroundColor: "transparent",
            content: '""'
          }
        },
        // Removed a Badge related style seems it's safe
        // https://github.com/ant-design/ant-design/issues/19809
        // >>>>> Divider
        [`${r}-item-divider`]: {
          overflow: "hidden",
          lineHeight: 0,
          borderColor: c,
          borderStyle: y,
          borderWidth: 0,
          borderTopWidth: u,
          marginBlock: u,
          padding: 0,
          "&-dashed": {
            borderStyle: "dashed"
          }
        }
      }), LN(e)), {
        [`${r}-item-group`]: {
          [`${r}-item-group-list`]: {
            margin: 0,
            padding: 0,
            [`${r}-item, ${r}-submenu-title`]: {
              paddingInline: `${ve(e.calc(n).mul(2).equal())} ${ve(l)}`
            }
          }
        },
        // ======================= Sub Menu =======================
        "&-submenu": {
          "&-popup": {
            position: "absolute",
            zIndex: d,
            borderRadius: f,
            boxShadow: "none",
            transformOrigin: "0 0",
            [`&${r}-submenu`]: {
              background: "transparent"
            },
            // https://github.com/ant-design/ant-design/issues/13955
            "&::before": {
              position: "absolute",
              inset: 0,
              zIndex: -1,
              width: "100%",
              height: "100%",
              opacity: 0,
              content: '""'
            },
            [`> ${r}`]: Object.assign(Object.assign(Object.assign({
              borderRadius: f
            }, LN(e)), kN(e)), {
              [`${r}-item, ${r}-submenu > ${r}-submenu-title`]: {
                borderRadius: m
              },
              [`${r}-submenu-title::after`]: {
                transition: `transform ${a} ${o}`
              }
            })
          },
          "\n          &-placement-leftTop,\n          &-placement-bottomRight,\n          ": {
            transformOrigin: "100% 0"
          },
          "\n          &-placement-leftBottom,\n          &-placement-topRight,\n          ": {
            transformOrigin: "100% 100%"
          },
          "\n          &-placement-rightBottom,\n          &-placement-topLeft,\n          ": {
            transformOrigin: "0 100%"
          },
          "\n          &-placement-bottomLeft,\n          &-placement-rightTop,\n          ": {
            transformOrigin: "0 0"
          },
          "\n          &-placement-leftTop,\n          &-placement-leftBottom\n          ": {
            paddingInlineEnd: e.paddingXS
          },
          "\n          &-placement-rightTop,\n          &-placement-rightBottom\n          ": {
            paddingInlineStart: e.paddingXS
          },
          "\n          &-placement-topRight,\n          &-placement-topLeft\n          ": {
            paddingBottom: e.paddingXS
          },
          "\n          &-placement-bottomRight,\n          &-placement-bottomLeft\n          ": {
            paddingTop: e.paddingXS
          }
        }
      }), kN(e)), {
        [`&-inline-collapsed ${r}-submenu-arrow,
        &-inline ${r}-submenu-arrow`]: {
          // ↓
          "&::before": {
            transform: `rotate(-45deg) translateX(${ve(g)})`
          },
          "&::after": {
            transform: `rotate(45deg) translateX(${ve(e.calc(g).mul(-1).equal())})`
          }
        },
        [`${r}-submenu-open${r}-submenu-inline > ${r}-submenu-title > ${r}-submenu-arrow`]: {
          // ↑
          transform: `translateY(${ve(e.calc(h).mul(0.2).mul(-1).equal())})`,
          "&::after": {
            transform: `rotate(-45deg) translateX(${ve(e.calc(g).mul(-1).equal())})`
          },
          "&::before": {
            transform: `rotate(45deg) translateX(${ve(g)})`
          }
        }
      })
    },
    // Integration with header element so menu items have the same height
    {
      [`${t}-layout-header`]: {
        [r]: {
          lineHeight: "inherit"
        }
      }
    }
  ];
}, ube = (e) => {
  var t, r, n;
  const {
    colorPrimary: a,
    colorError: i,
    colorTextDisabled: o,
    colorErrorBg: s,
    colorText: l,
    colorTextDescription: c,
    colorBgContainer: u,
    colorFillAlter: d,
    colorFillContent: f,
    lineWidth: m,
    lineWidthBold: h,
    controlItemBgActive: g,
    colorBgTextHover: y,
    controlHeightLG: S,
    lineHeight: x,
    colorBgElevated: b,
    marginXXS: _,
    padding: $,
    fontSize: w,
    controlHeightSM: O,
    fontSizeLG: T,
    colorTextLightSolid: I,
    colorErrorHover: P
  } = e, D = (t = e.activeBarWidth) !== null && t !== void 0 ? t : 0, B = (r = e.activeBarBorderWidth) !== null && r !== void 0 ? r : m, L = (n = e.itemMarginInline) !== null && n !== void 0 ? n : e.marginXXS, N = new Br(I).setAlpha(0.65).toRgbString();
  return {
    dropdownWidth: 160,
    zIndexPopup: e.zIndexPopupBase + 50,
    radiusItem: e.borderRadiusLG,
    itemBorderRadius: e.borderRadiusLG,
    radiusSubMenuItem: e.borderRadiusSM,
    subMenuItemBorderRadius: e.borderRadiusSM,
    colorItemText: l,
    itemColor: l,
    colorItemTextHover: l,
    itemHoverColor: l,
    colorItemTextHoverHorizontal: a,
    horizontalItemHoverColor: a,
    colorGroupTitle: c,
    groupTitleColor: c,
    colorItemTextSelected: a,
    itemSelectedColor: a,
    colorItemTextSelectedHorizontal: a,
    horizontalItemSelectedColor: a,
    colorItemBg: u,
    itemBg: u,
    colorItemBgHover: y,
    itemHoverBg: y,
    colorItemBgActive: f,
    itemActiveBg: g,
    colorSubItemBg: d,
    subMenuItemBg: d,
    colorItemBgSelected: g,
    itemSelectedBg: g,
    colorItemBgSelectedHorizontal: "transparent",
    horizontalItemSelectedBg: "transparent",
    colorActiveBarWidth: 0,
    activeBarWidth: D,
    colorActiveBarHeight: h,
    activeBarHeight: h,
    colorActiveBarBorderSize: m,
    activeBarBorderWidth: B,
    // Disabled
    colorItemTextDisabled: o,
    itemDisabledColor: o,
    // Danger
    colorDangerItemText: i,
    dangerItemColor: i,
    colorDangerItemTextHover: i,
    dangerItemHoverColor: i,
    colorDangerItemTextSelected: i,
    dangerItemSelectedColor: i,
    colorDangerItemBgActive: s,
    dangerItemActiveBg: s,
    colorDangerItemBgSelected: s,
    dangerItemSelectedBg: s,
    itemMarginInline: L,
    horizontalItemBorderRadius: 0,
    horizontalItemHoverBg: "transparent",
    itemHeight: S,
    groupTitleLineHeight: x,
    collapsedWidth: S * 2,
    popupBg: b,
    itemMarginBlock: _,
    itemPaddingInline: $,
    horizontalLineHeight: `${S * 1.15}px`,
    iconSize: w,
    iconMarginInlineEnd: O - w,
    collapsedIconSize: T,
    groupTitleFontSize: w,
    // Disabled
    darkItemDisabledColor: new Br(I).setAlpha(0.25).toRgbString(),
    // Dark
    darkItemColor: N,
    darkDangerItemColor: i,
    darkItemBg: "#001529",
    darkPopupBg: "#001529",
    darkSubMenuItemBg: "#000c17",
    darkItemSelectedColor: I,
    darkItemSelectedBg: a,
    darkDangerItemSelectedBg: i,
    darkItemHoverBg: "transparent",
    darkGroupTitleColor: N,
    darkItemHoverColor: I,
    darkDangerItemHoverColor: P,
    darkDangerItemSelectedColor: I,
    darkDangerItemActiveBg: i,
    // internal
    itemWidth: D ? `calc(100% + ${B}px)` : `calc(100% - ${L * 2}px)`
  };
}, dbe = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  return Zr("Menu", (a) => {
    const {
      colorBgElevated: i,
      controlHeightLG: o,
      fontSize: s,
      darkItemColor: l,
      darkDangerItemColor: c,
      darkItemBg: u,
      darkSubMenuItemBg: d,
      darkItemSelectedColor: f,
      darkItemSelectedBg: m,
      darkDangerItemSelectedBg: h,
      darkItemHoverBg: g,
      darkGroupTitleColor: y,
      darkItemHoverColor: S,
      darkItemDisabledColor: x,
      darkDangerItemHoverColor: b,
      darkDangerItemSelectedColor: _,
      darkDangerItemActiveBg: $,
      popupBg: w,
      darkPopupBg: O
    } = a, T = a.calc(s).div(7).mul(5).equal(), I = $r(a, {
      menuArrowSize: T,
      menuHorizontalHeight: a.calc(o).mul(1.15).equal(),
      menuArrowOffset: a.calc(T).mul(0.25).equal(),
      menuSubMenuBg: i,
      calc: a.calc,
      popupBg: w
    }), P = $r(I, {
      itemColor: l,
      itemHoverColor: S,
      groupTitleColor: y,
      itemSelectedColor: f,
      itemBg: u,
      popupBg: O,
      subMenuItemBg: d,
      itemActiveBg: "transparent",
      itemSelectedBg: m,
      activeBarHeight: 0,
      activeBarBorderWidth: 0,
      itemHoverBg: g,
      // Disabled
      itemDisabledColor: x,
      // Danger
      dangerItemColor: c,
      dangerItemHoverColor: b,
      dangerItemSelectedColor: _,
      dangerItemActiveBg: $,
      dangerItemSelectedBg: h,
      menuSubMenuBg: d,
      // Horizontal
      horizontalItemSelectedColor: f,
      horizontalItemSelectedBg: m
    });
    return [
      // Basic
      cbe(I),
      // Horizontal
      obe(I),
      // Hard code for some light style
      // Vertical
      lbe(I),
      // Hard code for some light style
      // Theme
      DN(I, "light"),
      DN(P, "dark"),
      // RTL
      sbe(I),
      // Motion
      WT(I),
      us(I, "slide-up"),
      us(I, "slide-down"),
      ph(I, "zoom-big")
    ];
  }, ube, {
    deprecatedTokens: [["colorGroupTitle", "groupTitleColor"], ["radiusItem", "itemBorderRadius"], ["radiusSubMenuItem", "subMenuItemBorderRadius"], ["colorItemText", "itemColor"], ["colorItemTextHover", "itemHoverColor"], ["colorItemTextHoverHorizontal", "horizontalItemHoverColor"], ["colorItemTextSelected", "itemSelectedColor"], ["colorItemTextSelectedHorizontal", "horizontalItemSelectedColor"], ["colorItemTextDisabled", "itemDisabledColor"], ["colorDangerItemText", "dangerItemColor"], ["colorDangerItemTextHover", "dangerItemHoverColor"], ["colorDangerItemTextSelected", "dangerItemSelectedColor"], ["colorDangerItemBgActive", "dangerItemActiveBg"], ["colorDangerItemBgSelected", "dangerItemSelectedBg"], ["colorItemBg", "itemBg"], ["colorItemBgHover", "itemHoverBg"], ["colorSubItemBg", "subMenuItemBg"], ["colorItemBgActive", "itemActiveBg"], ["colorItemBgSelectedHorizontal", "horizontalItemSelectedBg"], ["colorActiveBarWidth", "activeBarWidth"], ["colorActiveBarHeight", "activeBarHeight"], ["colorActiveBarBorderSize", "activeBarBorderWidth"], ["colorItemBgSelected", "itemSelectedBg"]],
    // Dropdown will handle menu style self. We do not need to handle this.
    injectStyle: r,
    unitless: {
      groupTitleLineHeight: !0
    }
  })(e, t);
}, bV = (e) => {
  var t;
  const {
    popupClassName: r,
    icon: n,
    title: a,
    theme: i
  } = e, o = p.useContext(Lb), {
    prefixCls: s,
    inlineCollapsed: l,
    theme: c
  } = o, u = $d();
  let d;
  if (!n)
    d = l && !u.length && a && typeof a == "string" ? /* @__PURE__ */ p.createElement("div", {
      className: `${s}-inline-collapsed-noicon`
    }, a.charAt(0)) : /* @__PURE__ */ p.createElement("span", {
      className: `${s}-title-content`
    }, a);
  else {
    const h = /* @__PURE__ */ p.isValidElement(a) && a.type === "span";
    d = /* @__PURE__ */ p.createElement(p.Fragment, null, Si(n, {
      className: be(/* @__PURE__ */ p.isValidElement(n) ? (t = n.props) === null || t === void 0 ? void 0 : t.className : "", `${s}-item-icon`)
    }), h ? a : /* @__PURE__ */ p.createElement("span", {
      className: `${s}-title-content`
    }, a));
  }
  const f = p.useMemo(() => Object.assign(Object.assign({}, o), {
    firstLevel: !1
  }), [o]), [m] = ps("Menu");
  return /* @__PURE__ */ p.createElement(Lb.Provider, {
    value: f
  }, /* @__PURE__ */ p.createElement(yh, Object.assign({}, bn(e, ["icon"]), {
    title: d,
    popupClassName: be(s, r, `${s}-${i || c}`),
    popupStyle: {
      zIndex: m
    }
  })));
};
var fbe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function Sx(e) {
  return e === null || e === !1;
}
const pbe = {
  item: gV,
  submenu: bV,
  divider: hV
}, mbe = /* @__PURE__ */ Aa((e, t) => {
  var r;
  const n = p.useContext(kb), a = n || {}, {
    getPrefixCls: i,
    getPopupContainer: o,
    direction: s,
    menu: l
  } = p.useContext(Lt), c = i(), {
    prefixCls: u,
    className: d,
    style: f,
    theme: m = "light",
    expandIcon: h,
    _internalDisableMenuItemTitleTooltip: g,
    inlineCollapsed: y,
    siderCollapsed: S,
    rootClassName: x,
    mode: b,
    selectable: _,
    onClick: $,
    overflowedIndicatorPopupClassName: w
  } = e, O = fbe(e, ["prefixCls", "className", "style", "theme", "expandIcon", "_internalDisableMenuItemTitleTooltip", "inlineCollapsed", "siderCollapsed", "rootClassName", "mode", "selectable", "onClick", "overflowedIndicatorPopupClassName"]), T = bn(O, ["collapsedWidth"]);
  if (process.env.NODE_ENV !== "production") {
    const K = xr("Menu");
    process.env.NODE_ENV !== "production" && K(!("inlineCollapsed" in e && b !== "inline"), "usage", "`inlineCollapsed` should only be used when `mode` is inline."), process.env.NODE_ENV !== "production" && K(!(e.siderCollapsed !== void 0 && "inlineCollapsed" in e), "usage", "`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead."), K.deprecated("items" in e && !e.children, "children", "items");
  }
  (r = a.validator) === null || r === void 0 || r.call(a, {
    mode: b
  });
  const I = br(function() {
    var K;
    $?.apply(void 0, arguments), (K = a.onClick) === null || K === void 0 || K.call(a);
  }), P = a.mode || b, D = _ ?? a.selectable, B = p.useMemo(() => S !== void 0 ? S : y, [y, S]), L = {
    horizontal: {
      motionName: `${c}-slide-up`
    },
    inline: Pb(c),
    other: {
      motionName: `${c}-zoom-big`
    }
  }, N = i("menu", u || a.prefixCls), z = Mn(N), [F, j, H] = dbe(N, z, !n), U = be(`${N}-${m}`, l?.className, d), G = p.useMemo(() => {
    var K, Z;
    if (typeof h == "function" || Sx(h))
      return h || null;
    if (typeof a.expandIcon == "function" || Sx(a.expandIcon))
      return a.expandIcon || null;
    if (typeof l?.expandIcon == "function" || Sx(l?.expandIcon))
      return l?.expandIcon || null;
    const ee = (K = h ?? a?.expandIcon) !== null && K !== void 0 ? K : l?.expandIcon;
    return Si(ee, {
      className: be(`${N}-submenu-expand-icon`, /* @__PURE__ */ p.isValidElement(ee) ? (Z = ee.props) === null || Z === void 0 ? void 0 : Z.className : void 0)
    });
  }, [h, a?.expandIcon, l?.expandIcon, N]), V = p.useMemo(() => ({
    prefixCls: N,
    inlineCollapsed: B || !1,
    direction: s,
    firstLevel: !0,
    theme: m,
    mode: P,
    disableMenuItemTitleTooltip: g
  }), [N, B, s, g, m]);
  return F(/* @__PURE__ */ p.createElement(kb.Provider, {
    value: null
  }, /* @__PURE__ */ p.createElement(Lb.Provider, {
    value: V
  }, /* @__PURE__ */ p.createElement(_d, Object.assign({
    getPopupContainer: o,
    overflowedIndicator: /* @__PURE__ */ p.createElement(z1, null),
    overflowedIndicatorPopupClassName: be(N, `${N}-${m}`, w),
    mode: P,
    selectable: D,
    onClick: I
  }, T, {
    inlineCollapsed: B,
    style: Object.assign(Object.assign({}, l?.style), f),
    className: U,
    prefixCls: N,
    direction: s,
    defaultMotions: L,
    expandIcon: G,
    ref: t,
    rootClassName: be(x, j, a.rootClassName, H, z),
    _internalComponents: pbe
  })))));
}), Fc = /* @__PURE__ */ Aa((e, t) => {
  const r = ct(null), n = p.useContext(B1);
  return fo(t, () => ({
    menu: r.current,
    focus: (a) => {
      var i;
      (i = r.current) === null || i === void 0 || i.focus(a);
    }
  })), /* @__PURE__ */ p.createElement(mbe, Object.assign({
    ref: r
  }, e, n));
});
Fc.Item = gV;
Fc.SubMenu = bV;
Fc.Divider = hV;
Fc.ItemGroup = F1;
process.env.NODE_ENV !== "production" && (Fc.displayName = "Menu");
const vbe = (e) => {
  const {
    componentCls: t,
    menuCls: r,
    colorError: n,
    colorTextLightSolid: a
  } = e, i = `${r}-item`;
  return {
    [`${t}, ${t}-menu-submenu`]: {
      [`${r} ${i}`]: {
        [`&${i}-danger:not(${i}-disabled)`]: {
          color: n,
          "&:hover": {
            color: a,
            backgroundColor: n
          }
        }
      }
    }
  };
}, hbe = (e) => {
  const {
    componentCls: t,
    menuCls: r,
    zIndexPopup: n,
    dropdownArrowDistance: a,
    sizePopupArrow: i,
    antCls: o,
    iconCls: s,
    motionDurationMid: l,
    paddingBlock: c,
    fontSize: u,
    dropdownEdgeChildPadding: d,
    colorTextDisabled: f,
    fontSizeIcon: m,
    controlPaddingHorizontal: h,
    colorBgElevated: g
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign({}, Yr(e)), {
        position: "absolute",
        top: -9999,
        left: {
          _skip_check_: !0,
          value: -9999
        },
        zIndex: n,
        display: "block",
        // A placeholder out of dropdown visible range to avoid close when user moving
        "&::before": {
          position: "absolute",
          insetBlock: e.calc(i).div(2).sub(a).equal(),
          // insetInlineStart: -7, // FIXME: Seems not work for hidden element
          zIndex: -9999,
          opacity: 1e-4,
          content: '""'
        },
        [`&-trigger${o}-btn`]: {
          [`& > ${s}-down, & > ${o}-btn-icon > ${s}-down`]: {
            fontSize: m
          }
        },
        [`${t}-wrap`]: {
          position: "relative",
          [`${o}-btn > ${s}-down`]: {
            fontSize: m
          },
          [`${s}-down::before`]: {
            transition: `transform ${l}`
          }
        },
        [`${t}-wrap-open`]: {
          [`${s}-down::before`]: {
            transform: "rotate(180deg)"
          }
        },
        "\n        &-hidden,\n        &-menu-hidden,\n        &-menu-submenu-hidden\n      ": {
          display: "none"
        },
        // =============================================================
        // ==                         Motion                          ==
        // =============================================================
        // When position is not enough for dropdown, the placement will revert.
        // We will handle this with revert motion name.
        [`&${o}-slide-down-enter${o}-slide-down-enter-active${t}-placement-bottomLeft,
          &${o}-slide-down-appear${o}-slide-down-appear-active${t}-placement-bottomLeft,
          &${o}-slide-down-enter${o}-slide-down-enter-active${t}-placement-bottom,
          &${o}-slide-down-appear${o}-slide-down-appear-active${t}-placement-bottom,
          &${o}-slide-down-enter${o}-slide-down-enter-active${t}-placement-bottomRight,
          &${o}-slide-down-appear${o}-slide-down-appear-active${t}-placement-bottomRight`]: {
          animationName: T1
        },
        [`&${o}-slide-up-enter${o}-slide-up-enter-active${t}-placement-topLeft,
          &${o}-slide-up-appear${o}-slide-up-appear-active${t}-placement-topLeft,
          &${o}-slide-up-enter${o}-slide-up-enter-active${t}-placement-top,
          &${o}-slide-up-appear${o}-slide-up-appear-active${t}-placement-top,
          &${o}-slide-up-enter${o}-slide-up-enter-active${t}-placement-topRight,
          &${o}-slide-up-appear${o}-slide-up-appear-active${t}-placement-topRight`]: {
          animationName: M1
        },
        [`&${o}-slide-down-leave${o}-slide-down-leave-active${t}-placement-bottomLeft,
          &${o}-slide-down-leave${o}-slide-down-leave-active${t}-placement-bottom,
          &${o}-slide-down-leave${o}-slide-down-leave-active${t}-placement-bottomRight`]: {
          animationName: I1
        },
        [`&${o}-slide-up-leave${o}-slide-up-leave-active${t}-placement-topLeft,
          &${o}-slide-up-leave${o}-slide-up-leave-active${t}-placement-top,
          &${o}-slide-up-leave${o}-slide-up-leave-active${t}-placement-topRight`]: {
          animationName: A1
        }
      })
    },
    // =============================================================
    // ==                        Arrow style                      ==
    // =============================================================
    XH(e, g, {
      arrowPlacement: {
        top: !0,
        bottom: !0
      }
    }),
    {
      // =============================================================
      // ==                          Menu                           ==
      // =============================================================
      [`${t} ${r}`]: {
        position: "relative",
        margin: 0
      },
      [`${r}-submenu-popup`]: {
        position: "absolute",
        zIndex: n,
        background: "transparent",
        boxShadow: "none",
        transformOrigin: "0 0",
        "ul, li": {
          listStyle: "none",
          margin: 0
        }
      },
      [`${t}, ${t}-menu-submenu`]: {
        [r]: Object.assign(Object.assign({
          padding: d,
          listStyleType: "none",
          backgroundColor: g,
          backgroundClip: "padding-box",
          borderRadius: e.borderRadiusLG,
          outline: "none",
          boxShadow: e.boxShadowSecondary
        }, zs(e)), {
          "&:empty": {
            padding: 0,
            boxShadow: "none"
          },
          [`${r}-item-group-title`]: {
            padding: `${ve(c)} ${ve(h)}`,
            color: e.colorTextDescription,
            transition: `all ${l}`
          },
          // ======================= Item Content =======================
          [`${r}-item`]: {
            position: "relative",
            display: "flex",
            alignItems: "center"
          },
          [`${r}-item-icon`]: {
            minWidth: u,
            marginInlineEnd: e.marginXS,
            fontSize: e.fontSizeSM
          },
          [`${r}-title-content`]: {
            flex: "auto",
            "> a": {
              color: "inherit",
              transition: `all ${l}`,
              "&:hover": {
                color: "inherit"
              },
              "&::after": {
                position: "absolute",
                inset: 0,
                content: '""'
              }
            }
          },
          // =========================== Item ===========================
          [`${r}-item, ${r}-submenu-title`]: Object.assign(Object.assign({
            clear: "both",
            margin: 0,
            padding: `${ve(c)} ${ve(h)}`,
            color: e.colorText,
            fontWeight: "normal",
            fontSize: u,
            lineHeight: e.lineHeight,
            cursor: "pointer",
            transition: `all ${l}`,
            borderRadius: e.borderRadiusSM,
            "&:hover, &-active": {
              backgroundColor: e.controlItemBgHover
            }
          }, zs(e)), {
            "&-selected": {
              color: e.colorPrimary,
              backgroundColor: e.controlItemBgActive,
              "&:hover, &-active": {
                backgroundColor: e.controlItemBgActiveHover
              }
            },
            "&-disabled": {
              color: f,
              cursor: "not-allowed",
              "&:hover": {
                color: f,
                backgroundColor: g,
                cursor: "not-allowed"
              },
              a: {
                pointerEvents: "none"
              }
            },
            "&-divider": {
              height: 1,
              // By design
              margin: `${ve(e.marginXXS)} 0`,
              overflow: "hidden",
              lineHeight: 0,
              backgroundColor: e.colorSplit
            },
            [`${t}-menu-submenu-expand-icon`]: {
              position: "absolute",
              insetInlineEnd: e.paddingXS,
              [`${t}-menu-submenu-arrow-icon`]: {
                marginInlineEnd: "0 !important",
                color: e.colorTextDescription,
                fontSize: m,
                fontStyle: "normal"
              }
            }
          }),
          [`${r}-item-group-list`]: {
            margin: `0 ${ve(e.marginXS)}`,
            padding: 0,
            listStyle: "none"
          },
          [`${r}-submenu-title`]: {
            paddingInlineEnd: e.calc(h).add(e.fontSizeSM).equal()
          },
          [`${r}-submenu-vertical`]: {
            position: "relative"
          },
          [`${r}-submenu${r}-submenu-disabled ${t}-menu-submenu-title`]: {
            [`&, ${t}-menu-submenu-arrow-icon`]: {
              color: f,
              backgroundColor: g,
              cursor: "not-allowed"
            }
          },
          // https://github.com/ant-design/ant-design/issues/19264
          [`${r}-submenu-selected ${t}-menu-submenu-title`]: {
            color: e.colorPrimary
          }
        })
      }
    },
    // Follow code may reuse in other components
    [us(e, "slide-up"), us(e, "slide-down"), ld(e, "move-up"), ld(e, "move-down"), ph(e, "zoom-big")]
  ];
}, gbe = (e) => Object.assign(Object.assign({
  zIndexPopup: e.zIndexPopupBase + 50,
  paddingBlock: (e.controlHeight - e.fontSize * e.lineHeight) / 2
}, iI({
  contentRadius: e.borderRadiusLG,
  limitVerticalRadius: !0
})), aI(e)), ybe = Zr("Dropdown", (e) => {
  const {
    marginXXS: t,
    sizePopupArrow: r,
    paddingXXS: n,
    componentCls: a
  } = e, i = $r(e, {
    menuCls: `${a}-menu`,
    dropdownArrowDistance: e.calc(r).div(2).add(t).equal(),
    dropdownEdgeChildPadding: n
  });
  return [hbe(i), vbe(i)];
}, gbe, {
  resetStyle: !1
}), bh = (e) => {
  const {
    menu: t,
    arrow: r,
    prefixCls: n,
    children: a,
    trigger: i,
    disabled: o,
    dropdownRender: s,
    getPopupContainer: l,
    overlayClassName: c,
    rootClassName: u,
    overlayStyle: d,
    open: f,
    onOpenChange: m,
    // Deprecated
    visible: h,
    onVisibleChange: g,
    mouseEnterDelay: y = 0.15,
    mouseLeaveDelay: S = 0.1,
    autoAdjustOverflow: x = !0,
    placement: b = "",
    overlay: _,
    transitionName: $
  } = e, {
    getPopupContainer: w,
    getPrefixCls: O,
    direction: T,
    dropdown: I
  } = p.useContext(Lt), P = xr("Dropdown");
  process.env.NODE_ENV !== "production" && ([["visible", "open"], ["onVisibleChange", "onOpenChange"]].forEach((he) => {
    let [ne, me] = he;
    P.deprecated(!(ne in e), ne, me);
  }), P.deprecated(!("overlay" in e), "overlay", "menu"));
  const D = p.useMemo(() => {
    const he = O();
    return $ !== void 0 ? $ : b.includes("top") ? `${he}-slide-down` : `${he}-slide-up`;
  }, [O, b, $]), B = p.useMemo(() => b ? b.includes("Center") ? b.slice(0, b.indexOf("Center")) : b : T === "rtl" ? "bottomRight" : "bottomLeft", [b, T]);
  if (process.env.NODE_ENV !== "production") {
    if (b.includes("Center")) {
      const he = b.slice(0, b.indexOf("Center"));
      process.env.NODE_ENV !== "production" && P(!b.includes("Center"), "deprecated", `You are using '${b}' placement in Dropdown, which is deprecated. Try to use '${he}' instead.`);
    }
    [["visible", "open"], ["onVisibleChange", "onOpenChange"]].forEach((he) => {
      let [ne, me] = he;
      P.deprecated(!(ne in e), ne, me);
    });
  }
  const L = O("dropdown", n), N = Mn(L), [z, F, j] = ybe(L, N), [, H] = ua(), U = p.Children.only(a), G = Si(U, {
    className: be(`${L}-trigger`, {
      [`${L}-rtl`]: T === "rtl"
    }, U.props.className),
    disabled: o
  }), V = o ? [] : i;
  let K;
  V && V.includes("contextMenu") && (K = !0);
  const [Z, ee] = Kr(!1, {
    value: f ?? h
  }), ae = br((he) => {
    m?.(he, {
      source: "trigger"
    }), g?.(he), ee(he);
  }), ue = be(c, u, F, j, N, I?.className, {
    [`${L}-rtl`]: T === "rtl"
  }), re = JH({
    arrowPointAtCenter: typeof r == "object" && r.pointAtCenter,
    autoAdjustOverflow: x,
    offset: H.marginXXS,
    arrowWidth: r ? H.sizePopupArrow : 0,
    borderRadius: H.borderRadius
  }), oe = p.useCallback(() => {
    t?.selectable && t?.multiple || (m?.(!1, {
      source: "menu"
    }), ee(!1));
  }, [t?.selectable, t?.multiple]), fe = () => {
    let he;
    return t?.items ? he = /* @__PURE__ */ p.createElement(Fc, Object.assign({}, t)) : typeof _ == "function" ? he = _() : he = _, s && (he = s(he)), he = p.Children.only(typeof he == "string" ? /* @__PURE__ */ p.createElement("span", null, he) : he), /* @__PURE__ */ p.createElement(yV, {
      prefixCls: `${L}-menu`,
      rootClassName: be(j, N),
      expandIcon: /* @__PURE__ */ p.createElement("span", {
        className: `${L}-menu-submenu-arrow`
      }, /* @__PURE__ */ p.createElement(_c, {
        className: `${L}-menu-submenu-arrow-icon`
      })),
      mode: "vertical",
      selectable: !1,
      onClick: oe,
      validator: (ne) => {
        let {
          mode: me
        } = ne;
        process.env.NODE_ENV !== "production" && P(!me || me === "vertical", "usage", `mode="${me}" is not supported for Dropdown's Menu.`);
      }
    }, he);
  }, [le, se] = ps("Dropdown", d?.zIndex);
  let Q = /* @__PURE__ */ p.createElement(rV, Object.assign({
    alignPoint: K
  }, bn(e, ["rootClassName"]), {
    mouseEnterDelay: y,
    mouseLeaveDelay: S,
    visible: Z,
    builtinPlacements: re,
    arrow: !!r,
    overlayClassName: ue,
    prefixCls: L,
    getPopupContainer: l || w,
    transitionName: D,
    trigger: V,
    overlay: fe,
    placement: B,
    onVisibleChange: ae,
    overlayStyle: Object.assign(Object.assign(Object.assign({}, I?.style), d), {
      zIndex: le
    })
  }), G);
  return le && (Q = /* @__PURE__ */ p.createElement(gd.Provider, {
    value: se
  }, Q)), z(Q);
};
function bbe(e) {
  return Object.assign(Object.assign({}, e), {
    align: {
      overflow: {
        adjustX: !1,
        adjustY: !1
      }
    }
  });
}
const Cbe = P1(bh, "dropdown", (e) => e, bbe), Sbe = (e) => /* @__PURE__ */ p.createElement(Cbe, Object.assign({}, e), /* @__PURE__ */ p.createElement("span", null));
bh._InternalPanelDoNotUseOrYouWillBeFired = Sbe;
process.env.NODE_ENV !== "production" && (bh.displayName = "Dropdown");
var CV = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(Ue, function() {
    var r = 1e3, n = 6e4, a = 36e5, i = "millisecond", o = "second", s = "minute", l = "hour", c = "day", u = "week", d = "month", f = "quarter", m = "year", h = "date", g = "Invalid Date", y = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, S = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, x = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(N) {
      var z = ["th", "st", "nd", "rd"], F = N % 100;
      return "[" + N + (z[(F - 20) % 10] || z[F] || z[0]) + "]";
    } }, b = function(N, z, F) {
      var j = String(N);
      return !j || j.length >= z ? N : "" + Array(z + 1 - j.length).join(F) + N;
    }, _ = { s: b, z: function(N) {
      var z = -N.utcOffset(), F = Math.abs(z), j = Math.floor(F / 60), H = F % 60;
      return (z <= 0 ? "+" : "-") + b(j, 2, "0") + ":" + b(H, 2, "0");
    }, m: function N(z, F) {
      if (z.date() < F.date()) return -N(F, z);
      var j = 12 * (F.year() - z.year()) + (F.month() - z.month()), H = z.clone().add(j, d), U = F - H < 0, G = z.clone().add(j + (U ? -1 : 1), d);
      return +(-(j + (F - H) / (U ? H - G : G - H)) || 0);
    }, a: function(N) {
      return N < 0 ? Math.ceil(N) || 0 : Math.floor(N);
    }, p: function(N) {
      return { M: d, y: m, w: u, d: c, D: h, h: l, m: s, s: o, ms: i, Q: f }[N] || String(N || "").toLowerCase().replace(/s$/, "");
    }, u: function(N) {
      return N === void 0;
    } }, $ = "en", w = {};
    w[$] = x;
    var O = "$isDayjsObject", T = function(N) {
      return N instanceof B || !(!N || !N[O]);
    }, I = function N(z, F, j) {
      var H;
      if (!z) return $;
      if (typeof z == "string") {
        var U = z.toLowerCase();
        w[U] && (H = U), F && (w[U] = F, H = U);
        var G = z.split("-");
        if (!H && G.length > 1) return N(G[0]);
      } else {
        var V = z.name;
        w[V] = z, H = V;
      }
      return !j && H && ($ = H), H || !j && $;
    }, P = function(N, z) {
      if (T(N)) return N.clone();
      var F = typeof z == "object" ? z : {};
      return F.date = N, F.args = arguments, new B(F);
    }, D = _;
    D.l = I, D.i = T, D.w = function(N, z) {
      return P(N, { locale: z.$L, utc: z.$u, x: z.$x, $offset: z.$offset });
    };
    var B = function() {
      function N(F) {
        this.$L = I(F.locale, null, !0), this.parse(F), this.$x = this.$x || F.x || {}, this[O] = !0;
      }
      var z = N.prototype;
      return z.parse = function(F) {
        this.$d = function(j) {
          var H = j.date, U = j.utc;
          if (H === null) return /* @__PURE__ */ new Date(NaN);
          if (D.u(H)) return /* @__PURE__ */ new Date();
          if (H instanceof Date) return new Date(H);
          if (typeof H == "string" && !/Z$/i.test(H)) {
            var G = H.match(y);
            if (G) {
              var V = G[2] - 1 || 0, K = (G[7] || "0").substring(0, 3);
              return U ? new Date(Date.UTC(G[1], V, G[3] || 1, G[4] || 0, G[5] || 0, G[6] || 0, K)) : new Date(G[1], V, G[3] || 1, G[4] || 0, G[5] || 0, G[6] || 0, K);
            }
          }
          return new Date(H);
        }(F), this.init();
      }, z.init = function() {
        var F = this.$d;
        this.$y = F.getFullYear(), this.$M = F.getMonth(), this.$D = F.getDate(), this.$W = F.getDay(), this.$H = F.getHours(), this.$m = F.getMinutes(), this.$s = F.getSeconds(), this.$ms = F.getMilliseconds();
      }, z.$utils = function() {
        return D;
      }, z.isValid = function() {
        return this.$d.toString() !== g;
      }, z.isSame = function(F, j) {
        var H = P(F);
        return this.startOf(j) <= H && H <= this.endOf(j);
      }, z.isAfter = function(F, j) {
        return P(F) < this.startOf(j);
      }, z.isBefore = function(F, j) {
        return this.endOf(j) < P(F);
      }, z.$g = function(F, j, H) {
        return D.u(F) ? this[j] : this.set(H, F);
      }, z.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, z.valueOf = function() {
        return this.$d.getTime();
      }, z.startOf = function(F, j) {
        var H = this, U = !!D.u(j) || j, G = D.p(F), V = function(fe, le) {
          var se = D.w(H.$u ? Date.UTC(H.$y, le, fe) : new Date(H.$y, le, fe), H);
          return U ? se : se.endOf(c);
        }, K = function(fe, le) {
          return D.w(H.toDate()[fe].apply(H.toDate("s"), (U ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(le)), H);
        }, Z = this.$W, ee = this.$M, ae = this.$D, ue = "set" + (this.$u ? "UTC" : "");
        switch (G) {
          case m:
            return U ? V(1, 0) : V(31, 11);
          case d:
            return U ? V(1, ee) : V(0, ee + 1);
          case u:
            var re = this.$locale().weekStart || 0, oe = (Z < re ? Z + 7 : Z) - re;
            return V(U ? ae - oe : ae + (6 - oe), ee);
          case c:
          case h:
            return K(ue + "Hours", 0);
          case l:
            return K(ue + "Minutes", 1);
          case s:
            return K(ue + "Seconds", 2);
          case o:
            return K(ue + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, z.endOf = function(F) {
        return this.startOf(F, !1);
      }, z.$set = function(F, j) {
        var H, U = D.p(F), G = "set" + (this.$u ? "UTC" : ""), V = (H = {}, H[c] = G + "Date", H[h] = G + "Date", H[d] = G + "Month", H[m] = G + "FullYear", H[l] = G + "Hours", H[s] = G + "Minutes", H[o] = G + "Seconds", H[i] = G + "Milliseconds", H)[U], K = U === c ? this.$D + (j - this.$W) : j;
        if (U === d || U === m) {
          var Z = this.clone().set(h, 1);
          Z.$d[V](K), Z.init(), this.$d = Z.set(h, Math.min(this.$D, Z.daysInMonth())).$d;
        } else V && this.$d[V](K);
        return this.init(), this;
      }, z.set = function(F, j) {
        return this.clone().$set(F, j);
      }, z.get = function(F) {
        return this[D.p(F)]();
      }, z.add = function(F, j) {
        var H, U = this;
        F = Number(F);
        var G = D.p(j), V = function(ee) {
          var ae = P(U);
          return D.w(ae.date(ae.date() + Math.round(ee * F)), U);
        };
        if (G === d) return this.set(d, this.$M + F);
        if (G === m) return this.set(m, this.$y + F);
        if (G === c) return V(1);
        if (G === u) return V(7);
        var K = (H = {}, H[s] = n, H[l] = a, H[o] = r, H)[G] || 1, Z = this.$d.getTime() + F * K;
        return D.w(Z, this);
      }, z.subtract = function(F, j) {
        return this.add(-1 * F, j);
      }, z.format = function(F) {
        var j = this, H = this.$locale();
        if (!this.isValid()) return H.invalidDate || g;
        var U = F || "YYYY-MM-DDTHH:mm:ssZ", G = D.z(this), V = this.$H, K = this.$m, Z = this.$M, ee = H.weekdays, ae = H.months, ue = H.meridiem, re = function(le, se, Q, he) {
          return le && (le[se] || le(j, U)) || Q[se].slice(0, he);
        }, oe = function(le) {
          return D.s(V % 12 || 12, le, "0");
        }, fe = ue || function(le, se, Q) {
          var he = le < 12 ? "AM" : "PM";
          return Q ? he.toLowerCase() : he;
        };
        return U.replace(S, function(le, se) {
          return se || function(Q) {
            switch (Q) {
              case "YY":
                return String(j.$y).slice(-2);
              case "YYYY":
                return D.s(j.$y, 4, "0");
              case "M":
                return Z + 1;
              case "MM":
                return D.s(Z + 1, 2, "0");
              case "MMM":
                return re(H.monthsShort, Z, ae, 3);
              case "MMMM":
                return re(ae, Z);
              case "D":
                return j.$D;
              case "DD":
                return D.s(j.$D, 2, "0");
              case "d":
                return String(j.$W);
              case "dd":
                return re(H.weekdaysMin, j.$W, ee, 2);
              case "ddd":
                return re(H.weekdaysShort, j.$W, ee, 3);
              case "dddd":
                return ee[j.$W];
              case "H":
                return String(V);
              case "HH":
                return D.s(V, 2, "0");
              case "h":
                return oe(1);
              case "hh":
                return oe(2);
              case "a":
                return fe(V, K, !0);
              case "A":
                return fe(V, K, !1);
              case "m":
                return String(K);
              case "mm":
                return D.s(K, 2, "0");
              case "s":
                return String(j.$s);
              case "ss":
                return D.s(j.$s, 2, "0");
              case "SSS":
                return D.s(j.$ms, 3, "0");
              case "Z":
                return G;
            }
            return null;
          }(le) || G.replace(":", "");
        });
      }, z.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, z.diff = function(F, j, H) {
        var U, G = this, V = D.p(j), K = P(F), Z = (K.utcOffset() - this.utcOffset()) * n, ee = this - K, ae = function() {
          return D.m(G, K);
        };
        switch (V) {
          case m:
            U = ae() / 12;
            break;
          case d:
            U = ae();
            break;
          case f:
            U = ae() / 3;
            break;
          case u:
            U = (ee - Z) / 6048e5;
            break;
          case c:
            U = (ee - Z) / 864e5;
            break;
          case l:
            U = ee / a;
            break;
          case s:
            U = ee / n;
            break;
          case o:
            U = ee / r;
            break;
          default:
            U = ee;
        }
        return H ? U : D.a(U);
      }, z.daysInMonth = function() {
        return this.endOf(d).$D;
      }, z.$locale = function() {
        return w[this.$L];
      }, z.locale = function(F, j) {
        if (!F) return this.$L;
        var H = this.clone(), U = I(F, j, !0);
        return U && (H.$L = U), H;
      }, z.clone = function() {
        return D.w(this.$d, this);
      }, z.toDate = function() {
        return new Date(this.valueOf());
      }, z.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, z.toISOString = function() {
        return this.$d.toISOString();
      }, z.toString = function() {
        return this.$d.toUTCString();
      }, N;
    }(), L = B.prototype;
    return P.prototype = L, [["$ms", i], ["$s", o], ["$m", s], ["$H", l], ["$W", c], ["$M", d], ["$y", m], ["$D", h]].forEach(function(N) {
      L[N[1]] = function(z) {
        return this.$g(z, N[0], N[1]);
      };
    }), P.extend = function(N, z) {
      return N.$i || (N(z, B, P), N.$i = !0), P;
    }, P.locale = I, P.isDayjs = T, P.unix = function(N) {
      return P(1e3 * N);
    }, P.en = w[$], P.Ls = w, P.p = {}, P;
  });
})(CV);
var xbe = CV.exports;
const fn = /* @__PURE__ */ Ut(xbe);
var SV = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(Ue, function() {
    return function(r, n) {
      n.prototype.weekday = function(a) {
        var i = this.$locale().weekStart || 0, o = this.$W, s = (o < i ? o + 7 : o) - i;
        return this.$utils().u(a) ? s : this.subtract(s, "day").add(a, "day");
      };
    };
  });
})(SV);
var $be = SV.exports;
const _be = /* @__PURE__ */ Ut($be);
var xV = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(Ue, function() {
    return function(r, n, a) {
      var i = n.prototype, o = function(d) {
        return d && (d.indexOf ? d : d.s);
      }, s = function(d, f, m, h, g) {
        var y = d.name ? d : d.$locale(), S = o(y[f]), x = o(y[m]), b = S || x.map(function($) {
          return $.slice(0, h);
        });
        if (!g) return b;
        var _ = y.weekStart;
        return b.map(function($, w) {
          return b[(w + (_ || 0)) % 7];
        });
      }, l = function() {
        return a.Ls[a.locale()];
      }, c = function(d, f) {
        return d.formats[f] || function(m) {
          return m.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(h, g, y) {
            return g || y.slice(1);
          });
        }(d.formats[f.toUpperCase()]);
      }, u = function() {
        var d = this;
        return { months: function(f) {
          return f ? f.format("MMMM") : s(d, "months");
        }, monthsShort: function(f) {
          return f ? f.format("MMM") : s(d, "monthsShort", "months", 3);
        }, firstDayOfWeek: function() {
          return d.$locale().weekStart || 0;
        }, weekdays: function(f) {
          return f ? f.format("dddd") : s(d, "weekdays");
        }, weekdaysMin: function(f) {
          return f ? f.format("dd") : s(d, "weekdaysMin", "weekdays", 2);
        }, weekdaysShort: function(f) {
          return f ? f.format("ddd") : s(d, "weekdaysShort", "weekdays", 3);
        }, longDateFormat: function(f) {
          return c(d.$locale(), f);
        }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
      };
      i.localeData = function() {
        return u.bind(this)();
      }, a.localeData = function() {
        var d = l();
        return { firstDayOfWeek: function() {
          return d.weekStart || 0;
        }, weekdays: function() {
          return a.weekdays();
        }, weekdaysShort: function() {
          return a.weekdaysShort();
        }, weekdaysMin: function() {
          return a.weekdaysMin();
        }, months: function() {
          return a.months();
        }, monthsShort: function() {
          return a.monthsShort();
        }, longDateFormat: function(f) {
          return c(d, f);
        }, meridiem: d.meridiem, ordinal: d.ordinal };
      }, a.months = function() {
        return s(l(), "months");
      }, a.monthsShort = function() {
        return s(l(), "monthsShort", "months", 3);
      }, a.weekdays = function(d) {
        return s(l(), "weekdays", null, null, d);
      }, a.weekdaysShort = function(d) {
        return s(l(), "weekdaysShort", "weekdays", 3, d);
      }, a.weekdaysMin = function(d) {
        return s(l(), "weekdaysMin", "weekdays", 2, d);
      };
    };
  });
})(xV);
var Ebe = xV.exports;
const wbe = /* @__PURE__ */ Ut(Ebe);
var $V = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(Ue, function() {
    var r = "week", n = "year";
    return function(a, i, o) {
      var s = i.prototype;
      s.week = function(l) {
        if (l === void 0 && (l = null), l !== null) return this.add(7 * (l - this.week()), "day");
        var c = this.$locale().yearStart || 1;
        if (this.month() === 11 && this.date() > 25) {
          var u = o(this).startOf(n).add(1, n).date(c), d = o(this).endOf(r);
          if (u.isBefore(d)) return 1;
        }
        var f = o(this).startOf(n).date(c).startOf(r).subtract(1, "millisecond"), m = this.diff(f, r, !0);
        return m < 0 ? o(this).startOf("week").week() : Math.ceil(m);
      }, s.weeks = function(l) {
        return l === void 0 && (l = null), this.week(l);
      };
    };
  });
})($V);
var Obe = $V.exports;
const Tbe = /* @__PURE__ */ Ut(Obe);
var _V = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(Ue, function() {
    return function(r, n) {
      n.prototype.weekYear = function() {
        var a = this.month(), i = this.week(), o = this.year();
        return i === 1 && a === 11 ? o + 1 : a === 0 && i >= 52 ? o - 1 : o;
      };
    };
  });
})(_V);
var Ibe = _V.exports;
const Mbe = /* @__PURE__ */ Ut(Ibe);
var EV = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(Ue, function() {
    return function(r, n) {
      var a = n.prototype, i = a.format;
      a.format = function(o) {
        var s = this, l = this.$locale();
        if (!this.isValid()) return i.bind(this)(o);
        var c = this.$utils(), u = (o || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(d) {
          switch (d) {
            case "Q":
              return Math.ceil((s.$M + 1) / 3);
            case "Do":
              return l.ordinal(s.$D);
            case "gggg":
              return s.weekYear();
            case "GGGG":
              return s.isoWeekYear();
            case "wo":
              return l.ordinal(s.week(), "W");
            case "w":
            case "ww":
              return c.s(s.week(), d === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return c.s(s.isoWeek(), d === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return c.s(String(s.$H === 0 ? 24 : s.$H), d === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(s.$d.getTime() / 1e3);
            case "x":
              return s.$d.getTime();
            case "z":
              return "[" + s.offsetName() + "]";
            case "zzz":
              return "[" + s.offsetName("long") + "]";
            default:
              return d;
          }
        });
        return i.bind(this)(u);
      };
    };
  });
})(EV);
var Abe = EV.exports;
const wV = /* @__PURE__ */ Ut(Abe);
var OV = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(Ue, function() {
    var r = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, n = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, a = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, l = function(g) {
      return (g = +g) + (g > 68 ? 1900 : 2e3);
    }, c = function(g) {
      return function(y) {
        this[g] = +y;
      };
    }, u = [/[+-]\d\d:?(\d\d)?|Z/, function(g) {
      (this.zone || (this.zone = {})).offset = function(y) {
        if (!y || y === "Z") return 0;
        var S = y.match(/([+-]|\d\d)/g), x = 60 * S[1] + (+S[2] || 0);
        return x === 0 ? 0 : S[0] === "+" ? -x : x;
      }(g);
    }], d = function(g) {
      var y = s[g];
      return y && (y.indexOf ? y : y.s.concat(y.f));
    }, f = function(g, y) {
      var S, x = s.meridiem;
      if (x) {
        for (var b = 1; b <= 24; b += 1) if (g.indexOf(x(b, 0, y)) > -1) {
          S = b > 12;
          break;
        }
      } else S = g === (y ? "pm" : "PM");
      return S;
    }, m = { A: [o, function(g) {
      this.afternoon = f(g, !1);
    }], a: [o, function(g) {
      this.afternoon = f(g, !0);
    }], S: [/\d/, function(g) {
      this.milliseconds = 100 * +g;
    }], SS: [a, function(g) {
      this.milliseconds = 10 * +g;
    }], SSS: [/\d{3}/, function(g) {
      this.milliseconds = +g;
    }], s: [i, c("seconds")], ss: [i, c("seconds")], m: [i, c("minutes")], mm: [i, c("minutes")], H: [i, c("hours")], h: [i, c("hours")], HH: [i, c("hours")], hh: [i, c("hours")], D: [i, c("day")], DD: [a, c("day")], Do: [o, function(g) {
      var y = s.ordinal, S = g.match(/\d+/);
      if (this.day = S[0], y) for (var x = 1; x <= 31; x += 1) y(x).replace(/\[|\]/g, "") === g && (this.day = x);
    }], M: [i, c("month")], MM: [a, c("month")], MMM: [o, function(g) {
      var y = d("months"), S = (d("monthsShort") || y.map(function(x) {
        return x.slice(0, 3);
      })).indexOf(g) + 1;
      if (S < 1) throw new Error();
      this.month = S % 12 || S;
    }], MMMM: [o, function(g) {
      var y = d("months").indexOf(g) + 1;
      if (y < 1) throw new Error();
      this.month = y % 12 || y;
    }], Y: [/[+-]?\d+/, c("year")], YY: [a, function(g) {
      this.year = l(g);
    }], YYYY: [/\d{4}/, c("year")], Z: u, ZZ: u };
    function h(g) {
      var y, S;
      y = g, S = s && s.formats;
      for (var x = (g = y.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(I, P, D) {
        var B = D && D.toUpperCase();
        return P || S[D] || r[D] || S[B].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(L, N, z) {
          return N || z.slice(1);
        });
      })).match(n), b = x.length, _ = 0; _ < b; _ += 1) {
        var $ = x[_], w = m[$], O = w && w[0], T = w && w[1];
        x[_] = T ? { regex: O, parser: T } : $.replace(/^\[|\]$/g, "");
      }
      return function(I) {
        for (var P = {}, D = 0, B = 0; D < b; D += 1) {
          var L = x[D];
          if (typeof L == "string") B += L.length;
          else {
            var N = L.regex, z = L.parser, F = I.slice(B), j = N.exec(F)[0];
            z.call(P, j), I = I.replace(j, "");
          }
        }
        return function(H) {
          var U = H.afternoon;
          if (U !== void 0) {
            var G = H.hours;
            U ? G < 12 && (H.hours += 12) : G === 12 && (H.hours = 0), delete H.afternoon;
          }
        }(P), P;
      };
    }
    return function(g, y, S) {
      S.p.customParseFormat = !0, g && g.parseTwoDigitYear && (l = g.parseTwoDigitYear);
      var x = y.prototype, b = x.parse;
      x.parse = function(_) {
        var $ = _.date, w = _.utc, O = _.args;
        this.$u = w;
        var T = O[1];
        if (typeof T == "string") {
          var I = O[2] === !0, P = O[3] === !0, D = I || P, B = O[2];
          P && (B = O[2]), s = this.$locale(), !I && B && (s = S.Ls[B]), this.$d = function(F, j, H) {
            try {
              if (["x", "X"].indexOf(j) > -1) return new Date((j === "X" ? 1e3 : 1) * F);
              var U = h(j)(F), G = U.year, V = U.month, K = U.day, Z = U.hours, ee = U.minutes, ae = U.seconds, ue = U.milliseconds, re = U.zone, oe = /* @__PURE__ */ new Date(), fe = K || (G || V ? 1 : oe.getDate()), le = G || oe.getFullYear(), se = 0;
              G && !V || (se = V > 0 ? V - 1 : oe.getMonth());
              var Q = Z || 0, he = ee || 0, ne = ae || 0, me = ue || 0;
              return re ? new Date(Date.UTC(le, se, fe, Q, he, ne, me + 60 * re.offset * 1e3)) : H ? new Date(Date.UTC(le, se, fe, Q, he, ne, me)) : new Date(le, se, fe, Q, he, ne, me);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }($, T, w), this.init(), B && B !== !0 && (this.$L = this.locale(B).$L), D && $ != this.format(T) && (this.$d = /* @__PURE__ */ new Date("")), s = {};
        } else if (T instanceof Array) for (var L = T.length, N = 1; N <= L; N += 1) {
          O[1] = T[N - 1];
          var z = S.apply(this, O);
          if (z.isValid()) {
            this.$d = z.$d, this.$L = z.$L, this.init();
            break;
          }
          N === L && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else b.call(this, _);
      };
    };
  });
})(OV);
var Pbe = OV.exports;
const Rbe = /* @__PURE__ */ Ut(Pbe);
fn.extend(Rbe);
fn.extend(wV);
fn.extend(_be);
fn.extend(wbe);
fn.extend(Tbe);
fn.extend(Mbe);
fn.extend(function(e, t) {
  var r = t.prototype, n = r.format;
  r.format = function(i) {
    var o = (i || "").replace("Wo", "wo");
    return n.bind(this)(o);
  };
});
var Nbe = {
  // ar_EG:
  // az_AZ:
  // bg_BG:
  bn_BD: "bn-bd",
  by_BY: "be",
  // ca_ES:
  // cs_CZ:
  // da_DK:
  // de_DE:
  // el_GR:
  en_GB: "en-gb",
  en_US: "en",
  // es_ES:
  // et_EE:
  // fa_IR:
  // fi_FI:
  fr_BE: "fr",
  // todo: dayjs has no fr_BE locale, use fr at present
  fr_CA: "fr-ca",
  // fr_FR:
  // ga_IE:
  // gl_ES:
  // he_IL:
  // hi_IN:
  // hr_HR:
  // hu_HU:
  hy_AM: "hy-am",
  // id_ID:
  // is_IS:
  // it_IT:
  // ja_JP:
  // ka_GE:
  // kk_KZ:
  // km_KH:
  kmr_IQ: "ku",
  // kn_IN:
  // ko_KR:
  // ku_IQ: // previous ku in antd
  // lt_LT:
  // lv_LV:
  // mk_MK:
  // ml_IN:
  // mn_MN:
  // ms_MY:
  // nb_NO:
  // ne_NP:
  nl_BE: "nl-be",
  // nl_NL:
  // pl_PL:
  pt_BR: "pt-br",
  // pt_PT:
  // ro_RO:
  // ru_RU:
  // sk_SK:
  // sl_SI:
  // sr_RS:
  // sv_SE:
  // ta_IN:
  // th_TH:
  // tr_TR:
  // uk_UA:
  // ur_PK:
  // vi_VN:
  zh_CN: "zh-cn",
  zh_HK: "zh-hk",
  zh_TW: "zh-tw"
}, Vl = function(t) {
  var r = Nbe[t];
  return r || t.split("_")[0];
}, FN = function() {
  $b(!1, "Not match any format. Please help to fire a issue about this.");
}, Dbe = {
  // get
  getNow: function() {
    return fn();
  },
  getFixedDate: function(t) {
    return fn(t, ["YYYY-M-DD", "YYYY-MM-DD"]);
  },
  getEndDate: function(t) {
    return t.endOf("month");
  },
  getWeekDay: function(t) {
    var r = t.locale("en");
    return r.weekday() + r.localeData().firstDayOfWeek();
  },
  getYear: function(t) {
    return t.year();
  },
  getMonth: function(t) {
    return t.month();
  },
  getDate: function(t) {
    return t.date();
  },
  getHour: function(t) {
    return t.hour();
  },
  getMinute: function(t) {
    return t.minute();
  },
  getSecond: function(t) {
    return t.second();
  },
  getMillisecond: function(t) {
    return t.millisecond();
  },
  // set
  addYear: function(t, r) {
    return t.add(r, "year");
  },
  addMonth: function(t, r) {
    return t.add(r, "month");
  },
  addDate: function(t, r) {
    return t.add(r, "day");
  },
  setYear: function(t, r) {
    return t.year(r);
  },
  setMonth: function(t, r) {
    return t.month(r);
  },
  setDate: function(t, r) {
    return t.date(r);
  },
  setHour: function(t, r) {
    return t.hour(r);
  },
  setMinute: function(t, r) {
    return t.minute(r);
  },
  setSecond: function(t, r) {
    return t.second(r);
  },
  setMillisecond: function(t, r) {
    return t.millisecond(r);
  },
  // Compare
  isAfter: function(t, r) {
    return t.isAfter(r);
  },
  isValidate: function(t) {
    return t.isValid();
  },
  locale: {
    getWeekFirstDay: function(t) {
      return fn().locale(Vl(t)).localeData().firstDayOfWeek();
    },
    getWeekFirstDate: function(t, r) {
      return r.locale(Vl(t)).weekday(0);
    },
    getWeek: function(t, r) {
      return r.locale(Vl(t)).week();
    },
    getShortWeekDays: function(t) {
      return fn().locale(Vl(t)).localeData().weekdaysMin();
    },
    getShortMonths: function(t) {
      return fn().locale(Vl(t)).localeData().monthsShort();
    },
    format: function(t, r, n) {
      return r.locale(Vl(t)).format(n);
    },
    parse: function(t, r, n) {
      for (var a = Vl(t), i = 0; i < n.length; i += 1) {
        var o = n[i], s = r;
        if (o.includes("wo") || o.includes("Wo")) {
          for (var l = s.split("-")[0], c = s.split("-")[1], u = fn(l, "YYYY").startOf("year").locale(a), d = 0; d <= 52; d += 1) {
            var f = u.add(d, "week");
            if (f.format("Wo") === c)
              return f;
          }
          return FN(), null;
        }
        var m = fn(s, o, !0).locale(a);
        if (m.isValid())
          return m;
      }
      return r && FN(), null;
    }
  }
}, Bo = /* @__PURE__ */ p.createContext(null), jbe = {
  bottomLeft: {
    points: ["tl", "bl"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ["tr", "br"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ["bl", "tl"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topRight: {
    points: ["br", "tr"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};
function TV(e) {
  var t = e.popupElement, r = e.popupStyle, n = e.popupClassName, a = e.popupAlign, i = e.transitionName, o = e.getPopupContainer, s = e.children, l = e.range, c = e.placement, u = e.builtinPlacements, d = u === void 0 ? jbe : u, f = e.direction, m = e.visible, h = e.onClose, g = p.useContext(Bo), y = g.prefixCls, S = "".concat(y, "-dropdown"), x = p.useMemo(function() {
    return c !== void 0 ? c : f === "rtl" ? "bottomRight" : "bottomLeft";
  }, [c, f]);
  return /* @__PURE__ */ p.createElement(hh, {
    showAction: [],
    hideAction: ["click"],
    popupPlacement: x,
    builtinPlacements: d,
    prefixCls: S,
    popupTransitionName: i,
    popup: t,
    popupAlign: a,
    popupVisible: m,
    popupClassName: be(n, te(te({}, "".concat(S, "-range"), l), "".concat(S, "-rtl"), f === "rtl")),
    popupStyle: r,
    stretch: "minWidth",
    getPopupContainer: o,
    onPopupVisibleChange: function(_) {
      _ || h();
    }
  }, s);
}
function pI(e, t) {
  for (var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0", n = String(e); n.length < t; )
    n = "".concat(r).concat(n);
  return n;
}
function Bc(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function N0(e, t, r) {
  var n = ze(e);
  return n[t] = r, n;
}
function H1(e, t) {
  var r = {}, n = t || Object.keys(e);
  return n.forEach(function(a) {
    e[a] !== void 0 && (r[a] = e[a]);
  }), r;
}
function IV(e, t, r) {
  if (r)
    return r;
  switch (e) {
    case "time":
      return t.fieldTimeFormat;
    case "datetime":
      return t.fieldDateTimeFormat;
    case "month":
      return t.fieldMonthFormat;
    case "year":
      return t.fieldYearFormat;
    case "quarter":
      return t.fieldQuarterFormat;
    case "week":
      return t.fieldWeekFormat;
    default:
      return t.fieldDateFormat;
  }
}
function MV(e, t, r) {
  var n = r !== void 0 ? r : t[t.length - 1], a = t.find(function(i) {
    return e[i];
  });
  return n !== a ? e[a] : void 0;
}
function AV(e) {
  return H1(e, ["placement", "builtinPlacements", "popupAlign", "getPopupContainer", "transitionName", "direction"]);
}
function mI(e, t, r, n) {
  process.env.NODE_ENV !== "production" && (jt(!t, "'dateRender' is deprecated. Please use 'cellRender' instead."), jt(!r, "'monthCellRender' is deprecated. Please use 'cellRender' instead."));
  var a = p.useMemo(function() {
    return e || function(o, s) {
      var l = o;
      return t && s.type === "date" ? t(l, s.today) : r && s.type === "month" ? r(l, s.locale) : s.originNode;
    };
  }, [e, r, t]), i = p.useCallback(function(o, s) {
    return a(o, ce(ce({}, s), {}, {
      range: n
    }));
  }, [a, n]);
  return i;
}
function PV(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], n = p.useState([!1, !1]), a = ye(n, 2), i = a[0], o = a[1], s = function(u, d) {
    o(function(f) {
      return N0(f, d, u);
    });
  }, l = p.useMemo(function() {
    return i.map(function(c, u) {
      if (c)
        return !0;
      var d = e[u];
      return d ? !!(!r[u] && !d || d && t(d, {
        activeIndex: u
      })) : !1;
    });
  }, [e, i, t, r]);
  return [l, s];
}
function RV(e, t, r, n, a) {
  var i = "", o = [];
  return e && o.push(a ? "hh" : "HH"), t && o.push("mm"), r && o.push("ss"), i = o.join(":"), n && (i += ".SSS"), a && (i += " A"), i;
}
function Lbe(e, t, r, n, a, i) {
  var o = e.fieldDateTimeFormat, s = e.fieldDateFormat, l = e.fieldTimeFormat, c = e.fieldMonthFormat, u = e.fieldYearFormat, d = e.fieldWeekFormat, f = e.fieldQuarterFormat, m = e.yearFormat, h = e.cellYearFormat, g = e.cellQuarterFormat, y = e.dayFormat, S = e.cellDateFormat, x = RV(t, r, n, a, i);
  return ce(ce({}, e), {}, {
    fieldDateTimeFormat: o || "YYYY-MM-DD ".concat(x),
    fieldDateFormat: s || "YYYY-MM-DD",
    fieldTimeFormat: l || x,
    fieldMonthFormat: c || "YYYY-MM",
    fieldYearFormat: u || "YYYY",
    fieldWeekFormat: d || "gggg-wo",
    fieldQuarterFormat: f || "YYYY-[Q]Q",
    yearFormat: m || "YYYY",
    cellYearFormat: h || "YYYY",
    cellQuarterFormat: g || "[Q]Q",
    cellDateFormat: S || y || "D"
  });
}
function NV(e, t) {
  var r = t.showHour, n = t.showMinute, a = t.showSecond, i = t.showMillisecond, o = t.use12Hours;
  return xe.useMemo(function() {
    return Lbe(e, r, n, a, i, o);
  }, [e, r, n, a, i, o]);
}
function bf(e, t, r) {
  return r ?? t.some(function(n) {
    return e.includes(n);
  });
}
var kbe = [
  // 'format',
  "showNow",
  "showHour",
  "showMinute",
  "showSecond",
  "showMillisecond",
  "use12Hours",
  "hourStep",
  "minuteStep",
  "secondStep",
  "millisecondStep",
  "hideDisabledOptions",
  "defaultValue",
  "disabledHours",
  "disabledMinutes",
  "disabledSeconds",
  "disabledMilliseconds",
  "disabledTime",
  "changeOnScroll",
  "defaultOpenValue"
];
function Fbe(e) {
  var t = H1(e, kbe), r = e.format, n = e.picker, a = null;
  return r && (a = r, Array.isArray(a) && (a = a[0]), a = kt(a) === "object" ? a.format : a), n === "time" && (t.format = a), [t, a];
}
function Bbe(e) {
  return e && typeof e == "string";
}
function DV(e, t, r, n) {
  return [e, t, r, n].some(function(a) {
    return a !== void 0;
  });
}
function jV(e, t, r, n, a) {
  var i = t, o = r, s = n;
  if (!e && !i && !o && !s && !a)
    i = !0, o = !0, s = !0;
  else if (e) {
    var l, c, u, d = [i, o, s].some(function(h) {
      return h === !1;
    }), f = [i, o, s].some(function(h) {
      return h === !0;
    }), m = d ? !0 : !f;
    i = (l = i) !== null && l !== void 0 ? l : m, o = (c = o) !== null && c !== void 0 ? c : m, s = (u = s) !== null && u !== void 0 ? u : m;
  }
  return [i, o, s, a];
}
function LV(e) {
  var t = e.showTime, r = Fbe(e), n = ye(r, 2), a = n[0], i = n[1], o = t && kt(t) === "object" ? t : {}, s = ce(ce({
    defaultOpenValue: o.defaultOpenValue || o.defaultValue
  }, a), o), l = s.showMillisecond, c = s.showHour, u = s.showMinute, d = s.showSecond, f = DV(c, u, d, l), m = jV(f, c, u, d, l), h = ye(m, 3);
  return c = h[0], u = h[1], d = h[2], [s, ce(ce({}, s), {}, {
    showHour: c,
    showMinute: u,
    showSecond: d,
    showMillisecond: l
  }), s.format, i];
}
function kV(e, t, r, n, a) {
  var i = e === "time";
  if (e === "datetime" || i) {
    for (var o = n, s = IV(e, a, null), l = s, c = [t, r], u = 0; u < c.length; u += 1) {
      var d = Bc(c[u])[0];
      if (Bbe(d)) {
        l = d;
        break;
      }
    }
    var f = o.showHour, m = o.showMinute, h = o.showSecond, g = o.showMillisecond, y = o.use12Hours, S = bf(l, ["a", "A", "LT", "LLL", "LTS"], y), x = DV(f, m, h, g);
    x || (f = bf(l, ["H", "h", "k", "LT", "LLL"]), m = bf(l, ["m", "LT", "LLL"]), h = bf(l, ["s", "LTS"]), g = bf(l, ["SSS"]));
    var b = jV(x, f, m, h, g), _ = ye(b, 3);
    f = _[0], m = _[1], h = _[2];
    var $ = t || RV(f, m, h, g, S);
    return ce(ce({}, o), {}, {
      // Format
      format: $,
      // Show Config
      showHour: f,
      showMinute: m,
      showSecond: h,
      showMillisecond: g,
      use12Hours: S
    });
  }
  return null;
}
function zbe(e, t, r) {
  if (process.env.NODE_ENV !== "production" && r && jt(!1, "`clearIcon` will be removed in future. Please use `allowClear` instead."), t === !1)
    return null;
  var n = t && kt(t) === "object" ? t : {};
  return n.clearIcon || r || /* @__PURE__ */ p.createElement("span", {
    className: "".concat(e, "-clear-btn")
  });
}
var xx = 7;
function wl(e, t, r) {
  return !e && !t || e === t ? !0 : !e || !t ? !1 : r();
}
function nE(e, t, r) {
  return wl(t, r, function() {
    var n = Math.floor(e.getYear(t) / 10), a = Math.floor(e.getYear(r) / 10);
    return n === a;
  });
}
function Ec(e, t, r) {
  return wl(t, r, function() {
    return e.getYear(t) === e.getYear(r);
  });
}
function BN(e, t) {
  var r = Math.floor(e.getMonth(t) / 3);
  return r + 1;
}
function Hbe(e, t, r) {
  return wl(t, r, function() {
    return Ec(e, t, r) && BN(e, t) === BN(e, r);
  });
}
function vI(e, t, r) {
  return wl(t, r, function() {
    return Ec(e, t, r) && e.getMonth(t) === e.getMonth(r);
  });
}
function hI(e, t, r) {
  return wl(t, r, function() {
    return Ec(e, t, r) && vI(e, t, r) && e.getDate(t) === e.getDate(r);
  });
}
function FV(e, t, r) {
  return wl(t, r, function() {
    return e.getHour(t) === e.getHour(r) && e.getMinute(t) === e.getMinute(r) && e.getSecond(t) === e.getSecond(r);
  });
}
function BV(e, t, r) {
  return wl(t, r, function() {
    return hI(e, t, r) && FV(e, t, r) && e.getMillisecond(t) === e.getMillisecond(r);
  });
}
function E0(e, t, r, n) {
  return wl(r, n, function() {
    var a = e.locale.getWeekFirstDate(t, r), i = e.locale.getWeekFirstDate(t, n);
    return Ec(e, a, i) && e.locale.getWeek(t, r) === e.locale.getWeek(t, n);
  });
}
function qa(e, t, r, n, a) {
  switch (a) {
    case "date":
      return hI(e, r, n);
    case "week":
      return E0(e, t.locale, r, n);
    case "month":
      return vI(e, r, n);
    case "quarter":
      return Hbe(e, r, n);
    case "year":
      return Ec(e, r, n);
    case "decade":
      return nE(e, r, n);
    case "time":
      return FV(e, r, n);
    default:
      return BV(e, r, n);
  }
}
function V1(e, t, r, n) {
  return !t || !r || !n ? !1 : e.isAfter(n, t) && e.isAfter(r, n);
}
function Qg(e, t, r, n, a) {
  return qa(e, t, r, n, a) ? !0 : e.isAfter(r, n);
}
function Vbe(e, t, r) {
  var n = t.locale.getWeekFirstDay(e), a = t.setDate(r, 1), i = t.getWeekDay(a), o = t.addDate(a, n - i);
  return t.getMonth(o) === t.getMonth(r) && t.getDate(o) > 1 && (o = t.addDate(o, -7)), o;
}
function ba(e, t) {
  var r = t.generateConfig, n = t.locale, a = t.format;
  return e ? typeof a == "function" ? a(e) : r.locale.format(n.locale, e, a) : "";
}
function Fb(e, t, r) {
  var n = t, a = ["getHour", "getMinute", "getSecond", "getMillisecond"], i = ["setHour", "setMinute", "setSecond", "setMillisecond"];
  return i.forEach(function(o, s) {
    r ? n = e[o](n, e[a[s]](r)) : n = e[o](n, 0);
  }), n;
}
function Gbe(e, t, r, n, a) {
  var i = br(function(o, s) {
    return !!(r && r(o, s) || n && e.isAfter(n, o) && !qa(e, t, n, o, s.type) || a && e.isAfter(o, a) && !qa(e, t, a, o, s.type));
  });
  return i;
}
function Ube(e, t, r) {
  return p.useMemo(function() {
    var n = IV(e, t, r), a = Bc(n), i = a[0], o = kt(i) === "object" && i.type === "mask" ? i.format : null;
    return [
      // Format list
      a.map(function(s) {
        return typeof s == "string" || typeof s == "function" ? s : s.format;
      }),
      // Mask Format
      o
    ];
  }, [e, t, r]);
}
function Wbe(e, t, r) {
  return typeof e[0] == "function" || r ? !0 : t;
}
function qbe(e, t, r, n) {
  var a = br(function(i, o) {
    var s = ce({
      type: t
    }, o);
    if (delete s.activeIndex, // Date object is invalid
    !e.isValidate(i) || // Date is disabled by `disabledDate`
    r && r(i, s))
      return !0;
    if ((t === "date" || t === "time") && n) {
      var l, c = o && o.activeIndex === 1 ? "end" : "start", u = ((l = n.disabledTime) === null || l === void 0 ? void 0 : l.call(n, i, c, {
        from: s.from
      })) || {}, d = u.disabledHours, f = u.disabledMinutes, m = u.disabledSeconds, h = u.disabledMilliseconds, g = n.disabledHours, y = n.disabledMinutes, S = n.disabledSeconds, x = d || g, b = f || y, _ = m || S, $ = e.getHour(i), w = e.getMinute(i), O = e.getSecond(i), T = e.getMillisecond(i);
      if (x && x().includes($) || b && b($).includes(w) || _ && _($, w).includes(O) || h && h($, w, O).includes(T))
        return !0;
    }
    return !1;
  });
  return a;
}
function ey(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = p.useMemo(function() {
    var n = e && Bc(e);
    return t && n && (n[1] = n[1] || n[0]), n;
  }, [e, t]);
  return r;
}
function zV(e, t) {
  var r = e.generateConfig, n = e.locale, a = e.picker, i = a === void 0 ? "date" : a, o = e.prefixCls, s = o === void 0 ? "rc-picker" : o, l = e.styles, c = l === void 0 ? {} : l, u = e.classNames, d = u === void 0 ? {} : u, f = e.order, m = f === void 0 ? !0 : f, h = e.components, g = h === void 0 ? {} : h, y = e.inputRender, S = e.allowClear, x = e.clearIcon, b = e.needConfirm, _ = e.multiple, $ = e.format, w = e.inputReadOnly, O = e.disabledDate, T = e.minDate, I = e.maxDate, P = e.showTime, D = e.value, B = e.defaultValue, L = e.pickerValue, N = e.defaultPickerValue, z = ey(D), F = ey(B), j = ey(L), H = ey(N), U = i === "date" && P ? "datetime" : i, G = U === "time" || U === "datetime", V = G || _, K = b ?? G, Z = LV(e), ee = ye(Z, 4), ae = ee[0], ue = ee[1], re = ee[2], oe = ee[3], fe = NV(n, ue), le = p.useMemo(function() {
    return kV(U, re, oe, ae, fe);
  }, [U, re, oe, ae, fe]);
  process.env.NODE_ENV !== "production" && i === "time" && ["disabledHours", "disabledMinutes", "disabledSeconds"].some(function(Y) {
    return e[Y];
  }) && jt(!1, "'disabledHours', 'disabledMinutes', 'disabledSeconds' will be removed in the next major version, please use 'disabledTime' instead.");
  var se = p.useMemo(function() {
    return ce(ce({}, e), {}, {
      prefixCls: s,
      locale: fe,
      picker: i,
      styles: c,
      classNames: d,
      order: m,
      components: ce({
        input: y
      }, g),
      clearIcon: zbe(s, S, x),
      showTime: le,
      value: z,
      defaultValue: F,
      pickerValue: j,
      defaultPickerValue: H
    }, t?.());
  }, [e]), Q = Ube(U, fe, $), he = ye(Q, 2), ne = he[0], me = he[1], k = Wbe(ne, w, _), M = Gbe(r, n, O, T, I), R = qbe(r, i, M, le), q = p.useMemo(function() {
    return ce(ce({}, se), {}, {
      needConfirm: K,
      inputReadOnly: k,
      disabledDate: M
    });
  }, [se, K, k, M]);
  return [q, U, V, ne, me, R];
}
function Kbe(e, t, r) {
  var n = Kr(t, {
    value: e
  }), a = ye(n, 2), i = a[0], o = a[1], s = xe.useRef(e), l = xe.useRef(), c = function() {
    vr.cancel(l.current);
  }, u = br(function() {
    o(s.current), r && i !== s.current && r(s.current);
  }), d = br(function(f, m) {
    c(), s.current = f, f || m ? u() : l.current = vr(u);
  });
  return xe.useEffect(function() {
    return c;
  }, []), [i, d];
}
function HV(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], n = arguments.length > 3 ? arguments[3] : void 0, a = r.every(function(u) {
    return u;
  }) ? !1 : e, i = Kbe(a, t || !1, n), o = ye(i, 2), s = o[0], l = o[1];
  function c(u) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (!d.inherit || s) && l(u, d.force);
  }
  return [s, c];
}
function VV(e) {
  var t = p.useRef();
  return p.useImperativeHandle(e, function() {
    var r;
    return {
      nativeElement: (r = t.current) === null || r === void 0 ? void 0 : r.nativeElement,
      focus: function(a) {
        var i;
        (i = t.current) === null || i === void 0 || i.focus(a);
      },
      blur: function() {
        var a;
        (a = t.current) === null || a === void 0 || a.blur();
      }
    };
  }), t;
}
function GV(e, t) {
  return p.useMemo(function() {
    return e || (t ? (jt(!1, "`ranges` is deprecated. Please use `presets` instead."), Object.entries(t).map(function(r) {
      var n = ye(r, 2), a = n[0], i = n[1];
      return {
        label: a,
        value: i
      };
    })) : []);
  }, [e, t]);
}
function gI(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, n = p.useRef(t);
  n.current = t, vc(function() {
    if (e)
      n.current(e);
    else {
      var a = vr(function() {
        n.current(e);
      }, r);
      return function() {
        vr.cancel(a);
      };
    }
  }, [e]);
}
function UV(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = p.useState(0), n = ye(r, 2), a = n[0], i = n[1], o = p.useState(!1), s = ye(o, 2), l = s[0], c = s[1], u = p.useRef([]), d = p.useRef(null), f = function(y) {
    c(y);
  }, m = function(y) {
    return y && (d.current = y), d.current;
  }, h = function(y) {
    var S = u.current, x = new Set(S.filter(function(_) {
      return y[_] || t[_];
    })), b = S[S.length - 1] === 0 ? 1 : 0;
    return x.size >= 2 || e[b] ? null : b;
  };
  return gI(l, function() {
    l || (u.current = []);
  }), p.useEffect(function() {
    l && u.current.push(a);
  }, [l, a]), [l, f, m, a, i, h, u.current];
}
function Ybe(e, t, r, n, a, i) {
  var o = r[r.length - 1], s = function(c, u) {
    var d = ye(e, 2), f = d[0], m = d[1], h = ce(ce({}, u), {}, {
      from: MV(e, r)
    });
    return o === 1 && t[0] && f && // Same date isOK
    !qa(n, a, f, c, h.type) && // Before start date
    n.isAfter(f, c) || o === 0 && t[1] && m && // Same date isOK
    !qa(n, a, m, c, h.type) && // After end date
    n.isAfter(c, m) ? !0 : i?.(c, h);
  };
  return s;
}
function w0(e, t, r, n) {
  switch (t) {
    case "date":
    case "week":
      return e.addMonth(r, n);
    case "month":
    case "quarter":
      return e.addYear(r, n);
    case "year":
      return e.addYear(r, n * 10);
    case "decade":
      return e.addYear(r, n * 100);
    default:
      return r;
  }
}
var $x = [];
function WV(e, t, r, n, a, i, o, s) {
  var l = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : $x, c = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : $x, u = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : $x, d = arguments.length > 11 ? arguments[11] : void 0, f = arguments.length > 12 ? arguments[12] : void 0, m = arguments.length > 13 ? arguments[13] : void 0, h = o === "time", g = i || 0, y = function(j) {
    var H = e.getNow();
    return h && (H = Fb(e, H)), l[j] || r[j] || H;
  }, S = ye(c, 2), x = S[0], b = S[1], _ = Kr(function() {
    return y(0);
  }, {
    value: x
  }), $ = ye(_, 2), w = $[0], O = $[1], T = Kr(function() {
    return y(1);
  }, {
    value: b
  }), I = ye(T, 2), P = I[0], D = I[1], B = p.useMemo(function() {
    var F = [w, P][g];
    return h ? F : Fb(e, F, u[g]);
  }, [h, w, P, g, e, u]), L = function(j) {
    var H = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "panel", U = [O, D][g];
    U(j);
    var G = [w, P];
    G[g] = j, d && (!qa(e, t, w, G[0], o) || !qa(e, t, P, G[1], o)) && d(G, {
      source: H,
      range: g === 1 ? "end" : "start",
      mode: n
    });
  }, N = function(j, H) {
    if (s) {
      var U = {
        date: "month",
        week: "month",
        month: "year",
        quarter: "year"
      }, G = U[o];
      if (G && !qa(e, t, j, H, G))
        return w0(e, o, H, -1);
      if (o === "year") {
        var V = Math.floor(e.getYear(j) / 10), K = Math.floor(e.getYear(H) / 10);
        if (V !== K)
          return w0(e, o, H, -1);
      }
    }
    return H;
  }, z = p.useRef(null);
  return hr(function() {
    if (a && !l[g]) {
      var F = h ? null : e.getNow();
      if (z.current !== null && z.current !== g ? F = [w, P][g ^ 1] : r[g] ? F = g === 0 ? r[0] : N(r[0], r[1]) : r[g ^ 1] && (F = r[g ^ 1]), F) {
        f && e.isAfter(f, F) && (F = f);
        var j = s ? w0(e, o, F, 1) : F;
        m && e.isAfter(j, m) && (F = s ? w0(e, o, m, -1) : m), L(F, "reset");
      }
    }
  }, [a, g, r[g]]), p.useEffect(function() {
    a ? z.current = g : z.current = null;
  }, [a, g]), hr(function() {
    a && l && l[g] && L(l[g], "reset");
  }, [a, g]), [B, L];
}
function qV(e, t) {
  var r = p.useRef(e), n = p.useState({}), a = ye(n, 2), i = a[1], o = function(c) {
    return c && t !== void 0 ? t : r.current;
  }, s = function(c) {
    r.current = c, i({});
  };
  return [o, s, o(!0)];
}
var Zbe = [];
function KV(e, t, r) {
  var n = function(o) {
    return o.map(function(s) {
      return ba(s, {
        generateConfig: e,
        locale: t,
        format: r[0]
      });
    });
  }, a = function(o, s) {
    for (var l = Math.max(o.length, s.length), c = -1, u = 0; u < l; u += 1) {
      var d = o[u] || null, f = s[u] || null;
      if (d !== f && !BV(e, d, f)) {
        c = u;
        break;
      }
    }
    return [c < 0, c !== 0];
  };
  return [n, a];
}
function YV(e, t) {
  return ze(e).sort(function(r, n) {
    return t.isAfter(r, n) ? 1 : -1;
  });
}
function Xbe(e) {
  var t = qV(e), r = ye(t, 2), n = r[0], a = r[1], i = br(function() {
    a(e);
  });
  return p.useEffect(function() {
    i();
  }, [e]), [n, a];
}
function ZV(e, t, r, n, a, i, o, s, l) {
  var c = Kr(i, {
    value: o
  }), u = ye(c, 2), d = u[0], f = u[1], m = d || Zbe, h = Xbe(m), g = ye(h, 2), y = g[0], S = g[1], x = KV(e, t, r), b = ye(x, 2), _ = b[0], $ = b[1], w = br(function(T) {
    var I = ze(T);
    if (n)
      for (var P = 0; P < 2; P += 1)
        I[P] = I[P] || null;
    else a && (I = YV(I.filter(function(F) {
      return F;
    }), e));
    var D = $(y(), I), B = ye(D, 2), L = B[0], N = B[1];
    if (!L && (S(I), s)) {
      var z = _(I);
      s(I, z, {
        range: N ? "end" : "start"
      });
    }
  }), O = function() {
    l && l(y());
  };
  return [m, f, y, w, O];
}
function XV(e, t, r, n, a, i, o, s, l, c) {
  var u = e.generateConfig, d = e.locale, f = e.picker, m = e.onChange, h = e.allowEmpty, g = e.order, y = i.some(function(L) {
    return L;
  }) ? !1 : g, S = KV(u, d, o), x = ye(S, 2), b = x[0], _ = x[1], $ = qV(t), w = ye($, 2), O = w[0], T = w[1], I = br(function() {
    T(t);
  });
  p.useEffect(function() {
    I();
  }, [t]);
  var P = br(function(L) {
    var N = L === null, z = ze(L || O());
    if (N)
      for (var F = Math.max(i.length, z.length), j = 0; j < F; j += 1)
        i[j] || (z[j] = null);
    y && z[0] && z[1] && (z = YV(z, u)), a(z);
    var H = z, U = ye(H, 2), G = U[0], V = U[1], K = !G, Z = !V, ee = h ? (
      // Validate empty start
      (!K || h[0]) && // Validate empty end
      (!Z || h[1])
    ) : !0, ae = !g || K || Z || qa(u, d, G, V, f) || u.isAfter(V, G), ue = (
      // Validate start
      (!G || !c(G, {
        activeIndex: 0
      })) && // Validate end
      (!V || !c(V, {
        from: G,
        activeIndex: 1
      }))
    ), re = (
      // Null value is from clear button
      N || // Normal check
      ee && ae && ue
    );
    if (re) {
      r(z);
      var oe = _(z, t), fe = ye(oe, 1), le = fe[0];
      m && !le && m(
        // Return null directly if all date are empty
        N && z.every(function(se) {
          return !se;
        }) ? null : z,
        b(z)
      );
    }
    return re;
  }), D = br(function(L, N) {
    var z = N0(O(), L, n()[L]);
    T(z), N && P();
  }), B = !s && !l;
  return gI(!B, function() {
    B && (P(), a(t), I());
  }, 2), [D, P];
}
function JV(e, t, r, n, a) {
  return t !== "date" && t !== "time" ? !1 : r !== void 0 ? r : n !== void 0 ? n : !a && (e === "date" || e === "time");
}
function Jbe(e, t, r, n, a, i) {
  var o = e;
  function s(d, f, m) {
    var h = i[d](o), g = m.find(function(b) {
      return b.value === h;
    });
    if (!g || g.disabled) {
      var y = m.filter(function(b) {
        return !b.disabled;
      }), S = ze(y).reverse(), x = S.find(function(b) {
        return b.value <= h;
      }) || y[0];
      x && (h = x.value, o = i[f](o, h));
    }
    return h;
  }
  var l = s("getHour", "setHour", t()), c = s("getMinute", "setMinute", r(l)), u = s("getSecond", "setSecond", n(l, c));
  return s("getMillisecond", "setMillisecond", a(l, c, u)), o;
}
function ty() {
  return [];
}
function ry(e, t) {
  for (var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 2, o = [], s = r >= 1 ? r | 0 : 1, l = e; l <= t; l += s) {
    var c = a.includes(l);
    (!c || !n) && o.push({
      label: pI(l, i),
      value: l,
      disabled: c
    });
  }
  return o;
}
function yI(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 ? arguments[2] : void 0, n = t || {}, a = n.use12Hours, i = n.hourStep, o = i === void 0 ? 1 : i, s = n.minuteStep, l = s === void 0 ? 1 : s, c = n.secondStep, u = c === void 0 ? 1 : c, d = n.millisecondStep, f = d === void 0 ? 100 : d, m = n.hideDisabledOptions, h = n.disabledTime, g = n.disabledHours, y = n.disabledMinutes, S = n.disabledSeconds, x = p.useMemo(function() {
    return r || e.getNow();
  }, [r, e]);
  if (process.env.NODE_ENV !== "production") {
    var b = 24 % o === 0, _ = 60 % l === 0, $ = 60 % u === 0;
    jt(b, "`hourStep` ".concat(o, " is invalid. It should be a factor of 24.")), jt(_, "`minuteStep` ".concat(l, " is invalid. It should be a factor of 60.")), jt($, "`secondStep` ".concat(u, " is invalid. It should be a factor of 60."));
  }
  var w = p.useCallback(function(V) {
    var K = h?.(V) || {};
    return [K.disabledHours || g || ty, K.disabledMinutes || y || ty, K.disabledSeconds || S || ty, K.disabledMilliseconds || ty];
  }, [h, g, y, S]), O = p.useMemo(function() {
    return w(x);
  }, [x, w]), T = ye(O, 4), I = T[0], P = T[1], D = T[2], B = T[3], L = p.useCallback(function(V, K, Z, ee) {
    var ae = ry(0, 23, o, m, V()), ue = a ? ae.map(function(le) {
      return ce(ce({}, le), {}, {
        label: pI(le.value % 12 || 12, 2)
      });
    }) : ae, re = function(se) {
      return ry(0, 59, l, m, K(se));
    }, oe = function(se, Q) {
      return ry(0, 59, u, m, Z(se, Q));
    }, fe = function(se, Q, he) {
      return ry(0, 999, f, m, ee(se, Q, he), 3);
    };
    return [ue, re, oe, fe];
  }, [m, o, a, f, l, u]), N = p.useMemo(function() {
    return L(I, P, D, B);
  }, [L, I, P, D, B]), z = ye(N, 4), F = z[0], j = z[1], H = z[2], U = z[3], G = function(K, Z) {
    var ee = function() {
      return F;
    }, ae = j, ue = H, re = U;
    if (Z) {
      var oe = w(Z), fe = ye(oe, 4), le = fe[0], se = fe[1], Q = fe[2], he = fe[3], ne = L(le, se, Q, he), me = ye(ne, 4), k = me[0], M = me[1], R = me[2], q = me[3];
      ee = function() {
        return k;
      }, ae = M, ue = R, re = q;
    }
    var Y = Jbe(K, ee, ae, ue, re, e);
    return Y;
  };
  return [
    // getValidTime
    G,
    // Units
    F,
    j,
    H,
    U
  ];
}
function Qbe(e) {
  var t = e.mode, r = e.internalMode, n = e.renderExtraFooter, a = e.showNow, i = e.showTime, o = e.onSubmit, s = e.onNow, l = e.invalid, c = e.needConfirm, u = e.generateConfig, d = e.disabledDate, f = p.useContext(Bo), m = f.prefixCls, h = f.locale, g = f.button, y = g === void 0 ? "button" : g, S = u.getNow(), x = yI(u, i, S), b = ye(x, 1), _ = b[0], $ = n?.(t), w = d(S, {
    type: t
  }), O = function() {
    if (!w) {
      var N = _(S);
      s(N);
    }
  }, T = "".concat(m, "-now"), I = "".concat(T, "-btn"), P = a && /* @__PURE__ */ p.createElement("li", {
    className: T
  }, /* @__PURE__ */ p.createElement("a", {
    className: be(I, w && "".concat(I, "-disabled")),
    "aria-disabled": w,
    onClick: O
  }, r === "date" ? h.today : h.now)), D = c && /* @__PURE__ */ p.createElement("li", {
    className: "".concat(m, "-ok")
  }, /* @__PURE__ */ p.createElement(y, {
    disabled: l,
    onClick: o
  }, h.ok)), B = (P || D) && /* @__PURE__ */ p.createElement("ul", {
    className: "".concat(m, "-ranges")
  }, P, D);
  return !$ && !B ? null : /* @__PURE__ */ p.createElement("div", {
    className: "".concat(m, "-footer")
  }, $ && /* @__PURE__ */ p.createElement("div", {
    className: "".concat(m, "-footer-extra")
  }, $), B);
}
function QV(e, t, r) {
  function n(a, i) {
    var o = a.findIndex(function(l) {
      return qa(e, t, l, i, r);
    });
    if (o === -1)
      return [].concat(ze(a), [i]);
    var s = ze(a);
    return s.splice(o, 1), s;
  }
  return n;
}
var zc = /* @__PURE__ */ p.createContext(null);
function G1() {
  return p.useContext(zc);
}
function Ed(e, t) {
  var r = e.prefixCls, n = e.generateConfig, a = e.locale, i = e.disabledDate, o = e.minDate, s = e.maxDate, l = e.cellRender, c = e.hoverValue, u = e.hoverRangeValue, d = e.onHover, f = e.values, m = e.pickerValue, h = e.onSelect, g = e.prevIcon, y = e.nextIcon, S = e.superPrevIcon, x = e.superNextIcon, b = n.getNow(), _ = {
    now: b,
    values: f,
    pickerValue: m,
    prefixCls: r,
    disabledDate: i,
    minDate: o,
    maxDate: s,
    cellRender: l,
    hoverValue: c,
    hoverRangeValue: u,
    onHover: d,
    locale: a,
    generateConfig: n,
    onSelect: h,
    panelType: t,
    // Icons
    prevIcon: g,
    nextIcon: y,
    superPrevIcon: S,
    superNextIcon: x
  };
  return [_, b];
}
var Fs = /* @__PURE__ */ p.createContext({});
process.env.NODE_ENV !== "production" && (Fs.displayName = "PickerHackContext");
function Ch(e) {
  for (var t = e.rowNum, r = e.colNum, n = e.baseDate, a = e.getCellDate, i = e.prefixColumn, o = e.rowClassName, s = e.titleFormat, l = e.getCellText, c = e.getCellClassName, u = e.headerCells, d = e.cellSelection, f = d === void 0 ? !0 : d, m = e.disabledDate, h = G1(), g = h.prefixCls, y = h.panelType, S = h.now, x = h.disabledDate, b = h.cellRender, _ = h.onHover, $ = h.hoverValue, w = h.hoverRangeValue, O = h.generateConfig, T = h.values, I = h.locale, P = h.onSelect, D = m || x, B = "".concat(g, "-cell"), L = p.useContext(Fs), N = L.onCellDblClick, z = function(Z) {
    return T.some(function(ee) {
      return ee && qa(O, I, Z, ee, y);
    });
  }, F = [], j = 0; j < t; j += 1) {
    for (var H = [], U = void 0, G = function() {
      var Z = j * r + V, ee = a(n, Z), ae = D?.(ee, {
        type: y
      });
      V === 0 && (U = ee, i && H.push(i(U)));
      var ue = !1, re = !1, oe = !1;
      if (f && w) {
        var fe = ye(w, 2), le = fe[0], se = fe[1];
        ue = V1(O, le, se, ee), re = qa(O, I, ee, le, y), oe = qa(O, I, ee, se, y);
      }
      var Q = s ? ba(ee, {
        locale: I,
        format: s,
        generateConfig: O
      }) : void 0, he = /* @__PURE__ */ p.createElement("div", {
        className: "".concat(B, "-inner")
      }, l(ee));
      H.push(/* @__PURE__ */ p.createElement("td", {
        key: V,
        title: Q,
        className: be(B, ce(te(te(te(te(te(te({}, "".concat(B, "-disabled"), ae), "".concat(B, "-hover"), ($ || []).some(function(ne) {
          return qa(O, I, ee, ne, y);
        })), "".concat(B, "-in-range"), ue && !re && !oe), "".concat(B, "-range-start"), re), "".concat(B, "-range-end"), oe), "".concat(g, "-cell-selected"), !w && // WeekPicker use row instead
        y !== "week" && z(ee)), c(ee))),
        onClick: function() {
          ae || P(ee);
        },
        onDoubleClick: function() {
          !ae && N && N();
        },
        onMouseEnter: function() {
          ae || _?.(ee);
        },
        onMouseLeave: function() {
          ae || _?.(null);
        }
      }, b ? b(ee, {
        prefixCls: g,
        originNode: he,
        today: S,
        type: y,
        locale: I
      }) : he));
    }, V = 0; V < r; V += 1)
      G();
    F.push(/* @__PURE__ */ p.createElement("tr", {
      key: j,
      className: o?.(U)
    }, H));
  }
  return /* @__PURE__ */ p.createElement("div", {
    className: "".concat(g, "-body")
  }, /* @__PURE__ */ p.createElement("table", {
    className: "".concat(g, "-content")
  }, u && /* @__PURE__ */ p.createElement("thead", null, /* @__PURE__ */ p.createElement("tr", null, u)), /* @__PURE__ */ p.createElement("tbody", null, F)));
}
var ny = {
  visibility: "hidden"
};
function wd(e) {
  var t = e.offset, r = e.superOffset, n = e.onChange, a = e.getStart, i = e.getEnd, o = e.children, s = G1(), l = s.prefixCls, c = s.prevIcon, u = c === void 0 ? "‹" : c, d = s.nextIcon, f = d === void 0 ? "›" : d, m = s.superPrevIcon, h = m === void 0 ? "«" : m, g = s.superNextIcon, y = g === void 0 ? "»" : g, S = s.minDate, x = s.maxDate, b = s.generateConfig, _ = s.locale, $ = s.pickerValue, w = s.panelType, O = "".concat(l, "-header"), T = p.useContext(Fs), I = T.hidePrev, P = T.hideNext, D = T.hideHeader, B = p.useMemo(function() {
    if (!S || !t || !i)
      return !1;
    var K = i(t(-1, $));
    return !Qg(b, _, K, S, w);
  }, [S, t, $, i, b, _, w]), L = p.useMemo(function() {
    if (!S || !r || !i)
      return !1;
    var K = i(r(-1, $));
    return !Qg(b, _, K, S, w);
  }, [S, r, $, i, b, _, w]), N = p.useMemo(function() {
    if (!x || !t || !a)
      return !1;
    var K = a(t(1, $));
    return !Qg(b, _, x, K, w);
  }, [x, t, $, a, b, _, w]), z = p.useMemo(function() {
    if (!x || !r || !a)
      return !1;
    var K = a(r(1, $));
    return !Qg(b, _, x, K, w);
  }, [x, r, $, a, b, _, w]), F = function(Z) {
    t && n(t(Z, $));
  }, j = function(Z) {
    r && n(r(Z, $));
  };
  if (D)
    return null;
  var H = "".concat(O, "-prev-btn"), U = "".concat(O, "-next-btn"), G = "".concat(O, "-super-prev-btn"), V = "".concat(O, "-super-next-btn");
  return /* @__PURE__ */ p.createElement("div", {
    className: O
  }, r && /* @__PURE__ */ p.createElement("button", {
    type: "button",
    onClick: function() {
      return j(-1);
    },
    tabIndex: -1,
    className: be(G, L && "".concat(G, "-disabled")),
    disabled: L,
    style: I ? ny : {}
  }, h), t && /* @__PURE__ */ p.createElement("button", {
    type: "button",
    onClick: function() {
      return F(-1);
    },
    tabIndex: -1,
    className: be(H, B && "".concat(H, "-disabled")),
    disabled: B,
    style: I ? ny : {}
  }, u), /* @__PURE__ */ p.createElement("div", {
    className: "".concat(O, "-view")
  }, o), t && /* @__PURE__ */ p.createElement("button", {
    type: "button",
    onClick: function() {
      return F(1);
    },
    tabIndex: -1,
    className: be(U, N && "".concat(U, "-disabled")),
    disabled: N,
    style: P ? ny : {}
  }, f), r && /* @__PURE__ */ p.createElement("button", {
    type: "button",
    onClick: function() {
      return j(1);
    },
    tabIndex: -1,
    className: be(V, z && "".concat(V, "-disabled")),
    disabled: z,
    style: P ? ny : {}
  }, y));
}
function U1(e) {
  var t = e.prefixCls, r = e.panelName, n = r === void 0 ? "date" : r, a = e.locale, i = e.generateConfig, o = e.pickerValue, s = e.onPickerValueChange, l = e.onModeChange, c = e.mode, u = c === void 0 ? "date" : c, d = e.disabledDate, f = e.onSelect, m = e.onHover, h = e.showWeek, g = "".concat(t, "-").concat(n, "-panel"), y = "".concat(t, "-cell"), S = u === "week", x = Ed(e, u), b = ye(x, 2), _ = b[0], $ = b[1], w = i.locale.getWeekFirstDay(a.locale), O = i.setDate(o, 1), T = Vbe(a.locale, i, O), I = i.getMonth(o), P = S || h ? function(V) {
    var K = d?.(V, {
      type: "week"
    });
    return /* @__PURE__ */ p.createElement("td", {
      key: "week",
      className: be(y, "".concat(y, "-week"), te({}, "".concat(y, "-disabled"), K)),
      onClick: function() {
        K || f(V);
      },
      onMouseEnter: function() {
        K || m?.(V);
      },
      onMouseLeave: function() {
        K || m?.(null);
      }
    }, /* @__PURE__ */ p.createElement("div", {
      className: "".concat(y, "-inner")
    }, i.locale.getWeek(a.locale, V)));
  } : null, D = [], B = a.shortWeekDays || (i.locale.getShortWeekDays ? i.locale.getShortWeekDays(a.locale) : []);
  P && D.push(/* @__PURE__ */ p.createElement("th", {
    key: "empty",
    "aria-label": "empty cell"
  }));
  for (var L = 0; L < xx; L += 1)
    D.push(/* @__PURE__ */ p.createElement("th", {
      key: L
    }, B[(L + w) % xx]));
  var N = function(K, Z) {
    return i.addDate(K, Z);
  }, z = function(K) {
    return ba(K, {
      locale: a,
      format: a.cellDateFormat,
      generateConfig: i
    });
  }, F = function(K) {
    var Z = te(te({}, "".concat(t, "-cell-in-view"), vI(i, K, o)), "".concat(t, "-cell-today"), hI(i, K, $));
    return Z;
  }, j = a.shortMonths || (i.locale.getShortMonths ? i.locale.getShortMonths(a.locale) : []), H = /* @__PURE__ */ p.createElement("button", {
    type: "button",
    key: "year",
    onClick: function() {
      l("year", o);
    },
    tabIndex: -1,
    className: "".concat(t, "-year-btn")
  }, ba(o, {
    locale: a,
    format: a.yearFormat,
    generateConfig: i
  })), U = /* @__PURE__ */ p.createElement("button", {
    type: "button",
    key: "month",
    onClick: function() {
      l("month", o);
    },
    tabIndex: -1,
    className: "".concat(t, "-month-btn")
  }, a.monthFormat ? ba(o, {
    locale: a,
    format: a.monthFormat,
    generateConfig: i
  }) : j[I]), G = a.monthBeforeYear ? [U, H] : [H, U];
  return /* @__PURE__ */ p.createElement(zc.Provider, {
    value: _
  }, /* @__PURE__ */ p.createElement("div", {
    className: be(g, h && "".concat(g, "-show-week"))
  }, /* @__PURE__ */ p.createElement(wd, {
    offset: function(K) {
      return i.addMonth(o, K);
    },
    superOffset: function(K) {
      return i.addYear(o, K);
    },
    onChange: s,
    getStart: function(K) {
      return i.setDate(K, 1);
    },
    getEnd: function(K) {
      var Z = i.setDate(K, 1);
      return Z = i.addMonth(Z, 1), i.addDate(Z, -1);
    }
  }, G), /* @__PURE__ */ p.createElement(Ch, Pe({
    titleFormat: a.fieldDateFormat
  }, e, {
    colNum: xx,
    rowNum: 6,
    baseDate: T,
    headerCells: D,
    getCellDate: N,
    getCellText: z,
    getCellClassName: F,
    prefixColumn: P,
    cellSelection: !S
  }))));
}
var e1e = 1 / 3;
function t1e(e, t) {
  var r = p.useRef(!1), n = p.useRef(null), a = p.useRef(null), i = function() {
    return r.current;
  }, o = function() {
    vr.cancel(n.current), r.current = !1;
  }, s = p.useRef(), l = function() {
    var d = e.current;
    if (a.current = null, s.current = 0, d) {
      var f = d.querySelector('[data-value="'.concat(t, '"]')), m = d.querySelector("li"), h = function g() {
        o(), r.current = !0, s.current += 1;
        var y = d.scrollTop, S = m.offsetTop, x = f.offsetTop, b = x - S;
        if (x === 0 && f !== m || !yd(d)) {
          s.current <= 5 && (n.current = vr(g));
          return;
        }
        var _ = y + (b - y) * e1e, $ = Math.abs(b - _);
        if (a.current !== null && a.current < $) {
          o();
          return;
        }
        if (a.current = $, $ <= 1) {
          d.scrollTop = b, o();
          return;
        }
        d.scrollTop = _, n.current = vr(g);
      };
      f && m && h();
    }
  }, c = br(l);
  return [c, o, i];
}
var r1e = 300;
function Cf(e) {
  var t = e.units, r = e.value, n = e.optionalValue, a = e.type, i = e.onChange, o = e.onDblClick, s = e.changeOnScroll, l = G1(), c = l.prefixCls, u = l.cellRender, d = l.now, f = l.locale, m = "".concat(c, "-time-panel"), h = "".concat(c, "-time-panel-cell"), g = p.useRef(null), y = p.useRef(), S = function() {
    clearTimeout(y.current);
  }, x = t1e(g, r ?? n), b = ye(x, 3), _ = b[0], $ = b[1], w = b[2];
  hr(function() {
    return _(), S(), function() {
      $(), S();
    };
  }, [r, n, t]);
  var O = function(P) {
    S();
    var D = P.target;
    !w() && s && (y.current = setTimeout(function() {
      var B = g.current, L = B.querySelector("li").offsetTop, N = Array.from(B.querySelectorAll("li")), z = N.map(function(G) {
        return G.offsetTop - L;
      }), F = z.map(function(G, V) {
        return t[V].disabled ? Number.MAX_SAFE_INTEGER : Math.abs(G - D.scrollTop);
      }), j = Math.min.apply(Math, ze(F)), H = F.findIndex(function(G) {
        return G === j;
      }), U = t[H];
      U && !U.disabled && i(U.value);
    }, r1e));
  }, T = "".concat(m, "-column");
  return /* @__PURE__ */ p.createElement("ul", {
    className: T,
    ref: g,
    "data-type": a,
    onScroll: O
  }, t.map(function(I) {
    var P = I.label, D = I.value, B = I.disabled, L = /* @__PURE__ */ p.createElement("div", {
      className: "".concat(h, "-inner")
    }, P);
    return /* @__PURE__ */ p.createElement("li", {
      key: D,
      className: be(h, te(te({}, "".concat(h, "-selected"), r === D), "".concat(h, "-disabled"), B)),
      onClick: function() {
        B || i(D);
      },
      onDoubleClick: function() {
        !B && o && o();
      },
      "data-value": D
    }, u ? u(D, {
      prefixCls: c,
      originNode: L,
      today: d,
      type: "time",
      subType: a,
      locale: f
    }) : L);
  }));
}
function ll(e) {
  return e < 12;
}
function n1e(e) {
  var t = e.showHour, r = e.showMinute, n = e.showSecond, a = e.showMillisecond, i = e.use12Hours, o = e.changeOnScroll, s = G1(), l = s.prefixCls, c = s.values, u = s.generateConfig, d = s.locale, f = s.onSelect, m = s.pickerValue, h = c?.[0] || null, g = p.useContext(Fs), y = g.onCellDblClick, S = yI(u, e, h), x = ye(S, 5), b = x[0], _ = x[1], $ = x[2], w = x[3], O = x[4], T = function(de) {
    var Se = h && u[de](h), Ee = m && u[de](m);
    return [Se, Ee];
  }, I = T("getHour"), P = ye(I, 2), D = P[0], B = P[1], L = T("getMinute"), N = ye(L, 2), z = N[0], F = N[1], j = T("getSecond"), H = ye(j, 2), U = H[0], G = H[1], V = T("getMillisecond"), K = ye(V, 2), Z = K[0], ee = K[1], ae = D === null ? null : ll(D) ? "am" : "pm", ue = p.useMemo(function() {
    return i ? ll(D) ? _.filter(function(J) {
      return ll(J.value);
    }) : _.filter(function(J) {
      return !ll(J.value);
    }) : _;
  }, [D, _, i]), re = function(de, Se) {
    var Ee, Te = de.filter(function(Le) {
      return !Le.disabled;
    });
    return Se ?? // Fallback to enabled value
    (Te == null || (Ee = Te[0]) === null || Ee === void 0 ? void 0 : Ee.value);
  }, oe = re(_, D), fe = p.useMemo(function() {
    return $(oe);
  }, [$, oe]), le = re(fe, z), se = p.useMemo(function() {
    return w(oe, le);
  }, [w, oe, le]), Q = re(se, U), he = p.useMemo(function() {
    return O(oe, le, Q);
  }, [O, oe, le, Q]), ne = re(he, Z), me = p.useMemo(function() {
    if (!i)
      return [];
    var J = u.getNow(), de = u.setHour(J, 6), Se = u.setHour(J, 18), Ee = function(Le, Ie) {
      var De = d.cellMeridiemFormat;
      return De ? ba(Le, {
        generateConfig: u,
        locale: d,
        format: De
      }) : Ie;
    };
    return [{
      label: Ee(de, "AM"),
      value: "am",
      disabled: _.every(function(Te) {
        return Te.disabled || !ll(Te.value);
      })
    }, {
      label: Ee(Se, "PM"),
      value: "pm",
      disabled: _.every(function(Te) {
        return Te.disabled || ll(Te.value);
      })
    }];
  }, [_, i, u, d]), k = function(de) {
    var Se = b(de);
    f(Se);
  }, M = p.useMemo(function() {
    var J = h || m || u.getNow(), de = function(Ee) {
      return Ee != null;
    };
    return de(D) ? (J = u.setHour(J, D), J = u.setMinute(J, z), J = u.setSecond(J, U), J = u.setMillisecond(J, Z)) : de(B) ? (J = u.setHour(J, B), J = u.setMinute(J, F), J = u.setSecond(J, G), J = u.setMillisecond(J, ee)) : de(oe) && (J = u.setHour(J, oe), J = u.setMinute(J, le), J = u.setSecond(J, Q), J = u.setMillisecond(J, ne)), J;
  }, [h, m, D, z, U, Z, oe, le, Q, ne, B, F, G, ee, u]), R = function(de) {
    k(u.setHour(M, de));
  }, q = function(de) {
    k(u.setMinute(M, de));
  }, Y = function(de) {
    k(u.setSecond(M, de));
  }, X = function(de) {
    k(u.setMillisecond(M, de));
  }, pe = function(de) {
    de === "am" && !ll(D) ? k(u.setHour(M, D - 12)) : de === "pm" && ll(D) && k(u.setHour(M, D + 12));
  }, $e = {
    onDblClick: y,
    changeOnScroll: o
  };
  return /* @__PURE__ */ p.createElement("div", {
    className: "".concat(l, "-content")
  }, t && /* @__PURE__ */ p.createElement(Cf, Pe({
    units: ue,
    value: D,
    optionalValue: B,
    type: "hour",
    onChange: R
  }, $e)), r && /* @__PURE__ */ p.createElement(Cf, Pe({
    units: fe,
    value: z,
    optionalValue: F,
    type: "minute",
    onChange: q
  }, $e)), n && /* @__PURE__ */ p.createElement(Cf, Pe({
    units: se,
    value: U,
    optionalValue: G,
    type: "second",
    onChange: Y
  }, $e)), a && /* @__PURE__ */ p.createElement(Cf, Pe({
    units: he,
    value: Z,
    optionalValue: ee,
    type: "millisecond",
    onChange: X
  }, $e)), i && /* @__PURE__ */ p.createElement(Cf, Pe({
    units: me,
    value: ae,
    type: "meridiem",
    onChange: pe
  }, $e)));
}
function eG(e) {
  var t = e.prefixCls, r = e.value, n = e.locale, a = e.generateConfig, i = e.showTime, o = i || {}, s = o.format, l = "".concat(t, "-time-panel"), c = Ed(e, "time"), u = ye(c, 1), d = u[0];
  return /* @__PURE__ */ p.createElement(zc.Provider, {
    value: d
  }, /* @__PURE__ */ p.createElement("div", {
    className: be(l)
  }, /* @__PURE__ */ p.createElement(wd, null, r ? ba(r, {
    locale: n,
    format: s,
    generateConfig: a
  }) : " "), /* @__PURE__ */ p.createElement(n1e, i)));
}
function a1e(e) {
  var t = e.prefixCls, r = e.generateConfig, n = e.showTime, a = e.onSelect, i = e.value, o = e.pickerValue, s = e.onHover, l = "".concat(t, "-datetime-panel"), c = yI(r, n), u = ye(c, 1), d = u[0], f = function(y) {
    return i ? Fb(r, y, i) : Fb(r, y, o);
  }, m = function(y) {
    s(y && f(y));
  }, h = function(y) {
    var S = f(y);
    a(d(S, S));
  };
  return /* @__PURE__ */ p.createElement("div", {
    className: l
  }, /* @__PURE__ */ p.createElement(U1, Pe({}, e, {
    onSelect: h,
    onHover: m
  })), /* @__PURE__ */ p.createElement(eG, e));
}
function i1e(e) {
  var t = e.prefixCls, r = e.locale, n = e.generateConfig, a = e.pickerValue, i = e.disabledDate, o = e.onPickerValueChange, s = "".concat(t, "-decade-panel"), l = Ed(e, "decade"), c = ye(l, 1), u = c[0], d = function(w) {
    var O = Math.floor(n.getYear(a) / 100) * 100;
    return n.setYear(w, O);
  }, f = function(w) {
    var O = d(w);
    return n.addYear(O, 99);
  }, m = d(a), h = f(a), g = n.addYear(m, -10), y = function(w, O) {
    return n.addYear(w, O * 10);
  }, S = function(w) {
    var O = r.cellYearFormat, T = ba(w, {
      locale: r,
      format: O,
      generateConfig: n
    }), I = ba(n.addYear(w, 9), {
      locale: r,
      format: O,
      generateConfig: n
    });
    return "".concat(T, "-").concat(I);
  }, x = function(w) {
    return te({}, "".concat(t, "-cell-in-view"), nE(n, w, m) || nE(n, w, h) || V1(n, m, h, w));
  }, b = i ? function($, w) {
    var O = n.setDate($, 1), T = n.setMonth(O, 0), I = n.setYear(T, Math.floor(n.getYear(T) / 10) * 10), P = n.addYear(I, 10), D = n.addDate(P, -1);
    return i(I, w) && i(D, w);
  } : null, _ = "".concat(ba(m, {
    locale: r,
    format: r.yearFormat,
    generateConfig: n
  }), "-").concat(ba(h, {
    locale: r,
    format: r.yearFormat,
    generateConfig: n
  }));
  return /* @__PURE__ */ p.createElement(zc.Provider, {
    value: u
  }, /* @__PURE__ */ p.createElement("div", {
    className: s
  }, /* @__PURE__ */ p.createElement(wd, {
    superOffset: function(w) {
      return n.addYear(a, w * 100);
    },
    onChange: o,
    getStart: d,
    getEnd: f
  }, _), /* @__PURE__ */ p.createElement(Ch, Pe({}, e, {
    disabledDate: b,
    colNum: 3,
    rowNum: 4,
    baseDate: g,
    getCellDate: y,
    getCellText: S,
    getCellClassName: x
  }))));
}
function o1e(e) {
  var t = e.prefixCls, r = e.locale, n = e.generateConfig, a = e.pickerValue, i = e.disabledDate, o = e.onPickerValueChange, s = e.onModeChange, l = "".concat(t, "-month-panel"), c = Ed(e, "month"), u = ye(c, 1), d = u[0], f = n.setMonth(a, 0), m = r.shortMonths || (n.locale.getShortMonths ? n.locale.getShortMonths(r.locale) : []), h = function(_, $) {
    return n.addMonth(_, $);
  }, g = function(_) {
    var $ = n.getMonth(_);
    return r.monthFormat ? ba(_, {
      locale: r,
      format: r.monthFormat,
      generateConfig: n
    }) : m[$];
  }, y = function() {
    return te({}, "".concat(t, "-cell-in-view"), !0);
  }, S = i ? function(b, _) {
    var $ = n.setDate(b, 1), w = n.setMonth($, n.getMonth($) + 1), O = n.addDate(w, -1);
    return i($, _) && i(O, _);
  } : null, x = /* @__PURE__ */ p.createElement("button", {
    type: "button",
    key: "year",
    onClick: function() {
      s("year");
    },
    tabIndex: -1,
    className: "".concat(t, "-year-btn")
  }, ba(a, {
    locale: r,
    format: r.yearFormat,
    generateConfig: n
  }));
  return /* @__PURE__ */ p.createElement(zc.Provider, {
    value: d
  }, /* @__PURE__ */ p.createElement("div", {
    className: l
  }, /* @__PURE__ */ p.createElement(wd, {
    superOffset: function(_) {
      return n.addYear(a, _);
    },
    onChange: o,
    getStart: function(_) {
      return n.setMonth(_, 0);
    },
    getEnd: function(_) {
      return n.setMonth(_, 11);
    }
  }, x), /* @__PURE__ */ p.createElement(Ch, Pe({}, e, {
    disabledDate: S,
    titleFormat: r.fieldMonthFormat,
    colNum: 3,
    rowNum: 4,
    baseDate: f,
    getCellDate: h,
    getCellText: g,
    getCellClassName: y
  }))));
}
function s1e(e) {
  var t = e.prefixCls, r = e.locale, n = e.generateConfig, a = e.pickerValue, i = e.onPickerValueChange, o = e.onModeChange, s = "".concat(t, "-quarter-panel"), l = Ed(e, "quarter"), c = ye(l, 1), u = c[0], d = n.setMonth(a, 0), f = function(S, x) {
    return n.addMonth(S, x * 3);
  }, m = function(S) {
    return ba(S, {
      locale: r,
      format: r.cellQuarterFormat,
      generateConfig: n
    });
  }, h = function() {
    return te({}, "".concat(t, "-cell-in-view"), !0);
  }, g = /* @__PURE__ */ p.createElement("button", {
    type: "button",
    key: "year",
    onClick: function() {
      o("year");
    },
    tabIndex: -1,
    className: "".concat(t, "-year-btn")
  }, ba(a, {
    locale: r,
    format: r.yearFormat,
    generateConfig: n
  }));
  return /* @__PURE__ */ p.createElement(zc.Provider, {
    value: u
  }, /* @__PURE__ */ p.createElement("div", {
    className: s
  }, /* @__PURE__ */ p.createElement(wd, {
    superOffset: function(S) {
      return n.addYear(a, S);
    },
    onChange: i,
    getStart: function(S) {
      return n.setMonth(S, 0);
    },
    getEnd: function(S) {
      return n.setMonth(S, 11);
    }
  }, g), /* @__PURE__ */ p.createElement(Ch, Pe({}, e, {
    titleFormat: r.fieldQuarterFormat,
    colNum: 4,
    rowNum: 1,
    baseDate: d,
    getCellDate: f,
    getCellText: m,
    getCellClassName: h
  }))));
}
function l1e(e) {
  var t = e.prefixCls, r = e.generateConfig, n = e.locale, a = e.value, i = e.hoverValue, o = e.hoverRangeValue, s = n.locale, l = "".concat(t, "-week-panel-row"), c = function(d) {
    var f = {};
    if (o) {
      var m = ye(o, 2), h = m[0], g = m[1], y = E0(r, s, h, d), S = E0(r, s, g, d);
      f["".concat(l, "-range-start")] = y, f["".concat(l, "-range-end")] = S, f["".concat(l, "-range-hover")] = !y && !S && V1(r, h, g, d);
    }
    return i && (f["".concat(l, "-hover")] = i.some(function(x) {
      return E0(r, s, d, x);
    })), be(
      l,
      te({}, "".concat(l, "-selected"), !o && E0(r, s, a, d)),
      // Patch for hover range
      f
    );
  };
  return /* @__PURE__ */ p.createElement(U1, Pe({}, e, {
    mode: "week",
    panelName: "week",
    rowClassName: c
  }));
}
function c1e(e) {
  var t = e.prefixCls, r = e.locale, n = e.generateConfig, a = e.pickerValue, i = e.disabledDate, o = e.onPickerValueChange, s = e.onModeChange, l = "".concat(t, "-year-panel"), c = Ed(e, "year"), u = ye(c, 1), d = u[0], f = function(O) {
    var T = Math.floor(n.getYear(a) / 10) * 10;
    return n.setYear(O, T);
  }, m = function(O) {
    var T = f(O);
    return n.addYear(T, 9);
  }, h = f(a), g = m(a), y = n.addYear(h, -1), S = function(O, T) {
    return n.addYear(O, T);
  }, x = function(O) {
    return ba(O, {
      locale: r,
      format: r.cellYearFormat,
      generateConfig: n
    });
  }, b = function(O) {
    return te({}, "".concat(t, "-cell-in-view"), Ec(n, O, h) || Ec(n, O, g) || V1(n, h, g, O));
  }, _ = i ? function(w, O) {
    var T = n.setMonth(w, 0), I = n.setDate(T, 1), P = n.setMonth(w, n.getMonth(w) + 1), D = n.addDate(P, -1);
    return i(I, O) && i(D, O);
  } : null, $ = /* @__PURE__ */ p.createElement("button", {
    type: "button",
    key: "year",
    onClick: function() {
      s("decade");
    },
    tabIndex: -1,
    className: "".concat(t, "-decade-btn")
  }, ba(h, {
    locale: r,
    format: r.yearFormat,
    generateConfig: n
  }), "-", ba(g, {
    locale: r,
    format: r.yearFormat,
    generateConfig: n
  }));
  return /* @__PURE__ */ p.createElement(zc.Provider, {
    value: d
  }, /* @__PURE__ */ p.createElement("div", {
    className: l
  }, /* @__PURE__ */ p.createElement(wd, {
    superOffset: function(O) {
      return n.addYear(a, O * 10);
    },
    onChange: o,
    getStart: f,
    getEnd: m
  }, $), /* @__PURE__ */ p.createElement(Ch, Pe({}, e, {
    disabledDate: _,
    titleFormat: r.fieldYearFormat,
    colNum: 3,
    rowNum: 4,
    baseDate: y,
    getCellDate: S,
    getCellText: x,
    getCellClassName: b
  }))));
}
var u1e = {
  date: U1,
  datetime: a1e,
  week: l1e,
  month: o1e,
  quarter: s1e,
  year: c1e,
  decade: i1e,
  time: eG
};
function d1e(e, t) {
  var r, n = e.locale, a = e.generateConfig, i = e.direction, o = e.prefixCls, s = e.tabIndex, l = s === void 0 ? 0 : s, c = e.multiple, u = e.defaultValue, d = e.value, f = e.onChange, m = e.onSelect, h = e.defaultPickerValue, g = e.pickerValue, y = e.onPickerValueChange, S = e.mode, x = e.onPanelChange, b = e.picker, _ = b === void 0 ? "date" : b, $ = e.showTime, w = e.hoverValue, O = e.hoverRangeValue, T = e.cellRender, I = e.dateRender, P = e.monthCellRender, D = e.components, B = D === void 0 ? {} : D, L = e.hideHeader, N = ((r = p.useContext(Bo)) === null || r === void 0 ? void 0 : r.prefixCls) || o || "rc-picker", z = p.useRef();
  p.useImperativeHandle(t, function() {
    return {
      nativeElement: z.current
    };
  });
  var F = LV(e), j = ye(F, 4), H = j[0], U = j[1], G = j[2], V = j[3], K = NV(n, U), Z = _ === "date" && $ ? "datetime" : _, ee = p.useMemo(function() {
    return kV(Z, G, V, H, K);
  }, [Z, G, V, H, K]), ae = a.getNow(), ue = Kr(_, {
    value: S,
    postState: function(qe) {
      return qe || "date";
    }
  }), re = ye(ue, 2), oe = re[0], fe = re[1], le = oe === "date" && ee ? "datetime" : oe, se = QV(a, n, Z), Q = Kr(u, {
    value: d
  }), he = ye(Q, 2), ne = he[0], me = he[1], k = p.useMemo(function() {
    var Ne = Bc(ne).filter(function(qe) {
      return qe;
    });
    return c ? Ne : Ne.slice(0, 1);
  }, [ne, c]), M = br(function(Ne) {
    me(Ne), f && (Ne === null || k.length !== Ne.length || k.some(function(qe, Qe) {
      return !qa(a, n, qe, Ne[Qe], Z);
    })) && f?.(c ? Ne : Ne[0]);
  }), R = br(function(Ne) {
    if (m?.(Ne), oe === _) {
      var qe = c ? se(k, Ne) : [Ne];
      M(qe);
    }
  }), q = Kr(h || k[0] || ae, {
    value: g
  }), Y = ye(q, 2), X = Y[0], pe = Y[1];
  p.useEffect(function() {
    k[0] && !g && pe(k[0]);
  }, [k[0]]);
  var $e = function(qe, Qe) {
    x?.(qe || g, Qe || oe);
  }, J = function(qe) {
    var Qe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    pe(qe), y?.(qe), Qe && $e(qe);
  }, de = function(qe, Qe) {
    fe(qe), Qe && J(Qe), $e(Qe, qe);
  }, Se = function(qe) {
    if (R(qe), J(qe), oe !== _) {
      var Qe = ["decade", "year"], tt = [].concat(Qe, ["month"]), Ge = {
        quarter: [].concat(Qe, ["quarter"]),
        week: [].concat(ze(tt), ["week"]),
        date: [].concat(ze(tt), ["date"])
      }, it = Ge[_] || tt, ht = it.indexOf(oe), It = it[ht + 1];
      It && de(It, qe);
    }
  }, Ee = p.useMemo(function() {
    var Ne, qe;
    if (Array.isArray(O)) {
      var Qe = ye(O, 2);
      Ne = Qe[0], qe = Qe[1];
    } else
      Ne = O;
    return !Ne && !qe ? null : (Ne = Ne || qe, qe = qe || Ne, a.isAfter(Ne, qe) ? [qe, Ne] : [Ne, qe]);
  }, [O, a]), Te = mI(T, I, P), Le = B[le] || u1e[le] || U1, Ie = p.useContext(Fs), De = p.useMemo(function() {
    return ce(ce({}, Ie), {}, {
      hideHeader: L
    });
  }, [Ie, L]);
  process.env.NODE_ENV !== "production" && jt(!k || k.every(function(Ne) {
    return a.isValidate(Ne);
  }), "Invalidate date pass to `value` or `defaultValue`.");
  var Ae = "".concat(N, "-panel"), Fe = H1(e, [
    // Week
    "showWeek",
    // Icons
    "prevIcon",
    "nextIcon",
    "superPrevIcon",
    "superNextIcon",
    // Disabled
    "disabledDate",
    "minDate",
    "maxDate",
    // Hover
    "onHover"
  ]);
  return /* @__PURE__ */ p.createElement(Fs.Provider, {
    value: De
  }, /* @__PURE__ */ p.createElement("div", {
    ref: z,
    tabIndex: l,
    className: be(Ae, te({}, "".concat(Ae, "-rtl"), i === "rtl"))
  }, /* @__PURE__ */ p.createElement(Le, Pe({}, Fe, {
    // Time
    showTime: ee,
    prefixCls: N,
    locale: K,
    generateConfig: a,
    onModeChange: de,
    pickerValue: X,
    onPickerValueChange: function(qe) {
      J(qe, !0);
    },
    value: k[0],
    onSelect: Se,
    values: k,
    cellRender: Te,
    hoverRangeValue: Ee,
    hoverValue: w
  }))));
}
var db = /* @__PURE__ */ p.memo(/* @__PURE__ */ p.forwardRef(d1e));
process.env.NODE_ENV !== "production" && (db.displayName = "PanelPicker");
function f1e(e) {
  var t = e.picker, r = e.multiplePanel, n = e.pickerValue, a = e.onPickerValueChange, i = e.needConfirm, o = e.onSubmit, s = e.range, l = e.hoverValue, c = p.useContext(Bo), u = c.prefixCls, d = c.generateConfig, f = p.useCallback(function(x, b) {
    return w0(d, t, x, b);
  }, [d, t]), m = p.useMemo(function() {
    return f(n, 1);
  }, [n, f]), h = function(b) {
    a(f(b, -1));
  }, g = {
    onCellDblClick: function() {
      i && o();
    }
  }, y = t === "time", S = ce(ce({}, e), {}, {
    hoverValue: null,
    hoverRangeValue: null,
    hideHeader: y
  });
  return s ? S.hoverRangeValue = l : S.hoverValue = l, r ? /* @__PURE__ */ p.createElement("div", {
    className: "".concat(u, "-panels")
  }, /* @__PURE__ */ p.createElement(Fs.Provider, {
    value: ce(ce({}, g), {}, {
      hideNext: !0
    })
  }, /* @__PURE__ */ p.createElement(db, S)), /* @__PURE__ */ p.createElement(Fs.Provider, {
    value: ce(ce({}, g), {}, {
      hidePrev: !0
    })
  }, /* @__PURE__ */ p.createElement(db, Pe({}, S, {
    pickerValue: m,
    onPickerValueChange: h
  })))) : /* @__PURE__ */ p.createElement(Fs.Provider, {
    value: ce({}, g)
  }, /* @__PURE__ */ p.createElement(db, S));
}
function zN(e) {
  return typeof e == "function" ? e() : e;
}
function p1e(e) {
  var t = e.prefixCls, r = e.presets, n = e.onClick, a = e.onHover;
  return r.length ? /* @__PURE__ */ p.createElement("div", {
    className: "".concat(t, "-presets")
  }, /* @__PURE__ */ p.createElement("ul", null, r.map(function(i, o) {
    var s = i.label, l = i.value;
    return /* @__PURE__ */ p.createElement("li", {
      key: o,
      onClick: function() {
        n(zN(l));
      },
      onMouseEnter: function() {
        a(zN(l));
      },
      onMouseLeave: function() {
        a(null);
      }
    }, s);
  }))) : null;
}
function tG(e) {
  var t = e.panelRender, r = e.internalMode, n = e.picker, a = e.showNow, i = e.range, o = e.multiple, s = e.activeOffset, l = s === void 0 ? 0 : s, c = e.presets, u = e.onPresetHover, d = e.onPresetSubmit, f = e.onFocus, m = e.onBlur, h = e.direction, g = e.value, y = e.onSelect, S = e.isInvalid, x = e.defaultOpenValue, b = e.onOk, _ = e.onSubmit, $ = p.useContext(Bo), w = $.prefixCls, O = "".concat(w, "-panel"), T = h === "rtl", I = p.useRef(null), P = p.useRef(null), D = p.useState(0), B = ye(D, 2), L = B[0], N = B[1], z = p.useState(0), F = ye(z, 2), j = F[0], H = F[1], U = function(he) {
    he.offsetWidth && N(he.offsetWidth);
  };
  p.useEffect(function() {
    if (i) {
      var Q, he = ((Q = I.current) === null || Q === void 0 ? void 0 : Q.offsetWidth) || 0, ne = L - he;
      l <= ne ? H(0) : H(l + he - L);
    }
  }, [L, l, i]);
  function G(Q) {
    return Q.filter(function(he) {
      return he;
    });
  }
  var V = p.useMemo(function() {
    return G(Bc(g));
  }, [g]), K = n === "time" && !V.length, Z = p.useMemo(function() {
    return K ? G([x]) : V;
  }, [K, V, x]), ee = K ? x : V, ae = p.useMemo(function() {
    return Z.length ? Z.some(function(Q) {
      return S(Q);
    }) : !0;
  }, [Z, S]), ue = function() {
    K && y(x), b(), _();
  }, re = /* @__PURE__ */ p.createElement("div", {
    className: "".concat(w, "-panel-layout")
  }, /* @__PURE__ */ p.createElement(p1e, {
    prefixCls: w,
    presets: c,
    onClick: d,
    onHover: u
  }), /* @__PURE__ */ p.createElement("div", null, /* @__PURE__ */ p.createElement(f1e, Pe({}, e, {
    value: ee
  })), /* @__PURE__ */ p.createElement(Qbe, Pe({}, e, {
    showNow: o ? !1 : a,
    invalid: ae,
    onSubmit: ue
  }))));
  t && (re = t(re));
  var oe = "".concat(O, "-container"), fe = "marginLeft", le = "marginRight", se = /* @__PURE__ */ p.createElement("div", {
    tabIndex: -1,
    className: be(
      oe,
      // Used for Today Button style, safe to remove if no need
      "".concat(w, "-").concat(r, "-panel-container")
    ),
    style: te(te({}, T ? le : fe, j), T ? fe : le, "auto"),
    onFocus: f,
    onBlur: m
  }, re);
  return i && (se = /* @__PURE__ */ p.createElement("div", {
    ref: P,
    className: be("".concat(w, "-range-wrapper"), "".concat(w, "-").concat(n, "-range-wrapper"))
  }, /* @__PURE__ */ p.createElement("div", {
    ref: I,
    className: "".concat(w, "-range-arrow"),
    style: te({}, T ? "right" : "left", l)
  }), /* @__PURE__ */ p.createElement(Ia, {
    onResize: U
  }, se))), se;
}
function rG(e, t) {
  var r = e.format, n = e.maskFormat, a = e.generateConfig, i = e.locale, o = e.preserveInvalidOnBlur, s = e.inputReadOnly, l = e.required, c = e["aria-required"], u = e.onSubmit, d = e.onFocus, f = e.onBlur, m = e.onInputChange, h = e.onInvalid, g = e.open, y = e.onOpenChange, S = e.onKeyDown, x = e.onChange, b = e.activeHelp, _ = e.name, $ = e.autoComplete, w = e.id, O = e.value, T = e.invalid, I = e.placeholder, P = e.disabled, D = e.activeIndex, B = e.allHelp, L = e.picker, N = function(K, Z) {
    var ee = a.locale.parse(i.locale, K, [Z]);
    return ee && a.isValidate(ee) ? ee : null;
  }, z = r[0], F = p.useCallback(function(V) {
    return ba(V, {
      locale: i,
      format: z,
      generateConfig: a
    });
  }, [i, a, z]), j = p.useMemo(function() {
    return O.map(F);
  }, [O, F]), H = p.useMemo(function() {
    var V = L === "time" ? 8 : 10, K = typeof z == "function" ? z(a.getNow()).length : z.length;
    return Math.max(V, K) + 2;
  }, [z, L, a]), U = function(K) {
    for (var Z = 0; Z < r.length; Z += 1) {
      var ee = r[Z];
      if (typeof ee == "string") {
        var ae = N(K, ee);
        if (ae)
          return ae;
      }
    }
    return !1;
  }, G = function(K) {
    function Z(ue) {
      return K !== void 0 ? ue[K] : ue;
    }
    var ee = aa(e, {
      aria: !0,
      data: !0
    }), ae = ce(ce({}, ee), {}, {
      // ============== Shared ==============
      format: n,
      validateFormat: function(re) {
        return !!U(re);
      },
      preserveInvalidOnBlur: o,
      readOnly: s,
      required: l,
      "aria-required": c,
      name: _,
      autoComplete: $,
      size: H,
      // ============= By Index =============
      id: Z(w),
      value: Z(j) || "",
      invalid: Z(T),
      placeholder: Z(I),
      active: D === K,
      helped: B || b && D === K,
      disabled: Z(P),
      onFocus: function(re) {
        d(re, K);
      },
      onBlur: function(re) {
        f(re, K);
      },
      onSubmit: u,
      // Get validate text value
      onChange: function(re) {
        m();
        var oe = U(re);
        if (oe) {
          h(!1, K), x(oe, K);
          return;
        }
        h(!!re, K);
      },
      onHelp: function() {
        y(!0, {
          index: K
        });
      },
      onKeyDown: function(re) {
        var oe = !1;
        if (S?.(re, function() {
          process.env.NODE_ENV !== "production" && jt(!1, "`preventDefault` callback is deprecated. Please call `event.preventDefault` directly."), oe = !0;
        }), !re.defaultPrevented && !oe)
          switch (re.key) {
            case "Escape":
              y(!1, {
                index: K
              });
              break;
            case "Enter":
              g || y(!0);
              break;
          }
      }
    }, t?.({
      valueTexts: j
    }));
    return Object.keys(ae).forEach(function(ue) {
      ae[ue] === void 0 && delete ae[ue];
    }), ae;
  };
  return [G, F];
}
var m1e = ["onMouseEnter", "onMouseLeave"];
function nG(e) {
  return p.useMemo(function() {
    return H1(e, m1e);
  }, [e]);
}
var v1e = ["icon", "type"], h1e = ["onClear"];
function W1(e) {
  var t = e.icon, r = e.type, n = Kt(e, v1e), a = p.useContext(Bo), i = a.prefixCls;
  return t ? /* @__PURE__ */ p.createElement("span", Pe({
    className: "".concat(i, "-").concat(r)
  }, n), t) : null;
}
function aE(e) {
  var t = e.onClear, r = Kt(e, h1e);
  return /* @__PURE__ */ p.createElement(W1, Pe({}, r, {
    type: "clear",
    role: "button",
    onMouseDown: function(a) {
      a.preventDefault();
    },
    onClick: function(a) {
      a.stopPropagation(), t();
    }
  }));
}
var _x = ["YYYY", "MM", "DD", "HH", "mm", "ss", "SSS"], HN = "顧", g1e = /* @__PURE__ */ function() {
  function e(t) {
    Hn(this, e), te(this, "format", void 0), te(this, "maskFormat", void 0), te(this, "cells", void 0), te(this, "maskCells", void 0), this.format = t;
    var r = _x.map(function(s) {
      return "(".concat(s, ")");
    }).join("|"), n = new RegExp(r, "g");
    this.maskFormat = t.replace(
      n,
      // Use Chinese character to avoid user use it in format
      function(s) {
        return HN.repeat(s.length);
      }
    );
    var a = new RegExp("(".concat(_x.join("|"), ")")), i = (t.split(a) || []).filter(function(s) {
      return s;
    }), o = 0;
    this.cells = i.map(function(s) {
      var l = _x.includes(s), c = o, u = o + s.length;
      return o = u, {
        text: s,
        mask: l,
        start: c,
        end: u
      };
    }), this.maskCells = this.cells.filter(function(s) {
      return s.mask;
    });
  }
  return Vn(e, [{
    key: "getSelection",
    value: function(r) {
      var n = this.maskCells[r] || {}, a = n.start, i = n.end;
      return [a || 0, i || 0];
    }
    /** Check given text match format */
  }, {
    key: "match",
    value: function(r) {
      for (var n = 0; n < this.maskFormat.length; n += 1) {
        var a = this.maskFormat[n], i = r[n];
        if (!i || a !== HN && a !== i)
          return !1;
      }
      return !0;
    }
    /** Get mask cell count */
  }, {
    key: "size",
    value: function() {
      return this.maskCells.length;
    }
  }, {
    key: "getMaskCellIndex",
    value: function(r) {
      for (var n = Number.MAX_SAFE_INTEGER, a = 0, i = 0; i < this.maskCells.length; i += 1) {
        var o = this.maskCells[i], s = o.start, l = o.end;
        if (r >= s && r <= l)
          return i;
        var c = Math.min(Math.abs(r - s), Math.abs(r - l));
        c < n && (n = c, a = i);
      }
      return a;
    }
  }]), e;
}();
function y1e(e) {
  var t = {
    YYYY: [0, 9999, (/* @__PURE__ */ new Date()).getFullYear()],
    MM: [1, 12],
    DD: [1, 31],
    HH: [0, 23],
    mm: [0, 59],
    ss: [0, 59],
    SSS: [0, 999]
  };
  return t[e];
}
var b1e = ["active", "showActiveCls", "suffixIcon", "format", "validateFormat", "onChange", "onInput", "helped", "onHelp", "onSubmit", "onKeyDown", "preserveInvalidOnBlur", "invalid", "clearIcon"], Bb = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.active, n = e.showActiveCls, a = n === void 0 ? !0 : n, i = e.suffixIcon, o = e.format, s = e.validateFormat, l = e.onChange;
  e.onInput;
  var c = e.helped, u = e.onHelp, d = e.onSubmit, f = e.onKeyDown, m = e.preserveInvalidOnBlur, h = m === void 0 ? !1 : m, g = e.invalid, y = e.clearIcon, S = Kt(e, b1e), x = e.value, b = e.onFocus, _ = e.onBlur, $ = e.onMouseUp, w = p.useContext(Bo), O = w.prefixCls, T = w.input, I = T === void 0 ? "input" : T, P = "".concat(O, "-input"), D = p.useState(!1), B = ye(D, 2), L = B[0], N = B[1], z = p.useState(x), F = ye(z, 2), j = F[0], H = F[1], U = p.useState(""), G = ye(U, 2), V = G[0], K = G[1], Z = p.useState(null), ee = ye(Z, 2), ae = ee[0], ue = ee[1], re = p.useState(null), oe = ye(re, 2), fe = oe[0], le = oe[1], se = j || "";
  p.useEffect(function() {
    H(x);
  }, [x]);
  var Q = p.useRef(), he = p.useRef();
  p.useImperativeHandle(t, function() {
    return {
      nativeElement: Q.current,
      inputElement: he.current,
      focus: function(Ne) {
        he.current.focus(Ne);
      },
      blur: function() {
        he.current.blur();
      }
    };
  });
  var ne = p.useMemo(function() {
    return new g1e(o || "");
  }, [o]), me = p.useMemo(function() {
    return c ? [0, 0] : ne.getSelection(ae);
  }, [ne, ae, c]), k = ye(me, 2), M = k[0], R = k[1], q = function(Ne) {
    Ne && Ne !== o && Ne !== x && u();
  }, Y = br(function(Fe) {
    s(Fe) && l(Fe), H(Fe), q(Fe);
  }), X = function(Ne) {
    if (!o) {
      var qe = Ne.target.value;
      q(qe), H(qe), l(qe);
    }
  }, pe = function(Ne) {
    var qe = Ne.clipboardData.getData("text");
    s(qe) && Y(qe);
  }, $e = p.useRef(!1), J = function() {
    $e.current = !0;
  }, de = function(Ne) {
    var qe = Ne.target, Qe = qe.selectionStart, tt = ne.getMaskCellIndex(Qe);
    ue(tt), le({}), $?.(Ne), $e.current = !1;
  }, Se = function(Ne) {
    N(!0), ue(0), K(""), b(Ne);
  }, Ee = function(Ne) {
    _(Ne);
  }, Te = function(Ne) {
    N(!1), Ee(Ne);
  };
  gI(r, function() {
    !r && !h && H(x);
  });
  var Le = function(Ne) {
    Ne.key === "Enter" && s(se) && d(), f?.(Ne);
  }, Ie = function(Ne) {
    Le(Ne);
    var qe = Ne.key, Qe = null, tt = null, Ge = R - M, it = o.slice(M, R), ht = function(pt) {
      ue(function(Ze) {
        var wt = Ze + pt;
        return wt = Math.max(wt, 0), wt = Math.min(wt, ne.size() - 1), wt;
      });
    }, It = function(pt) {
      var Ze = y1e(it), wt = ye(Ze, 3), bt = wt[0], Je = wt[1], _t = wt[2], Vt = se.slice(M, R), ot = Number(Vt);
      if (isNaN(ot))
        return String(_t || (pt > 0 ? bt : Je));
      var Ct = ot + pt, rt = Je - bt + 1;
      return String(bt + (rt + Ct - bt) % rt);
    };
    switch (qe) {
      case "Backspace":
      case "Delete":
        Qe = "", tt = it;
        break;
      case "ArrowLeft":
        Qe = "", ht(-1);
        break;
      case "ArrowRight":
        Qe = "", ht(1);
        break;
      case "ArrowUp":
        Qe = "", tt = It(1);
        break;
      case "ArrowDown":
        Qe = "", tt = It(-1);
        break;
      default:
        isNaN(Number(qe)) || (Qe = V + qe, tt = Qe);
        break;
    }
    if (Qe !== null && (K(Qe), Qe.length >= Ge && (ht(1), K(""))), tt !== null) {
      var xt = (
        // before
        se.slice(0, M) + // replace
        pI(tt, Ge) + // after
        se.slice(R)
      );
      Y(xt.slice(0, o.length));
    }
    le({});
  }, De = p.useRef();
  hr(function() {
    if (!(!L || !o || $e.current)) {
      if (!ne.match(se)) {
        Y(o);
        return;
      }
      return he.current.setSelectionRange(M, R), De.current = vr(function() {
        he.current.setSelectionRange(M, R);
      }), function() {
        vr.cancel(De.current);
      };
    }
  }, [ne, o, L, se, ae, M, R, fe, Y]);
  var Ae = o ? {
    onFocus: Se,
    onBlur: Te,
    onKeyDown: Ie,
    onMouseDown: J,
    onMouseUp: de,
    onPaste: pe
  } : {};
  return /* @__PURE__ */ p.createElement("div", {
    ref: Q,
    className: be(P, te(te({}, "".concat(P, "-active"), r && a), "".concat(P, "-placeholder"), c))
  }, /* @__PURE__ */ p.createElement(I, Pe({
    ref: he,
    "aria-invalid": g,
    autoComplete: "off"
  }, S, {
    onKeyDown: Le,
    onBlur: Ee
    // Replace with format
  }, Ae, {
    // Value
    value: se,
    onChange: X
  })), /* @__PURE__ */ p.createElement(W1, {
    type: "suffix",
    icon: i
  }), y);
});
process.env.NODE_ENV !== "production" && (Bb.displayName = "Input");
var C1e = ["id", "clearIcon", "suffixIcon", "separator", "activeIndex", "activeHelp", "allHelp", "focused", "onFocus", "onBlur", "onKeyDown", "locale", "generateConfig", "placeholder", "className", "style", "onClick", "onClear", "value", "onChange", "onSubmit", "onInputChange", "format", "maskFormat", "preserveInvalidOnBlur", "onInvalid", "disabled", "invalid", "inputReadOnly", "direction", "onOpenChange", "onActiveOffset", "onMouseDown", "required", "aria-required", "autoFocus"], S1e = ["index"];
function x1e(e, t) {
  var r = e.id, n = e.clearIcon, a = e.suffixIcon, i = e.separator, o = i === void 0 ? "~" : i, s = e.activeIndex;
  e.activeHelp, e.allHelp;
  var l = e.focused;
  e.onFocus, e.onBlur, e.onKeyDown, e.locale, e.generateConfig;
  var c = e.placeholder, u = e.className, d = e.style, f = e.onClick, m = e.onClear, h = e.value;
  e.onChange, e.onSubmit, e.onInputChange, e.format, e.maskFormat, e.preserveInvalidOnBlur, e.onInvalid;
  var g = e.disabled, y = e.invalid;
  e.inputReadOnly;
  var S = e.direction;
  e.onOpenChange;
  var x = e.onActiveOffset, b = e.onMouseDown;
  e.required, e["aria-required"];
  var _ = e.autoFocus, $ = Kt(e, C1e), w = S === "rtl", O = p.useContext(Bo), T = O.prefixCls, I = p.useMemo(function() {
    if (typeof r == "string")
      return [r];
    var oe = r || {};
    return [oe.start, oe.end];
  }, [r]), P = p.useRef(), D = p.useRef(), B = p.useRef(), L = function(fe) {
    var le;
    return (le = [D, B][fe]) === null || le === void 0 ? void 0 : le.current;
  };
  p.useImperativeHandle(t, function() {
    return {
      nativeElement: P.current,
      focus: function(fe) {
        if (kt(fe) === "object") {
          var le, se = fe || {}, Q = se.index, he = Q === void 0 ? 0 : Q, ne = Kt(se, S1e);
          (le = L(he)) === null || le === void 0 || le.focus(ne);
        } else {
          var me;
          (me = L(fe ?? 0)) === null || me === void 0 || me.focus();
        }
      },
      blur: function() {
        var fe, le;
        (fe = L(0)) === null || fe === void 0 || fe.blur(), (le = L(1)) === null || le === void 0 || le.blur();
      }
    };
  });
  var N = nG($), z = p.useMemo(function() {
    return Array.isArray(c) ? c : [c, c];
  }, [c]), F = rG(ce(ce({}, e), {}, {
    id: I,
    placeholder: z
  })), j = ye(F, 1), H = j[0], U = w ? "right" : "left", G = p.useState(te({
    position: "absolute",
    width: 0
  }, U, 0)), V = ye(G, 2), K = V[0], Z = V[1], ee = br(function() {
    var oe = L(s);
    if (oe) {
      var fe = oe.nativeElement, le = fe.offsetWidth, se = fe.offsetLeft, Q = fe.offsetParent, he = se;
      if (w) {
        var ne = Q, me = getComputedStyle(ne);
        he = ne.offsetWidth - parseFloat(me.borderRightWidth) - parseFloat(me.borderLeftWidth) - se - le;
      }
      Z(function(k) {
        return ce(ce({}, k), {}, te({
          width: le
        }, U, he));
      }), x(s === 0 ? 0 : he);
    }
  });
  p.useEffect(function() {
    ee();
  }, [s]);
  var ae = n && (h[0] && !g[0] || h[1] && !g[1]), ue = _ && !g[0], re = _ && !ue && !g[1];
  return /* @__PURE__ */ p.createElement(Ia, {
    onResize: ee
  }, /* @__PURE__ */ p.createElement("div", Pe({}, N, {
    className: be(T, "".concat(T, "-range"), te(te(te(te({}, "".concat(T, "-focused"), l), "".concat(T, "-disabled"), g.every(function(oe) {
      return oe;
    })), "".concat(T, "-invalid"), y.some(function(oe) {
      return oe;
    })), "".concat(T, "-rtl"), w), u),
    style: d,
    ref: P,
    onClick: f,
    onMouseDown: function(fe) {
      var le = fe.target;
      le !== D.current.inputElement && le !== B.current.inputElement && fe.preventDefault(), b?.(fe);
    }
  }), /* @__PURE__ */ p.createElement(Bb, Pe({
    ref: D
  }, H(0), {
    autoFocus: ue,
    "date-range": "start"
  })), /* @__PURE__ */ p.createElement("div", {
    className: "".concat(T, "-range-separator")
  }, o), /* @__PURE__ */ p.createElement(Bb, Pe({
    ref: B
  }, H(1), {
    autoFocus: re,
    "date-range": "end"
  })), /* @__PURE__ */ p.createElement("div", {
    className: "".concat(T, "-active-bar"),
    style: K
  }), /* @__PURE__ */ p.createElement(W1, {
    type: "suffix",
    icon: a
  }), ae && /* @__PURE__ */ p.createElement(aE, {
    icon: n,
    onClear: m
  })));
}
var aG = /* @__PURE__ */ p.forwardRef(x1e);
process.env.NODE_ENV !== "production" && (aG.displayName = "RangeSelector");
function VN(e, t) {
  var r = e ?? t;
  return Array.isArray(r) ? r : [r, r];
}
function ay(e) {
  return e === 1 ? "end" : "start";
}
function $1e(e, t) {
  var r = zV(e, function() {
    var sr = e.disabled, qt = e.allowEmpty, gr = VN(sr, !1), Ft = VN(qt, !1);
    return {
      disabled: gr,
      allowEmpty: Ft
    };
  }), n = ye(r, 6), a = n[0], i = n[1], o = n[2], s = n[3], l = n[4], c = n[5], u = a.prefixCls, d = a.styles, f = a.classNames, m = a.defaultValue, h = a.value, g = a.needConfirm, y = a.onKeyDown, S = a.disabled, x = a.allowEmpty, b = a.disabledDate, _ = a.minDate, $ = a.maxDate, w = a.defaultOpen, O = a.open, T = a.onOpenChange, I = a.locale, P = a.generateConfig, D = a.picker, B = a.showNow, L = a.showToday, N = a.showTime, z = a.mode, F = a.onPanelChange, j = a.onCalendarChange, H = a.onOk, U = a.defaultPickerValue, G = a.pickerValue, V = a.onPickerValueChange, K = a.inputReadOnly, Z = a.suffixIcon, ee = a.onFocus, ae = a.onBlur, ue = a.presets, re = a.ranges, oe = a.components, fe = a.cellRender, le = a.dateRender, se = a.monthCellRender, Q = a.onClick, he = VV(t), ne = HV(O, w, S, T), me = ye(ne, 2), k = me[0], M = me[1], R = function(qt, gr) {
    (S.some(function(Ft) {
      return !Ft;
    }) || !qt) && M(qt, gr);
  }, q = ZV(P, I, s, !0, !1, m, h, j, H), Y = ye(q, 5), X = Y[0], pe = Y[1], $e = Y[2], J = Y[3], de = Y[4], Se = $e(), Ee = UV(S, x), Te = ye(Ee, 7), Le = Te[0], Ie = Te[1], De = Te[2], Ae = Te[3], Fe = Te[4], Ne = Te[5], qe = Te[6], Qe = function(qt, gr) {
    Ie(!0), ee?.(qt, {
      range: ay(gr ?? Ae)
    });
  }, tt = function(qt, gr) {
    Ie(!1), ae?.(qt, {
      range: ay(gr ?? Ae)
    });
  }, Ge = p.useMemo(function() {
    if (!N)
      return null;
    var sr = N.disabledTime, qt = sr ? function(gr) {
      var Ft = ay(Ae), rr = MV(Se, qe, Ae);
      return sr(gr, Ft, {
        from: rr
      });
    } : void 0;
    return ce(ce({}, N), {}, {
      disabledTime: qt
    });
  }, [N, Ae, Se, qe]), it = Kr([D, D], {
    value: z
  }), ht = ye(it, 2), It = ht[0], xt = ht[1], Xe = It[Ae] || D, pt = Xe === "date" && Ge ? "datetime" : Xe, Ze = pt === D && pt !== "time", wt = JV(D, Xe, B, L, !0), bt = XV(a, X, pe, $e, J, S, s, Le, k, c), Je = ye(bt, 2), _t = Je[0], Vt = Je[1], ot = Ybe(Se, S, qe, P, I, b), Ct = PV(Se, c, x), rt = ye(Ct, 2), $t = rt[0], Wt = rt[1], _e = WV(P, I, Se, It, k, Ae, i, Ze, U, G, Ge?.defaultOpenValue, V, _, $), Ke = ye(_e, 2), nt = Ke[0], Ve = Ke[1], ke = br(function(sr, qt, gr) {
    var Ft = N0(It, Ae, qt);
    if ((Ft[0] !== It[0] || Ft[1] !== It[1]) && xt(Ft), F && gr !== !1) {
      var rr = ze(Se);
      sr && (rr[Ae] = sr), F(rr, Ft);
    }
  }), ut = function(qt, gr) {
    return (
      // Trigger change only when date changed
      N0(Se, gr, qt)
    );
  }, st = function(qt, gr) {
    var Ft = Se;
    qt && (Ft = ut(qt, Ae));
    var rr = Ne(Ft);
    J(Ft), _t(Ae, rr === null), rr === null ? R(!1, {
      force: !0
    }) : gr || he.current.focus({
      index: rr
    });
  }, Et = function(qt) {
    if (!he.current.nativeElement.contains(document.activeElement)) {
      var gr = S.findIndex(function(Ft) {
        return !Ft;
      });
      gr >= 0 && he.current.focus({
        index: gr
      });
    }
    R(!0), Q?.(qt);
  }, zt = function() {
    Vt(null), R(!1, {
      force: !0
    });
  }, Be = p.useState(null), ft = ye(Be, 2), yt = ft[0], Rt = ft[1], Ht = p.useState(null), ir = ye(Ht, 2), ar = ir[0], Nr = ir[1], Xr = p.useMemo(function() {
    return ar || Se;
  }, [Se, ar]);
  p.useEffect(function() {
    k || Nr(null);
  }, [k]);
  var Qr = p.useState(0), Ur = ye(Qr, 2), gn = Ur[0], Zt = Ur[1], er = GV(ue, re), _r = function(qt) {
    Nr(qt), Rt("preset");
  }, Sn = function(qt) {
    var gr = Vt(qt);
    gr && R(!1, {
      force: !0
    });
  }, On = function(qt) {
    st(qt);
  }, Un = function(qt) {
    Nr(qt ? ut(qt, Ae) : null), Rt("cell");
  }, oa = function(qt) {
    R(!0), Qe(qt);
  }, va = function(qt) {
    De("panel");
    var gr = N0(Se, Ae, qt);
    J(gr), !g && !o && i === pt && st(qt);
  }, Fn = function() {
    R(!1);
  }, or = mI(fe, le, se, ay(Ae)), tr = Se[Ae] || null, Jr = br(function(sr) {
    return c(sr, {
      activeIndex: Ae
    });
  }), tn = p.useMemo(function() {
    var sr = aa(a, !1), qt = bn(a, [].concat(ze(Object.keys(sr)), ["onChange", "onCalendarChange", "style", "className", "onPanelChange", "disabledTime"]));
    return qt;
  }, [a]), zr = /* @__PURE__ */ p.createElement(tG, Pe({}, tn, {
    showNow: wt,
    showTime: Ge,
    range: !0,
    multiplePanel: Ze,
    activeOffset: gn,
    disabledDate: ot,
    onFocus: oa,
    onBlur: tt,
    picker: D,
    mode: Xe,
    internalMode: pt,
    onPanelChange: ke,
    format: l,
    value: tr,
    isInvalid: Jr,
    onChange: null,
    onSelect: va,
    pickerValue: nt,
    defaultOpenValue: Bc(N?.defaultOpenValue)[Ae],
    onPickerValueChange: Ve,
    hoverValue: Xr,
    onHover: Un,
    needConfirm: g,
    onSubmit: st,
    onOk: de,
    presets: er,
    onPresetHover: _r,
    onPresetSubmit: Sn,
    onNow: On,
    cellRender: or
  })), cr = function(qt, gr) {
    var Ft = ut(qt, gr);
    J(Ft);
  }, Ot = function() {
    De("input");
  }, Tt = function(qt, gr) {
    De("input"), R(!0, {
      inherit: !0
    }), Fe(gr), Qe(qt, gr);
  }, Sr = function(qt, gr) {
    R(!1), tt(qt, gr);
  }, Mr = function(qt, gr) {
    qt.key === "Tab" && st(null, !0), y?.(qt, gr);
  }, en = p.useMemo(function() {
    return {
      prefixCls: u,
      locale: I,
      generateConfig: P,
      button: oe.button,
      input: oe.input
    };
  }, [u, I, P, oe.button, oe.input]);
  if (hr(function() {
    k && Ae !== void 0 && ke(null, D, !1);
  }, [k, Ae, D]), hr(function() {
    var sr = De();
    !k && sr === "input" && (R(!1), st(null, !0)), !k && o && !g && sr === "panel" && (R(!0), st());
  }, [k]), process.env.NODE_ENV !== "production") {
    var Rn = function(qt) {
      return (
        // Value is empty
        !(h != null && h[qt]) && // DefaultValue is empty
        !(m != null && m[qt])
      );
    };
    S.some(function(sr, qt) {
      return sr && Rn(qt) && !x[qt];
    }) && jt(!1, "`disabled` should not set with empty `value`. You should set `allowEmpty` or `value` instead.");
  }
  return /* @__PURE__ */ p.createElement(Bo.Provider, {
    value: en
  }, /* @__PURE__ */ p.createElement(TV, Pe({}, AV(a), {
    popupElement: zr,
    popupStyle: d.popup,
    popupClassName: f.popup,
    visible: k,
    onClose: Fn,
    range: !0
  }), /* @__PURE__ */ p.createElement(
    aG,
    Pe({}, a, {
      // Ref
      ref: he,
      suffixIcon: Z,
      activeIndex: Le || k ? Ae : null,
      activeHelp: !!ar,
      allHelp: !!ar && yt === "preset",
      focused: Le,
      onFocus: Tt,
      onBlur: Sr,
      onKeyDown: Mr,
      onSubmit: st,
      value: Xr,
      maskFormat: l,
      onChange: cr,
      onInputChange: Ot,
      format: s,
      inputReadOnly: K,
      disabled: S,
      open: k,
      onOpenChange: R,
      onClick: Et,
      onClear: zt,
      invalid: $t,
      onInvalid: Wt,
      onActiveOffset: Zt
    })
  )));
}
var iG = /* @__PURE__ */ p.forwardRef($1e);
process.env.NODE_ENV !== "production" && (iG.displayName = "RefRangePicker");
function _1e(e) {
  var t = e.prefixCls, r = e.value, n = e.onRemove, a = e.removeIcon, i = a === void 0 ? "×" : a, o = e.formatDate, s = e.disabled, l = e.maxTagCount, c = e.placeholder, u = "".concat(t, "-selector"), d = "".concat(t, "-selection"), f = "".concat(d, "-overflow");
  function m(y, S) {
    return /* @__PURE__ */ p.createElement("span", {
      className: be("".concat(d, "-item")),
      title: typeof y == "string" ? y : null
    }, /* @__PURE__ */ p.createElement("span", {
      className: "".concat(d, "-item-content")
    }, y), !s && S && /* @__PURE__ */ p.createElement("span", {
      onMouseDown: function(b) {
        b.preventDefault();
      },
      onClick: S,
      className: "".concat(d, "-item-remove")
    }, i));
  }
  function h(y) {
    var S = o(y), x = function(_) {
      _ && _.stopPropagation(), n(y);
    };
    return m(S, x);
  }
  function g(y) {
    var S = "+ ".concat(y.length, " ...");
    return m(S);
  }
  return /* @__PURE__ */ p.createElement("div", {
    className: u
  }, /* @__PURE__ */ p.createElement(Ro, {
    prefixCls: f,
    data: r,
    renderItem: h,
    renderRest: g,
    itemKey: function(S) {
      return o(S);
    },
    maxCount: l
  }), !r.length && /* @__PURE__ */ p.createElement("span", {
    className: "".concat(t, "-selection-placeholder")
  }, c));
}
var E1e = ["id", "open", "clearIcon", "suffixIcon", "activeHelp", "allHelp", "focused", "onFocus", "onBlur", "onKeyDown", "locale", "generateConfig", "placeholder", "className", "style", "onClick", "onClear", "internalPicker", "value", "onChange", "onSubmit", "onInputChange", "multiple", "maxTagCount", "format", "maskFormat", "preserveInvalidOnBlur", "onInvalid", "disabled", "invalid", "inputReadOnly", "direction", "onOpenChange", "onMouseDown", "required", "aria-required", "autoFocus", "removeIcon"];
function w1e(e, t) {
  e.id;
  var r = e.open, n = e.clearIcon, a = e.suffixIcon;
  e.activeHelp, e.allHelp;
  var i = e.focused;
  e.onFocus, e.onBlur, e.onKeyDown;
  var o = e.locale, s = e.generateConfig, l = e.placeholder, c = e.className, u = e.style, d = e.onClick, f = e.onClear, m = e.internalPicker, h = e.value, g = e.onChange, y = e.onSubmit;
  e.onInputChange;
  var S = e.multiple, x = e.maxTagCount;
  e.format, e.maskFormat, e.preserveInvalidOnBlur, e.onInvalid;
  var b = e.disabled, _ = e.invalid;
  e.inputReadOnly;
  var $ = e.direction;
  e.onOpenChange;
  var w = e.onMouseDown;
  e.required, e["aria-required"];
  var O = e.autoFocus, T = e.removeIcon, I = Kt(e, E1e), P = $ === "rtl", D = p.useContext(Bo), B = D.prefixCls, L = p.useRef(), N = p.useRef();
  p.useImperativeHandle(t, function() {
    return {
      nativeElement: L.current,
      focus: function(ae) {
        var ue;
        (ue = N.current) === null || ue === void 0 || ue.focus(ae);
      },
      blur: function() {
        var ae;
        (ae = N.current) === null || ae === void 0 || ae.blur();
      }
    };
  });
  var z = nG(I), F = function(ae) {
    g([ae]);
  }, j = function(ae) {
    var ue = h.filter(function(re) {
      return re && !qa(s, o, re, ae, m);
    });
    g(ue), r || y();
  }, H = rG(ce(ce({}, e), {}, {
    onChange: F
  }), function(ee) {
    var ae = ee.valueTexts;
    return {
      value: ae[0] || "",
      active: i
    };
  }), U = ye(H, 2), G = U[0], V = U[1], K = !!(n && h.length && !b), Z = S ? /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement(_1e, {
    prefixCls: B,
    value: h,
    onRemove: j,
    formatDate: V,
    maxTagCount: x,
    disabled: b,
    removeIcon: T,
    placeholder: l
  }), /* @__PURE__ */ p.createElement("input", {
    className: "".concat(B, "-multiple-input"),
    value: h.map(V).join(","),
    ref: N,
    readOnly: !0,
    autoFocus: O
  }), /* @__PURE__ */ p.createElement(W1, {
    type: "suffix",
    icon: a
  }), K && /* @__PURE__ */ p.createElement(aE, {
    icon: n,
    onClear: f
  })) : /* @__PURE__ */ p.createElement(Bb, Pe({
    ref: N
  }, G(), {
    autoFocus: O,
    suffixIcon: a,
    clearIcon: K && /* @__PURE__ */ p.createElement(aE, {
      icon: n,
      onClear: f
    }),
    showActiveCls: !1
  }));
  return /* @__PURE__ */ p.createElement("div", Pe({}, z, {
    className: be(B, te(te(te(te(te({}, "".concat(B, "-multiple"), S), "".concat(B, "-focused"), i), "".concat(B, "-disabled"), b), "".concat(B, "-invalid"), _), "".concat(B, "-rtl"), P), c),
    style: u,
    ref: L,
    onClick: d,
    onMouseDown: function(ae) {
      var ue, re = ae.target;
      re !== ((ue = N.current) === null || ue === void 0 ? void 0 : ue.inputElement) && ae.preventDefault(), w?.(ae);
    }
  }), Z);
}
var oG = /* @__PURE__ */ p.forwardRef(w1e);
process.env.NODE_ENV !== "production" && (oG.displayName = "SingleSelector");
function O1e(e, t) {
  var r = zV(e), n = ye(r, 6), a = n[0], i = n[1], o = n[2], s = n[3], l = n[4], c = n[5], u = a, d = u.prefixCls, f = u.styles, m = u.classNames, h = u.order, g = u.defaultValue, y = u.value, S = u.needConfirm, x = u.onChange, b = u.onKeyDown, _ = u.disabled, $ = u.disabledDate, w = u.minDate, O = u.maxDate, T = u.defaultOpen, I = u.open, P = u.onOpenChange, D = u.locale, B = u.generateConfig, L = u.picker, N = u.showNow, z = u.showToday, F = u.showTime, j = u.mode, H = u.onPanelChange, U = u.onCalendarChange, G = u.onOk, V = u.multiple, K = u.defaultPickerValue, Z = u.pickerValue, ee = u.onPickerValueChange, ae = u.inputReadOnly, ue = u.suffixIcon, re = u.removeIcon, oe = u.onFocus, fe = u.onBlur, le = u.presets, se = u.components, Q = u.cellRender, he = u.dateRender, ne = u.monthCellRender, me = u.onClick, k = VV(t);
  function M(Ot) {
    return Ot === null ? null : V ? Ot : Ot[0];
  }
  var R = QV(B, D, i), q = HV(I, T, [_], P), Y = ye(q, 2), X = Y[0], pe = Y[1], $e = function(Tt, Sr, Mr) {
    if (U) {
      var en = ce({}, Mr);
      delete en.range, U(M(Tt), M(Sr), en);
    }
  }, J = function(Tt) {
    G?.(M(Tt));
  }, de = ZV(B, D, s, !1, h, g, y, $e, J), Se = ye(de, 5), Ee = Se[0], Te = Se[1], Le = Se[2], Ie = Se[3], De = Se[4], Ae = Le(), Fe = UV([_]), Ne = ye(Fe, 4), qe = Ne[0], Qe = Ne[1], tt = Ne[2], Ge = Ne[3], it = function(Tt) {
    Qe(!0), oe?.(Tt, {});
  }, ht = function(Tt) {
    Qe(!1), fe?.(Tt, {});
  }, It = Kr(L, {
    value: j
  }), xt = ye(It, 2), Xe = xt[0], pt = xt[1], Ze = Xe === "date" && F ? "datetime" : Xe, wt = JV(L, Xe, N, z), bt = x && function(Ot, Tt) {
    x(M(Ot), M(Tt));
  }, Je = XV(
    ce(ce({}, a), {}, {
      onChange: bt
    }),
    Ee,
    Te,
    Le,
    Ie,
    [],
    //disabled,
    s,
    qe,
    X,
    c
  ), _t = ye(Je, 2), Vt = _t[1], ot = PV(Ae, c), Ct = ye(ot, 2), rt = Ct[0], $t = Ct[1], Wt = p.useMemo(function() {
    return rt.some(function(Ot) {
      return Ot;
    });
  }, [rt]), _e = function(Tt, Sr) {
    if (ee) {
      var Mr = ce(ce({}, Sr), {}, {
        mode: Sr.mode[0]
      });
      delete Mr.range, ee(Tt[0], Mr);
    }
  }, Ke = WV(
    B,
    D,
    Ae,
    [Xe],
    X,
    Ge,
    i,
    !1,
    // multiplePanel,
    K,
    Z,
    Bc(F?.defaultOpenValue),
    _e,
    w,
    O
  ), nt = ye(Ke, 2), Ve = nt[0], ke = nt[1], ut = br(function(Ot, Tt, Sr) {
    if (pt(Tt), H && Sr !== !1) {
      var Mr = Ot || Ae[Ae.length - 1];
      H(Mr, Tt);
    }
  }), st = function() {
    Vt(Le()), pe(!1, {
      force: !0
    });
  }, Et = function(Tt) {
    !_ && !k.current.nativeElement.contains(document.activeElement) && k.current.focus(), pe(!0), me?.(Tt);
  }, zt = function() {
    Vt(null), pe(!1, {
      force: !0
    });
  }, Be = p.useState(null), ft = ye(Be, 2), yt = ft[0], Rt = ft[1], Ht = p.useState(null), ir = ye(Ht, 2), ar = ir[0], Nr = ir[1], Xr = p.useMemo(function() {
    var Ot = [ar].concat(ze(Ae)).filter(function(Tt) {
      return Tt;
    });
    return V ? Ot : Ot.slice(0, 1);
  }, [Ae, ar, V]), Qr = p.useMemo(function() {
    return !V && ar ? [ar] : Ae.filter(function(Ot) {
      return Ot;
    });
  }, [Ae, ar, V]);
  p.useEffect(function() {
    X || Nr(null);
  }, [X]);
  var Ur = GV(le), gn = function(Tt) {
    Nr(Tt), Rt("preset");
  }, Zt = function(Tt) {
    var Sr = V ? R(Le(), Tt) : [Tt], Mr = Vt(Sr);
    Mr && !V && pe(!1, {
      force: !0
    });
  }, er = function(Tt) {
    Zt(Tt);
  }, _r = function(Tt) {
    Nr(Tt), Rt("cell");
  }, Sn = function(Tt) {
    pe(!0), it(Tt);
  }, On = function(Tt) {
    tt("panel");
    var Sr = V ? R(Le(), Tt) : [Tt];
    Ie(Sr), !S && !o && i === Ze && st();
  }, Un = function() {
    pe(!1);
  }, oa = mI(Q, he, ne), va = p.useMemo(function() {
    var Ot = aa(a, !1), Tt = bn(a, [].concat(ze(Object.keys(Ot)), ["onChange", "onCalendarChange", "style", "className", "onPanelChange"]));
    return ce(ce({}, Tt), {}, {
      multiple: a.multiple
    });
  }, [a]), Fn = /* @__PURE__ */ p.createElement(tG, Pe({}, va, {
    showNow: wt,
    showTime: F,
    disabledDate: $,
    onFocus: Sn,
    onBlur: ht,
    picker: L,
    mode: Xe,
    internalMode: Ze,
    onPanelChange: ut,
    format: l,
    value: Ae,
    isInvalid: c,
    onChange: null,
    onSelect: On,
    pickerValue: Ve,
    defaultOpenValue: F?.defaultOpenValue,
    onPickerValueChange: ke,
    hoverValue: Xr,
    onHover: _r,
    needConfirm: S,
    onSubmit: st,
    onOk: De,
    presets: Ur,
    onPresetHover: gn,
    onPresetSubmit: Zt,
    onNow: er,
    cellRender: oa
  })), or = function(Tt) {
    Ie(Tt);
  }, tr = function() {
    tt("input");
  }, Jr = function(Tt) {
    tt("input"), pe(!0, {
      inherit: !0
    }), it(Tt);
  }, tn = function(Tt) {
    pe(!1), ht(Tt);
  }, zr = function(Tt, Sr) {
    Tt.key === "Tab" && st(), b?.(Tt, Sr);
  }, cr = p.useMemo(function() {
    return {
      prefixCls: d,
      locale: D,
      generateConfig: B,
      button: se.button,
      input: se.input
    };
  }, [d, D, B, se.button, se.input]);
  return hr(function() {
    X && Ge !== void 0 && ut(null, L, !1);
  }, [X, Ge, L]), hr(function() {
    var Ot = tt();
    !X && Ot === "input" && (pe(!1), st()), !X && o && !S && Ot === "panel" && (pe(!0), st());
  }, [X]), /* @__PURE__ */ p.createElement(Bo.Provider, {
    value: cr
  }, /* @__PURE__ */ p.createElement(TV, Pe({}, AV(a), {
    popupElement: Fn,
    popupStyle: f.popup,
    popupClassName: m.popup,
    visible: X,
    onClose: Un
  }), /* @__PURE__ */ p.createElement(
    oG,
    Pe({}, a, {
      // Ref
      ref: k,
      suffixIcon: ue,
      removeIcon: re,
      activeHelp: !!ar,
      allHelp: !!ar && yt === "preset",
      focused: qe,
      onFocus: Jr,
      onBlur: tn,
      onKeyDown: zr,
      onSubmit: st,
      value: Qr,
      maskFormat: l,
      onChange: or,
      onInputChange: tr,
      internalPicker: i,
      format: s,
      inputReadOnly: ae,
      disabled: _,
      open: X,
      onOpenChange: pe,
      onClick: Et,
      onClear: zt,
      invalid: Wt,
      onInvalid: function(Tt) {
        $t(Tt, 0);
      }
    })
  )));
}
var sG = /* @__PURE__ */ p.forwardRef(O1e);
process.env.NODE_ENV !== "production" && (sG.displayName = "RefPicker");
const lG = /* @__PURE__ */ p.createContext(null), T1e = lG.Provider, cG = /* @__PURE__ */ p.createContext(null), I1e = cG.Provider;
var M1e = ["prefixCls", "className", "style", "checked", "disabled", "defaultChecked", "type", "title", "onChange"], uG = /* @__PURE__ */ Aa(function(e, t) {
  var r = e.prefixCls, n = r === void 0 ? "rc-checkbox" : r, a = e.className, i = e.style, o = e.checked, s = e.disabled, l = e.defaultChecked, c = l === void 0 ? !1 : l, u = e.type, d = u === void 0 ? "checkbox" : u, f = e.title, m = e.onChange, h = Kt(e, M1e), g = ct(null), y = ct(null), S = Kr(c, {
    value: o
  }), x = ye(S, 2), b = x[0], _ = x[1];
  fo(t, function() {
    return {
      focus: function(T) {
        var I;
        (I = g.current) === null || I === void 0 || I.focus(T);
      },
      blur: function() {
        var T;
        (T = g.current) === null || T === void 0 || T.blur();
      },
      input: g.current,
      nativeElement: y.current
    };
  });
  var $ = be(n, a, te(te({}, "".concat(n, "-checked"), b), "".concat(n, "-disabled"), s)), w = function(T) {
    s || ("checked" in e || _(T.target.checked), m?.({
      target: ce(ce({}, e), {}, {
        type: d,
        checked: T.target.checked
      }),
      stopPropagation: function() {
        T.stopPropagation();
      },
      preventDefault: function() {
        T.preventDefault();
      },
      nativeEvent: T.nativeEvent
    }));
  };
  return /* @__PURE__ */ p.createElement("span", {
    className: $,
    title: f,
    style: i,
    ref: y
  }, /* @__PURE__ */ p.createElement("input", Pe({}, h, {
    className: "".concat(n, "-input"),
    ref: g,
    onChange: w,
    disabled: s,
    checked: !!b,
    type: d
  })), /* @__PURE__ */ p.createElement("span", {
    className: "".concat(n, "-inner")
  }));
});
const A1e = (e) => {
  const {
    componentCls: t,
    antCls: r
  } = e, n = `${t}-group`;
  return {
    [n]: Object.assign(Object.assign({}, Yr(e)), {
      display: "inline-block",
      fontSize: 0,
      // RTL
      [`&${n}-rtl`]: {
        direction: "rtl"
      },
      [`${r}-badge ${r}-badge-count`]: {
        zIndex: 1
      },
      [`> ${r}-badge:not(:first-child) > ${r}-button-wrapper`]: {
        borderInlineStart: "none"
      }
    })
  };
}, P1e = (e) => {
  const {
    componentCls: t,
    wrapperMarginInlineEnd: r,
    colorPrimary: n,
    radioSize: a,
    motionDurationSlow: i,
    motionDurationMid: o,
    motionEaseInOutCirc: s,
    colorBgContainer: l,
    colorBorder: c,
    lineWidth: u,
    colorBgContainerDisabled: d,
    colorTextDisabled: f,
    paddingXS: m,
    dotColorDisabled: h,
    lineType: g,
    radioColor: y,
    radioBgColor: S,
    calc: x
  } = e, b = `${t}-inner`, $ = x(a).sub(x(4).mul(2)), w = x(1).mul(a).equal({
    unit: !0
  });
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({}, Yr(e)), {
      display: "inline-flex",
      alignItems: "baseline",
      marginInlineStart: 0,
      marginInlineEnd: r,
      cursor: "pointer",
      // RTL
      [`&${t}-wrapper-rtl`]: {
        direction: "rtl"
      },
      "&-disabled": {
        cursor: "not-allowed",
        color: e.colorTextDisabled
      },
      "&::after": {
        display: "inline-block",
        width: 0,
        overflow: "hidden",
        content: '"\\a0"'
      },
      // hashId 在 wrapper 上，只能铺平
      [`${t}-checked::after`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        width: "100%",
        height: "100%",
        border: `${ve(u)} ${g} ${n}`,
        borderRadius: "50%",
        visibility: "hidden",
        opacity: 0,
        content: '""'
      },
      [t]: Object.assign(Object.assign({}, Yr(e)), {
        position: "relative",
        display: "inline-block",
        outline: "none",
        cursor: "pointer",
        alignSelf: "center",
        borderRadius: "50%"
      }),
      [`${t}-wrapper:hover &,
        &:hover ${b}`]: {
        borderColor: n
      },
      [`${t}-input:focus-visible + ${b}`]: Object.assign({}, Sl(e)),
      [`${t}:hover::after, ${t}-wrapper:hover &::after`]: {
        visibility: "visible"
      },
      [`${t}-inner`]: {
        "&::after": {
          boxSizing: "border-box",
          position: "absolute",
          insetBlockStart: "50%",
          insetInlineStart: "50%",
          display: "block",
          width: w,
          height: w,
          marginBlockStart: x(1).mul(a).div(-2).equal({
            unit: !0
          }),
          marginInlineStart: x(1).mul(a).div(-2).equal({
            unit: !0
          }),
          backgroundColor: y,
          borderBlockStart: 0,
          borderInlineStart: 0,
          borderRadius: w,
          transform: "scale(0)",
          opacity: 0,
          transition: `all ${i} ${s}`,
          content: '""'
        },
        boxSizing: "border-box",
        position: "relative",
        insetBlockStart: 0,
        insetInlineStart: 0,
        display: "block",
        width: w,
        height: w,
        backgroundColor: l,
        borderColor: c,
        borderStyle: "solid",
        borderWidth: u,
        borderRadius: "50%",
        transition: `all ${o}`
      },
      [`${t}-input`]: {
        position: "absolute",
        inset: 0,
        zIndex: 1,
        cursor: "pointer",
        opacity: 0
      },
      // 选中状态
      [`${t}-checked`]: {
        [b]: {
          borderColor: n,
          backgroundColor: S,
          "&::after": {
            transform: `scale(${e.calc(e.dotSize).div(a).equal()})`,
            opacity: 1,
            transition: `all ${i} ${s}`
          }
        }
      },
      [`${t}-disabled`]: {
        cursor: "not-allowed",
        [b]: {
          backgroundColor: d,
          borderColor: c,
          cursor: "not-allowed",
          "&::after": {
            backgroundColor: h
          }
        },
        [`${t}-input`]: {
          cursor: "not-allowed"
        },
        [`${t}-disabled + span`]: {
          color: f,
          cursor: "not-allowed"
        },
        [`&${t}-checked`]: {
          [b]: {
            "&::after": {
              transform: `scale(${x($).div(a).equal()})`
            }
          }
        }
      },
      [`span${t} + *`]: {
        paddingInlineStart: m,
        paddingInlineEnd: m
      }
    })
  };
}, R1e = (e) => {
  const {
    buttonColor: t,
    controlHeight: r,
    componentCls: n,
    lineWidth: a,
    lineType: i,
    colorBorder: o,
    motionDurationSlow: s,
    motionDurationMid: l,
    buttonPaddingInline: c,
    fontSize: u,
    buttonBg: d,
    fontSizeLG: f,
    controlHeightLG: m,
    controlHeightSM: h,
    paddingXS: g,
    borderRadius: y,
    borderRadiusSM: S,
    borderRadiusLG: x,
    buttonCheckedBg: b,
    buttonSolidCheckedColor: _,
    colorTextDisabled: $,
    colorBgContainerDisabled: w,
    buttonCheckedBgDisabled: O,
    buttonCheckedColorDisabled: T,
    colorPrimary: I,
    colorPrimaryHover: P,
    colorPrimaryActive: D,
    buttonSolidCheckedBg: B,
    buttonSolidCheckedHoverBg: L,
    buttonSolidCheckedActiveBg: N,
    calc: z
  } = e;
  return {
    [`${n}-button-wrapper`]: {
      position: "relative",
      display: "inline-block",
      height: r,
      margin: 0,
      paddingInline: c,
      paddingBlock: 0,
      color: t,
      fontSize: u,
      lineHeight: ve(z(r).sub(z(a).mul(2)).equal()),
      background: d,
      border: `${ve(a)} ${i} ${o}`,
      // strange align fix for chrome but works
      // https://gw.alipayobjects.com/zos/rmsportal/VFTfKXJuogBAXcvfAUWJ.gif
      borderBlockStartWidth: z(a).add(0.02).equal(),
      borderInlineStartWidth: 0,
      borderInlineEndWidth: a,
      cursor: "pointer",
      transition: [`color ${l}`, `background ${l}`, `box-shadow ${l}`].join(","),
      a: {
        color: t
      },
      [`> ${n}-button`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        zIndex: -1,
        width: "100%",
        height: "100%"
      },
      "&:not(:first-child)": {
        "&::before": {
          position: "absolute",
          insetBlockStart: z(a).mul(-1).equal(),
          insetInlineStart: z(a).mul(-1).equal(),
          display: "block",
          boxSizing: "content-box",
          width: 1,
          height: "100%",
          paddingBlock: a,
          paddingInline: 0,
          backgroundColor: o,
          transition: `background-color ${s}`,
          content: '""'
        }
      },
      "&:first-child": {
        borderInlineStart: `${ve(a)} ${i} ${o}`,
        borderStartStartRadius: y,
        borderEndStartRadius: y
      },
      "&:last-child": {
        borderStartEndRadius: y,
        borderEndEndRadius: y
      },
      "&:first-child:last-child": {
        borderRadius: y
      },
      [`${n}-group-large &`]: {
        height: m,
        fontSize: f,
        lineHeight: ve(z(m).sub(z(a).mul(2)).equal()),
        "&:first-child": {
          borderStartStartRadius: x,
          borderEndStartRadius: x
        },
        "&:last-child": {
          borderStartEndRadius: x,
          borderEndEndRadius: x
        }
      },
      [`${n}-group-small &`]: {
        height: h,
        paddingInline: z(g).sub(a).equal(),
        paddingBlock: 0,
        lineHeight: ve(z(h).sub(z(a).mul(2)).equal()),
        "&:first-child": {
          borderStartStartRadius: S,
          borderEndStartRadius: S
        },
        "&:last-child": {
          borderStartEndRadius: S,
          borderEndEndRadius: S
        }
      },
      "&:hover": {
        position: "relative",
        color: I
      },
      "&:has(:focus-visible)": Object.assign({}, Sl(e)),
      [`${n}-inner, input[type='checkbox'], input[type='radio']`]: {
        width: 0,
        height: 0,
        opacity: 0,
        pointerEvents: "none"
      },
      [`&-checked:not(${n}-button-wrapper-disabled)`]: {
        zIndex: 1,
        color: I,
        background: b,
        borderColor: I,
        "&::before": {
          backgroundColor: I
        },
        "&:first-child": {
          borderColor: I
        },
        "&:hover": {
          color: P,
          borderColor: P,
          "&::before": {
            backgroundColor: P
          }
        },
        "&:active": {
          color: D,
          borderColor: D,
          "&::before": {
            backgroundColor: D
          }
        }
      },
      [`${n}-group-solid &-checked:not(${n}-button-wrapper-disabled)`]: {
        color: _,
        background: B,
        borderColor: B,
        "&:hover": {
          color: _,
          background: L,
          borderColor: L
        },
        "&:active": {
          color: _,
          background: N,
          borderColor: N
        }
      },
      "&-disabled": {
        color: $,
        backgroundColor: w,
        borderColor: o,
        cursor: "not-allowed",
        "&:first-child, &:hover": {
          color: $,
          backgroundColor: w,
          borderColor: o
        }
      },
      [`&-disabled${n}-button-wrapper-checked`]: {
        color: T,
        backgroundColor: O,
        borderColor: o,
        boxShadow: "none"
      }
    }
  };
}, N1e = (e) => {
  const {
    wireframe: t,
    padding: r,
    marginXS: n,
    lineWidth: a,
    fontSizeLG: i,
    colorText: o,
    colorBgContainer: s,
    colorTextDisabled: l,
    controlItemBgActiveDisabled: c,
    colorTextLightSolid: u,
    colorPrimary: d,
    colorPrimaryHover: f,
    colorPrimaryActive: m,
    colorWhite: h
  } = e, g = 4, y = i, S = t ? y - g * 2 : y - (g + a) * 2;
  return {
    // Radio
    radioSize: y,
    dotSize: S,
    dotColorDisabled: l,
    // Radio buttons
    buttonSolidCheckedColor: u,
    buttonSolidCheckedBg: d,
    buttonSolidCheckedHoverBg: f,
    buttonSolidCheckedActiveBg: m,
    buttonBg: s,
    buttonCheckedBg: s,
    buttonColor: o,
    buttonCheckedBgDisabled: c,
    buttonCheckedColorDisabled: l,
    buttonPaddingInline: r - a,
    wrapperMarginInlineEnd: n,
    // internal
    radioColor: t ? d : h,
    radioBgColor: t ? s : d
  };
}, dG = Zr("Radio", (e) => {
  const {
    controlOutline: t,
    controlOutlineWidth: r
  } = e, n = `0 0 0 ${ve(r)} ${t}`, i = $r(e, {
    radioFocusShadow: n,
    radioButtonFocusShadow: n
  });
  return [A1e(i), P1e(i), R1e(i)];
}, N1e, {
  unitless: {
    radioSize: !0,
    dotSize: !0
  }
});
var D1e = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const j1e = (e, t) => {
  var r, n;
  const a = p.useContext(lG), i = p.useContext(cG), {
    getPrefixCls: o,
    direction: s,
    radio: l
  } = p.useContext(Lt), c = p.useRef(null), u = Za(t, c), {
    isFormItemInput: d
  } = p.useContext(xa);
  if (process.env.NODE_ENV !== "production") {
    const N = xr("Radio");
    process.env.NODE_ENV !== "production" && N(!("optionType" in e), "usage", "`optionType` is only support in Radio.Group.");
  }
  const f = (N) => {
    var z, F;
    (z = e.onChange) === null || z === void 0 || z.call(e, N), (F = a?.onChange) === null || F === void 0 || F.call(a, N);
  }, {
    prefixCls: m,
    className: h,
    rootClassName: g,
    children: y,
    style: S,
    title: x
  } = e, b = D1e(e, ["prefixCls", "className", "rootClassName", "children", "style", "title"]), _ = o("radio", m), $ = (a?.optionType || i) === "button", w = $ ? `${_}-button` : _, O = Mn(_), [T, I, P] = dG(_, O), D = Object.assign({}, b), B = p.useContext(Vi);
  a && (D.name = a.name, D.onChange = f, D.checked = e.value === a.value, D.disabled = (r = D.disabled) !== null && r !== void 0 ? r : a.disabled), D.disabled = (n = D.disabled) !== null && n !== void 0 ? n : B;
  const L = be(`${w}-wrapper`, {
    [`${w}-wrapper-checked`]: D.checked,
    [`${w}-wrapper-disabled`]: D.disabled,
    [`${w}-wrapper-rtl`]: s === "rtl",
    [`${w}-wrapper-in-form-item`]: d
  }, l?.className, h, g, I, P, O);
  return T(/* @__PURE__ */ p.createElement(ch, {
    component: "Radio",
    disabled: D.disabled
  }, /* @__PURE__ */ p.createElement("label", {
    className: L,
    style: Object.assign(Object.assign({}, l?.style), S),
    onMouseEnter: e.onMouseEnter,
    onMouseLeave: e.onMouseLeave,
    title: x
  }, /* @__PURE__ */ p.createElement(uG, Object.assign({}, D, {
    className: be(D.className, {
      [$1]: !$
    }),
    type: "radio",
    prefixCls: w,
    ref: u
  })), y !== void 0 ? /* @__PURE__ */ p.createElement("span", null, y) : null)));
}, Q0 = /* @__PURE__ */ p.forwardRef(j1e);
process.env.NODE_ENV !== "production" && (Q0.displayName = "Radio");
const L1e = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    getPrefixCls: r,
    direction: n
  } = p.useContext(Lt), [a, i] = Kr(e.defaultValue, {
    value: e.value
  }), o = (N) => {
    const z = a, F = N.target.value;
    "value" in e || i(F);
    const {
      onChange: j
    } = e;
    j && F !== z && j(N);
  }, {
    prefixCls: s,
    className: l,
    rootClassName: c,
    options: u,
    buttonStyle: d = "outline",
    disabled: f,
    children: m,
    size: h,
    style: g,
    id: y,
    onMouseEnter: S,
    onMouseLeave: x,
    onFocus: b,
    onBlur: _
  } = e, $ = r("radio", s), w = `${$}-group`, O = Mn($), [T, I, P] = dG($, O);
  let D = m;
  u && u.length > 0 && (D = u.map((N) => typeof N == "string" || typeof N == "number" ? /* @__PURE__ */ p.createElement(Q0, {
    key: N.toString(),
    prefixCls: $,
    disabled: f,
    value: N,
    checked: a === N
  }, N) : /* @__PURE__ */ p.createElement(Q0, {
    key: `radio-group-value-options-${N.value}`,
    prefixCls: $,
    disabled: N.disabled || f,
    value: N.value,
    checked: a === N.value,
    title: N.title,
    style: N.style,
    id: N.id,
    required: N.required
  }, N.label)));
  const B = Xa(h), L = be(w, `${w}-${d}`, {
    [`${w}-${B}`]: B,
    [`${w}-rtl`]: n === "rtl"
  }, l, c, I, P, O);
  return T(/* @__PURE__ */ p.createElement("div", Object.assign({}, aa(e, {
    aria: !0,
    data: !0
  }), {
    className: L,
    style: g,
    onMouseEnter: S,
    onMouseLeave: x,
    onFocus: b,
    onBlur: _,
    id: y,
    ref: t
  }), /* @__PURE__ */ p.createElement(T1e, {
    value: {
      onChange: o,
      value: a,
      disabled: e.disabled,
      name: e.name,
      optionType: e.optionType
    }
  }, D)));
}), k1e = /* @__PURE__ */ p.memo(L1e);
var F1e = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const B1e = (e, t) => {
  const {
    getPrefixCls: r
  } = p.useContext(Lt), {
    prefixCls: n
  } = e, a = F1e(e, ["prefixCls"]), i = r("radio", n);
  return /* @__PURE__ */ p.createElement(I1e, {
    value: "button"
  }, /* @__PURE__ */ p.createElement(Q0, Object.assign({
    prefixCls: i
  }, a, {
    type: "radio",
    ref: t
  })));
}, z1e = /* @__PURE__ */ p.forwardRef(B1e), Ba = Q0;
Ba.Button = z1e;
Ba.Group = k1e;
Ba.__ANT_RADIO = !0;
function Sh(e) {
  return $r(e, {
    inputAffixPadding: e.paddingXXS
  });
}
const xh = (e) => {
  const {
    controlHeight: t,
    fontSize: r,
    lineHeight: n,
    lineWidth: a,
    controlHeightSM: i,
    controlHeightLG: o,
    fontSizeLG: s,
    lineHeightLG: l,
    paddingSM: c,
    controlPaddingHorizontalSM: u,
    controlPaddingHorizontal: d,
    colorFillAlter: f,
    colorPrimaryHover: m,
    colorPrimary: h,
    controlOutlineWidth: g,
    controlOutline: y,
    colorErrorOutline: S,
    colorWarningOutline: x,
    colorBgContainer: b
  } = e;
  return {
    paddingBlock: Math.max(Math.round((t - r * n) / 2 * 10) / 10 - a, 0),
    paddingBlockSM: Math.max(Math.round((i - r * n) / 2 * 10) / 10 - a, 0),
    paddingBlockLG: Math.ceil((o - s * l) / 2 * 10) / 10 - a,
    paddingInline: c - a,
    paddingInlineSM: u - a,
    paddingInlineLG: d - a,
    addonBg: f,
    activeBorderColor: h,
    hoverBorderColor: m,
    activeShadow: `0 0 0 ${g}px ${y}`,
    errorActiveShadow: `0 0 0 ${g}px ${S}`,
    warningActiveShadow: `0 0 0 ${g}px ${x}`,
    hoverBg: b,
    activeBg: b,
    inputFontSize: r,
    inputFontSizeLG: s,
    inputFontSizeSM: r
  };
}, H1e = (e) => ({
  borderColor: e.hoverBorderColor,
  backgroundColor: e.hoverBg
}), q1 = (e) => ({
  color: e.colorTextDisabled,
  backgroundColor: e.colorBgContainerDisabled,
  borderColor: e.colorBorder,
  boxShadow: "none",
  cursor: "not-allowed",
  opacity: 1,
  "input[disabled], textarea[disabled]": {
    cursor: "not-allowed"
  },
  "&:hover:not([disabled])": Object.assign({}, H1e($r(e, {
    hoverBorderColor: e.colorBorder,
    hoverBg: e.colorBgContainerDisabled
  })))
}), bI = (e, t) => ({
  background: e.colorBgContainer,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: t.borderColor,
  "&:hover": {
    borderColor: t.hoverBorderColor,
    backgroundColor: e.hoverBg
  },
  "&:focus, &:focus-within": {
    borderColor: t.activeBorderColor,
    boxShadow: t.activeShadow,
    outline: 0,
    backgroundColor: e.activeBg
  }
}), GN = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, bI(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  }),
  [`&${e.componentCls}-status-${t.status}${e.componentCls}-disabled`]: {
    borderColor: t.borderColor
  }
}), CI = (e, t) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, bI(e, {
    borderColor: e.colorBorder,
    hoverBorderColor: e.hoverBorderColor,
    activeBorderColor: e.activeBorderColor,
    activeShadow: e.activeShadow
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, q1(e))
  }), GN(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderColor: e.colorErrorBorderHover,
    activeBorderColor: e.colorError,
    activeShadow: e.errorActiveShadow,
    affixColor: e.colorError
  })), GN(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderColor: e.colorWarningBorderHover,
    activeBorderColor: e.colorWarning,
    activeShadow: e.warningActiveShadow,
    affixColor: e.colorWarning
  })), t)
}), UN = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      borderColor: t.addonBorderColor,
      color: t.addonColor
    }
  }
}), fG = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.addonBg,
        border: `${ve(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
      },
      "&-addon:first-child": {
        borderInlineEnd: 0
      },
      "&-addon:last-child": {
        borderInlineStart: 0
      }
    }
  }, UN(e, {
    status: "error",
    addonBorderColor: e.colorError,
    addonColor: e.colorErrorText
  })), UN(e, {
    status: "warning",
    addonBorderColor: e.colorWarning,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group-addon`]: Object.assign({}, q1(e))
    }
  })
}), SI = (e, t) => ({
  "&-borderless": Object.assign({
    background: "transparent",
    border: "none",
    "&:focus, &:focus-within": {
      outline: "none"
    },
    [`&${e.componentCls}-disabled, &[disabled]`]: {
      color: e.colorTextDisabled
    }
  }, t)
}), pG = (e, t) => ({
  background: t.bg,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: "transparent",
  "input&, & input, textarea&, & textarea": {
    color: t?.inputColor
  },
  "&:hover": {
    background: t.hoverBg
  },
  "&:focus, &:focus-within": {
    outline: 0,
    borderColor: t.activeBorderColor,
    backgroundColor: e.activeBg
  }
}), WN = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, pG(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  })
}), xI = (e, t) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, pG(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.colorPrimary
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, q1(e))
  }), WN(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    inputColor: e.colorErrorText,
    affixColor: e.colorError
  })), WN(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    inputColor: e.colorWarningText,
    affixColor: e.colorWarning
  })), t)
}), qN = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      background: t.addonBg,
      color: t.addonColor
    }
  }
}), mG = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.colorFillTertiary
      },
      [`${e.componentCls}-filled:not(:focus):not(:focus-within)`]: {
        "&:not(:first-child)": {
          borderInlineStart: `${ve(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
        },
        "&:not(:last-child)": {
          borderInlineEnd: `${ve(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
        }
      }
    }
  }, qN(e, {
    status: "error",
    addonBg: e.colorErrorBg,
    addonColor: e.colorErrorText
  })), qN(e, {
    status: "warning",
    addonBg: e.colorWarningBg,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group`]: {
        "&-addon": {
          background: e.colorFillTertiary,
          color: e.colorTextDisabled
        },
        "&-addon:first-child": {
          borderInlineStart: `${ve(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${ve(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${ve(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        "&-addon:last-child": {
          borderInlineEnd: `${ve(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${ve(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${ve(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        }
      }
    }
  })
}), $I = (e) => ({
  // Firefox
  "&::-moz-placeholder": {
    opacity: 1
  },
  "&::placeholder": {
    color: e,
    userSelect: "none"
    // https://github.com/ant-design/ant-design/pull/32639
  },
  "&:placeholder-shown": {
    textOverflow: "ellipsis"
  }
}), vG = (e) => {
  const {
    paddingBlockLG: t,
    lineHeightLG: r,
    borderRadiusLG: n,
    paddingInlineLG: a
  } = e;
  return {
    padding: `${ve(t)} ${ve(a)}`,
    fontSize: e.inputFontSizeLG,
    lineHeight: r,
    borderRadius: n
  };
}, _I = (e) => ({
  padding: `${ve(e.paddingBlockSM)} ${ve(e.paddingInlineSM)}`,
  fontSize: e.inputFontSizeSM,
  borderRadius: e.borderRadiusSM
}), $h = (e) => Object.assign(Object.assign({
  position: "relative",
  display: "inline-block",
  width: "100%",
  minWidth: 0,
  padding: `${ve(e.paddingBlock)} ${ve(e.paddingInline)}`,
  color: e.colorText,
  fontSize: e.inputFontSize,
  lineHeight: e.lineHeight,
  borderRadius: e.borderRadius,
  transition: `all ${e.motionDurationMid}`
}, $I(e.colorTextPlaceholder)), {
  // Reset height for `textarea`s
  "textarea&": {
    maxWidth: "100%",
    // prevent textarea resize from coming out of its container
    height: "auto",
    minHeight: e.controlHeight,
    lineHeight: e.lineHeight,
    verticalAlign: "bottom",
    transition: `all ${e.motionDurationSlow}, height 0s`,
    resize: "vertical"
  },
  // Size
  "&-lg": Object.assign({}, vG(e)),
  "&-sm": Object.assign({}, _I(e)),
  // RTL
  "&-rtl, &-textarea-rtl": {
    direction: "rtl"
  }
}), hG = (e) => {
  const {
    componentCls: t,
    antCls: r
  } = e;
  return {
    position: "relative",
    display: "table",
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    // Undo padding and float of grid classes
    "&[class*='col-']": {
      paddingInlineEnd: e.paddingXS,
      "&:last-child": {
        paddingInlineEnd: 0
      }
    },
    // Sizing options
    [`&-lg ${t}, &-lg > ${t}-group-addon`]: Object.assign({}, vG(e)),
    [`&-sm ${t}, &-sm > ${t}-group-addon`]: Object.assign({}, _I(e)),
    // Fix https://github.com/ant-design/ant-design/issues/5754
    [`&-lg ${r}-select-single ${r}-select-selector`]: {
      height: e.controlHeightLG
    },
    [`&-sm ${r}-select-single ${r}-select-selector`]: {
      height: e.controlHeightSM
    },
    [`> ${t}`]: {
      display: "table-cell",
      "&:not(:first-child):not(:last-child)": {
        borderRadius: 0
      }
    },
    [`${t}-group`]: {
      "&-addon, &-wrap": {
        display: "table-cell",
        width: 1,
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        "&:not(:first-child):not(:last-child)": {
          borderRadius: 0
        }
      },
      "&-wrap > *": {
        display: "block !important"
      },
      "&-addon": {
        position: "relative",
        padding: `0 ${ve(e.paddingInline)}`,
        color: e.colorText,
        fontWeight: "normal",
        fontSize: e.inputFontSize,
        textAlign: "center",
        borderRadius: e.borderRadius,
        transition: `all ${e.motionDurationSlow}`,
        lineHeight: 1,
        // Reset Select's style in addon
        [`${r}-select`]: {
          margin: `${ve(e.calc(e.paddingBlock).add(1).mul(-1).equal())} ${ve(e.calc(e.paddingInline).mul(-1).equal())}`,
          [`&${r}-select-single:not(${r}-select-customize-input):not(${r}-pagination-size-changer)`]: {
            [`${r}-select-selector`]: {
              backgroundColor: "inherit",
              border: `${ve(e.lineWidth)} ${e.lineType} transparent`,
              boxShadow: "none"
            }
          },
          "&-open, &-focused": {
            [`${r}-select-selector`]: {
              color: e.colorPrimary
            }
          }
        },
        // https://github.com/ant-design/ant-design/issues/31333
        [`${r}-cascader-picker`]: {
          margin: `-9px ${ve(e.calc(e.paddingInline).mul(-1).equal())}`,
          backgroundColor: "transparent",
          [`${r}-cascader-input`]: {
            textAlign: "start",
            border: 0,
            boxShadow: "none"
          }
        }
      }
    },
    [`${t}`]: {
      width: "100%",
      marginBottom: 0,
      textAlign: "inherit",
      "&:focus": {
        zIndex: 1,
        // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
        borderInlineEndWidth: 1
      },
      "&:hover": {
        zIndex: 1,
        borderInlineEndWidth: 1,
        [`${t}-search-with-button &`]: {
          zIndex: 0
        }
      }
    },
    // Reset rounded corners
    [`> ${t}:first-child, ${t}-group-addon:first-child`]: {
      borderStartEndRadius: 0,
      borderEndEndRadius: 0,
      // Reset Select's style in addon
      [`${r}-select ${r}-select-selector`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${t}-affix-wrapper`]: {
      [`&:not(:first-child) ${t}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      },
      [`&:not(:last-child) ${t}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${t}:last-child, ${t}-group-addon:last-child`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      // Reset Select's style in addon
      [`${r}-select ${r}-select-selector`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`${t}-affix-wrapper`]: {
      "&:not(:last-child)": {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0,
        [`${t}-search &`]: {
          borderStartStartRadius: e.borderRadius,
          borderEndStartRadius: e.borderRadius
        }
      },
      [`&:not(:first-child), ${t}-search &:not(:first-child)`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&${t}-group-compact`]: Object.assign(Object.assign({
      display: "block"
    }, Bs()), {
      [`${t}-group-addon, ${t}-group-wrap, > ${t}`]: {
        "&:not(:first-child):not(:last-child)": {
          borderInlineEndWidth: e.lineWidth,
          "&:hover, &:focus": {
            zIndex: 1
          }
        }
      },
      "& > *": {
        display: "inline-flex",
        float: "none",
        verticalAlign: "top",
        // https://github.com/ant-design/ant-design-pro/issues/139
        borderRadius: 0
      },
      [`
        & > ${t}-affix-wrapper,
        & > ${t}-number-affix-wrapper,
        & > ${r}-picker-range
      `]: {
        display: "inline-flex"
      },
      "& > *:not(:last-child)": {
        marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal(),
        borderInlineEndWidth: e.lineWidth
      },
      // Undo float for .ant-input-group .ant-input
      [`${t}`]: {
        float: "none"
      },
      // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
      [`& > ${r}-select > ${r}-select-selector,
      & > ${r}-select-auto-complete ${t},
      & > ${r}-cascader-picker ${t},
      & > ${t}-group-wrapper ${t}`]: {
        borderInlineEndWidth: e.lineWidth,
        borderRadius: 0,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      [`& > ${r}-select-focused`]: {
        zIndex: 1
      },
      // update z-index for arrow icon
      [`& > ${r}-select > ${r}-select-arrow`]: {
        zIndex: 1
        // https://github.com/ant-design/ant-design/issues/20371
      },
      [`& > *:first-child,
      & > ${r}-select:first-child > ${r}-select-selector,
      & > ${r}-select-auto-complete:first-child ${t},
      & > ${r}-cascader-picker:first-child ${t}`]: {
        borderStartStartRadius: e.borderRadius,
        borderEndStartRadius: e.borderRadius
      },
      [`& > *:last-child,
      & > ${r}-select:last-child > ${r}-select-selector,
      & > ${r}-cascader-picker:last-child ${t},
      & > ${r}-cascader-picker-focused:last-child ${t}`]: {
        borderInlineEndWidth: e.lineWidth,
        borderStartEndRadius: e.borderRadius,
        borderEndEndRadius: e.borderRadius
      },
      // https://github.com/ant-design/ant-design/issues/12493
      [`& > ${r}-select-auto-complete ${t}`]: {
        verticalAlign: "top"
      },
      [`${t}-group-wrapper + ${t}-group-wrapper`]: {
        marginInlineStart: e.calc(e.lineWidth).mul(-1).equal(),
        [`${t}-affix-wrapper`]: {
          borderRadius: 0
        }
      },
      [`${t}-group-wrapper:not(:last-child)`]: {
        [`&${t}-search > ${t}-group`]: {
          [`& > ${t}-group-addon > ${t}-search-button`]: {
            borderRadius: 0
          },
          [`& > ${t}`]: {
            borderStartStartRadius: e.borderRadius,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            borderEndStartRadius: e.borderRadius
          }
        }
      }
    })
  };
}, V1e = (e) => {
  const {
    componentCls: t,
    controlHeightSM: r,
    lineWidth: n,
    calc: a
  } = e, o = a(r).sub(a(n).mul(2)).sub(16).div(2).equal();
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Yr(e)), $h(e)), CI(e)), xI(e)), SI(e)), {
      '&[type="color"]': {
        height: e.controlHeight,
        [`&${t}-lg`]: {
          height: e.controlHeightLG
        },
        [`&${t}-sm`]: {
          height: r,
          paddingTop: o,
          paddingBottom: o
        }
      },
      '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
        "-webkit-appearance": "none"
      }
    })
  };
}, G1e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // ========================= Input =========================
    [`${t}-clear-icon`]: {
      margin: 0,
      color: e.colorTextQuaternary,
      fontSize: e.fontSizeIcon,
      verticalAlign: -1,
      // https://github.com/ant-design/ant-design/pull/18151
      // https://codesandbox.io/s/wizardly-sun-u10br
      cursor: "pointer",
      transition: `color ${e.motionDurationSlow}`,
      "&:hover": {
        color: e.colorTextTertiary
      },
      "&:active": {
        color: e.colorText
      },
      "&-hidden": {
        visibility: "hidden"
      },
      "&-has-suffix": {
        margin: `0 ${ve(e.inputAffixPadding)}`
      }
    }
  };
}, U1e = (e) => {
  const {
    componentCls: t,
    inputAffixPadding: r,
    colorTextDescription: n,
    motionDurationSlow: a,
    colorIcon: i,
    colorIconHover: o,
    iconCls: s
  } = e;
  return {
    [`${t}-affix-wrapper`]: Object.assign(Object.assign(Object.assign(Object.assign({}, $h(e)), {
      display: "inline-flex",
      [`&:not(${t}-disabled):hover`]: {
        zIndex: 1,
        [`${t}-search-with-button &`]: {
          zIndex: 0
        }
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      [`> input${t}`]: {
        padding: 0
      },
      [`> input${t}, > textarea${t}`]: {
        fontSize: "inherit",
        border: "none",
        borderRadius: 0,
        outline: "none",
        background: "transparent",
        color: "inherit",
        "&::-ms-reveal": {
          display: "none"
        },
        "&:focus": {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [`${t}`]: {
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          "> *:not(:last-child)": {
            marginInlineEnd: e.paddingXS
          }
        },
        "&-show-count-suffix": {
          color: n
        },
        "&-show-count-has-suffix": {
          marginInlineEnd: e.paddingXXS
        },
        "&-prefix": {
          marginInlineEnd: r
        },
        "&-suffix": {
          marginInlineStart: r
        }
      }
    }), G1e(e)), {
      // password
      [`${s}${t}-password-icon`]: {
        color: i,
        cursor: "pointer",
        transition: `all ${a}`,
        "&:hover": {
          color: o
        }
      }
    })
  };
}, W1e = (e) => {
  const {
    componentCls: t,
    borderRadiusLG: r,
    borderRadiusSM: n
  } = e;
  return {
    [`${t}-group`]: Object.assign(Object.assign(Object.assign({}, Yr(e)), hG(e)), {
      "&-rtl": {
        direction: "rtl"
      },
      "&-wrapper": Object.assign(Object.assign(Object.assign({
        display: "inline-block",
        width: "100%",
        textAlign: "start",
        verticalAlign: "top",
        "&-rtl": {
          direction: "rtl"
        },
        // Size
        "&-lg": {
          [`${t}-group-addon`]: {
            borderRadius: r,
            fontSize: e.inputFontSizeLG
          }
        },
        "&-sm": {
          [`${t}-group-addon`]: {
            borderRadius: n
          }
        }
      }, fG(e)), mG(e)), {
        // '&-disabled': {
        //   [`${componentCls}-group-addon`]: {
        //     ...genDisabledStyle(token),
        //   },
        // },
        // Fix the issue of using icons in Space Compact mode
        // https://github.com/ant-design/ant-design/issues/42122
        [`&:not(${t}-compact-first-item):not(${t}-compact-last-item)${t}-compact-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderRadius: 0
          }
        },
        [`&:not(${t}-compact-last-item)${t}-compact-first-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        [`&:not(${t}-compact-first-item)${t}-compact-last-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        },
        // Fix the issue of input use show-count param in space compact mode
        // https://github.com/ant-design/ant-design/issues/46872
        [`&:not(${t}-compact-last-item)${t}-compact-item`]: {
          [`${t}-affix-wrapper`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        }
      })
    })
  };
}, q1e = (e) => {
  const {
    componentCls: t,
    antCls: r
  } = e, n = `${t}-search`;
  return {
    [n]: {
      [`${t}`]: {
        "&:hover, &:focus": {
          borderColor: e.colorPrimaryHover,
          [`+ ${t}-group-addon ${n}-button:not(${r}-btn-primary)`]: {
            borderInlineStartColor: e.colorPrimaryHover
          }
        }
      },
      [`${t}-affix-wrapper`]: {
        borderRadius: 0
      },
      // fix slight height diff in Firefox:
      // https://ant.design/components/auto-complete-cn/#components-auto-complete-demo-certain-category
      [`${t}-lg`]: {
        lineHeight: e.calc(e.lineHeightLG).sub(2e-4).equal()
      },
      [`> ${t}-group`]: {
        [`> ${t}-group-addon:last-child`]: {
          insetInlineStart: -1,
          padding: 0,
          border: 0,
          [`${n}-button`]: {
            // Fix https://github.com/ant-design/ant-design/issues/47150
            marginInlineEnd: -1,
            paddingTop: 0,
            paddingBottom: 0,
            borderStartStartRadius: 0,
            borderStartEndRadius: e.borderRadius,
            borderEndEndRadius: e.borderRadius,
            borderEndStartRadius: 0,
            boxShadow: "none"
          },
          [`${n}-button:not(${r}-btn-primary)`]: {
            color: e.colorTextDescription,
            "&:hover": {
              color: e.colorPrimaryHover
            },
            "&:active": {
              color: e.colorPrimaryActive
            },
            [`&${r}-btn-loading::before`]: {
              insetInlineStart: 0,
              insetInlineEnd: 0,
              insetBlockStart: 0,
              insetBlockEnd: 0
            }
          }
        }
      },
      [`${n}-button`]: {
        height: e.controlHeight,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      [`&-large ${n}-button`]: {
        height: e.controlHeightLG
      },
      [`&-small ${n}-button`]: {
        height: e.controlHeightSM
      },
      "&-rtl": {
        direction: "rtl"
      },
      // ===================== Compact Item Customized Styles =====================
      [`&${t}-compact-item`]: {
        [`&:not(${t}-compact-last-item)`]: {
          [`${t}-group-addon`]: {
            [`${t}-search-button`]: {
              marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal(),
              borderRadius: 0
            }
          }
        },
        [`&:not(${t}-compact-first-item)`]: {
          [`${t},${t}-affix-wrapper`]: {
            borderRadius: 0
          }
        },
        [`> ${t}-group-addon ${t}-search-button,
        > ${t},
        ${t}-affix-wrapper`]: {
          "&:hover, &:focus, &:active": {
            zIndex: 2
          }
        },
        [`> ${t}-affix-wrapper-focused`]: {
          zIndex: 2
        }
      }
    }
  };
}, K1e = (e) => {
  const {
    componentCls: t,
    paddingLG: r
  } = e, n = `${t}-textarea`;
  return {
    [n]: {
      position: "relative",
      "&-show-count": {
        // https://github.com/ant-design/ant-design/issues/33049
        [`> ${t}`]: {
          height: "100%"
        },
        [`${t}-data-count`]: {
          position: "absolute",
          bottom: e.calc(e.fontSize).mul(e.lineHeight).mul(-1).equal(),
          insetInlineEnd: 0,
          color: e.colorTextDescription,
          whiteSpace: "nowrap",
          pointerEvents: "none"
        }
      },
      [`
        &-allow-clear > ${t},
        &-affix-wrapper${n}-has-feedback ${t}
      `]: {
        paddingInlineEnd: r
      },
      [`&-affix-wrapper${t}-affix-wrapper`]: {
        padding: 0,
        [`> textarea${t}`]: {
          fontSize: "inherit",
          border: "none",
          outline: "none",
          background: "transparent",
          "&:focus": {
            boxShadow: "none !important"
          }
        },
        [`${t}-suffix`]: {
          margin: 0,
          "> *:not(:last-child)": {
            marginInline: 0
          },
          // Clear Icon
          [`${t}-clear-icon`]: {
            position: "absolute",
            insetInlineEnd: e.paddingXS,
            insetBlockStart: e.paddingXS
          },
          // Feedback Icon
          [`${n}-suffix`]: {
            position: "absolute",
            top: 0,
            insetInlineEnd: e.paddingInline,
            bottom: 0,
            zIndex: 1,
            display: "inline-flex",
            alignItems: "center",
            margin: "auto",
            pointerEvents: "none"
          }
        }
      }
    }
  };
}, Y1e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-out-of-range`]: {
      [`&, & input, & textarea, ${t}-show-count-suffix, ${t}-data-count`]: {
        color: e.colorError
      }
    }
  };
}, EI = Zr("Input", (e) => {
  const t = $r(e, Sh(e));
  return [
    V1e(t),
    K1e(t),
    U1e(t),
    W1e(t),
    q1e(t),
    Y1e(t),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    uh(t)
  ];
}, xh, {
  resetFont: !1
}), Ex = (e, t) => {
  const {
    componentCls: r,
    controlHeight: n
  } = e, a = t ? `${r}-${t}` : "", i = kH(e);
  return [
    // genSelectionStyle(token, suffix),
    {
      [`${r}-multiple${a}`]: {
        paddingBlock: i.containerPadding,
        paddingInlineStart: i.basePadding,
        minHeight: n,
        // ======================== Selections ========================
        [`${r}-selection-item`]: {
          height: i.itemHeight,
          lineHeight: ve(i.itemLineHeight)
        }
      }
    }
  ];
}, Z1e = (e) => {
  const {
    componentCls: t,
    calc: r,
    lineWidth: n
  } = e, a = $r(e, {
    fontHeight: e.fontSize,
    selectHeight: e.controlHeightSM,
    multipleSelectItemHeight: e.multipleItemHeightSM,
    borderRadius: e.borderRadiusSM,
    borderRadiusSM: e.borderRadiusXS,
    controlHeight: e.controlHeightSM
  }), i = $r(e, {
    fontHeight: r(e.multipleItemHeightLG).sub(r(n).mul(2).equal()).equal(),
    fontSize: e.fontSizeLG,
    selectHeight: e.controlHeightLG,
    multipleSelectItemHeight: e.multipleItemHeightLG,
    borderRadius: e.borderRadiusLG,
    borderRadiusSM: e.borderRadius,
    controlHeight: e.controlHeightLG
  });
  return [
    // ======================== Size ========================
    Ex(a, "small"),
    Ex(e),
    Ex(i, "large"),
    // ====================== Selection ======================
    {
      [`${t}${t}-multiple`]: Object.assign(Object.assign({
        width: "100%",
        cursor: "text",
        // ==================== Selector =====================
        [`${t}-selector`]: {
          flex: "auto",
          padding: 0,
          position: "relative",
          "&:after": {
            margin: 0
          },
          // ================== placeholder ==================
          [`${t}-selection-placeholder`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: e.inputPaddingHorizontalBase,
            insetInlineEnd: 0,
            transform: "translateY(-50%)",
            transition: `all ${e.motionDurationSlow}`,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            flex: 1,
            color: e.colorTextPlaceholder,
            pointerEvents: "none"
          }
        }
      }, FH(e)), {
        // ====================== Input ======================
        // Input is `readonly`, which is used for a11y only
        [`${t}-multiple-input`]: {
          width: 0,
          height: 0,
          border: 0,
          visibility: "hidden",
          position: "absolute",
          zIndex: -1
        }
      })
    }
  ];
}, X1e = (e) => {
  const {
    pickerCellCls: t,
    pickerCellInnerCls: r,
    cellHeight: n,
    borderRadiusSM: a,
    motionDurationMid: i,
    cellHoverBg: o,
    lineWidth: s,
    lineType: l,
    colorPrimary: c,
    cellActiveWithRangeBg: u,
    colorTextLightSolid: d,
    colorTextDisabled: f,
    cellBgDisabled: m,
    colorFillSecondary: h
  } = e;
  return {
    "&::before": {
      position: "absolute",
      top: "50%",
      insetInlineStart: 0,
      insetInlineEnd: 0,
      zIndex: 1,
      height: n,
      transform: "translateY(-50%)",
      content: '""'
    },
    // >>> Default
    [r]: {
      position: "relative",
      zIndex: 2,
      display: "inline-block",
      minWidth: n,
      height: n,
      lineHeight: ve(n),
      borderRadius: a,
      transition: `background ${i}`
    },
    // >>> Hover
    [`&:hover:not(${t}-in-view),
    &:hover:not(${t}-selected):not(${t}-range-start):not(${t}-range-end)`]: {
      [r]: {
        background: o
      }
    },
    // >>> Today
    [`&-in-view${t}-today ${r}`]: {
      "&::before": {
        position: "absolute",
        top: 0,
        insetInlineEnd: 0,
        bottom: 0,
        insetInlineStart: 0,
        zIndex: 1,
        border: `${ve(s)} ${l} ${c}`,
        borderRadius: a,
        content: '""'
      }
    },
    // >>> In Range
    [`&-in-view${t}-in-range,
      &-in-view${t}-range-start,
      &-in-view${t}-range-end`]: {
      position: "relative",
      [`&:not(${t}-disabled):before`]: {
        background: u
      }
    },
    // >>> Selected
    [`&-in-view${t}-selected,
      &-in-view${t}-range-start,
      &-in-view${t}-range-end`]: {
      [`&:not(${t}-disabled) ${r}`]: {
        color: d,
        background: c
      },
      [`&${t}-disabled ${r}`]: {
        background: h
      }
    },
    [`&-in-view${t}-range-start:not(${t}-disabled):before`]: {
      insetInlineStart: "50%"
    },
    [`&-in-view${t}-range-end:not(${t}-disabled):before`]: {
      insetInlineEnd: "50%"
    },
    // range start border-radius
    [`&-in-view${t}-range-start:not(${t}-range-end) ${r}`]: {
      borderStartStartRadius: a,
      borderEndStartRadius: a,
      borderStartEndRadius: 0,
      borderEndEndRadius: 0
    },
    // range end border-radius
    [`&-in-view${t}-range-end:not(${t}-range-start) ${r}`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      borderStartEndRadius: a,
      borderEndEndRadius: a
    },
    // >>> Disabled
    "&-disabled": {
      color: f,
      pointerEvents: "none",
      [r]: {
        background: "transparent"
      },
      "&::before": {
        background: m
      }
    },
    [`&-disabled${t}-today ${r}::before`]: {
      borderColor: f
    }
  };
}, J1e = (e) => {
  const {
    componentCls: t,
    pickerCellCls: r,
    pickerCellInnerCls: n,
    pickerYearMonthCellWidth: a,
    pickerControlIconSize: i,
    cellWidth: o,
    paddingSM: s,
    paddingXS: l,
    paddingXXS: c,
    colorBgContainer: u,
    lineWidth: d,
    lineType: f,
    borderRadiusLG: m,
    colorPrimary: h,
    colorTextHeading: g,
    colorSplit: y,
    pickerControlIconBorderWidth: S,
    colorIcon: x,
    textHeight: b,
    motionDurationMid: _,
    colorIconHover: $,
    fontWeightStrong: w,
    cellHeight: O,
    pickerCellPaddingVertical: T,
    colorTextDisabled: I,
    colorText: P,
    fontSize: D,
    motionDurationSlow: B,
    withoutTimeCellHeight: L,
    pickerQuarterPanelContentHeight: N,
    borderRadiusSM: z,
    colorTextLightSolid: F,
    cellHoverBg: j,
    timeColumnHeight: H,
    timeColumnWidth: U,
    timeCellHeight: G,
    controlItemBgActive: V,
    marginXXS: K,
    pickerDatePanelPaddingHorizontal: Z,
    pickerControlIconMargin: ee
  } = e, ae = e.calc(o).mul(7).add(e.calc(Z).mul(2)).equal();
  return {
    [t]: {
      "&-panel": {
        display: "inline-flex",
        flexDirection: "column",
        textAlign: "center",
        background: u,
        borderRadius: m,
        outline: "none",
        "&-focused": {
          borderColor: h
        },
        "&-rtl": {
          direction: "rtl",
          [`${t}-prev-icon,
              ${t}-super-prev-icon`]: {
            transform: "rotate(45deg)"
          },
          [`${t}-next-icon,
              ${t}-super-next-icon`]: {
            transform: "rotate(-135deg)"
          }
        }
      },
      // ========================================================
      // =                     Shared Panel                     =
      // ========================================================
      "&-decade-panel,\n        &-year-panel,\n        &-quarter-panel,\n        &-month-panel,\n        &-week-panel,\n        &-date-panel,\n        &-time-panel": {
        display: "flex",
        flexDirection: "column",
        width: ae
      },
      // ======================= Header =======================
      "&-header": {
        display: "flex",
        padding: `0 ${ve(l)}`,
        color: g,
        borderBottom: `${ve(d)} ${f} ${y}`,
        "> *": {
          flex: "none"
        },
        button: {
          padding: 0,
          color: x,
          lineHeight: ve(b),
          background: "transparent",
          border: 0,
          cursor: "pointer",
          transition: `color ${_}`,
          fontSize: "inherit",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center"
        },
        "> button": {
          minWidth: "1.6em",
          fontSize: D,
          "&:hover": {
            color: $
          },
          "&:disabled": {
            opacity: 0.25,
            pointerEvents: "none"
          }
        },
        "&-view": {
          flex: "auto",
          fontWeight: w,
          lineHeight: ve(b),
          "> button": {
            color: "inherit",
            fontWeight: "inherit",
            "&:not(:first-child)": {
              marginInlineStart: l
            },
            "&:hover": {
              color: h
            }
          }
        }
      },
      // Arrow button
      "&-prev-icon,\n        &-next-icon,\n        &-super-prev-icon,\n        &-super-next-icon": {
        position: "relative",
        width: i,
        height: i,
        "&::before": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          width: i,
          height: i,
          border: "0 solid currentcolor",
          borderBlockWidth: `${ve(S)} 0`,
          borderInlineWidth: `${ve(S)} 0`,
          content: '""'
        }
      },
      "&-super-prev-icon,\n        &-super-next-icon": {
        "&::after": {
          position: "absolute",
          top: ee,
          insetInlineStart: ee,
          display: "inline-block",
          width: i,
          height: i,
          border: "0 solid currentcolor",
          borderBlockWidth: `${ve(S)} 0`,
          borderInlineWidth: `${ve(S)} 0`,
          content: '""'
        }
      },
      "&-prev-icon,\n        &-super-prev-icon": {
        transform: "rotate(-45deg)"
      },
      "&-next-icon,\n        &-super-next-icon": {
        transform: "rotate(135deg)"
      },
      // ======================== Body ========================
      "&-content": {
        width: "100%",
        tableLayout: "fixed",
        borderCollapse: "collapse",
        "th, td": {
          position: "relative",
          minWidth: O,
          fontWeight: "normal"
        },
        th: {
          height: e.calc(O).add(e.calc(T).mul(2)).equal(),
          color: P,
          verticalAlign: "middle"
        }
      },
      "&-cell": Object.assign({
        padding: `${ve(T)} 0`,
        color: I,
        cursor: "pointer",
        // In view
        "&-in-view": {
          color: P
        }
      }, X1e(e)),
      "&-decade-panel,\n        &-year-panel,\n        &-quarter-panel,\n        &-month-panel": {
        [`${t}-content`]: {
          height: e.calc(L).mul(4).equal()
        },
        [n]: {
          padding: `0 ${ve(l)}`
        }
      },
      "&-quarter-panel": {
        [`${t}-content`]: {
          height: N
        }
      },
      // ========================================================
      // =                       Special                        =
      // ========================================================
      // ===================== Decade Panel =====================
      "&-decade-panel": {
        [n]: {
          padding: `0 ${ve(e.calc(l).div(2).equal())}`
        },
        [`${t}-cell::before`]: {
          display: "none"
        }
      },
      // ============= Year & Quarter & Month Panel =============
      "&-year-panel,\n        &-quarter-panel,\n        &-month-panel": {
        [`${t}-body`]: {
          padding: `0 ${ve(l)}`
        },
        [n]: {
          width: a
        }
      },
      // ====================== Date Panel ======================
      "&-date-panel": {
        [`${t}-body`]: {
          padding: `${ve(l)} ${ve(Z)}`
        },
        [`${t}-content th`]: {
          boxSizing: "border-box",
          padding: 0
        }
      },
      // ====================== Week Panel ======================
      "&-week-panel": {
        // Clear cell style
        [`${t}-cell`]: {
          [`&:hover ${n},
            &-selected ${n},
            ${n}`]: {
            background: "transparent !important"
          }
        },
        "&-row": {
          td: {
            "&:before": {
              transition: `background ${_}`
            },
            "&:first-child:before": {
              borderStartStartRadius: z,
              borderEndStartRadius: z
            },
            "&:last-child:before": {
              borderStartEndRadius: z,
              borderEndEndRadius: z
            }
          },
          "&:hover td": {
            "&:before": {
              background: j
            }
          },
          "&-range-start td,\n            &-range-end td,\n            &-selected td,\n            &-hover td": {
            // Rise priority to override hover style
            [`&${r}`]: {
              "&:before": {
                background: h
              },
              [`&${t}-cell-week`]: {
                color: new Br(F).setAlpha(0.5).toHexString()
              },
              [n]: {
                color: F
              }
            }
          },
          "&-range-hover td:before": {
            background: V
          }
        }
      },
      // >>> ShowWeek
      "&-week-panel, &-date-panel-show-week": {
        [`${t}-body`]: {
          padding: `${ve(l)} ${ve(s)}`
        },
        [`${t}-content th`]: {
          width: "auto"
        }
      },
      // ==================== Datetime Panel ====================
      "&-datetime-panel": {
        display: "flex",
        [`${t}-time-panel`]: {
          borderInlineStart: `${ve(d)} ${f} ${y}`
        },
        [`${t}-date-panel,
          ${t}-time-panel`]: {
          transition: `opacity ${B}`
        },
        // Keyboard
        "&-active": {
          [`${t}-date-panel,
            ${t}-time-panel`]: {
            opacity: 0.3,
            "&-active": {
              opacity: 1
            }
          }
        }
      },
      // ====================== Time Panel ======================
      "&-time-panel": {
        width: "auto",
        minWidth: "auto",
        direction: "ltr",
        [`${t}-content`]: {
          display: "flex",
          flex: "auto",
          height: H
        },
        "&-column": {
          flex: "1 0 auto",
          width: U,
          margin: `${ve(c)} 0`,
          padding: 0,
          overflowY: "hidden",
          textAlign: "start",
          listStyle: "none",
          transition: `background ${_}`,
          overflowX: "hidden",
          "&::-webkit-scrollbar": {
            width: 8,
            backgroundColor: "transparent"
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: e.colorTextTertiary,
            borderRadius: e.borderRadiusSM
          },
          // For Firefox
          "&": {
            scrollbarWidth: "thin",
            scrollbarColor: `${e.colorTextTertiary} transparent`
          },
          "&::after": {
            display: "block",
            height: e.calc("100%").sub(G).equal(),
            content: '""'
          },
          "&:not(:first-child)": {
            borderInlineStart: `${ve(d)} ${f} ${y}`
          },
          "&-active": {
            background: new Br(V).setAlpha(0.2).toHexString()
          },
          "&:hover": {
            overflowY: "auto"
          },
          "> li": {
            margin: 0,
            padding: 0,
            [`&${t}-time-panel-cell`]: {
              marginInline: K,
              [`${t}-time-panel-cell-inner`]: {
                display: "block",
                width: e.calc(U).sub(e.calc(K).mul(2)).equal(),
                height: G,
                margin: 0,
                paddingBlock: 0,
                paddingInlineEnd: 0,
                paddingInlineStart: e.calc(U).sub(G).div(2).equal(),
                color: P,
                lineHeight: ve(G),
                borderRadius: z,
                cursor: "pointer",
                transition: `background ${_}`,
                "&:hover": {
                  background: j
                }
              },
              "&-selected": {
                [`${t}-time-panel-cell-inner`]: {
                  background: V
                }
              },
              "&-disabled": {
                [`${t}-time-panel-cell-inner`]: {
                  color: I,
                  background: "transparent",
                  cursor: "not-allowed"
                }
              }
            }
          }
        }
      }
    }
  };
}, Q1e = (e) => {
  const {
    componentCls: t,
    textHeight: r,
    lineWidth: n,
    paddingSM: a,
    antCls: i,
    colorPrimary: o,
    cellActiveWithRangeBg: s,
    colorPrimaryBorder: l,
    lineType: c,
    colorSplit: u
  } = e;
  return {
    [`${t}-dropdown`]: {
      // ======================== Footer ========================
      [`${t}-footer`]: {
        borderTop: `${ve(n)} ${c} ${u}`,
        "&-extra": {
          padding: `0 ${ve(a)}`,
          lineHeight: ve(e.calc(r).sub(e.calc(n).mul(2)).equal()),
          textAlign: "start",
          "&:not(:last-child)": {
            borderBottom: `${ve(n)} ${c} ${u}`
          }
        }
      },
      // ==================== Footer > Ranges ===================
      [`${t}-panels + ${t}-footer ${t}-ranges`]: {
        justifyContent: "space-between"
      },
      [`${t}-ranges`]: {
        marginBlock: 0,
        paddingInline: ve(a),
        overflow: "hidden",
        textAlign: "start",
        listStyle: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "> li": {
          lineHeight: ve(e.calc(r).sub(e.calc(n).mul(2)).equal()),
          display: "inline-block"
        },
        [`${t}-now-btn-disabled`]: {
          pointerEvents: "none",
          color: e.colorTextDisabled
        },
        // https://github.com/ant-design/ant-design/issues/23687
        [`${t}-preset > ${i}-tag-blue`]: {
          color: o,
          background: s,
          borderColor: l,
          cursor: "pointer"
        },
        [`${t}-ok`]: {
          paddingBlock: e.calc(n).mul(2).equal(),
          marginInlineStart: "auto"
        }
      }
    }
  };
}, eCe = (e) => {
  const {
    componentCls: t,
    controlHeightLG: r,
    paddingXXS: n,
    padding: a
  } = e;
  return {
    pickerCellCls: `${t}-cell`,
    pickerCellInnerCls: `${t}-cell-inner`,
    pickerYearMonthCellWidth: e.calc(r).mul(1.5).equal(),
    pickerQuarterPanelContentHeight: e.calc(r).mul(1.4).equal(),
    pickerCellPaddingVertical: e.calc(n).add(e.calc(n).div(2)).equal(),
    pickerCellBorderGap: 2,
    // Magic for gap between cells
    pickerControlIconSize: 7,
    pickerControlIconMargin: 4,
    pickerControlIconBorderWidth: 1.5,
    pickerDatePanelPaddingHorizontal: e.calc(a).add(e.calc(n).div(2)).equal()
    // 18 in normal
  };
}, tCe = (e) => {
  const {
    colorBgContainerDisabled: t,
    controlHeight: r,
    controlHeightSM: n,
    controlHeightLG: a,
    paddingXXS: i,
    lineWidth: o
  } = e, s = i * 2, l = o * 2, c = Math.min(r - s, r - l), u = Math.min(n - s, n - l), d = Math.min(a - s, a - l);
  return {
    INTERNAL_FIXED_ITEM_MARGIN: Math.floor(i / 2),
    cellHoverBg: e.controlItemBgHover,
    cellActiveWithRangeBg: e.controlItemBgActive,
    cellHoverWithRangeBg: new Br(e.colorPrimary).lighten(35).toHexString(),
    cellRangeBorderColor: new Br(e.colorPrimary).lighten(20).toHexString(),
    cellBgDisabled: t,
    timeColumnWidth: a * 1.4,
    timeColumnHeight: 28 * 8,
    timeCellHeight: 28,
    cellWidth: n * 1.5,
    cellHeight: n,
    textHeight: a,
    withoutTimeCellHeight: a * 1.65,
    multipleItemBg: e.colorFillSecondary,
    multipleItemBorderColor: "transparent",
    multipleItemHeight: c,
    multipleItemHeightSM: u,
    multipleItemHeightLG: d,
    multipleSelectorBgDisabled: t,
    multipleItemColorDisabled: e.colorTextDisabled,
    multipleItemBorderColorDisabled: "transparent"
  };
}, rCe = (e) => Object.assign(Object.assign(Object.assign(Object.assign({}, xh(e)), tCe(e)), aI(e)), {
  presetsWidth: 120,
  presetsMaxWidth: 200,
  zIndexPopup: e.zIndexPopupBase + 50
}), nCe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: [
      Object.assign(Object.assign(Object.assign({}, CI(e)), xI(e)), SI(e)),
      // ========================= Multiple =========================
      {
        "&-outlined": {
          [`&${t}-multiple ${t}-selection-item`]: {
            background: e.multipleItemBg,
            border: `${ve(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
          }
        },
        "&-filled": {
          [`&${t}-multiple ${t}-selection-item`]: {
            background: e.colorBgContainer,
            border: `${ve(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
          }
        },
        "&-borderless": {
          [`&${t}-multiple ${t}-selection-item`]: {
            background: e.multipleItemBg,
            border: `${ve(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
          }
        }
      }
    ]
  };
}, wx = (e, t, r, n) => {
  const a = e.calc(r).add(2).equal(), i = e.max(e.calc(t).sub(a).div(2).equal(), 0), o = e.max(e.calc(t).sub(a).sub(i).equal(), 0);
  return {
    padding: `${ve(i)} ${ve(n)} ${ve(o)}`
  };
}, aCe = (e) => {
  const {
    componentCls: t,
    colorError: r,
    colorWarning: n
  } = e;
  return {
    [`${t}:not(${t}-disabled):not([disabled])`]: {
      [`&${t}-status-error`]: {
        [`${t}-active-bar`]: {
          background: r
        }
      },
      [`&${t}-status-warning`]: {
        [`${t}-active-bar`]: {
          background: n
        }
      }
    }
  };
}, iCe = (e) => {
  const {
    componentCls: t,
    antCls: r,
    controlHeight: n,
    paddingInline: a,
    lineWidth: i,
    lineType: o,
    colorBorder: s,
    borderRadius: l,
    motionDurationMid: c,
    colorTextDisabled: u,
    colorTextPlaceholder: d,
    controlHeightLG: f,
    fontSizeLG: m,
    controlHeightSM: h,
    paddingInlineSM: g,
    paddingXS: y,
    marginXS: S,
    colorTextDescription: x,
    lineWidthBold: b,
    colorPrimary: _,
    motionDurationSlow: $,
    zIndexPopup: w,
    paddingXXS: O,
    sizePopupArrow: T,
    colorBgElevated: I,
    borderRadiusLG: P,
    boxShadowSecondary: D,
    borderRadiusSM: B,
    colorSplit: L,
    cellHoverBg: N,
    presetsWidth: z,
    presetsMaxWidth: F,
    boxShadowPopoverArrow: j,
    fontHeight: H,
    fontHeightLG: U,
    lineHeightLG: G
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign(Object.assign({}, Yr(e)), wx(e, n, H, a)), {
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        lineHeight: 1,
        borderRadius: l,
        transition: `border ${c}, box-shadow ${c}, background ${c}`,
        // ======================== Input =========================
        [`${t}-input`]: {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          width: "100%",
          "> input": Object.assign(Object.assign({
            position: "relative",
            display: "inline-block",
            width: "100%",
            color: "inherit",
            fontSize: e.fontSize,
            lineHeight: e.lineHeight,
            transition: `all ${c}`
          }, $I(d)), {
            flex: "auto",
            // Fix Firefox flex not correct:
            // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
            minWidth: 1,
            height: "auto",
            padding: 0,
            background: "transparent",
            border: 0,
            fontFamily: "inherit",
            "&:focus": {
              boxShadow: "none",
              outline: 0
            },
            "&[disabled]": {
              background: "transparent",
              color: u,
              cursor: "not-allowed"
            }
          }),
          "&-placeholder": {
            "> input": {
              color: d
            }
          }
        },
        // Size
        "&-large": Object.assign(Object.assign({}, wx(e, f, U, a)), {
          [`${t}-input > input`]: {
            fontSize: m,
            lineHeight: G
          }
        }),
        "&-small": Object.assign({}, wx(e, h, H, g)),
        [`${t}-suffix`]: {
          display: "flex",
          flex: "none",
          alignSelf: "center",
          marginInlineStart: e.calc(y).div(2).equal(),
          color: u,
          lineHeight: 1,
          pointerEvents: "none",
          transition: `opacity ${c}, color ${c}`,
          "> *": {
            verticalAlign: "top",
            "&:not(:last-child)": {
              marginInlineEnd: S
            }
          }
        },
        [`${t}-clear`]: {
          position: "absolute",
          top: "50%",
          insetInlineEnd: 0,
          color: u,
          lineHeight: 1,
          transform: "translateY(-50%)",
          cursor: "pointer",
          opacity: 0,
          transition: `opacity ${c}, color ${c}`,
          "> *": {
            verticalAlign: "top"
          },
          "&:hover": {
            color: x
          }
        },
        "&:hover": {
          [`${t}-clear`]: {
            opacity: 1
          },
          // Should use the following selector, but since `:has` has poor compatibility,
          // we use `:not(:last-child)` instead, which may cause some problems in some cases.
          // [`${componentCls}-suffix:has(+ ${componentCls}-clear)`]: {
          [`${t}-suffix:not(:last-child)`]: {
            opacity: 0
          }
        },
        [`${t}-separator`]: {
          position: "relative",
          display: "inline-block",
          width: "1em",
          height: m,
          color: u,
          fontSize: m,
          verticalAlign: "top",
          cursor: "default",
          [`${t}-focused &`]: {
            color: x
          },
          [`${t}-range-separator &`]: {
            [`${t}-disabled &`]: {
              cursor: "not-allowed"
            }
          }
        },
        // ======================== Range =========================
        "&-range": {
          position: "relative",
          display: "inline-flex",
          // Active bar
          [`${t}-active-bar`]: {
            bottom: e.calc(i).mul(-1).equal(),
            height: b,
            background: _,
            opacity: 0,
            transition: `all ${$} ease-out`,
            pointerEvents: "none"
          },
          [`&${t}-focused`]: {
            [`${t}-active-bar`]: {
              opacity: 1
            }
          },
          [`${t}-range-separator`]: {
            alignItems: "center",
            padding: `0 ${ve(y)}`,
            lineHeight: 1
          }
        },
        // ======================== Clear =========================
        "&-range, &-multiple": {
          // Clear
          [`${t}-clear`]: {
            insetInlineEnd: a
          },
          [`&${t}-small`]: {
            [`${t}-clear`]: {
              insetInlineEnd: g
            }
          }
        },
        // ======================= Dropdown =======================
        "&-dropdown": Object.assign(Object.assign(Object.assign({}, Yr(e)), J1e(e)), {
          pointerEvents: "none",
          position: "absolute",
          // Fix incorrect position of picker popup
          // https://github.com/ant-design/ant-design/issues/35590
          top: -9999,
          left: {
            _skip_check_: !0,
            value: -9999
          },
          zIndex: w,
          [`&${t}-dropdown-hidden`]: {
            display: "none"
          },
          [`&${t}-dropdown-placement-bottomLeft`]: {
            [`${t}-range-arrow`]: {
              top: 0,
              display: "block",
              transform: "translateY(-100%)"
            }
          },
          [`&${t}-dropdown-placement-topLeft`]: {
            [`${t}-range-arrow`]: {
              bottom: 0,
              display: "block",
              transform: "translateY(100%) rotate(180deg)"
            }
          },
          [`&${r}-slide-up-enter${r}-slide-up-enter-active${t}-dropdown-placement-topLeft,
          &${r}-slide-up-enter${r}-slide-up-enter-active${t}-dropdown-placement-topRight,
          &${r}-slide-up-appear${r}-slide-up-appear-active${t}-dropdown-placement-topLeft,
          &${r}-slide-up-appear${r}-slide-up-appear-active${t}-dropdown-placement-topRight`]: {
            animationName: M1
          },
          [`&${r}-slide-up-enter${r}-slide-up-enter-active${t}-dropdown-placement-bottomLeft,
          &${r}-slide-up-enter${r}-slide-up-enter-active${t}-dropdown-placement-bottomRight,
          &${r}-slide-up-appear${r}-slide-up-appear-active${t}-dropdown-placement-bottomLeft,
          &${r}-slide-up-appear${r}-slide-up-appear-active${t}-dropdown-placement-bottomRight`]: {
            animationName: T1
          },
          // https://github.com/ant-design/ant-design/issues/48727
          [`&${r}-slide-up-leave ${t}-panel-container`]: {
            pointerEvents: "none"
          },
          [`&${r}-slide-up-leave${r}-slide-up-leave-active${t}-dropdown-placement-topLeft,
          &${r}-slide-up-leave${r}-slide-up-leave-active${t}-dropdown-placement-topRight`]: {
            animationName: A1
          },
          [`&${r}-slide-up-leave${r}-slide-up-leave-active${t}-dropdown-placement-bottomLeft,
          &${r}-slide-up-leave${r}-slide-up-leave-active${t}-dropdown-placement-bottomRight`]: {
            animationName: I1
          },
          // Time picker with additional style
          [`${t}-panel > ${t}-time-panel`]: {
            paddingTop: O
          },
          // ======================== Ranges ========================
          [`${t}-range-wrapper`]: {
            display: "flex",
            position: "relative"
          },
          [`${t}-range-arrow`]: Object.assign(Object.assign({
            position: "absolute",
            zIndex: 1,
            display: "none",
            paddingInline: e.calc(a).mul(1.5).equal(),
            boxSizing: "content-box",
            transition: `left ${$} ease-out`
          }, YH(e, I, j)), {
            "&:before": {
              insetInlineStart: e.calc(a).mul(1.5).equal()
            }
          }),
          [`${t}-panel-container`]: {
            overflow: "hidden",
            verticalAlign: "top",
            background: I,
            borderRadius: P,
            boxShadow: D,
            transition: `margin ${$}`,
            display: "inline-block",
            pointerEvents: "auto",
            // ======================== Layout ========================
            [`${t}-panel-layout`]: {
              display: "flex",
              flexWrap: "nowrap",
              alignItems: "stretch"
            },
            // ======================== Preset ========================
            [`${t}-presets`]: {
              display: "flex",
              flexDirection: "column",
              minWidth: z,
              maxWidth: F,
              ul: {
                height: 0,
                flex: "auto",
                listStyle: "none",
                overflow: "auto",
                margin: 0,
                padding: y,
                borderInlineEnd: `${ve(i)} ${o} ${L}`,
                li: Object.assign(Object.assign({}, cs), {
                  borderRadius: B,
                  paddingInline: y,
                  paddingBlock: e.calc(h).sub(H).div(2).equal(),
                  cursor: "pointer",
                  transition: `all ${$}`,
                  "+ li": {
                    marginTop: S
                  },
                  "&:hover": {
                    background: N
                  }
                })
              }
            },
            // ======================== Panels ========================
            [`${t}-panels`]: {
              display: "inline-flex",
              flexWrap: "nowrap",
              direction: "ltr",
              // [`${componentCls}-panel`]: {
              //   borderWidth: `0 0 ${unit(lineWidth)}`,
              // },
              "&:last-child": {
                [`${t}-panel`]: {
                  borderWidth: 0
                }
              }
            },
            [`${t}-panel`]: {
              verticalAlign: "top",
              background: "transparent",
              borderRadius: 0,
              borderWidth: 0,
              [`${t}-content,
            table`]: {
                textAlign: "center"
              },
              "&-focused": {
                borderColor: s
              }
            }
          }
        }),
        "&-dropdown-range": {
          padding: `${ve(e.calc(T).mul(2).div(3).equal())} 0`,
          "&-hidden": {
            display: "none"
          }
        },
        "&-rtl": {
          direction: "rtl",
          [`${t}-separator`]: {
            transform: "rotate(180deg)"
          },
          [`${t}-footer`]: {
            "&-extra": {
              direction: "rtl"
            }
          }
        }
      })
    },
    // Follow code may reuse in other components
    us(e, "slide-up"),
    us(e, "slide-down"),
    ld(e, "move-up"),
    ld(e, "move-down")
  ];
}, gG = Zr("DatePicker", (e) => {
  const t = $r(Sh(e), eCe(e), {
    inputPaddingHorizontalBase: e.calc(e.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: e.multipleItemHeight,
    selectHeight: e.controlHeight
  });
  return [
    Q1e(t),
    iCe(t),
    nCe(t),
    aCe(t),
    Z1e(t),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    uh(e, {
      focusElCls: `${e.componentCls}-focused`
    })
  ];
}, rCe);
var oCe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { tag: "path", attrs: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z" } }] }, name: "plus", theme: "outlined" }, sCe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: oCe
  }));
}, yG = /* @__PURE__ */ p.forwardRef(sCe);
process.env.NODE_ENV !== "production" && (yG.displayName = "PlusOutlined");
const K1 = /* @__PURE__ */ Ws(null);
var lCe = function(t) {
  var r = t.activeTabOffset, n = t.horizontal, a = t.rtl, i = t.indicator, o = i === void 0 ? {} : i, s = o.size, l = o.align, c = l === void 0 ? "center" : l, u = He(), d = ye(u, 2), f = d[0], m = d[1], h = ct(), g = xe.useCallback(function(S) {
    return typeof s == "function" ? s(S) : typeof s == "number" ? s : S;
  }, [s]);
  function y() {
    vr.cancel(h.current);
  }
  return St(function() {
    var S = {};
    if (r)
      if (n) {
        S.width = g(r.width);
        var x = a ? "right" : "left";
        c === "start" && (S[x] = r[x]), c === "center" && (S[x] = r[x] + r.width / 2, S.transform = a ? "translateX(50%)" : "translateX(-50%)"), c === "end" && (S[x] = r[x] + r.width, S.transform = "translateX(-100%)");
      } else
        S.height = g(r.height), c === "start" && (S.top = r.top), c === "center" && (S.top = r.top + r.height / 2, S.transform = "translateY(-50%)"), c === "end" && (S.top = r.top + r.height, S.transform = "translateY(-100%)");
    return y(), h.current = vr(function() {
      m(S);
    }), y;
  }, [r, n, a, c, g]), {
    style: f
  };
}, KN = {
  width: 0,
  height: 0,
  left: 0,
  top: 0
};
function cCe(e, t, r) {
  return dr(function() {
    for (var n, a = /* @__PURE__ */ new Map(), i = t.get((n = e[0]) === null || n === void 0 ? void 0 : n.key) || KN, o = i.left + i.width, s = 0; s < e.length; s += 1) {
      var l = e[s].key, c = t.get(l);
      if (!c) {
        var u;
        c = t.get((u = e[s - 1]) === null || u === void 0 ? void 0 : u.key) || KN;
      }
      var d = a.get(l) || ce({}, c);
      d.right = o - d.left - d.width, a.set(l, d);
    }
    return a;
  }, [e.map(function(n) {
    return n.key;
  }).join("_"), t, r]);
}
function YN(e, t) {
  var r = p.useRef(e), n = p.useState({}), a = ye(n, 2), i = a[1];
  function o(s) {
    var l = typeof s == "function" ? s(r.current) : s;
    l !== r.current && t(l, r.current), r.current = l, i({});
  }
  return [r.current, o];
}
var uCe = 0.1, ZN = 0.01, fb = 20, XN = Math.pow(0.995, fb);
function dCe(e, t) {
  var r = He(), n = ye(r, 2), a = n[0], i = n[1], o = He(0), s = ye(o, 2), l = s[0], c = s[1], u = He(0), d = ye(u, 2), f = d[0], m = d[1], h = He(), g = ye(h, 2), y = g[0], S = g[1], x = ct();
  function b(I) {
    var P = I.touches[0], D = P.screenX, B = P.screenY;
    i({
      x: D,
      y: B
    }), window.clearInterval(x.current);
  }
  function _(I) {
    if (a) {
      I.preventDefault();
      var P = I.touches[0], D = P.screenX, B = P.screenY;
      i({
        x: D,
        y: B
      });
      var L = D - a.x, N = B - a.y;
      t(L, N);
      var z = Date.now();
      c(z), m(z - l), S({
        x: L,
        y: N
      });
    }
  }
  function $() {
    if (a && (i(null), S(null), y)) {
      var I = y.x / f, P = y.y / f, D = Math.abs(I), B = Math.abs(P);
      if (Math.max(D, B) < uCe) return;
      var L = I, N = P;
      x.current = window.setInterval(function() {
        if (Math.abs(L) < ZN && Math.abs(N) < ZN) {
          window.clearInterval(x.current);
          return;
        }
        L *= XN, N *= XN, t(L * fb, N * fb);
      }, fb);
    }
  }
  var w = ct();
  function O(I) {
    var P = I.deltaX, D = I.deltaY, B = 0, L = Math.abs(P), N = Math.abs(D);
    L === N ? B = w.current === "x" ? P : D : L > N ? (B = P, w.current = "x") : (B = D, w.current = "y"), t(-B, -B) && I.preventDefault();
  }
  var T = ct(null);
  T.current = {
    onTouchStart: b,
    onTouchMove: _,
    onTouchEnd: $,
    onWheel: O
  }, p.useEffect(function() {
    function I(L) {
      T.current.onTouchStart(L);
    }
    function P(L) {
      T.current.onTouchMove(L);
    }
    function D(L) {
      T.current.onTouchEnd(L);
    }
    function B(L) {
      T.current.onWheel(L);
    }
    return document.addEventListener("touchmove", P, {
      passive: !1
    }), document.addEventListener("touchend", D, {
      passive: !0
    }), e.current.addEventListener("touchstart", I, {
      passive: !0
    }), e.current.addEventListener("wheel", B, {
      passive: !1
    }), function() {
      document.removeEventListener("touchmove", P), document.removeEventListener("touchend", D);
    };
  }, []);
}
function bG(e) {
  var t = He(0), r = ye(t, 2), n = r[0], a = r[1], i = ct(0), o = ct();
  return o.current = e, vc(function() {
    var s;
    (s = o.current) === null || s === void 0 || s.call(o);
  }, [n]), function() {
    i.current === n && (i.current += 1, a(i.current));
  };
}
function fCe(e) {
  var t = ct([]), r = He({}), n = ye(r, 2), a = n[1], i = ct(typeof e == "function" ? e() : e), o = bG(function() {
    var l = i.current;
    t.current.forEach(function(c) {
      l = c(l);
    }), t.current = [], i.current = l, a({});
  });
  function s(l) {
    t.current.push(l), o();
  }
  return [i.current, s];
}
var JN = {
  width: 0,
  height: 0,
  left: 0,
  top: 0,
  right: 0
};
function pCe(e, t, r, n, a, i, o) {
  var s = o.tabs, l = o.tabPosition, c = o.rtl, u, d, f;
  return ["top", "bottom"].includes(l) ? (u = "width", d = c ? "right" : "left", f = Math.abs(r)) : (u = "height", d = "top", f = -r), dr(function() {
    if (!s.length)
      return [0, 0];
    for (var m = s.length, h = m, g = 0; g < m; g += 1) {
      var y = e.get(s[g].key) || JN;
      if (y[d] + y[u] > f + t) {
        h = g - 1;
        break;
      }
    }
    for (var S = 0, x = m - 1; x >= 0; x -= 1) {
      var b = e.get(s[x].key) || JN;
      if (b[d] < f) {
        S = x + 1;
        break;
      }
    }
    return S >= h ? [0, 0] : [S, h];
  }, [e, t, n, a, i, f, l, s.map(function(m) {
    return m.key;
  }).join("_"), c]);
}
function QN(e) {
  var t;
  return e instanceof Map ? (t = {}, e.forEach(function(r, n) {
    t[n] = r;
  })) : t = e, JSON.stringify(t);
}
var mCe = "TABS_DQ";
function CG(e) {
  return String(e).replace(/"/g, mCe);
}
function SG(e, t, r, n) {
  return (
    // Only editable tabs can be removed
    !(!r || // Tabs cannot be removed when disabled
    n || // closable is false
    e === !1 || // If closable is undefined, the remove button should be hidden when closeIcon is null or false
    e === void 0 && (t === !1 || t === null))
  );
}
var xG = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.editable, a = e.locale, i = e.style;
  return !n || n.showAdd === !1 ? null : /* @__PURE__ */ p.createElement("button", {
    ref: t,
    type: "button",
    className: "".concat(r, "-nav-add"),
    style: i,
    "aria-label": a?.addAriaLabel || "Add tab",
    onClick: function(s) {
      n.onEdit("add", {
        event: s
      });
    }
  }, n.addIcon || "+");
}), iE = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.position, n = e.prefixCls, a = e.extra;
  if (!a)
    return null;
  var i, o = {};
  return kt(a) === "object" && !/* @__PURE__ */ p.isValidElement(a) ? o = a : o.right = a, r === "right" && (i = o.right), r === "left" && (i = o.left), i ? /* @__PURE__ */ p.createElement("div", {
    className: "".concat(n, "-extra-content"),
    ref: t
  }, i) : null;
});
process.env.NODE_ENV !== "production" && (iE.displayName = "ExtraContent");
var vCe = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.id, a = e.tabs, i = e.locale, o = e.mobile, s = e.more, l = s === void 0 ? {} : s, c = e.style, u = e.className, d = e.editable, f = e.tabBarGutter, m = e.rtl, h = e.removeAriaLabel, g = e.onTabClick, y = e.getPopupContainer, S = e.popupClassName, x = He(!1), b = ye(x, 2), _ = b[0], $ = b[1], w = He(null), O = ye(w, 2), T = O[0], I = O[1], P = l.icon, D = P === void 0 ? "More" : P, B = "".concat(n, "-more-popup"), L = "".concat(r, "-dropdown"), N = T !== null ? "".concat(B, "-").concat(T) : null, z = i?.dropdownAriaLabel;
  function F(Z, ee) {
    Z.preventDefault(), Z.stopPropagation(), d.onEdit("remove", {
      key: ee,
      event: Z
    });
  }
  var j = /* @__PURE__ */ p.createElement(_d, {
    onClick: function(ee) {
      var ae = ee.key, ue = ee.domEvent;
      g(ae, ue), $(!1);
    },
    prefixCls: "".concat(L, "-menu"),
    id: B,
    tabIndex: -1,
    role: "listbox",
    "aria-activedescendant": N,
    selectedKeys: [T],
    "aria-label": z !== void 0 ? z : "expanded dropdown"
  }, a.map(function(Z) {
    var ee = Z.closable, ae = Z.disabled, ue = Z.closeIcon, re = Z.key, oe = Z.label, fe = SG(ee, ue, d, ae);
    return /* @__PURE__ */ p.createElement(gh, {
      key: re,
      id: "".concat(B, "-").concat(re),
      role: "option",
      "aria-controls": n && "".concat(n, "-panel-").concat(re),
      disabled: ae
    }, /* @__PURE__ */ p.createElement("span", null, oe), fe && /* @__PURE__ */ p.createElement("button", {
      type: "button",
      "aria-label": h || "remove",
      tabIndex: 0,
      className: "".concat(L, "-menu-item-remove"),
      onClick: function(se) {
        se.stopPropagation(), F(se, re);
      }
    }, ue || d.removeIcon || "×"));
  }));
  function H(Z) {
    for (var ee = a.filter(function(fe) {
      return !fe.disabled;
    }), ae = ee.findIndex(function(fe) {
      return fe.key === T;
    }) || 0, ue = ee.length, re = 0; re < ue; re += 1) {
      ae = (ae + Z + ue) % ue;
      var oe = ee[ae];
      if (!oe.disabled) {
        I(oe.key);
        return;
      }
    }
  }
  function U(Z) {
    var ee = Z.which;
    if (!_) {
      [Mt.DOWN, Mt.SPACE, Mt.ENTER].includes(ee) && ($(!0), Z.preventDefault());
      return;
    }
    switch (ee) {
      case Mt.UP:
        H(-1), Z.preventDefault();
        break;
      case Mt.DOWN:
        H(1), Z.preventDefault();
        break;
      case Mt.ESC:
        $(!1);
        break;
      case Mt.SPACE:
      case Mt.ENTER:
        T !== null && g(T, Z);
        break;
    }
  }
  St(function() {
    var Z = document.getElementById(N);
    Z && Z.scrollIntoView && Z.scrollIntoView(!1);
  }, [T]), St(function() {
    _ || I(null);
  }, [_]);
  var G = te({}, m ? "marginRight" : "marginLeft", f);
  a.length || (G.visibility = "hidden", G.order = 1);
  var V = be(te({}, "".concat(L, "-rtl"), m)), K = o ? null : /* @__PURE__ */ p.createElement(rV, Pe({
    prefixCls: L,
    overlay: j,
    visible: a.length ? _ : !1,
    onVisibleChange: $,
    overlayClassName: be(V, S),
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    getPopupContainer: y
  }, l), /* @__PURE__ */ p.createElement("button", {
    type: "button",
    className: "".concat(r, "-nav-more"),
    style: G,
    tabIndex: -1,
    "aria-hidden": "true",
    "aria-haspopup": "listbox",
    "aria-controls": B,
    id: "".concat(n, "-more"),
    "aria-expanded": _,
    onKeyDown: U
  }, D));
  return /* @__PURE__ */ p.createElement("div", {
    className: be("".concat(r, "-nav-operations"), u),
    style: c,
    ref: t
  }, K, /* @__PURE__ */ p.createElement(xG, {
    prefixCls: r,
    locale: i,
    editable: d
  }));
});
const hCe = /* @__PURE__ */ p.memo(vCe, function(e, t) {
  return (
    // https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    t.tabMoving
  );
});
var gCe = function(t) {
  var r = t.prefixCls, n = t.id, a = t.active, i = t.tab, o = i.key, s = i.label, l = i.disabled, c = i.closeIcon, u = i.icon, d = t.closable, f = t.renderWrapper, m = t.removeAriaLabel, h = t.editable, g = t.onClick, y = t.onFocus, S = t.style, x = "".concat(r, "-tab"), b = SG(d, c, h, l);
  function _(T) {
    l || g(T);
  }
  function $(T) {
    T.preventDefault(), T.stopPropagation(), h.onEdit("remove", {
      key: o,
      event: T
    });
  }
  var w = p.useMemo(function() {
    return u && typeof s == "string" ? /* @__PURE__ */ p.createElement("span", null, s) : s;
  }, [s, u]), O = /* @__PURE__ */ p.createElement("div", {
    key: o,
    "data-node-key": CG(o),
    className: be(x, te(te(te({}, "".concat(x, "-with-remove"), b), "".concat(x, "-active"), a), "".concat(x, "-disabled"), l)),
    style: S,
    onClick: _
  }, /* @__PURE__ */ p.createElement("div", {
    role: "tab",
    "aria-selected": a,
    id: n && "".concat(n, "-tab-").concat(o),
    className: "".concat(x, "-btn"),
    "aria-controls": n && "".concat(n, "-panel-").concat(o),
    "aria-disabled": l,
    tabIndex: l ? null : 0,
    onClick: function(I) {
      I.stopPropagation(), _(I);
    },
    onKeyDown: function(I) {
      [Mt.SPACE, Mt.ENTER].includes(I.which) && (I.preventDefault(), _(I));
    },
    onFocus: y
  }, u && /* @__PURE__ */ p.createElement("span", {
    className: "".concat(x, "-icon")
  }, u), s && w), b && /* @__PURE__ */ p.createElement("button", {
    type: "button",
    "aria-label": m || "remove",
    tabIndex: 0,
    className: "".concat(x, "-remove"),
    onClick: function(I) {
      I.stopPropagation(), $(I);
    }
  }, c || h.removeIcon || "×"));
  return f ? f(O) : O;
}, yCe = function(t, r) {
  var n = t.offsetWidth, a = t.offsetHeight, i = t.offsetTop, o = t.offsetLeft, s = t.getBoundingClientRect(), l = s.width, c = s.height, u = s.x, d = s.y;
  return Math.abs(l - n) < 1 ? [l, c, u - r.x, d - r.y] : [n, a, o, i];
}, $u = function(t) {
  var r = t.current || {}, n = r.offsetWidth, a = n === void 0 ? 0 : n, i = r.offsetHeight, o = i === void 0 ? 0 : i;
  if (t.current) {
    var s = t.current.getBoundingClientRect(), l = s.width, c = s.height;
    if (Math.abs(l - a) < 1)
      return [l, c];
  }
  return [a, o];
}, iy = function(t, r) {
  return t[r ? 0 : 1];
}, e4 = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.className, n = e.style, a = e.id, i = e.animated, o = e.activeKey, s = e.rtl, l = e.extra, c = e.editable, u = e.locale, d = e.tabPosition, f = e.tabBarGutter, m = e.children, h = e.onTabClick, g = e.onTabScroll, y = e.indicator, S = p.useContext(K1), x = S.prefixCls, b = S.tabs, _ = ct(null), $ = ct(null), w = ct(null), O = ct(null), T = ct(null), I = ct(null), P = ct(null), D = d === "top" || d === "bottom", B = YN(0, function(Ve, ke) {
    D && g && g({
      direction: Ve > ke ? "left" : "right"
    });
  }), L = ye(B, 2), N = L[0], z = L[1], F = YN(0, function(Ve, ke) {
    !D && g && g({
      direction: Ve > ke ? "top" : "bottom"
    });
  }), j = ye(F, 2), H = j[0], U = j[1], G = He([0, 0]), V = ye(G, 2), K = V[0], Z = V[1], ee = He([0, 0]), ae = ye(ee, 2), ue = ae[0], re = ae[1], oe = He([0, 0]), fe = ye(oe, 2), le = fe[0], se = fe[1], Q = He([0, 0]), he = ye(Q, 2), ne = he[0], me = he[1], k = fCe(/* @__PURE__ */ new Map()), M = ye(k, 2), R = M[0], q = M[1], Y = cCe(b, R, ue[0]), X = iy(K, D), pe = iy(ue, D), $e = iy(le, D), J = iy(ne, D), de = X < pe + $e, Se = de ? X - J : X - $e, Ee = "".concat(x, "-nav-operations-hidden"), Te = 0, Le = 0;
  D && s ? (Te = 0, Le = Math.max(0, pe - Se)) : (Te = Math.min(0, Se - pe), Le = 0);
  function Ie(Ve) {
    return Ve < Te ? Te : Ve > Le ? Le : Ve;
  }
  var De = ct(null), Ae = He(), Fe = ye(Ae, 2), Ne = Fe[0], qe = Fe[1];
  function Qe() {
    qe(Date.now());
  }
  function tt() {
    De.current && clearTimeout(De.current);
  }
  dCe(O, function(Ve, ke) {
    function ut(st, Et) {
      st(function(zt) {
        var Be = Ie(zt + Et);
        return Be;
      });
    }
    return de ? (D ? ut(z, Ve) : ut(U, ke), tt(), Qe(), !0) : !1;
  }), St(function() {
    return tt(), Ne && (De.current = setTimeout(function() {
      qe(0);
    }, 100)), tt;
  }, [Ne]);
  var Ge = pCe(
    Y,
    // Container
    Se,
    // Transform
    D ? N : H,
    // Tabs
    pe,
    // Add
    $e,
    // Operation
    J,
    ce(ce({}, e), {}, {
      tabs: b
    })
  ), it = ye(Ge, 2), ht = it[0], It = it[1], xt = br(function() {
    var Ve = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : o, ke = Y.get(Ve) || {
      width: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0
    };
    if (D) {
      var ut = N;
      s ? ke.right < N ? ut = ke.right : ke.right + ke.width > N + Se && (ut = ke.right + ke.width - Se) : ke.left < -N ? ut = -ke.left : ke.left + ke.width > -N + Se && (ut = -(ke.left + ke.width - Se)), U(0), z(Ie(ut));
    } else {
      var st = H;
      ke.top < -H ? st = -ke.top : ke.top + ke.height > -H + Se && (st = -(ke.top + ke.height - Se)), z(0), U(Ie(st));
    }
  }), Xe = {};
  d === "top" || d === "bottom" ? Xe[s ? "marginRight" : "marginLeft"] = f : Xe.marginTop = f;
  var pt = b.map(function(Ve, ke) {
    var ut = Ve.key;
    return /* @__PURE__ */ p.createElement(gCe, {
      id: a,
      prefixCls: x,
      key: ut,
      tab: Ve,
      style: ke === 0 ? void 0 : Xe,
      closable: Ve.closable,
      editable: c,
      active: ut === o,
      renderWrapper: m,
      removeAriaLabel: u?.removeAriaLabel,
      onClick: function(Et) {
        h(ut, Et);
      },
      onFocus: function() {
        xt(ut), Qe(), O.current && (s || (O.current.scrollLeft = 0), O.current.scrollTop = 0);
      }
    });
  }), Ze = function() {
    return q(function() {
      var ke, ut = /* @__PURE__ */ new Map(), st = (ke = T.current) === null || ke === void 0 ? void 0 : ke.getBoundingClientRect();
      return b.forEach(function(Et) {
        var zt, Be = Et.key, ft = (zt = T.current) === null || zt === void 0 ? void 0 : zt.querySelector('[data-node-key="'.concat(CG(Be), '"]'));
        if (ft) {
          var yt = yCe(ft, st), Rt = ye(yt, 4), Ht = Rt[0], ir = Rt[1], ar = Rt[2], Nr = Rt[3];
          ut.set(Be, {
            width: Ht,
            height: ir,
            left: ar,
            top: Nr
          });
        }
      }), ut;
    });
  };
  St(function() {
    Ze();
  }, [b.map(function(Ve) {
    return Ve.key;
  }).join("_")]);
  var wt = bG(function() {
    var Ve = $u(_), ke = $u($), ut = $u(w);
    Z([Ve[0] - ke[0] - ut[0], Ve[1] - ke[1] - ut[1]]);
    var st = $u(P);
    se(st);
    var Et = $u(I);
    me(Et);
    var zt = $u(T);
    re([zt[0] - st[0], zt[1] - st[1]]), Ze();
  }), bt = b.slice(0, ht), Je = b.slice(It + 1), _t = [].concat(ze(bt), ze(Je)), Vt = Y.get(o), ot = lCe({
    activeTabOffset: Vt,
    horizontal: D,
    indicator: y,
    rtl: s
  }), Ct = ot.style;
  St(function() {
    xt();
  }, [o, Te, Le, QN(Vt), QN(Y), D]), St(function() {
    wt();
  }, [s]);
  var rt = !!_t.length, $t = "".concat(x, "-nav-wrap"), Wt, _e, Ke, nt;
  return D ? s ? (_e = N > 0, Wt = N !== Le) : (Wt = N < 0, _e = N !== Te) : (Ke = H < 0, nt = H !== Te), /* @__PURE__ */ p.createElement(Ia, {
    onResize: wt
  }, /* @__PURE__ */ p.createElement("div", {
    ref: qs(t, _),
    role: "tablist",
    className: be("".concat(x, "-nav"), r),
    style: n,
    onKeyDown: function() {
      Qe();
    }
  }, /* @__PURE__ */ p.createElement(iE, {
    ref: $,
    position: "left",
    extra: l,
    prefixCls: x
  }), /* @__PURE__ */ p.createElement(Ia, {
    onResize: wt
  }, /* @__PURE__ */ p.createElement("div", {
    className: be($t, te(te(te(te({}, "".concat($t, "-ping-left"), Wt), "".concat($t, "-ping-right"), _e), "".concat($t, "-ping-top"), Ke), "".concat($t, "-ping-bottom"), nt)),
    ref: O
  }, /* @__PURE__ */ p.createElement(Ia, {
    onResize: wt
  }, /* @__PURE__ */ p.createElement("div", {
    ref: T,
    className: "".concat(x, "-nav-list"),
    style: {
      transform: "translate(".concat(N, "px, ").concat(H, "px)"),
      transition: Ne ? "none" : void 0
    }
  }, pt, /* @__PURE__ */ p.createElement(xG, {
    ref: P,
    prefixCls: x,
    locale: u,
    editable: c,
    style: ce(ce({}, pt.length === 0 ? void 0 : Xe), {}, {
      visibility: rt ? "hidden" : null
    })
  }), /* @__PURE__ */ p.createElement("div", {
    className: be("".concat(x, "-ink-bar"), te({}, "".concat(x, "-ink-bar-animated"), i.inkBar)),
    style: Ct
  }))))), /* @__PURE__ */ p.createElement(hCe, Pe({}, e, {
    removeAriaLabel: u?.removeAriaLabel,
    ref: I,
    prefixCls: x,
    tabs: _t,
    className: !rt && Ee,
    tabMoving: !!Ne
  })), /* @__PURE__ */ p.createElement(iE, {
    ref: w,
    position: "right",
    extra: l,
    prefixCls: x
  })));
}), wI = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.className, a = e.style, i = e.id, o = e.active, s = e.tabKey, l = e.children;
  return /* @__PURE__ */ p.createElement("div", {
    id: i && "".concat(i, "-panel-").concat(s),
    role: "tabpanel",
    tabIndex: o ? 0 : -1,
    "aria-labelledby": i && "".concat(i, "-tab-").concat(s),
    "aria-hidden": !o,
    style: a,
    className: be(r, o && "".concat(r, "-active"), n),
    ref: t
  }, l);
});
process.env.NODE_ENV !== "production" && (wI.displayName = "TabPane");
var bCe = ["renderTabBar"], CCe = ["label", "key"], $G = function(t) {
  var r = t.renderTabBar, n = Kt(t, bCe), a = p.useContext(K1), i = a.tabs;
  if (r) {
    var o = ce(ce({}, n), {}, {
      // Legacy support. We do not use this actually
      panes: i.map(function(s) {
        var l = s.label, c = s.key, u = Kt(s, CCe);
        return /* @__PURE__ */ p.createElement(wI, Pe({
          tab: l,
          key: c,
          tabKey: c
        }, u));
      })
    });
    return r(o, e4);
  }
  return /* @__PURE__ */ p.createElement(e4, n);
};
process.env.NODE_ENV !== "production" && ($G.displayName = "TabNavListWrapper");
var SCe = ["key", "forceRender", "style", "className", "destroyInactiveTabPane"], xCe = function(t) {
  var r = t.id, n = t.activeKey, a = t.animated, i = t.tabPosition, o = t.destroyInactiveTabPane, s = p.useContext(K1), l = s.prefixCls, c = s.tabs, u = a.tabPane, d = "".concat(l, "-tabpane");
  return /* @__PURE__ */ p.createElement("div", {
    className: be("".concat(l, "-content-holder"))
  }, /* @__PURE__ */ p.createElement("div", {
    className: be("".concat(l, "-content"), "".concat(l, "-content-").concat(i), te({}, "".concat(l, "-content-animated"), u))
  }, c.map(function(f) {
    var m = f.key, h = f.forceRender, g = f.style, y = f.className, S = f.destroyInactiveTabPane, x = Kt(f, SCe), b = m === n;
    return /* @__PURE__ */ p.createElement(Ci, Pe({
      key: m,
      visible: b,
      forceRender: h,
      removeOnLeave: !!(o || S),
      leavedClassName: "".concat(d, "-hidden")
    }, a.tabPaneMotion), function(_, $) {
      var w = _.style, O = _.className;
      return /* @__PURE__ */ p.createElement(wI, Pe({}, x, {
        prefixCls: d,
        id: r,
        tabKey: m,
        animated: u,
        active: b,
        style: ce(ce({}, g), w),
        className: be(y, O),
        ref: $
      }));
    });
  })));
};
function $Ce() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
    inkBar: !0,
    tabPane: !1
  }, t;
  return e === !1 ? t = {
    inkBar: !1,
    tabPane: !1
  } : e === !0 ? t = {
    inkBar: !0,
    tabPane: !1
  } : t = ce({
    inkBar: !0
  }, kt(e) === "object" ? e : {}), t.tabPaneMotion && t.tabPane === void 0 && (t.tabPane = !0), !t.tabPaneMotion && t.tabPane && (process.env.NODE_ENV !== "production" && jt(!1, "`animated.tabPane` is true but `animated.tabPaneMotion` is not provided. Motion will not work."), t.tabPane = !1), t;
}
var _Ce = ["id", "prefixCls", "className", "items", "direction", "activeKey", "defaultActiveKey", "editable", "animated", "tabPosition", "tabBarGutter", "tabBarStyle", "tabBarExtraContent", "locale", "more", "destroyInactiveTabPane", "renderTabBar", "onChange", "onTabClick", "onTabScroll", "getPopupContainer", "popupClassName", "indicator"], t4 = 0, _G = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.id, n = e.prefixCls, a = n === void 0 ? "rc-tabs" : n, i = e.className, o = e.items, s = e.direction, l = e.activeKey, c = e.defaultActiveKey, u = e.editable, d = e.animated, f = e.tabPosition, m = f === void 0 ? "top" : f, h = e.tabBarGutter, g = e.tabBarStyle, y = e.tabBarExtraContent, S = e.locale, x = e.more, b = e.destroyInactiveTabPane, _ = e.renderTabBar, $ = e.onChange, w = e.onTabClick, O = e.onTabScroll, T = e.getPopupContainer, I = e.popupClassName, P = e.indicator, D = Kt(e, _Ce), B = p.useMemo(function() {
    return (o || []).filter(function(ne) {
      return ne && kt(ne) === "object" && "key" in ne;
    });
  }, [o]), L = s === "rtl", N = $Ce(d), z = He(!1), F = ye(z, 2), j = F[0], H = F[1];
  St(function() {
    H(R1());
  }, []);
  var U = Kr(function() {
    var ne;
    return (ne = B[0]) === null || ne === void 0 ? void 0 : ne.key;
  }, {
    value: l,
    defaultValue: c
  }), G = ye(U, 2), V = G[0], K = G[1], Z = He(function() {
    return B.findIndex(function(ne) {
      return ne.key === V;
    });
  }), ee = ye(Z, 2), ae = ee[0], ue = ee[1];
  St(function() {
    var ne = B.findIndex(function(k) {
      return k.key === V;
    });
    if (ne === -1) {
      var me;
      ne = Math.max(0, Math.min(ae, B.length - 1)), K((me = B[ne]) === null || me === void 0 ? void 0 : me.key);
    }
    ue(ne);
  }, [B.map(function(ne) {
    return ne.key;
  }).join("_"), V, ae]);
  var re = Kr(null, {
    value: r
  }), oe = ye(re, 2), fe = oe[0], le = oe[1];
  St(function() {
    r || (le("rc-tabs-".concat(process.env.NODE_ENV === "test" ? "test" : t4)), t4 += 1);
  }, []);
  function se(ne, me) {
    w?.(ne, me);
    var k = ne !== V;
    K(ne), k && $?.(ne);
  }
  var Q = {
    id: fe,
    activeKey: V,
    animated: N,
    tabPosition: m,
    rtl: L,
    mobile: j
  }, he = ce(ce({}, Q), {}, {
    editable: u,
    locale: S,
    more: x,
    tabBarGutter: h,
    onTabClick: se,
    onTabScroll: O,
    extra: y,
    style: g,
    panes: null,
    getPopupContainer: T,
    popupClassName: I,
    indicator: P
  });
  return /* @__PURE__ */ p.createElement(K1.Provider, {
    value: {
      tabs: B,
      prefixCls: a
    }
  }, /* @__PURE__ */ p.createElement("div", Pe({
    ref: t,
    id: r,
    className: be(a, "".concat(a, "-").concat(m), te(te(te({}, "".concat(a, "-mobile"), j), "".concat(a, "-editable"), u), "".concat(a, "-rtl"), L), i)
  }, D), /* @__PURE__ */ p.createElement($G, Pe({}, he, {
    renderTabBar: _
  })), /* @__PURE__ */ p.createElement(xCe, Pe({
    destroyInactiveTabPane: b
  }, Q, {
    animated: N
  }))));
});
process.env.NODE_ENV !== "production" && (_G.displayName = "Tabs");
const ECe = {
  motionAppear: !1,
  motionEnter: !0,
  motionLeave: !0
};
function wCe(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    inkBar: !0,
    tabPane: !1
  }, r;
  return t === !1 ? r = {
    inkBar: !1,
    tabPane: !1
  } : t === !0 ? r = {
    inkBar: !0,
    tabPane: !0
  } : r = Object.assign({
    inkBar: !0
  }, typeof t == "object" ? t : {}), r.tabPane && (r.tabPaneMotion = Object.assign(Object.assign({}, ECe), {
    motionName: Gi(e, "switch")
  })), r;
}
var OCe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function TCe(e) {
  return e.filter((t) => t);
}
function ICe(e, t) {
  if (process.env.NODE_ENV !== "production" && xr("Tabs").deprecated(!t, "Tabs.TabPane", "items"), e)
    return e;
  const r = Ma(t).map((n) => {
    if (/* @__PURE__ */ p.isValidElement(n)) {
      const {
        key: a,
        props: i
      } = n, o = i || {}, {
        tab: s
      } = o, l = OCe(o, ["tab"]);
      return Object.assign(Object.assign({
        key: String(a)
      }, l), {
        label: s
      });
    }
    return null;
  });
  return TCe(r);
}
const MCe = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: r
  } = e;
  return [
    {
      [t]: {
        [`${t}-switch`]: {
          "&-appear, &-enter": {
            transition: "none",
            "&-start": {
              opacity: 0
            },
            "&-active": {
              opacity: 1,
              transition: `opacity ${r}`
            }
          },
          "&-leave": {
            position: "absolute",
            transition: "none",
            inset: 0,
            "&-start": {
              opacity: 1
            },
            "&-active": {
              opacity: 0,
              transition: `opacity ${r}`
            }
          }
        }
      }
    },
    // Follow code may reuse in other components
    [us(e, "slide-up"), us(e, "slide-down")]
  ];
}, ACe = (e) => {
  const {
    componentCls: t,
    tabsCardPadding: r,
    cardBg: n,
    cardGutter: a,
    colorBorderSecondary: i,
    itemSelectedColor: o
  } = e;
  return {
    [`${t}-card`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        [`${t}-tab`]: {
          margin: 0,
          padding: r,
          background: n,
          border: `${ve(e.lineWidth)} ${e.lineType} ${i}`,
          transition: `all ${e.motionDurationSlow} ${e.motionEaseInOut}`
        },
        [`${t}-tab-active`]: {
          color: o,
          background: e.colorBgContainer
        },
        [`${t}-ink-bar`]: {
          visibility: "hidden"
        }
      },
      // ========================== Top & Bottom ==========================
      [`&${t}-top, &${t}-bottom`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab + ${t}-tab`]: {
            marginLeft: {
              _skip_check_: !0,
              value: ve(a)
            }
          }
        }
      },
      [`&${t}-top`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: `${ve(e.borderRadiusLG)} ${ve(e.borderRadiusLG)} 0 0`
          },
          [`${t}-tab-active`]: {
            borderBottomColor: e.colorBgContainer
          }
        }
      },
      [`&${t}-bottom`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: `0 0 ${ve(e.borderRadiusLG)} ${ve(e.borderRadiusLG)}`
          },
          [`${t}-tab-active`]: {
            borderTopColor: e.colorBgContainer
          }
        }
      },
      // ========================== Left & Right ==========================
      [`&${t}-left, &${t}-right`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab + ${t}-tab`]: {
            marginTop: ve(a)
          }
        }
      },
      [`&${t}-left`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `${ve(e.borderRadiusLG)} 0 0 ${ve(e.borderRadiusLG)}`
            }
          },
          [`${t}-tab-active`]: {
            borderRightColor: {
              _skip_check_: !0,
              value: e.colorBgContainer
            }
          }
        }
      },
      [`&${t}-right`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `0 ${ve(e.borderRadiusLG)} ${ve(e.borderRadiusLG)} 0`
            }
          },
          [`${t}-tab-active`]: {
            borderLeftColor: {
              _skip_check_: !0,
              value: e.colorBgContainer
            }
          }
        }
      }
    }
  };
}, PCe = (e) => {
  const {
    componentCls: t,
    itemHoverColor: r,
    dropdownEdgeChildVerticalPadding: n
  } = e;
  return {
    [`${t}-dropdown`]: Object.assign(Object.assign({}, Yr(e)), {
      position: "absolute",
      top: -9999,
      left: {
        _skip_check_: !0,
        value: -9999
      },
      zIndex: e.zIndexPopup,
      display: "block",
      "&-hidden": {
        display: "none"
      },
      [`${t}-dropdown-menu`]: {
        maxHeight: e.tabsDropdownHeight,
        margin: 0,
        padding: `${ve(n)} 0`,
        overflowX: "hidden",
        overflowY: "auto",
        textAlign: {
          _skip_check_: !0,
          value: "left"
        },
        listStyleType: "none",
        backgroundColor: e.colorBgContainer,
        backgroundClip: "padding-box",
        borderRadius: e.borderRadiusLG,
        outline: "none",
        boxShadow: e.boxShadowSecondary,
        "&-item": Object.assign(Object.assign({}, cs), {
          display: "flex",
          alignItems: "center",
          minWidth: e.tabsDropdownWidth,
          margin: 0,
          padding: `${ve(e.paddingXXS)} ${ve(e.paddingSM)}`,
          color: e.colorText,
          fontWeight: "normal",
          fontSize: e.fontSize,
          lineHeight: e.lineHeight,
          cursor: "pointer",
          transition: `all ${e.motionDurationSlow}`,
          "> span": {
            flex: 1,
            whiteSpace: "nowrap"
          },
          "&-remove": {
            flex: "none",
            marginLeft: {
              _skip_check_: !0,
              value: e.marginSM
            },
            color: e.colorTextDescription,
            fontSize: e.fontSizeSM,
            background: "transparent",
            border: 0,
            cursor: "pointer",
            "&:hover": {
              color: r
            }
          },
          "&:hover": {
            background: e.controlItemBgHover
          },
          "&-disabled": {
            "&, &:hover": {
              color: e.colorTextDisabled,
              background: "transparent",
              cursor: "not-allowed"
            }
          }
        })
      }
    })
  };
}, RCe = (e) => {
  const {
    componentCls: t,
    margin: r,
    colorBorderSecondary: n,
    horizontalMargin: a,
    verticalItemPadding: i,
    verticalItemMargin: o,
    calc: s
  } = e;
  return {
    // ========================== Top & Bottom ==========================
    [`${t}-top, ${t}-bottom`]: {
      flexDirection: "column",
      [`> ${t}-nav, > div > ${t}-nav`]: {
        margin: a,
        "&::before": {
          position: "absolute",
          right: {
            _skip_check_: !0,
            value: 0
          },
          left: {
            _skip_check_: !0,
            value: 0
          },
          borderBottom: `${ve(e.lineWidth)} ${e.lineType} ${n}`,
          content: "''"
        },
        [`${t}-ink-bar`]: {
          height: e.lineWidthBold,
          "&-animated": {
            transition: `width ${e.motionDurationSlow}, left ${e.motionDurationSlow},
            right ${e.motionDurationSlow}`
          }
        },
        [`${t}-nav-wrap`]: {
          "&::before, &::after": {
            top: 0,
            bottom: 0,
            width: e.controlHeight
          },
          "&::before": {
            left: {
              _skip_check_: !0,
              value: 0
            },
            boxShadow: e.boxShadowTabsOverflowLeft
          },
          "&::after": {
            right: {
              _skip_check_: !0,
              value: 0
            },
            boxShadow: e.boxShadowTabsOverflowRight
          },
          [`&${t}-nav-wrap-ping-left::before`]: {
            opacity: 1
          },
          [`&${t}-nav-wrap-ping-right::after`]: {
            opacity: 1
          }
        }
      }
    },
    [`${t}-top`]: {
      [`> ${t}-nav,
        > div > ${t}-nav`]: {
        "&::before": {
          bottom: 0
        },
        [`${t}-ink-bar`]: {
          bottom: 0
        }
      }
    },
    [`${t}-bottom`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        order: 1,
        marginTop: r,
        marginBottom: 0,
        "&::before": {
          top: 0
        },
        [`${t}-ink-bar`]: {
          top: 0
        }
      },
      [`> ${t}-content-holder, > div > ${t}-content-holder`]: {
        order: 0
      }
    },
    // ========================== Left & Right ==========================
    [`${t}-left, ${t}-right`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        flexDirection: "column",
        minWidth: s(e.controlHeight).mul(1.25).equal(),
        // >>>>>>>>>>> Tab
        [`${t}-tab`]: {
          padding: i,
          textAlign: "center"
        },
        [`${t}-tab + ${t}-tab`]: {
          margin: o
        },
        // >>>>>>>>>>> Nav
        [`${t}-nav-wrap`]: {
          flexDirection: "column",
          "&::before, &::after": {
            right: {
              _skip_check_: !0,
              value: 0
            },
            left: {
              _skip_check_: !0,
              value: 0
            },
            height: e.controlHeight
          },
          "&::before": {
            top: 0,
            boxShadow: e.boxShadowTabsOverflowTop
          },
          "&::after": {
            bottom: 0,
            boxShadow: e.boxShadowTabsOverflowBottom
          },
          [`&${t}-nav-wrap-ping-top::before`]: {
            opacity: 1
          },
          [`&${t}-nav-wrap-ping-bottom::after`]: {
            opacity: 1
          }
        },
        // >>>>>>>>>>> Ink Bar
        [`${t}-ink-bar`]: {
          width: e.lineWidthBold,
          "&-animated": {
            transition: `height ${e.motionDurationSlow}, top ${e.motionDurationSlow}`
          }
        },
        [`${t}-nav-list, ${t}-nav-operations`]: {
          flex: "1 0 auto",
          // fix safari scroll problem
          flexDirection: "column"
        }
      }
    },
    [`${t}-left`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        [`${t}-ink-bar`]: {
          right: {
            _skip_check_: !0,
            value: 0
          }
        }
      },
      [`> ${t}-content-holder, > div > ${t}-content-holder`]: {
        marginLeft: {
          _skip_check_: !0,
          value: ve(s(e.lineWidth).mul(-1).equal())
        },
        borderLeft: {
          _skip_check_: !0,
          value: `${ve(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        [`> ${t}-content > ${t}-tabpane`]: {
          paddingLeft: {
            _skip_check_: !0,
            value: e.paddingLG
          }
        }
      }
    },
    [`${t}-right`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        order: 1,
        [`${t}-ink-bar`]: {
          left: {
            _skip_check_: !0,
            value: 0
          }
        }
      },
      [`> ${t}-content-holder, > div > ${t}-content-holder`]: {
        order: 0,
        marginRight: {
          _skip_check_: !0,
          value: s(e.lineWidth).mul(-1).equal()
        },
        borderRight: {
          _skip_check_: !0,
          value: `${ve(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        [`> ${t}-content > ${t}-tabpane`]: {
          paddingRight: {
            _skip_check_: !0,
            value: e.paddingLG
          }
        }
      }
    }
  };
}, NCe = (e) => {
  const {
    componentCls: t,
    cardPaddingSM: r,
    cardPaddingLG: n,
    horizontalItemPaddingSM: a,
    horizontalItemPaddingLG: i
  } = e;
  return {
    [t]: {
      "&-small": {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: a,
            fontSize: e.titleFontSizeSM
          }
        }
      },
      "&-large": {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: i,
            fontSize: e.titleFontSizeLG
          }
        }
      }
    },
    [`${t}-card`]: {
      [`&${t}-small`]: {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: r
          }
        },
        [`&${t}-bottom`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: `0 0 ${ve(e.borderRadius)} ${ve(e.borderRadius)}`
          }
        },
        [`&${t}-top`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: `${ve(e.borderRadius)} ${ve(e.borderRadius)} 0 0`
          }
        },
        [`&${t}-right`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `0 ${ve(e.borderRadius)} ${ve(e.borderRadius)} 0`
            }
          }
        },
        [`&${t}-left`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `${ve(e.borderRadius)} 0 0 ${ve(e.borderRadius)}`
            }
          }
        }
      },
      [`&${t}-large`]: {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: n
          }
        }
      }
    }
  };
}, DCe = (e) => {
  const {
    componentCls: t,
    itemActiveColor: r,
    itemHoverColor: n,
    iconCls: a,
    tabsHorizontalItemMargin: i,
    horizontalItemPadding: o,
    itemSelectedColor: s,
    itemColor: l
  } = e, c = `${t}-tab`;
  return {
    [c]: {
      position: "relative",
      WebkitTouchCallout: "none",
      WebkitTapHighlightColor: "transparent",
      display: "inline-flex",
      alignItems: "center",
      padding: o,
      fontSize: e.titleFontSize,
      background: "transparent",
      border: 0,
      outline: "none",
      cursor: "pointer",
      color: l,
      "&-btn, &-remove": Object.assign({
        "&:focus:not(:focus-visible), &:active": {
          color: r
        }
      }, zs(e)),
      "&-btn": {
        outline: "none",
        transition: `all ${e.motionDurationSlow}`,
        [`${c}-icon:not(:last-child)`]: {
          marginInlineEnd: e.marginSM
        }
      },
      "&-remove": {
        flex: "none",
        marginRight: {
          _skip_check_: !0,
          value: e.calc(e.marginXXS).mul(-1).equal()
        },
        marginLeft: {
          _skip_check_: !0,
          value: e.marginXS
        },
        color: e.colorTextDescription,
        fontSize: e.fontSizeSM,
        background: "transparent",
        border: "none",
        outline: "none",
        cursor: "pointer",
        transition: `all ${e.motionDurationSlow}`,
        "&:hover": {
          color: e.colorTextHeading
        }
      },
      "&:hover": {
        color: n
      },
      [`&${c}-active ${c}-btn`]: {
        color: s,
        textShadow: e.tabsActiveTextShadow
      },
      [`&${c}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed"
      },
      [`&${c}-disabled ${c}-btn, &${c}-disabled ${t}-remove`]: {
        "&:focus, &:active": {
          color: e.colorTextDisabled
        }
      },
      [`& ${c}-remove ${a}`]: {
        margin: 0
      },
      [`${a}:not(:last-child)`]: {
        marginRight: {
          _skip_check_: !0,
          value: e.marginSM
        }
      }
    },
    [`${c} + ${c}`]: {
      margin: {
        _skip_check_: !0,
        value: i
      }
    }
  };
}, jCe = (e) => {
  const {
    componentCls: t,
    tabsHorizontalItemMarginRTL: r,
    iconCls: n,
    cardGutter: a,
    calc: i
  } = e;
  return {
    [`${t}-rtl`]: {
      direction: "rtl",
      [`${t}-nav`]: {
        [`${t}-tab`]: {
          margin: {
            _skip_check_: !0,
            value: r
          },
          [`${t}-tab:last-of-type`]: {
            marginLeft: {
              _skip_check_: !0,
              value: 0
            }
          },
          [n]: {
            marginRight: {
              _skip_check_: !0,
              value: 0
            },
            marginLeft: {
              _skip_check_: !0,
              value: ve(e.marginSM)
            }
          },
          [`${t}-tab-remove`]: {
            marginRight: {
              _skip_check_: !0,
              value: ve(e.marginXS)
            },
            marginLeft: {
              _skip_check_: !0,
              value: ve(i(e.marginXXS).mul(-1).equal())
            },
            [n]: {
              margin: 0
            }
          }
        }
      },
      [`&${t}-left`]: {
        [`> ${t}-nav`]: {
          order: 1
        },
        [`> ${t}-content-holder`]: {
          order: 0
        }
      },
      [`&${t}-right`]: {
        [`> ${t}-nav`]: {
          order: 0
        },
        [`> ${t}-content-holder`]: {
          order: 1
        }
      },
      // ====================== Card ======================
      [`&${t}-card${t}-top, &${t}-card${t}-bottom`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab + ${t}-tab`]: {
            marginRight: {
              _skip_check_: !0,
              value: a
            },
            marginLeft: {
              _skip_check_: !0,
              value: 0
            }
          }
        }
      }
    },
    [`${t}-dropdown-rtl`]: {
      direction: "rtl"
    },
    [`${t}-menu-item`]: {
      [`${t}-dropdown-rtl`]: {
        textAlign: {
          _skip_check_: !0,
          value: "right"
        }
      }
    }
  };
}, LCe = (e) => {
  const {
    componentCls: t,
    tabsCardPadding: r,
    cardHeight: n,
    cardGutter: a,
    itemHoverColor: i,
    itemActiveColor: o,
    colorBorderSecondary: s
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign({}, Yr(e)), {
      display: "flex",
      // ========================== Navigation ==========================
      [`> ${t}-nav, > div > ${t}-nav`]: {
        position: "relative",
        display: "flex",
        flex: "none",
        alignItems: "center",
        [`${t}-nav-wrap`]: {
          position: "relative",
          display: "flex",
          flex: "auto",
          alignSelf: "stretch",
          overflow: "hidden",
          whiteSpace: "nowrap",
          transform: "translate(0)",
          // Fix chrome render bug
          // >>>>> Ping shadow
          "&::before, &::after": {
            position: "absolute",
            zIndex: 1,
            opacity: 0,
            transition: `opacity ${e.motionDurationSlow}`,
            content: "''",
            pointerEvents: "none"
          }
        },
        [`${t}-nav-list`]: {
          position: "relative",
          display: "flex",
          transition: `opacity ${e.motionDurationSlow}`
        },
        // >>>>>>>> Operations
        [`${t}-nav-operations`]: {
          display: "flex",
          alignSelf: "stretch"
        },
        [`${t}-nav-operations-hidden`]: {
          position: "absolute",
          visibility: "hidden",
          pointerEvents: "none"
        },
        [`${t}-nav-more`]: {
          position: "relative",
          padding: r,
          background: "transparent",
          border: 0,
          color: e.colorText,
          "&::after": {
            position: "absolute",
            right: {
              _skip_check_: !0,
              value: 0
            },
            bottom: 0,
            left: {
              _skip_check_: !0,
              value: 0
            },
            height: e.calc(e.controlHeightLG).div(8).equal(),
            transform: "translateY(100%)",
            content: "''"
          }
        },
        [`${t}-nav-add`]: Object.assign({
          minWidth: n,
          minHeight: n,
          marginLeft: {
            _skip_check_: !0,
            value: a
          },
          padding: `0 ${ve(e.paddingXS)}`,
          background: "transparent",
          border: `${ve(e.lineWidth)} ${e.lineType} ${s}`,
          borderRadius: `${ve(e.borderRadiusLG)} ${ve(e.borderRadiusLG)} 0 0`,
          outline: "none",
          cursor: "pointer",
          color: e.colorText,
          transition: `all ${e.motionDurationSlow} ${e.motionEaseInOut}`,
          "&:hover": {
            color: i
          },
          "&:active, &:focus:not(:focus-visible)": {
            color: o
          }
        }, zs(e))
      },
      [`${t}-extra-content`]: {
        flex: "none"
      },
      // ============================ InkBar ============================
      [`${t}-ink-bar`]: {
        position: "absolute",
        background: e.inkBarColor,
        pointerEvents: "none"
      }
    }), DCe(e)), {
      // =========================== TabPanes ===========================
      [`${t}-content`]: {
        position: "relative",
        width: "100%"
      },
      [`${t}-content-holder`]: {
        flex: "auto",
        minWidth: 0,
        minHeight: 0
      },
      [`${t}-tabpane`]: {
        outline: "none",
        "&-hidden": {
          display: "none"
        }
      }
    }),
    [`${t}-centered`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        [`${t}-nav-wrap`]: {
          [`&:not([class*='${t}-nav-wrap-ping'])`]: {
            justifyContent: "center"
          }
        }
      }
    }
  };
}, kCe = (e) => {
  const t = e.controlHeightLG;
  return {
    zIndexPopup: e.zIndexPopupBase + 50,
    cardBg: e.colorFillAlter,
    cardHeight: t,
    // Initialize with empty string, because cardPadding will be calculated with cardHeight by default.
    cardPadding: `${(t - Math.round(e.fontSize * e.lineHeight)) / 2 - e.lineWidth}px ${e.padding}px`,
    cardPaddingSM: `${e.paddingXXS * 1.5}px ${e.padding}px`,
    cardPaddingLG: `${e.paddingXS}px ${e.padding}px ${e.paddingXXS * 1.5}px`,
    titleFontSize: e.fontSize,
    titleFontSizeLG: e.fontSizeLG,
    titleFontSizeSM: e.fontSize,
    inkBarColor: e.colorPrimary,
    horizontalMargin: `0 0 ${e.margin}px 0`,
    horizontalItemGutter: 32,
    // Fixed Value
    // Initialize with empty string, because horizontalItemMargin will be calculated with horizontalItemGutter by default.
    horizontalItemMargin: "",
    horizontalItemMarginRTL: "",
    horizontalItemPadding: `${e.paddingSM}px 0`,
    horizontalItemPaddingSM: `${e.paddingXS}px 0`,
    horizontalItemPaddingLG: `${e.padding}px 0`,
    verticalItemPadding: `${e.paddingXS}px ${e.paddingLG}px`,
    verticalItemMargin: `${e.margin}px 0 0 0`,
    itemColor: e.colorText,
    itemSelectedColor: e.colorPrimary,
    itemHoverColor: e.colorPrimaryHover,
    itemActiveColor: e.colorPrimaryActive,
    cardGutter: e.marginXXS / 2
  };
}, FCe = Zr("Tabs", (e) => {
  const t = $r(e, {
    // `cardPadding` is empty by default, so we could calculate with dynamic `cardHeight`
    tabsCardPadding: e.cardPadding,
    dropdownEdgeChildVerticalPadding: e.paddingXXS,
    tabsActiveTextShadow: "0 0 0.25px currentcolor",
    tabsDropdownHeight: 200,
    tabsDropdownWidth: 120,
    tabsHorizontalItemMargin: `0 0 0 ${ve(e.horizontalItemGutter)}`,
    tabsHorizontalItemMarginRTL: `0 0 0 ${ve(e.horizontalItemGutter)}`
  });
  return [NCe(t), jCe(t), RCe(t), PCe(t), ACe(t), LCe(t), MCe(t)];
}, kCe), EG = () => null;
process.env.NODE_ENV !== "production" && (EG.displayName = "DeprecatedTabPane");
var BCe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const OI = (e) => {
  var t, r, n, a, i, o, s, l, c, u, d;
  const {
    type: f,
    className: m,
    rootClassName: h,
    size: g,
    onEdit: y,
    hideAdd: S,
    centered: x,
    addIcon: b,
    removeIcon: _,
    moreIcon: $,
    more: w,
    popupClassName: O,
    children: T,
    items: I,
    animated: P,
    style: D,
    indicatorSize: B,
    indicator: L
  } = e, N = BCe(e, ["type", "className", "rootClassName", "size", "onEdit", "hideAdd", "centered", "addIcon", "removeIcon", "moreIcon", "more", "popupClassName", "children", "items", "animated", "style", "indicatorSize", "indicator"]), {
    prefixCls: z
  } = N, {
    direction: F,
    tabs: j,
    getPrefixCls: H,
    getPopupContainer: U
  } = p.useContext(Lt), G = H("tabs", z), V = Mn(G), [K, Z, ee] = FCe(G, V);
  let ae;
  f === "editable-card" && (ae = {
    onEdit: (Q, he) => {
      let {
        key: ne,
        event: me
      } = he;
      y?.(Q === "add" ? me : ne, Q);
    },
    removeIcon: (t = _ ?? j?.removeIcon) !== null && t !== void 0 ? t : /* @__PURE__ */ p.createElement(Ys, null),
    addIcon: (b ?? j?.addIcon) || /* @__PURE__ */ p.createElement(yG, null),
    showAdd: S !== !0
  });
  const ue = H();
  if (process.env.NODE_ENV !== "production") {
    const Q = xr("Tabs");
    process.env.NODE_ENV !== "production" && Q(!("onPrevClick" in e) && !("onNextClick" in e), "breaking", "`onPrevClick` and `onNextClick` has been removed. Please use `onTabScroll` instead."), process.env.NODE_ENV !== "production" && Q(!(B || j?.indicatorSize), "deprecated", "`indicatorSize` has been deprecated. Please use `indicator={{ size: ... }}` instead.");
  }
  const re = Xa(g), oe = ICe(I, T), fe = wCe(G, P), le = Object.assign(Object.assign({}, j?.style), D), se = {
    align: (r = L?.align) !== null && r !== void 0 ? r : (n = j?.indicator) === null || n === void 0 ? void 0 : n.align,
    size: (s = (i = (a = L?.size) !== null && a !== void 0 ? a : B) !== null && i !== void 0 ? i : (o = j?.indicator) === null || o === void 0 ? void 0 : o.size) !== null && s !== void 0 ? s : j?.indicatorSize
  };
  return K(/* @__PURE__ */ p.createElement(_G, Object.assign({
    direction: F,
    getPopupContainer: U
  }, N, {
    items: oe,
    className: be({
      [`${G}-${re}`]: re,
      [`${G}-card`]: ["card", "editable-card"].includes(f),
      [`${G}-editable-card`]: f === "editable-card",
      [`${G}-centered`]: x
    }, j?.className, m, h, Z, ee, V),
    popupClassName: be(O, Z, ee, V),
    style: le,
    editable: ae,
    more: Object.assign({
      icon: (d = (u = (c = (l = j?.more) === null || l === void 0 ? void 0 : l.icon) !== null && c !== void 0 ? c : j?.moreIcon) !== null && u !== void 0 ? u : $) !== null && d !== void 0 ? d : /* @__PURE__ */ p.createElement(z1, null),
      transitionName: `${ue}-slide-up`
    }, w),
    prefixCls: G,
    animated: fe,
    indicator: se
  })));
};
OI.TabPane = EG;
process.env.NODE_ENV !== "production" && (OI.displayName = "Tabs");
var zCe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const wG = (e) => {
  var {
    prefixCls: t,
    className: r,
    hoverable: n = !0
  } = e, a = zCe(e, ["prefixCls", "className", "hoverable"]);
  const {
    getPrefixCls: i
  } = p.useContext(Lt), o = i("card", t), s = be(`${o}-grid`, r, {
    [`${o}-grid-hoverable`]: n
  });
  return /* @__PURE__ */ p.createElement("div", Object.assign({}, a, {
    className: s
  }));
}, HCe = (e) => {
  const {
    antCls: t,
    componentCls: r,
    headerHeight: n,
    cardPaddingBase: a,
    tabsMarginBottom: i
  } = e;
  return Object.assign(Object.assign({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    minHeight: n,
    marginBottom: -1,
    padding: `0 ${ve(a)}`,
    color: e.colorTextHeading,
    fontWeight: e.fontWeightStrong,
    fontSize: e.headerFontSize,
    background: e.headerBg,
    borderBottom: `${ve(e.lineWidth)} ${e.lineType} ${e.colorBorderSecondary}`,
    borderRadius: `${ve(e.borderRadiusLG)} ${ve(e.borderRadiusLG)} 0 0`
  }, Bs()), {
    "&-wrapper": {
      width: "100%",
      display: "flex",
      alignItems: "center"
    },
    "&-title": Object.assign(Object.assign({
      display: "inline-block",
      flex: 1
    }, cs), {
      [`
          > ${r}-typography,
          > ${r}-typography-edit-content
        `]: {
        insetInlineStart: 0,
        marginTop: 0,
        marginBottom: 0
      }
    }),
    [`${t}-tabs-top`]: {
      clear: "both",
      marginBottom: i,
      color: e.colorText,
      fontWeight: "normal",
      fontSize: e.fontSize,
      "&-bar": {
        borderBottom: `${ve(e.lineWidth)} ${e.lineType} ${e.colorBorderSecondary}`
      }
    }
  });
}, VCe = (e) => {
  const {
    cardPaddingBase: t,
    colorBorderSecondary: r,
    cardShadow: n,
    lineWidth: a
  } = e;
  return {
    width: "33.33%",
    padding: t,
    border: 0,
    borderRadius: 0,
    boxShadow: `
      ${ve(a)} 0 0 0 ${r},
      0 ${ve(a)} 0 0 ${r},
      ${ve(a)} ${ve(a)} 0 0 ${r},
      ${ve(a)} 0 0 0 ${r} inset,
      0 ${ve(a)} 0 0 ${r} inset;
    `,
    transition: `all ${e.motionDurationMid}`,
    "&-hoverable:hover": {
      position: "relative",
      zIndex: 1,
      boxShadow: n
    }
  };
}, GCe = (e) => {
  const {
    componentCls: t,
    iconCls: r,
    actionsLiMargin: n,
    cardActionsIconSize: a,
    colorBorderSecondary: i,
    actionsBg: o
  } = e;
  return Object.assign(Object.assign({
    margin: 0,
    padding: 0,
    listStyle: "none",
    background: o,
    borderTop: `${ve(e.lineWidth)} ${e.lineType} ${i}`,
    display: "flex",
    borderRadius: `0 0 ${ve(e.borderRadiusLG)} ${ve(e.borderRadiusLG)}`
  }, Bs()), {
    "& > li": {
      margin: n,
      color: e.colorTextDescription,
      textAlign: "center",
      "> span": {
        position: "relative",
        display: "block",
        minWidth: e.calc(e.cardActionsIconSize).mul(2).equal(),
        fontSize: e.fontSize,
        lineHeight: e.lineHeight,
        cursor: "pointer",
        "&:hover": {
          color: e.colorPrimary,
          transition: `color ${e.motionDurationMid}`
        },
        [`a:not(${t}-btn), > ${r}`]: {
          display: "inline-block",
          width: "100%",
          color: e.colorTextDescription,
          lineHeight: ve(e.fontHeight),
          transition: `color ${e.motionDurationMid}`,
          "&:hover": {
            color: e.colorPrimary
          }
        },
        [`> ${r}`]: {
          fontSize: a,
          lineHeight: ve(e.calc(a).mul(e.lineHeight).equal())
        }
      },
      "&:not(:last-child)": {
        borderInlineEnd: `${ve(e.lineWidth)} ${e.lineType} ${i}`
      }
    }
  });
}, UCe = (e) => Object.assign(Object.assign({
  margin: `${ve(e.calc(e.marginXXS).mul(-1).equal())} 0`,
  display: "flex"
}, Bs()), {
  "&-avatar": {
    paddingInlineEnd: e.padding
  },
  "&-detail": {
    overflow: "hidden",
    flex: 1,
    "> div:not(:last-child)": {
      marginBottom: e.marginXS
    }
  },
  "&-title": Object.assign({
    color: e.colorTextHeading,
    fontWeight: e.fontWeightStrong,
    fontSize: e.fontSizeLG
  }, cs),
  "&-description": {
    color: e.colorTextDescription
  }
}), WCe = (e) => {
  const {
    componentCls: t,
    cardPaddingBase: r,
    colorFillAlter: n
  } = e;
  return {
    [`${t}-head`]: {
      padding: `0 ${ve(r)}`,
      background: n,
      "&-title": {
        fontSize: e.fontSize
      }
    },
    [`${t}-body`]: {
      padding: `${ve(e.padding)} ${ve(r)}`
    }
  };
}, qCe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    overflow: "hidden",
    [`${t}-body`]: {
      userSelect: "none"
    }
  };
}, KCe = (e) => {
  const {
    antCls: t,
    componentCls: r,
    cardShadow: n,
    cardHeadPadding: a,
    colorBorderSecondary: i,
    boxShadowTertiary: o,
    cardPaddingBase: s,
    extraColor: l
  } = e;
  return {
    [r]: Object.assign(Object.assign({}, Yr(e)), {
      position: "relative",
      background: e.colorBgContainer,
      borderRadius: e.borderRadiusLG,
      [`&:not(${r}-bordered)`]: {
        boxShadow: o
      },
      [`${r}-head`]: HCe(e),
      [`${r}-extra`]: {
        // https://stackoverflow.com/a/22429853/3040605
        marginInlineStart: "auto",
        color: l,
        fontWeight: "normal",
        fontSize: e.fontSize
      },
      [`${r}-body`]: Object.assign({
        padding: s,
        borderRadius: `0 0 ${ve(e.borderRadiusLG)} ${ve(e.borderRadiusLG)}`
      }, Bs()),
      [`${r}-grid`]: VCe(e),
      [`${r}-cover`]: {
        "> *": {
          display: "block",
          width: "100%"
        },
        [`img, img + ${t}-image-mask`]: {
          borderRadius: `${ve(e.borderRadiusLG)} ${ve(e.borderRadiusLG)} 0 0`
        }
      },
      [`${r}-actions`]: GCe(e),
      [`${r}-meta`]: UCe(e)
    }),
    [`${r}-bordered`]: {
      border: `${ve(e.lineWidth)} ${e.lineType} ${i}`,
      [`${r}-cover`]: {
        marginTop: -1,
        marginInlineStart: -1,
        marginInlineEnd: -1
      }
    },
    [`${r}-hoverable`]: {
      cursor: "pointer",
      transition: `box-shadow ${e.motionDurationMid}, border-color ${e.motionDurationMid}`,
      "&:hover": {
        borderColor: "transparent",
        boxShadow: n
      }
    },
    [`${r}-contain-grid`]: {
      borderRadius: `${ve(e.borderRadiusLG)} ${ve(e.borderRadiusLG)} 0 0 `,
      [`${r}-body`]: {
        display: "flex",
        flexWrap: "wrap"
      },
      [`&:not(${r}-loading) ${r}-body`]: {
        marginBlockStart: e.calc(e.lineWidth).mul(-1).equal(),
        marginInlineStart: e.calc(e.lineWidth).mul(-1).equal(),
        padding: 0
      }
    },
    [`${r}-contain-tabs`]: {
      [`> div${r}-head`]: {
        minHeight: 0,
        [`${r}-head-title, ${r}-extra`]: {
          paddingTop: a
        }
      }
    },
    [`${r}-type-inner`]: WCe(e),
    [`${r}-loading`]: qCe(e),
    [`${r}-rtl`]: {
      direction: "rtl"
    }
  };
}, YCe = (e) => {
  const {
    componentCls: t,
    cardPaddingSM: r,
    headerHeightSM: n,
    headerFontSizeSM: a
  } = e;
  return {
    [`${t}-small`]: {
      [`> ${t}-head`]: {
        minHeight: n,
        padding: `0 ${ve(r)}`,
        fontSize: a,
        [`> ${t}-head-wrapper`]: {
          [`> ${t}-extra`]: {
            fontSize: e.fontSize
          }
        }
      },
      [`> ${t}-body`]: {
        padding: r
      }
    },
    [`${t}-small${t}-contain-tabs`]: {
      [`> ${t}-head`]: {
        [`${t}-head-title, ${t}-extra`]: {
          paddingTop: 0,
          display: "flex",
          alignItems: "center"
        }
      }
    }
  };
}, ZCe = (e) => ({
  headerBg: "transparent",
  headerFontSize: e.fontSizeLG,
  headerFontSizeSM: e.fontSize,
  headerHeight: e.fontSizeLG * e.lineHeightLG + e.padding * 2,
  headerHeightSM: e.fontSize * e.lineHeight + e.paddingXS * 2,
  actionsBg: e.colorBgContainer,
  actionsLiMargin: `${e.paddingSM}px 0`,
  tabsMarginBottom: -e.padding - e.lineWidth,
  extraColor: e.colorText
}), XCe = Zr("Card", (e) => {
  const t = $r(e, {
    cardShadow: e.boxShadowCard,
    cardHeadPadding: e.padding,
    cardPaddingBase: e.paddingLG,
    cardActionsIconSize: e.fontSize,
    cardPaddingSM: 12
    // Fixed padding.
  });
  return [
    // Style
    KCe(t),
    // Size
    YCe(t)
  ];
}, ZCe);
var r4 = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const JCe = (e) => {
  const {
    actionClasses: t,
    actions: r = [],
    actionStyle: n
  } = e;
  return /* @__PURE__ */ p.createElement("ul", {
    className: t,
    style: n
  }, r.map((a, i) => {
    const o = `action-${i}`;
    return /* @__PURE__ */ p.createElement("li", {
      style: {
        width: `${100 / r.length}%`
      },
      key: o
    }, /* @__PURE__ */ p.createElement("span", null, a));
  }));
}, QCe = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    prefixCls: r,
    className: n,
    rootClassName: a,
    style: i,
    extra: o,
    headStyle: s = {},
    bodyStyle: l = {},
    title: c,
    loading: u,
    bordered: d = !0,
    size: f,
    type: m,
    cover: h,
    actions: g,
    tabList: y,
    children: S,
    activeTabKey: x,
    defaultActiveTabKey: b,
    tabBarExtraContent: _,
    hoverable: $,
    tabProps: w = {},
    classNames: O,
    styles: T
  } = e, I = r4(e, ["prefixCls", "className", "rootClassName", "style", "extra", "headStyle", "bodyStyle", "title", "loading", "bordered", "size", "type", "cover", "actions", "tabList", "children", "activeTabKey", "defaultActiveTabKey", "tabBarExtraContent", "hoverable", "tabProps", "classNames", "styles"]), {
    getPrefixCls: P,
    direction: D,
    card: B
  } = p.useContext(Lt);
  if (process.env.NODE_ENV !== "production") {
    const R = xr("Card");
    [["headStyle", "styles.header"], ["bodyStyle", "styles.body"]].forEach((q) => {
      let [Y, X] = q;
      R.deprecated(!(Y in e), Y, X);
    });
  }
  const L = (R) => {
    var q;
    (q = e.onTabChange) === null || q === void 0 || q.call(e, R);
  }, N = (R) => {
    var q;
    return be((q = B?.classNames) === null || q === void 0 ? void 0 : q[R], O?.[R]);
  }, z = (R) => {
    var q;
    return Object.assign(Object.assign({}, (q = B?.styles) === null || q === void 0 ? void 0 : q[R]), T?.[R]);
  }, F = p.useMemo(() => {
    let R = !1;
    return p.Children.forEach(S, (q) => {
      q && q.type && q.type === wG && (R = !0);
    }), R;
  }, [S]), j = P("card", r), [H, U, G] = XCe(j), V = /* @__PURE__ */ p.createElement(Ui, {
    loading: !0,
    active: !0,
    paragraph: {
      rows: 4
    },
    title: !1
  }, S), K = x !== void 0, Z = Object.assign(Object.assign({}, w), {
    [K ? "activeKey" : "defaultActiveKey"]: K ? x : b,
    tabBarExtraContent: _
  });
  let ee;
  const ae = Xa(f), ue = !ae || ae === "default" ? "large" : ae, re = y ? /* @__PURE__ */ p.createElement(OI, Object.assign({
    size: ue
  }, Z, {
    className: `${j}-head-tabs`,
    onChange: L,
    items: y.map((R) => {
      var {
        tab: q
      } = R, Y = r4(R, ["tab"]);
      return Object.assign({
        label: q
      }, Y);
    })
  })) : null;
  if (c || o || re) {
    const R = be(`${j}-head`, N("header")), q = be(`${j}-head-title`, N("title")), Y = be(`${j}-extra`, N("extra")), X = Object.assign(Object.assign({}, s), z("header"));
    ee = /* @__PURE__ */ p.createElement("div", {
      className: R,
      style: X
    }, /* @__PURE__ */ p.createElement("div", {
      className: `${j}-head-wrapper`
    }, c && /* @__PURE__ */ p.createElement("div", {
      className: q,
      style: z("title")
    }, c), o && /* @__PURE__ */ p.createElement("div", {
      className: Y,
      style: z("extra")
    }, o)), re);
  }
  const oe = be(`${j}-cover`, N("cover")), fe = h ? /* @__PURE__ */ p.createElement("div", {
    className: oe,
    style: z("cover")
  }, h) : null, le = be(`${j}-body`, N("body")), se = Object.assign(Object.assign({}, l), z("body")), Q = /* @__PURE__ */ p.createElement("div", {
    className: le,
    style: se
  }, u ? V : S), he = be(`${j}-actions`, N("actions")), ne = g && g.length ? /* @__PURE__ */ p.createElement(JCe, {
    actionClasses: he,
    actionStyle: z("actions"),
    actions: g
  }) : null, me = bn(I, ["onTabChange"]), k = be(j, B?.className, {
    [`${j}-loading`]: u,
    [`${j}-bordered`]: d,
    [`${j}-hoverable`]: $,
    [`${j}-contain-grid`]: F,
    [`${j}-contain-tabs`]: y && y.length,
    [`${j}-${ae}`]: ae,
    [`${j}-type-${m}`]: !!m,
    [`${j}-rtl`]: D === "rtl"
  }, n, a, U, G), M = Object.assign(Object.assign({}, B?.style), i);
  return H(/* @__PURE__ */ p.createElement("div", Object.assign({
    ref: t
  }, me, {
    className: k,
    style: M
  }), ee, fe, Q, ne));
});
var eSe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const tSe = (e) => {
  const {
    prefixCls: t,
    className: r,
    avatar: n,
    title: a,
    description: i
  } = e, o = eSe(e, ["prefixCls", "className", "avatar", "title", "description"]), {
    getPrefixCls: s
  } = p.useContext(Lt), l = s("card", t), c = be(`${l}-meta`, r), u = n ? /* @__PURE__ */ p.createElement("div", {
    className: `${l}-meta-avatar`
  }, n) : null, d = a ? /* @__PURE__ */ p.createElement("div", {
    className: `${l}-meta-title`
  }, a) : null, f = i ? /* @__PURE__ */ p.createElement("div", {
    className: `${l}-meta-description`
  }, i) : null, m = d || f ? /* @__PURE__ */ p.createElement("div", {
    className: `${l}-meta-detail`
  }, d, f) : null;
  return /* @__PURE__ */ p.createElement("div", Object.assign({}, o, {
    className: c
  }), u, m);
}, zn = QCe;
zn.Grid = wG;
zn.Meta = tSe;
process.env.NODE_ENV !== "production" && (zn.displayName = "Card");
function rSe(e, t, r) {
  var n = r || {}, a = n.noTrailing, i = a === void 0 ? !1 : a, o = n.noLeading, s = o === void 0 ? !1 : o, l = n.debounceMode, c = l === void 0 ? void 0 : l, u, d = !1, f = 0;
  function m() {
    u && clearTimeout(u);
  }
  function h(y) {
    var S = y || {}, x = S.upcomingOnly, b = x === void 0 ? !1 : x;
    m(), d = !b;
  }
  function g() {
    for (var y = arguments.length, S = new Array(y), x = 0; x < y; x++)
      S[x] = arguments[x];
    var b = this, _ = Date.now() - f;
    if (d)
      return;
    function $() {
      f = Date.now(), t.apply(b, S);
    }
    function w() {
      u = void 0;
    }
    !s && c && !u && $(), m(), c === void 0 && _ > e ? s ? (f = Date.now(), i || (u = setTimeout(c ? w : $, e))) : $() : i !== !0 && (u = setTimeout(c ? w : $, c === void 0 ? e - _ : e));
  }
  return g.cancel = h, g;
}
function nSe(e, t, r) {
  var n = {}, a = n.atBegin, i = a === void 0 ? !1 : a;
  return rSe(e, t, {
    debounceMode: i !== !1
  });
}
function yi(e, t) {
  return e[t];
}
var aSe = ["children"];
function OG(e, t) {
  return "".concat(e, "-").concat(t);
}
function iSe(e) {
  return e && e.type && e.type.isTreeNode;
}
function _h(e, t) {
  return e ?? t;
}
function ud(e) {
  var t = e || {}, r = t.title, n = t._title, a = t.key, i = t.children, o = r || "title";
  return {
    title: o,
    _title: n || [o],
    key: a || "key",
    children: i || "children"
  };
}
function oSe(e, t) {
  var r = /* @__PURE__ */ new Map();
  function n(a) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    (a || []).forEach(function(o) {
      var s = o[t.key], l = o[t.children];
      jt(s != null, "Tree node must have a certain key: [".concat(i).concat(s, "]"));
      var c = String(s);
      jt(!r.has(c) || s === null || s === void 0, "Same 'key' exist in the Tree: ".concat(c)), r.set(c, !0), n(l, "".concat(i).concat(c, " > "));
    });
  }
  n(e);
}
function TG(e) {
  function t(r) {
    var n = Ma(r);
    return n.map(function(a) {
      if (!iSe(a))
        return jt(!a, "Tree/TreeNode can only accept TreeNode as children."), null;
      var i = a.key, o = a.props, s = o.children, l = Kt(o, aSe), c = ce({
        key: i
      }, l), u = t(s);
      return u.length && (c.children = u), c;
    }).filter(function(a) {
      return a;
    });
  }
  return t(e);
}
function Ox(e, t, r) {
  var n = ud(r), a = n._title, i = n.key, o = n.children, s = new Set(t === !0 ? [] : t), l = [];
  function c(u) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return u.map(function(f, m) {
      for (var h = OG(d ? d.pos : "0", m), g = _h(f[i], h), y, S = 0; S < a.length; S += 1) {
        var x = a[S];
        if (f[x] !== void 0) {
          y = f[x];
          break;
        }
      }
      var b = Object.assign(bn(f, [].concat(ze(a), [i, o])), {
        title: y,
        key: g,
        parent: d,
        pos: h,
        children: null,
        data: f,
        isStart: [].concat(ze(d ? d.isStart : []), [m === 0]),
        isEnd: [].concat(ze(d ? d.isEnd : []), [m === u.length - 1])
      });
      return l.push(b), t === !0 || s.has(g) ? b.children = c(f[o] || [], b) : b.children = [], b;
    });
  }
  return c(e), l;
}
function sSe(e, t, r) {
  var n = {};
  kt(r) === "object" ? n = r : n = {
    externalGetKey: r
  }, n = n || {};
  var a = n, i = a.childrenPropName, o = a.externalGetKey, s = a.fieldNames, l = ud(s), c = l.key, u = l.children, d = i || u, f;
  o ? typeof o == "string" ? f = function(g) {
    return g[o];
  } : typeof o == "function" && (f = function(g) {
    return o(g);
  }) : f = function(g, y) {
    return _h(g[c], y);
  };
  function m(h, g, y, S) {
    var x = h ? h[d] : e, b = h ? OG(y.pos, g) : "0", _ = h ? [].concat(ze(S), [h]) : [];
    if (h) {
      var $ = f(h, b), w = {
        node: h,
        index: g,
        pos: b,
        key: $,
        parentPos: y.node ? y.pos : null,
        level: y.level + 1,
        nodes: _
      };
      t(w);
    }
    x && x.forEach(function(O, T) {
      m(O, T, {
        node: h,
        pos: b,
        level: y ? y.level + 1 : -1
      }, _);
    });
  }
  m(null);
}
function TI(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.initWrapper, n = t.processEntity, a = t.onProcessFinished, i = t.externalGetKey, o = t.childrenPropName, s = t.fieldNames, l = arguments.length > 2 ? arguments[2] : void 0, c = i || l, u = {}, d = {}, f = {
    posEntities: u,
    keyEntities: d
  };
  return r && (f = r(f) || f), sSe(e, function(m) {
    var h = m.node, g = m.index, y = m.pos, S = m.key, x = m.parentPos, b = m.level, _ = m.nodes, $ = {
      node: h,
      nodes: _,
      index: g,
      key: S,
      pos: y,
      level: b
    }, w = _h(S, y);
    u[y] = $, d[w] = $, $.parent = u[x], $.parent && ($.parent.children = $.parent.children || [], $.parent.children.push($)), n && n($, f);
  }, {
    externalGetKey: c,
    childrenPropName: o,
    fieldNames: s
  }), a && a(f), f;
}
function D0(e, t) {
  var r = t.expandedKeys, n = t.selectedKeys, a = t.loadedKeys, i = t.loadingKeys, o = t.checkedKeys, s = t.halfCheckedKeys, l = t.dragOverNodeKey, c = t.dropPosition, u = t.keyEntities, d = yi(u, e), f = {
    eventKey: e,
    expanded: r.indexOf(e) !== -1,
    selected: n.indexOf(e) !== -1,
    loaded: a.indexOf(e) !== -1,
    loading: i.indexOf(e) !== -1,
    checked: o.indexOf(e) !== -1,
    halfChecked: s.indexOf(e) !== -1,
    pos: String(d ? d.pos : ""),
    // [Legacy] Drag props
    // Since the interaction of drag is changed, the semantic of the props are
    // not accuracy, I think it should be finally removed
    dragOver: l === e && c === 0,
    dragOverGapTop: l === e && c === -1,
    dragOverGapBottom: l === e && c === 1
  };
  return f;
}
function la(e) {
  var t = e.data, r = e.expanded, n = e.selected, a = e.checked, i = e.loaded, o = e.loading, s = e.halfChecked, l = e.dragOver, c = e.dragOverGapTop, u = e.dragOverGapBottom, d = e.pos, f = e.active, m = e.eventKey, h = ce(ce({}, t), {}, {
    expanded: r,
    selected: n,
    checked: a,
    loaded: i,
    loading: o,
    halfChecked: s,
    dragOver: l,
    dragOverGapTop: c,
    dragOverGapBottom: u,
    pos: d,
    active: f,
    key: m
  });
  return "props" in h || Object.defineProperty(h, "props", {
    get: function() {
      return jt(!1, "Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`."), e;
    }
  }), h;
}
function IG(e, t) {
  var r = /* @__PURE__ */ new Set();
  return e.forEach(function(n) {
    t.has(n) || r.add(n);
  }), r;
}
function lSe(e) {
  var t = e || {}, r = t.disabled, n = t.disableCheckbox, a = t.checkable;
  return !!(r || n) || a === !1;
}
function cSe(e, t, r, n) {
  for (var a = new Set(e), i = /* @__PURE__ */ new Set(), o = 0; o <= r; o += 1) {
    var s = t.get(o) || /* @__PURE__ */ new Set();
    s.forEach(function(d) {
      var f = d.key, m = d.node, h = d.children, g = h === void 0 ? [] : h;
      a.has(f) && !n(m) && g.filter(function(y) {
        return !n(y.node);
      }).forEach(function(y) {
        a.add(y.key);
      });
    });
  }
  for (var l = /* @__PURE__ */ new Set(), c = r; c >= 0; c -= 1) {
    var u = t.get(c) || /* @__PURE__ */ new Set();
    u.forEach(function(d) {
      var f = d.parent, m = d.node;
      if (!(n(m) || !d.parent || l.has(d.parent.key))) {
        if (n(d.parent.node)) {
          l.add(f.key);
          return;
        }
        var h = !0, g = !1;
        (f.children || []).filter(function(y) {
          return !n(y.node);
        }).forEach(function(y) {
          var S = y.key, x = a.has(S);
          h && !x && (h = !1), !g && (x || i.has(S)) && (g = !0);
        }), h && a.add(f.key), g && i.add(f.key), l.add(f.key);
      }
    });
  }
  return {
    checkedKeys: Array.from(a),
    halfCheckedKeys: Array.from(IG(i, a))
  };
}
function uSe(e, t, r, n, a) {
  for (var i = new Set(e), o = new Set(t), s = 0; s <= n; s += 1) {
    var l = r.get(s) || /* @__PURE__ */ new Set();
    l.forEach(function(f) {
      var m = f.key, h = f.node, g = f.children, y = g === void 0 ? [] : g;
      !i.has(m) && !o.has(m) && !a(h) && y.filter(function(S) {
        return !a(S.node);
      }).forEach(function(S) {
        i.delete(S.key);
      });
    });
  }
  o = /* @__PURE__ */ new Set();
  for (var c = /* @__PURE__ */ new Set(), u = n; u >= 0; u -= 1) {
    var d = r.get(u) || /* @__PURE__ */ new Set();
    d.forEach(function(f) {
      var m = f.parent, h = f.node;
      if (!(a(h) || !f.parent || c.has(f.parent.key))) {
        if (a(f.parent.node)) {
          c.add(m.key);
          return;
        }
        var g = !0, y = !1;
        (m.children || []).filter(function(S) {
          return !a(S.node);
        }).forEach(function(S) {
          var x = S.key, b = i.has(x);
          g && !b && (g = !1), !y && (b || o.has(x)) && (y = !0);
        }), g || i.delete(m.key), y && o.add(m.key), c.add(m.key);
      }
    });
  }
  return {
    checkedKeys: Array.from(i),
    halfCheckedKeys: Array.from(IG(o, i))
  };
}
function rd(e, t, r, n) {
  var a = [], i;
  n ? i = n : i = lSe;
  var o = new Set(e.filter(function(u) {
    var d = !!yi(r, u);
    return d || a.push(u), d;
  })), s = /* @__PURE__ */ new Map(), l = 0;
  Object.keys(r).forEach(function(u) {
    var d = r[u], f = d.level, m = s.get(f);
    m || (m = /* @__PURE__ */ new Set(), s.set(f, m)), m.add(d), l = Math.max(l, f);
  }), jt(!a.length, "Tree missing follow keys: ".concat(a.slice(0, 100).map(function(u) {
    return "'".concat(u, "'");
  }).join(", ")));
  var c;
  return t === !0 ? c = cSe(o, s, l, i) : c = uSe(o, t.halfCheckedKeys, s, l, i), c;
}
const dSe = (e) => {
  const {
    checkboxCls: t
  } = e, r = `${t}-wrapper`;
  return [
    // ===================== Basic =====================
    {
      // Group
      [`${t}-group`]: Object.assign(Object.assign({}, Yr(e)), {
        display: "inline-flex",
        flexWrap: "wrap",
        columnGap: e.marginXS,
        // Group > Grid
        [`> ${e.antCls}-row`]: {
          flex: 1
        }
      }),
      // Wrapper
      [r]: Object.assign(Object.assign({}, Yr(e)), {
        display: "inline-flex",
        alignItems: "baseline",
        cursor: "pointer",
        // Fix checkbox & radio in flex align #30260
        "&:after": {
          display: "inline-block",
          width: 0,
          overflow: "hidden",
          content: "'\\a0'"
        },
        // Checkbox near checkbox
        [`& + ${r}`]: {
          marginInlineStart: 0
        },
        [`&${r}-in-form-item`]: {
          'input[type="checkbox"]': {
            width: 14,
            // FIXME: magic
            height: 14
            // FIXME: magic
          }
        }
      }),
      // Wrapper > Checkbox
      [t]: Object.assign(Object.assign({}, Yr(e)), {
        position: "relative",
        whiteSpace: "nowrap",
        lineHeight: 1,
        cursor: "pointer",
        borderRadius: e.borderRadiusSM,
        // To make alignment right when `controlHeight` is changed
        // Ref: https://github.com/ant-design/ant-design/issues/41564
        alignSelf: "center",
        // Wrapper > Checkbox > input
        [`${t}-input`]: {
          position: "absolute",
          // Since baseline align will get additional space offset,
          // we need to move input to top to make it align with text.
          // Ref: https://github.com/ant-design/ant-design/issues/38926#issuecomment-1486137799
          inset: 0,
          zIndex: 1,
          cursor: "pointer",
          opacity: 0,
          margin: 0,
          [`&:focus-visible + ${t}-inner`]: Object.assign({}, Sl(e))
        },
        // Wrapper > Checkbox > inner
        [`${t}-inner`]: {
          boxSizing: "border-box",
          display: "block",
          width: e.checkboxSize,
          height: e.checkboxSize,
          direction: "ltr",
          backgroundColor: e.colorBgContainer,
          border: `${ve(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderRadius: e.borderRadiusSM,
          borderCollapse: "separate",
          transition: `all ${e.motionDurationSlow}`,
          "&:after": {
            boxSizing: "border-box",
            position: "absolute",
            top: "50%",
            insetInlineStart: "25%",
            display: "table",
            width: e.calc(e.checkboxSize).div(14).mul(5).equal(),
            height: e.calc(e.checkboxSize).div(14).mul(8).equal(),
            border: `${ve(e.lineWidthBold)} solid ${e.colorWhite}`,
            borderTop: 0,
            borderInlineStart: 0,
            transform: "rotate(45deg) scale(0) translate(-50%,-50%)",
            opacity: 0,
            content: '""',
            transition: `all ${e.motionDurationFast} ${e.motionEaseInBack}, opacity ${e.motionDurationFast}`
          }
        },
        // Wrapper > Checkbox + Text
        "& + span": {
          paddingInlineStart: e.paddingXS,
          paddingInlineEnd: e.paddingXS
        }
      })
    },
    // ===================== Hover =====================
    {
      // Wrapper & Wrapper > Checkbox
      [`
        ${r}:not(${r}-disabled),
        ${t}:not(${t}-disabled)
      `]: {
        [`&:hover ${t}-inner`]: {
          borderColor: e.colorPrimary
        }
      },
      [`${r}:not(${r}-disabled)`]: {
        [`&:hover ${t}-checked:not(${t}-disabled) ${t}-inner`]: {
          backgroundColor: e.colorPrimaryHover,
          borderColor: "transparent"
        },
        [`&:hover ${t}-checked:not(${t}-disabled):after`]: {
          borderColor: e.colorPrimaryHover
        }
      }
    },
    // ==================== Checked ====================
    {
      // Wrapper > Checkbox
      [`${t}-checked`]: {
        [`${t}-inner`]: {
          backgroundColor: e.colorPrimary,
          borderColor: e.colorPrimary,
          "&:after": {
            opacity: 1,
            transform: "rotate(45deg) scale(1) translate(-50%,-50%)",
            transition: `all ${e.motionDurationMid} ${e.motionEaseOutBack} ${e.motionDurationFast}`
          }
        }
      },
      [`
        ${r}-checked:not(${r}-disabled),
        ${t}-checked:not(${t}-disabled)
      `]: {
        [`&:hover ${t}-inner`]: {
          backgroundColor: e.colorPrimaryHover,
          borderColor: "transparent"
        }
      }
    },
    // ================= Indeterminate =================
    {
      [t]: {
        "&-indeterminate": {
          // Wrapper > Checkbox > inner
          [`${t}-inner`]: {
            backgroundColor: e.colorBgContainer,
            borderColor: e.colorBorder,
            "&:after": {
              top: "50%",
              insetInlineStart: "50%",
              width: e.calc(e.fontSizeLG).div(2).equal(),
              height: e.calc(e.fontSizeLG).div(2).equal(),
              backgroundColor: e.colorPrimary,
              border: 0,
              transform: "translate(-50%, -50%) scale(1)",
              opacity: 1,
              content: '""'
            }
          }
        }
      }
    },
    // ==================== Disable ====================
    {
      // Wrapper
      [`${r}-disabled`]: {
        cursor: "not-allowed"
      },
      // Wrapper > Checkbox
      [`${t}-disabled`]: {
        // Wrapper > Checkbox > input
        [`&, ${t}-input`]: {
          cursor: "not-allowed",
          // Disabled for native input to enable Tooltip event handler
          // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-1365075901
          pointerEvents: "none"
        },
        // Wrapper > Checkbox > inner
        [`${t}-inner`]: {
          background: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          "&:after": {
            borderColor: e.colorTextDisabled
          }
        },
        "&:after": {
          display: "none"
        },
        "& + span": {
          color: e.colorTextDisabled
        },
        [`&${t}-indeterminate ${t}-inner::after`]: {
          background: e.colorTextDisabled
        }
      }
    }
  ];
};
function MG(e, t) {
  const r = $r(t, {
    checkboxCls: `.${e}`,
    checkboxSize: t.controlInteractiveSize
  });
  return [dSe(r)];
}
const AG = Zr("Checkbox", (e, t) => {
  let {
    prefixCls: r
  } = t;
  return [MG(r, e)];
}), PG = /* @__PURE__ */ xe.createContext(null);
var fSe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const pSe = (e, t) => {
  var r;
  const {
    prefixCls: n,
    className: a,
    rootClassName: i,
    children: o,
    indeterminate: s = !1,
    style: l,
    onMouseEnter: c,
    onMouseLeave: u,
    skipGroup: d = !1,
    disabled: f
  } = e, m = fSe(e, ["prefixCls", "className", "rootClassName", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave", "skipGroup", "disabled"]), {
    getPrefixCls: h,
    direction: g,
    checkbox: y
  } = p.useContext(Lt), S = p.useContext(PG), {
    isFormItemInput: x
  } = p.useContext(xa), b = p.useContext(Vi), _ = (r = S?.disabled || f) !== null && r !== void 0 ? r : b, $ = p.useRef(m.value);
  if (process.env.NODE_ENV !== "production") {
    const z = xr("Checkbox");
    process.env.NODE_ENV !== "production" && z("checked" in m || !!S || !("value" in m), "usage", "`value` is not a valid prop, do you mean `checked`?");
  }
  p.useEffect(() => {
    S?.registerValue(m.value);
  }, []), p.useEffect(() => {
    if (!d)
      return m.value !== $.current && (S?.cancelValue($.current), S?.registerValue(m.value), $.current = m.value), () => S?.cancelValue(m.value);
  }, [m.value]);
  const w = h("checkbox", n), O = Mn(w), [T, I, P] = AG(w, O), D = Object.assign({}, m);
  S && !d && (D.onChange = function() {
    m.onChange && m.onChange.apply(m, arguments), S.toggleOption && S.toggleOption({
      label: o,
      value: m.value
    });
  }, D.name = S.name, D.checked = S.value.includes(m.value));
  const B = be(`${w}-wrapper`, {
    [`${w}-rtl`]: g === "rtl",
    [`${w}-wrapper-checked`]: D.checked,
    [`${w}-wrapper-disabled`]: _,
    [`${w}-wrapper-in-form-item`]: x
  }, y?.className, a, i, P, O, I), L = be({
    [`${w}-indeterminate`]: s
  }, $1, I), N = s ? "mixed" : void 0;
  return T(/* @__PURE__ */ p.createElement(ch, {
    component: "Checkbox",
    disabled: _
  }, /* @__PURE__ */ p.createElement("label", {
    className: B,
    style: Object.assign(Object.assign({}, y?.style), l),
    onMouseEnter: c,
    onMouseLeave: u
  }, /* @__PURE__ */ p.createElement(uG, Object.assign({
    "aria-checked": N
  }, D, {
    prefixCls: w,
    className: L,
    disabled: _,
    ref: t
  })), o !== void 0 && /* @__PURE__ */ p.createElement("span", null, o))));
}, II = /* @__PURE__ */ p.forwardRef(pSe);
process.env.NODE_ENV !== "production" && (II.displayName = "Checkbox");
var mSe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const vSe = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    defaultValue: r,
    children: n,
    options: a = [],
    prefixCls: i,
    className: o,
    rootClassName: s,
    style: l,
    onChange: c
  } = e, u = mSe(e, ["defaultValue", "children", "options", "prefixCls", "className", "rootClassName", "style", "onChange"]), {
    getPrefixCls: d,
    direction: f
  } = p.useContext(Lt), [m, h] = p.useState(u.value || r || []), [g, y] = p.useState([]);
  p.useEffect(() => {
    "value" in u && h(u.value || []);
  }, [u.value]);
  const S = p.useMemo(() => a.map((z) => typeof z == "string" || typeof z == "number" ? {
    label: z,
    value: z
  } : z), [a]), x = (z) => {
    y((F) => F.filter((j) => j !== z));
  }, b = (z) => {
    y((F) => [].concat(ze(F), [z]));
  }, _ = (z) => {
    const F = m.indexOf(z.value), j = ze(m);
    F === -1 ? j.push(z.value) : j.splice(F, 1), "value" in u || h(j), c?.(j.filter((H) => g.includes(H)).sort((H, U) => {
      const G = S.findIndex((K) => K.value === H), V = S.findIndex((K) => K.value === U);
      return G - V;
    }));
  }, $ = d("checkbox", i), w = `${$}-group`, O = Mn($), [T, I, P] = AG($, O), D = bn(u, ["value", "disabled"]), B = a.length ? S.map((z) => /* @__PURE__ */ p.createElement(II, {
    prefixCls: $,
    key: z.value.toString(),
    disabled: "disabled" in z ? z.disabled : u.disabled,
    value: z.value,
    checked: m.includes(z.value),
    onChange: z.onChange,
    className: `${w}-item`,
    style: z.style,
    title: z.title,
    id: z.id,
    required: z.required
  }, z.label)) : n, L = {
    toggleOption: _,
    value: m,
    disabled: u.disabled,
    name: u.name,
    // https://github.com/ant-design/ant-design/issues/16376
    registerValue: b,
    cancelValue: x
  }, N = be(w, {
    [`${w}-rtl`]: f === "rtl"
  }, o, s, P, O, I);
  return T(/* @__PURE__ */ p.createElement("div", Object.assign({
    className: N,
    style: l
  }, D, {
    ref: t
  }), /* @__PURE__ */ p.createElement(PG.Provider, {
    value: L
  }, B)));
}), co = II;
co.Group = vSe;
co.__ANT_CHECKBOX = !0;
process.env.NODE_ENV !== "production" && (co.displayName = "Checkbox");
const RG = /* @__PURE__ */ Ws({}), hSe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // Grid system
    [t]: {
      display: "flex",
      flexFlow: "row wrap",
      minWidth: 0,
      "&::before, &::after": {
        display: "flex"
      },
      "&-no-wrap": {
        flexWrap: "nowrap"
      },
      // The origin of the X-axis
      "&-start": {
        justifyContent: "flex-start"
      },
      // The center of the X-axis
      "&-center": {
        justifyContent: "center"
      },
      // The opposite of the X-axis
      "&-end": {
        justifyContent: "flex-end"
      },
      "&-space-between": {
        justifyContent: "space-between"
      },
      "&-space-around": {
        justifyContent: "space-around"
      },
      "&-space-evenly": {
        justifyContent: "space-evenly"
      },
      // Align at the top
      "&-top": {
        alignItems: "flex-start"
      },
      // Align at the center
      "&-middle": {
        alignItems: "center"
      },
      "&-bottom": {
        alignItems: "flex-end"
      }
    }
  };
}, gSe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // Grid system
    [t]: {
      position: "relative",
      maxWidth: "100%",
      // Prevent columns from collapsing when empty
      minHeight: 1
    }
  };
}, ySe = (e, t) => {
  const {
    prefixCls: r,
    componentCls: n,
    gridColumns: a
  } = e, i = {};
  for (let o = a; o >= 0; o--)
    o === 0 ? (i[`${n}${t}-${o}`] = {
      display: "none"
    }, i[`${n}-push-${o}`] = {
      insetInlineStart: "auto"
    }, i[`${n}-pull-${o}`] = {
      insetInlineEnd: "auto"
    }, i[`${n}${t}-push-${o}`] = {
      insetInlineStart: "auto"
    }, i[`${n}${t}-pull-${o}`] = {
      insetInlineEnd: "auto"
    }, i[`${n}${t}-offset-${o}`] = {
      marginInlineStart: 0
    }, i[`${n}${t}-order-${o}`] = {
      order: 0
    }) : (i[`${n}${t}-${o}`] = [
      // https://github.com/ant-design/ant-design/issues/44456
      // Form set `display: flex` on Col which will override `display: block`.
      // Let's get it from css variable to support override.
      {
        "--ant-display": "block",
        // Fallback to display if variable not support
        display: "block"
      },
      {
        display: "var(--ant-display)",
        flex: `0 0 ${o / a * 100}%`,
        maxWidth: `${o / a * 100}%`
      }
    ], i[`${n}${t}-push-${o}`] = {
      insetInlineStart: `${o / a * 100}%`
    }, i[`${n}${t}-pull-${o}`] = {
      insetInlineEnd: `${o / a * 100}%`
    }, i[`${n}${t}-offset-${o}`] = {
      marginInlineStart: `${o / a * 100}%`
    }, i[`${n}${t}-order-${o}`] = {
      order: o
    });
  return i[`${n}${t}-flex`] = {
    flex: `var(--${r}${t}-flex)`
  }, i;
}, oE = (e, t) => ySe(e, t), bSe = (e, t, r) => ({
  [`@media (min-width: ${ve(t)})`]: Object.assign({}, oE(e, r))
}), CSe = () => ({}), SSe = () => ({}), xSe = Zr("Grid", hSe, CSe), $Se = Zr("Grid", (e) => {
  const t = $r(e, {
    gridColumns: 24
    // Row is divided into 24 parts in Grid
  }), r = {
    "-sm": t.screenSMMin,
    "-md": t.screenMDMin,
    "-lg": t.screenLGMin,
    "-xl": t.screenXLMin,
    "-xxl": t.screenXXLMin
  };
  return [gSe(t), oE(t, ""), oE(t, "-xs"), Object.keys(r).map((n) => bSe(t, r[n], n)).reduce((n, a) => Object.assign(Object.assign({}, n), a), {})];
}, SSe);
var _Se = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function n4(e) {
  return typeof e == "number" ? `${e} ${e} auto` : /^\d+(\.\d+)?(px|em|rem|%)$/.test(e) ? `0 0 ${e}` : e;
}
const ESe = ["xs", "sm", "md", "lg", "xl", "xxl"], Oe = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    getPrefixCls: r,
    direction: n
  } = p.useContext(Lt), {
    gutter: a,
    wrap: i
  } = p.useContext(RG), {
    prefixCls: o,
    span: s,
    order: l,
    offset: c,
    push: u,
    pull: d,
    className: f,
    children: m,
    flex: h,
    style: g
  } = e, y = _Se(e, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children", "flex", "style"]), S = r("col", o), [x, b, _] = $Se(S), $ = {};
  let w = {};
  ESe.forEach((I) => {
    let P = {};
    const D = e[I];
    typeof D == "number" ? P.span = D : typeof D == "object" && (P = D || {}), delete y[I], w = Object.assign(Object.assign({}, w), {
      [`${S}-${I}-${P.span}`]: P.span !== void 0,
      [`${S}-${I}-order-${P.order}`]: P.order || P.order === 0,
      [`${S}-${I}-offset-${P.offset}`]: P.offset || P.offset === 0,
      [`${S}-${I}-push-${P.push}`]: P.push || P.push === 0,
      [`${S}-${I}-pull-${P.pull}`]: P.pull || P.pull === 0,
      [`${S}-rtl`]: n === "rtl"
    }), P.flex && (w[`${S}-${I}-flex`] = !0, $[`--${S}-${I}-flex`] = n4(P.flex));
  });
  const O = be(S, {
    [`${S}-${s}`]: s !== void 0,
    [`${S}-order-${l}`]: l,
    [`${S}-offset-${c}`]: c,
    [`${S}-push-${u}`]: u,
    [`${S}-pull-${d}`]: d
  }, f, w, b, _), T = {};
  if (a && a[0] > 0) {
    const I = a[0] / 2;
    T.paddingLeft = I, T.paddingRight = I;
  }
  return h && (T.flex = n4(h), i === !1 && !T.minWidth && (T.minWidth = 0)), x(/* @__PURE__ */ p.createElement("div", Object.assign({}, y, {
    style: Object.assign(Object.assign(Object.assign({}, T), g), $),
    className: O,
    ref: t
  }), m));
});
process.env.NODE_ENV !== "production" && (Oe.displayName = "Col");
var wSe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function a4(e, t) {
  const [r, n] = p.useState(typeof e == "string" ? e : ""), a = () => {
    if (typeof e == "string" && n(e), typeof e == "object")
      for (let i = 0; i < X0.length; i++) {
        const o = X0[i];
        if (!t[o])
          continue;
        const s = e[o];
        if (s !== void 0) {
          n(s);
          return;
        }
      }
  };
  return p.useEffect(() => {
    a();
  }, [JSON.stringify(e), t]), r;
}
const At = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    prefixCls: r,
    justify: n,
    align: a,
    className: i,
    style: o,
    children: s,
    gutter: l = 0,
    wrap: c
  } = e, u = wSe(e, ["prefixCls", "justify", "align", "className", "style", "children", "gutter", "wrap"]), {
    getPrefixCls: d,
    direction: f
  } = p.useContext(Lt), [m, h] = p.useState({
    xs: !0,
    sm: !0,
    md: !0,
    lg: !0,
    xl: !0,
    xxl: !0
  }), [g, y] = p.useState({
    xs: !1,
    sm: !1,
    md: !1,
    lg: !1,
    xl: !1,
    xxl: !1
  }), S = a4(a, g), x = a4(n, g), b = p.useRef(l), _ = UH();
  p.useEffect(() => {
    const j = _.subscribe((H) => {
      y(H);
      const U = b.current || 0;
      (!Array.isArray(U) && typeof U == "object" || Array.isArray(U) && (typeof U[0] == "object" || typeof U[1] == "object")) && h(H);
    });
    return () => _.unsubscribe(j);
  }, []);
  const $ = () => {
    const j = [void 0, void 0];
    return (Array.isArray(l) ? l : [l, void 0]).forEach((U, G) => {
      if (typeof U == "object")
        for (let V = 0; V < X0.length; V++) {
          const K = X0[V];
          if (m[K] && U[K] !== void 0) {
            j[G] = U[K];
            break;
          }
        }
      else
        j[G] = U;
    }), j;
  }, w = d("row", r), [O, T, I] = xSe(w), P = $(), D = be(w, {
    [`${w}-no-wrap`]: c === !1,
    [`${w}-${x}`]: x,
    [`${w}-${S}`]: S,
    [`${w}-rtl`]: f === "rtl"
  }, i, T, I), B = {}, L = P[0] != null && P[0] > 0 ? P[0] / -2 : void 0;
  L && (B.marginLeft = L, B.marginRight = L);
  const [N, z] = P;
  B.rowGap = z;
  const F = p.useMemo(() => ({
    gutter: [N, z],
    wrap: c
  }), [N, z, c]);
  return O(/* @__PURE__ */ p.createElement(RG.Provider, {
    value: F
  }, /* @__PURE__ */ p.createElement("div", Object.assign({}, u, {
    className: D,
    style: Object.assign(Object.assign({}, B), o),
    ref: t
  }), s)));
});
process.env.NODE_ENV !== "production" && (At.displayName = "Row");
const OSe = (e) => {
  const {
    componentCls: t,
    sizePaddingEdgeHorizontal: r,
    colorSplit: n,
    lineWidth: a,
    textPaddingInline: i,
    orientationMargin: o,
    verticalMarginInline: s
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, Yr(e)), {
      borderBlockStart: `${ve(a)} solid ${n}`,
      // vertical
      "&-vertical": {
        position: "relative",
        top: "-0.06em",
        display: "inline-block",
        height: "0.9em",
        marginInline: s,
        marginBlock: 0,
        verticalAlign: "middle",
        borderTop: 0,
        borderInlineStart: `${ve(a)} solid ${n}`
      },
      "&-horizontal": {
        display: "flex",
        clear: "both",
        width: "100%",
        minWidth: "100%",
        // Fix https://github.com/ant-design/ant-design/issues/10914
        margin: `${ve(e.dividerHorizontalGutterMargin)} 0`
      },
      [`&-horizontal${t}-with-text`]: {
        display: "flex",
        alignItems: "center",
        margin: `${ve(e.dividerHorizontalWithTextGutterMargin)} 0`,
        color: e.colorTextHeading,
        fontWeight: 500,
        fontSize: e.fontSizeLG,
        whiteSpace: "nowrap",
        textAlign: "center",
        borderBlockStart: `0 ${n}`,
        "&::before, &::after": {
          position: "relative",
          width: "50%",
          borderBlockStart: `${ve(a)} solid transparent`,
          // Chrome not accept `inherit` in `border-top`
          borderBlockStartColor: "inherit",
          borderBlockEnd: 0,
          transform: "translateY(50%)",
          content: "''"
        }
      },
      [`&-horizontal${t}-with-text-left`]: {
        "&::before": {
          width: `calc(${o} * 100%)`
        },
        "&::after": {
          width: `calc(100% - ${o} * 100%)`
        }
      },
      [`&-horizontal${t}-with-text-right`]: {
        "&::before": {
          width: `calc(100% - ${o} * 100%)`
        },
        "&::after": {
          width: `calc(${o} * 100%)`
        }
      },
      [`${t}-inner-text`]: {
        display: "inline-block",
        paddingBlock: 0,
        paddingInline: i
      },
      "&-dashed": {
        background: "none",
        borderColor: n,
        borderStyle: "dashed",
        borderWidth: `${ve(a)} 0 0`
      },
      [`&-horizontal${t}-with-text${t}-dashed`]: {
        "&::before, &::after": {
          borderStyle: "dashed none none"
        }
      },
      [`&-vertical${t}-dashed`]: {
        borderInlineStartWidth: a,
        borderInlineEnd: 0,
        borderBlockStart: 0,
        borderBlockEnd: 0
      },
      [`&-plain${t}-with-text`]: {
        color: e.colorText,
        fontWeight: "normal",
        fontSize: e.fontSize
      },
      [`&-horizontal${t}-with-text-left${t}-no-default-orientation-margin-left`]: {
        "&::before": {
          width: 0
        },
        "&::after": {
          width: "100%"
        },
        [`${t}-inner-text`]: {
          paddingInlineStart: r
        }
      },
      [`&-horizontal${t}-with-text-right${t}-no-default-orientation-margin-right`]: {
        "&::before": {
          width: "100%"
        },
        "&::after": {
          width: 0
        },
        [`${t}-inner-text`]: {
          paddingInlineEnd: r
        }
      }
    })
  };
}, TSe = (e) => ({
  textPaddingInline: "1em",
  orientationMargin: 0.05,
  verticalMarginInline: e.marginXS
}), ISe = Zr("Divider", (e) => {
  const t = $r(e, {
    dividerHorizontalWithTextGutterMargin: e.margin,
    dividerHorizontalGutterMargin: e.marginLG,
    sizePaddingEdgeHorizontal: 0
  });
  return [OSe(t)];
}, TSe, {
  unitless: {
    orientationMargin: !0
  }
});
var MSe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const Eh = (e) => {
  const {
    getPrefixCls: t,
    direction: r,
    divider: n
  } = p.useContext(Lt), {
    prefixCls: a,
    type: i = "horizontal",
    orientation: o = "center",
    orientationMargin: s,
    className: l,
    rootClassName: c,
    children: u,
    dashed: d,
    plain: f,
    style: m
  } = e, h = MSe(e, ["prefixCls", "type", "orientation", "orientationMargin", "className", "rootClassName", "children", "dashed", "plain", "style"]), g = t("divider", a), [y, S, x] = ISe(g), b = !!u, _ = o === "left" && s != null, $ = o === "right" && s != null, w = be(g, n?.className, S, x, `${g}-${i}`, {
    [`${g}-with-text`]: b,
    [`${g}-with-text-${o}`]: b,
    [`${g}-dashed`]: !!d,
    [`${g}-plain`]: !!f,
    [`${g}-rtl`]: r === "rtl",
    [`${g}-no-default-orientation-margin-left`]: _,
    [`${g}-no-default-orientation-margin-right`]: $
  }, l, c), O = p.useMemo(() => typeof s == "number" ? s : /^\d+$/.test(s) ? Number(s) : s, [s]), T = Object.assign(Object.assign({}, _ && {
    marginLeft: O
  }), $ && {
    marginRight: O
  });
  if (process.env.NODE_ENV !== "production") {
    const I = xr("Divider");
    process.env.NODE_ENV !== "production" && I(!u || i !== "vertical", "usage", "`children` not working in `vertical` mode.");
  }
  return y(/* @__PURE__ */ p.createElement("div", Object.assign({
    className: w,
    style: Object.assign(Object.assign({}, n?.style), m)
  }, h, {
    role: "separator"
  }), u && i !== "vertical" && /* @__PURE__ */ p.createElement("span", {
    className: `${g}-inner-text`,
    style: T
  }, u)));
};
process.env.NODE_ENV !== "production" && (Eh.displayName = "Divider");
var ASe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" } }] }, name: "up", theme: "outlined" }, PSe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: ASe
  }));
}, NG = /* @__PURE__ */ p.forwardRef(PSe);
process.env.NODE_ENV !== "production" && (NG.displayName = "UpOutlined");
function sE() {
  return typeof BigInt == "function";
}
function DG(e) {
  return !e && e !== 0 && !Number.isNaN(e) || !String(e).trim();
}
function yc(e) {
  var t = e.trim(), r = t.startsWith("-");
  r && (t = t.slice(1)), t = t.replace(/(\.\d*[^0])0*$/, "$1").replace(/\.0*$/, "").replace(/^0+/, ""), t.startsWith(".") && (t = "0".concat(t));
  var n = t || "0", a = n.split("."), i = a[0] || "0", o = a[1] || "0";
  i === "0" && o === "0" && (r = !1);
  var s = r ? "-" : "";
  return {
    negative: r,
    negativeStr: s,
    trimStr: n,
    integerStr: i,
    decimalStr: o,
    fullStr: "".concat(s).concat(n)
  };
}
function MI(e) {
  var t = String(e);
  return !Number.isNaN(Number(t)) && t.includes("e");
}
function fc(e) {
  var t = String(e);
  if (MI(e)) {
    var r = Number(t.slice(t.indexOf("e-") + 2)), n = t.match(/\.(\d+)/);
    return n != null && n[1] && (r += n[1].length), r;
  }
  return t.includes(".") && AI(t) ? t.length - t.indexOf(".") - 1 : 0;
}
function Y1(e) {
  var t = String(e);
  if (MI(e)) {
    if (e > Number.MAX_SAFE_INTEGER)
      return String(sE() ? BigInt(e).toString() : Number.MAX_SAFE_INTEGER);
    if (e < Number.MIN_SAFE_INTEGER)
      return String(sE() ? BigInt(e).toString() : Number.MIN_SAFE_INTEGER);
    t = e.toFixed(fc(t));
  }
  return yc(t).fullStr;
}
function AI(e) {
  return typeof e == "number" ? !Number.isNaN(e) : e ? (
    // Normal type: 11.28
    /^\s*-?\d+(\.\d+)?\s*$/.test(e) || // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(e) || // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(e)
  ) : !1;
}
var RSe = /* @__PURE__ */ function() {
  function e(t) {
    if (Hn(this, e), te(this, "origin", ""), te(this, "negative", void 0), te(this, "integer", void 0), te(this, "decimal", void 0), te(this, "decimalLen", void 0), te(this, "empty", void 0), te(this, "nan", void 0), DG(t)) {
      this.empty = !0;
      return;
    }
    if (this.origin = String(t), t === "-" || Number.isNaN(t)) {
      this.nan = !0;
      return;
    }
    var r = t;
    if (MI(r) && (r = Number(r)), r = typeof r == "string" ? r : Y1(r), AI(r)) {
      var n = yc(r);
      this.negative = n.negative;
      var a = n.trimStr.split(".");
      this.integer = BigInt(a[0]);
      var i = a[1] || "0";
      this.decimal = BigInt(i), this.decimalLen = i.length;
    } else
      this.nan = !0;
  }
  return Vn(e, [{
    key: "getMark",
    value: function() {
      return this.negative ? "-" : "";
    }
  }, {
    key: "getIntegerStr",
    value: function() {
      return this.integer.toString();
    }
    /**
     * @private get decimal string
     */
  }, {
    key: "getDecimalStr",
    value: function() {
      return this.decimal.toString().padStart(this.decimalLen, "0");
    }
    /**
     * @private Align BigIntDecimal with same decimal length. e.g. 12.3 + 5 = 1230000
     * This is used for add function only.
     */
  }, {
    key: "alignDecimal",
    value: function(r) {
      var n = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(r, "0"));
      return BigInt(n);
    }
  }, {
    key: "negate",
    value: function() {
      var r = new e(this.toString());
      return r.negative = !r.negative, r;
    }
  }, {
    key: "cal",
    value: function(r, n, a) {
      var i = Math.max(this.getDecimalStr().length, r.getDecimalStr().length), o = this.alignDecimal(i), s = r.alignDecimal(i), l = n(o, s).toString(), c = a(i), u = yc(l), d = u.negativeStr, f = u.trimStr, m = "".concat(d).concat(f.padStart(c + 1, "0"));
      return new e("".concat(m.slice(0, -c), ".").concat(m.slice(-c)));
    }
  }, {
    key: "add",
    value: function(r) {
      if (this.isInvalidate())
        return new e(r);
      var n = new e(r);
      return n.isInvalidate() ? this : this.cal(n, function(a, i) {
        return a + i;
      }, function(a) {
        return a;
      });
    }
  }, {
    key: "multi",
    value: function(r) {
      var n = new e(r);
      return this.isInvalidate() || n.isInvalidate() ? new e(NaN) : this.cal(n, function(a, i) {
        return a * i;
      }, function(a) {
        return a * 2;
      });
    }
  }, {
    key: "isEmpty",
    value: function() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function() {
      return this.nan;
    }
  }, {
    key: "isInvalidate",
    value: function() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function(r) {
      return this.toString() === r?.toString();
    }
  }, {
    key: "lessEquals",
    value: function(r) {
      return this.add(r.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function() {
      return this.isNaN() ? NaN : Number(this.toString());
    }
  }, {
    key: "toString",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      return r ? this.isInvalidate() ? "" : yc("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr : this.origin;
    }
  }]), e;
}(), NSe = /* @__PURE__ */ function() {
  function e(t) {
    if (Hn(this, e), te(this, "origin", ""), te(this, "number", void 0), te(this, "empty", void 0), DG(t)) {
      this.empty = !0;
      return;
    }
    this.origin = String(t), this.number = Number(t);
  }
  return Vn(e, [{
    key: "negate",
    value: function() {
      return new e(-this.toNumber());
    }
  }, {
    key: "add",
    value: function(r) {
      if (this.isInvalidate())
        return new e(r);
      var n = Number(r);
      if (Number.isNaN(n))
        return this;
      var a = this.number + n;
      if (a > Number.MAX_SAFE_INTEGER)
        return new e(Number.MAX_SAFE_INTEGER);
      if (a < Number.MIN_SAFE_INTEGER)
        return new e(Number.MIN_SAFE_INTEGER);
      var i = Math.max(fc(this.number), fc(n));
      return new e(a.toFixed(i));
    }
  }, {
    key: "multi",
    value: function(r) {
      var n = Number(r);
      if (this.isInvalidate() || Number.isNaN(n))
        return new e(NaN);
      var a = this.number * n;
      if (a > Number.MAX_SAFE_INTEGER)
        return new e(Number.MAX_SAFE_INTEGER);
      if (a < Number.MIN_SAFE_INTEGER)
        return new e(Number.MIN_SAFE_INTEGER);
      var i = Math.max(fc(this.number), fc(n));
      return new e(a.toFixed(i));
    }
  }, {
    key: "isEmpty",
    value: function() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.number);
    }
  }, {
    key: "isInvalidate",
    value: function() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function(r) {
      return this.toNumber() === r?.toNumber();
    }
  }, {
    key: "lessEquals",
    value: function(r) {
      return this.add(r.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function() {
      return this.number;
    }
  }, {
    key: "toString",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      return r ? this.isInvalidate() ? "" : Y1(this.number) : this.origin;
    }
  }]), e;
}();
function _o(e) {
  return sE() ? new RSe(e) : new NSe(e);
}
function pb(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (e === "")
    return "";
  var a = yc(e), i = a.negativeStr, o = a.integerStr, s = a.decimalStr, l = "".concat(t).concat(s), c = "".concat(i).concat(o);
  if (r >= 0) {
    var u = Number(s[r]);
    if (u >= 5 && !n) {
      var d = _o(e).add("".concat(i, "0.").concat("0".repeat(r)).concat(10 - u));
      return pb(d.toString(), t, r, n);
    }
    return r === 0 ? c : "".concat(c).concat(t).concat(s.padEnd(r, "0").slice(0, r));
  }
  return l === ".0" ? c : "".concat(c).concat(l);
}
function DSe(e) {
  return !!(e.addonBefore || e.addonAfter);
}
function jSe(e) {
  return !!(e.prefix || e.suffix || e.allowClear);
}
function i4(e, t, r) {
  var n = t.cloneNode(!0), a = Object.create(e, {
    target: {
      value: n
    },
    currentTarget: {
      value: n
    }
  });
  return n.value = r, typeof t.selectionStart == "number" && typeof t.selectionEnd == "number" && (n.selectionStart = t.selectionStart, n.selectionEnd = t.selectionEnd), n.setSelectionRange = function() {
    t.setSelectionRange.apply(t, arguments);
  }, a;
}
function zb(e, t, r, n) {
  if (r) {
    var a = t;
    if (t.type === "click") {
      a = i4(t, e, ""), r(a);
      return;
    }
    if (e.type !== "file" && n !== void 0) {
      a = i4(t, e, n), r(a);
      return;
    }
    r(a);
  }
}
function jG(e, t) {
  if (e) {
    e.focus(t);
    var r = t || {}, n = r.cursor;
    if (n) {
      var a = e.value.length;
      switch (n) {
        case "start":
          e.setSelectionRange(0, 0);
          break;
        case "end":
          e.setSelectionRange(a, a);
          break;
        default:
          e.setSelectionRange(0, a);
      }
    }
  }
}
var PI = /* @__PURE__ */ xe.forwardRef(function(e, t) {
  var r, n, a = e.inputElement, i = e.children, o = e.prefixCls, s = e.prefix, l = e.suffix, c = e.addonBefore, u = e.addonAfter, d = e.className, f = e.style, m = e.disabled, h = e.readOnly, g = e.focused, y = e.triggerFocus, S = e.allowClear, x = e.value, b = e.handleReset, _ = e.hidden, $ = e.classes, w = e.classNames, O = e.dataAttrs, T = e.styles, I = e.components, P = i ?? a, D = I?.affixWrapper || "span", B = I?.groupWrapper || "span", L = I?.wrapper || "span", N = I?.groupAddon || "span", z = ct(null), F = function(me) {
    var k;
    (k = z.current) !== null && k !== void 0 && k.contains(me.target) && y?.();
  }, j = jSe(e), H = /* @__PURE__ */ Tle(P, {
    value: x,
    className: be(P.props.className, !j && w?.variant) || null
  }), U = ct(null);
  if (xe.useImperativeHandle(t, function() {
    return {
      nativeElement: U.current || z.current
    };
  }), j) {
    var G, V = null;
    if (S) {
      var K, Z = !m && !h && x, ee = "".concat(o, "-clear-icon"), ae = kt(S) === "object" && S !== null && S !== void 0 && S.clearIcon ? S.clearIcon : "✖";
      V = /* @__PURE__ */ xe.createElement("span", {
        onClick: b,
        onMouseDown: function(me) {
          return me.preventDefault();
        },
        className: be(ee, (K = {}, te(K, "".concat(ee, "-hidden"), !Z), te(K, "".concat(ee, "-has-suffix"), !!l), K)),
        role: "button",
        tabIndex: -1
      }, ae);
    }
    var ue = "".concat(o, "-affix-wrapper"), re = be(ue, (G = {}, te(G, "".concat(o, "-disabled"), m), te(G, "".concat(ue, "-disabled"), m), te(G, "".concat(ue, "-focused"), g), te(G, "".concat(ue, "-readonly"), h), te(G, "".concat(ue, "-input-with-clear-btn"), l && S && x), G), $?.affixWrapper, w?.affixWrapper, w?.variant), oe = (l || S) && /* @__PURE__ */ xe.createElement("span", {
      className: be("".concat(o, "-suffix"), w?.suffix),
      style: T?.suffix
    }, V, l);
    H = /* @__PURE__ */ xe.createElement(D, Pe({
      className: re,
      style: T?.affixWrapper,
      onClick: F
    }, O?.affixWrapper, {
      ref: z
    }), s && /* @__PURE__ */ xe.createElement("span", {
      className: be("".concat(o, "-prefix"), w?.prefix),
      style: T?.prefix
    }, s), H, oe);
  }
  if (DSe(e)) {
    var fe = "".concat(o, "-group"), le = "".concat(fe, "-addon"), se = "".concat(fe, "-wrapper"), Q = be("".concat(o, "-wrapper"), fe, $?.wrapper, w?.wrapper), he = be(se, te({}, "".concat(se, "-disabled"), m), $?.group, w?.groupWrapper);
    H = /* @__PURE__ */ xe.createElement(B, {
      className: he,
      ref: U
    }, /* @__PURE__ */ xe.createElement(L, {
      className: Q
    }, c && /* @__PURE__ */ xe.createElement(N, {
      className: le
    }, c), H, u && /* @__PURE__ */ xe.createElement(N, {
      className: le
    }, u)));
  }
  return /* @__PURE__ */ xe.cloneElement(H, {
    className: be((r = H.props) === null || r === void 0 ? void 0 : r.className, d) || null,
    style: ce(ce({}, (n = H.props) === null || n === void 0 ? void 0 : n.style), f),
    hidden: _
  });
}), LSe = ["show"];
function LG(e, t) {
  return p.useMemo(function() {
    var r = {};
    t && (r.show = kt(t) === "object" && t.formatter ? t.formatter : !!t), r = ce(ce({}, r), e);
    var n = r, a = n.show, i = Kt(n, LSe);
    return ce(ce({}, i), {}, {
      show: !!a,
      showFormatter: typeof a == "function" ? a : void 0,
      strategy: i.strategy || function(o) {
        return o.length;
      }
    });
  }, [e, t]);
}
var kSe = ["autoComplete", "onChange", "onFocus", "onBlur", "onPressEnter", "onKeyDown", "prefixCls", "disabled", "htmlSize", "className", "maxLength", "suffix", "showCount", "count", "type", "classes", "classNames", "styles", "onCompositionStart", "onCompositionEnd"], FSe = /* @__PURE__ */ Aa(function(e, t) {
  var r = e.autoComplete, n = e.onChange, a = e.onFocus, i = e.onBlur, o = e.onPressEnter, s = e.onKeyDown, l = e.prefixCls, c = l === void 0 ? "rc-input" : l, u = e.disabled, d = e.htmlSize, f = e.className, m = e.maxLength, h = e.suffix, g = e.showCount, y = e.count, S = e.type, x = S === void 0 ? "text" : S, b = e.classes, _ = e.classNames, $ = e.styles, w = e.onCompositionStart, O = e.onCompositionEnd, T = Kt(e, kSe), I = He(!1), P = ye(I, 2), D = P[0], B = P[1], L = ct(!1), N = ct(null), z = ct(null), F = function(X) {
    N.current && jG(N.current, X);
  }, j = Kr(e.defaultValue, {
    value: e.value
  }), H = ye(j, 2), U = H[0], G = H[1], V = U == null ? "" : String(U), K = He(null), Z = ye(K, 2), ee = Z[0], ae = Z[1], ue = LG(y, g), re = ue.max || m, oe = ue.strategy(V), fe = !!re && oe > re;
  fo(t, function() {
    var Y;
    return {
      focus: F,
      blur: function() {
        var pe;
        (pe = N.current) === null || pe === void 0 || pe.blur();
      },
      setSelectionRange: function(pe, $e, J) {
        var de;
        (de = N.current) === null || de === void 0 || de.setSelectionRange(pe, $e, J);
      },
      select: function() {
        var pe;
        (pe = N.current) === null || pe === void 0 || pe.select();
      },
      input: N.current,
      nativeElement: ((Y = z.current) === null || Y === void 0 ? void 0 : Y.nativeElement) || N.current
    };
  }), St(function() {
    B(function(Y) {
      return Y && u ? !1 : Y;
    });
  }, [u]);
  var le = function(X, pe, $e) {
    var J = pe;
    if (!L.current && ue.exceedFormatter && ue.max && ue.strategy(pe) > ue.max) {
      if (J = ue.exceedFormatter(pe, {
        max: ue.max
      }), pe !== J) {
        var de, Se;
        ae([((de = N.current) === null || de === void 0 ? void 0 : de.selectionStart) || 0, ((Se = N.current) === null || Se === void 0 ? void 0 : Se.selectionEnd) || 0]);
      }
    } else if ($e.source === "compositionEnd")
      return;
    G(J), N.current && zb(N.current, X, n, J);
  };
  St(function() {
    if (ee) {
      var Y;
      (Y = N.current) === null || Y === void 0 || Y.setSelectionRange.apply(Y, ze(ee));
    }
  }, [ee]);
  var se = function(X) {
    le(X, X.target.value, {
      source: "change"
    });
  }, Q = function(X) {
    L.current = !1, le(X, X.currentTarget.value, {
      source: "compositionEnd"
    }), O?.(X);
  }, he = function(X) {
    o && X.key === "Enter" && o(X), s?.(X);
  }, ne = function(X) {
    B(!0), a?.(X);
  }, me = function(X) {
    B(!1), i?.(X);
  }, k = function(X) {
    G(""), F(), N.current && zb(N.current, X, n);
  }, M = fe && "".concat(c, "-out-of-range"), R = function() {
    var X = bn(e, [
      "prefixCls",
      "onPressEnter",
      "addonBefore",
      "addonAfter",
      "prefix",
      "suffix",
      "allowClear",
      // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      "defaultValue",
      "showCount",
      "count",
      "classes",
      "htmlSize",
      "styles",
      "classNames"
    ]);
    return /* @__PURE__ */ xe.createElement("input", Pe({
      autoComplete: r
    }, X, {
      onChange: se,
      onFocus: ne,
      onBlur: me,
      onKeyDown: he,
      className: be(c, te({}, "".concat(c, "-disabled"), u), _?.input),
      style: $?.input,
      ref: N,
      size: d,
      type: x,
      onCompositionStart: function($e) {
        L.current = !0, w?.($e);
      },
      onCompositionEnd: Q
    }));
  }, q = function() {
    var X = Number(re) > 0;
    if (h || ue.show) {
      var pe = ue.showFormatter ? ue.showFormatter({
        value: V,
        count: oe,
        maxLength: re
      }) : "".concat(oe).concat(X ? " / ".concat(re) : "");
      return /* @__PURE__ */ xe.createElement(xe.Fragment, null, ue.show && /* @__PURE__ */ xe.createElement("span", {
        className: be("".concat(c, "-show-count-suffix"), te({}, "".concat(c, "-show-count-has-suffix"), !!h), _?.count),
        style: ce({}, $?.count)
      }, pe), h);
    }
    return null;
  };
  return /* @__PURE__ */ xe.createElement(PI, Pe({}, T, {
    prefixCls: c,
    className: be(f, M),
    handleReset: k,
    value: V,
    focused: D,
    triggerFocus: F,
    suffix: q(),
    disabled: u,
    classes: b,
    classNames: _,
    styles: $
  }), R());
});
function BSe(e, t) {
  return typeof Proxy < "u" && e ? new Proxy(e, {
    get: function(n, a) {
      if (t[a])
        return t[a];
      var i = n[a];
      return typeof i == "function" ? i.bind(n) : i;
    }
  }) : e;
}
function zSe(e, t) {
  var r = ct(null);
  function n() {
    try {
      var i = e.selectionStart, o = e.selectionEnd, s = e.value, l = s.substring(0, i), c = s.substring(o);
      r.current = {
        start: i,
        end: o,
        value: s,
        beforeTxt: l,
        afterTxt: c
      };
    } catch {
    }
  }
  function a() {
    if (e && r.current && t)
      try {
        var i = e.value, o = r.current, s = o.beforeTxt, l = o.afterTxt, c = o.start, u = i.length;
        if (i.endsWith(l))
          u = i.length - r.current.afterTxt.length;
        else if (i.startsWith(s))
          u = s.length;
        else {
          var d = s[c - 1], f = i.indexOf(d, c - 1);
          f !== -1 && (u = f + 1);
        }
        e.setSelectionRange(u, u);
      } catch (m) {
        jt(!1, "Something warning of cursor restore. Please fire issue about this: ".concat(m.message));
      }
  }
  return [n, a];
}
var HSe = function() {
  var t = He(!1), r = ye(t, 2), n = r[0], a = r[1];
  return hr(function() {
    a(R1());
  }, []), n;
}, VSe = 200, GSe = 600;
function USe(e) {
  var t = e.prefixCls, r = e.upNode, n = e.downNode, a = e.upDisabled, i = e.downDisabled, o = e.onStep, s = p.useRef(), l = p.useRef([]), c = p.useRef();
  c.current = o;
  var u = function() {
    clearTimeout(s.current);
  }, d = function(b, _) {
    b.preventDefault(), u(), c.current(_);
    function $() {
      c.current(_), s.current = setTimeout($, VSe);
    }
    s.current = setTimeout($, GSe);
  };
  p.useEffect(function() {
    return function() {
      u(), l.current.forEach(function(x) {
        return vr.cancel(x);
      });
    };
  }, []);
  var f = HSe();
  if (f)
    return null;
  var m = "".concat(t, "-handler"), h = be(m, "".concat(m, "-up"), te({}, "".concat(m, "-up-disabled"), a)), g = be(m, "".concat(m, "-down"), te({}, "".concat(m, "-down-disabled"), i)), y = function() {
    return l.current.push(vr(u));
  }, S = {
    unselectable: "on",
    role: "button",
    onMouseUp: y,
    onMouseLeave: y
  };
  return /* @__PURE__ */ p.createElement("div", {
    className: "".concat(m, "-wrap")
  }, /* @__PURE__ */ p.createElement("span", Pe({}, S, {
    onMouseDown: function(b) {
      d(b, !0);
    },
    "aria-label": "Increase Value",
    "aria-disabled": a,
    className: h
  }), r || /* @__PURE__ */ p.createElement("span", {
    unselectable: "on",
    className: "".concat(t, "-handler-up-inner")
  })), /* @__PURE__ */ p.createElement("span", Pe({}, S, {
    onMouseDown: function(b) {
      d(b, !1);
    },
    "aria-label": "Decrease Value",
    "aria-disabled": i,
    className: g
  }), n || /* @__PURE__ */ p.createElement("span", {
    unselectable: "on",
    className: "".concat(t, "-handler-down-inner")
  })));
}
function o4(e) {
  var t = typeof e == "number" ? Y1(e) : yc(e).fullStr, r = t.includes(".");
  return r ? yc(t.replace(/(\d)\.(\d)/g, "$1$2.")).fullStr : e + "0";
}
const WSe = function() {
  var e = ct(0), t = function() {
    vr.cancel(e.current);
  };
  return St(function() {
    return t;
  }, []), function(r) {
    t(), e.current = vr(function() {
      r();
    });
  };
};
var qSe = ["prefixCls", "className", "style", "min", "max", "step", "defaultValue", "value", "disabled", "readOnly", "upHandler", "downHandler", "keyboard", "changeOnWheel", "controls", "classNames", "stringMode", "parser", "formatter", "precision", "decimalSeparator", "onChange", "onInput", "onPressEnter", "onStep", "changeOnBlur", "domRef"], KSe = ["disabled", "style", "prefixCls", "value", "prefix", "suffix", "addonBefore", "addonAfter", "className", "classNames"], s4 = function(t, r) {
  return t || r.isEmpty() ? r.toString() : r.toNumber();
}, l4 = function(t) {
  var r = _o(t);
  return r.isInvalidate() ? null : r;
}, YSe = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.className, a = e.style, i = e.min, o = e.max, s = e.step, l = s === void 0 ? 1 : s, c = e.defaultValue, u = e.value, d = e.disabled, f = e.readOnly, m = e.upHandler, h = e.downHandler, g = e.keyboard, y = e.changeOnWheel, S = y === void 0 ? !1 : y, x = e.controls, b = x === void 0 ? !0 : x;
  e.classNames;
  var _ = e.stringMode, $ = e.parser, w = e.formatter, O = e.precision, T = e.decimalSeparator, I = e.onChange, P = e.onInput, D = e.onPressEnter, B = e.onStep, L = e.changeOnBlur, N = L === void 0 ? !0 : L, z = e.domRef, F = Kt(e, qSe), j = "".concat(r, "-input"), H = p.useRef(null), U = p.useState(!1), G = ye(U, 2), V = G[0], K = G[1], Z = p.useRef(!1), ee = p.useRef(!1), ae = p.useRef(!1), ue = p.useState(function() {
    return _o(u ?? c);
  }), re = ye(ue, 2), oe = re[0], fe = re[1];
  function le(xt) {
    u === void 0 && fe(xt);
  }
  var se = p.useCallback(function(xt, Xe) {
    if (!Xe)
      return O >= 0 ? O : Math.max(fc(xt), fc(l));
  }, [O, l]), Q = p.useCallback(function(xt) {
    var Xe = String(xt);
    if ($)
      return $(Xe);
    var pt = Xe;
    return T && (pt = pt.replace(T, ".")), pt.replace(/[^\w.-]+/g, "");
  }, [$, T]), he = p.useRef(""), ne = p.useCallback(function(xt, Xe) {
    if (w)
      return w(xt, {
        userTyping: Xe,
        input: String(he.current)
      });
    var pt = typeof xt == "number" ? Y1(xt) : xt;
    if (!Xe) {
      var Ze = se(pt, Xe);
      if (AI(pt) && (T || Ze >= 0)) {
        var wt = T || ".";
        pt = pb(pt, wt, Ze);
      }
    }
    return pt;
  }, [w, se, T]), me = p.useState(function() {
    var xt = c ?? u;
    return oe.isInvalidate() && ["string", "number"].includes(kt(xt)) ? Number.isNaN(xt) ? "" : xt : ne(oe.toString(), !1);
  }), k = ye(me, 2), M = k[0], R = k[1];
  he.current = M;
  function q(xt, Xe) {
    R(ne(
      // Invalidate number is sometime passed by external control, we should let it go
      // Otherwise is controlled by internal interactive logic which check by userTyping
      // You can ref 'show limited value when input is not focused' test for more info.
      xt.isInvalidate() ? xt.toString(!1) : xt.toString(!Xe),
      Xe
    ));
  }
  var Y = p.useMemo(function() {
    return l4(o);
  }, [o, O]), X = p.useMemo(function() {
    return l4(i);
  }, [i, O]), pe = p.useMemo(function() {
    return !Y || !oe || oe.isInvalidate() ? !1 : Y.lessEquals(oe);
  }, [Y, oe]), $e = p.useMemo(function() {
    return !X || !oe || oe.isInvalidate() ? !1 : oe.lessEquals(X);
  }, [X, oe]), J = zSe(H.current, V), de = ye(J, 2), Se = de[0], Ee = de[1], Te = function(Xe) {
    return Y && !Xe.lessEquals(Y) ? Y : X && !X.lessEquals(Xe) ? X : null;
  }, Le = function(Xe) {
    return !Te(Xe);
  }, Ie = function(Xe, pt) {
    var Ze = Xe, wt = Le(Ze) || Ze.isEmpty();
    if (!Ze.isEmpty() && !pt && (Ze = Te(Ze) || Ze, wt = !0), !f && !d && wt) {
      var bt = Ze.toString(), Je = se(bt, pt);
      return Je >= 0 && (Ze = _o(pb(bt, ".", Je)), Le(Ze) || (Ze = _o(pb(bt, ".", Je, !0)))), Ze.equals(oe) || (le(Ze), I?.(Ze.isEmpty() ? null : s4(_, Ze)), u === void 0 && q(Ze, pt)), Ze;
    }
    return oe;
  }, De = WSe(), Ae = function xt(Xe) {
    if (Se(), he.current = Xe, R(Xe), !ee.current) {
      var pt = Q(Xe), Ze = _o(pt);
      Ze.isNaN() || Ie(Ze, !0);
    }
    P?.(Xe), De(function() {
      var wt = Xe;
      $ || (wt = Xe.replace(/。/g, ".")), wt !== Xe && xt(wt);
    });
  }, Fe = function() {
    ee.current = !0;
  }, Ne = function() {
    ee.current = !1, Ae(H.current.value);
  }, qe = function(Xe) {
    Ae(Xe.target.value);
  }, Qe = function(Xe) {
    var pt;
    if (!(Xe && pe || !Xe && $e)) {
      Z.current = !1;
      var Ze = _o(ae.current ? o4(l) : l);
      Xe || (Ze = Ze.negate());
      var wt = (oe || _o(0)).add(Ze.toString()), bt = Ie(wt, !1);
      B?.(s4(_, bt), {
        offset: ae.current ? o4(l) : l,
        type: Xe ? "up" : "down"
      }), (pt = H.current) === null || pt === void 0 || pt.focus();
    }
  }, tt = function(Xe) {
    var pt = _o(Q(M)), Ze;
    pt.isNaN() ? Ze = Ie(oe, Xe) : Ze = Ie(pt, Xe), u !== void 0 ? q(oe, !1) : Ze.isNaN() || q(Ze, !1);
  }, Ge = function() {
    Z.current = !0;
  }, it = function(Xe) {
    var pt = Xe.key, Ze = Xe.shiftKey;
    Z.current = !0, ae.current = Ze, pt === "Enter" && (ee.current || (Z.current = !1), tt(!1), D?.(Xe)), g !== !1 && !ee.current && ["Up", "ArrowUp", "Down", "ArrowDown"].includes(pt) && (Qe(pt === "Up" || pt === "ArrowUp"), Xe.preventDefault());
  }, ht = function() {
    Z.current = !1, ae.current = !1;
  };
  p.useEffect(function() {
    if (S && V) {
      var xt = function(Ze) {
        Qe(Ze.deltaY < 0), Ze.preventDefault();
      }, Xe = H.current;
      if (Xe)
        return Xe.addEventListener("wheel", xt, {
          passive: !1
        }), function() {
          return Xe.removeEventListener("wheel", xt);
        };
    }
  });
  var It = function() {
    N && tt(!1), K(!1), Z.current = !1;
  };
  return vc(function() {
    oe.isInvalidate() || q(oe, !1);
  }, [O, w]), vc(function() {
    var xt = _o(u);
    fe(xt);
    var Xe = _o(Q(M));
    (!xt.equals(Xe) || !Z.current || w) && q(xt, Z.current);
  }, [u]), vc(function() {
    w && Ee();
  }, [M]), /* @__PURE__ */ p.createElement("div", {
    ref: z,
    className: be(r, n, te(te(te(te(te({}, "".concat(r, "-focused"), V), "".concat(r, "-disabled"), d), "".concat(r, "-readonly"), f), "".concat(r, "-not-a-number"), oe.isNaN()), "".concat(r, "-out-of-range"), !oe.isInvalidate() && !Le(oe))),
    style: a,
    onFocus: function() {
      K(!0);
    },
    onBlur: It,
    onKeyDown: it,
    onKeyUp: ht,
    onCompositionStart: Fe,
    onCompositionEnd: Ne,
    onBeforeInput: Ge
  }, b && /* @__PURE__ */ p.createElement(USe, {
    prefixCls: r,
    upNode: m,
    downNode: h,
    upDisabled: pe,
    downDisabled: $e,
    onStep: Qe
  }), /* @__PURE__ */ p.createElement("div", {
    className: "".concat(j, "-wrap")
  }, /* @__PURE__ */ p.createElement("input", Pe({
    autoComplete: "off",
    role: "spinbutton",
    "aria-valuemin": i,
    "aria-valuemax": o,
    "aria-valuenow": oe.isInvalidate() ? null : oe.toString(),
    step: l
  }, F, {
    ref: Za(H, t),
    className: j,
    value: M,
    onChange: qe,
    disabled: d,
    readOnly: f
  }))));
}), kG = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.disabled, n = e.style, a = e.prefixCls, i = a === void 0 ? "rc-input-number" : a, o = e.value, s = e.prefix, l = e.suffix, c = e.addonBefore, u = e.addonAfter, d = e.className, f = e.classNames, m = Kt(e, KSe), h = p.useRef(null), g = p.useRef(null), y = p.useRef(null), S = function(b) {
    y.current && jG(y.current, b);
  };
  return p.useImperativeHandle(t, function() {
    return BSe(y.current, {
      nativeElement: h.current.nativeElement || g.current
    });
  }), /* @__PURE__ */ p.createElement(PI, {
    className: d,
    triggerFocus: S,
    prefixCls: i,
    value: o,
    disabled: r,
    style: n,
    prefix: s,
    suffix: l,
    addonAfter: u,
    addonBefore: c,
    classNames: f,
    components: {
      affixWrapper: "div",
      groupWrapper: "div",
      wrapper: "div",
      groupAddon: "div"
    },
    ref: h
  }, /* @__PURE__ */ p.createElement(YSe, Pe({
    prefixCls: i,
    disabled: r,
    ref: y,
    domRef: g,
    className: f?.input
  }, m)));
});
process.env.NODE_ENV !== "production" && (kG.displayName = "InputNumber");
const Hb = (e) => e ? /* @__PURE__ */ xe.createElement(Lc, null, /* @__PURE__ */ xe.createElement(UT, {
  override: !0,
  status: !0
}, e)) : null, ZSe = (e) => {
  var t;
  const r = (t = e.handleVisible) !== null && t !== void 0 ? t : "auto";
  return Object.assign(Object.assign({}, xh(e)), {
    controlWidth: 90,
    handleWidth: e.controlHeightSM - e.lineWidth * 2,
    handleFontSize: e.fontSize / 2,
    handleVisible: r,
    handleActiveBg: e.colorFillAlter,
    handleBg: e.colorBgContainer,
    filledHandleBg: new Br(e.colorFillSecondary).onBackground(e.colorBgContainer).toHexString(),
    handleHoverColor: e.colorPrimary,
    handleBorderColor: e.colorBorder,
    handleOpacity: r === !0 ? 1 : 0
  });
}, c4 = (e, t) => {
  let {
    componentCls: r,
    borderRadiusSM: n,
    borderRadiusLG: a
  } = e;
  const i = t === "lg" ? a : n;
  return {
    [`&-${t}`]: {
      [`${r}-handler-wrap`]: {
        borderStartEndRadius: i,
        borderEndEndRadius: i
      },
      [`${r}-handler-up`]: {
        borderStartEndRadius: i
      },
      [`${r}-handler-down`]: {
        borderEndEndRadius: i
      }
    }
  };
}, XSe = (e) => {
  const {
    componentCls: t,
    lineWidth: r,
    lineType: n,
    borderRadius: a,
    inputFontSizeSM: i,
    inputFontSizeLG: o,
    controlHeightLG: s,
    controlHeightSM: l,
    colorError: c,
    paddingInlineSM: u,
    paddingBlockSM: d,
    paddingBlockLG: f,
    paddingInlineLG: m,
    colorTextDescription: h,
    motionDurationMid: g,
    handleHoverColor: y,
    paddingInline: S,
    paddingBlock: x,
    handleBg: b,
    handleActiveBg: _,
    colorTextDisabled: $,
    borderRadiusSM: w,
    borderRadiusLG: O,
    controlWidth: T,
    handleOpacity: I,
    handleBorderColor: P,
    filledHandleBg: D,
    lineHeightLG: B,
    calc: L
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Yr(e)), $h(e)), {
        display: "inline-block",
        width: T,
        margin: 0,
        padding: 0,
        borderRadius: a
      }), CI(e, {
        [`${t}-handler-wrap`]: {
          background: b,
          [`${t}-handler-down`]: {
            borderBlockStart: `${ve(r)} ${n} ${P}`
          }
        }
      })), xI(e, {
        [`${t}-handler-wrap`]: {
          background: D,
          [`${t}-handler-down`]: {
            borderBlockStart: `${ve(r)} ${n} ${P}`
          }
        },
        "&:focus-within": {
          [`${t}-handler-wrap`]: {
            background: b
          }
        }
      })), SI(e)), {
        "&-rtl": {
          direction: "rtl",
          [`${t}-input`]: {
            direction: "rtl"
          }
        },
        "&-lg": {
          padding: 0,
          fontSize: o,
          lineHeight: B,
          borderRadius: O,
          [`input${t}-input`]: {
            height: L(s).sub(L(r).mul(2)).equal(),
            padding: `${ve(f)} ${ve(m)}`
          }
        },
        "&-sm": {
          padding: 0,
          fontSize: i,
          borderRadius: w,
          [`input${t}-input`]: {
            height: L(l).sub(L(r).mul(2)).equal(),
            padding: `${ve(d)} ${ve(u)}`
          }
        },
        // ===================== Out Of Range =====================
        "&-out-of-range": {
          [`${t}-input-wrap`]: {
            input: {
              color: c
            }
          }
        },
        // Style for input-group: input with label, with button or dropdown...
        "&-group": Object.assign(Object.assign(Object.assign({}, Yr(e)), hG(e)), {
          "&-wrapper": Object.assign(Object.assign(Object.assign({
            display: "inline-block",
            textAlign: "start",
            verticalAlign: "top",
            [`${t}-affix-wrapper`]: {
              width: "100%"
            },
            // Size
            "&-lg": {
              [`${t}-group-addon`]: {
                borderRadius: O,
                fontSize: e.fontSizeLG
              }
            },
            "&-sm": {
              [`${t}-group-addon`]: {
                borderRadius: w
              }
            }
          }, fG(e)), mG(e)), {
            // Fix the issue of using icons in Space Compact mode
            // https://github.com/ant-design/ant-design/issues/45764
            [`&:not(${t}-compact-first-item):not(${t}-compact-last-item)${t}-compact-item`]: {
              [`${t}, ${t}-group-addon`]: {
                borderRadius: 0
              }
            },
            [`&:not(${t}-compact-last-item)${t}-compact-first-item`]: {
              [`${t}, ${t}-group-addon`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
              }
            },
            [`&:not(${t}-compact-first-item)${t}-compact-last-item`]: {
              [`${t}, ${t}-group-addon`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
              }
            }
          })
        }),
        [`&-disabled ${t}-input`]: {
          cursor: "not-allowed"
        },
        [t]: {
          "&-input": Object.assign(Object.assign(Object.assign(Object.assign({}, Yr(e)), {
            width: "100%",
            padding: `${ve(x)} ${ve(S)}`,
            textAlign: "start",
            backgroundColor: "transparent",
            border: 0,
            borderRadius: a,
            outline: 0,
            transition: `all ${g} linear`,
            appearance: "textfield",
            fontSize: "inherit"
          }), $I(e.colorTextPlaceholder)), {
            '&[type="number"]::-webkit-inner-spin-button, &[type="number"]::-webkit-outer-spin-button': {
              margin: 0,
              /* stylelint-disable-next-line property-no-vendor-prefix */
              webkitAppearance: "none",
              appearance: "none"
            }
          })
        }
      })
    },
    // Handler
    {
      [t]: Object.assign(Object.assign(Object.assign({
        [`&:hover ${t}-handler-wrap, &-focused ${t}-handler-wrap`]: {
          opacity: 1
        },
        [`${t}-handler-wrap`]: {
          position: "absolute",
          insetBlockStart: 0,
          insetInlineEnd: 0,
          width: e.handleWidth,
          height: "100%",
          borderStartStartRadius: 0,
          borderStartEndRadius: a,
          borderEndEndRadius: a,
          borderEndStartRadius: 0,
          opacity: I,
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          transition: `opacity ${g} linear ${g}`,
          // Fix input number inside Menu makes icon too large
          // We arise the selector priority by nest selector here
          // https://github.com/ant-design/ant-design/issues/14367
          [`${t}-handler`]: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: "auto",
            height: "40%",
            [`
              ${t}-handler-up-inner,
              ${t}-handler-down-inner
            `]: {
              marginInlineEnd: 0,
              fontSize: e.handleFontSize
            }
          }
        },
        [`${t}-handler`]: {
          height: "50%",
          overflow: "hidden",
          color: h,
          fontWeight: "bold",
          lineHeight: 0,
          textAlign: "center",
          cursor: "pointer",
          borderInlineStart: `${ve(r)} ${n} ${P}`,
          transition: `all ${g} linear`,
          "&:active": {
            background: _
          },
          // Hover
          "&:hover": {
            height: "60%",
            [`
              ${t}-handler-up-inner,
              ${t}-handler-down-inner
            `]: {
              color: y
            }
          },
          "&-up-inner, &-down-inner": Object.assign(Object.assign({}, ih()), {
            color: h,
            transition: `all ${g} linear`,
            userSelect: "none"
          })
        },
        [`${t}-handler-up`]: {
          borderStartEndRadius: a
        },
        [`${t}-handler-down`]: {
          borderEndEndRadius: a
        }
      }, c4(e, "lg")), c4(e, "sm")), {
        // Disabled
        "&-disabled, &-readonly": {
          [`${t}-handler-wrap`]: {
            display: "none"
          },
          [`${t}-input`]: {
            color: "inherit"
          }
        },
        [`
          ${t}-handler-up-disabled,
          ${t}-handler-down-disabled
        `]: {
          cursor: "not-allowed"
        },
        [`
          ${t}-handler-up-disabled:hover &-handler-up-inner,
          ${t}-handler-down-disabled:hover &-handler-down-inner
        `]: {
          color: $
        }
      })
    }
  ];
}, JSe = (e) => {
  const {
    componentCls: t,
    paddingBlock: r,
    paddingInline: n,
    inputAffixPadding: a,
    controlWidth: i,
    borderRadiusLG: o,
    borderRadiusSM: s,
    paddingInlineLG: l,
    paddingInlineSM: c,
    paddingBlockLG: u,
    paddingBlockSM: d
  } = e;
  return {
    [`${t}-affix-wrapper`]: Object.assign(Object.assign({
      [`input${t}-input`]: {
        padding: `${ve(r)} 0`
      }
    }, $h(e)), {
      // or number handler will cover form status
      position: "relative",
      display: "inline-flex",
      width: i,
      padding: 0,
      paddingInlineStart: n,
      "&-lg": {
        borderRadius: o,
        paddingInlineStart: l,
        [`input${t}-input`]: {
          padding: `${ve(u)} 0`
        }
      },
      "&-sm": {
        borderRadius: s,
        paddingInlineStart: c,
        [`input${t}-input`]: {
          padding: `${ve(d)} 0`
        }
      },
      [`&:not(${t}-disabled):hover`]: {
        zIndex: 1
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      [`&-disabled > ${t}-disabled`]: {
        background: "transparent"
      },
      [`> div${t}`]: {
        width: "100%",
        border: "none",
        outline: "none",
        [`&${t}-focused`]: {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [`${t}-handler-wrap`]: {
        zIndex: 2
      },
      [t]: {
        color: "inherit",
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          pointerEvents: "none"
        },
        "&-prefix": {
          marginInlineEnd: a
        },
        "&-suffix": {
          position: "absolute",
          insetBlockStart: 0,
          insetInlineEnd: 0,
          zIndex: 1,
          height: "100%",
          marginInlineEnd: n,
          marginInlineStart: a
        }
      }
    })
  };
}, QSe = Zr("InputNumber", (e) => {
  const t = $r(e, Sh(e));
  return [
    XSe(t),
    JSe(t),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    uh(t)
  ];
}, ZSe, {
  unitless: {
    handleOpacity: !0
  }
});
var exe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const FG = /* @__PURE__ */ p.forwardRef((e, t) => {
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: re
    } = xr("InputNumber");
    re(!("bordered" in e), "bordered", "variant");
  }
  const {
    getPrefixCls: r,
    direction: n
  } = p.useContext(Lt), a = p.useRef(null);
  p.useImperativeHandle(t, () => a.current);
  const {
    className: i,
    rootClassName: o,
    size: s,
    disabled: l,
    prefixCls: c,
    addonBefore: u,
    addonAfter: d,
    prefix: f,
    bordered: m,
    readOnly: h,
    status: g,
    controls: y,
    variant: S
  } = e, x = exe(e, ["className", "rootClassName", "size", "disabled", "prefixCls", "addonBefore", "addonAfter", "prefix", "bordered", "readOnly", "status", "controls", "variant"]), b = r("input-number", c), _ = Mn(b), [$, w, O] = QSe(b, _), {
    compactSize: T,
    compactItemClassnames: I
  } = El(b, n);
  let P = /* @__PURE__ */ p.createElement(NG, {
    className: `${b}-handler-up-inner`
  }), D = /* @__PURE__ */ p.createElement(j1, {
    className: `${b}-handler-down-inner`
  });
  const B = typeof y == "boolean" ? y : void 0;
  typeof y == "object" && (P = typeof y.upIcon > "u" ? P : /* @__PURE__ */ p.createElement("span", {
    className: `${b}-handler-up-inner`
  }, y.upIcon), D = typeof y.downIcon > "u" ? D : /* @__PURE__ */ p.createElement("span", {
    className: `${b}-handler-down-inner`
  }, y.downIcon));
  const {
    hasFeedback: L,
    status: N,
    isFormItemInput: z,
    feedbackIcon: F
  } = p.useContext(xa), j = kc(N, g), H = Xa((re) => {
    var oe;
    return (oe = s ?? T) !== null && oe !== void 0 ? oe : re;
  }), U = p.useContext(Vi), G = l ?? U, [V, K] = xd(S, m), Z = L && /* @__PURE__ */ p.createElement(p.Fragment, null, F), ee = be({
    [`${b}-lg`]: H === "large",
    [`${b}-sm`]: H === "small",
    [`${b}-rtl`]: n === "rtl",
    [`${b}-in-form-item`]: z
  }, w), ae = `${b}-group`, ue = /* @__PURE__ */ p.createElement(kG, Object.assign({
    ref: a,
    disabled: G,
    className: be(O, _, i, o, I),
    upHandler: P,
    downHandler: D,
    prefixCls: b,
    readOnly: h,
    controls: B,
    prefix: f,
    suffix: Z,
    addonBefore: Hb(u),
    addonAfter: Hb(d),
    classNames: {
      input: ee,
      variant: be({
        [`${b}-${V}`]: K
      }, xl(b, j, L)),
      affixWrapper: be({
        [`${b}-affix-wrapper-sm`]: H === "small",
        [`${b}-affix-wrapper-lg`]: H === "large",
        [`${b}-affix-wrapper-rtl`]: n === "rtl"
      }, w),
      wrapper: be({
        [`${ae}-rtl`]: n === "rtl"
      }, w),
      groupWrapper: be({
        [`${b}-group-wrapper-sm`]: H === "small",
        [`${b}-group-wrapper-lg`]: H === "large",
        [`${b}-group-wrapper-rtl`]: n === "rtl",
        [`${b}-group-wrapper-${V}`]: K
      }, xl(`${b}-group-wrapper`, j, L), w)
    }
  }, x));
  return $(ue);
}), Vb = FG, txe = (e) => /* @__PURE__ */ p.createElement(Fo, {
  theme: {
    components: {
      InputNumber: {
        handleVisible: !0
      }
    }
  }
}, /* @__PURE__ */ p.createElement(FG, Object.assign({}, e)));
process.env.NODE_ENV !== "production" && (Vb.displayName = "InputNumber");
Vb._InternalPanelDoNotUseOrYouWillBeFired = txe;
const rxe = (e) => {
  const {
    getPrefixCls: t,
    direction: r
  } = Cr(Lt), {
    prefixCls: n,
    className: a
  } = e, i = t("input-group", n), o = t("input"), [s, l] = EI(o), c = be(i, {
    [`${i}-lg`]: e.size === "large",
    [`${i}-sm`]: e.size === "small",
    [`${i}-compact`]: e.compact,
    [`${i}-rtl`]: r === "rtl"
  }, l, a), u = Cr(xa), d = dr(() => Object.assign(Object.assign({}, u), {
    isFormItemInput: !1
  }), [u]);
  return process.env.NODE_ENV !== "production" && xr("Input.Group").deprecated(!1, "Input.Group", "Space.Compact"), s(/* @__PURE__ */ p.createElement("span", {
    className: c,
    style: e.style,
    onMouseEnter: e.onMouseEnter,
    onMouseLeave: e.onMouseLeave,
    onFocus: e.onFocus,
    onBlur: e.onBlur
  }, /* @__PURE__ */ p.createElement(xa.Provider, {
    value: d
  }, e.children)));
}, BG = (e) => {
  let t;
  return typeof e == "object" && e?.clearIcon ? t = e : e && (t = {
    clearIcon: /* @__PURE__ */ xe.createElement(Nc, null)
  }), t;
};
function zG(e, t) {
  const r = ct([]), n = () => {
    r.current.push(setTimeout(() => {
      var a, i, o, s;
      !((a = e.current) === null || a === void 0) && a.input && ((i = e.current) === null || i === void 0 ? void 0 : i.input.getAttribute("type")) === "password" && (!((o = e.current) === null || o === void 0) && o.input.hasAttribute("value")) && ((s = e.current) === null || s === void 0 || s.input.removeAttribute("value"));
    }));
  };
  return St(() => (t && n(), () => r.current.forEach((a) => {
    a && clearTimeout(a);
  })), []), n;
}
function nxe(e) {
  return !!(e.prefix || e.suffix || e.allowClear || e.showCount);
}
var axe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function ixe(e, t) {
  if (!e)
    return;
  e.focus(t);
  const {
    cursor: r
  } = t || {};
  if (r) {
    const n = e.value.length;
    switch (r) {
      case "start":
        e.setSelectionRange(0, 0);
        break;
      case "end":
        e.setSelectionRange(n, n);
        break;
      default:
        e.setSelectionRange(0, n);
    }
  }
}
const wh = /* @__PURE__ */ Aa((e, t) => {
  var r;
  const {
    prefixCls: n,
    bordered: a = !0,
    status: i,
    size: o,
    disabled: s,
    onBlur: l,
    onFocus: c,
    suffix: u,
    allowClear: d,
    addonAfter: f,
    addonBefore: m,
    className: h,
    style: g,
    styles: y,
    rootClassName: S,
    onChange: x,
    classNames: b,
    variant: _
  } = e, $ = axe(e, ["prefixCls", "bordered", "status", "size", "disabled", "onBlur", "onFocus", "suffix", "allowClear", "addonAfter", "addonBefore", "className", "style", "styles", "rootClassName", "onChange", "classNames", "variant"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: ne
    } = xr("Input");
    ne(!("bordered" in e), "bordered", "variant");
  }
  const {
    getPrefixCls: w,
    direction: O,
    input: T
  } = xe.useContext(Lt), I = w("input", n), P = ct(null), D = Mn(I), [B, L, N] = EI(I, D), {
    compactSize: z,
    compactItemClassnames: F
  } = El(I, O), j = Xa((ne) => {
    var me;
    return (me = o ?? z) !== null && me !== void 0 ? me : ne;
  }), H = xe.useContext(Vi), U = s ?? H, {
    status: G,
    hasFeedback: V,
    feedbackIcon: K
  } = Cr(xa), Z = kc(G, i), ee = nxe(e) || !!V, ae = ct(ee);
  if (process.env.NODE_ENV !== "production") {
    const ne = xr("Input");
    St(() => {
      var me;
      ee && !ae.current && process.env.NODE_ENV !== "production" && ne(document.activeElement === ((me = P.current) === null || me === void 0 ? void 0 : me.input), "usage", "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ"), ae.current = ee;
    }, [ee]);
  }
  const ue = zG(P, !0), re = (ne) => {
    ue(), l?.(ne);
  }, oe = (ne) => {
    ue(), c?.(ne);
  }, fe = (ne) => {
    ue(), x?.(ne);
  }, le = (V || u) && /* @__PURE__ */ xe.createElement(xe.Fragment, null, u, V && K), se = BG(d ?? T?.allowClear), [Q, he] = xd(_, a);
  return B(/* @__PURE__ */ xe.createElement(FSe, Object.assign({
    ref: Za(t, P),
    prefixCls: I,
    autoComplete: T?.autoComplete
  }, $, {
    disabled: U,
    onBlur: re,
    onFocus: oe,
    style: Object.assign(Object.assign({}, T?.style), g),
    styles: Object.assign(Object.assign({}, T?.styles), y),
    suffix: le,
    allowClear: se,
    className: be(h, S, N, D, F, T?.className),
    onChange: fe,
    addonBefore: Hb(m),
    addonAfter: Hb(f),
    classNames: Object.assign(Object.assign(Object.assign({}, b), T?.classNames), {
      input: be({
        [`${I}-sm`]: j === "small",
        [`${I}-lg`]: j === "large",
        [`${I}-rtl`]: O === "rtl"
      }, b?.input, (r = T?.classNames) === null || r === void 0 ? void 0 : r.input, L),
      variant: be({
        [`${I}-${Q}`]: he
      }, xl(I, Z)),
      affixWrapper: be({
        [`${I}-affix-wrapper-sm`]: j === "small",
        [`${I}-affix-wrapper-lg`]: j === "large",
        [`${I}-affix-wrapper-rtl`]: O === "rtl"
      }, L),
      wrapper: be({
        [`${I}-group-rtl`]: O === "rtl"
      }, L),
      groupWrapper: be({
        [`${I}-group-wrapper-sm`]: j === "small",
        [`${I}-group-wrapper-lg`]: j === "large",
        [`${I}-group-wrapper-rtl`]: O === "rtl",
        [`${I}-group-wrapper-${Q}`]: he
      }, xl(`${I}-group-wrapper`, Z, V), L)
    })
  })));
});
process.env.NODE_ENV !== "production" && (wh.displayName = "Input");
const oxe = (e) => {
  const {
    componentCls: t,
    paddingXS: r
  } = e;
  return {
    [`${t}`]: {
      display: "inline-flex",
      alignItems: "center",
      flexWrap: "nowrap",
      columnGap: r,
      "&-rtl": {
        direction: "rtl"
      },
      [`${t}-input`]: {
        textAlign: "center",
        paddingInline: e.paddingXXS
      },
      // ================= Size =================
      [`&${t}-sm ${t}-input`]: {
        paddingInline: e.calc(e.paddingXXS).div(2).equal()
      },
      [`&${t}-lg ${t}-input`]: {
        paddingInline: e.paddingXS
      }
    }
  };
}, sxe = Zr(["Input", "OTP"], (e) => {
  const t = $r(e, Sh(e));
  return [oxe(t)];
}, xh);
var lxe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const cxe = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    value: r,
    onChange: n,
    onActiveChange: a,
    index: i,
    mask: o
  } = e, s = lxe(e, ["value", "onChange", "onActiveChange", "index", "mask"]), l = r && typeof o == "string" ? o : r, c = (h) => {
    n(i, h.target.value);
  }, u = p.useRef(null);
  p.useImperativeHandle(t, () => u.current);
  const d = () => {
    vr(() => {
      var h;
      const g = (h = u.current) === null || h === void 0 ? void 0 : h.input;
      document.activeElement === g && g && g.select();
    });
  }, f = (h) => {
    let {
      key: g
    } = h;
    g === "ArrowLeft" ? a(i - 1) : g === "ArrowRight" && a(i + 1), d();
  }, m = (h) => {
    h.key === "Backspace" && !r && a(i - 1), d();
  };
  return /* @__PURE__ */ p.createElement(wh, Object.assign({}, s, {
    ref: u,
    value: l,
    onInput: c,
    onFocus: d,
    onKeyDown: f,
    onKeyUp: m,
    onMouseDown: d,
    onMouseUp: d,
    type: o === !0 ? "password" : "text"
  }));
});
var uxe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function oy(e) {
  return (e || "").split("");
}
const dxe = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    prefixCls: r,
    length: n = 6,
    size: a,
    defaultValue: i,
    value: o,
    onChange: s,
    formatter: l,
    variant: c,
    disabled: u,
    status: d,
    autoFocus: f,
    mask: m
  } = e, h = uxe(e, ["prefixCls", "length", "size", "defaultValue", "value", "onChange", "formatter", "variant", "disabled", "status", "autoFocus", "mask"]);
  if (process.env.NODE_ENV !== "production") {
    const V = xr("Input.OTP");
    process.env.NODE_ENV !== "production" && V(!(typeof m == "string" && m.length > 1), "usage", "`mask` prop should be a single character.");
  }
  const {
    getPrefixCls: g,
    direction: y
  } = p.useContext(Lt), S = g("otp", r), x = aa(h, {
    aria: !0,
    data: !0,
    attr: !0
  }), b = Mn(S), [_, $, w] = sxe(S, b), O = Xa((V) => a ?? V), T = p.useContext(xa), I = kc(T.status, d), P = p.useMemo(() => Object.assign(Object.assign({}, T), {
    status: I,
    hasFeedback: !1,
    feedbackIcon: null
  }), [T, I]), D = p.useRef(null), B = p.useRef({});
  p.useImperativeHandle(t, () => ({
    focus: () => {
      var V;
      (V = B.current[0]) === null || V === void 0 || V.focus();
    },
    blur: () => {
      var V;
      for (let K = 0; K < n; K += 1)
        (V = B.current[K]) === null || V === void 0 || V.blur();
    },
    nativeElement: D.current
  }));
  const L = (V) => l ? l(V) : V, [N, z] = p.useState(oy(L(i || "")));
  p.useEffect(() => {
    o !== void 0 && z(oy(o));
  }, [o]);
  const F = br((V) => {
    z(V), s && V.length === n && V.every((K) => K) && V.some((K, Z) => N[Z] !== K) && s(V.join(""));
  }), j = br((V, K) => {
    let Z = ze(N);
    for (let ae = 0; ae < V; ae += 1)
      Z[ae] || (Z[ae] = "");
    K.length <= 1 ? Z[V] = K : Z = Z.slice(0, V).concat(oy(K)), Z = Z.slice(0, n);
    for (let ae = Z.length - 1; ae >= 0 && !Z[ae]; ae -= 1)
      Z.pop();
    const ee = L(Z.map((ae) => ae || " ").join(""));
    return Z = oy(ee).map((ae, ue) => ae === " " && !Z[ue] ? Z[ue] : ae), Z;
  }), H = (V, K) => {
    var Z;
    const ee = j(V, K), ae = Math.min(V + K.length, n - 1);
    ae !== V && ((Z = B.current[ae]) === null || Z === void 0 || Z.focus()), F(ee);
  }, U = (V) => {
    var K;
    (K = B.current[V]) === null || K === void 0 || K.focus();
  }, G = {
    variant: c,
    disabled: u,
    status: I,
    mask: m
  };
  return _(/* @__PURE__ */ p.createElement("div", Object.assign({}, x, {
    ref: D,
    className: be(S, {
      [`${S}-sm`]: O === "small",
      [`${S}-lg`]: O === "large",
      [`${S}-rtl`]: y === "rtl"
    }, w, $)
  }), /* @__PURE__ */ p.createElement(xa.Provider, {
    value: P
  }, Array.from({
    length: n
  }).map((V, K) => {
    const Z = `otp-${K}`, ee = N[K] || "";
    return /* @__PURE__ */ p.createElement(cxe, Object.assign({
      ref: (ae) => {
        B.current[K] = ae;
      },
      key: Z,
      index: K,
      size: O,
      htmlSize: 1,
      className: `${S}-input`,
      onChange: H,
      value: ee,
      onActiveChange: U,
      autoFocus: K === 0 && f
    }, G));
  }))));
});
var fxe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { tag: "path", attrs: { d: "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, name: "eye-invisible", theme: "outlined" }, pxe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: fxe
  }));
}, HG = /* @__PURE__ */ p.forwardRef(pxe);
process.env.NODE_ENV !== "production" && (HG.displayName = "EyeInvisibleOutlined");
var mxe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, name: "eye", theme: "outlined" }, vxe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: mxe
  }));
}, RI = /* @__PURE__ */ p.forwardRef(vxe);
process.env.NODE_ENV !== "production" && (RI.displayName = "EyeOutlined");
var hxe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const gxe = (e) => e ? /* @__PURE__ */ p.createElement(RI, null) : /* @__PURE__ */ p.createElement(HG, null), yxe = {
  click: "onClick",
  hover: "onMouseOver"
}, VG = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    disabled: r,
    action: n = "click",
    visibilityToggle: a = !0,
    iconRender: i = gxe
  } = e, o = typeof a == "object" && a.visible !== void 0, [s, l] = He(() => o ? a.visible : !1), c = ct(null);
  p.useEffect(() => {
    o && l(a.visible);
  }, [o, a]);
  const u = zG(c), d = () => {
    r || (s && u(), l((T) => {
      var I;
      const P = !T;
      return typeof a == "object" && ((I = a.onVisibleChange) === null || I === void 0 || I.call(a, P)), P;
    }));
  }, f = (T) => {
    const I = yxe[n] || "", P = i(s), D = {
      [I]: d,
      className: `${T}-icon`,
      key: "passwordIcon",
      onMouseDown: (B) => {
        B.preventDefault();
      },
      onMouseUp: (B) => {
        B.preventDefault();
      }
    };
    return /* @__PURE__ */ p.cloneElement(/* @__PURE__ */ p.isValidElement(P) ? P : /* @__PURE__ */ p.createElement("span", null, P), D);
  }, {
    className: m,
    prefixCls: h,
    inputPrefixCls: g,
    size: y
  } = e, S = hxe(e, ["className", "prefixCls", "inputPrefixCls", "size"]), {
    getPrefixCls: x
  } = p.useContext(Lt), b = x("input", g), _ = x("input-password", h), $ = a && f(_), w = be(_, m, {
    [`${_}-${y}`]: !!y
  }), O = Object.assign(Object.assign({}, bn(S, ["suffix", "iconRender", "visibilityToggle"])), {
    type: s ? "text" : "password",
    className: w,
    prefixCls: b,
    suffix: $
  });
  return y && (O.size = y), /* @__PURE__ */ p.createElement(wh, Object.assign({
    ref: Za(t, c)
  }, O));
});
process.env.NODE_ENV !== "production" && (VG.displayName = "Input.Password");
var bxe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const GG = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    prefixCls: r,
    inputPrefixCls: n,
    className: a,
    size: i,
    suffix: o,
    enterButton: s = !1,
    addonAfter: l,
    loading: c,
    disabled: u,
    onSearch: d,
    onChange: f,
    onCompositionStart: m,
    onCompositionEnd: h
  } = e, g = bxe(e, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton", "addonAfter", "loading", "disabled", "onSearch", "onChange", "onCompositionStart", "onCompositionEnd"]), {
    getPrefixCls: y,
    direction: S
  } = p.useContext(Lt), x = p.useRef(!1), b = y("input-search", r), _ = y("input", n), {
    compactSize: $
  } = El(b, S), w = Xa((G) => {
    var V;
    return (V = i ?? $) !== null && V !== void 0 ? V : G;
  }), O = p.useRef(null), T = (G) => {
    G && G.target && G.type === "click" && d && d(G.target.value, G, {
      source: "clear"
    }), f && f(G);
  }, I = (G) => {
    var V;
    document.activeElement === ((V = O.current) === null || V === void 0 ? void 0 : V.input) && G.preventDefault();
  }, P = (G) => {
    var V, K;
    d && d((K = (V = O.current) === null || V === void 0 ? void 0 : V.input) === null || K === void 0 ? void 0 : K.value, G, {
      source: "input"
    });
  }, D = (G) => {
    x.current || c || P(G);
  }, B = typeof s == "boolean" ? /* @__PURE__ */ p.createElement(L1, null) : null, L = `${b}-button`;
  let N;
  const z = s || {}, F = z.type && z.type.__ANT_BUTTON === !0;
  F || z.type === "button" ? N = Si(z, Object.assign({
    onMouseDown: I,
    onClick: (G) => {
      var V, K;
      (K = (V = z?.props) === null || V === void 0 ? void 0 : V.onClick) === null || K === void 0 || K.call(V, G), P(G);
    },
    key: "enterButton"
  }, F ? {
    className: L,
    size: w
  } : {})) : N = /* @__PURE__ */ p.createElement(Nt, {
    className: L,
    type: s ? "primary" : void 0,
    size: w,
    disabled: u,
    key: "enterButton",
    onMouseDown: I,
    onClick: P,
    loading: c,
    icon: B
  }, s), l && (N = [N, Si(l, {
    key: "addonAfter"
  })]);
  const j = be(b, {
    [`${b}-rtl`]: S === "rtl",
    [`${b}-${w}`]: !!w,
    [`${b}-with-button`]: !!s
  }, a), H = (G) => {
    x.current = !0, m?.(G);
  }, U = (G) => {
    x.current = !1, h?.(G);
  };
  return /* @__PURE__ */ p.createElement(wh, Object.assign({
    ref: Za(O, t),
    onPressEnter: D
  }, g, {
    size: w,
    onCompositionStart: H,
    onCompositionEnd: U,
    prefixCls: _,
    addonAfter: N,
    suffix: o,
    onChange: T,
    className: j,
    disabled: u
  }));
});
process.env.NODE_ENV !== "production" && (GG.displayName = "Search");
var Cxe = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`, Sxe = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break", "white-space"], Tx = {}, no;
function xxe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = e.getAttribute("id") || e.getAttribute("data-reactid") || e.getAttribute("name");
  if (t && Tx[r])
    return Tx[r];
  var n = window.getComputedStyle(e), a = n.getPropertyValue("box-sizing") || n.getPropertyValue("-moz-box-sizing") || n.getPropertyValue("-webkit-box-sizing"), i = parseFloat(n.getPropertyValue("padding-bottom")) + parseFloat(n.getPropertyValue("padding-top")), o = parseFloat(n.getPropertyValue("border-bottom-width")) + parseFloat(n.getPropertyValue("border-top-width")), s = Sxe.map(function(c) {
    return "".concat(c, ":").concat(n.getPropertyValue(c));
  }).join(";"), l = {
    sizingStyle: s,
    paddingSize: i,
    borderSize: o,
    boxSizing: a
  };
  return t && r && (Tx[r] = l), l;
}
function $xe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  no || (no = document.createElement("textarea"), no.setAttribute("tab-index", "-1"), no.setAttribute("aria-hidden", "true"), document.body.appendChild(no)), e.getAttribute("wrap") ? no.setAttribute("wrap", e.getAttribute("wrap")) : no.removeAttribute("wrap");
  var a = xxe(e, t), i = a.paddingSize, o = a.borderSize, s = a.boxSizing, l = a.sizingStyle;
  no.setAttribute("style", "".concat(l, ";").concat(Cxe)), no.value = e.value || e.placeholder || "";
  var c = void 0, u = void 0, d, f = no.scrollHeight;
  if (s === "border-box" ? f += o : s === "content-box" && (f -= i), r !== null || n !== null) {
    no.value = " ";
    var m = no.scrollHeight - i;
    r !== null && (c = m * r, s === "border-box" && (c = c + i + o), f = Math.max(c, f)), n !== null && (u = m * n, s === "border-box" && (u = u + i + o), d = f > u ? "" : "hidden", f = Math.min(u, f));
  }
  var h = {
    height: f,
    overflowY: d,
    resize: "none"
  };
  return c && (h.minHeight = c), u && (h.maxHeight = u), h;
}
var _xe = ["prefixCls", "onPressEnter", "defaultValue", "value", "autoSize", "onResize", "className", "style", "disabled", "onChange", "onInternalAutoSize"], Ix = 0, Mx = 1, Ax = 2, Exe = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e, n = r.prefixCls;
  r.onPressEnter;
  var a = r.defaultValue, i = r.value, o = r.autoSize, s = r.onResize, l = r.className, c = r.style, u = r.disabled, d = r.onChange, f = r.onInternalAutoSize, m = Kt(r, _xe), h = Kr(a, {
    value: i,
    postState: function(ae) {
      return ae ?? "";
    }
  }), g = ye(h, 2), y = g[0], S = g[1], x = function(ae) {
    S(ae.target.value), d?.(ae);
  }, b = p.useRef();
  p.useImperativeHandle(t, function() {
    return {
      textArea: b.current
    };
  });
  var _ = p.useMemo(function() {
    return o && kt(o) === "object" ? [o.minRows, o.maxRows] : [];
  }, [o]), $ = ye(_, 2), w = $[0], O = $[1], T = !!o, I = function() {
    try {
      if (document.activeElement === b.current) {
        var ae = b.current, ue = ae.selectionStart, re = ae.selectionEnd, oe = ae.scrollTop;
        b.current.setSelectionRange(ue, re), b.current.scrollTop = oe;
      }
    } catch {
    }
  }, P = p.useState(Ax), D = ye(P, 2), B = D[0], L = D[1], N = p.useState(), z = ye(N, 2), F = z[0], j = z[1], H = function() {
    L(Ix), process.env.NODE_ENV === "test" && f?.();
  };
  hr(function() {
    T && H();
  }, [i, w, O, T]), hr(function() {
    if (B === Ix)
      L(Mx);
    else if (B === Mx) {
      var ee = $xe(b.current, !1, w, O);
      L(Ax), j(ee);
    } else
      I();
  }, [B]);
  var U = p.useRef(), G = function() {
    vr.cancel(U.current);
  }, V = function(ae) {
    B === Ax && (s?.(ae), o && (G(), U.current = vr(function() {
      H();
    })));
  };
  p.useEffect(function() {
    return G;
  }, []);
  var K = T ? F : null, Z = ce(ce({}, c), K);
  return (B === Ix || B === Mx) && (Z.overflowY = "hidden", Z.overflowX = "hidden"), /* @__PURE__ */ p.createElement(Ia, {
    onResize: V,
    disabled: !(o || s)
  }, /* @__PURE__ */ p.createElement("textarea", Pe({}, m, {
    ref: b,
    style: Z,
    className: be(n, l, te({}, "".concat(n, "-disabled"), u)),
    disabled: u,
    value: y,
    onChange: x
  })));
}), wxe = ["defaultValue", "value", "onFocus", "onBlur", "onChange", "allowClear", "maxLength", "onCompositionStart", "onCompositionEnd", "suffix", "prefixCls", "showCount", "count", "className", "style", "disabled", "hidden", "classNames", "styles", "onResize", "readOnly"], Oxe = /* @__PURE__ */ xe.forwardRef(function(e, t) {
  var r, n = e.defaultValue, a = e.value, i = e.onFocus, o = e.onBlur, s = e.onChange, l = e.allowClear, c = e.maxLength, u = e.onCompositionStart, d = e.onCompositionEnd, f = e.suffix, m = e.prefixCls, h = m === void 0 ? "rc-textarea" : m, g = e.showCount, y = e.count, S = e.className, x = e.style, b = e.disabled, _ = e.hidden, $ = e.classNames, w = e.styles, O = e.onResize, T = e.readOnly, I = Kt(e, wxe), P = Kr(n, {
    value: a,
    defaultValue: n
  }), D = ye(P, 2), B = D[0], L = D[1], N = B == null ? "" : String(B), z = xe.useState(!1), F = ye(z, 2), j = F[0], H = F[1], U = xe.useRef(!1), G = xe.useState(null), V = ye(G, 2), K = V[0], Z = V[1], ee = ct(null), ae = ct(null), ue = function() {
    var Ie;
    return (Ie = ae.current) === null || Ie === void 0 ? void 0 : Ie.textArea;
  }, re = function() {
    ue().focus();
  };
  fo(t, function() {
    var Le;
    return {
      resizableTextArea: ae.current,
      focus: re,
      blur: function() {
        ue().blur();
      },
      nativeElement: ((Le = ee.current) === null || Le === void 0 ? void 0 : Le.nativeElement) || ue()
    };
  }), St(function() {
    H(function(Le) {
      return !b && Le;
    });
  }, [b]);
  var oe = xe.useState(null), fe = ye(oe, 2), le = fe[0], se = fe[1];
  xe.useEffect(function() {
    if (le) {
      var Le;
      (Le = ue()).setSelectionRange.apply(Le, ze(le));
    }
  }, [le]);
  var Q = LG(y, g), he = (r = Q.max) !== null && r !== void 0 ? r : c, ne = Number(he) > 0, me = Q.strategy(N), k = !!he && me > he, M = function(Ie, De) {
    var Ae = De;
    !U.current && Q.exceedFormatter && Q.max && Q.strategy(De) > Q.max && (Ae = Q.exceedFormatter(De, {
      max: Q.max
    }), De !== Ae && se([ue().selectionStart || 0, ue().selectionEnd || 0])), L(Ae), zb(Ie.currentTarget, Ie, s, Ae);
  }, R = function(Ie) {
    U.current = !0, u?.(Ie);
  }, q = function(Ie) {
    U.current = !1, M(Ie, Ie.currentTarget.value), d?.(Ie);
  }, Y = function(Ie) {
    M(Ie, Ie.target.value);
  }, X = function(Ie) {
    var De = I.onPressEnter, Ae = I.onKeyDown;
    Ie.key === "Enter" && De && De(Ie), Ae?.(Ie);
  }, pe = function(Ie) {
    H(!0), i?.(Ie);
  }, $e = function(Ie) {
    H(!1), o?.(Ie);
  }, J = function(Ie) {
    L(""), re(), zb(ue(), Ie, s);
  }, de = f, Se;
  Q.show && (Q.showFormatter ? Se = Q.showFormatter({
    value: N,
    count: me,
    maxLength: he
  }) : Se = "".concat(me).concat(ne ? " / ".concat(he) : ""), de = /* @__PURE__ */ xe.createElement(xe.Fragment, null, de, /* @__PURE__ */ xe.createElement("span", {
    className: be("".concat(h, "-data-count"), $?.count),
    style: w?.count
  }, Se)));
  var Ee = function(Ie) {
    var De;
    O?.(Ie), (De = ue()) !== null && De !== void 0 && De.style.height && Z(!0);
  }, Te = !I.autoSize && !g && !l;
  return /* @__PURE__ */ xe.createElement(PI, {
    ref: ee,
    value: N,
    allowClear: l,
    handleReset: J,
    suffix: de,
    prefixCls: h,
    classNames: ce(ce({}, $), {}, {
      affixWrapper: be($?.affixWrapper, te(te({}, "".concat(h, "-show-count"), g), "".concat(h, "-textarea-allow-clear"), l))
    }),
    disabled: b,
    focused: j,
    className: be(S, k && "".concat(h, "-out-of-range")),
    style: ce(ce({}, x), K && !Te ? {
      height: "auto"
    } : {}),
    dataAttrs: {
      affixWrapper: {
        "data-count": typeof Se == "string" ? Se : void 0
      }
    },
    hidden: _,
    readOnly: T
  }, /* @__PURE__ */ xe.createElement(Exe, Pe({}, I, {
    maxLength: c,
    onKeyDown: X,
    onChange: Y,
    onFocus: pe,
    onBlur: $e,
    onCompositionStart: R,
    onCompositionEnd: q,
    className: be($?.textarea),
    style: ce(ce({}, w?.textarea), {}, {
      resize: x?.resize
    }),
    disabled: b,
    prefixCls: h,
    onResize: Ee,
    ref: ae,
    readOnly: T
  })));
}), Txe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const UG = /* @__PURE__ */ Aa((e, t) => {
  var r, n;
  const {
    prefixCls: a,
    bordered: i = !0,
    size: o,
    disabled: s,
    status: l,
    allowClear: c,
    classNames: u,
    rootClassName: d,
    className: f,
    style: m,
    styles: h,
    variant: g
  } = e, y = Txe(e, ["prefixCls", "bordered", "size", "disabled", "status", "allowClear", "classNames", "rootClassName", "className", "style", "styles", "variant"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: G
    } = xr("TextArea");
    G(!("bordered" in e), "bordered", "variant");
  }
  const {
    getPrefixCls: S,
    direction: x,
    textArea: b
  } = p.useContext(Lt), _ = Xa(o), $ = p.useContext(Vi), w = s ?? $, {
    status: O,
    hasFeedback: T,
    feedbackIcon: I
  } = p.useContext(xa), P = kc(O, l), D = p.useRef(null);
  p.useImperativeHandle(t, () => {
    var G;
    return {
      resizableTextArea: (G = D.current) === null || G === void 0 ? void 0 : G.resizableTextArea,
      focus: (V) => {
        var K, Z;
        ixe((Z = (K = D.current) === null || K === void 0 ? void 0 : K.resizableTextArea) === null || Z === void 0 ? void 0 : Z.textArea, V);
      },
      blur: () => {
        var V;
        return (V = D.current) === null || V === void 0 ? void 0 : V.blur();
      }
    };
  });
  const B = S("input", a), L = Mn(B), [N, z, F] = EI(B, L), [j, H] = xd(g, i), U = BG(c ?? b?.allowClear);
  return N(/* @__PURE__ */ p.createElement(Oxe, Object.assign({
    autoComplete: b?.autoComplete
  }, y, {
    style: Object.assign(Object.assign({}, b?.style), m),
    styles: Object.assign(Object.assign({}, b?.styles), h),
    disabled: w,
    allowClear: U,
    className: be(F, L, f, d, b?.className),
    classNames: Object.assign(Object.assign(Object.assign({}, u), b?.classNames), {
      textarea: be({
        [`${B}-sm`]: _ === "small",
        [`${B}-lg`]: _ === "large"
      }, z, u?.textarea, (r = b?.classNames) === null || r === void 0 ? void 0 : r.textarea),
      variant: be({
        [`${B}-${j}`]: H
      }, xl(B, P)),
      affixWrapper: be(`${B}-textarea-affix-wrapper`, {
        [`${B}-affix-wrapper-rtl`]: x === "rtl",
        [`${B}-affix-wrapper-sm`]: _ === "small",
        [`${B}-affix-wrapper-lg`]: _ === "large",
        [`${B}-textarea-show-count`]: e.showCount || ((n = e.count) === null || n === void 0 ? void 0 : n.show)
      }, z)
    }),
    prefixCls: B,
    suffix: T && /* @__PURE__ */ p.createElement("span", {
      className: `${B}-textarea-suffix`
    }, I),
    ref: D
  })));
}), Lr = wh;
Lr.Group = rxe;
Lr.Search = GG;
Lr.TextArea = UG;
Lr.Password = VG;
Lr.OTP = dxe;
var Ixe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" } }] }, name: "calendar", theme: "outlined" }, Mxe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: Ixe
  }));
}, NI = /* @__PURE__ */ p.forwardRef(Mxe);
process.env.NODE_ENV !== "production" && (NI.displayName = "CalendarOutlined");
var Axe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" } }] }, name: "clock-circle", theme: "outlined" }, Pxe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: Axe
  }));
}, DI = /* @__PURE__ */ p.forwardRef(Pxe);
process.env.NODE_ENV !== "production" && (DI.displayName = "ClockCircleOutlined");
var Rxe = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" } }] }, name: "swap-right", theme: "outlined" }, Nxe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: Rxe
  }));
}, WG = /* @__PURE__ */ p.forwardRef(Nxe);
process.env.NODE_ENV !== "production" && (WG.displayName = "SwapRightOutlined");
function Dxe(e, t, r) {
  return r !== void 0 ? r : t === "year" && e.lang.yearPlaceholder ? e.lang.yearPlaceholder : t === "quarter" && e.lang.quarterPlaceholder ? e.lang.quarterPlaceholder : t === "month" && e.lang.monthPlaceholder ? e.lang.monthPlaceholder : t === "week" && e.lang.weekPlaceholder ? e.lang.weekPlaceholder : t === "time" && e.timePickerLocale.placeholder ? e.timePickerLocale.placeholder : e.lang.placeholder;
}
function jxe(e, t, r) {
  return r !== void 0 ? r : t === "year" && e.lang.yearPlaceholder ? e.lang.rangeYearPlaceholder : t === "quarter" && e.lang.quarterPlaceholder ? e.lang.rangeQuarterPlaceholder : t === "month" && e.lang.monthPlaceholder ? e.lang.rangeMonthPlaceholder : t === "week" && e.lang.weekPlaceholder ? e.lang.rangeWeekPlaceholder : t === "time" && e.timePickerLocale.placeholder ? e.timePickerLocale.rangePlaceholder : e.lang.rangePlaceholder;
}
function jI(e, t) {
  const r = {
    adjustX: 1,
    adjustY: 1
  };
  switch (t) {
    case "bottomLeft":
      return {
        points: ["tl", "bl"],
        offset: [0, 4],
        overflow: r
      };
    case "bottomRight":
      return {
        points: ["tr", "br"],
        offset: [0, 4],
        overflow: r
      };
    case "topLeft":
      return {
        points: ["bl", "tl"],
        offset: [0, -4],
        overflow: r
      };
    case "topRight":
      return {
        points: ["br", "tr"],
        offset: [0, -4],
        overflow: r
      };
    default:
      return {
        points: e === "rtl" ? ["tr", "br"] : ["tl", "bl"],
        offset: [0, 4],
        overflow: r
      };
  }
}
function qG(e, t) {
  const {
    allowClear: r = !0
  } = e, {
    clearIcon: n,
    removeIcon: a
  } = HH(Object.assign(Object.assign({}, e), {
    prefixCls: t,
    componentName: "DatePicker"
  }));
  return [p.useMemo(() => r === !1 ? !1 : Object.assign({
    clearIcon: n
  }, r === !0 ? {} : r), [r, n]), a];
}
function Lxe(e) {
  return /* @__PURE__ */ p.createElement(Nt, Object.assign({
    size: "small",
    type: "primary"
  }, e));
}
function KG(e) {
  return dr(() => Object.assign({
    button: Lxe
  }, e), [e]);
}
var kxe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function Fxe(e) {
  const t = /* @__PURE__ */ Aa((r, n) => {
    var a;
    const {
      prefixCls: i,
      getPopupContainer: o,
      components: s,
      className: l,
      style: c,
      placement: u,
      size: d,
      disabled: f,
      bordered: m = !0,
      placeholder: h,
      popupClassName: g,
      dropdownClassName: y,
      status: S,
      rootClassName: x,
      variant: b
    } = r, _ = kxe(r, ["prefixCls", "getPopupContainer", "components", "className", "style", "placement", "size", "disabled", "bordered", "placeholder", "popupClassName", "dropdownClassName", "status", "rootClassName", "variant"]), $ = p.useRef(null), {
      getPrefixCls: w,
      direction: O,
      getPopupContainer: T,
      rangePicker: I
    } = Cr(Lt), P = w("picker", i), {
      compactSize: D,
      compactItemClassnames: B
    } = El(P, O), {
      picker: L
    } = r, N = w(), [z, F] = xd(b, m), j = Mn(P), [H, U, G] = gG(P, j);
    if (process.env.NODE_ENV !== "production") {
      const ne = xr("DatePicker.RangePicker");
      ne.deprecated(!y, "dropdownClassName", "popupClassName"), ne.deprecated(!("bordered" in r), "bordered", "variant");
    }
    const [V] = qG(r, P), K = KG(s), Z = Xa((ne) => {
      var me;
      return (me = d ?? D) !== null && me !== void 0 ? me : ne;
    }), ee = p.useContext(Vi), ae = f ?? ee, ue = Cr(xa), {
      hasFeedback: re,
      status: oe,
      feedbackIcon: fe
    } = ue, le = /* @__PURE__ */ p.createElement(p.Fragment, null, L === "time" ? /* @__PURE__ */ p.createElement(DI, null) : /* @__PURE__ */ p.createElement(NI, null), re && fe);
    fo(n, () => $.current);
    const [se] = Ks("Calendar", Ob), Q = Object.assign(Object.assign({}, se), r.locale), [he] = ps("DatePicker", (a = r.popupStyle) === null || a === void 0 ? void 0 : a.zIndex);
    return H(/* @__PURE__ */ p.createElement(Lc, null, /* @__PURE__ */ p.createElement(iG, Object.assign({
      separator: /* @__PURE__ */ p.createElement("span", {
        "aria-label": "to",
        className: `${P}-separator`
      }, /* @__PURE__ */ p.createElement(WG, null)),
      disabled: ae,
      ref: $,
      popupAlign: jI(O, u),
      placement: u,
      placeholder: jxe(Q, L, h),
      suffixIcon: le,
      prevIcon: /* @__PURE__ */ p.createElement("span", {
        className: `${P}-prev-icon`
      }),
      nextIcon: /* @__PURE__ */ p.createElement("span", {
        className: `${P}-next-icon`
      }),
      superPrevIcon: /* @__PURE__ */ p.createElement("span", {
        className: `${P}-super-prev-icon`
      }),
      superNextIcon: /* @__PURE__ */ p.createElement("span", {
        className: `${P}-super-next-icon`
      }),
      transitionName: `${N}-slide-up`
    }, _, {
      className: be({
        [`${P}-${Z}`]: Z,
        [`${P}-${z}`]: F
      }, xl(P, kc(oe, S), re), U, B, l, I?.className, G, j, x),
      style: Object.assign(Object.assign({}, I?.style), c),
      locale: Q.lang,
      prefixCls: P,
      getPopupContainer: o || T,
      generateConfig: e,
      components: K,
      direction: O,
      classNames: {
        popup: be(U, g || y, G, j, x)
      },
      styles: {
        popup: Object.assign(Object.assign({}, r.popupStyle), {
          zIndex: he
        })
      },
      allowClear: V
    }))));
  });
  return process.env.NODE_ENV !== "production" && (t.displayName = "RangePicker"), t;
}
var Bxe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function zxe(e) {
  function t(l, c) {
    const u = c === "TimePicker" ? "timePicker" : "datePicker", d = /* @__PURE__ */ Aa((f, m) => {
      var h;
      const {
        prefixCls: g,
        getPopupContainer: y,
        components: S,
        style: x,
        className: b,
        rootClassName: _,
        size: $,
        bordered: w,
        placement: O,
        placeholder: T,
        popupClassName: I,
        dropdownClassName: P,
        disabled: D,
        status: B,
        variant: L,
        onCalendarChange: N
      } = f, z = Bxe(f, ["prefixCls", "getPopupContainer", "components", "style", "className", "rootClassName", "size", "bordered", "placement", "placeholder", "popupClassName", "dropdownClassName", "disabled", "status", "variant", "onCalendarChange"]), {
        getPrefixCls: F,
        direction: j,
        getPopupContainer: H,
        // Consume different styles according to different names
        [u]: U
      } = Cr(Lt), G = F("picker", g), {
        compactSize: V,
        compactItemClassnames: K
      } = El(G, j), Z = p.useRef(null), [ee, ae] = xd(L, w), ue = Mn(G), [re, oe, fe] = gG(G, ue);
      fo(m, () => Z.current);
      const le = {
        showToday: !0
      }, se = l || f.picker, Q = F(), {
        onSelect: he,
        multiple: ne
      } = z, me = he && l === "time" && !ne, k = (De, Ae, Fe) => {
        N?.(De, Ae, Fe), me && he(De);
      };
      if (process.env.NODE_ENV !== "production") {
        const De = xr(c || "DatePicker");
        process.env.NODE_ENV !== "production" && De(l !== "quarter", "deprecated", `DatePicker.${c} is legacy usage. Please use DatePicker[picker='${l}'] directly.`), De.deprecated(!P, "dropdownClassName", "popupClassName"), De.deprecated(!("bordered" in f), "bordered", "variant"), De.deprecated(!me, "onSelect", "onCalendarChange");
      }
      const [M, R] = qG(f, G), q = KG(S), Y = Xa((De) => {
        var Ae;
        return (Ae = $ ?? V) !== null && Ae !== void 0 ? Ae : De;
      }), X = p.useContext(Vi), pe = D ?? X, $e = Cr(xa), {
        hasFeedback: J,
        status: de,
        feedbackIcon: Se
      } = $e, Ee = /* @__PURE__ */ p.createElement(p.Fragment, null, se === "time" ? /* @__PURE__ */ p.createElement(DI, null) : /* @__PURE__ */ p.createElement(NI, null), J && Se), [Te] = Ks("DatePicker", Ob), Le = Object.assign(Object.assign({}, Te), f.locale), [Ie] = ps("DatePicker", (h = f.popupStyle) === null || h === void 0 ? void 0 : h.zIndex);
      return re(/* @__PURE__ */ p.createElement(Lc, null, /* @__PURE__ */ p.createElement(sG, Object.assign({
        ref: Z,
        placeholder: Dxe(Le, se, T),
        suffixIcon: Ee,
        dropdownAlign: jI(j, O),
        placement: O,
        prevIcon: /* @__PURE__ */ p.createElement("span", {
          className: `${G}-prev-icon`
        }),
        nextIcon: /* @__PURE__ */ p.createElement("span", {
          className: `${G}-next-icon`
        }),
        superPrevIcon: /* @__PURE__ */ p.createElement("span", {
          className: `${G}-super-prev-icon`
        }),
        superNextIcon: /* @__PURE__ */ p.createElement("span", {
          className: `${G}-super-next-icon`
        }),
        transitionName: `${Q}-slide-up`,
        picker: l,
        onCalendarChange: k
      }, le, z, {
        locale: Le.lang,
        className: be({
          [`${G}-${Y}`]: Y,
          [`${G}-${ee}`]: ae
        }, xl(G, kc(de, B), J), oe, K, U?.className, b, fe, ue, _),
        style: Object.assign(Object.assign({}, U?.style), x),
        prefixCls: G,
        getPopupContainer: y || H,
        generateConfig: e,
        components: q,
        direction: j,
        disabled: pe,
        classNames: {
          popup: be(oe, fe, ue, _, I || P)
        },
        styles: {
          popup: Object.assign(Object.assign({}, f.popupStyle), {
            zIndex: Ie
          })
        },
        allowClear: M,
        removeIcon: R
      }))));
    });
    return process.env.NODE_ENV !== "production" && c && (d.displayName = c), d;
  }
  const r = t(), n = t("week", "WeekPicker"), a = t("month", "MonthPicker"), i = t("year", "YearPicker"), o = t("quarter", "QuarterPicker"), s = t("time", "TimePicker");
  return {
    DatePicker: r,
    WeekPicker: n,
    MonthPicker: a,
    YearPicker: i,
    TimePicker: s,
    QuarterPicker: o
  };
}
function YG(e) {
  const {
    DatePicker: t,
    WeekPicker: r,
    MonthPicker: n,
    YearPicker: a,
    TimePicker: i,
    QuarterPicker: o
  } = zxe(e), s = Fxe(e), l = t;
  return l.WeekPicker = r, l.MonthPicker = n, l.YearPicker = a, l.RangePicker = s, l.TimePicker = i, l.QuarterPicker = o, process.env.NODE_ENV !== "production" && (l.displayName = "DatePicker"), l;
}
const Od = YG(Dbe);
function ZG(e) {
  const t = jI(e.direction, e.placement);
  return t.overflow.adjustY = !1, t.overflow.adjustX = !1, Object.assign(Object.assign({}, e), {
    dropdownAlign: t
  });
}
const Hxe = P1(Od, "picker", null, ZG);
Od._InternalPanelDoNotUseOrYouWillBeFired = Hxe;
const Vxe = P1(Od.RangePicker, "picker", null, ZG);
Od._InternalRangePanelDoNotUseOrYouWillBeFired = Vxe;
Od.generatePicker = YG;
var u4 = /* @__PURE__ */ p.createContext(null), XG = /* @__PURE__ */ p.createContext({}), Gxe = ["prefixCls", "className", "containerRef"], JG = function(t) {
  var r = t.prefixCls, n = t.className, a = t.containerRef, i = Kt(t, Gxe), o = p.useContext(XG), s = o.panel, l = qs(s, a);
  return /* @__PURE__ */ p.createElement("div", Pe({
    className: be("".concat(r, "-content"), n),
    role: "dialog",
    ref: l
  }, aa(t, {
    aria: !0
  }), {
    "aria-modal": "true"
  }, i));
};
process.env.NODE_ENV !== "production" && (JG.displayName = "DrawerPanel");
function d4(e) {
  return typeof e == "string" && String(Number(e)) === e ? (jt(!1, "Invalid value type of `width` or `height` which should be number type instead."), Number(e)) : e;
}
function Uxe(e) {
  jt(!("wrapperClassName" in e), "'wrapperClassName' is removed. Please use 'rootClassName' instead."), jt(Ca() || !e.open, "Drawer with 'open' in SSR is not work since no place to createPortal. Please move to 'useEffect' instead.");
}
var f4 = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none",
  position: "absolute"
};
function Wxe(e, t) {
  var r, n, a, i = e.prefixCls, o = e.open, s = e.placement, l = e.inline, c = e.push, u = e.forceRender, d = e.autoFocus, f = e.keyboard, m = e.classNames, h = e.rootClassName, g = e.rootStyle, y = e.zIndex, S = e.className, x = e.id, b = e.style, _ = e.motion, $ = e.width, w = e.height, O = e.children, T = e.mask, I = e.maskClosable, P = e.maskMotion, D = e.maskClassName, B = e.maskStyle, L = e.afterOpenChange, N = e.onClose, z = e.onMouseEnter, F = e.onMouseOver, j = e.onMouseLeave, H = e.onClick, U = e.onKeyDown, G = e.onKeyUp, V = e.styles, K = e.drawerRender, Z = p.useRef(), ee = p.useRef(), ae = p.useRef();
  p.useImperativeHandle(t, function() {
    return Z.current;
  });
  var ue = function(pe) {
    var $e = pe.keyCode, J = pe.shiftKey;
    switch ($e) {
      case Mt.TAB: {
        if ($e === Mt.TAB) {
          if (!J && document.activeElement === ae.current) {
            var de;
            (de = ee.current) === null || de === void 0 || de.focus({
              preventScroll: !0
            });
          } else if (J && document.activeElement === ee.current) {
            var Se;
            (Se = ae.current) === null || Se === void 0 || Se.focus({
              preventScroll: !0
            });
          }
        }
        break;
      }
      case Mt.ESC: {
        N && f && (pe.stopPropagation(), N(pe));
        break;
      }
    }
  };
  p.useEffect(function() {
    if (o && d) {
      var X;
      (X = Z.current) === null || X === void 0 || X.focus({
        preventScroll: !0
      });
    }
  }, [o]);
  var re = p.useState(!1), oe = ye(re, 2), fe = oe[0], le = oe[1], se = p.useContext(u4), Q;
  typeof c == "boolean" ? Q = c ? {} : {
    distance: 0
  } : Q = c || {};
  var he = (r = (n = (a = Q) === null || a === void 0 ? void 0 : a.distance) !== null && n !== void 0 ? n : se?.pushDistance) !== null && r !== void 0 ? r : 180, ne = p.useMemo(function() {
    return {
      pushDistance: he,
      push: function() {
        le(!0);
      },
      pull: function() {
        le(!1);
      }
    };
  }, [he]);
  p.useEffect(function() {
    if (o) {
      var X;
      se == null || (X = se.push) === null || X === void 0 || X.call(se);
    } else {
      var pe;
      se == null || (pe = se.pull) === null || pe === void 0 || pe.call(se);
    }
  }, [o]), p.useEffect(function() {
    return function() {
      var X;
      se == null || (X = se.pull) === null || X === void 0 || X.call(se);
    };
  }, []);
  var me = T && /* @__PURE__ */ p.createElement(Ci, Pe({
    key: "mask"
  }, P, {
    visible: o
  }), function(X, pe) {
    var $e = X.className, J = X.style;
    return /* @__PURE__ */ p.createElement("div", {
      className: be("".concat(i, "-mask"), $e, m?.mask, D),
      style: ce(ce(ce({}, J), B), V?.mask),
      onClick: I && o ? N : void 0,
      ref: pe
    });
  }), k = typeof _ == "function" ? _(s) : _, M = {};
  if (fe && he)
    switch (s) {
      case "top":
        M.transform = "translateY(".concat(he, "px)");
        break;
      case "bottom":
        M.transform = "translateY(".concat(-he, "px)");
        break;
      case "left":
        M.transform = "translateX(".concat(he, "px)");
        break;
      default:
        M.transform = "translateX(".concat(-he, "px)");
        break;
    }
  s === "left" || s === "right" ? M.width = d4($) : M.height = d4(w);
  var R = {
    onMouseEnter: z,
    onMouseOver: F,
    onMouseLeave: j,
    onClick: H,
    onKeyDown: U,
    onKeyUp: G
  }, q = /* @__PURE__ */ p.createElement(Ci, Pe({
    key: "panel"
  }, k, {
    visible: o,
    forceRender: u,
    onVisibleChanged: function(pe) {
      L?.(pe);
    },
    removeOnLeave: !1,
    leavedClassName: "".concat(i, "-content-wrapper-hidden")
  }), function(X, pe) {
    var $e = X.className, J = X.style, de = /* @__PURE__ */ p.createElement(JG, Pe({
      id: x,
      containerRef: pe,
      prefixCls: i,
      className: be(S, m?.content),
      style: ce(ce({}, b), V?.content)
    }, aa(e, {
      aria: !0
    }), R), O);
    return /* @__PURE__ */ p.createElement("div", Pe({
      className: be("".concat(i, "-content-wrapper"), m?.wrapper, $e),
      style: ce(ce(ce({}, M), J), V?.wrapper)
    }, aa(e, {
      data: !0
    })), K ? K(de) : de);
  }), Y = ce({}, g);
  return y && (Y.zIndex = y), /* @__PURE__ */ p.createElement(u4.Provider, {
    value: ne
  }, /* @__PURE__ */ p.createElement("div", {
    className: be(i, "".concat(i, "-").concat(s), h, te(te({}, "".concat(i, "-open"), o), "".concat(i, "-inline"), l)),
    style: Y,
    tabIndex: -1,
    ref: Z,
    onKeyDown: ue
  }, me, /* @__PURE__ */ p.createElement("div", {
    tabIndex: 0,
    ref: ee,
    style: f4,
    "aria-hidden": "true",
    "data-sentinel": "start"
  }), q, /* @__PURE__ */ p.createElement("div", {
    tabIndex: 0,
    ref: ae,
    style: f4,
    "aria-hidden": "true",
    "data-sentinel": "end"
  })));
}
var QG = /* @__PURE__ */ p.forwardRef(Wxe);
process.env.NODE_ENV !== "production" && (QG.displayName = "DrawerPopup");
var eU = function(t) {
  var r = t.open, n = r === void 0 ? !1 : r, a = t.prefixCls, i = a === void 0 ? "rc-drawer" : a, o = t.placement, s = o === void 0 ? "right" : o, l = t.autoFocus, c = l === void 0 ? !0 : l, u = t.keyboard, d = u === void 0 ? !0 : u, f = t.width, m = f === void 0 ? 378 : f, h = t.mask, g = h === void 0 ? !0 : h, y = t.maskClosable, S = y === void 0 ? !0 : y, x = t.getContainer, b = t.forceRender, _ = t.afterOpenChange, $ = t.destroyOnClose, w = t.onMouseEnter, O = t.onMouseOver, T = t.onMouseLeave, I = t.onClick, P = t.onKeyDown, D = t.onKeyUp, B = t.panelRef, L = p.useState(!1), N = ye(L, 2), z = N[0], F = N[1];
  process.env.NODE_ENV !== "production" && Uxe(t);
  var j = p.useState(!1), H = ye(j, 2), U = H[0], G = H[1];
  hr(function() {
    G(!0);
  }, []);
  var V = U ? n : !1, K = p.useRef(), Z = p.useRef();
  hr(function() {
    V && (Z.current = document.activeElement);
  }, [V]);
  var ee = function(fe) {
    var le;
    if (F(fe), _?.(fe), !fe && Z.current && !((le = K.current) !== null && le !== void 0 && le.contains(Z.current))) {
      var se;
      (se = Z.current) === null || se === void 0 || se.focus({
        preventScroll: !0
      });
    }
  }, ae = p.useMemo(function() {
    return {
      panel: B
    };
  }, [B]);
  if (!b && !z && !V && $)
    return null;
  var ue = {
    onMouseEnter: w,
    onMouseOver: O,
    onMouseLeave: T,
    onClick: I,
    onKeyDown: P,
    onKeyUp: D
  }, re = ce(ce({}, t), {}, {
    open: V,
    prefixCls: i,
    placement: s,
    autoFocus: c,
    keyboard: d,
    width: m,
    mask: g,
    maskClosable: S,
    inline: x === !1,
    afterOpenChange: ee,
    ref: K
  }, ue);
  return /* @__PURE__ */ p.createElement(XG.Provider, {
    value: ae
  }, /* @__PURE__ */ p.createElement(bd, {
    open: V || b || z,
    autoDestroy: !1,
    getContainer: x,
    autoLock: g && (V || z)
  }, /* @__PURE__ */ p.createElement(QG, re)));
};
process.env.NODE_ENV !== "production" && (eU.displayName = "Drawer");
const tU = (e) => {
  var t, r;
  const {
    prefixCls: n,
    title: a,
    footer: i,
    extra: o,
    loading: s,
    onClose: l,
    headerStyle: c,
    bodyStyle: u,
    footerStyle: d,
    children: f,
    classNames: m,
    styles: h
  } = e, {
    drawer: g
  } = p.useContext(Lt), y = p.useCallback(($) => /* @__PURE__ */ p.createElement("button", {
    type: "button",
    onClick: l,
    "aria-label": "Close",
    className: `${n}-close`
  }, $), [l]), [S, x] = BT(sd(e), sd(g), {
    closable: !0,
    closeIconRender: y
  }), b = p.useMemo(() => {
    var $, w;
    return !a && !S ? null : /* @__PURE__ */ p.createElement("div", {
      style: Object.assign(Object.assign(Object.assign({}, ($ = g?.styles) === null || $ === void 0 ? void 0 : $.header), c), h?.header),
      className: be(`${n}-header`, {
        [`${n}-header-close-only`]: S && !a && !o
      }, (w = g?.classNames) === null || w === void 0 ? void 0 : w.header, m?.header)
    }, /* @__PURE__ */ p.createElement("div", {
      className: `${n}-header-title`
    }, x, a && /* @__PURE__ */ p.createElement("div", {
      className: `${n}-title`
    }, a)), o && /* @__PURE__ */ p.createElement("div", {
      className: `${n}-extra`
    }, o));
  }, [S, x, o, c, n, a]), _ = p.useMemo(() => {
    var $, w;
    if (!i)
      return null;
    const O = `${n}-footer`;
    return /* @__PURE__ */ p.createElement("div", {
      className: be(O, ($ = g?.classNames) === null || $ === void 0 ? void 0 : $.footer, m?.footer),
      style: Object.assign(Object.assign(Object.assign({}, (w = g?.styles) === null || w === void 0 ? void 0 : w.footer), d), h?.footer)
    }, i);
  }, [i, d, n]);
  return /* @__PURE__ */ p.createElement(p.Fragment, null, b, /* @__PURE__ */ p.createElement("div", {
    className: be(`${n}-body`, m?.body, (t = g?.classNames) === null || t === void 0 ? void 0 : t.body),
    style: Object.assign(Object.assign(Object.assign({}, (r = g?.styles) === null || r === void 0 ? void 0 : r.body), u), h?.body)
  }, s ? /* @__PURE__ */ p.createElement(Ui, {
    active: !0,
    title: !1,
    paragraph: {
      rows: 5
    },
    className: `${n}-body-skeleton`
  }) : f), _);
}, qxe = (e) => {
  const t = "100%";
  return {
    left: `translateX(-${t})`,
    right: `translateX(${t})`,
    top: `translateY(-${t})`,
    bottom: `translateY(${t})`
  }[e];
}, rU = (e, t) => ({
  "&-enter, &-appear": Object.assign(Object.assign({}, e), {
    "&-active": t
  }),
  "&-leave": Object.assign(Object.assign({}, t), {
    "&-active": e
  })
}), nU = (e, t) => Object.assign({
  "&-enter, &-appear, &-leave": {
    "&-start": {
      transition: "none"
    },
    "&-active": {
      transition: `all ${t}`
    }
  }
}, rU({
  opacity: e
}, {
  opacity: 1
})), Kxe = (e, t) => [nU(0.7, t), rU({
  transform: qxe(e)
}, {
  transform: "none"
})], Yxe = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: r
  } = e;
  return {
    [t]: {
      // ======================== Mask ========================
      [`${t}-mask-motion`]: nU(0, r),
      // ======================= Panel ========================
      [`${t}-panel-motion`]: ["left", "right", "top", "bottom"].reduce((n, a) => Object.assign(Object.assign({}, n), {
        [`&-${a}`]: Kxe(a, r)
      }), {})
    }
  };
}, Zxe = (e) => {
  const {
    borderRadiusSM: t,
    componentCls: r,
    zIndexPopup: n,
    colorBgMask: a,
    colorBgElevated: i,
    motionDurationSlow: o,
    motionDurationMid: s,
    paddingXS: l,
    padding: c,
    paddingLG: u,
    fontSizeLG: d,
    lineHeightLG: f,
    lineWidth: m,
    lineType: h,
    colorSplit: g,
    marginXS: y,
    colorIcon: S,
    colorIconHover: x,
    colorBgTextHover: b,
    colorBgTextActive: _,
    colorText: $,
    fontWeightStrong: w,
    footerPaddingBlock: O,
    footerPaddingInline: T,
    calc: I
  } = e, P = `${r}-content-wrapper`;
  return {
    [r]: {
      position: "fixed",
      inset: 0,
      zIndex: n,
      pointerEvents: "none",
      color: $,
      "&-pure": {
        position: "relative",
        background: i,
        display: "flex",
        flexDirection: "column",
        [`&${r}-left`]: {
          boxShadow: e.boxShadowDrawerLeft
        },
        [`&${r}-right`]: {
          boxShadow: e.boxShadowDrawerRight
        },
        [`&${r}-top`]: {
          boxShadow: e.boxShadowDrawerUp
        },
        [`&${r}-bottom`]: {
          boxShadow: e.boxShadowDrawerDown
        }
      },
      "&-inline": {
        position: "absolute"
      },
      // ====================== Mask ======================
      [`${r}-mask`]: {
        position: "absolute",
        inset: 0,
        zIndex: n,
        background: a,
        pointerEvents: "auto"
      },
      // ==================== Content =====================
      [P]: {
        position: "absolute",
        zIndex: n,
        maxWidth: "100vw",
        transition: `all ${o}`,
        "&-hidden": {
          display: "none"
        }
      },
      // Placement
      [`&-left > ${P}`]: {
        top: 0,
        bottom: 0,
        left: {
          _skip_check_: !0,
          value: 0
        },
        boxShadow: e.boxShadowDrawerLeft
      },
      [`&-right > ${P}`]: {
        top: 0,
        right: {
          _skip_check_: !0,
          value: 0
        },
        bottom: 0,
        boxShadow: e.boxShadowDrawerRight
      },
      [`&-top > ${P}`]: {
        top: 0,
        insetInline: 0,
        boxShadow: e.boxShadowDrawerUp
      },
      [`&-bottom > ${P}`]: {
        bottom: 0,
        insetInline: 0,
        boxShadow: e.boxShadowDrawerDown
      },
      [`${r}-content`]: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        overflow: "auto",
        background: i,
        pointerEvents: "auto"
      },
      // Header
      [`${r}-header`]: {
        display: "flex",
        flex: 0,
        alignItems: "center",
        padding: `${ve(c)} ${ve(u)}`,
        fontSize: d,
        lineHeight: f,
        borderBottom: `${ve(m)} ${h} ${g}`,
        "&-title": {
          display: "flex",
          flex: 1,
          alignItems: "center",
          minWidth: 0,
          minHeight: 0
        }
      },
      [`${r}-extra`]: {
        flex: "none"
      },
      [`${r}-close`]: Object.assign({
        display: "inline-flex",
        width: I(d).add(l).equal(),
        height: I(d).add(l).equal(),
        borderRadius: t,
        justifyContent: "center",
        alignItems: "center",
        marginInlineEnd: y,
        color: S,
        fontWeight: w,
        fontSize: d,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        textDecoration: "none",
        background: "transparent",
        border: 0,
        cursor: "pointer",
        transition: `all ${s}`,
        textRendering: "auto",
        "&:hover": {
          color: x,
          backgroundColor: b,
          textDecoration: "none"
        },
        "&:active": {
          backgroundColor: _
        }
      }, zs(e)),
      [`${r}-title`]: {
        flex: 1,
        margin: 0,
        fontWeight: e.fontWeightStrong,
        fontSize: d,
        lineHeight: f
      },
      // Body
      [`${r}-body`]: {
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        padding: u,
        overflow: "auto",
        [`${r}-body-skeleton`]: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center"
        }
      },
      // Footer
      [`${r}-footer`]: {
        flexShrink: 0,
        padding: `${ve(O)} ${ve(T)}`,
        borderTop: `${ve(m)} ${h} ${g}`
      },
      // ====================== RTL =======================
      "&-rtl": {
        direction: "rtl"
      }
    }
  };
}, Xxe = (e) => ({
  zIndexPopup: e.zIndexPopupBase,
  footerPaddingBlock: e.paddingXS,
  footerPaddingInline: e.padding
}), aU = Zr("Drawer", (e) => {
  const t = $r(e, {});
  return [Zxe(t), Yxe(t)];
}, Xxe);
var iU = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const Jxe = {
  distance: 180
}, LI = (e) => {
  var t;
  const {
    rootClassName: r,
    width: n,
    height: a,
    size: i = "default",
    mask: o = !0,
    push: s = Jxe,
    open: l,
    afterOpenChange: c,
    onClose: u,
    prefixCls: d,
    getContainer: f,
    style: m,
    className: h,
    // Deprecated
    visible: g,
    afterVisibleChange: y,
    maskStyle: S,
    drawerStyle: x,
    contentWrapperStyle: b
  } = e, _ = iU(e, ["rootClassName", "width", "height", "size", "mask", "push", "open", "afterOpenChange", "onClose", "prefixCls", "getContainer", "style", "className", "visible", "afterVisibleChange", "maskStyle", "drawerStyle", "contentWrapperStyle"]), {
    getPopupContainer: $,
    getPrefixCls: w,
    direction: O,
    drawer: T
  } = p.useContext(Lt), I = w("drawer", d), [P, D, B] = aU(I), L = (
    // 有可能为 false，所以不能直接判断
    f === void 0 && $ ? () => $(document.body) : f
  ), N = be({
    "no-mask": !o,
    [`${I}-rtl`]: O === "rtl"
  }, r, D, B);
  if (process.env.NODE_ENV !== "production") {
    const ue = xr("Drawer");
    [["visible", "open"], ["afterVisibleChange", "afterOpenChange"], ["headerStyle", "styles.header"], ["bodyStyle", "styles.body"], ["footerStyle", "styles.footer"], ["contentWrapperStyle", "styles.wrapper"], ["maskStyle", "styles.mask"], ["drawerStyle", "styles.content"]].forEach((re) => {
      let [oe, fe] = re;
      ue.deprecated(!(oe in e), oe, fe);
    }), L !== void 0 && ((t = e.style) === null || t === void 0 ? void 0 : t.position) === "absolute" && process.env.NODE_ENV !== "production" && ue(!1, "breaking", "`style` is replaced by `rootStyle` in v5. Please check that `position: absolute` is necessary.");
  }
  const z = p.useMemo(() => n ?? (i === "large" ? 736 : 378), [n, i]), F = p.useMemo(() => a ?? (i === "large" ? 736 : 378), [a, i]), j = {
    motionName: Gi(I, "mask-motion"),
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    motionDeadline: 500
  }, H = (ue) => ({
    motionName: Gi(I, `panel-motion-${ue}`),
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    motionDeadline: 500
  }), U = Kz(), [G, V] = ps("Drawer", _.zIndex), {
    classNames: K = {},
    styles: Z = {}
  } = _, {
    classNames: ee = {},
    styles: ae = {}
  } = T || {};
  return P(/* @__PURE__ */ p.createElement(Lc, null, /* @__PURE__ */ p.createElement(UT, {
    status: !0,
    override: !0
  }, /* @__PURE__ */ p.createElement(gd.Provider, {
    value: V
  }, /* @__PURE__ */ p.createElement(eU, Object.assign({
    prefixCls: I,
    onClose: u,
    maskMotion: j,
    motion: H
  }, _, {
    classNames: {
      mask: be(K.mask, ee.mask),
      content: be(K.content, ee.content),
      wrapper: be(K.wrapper, ee.wrapper)
    },
    styles: {
      mask: Object.assign(Object.assign(Object.assign({}, Z.mask), S), ae.mask),
      content: Object.assign(Object.assign(Object.assign({}, Z.content), x), ae.content),
      wrapper: Object.assign(Object.assign(Object.assign({}, Z.wrapper), b), ae.wrapper)
    },
    open: l ?? g,
    mask: o,
    push: s,
    width: z,
    height: F,
    style: Object.assign(Object.assign({}, T?.style), m),
    className: be(T?.className, h),
    rootClassName: N,
    getContainer: L,
    afterOpenChange: c ?? y,
    panelRef: U,
    zIndex: G
  }), /* @__PURE__ */ p.createElement(tU, Object.assign({
    prefixCls: I
  }, _, {
    onClose: u
  })))))));
}, Qxe = (e) => {
  const {
    prefixCls: t,
    style: r,
    className: n,
    placement: a = "right"
  } = e, i = iU(e, ["prefixCls", "style", "className", "placement"]), {
    getPrefixCls: o
  } = p.useContext(Lt), s = o("drawer", t), [l, c, u] = aU(s), d = be(s, `${s}-pure`, `${s}-${a}`, c, u, n);
  return l(/* @__PURE__ */ p.createElement("div", {
    className: d,
    style: r
  }, /* @__PURE__ */ p.createElement(tU, Object.assign({
    prefixCls: s
  }, i))));
};
LI._InternalPanelDoNotUseOrYouWillBeFired = Qxe;
process.env.NODE_ENV !== "production" && (LI.displayName = "Drawer");
function Gb(e) {
  return ["small", "middle", "large"].includes(e);
}
function p4(e) {
  return e ? typeof e == "number" && !Number.isNaN(e) : !1;
}
const oU = /* @__PURE__ */ xe.createContext({
  latestIndex: 0
}), e$e = oU.Provider, t$e = (e) => {
  let {
    className: t,
    index: r,
    children: n,
    split: a,
    style: i
  } = e;
  const {
    latestIndex: o
  } = p.useContext(oU);
  return n == null ? null : /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement("div", {
    className: t,
    style: i
  }, n), r < o && a && /* @__PURE__ */ p.createElement("span", {
    className: `${t}-split`
  }, a));
};
var r$e = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const n$e = /* @__PURE__ */ p.forwardRef((e, t) => {
  var r, n, a;
  const {
    getPrefixCls: i,
    space: o,
    direction: s
  } = p.useContext(Lt), {
    size: l = (r = o?.size) !== null && r !== void 0 ? r : "small",
    align: c,
    className: u,
    rootClassName: d,
    children: f,
    direction: m = "horizontal",
    prefixCls: h,
    split: g,
    style: y,
    wrap: S = !1,
    classNames: x,
    styles: b
  } = e, _ = r$e(e, ["size", "align", "className", "rootClassName", "children", "direction", "prefixCls", "split", "style", "wrap", "classNames", "styles"]), [$, w] = Array.isArray(l) ? l : [l, l], O = Gb(w), T = Gb($), I = p4(w), P = p4($), D = Ma(f, {
    keepEmpty: !0
  }), B = c === void 0 && m === "horizontal" ? "center" : c, L = i("space", h), [N, z, F] = bz(L), j = be(L, o?.className, z, `${L}-${m}`, {
    [`${L}-rtl`]: s === "rtl",
    [`${L}-align-${B}`]: B,
    [`${L}-gap-row-${w}`]: O,
    [`${L}-gap-col-${$}`]: T
  }, u, d, F), H = be(`${L}-item`, (n = x?.item) !== null && n !== void 0 ? n : (a = o?.classNames) === null || a === void 0 ? void 0 : a.item);
  let U = 0;
  const G = D.map((Z, ee) => {
    var ae, ue;
    Z != null && (U = ee);
    const re = Z && Z.key || `${H}-${ee}`;
    return /* @__PURE__ */ p.createElement(t$e, {
      className: H,
      key: re,
      index: ee,
      split: g,
      style: (ae = b?.item) !== null && ae !== void 0 ? ae : (ue = o?.styles) === null || ue === void 0 ? void 0 : ue.item
    }, Z);
  }), V = p.useMemo(() => ({
    latestIndex: U
  }), [U]);
  if (D.length === 0)
    return null;
  const K = {};
  return S && (K.flexWrap = "wrap"), !T && P && (K.columnGap = $), !O && I && (K.rowGap = w), N(/* @__PURE__ */ p.createElement("div", Object.assign({
    ref: t,
    className: j,
    style: Object.assign(Object.assign(Object.assign({}, K), o?.style), y)
  }, _), /* @__PURE__ */ p.createElement(e$e, {
    value: V
  }, G)));
}), lr = n$e;
lr.Compact = $pe;
process.env.NODE_ENV !== "production" && (lr.displayName = "Space");
var a$e = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const sU = (e) => {
  const {
    getPopupContainer: t,
    getPrefixCls: r,
    direction: n
  } = p.useContext(Lt), {
    prefixCls: a,
    type: i = "default",
    danger: o,
    disabled: s,
    loading: l,
    onClick: c,
    htmlType: u,
    children: d,
    className: f,
    menu: m,
    arrow: h,
    autoFocus: g,
    overlay: y,
    trigger: S,
    align: x,
    open: b,
    onOpenChange: _,
    placement: $,
    getPopupContainer: w,
    href: O,
    icon: T = /* @__PURE__ */ p.createElement(z1, null),
    title: I,
    buttonsRender: P = (oe) => oe,
    mouseEnterDelay: D,
    mouseLeaveDelay: B,
    overlayClassName: L,
    overlayStyle: N,
    destroyPopupOnHide: z,
    dropdownRender: F
  } = e, j = a$e(e, ["prefixCls", "type", "danger", "disabled", "loading", "onClick", "htmlType", "children", "className", "menu", "arrow", "autoFocus", "overlay", "trigger", "align", "open", "onOpenChange", "placement", "getPopupContainer", "href", "icon", "title", "buttonsRender", "mouseEnterDelay", "mouseLeaveDelay", "overlayClassName", "overlayStyle", "destroyPopupOnHide", "dropdownRender"]), H = r("dropdown", a), U = `${H}-button`, G = {
    menu: m,
    arrow: h,
    autoFocus: g,
    align: x,
    disabled: s,
    trigger: s ? [] : S,
    onOpenChange: _,
    getPopupContainer: w || t,
    mouseEnterDelay: D,
    mouseLeaveDelay: B,
    overlayClassName: L,
    overlayStyle: N,
    destroyPopupOnHide: z,
    dropdownRender: F
  }, {
    compactSize: V,
    compactItemClassnames: K
  } = El(H, n), Z = be(U, K, f);
  "overlay" in e && (G.overlay = y), "open" in e && (G.open = b), "placement" in e ? G.placement = $ : G.placement = n === "rtl" ? "bottomLeft" : "bottomRight";
  const ee = /* @__PURE__ */ p.createElement(Nt, {
    type: i,
    danger: o,
    disabled: s,
    loading: l,
    onClick: c,
    htmlType: u,
    href: O,
    title: I
  }, d), ae = /* @__PURE__ */ p.createElement(Nt, {
    type: i,
    danger: o,
    icon: T
  }), [ue, re] = P([ee, ae]);
  return /* @__PURE__ */ p.createElement(lr.Compact, Object.assign({
    className: Z,
    size: V,
    block: !0
  }, j), ue, /* @__PURE__ */ p.createElement(bh, Object.assign({}, G), re));
};
sU.__ANT_BUTTON = !0;
const kI = bh;
kI.Button = sU;
const lU = ["wrap", "nowrap", "wrap-reverse"], cU = ["flex-start", "flex-end", "start", "end", "center", "space-between", "space-around", "space-evenly", "stretch", "normal", "left", "right"], uU = ["center", "start", "end", "flex-start", "flex-end", "self-start", "self-end", "baseline", "normal", "stretch"], i$e = (e, t) => {
  const r = t.wrap === !0 ? "wrap" : t.wrap;
  return {
    [`${e}-wrap-${r}`]: r && lU.includes(r)
  };
}, o$e = (e, t) => {
  const r = {};
  return uU.forEach((n) => {
    r[`${e}-align-${n}`] = t.align === n;
  }), r[`${e}-align-stretch`] = !t.align && !!t.vertical, r;
}, s$e = (e, t) => {
  const r = {};
  return cU.forEach((n) => {
    r[`${e}-justify-${n}`] = t.justify === n;
  }), r;
};
function l$e(e, t) {
  return be(Object.assign(Object.assign(Object.assign({}, i$e(e, t)), o$e(e, t)), s$e(e, t)));
}
const c$e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      display: "flex",
      "&-vertical": {
        flexDirection: "column"
      },
      "&-rtl": {
        direction: "rtl"
      },
      "&:empty": {
        display: "none"
      }
    }
  };
}, u$e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-gap-small": {
        gap: e.flexGapSM
      },
      "&-gap-middle": {
        gap: e.flexGap
      },
      "&-gap-large": {
        gap: e.flexGapLG
      }
    }
  };
}, d$e = (e) => {
  const {
    componentCls: t
  } = e, r = {};
  return lU.forEach((n) => {
    r[`${t}-wrap-${n}`] = {
      flexWrap: n
    };
  }), r;
}, f$e = (e) => {
  const {
    componentCls: t
  } = e, r = {};
  return uU.forEach((n) => {
    r[`${t}-align-${n}`] = {
      alignItems: n
    };
  }), r;
}, p$e = (e) => {
  const {
    componentCls: t
  } = e, r = {};
  return cU.forEach((n) => {
    r[`${t}-justify-${n}`] = {
      justifyContent: n
    };
  }), r;
}, m$e = () => ({}), v$e = Zr("Flex", (e) => {
  const {
    paddingXS: t,
    padding: r,
    paddingLG: n
  } = e, a = $r(e, {
    flexGapSM: t,
    flexGap: r,
    flexGapLG: n
  });
  return [c$e(a), u$e(a), d$e(a), f$e(a), p$e(a)];
}, m$e, {
  // Flex component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/46403
  resetStyle: !1
});
var h$e = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const FI = /* @__PURE__ */ xe.forwardRef((e, t) => {
  const {
    prefixCls: r,
    rootClassName: n,
    className: a,
    style: i,
    flex: o,
    gap: s,
    children: l,
    vertical: c = !1,
    component: u = "div"
  } = e, d = h$e(e, ["prefixCls", "rootClassName", "className", "style", "flex", "gap", "children", "vertical", "component"]), {
    flex: f,
    direction: m,
    getPrefixCls: h
  } = xe.useContext(Lt), g = h("flex", r), [y, S, x] = v$e(g), b = c ?? f?.vertical, _ = be(a, n, f?.className, g, S, x, l$e(g, e), {
    [`${g}-rtl`]: m === "rtl",
    [`${g}-gap-${s}`]: Gb(s),
    [`${g}-vertical`]: b
  }), $ = Object.assign(Object.assign({}, f?.style), i);
  return o && ($.flex = o), s && !Gb(s) && ($.gap = s), y(/* @__PURE__ */ xe.createElement(u, Object.assign({
    ref: t,
    className: _,
    style: $
  }, bn(d, ["justify", "wrap", "align"])), l));
});
process.env.NODE_ENV !== "production" && (FI.displayName = "Flex");
function Ub(e) {
  const [t, r] = p.useState(e);
  return p.useEffect(() => {
    const n = setTimeout(() => {
      r(e);
    }, e.length ? 0 : 10);
    return () => {
      clearTimeout(n);
    };
  }, [e]), t;
}
const g$e = (e) => {
  const {
    componentCls: t
  } = e, r = `${t}-show-help`, n = `${t}-show-help-item`;
  return {
    [r]: {
      // Explain holder
      transition: `opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`,
      "&-appear, &-enter": {
        opacity: 0,
        "&-active": {
          opacity: 1
        }
      },
      "&-leave": {
        opacity: 1,
        "&-active": {
          opacity: 0
        }
      },
      // Explain
      [n]: {
        overflow: "hidden",
        transition: `height ${e.motionDurationSlow} ${e.motionEaseInOut},
                     opacity ${e.motionDurationSlow} ${e.motionEaseInOut},
                     transform ${e.motionDurationSlow} ${e.motionEaseInOut} !important`,
        [`&${n}-appear, &${n}-enter`]: {
          transform: "translateY(-5px)",
          opacity: 0,
          "&-active": {
            transform: "translateY(0)",
            opacity: 1
          }
        },
        [`&${n}-leave-active`]: {
          transform: "translateY(-5px)"
        }
      }
    }
  };
}, y$e = (e) => ({
  legend: {
    display: "block",
    width: "100%",
    marginBottom: e.marginLG,
    padding: 0,
    color: e.colorTextDescription,
    fontSize: e.fontSizeLG,
    lineHeight: "inherit",
    border: 0,
    borderBottom: `${ve(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
  },
  'input[type="search"]': {
    boxSizing: "border-box"
  },
  // Position radios and checkboxes better
  'input[type="radio"], input[type="checkbox"]': {
    lineHeight: "normal"
  },
  'input[type="file"]': {
    display: "block"
  },
  // Make range inputs behave like textual form controls
  'input[type="range"]': {
    display: "block",
    width: "100%"
  },
  // Make multiple select elements height not fixed
  "select[multiple], select[size]": {
    height: "auto"
  },
  // Focus for file, radio, and checkbox
  "input[type='file']:focus,\n  input[type='radio']:focus,\n  input[type='checkbox']:focus": {
    outline: 0,
    boxShadow: `0 0 0 ${ve(e.controlOutlineWidth)} ${e.controlOutline}`
  },
  // Adjust output element
  output: {
    display: "block",
    paddingTop: 15,
    color: e.colorText,
    fontSize: e.fontSize,
    lineHeight: e.lineHeight
  }
}), m4 = (e, t) => {
  const {
    formItemCls: r
  } = e;
  return {
    [r]: {
      [`${r}-label > label`]: {
        height: t
      },
      [`${r}-control-input`]: {
        minHeight: t
      }
    }
  };
}, b$e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [e.componentCls]: Object.assign(Object.assign(Object.assign({}, Yr(e)), y$e(e)), {
      [`${t}-text`]: {
        display: "inline-block",
        paddingInlineEnd: e.paddingSM
      },
      // ================================================================
      // =                             Size                             =
      // ================================================================
      "&-small": Object.assign({}, m4(e, e.controlHeightSM)),
      "&-large": Object.assign({}, m4(e, e.controlHeightLG))
    })
  };
}, C$e = (e) => {
  const {
    formItemCls: t,
    iconCls: r,
    componentCls: n,
    rootPrefixCls: a,
    antCls: i,
    labelRequiredMarkColor: o,
    labelColor: s,
    labelFontSize: l,
    labelHeight: c,
    labelColonMarginInlineStart: u,
    labelColonMarginInlineEnd: d,
    itemMarginBottom: f
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, Yr(e)), {
      marginBottom: f,
      verticalAlign: "top",
      "&-with-help": {
        transition: "none"
      },
      [`&-hidden,
        &-hidden${i}-row`]: {
        // https://github.com/ant-design/ant-design/issues/26141
        display: "none"
      },
      "&-has-warning": {
        [`${t}-split`]: {
          color: e.colorError
        }
      },
      "&-has-error": {
        [`${t}-split`]: {
          color: e.colorWarning
        }
      },
      // ==============================================================
      // =                            Label                           =
      // ==============================================================
      [`${t}-label`]: {
        flexGrow: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textAlign: "end",
        verticalAlign: "middle",
        "&-left": {
          textAlign: "start"
        },
        "&-wrap": {
          overflow: "unset",
          lineHeight: e.lineHeight,
          whiteSpace: "unset"
        },
        "> label": {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          maxWidth: "100%",
          height: c,
          color: s,
          fontSize: l,
          [`> ${r}`]: {
            fontSize: e.fontSize,
            verticalAlign: "top"
          },
          // Required mark
          [`&${t}-required:not(${t}-required-mark-optional)::before`]: {
            display: "inline-block",
            marginInlineEnd: e.marginXXS,
            color: o,
            fontSize: e.fontSize,
            fontFamily: "SimSun, sans-serif",
            lineHeight: 1,
            content: '"*"',
            [`${n}-hide-required-mark &`]: {
              display: "none"
            }
          },
          // Optional mark
          [`${t}-optional`]: {
            display: "inline-block",
            marginInlineStart: e.marginXXS,
            color: e.colorTextDescription,
            [`${n}-hide-required-mark &`]: {
              display: "none"
            }
          },
          // Optional mark
          [`${t}-tooltip`]: {
            color: e.colorTextDescription,
            cursor: "help",
            writingMode: "horizontal-tb",
            marginInlineStart: e.marginXXS
          },
          "&::after": {
            content: '":"',
            position: "relative",
            marginBlock: 0,
            marginInlineStart: u,
            marginInlineEnd: d
          },
          [`&${t}-no-colon::after`]: {
            content: '"\\a0"'
          }
        }
      },
      // ==============================================================
      // =                            Input                           =
      // ==============================================================
      [`${t}-control`]: {
        "--ant-display": "flex",
        flexDirection: "column",
        flexGrow: 1,
        [`&:first-child:not([class^="'${a}-col-'"]):not([class*="' ${a}-col-'"])`]: {
          width: "100%"
        },
        "&-input": {
          position: "relative",
          display: "flex",
          alignItems: "center",
          minHeight: e.controlHeight,
          "&-content": {
            flex: "auto",
            maxWidth: "100%"
          }
        }
      },
      // ==============================================================
      // =                           Explain                          =
      // ==============================================================
      [t]: {
        "&-explain, &-extra": {
          clear: "both",
          color: e.colorTextDescription,
          fontSize: e.fontSize,
          lineHeight: e.lineHeight
        },
        "&-explain-connected": {
          width: "100%"
        },
        "&-extra": {
          minHeight: e.controlHeightSM,
          transition: `color ${e.motionDurationMid} ${e.motionEaseOut}`
          // sync input color transition
        },
        "&-explain": {
          "&-error": {
            color: e.colorError
          },
          "&-warning": {
            color: e.colorWarning
          }
        }
      },
      [`&-with-help ${t}-explain`]: {
        height: "auto",
        opacity: 1
      },
      // ==============================================================
      // =                        Feedback Icon                       =
      // ==============================================================
      [`${t}-feedback-icon`]: {
        fontSize: e.fontSize,
        textAlign: "center",
        visibility: "visible",
        animationName: qT,
        animationDuration: e.motionDurationMid,
        animationTimingFunction: e.motionEaseOutBack,
        pointerEvents: "none",
        "&-success": {
          color: e.colorSuccess
        },
        "&-error": {
          color: e.colorError
        },
        "&-warning": {
          color: e.colorWarning
        },
        "&-validating": {
          color: e.colorPrimary
        }
      }
    })
  };
}, v4 = (e, t) => {
  const {
    formItemCls: r
  } = e;
  return {
    [`${t}-horizontal`]: {
      [`${r}-label`]: {
        flexGrow: 0
      },
      [`${r}-control`]: {
        flex: "1 1 0",
        // https://github.com/ant-design/ant-design/issues/32777
        // https://github.com/ant-design/ant-design/issues/33773
        minWidth: 0
      },
      // Do not change this to `ant-col-24`! `-24` match all the responsive rules
      // https://github.com/ant-design/ant-design/issues/32980
      // https://github.com/ant-design/ant-design/issues/34903
      // https://github.com/ant-design/ant-design/issues/44538
      [`${r}-label[class$='-24'], ${r}-label[class*='-24 ']`]: {
        [`& + ${r}-control`]: {
          minWidth: "unset"
        }
      }
    }
  };
}, S$e = (e) => {
  const {
    componentCls: t,
    formItemCls: r,
    inlineItemMarginBottom: n
  } = e;
  return {
    [`${t}-inline`]: {
      display: "flex",
      flexWrap: "wrap",
      [r]: {
        flex: "none",
        marginInlineEnd: e.margin,
        marginBottom: n,
        "&-row": {
          flexWrap: "nowrap"
        },
        [`> ${r}-label,
        > ${r}-control`]: {
          display: "inline-block",
          verticalAlign: "top"
        },
        [`> ${r}-label`]: {
          flex: "none"
        },
        [`${t}-text`]: {
          display: "inline-block"
        },
        [`${r}-has-feedback`]: {
          display: "inline-block"
        }
      }
    }
  };
}, Mo = (e) => ({
  padding: e.verticalLabelPadding,
  margin: e.verticalLabelMargin,
  whiteSpace: "initial",
  textAlign: "start",
  "> label": {
    margin: 0,
    "&::after": {
      // https://github.com/ant-design/ant-design/issues/43538
      visibility: "hidden"
    }
  }
}), dU = (e) => {
  const {
    componentCls: t,
    formItemCls: r,
    rootPrefixCls: n
  } = e;
  return {
    [`${r} ${r}-label`]: Mo(e),
    // ref: https://github.com/ant-design/ant-design/issues/45122
    [`${t}:not(${t}-inline)`]: {
      [r]: {
        flexWrap: "wrap",
        [`${r}-label, ${r}-control`]: {
          // When developer pass `xs: { span }`,
          // It should follow the `xs` screen config
          // ref: https://github.com/ant-design/ant-design/issues/44386
          [`&:not([class*=" ${n}-col-xs"])`]: {
            flex: "0 0 100%",
            maxWidth: "100%"
          }
        }
      }
    }
  };
}, x$e = (e) => {
  const {
    componentCls: t,
    formItemCls: r,
    antCls: n
  } = e;
  return {
    [`${t}-vertical`]: {
      [`${r}:not(${r}-horizontal)`]: {
        [`${r}-row`]: {
          flexDirection: "column"
        },
        [`${r}-label > label`]: {
          height: "auto"
        },
        [`${r}-control`]: {
          width: "100%"
        },
        [`${r}-label,
        ${n}-col-24${r}-label,
        ${n}-col-xl-24${r}-label`]: Mo(e)
      }
    },
    [`@media (max-width: ${ve(e.screenXSMax)})`]: [dU(e), {
      [t]: {
        [`${r}:not(${r}-horizontal)`]: {
          [`${n}-col-xs-24${r}-label`]: Mo(e)
        }
      }
    }],
    [`@media (max-width: ${ve(e.screenSMMax)})`]: {
      [t]: {
        [`${r}:not(${r}-horizontal)`]: {
          [`${n}-col-sm-24${r}-label`]: Mo(e)
        }
      }
    },
    [`@media (max-width: ${ve(e.screenMDMax)})`]: {
      [t]: {
        [`${r}:not(${r}-horizontal)`]: {
          [`${n}-col-md-24${r}-label`]: Mo(e)
        }
      }
    },
    [`@media (max-width: ${ve(e.screenLGMax)})`]: {
      [t]: {
        [`${r}:not(${r}-horizontal)`]: {
          [`${n}-col-lg-24${r}-label`]: Mo(e)
        }
      }
    }
  };
}, $$e = (e) => {
  const {
    formItemCls: t,
    antCls: r
  } = e;
  return {
    [`${t}-vertical`]: {
      [`${t}-row`]: {
        flexDirection: "column"
      },
      [`${t}-label > label`]: {
        height: "auto"
      },
      [`${t}-control`]: {
        width: "100%"
      }
    },
    [`${t}-vertical ${t}-label,
      ${r}-col-24${t}-label,
      ${r}-col-xl-24${t}-label`]: Mo(e),
    [`@media (max-width: ${ve(e.screenXSMax)})`]: [dU(e), {
      [t]: {
        [`${r}-col-xs-24${t}-label`]: Mo(e)
      }
    }],
    [`@media (max-width: ${ve(e.screenSMMax)})`]: {
      [t]: {
        [`${r}-col-sm-24${t}-label`]: Mo(e)
      }
    },
    [`@media (max-width: ${ve(e.screenMDMax)})`]: {
      [t]: {
        [`${r}-col-md-24${t}-label`]: Mo(e)
      }
    },
    [`@media (max-width: ${ve(e.screenLGMax)})`]: {
      [t]: {
        [`${r}-col-lg-24${t}-label`]: Mo(e)
      }
    }
  };
}, _$e = (e) => ({
  labelRequiredMarkColor: e.colorError,
  labelColor: e.colorTextHeading,
  labelFontSize: e.fontSize,
  labelHeight: e.controlHeight,
  labelColonMarginInlineStart: e.marginXXS / 2,
  labelColonMarginInlineEnd: e.marginXS,
  itemMarginBottom: e.marginLG,
  verticalLabelPadding: `0 0 ${e.paddingXS}px`,
  verticalLabelMargin: 0,
  inlineItemMarginBottom: 0
}), fU = (e, t) => $r(e, {
  formItemCls: `${e.componentCls}-item`,
  rootPrefixCls: t
}), BI = Zr("Form", (e, t) => {
  let {
    rootPrefixCls: r
  } = t;
  const n = fU(e, r);
  return [b$e(n), C$e(n), g$e(n), v4(n, n.componentCls), v4(n, n.formItemCls), S$e(n), x$e(n), $$e(n), WT(n), qT];
}, _$e, {
  // Let From style before the Grid
  // ref https://github.com/ant-design/ant-design/issues/44386
  order: -1e3
}), h4 = [];
function Px(e, t, r) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  return {
    key: typeof e == "string" ? e : `${t}-${n}`,
    error: e,
    errorStatus: r
  };
}
const pU = (e) => {
  let {
    help: t,
    helpStatus: r,
    errors: n = h4,
    warnings: a = h4,
    className: i,
    fieldId: o,
    onVisibleChanged: s
  } = e;
  const {
    prefixCls: l
  } = p.useContext(GT), c = `${l}-item-explain`, u = Mn(l), [d, f, m] = BI(l, u), h = dr(() => Pb(l), [l]), g = Ub(n), y = Ub(a), S = p.useMemo(() => t != null ? [Px(t, "help", r)] : [].concat(ze(g.map((b, _) => Px(b, "error", "error", _))), ze(y.map((b, _) => Px(b, "warning", "warning", _)))), [t, r, g, y]), x = {};
  return o && (x.id = `${o}_help`), d(/* @__PURE__ */ p.createElement(Ci, {
    motionDeadline: h.motionDeadline,
    motionName: `${l}-show-help`,
    visible: !!S.length,
    onVisibleChanged: s
  }, (b) => {
    const {
      className: _,
      style: $
    } = b;
    return /* @__PURE__ */ p.createElement("div", Object.assign({}, x, {
      className: be(c, _, m, u, i, f),
      style: $,
      role: "alert"
    }), /* @__PURE__ */ p.createElement(KB, Object.assign({
      keys: S
    }, Pb(l), {
      motionName: `${l}-show-help-item`,
      component: !1
    }), (w) => {
      const {
        key: O,
        error: T,
        errorStatus: I,
        className: P,
        style: D
      } = w;
      return /* @__PURE__ */ p.createElement("div", {
        key: O,
        className: be(P, {
          [`${c}-${I}`]: I
        }),
        style: D
      }, T);
    }));
  }));
}, E$e = ["parentNode"], w$e = "form_item";
function j0(e) {
  return e === void 0 || e === !1 ? [] : Array.isArray(e) ? e : [e];
}
function mU(e, t) {
  if (!e.length)
    return;
  const r = e.join("_");
  return t ? `${t}_${r}` : E$e.includes(r) ? `${w$e}_${r}` : r;
}
function vU(e, t, r, n, a, i) {
  let o = n;
  return i !== void 0 ? o = i : r.validating ? o = "validating" : e.length ? o = "error" : t.length ? o = "warning" : (r.touched || a && r.validated) && (o = "success"), o;
}
function g4(e) {
  return j0(e).join("_");
}
function O$e(e, t) {
  const r = t.getFieldInstance(e), n = MF(r);
  if (n)
    return n;
  const a = mU(j0(e), t.__INTERNAL__.name);
  if (a)
    return document.getElementById(a);
}
function hU(e) {
  const [t] = VT(), r = p.useRef({}), n = p.useMemo(() => e ?? Object.assign(Object.assign({}, t), {
    __INTERNAL__: {
      itemRef: (a) => (i) => {
        const o = g4(a);
        i ? r.current[o] = i : delete r.current[o];
      }
    },
    scrollToField: function(a) {
      let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      const o = O$e(a, n);
      o && Mfe(o, Object.assign({
        scrollMode: "if-needed",
        block: "nearest"
      }, i));
    },
    getFieldInstance: (a) => {
      const i = g4(a);
      return r.current[i];
    }
  }), [e, t]);
  return [n];
}
const sy = {};
function T$e(e) {
  let {
    name: t
  } = e;
  const r = xr("Form");
  St(() => {
    if (t)
      return sy[t] = (sy[t] || 0) + 1, process.env.NODE_ENV !== "production" && r(sy[t] <= 1, "usage", "There exist multiple Form with same `name`."), () => {
        sy[t] -= 1;
      };
  }, [t]);
}
var I$e = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const M$e = (e, t) => {
  const r = p.useContext(Vi), {
    getPrefixCls: n,
    direction: a,
    form: i
  } = p.useContext(Lt), {
    prefixCls: o,
    className: s,
    rootClassName: l,
    size: c,
    disabled: u = r,
    form: d,
    colon: f,
    labelAlign: m,
    labelWrap: h,
    labelCol: g,
    wrapperCol: y,
    hideRequiredMark: S,
    layout: x = "horizontal",
    scrollToFirstError: b,
    requiredMark: _,
    onFinishFailed: $,
    name: w,
    style: O,
    feedbackIcons: T,
    variant: I
  } = e, P = I$e(e, ["prefixCls", "className", "rootClassName", "size", "disabled", "form", "colon", "labelAlign", "labelWrap", "labelCol", "wrapperCol", "hideRequiredMark", "layout", "scrollToFirstError", "requiredMark", "onFinishFailed", "name", "style", "feedbackIcons", "variant"]), D = Xa(c), B = p.useContext(gB);
  process.env.NODE_ENV !== "production" && T$e(e);
  const L = dr(() => _ !== void 0 ? _ : S ? !1 : i && i.requiredMark !== void 0 ? i.requiredMark : !0, [S, _, i]), N = f ?? i?.colon, z = n("form", o), F = Mn(z), [j, H, U] = BI(z, F), G = be(z, `${z}-${x}`, {
    [`${z}-hide-required-mark`]: L === !1,
    [`${z}-rtl`]: a === "rtl",
    [`${z}-${D}`]: D
  }, U, F, H, i?.className, s, l), [V] = hU(d), {
    __INTERNAL__: K
  } = V;
  K.name = w;
  const Z = dr(() => ({
    name: w,
    labelAlign: m,
    labelCol: g,
    labelWrap: h,
    wrapperCol: y,
    vertical: x === "vertical",
    colon: N,
    requiredMark: L,
    itemRef: K.itemRef,
    form: V,
    feedbackIcons: T
  }), [w, m, g, y, x, N, L, V, T]), ee = p.useRef(null);
  p.useImperativeHandle(t, () => {
    var re;
    return Object.assign(Object.assign({}, V), {
      nativeElement: (re = ee.current) === null || re === void 0 ? void 0 : re.nativeElement
    });
  });
  const ae = (re, oe) => {
    if (re) {
      let fe = {
        block: "nearest"
      };
      typeof re == "object" && (fe = re), V.scrollToField(oe, fe);
    }
  }, ue = (re) => {
    if ($?.(re), re.errorFields.length) {
      const oe = re.errorFields[0].name;
      if (b !== void 0) {
        ae(b, oe);
        return;
      }
      i && i.scrollToFirstError !== void 0 && ae(i.scrollToFirstError, oe);
    }
  };
  return j(/* @__PURE__ */ p.createElement(Wz.Provider, {
    value: I
  }, /* @__PURE__ */ p.createElement(IT, {
    disabled: u
  }, /* @__PURE__ */ p.createElement(Sc.Provider, {
    value: D
  }, /* @__PURE__ */ p.createElement(Uz, {
    // This is not list in API, we pass with spread
    validateMessages: B
  }, /* @__PURE__ */ p.createElement(Vs.Provider, {
    value: Z
  }, /* @__PURE__ */ p.createElement(Cd, Object.assign({
    id: w
  }, P, {
    name: w,
    onFinishFailed: ue,
    form: V,
    ref: ee,
    style: Object.assign(Object.assign({}, i?.style), O),
    className: G
  }))))))));
}, gU = /* @__PURE__ */ p.forwardRef(M$e);
process.env.NODE_ENV !== "production" && (gU.displayName = "Form");
function A$e(e) {
  if (typeof e == "function")
    return e;
  const t = Ma(e);
  return t.length <= 1 ? t[0] : t;
}
const yU = () => {
  const {
    status: e,
    errors: t = [],
    warnings: r = []
  } = Cr(xa);
  if (process.env.NODE_ENV !== "production") {
    const n = xr("Form.Item");
    process.env.NODE_ENV !== "production" && n(e !== void 0, "usage", "Form.Item.useStatus should be used under Form.Item component. For more information: https://u.ant.design/form-item-usestatus");
  }
  return {
    status: e,
    errors: t,
    warnings: r
  };
};
yU.Context = xa;
function P$e(e) {
  const [t, r] = p.useState(e), n = ct(null), a = ct([]), i = ct(!1);
  p.useEffect(() => (i.current = !1, () => {
    i.current = !0, vr.cancel(n.current), n.current = null;
  }), []);
  function o(s) {
    i.current || (n.current === null && (a.current = [], n.current = vr(() => {
      n.current = null, r((l) => {
        let c = l;
        return a.current.forEach((u) => {
          c = u(c);
        }), c;
      });
    })), a.current.push(s));
  }
  return [t, o];
}
function R$e() {
  const {
    itemRef: e
  } = p.useContext(Vs), t = p.useRef({});
  function r(n, a) {
    const i = a && typeof a == "object" && a.ref, o = n.join("_");
    return (t.current.name !== o || t.current.originRef !== i) && (t.current.name = o, t.current.originRef = i, t.current.ref = Za(e(n), i)), t.current.ref;
  }
  return r;
}
const N$e = (e) => {
  const {
    formItemCls: t
  } = e;
  return {
    "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)": {
      // Fallback for IE, safe to remove we not support it anymore
      [`${t}-control`]: {
        display: "flex"
      }
    }
  };
}, D$e = vd(["Form", "item-item"], (e, t) => {
  let {
    rootPrefixCls: r
  } = t;
  const n = fU(e, r);
  return [N$e(n)];
}), j$e = (e) => {
  const {
    prefixCls: t,
    status: r,
    wrapperCol: n,
    children: a,
    errors: i,
    warnings: o,
    _internalItemRender: s,
    extra: l,
    help: c,
    fieldId: u,
    marginBottom: d,
    onErrorVisibleChanged: f
  } = e, m = `${t}-item`, h = p.useContext(Vs), g = n || h.wrapperCol || {}, y = be(`${m}-control`, g.className), S = p.useMemo(() => Object.assign({}, h), [h]);
  delete S.labelCol, delete S.wrapperCol;
  const x = /* @__PURE__ */ p.createElement("div", {
    className: `${m}-control-input`
  }, /* @__PURE__ */ p.createElement("div", {
    className: `${m}-control-input-content`
  }, a)), b = p.useMemo(() => ({
    prefixCls: t,
    status: r
  }), [t, r]), _ = d !== null || i.length || o.length ? /* @__PURE__ */ p.createElement("div", {
    style: {
      display: "flex",
      flexWrap: "nowrap"
    }
  }, /* @__PURE__ */ p.createElement(GT.Provider, {
    value: b
  }, /* @__PURE__ */ p.createElement(pU, {
    fieldId: u,
    errors: i,
    warnings: o,
    help: c,
    helpStatus: r,
    className: `${m}-explain-connected`,
    onVisibleChanged: f
  })), !!d && /* @__PURE__ */ p.createElement("div", {
    style: {
      width: 0,
      height: d
    }
  })) : null, $ = {};
  u && ($.id = `${u}_extra`);
  const w = l ? /* @__PURE__ */ p.createElement("div", Object.assign({}, $, {
    className: `${m}-extra`
  }), l) : null, O = s && s.mark === "pro_table_render" && s.render ? s.render(e, {
    input: x,
    errorList: _,
    extra: w
  }) : /* @__PURE__ */ p.createElement(p.Fragment, null, x, _, w);
  return /* @__PURE__ */ p.createElement(Vs.Provider, {
    value: S
  }, /* @__PURE__ */ p.createElement(Oe, Object.assign({}, g, {
    className: y
  }), O), /* @__PURE__ */ p.createElement(D$e, {
    prefixCls: t
  }));
};
var L$e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, name: "question-circle", theme: "outlined" }, k$e = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: L$e
  }));
}, bU = /* @__PURE__ */ p.forwardRef(k$e);
process.env.NODE_ENV !== "production" && (bU.displayName = "QuestionCircleOutlined");
var F$e = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function B$e(e) {
  return e ? typeof e == "object" && !/* @__PURE__ */ p.isValidElement(e) ? e : {
    title: e
  } : null;
}
const z$e = (e) => {
  let {
    prefixCls: t,
    label: r,
    htmlFor: n,
    labelCol: a,
    labelAlign: i,
    colon: o,
    required: s,
    requiredMark: l,
    tooltip: c,
    vertical: u
  } = e;
  var d;
  const [f] = Ks("Form"), {
    labelAlign: m,
    labelCol: h,
    labelWrap: g,
    colon: y
  } = p.useContext(Vs);
  if (!r)
    return null;
  const S = a || h || {}, x = i || m, b = `${t}-item-label`, _ = be(b, x === "left" && `${b}-left`, S.className, {
    [`${b}-wrap`]: !!g
  });
  let $ = r;
  const w = o === !0 || y !== !1 && o !== !1;
  w && !u && typeof r == "string" && r.trim() !== "" && ($ = r.replace(/[:|：]\s*$/, ""));
  const T = B$e(c);
  if (T) {
    const {
      icon: B = /* @__PURE__ */ p.createElement(bU, null)
    } = T, L = F$e(T, ["icon"]), N = /* @__PURE__ */ p.createElement(lo, Object.assign({}, L), /* @__PURE__ */ p.cloneElement(B, {
      className: `${t}-item-tooltip`,
      title: "",
      onClick: (z) => {
        z.preventDefault();
      },
      tabIndex: null
    }));
    $ = /* @__PURE__ */ p.createElement(p.Fragment, null, $, N);
  }
  const I = l === "optional", P = typeof l == "function";
  P ? $ = l($, {
    required: !!s
  }) : I && !s && ($ = /* @__PURE__ */ p.createElement(p.Fragment, null, $, /* @__PURE__ */ p.createElement("span", {
    className: `${t}-item-optional`,
    title: ""
  }, f?.optional || ((d = jo.Form) === null || d === void 0 ? void 0 : d.optional))));
  const D = be({
    [`${t}-item-required`]: s,
    [`${t}-item-required-mark-optional`]: I || P,
    [`${t}-item-no-colon`]: !w
  });
  return /* @__PURE__ */ p.createElement(Oe, Object.assign({}, S, {
    className: _
  }), /* @__PURE__ */ p.createElement("label", {
    htmlFor: n,
    className: D,
    title: typeof r == "string" ? r : ""
  }, $));
}, H$e = {
  success: oh,
  warning: sh,
  error: Nc,
  validating: Dc
};
function CU(e) {
  let {
    children: t,
    errors: r,
    warnings: n,
    hasFeedback: a,
    validateStatus: i,
    prefixCls: o,
    meta: s,
    noStyle: l
  } = e;
  const c = `${o}-item`, {
    feedbackIcons: u
  } = p.useContext(Vs), d = vU(r, n, s, null, !!a, i), {
    isFormItemInput: f,
    status: m,
    hasFeedback: h,
    feedbackIcon: g
  } = p.useContext(xa), y = p.useMemo(() => {
    var S;
    let x;
    if (a) {
      const _ = a !== !0 && a.icons || u, $ = d && ((S = _?.({
        status: d,
        errors: r,
        warnings: n
      })) === null || S === void 0 ? void 0 : S[d]), w = d && H$e[d];
      x = $ !== !1 && w ? /* @__PURE__ */ p.createElement("span", {
        className: be(`${c}-feedback-icon`, `${c}-feedback-icon-${d}`)
      }, $ || /* @__PURE__ */ p.createElement(w, null)) : null;
    }
    const b = {
      status: d || "",
      errors: r,
      warnings: n,
      hasFeedback: !!a,
      feedbackIcon: x,
      isFormItemInput: !0
    };
    return l && (b.status = (d ?? m) || "", b.isFormItemInput = f, b.hasFeedback = !!(a ?? h), b.feedbackIcon = a !== void 0 ? b.feedbackIcon : g), b;
  }, [d, a, l, f, m]);
  return /* @__PURE__ */ p.createElement(xa.Provider, {
    value: y
  }, t);
}
var V$e = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function G$e(e) {
  const {
    prefixCls: t,
    className: r,
    rootClassName: n,
    style: a,
    help: i,
    errors: o,
    warnings: s,
    validateStatus: l,
    meta: c,
    hasFeedback: u,
    hidden: d,
    children: f,
    fieldId: m,
    required: h,
    isRequired: g,
    onSubItemMetaChange: y,
    layout: S
  } = e, x = V$e(e, ["prefixCls", "className", "rootClassName", "style", "help", "errors", "warnings", "validateStatus", "meta", "hasFeedback", "hidden", "children", "fieldId", "required", "isRequired", "onSubItemMetaChange", "layout"]), b = `${t}-item`, {
    requiredMark: _,
    vertical: $
  } = p.useContext(Vs), w = $ || S === "vertical", O = p.useRef(null), T = Ub(o), I = Ub(s), P = i != null, D = !!(P || o.length || s.length), B = !!O.current && yd(O.current), [L, N] = p.useState(null);
  hr(() => {
    if (D && O.current) {
      const U = getComputedStyle(O.current);
      N(parseInt(U.marginBottom, 10));
    }
  }, [D, B]);
  const z = (U) => {
    U || N(null);
  }, j = function() {
    let U = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    const G = U ? T : c.errors, V = U ? I : c.warnings;
    return vU(G, V, c, "", !!u, l);
  }(), H = be(b, r, n, {
    [`${b}-with-help`]: P || T.length || I.length,
    // Status
    [`${b}-has-feedback`]: j && u,
    [`${b}-has-success`]: j === "success",
    [`${b}-has-warning`]: j === "warning",
    [`${b}-has-error`]: j === "error",
    [`${b}-is-validating`]: j === "validating",
    [`${b}-hidden`]: d,
    // Layout
    [`${b}-${S}`]: S
  });
  return /* @__PURE__ */ p.createElement("div", {
    className: H,
    style: a,
    ref: O
  }, /* @__PURE__ */ p.createElement(At, Object.assign({
    className: `${b}-row`
  }, bn(x, [
    "_internalItemRender",
    "colon",
    "dependencies",
    "extra",
    "fieldKey",
    "getValueFromEvent",
    "getValueProps",
    "htmlFor",
    "id",
    // It is deprecated because `htmlFor` is its replacement.
    "initialValue",
    "isListField",
    "label",
    "labelAlign",
    "labelCol",
    "labelWrap",
    "messageVariables",
    "name",
    "normalize",
    "noStyle",
    "preserve",
    "requiredMark",
    "rules",
    "shouldUpdate",
    "trigger",
    "tooltip",
    "validateFirst",
    "validateTrigger",
    "valuePropName",
    "wrapperCol",
    "validateDebounce"
  ])), /* @__PURE__ */ p.createElement(z$e, Object.assign({
    htmlFor: m
  }, e, {
    requiredMark: _,
    required: h ?? g,
    prefixCls: t,
    vertical: w
  })), /* @__PURE__ */ p.createElement(j$e, Object.assign({}, e, c, {
    errors: T,
    warnings: I,
    prefixCls: t,
    status: j,
    help: i,
    marginBottom: L,
    onErrorVisibleChanged: z
  }), /* @__PURE__ */ p.createElement(Gz.Provider, {
    value: y
  }, /* @__PURE__ */ p.createElement(CU, {
    prefixCls: t,
    meta: c,
    errors: c.errors,
    warnings: c.warnings,
    hasFeedback: u,
    // Already calculated
    validateStatus: j
  }, f)))), !!L && /* @__PURE__ */ p.createElement("div", {
    className: `${b}-margin-offset`,
    style: {
      marginBottom: -L
    }
  }));
}
const U$e = "__SPLIT__";
function W$e(e, t) {
  const r = Object.keys(e), n = Object.keys(t);
  return r.length === n.length && r.every((a) => {
    const i = e[a], o = t[a];
    return i === o || typeof i == "function" || typeof o == "function";
  });
}
const q$e = /* @__PURE__ */ p.memo((e) => {
  let {
    children: t
  } = e;
  return t;
}, (e, t) => W$e(e.control, t.control) && e.update === t.update && e.childProps.length === t.childProps.length && e.childProps.every((r, n) => r === t.childProps[n]));
function y4() {
  return {
    errors: [],
    warnings: [],
    touched: !1,
    validating: !1,
    name: [],
    validated: !1
  };
}
function K$e(e) {
  const {
    name: t,
    noStyle: r,
    className: n,
    dependencies: a,
    prefixCls: i,
    shouldUpdate: o,
    rules: s,
    children: l,
    required: c,
    label: u,
    messageVariables: d,
    trigger: f = "onChange",
    validateTrigger: m,
    hidden: h,
    help: g,
    layout: y
  } = e, {
    getPrefixCls: S
  } = p.useContext(Lt), {
    name: x
  } = p.useContext(Vs), b = A$e(l), _ = typeof b == "function", $ = p.useContext(Gz), {
    validateTrigger: w
  } = p.useContext($c), O = m !== void 0 ? m : w, T = t != null, I = S("form", i), P = Mn(I), [D, B, L] = BI(I, P), N = xr("Form.Item");
  process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && N(t !== null, "usage", "`null` is passed as `name` property");
  const z = p.useContext(Y0), F = p.useRef(), [j, H] = P$e({}), [U, G] = xc(() => y4()), V = (oe) => {
    const fe = z?.getKey(oe.name);
    if (G(oe.destroy ? y4() : oe, !0), r && g !== !1 && $) {
      let le = oe.name;
      if (oe.destroy)
        le = F.current || le;
      else if (fe !== void 0) {
        const [se, Q] = fe;
        le = [se].concat(ze(Q)), F.current = le;
      }
      $(oe, le);
    }
  }, K = (oe, fe) => {
    H((le) => {
      const se = Object.assign({}, le), he = [].concat(ze(oe.name.slice(0, -1)), ze(fe)).join(U$e);
      return oe.destroy ? delete se[he] : se[he] = oe, se;
    });
  }, [Z, ee] = p.useMemo(() => {
    const oe = ze(U.errors), fe = ze(U.warnings);
    return Object.values(j).forEach((le) => {
      oe.push.apply(oe, ze(le.errors || [])), fe.push.apply(fe, ze(le.warnings || []));
    }), [oe, fe];
  }, [j, U.errors, U.warnings]), ae = R$e();
  function ue(oe, fe, le) {
    return r && !h ? /* @__PURE__ */ p.createElement(CU, {
      prefixCls: I,
      hasFeedback: e.hasFeedback,
      validateStatus: e.validateStatus,
      meta: U,
      errors: Z,
      warnings: ee,
      noStyle: !0
    }, oe) : /* @__PURE__ */ p.createElement(G$e, Object.assign({
      key: "row"
    }, e, {
      className: be(n, L, P, B),
      prefixCls: I,
      fieldId: fe,
      isRequired: le,
      errors: Z,
      warnings: ee,
      meta: U,
      onSubItemMetaChange: K,
      layout: y
    }), oe);
  }
  if (!T && !_ && !a)
    return D(ue(b));
  let re = {};
  return typeof u == "string" ? re.label = u : t && (re.label = String(t)), d && (re = Object.assign(Object.assign({}, re), d)), D(/* @__PURE__ */ p.createElement(HT, Object.assign({}, e, {
    messageVariables: re,
    trigger: f,
    validateTrigger: O,
    onMetaChange: V
  }), (oe, fe, le) => {
    const se = j0(t).length && fe ? fe.name : [], Q = mU(se, x), he = c !== void 0 ? c : !!(s && s.some((k) => {
      if (k && typeof k == "object" && k.required && !k.warningOnly)
        return !0;
      if (typeof k == "function") {
        const M = k(le);
        return M && M.required && !M.warningOnly;
      }
      return !1;
    })), ne = Object.assign({}, oe);
    let me = null;
    if (process.env.NODE_ENV !== "production" && N(!(o && a), "usage", "`shouldUpdate` and `dependencies` shouldn't be used together. See https://u.ant.design/form-deps."), Array.isArray(b) && T)
      process.env.NODE_ENV !== "production" && N(!1, "usage", "A `Form.Item` with a `name` prop must have a single child element. For information on how to render more complex form items, see https://u.ant.design/complex-form-item."), me = b;
    else if (_ && (!(o || a) || T))
      process.env.NODE_ENV !== "production" && N(!!(o || a), "usage", "A `Form.Item` with a render function must have either `shouldUpdate` or `dependencies`."), process.env.NODE_ENV !== "production" && N(!T, "usage", "A `Form.Item` with a render function cannot be a field, and thus cannot have a `name` prop.");
    else if (a && !_ && !T)
      process.env.NODE_ENV !== "production" && N(!1, "usage", "Must set `name` or use a render function when `dependencies` is set.");
    else if (/* @__PURE__ */ p.isValidElement(b)) {
      process.env.NODE_ENV !== "production" && N(b.props.defaultValue === void 0, "usage", "`defaultValue` will not work on controlled Field. You should use `initialValues` of Form instead.");
      const k = Object.assign(Object.assign({}, b.props), ne);
      if (k.id || (k.id = Q), g || Z.length > 0 || ee.length > 0 || e.extra) {
        const q = [];
        (g || Z.length > 0) && q.push(`${Q}_help`), e.extra && q.push(`${Q}_extra`), k["aria-describedby"] = q.join(" ");
      }
      Z.length > 0 && (k["aria-invalid"] = "true"), he && (k["aria-required"] = "true"), No(b) && (k.ref = ae(se, b)), new Set([].concat(ze(j0(f)), ze(j0(O)))).forEach((q) => {
        k[q] = function() {
          for (var Y, X, pe, $e, J, de = arguments.length, Se = new Array(de), Ee = 0; Ee < de; Ee++)
            Se[Ee] = arguments[Ee];
          (pe = ne[q]) === null || pe === void 0 || (Y = pe).call.apply(Y, [ne].concat(Se)), (J = ($e = b.props)[q]) === null || J === void 0 || (X = J).call.apply(X, [$e].concat(Se));
        };
      });
      const R = [k["aria-required"], k["aria-invalid"], k["aria-describedby"]];
      me = /* @__PURE__ */ p.createElement(q$e, {
        control: ne,
        update: b,
        childProps: R
      }, Si(b, k));
    } else _ && (o || a) && !T ? me = b(le) : (process.env.NODE_ENV !== "production" && N(!se.length || !!r, "usage", "`name` is only used for validate React element. If you are using Form.Item as layout display, please remove `name` instead."), me = b);
    return ue(me, Q, he);
  }));
}
const SU = K$e;
SU.useStatus = yU;
var Y$e = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const Z$e = (e) => {
  var {
    prefixCls: t,
    children: r
  } = e, n = Y$e(e, ["prefixCls", "children"]);
  if (process.env.NODE_ENV !== "production") {
    const s = xr("Form.List");
    process.env.NODE_ENV !== "production" && s(typeof n.name == "number" || (Array.isArray(n.name) ? !!n.name.length : !!n.name), "usage", "Miss `name` prop.");
  }
  const {
    getPrefixCls: a
  } = p.useContext(Lt), i = a("form", t), o = p.useMemo(() => ({
    prefixCls: i,
    status: "error"
  }), [i]);
  return /* @__PURE__ */ p.createElement(Bz, Object.assign({}, n), (s, l, c) => /* @__PURE__ */ p.createElement(GT.Provider, {
    value: o
  }, r(s.map((u) => Object.assign(Object.assign({}, u), {
    fieldKey: u.key
  })), l, {
    errors: c.errors,
    warnings: c.warnings
  })));
};
function X$e() {
  const {
    form: e
  } = Cr(Vs);
  return e;
}
const Dt = gU;
Dt.Item = SU;
Dt.List = Z$e;
Dt.ErrorList = pU;
Dt.useForm = hU;
Dt.useFormInstance = X$e;
Dt.useWatch = Vz;
Dt.Provider = Uz;
Dt.create = () => {
  process.env.NODE_ENV !== "production" && Rc(!1, "Form", "antd v4 removed `Form.create`. Please remove or use `@ant-design/compatible` instead.");
};
function xU() {
  var e = document.documentElement.clientWidth, t = window.innerHeight || document.documentElement.clientHeight;
  return {
    width: e,
    height: t
  };
}
function lE(e) {
  var t = e.getBoundingClientRect(), r = document.documentElement;
  return {
    left: t.left + (window.pageXOffset || r.scrollLeft) - (r.clientLeft || document.body.clientLeft || 0),
    top: t.top + (window.pageYOffset || r.scrollTop) - (r.clientTop || document.body.clientTop || 0)
  };
}
function os(e, t, r, n) {
  var a = xb.unstable_batchedUpdates ? function(o) {
    xb.unstable_batchedUpdates(r, o);
  } : r;
  return e != null && e.addEventListener && e.addEventListener(t, a, n), {
    remove: function() {
      e != null && e.removeEventListener && e.removeEventListener(t, a, n);
    }
  };
}
var Oh = /* @__PURE__ */ p.createContext(null), J$e = function(t) {
  var r = t.visible, n = t.maskTransitionName, a = t.getContainer, i = t.prefixCls, o = t.rootClassName, s = t.icons, l = t.countRender, c = t.showSwitch, u = t.showProgress, d = t.current, f = t.transform, m = t.count, h = t.scale, g = t.minScale, y = t.maxScale, S = t.closeIcon, x = t.onSwitchLeft, b = t.onSwitchRight, _ = t.onClose, $ = t.onZoomIn, w = t.onZoomOut, O = t.onRotateRight, T = t.onRotateLeft, I = t.onFlipX, P = t.onFlipY, D = t.onReset, B = t.toolbarRender, L = t.zIndex, N = t.image, z = Cr(Oh), F = s.rotateLeft, j = s.rotateRight, H = s.zoomIn, U = s.zoomOut, G = s.close, V = s.left, K = s.right, Z = s.flipX, ee = s.flipY, ae = "".concat(i, "-operations-operation");
  p.useEffect(function() {
    var fe = function(se) {
      se.keyCode === Mt.ESC && _();
    };
    return r && window.addEventListener("keydown", fe), function() {
      window.removeEventListener("keydown", fe);
    };
  }, [r]);
  var ue = [{
    icon: ee,
    onClick: P,
    type: "flipY"
  }, {
    icon: Z,
    onClick: I,
    type: "flipX"
  }, {
    icon: F,
    onClick: T,
    type: "rotateLeft"
  }, {
    icon: j,
    onClick: O,
    type: "rotateRight"
  }, {
    icon: U,
    onClick: w,
    type: "zoomOut",
    disabled: h <= g
  }, {
    icon: H,
    onClick: $,
    type: "zoomIn",
    disabled: h === y
  }], re = ue.map(function(fe) {
    var le, se = fe.icon, Q = fe.onClick, he = fe.type, ne = fe.disabled;
    return /* @__PURE__ */ p.createElement("div", {
      className: be(ae, (le = {}, te(le, "".concat(i, "-operations-operation-").concat(he), !0), te(le, "".concat(i, "-operations-operation-disabled"), !!ne), le)),
      onClick: Q,
      key: he
    }, se);
  }), oe = /* @__PURE__ */ p.createElement("div", {
    className: "".concat(i, "-operations")
  }, re);
  return /* @__PURE__ */ p.createElement(Ci, {
    visible: r,
    motionName: n
  }, function(fe) {
    var le = fe.className, se = fe.style;
    return /* @__PURE__ */ p.createElement(bd, {
      open: !0,
      getContainer: a ?? document.body
    }, /* @__PURE__ */ p.createElement("div", {
      className: be("".concat(i, "-operations-wrapper"), le, o),
      style: ce(ce({}, se), {}, {
        zIndex: L
      })
    }, S === null ? null : /* @__PURE__ */ p.createElement("button", {
      className: "".concat(i, "-close"),
      onClick: _
    }, S || G), c && /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement("div", {
      className: be("".concat(i, "-switch-left"), te({}, "".concat(i, "-switch-left-disabled"), d === 0)),
      onClick: x
    }, V), /* @__PURE__ */ p.createElement("div", {
      className: be("".concat(i, "-switch-right"), te({}, "".concat(i, "-switch-right-disabled"), d === m - 1)),
      onClick: b
    }, K)), /* @__PURE__ */ p.createElement("div", {
      className: "".concat(i, "-footer")
    }, u && /* @__PURE__ */ p.createElement("div", {
      className: "".concat(i, "-progress")
    }, l ? l(d + 1, m) : "".concat(d + 1, " / ").concat(m)), B ? B(oe, ce(ce({
      icons: {
        flipYIcon: re[0],
        flipXIcon: re[1],
        rotateLeftIcon: re[2],
        rotateRightIcon: re[3],
        zoomOutIcon: re[4],
        zoomInIcon: re[5]
      },
      actions: {
        onFlipY: P,
        onFlipX: I,
        onRotateLeft: T,
        onRotateRight: O,
        onZoomOut: w,
        onZoomIn: $,
        onReset: D,
        onClose: _
      },
      transform: f
    }, z ? {
      current: d,
      total: m
    } : {}), {}, {
      image: N
    })) : oe)));
  });
}, ly = {
  x: 0,
  y: 0,
  rotate: 0,
  scale: 1,
  flipX: !1,
  flipY: !1
};
function Q$e(e, t, r, n) {
  var a = ct(null), i = ct([]), o = He(ly), s = ye(o, 2), l = s[0], c = s[1], u = function(h) {
    c(ly), Do(ly, l) || n?.({
      transform: ly,
      action: h
    });
  }, d = function(h, g) {
    a.current === null && (i.current = [], a.current = vr(function() {
      c(function(y) {
        var S = y;
        return i.current.forEach(function(x) {
          S = ce(ce({}, S), x);
        }), a.current = null, n?.({
          transform: S,
          action: g
        }), S;
      });
    })), i.current.push(ce(ce({}, l), h));
  }, f = function(h, g, y, S, x) {
    var b = e.current, _ = b.width, $ = b.height, w = b.offsetWidth, O = b.offsetHeight, T = b.offsetLeft, I = b.offsetTop, P = h, D = l.scale * h;
    D > r ? (D = r, P = r / l.scale) : D < t && (D = x ? D : t, P = D / l.scale);
    var B = y ?? innerWidth / 2, L = S ?? innerHeight / 2, N = P - 1, z = N * _ * 0.5, F = N * $ * 0.5, j = N * (B - l.x - T), H = N * (L - l.y - I), U = l.x - (j - z), G = l.y - (H - F);
    if (h < 1 && D === 1) {
      var V = w * D, K = O * D, Z = xU(), ee = Z.width, ae = Z.height;
      V <= ee && K <= ae && (U = 0, G = 0);
    }
    d({
      x: U,
      y: G,
      scale: D
    }, g);
  };
  return {
    transform: l,
    resetTransform: u,
    updateTransform: d,
    dispatchZoomChange: f
  };
}
function b4(e, t, r, n) {
  var a = t + r, i = (r - n) / 2;
  if (r > n) {
    if (t > 0)
      return te({}, e, i);
    if (t < 0 && a < n)
      return te({}, e, -i);
  } else if (t < 0 || a > n)
    return te({}, e, t < 0 ? i : -i);
  return {};
}
function $U(e, t, r, n) {
  var a = xU(), i = a.width, o = a.height, s = null;
  return e <= i && t <= o ? s = {
    x: 0,
    y: 0
  } : (e > i || t > o) && (s = ce(ce({}, b4("x", r, e, i)), b4("y", n, t, o))), s;
}
var Ju = 1, e_e = 1;
function t_e(e, t, r, n, a, i, o) {
  var s = a.rotate, l = a.scale, c = a.x, u = a.y, d = He(!1), f = ye(d, 2), m = f[0], h = f[1], g = ct({
    diffX: 0,
    diffY: 0,
    transformX: 0,
    transformY: 0
  }), y = function($) {
    !t || $.button !== 0 || ($.preventDefault(), $.stopPropagation(), g.current = {
      diffX: $.pageX - c,
      diffY: $.pageY - u,
      transformX: c,
      transformY: u
    }, h(!0));
  }, S = function($) {
    r && m && i({
      x: $.pageX - g.current.diffX,
      y: $.pageY - g.current.diffY
    }, "move");
  }, x = function() {
    if (r && m) {
      h(!1);
      var $ = g.current, w = $.transformX, O = $.transformY, T = c !== w && u !== O;
      if (!T) return;
      var I = e.current.offsetWidth * l, P = e.current.offsetHeight * l, D = e.current.getBoundingClientRect(), B = D.left, L = D.top, N = s % 180 !== 0, z = $U(N ? P : I, N ? I : P, B, L);
      z && i(ce({}, z), "dragRebound");
    }
  }, b = function($) {
    if (!(!r || $.deltaY == 0)) {
      var w = Math.abs($.deltaY / 100), O = Math.min(w, e_e), T = Ju + O * n;
      $.deltaY > 0 && (T = Ju / T), o(T, "wheel", $.clientX, $.clientY);
    }
  };
  return St(function() {
    var _, $, w, O;
    if (t) {
      w = os(window, "mouseup", x, !1), O = os(window, "mousemove", S, !1);
      try {
        window.top !== window.self && (_ = os(window.top, "mouseup", x, !1), $ = os(window.top, "mousemove", S, !1));
      } catch (T) {
        ls(!1, "[rc-image] ".concat(T));
      }
    }
    return function() {
      var T, I, P, D;
      (T = w) === null || T === void 0 || T.remove(), (I = O) === null || I === void 0 || I.remove(), (P = _) === null || P === void 0 || P.remove(), (D = $) === null || D === void 0 || D.remove();
    };
  }, [r, m, c, u, s, t]), {
    isMoving: m,
    onMouseDown: y,
    onMouseMove: S,
    onMouseUp: x,
    onWheel: b
  };
}
function r_e(e) {
  return new Promise(function(t) {
    var r = document.createElement("img");
    r.onerror = function() {
      return t(!1);
    }, r.onload = function() {
      return t(!0);
    }, r.src = e;
  });
}
function _U(e) {
  var t = e.src, r = e.isCustomPlaceholder, n = e.fallback, a = He(r ? "loading" : "normal"), i = ye(a, 2), o = i[0], s = i[1], l = ct(!1), c = o === "error";
  St(function() {
    var m = !0;
    return r_e(t).then(function(h) {
      !h && m && s("error");
    }), function() {
      m = !1;
    };
  }, [t]), St(function() {
    r && !l.current ? s("loading") : c && s("normal");
  }, [t]);
  var u = function() {
    s("normal");
  }, d = function(h) {
    l.current = !1, o === "loading" && h !== null && h !== void 0 && h.complete && (h.naturalWidth || h.naturalHeight) && (l.current = !0, u());
  }, f = c && n ? {
    src: n
  } : {
    onLoad: u,
    src: t
  };
  return [d, f, o];
}
function Wb(e, t) {
  var r = e.x - t.x, n = e.y - t.y;
  return Math.hypot(r, n);
}
function n_e(e, t, r, n) {
  var a = Wb(e, r), i = Wb(t, n);
  if (a === 0 && i === 0)
    return [e.x, e.y];
  var o = a / (a + i), s = e.x + o * (t.x - e.x), l = e.y + o * (t.y - e.y);
  return [s, l];
}
function a_e(e, t, r, n, a, i, o) {
  var s = a.rotate, l = a.scale, c = a.x, u = a.y, d = He(!1), f = ye(d, 2), m = f[0], h = f[1], g = ct({
    point1: {
      x: 0,
      y: 0
    },
    point2: {
      x: 0,
      y: 0
    },
    eventType: "none"
  }), y = function($) {
    g.current = ce(ce({}, g.current), $);
  }, S = function($) {
    if (t) {
      $.stopPropagation(), h(!0);
      var w = $.touches, O = w === void 0 ? [] : w;
      O.length > 1 ? y({
        point1: {
          x: O[0].clientX,
          y: O[0].clientY
        },
        point2: {
          x: O[1].clientX,
          y: O[1].clientY
        },
        eventType: "touchZoom"
      }) : y({
        point1: {
          x: O[0].clientX - c,
          y: O[0].clientY - u
        },
        eventType: "move"
      });
    }
  }, x = function($) {
    var w = $.touches, O = w === void 0 ? [] : w, T = g.current, I = T.point1, P = T.point2, D = T.eventType;
    if (O.length > 1 && D === "touchZoom") {
      var B = {
        x: O[0].clientX,
        y: O[0].clientY
      }, L = {
        x: O[1].clientX,
        y: O[1].clientY
      }, N = n_e(I, P, B, L), z = ye(N, 2), F = z[0], j = z[1], H = Wb(B, L) / Wb(I, P);
      o(H, "touchZoom", F, j, !0), y({
        point1: B,
        point2: L,
        eventType: "touchZoom"
      });
    } else D === "move" && (i({
      x: O[0].clientX - I.x,
      y: O[0].clientY - I.y
    }, "move"), y({
      eventType: "move"
    }));
  }, b = function() {
    if (r) {
      if (m && h(!1), y({
        eventType: "none"
      }), n > l)
        return i({
          x: 0,
          y: 0,
          scale: n
        }, "touchZoom");
      var $ = e.current.offsetWidth * l, w = e.current.offsetHeight * l, O = e.current.getBoundingClientRect(), T = O.left, I = O.top, P = s % 180 !== 0, D = $U(P ? w : $, P ? $ : w, T, I);
      D && i(ce({}, D), "dragRebound");
    }
  };
  return St(function() {
    var _;
    return r && t && (_ = os(window, "touchmove", function($) {
      return $.preventDefault();
    }, {
      passive: !1
    })), function() {
      var $;
      ($ = _) === null || $ === void 0 || $.remove();
    };
  }, [r, t]), {
    isTouching: m,
    onTouchStart: S,
    onTouchMove: x,
    onTouchEnd: b
  };
}
var i_e = ["fallback", "src", "imgRef"], o_e = ["prefixCls", "src", "alt", "imageInfo", "fallback", "movable", "onClose", "visible", "icons", "rootClassName", "closeIcon", "getContainer", "current", "count", "countRender", "scaleStep", "minScale", "maxScale", "transitionName", "maskTransitionName", "imageRender", "imgCommonProps", "toolbarRender", "onTransform", "onChange"], s_e = function(t) {
  var r = t.fallback, n = t.src, a = t.imgRef, i = Kt(t, i_e), o = _U({
    src: n,
    fallback: r
  }), s = ye(o, 2), l = s[0], c = s[1];
  return /* @__PURE__ */ xe.createElement("img", Pe({
    ref: function(d) {
      a.current = d, l(d);
    }
  }, i, c));
}, EU = function(t) {
  var r = t.prefixCls, n = t.src, a = t.alt, i = t.imageInfo, o = t.fallback, s = t.movable, l = s === void 0 ? !0 : s, c = t.onClose, u = t.visible, d = t.icons, f = d === void 0 ? {} : d, m = t.rootClassName, h = t.closeIcon, g = t.getContainer, y = t.current, S = y === void 0 ? 0 : y, x = t.count, b = x === void 0 ? 1 : x, _ = t.countRender, $ = t.scaleStep, w = $ === void 0 ? 0.5 : $, O = t.minScale, T = O === void 0 ? 1 : O, I = t.maxScale, P = I === void 0 ? 50 : I, D = t.transitionName, B = D === void 0 ? "zoom" : D, L = t.maskTransitionName, N = L === void 0 ? "fade" : L, z = t.imageRender, F = t.imgCommonProps, j = t.toolbarRender, H = t.onTransform, U = t.onChange, G = Kt(t, o_e), V = ct(), K = Cr(Oh), Z = K && b > 1, ee = K && b >= 1, ae = He(!0), ue = ye(ae, 2), re = ue[0], oe = ue[1], fe = Q$e(V, T, P, H), le = fe.transform, se = fe.resetTransform, Q = fe.updateTransform, he = fe.dispatchZoomChange, ne = t_e(V, l, u, w, le, Q, he), me = ne.isMoving, k = ne.onMouseDown, M = ne.onWheel, R = a_e(V, l, u, T, le, Q, he), q = R.isTouching, Y = R.onTouchStart, X = R.onTouchMove, pe = R.onTouchEnd, $e = le.rotate, J = le.scale, de = be(te({}, "".concat(r, "-moving"), me));
  St(function() {
    re || oe(!0);
  }, [re]);
  var Se = function() {
    se("close");
  }, Ee = function() {
    he(Ju + w, "zoomIn");
  }, Te = function() {
    he(Ju / (Ju + w), "zoomOut");
  }, Le = function() {
    Q({
      rotate: $e + 90
    }, "rotateRight");
  }, Ie = function() {
    Q({
      rotate: $e - 90
    }, "rotateLeft");
  }, De = function() {
    Q({
      flipX: !le.flipX
    }, "flipX");
  }, Ae = function() {
    Q({
      flipY: !le.flipY
    }, "flipY");
  }, Fe = function() {
    se("reset");
  }, Ne = function(It) {
    It?.preventDefault(), It?.stopPropagation(), S > 0 && (oe(!1), se("prev"), U?.(S - 1, S));
  }, qe = function(It) {
    It?.preventDefault(), It?.stopPropagation(), S < b - 1 && (oe(!1), se("next"), U?.(S + 1, S));
  }, Qe = function(It) {
    !u || !Z || (It.keyCode === Mt.LEFT ? Ne() : It.keyCode === Mt.RIGHT && qe());
  }, tt = function(It) {
    u && (J !== 1 ? Q({
      x: 0,
      y: 0,
      scale: 1
    }, "doubleClick") : he(Ju + w, "doubleClick", It.clientX, It.clientY));
  };
  St(function() {
    var ht = os(window, "keydown", Qe, !1);
    return function() {
      ht.remove();
    };
  }, [u, Z, S]);
  var Ge = /* @__PURE__ */ xe.createElement(s_e, Pe({}, F, {
    width: t.width,
    height: t.height,
    imgRef: V,
    className: "".concat(r, "-img"),
    alt: a,
    style: {
      transform: "translate3d(".concat(le.x, "px, ").concat(le.y, "px, 0) scale3d(").concat(le.flipX ? "-" : "").concat(J, ", ").concat(le.flipY ? "-" : "").concat(J, ", 1) rotate(").concat($e, "deg)"),
      transitionDuration: (!re || q) && "0s"
    },
    fallback: o,
    src: n,
    onWheel: M,
    onMouseDown: k,
    onDoubleClick: tt,
    onTouchStart: Y,
    onTouchMove: X,
    onTouchEnd: pe,
    onTouchCancel: pe
  })), it = ce({
    url: n,
    alt: a
  }, i);
  return /* @__PURE__ */ xe.createElement(xe.Fragment, null, /* @__PURE__ */ xe.createElement(FT, Pe({
    transitionName: B,
    maskTransitionName: N,
    closable: !1,
    keyboard: !0,
    prefixCls: r,
    onClose: c,
    visible: u,
    classNames: {
      wrapper: de
    },
    rootClassName: m,
    getContainer: g
  }, G, {
    afterClose: Se
  }), /* @__PURE__ */ xe.createElement("div", {
    className: "".concat(r, "-img-wrapper")
  }, z ? z(Ge, ce({
    transform: le,
    image: it
  }, K ? {
    current: S
  } : {})) : Ge)), /* @__PURE__ */ xe.createElement(J$e, {
    visible: u,
    transform: le,
    maskTransitionName: N,
    closeIcon: h,
    getContainer: g,
    prefixCls: r,
    rootClassName: m,
    icons: f,
    countRender: _,
    showSwitch: Z,
    showProgress: ee,
    current: S,
    count: b,
    scale: J,
    minScale: T,
    maxScale: P,
    toolbarRender: j,
    onSwitchLeft: Ne,
    onSwitchRight: qe,
    onZoomIn: Ee,
    onZoomOut: Te,
    onRotateRight: Le,
    onRotateLeft: Ie,
    onFlipX: De,
    onFlipY: Ae,
    onClose: c,
    onReset: Fe,
    zIndex: G.zIndex !== void 0 ? G.zIndex + 1 : void 0,
    image: it
  }));
}, cE = ["crossOrigin", "decoding", "draggable", "loading", "referrerPolicy", "sizes", "srcSet", "useMap", "alt"];
function l_e(e) {
  var t = p.useState({}), r = ye(t, 2), n = r[0], a = r[1], i = p.useCallback(function(s, l) {
    return a(function(c) {
      return ce(ce({}, c), {}, te({}, s, l));
    }), function() {
      a(function(c) {
        var u = ce({}, c);
        return delete u[s], u;
      });
    };
  }, []), o = p.useMemo(function() {
    return e ? e.map(function(s) {
      if (typeof s == "string")
        return {
          data: {
            src: s
          }
        };
      var l = {};
      return Object.keys(s).forEach(function(c) {
        ["src"].concat(ze(cE)).includes(c) && (l[c] = s[c]);
      }), {
        data: l
      };
    }) : Object.keys(n).reduce(function(s, l) {
      var c = n[l], u = c.canPreview, d = c.data;
      return u && s.push({
        data: d,
        id: l
      }), s;
    }, []);
  }, [e, n]);
  return [o, i, !!e];
}
var c_e = ["visible", "onVisibleChange", "getContainer", "current", "movable", "minScale", "maxScale", "countRender", "closeIcon", "onChange", "onTransform", "toolbarRender", "imageRender"], u_e = ["src"], d_e = function(t) {
  var r, n = t.previewPrefixCls, a = n === void 0 ? "rc-image-preview" : n, i = t.children, o = t.icons, s = o === void 0 ? {} : o, l = t.items, c = t.preview, u = t.fallback, d = kt(c) === "object" ? c : {}, f = d.visible, m = d.onVisibleChange, h = d.getContainer, g = d.current, y = d.movable, S = d.minScale, x = d.maxScale, b = d.countRender, _ = d.closeIcon, $ = d.onChange, w = d.onTransform, O = d.toolbarRender, T = d.imageRender, I = Kt(d, c_e), P = l_e(l), D = ye(P, 3), B = D[0], L = D[1], N = D[2], z = Kr(0, {
    value: g
  }), F = ye(z, 2), j = F[0], H = F[1], U = He(!1), G = ye(U, 2), V = G[0], K = G[1], Z = ((r = B[j]) === null || r === void 0 ? void 0 : r.data) || {}, ee = Z.src, ae = Kt(Z, u_e), ue = Kr(!!f, {
    value: f,
    onChange: function(q, Y) {
      m?.(q, Y, j);
    }
  }), re = ye(ue, 2), oe = re[0], fe = re[1], le = He(null), se = ye(le, 2), Q = se[0], he = se[1], ne = p.useCallback(function(R, q, Y, X) {
    var pe = N ? B.findIndex(function($e) {
      return $e.data.src === q;
    }) : B.findIndex(function($e) {
      return $e.id === R;
    });
    H(pe < 0 ? 0 : pe), fe(!0), he({
      x: Y,
      y: X
    }), K(!0);
  }, [B, N]);
  p.useEffect(function() {
    oe ? V || H(0) : K(!1);
  }, [oe]);
  var me = function(q, Y) {
    H(q), $?.(q, Y);
  }, k = function() {
    fe(!1), he(null);
  }, M = p.useMemo(function() {
    return {
      register: L,
      onPreview: ne
    };
  }, [L, ne]);
  return /* @__PURE__ */ p.createElement(Oh.Provider, {
    value: M
  }, i, /* @__PURE__ */ p.createElement(EU, Pe({
    "aria-hidden": !oe,
    movable: y,
    visible: oe,
    prefixCls: a,
    closeIcon: _,
    onClose: k,
    mousePosition: Q,
    imgCommonProps: ae,
    src: ee,
    fallback: u,
    icons: s,
    minScale: S,
    maxScale: x,
    getContainer: h,
    current: j,
    count: B.length,
    countRender: b,
    onTransform: w,
    toolbarRender: O,
    imageRender: T,
    onChange: me
  }, I)));
}, C4 = 0;
function f_e(e, t) {
  var r = p.useState(function() {
    return C4 += 1, String(C4);
  }), n = ye(r, 1), a = n[0], i = p.useContext(Oh), o = {
    data: t,
    canPreview: e
  };
  return p.useEffect(function() {
    if (i)
      return i.register(a, o);
  }, []), p.useEffect(function() {
    i && i.register(a, o);
  }, [e, t]), a;
}
var p_e = ["src", "alt", "onPreviewClose", "prefixCls", "previewPrefixCls", "placeholder", "fallback", "width", "height", "style", "preview", "className", "onClick", "onError", "wrapperClassName", "wrapperStyle", "rootClassName"], m_e = ["src", "visible", "onVisibleChange", "getContainer", "mask", "maskClassName", "movable", "icons", "scaleStep", "minScale", "maxScale", "imageRender", "toolbarRender"], Z1 = function(t) {
  var r = t.src, n = t.alt, a = t.onPreviewClose, i = t.prefixCls, o = i === void 0 ? "rc-image" : i, s = t.previewPrefixCls, l = s === void 0 ? "".concat(o, "-preview") : s, c = t.placeholder, u = t.fallback, d = t.width, f = t.height, m = t.style, h = t.preview, g = h === void 0 ? !0 : h, y = t.className, S = t.onClick, x = t.onError, b = t.wrapperClassName, _ = t.wrapperStyle, $ = t.rootClassName, w = Kt(t, p_e), O = c && c !== !0, T = kt(g) === "object" ? g : {}, I = T.src, P = T.visible, D = P === void 0 ? void 0 : P, B = T.onVisibleChange, L = B === void 0 ? a : B, N = T.getContainer, z = N === void 0 ? void 0 : N, F = T.mask, j = T.maskClassName, H = T.movable, U = T.icons, G = T.scaleStep, V = T.minScale, K = T.maxScale, Z = T.imageRender, ee = T.toolbarRender, ae = Kt(T, m_e), ue = I ?? r, re = Kr(!!D, {
    value: D,
    onChange: L
  }), oe = ye(re, 2), fe = oe[0], le = oe[1], se = _U({
    src: r,
    isCustomPlaceholder: O,
    fallback: u
  }), Q = ye(se, 3), he = Q[0], ne = Q[1], me = Q[2], k = He(null), M = ye(k, 2), R = M[0], q = M[1], Y = Cr(Oh), X = !!g, pe = function() {
    le(!1), q(null);
  }, $e = be(o, b, $, te({}, "".concat(o, "-error"), me === "error")), J = dr(function() {
    var Te = {};
    return cE.forEach(function(Le) {
      t[Le] !== void 0 && (Te[Le] = t[Le]);
    }), Te;
  }, cE.map(function(Te) {
    return t[Te];
  })), de = dr(function() {
    return ce(ce({}, J), {}, {
      src: ue
    });
  }, [ue, J]), Se = f_e(X, de), Ee = function(Le) {
    var Ie = lE(Le.target), De = Ie.left, Ae = Ie.top;
    Y ? Y.onPreview(Se, ue, De, Ae) : (q({
      x: De,
      y: Ae
    }), le(!0)), S?.(Le);
  };
  return /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement("div", Pe({}, w, {
    className: $e,
    onClick: X ? Ee : S,
    style: ce({
      width: d,
      height: f
    }, _)
  }), /* @__PURE__ */ p.createElement("img", Pe({}, J, {
    className: be("".concat(o, "-img"), te({}, "".concat(o, "-img-placeholder"), c === !0), y),
    style: ce({
      height: f
    }, m),
    ref: he
  }, ne, {
    width: d,
    height: f,
    onError: x
  })), me === "loading" && /* @__PURE__ */ p.createElement("div", {
    "aria-hidden": "true",
    className: "".concat(o, "-placeholder")
  }, c), F && X && /* @__PURE__ */ p.createElement("div", {
    className: be("".concat(o, "-mask"), j),
    style: {
      display: m?.display === "none" ? "none" : void 0
    }
  }, F)), !Y && X && /* @__PURE__ */ p.createElement(EU, Pe({
    "aria-hidden": !fe,
    visible: fe,
    prefixCls: l,
    onClose: pe,
    mousePosition: R,
    src: ue,
    alt: n,
    imageInfo: {
      width: d,
      height: f
    },
    fallback: u,
    getContainer: z,
    icons: U,
    movable: H,
    scaleStep: G,
    minScale: V,
    maxScale: K,
    rootClassName: $,
    imageRender: Z,
    imgCommonProps: J,
    toolbarRender: ee
  }, ae)));
};
Z1.PreviewGroup = d_e;
process.env.NODE_ENV !== "production" && (Z1.displayName = "Image");
var v_e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "defs", attrs: {}, children: [{ tag: "style", attrs: {} }] }, { tag: "path", attrs: { d: "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z" } }, { tag: "path", attrs: { d: "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z" } }] }, name: "rotate-left", theme: "outlined" }, h_e = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: v_e
  }));
}, wU = /* @__PURE__ */ p.forwardRef(h_e);
process.env.NODE_ENV !== "production" && (wU.displayName = "RotateLeftOutlined");
var g_e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "defs", attrs: {}, children: [{ tag: "style", attrs: {} }] }, { tag: "path", attrs: { d: "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z" } }, { tag: "path", attrs: { d: "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z" } }] }, name: "rotate-right", theme: "outlined" }, y_e = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: g_e
  }));
}, OU = /* @__PURE__ */ p.forwardRef(y_e);
process.env.NODE_ENV !== "production" && (OU.displayName = "RotateRightOutlined");
var b_e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, name: "swap", theme: "outlined" }, C_e = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: b_e
  }));
}, uE = /* @__PURE__ */ p.forwardRef(C_e);
process.env.NODE_ENV !== "production" && (uE.displayName = "SwapOutlined");
var S_e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, name: "zoom-in", theme: "outlined" }, x_e = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: S_e
  }));
}, TU = /* @__PURE__ */ p.forwardRef(x_e);
process.env.NODE_ENV !== "production" && (TU.displayName = "ZoomInOutlined");
var $_e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, name: "zoom-out", theme: "outlined" }, __e = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: $_e
  }));
}, IU = /* @__PURE__ */ p.forwardRef(__e);
process.env.NODE_ENV !== "production" && (IU.displayName = "ZoomOutOutlined");
const dE = (e) => ({
  position: e || "absolute",
  inset: 0
}), E_e = (e) => {
  const {
    iconCls: t,
    motionDurationSlow: r,
    paddingXXS: n,
    marginXXS: a,
    prefixCls: i,
    colorTextLightSolid: o
  } = e;
  return {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: o,
    background: new Br("#000").setAlpha(0.5).toRgbString(),
    cursor: "pointer",
    opacity: 0,
    transition: `opacity ${r}`,
    [`.${i}-mask-info`]: Object.assign(Object.assign({}, cs), {
      padding: `0 ${ve(n)}`,
      [t]: {
        marginInlineEnd: a,
        svg: {
          verticalAlign: "baseline"
        }
      }
    })
  };
}, w_e = (e) => {
  const {
    previewCls: t,
    modalMaskBg: r,
    paddingSM: n,
    marginXL: a,
    margin: i,
    paddingLG: o,
    previewOperationColorDisabled: s,
    previewOperationHoverColor: l,
    motionDurationSlow: c,
    iconCls: u,
    colorTextLightSolid: d
  } = e, f = new Br(r).setAlpha(0.1), m = f.clone().setAlpha(0.2);
  return {
    [`${t}-footer`]: {
      position: "fixed",
      bottom: a,
      left: {
        _skip_check_: !0,
        value: 0
      },
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      color: e.previewOperationColor
    },
    [`${t}-progress`]: {
      marginBottom: i
    },
    [`${t}-close`]: {
      position: "fixed",
      top: a,
      right: {
        _skip_check_: !0,
        value: a
      },
      display: "flex",
      color: d,
      backgroundColor: f.toRgbString(),
      borderRadius: "50%",
      padding: n,
      outline: 0,
      border: 0,
      cursor: "pointer",
      transition: `all ${c}`,
      "&:hover": {
        backgroundColor: m.toRgbString()
      },
      [`& > ${u}`]: {
        fontSize: e.previewOperationSize
      }
    },
    [`${t}-operations`]: {
      display: "flex",
      alignItems: "center",
      padding: `0 ${ve(o)}`,
      backgroundColor: f.toRgbString(),
      borderRadius: 100,
      "&-operation": {
        marginInlineStart: n,
        padding: n,
        cursor: "pointer",
        transition: `all ${c}`,
        userSelect: "none",
        [`&:not(${t}-operations-operation-disabled):hover > ${u}`]: {
          color: l
        },
        "&-disabled": {
          color: s,
          cursor: "not-allowed"
        },
        "&:first-of-type": {
          marginInlineStart: 0
        },
        [`& > ${u}`]: {
          fontSize: e.previewOperationSize
        }
      }
    }
  };
}, O_e = (e) => {
  const {
    modalMaskBg: t,
    iconCls: r,
    previewOperationColorDisabled: n,
    previewCls: a,
    zIndexPopup: i,
    motionDurationSlow: o
  } = e, s = new Br(t).setAlpha(0.1), l = s.clone().setAlpha(0.2);
  return {
    [`${a}-switch-left, ${a}-switch-right`]: {
      position: "fixed",
      insetBlockStart: "50%",
      zIndex: e.calc(i).add(1).equal(),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: e.imagePreviewSwitchSize,
      height: e.imagePreviewSwitchSize,
      marginTop: e.calc(e.imagePreviewSwitchSize).mul(-1).div(2).equal(),
      color: e.previewOperationColor,
      background: s.toRgbString(),
      borderRadius: "50%",
      transform: "translateY(-50%)",
      cursor: "pointer",
      transition: `all ${o}`,
      userSelect: "none",
      "&:hover": {
        background: l.toRgbString()
      },
      "&-disabled": {
        "&, &:hover": {
          color: n,
          background: "transparent",
          cursor: "not-allowed",
          [`> ${r}`]: {
            cursor: "not-allowed"
          }
        }
      },
      [`> ${r}`]: {
        fontSize: e.previewOperationSize
      }
    },
    [`${a}-switch-left`]: {
      insetInlineStart: e.marginSM
    },
    [`${a}-switch-right`]: {
      insetInlineEnd: e.marginSM
    }
  };
}, T_e = (e) => {
  const {
    motionEaseOut: t,
    previewCls: r,
    motionDurationSlow: n,
    componentCls: a
  } = e;
  return [
    {
      [`${a}-preview-root`]: {
        [r]: {
          height: "100%",
          textAlign: "center",
          pointerEvents: "none"
        },
        [`${r}-body`]: Object.assign(Object.assign({}, dE()), {
          overflow: "hidden"
        }),
        [`${r}-img`]: {
          maxWidth: "100%",
          maxHeight: "70%",
          verticalAlign: "middle",
          transform: "scale3d(1, 1, 1)",
          cursor: "grab",
          transition: `transform ${n} ${t} 0s`,
          userSelect: "none",
          "&-wrapper": Object.assign(Object.assign({}, dE()), {
            transition: `transform ${n} ${t} 0s`,
            // https://github.com/ant-design/ant-design/issues/39913
            // TailwindCSS will reset img default style.
            // Let's set back.
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "& > *": {
              pointerEvents: "auto"
            },
            "&::before": {
              display: "inline-block",
              width: 1,
              height: "50%",
              marginInlineEnd: -1,
              content: '""'
            }
          })
        },
        [`${r}-moving`]: {
          [`${r}-preview-img`]: {
            cursor: "grabbing",
            "&-wrapper": {
              transitionDuration: "0s"
            }
          }
        }
      }
    },
    // Override
    {
      [`${a}-preview-root`]: {
        [`${r}-wrap`]: {
          zIndex: e.zIndexPopup
        }
      }
    },
    // Preview operations & switch
    {
      [`${a}-preview-operations-wrapper`]: {
        position: "fixed",
        zIndex: e.calc(e.zIndexPopup).add(1).equal()
      },
      "&": [w_e(e), O_e(e)]
    }
  ];
}, I_e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // ============================== image ==============================
    [t]: {
      position: "relative",
      display: "inline-block",
      [`${t}-img`]: {
        width: "100%",
        height: "auto",
        verticalAlign: "middle"
      },
      [`${t}-img-placeholder`]: {
        backgroundColor: e.colorBgContainerDisabled,
        backgroundImage: "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSAyLjVoLTEzQS41LjUgMCAwIDAgMSAzdjEwYS41LjUgMCAwIDAgLjUuNWgxM2EuNS41IDAgMCAwIC41LS41VjNhLjUuNSAwIDAgMC0uNS0uNXpNNS4yODEgNC43NWExIDEgMCAwIDEgMCAyIDEgMSAwIDAgMSAwLTJ6bTguMDMgNi44M2EuMTI3LjEyNyAwIDAgMS0uMDgxLjAzSDIuNzY5YS4xMjUuMTI1IDAgMCAxLS4wOTYtLjIwN2wyLjY2MS0zLjE1NmEuMTI2LjEyNiAwIDAgMSAuMTc3LS4wMTZsLjAxNi4wMTZMNy4wOCAxMC4wOWwyLjQ3LTIuOTNhLjEyNi4xMjYgMCAwIDEgLjE3Ny0uMDE2bC4wMTUuMDE2IDMuNTg4IDQuMjQ0YS4xMjcuMTI3IDAgMCAxLS4wMi4xNzV6IiBmaWxsPSIjOEM4QzhDIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=')",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "30%"
      },
      [`${t}-mask`]: Object.assign({}, E_e(e)),
      [`${t}-mask:hover`]: {
        opacity: 1
      },
      [`${t}-placeholder`]: Object.assign({}, dE())
    }
  };
}, M_e = (e) => {
  const {
    previewCls: t
  } = e;
  return {
    [`${t}-root`]: ph(e, "zoom"),
    "&": Xz(e, !0)
  };
}, A_e = (e) => ({
  zIndexPopup: e.zIndexPopupBase + 80,
  previewOperationColor: new Br(e.colorTextLightSolid).setAlpha(0.65).toRgbString(),
  previewOperationHoverColor: new Br(e.colorTextLightSolid).setAlpha(0.85).toRgbString(),
  previewOperationColorDisabled: new Br(e.colorTextLightSolid).setAlpha(0.25).toRgbString(),
  previewOperationSize: e.fontSizeIcon * 1.5
  // FIXME: fontSizeIconLG
}), MU = Zr("Image", (e) => {
  const t = `${e.componentCls}-preview`, r = $r(e, {
    previewCls: t,
    modalMaskBg: new Br("#000").setAlpha(0.45).toRgbString(),
    // FIXME: Shared Token
    imagePreviewSwitchSize: e.controlHeightLG
  });
  return [I_e(r), T_e(r), Jz($r(r, {
    componentCls: t
  })), M_e(r)];
}, A_e);
var P_e = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const AU = {
  rotateLeft: /* @__PURE__ */ p.createElement(wU, null),
  rotateRight: /* @__PURE__ */ p.createElement(OU, null),
  zoomIn: /* @__PURE__ */ p.createElement(TU, null),
  zoomOut: /* @__PURE__ */ p.createElement(IU, null),
  close: /* @__PURE__ */ p.createElement(Ys, null),
  left: /* @__PURE__ */ p.createElement(cd, null),
  right: /* @__PURE__ */ p.createElement(_c, null),
  flipX: /* @__PURE__ */ p.createElement(uE, null),
  flipY: /* @__PURE__ */ p.createElement(uE, {
    rotate: 90
  })
}, R_e = (e) => {
  var {
    previewPrefixCls: t,
    preview: r
  } = e, n = P_e(e, ["previewPrefixCls", "preview"]);
  const {
    getPrefixCls: a
  } = p.useContext(Lt), i = a("image", t), o = `${i}-preview`, s = a(), l = Mn(i), [c, u, d] = MU(i, l), [f] = ps("ImagePreview", typeof r == "object" ? r.zIndex : void 0), m = p.useMemo(() => {
    var h;
    if (r === !1)
      return r;
    const g = typeof r == "object" ? r : {}, y = be(u, d, l, (h = g.rootClassName) !== null && h !== void 0 ? h : "");
    return Object.assign(Object.assign({}, g), {
      transitionName: Gi(s, "zoom", g.transitionName),
      maskTransitionName: Gi(s, "fade", g.maskTransitionName),
      rootClassName: y,
      zIndex: f
    });
  }, [r]);
  return c(/* @__PURE__ */ p.createElement(Z1.PreviewGroup, Object.assign({
    preview: m,
    previewPrefixCls: o,
    icons: AU
  }, n)));
};
var S4 = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const qb = (e) => {
  var t;
  const {
    prefixCls: r,
    preview: n,
    className: a,
    rootClassName: i,
    style: o
  } = e, s = S4(e, ["prefixCls", "preview", "className", "rootClassName", "style"]), {
    getPrefixCls: l,
    locale: c = jo,
    getPopupContainer: u,
    image: d
  } = p.useContext(Lt), f = l("image", r), m = l(), h = c.Image || jo.Image, g = Mn(f), [y, S, x] = MU(f, g), b = be(i, S, x, g), _ = be(a, S, d?.className), [$] = ps("ImagePreview", typeof n == "object" ? n.zIndex : void 0), w = p.useMemo(() => {
    var T;
    if (n === !1)
      return n;
    const I = typeof n == "object" ? n : {}, {
      getContainer: P,
      closeIcon: D
    } = I, B = S4(I, ["getContainer", "closeIcon"]);
    return Object.assign(Object.assign({
      mask: /* @__PURE__ */ p.createElement("div", {
        className: `${f}-mask-info`
      }, /* @__PURE__ */ p.createElement(RI, null), h?.preview),
      icons: AU
    }, B), {
      getContainer: P ?? u,
      transitionName: Gi(m, "zoom", I.transitionName),
      maskTransitionName: Gi(m, "fade", I.maskTransitionName),
      zIndex: $,
      closeIcon: D ?? ((T = d?.preview) === null || T === void 0 ? void 0 : T.closeIcon)
    });
  }, [n, h, (t = d?.preview) === null || t === void 0 ? void 0 : t.closeIcon]), O = Object.assign(Object.assign({}, d?.style), o);
  return y(/* @__PURE__ */ p.createElement(Z1, Object.assign({
    prefixCls: f,
    preview: w,
    rootClassName: b,
    className: _,
    style: O
  }, s)));
};
qb.PreviewGroup = R_e;
process.env.NODE_ENV !== "production" && (qb.displayName = "Image");
function N_e(e, t, r) {
  return typeof r == "boolean" ? r : e.length ? !0 : Ma(t).some((a) => a.type === fI);
}
const D_e = (e) => {
  const {
    componentCls: t,
    bodyBg: r,
    lightSiderBg: n,
    lightTriggerBg: a,
    lightTriggerColor: i
  } = e;
  return {
    [`${t}-sider-light`]: {
      background: n,
      [`${t}-sider-trigger`]: {
        color: i,
        background: a
      },
      [`${t}-sider-zero-width-trigger`]: {
        color: i,
        background: a,
        border: `1px solid ${r}`,
        // Safe to modify to any other color
        borderInlineStart: 0
      }
    }
  };
}, j_e = (e) => {
  const {
    antCls: t,
    // .ant
    componentCls: r,
    // .ant-layout
    colorText: n,
    triggerColor: a,
    footerBg: i,
    triggerBg: o,
    headerHeight: s,
    headerPadding: l,
    headerColor: c,
    footerPadding: u,
    triggerHeight: d,
    zeroTriggerHeight: f,
    zeroTriggerWidth: m,
    motionDurationMid: h,
    motionDurationSlow: g,
    fontSize: y,
    borderRadius: S,
    bodyBg: x,
    headerBg: b,
    siderBg: _
  } = e;
  return {
    [r]: Object.assign(Object.assign({
      display: "flex",
      flex: "auto",
      flexDirection: "column",
      /* fix firefox can't set height smaller than content on flex item */
      minHeight: 0,
      background: x,
      "&, *": {
        boxSizing: "border-box"
      },
      [`&${r}-has-sider`]: {
        flexDirection: "row",
        [`> ${r}, > ${r}-content`]: {
          // https://segmentfault.com/a/1190000019498300
          width: 0
        }
      },
      [`${r}-header, &${r}-footer`]: {
        flex: "0 0 auto"
      },
      [`${r}-sider`]: {
        position: "relative",
        // fix firefox can't set width smaller than content on flex item
        minWidth: 0,
        background: _,
        transition: `all ${h}, background 0s`,
        "&-children": {
          height: "100%",
          // Hack for fixing margin collapse bug
          // https://github.com/ant-design/ant-design/issues/7967
          // solution from https://stackoverflow.com/a/33132624/3040605
          marginTop: -0.1,
          paddingTop: 0.1,
          [`${t}-menu${t}-menu-inline-collapsed`]: {
            width: "auto"
          }
        },
        "&-has-trigger": {
          paddingBottom: d
        },
        "&-right": {
          order: 1
        },
        "&-trigger": {
          position: "fixed",
          bottom: 0,
          zIndex: 1,
          height: d,
          color: a,
          lineHeight: ve(d),
          textAlign: "center",
          background: o,
          cursor: "pointer",
          transition: `all ${h}`
        },
        "&-zero-width": {
          "> *": {
            overflow: "hidden"
          },
          "&-trigger": {
            position: "absolute",
            top: s,
            insetInlineEnd: e.calc(m).mul(-1).equal(),
            zIndex: 1,
            width: m,
            height: f,
            color: a,
            fontSize: e.fontSizeXL,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: _,
            borderStartStartRadius: 0,
            borderStartEndRadius: S,
            borderEndEndRadius: S,
            borderEndStartRadius: 0,
            cursor: "pointer",
            transition: `background ${g} ease`,
            "&::after": {
              position: "absolute",
              inset: 0,
              background: "transparent",
              transition: `all ${g}`,
              content: '""'
            },
            "&:hover::after": {
              background: "rgba(255, 255, 255, 0.2)"
            },
            "&-right": {
              insetInlineStart: e.calc(m).mul(-1).equal(),
              borderStartStartRadius: S,
              borderStartEndRadius: 0,
              borderEndEndRadius: 0,
              borderEndStartRadius: S
            }
          }
        }
      }
    }, D_e(e)), {
      // RTL
      "&-rtl": {
        direction: "rtl"
      }
    }),
    // ==================== Header ====================
    [`${r}-header`]: {
      height: s,
      padding: l,
      color: c,
      lineHeight: ve(s),
      background: b,
      // Other components/menu/style/index.less line:686
      // Integration with header element so menu items have the same height
      [`${t}-menu`]: {
        lineHeight: "inherit"
      }
    },
    // ==================== Footer ====================
    [`${r}-footer`]: {
      padding: u,
      color: n,
      fontSize: y,
      background: i
    },
    // =================== Content ====================
    [`${r}-content`]: {
      flex: "auto",
      color: n,
      // fix firefox can't set height smaller than content on flex item
      minHeight: 0
    }
  };
}, L_e = (e) => {
  const {
    colorBgLayout: t,
    controlHeight: r,
    controlHeightLG: n,
    colorText: a,
    controlHeightSM: i,
    marginXXS: o,
    colorTextLightSolid: s,
    colorBgContainer: l
  } = e, c = n * 1.25;
  return {
    // Deprecated
    colorBgHeader: "#001529",
    colorBgBody: t,
    colorBgTrigger: "#002140",
    bodyBg: t,
    headerBg: "#001529",
    headerHeight: r * 2,
    headerPadding: `0 ${c}px`,
    headerColor: a,
    footerPadding: `${i}px ${c}px`,
    footerBg: t,
    siderBg: "#001529",
    triggerHeight: n + o * 2,
    triggerBg: "#002140",
    triggerColor: s,
    zeroTriggerWidth: n,
    zeroTriggerHeight: n,
    lightSiderBg: l,
    lightTriggerBg: l,
    lightTriggerColor: a
  };
}, PU = Zr("Layout", (e) => [j_e(e)], L_e, {
  deprecatedTokens: [["colorBgBody", "bodyBg"], ["colorBgHeader", "headerBg"], ["colorBgTrigger", "triggerBg"]]
});
var RU = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function X1(e) {
  let {
    suffixCls: t,
    tagName: r,
    displayName: n
  } = e;
  return (a) => {
    const i = /* @__PURE__ */ p.forwardRef((o, s) => /* @__PURE__ */ p.createElement(a, Object.assign({
      ref: s,
      suffixCls: t,
      tagName: r
    }, o)));
    return process.env.NODE_ENV !== "production" && (i.displayName = n), i;
  };
}
const zI = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    prefixCls: r,
    suffixCls: n,
    className: a,
    tagName: i
  } = e, o = RU(e, ["prefixCls", "suffixCls", "className", "tagName"]), {
    getPrefixCls: s
  } = p.useContext(Lt), l = s("layout", r), [c, u, d] = PU(l), f = n ? `${l}-${n}` : l;
  return c(/* @__PURE__ */ p.createElement(i, Object.assign({
    className: be(r || f, a, u, d),
    ref: t
  }, o)));
}), k_e = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    direction: r
  } = p.useContext(Lt), [n, a] = p.useState([]), {
    prefixCls: i,
    className: o,
    rootClassName: s,
    children: l,
    hasSider: c,
    tagName: u,
    style: d
  } = e, f = RU(e, ["prefixCls", "className", "rootClassName", "children", "hasSider", "tagName", "style"]), m = bn(f, ["suffixCls"]), {
    getPrefixCls: h,
    layout: g
  } = p.useContext(Lt), y = h("layout", i), S = N_e(n, l, c), [x, b, _] = PU(y), $ = be(y, {
    [`${y}-has-sider`]: S,
    [`${y}-rtl`]: r === "rtl"
  }, g?.className, o, s, b, _), w = p.useMemo(() => ({
    siderHook: {
      addSider: (O) => {
        a((T) => [].concat(ze(T), [O]));
      },
      removeSider: (O) => {
        a((T) => T.filter((I) => I !== O));
      }
    }
  }), []);
  return x(/* @__PURE__ */ p.createElement(vV.Provider, {
    value: w
  }, /* @__PURE__ */ p.createElement(u, Object.assign({
    ref: t,
    className: $,
    style: Object.assign(Object.assign({}, g?.style), d)
  }, m), l)));
}), F_e = X1({
  tagName: "div",
  displayName: "Layout"
})(k_e), B_e = X1({
  suffixCls: "header",
  tagName: "header",
  displayName: "Header"
})(zI), z_e = X1({
  suffixCls: "footer",
  tagName: "footer",
  displayName: "Footer"
})(zI), H_e = X1({
  suffixCls: "content",
  tagName: "main",
  displayName: "Content"
})(zI), Ol = F_e;
Ol.Header = B_e;
Ol.Footer = z_e;
Ol.Content = H_e;
Ol.Sider = fI;
Ol._InternalSiderContext = B1;
const V_e = function() {
  const e = Object.assign({}, arguments.length <= 0 ? void 0 : arguments[0]);
  for (let t = 1; t < arguments.length; t++) {
    const r = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    r && Object.keys(r).forEach((n) => {
      const a = r[n];
      a !== void 0 && (e[n] = a);
    });
  }
  return e;
};
var G_e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, name: "double-left", theme: "outlined" }, U_e = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: G_e
  }));
}, fE = /* @__PURE__ */ p.forwardRef(U_e);
process.env.NODE_ENV !== "production" && (fE.displayName = "DoubleLeftOutlined");
var W_e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, name: "double-right", theme: "outlined" }, q_e = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: W_e
  }));
}, pE = /* @__PURE__ */ p.forwardRef(q_e);
process.env.NODE_ENV !== "production" && (pE.displayName = "DoubleRightOutlined");
var K_e = {
  // Options
  items_per_page: "条/页",
  jump_to: "跳至",
  jump_to_confirm: "确定",
  page: "页",
  // Pagination
  prev_page: "上一页",
  next_page: "下一页",
  prev_5: "向前 5 页",
  next_5: "向后 5 页",
  prev_3: "向前 3 页",
  next_3: "向后 3 页",
  page_size: "页码"
}, Y_e = ["10", "20", "50", "100"], NU = function(t) {
  var r = t.pageSizeOptions, n = r === void 0 ? Y_e : r, a = t.locale, i = t.changeSize, o = t.pageSize, s = t.goButton, l = t.quickGo, c = t.rootPrefixCls, u = t.selectComponentClass, d = t.selectPrefixCls, f = t.disabled, m = t.buildOptionText, h = xe.useState(""), g = ye(h, 2), y = g[0], S = g[1], x = function() {
    return !y || Number.isNaN(y) ? void 0 : Number(y);
  }, b = typeof m == "function" ? m : function(N) {
    return "".concat(N, " ").concat(a.items_per_page);
  }, _ = function(z) {
    i?.(Number(z));
  }, $ = function(z) {
    S(z.target.value);
  }, w = function(z) {
    s || y === "" || (S(""), !(z.relatedTarget && (z.relatedTarget.className.indexOf("".concat(c, "-item-link")) >= 0 || z.relatedTarget.className.indexOf("".concat(c, "-item")) >= 0)) && l?.(x()));
  }, O = function(z) {
    y !== "" && (z.keyCode === Mt.ENTER || z.type === "click") && (S(""), l?.(x()));
  }, T = function() {
    return n.some(function(z) {
      return z.toString() === o.toString();
    }) ? n : n.concat([o.toString()]).sort(function(z, F) {
      var j = Number.isNaN(Number(z)) ? 0 : Number(z), H = Number.isNaN(Number(F)) ? 0 : Number(F);
      return j - H;
    });
  }, I = "".concat(c, "-options");
  if (!i && !l)
    return null;
  var P = null, D = null, B = null;
  if (i && u) {
    var L = T().map(function(N, z) {
      return /* @__PURE__ */ xe.createElement(u.Option, {
        key: z,
        value: N.toString()
      }, b(N));
    });
    P = /* @__PURE__ */ xe.createElement(u, {
      disabled: f,
      prefixCls: d,
      showSearch: !1,
      className: "".concat(I, "-size-changer"),
      optionLabelProp: "children",
      popupMatchSelectWidth: !1,
      value: (o || n[0]).toString(),
      onChange: _,
      getPopupContainer: function(z) {
        return z.parentNode;
      },
      "aria-label": a.page_size,
      defaultOpen: !1
    }, L);
  }
  return l && (s && (B = typeof s == "boolean" ? /* @__PURE__ */ xe.createElement("button", {
    type: "button",
    onClick: O,
    onKeyUp: O,
    disabled: f,
    className: "".concat(I, "-quick-jumper-button")
  }, a.jump_to_confirm) : /* @__PURE__ */ xe.createElement("span", {
    onClick: O,
    onKeyUp: O
  }, s)), D = /* @__PURE__ */ xe.createElement("div", {
    className: "".concat(I, "-quick-jumper")
  }, a.jump_to, /* @__PURE__ */ xe.createElement("input", {
    disabled: f,
    type: "text",
    value: y,
    onChange: $,
    onKeyUp: O,
    onBlur: w,
    "aria-label": a.page
  }), a.page, B)), /* @__PURE__ */ xe.createElement("li", {
    className: I
  }, P, D);
};
process.env.NODE_ENV !== "production" && (NU.displayName = "Options");
var qu = function(t) {
  var r, n = t.rootPrefixCls, a = t.page, i = t.active, o = t.className, s = t.showTitle, l = t.onClick, c = t.onKeyPress, u = t.itemRender, d = "".concat(n, "-item"), f = be(d, "".concat(d, "-").concat(a), (r = {}, te(r, "".concat(d, "-active"), i), te(r, "".concat(d, "-disabled"), !a), r), o), m = function() {
    l(a);
  }, h = function(S) {
    c(S, l, a);
  }, g = u(a, "page", /* @__PURE__ */ xe.createElement("a", {
    rel: "nofollow"
  }, a));
  return g ? /* @__PURE__ */ xe.createElement("li", {
    title: s ? String(a) : null,
    className: f,
    onClick: m,
    onKeyDown: h,
    tabIndex: 0
  }, g) : null;
};
process.env.NODE_ENV !== "production" && (qu.displayName = "Pager");
var Z_e = function(t, r, n) {
  return n;
};
function Rx() {
}
function x4(e) {
  var t = Number(e);
  return typeof t == "number" && !Number.isNaN(t) && isFinite(t) && Math.floor(t) === t;
}
function Gl(e, t, r) {
  var n = typeof e > "u" ? t : e;
  return Math.floor((r - 1) / n) + 1;
}
var DU = function(t) {
  var r, n = t.prefixCls, a = n === void 0 ? "rc-pagination" : n, i = t.selectPrefixCls, o = i === void 0 ? "rc-select" : i, s = t.className, l = t.selectComponentClass, c = t.current, u = t.defaultCurrent, d = u === void 0 ? 1 : u, f = t.total, m = f === void 0 ? 0 : f, h = t.pageSize, g = t.defaultPageSize, y = g === void 0 ? 10 : g, S = t.onChange, x = S === void 0 ? Rx : S, b = t.hideOnSinglePage, _ = t.showPrevNextJumpers, $ = _ === void 0 ? !0 : _, w = t.showQuickJumper, O = t.showLessItems, T = t.showTitle, I = T === void 0 ? !0 : T, P = t.onShowSizeChange, D = P === void 0 ? Rx : P, B = t.locale, L = B === void 0 ? K_e : B, N = t.style, z = t.totalBoundaryShowSizeChanger, F = z === void 0 ? 50 : z, j = t.disabled, H = t.simple, U = t.showTotal, G = t.showSizeChanger, V = t.pageSizeOptions, K = t.itemRender, Z = K === void 0 ? Z_e : K, ee = t.jumpPrevIcon, ae = t.jumpNextIcon, ue = t.prevIcon, re = t.nextIcon, oe = xe.useRef(null), fe = Kr(10, {
    value: h,
    defaultValue: y
  }), le = ye(fe, 2), se = le[0], Q = le[1], he = Kr(1, {
    value: c,
    defaultValue: d,
    postState: function(er) {
      return Math.max(1, Math.min(er, Gl(void 0, se, m)));
    }
  }), ne = ye(he, 2), me = ne[0], k = ne[1], M = xe.useState(me), R = ye(M, 2), q = R[0], Y = R[1];
  St(function() {
    Y(me);
  }, [me]);
  var X = x !== Rx, pe = "current" in t;
  process.env.NODE_ENV !== "production" && jt(pe ? X : !0, "You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.");
  var $e = Math.max(1, me - (O ? 3 : 5)), J = Math.min(Gl(void 0, se, m), me + (O ? 3 : 5));
  function de(Zt, er) {
    var _r = Zt || /* @__PURE__ */ xe.createElement("button", {
      type: "button",
      "aria-label": er,
      className: "".concat(a, "-item-link")
    });
    return typeof Zt == "function" && (_r = /* @__PURE__ */ xe.createElement(Zt, ce({}, t))), _r;
  }
  function Se(Zt) {
    var er = Zt.target.value, _r = Gl(void 0, se, m), Sn;
    return er === "" ? Sn = er : Number.isNaN(Number(er)) ? Sn = q : er >= _r ? Sn = _r : Sn = Number(er), Sn;
  }
  function Ee(Zt) {
    return x4(Zt) && Zt !== me && x4(m) && m > 0;
  }
  var Te = m > se ? w : !1;
  function Le(Zt) {
    (Zt.keyCode === Mt.UP || Zt.keyCode === Mt.DOWN) && Zt.preventDefault();
  }
  function Ie(Zt) {
    var er = Se(Zt);
    switch (er !== q && Y(er), Zt.keyCode) {
      case Mt.ENTER:
        Fe(er);
        break;
      case Mt.UP:
        Fe(er - 1);
        break;
      case Mt.DOWN:
        Fe(er + 1);
        break;
    }
  }
  function De(Zt) {
    Fe(Se(Zt));
  }
  function Ae(Zt) {
    var er = Gl(Zt, se, m), _r = me > er && er !== 0 ? er : me;
    Q(Zt), Y(_r), D?.(me, Zt), k(_r), x?.(_r, Zt);
  }
  function Fe(Zt) {
    if (Ee(Zt) && !j) {
      var er = Gl(void 0, se, m), _r = Zt;
      return Zt > er ? _r = er : Zt < 1 && (_r = 1), _r !== q && Y(_r), k(_r), x?.(_r, se), _r;
    }
    return me;
  }
  var Ne = me > 1, qe = me < Gl(void 0, se, m), Qe = G ?? m > F;
  function tt() {
    Ne && Fe(me - 1);
  }
  function Ge() {
    qe && Fe(me + 1);
  }
  function it() {
    Fe($e);
  }
  function ht() {
    Fe(J);
  }
  function It(Zt, er) {
    if (Zt.key === "Enter" || Zt.charCode === Mt.ENTER || Zt.keyCode === Mt.ENTER) {
      for (var _r = arguments.length, Sn = new Array(_r > 2 ? _r - 2 : 0), On = 2; On < _r; On++)
        Sn[On - 2] = arguments[On];
      er.apply(void 0, Sn);
    }
  }
  function xt(Zt) {
    It(Zt, tt);
  }
  function Xe(Zt) {
    It(Zt, Ge);
  }
  function pt(Zt) {
    It(Zt, it);
  }
  function Ze(Zt) {
    It(Zt, ht);
  }
  function wt(Zt) {
    var er = Z(Zt, "prev", de(ue, "prev page"));
    return /* @__PURE__ */ xe.isValidElement(er) ? /* @__PURE__ */ xe.cloneElement(er, {
      disabled: !Ne
    }) : er;
  }
  function bt(Zt) {
    var er = Z(Zt, "next", de(re, "next page"));
    return /* @__PURE__ */ xe.isValidElement(er) ? /* @__PURE__ */ xe.cloneElement(er, {
      disabled: !qe
    }) : er;
  }
  function Je(Zt) {
    (Zt.type === "click" || Zt.keyCode === Mt.ENTER) && Fe(q);
  }
  var _t = null, Vt = aa(t, {
    aria: !0,
    data: !0
  }), ot = U && /* @__PURE__ */ xe.createElement("li", {
    className: "".concat(a, "-total-text")
  }, U(m, [m === 0 ? 0 : (me - 1) * se + 1, me * se > m ? m : me * se])), Ct = null, rt = Gl(void 0, se, m);
  if (b && m <= se)
    return null;
  var $t = [], Wt = {
    rootPrefixCls: a,
    onClick: Fe,
    onKeyPress: It,
    showTitle: I,
    itemRender: Z,
    page: -1
  }, _e = me - 1 > 0 ? me - 1 : 0, Ke = me + 1 < rt ? me + 1 : rt, nt = w && w.goButton, Ve = nt, ke = null;
  H && (nt && (typeof nt == "boolean" ? Ve = /* @__PURE__ */ xe.createElement("button", {
    type: "button",
    onClick: Je,
    onKeyUp: Je
  }, L.jump_to_confirm) : Ve = /* @__PURE__ */ xe.createElement("span", {
    onClick: Je,
    onKeyUp: Je
  }, nt), Ve = /* @__PURE__ */ xe.createElement("li", {
    title: I ? "".concat(L.jump_to).concat(me, "/").concat(rt) : null,
    className: "".concat(a, "-simple-pager")
  }, Ve)), ke = /* @__PURE__ */ xe.createElement("li", {
    title: I ? "".concat(me, "/").concat(rt) : null,
    className: "".concat(a, "-simple-pager")
  }, /* @__PURE__ */ xe.createElement("input", {
    type: "text",
    value: q,
    disabled: j,
    onKeyDown: Le,
    onKeyUp: Ie,
    onChange: Ie,
    onBlur: De,
    size: 3
  }), /* @__PURE__ */ xe.createElement("span", {
    className: "".concat(a, "-slash")
  }, "/"), rt));
  var ut = O ? 1 : 2;
  if (rt <= 3 + ut * 2) {
    rt || $t.push(/* @__PURE__ */ xe.createElement(qu, Pe({}, Wt, {
      key: "noPager",
      page: 1,
      className: "".concat(a, "-item-disabled")
    })));
    for (var st = 1; st <= rt; st += 1)
      $t.push(/* @__PURE__ */ xe.createElement(qu, Pe({}, Wt, {
        key: st,
        page: st,
        active: me === st
      })));
  } else {
    var Et = O ? L.prev_3 : L.prev_5, zt = O ? L.next_3 : L.next_5, Be = Z($e, "jump-prev", de(ee, "prev page")), ft = Z(J, "jump-next", de(ae, "next page"));
    $ && (_t = Be ? /* @__PURE__ */ xe.createElement("li", {
      title: I ? Et : null,
      key: "prev",
      onClick: it,
      tabIndex: 0,
      onKeyDown: pt,
      className: be("".concat(a, "-jump-prev"), te({}, "".concat(a, "-jump-prev-custom-icon"), !!ee))
    }, Be) : null, Ct = ft ? /* @__PURE__ */ xe.createElement("li", {
      title: I ? zt : null,
      key: "next",
      onClick: ht,
      tabIndex: 0,
      onKeyDown: Ze,
      className: be("".concat(a, "-jump-next"), te({}, "".concat(a, "-jump-next-custom-icon"), !!ae))
    }, ft) : null);
    var yt = Math.max(1, me - ut), Rt = Math.min(me + ut, rt);
    me - 1 <= ut && (Rt = 1 + ut * 2), rt - me <= ut && (yt = rt - ut * 2);
    for (var Ht = yt; Ht <= Rt; Ht += 1)
      $t.push(/* @__PURE__ */ xe.createElement(qu, Pe({}, Wt, {
        key: Ht,
        page: Ht,
        active: me === Ht
      })));
    if (me - 1 >= ut * 2 && me !== 3 && ($t[0] = /* @__PURE__ */ xe.cloneElement($t[0], {
      className: be("".concat(a, "-item-after-jump-prev"), $t[0].props.className)
    }), $t.unshift(_t)), rt - me >= ut * 2 && me !== rt - 2) {
      var ir = $t[$t.length - 1];
      $t[$t.length - 1] = /* @__PURE__ */ xe.cloneElement(ir, {
        className: be("".concat(a, "-item-before-jump-next"), ir.props.className)
      }), $t.push(Ct);
    }
    yt !== 1 && $t.unshift(/* @__PURE__ */ xe.createElement(qu, Pe({}, Wt, {
      key: 1,
      page: 1
    }))), Rt !== rt && $t.push(/* @__PURE__ */ xe.createElement(qu, Pe({}, Wt, {
      key: rt,
      page: rt
    })));
  }
  var ar = wt(_e);
  if (ar) {
    var Nr = !Ne || !rt;
    ar = /* @__PURE__ */ xe.createElement("li", {
      title: I ? L.prev_page : null,
      onClick: tt,
      tabIndex: Nr ? null : 0,
      onKeyDown: xt,
      className: be("".concat(a, "-prev"), te({}, "".concat(a, "-disabled"), Nr)),
      "aria-disabled": Nr
    }, ar);
  }
  var Xr = bt(Ke);
  if (Xr) {
    var Qr, Ur;
    H ? (Qr = !qe, Ur = Ne ? 0 : null) : (Qr = !qe || !rt, Ur = Qr ? null : 0), Xr = /* @__PURE__ */ xe.createElement("li", {
      title: I ? L.next_page : null,
      onClick: Ge,
      tabIndex: Ur,
      onKeyDown: Xe,
      className: be("".concat(a, "-next"), te({}, "".concat(a, "-disabled"), Qr)),
      "aria-disabled": Qr
    }, Xr);
  }
  var gn = be(a, s, (r = {}, te(r, "".concat(a, "-simple"), H), te(r, "".concat(a, "-disabled"), j), r));
  return /* @__PURE__ */ xe.createElement("ul", Pe({
    className: gn,
    style: N,
    ref: oe
  }, Vt), ot, ar, H ? ke : $t, Xr, /* @__PURE__ */ xe.createElement(NU, {
    locale: L,
    rootPrefixCls: a,
    disabled: j,
    selectComponentClass: l,
    selectPrefixCls: o,
    changeSize: Qe ? Ae : null,
    pageSize: se,
    pageSizeOptions: V,
    quickGo: Te ? Fe : null,
    goButton: Ve
  }));
};
process.env.NODE_ENV !== "production" && (DU.displayName = "Pagination");
const jU = (e) => /* @__PURE__ */ p.createElement(Kn, Object.assign({}, e, {
  showSearch: !0,
  size: "small"
})), LU = (e) => /* @__PURE__ */ p.createElement(Kn, Object.assign({}, e, {
  showSearch: !0,
  size: "middle"
}));
jU.Option = Kn.Option;
LU.Option = Kn.Option;
const X_e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-disabled`]: {
      "&, &:hover": {
        cursor: "not-allowed",
        [`${t}-item-link`]: {
          color: e.colorTextDisabled,
          cursor: "not-allowed"
        }
      },
      "&:focus-visible": {
        cursor: "not-allowed",
        [`${t}-item-link`]: {
          color: e.colorTextDisabled,
          cursor: "not-allowed"
        }
      }
    },
    [`&${t}-disabled`]: {
      cursor: "not-allowed",
      [`${t}-item`]: {
        cursor: "not-allowed",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        a: {
          color: e.colorTextDisabled,
          backgroundColor: "transparent",
          border: "none",
          cursor: "not-allowed"
        },
        "&-active": {
          borderColor: e.colorBorder,
          backgroundColor: e.itemActiveBgDisabled,
          "&:hover, &:active": {
            backgroundColor: e.itemActiveBgDisabled
          },
          a: {
            color: e.itemActiveColorDisabled
          }
        }
      },
      [`${t}-item-link`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        [`${t}-simple&`]: {
          backgroundColor: "transparent",
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      },
      [`${t}-simple-pager`]: {
        color: e.colorTextDisabled
      },
      [`${t}-jump-prev, ${t}-jump-next`]: {
        [`${t}-item-link-icon`]: {
          opacity: 0
        },
        [`${t}-item-ellipsis`]: {
          opacity: 1
        }
      }
    },
    [`&${t}-simple`]: {
      [`${t}-prev, ${t}-next`]: {
        [`&${t}-disabled ${t}-item-link`]: {
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      }
    }
  };
}, J_e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`&${t}-mini ${t}-total-text, &${t}-mini ${t}-simple-pager`]: {
      height: e.itemSizeSM,
      lineHeight: ve(e.itemSizeSM)
    },
    [`&${t}-mini ${t}-item`]: {
      minWidth: e.itemSizeSM,
      height: e.itemSizeSM,
      margin: 0,
      lineHeight: ve(e.calc(e.itemSizeSM).sub(2).equal())
    },
    [`&${t}-mini:not(${t}-disabled) ${t}-item:not(${t}-item-active)`]: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      "&:hover": {
        backgroundColor: e.colorBgTextHover
      },
      "&:active": {
        backgroundColor: e.colorBgTextActive
      }
    },
    [`&${t}-mini ${t}-prev, &${t}-mini ${t}-next`]: {
      minWidth: e.itemSizeSM,
      height: e.itemSizeSM,
      margin: 0,
      lineHeight: ve(e.itemSizeSM)
    },
    [`&${t}-mini:not(${t}-disabled)`]: {
      [`${t}-prev, ${t}-next`]: {
        [`&:hover ${t}-item-link`]: {
          backgroundColor: e.colorBgTextHover
        },
        [`&:active ${t}-item-link`]: {
          backgroundColor: e.colorBgTextActive
        },
        [`&${t}-disabled:hover ${t}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`
    &${t}-mini ${t}-prev ${t}-item-link,
    &${t}-mini ${t}-next ${t}-item-link
    `]: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      "&::after": {
        height: e.itemSizeSM,
        lineHeight: ve(e.itemSizeSM)
      }
    },
    [`&${t}-mini ${t}-jump-prev, &${t}-mini ${t}-jump-next`]: {
      height: e.itemSizeSM,
      marginInlineEnd: 0,
      lineHeight: ve(e.itemSizeSM)
    },
    [`&${t}-mini ${t}-options`]: {
      marginInlineStart: e.paginationMiniOptionsMarginInlineStart,
      "&-size-changer": {
        top: e.miniOptionsSizeChangerTop
      },
      "&-quick-jumper": {
        height: e.itemSizeSM,
        lineHeight: ve(e.itemSizeSM),
        input: Object.assign(Object.assign({}, _I(e)), {
          width: e.paginationMiniQuickJumperInputWidth,
          height: e.controlHeightSM
        })
      }
    }
  };
}, Q_e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`
    &${t}-simple ${t}-prev,
    &${t}-simple ${t}-next
    `]: {
      height: e.itemSizeSM,
      lineHeight: ve(e.itemSizeSM),
      verticalAlign: "top",
      [`${t}-item-link`]: {
        height: e.itemSizeSM,
        backgroundColor: "transparent",
        border: 0,
        "&:hover": {
          backgroundColor: e.colorBgTextHover
        },
        "&:active": {
          backgroundColor: e.colorBgTextActive
        },
        "&::after": {
          height: e.itemSizeSM,
          lineHeight: ve(e.itemSizeSM)
        }
      }
    },
    [`&${t}-simple ${t}-simple-pager`]: {
      display: "inline-block",
      height: e.itemSizeSM,
      marginInlineEnd: e.marginXS,
      input: {
        boxSizing: "border-box",
        height: "100%",
        marginInlineEnd: e.marginXS,
        padding: `0 ${ve(e.paginationItemPaddingInline)}`,
        textAlign: "center",
        backgroundColor: e.itemInputBg,
        border: `${ve(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
        borderRadius: e.borderRadius,
        outline: "none",
        transition: `border-color ${e.motionDurationMid}`,
        color: "inherit",
        "&:hover": {
          borderColor: e.colorPrimary
        },
        "&:focus": {
          borderColor: e.colorPrimaryHover,
          boxShadow: `${ve(e.inputOutlineOffset)} 0 ${ve(e.controlOutlineWidth)} ${e.controlOutline}`
        },
        "&[disabled]": {
          color: e.colorTextDisabled,
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          cursor: "not-allowed"
        }
      }
    }
  };
}, e2e = (e) => {
  const {
    componentCls: t,
    antCls: r
  } = e;
  return {
    [`${t}-jump-prev, ${t}-jump-next`]: {
      outline: 0,
      [`${t}-item-container`]: {
        position: "relative",
        [`${t}-item-link-icon`]: {
          color: e.colorPrimary,
          fontSize: e.fontSizeSM,
          opacity: 0,
          transition: `all ${e.motionDurationMid}`,
          "&-svg": {
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            margin: "auto"
          }
        },
        [`${t}-item-ellipsis`]: {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          display: "block",
          margin: "auto",
          color: e.colorTextDisabled,
          fontFamily: "Arial, Helvetica, sans-serif",
          letterSpacing: e.paginationEllipsisLetterSpacing,
          textAlign: "center",
          textIndent: e.paginationEllipsisTextIndent,
          opacity: 1,
          transition: `all ${e.motionDurationMid}`
        }
      },
      "&:hover": {
        [`${t}-item-link-icon`]: {
          opacity: 1
        },
        [`${t}-item-ellipsis`]: {
          opacity: 0
        }
      }
    },
    [`
    ${t}-prev,
    ${t}-jump-prev,
    ${t}-jump-next
    `]: {
      marginInlineEnd: e.marginXS
    },
    [`
    ${t}-prev,
    ${t}-next,
    ${t}-jump-prev,
    ${t}-jump-next
    `]: {
      display: "inline-block",
      minWidth: e.itemSize,
      height: e.itemSize,
      color: e.colorText,
      fontFamily: e.fontFamily,
      lineHeight: `${ve(e.itemSize)}`,
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      borderRadius: e.borderRadius,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid}`
    },
    [`${t}-prev, ${t}-next`]: {
      fontFamily: "Arial, Helvetica, sans-serif",
      outline: 0,
      button: {
        color: e.colorText,
        cursor: "pointer",
        userSelect: "none"
      },
      [`${t}-item-link`]: {
        display: "block",
        width: "100%",
        height: "100%",
        padding: 0,
        fontSize: e.fontSizeSM,
        textAlign: "center",
        backgroundColor: "transparent",
        border: `${ve(e.lineWidth)} ${e.lineType} transparent`,
        borderRadius: e.borderRadius,
        outline: "none",
        transition: `all ${e.motionDurationMid}`
      },
      [`&:hover ${t}-item-link`]: {
        backgroundColor: e.colorBgTextHover
      },
      [`&:active ${t}-item-link`]: {
        backgroundColor: e.colorBgTextActive
      },
      [`&${t}-disabled:hover`]: {
        [`${t}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`${t}-slash`]: {
      marginInlineEnd: e.paginationSlashMarginInlineEnd,
      marginInlineStart: e.paginationSlashMarginInlineStart
    },
    [`${t}-options`]: {
      display: "inline-block",
      marginInlineStart: e.margin,
      verticalAlign: "middle",
      "&-size-changer": {
        display: "inline-block",
        width: "auto",
        // https://github.com/ant-design/ant-design/issues/49258
        [`${r}-select-arrow:not(:last-child)`]: {
          opacity: 1
        }
      },
      "&-quick-jumper": {
        display: "inline-block",
        height: e.controlHeight,
        marginInlineStart: e.marginXS,
        lineHeight: ve(e.controlHeight),
        verticalAlign: "top",
        input: Object.assign(Object.assign(Object.assign({}, $h(e)), bI(e, {
          borderColor: e.colorBorder,
          hoverBorderColor: e.colorPrimaryHover,
          activeBorderColor: e.colorPrimary,
          activeShadow: e.activeShadow
        })), {
          "&[disabled]": Object.assign({}, q1(e)),
          width: e.calc(e.controlHeightLG).mul(1.25).equal(),
          height: e.controlHeight,
          boxSizing: "border-box",
          margin: 0,
          marginInlineStart: e.marginXS,
          marginInlineEnd: e.marginXS
        })
      }
    }
  };
}, t2e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-item`]: {
      display: "inline-block",
      minWidth: e.itemSize,
      height: e.itemSize,
      marginInlineEnd: e.marginXS,
      fontFamily: e.fontFamily,
      lineHeight: ve(e.calc(e.itemSize).sub(2).equal()),
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      backgroundColor: "transparent",
      border: `${ve(e.lineWidth)} ${e.lineType} transparent`,
      borderRadius: e.borderRadius,
      outline: 0,
      cursor: "pointer",
      userSelect: "none",
      a: {
        display: "block",
        padding: `0 ${ve(e.paginationItemPaddingInline)}`,
        color: e.colorText,
        "&:hover": {
          textDecoration: "none"
        }
      },
      [`&:not(${t}-item-active)`]: {
        "&:hover": {
          transition: `all ${e.motionDurationMid}`,
          backgroundColor: e.colorBgTextHover
        },
        "&:active": {
          backgroundColor: e.colorBgTextActive
        }
      },
      "&-active": {
        fontWeight: e.fontWeightStrong,
        backgroundColor: e.itemActiveBg,
        borderColor: e.colorPrimary,
        a: {
          color: e.colorPrimary
        },
        "&:hover": {
          borderColor: e.colorPrimaryHover
        },
        "&:hover a": {
          color: e.colorPrimaryHover
        }
      }
    }
  };
}, r2e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Yr(e)), {
      "ul, ol": {
        margin: 0,
        padding: 0,
        listStyle: "none"
      },
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        overflow: "hidden",
        visibility: "hidden",
        content: '""'
      },
      [`${t}-total-text`]: {
        display: "inline-block",
        height: e.itemSize,
        marginInlineEnd: e.marginXS,
        lineHeight: ve(e.calc(e.itemSize).sub(2).equal()),
        verticalAlign: "middle"
      }
    }), t2e(e)), e2e(e)), Q_e(e)), J_e(e)), X_e(e)), {
      // media query style
      [`@media only screen and (max-width: ${e.screenLG}px)`]: {
        [`${t}-item`]: {
          "&-after-jump-prev, &-before-jump-next": {
            display: "none"
          }
        }
      },
      [`@media only screen and (max-width: ${e.screenSM}px)`]: {
        [`${t}-options`]: {
          display: "none"
        }
      }
    }),
    // rtl style
    [`&${e.componentCls}-rtl`]: {
      direction: "rtl"
    }
  };
}, n2e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}:not(${t}-disabled)`]: {
      [`${t}-item`]: Object.assign({}, zs(e)),
      [`${t}-jump-prev, ${t}-jump-next`]: {
        "&:focus-visible": Object.assign({
          [`${t}-item-link-icon`]: {
            opacity: 1
          },
          [`${t}-item-ellipsis`]: {
            opacity: 0
          }
        }, Sl(e))
      },
      [`${t}-prev, ${t}-next`]: {
        [`&:focus-visible ${t}-item-link`]: Object.assign({}, Sl(e))
      }
    }
  };
}, kU = (e) => Object.assign({
  itemBg: e.colorBgContainer,
  itemSize: e.controlHeight,
  itemSizeSM: e.controlHeightSM,
  itemActiveBg: e.colorBgContainer,
  itemLinkBg: e.colorBgContainer,
  itemActiveColorDisabled: e.colorTextDisabled,
  itemActiveBgDisabled: e.controlItemBgActiveDisabled,
  itemInputBg: e.colorBgContainer,
  miniOptionsSizeChangerTop: 0
}, xh(e)), FU = (e) => $r(e, {
  inputOutlineOffset: 0,
  paginationMiniOptionsMarginInlineStart: e.calc(e.marginXXS).div(2).equal(),
  paginationMiniQuickJumperInputWidth: e.calc(e.controlHeightLG).mul(1.1).equal(),
  paginationItemPaddingInline: e.calc(e.marginXXS).mul(1.5).equal(),
  paginationEllipsisLetterSpacing: e.calc(e.marginXXS).div(2).equal(),
  paginationSlashMarginInlineStart: e.marginXXS,
  paginationSlashMarginInlineEnd: e.marginSM,
  paginationEllipsisTextIndent: "0.13em"
  // magic for ui experience
}, Sh(e)), a2e = Zr("Pagination", (e) => {
  const t = FU(e);
  return [r2e(t), n2e(t)];
}, kU), i2e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}${t}-bordered${t}-disabled:not(${t}-mini)`]: {
      "&, &:hover": {
        [`${t}-item-link`]: {
          borderColor: e.colorBorder
        }
      },
      "&:focus-visible": {
        [`${t}-item-link`]: {
          borderColor: e.colorBorder
        }
      },
      [`${t}-item, ${t}-item-link`]: {
        backgroundColor: e.colorBgContainerDisabled,
        borderColor: e.colorBorder,
        [`&:hover:not(${t}-item-active)`]: {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          a: {
            color: e.colorTextDisabled
          }
        },
        [`&${t}-item-active`]: {
          backgroundColor: e.itemActiveBgDisabled
        }
      },
      [`${t}-prev, ${t}-next`]: {
        "&:hover button": {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          color: e.colorTextDisabled
        },
        [`${t}-item-link`]: {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder
        }
      }
    },
    [`${t}${t}-bordered:not(${t}-mini)`]: {
      [`${t}-prev, ${t}-next`]: {
        "&:hover button": {
          borderColor: e.colorPrimaryHover,
          backgroundColor: e.itemBg
        },
        [`${t}-item-link`]: {
          backgroundColor: e.itemLinkBg,
          borderColor: e.colorBorder
        },
        [`&:hover ${t}-item-link`]: {
          borderColor: e.colorPrimary,
          backgroundColor: e.itemBg,
          color: e.colorPrimary
        },
        [`&${t}-disabled`]: {
          [`${t}-item-link`]: {
            borderColor: e.colorBorder,
            color: e.colorTextDisabled
          }
        }
      },
      [`${t}-item`]: {
        backgroundColor: e.itemBg,
        border: `${ve(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
        [`&:hover:not(${t}-item-active)`]: {
          borderColor: e.colorPrimary,
          backgroundColor: e.itemBg,
          a: {
            color: e.colorPrimary
          }
        },
        "&-active": {
          borderColor: e.colorPrimary
        }
      }
    }
  };
}, o2e = vd(["Pagination", "bordered"], (e) => {
  const t = FU(e);
  return [i2e(t)];
}, kU);
var s2e = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const HI = (e) => {
  const {
    prefixCls: t,
    selectPrefixCls: r,
    className: n,
    rootClassName: a,
    style: i,
    size: o,
    locale: s,
    selectComponentClass: l,
    responsive: c,
    showSizeChanger: u
  } = e, d = s2e(e, ["prefixCls", "selectPrefixCls", "className", "rootClassName", "style", "size", "locale", "selectComponentClass", "responsive", "showSizeChanger"]), {
    xs: f
  } = qH(c), [, m] = ua(), {
    getPrefixCls: h,
    direction: g,
    pagination: y = {}
  } = p.useContext(Lt), S = h("pagination", t), [x, b, _] = a2e(S), $ = u ?? y.showSizeChanger, w = p.useMemo(() => {
    const N = /* @__PURE__ */ p.createElement("span", {
      className: `${S}-item-ellipsis`
    }, "•••"), z = /* @__PURE__ */ p.createElement("button", {
      className: `${S}-item-link`,
      type: "button",
      tabIndex: -1
    }, g === "rtl" ? /* @__PURE__ */ p.createElement(_c, null) : /* @__PURE__ */ p.createElement(cd, null)), F = /* @__PURE__ */ p.createElement("button", {
      className: `${S}-item-link`,
      type: "button",
      tabIndex: -1
    }, g === "rtl" ? /* @__PURE__ */ p.createElement(cd, null) : /* @__PURE__ */ p.createElement(_c, null)), j = /* @__PURE__ */ p.createElement("a", {
      className: `${S}-item-link`
    }, /* @__PURE__ */ p.createElement("div", {
      className: `${S}-item-container`
    }, g === "rtl" ? /* @__PURE__ */ p.createElement(pE, {
      className: `${S}-item-link-icon`
    }) : /* @__PURE__ */ p.createElement(fE, {
      className: `${S}-item-link-icon`
    }), N)), H = /* @__PURE__ */ p.createElement("a", {
      className: `${S}-item-link`
    }, /* @__PURE__ */ p.createElement("div", {
      className: `${S}-item-container`
    }, g === "rtl" ? /* @__PURE__ */ p.createElement(fE, {
      className: `${S}-item-link-icon`
    }) : /* @__PURE__ */ p.createElement(pE, {
      className: `${S}-item-link-icon`
    }), N));
    return {
      prevIcon: z,
      nextIcon: F,
      jumpPrevIcon: j,
      jumpNextIcon: H
    };
  }, [g, S]), [O] = Ks("Pagination", yB), T = Object.assign(Object.assign({}, O), s), I = Xa(o), P = I === "small" || !!(f && !I && c), D = h("select", r), B = be({
    [`${S}-mini`]: P,
    [`${S}-rtl`]: g === "rtl",
    [`${S}-bordered`]: m.wireframe
  }, y?.className, n, a, b, _), L = Object.assign(Object.assign({}, y?.style), i);
  return x(/* @__PURE__ */ p.createElement(p.Fragment, null, m.wireframe && /* @__PURE__ */ p.createElement(o2e, {
    prefixCls: S
  }), /* @__PURE__ */ p.createElement(DU, Object.assign({}, w, d, {
    style: L,
    prefixCls: S,
    selectPrefixCls: D,
    className: B,
    selectComponentClass: l || (P ? jU : LU),
    locale: T,
    showSizeChanger: $
  }))));
};
process.env.NODE_ENV !== "production" && (HI.displayName = "Pagination");
function l2e(e) {
  let {
    percent: t,
    prefixCls: r
  } = e;
  const n = `${r}-dot`, a = `${n}-holder`, i = `${a}-hidden`, [o, s] = p.useState(!1);
  hr(() => {
    t !== 0 && s(!0);
  }, [t !== 0]);
  const l = Math.max(Math.min(t, 100), 0), c = 100, u = c / 5, d = c / 2 - u / 2, f = d * 2 * Math.PI, m = (h, g) => /* @__PURE__ */ p.createElement("circle", {
    className: be(h, `${n}-circle`),
    r: d,
    cx: "50",
    cy: "50",
    strokeWidth: u,
    style: g
  });
  return o ? /* @__PURE__ */ p.createElement("span", {
    className: be(a, `${n}-progress`, l <= 0 && i)
  }, /* @__PURE__ */ p.createElement("svg", {
    viewBox: `0 0 ${c} ${c}`,
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": l
  }, m(`${n}-circle-bg`), m("", {
    strokeDasharray: `${f * l / 100} ${f * (100 - l) / 100}`,
    strokeDashoffset: `${f / 4}`
  }))) : null;
}
function c2e(e) {
  const {
    prefixCls: t,
    percent: r = 0
  } = e, n = `${t}-dot`, a = `${n}-holder`, i = `${a}-hidden`;
  return /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement("span", {
    className: be(a, r > 0 && i)
  }, /* @__PURE__ */ p.createElement("span", {
    className: be(n, `${t}-dot-spin`)
  }, [1, 2, 3, 4].map((o) => /* @__PURE__ */ p.createElement("i", {
    className: `${t}-dot-item`,
    key: o
  })))), /* @__PURE__ */ p.createElement(l2e, {
    prefixCls: t,
    percent: r
  }));
}
function u2e(e) {
  const {
    prefixCls: t,
    indicator: r,
    percent: n
  } = e, a = `${t}-dot`;
  return r && /* @__PURE__ */ p.isValidElement(r) ? Si(r, {
    className: be(r.props.className, a),
    percent: n
  }) : /* @__PURE__ */ p.createElement(c2e, {
    prefixCls: t,
    percent: n
  });
}
const d2e = new Pr("antSpinMove", {
  to: {
    opacity: 1
  }
}), f2e = new Pr("antRotate", {
  to: {
    transform: "rotate(405deg)"
  }
}), p2e = (e) => {
  const {
    componentCls: t,
    calc: r
  } = e;
  return {
    [`${t}`]: Object.assign(Object.assign({}, Yr(e)), {
      position: "absolute",
      display: "none",
      color: e.colorPrimary,
      fontSize: 0,
      textAlign: "center",
      verticalAlign: "middle",
      opacity: 0,
      transition: `transform ${e.motionDurationSlow} ${e.motionEaseInOutCirc}`,
      "&-spinning": {
        position: "relative",
        display: "inline-block",
        opacity: 1
      },
      [`${t}-text`]: {
        fontSize: e.fontSize,
        paddingTop: r(r(e.dotSize).sub(e.fontSize)).div(2).add(2).equal()
      },
      "&-fullscreen": {
        position: "fixed",
        width: "100vw",
        height: "100vh",
        backgroundColor: e.colorBgMask,
        zIndex: e.zIndexPopupBase,
        inset: 0,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        opacity: 0,
        visibility: "hidden",
        transition: `all ${e.motionDurationMid}`,
        "&-show": {
          opacity: 1,
          visibility: "visible"
        },
        [t]: {
          [`${t}-dot-holder`]: {
            color: e.colorWhite
          },
          [`${t}-text`]: {
            color: e.colorTextLightSolid
          }
        }
      },
      "&-nested-loading": {
        position: "relative",
        [`> div > ${t}`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          zIndex: 4,
          display: "block",
          width: "100%",
          height: "100%",
          maxHeight: e.contentHeight,
          [`${t}-dot`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: "50%",
            margin: r(e.dotSize).mul(-1).div(2).equal()
          },
          [`${t}-text`]: {
            position: "absolute",
            top: "50%",
            width: "100%",
            textShadow: `0 1px 2px ${e.colorBgContainer}`
            // FIXME: shadow
          },
          [`&${t}-show-text ${t}-dot`]: {
            marginTop: r(e.dotSize).div(2).mul(-1).sub(10).equal()
          },
          "&-sm": {
            [`${t}-dot`]: {
              margin: r(e.dotSizeSM).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: r(r(e.dotSizeSM).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: r(e.dotSizeSM).div(2).mul(-1).sub(10).equal()
            }
          },
          "&-lg": {
            [`${t}-dot`]: {
              margin: r(e.dotSizeLG).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: r(r(e.dotSizeLG).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: r(e.dotSizeLG).div(2).mul(-1).sub(10).equal()
            }
          }
        },
        [`${t}-container`]: {
          position: "relative",
          transition: `opacity ${e.motionDurationSlow}`,
          "&::after": {
            position: "absolute",
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            zIndex: 10,
            width: "100%",
            height: "100%",
            background: e.colorBgContainer,
            opacity: 0,
            transition: `all ${e.motionDurationSlow}`,
            content: '""',
            pointerEvents: "none"
          }
        },
        [`${t}-blur`]: {
          clear: "both",
          opacity: 0.5,
          userSelect: "none",
          pointerEvents: "none",
          "&::after": {
            opacity: 0.4,
            pointerEvents: "auto"
          }
        }
      },
      // tip
      // ------------------------------
      "&-tip": {
        color: e.spinDotDefault
      },
      // holder
      // ------------------------------
      [`${t}-dot-progress`]: {
        position: "absolute",
        top: 0,
        insetInlineStart: 0
      },
      [`${t}-dot-holder`]: {
        width: "1em",
        height: "1em",
        fontSize: e.dotSize,
        display: "inline-block",
        transition: `transform ${e.motionDurationSlow} ease, opacity ${e.motionDurationSlow} ease`,
        transformOrigin: "50% 50%",
        lineHeight: 1,
        color: e.colorPrimary,
        "&-hidden": {
          transform: "scale(0.3)",
          opacity: 0
        }
      },
      // progress
      // ------------------------------
      [`${t}-dot-progress`]: {
        position: "absolute",
        top: 0,
        insetInlineStart: 0
      },
      // dots
      // ------------------------------
      [`${t}-dot`]: {
        position: "relative",
        display: "inline-block",
        fontSize: e.dotSize,
        width: "1em",
        height: "1em",
        "&-item": {
          position: "absolute",
          display: "block",
          width: r(e.dotSize).sub(r(e.marginXXS).div(2)).div(2).equal(),
          height: r(e.dotSize).sub(r(e.marginXXS).div(2)).div(2).equal(),
          background: "currentColor",
          borderRadius: "100%",
          transform: "scale(0.75)",
          transformOrigin: "50% 50%",
          opacity: 0.3,
          animationName: d2e,
          animationDuration: "1s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear",
          animationDirection: "alternate",
          "&:nth-child(1)": {
            top: 0,
            insetInlineStart: 0,
            animationDelay: "0s"
          },
          "&:nth-child(2)": {
            top: 0,
            insetInlineEnd: 0,
            animationDelay: "0.4s"
          },
          "&:nth-child(3)": {
            insetInlineEnd: 0,
            bottom: 0,
            animationDelay: "0.8s"
          },
          "&:nth-child(4)": {
            bottom: 0,
            insetInlineStart: 0,
            animationDelay: "1.2s"
          }
        },
        "&-spin": {
          transform: "rotate(45deg)",
          animationName: f2e,
          animationDuration: "1.2s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear"
        },
        "&-circle": {
          strokeLinecap: "round",
          transition: ["stroke-dashoffset", "stroke-dasharray", "stroke", "stroke-width", "opacity"].map((n) => `${n} ${e.motionDurationSlow} ease`).join(","),
          fillOpacity: 0,
          stroke: "currentcolor"
        },
        "&-circle-bg": {
          stroke: e.colorFillSecondary
        }
      },
      // small
      [`&-sm ${t}-dot`]: {
        fontSize: e.dotSizeSM
      },
      [`&-sm ${t}-dot-holder`]: {
        i: {
          width: r(r(e.dotSizeSM).sub(r(e.marginXXS).div(2))).div(2).equal(),
          height: r(r(e.dotSizeSM).sub(r(e.marginXXS).div(2))).div(2).equal()
        }
      },
      // large
      [`&-lg ${t}-dot`]: {
        fontSize: e.dotSizeLG
      },
      [`&-lg ${t}-dot-holder`]: {
        i: {
          width: r(r(e.dotSizeLG).sub(e.marginXXS)).div(2).equal(),
          height: r(r(e.dotSizeLG).sub(e.marginXXS)).div(2).equal()
        }
      },
      [`&${t}-show-text ${t}-text`]: {
        display: "block"
      }
    })
  };
}, m2e = (e) => {
  const {
    controlHeightLG: t,
    controlHeight: r
  } = e;
  return {
    contentHeight: 400,
    dotSize: t / 2,
    dotSizeSM: t * 0.35,
    dotSizeLG: r
  };
}, v2e = Zr("Spin", (e) => {
  const t = $r(e, {
    spinDotDefault: e.colorTextDescription
  });
  return [p2e(t)];
}, m2e), h2e = 200, $4 = [[30, 0.05], [70, 0.03], [96, 0.01]];
function g2e(e, t) {
  const [r, n] = p.useState(0), a = p.useRef(), i = t === "auto";
  return p.useEffect(() => (i && e && (n(0), a.current = setInterval(() => {
    n((o) => {
      const s = 100 - o;
      for (let l = 0; l < $4.length; l += 1) {
        const [c, u] = $4[l];
        if (o <= c)
          return o + s * u;
      }
      return o;
    });
  }, h2e)), () => {
    clearInterval(a.current);
  }), [i, e]), i ? r : t;
}
var y2e = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
let BU;
function b2e(e, t) {
  return !!e && !!t && !isNaN(Number(t));
}
const Td = (e) => {
  const {
    prefixCls: t,
    spinning: r = !0,
    delay: n = 0,
    className: a,
    rootClassName: i,
    size: o = "default",
    tip: s,
    wrapperClassName: l,
    style: c,
    children: u,
    fullscreen: d = !1,
    indicator: f,
    percent: m
  } = e, h = y2e(e, ["prefixCls", "spinning", "delay", "className", "rootClassName", "size", "tip", "wrapperClassName", "style", "children", "fullscreen", "indicator", "percent"]), {
    getPrefixCls: g
  } = p.useContext(Lt), y = g("spin", t), [S, x, b] = v2e(y), [_, $] = p.useState(() => r && !b2e(r, n)), w = g2e(_, m);
  p.useEffect(() => {
    if (r) {
      const N = nSe(n, () => {
        $(!0);
      });
      return N(), () => {
        var z;
        (z = N?.cancel) === null || z === void 0 || z.call(N);
      };
    }
    $(!1);
  }, [n, r]);
  const O = p.useMemo(() => typeof u < "u" && !d, [u, d]);
  if (process.env.NODE_ENV !== "production") {
    const N = xr("Spin");
    process.env.NODE_ENV !== "production" && N(!s || O || d, "usage", "`tip` only work in nest or fullscreen pattern.");
  }
  const {
    direction: T,
    spin: I
  } = p.useContext(Lt), P = be(y, I?.className, {
    [`${y}-sm`]: o === "small",
    [`${y}-lg`]: o === "large",
    [`${y}-spinning`]: _,
    [`${y}-show-text`]: !!s,
    [`${y}-rtl`]: T === "rtl"
  }, a, !d && i, x, b), D = be(`${y}-container`, {
    [`${y}-blur`]: _
  }), B = Object.assign(Object.assign({}, I?.style), c), L = /* @__PURE__ */ p.createElement("div", Object.assign({}, h, {
    style: B,
    className: P,
    "aria-live": "polite",
    "aria-busy": _
  }), /* @__PURE__ */ p.createElement(u2e, {
    prefixCls: y,
    indicator: f ?? BU,
    percent: w
  }), s && (O || d) ? /* @__PURE__ */ p.createElement("div", {
    className: `${y}-text`
  }, s) : null);
  return S(O ? /* @__PURE__ */ p.createElement("div", Object.assign({}, h, {
    className: be(`${y}-nested-loading`, l, x, b)
  }), _ && /* @__PURE__ */ p.createElement("div", {
    key: "loading"
  }, L), /* @__PURE__ */ p.createElement("div", {
    className: D,
    key: "container"
  }, u)) : d ? /* @__PURE__ */ p.createElement("div", {
    className: be(`${y}-fullscreen`, {
      [`${y}-fullscreen-show`]: _
    }, i, x, b)
  }, L) : L);
};
Td.setDefaultIndicator = (e) => {
  BU = e;
};
process.env.NODE_ENV !== "production" && (Td.displayName = "Spin");
let oo = null, pc = (e) => e(), eh = [], th = {};
function _4() {
  const {
    getContainer: e,
    duration: t,
    rtl: r,
    maxCount: n,
    top: a
  } = th, i = e?.() || document.body;
  return {
    getContainer: () => i,
    duration: t,
    rtl: r,
    maxCount: n,
    top: a
  };
}
const C2e = /* @__PURE__ */ xe.forwardRef((e, t) => {
  const {
    messageConfig: r,
    sync: n
  } = e, {
    getPrefixCls: a
  } = Cr(Lt), i = th.prefixCls || a("message"), o = Cr(W2), [s, l] = hz(Object.assign(Object.assign(Object.assign({}, r), {
    prefixCls: i
  }), o.message));
  return xe.useImperativeHandle(t, () => {
    const c = Object.assign({}, s);
    return Object.keys(c).forEach((u) => {
      c[u] = function() {
        return n(), s[u].apply(s, arguments);
      };
    }), {
      instance: c,
      sync: n
    };
  }), l;
}), S2e = /* @__PURE__ */ xe.forwardRef((e, t) => {
  const [r, n] = xe.useState(_4), a = () => {
    n(_4);
  };
  xe.useEffect(a, []);
  const i = RT(), o = i.getRootPrefixCls(), s = i.getIconPrefixCls(), l = i.getTheme(), c = /* @__PURE__ */ xe.createElement(C2e, {
    ref: t,
    sync: a,
    messageConfig: r
  });
  return /* @__PURE__ */ xe.createElement(Fo, {
    prefixCls: o,
    iconPrefixCls: s,
    theme: l
  }, i.holderRender ? i.holderRender(c) : c);
});
function J1() {
  if (!oo) {
    const e = document.createDocumentFragment(), t = {
      fragment: e
    };
    oo = t, pc(() => {
      DT(/* @__PURE__ */ xe.createElement(S2e, {
        ref: (r) => {
          const {
            instance: n,
            sync: a
          } = r || {};
          Promise.resolve().then(() => {
            !t.instance && n && (t.instance = n, t.sync = a, J1());
          });
        }
      }), e);
    });
    return;
  }
  oo.instance && (eh.forEach((e) => {
    const {
      type: t,
      skipped: r
    } = e;
    if (!r)
      switch (t) {
        case "open": {
          pc(() => {
            const n = oo.instance.open(Object.assign(Object.assign({}, th), e.config));
            n?.then(e.resolve), e.setCloseFn(n);
          });
          break;
        }
        case "destroy":
          pc(() => {
            oo?.instance.destroy(e.key);
          });
          break;
        default:
          pc(() => {
            var n;
            const a = (n = oo.instance)[t].apply(n, ze(e.args));
            a?.then(e.resolve), e.setCloseFn(a);
          });
      }
  }), eh = []);
}
function x2e(e) {
  th = Object.assign(Object.assign({}, th), e), pc(() => {
    var t;
    (t = oo?.sync) === null || t === void 0 || t.call(oo);
  });
}
function $2e(e) {
  const t = NT((r) => {
    let n;
    const a = {
      type: "open",
      config: e,
      resolve: r,
      setCloseFn: (i) => {
        n = i;
      }
    };
    return eh.push(a), () => {
      n ? pc(() => {
        n();
      }) : a.skipped = !0;
    };
  });
  return J1(), t;
}
function _2e(e, t) {
  const r = RT();
  process.env.NODE_ENV !== "production" && !r.holderRender && ZB("message");
  const n = NT((a) => {
    let i;
    const o = {
      type: e,
      args: t,
      resolve: a,
      setCloseFn: (s) => {
        i = s;
      }
    };
    return eh.push(o), () => {
      i ? pc(() => {
        i();
      }) : o.skipped = !0;
    };
  });
  return J1(), n;
}
const E2e = (e) => {
  eh.push({
    type: "destroy",
    key: e
  }), J1();
}, w2e = ["success", "info", "warning", "error", "loading"], O2e = {
  open: $2e,
  destroy: E2e,
  config: x2e,
  useMessage: gz,
  _InternalPanelDoNotUseOrYouWillBeFired: Kfe
}, zU = O2e;
w2e.forEach((e) => {
  zU[e] = function() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    return _2e(e, r);
  };
});
process.env.NODE_ENV;
process.env.NODE_ENV;
var T2e = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const I2e = (e) => {
  const {
    prefixCls: t,
    className: r,
    closeIcon: n,
    closable: a,
    type: i,
    title: o,
    children: s,
    footer: l
  } = e, c = T2e(e, ["prefixCls", "className", "closeIcon", "closable", "type", "title", "children", "footer"]), {
    getPrefixCls: u
  } = p.useContext(Lt), d = u(), f = t || u("modal"), m = Mn(d), [h, g, y] = tH(f, m), S = `${f}-confirm`;
  let x = {};
  return i ? x = {
    closable: a ?? !1,
    title: "",
    footer: "",
    children: /* @__PURE__ */ p.createElement(nH, Object.assign({}, e, {
      prefixCls: f,
      confirmPrefixCls: S,
      rootPrefixCls: d,
      content: s
    }))
  } : x = {
    closable: a ?? !0,
    title: o,
    footer: l !== null && /* @__PURE__ */ p.createElement(Zz, Object.assign({}, e)),
    children: s
  }, h(/* @__PURE__ */ p.createElement(kT, Object.assign({
    prefixCls: f,
    className: be(g, `${f}-pure-panel`, i && S, i && `${S}-${i}`, r, y, m)
  }, c, {
    closeIcon: Yz(f, n),
    closable: a
  }, x)));
}, M2e = vH(I2e);
function HU(e) {
  return mh(sH(e));
}
const da = rH;
da.useModal = fH;
da.info = function(t) {
  return mh(lH(t));
};
da.success = function(t) {
  return mh(cH(t));
};
da.error = function(t) {
  return mh(uH(t));
};
da.warning = HU;
da.warn = HU;
da.confirm = function(t) {
  return mh(dH(t));
};
da.destroyAll = function() {
  for (; dc.length; ) {
    const t = dc.pop();
    t && t();
  }
};
da.config = d0e;
da._InternalPanelDoNotUseOrYouWillBeFired = M2e;
process.env.NODE_ENV !== "production" && (da.displayName = "Modal");
var es = {}, Th = "rc-table-internal-hook";
function VI(e) {
  var t = /* @__PURE__ */ p.createContext(void 0), r = function(a) {
    var i = a.value, o = a.children, s = p.useRef(i);
    s.current = i;
    var l = p.useState(function() {
      return {
        getValue: function() {
          return s.current;
        },
        listeners: /* @__PURE__ */ new Set()
      };
    }), c = ye(l, 1), u = c[0];
    return hr(function() {
      EF(function() {
        u.listeners.forEach(function(d) {
          d(i);
        });
      });
    }, [i]), /* @__PURE__ */ p.createElement(t.Provider, {
      value: u
    }, o);
  };
  return {
    Context: t,
    Provider: r,
    defaultValue: e
  };
}
function Ka(e, t) {
  var r = br(typeof t == "function" ? t : function(d) {
    if (t === void 0)
      return d;
    if (!Array.isArray(t))
      return d[t];
    var f = {};
    return t.forEach(function(m) {
      f[m] = d[m];
    }), f;
  }), n = p.useContext(e?.Context), a = n || {}, i = a.listeners, o = a.getValue, s = p.useRef();
  s.current = r(n ? o() : e?.defaultValue);
  var l = p.useState({}), c = ye(l, 2), u = c[1];
  return hr(function() {
    if (!n)
      return;
    function d(f) {
      var m = r(f);
      Do(s.current, m, !0) || u({});
    }
    return i.add(d), function() {
      i.delete(d);
    };
  }, [n]), s.current;
}
function A2e() {
  var e = /* @__PURE__ */ p.createContext(null);
  function t() {
    return p.useContext(e);
  }
  function r(a, i) {
    var o = No(a), s = function(c, u) {
      var d = o ? {
        ref: u
      } : {}, f = p.useRef(0), m = p.useRef(c), h = t();
      return h !== null ? /* @__PURE__ */ p.createElement(a, Pe({}, c, d)) : (
        // Always trigger re-render if not provide `notTriggerRender`
        ((!i || i(m.current, c)) && (f.current += 1), m.current = c, /* @__PURE__ */ p.createElement(e.Provider, {
          value: f.current
        }, /* @__PURE__ */ p.createElement(a, Pe({}, c, d))))
      );
    };
    return process.env.NODE_ENV !== "production" && (s.displayName = "ImmutableRoot(".concat(a.displayName || a.name, ")")), o ? /* @__PURE__ */ p.forwardRef(s) : s;
  }
  function n(a, i) {
    var o = No(a), s = function(c, u) {
      var d = o ? {
        ref: u
      } : {};
      return t(), /* @__PURE__ */ p.createElement(a, Pe({}, c, d));
    };
    return process.env.NODE_ENV !== "production" && (s.displayName = "ImmutableResponse(".concat(a.displayName || a.name, ")")), o ? /* @__PURE__ */ p.memo(/* @__PURE__ */ p.forwardRef(s), i) : /* @__PURE__ */ p.memo(s, i);
  }
  return {
    makeImmutable: r,
    responseImmutable: n,
    useImmutableMark: t
  };
}
var GI = A2e(), VU = GI.makeImmutable, Id = GI.responseImmutable, P2e = GI.useImmutableMark, xi = VI();
function GU(e, t) {
  var r = p.useRef(0);
  r.current += 1;
  var n = p.useRef(e), a = [];
  Object.keys(e || {}).map(function(o) {
    var s;
    e?.[o] !== ((s = n.current) === null || s === void 0 ? void 0 : s[o]) && a.push(o);
  }), n.current = e;
  var i = p.useRef([]);
  return a.length && (i.current = a), p.useDebugValue(r.current), p.useDebugValue(i.current.join(", ")), t && console.log("".concat(t, ":"), r.current, i.current), r.current;
}
const $l = process.env.NODE_ENV !== "production" ? GU : function() {
};
var R2e = /* @__PURE__ */ p.memo(function() {
  var e = GU();
  return /* @__PURE__ */ p.createElement("h1", null, "Render Times: ", e);
});
process.env.NODE_ENV !== "production" && (R2e.displayName = "RenderBlock");
var UU = /* @__PURE__ */ p.createContext({
  renderWithProps: !1
}), N2e = "RC_TABLE_KEY";
function D2e(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function Q1(e) {
  var t = [], r = {};
  return e.forEach(function(n) {
    for (var a = n || {}, i = a.key, o = a.dataIndex, s = i || D2e(o).join("-") || N2e; r[s]; )
      s = "".concat(s, "_next");
    r[s] = !0, t.push(s);
  }), t;
}
function mE(e) {
  return e != null;
}
function j2e(e) {
  return e && kt(e) === "object" && !Array.isArray(e) && !/* @__PURE__ */ p.isValidElement(e);
}
function L2e(e, t, r, n, a, i) {
  var o = p.useContext(UU), s = P2e(), l = Pc(function() {
    if (mE(n))
      return [n];
    var c = t == null || t === "" ? [] : Array.isArray(t) ? t : [t], u = Bi(e, c), d = u, f = void 0;
    if (a) {
      var m = a(u, e, r);
      j2e(m) ? (process.env.NODE_ENV !== "production" && jt(!1, "`columns.render` return cell props is deprecated with perf issue, please use `onCell` instead."), d = m.children, f = m.props, o.renderWithProps = !0) : d = m;
    }
    return [d, f];
  }, [
    // Force update deps
    s,
    // Normal deps
    e,
    n,
    t,
    a,
    r
  ], function(c, u) {
    if (i) {
      var d = ye(c, 2), f = d[1], m = ye(u, 2), h = m[1];
      return i(h, f);
    }
    return o.renderWithProps ? !0 : !Do(c, u, !0);
  });
  return l;
}
function k2e(e, t, r, n) {
  var a = e + t - 1;
  return e <= n && a >= r;
}
function F2e(e, t) {
  return Ka(xi, function(r) {
    var n = k2e(e, t || 1, r.hoverStartRow, r.hoverEndRow);
    return [n, r.onHover];
  });
}
var B2e = function(t) {
  var r = t.ellipsis, n = t.rowType, a = t.children, i, o = r === !0 ? {
    showTitle: !0
  } : r;
  return o && (o.showTitle || n === "header") && (typeof a == "string" || typeof a == "number" ? i = a.toString() : /* @__PURE__ */ p.isValidElement(a) && typeof a.props.children == "string" && (i = a.props.children)), i;
};
function z2e(e) {
  var t, r, n, a, i, o, s, l;
  process.env.NODE_ENV !== "production" && $l(e);
  var c = e.component, u = e.children, d = e.ellipsis, f = e.scope, m = e.prefixCls, h = e.className, g = e.align, y = e.record, S = e.render, x = e.dataIndex, b = e.renderIndex, _ = e.shouldCellUpdate, $ = e.index, w = e.rowType, O = e.colSpan, T = e.rowSpan, I = e.fixLeft, P = e.fixRight, D = e.firstFixLeft, B = e.lastFixLeft, L = e.firstFixRight, N = e.lastFixRight, z = e.appendNode, F = e.additionalProps, j = F === void 0 ? {} : F, H = e.isSticky, U = "".concat(m, "-cell"), G = Ka(xi, ["supportSticky", "allColumnsFixedLeft", "rowHoverable"]), V = G.supportSticky, K = G.allColumnsFixedLeft, Z = G.rowHoverable, ee = L2e(y, x, b, u, S, _), ae = ye(ee, 2), ue = ae[0], re = ae[1], oe = {}, fe = typeof I == "number" && V, le = typeof P == "number" && V;
  fe && (oe.position = "sticky", oe.left = I), le && (oe.position = "sticky", oe.right = P);
  var se = (t = (r = (n = re?.colSpan) !== null && n !== void 0 ? n : j.colSpan) !== null && r !== void 0 ? r : O) !== null && t !== void 0 ? t : 1, Q = (a = (i = (o = re?.rowSpan) !== null && o !== void 0 ? o : j.rowSpan) !== null && i !== void 0 ? i : T) !== null && a !== void 0 ? a : 1, he = F2e($, Q), ne = ye(he, 2), me = ne[0], k = ne[1], M = br(function(J) {
    var de;
    y && k($, $ + Q - 1), j == null || (de = j.onMouseEnter) === null || de === void 0 || de.call(j, J);
  }), R = br(function(J) {
    var de;
    y && k(-1, -1), j == null || (de = j.onMouseLeave) === null || de === void 0 || de.call(j, J);
  });
  if (se === 0 || Q === 0)
    return null;
  var q = (s = j.title) !== null && s !== void 0 ? s : B2e({
    rowType: w,
    ellipsis: d,
    children: ue
  }), Y = be(U, h, (l = {}, te(l, "".concat(U, "-fix-left"), fe && V), te(l, "".concat(U, "-fix-left-first"), D && V), te(l, "".concat(U, "-fix-left-last"), B && V), te(l, "".concat(U, "-fix-left-all"), B && K && V), te(l, "".concat(U, "-fix-right"), le && V), te(l, "".concat(U, "-fix-right-first"), L && V), te(l, "".concat(U, "-fix-right-last"), N && V), te(l, "".concat(U, "-ellipsis"), d), te(l, "".concat(U, "-with-append"), z), te(l, "".concat(U, "-fix-sticky"), (fe || le) && H && V), te(l, "".concat(U, "-row-hover"), !re && me), l), j.className, re?.className), X = {};
  g && (X.textAlign = g);
  var pe = ce(ce(ce(ce({}, oe), j.style), X), re?.style), $e = ue;
  return kt($e) === "object" && !Array.isArray($e) && !/* @__PURE__ */ p.isValidElement($e) && ($e = null), d && (B || L) && ($e = /* @__PURE__ */ p.createElement("span", {
    className: "".concat(U, "-content")
  }, $e)), /* @__PURE__ */ p.createElement(c, Pe({}, re, j, {
    className: Y,
    style: pe,
    title: q,
    scope: f,
    onMouseEnter: Z ? M : void 0,
    onMouseLeave: Z ? R : void 0,
    colSpan: se !== 1 ? se : null,
    rowSpan: Q !== 1 ? Q : null
  }), z, $e);
}
const Hc = /* @__PURE__ */ p.memo(z2e);
function UI(e, t, r, n, a) {
  var i = r[e] || {}, o = r[t] || {}, s, l;
  i.fixed === "left" ? s = n.left[a === "rtl" ? t : e] : o.fixed === "right" && (l = n.right[a === "rtl" ? e : t]);
  var c = !1, u = !1, d = !1, f = !1, m = r[t + 1], h = r[e - 1], g = m && !m.fixed || h && !h.fixed || r.every(function(_) {
    return _.fixed === "left";
  });
  if (a === "rtl") {
    if (s !== void 0) {
      var y = h && h.fixed === "left";
      f = !y && g;
    } else if (l !== void 0) {
      var S = m && m.fixed === "right";
      d = !S && g;
    }
  } else if (s !== void 0) {
    var x = m && m.fixed === "left";
    c = !x && g;
  } else if (l !== void 0) {
    var b = h && h.fixed === "right";
    u = !b && g;
  }
  return {
    fixLeft: s,
    fixRight: l,
    lastFixLeft: c,
    firstFixRight: u,
    lastFixRight: d,
    firstFixLeft: f,
    isSticky: n.isSticky
  };
}
var WU = /* @__PURE__ */ p.createContext({});
function H2e(e) {
  var t = e.className, r = e.index, n = e.children, a = e.colSpan, i = a === void 0 ? 1 : a, o = e.rowSpan, s = e.align, l = Ka(xi, ["prefixCls", "direction"]), c = l.prefixCls, u = l.direction, d = p.useContext(WU), f = d.scrollColumnIndex, m = d.stickyOffsets, h = d.flattenColumns, g = r + i - 1, y = g + 1 === f ? i + 1 : i, S = UI(r, r + y - 1, h, m, u);
  return /* @__PURE__ */ p.createElement(Hc, Pe({
    className: t,
    index: r,
    component: "td",
    prefixCls: c,
    record: null,
    dataIndex: null,
    align: s,
    colSpan: y,
    rowSpan: o,
    render: function() {
      return n;
    }
  }, S));
}
var V2e = ["children"];
function G2e(e) {
  var t = e.children, r = Kt(e, V2e);
  return /* @__PURE__ */ p.createElement("tr", r, t);
}
function eC(e) {
  var t = e.children;
  return t;
}
eC.Row = G2e;
eC.Cell = H2e;
function U2e(e) {
  process.env.NODE_ENV !== "production" && $l(e);
  var t = e.children, r = e.stickyOffsets, n = e.flattenColumns, a = Ka(xi, "prefixCls"), i = n.length - 1, o = n[i], s = p.useMemo(function() {
    return {
      stickyOffsets: r,
      flattenColumns: n,
      scrollColumnIndex: o != null && o.scrollbar ? i : null
    };
  }, [o, n, i, r]);
  return /* @__PURE__ */ p.createElement(WU.Provider, {
    value: s
  }, /* @__PURE__ */ p.createElement("tfoot", {
    className: "".concat(a, "-summary")
  }, t));
}
const cy = Id(U2e);
var qU = eC;
function W2e(e) {
  return null;
}
function q2e(e) {
  return null;
}
function KU(e, t, r, n, a, i, o) {
  e.push({
    record: t,
    indent: r,
    index: o
  });
  var s = i(t), l = a?.has(s);
  if (t && Array.isArray(t[n]) && l)
    for (var c = 0; c < t[n].length; c += 1)
      KU(e, t[n][c], r + 1, n, a, i, c);
}
function YU(e, t, r, n) {
  var a = p.useMemo(function() {
    if (r != null && r.size) {
      for (var i = [], o = 0; o < e?.length; o += 1) {
        var s = e[o];
        KU(i, s, 0, t, r, n, o);
      }
      return i;
    }
    return e?.map(function(l, c) {
      return {
        record: l,
        indent: 0,
        index: c
      };
    });
  }, [e, t, r, n]);
  return a;
}
function ZU(e, t, r, n) {
  var a = Ka(xi, ["prefixCls", "fixedInfoList", "flattenColumns", "expandableType", "expandRowByClick", "onTriggerExpand", "rowClassName", "expandedRowClassName", "indentSize", "expandIcon", "expandedRowRender", "expandIconColumnIndex", "expandedKeys", "childrenColumnName", "rowExpandable", "onRow"]), i = a.flattenColumns, o = a.expandableType, s = a.expandedKeys, l = a.childrenColumnName, c = a.onTriggerExpand, u = a.rowExpandable, d = a.onRow, f = a.expandRowByClick, m = a.rowClassName, h = o === "nest", g = o === "row" && (!u || u(e)), y = g || h, S = s && s.has(t), x = l && e && e[l], b = br(c), _ = d?.(e, r), $ = _?.onClick, w = function(P) {
    f && y && c(e, P);
    for (var D = arguments.length, B = new Array(D > 1 ? D - 1 : 0), L = 1; L < D; L++)
      B[L - 1] = arguments[L];
    $?.apply(void 0, [P].concat(B));
  }, O;
  typeof m == "string" ? O = m : typeof m == "function" && (O = m(e, r, n));
  var T = Q1(i);
  return ce(ce({}, a), {}, {
    columnsKey: T,
    nestExpandable: h,
    expanded: S,
    hasNestChildren: x,
    record: e,
    onTriggerExpand: b,
    rowSupportExpand: g,
    expandable: y,
    rowProps: ce(ce({}, _), {}, {
      className: be(O, _?.className),
      onClick: w
    })
  });
}
function XU(e) {
  process.env.NODE_ENV !== "production" && $l(e);
  var t = e.prefixCls, r = e.children, n = e.component, a = e.cellComponent, i = e.className, o = e.expanded, s = e.colSpan, l = e.isEmpty, c = Ka(xi, ["scrollbarSize", "fixHeader", "fixColumn", "componentWidth", "horizonScroll"]), u = c.scrollbarSize, d = c.fixHeader, f = c.fixColumn, m = c.componentWidth, h = c.horizonScroll, g = r;
  return (l ? h && m : f) && (g = /* @__PURE__ */ p.createElement("div", {
    style: {
      width: m - (d ? u : 0),
      position: "sticky",
      left: 0,
      overflow: "hidden"
    },
    className: "".concat(t, "-expanded-row-fixed")
  }, g)), /* @__PURE__ */ p.createElement(n, {
    className: i,
    style: {
      display: o ? null : "none"
    }
  }, /* @__PURE__ */ p.createElement(Hc, {
    component: a,
    prefixCls: t,
    colSpan: s
  }, g));
}
function JU(e, t, r, n, a) {
  var i = e.record, o = e.prefixCls, s = e.columnsKey, l = e.fixedInfoList, c = e.expandIconColumnIndex, u = e.nestExpandable, d = e.indentSize, f = e.expandIcon, m = e.expanded, h = e.hasNestChildren, g = e.onTriggerExpand, y = s[r], S = l[r], x;
  r === (c || 0) && u && (x = /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement("span", {
    style: {
      paddingLeft: "".concat(d * n, "px")
    },
    className: "".concat(o, "-row-indent indent-level-").concat(n)
  }), f({
    prefixCls: o,
    expanded: m,
    expandable: h,
    record: i,
    onExpand: g
  })));
  var b;
  return t.onCell && (b = t.onCell(i, a)), {
    key: y,
    fixedInfo: S,
    appendCellNode: x,
    additionalCellProps: b || {}
  };
}
function QU(e) {
  process.env.NODE_ENV !== "production" && $l(e);
  var t = e.className, r = e.style, n = e.record, a = e.index, i = e.renderIndex, o = e.rowKey, s = e.indent, l = s === void 0 ? 0 : s, c = e.rowComponent, u = e.cellComponent, d = e.scopeCellComponent, f = ZU(n, o, a, l), m = f.prefixCls, h = f.flattenColumns, g = f.expandedRowClassName, y = f.expandedRowRender, S = f.rowProps, x = f.expanded, b = f.rowSupportExpand, _ = p.useRef(!1);
  _.current || (_.current = x), process.env.NODE_ENV !== "production" && $l(e);
  var $ = g && g(n, a, l), w = /* @__PURE__ */ p.createElement(c, Pe({}, S, {
    "data-row-key": o,
    className: be(t, "".concat(m, "-row"), "".concat(m, "-row-level-").concat(l), S?.className, l >= 1 ? $ : ""),
    style: ce(ce({}, r), S?.style)
  }), h.map(function(I, P) {
    var D = I.render, B = I.dataIndex, L = I.className, N = JU(f, I, P, l, a), z = N.key, F = N.fixedInfo, j = N.appendCellNode, H = N.additionalCellProps;
    return /* @__PURE__ */ p.createElement(Hc, Pe({
      className: L,
      ellipsis: I.ellipsis,
      align: I.align,
      scope: I.rowScope,
      component: I.rowScope ? d : u,
      prefixCls: m,
      key: z,
      record: n,
      index: a,
      renderIndex: i,
      dataIndex: B,
      render: D,
      shouldCellUpdate: I.shouldCellUpdate
    }, F, {
      appendNode: j,
      additionalProps: H
    }));
  })), O;
  if (b && (_.current || x)) {
    var T = y(n, a, l + 1, x);
    O = /* @__PURE__ */ p.createElement(XU, {
      expanded: x,
      className: be("".concat(m, "-expanded-row"), "".concat(m, "-expanded-row-level-").concat(l + 1), $),
      prefixCls: m,
      component: c,
      cellComponent: u,
      colSpan: h.length,
      isEmpty: !1
    }, T);
  }
  return /* @__PURE__ */ p.createElement(p.Fragment, null, w, O);
}
process.env.NODE_ENV !== "production" && (QU.displayName = "BodyRow");
const K2e = Id(QU);
function Y2e(e) {
  var t = e.columnKey, r = e.onColumnResize, n = p.useRef();
  return p.useEffect(function() {
    n.current && r(t, n.current.offsetWidth);
  }, []), /* @__PURE__ */ p.createElement(Ia, {
    data: t
  }, /* @__PURE__ */ p.createElement("td", {
    ref: n,
    style: {
      padding: 0,
      border: 0,
      height: 0
    }
  }, /* @__PURE__ */ p.createElement("div", {
    style: {
      height: 0,
      overflow: "hidden"
    }
  }, " ")));
}
function Z2e(e) {
  var t = e.prefixCls, r = e.columnsKey, n = e.onColumnResize;
  return /* @__PURE__ */ p.createElement("tr", {
    "aria-hidden": "true",
    className: "".concat(t, "-measure-row"),
    style: {
      height: 0,
      fontSize: 0
    }
  }, /* @__PURE__ */ p.createElement(Ia.Collection, {
    onBatchResize: function(i) {
      i.forEach(function(o) {
        var s = o.data, l = o.size;
        n(s, l.offsetWidth);
      });
    }
  }, r.map(function(a) {
    return /* @__PURE__ */ p.createElement(Y2e, {
      key: a,
      columnKey: a,
      onColumnResize: n
    });
  })));
}
function eW(e) {
  process.env.NODE_ENV !== "production" && $l(e);
  var t = e.data, r = e.measureColumnWidth, n = Ka(xi, ["prefixCls", "getComponent", "onColumnResize", "flattenColumns", "getRowKey", "expandedKeys", "childrenColumnName", "emptyNode"]), a = n.prefixCls, i = n.getComponent, o = n.onColumnResize, s = n.flattenColumns, l = n.getRowKey, c = n.expandedKeys, u = n.childrenColumnName, d = n.emptyNode, f = YU(t, u, c, l), m = p.useRef({
    renderWithProps: !1
  }), h = i(["body", "wrapper"], "tbody"), g = i(["body", "row"], "tr"), y = i(["body", "cell"], "td"), S = i(["body", "cell"], "th"), x;
  t.length ? x = f.map(function(_, $) {
    var w = _.record, O = _.indent, T = _.index, I = l(w, $);
    return /* @__PURE__ */ p.createElement(K2e, {
      key: I,
      rowKey: I,
      record: w,
      index: $,
      renderIndex: T,
      rowComponent: g,
      cellComponent: y,
      scopeCellComponent: S,
      getRowKey: l,
      indent: O
    });
  }) : x = /* @__PURE__ */ p.createElement(XU, {
    expanded: !0,
    className: "".concat(a, "-placeholder"),
    prefixCls: a,
    component: g,
    cellComponent: y,
    colSpan: s.length,
    isEmpty: !0
  }, d);
  var b = Q1(s);
  return /* @__PURE__ */ p.createElement(UU.Provider, {
    value: m.current
  }, /* @__PURE__ */ p.createElement(h, {
    className: "".concat(a, "-tbody")
  }, r && /* @__PURE__ */ p.createElement(Z2e, {
    prefixCls: a,
    columnsKey: b,
    onColumnResize: o
  }), x));
}
process.env.NODE_ENV !== "production" && (eW.displayName = "Body");
const X2e = Id(eW);
var J2e = ["expandable"], L0 = "RC_TABLE_INTERNAL_COL_DEFINE";
function Q2e(e) {
  var t = e.expandable, r = Kt(e, J2e), n;
  return "expandable" in e ? n = ce(ce({}, r), t) : (process.env.NODE_ENV !== "production" && ["indentSize", "expandedRowKeys", "defaultExpandedRowKeys", "defaultExpandAllRows", "expandedRowRender", "expandRowByClick", "expandIcon", "onExpand", "onExpandedRowsChange", "expandedRowClassName", "expandIconColumnIndex", "showExpandColumn", "title"].some(function(a) {
    return a in e;
  }) && jt(!1, "expanded related props have been moved into `expandable`."), n = r), n.showExpandColumn === !1 && (n.expandIconColumnIndex = -1), n;
}
var eEe = ["columnType"];
function tW(e) {
  for (var t = e.colWidths, r = e.columns, n = e.columCount, a = [], i = n || r.length, o = !1, s = i - 1; s >= 0; s -= 1) {
    var l = t[s], c = r && r[s], u = c && c[L0];
    if (l || u || o) {
      var d = u || {};
      d.columnType;
      var f = Kt(d, eEe);
      a.unshift(/* @__PURE__ */ p.createElement("col", Pe({
        key: s,
        style: {
          width: l
        }
      }, f))), o = !0;
    }
  }
  return /* @__PURE__ */ p.createElement("colgroup", null, a);
}
var tEe = ["className", "noData", "columns", "flattenColumns", "colWidths", "columCount", "stickyOffsets", "direction", "fixHeader", "stickyTopOffset", "stickyBottomOffset", "stickyClassName", "onScroll", "maxContentScroll", "children"];
function rEe(e, t) {
  return dr(function() {
    for (var r = [], n = 0; n < t; n += 1) {
      var a = e[n];
      if (a !== void 0)
        r[n] = a;
      else
        return null;
    }
    return r;
  }, [e.join("_"), t]);
}
var rW = /* @__PURE__ */ p.forwardRef(function(e, t) {
  process.env.NODE_ENV !== "production" && $l(e);
  var r = e.className, n = e.noData, a = e.columns, i = e.flattenColumns, o = e.colWidths, s = e.columCount, l = e.stickyOffsets, c = e.direction, u = e.fixHeader, d = e.stickyTopOffset, f = e.stickyBottomOffset, m = e.stickyClassName, h = e.onScroll, g = e.maxContentScroll, y = e.children, S = Kt(e, tEe), x = Ka(xi, ["prefixCls", "scrollbarSize", "isSticky", "getComponent"]), b = x.prefixCls, _ = x.scrollbarSize, $ = x.isSticky, w = x.getComponent, O = w(["header", "table"], "table"), T = $ && !u ? 0 : _, I = p.useRef(null), P = p.useCallback(function(H) {
    B0(t, H), B0(I, H);
  }, []);
  p.useEffect(function() {
    var H;
    function U(G) {
      var V = G, K = V.currentTarget, Z = V.deltaX;
      Z && (h({
        currentTarget: K,
        scrollLeft: K.scrollLeft + Z
      }), G.preventDefault());
    }
    return (H = I.current) === null || H === void 0 || H.addEventListener("wheel", U, {
      passive: !1
    }), function() {
      var G;
      (G = I.current) === null || G === void 0 || G.removeEventListener("wheel", U);
    };
  }, []);
  var D = p.useMemo(function() {
    return i.every(function(H) {
      return H.width;
    });
  }, [i]), B = i[i.length - 1], L = {
    fixed: B ? B.fixed : null,
    scrollbar: !0,
    onHeaderCell: function() {
      return {
        className: "".concat(b, "-cell-scrollbar")
      };
    }
  }, N = dr(function() {
    return T ? [].concat(ze(a), [L]) : a;
  }, [T, a]), z = dr(function() {
    return T ? [].concat(ze(i), [L]) : i;
  }, [T, i]), F = dr(function() {
    var H = l.right, U = l.left;
    return ce(ce({}, l), {}, {
      left: c === "rtl" ? [].concat(ze(U.map(function(G) {
        return G + T;
      })), [0]) : U,
      right: c === "rtl" ? H : [].concat(ze(H.map(function(G) {
        return G + T;
      })), [0]),
      isSticky: $
    });
  }, [T, l, $]), j = rEe(o, s);
  return /* @__PURE__ */ p.createElement("div", {
    style: ce({
      overflow: "hidden"
    }, $ ? {
      top: d,
      bottom: f
    } : {}),
    ref: P,
    className: be(r, te({}, m, !!m))
  }, /* @__PURE__ */ p.createElement(O, {
    style: {
      tableLayout: "fixed",
      visibility: n || j ? null : "hidden"
    }
  }, (!n || !g || D) && /* @__PURE__ */ p.createElement(tW, {
    colWidths: j ? [].concat(ze(j), [T]) : [],
    columCount: s + 1,
    columns: z
  }), y(ce(ce({}, S), {}, {
    stickyOffsets: F,
    columns: N,
    flattenColumns: z
  }))));
});
process.env.NODE_ENV !== "production" && (rW.displayName = "FixedHolder");
const E4 = /* @__PURE__ */ p.memo(rW);
var nW = function(t) {
  var r = t.cells, n = t.stickyOffsets, a = t.flattenColumns, i = t.rowComponent, o = t.cellComponent, s = t.onHeaderRow, l = t.index, c = Ka(xi, ["prefixCls", "direction"]), u = c.prefixCls, d = c.direction, f;
  s && (f = s(r.map(function(h) {
    return h.column;
  }), l));
  var m = Q1(r.map(function(h) {
    return h.column;
  }));
  return /* @__PURE__ */ p.createElement(i, f, r.map(function(h, g) {
    var y = h.column, S = UI(h.colStart, h.colEnd, a, n, d), x;
    return y && y.onHeaderCell && (x = h.column.onHeaderCell(y)), /* @__PURE__ */ p.createElement(Hc, Pe({}, h, {
      scope: y.title ? h.colSpan > 1 ? "colgroup" : "col" : null,
      ellipsis: y.ellipsis,
      align: y.align,
      component: o,
      prefixCls: u,
      key: m[g]
    }, S, {
      additionalProps: x,
      rowType: "header"
    }));
  }));
};
process.env.NODE_ENV !== "production" && (nW.displayName = "HeaderRow");
function nEe(e) {
  var t = [];
  function r(o, s) {
    var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    t[l] = t[l] || [];
    var c = s, u = o.filter(Boolean).map(function(d) {
      var f = {
        key: d.key,
        className: d.className || "",
        children: d.title,
        column: d,
        colStart: c
      }, m = 1, h = d.children;
      return h && h.length > 0 && (m = r(h, c, l + 1).reduce(function(g, y) {
        return g + y;
      }, 0), f.hasSubColumns = !0), "colSpan" in d && (m = d.colSpan), "rowSpan" in d && (f.rowSpan = d.rowSpan), f.colSpan = m, f.colEnd = f.colStart + m - 1, t[l].push(f), c += m, m;
    });
    return u;
  }
  r(e, 0);
  for (var n = t.length, a = function(s) {
    t[s].forEach(function(l) {
      !("rowSpan" in l) && !l.hasSubColumns && (l.rowSpan = n - s);
    });
  }, i = 0; i < n; i += 1)
    a(i);
  return t;
}
var aEe = function(t) {
  process.env.NODE_ENV !== "production" && $l(t);
  var r = t.stickyOffsets, n = t.columns, a = t.flattenColumns, i = t.onHeaderRow, o = Ka(xi, ["prefixCls", "getComponent"]), s = o.prefixCls, l = o.getComponent, c = p.useMemo(function() {
    return nEe(n);
  }, [n]), u = l(["header", "wrapper"], "thead"), d = l(["header", "row"], "tr"), f = l(["header", "cell"], "th");
  return /* @__PURE__ */ p.createElement(u, {
    className: "".concat(s, "-thead")
  }, c.map(function(m, h) {
    var g = /* @__PURE__ */ p.createElement(nW, {
      key: h,
      flattenColumns: a,
      cells: m,
      stickyOffsets: r,
      rowComponent: d,
      cellComponent: f,
      onHeaderRow: i,
      index: h
    });
    return g;
  }));
};
const w4 = Id(aEe);
function O4(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return typeof t == "number" ? t : t.endsWith("%") ? e * parseFloat(t) / 100 : null;
}
function iEe(e, t, r) {
  return p.useMemo(function() {
    if (t && t > 0) {
      var n = 0, a = 0;
      e.forEach(function(f) {
        var m = O4(t, f.width);
        m ? n += m : a += 1;
      });
      var i = Math.max(t, r), o = Math.max(i - n, a), s = a, l = o / a, c = 0, u = e.map(function(f) {
        var m = ce({}, f), h = O4(t, m.width);
        if (h)
          m.width = h;
        else {
          var g = Math.floor(l);
          m.width = s === 1 ? o : g, o -= g, s -= 1;
        }
        return c += m.width, m;
      });
      if (c < i) {
        var d = i / c;
        o = i, u.forEach(function(f, m) {
          var h = Math.floor(f.width * d);
          f.width = m === u.length - 1 ? o : h, o -= h;
        });
      }
      return [u, Math.max(c, i)];
    }
    return [e, t];
  }, [e, t, r]);
}
var oEe = ["children"], sEe = ["fixed"];
function WI(e) {
  return Ma(e).filter(function(t) {
    return /* @__PURE__ */ p.isValidElement(t);
  }).map(function(t) {
    var r = t.key, n = t.props, a = n.children, i = Kt(n, oEe), o = ce({
      key: r
    }, i);
    return a && (o.children = WI(a)), o;
  });
}
function aW(e) {
  return e.filter(function(t) {
    return t && kt(t) === "object" && !t.hidden;
  }).map(function(t) {
    var r = t.children;
    return r && r.length > 0 ? ce(ce({}, t), {}, {
      children: aW(r)
    }) : t;
  });
}
function vE(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "key";
  return e.filter(function(r) {
    return r && kt(r) === "object";
  }).reduce(function(r, n, a) {
    var i = n.fixed, o = i === !0 ? "left" : i, s = "".concat(t, "-").concat(a), l = n.children;
    return l && l.length > 0 ? [].concat(ze(r), ze(vE(l, s).map(function(c) {
      return ce({
        fixed: o
      }, c);
    }))) : [].concat(ze(r), [ce(ce({
      key: s
    }, n), {}, {
      fixed: o
    })]);
  }, []);
}
function lEe(e) {
  return e.map(function(t) {
    var r = t.fixed, n = Kt(t, sEe), a = r;
    return r === "left" ? a = "right" : r === "right" && (a = "left"), ce({
      fixed: a
    }, n);
  });
}
function cEe(e, t) {
  var r = e.prefixCls, n = e.columns, a = e.children, i = e.expandable, o = e.expandedKeys, s = e.columnTitle, l = e.getRowKey, c = e.onTriggerExpand, u = e.expandIcon, d = e.rowExpandable, f = e.expandIconColumnIndex, m = e.direction, h = e.expandRowByClick, g = e.columnWidth, y = e.fixed, S = e.scrollWidth, x = e.clientWidth, b = p.useMemo(function() {
    var B = n || WI(a) || [];
    return aW(B.slice());
  }, [n, a]), _ = p.useMemo(function() {
    if (i) {
      var B, L = b.slice();
      if (process.env.NODE_ENV !== "production" && f >= 0 && jt(!1, "`expandIconColumnIndex` is deprecated. Please use `Table.EXPAND_COLUMN` in `columns` instead."), !L.includes(es)) {
        var N = f || 0;
        N >= 0 && L.splice(N, 0, es);
      }
      process.env.NODE_ENV !== "production" && L.filter(function(U) {
        return U === es;
      }).length > 1 && jt(!1, "There exist more than one `EXPAND_COLUMN` in `columns`.");
      var z = L.indexOf(es);
      L = L.filter(function(U, G) {
        return U !== es || G === z;
      });
      var F = b[z], j;
      (y === "left" || y) && !f ? j = "left" : (y === "right" || y) && f === b.length ? j = "right" : j = F ? F.fixed : null;
      var H = (B = {}, te(B, L0, {
        className: "".concat(r, "-expand-icon-col"),
        columnType: "EXPAND_COLUMN"
      }), te(B, "title", s), te(B, "fixed", j), te(B, "className", "".concat(r, "-row-expand-icon-cell")), te(B, "width", g), te(B, "render", function(G, V, K) {
        var Z = l(V, K), ee = o.has(Z), ae = d ? d(V) : !0, ue = u({
          prefixCls: r,
          expanded: ee,
          expandable: ae,
          record: V,
          onExpand: c
        });
        return h ? /* @__PURE__ */ p.createElement("span", {
          onClick: function(oe) {
            return oe.stopPropagation();
          }
        }, ue) : ue;
      }), B);
      return L.map(function(U) {
        return U === es ? H : U;
      });
    }
    return process.env.NODE_ENV !== "production" && b.includes(es) && jt(!1, "`expandable` is not config but there exist `EXPAND_COLUMN` in `columns`."), b.filter(function(U) {
      return U !== es;
    });
  }, [i, b, l, o, u, m]), $ = p.useMemo(function() {
    var B = _;
    return t && (B = t(B)), B.length || (B = [{
      render: function() {
        return null;
      }
    }]), B;
  }, [t, _, m]), w = p.useMemo(function() {
    return m === "rtl" ? lEe(vE($)) : vE($);
  }, [$, m, S]), O = p.useMemo(function() {
    for (var B = -1, L = w.length - 1; L >= 0; L -= 1) {
      var N = w[L].fixed;
      if (N === "left" || N === !0) {
        B = L;
        break;
      }
    }
    if (B >= 0)
      for (var z = 0; z <= B; z += 1) {
        var F = w[z].fixed;
        if (F !== "left" && F !== !0)
          return !0;
      }
    var j = w.findIndex(function(G) {
      var V = G.fixed;
      return V === "right";
    });
    if (j >= 0)
      for (var H = j; H < w.length; H += 1) {
        var U = w[H].fixed;
        if (U !== "right")
          return !0;
      }
    return !1;
  }, [w]), T = iEe(w, S, x), I = ye(T, 2), P = I[0], D = I[1];
  return [$, P, D, O];
}
function uEe(e) {
  var t, r = e.prefixCls, n = e.record, a = e.onExpand, i = e.expanded, o = e.expandable, s = "".concat(r, "-row-expand-icon");
  if (!o)
    return /* @__PURE__ */ p.createElement("span", {
      className: be(s, "".concat(r, "-row-spaced"))
    });
  var l = function(u) {
    a(n, u), u.stopPropagation();
  };
  return /* @__PURE__ */ p.createElement("span", {
    className: be(s, (t = {}, te(t, "".concat(r, "-row-expanded"), i), te(t, "".concat(r, "-row-collapsed"), !i), t)),
    onClick: l
  });
}
function dEe(e, t, r) {
  var n = [];
  function a(i) {
    (i || []).forEach(function(o, s) {
      n.push(t(o, s)), a(o[r]);
    });
  }
  return a(e), n;
}
function fEe(e, t, r) {
  var n = Q2e(e), a = n.expandIcon, i = n.expandedRowKeys, o = n.defaultExpandedRowKeys, s = n.defaultExpandAllRows, l = n.expandedRowRender, c = n.onExpand, u = n.onExpandedRowsChange, d = n.childrenColumnName, f = a || uEe, m = d || "children", h = p.useMemo(function() {
    return l ? "row" : e.expandable && e.internalHooks === Th && e.expandable.__PARENT_RENDER_ICON__ || t.some(function($) {
      return $ && kt($) === "object" && $[m];
    }) ? "nest" : !1;
  }, [!!l, t]), g = p.useState(function() {
    return o || (s ? dEe(t, r, m) : []);
  }), y = ye(g, 2), S = y[0], x = y[1], b = p.useMemo(function() {
    return new Set(i || S || []);
  }, [i, S]), _ = p.useCallback(function($) {
    var w = r($, t.indexOf($)), O, T = b.has(w);
    T ? (b.delete(w), O = ze(b)) : O = [].concat(ze(b), [w]), x(O), c && c(!T, $), u && u(O);
  }, [r, b, t, c, u]);
  return process.env.NODE_ENV !== "production" && l && t.some(function($) {
    return Array.isArray($?.[m]);
  }) && jt(!1, "`expandedRowRender` should not use with nested Table"), [n, h, b, f, m, _];
}
function pEe(e, t, r) {
  var n = e.map(function(a, i) {
    return UI(i, i, e, t, r);
  });
  return Pc(function() {
    return n;
  }, [n], function(a, i) {
    return !Do(a, i);
  });
}
function iW(e) {
  var t = ct(e), r = He({}), n = ye(r, 2), a = n[1], i = ct(null), o = ct([]);
  function s(l) {
    o.current.push(l);
    var c = Promise.resolve();
    i.current = c, c.then(function() {
      if (i.current === c) {
        var u = o.current, d = t.current;
        o.current = [], u.forEach(function(f) {
          t.current = f(t.current);
        }), i.current = null, d !== t.current && a({});
      }
    });
  }
  return St(function() {
    return function() {
      i.current = null;
    };
  }, []), [t.current, s];
}
function mEe(e) {
  var t = ct(null), r = ct();
  function n() {
    window.clearTimeout(r.current);
  }
  function a(o) {
    t.current = o, n(), r.current = window.setTimeout(function() {
      t.current = null, r.current = void 0;
    }, 100);
  }
  function i() {
    return t.current;
  }
  return St(function() {
    return n;
  }, []), [a, i];
}
function vEe() {
  var e = p.useState(-1), t = ye(e, 2), r = t[0], n = t[1], a = p.useState(-1), i = ye(a, 2), o = i[0], s = i[1], l = p.useCallback(function(c, u) {
    n(c), s(u);
  }, []);
  return [r, o, l];
}
var T4 = Ca() ? window : null;
function hEe(e, t) {
  var r = kt(e) === "object" ? e : {}, n = r.offsetHeader, a = n === void 0 ? 0 : n, i = r.offsetSummary, o = i === void 0 ? 0 : i, s = r.offsetScroll, l = s === void 0 ? 0 : s, c = r.getContainer, u = c === void 0 ? function() {
    return T4;
  } : c, d = u() || T4;
  return p.useMemo(function() {
    var f = !!e;
    return {
      isSticky: f,
      stickyClassName: f ? "".concat(t, "-sticky-holder") : "",
      offsetHeader: a,
      offsetSummary: o,
      offsetScroll: l,
      container: d
    };
  }, [l, a, o, t, d]);
}
function gEe(e, t, r) {
  var n = dr(function() {
    var a = t.length, i = function(c, u, d) {
      for (var f = [], m = 0, h = c; h !== u; h += d)
        f.push(m), t[h].fixed && (m += e[h] || 0);
      return f;
    }, o = i(0, a, 1), s = i(a - 1, -1, -1).reverse();
    return r === "rtl" ? {
      left: s,
      right: o
    } : {
      left: o,
      right: s
    };
  }, [e, t, r]);
  return n;
}
function I4(e) {
  var t = e.className, r = e.children;
  return /* @__PURE__ */ p.createElement("div", {
    className: t
  }, r);
}
var yEe = function(t, r) {
  var n, a, i = t.scrollBodyRef, o = t.onScroll, s = t.offsetScroll, l = t.container, c = Ka(xi, "prefixCls"), u = ((n = i.current) === null || n === void 0 ? void 0 : n.scrollWidth) || 0, d = ((a = i.current) === null || a === void 0 ? void 0 : a.clientWidth) || 0, f = u && d * (d / u), m = p.useRef(), h = iW({
    scrollLeft: 0,
    isHiddenScrollBar: !1
  }), g = ye(h, 2), y = g[0], S = g[1], x = p.useRef({
    delta: 0,
    x: 0
  }), b = p.useState(!1), _ = ye(b, 2), $ = _[0], w = _[1], O = p.useRef(null);
  p.useEffect(function() {
    return function() {
      vr.cancel(O.current);
    };
  }, []);
  var T = function() {
    w(!1);
  }, I = function(N) {
    N.persist(), x.current.delta = N.pageX - y.scrollLeft, x.current.x = 0, w(!0), N.preventDefault();
  }, P = function(N) {
    var z, F = N || ((z = window) === null || z === void 0 ? void 0 : z.event), j = F.buttons;
    if (!$ || j === 0) {
      $ && w(!1);
      return;
    }
    var H = x.current.x + N.pageX - x.current.x - x.current.delta;
    H <= 0 && (H = 0), H + f >= d && (H = d - f), o({
      scrollLeft: H / d * (u + 2)
    }), x.current.x = N.pageX;
  }, D = function() {
    O.current = vr(function() {
      if (i.current) {
        var N = lE(i.current).top, z = N + i.current.offsetHeight, F = l === window ? document.documentElement.scrollTop + window.innerHeight : lE(l).top + l.clientHeight;
        z - IR() <= F || N >= F - s ? S(function(j) {
          return ce(ce({}, j), {}, {
            isHiddenScrollBar: !0
          });
        }) : S(function(j) {
          return ce(ce({}, j), {}, {
            isHiddenScrollBar: !1
          });
        });
      }
    });
  }, B = function(N) {
    S(function(z) {
      return ce(ce({}, z), {}, {
        scrollLeft: N / u * d || 0
      });
    });
  };
  return p.useImperativeHandle(r, function() {
    return {
      setScrollLeft: B,
      checkScrollBarVisible: D
    };
  }), p.useEffect(function() {
    var L = os(document.body, "mouseup", T, !1), N = os(document.body, "mousemove", P, !1);
    return D(), function() {
      L.remove(), N.remove();
    };
  }, [f, $]), p.useEffect(function() {
    var L = os(l, "scroll", D, !1), N = os(window, "resize", D, !1);
    return function() {
      L.remove(), N.remove();
    };
  }, [l]), p.useEffect(function() {
    y.isHiddenScrollBar || S(function(L) {
      var N = i.current;
      return N ? ce(ce({}, L), {}, {
        scrollLeft: N.scrollLeft / N.scrollWidth * N.clientWidth
      }) : L;
    });
  }, [y.isHiddenScrollBar]), u <= d || !f || y.isHiddenScrollBar ? null : /* @__PURE__ */ p.createElement("div", {
    style: {
      height: IR(),
      width: d,
      bottom: s
    },
    className: "".concat(c, "-sticky-scroll")
  }, /* @__PURE__ */ p.createElement("div", {
    onMouseDown: I,
    ref: m,
    className: be("".concat(c, "-sticky-scroll-bar"), te({}, "".concat(c, "-sticky-scroll-bar-active"), $)),
    style: {
      width: "".concat(f, "px"),
      transform: "translate3d(".concat(y.scrollLeft, "px, 0, 0)")
    }
  }));
};
const bEe = /* @__PURE__ */ p.forwardRef(yEe);
var oW = "rc-table", CEe = [], SEe = {};
function xEe() {
  return "No Data";
}
function $Ee(e, t) {
  var r, n = ce({
    rowKey: "key",
    prefixCls: oW,
    emptyText: xEe
  }, e), a = n.prefixCls, i = n.className, o = n.rowClassName, s = n.style, l = n.data, c = n.rowKey, u = n.scroll, d = n.tableLayout, f = n.direction, m = n.title, h = n.footer, g = n.summary, y = n.caption, S = n.id, x = n.showHeader, b = n.components, _ = n.emptyText, $ = n.onRow, w = n.onHeaderRow, O = n.onScroll, T = n.internalHooks, I = n.transformColumns, P = n.internalRefs, D = n.tailor, B = n.getContainerWidth, L = n.sticky, N = n.rowHoverable, z = N === void 0 ? !0 : N, F = l || CEe, j = !!F.length, H = T === Th;
  process.env.NODE_ENV !== "production" && (["onRowClick", "onRowDoubleClick", "onRowContextMenu", "onRowMouseEnter", "onRowMouseLeave"].forEach(function(Ft) {
    jt(n[Ft] === void 0, "`".concat(Ft, "` is removed, please use `onRow` instead."));
  }), jt(!("getBodyWrapper" in n), "`getBodyWrapper` is deprecated, please use custom `components` instead."));
  var U = p.useCallback(function(Ft, rr) {
    return Bi(b, Ft) || rr;
  }, [b]), G = p.useMemo(function() {
    return typeof c == "function" ? c : function(Ft) {
      var rr = Ft && Ft[c];
      return process.env.NODE_ENV !== "production" && jt(rr !== void 0, "Each record in table should have a unique `key` prop, or set `rowKey` to an unique primary key."), rr;
    };
  }, [c]), V = U(["body"]), K = vEe(), Z = ye(K, 3), ee = Z[0], ae = Z[1], ue = Z[2], re = fEe(n, F, G), oe = ye(re, 6), fe = oe[0], le = oe[1], se = oe[2], Q = oe[3], he = oe[4], ne = oe[5], me = u?.x, k = p.useState(0), M = ye(k, 2), R = M[0], q = M[1], Y = cEe(ce(ce(ce({}, n), fe), {}, {
    expandable: !!fe.expandedRowRender,
    columnTitle: fe.columnTitle,
    expandedKeys: se,
    getRowKey: G,
    // https://github.com/ant-design/ant-design/issues/23894
    onTriggerExpand: ne,
    expandIcon: Q,
    expandIconColumnIndex: fe.expandIconColumnIndex,
    direction: f,
    scrollWidth: H && D && typeof me == "number" ? me : null,
    clientWidth: R
  }), H ? I : null), X = ye(Y, 4), pe = X[0], $e = X[1], J = X[2], de = X[3], Se = J ?? me, Ee = p.useMemo(function() {
    return {
      columns: pe,
      flattenColumns: $e
    };
  }, [pe, $e]), Te = p.useRef(), Le = p.useRef(), Ie = p.useRef(), De = p.useRef();
  p.useImperativeHandle(t, function() {
    return {
      nativeElement: Te.current,
      scrollTo: function(rr) {
        var pn;
        if (Ie.current instanceof HTMLElement) {
          var Wn = rr.index, $n = rr.top, di = rr.key;
          if ($n) {
            var fi;
            (fi = Ie.current) === null || fi === void 0 || fi.scrollTo({
              top: $n
            });
          } else {
            var Oi, Wi = di ?? G(F[Wn]);
            (Oi = Ie.current.querySelector('[data-row-key="'.concat(Wi, '"]'))) === null || Oi === void 0 || Oi.scrollIntoView();
          }
        } else (pn = Ie.current) !== null && pn !== void 0 && pn.scrollTo && Ie.current.scrollTo(rr);
      }
    };
  });
  var Ae = p.useRef(), Fe = p.useState(!1), Ne = ye(Fe, 2), qe = Ne[0], Qe = Ne[1], tt = p.useState(!1), Ge = ye(tt, 2), it = Ge[0], ht = Ge[1], It = iW(/* @__PURE__ */ new Map()), xt = ye(It, 2), Xe = xt[0], pt = xt[1], Ze = Q1($e), wt = Ze.map(function(Ft) {
    return Xe.get(Ft);
  }), bt = p.useMemo(function() {
    return wt;
  }, [wt.join("_")]), Je = gEe(bt, $e, f), _t = u && mE(u.y), Vt = u && mE(Se) || !!fe.fixed, ot = Vt && $e.some(function(Ft) {
    var rr = Ft.fixed;
    return rr;
  }), Ct = p.useRef(), rt = hEe(L, a), $t = rt.isSticky, Wt = rt.offsetHeader, _e = rt.offsetSummary, Ke = rt.offsetScroll, nt = rt.stickyClassName, Ve = rt.container, ke = p.useMemo(function() {
    return g?.(F);
  }, [g, F]), ut = (_t || $t) && /* @__PURE__ */ p.isValidElement(ke) && ke.type === eC && ke.props.fixed, st, Et, zt;
  _t && (Et = {
    overflowY: "scroll",
    maxHeight: u.y
  }), Vt && (st = {
    overflowX: "auto"
  }, _t || (Et = {
    overflowY: "hidden"
  }), zt = {
    width: Se === !0 ? "auto" : Se,
    minWidth: "100%"
  });
  var Be = p.useCallback(function(Ft, rr) {
    yd(Te.current) && pt(function(pn) {
      if (pn.get(Ft) !== rr) {
        var Wn = new Map(pn);
        return Wn.set(Ft, rr), Wn;
      }
      return pn;
    });
  }, []), ft = mEe(), yt = ye(ft, 2), Rt = yt[0], Ht = yt[1];
  function ir(Ft, rr) {
    rr && (typeof rr == "function" ? rr(Ft) : rr.scrollLeft !== Ft && (rr.scrollLeft = Ft, rr.scrollLeft !== Ft && setTimeout(function() {
      rr.scrollLeft = Ft;
    }, 0)));
  }
  var ar = br(function(Ft) {
    var rr = Ft.currentTarget, pn = Ft.scrollLeft, Wn = f === "rtl", $n = typeof pn == "number" ? pn : rr.scrollLeft, di = rr || SEe;
    if (!Ht() || Ht() === di) {
      var fi;
      Rt(di), ir($n, Le.current), ir($n, Ie.current), ir($n, Ae.current), ir($n, (fi = Ct.current) === null || fi === void 0 ? void 0 : fi.setScrollLeft);
    }
    var Oi = rr || Le.current;
    if (Oi) {
      var Wi = Oi.scrollWidth, hs = Oi.clientWidth;
      if (Wi === hs) {
        Qe(!1), ht(!1);
        return;
      }
      Wn ? (Qe(-$n < Wi - hs), ht(-$n > 0)) : (Qe($n > 0), ht($n < Wi - hs));
    }
  }), Nr = br(function(Ft) {
    ar(Ft), O?.(Ft);
  }), Xr = function() {
    Vt && Ie.current ? ar({
      currentTarget: Ie.current
    }) : (Qe(!1), ht(!1));
  }, Qr = function(rr) {
    var pn, Wn = rr.width;
    (pn = Ct.current) === null || pn === void 0 || pn.checkScrollBarVisible();
    var $n = Te.current ? Te.current.offsetWidth : Wn;
    H && B && Te.current && ($n = B(Te.current, $n) || $n), $n !== R && (Xr(), q($n));
  }, Ur = p.useRef(!1);
  p.useEffect(function() {
    Ur.current && Xr();
  }, [Vt, l, pe.length]), p.useEffect(function() {
    Ur.current = !0;
  }, []);
  var gn = p.useState(0), Zt = ye(gn, 2), er = Zt[0], _r = Zt[1], Sn = p.useState(!0), On = ye(Sn, 2), Un = On[0], oa = On[1];
  p.useEffect(function() {
    (!D || !H) && (Ie.current instanceof Element ? _r(R2(Ie.current).width) : _r(R2(De.current).width)), oa(N2("position", "sticky"));
  }, []), p.useEffect(function() {
    H && P && (P.body.current = Ie.current);
  });
  var va = p.useCallback(function(Ft) {
    return /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement(w4, Ft), ut === "top" && /* @__PURE__ */ p.createElement(cy, Ft, ke));
  }, [ut, ke]), Fn = p.useCallback(function(Ft) {
    return /* @__PURE__ */ p.createElement(cy, Ft, ke);
  }, [ke]), or = U(["table"], "table"), tr = p.useMemo(function() {
    return d || (ot ? Se === "max-content" ? "auto" : "fixed" : _t || $t || $e.some(function(Ft) {
      var rr = Ft.ellipsis;
      return rr;
    }) ? "fixed" : "auto");
  }, [_t, ot, $e, d, $t]), Jr, tn = {
    colWidths: bt,
    columCount: $e.length,
    stickyOffsets: Je,
    onHeaderRow: w,
    fixHeader: _t,
    scroll: u
  }, zr = p.useMemo(function() {
    return j ? null : typeof _ == "function" ? _() : _;
  }, [j, _]), cr = /* @__PURE__ */ p.createElement(X2e, {
    data: F,
    measureColumnWidth: _t || Vt || $t
  }), Ot = /* @__PURE__ */ p.createElement(tW, {
    colWidths: $e.map(function(Ft) {
      var rr = Ft.width;
      return rr;
    }),
    columns: $e
  }), Tt = y != null ? /* @__PURE__ */ p.createElement("caption", {
    className: "".concat(a, "-caption")
  }, y) : void 0, Sr = aa(n, {
    data: !0
  }), Mr = aa(n, {
    aria: !0
  });
  if (_t || $t) {
    var en;
    typeof V == "function" ? (en = V(F, {
      scrollbarSize: er,
      ref: Ie,
      onScroll: ar
    }), tn.colWidths = $e.map(function(Ft, rr) {
      var pn = Ft.width, Wn = rr === $e.length - 1 ? pn - er : pn;
      return typeof Wn == "number" && !Number.isNaN(Wn) ? Wn : (process.env.NODE_ENV !== "production" && jt(n.columns.length === 0, "When use `components.body` with render props. Each column should have a fixed `width` value."), 0);
    })) : en = /* @__PURE__ */ p.createElement("div", {
      style: ce(ce({}, st), Et),
      onScroll: Nr,
      ref: Ie,
      className: be("".concat(a, "-body"))
    }, /* @__PURE__ */ p.createElement(or, Pe({
      style: ce(ce({}, zt), {}, {
        tableLayout: tr
      })
    }, Mr), Tt, Ot, cr, !ut && ke && /* @__PURE__ */ p.createElement(cy, {
      stickyOffsets: Je,
      flattenColumns: $e
    }, ke)));
    var Rn = ce(ce(ce({
      noData: !F.length,
      maxContentScroll: Vt && Se === "max-content"
    }, tn), Ee), {}, {
      direction: f,
      stickyClassName: nt,
      onScroll: ar
    });
    Jr = /* @__PURE__ */ p.createElement(p.Fragment, null, x !== !1 && /* @__PURE__ */ p.createElement(E4, Pe({}, Rn, {
      stickyTopOffset: Wt,
      className: "".concat(a, "-header"),
      ref: Le
    }), va), en, ut && ut !== "top" && /* @__PURE__ */ p.createElement(E4, Pe({}, Rn, {
      stickyBottomOffset: _e,
      className: "".concat(a, "-summary"),
      ref: Ae
    }), Fn), $t && Ie.current && Ie.current instanceof Element && /* @__PURE__ */ p.createElement(bEe, {
      ref: Ct,
      offsetScroll: Ke,
      scrollBodyRef: Ie,
      onScroll: ar,
      container: Ve
    }));
  } else
    Jr = /* @__PURE__ */ p.createElement("div", {
      style: ce(ce({}, st), Et),
      className: be("".concat(a, "-content")),
      onScroll: ar,
      ref: Ie
    }, /* @__PURE__ */ p.createElement(or, Pe({
      style: ce(ce({}, zt), {}, {
        tableLayout: tr
      })
    }, Mr), Tt, Ot, x !== !1 && /* @__PURE__ */ p.createElement(w4, Pe({}, tn, Ee)), cr, ke && /* @__PURE__ */ p.createElement(cy, {
      stickyOffsets: Je,
      flattenColumns: $e
    }, ke)));
  var sr = /* @__PURE__ */ p.createElement("div", Pe({
    className: be(a, i, (r = {}, te(r, "".concat(a, "-rtl"), f === "rtl"), te(r, "".concat(a, "-ping-left"), qe), te(r, "".concat(a, "-ping-right"), it), te(r, "".concat(a, "-layout-fixed"), d === "fixed"), te(r, "".concat(a, "-fixed-header"), _t), te(r, "".concat(a, "-fixed-column"), ot), te(r, "".concat(a, "-fixed-column-gapped"), ot && de), te(r, "".concat(a, "-scroll-horizontal"), Vt), te(r, "".concat(a, "-has-fix-left"), $e[0] && $e[0].fixed), te(r, "".concat(a, "-has-fix-right"), $e[$e.length - 1] && $e[$e.length - 1].fixed === "right"), r)),
    style: s,
    id: S,
    ref: Te
  }, Sr), m && /* @__PURE__ */ p.createElement(I4, {
    className: "".concat(a, "-title")
  }, m(F)), /* @__PURE__ */ p.createElement("div", {
    ref: De,
    className: "".concat(a, "-container")
  }, Jr), h && /* @__PURE__ */ p.createElement(I4, {
    className: "".concat(a, "-footer")
  }, h(F)));
  Vt && (sr = /* @__PURE__ */ p.createElement(Ia, {
    onResize: Qr
  }, sr));
  var qt = pEe($e, Je, f), gr = p.useMemo(function() {
    return {
      // Scroll
      scrollX: Se,
      // Table
      prefixCls: a,
      getComponent: U,
      scrollbarSize: er,
      direction: f,
      fixedInfoList: qt,
      isSticky: $t,
      supportSticky: Un,
      componentWidth: R,
      fixHeader: _t,
      fixColumn: ot,
      horizonScroll: Vt,
      // Body
      tableLayout: tr,
      rowClassName: o,
      expandedRowClassName: fe.expandedRowClassName,
      expandIcon: Q,
      expandableType: le,
      expandRowByClick: fe.expandRowByClick,
      expandedRowRender: fe.expandedRowRender,
      onTriggerExpand: ne,
      expandIconColumnIndex: fe.expandIconColumnIndex,
      indentSize: fe.indentSize,
      allColumnsFixedLeft: $e.every(function(Ft) {
        return Ft.fixed === "left";
      }),
      emptyNode: zr,
      // Column
      columns: pe,
      flattenColumns: $e,
      onColumnResize: Be,
      // Row
      hoverStartRow: ee,
      hoverEndRow: ae,
      onHover: ue,
      rowExpandable: fe.rowExpandable,
      onRow: $,
      getRowKey: G,
      expandedKeys: se,
      childrenColumnName: he,
      rowHoverable: z
    };
  }, [
    // Scroll
    Se,
    // Table
    a,
    U,
    er,
    f,
    qt,
    $t,
    Un,
    R,
    _t,
    ot,
    Vt,
    // Body
    tr,
    o,
    fe.expandedRowClassName,
    Q,
    le,
    fe.expandRowByClick,
    fe.expandedRowRender,
    ne,
    fe.expandIconColumnIndex,
    fe.indentSize,
    zr,
    // Column
    pe,
    $e,
    Be,
    // Row
    ee,
    ae,
    ue,
    fe.rowExpandable,
    $,
    G,
    se,
    he,
    z
  ]);
  return /* @__PURE__ */ p.createElement(xi.Provider, {
    value: gr
  }, sr);
}
var sW = /* @__PURE__ */ p.forwardRef($Ee);
process.env.NODE_ENV !== "production" && (sW.displayName = "Table");
function lW(e) {
  return VU(sW, e);
}
var Md = lW();
Md.EXPAND_COLUMN = es;
Md.INTERNAL_HOOKS = Th;
Md.Column = W2e;
Md.ColumnGroup = q2e;
Md.Summary = qU;
var qI = VI(null), cW = VI(null);
function _Ee(e, t, r) {
  var n = t || 1;
  return r[e + n] - (r[e] || 0);
}
function EEe(e) {
  var t = e.rowInfo, r = e.column, n = e.colIndex, a = e.indent, i = e.index, o = e.component, s = e.renderIndex, l = e.record, c = e.style, u = e.className, d = e.inverse, f = e.getHeight, m = r.render, h = r.dataIndex, g = r.className, y = r.width, S = Ka(cW, ["columnsOffset"]), x = S.columnsOffset, b = JU(t, r, n, a, i), _ = b.key, $ = b.fixedInfo, w = b.appendCellNode, O = b.additionalCellProps, T = O.style, I = O.colSpan, P = I === void 0 ? 1 : I, D = O.rowSpan, B = D === void 0 ? 1 : D, L = n - 1, N = _Ee(L, P, x), z = P > 1 ? y - N : 0, F = ce(ce(ce({}, T), c), {}, {
    flex: "0 0 ".concat(N, "px"),
    width: "".concat(N, "px"),
    marginRight: z,
    pointerEvents: "auto"
  }), j = p.useMemo(function() {
    return d ? B <= 1 : P === 0 || B === 0 || B > 1;
  }, [B, P, d]);
  j ? F.visibility = "hidden" : d && (F.height = f?.(B));
  var H = j ? function() {
    return null;
  } : m, U = {};
  return (B === 0 || P === 0) && (U.rowSpan = 1, U.colSpan = 1), /* @__PURE__ */ p.createElement(Hc, Pe({
    className: be(g, u),
    ellipsis: r.ellipsis,
    align: r.align,
    scope: r.rowScope,
    component: o,
    prefixCls: t.prefixCls,
    key: _,
    record: l,
    index: i,
    renderIndex: s,
    dataIndex: h,
    render: H,
    shouldCellUpdate: r.shouldCellUpdate
  }, $, {
    appendNode: w,
    additionalProps: ce(ce({}, O), {}, {
      style: F
    }, U)
  }));
}
var wEe = ["data", "index", "className", "rowKey", "style", "extra", "getHeight"], OEe = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.data, n = e.index, a = e.className, i = e.rowKey, o = e.style, s = e.extra, l = e.getHeight, c = Kt(e, wEe), u = r.record, d = r.indent, f = r.index, m = Ka(xi, ["prefixCls", "flattenColumns", "fixColumn", "componentWidth", "scrollX"]), h = m.scrollX, g = m.flattenColumns, y = m.prefixCls, S = m.fixColumn, x = m.componentWidth, b = Ka(qI, ["getComponent"]), _ = b.getComponent, $ = ZU(u, i, n, d), w = _(["body", "row"], "div"), O = _(["body", "cell"], "div"), T = $.rowSupportExpand, I = $.expanded, P = $.rowProps, D = $.expandedRowRender, B = $.expandedRowClassName, L;
  if (T && I) {
    var N = D(u, n, d + 1, I), z = B?.(u, n, d), F = {};
    S && (F = {
      style: te({}, "--virtual-width", "".concat(x, "px"))
    });
    var j = "".concat(y, "-expanded-row-cell");
    L = /* @__PURE__ */ p.createElement(w, {
      className: be("".concat(y, "-expanded-row"), "".concat(y, "-expanded-row-level-").concat(d + 1), z)
    }, /* @__PURE__ */ p.createElement(Hc, {
      component: O,
      prefixCls: y,
      className: be(j, te({}, "".concat(j, "-fixed"), S)),
      additionalProps: F
    }, N));
  }
  var H = ce(ce({}, o), {}, {
    width: h
  });
  s && (H.position = "absolute", H.pointerEvents = "none");
  var U = /* @__PURE__ */ p.createElement(w, Pe({}, P, c, {
    "data-row-key": i,
    ref: T ? null : t,
    className: be(a, "".concat(y, "-row"), P?.className, te({}, "".concat(y, "-row-extra"), s)),
    style: ce(ce({}, H), P?.style)
  }), g.map(function(G, V) {
    return /* @__PURE__ */ p.createElement(EEe, {
      key: V,
      component: O,
      rowInfo: $,
      column: G,
      colIndex: V,
      indent: d,
      index: n,
      renderIndex: f,
      record: u,
      inverse: s,
      getHeight: l
    });
  }));
  return T ? /* @__PURE__ */ p.createElement("div", {
    ref: t
  }, U, L) : U;
}), hE = Id(OEe);
process.env.NODE_ENV !== "production" && (hE.displayName = "BodyLine");
var TEe = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.data, n = e.onScroll, a = Ka(xi, ["flattenColumns", "onColumnResize", "getRowKey", "prefixCls", "expandedKeys", "childrenColumnName", "emptyNode", "scrollX"]), i = a.flattenColumns, o = a.onColumnResize, s = a.getRowKey, l = a.expandedKeys, c = a.prefixCls, u = a.childrenColumnName, d = a.emptyNode, f = a.scrollX, m = Ka(qI), h = m.sticky, g = m.scrollY, y = m.listItemHeight, S = m.getComponent, x = m.onScroll, b = p.useRef(), _ = YU(r, u, l, s), $ = p.useMemo(function() {
    var F = 0;
    return i.map(function(j) {
      var H = j.width, U = j.key;
      return F += H, [U, H, F];
    });
  }, [i]), w = p.useMemo(function() {
    return $.map(function(F) {
      return F[2];
    });
  }, [$]);
  p.useEffect(function() {
    $.forEach(function(F) {
      var j = ye(F, 2), H = j[0], U = j[1];
      o(H, U);
    });
  }, [$]), p.useImperativeHandle(t, function() {
    var F = {
      scrollTo: function(H) {
        var U;
        (U = b.current) === null || U === void 0 || U.scrollTo(H);
      }
    };
    return Object.defineProperty(F, "scrollLeft", {
      get: function() {
        var H;
        return ((H = b.current) === null || H === void 0 ? void 0 : H.getScrollInfo().x) || 0;
      },
      set: function(H) {
        var U;
        (U = b.current) === null || U === void 0 || U.scrollTo({
          left: H
        });
      }
    }), F;
  });
  var O = function(j, H) {
    var U, G = (U = _[H]) === null || U === void 0 ? void 0 : U.record, V = j.onCell;
    if (V) {
      var K, Z = V(G, H);
      return (K = Z?.rowSpan) !== null && K !== void 0 ? K : 1;
    }
    return 1;
  }, T = function(j) {
    var H = j.start, U = j.end, G = j.getSize, V = j.offsetY;
    if (U < 0)
      return null;
    for (var K = i.filter(
      // rowSpan is 0
      function(ne) {
        return O(ne, H) === 0;
      }
    ), Z = H, ee = function(me) {
      if (K = K.filter(function(k) {
        return O(k, me) === 0;
      }), !K.length)
        return Z = me, 1;
    }, ae = H; ae >= 0 && !ee(ae); ae -= 1)
      ;
    for (var ue = i.filter(
      // rowSpan is not 1
      function(ne) {
        return O(ne, U) !== 1;
      }
    ), re = U, oe = function(me) {
      if (ue = ue.filter(function(k) {
        return O(k, me) !== 1;
      }), !ue.length)
        return re = Math.max(me - 1, U), 1;
    }, fe = U; fe < _.length && !oe(fe); fe += 1)
      ;
    for (var le = [], se = function(me) {
      var k = _[me];
      if (!k)
        return 1;
      i.some(function(M) {
        return O(M, me) > 1;
      }) && le.push(me);
    }, Q = Z; Q <= re; Q += 1)
      se(Q);
    var he = le.map(function(ne) {
      var me = _[ne], k = s(me.record, ne), M = function(Y) {
        var X = ne + Y - 1, pe = s(_[X].record, X), $e = G(k, pe);
        return $e.bottom - $e.top;
      }, R = G(k);
      return /* @__PURE__ */ p.createElement(hE, {
        key: ne,
        data: me,
        rowKey: k,
        index: ne,
        style: {
          top: -V + R.top
        },
        extra: !0,
        getHeight: M
      });
    });
    return he;
  }, I = p.useMemo(function() {
    return {
      columnsOffset: w
    };
  }, [w]), P = "".concat(c, "-tbody"), D = S(["body", "wrapper"]), B = S(["body", "row"], "div"), L = S(["body", "cell"], "div"), N;
  if (_.length) {
    var z = {};
    h && (z.position = "sticky", z.bottom = 0, kt(h) === "object" && h.offsetScroll && (z.bottom = h.offsetScroll)), N = /* @__PURE__ */ p.createElement(D1, {
      fullHeight: !1,
      ref: b,
      prefixCls: "".concat(P, "-virtual"),
      styles: {
        horizontalScrollBar: z
      },
      className: P,
      height: g,
      itemHeight: y || 24,
      data: _,
      itemKey: function(j) {
        return s(j.record);
      },
      component: D,
      scrollWidth: f,
      onVirtualScroll: function(j) {
        var H = j.x;
        n({
          scrollLeft: H
        });
      },
      onScroll: x,
      extraRender: T
    }, function(F, j, H) {
      var U = s(F.record, j);
      return /* @__PURE__ */ p.createElement(hE, {
        data: F,
        rowKey: U,
        index: j,
        style: H.style
      });
    });
  } else
    N = /* @__PURE__ */ p.createElement(B, {
      className: be("".concat(c, "-placeholder"))
    }, /* @__PURE__ */ p.createElement(Hc, {
      component: L,
      prefixCls: c
    }, d));
  return /* @__PURE__ */ p.createElement(cW.Provider, {
    value: I
  }, N);
}), uW = Id(TEe);
process.env.NODE_ENV !== "production" && (uW.displayName = "ResponseGrid");
var IEe = function(t, r) {
  var n = r.ref, a = r.onScroll;
  return /* @__PURE__ */ p.createElement(uW, {
    ref: n,
    data: t,
    onScroll: a
  });
};
function MEe(e, t) {
  var r = e.columns, n = e.scroll, a = e.sticky, i = e.prefixCls, o = i === void 0 ? oW : i, s = e.className, l = e.listItemHeight, c = e.components, u = e.onScroll, d = n || {}, f = d.x, m = d.y;
  typeof f != "number" && (process.env.NODE_ENV !== "production" && jt(!f, "`scroll.x` in virtual table must be number."), f = 1), typeof m != "number" && (m = 500, process.env.NODE_ENV !== "production" && jt(!1, "`scroll.y` in virtual table must be number."));
  var h = br(function(S, x) {
    return Bi(c, S) || x;
  }), g = br(u), y = p.useMemo(function() {
    return {
      sticky: a,
      scrollY: m,
      listItemHeight: l,
      getComponent: h,
      onScroll: g
    };
  }, [a, m, l, h, g]);
  return /* @__PURE__ */ p.createElement(qI.Provider, {
    value: y
  }, /* @__PURE__ */ p.createElement(Md, Pe({}, e, {
    className: be(s, "".concat(o, "-virtual")),
    scroll: ce(ce({}, n), {}, {
      x: f
    }),
    components: ce(ce({}, c), {}, {
      body: IEe
    }),
    columns: r,
    internalHooks: Th,
    tailor: !0,
    ref: t
  })));
}
var dW = /* @__PURE__ */ p.forwardRef(MEe);
process.env.NODE_ENV !== "production" && (dW.displayName = "VirtualTable");
function fW(e) {
  return VU(dW, e);
}
fW();
function AEe(e) {
  return null;
}
function PEe(e) {
  return null;
}
var KI = /* @__PURE__ */ p.createContext(null), REe = function(t) {
  for (var r = t.prefixCls, n = t.level, a = t.isStart, i = t.isEnd, o = "".concat(r, "-indent-unit"), s = [], l = 0; l < n; l += 1)
    s.push(/* @__PURE__ */ p.createElement("span", {
      key: l,
      className: be(o, te(te({}, "".concat(o, "-start"), a[l]), "".concat(o, "-end"), i[l]))
    }));
  return /* @__PURE__ */ p.createElement("span", {
    "aria-hidden": "true",
    className: "".concat(r, "-indent")
  }, s);
};
const NEe = /* @__PURE__ */ p.memo(REe);
var DEe = ["eventKey", "className", "style", "dragOver", "dragOverGapTop", "dragOverGapBottom", "isLeaf", "isStart", "isEnd", "expanded", "selected", "checked", "halfChecked", "loading", "domRef", "active", "data", "onMouseMove", "selectable"], M4 = "open", A4 = "close", jEe = "---", LEe = /* @__PURE__ */ function(e) {
  ds(r, e);
  var t = fs(r);
  function r() {
    var n;
    Hn(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), te(at(n), "state", {
      dragNodeHighlight: !1
    }), te(at(n), "selectHandle", void 0), te(at(n), "cacheIndent", void 0), te(at(n), "onSelectorClick", function(s) {
      var l = n.props.context.onNodeClick;
      l(s, la(n.props)), n.isSelectable() ? n.onSelect(s) : n.onCheck(s);
    }), te(at(n), "onSelectorDoubleClick", function(s) {
      var l = n.props.context.onNodeDoubleClick;
      l(s, la(n.props));
    }), te(at(n), "onSelect", function(s) {
      if (!n.isDisabled()) {
        var l = n.props.context.onNodeSelect;
        l(s, la(n.props));
      }
    }), te(at(n), "onCheck", function(s) {
      if (!n.isDisabled()) {
        var l = n.props, c = l.disableCheckbox, u = l.checked, d = n.props.context.onNodeCheck;
        if (!(!n.isCheckable() || c)) {
          var f = !u;
          d(s, la(n.props), f);
        }
      }
    }), te(at(n), "onMouseEnter", function(s) {
      var l = n.props.context.onNodeMouseEnter;
      l(s, la(n.props));
    }), te(at(n), "onMouseLeave", function(s) {
      var l = n.props.context.onNodeMouseLeave;
      l(s, la(n.props));
    }), te(at(n), "onContextMenu", function(s) {
      var l = n.props.context.onNodeContextMenu;
      l(s, la(n.props));
    }), te(at(n), "onDragStart", function(s) {
      var l = n.props.context.onNodeDragStart;
      s.stopPropagation(), n.setState({
        dragNodeHighlight: !0
      }), l(s, at(n));
      try {
        s.dataTransfer.setData("text/plain", "");
      } catch {
      }
    }), te(at(n), "onDragEnter", function(s) {
      var l = n.props.context.onNodeDragEnter;
      s.preventDefault(), s.stopPropagation(), l(s, at(n));
    }), te(at(n), "onDragOver", function(s) {
      var l = n.props.context.onNodeDragOver;
      s.preventDefault(), s.stopPropagation(), l(s, at(n));
    }), te(at(n), "onDragLeave", function(s) {
      var l = n.props.context.onNodeDragLeave;
      s.stopPropagation(), l(s, at(n));
    }), te(at(n), "onDragEnd", function(s) {
      var l = n.props.context.onNodeDragEnd;
      s.stopPropagation(), n.setState({
        dragNodeHighlight: !1
      }), l(s, at(n));
    }), te(at(n), "onDrop", function(s) {
      var l = n.props.context.onNodeDrop;
      s.preventDefault(), s.stopPropagation(), n.setState({
        dragNodeHighlight: !1
      }), l(s, at(n));
    }), te(at(n), "onExpand", function(s) {
      var l = n.props, c = l.loading, u = l.context.onNodeExpand;
      c || u(s, la(n.props));
    }), te(at(n), "setSelectHandle", function(s) {
      n.selectHandle = s;
    }), te(at(n), "getNodeState", function() {
      var s = n.props.expanded;
      return n.isLeaf() ? null : s ? M4 : A4;
    }), te(at(n), "hasChildren", function() {
      var s = n.props.eventKey, l = n.props.context.keyEntities, c = yi(l, s) || {}, u = c.children;
      return !!(u || []).length;
    }), te(at(n), "isLeaf", function() {
      var s = n.props, l = s.isLeaf, c = s.loaded, u = n.props.context.loadData, d = n.hasChildren();
      return l === !1 ? !1 : l || !u && !d || u && c && !d;
    }), te(at(n), "isDisabled", function() {
      var s = n.props.disabled, l = n.props.context.disabled;
      return !!(l || s);
    }), te(at(n), "isCheckable", function() {
      var s = n.props.checkable, l = n.props.context.checkable;
      return !l || s === !1 ? !1 : l;
    }), te(at(n), "syncLoadData", function(s) {
      var l = s.expanded, c = s.loading, u = s.loaded, d = n.props.context, f = d.loadData, m = d.onNodeLoad;
      c || f && l && !n.isLeaf() && !u && m(la(n.props));
    }), te(at(n), "isDraggable", function() {
      var s = n.props, l = s.data, c = s.context.draggable;
      return !!(c && (!c.nodeDraggable || c.nodeDraggable(l)));
    }), te(at(n), "renderDragHandler", function() {
      var s = n.props.context, l = s.draggable, c = s.prefixCls;
      return l != null && l.icon ? /* @__PURE__ */ p.createElement("span", {
        className: "".concat(c, "-draggable-icon")
      }, l.icon) : null;
    }), te(at(n), "renderSwitcherIconDom", function(s) {
      var l = n.props.switcherIcon, c = n.props.context.switcherIcon, u = l || c;
      return typeof u == "function" ? u(ce(ce({}, n.props), {}, {
        isLeaf: s
      })) : u;
    }), te(at(n), "renderSwitcher", function() {
      var s = n.props.expanded, l = n.props.context.prefixCls;
      if (n.isLeaf()) {
        var c = n.renderSwitcherIconDom(!0);
        return c !== !1 ? /* @__PURE__ */ p.createElement("span", {
          className: be("".concat(l, "-switcher"), "".concat(l, "-switcher-noop"))
        }, c) : null;
      }
      var u = be("".concat(l, "-switcher"), "".concat(l, "-switcher_").concat(s ? M4 : A4)), d = n.renderSwitcherIconDom(!1);
      return d !== !1 ? /* @__PURE__ */ p.createElement("span", {
        onClick: n.onExpand,
        className: u
      }, d) : null;
    }), te(at(n), "renderCheckbox", function() {
      var s = n.props, l = s.checked, c = s.halfChecked, u = s.disableCheckbox, d = n.props.context.prefixCls, f = n.isDisabled(), m = n.isCheckable();
      if (!m) return null;
      var h = typeof m != "boolean" ? m : null;
      return /* @__PURE__ */ p.createElement("span", {
        className: be("".concat(d, "-checkbox"), l && "".concat(d, "-checkbox-checked"), !l && c && "".concat(d, "-checkbox-indeterminate"), (f || u) && "".concat(d, "-checkbox-disabled")),
        onClick: n.onCheck
      }, h);
    }), te(at(n), "renderIcon", function() {
      var s = n.props.loading, l = n.props.context.prefixCls;
      return /* @__PURE__ */ p.createElement("span", {
        className: be("".concat(l, "-iconEle"), "".concat(l, "-icon__").concat(n.getNodeState() || "docu"), s && "".concat(l, "-icon_loading"))
      });
    }), te(at(n), "renderSelector", function() {
      var s = n.state.dragNodeHighlight, l = n.props, c = l.title, u = c === void 0 ? jEe : c, d = l.selected, f = l.icon, m = l.loading, h = l.data, g = n.props.context, y = g.prefixCls, S = g.showIcon, x = g.icon, b = g.loadData, _ = g.titleRender, $ = n.isDisabled(), w = "".concat(y, "-node-content-wrapper"), O;
      if (S) {
        var T = f || x;
        O = T ? /* @__PURE__ */ p.createElement("span", {
          className: be("".concat(y, "-iconEle"), "".concat(y, "-icon__customize"))
        }, typeof T == "function" ? T(n.props) : T) : n.renderIcon();
      } else b && m && (O = n.renderIcon());
      var I;
      typeof u == "function" ? I = u(h) : _ ? I = _(h) : I = u;
      var P = /* @__PURE__ */ p.createElement("span", {
        className: "".concat(y, "-title")
      }, I);
      return /* @__PURE__ */ p.createElement("span", {
        ref: n.setSelectHandle,
        title: typeof u == "string" ? u : "",
        className: be("".concat(w), "".concat(w, "-").concat(n.getNodeState() || "normal"), !$ && (d || s) && "".concat(y, "-node-selected")),
        onMouseEnter: n.onMouseEnter,
        onMouseLeave: n.onMouseLeave,
        onContextMenu: n.onContextMenu,
        onClick: n.onSelectorClick,
        onDoubleClick: n.onSelectorDoubleClick
      }, O, P, n.renderDropIndicator());
    }), te(at(n), "renderDropIndicator", function() {
      var s = n.props, l = s.disabled, c = s.eventKey, u = n.props.context, d = u.draggable, f = u.dropLevelOffset, m = u.dropPosition, h = u.prefixCls, g = u.indent, y = u.dropIndicatorRender, S = u.dragOverNodeKey, x = u.direction, b = !!d, _ = !l && b && S === c, $ = g ?? n.cacheIndent;
      return n.cacheIndent = g, _ ? y({
        dropPosition: m,
        dropLevelOffset: f,
        indent: $,
        prefixCls: h,
        direction: x
      }) : null;
    }), n;
  }
  return Vn(r, [{
    key: "componentDidMount",
    value: (
      // Isomorphic needn't load data in server side
      function() {
        this.syncLoadData(this.props);
      }
    )
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.syncLoadData(this.props);
    }
  }, {
    key: "isSelectable",
    value: function() {
      var a = this.props.selectable, i = this.props.context.selectable;
      return typeof a == "boolean" ? a : i;
    }
  }, {
    key: "render",
    value: (
      // =========================== Render ===========================
      function() {
        var a, i = this.props, o = i.eventKey, s = i.className, l = i.style, c = i.dragOver, u = i.dragOverGapTop, d = i.dragOverGapBottom, f = i.isLeaf, m = i.isStart, h = i.isEnd, g = i.expanded, y = i.selected, S = i.checked, x = i.halfChecked, b = i.loading, _ = i.domRef, $ = i.active;
        i.data;
        var w = i.onMouseMove, O = i.selectable, T = Kt(i, DEe), I = this.props.context, P = I.prefixCls, D = I.filterTreeNode, B = I.keyEntities, L = I.dropContainerKey, N = I.dropTargetKey, z = I.draggingNodeKey, F = this.isDisabled(), j = aa(T, {
          aria: !0,
          data: !0
        }), H = yi(B, o) || {}, U = H.level, G = h[h.length - 1], V = this.isDraggable(), K = !F && V, Z = z === o, ee = O !== void 0 ? {
          "aria-selected": !!O
        } : void 0;
        return /* @__PURE__ */ p.createElement("div", Pe({
          ref: _,
          className: be(s, "".concat(P, "-treenode"), (a = {}, te(te(te(te(te(te(te(te(te(te(a, "".concat(P, "-treenode-disabled"), F), "".concat(P, "-treenode-switcher-").concat(g ? "open" : "close"), !f), "".concat(P, "-treenode-checkbox-checked"), S), "".concat(P, "-treenode-checkbox-indeterminate"), x), "".concat(P, "-treenode-selected"), y), "".concat(P, "-treenode-loading"), b), "".concat(P, "-treenode-active"), $), "".concat(P, "-treenode-leaf-last"), G), "".concat(P, "-treenode-draggable"), V), "dragging", Z), te(te(te(te(te(te(a, "drop-target", N === o), "drop-container", L === o), "drag-over", !F && c), "drag-over-gap-top", !F && u), "drag-over-gap-bottom", !F && d), "filter-node", D && D(la(this.props))))),
          style: l,
          draggable: K,
          "aria-grabbed": Z,
          onDragStart: K ? this.onDragStart : void 0,
          onDragEnter: V ? this.onDragEnter : void 0,
          onDragOver: V ? this.onDragOver : void 0,
          onDragLeave: V ? this.onDragLeave : void 0,
          onDrop: V ? this.onDrop : void 0,
          onDragEnd: V ? this.onDragEnd : void 0,
          onMouseMove: w
        }, ee, j), /* @__PURE__ */ p.createElement(NEe, {
          prefixCls: P,
          level: U,
          isStart: m,
          isEnd: h
        }), this.renderDragHandler(), this.renderSwitcher(), this.renderCheckbox(), this.renderSelector());
      }
    )
  }]), r;
}(p.Component), dd = function(t) {
  return /* @__PURE__ */ p.createElement(KI.Consumer, null, function(r) {
    return /* @__PURE__ */ p.createElement(LEe, Pe({}, t, {
      context: r
    }));
  });
};
dd.displayName = "TreeNode";
dd.isTreeNode = 1;
function Jo(e, t) {
  if (!e) return [];
  var r = e.slice(), n = r.indexOf(t);
  return n >= 0 && r.splice(n, 1), r;
}
function Ps(e, t) {
  var r = (e || []).slice();
  return r.indexOf(t) === -1 && r.push(t), r;
}
function YI(e) {
  return e.split("-");
}
function kEe(e, t) {
  var r = [], n = yi(t, e);
  function a() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    i.forEach(function(o) {
      var s = o.key, l = o.children;
      r.push(s), a(l);
    });
  }
  return a(n.children), r;
}
function FEe(e) {
  if (e.parent) {
    var t = YI(e.pos);
    return Number(t[t.length - 1]) === e.parent.children.length - 1;
  }
  return !1;
}
function BEe(e) {
  var t = YI(e.pos);
  return Number(t[t.length - 1]) === 0;
}
function P4(e, t, r, n, a, i, o, s, l, c) {
  var u, d = e.clientX, f = e.clientY, m = e.target.getBoundingClientRect(), h = m.top, g = m.height, y = (c === "rtl" ? -1 : 1) * ((a?.x || 0) - d), S = (y - 12) / n, x = l.filter(function(F) {
    var j;
    return (j = s[F]) === null || j === void 0 || (j = j.children) === null || j === void 0 ? void 0 : j.length;
  }), b = yi(s, r.props.eventKey);
  if (f < h + g / 2) {
    var _ = o.findIndex(function(F) {
      return F.key === b.key;
    }), $ = _ <= 0 ? 0 : _ - 1, w = o[$].key;
    b = yi(s, w);
  }
  var O = b.key, T = b, I = b.key, P = 0, D = 0;
  if (!x.includes(O))
    for (var B = 0; B < S && FEe(b); B += 1)
      b = b.parent, D += 1;
  var L = t.props.data, N = b.node, z = !0;
  return BEe(b) && b.level === 0 && f < h + g / 2 && i({
    dragNode: L,
    dropNode: N,
    dropPosition: -1
  }) && b.key === r.props.eventKey ? P = -1 : (T.children || []).length && x.includes(I) ? i({
    dragNode: L,
    dropNode: N,
    dropPosition: 0
  }) ? P = 0 : z = !1 : D === 0 ? S > -1.5 ? i({
    dragNode: L,
    dropNode: N,
    dropPosition: 1
  }) ? P = 1 : z = !1 : i({
    dragNode: L,
    dropNode: N,
    dropPosition: 0
  }) ? P = 0 : i({
    dragNode: L,
    dropNode: N,
    dropPosition: 1
  }) ? P = 1 : z = !1 : i({
    dragNode: L,
    dropNode: N,
    dropPosition: 1
  }) ? P = 1 : z = !1, {
    dropPosition: P,
    dropLevelOffset: D,
    dropTargetKey: b.key,
    dropTargetPos: b.pos,
    dragOverNodeKey: I,
    dropContainerKey: P === 0 ? null : ((u = b.parent) === null || u === void 0 ? void 0 : u.key) || null,
    dropAllowed: z
  };
}
function R4(e, t) {
  if (e) {
    var r = t.multiple;
    return r ? e.slice() : e.length ? [e[0]] : e;
  }
}
function Nx(e) {
  if (!e)
    return null;
  var t;
  if (Array.isArray(e))
    t = {
      checkedKeys: e,
      halfCheckedKeys: void 0
    };
  else if (kt(e) === "object")
    t = {
      checkedKeys: e.checked || void 0,
      halfCheckedKeys: e.halfChecked || void 0
    };
  else
    return jt(!1, "`checkedKeys` is not an array or an object"), null;
  return t;
}
function gE(e, t) {
  var r = /* @__PURE__ */ new Set();
  function n(a) {
    if (!r.has(a)) {
      var i = yi(t, a);
      if (i) {
        r.add(a);
        var o = i.parent, s = i.node;
        s.disabled || o && n(o.key);
      }
    }
  }
  return (e || []).forEach(function(a) {
    n(a);
  }), ze(r);
}
function zEe(e) {
  const [t, r] = He(null);
  return [Bt((i, o, s) => {
    const l = t ?? i, c = Math.min(l || 0, i), u = Math.max(l || 0, i), d = o.slice(c, u + 1).map((h) => e(h)), f = d.some((h) => !s.has(h)), m = [];
    return d.forEach((h) => {
      f ? (s.has(h) || m.push(h), s.add(h)) : (s.delete(h), m.push(h));
    }), r(f ? u : null), m;
  }, [t]), (i) => {
    r(i);
  }];
}
const Qo = {}, yE = "SELECT_ALL", bE = "SELECT_INVERT", CE = "SELECT_NONE", N4 = [], pW = (e, t) => {
  let r = [];
  return (t || []).forEach((n) => {
    r.push(n), n && typeof n == "object" && e in n && (r = [].concat(ze(r), ze(pW(e, n[e]))));
  }), r;
}, HEe = (e, t) => {
  const {
    preserveSelectedRowKeys: r,
    selectedRowKeys: n,
    defaultSelectedRowKeys: a,
    getCheckboxProps: i,
    onChange: o,
    onSelect: s,
    onSelectAll: l,
    onSelectInvert: c,
    onSelectNone: u,
    onSelectMultiple: d,
    columnWidth: f,
    type: m,
    selections: h,
    fixed: g,
    renderCell: y,
    hideSelectAll: S,
    checkStrictly: x = !0
  } = t || {}, {
    prefixCls: b,
    data: _,
    pageData: $,
    getRecordByKey: w,
    getRowKey: O,
    expandType: T,
    childrenColumnName: I,
    locale: P,
    getPopupContainer: D
  } = e, B = xr("Table"), [L, N] = zEe((se) => se), [z, F] = Kr(n || a || N4, {
    value: n
  }), j = p.useRef(/* @__PURE__ */ new Map()), H = Bt((se) => {
    if (r) {
      const Q = /* @__PURE__ */ new Map();
      se.forEach((he) => {
        let ne = w(he);
        !ne && j.current.has(he) && (ne = j.current.get(he)), Q.set(he, ne);
      }), j.current = Q;
    }
  }, [w, r]);
  p.useEffect(() => {
    H(z);
  }, [z]);
  const {
    keyEntities: U
  } = dr(() => {
    if (x)
      return {
        keyEntities: null
      };
    let se = _;
    if (r) {
      const Q = new Set(_.map((ne, me) => O(ne, me))), he = Array.from(j.current).reduce((ne, me) => {
        let [k, M] = me;
        return Q.has(k) ? ne : ne.concat(M);
      }, []);
      se = [].concat(ze(se), ze(he));
    }
    return TI(se, {
      externalGetKey: O,
      childrenPropName: I
    });
  }, [_, O, x, I, r]), G = dr(() => pW(I, $), [I, $]), V = dr(() => {
    const se = /* @__PURE__ */ new Map();
    return G.forEach((Q, he) => {
      const ne = O(Q, he), me = (i ? i(Q) : null) || {};
      se.set(ne, me), process.env.NODE_ENV !== "production" && B(!("checked" in me || "defaultChecked" in me), "usage", "Do not set `checked` or `defaultChecked` in `getCheckboxProps`. Please use `selectedRowKeys` instead.");
    }), se;
  }, [G, O, i]), K = Bt((se) => {
    var Q;
    return !!(!((Q = V.get(O(se))) === null || Q === void 0) && Q.disabled);
  }, [V, O]), [Z, ee] = dr(() => {
    if (x)
      return [z || [], []];
    const {
      checkedKeys: se,
      halfCheckedKeys: Q
    } = rd(z, !0, U, K);
    return [se || [], Q];
  }, [z, x, U, K]), ae = dr(() => {
    const se = m === "radio" ? Z.slice(0, 1) : Z;
    return new Set(se);
  }, [Z, m]), ue = dr(() => m === "radio" ? /* @__PURE__ */ new Set() : new Set(ee), [ee, m]);
  p.useEffect(() => {
    t || F(N4);
  }, [!!t]);
  const re = Bt((se, Q) => {
    let he, ne;
    H(se), r ? (he = se, ne = se.map((me) => j.current.get(me))) : (he = [], ne = [], se.forEach((me) => {
      const k = w(me);
      k !== void 0 && (he.push(me), ne.push(k));
    })), F(he), o?.(he, ne, {
      type: Q
    });
  }, [F, w, o, r]), oe = Bt((se, Q, he, ne) => {
    if (s) {
      const me = he.map((k) => w(k));
      s(w(se), Q, me, ne);
    }
    re(he, "single");
  }, [s, w, re]), fe = dr(() => !h || S ? null : (h === !0 ? [yE, bE, CE] : h).map((Q) => Q === yE ? {
    key: "all",
    text: P.selectionAll,
    onSelect() {
      re(_.map((he, ne) => O(he, ne)).filter((he) => {
        const ne = V.get(he);
        return !ne?.disabled || ae.has(he);
      }), "all");
    }
  } : Q === bE ? {
    key: "invert",
    text: P.selectInvert,
    onSelect() {
      const he = new Set(ae);
      $.forEach((me, k) => {
        const M = O(me, k), R = V.get(M);
        R?.disabled || (he.has(M) ? he.delete(M) : he.add(M));
      });
      const ne = Array.from(he);
      c && (B.deprecated(!1, "onSelectInvert", "onChange"), c(ne)), re(ne, "invert");
    }
  } : Q === CE ? {
    key: "none",
    text: P.selectNone,
    onSelect() {
      u?.(), re(Array.from(ae).filter((he) => {
        const ne = V.get(he);
        return ne?.disabled;
      }), "none");
    }
  } : Q).map((Q) => Object.assign(Object.assign({}, Q), {
    onSelect: function() {
      for (var he, ne, me = arguments.length, k = new Array(me), M = 0; M < me; M++)
        k[M] = arguments[M];
      (ne = Q.onSelect) === null || ne === void 0 || (he = ne).call.apply(he, [Q].concat(k)), N(null);
    }
  })), [h, ae, $, O, c, re]);
  return [Bt((se) => {
    var Q;
    if (!t)
      return process.env.NODE_ENV !== "production" && B(!se.includes(Qo), "usage", "`rowSelection` is not config but `SELECTION_COLUMN` exists in the `columns`."), se.filter((Ie) => Ie !== Qo);
    let he = ze(se);
    const ne = new Set(ae), me = G.map(O).filter((Ie) => !V.get(Ie).disabled), k = me.every((Ie) => ne.has(Ie)), M = me.some((Ie) => ne.has(Ie)), R = () => {
      const Ie = [];
      k ? me.forEach((Ae) => {
        ne.delete(Ae), Ie.push(Ae);
      }) : me.forEach((Ae) => {
        ne.has(Ae) || (ne.add(Ae), Ie.push(Ae));
      });
      const De = Array.from(ne);
      l?.(!k, De.map((Ae) => w(Ae)), Ie.map((Ae) => w(Ae))), re(De, "all"), N(null);
    };
    let q, Y;
    if (m !== "radio") {
      let Ie;
      if (fe) {
        const qe = {
          getPopupContainer: D,
          items: fe.map((Qe, tt) => {
            const {
              key: Ge,
              text: it,
              onSelect: ht
            } = Qe;
            return {
              key: Ge ?? tt,
              onClick: () => {
                ht?.(me);
              },
              label: it
            };
          })
        };
        Ie = /* @__PURE__ */ p.createElement("div", {
          className: `${b}-selection-extra`
        }, /* @__PURE__ */ p.createElement(kI, {
          menu: qe,
          getPopupContainer: D
        }, /* @__PURE__ */ p.createElement("span", null, /* @__PURE__ */ p.createElement(j1, null))));
      }
      const De = G.map((qe, Qe) => {
        const tt = O(qe, Qe), Ge = V.get(tt) || {};
        return Object.assign({
          checked: ne.has(tt)
        }, Ge);
      }).filter((qe) => {
        let {
          disabled: Qe
        } = qe;
        return Qe;
      }), Ae = !!De.length && De.length === G.length, Fe = Ae && De.every((qe) => {
        let {
          checked: Qe
        } = qe;
        return Qe;
      }), Ne = Ae && De.some((qe) => {
        let {
          checked: Qe
        } = qe;
        return Qe;
      });
      Y = /* @__PURE__ */ p.createElement(co, {
        checked: Ae ? Fe : !!G.length && k,
        indeterminate: Ae ? !Fe && Ne : !k && M,
        onChange: R,
        disabled: G.length === 0 || Ae,
        "aria-label": Ie ? "Custom selection" : "Select all",
        skipGroup: !0
      }), q = !S && /* @__PURE__ */ p.createElement("div", {
        className: `${b}-selection`
      }, Y, Ie);
    }
    let X;
    m === "radio" ? X = (Ie, De, Ae) => {
      const Fe = O(De, Ae), Ne = ne.has(Fe);
      return {
        node: /* @__PURE__ */ p.createElement(Ba, Object.assign({}, V.get(Fe), {
          checked: Ne,
          onClick: (qe) => qe.stopPropagation(),
          onChange: (qe) => {
            ne.has(Fe) || oe(Fe, !0, [Fe], qe.nativeEvent);
          }
        })),
        checked: Ne
      };
    } : X = (Ie, De, Ae) => {
      var Fe;
      const Ne = O(De, Ae), qe = ne.has(Ne), Qe = ue.has(Ne), tt = V.get(Ne);
      let Ge;
      return T === "nest" ? (Ge = Qe, process.env.NODE_ENV !== "production" && B(typeof tt?.indeterminate != "boolean", "usage", "set `indeterminate` using `rowSelection.getCheckboxProps` is not allowed with tree structured dataSource.")) : Ge = (Fe = tt?.indeterminate) !== null && Fe !== void 0 ? Fe : Qe, {
        node: /* @__PURE__ */ p.createElement(co, Object.assign({}, tt, {
          indeterminate: Ge,
          checked: qe,
          skipGroup: !0,
          onClick: (it) => it.stopPropagation(),
          onChange: (it) => {
            let {
              nativeEvent: ht
            } = it;
            const {
              shiftKey: It
            } = ht, xt = me.findIndex((pt) => pt === Ne), Xe = Z.some((pt) => me.includes(pt));
            if (It && x && Xe) {
              const pt = L(xt, me, ne), Ze = Array.from(ne);
              d?.(!qe, Ze.map((wt) => w(wt)), pt.map((wt) => w(wt))), re(Ze, "multiple");
            } else {
              const pt = Z;
              if (x) {
                const Ze = qe ? Jo(pt, Ne) : Ps(pt, Ne);
                oe(Ne, !qe, Ze, ht);
              } else {
                const Ze = rd([].concat(ze(pt), [Ne]), !0, U, K), {
                  checkedKeys: wt,
                  halfCheckedKeys: bt
                } = Ze;
                let Je = wt;
                if (qe) {
                  const _t = new Set(wt);
                  _t.delete(Ne), Je = rd(Array.from(_t), {
                    halfCheckedKeys: bt
                  }, U, K).checkedKeys;
                }
                oe(Ne, !qe, Je, ht);
              }
            }
            N(qe ? null : xt);
          }
        })),
        checked: qe
      };
    };
    const pe = (Ie, De, Ae) => {
      const {
        node: Fe,
        checked: Ne
      } = X(Ie, De, Ae);
      return y ? y(Ne, De, Ae, Fe) : Fe;
    };
    if (!he.includes(Qo))
      if (he.findIndex((Ie) => {
        var De;
        return ((De = Ie[L0]) === null || De === void 0 ? void 0 : De.columnType) === "EXPAND_COLUMN";
      }) === 0) {
        const [Ie, ...De] = he;
        he = [Ie, Qo].concat(ze(De));
      } else
        he = [Qo].concat(ze(he));
    const $e = he.indexOf(Qo);
    process.env.NODE_ENV !== "production" && B(he.filter((Ie) => Ie === Qo).length <= 1, "usage", "Multiple `SELECTION_COLUMN` exist in `columns`."), he = he.filter((Ie, De) => Ie !== Qo || De === $e);
    const J = he[$e - 1], de = he[$e + 1];
    let Se = g;
    Se === void 0 && (de?.fixed !== void 0 ? Se = de.fixed : J?.fixed !== void 0 && (Se = J.fixed)), Se && J && ((Q = J[L0]) === null || Q === void 0 ? void 0 : Q.columnType) === "EXPAND_COLUMN" && J.fixed === void 0 && (J.fixed = Se);
    const Ee = be(`${b}-selection-col`, {
      [`${b}-selection-col-with-dropdown`]: h && m === "checkbox"
    }), Te = () => t?.columnTitle ? typeof t.columnTitle == "function" ? t.columnTitle(Y) : t.columnTitle : q, Le = {
      fixed: Se,
      width: f,
      className: `${b}-selection-column`,
      title: Te(),
      render: pe,
      onCell: t.onCell,
      [L0]: {
        className: Ee
      }
    };
    return he.map((Ie) => Ie === Qo ? Le : Ie);
  }, [O, G, t, Z, ae, ue, f, fe, T, V, d, oe, K]), ae];
};
function VEe(e, t) {
  return e._antProxy = e._antProxy || {}, Object.keys(t).forEach((r) => {
    if (!(r in e._antProxy)) {
      const n = e[r];
      e._antProxy[r] = n, e[r] = t[r];
    }
  }), e;
}
function GEe(e, t) {
  return fo(e, () => {
    const r = t(), {
      nativeElement: n
    } = r;
    return typeof Proxy < "u" ? new Proxy(n, {
      get(a, i) {
        return r[i] ? r[i] : Reflect.get(a, i);
      }
    }) : VEe(n, r);
  });
}
function UEe(e) {
  return function(r) {
    let {
      prefixCls: n,
      onExpand: a,
      record: i,
      expanded: o,
      expandable: s
    } = r;
    const l = `${n}-row-expand-icon`;
    return /* @__PURE__ */ p.createElement("button", {
      type: "button",
      onClick: (c) => {
        a(i, c), c.stopPropagation();
      },
      className: be(l, {
        [`${l}-spaced`]: !s,
        [`${l}-expanded`]: s && o,
        [`${l}-collapsed`]: s && !o
      }),
      "aria-label": o ? e.collapse : e.expand,
      "aria-expanded": o
    });
  };
}
function WEe(e) {
  return (r, n) => {
    const a = r.querySelector(`.${e}-container`);
    let i = n;
    if (a) {
      const o = getComputedStyle(a), s = parseInt(o.borderLeftWidth, 10), l = parseInt(o.borderRightWidth, 10);
      i = n - s - l;
    }
    return i;
  };
}
function wc(e, t) {
  return "key" in e && e.key !== void 0 && e.key !== null ? e.key : e.dataIndex ? Array.isArray(e.dataIndex) ? e.dataIndex.join(".") : e.dataIndex : t;
}
function Ih(e, t) {
  return t ? `${t}-${e}` : `${e}`;
}
function tC(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function qEe(e, t) {
  const r = tC(e, t);
  return Object.prototype.toString.call(r) === "[object Object]" ? "" : r;
}
var KEe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z" } }] }, name: "filter", theme: "filled" }, YEe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: KEe
  }));
}, mW = /* @__PURE__ */ p.forwardRef(YEe);
process.env.NODE_ENV !== "production" && (mW.displayName = "FilterFilled");
function ZEe(e) {
  const t = p.useRef(e), r = WH();
  return [() => t.current, (n) => {
    t.current = n, r();
  }];
}
function XEe(e) {
  var t = e.dropPosition, r = e.dropLevelOffset, n = e.indent, a = {
    pointerEvents: "none",
    position: "absolute",
    right: 0,
    backgroundColor: "red",
    height: 2
  };
  switch (t) {
    case -1:
      a.top = 0, a.left = -r * n;
      break;
    case 1:
      a.bottom = 0, a.left = -r * n;
      break;
    case 0:
      a.bottom = 0, a.left = n;
      break;
  }
  return /* @__PURE__ */ p.createElement("div", {
    style: a
  });
}
function vW(e) {
  if (e == null) throw new TypeError("Cannot destructure " + e);
}
function JEe(e, t) {
  var r = p.useState(!1), n = ye(r, 2), a = n[0], i = n[1];
  hr(function() {
    if (a)
      return e(), function() {
        t();
      };
  }, [a]), hr(function() {
    return i(!0), function() {
      i(!1);
    };
  }, []);
}
var QEe = ["className", "style", "motion", "motionNodes", "motionType", "onMotionStart", "onMotionEnd", "active", "treeNodeRequiredProps"], hW = function(t, r) {
  var n = t.className, a = t.style, i = t.motion, o = t.motionNodes, s = t.motionType, l = t.onMotionStart, c = t.onMotionEnd, u = t.active, d = t.treeNodeRequiredProps, f = Kt(t, QEe), m = p.useState(!0), h = ye(m, 2), g = h[0], y = h[1], S = p.useContext(KI), x = S.prefixCls, b = o && s !== "hide";
  hr(function() {
    o && b !== g && y(b);
  }, [o]);
  var _ = function() {
    o && l();
  }, $ = p.useRef(!1), w = function() {
    o && !$.current && ($.current = !0, c());
  };
  JEe(_, w);
  var O = function(I) {
    b === I && w();
  };
  return o ? /* @__PURE__ */ p.createElement(Ci, Pe({
    ref: r,
    visible: g
  }, i, {
    motionAppear: s === "show",
    onVisibleChanged: O
  }), function(T, I) {
    var P = T.className, D = T.style;
    return /* @__PURE__ */ p.createElement("div", {
      ref: I,
      className: be("".concat(x, "-treenode-motion"), P),
      style: D
    }, o.map(function(B) {
      var L = Object.assign({}, (vW(B.data), B.data)), N = B.title, z = B.key, F = B.isStart, j = B.isEnd;
      delete L.children;
      var H = D0(z, d);
      return /* @__PURE__ */ p.createElement(dd, Pe({}, L, H, {
        title: N,
        active: u,
        data: B.data,
        key: z,
        isStart: F,
        isEnd: j
      }));
    }));
  }) : /* @__PURE__ */ p.createElement(dd, Pe({
    domRef: r,
    className: n,
    style: a
  }, f, {
    active: u
  }));
};
hW.displayName = "MotionTreeNode";
var ewe = /* @__PURE__ */ p.forwardRef(hW);
function twe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = e.length, n = t.length;
  if (Math.abs(r - n) !== 1)
    return {
      add: !1,
      key: null
    };
  function a(i, o) {
    var s = /* @__PURE__ */ new Map();
    i.forEach(function(c) {
      s.set(c, !0);
    });
    var l = o.filter(function(c) {
      return !s.has(c);
    });
    return l.length === 1 ? l[0] : null;
  }
  return r < n ? {
    add: !0,
    key: a(e, t)
  } : {
    add: !1,
    key: a(t, e)
  };
}
function D4(e, t, r) {
  var n = e.findIndex(function(s) {
    return s.key === r;
  }), a = e[n + 1], i = t.findIndex(function(s) {
    return s.key === r;
  });
  if (a) {
    var o = t.findIndex(function(s) {
      return s.key === a.key;
    });
    return t.slice(i + 1, o);
  }
  return t.slice(i + 1);
}
var rwe = ["prefixCls", "data", "selectable", "checkable", "expandedKeys", "selectedKeys", "checkedKeys", "loadedKeys", "loadingKeys", "halfCheckedKeys", "keyEntities", "disabled", "dragging", "dragOverNodeKey", "dropPosition", "motion", "height", "itemHeight", "virtual", "focusable", "activeItem", "focused", "tabIndex", "onKeyDown", "onFocus", "onBlur", "onActiveChange", "onListChangeStart", "onListChangeEnd"], j4 = {
  width: 0,
  height: 0,
  display: "flex",
  overflow: "hidden",
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
}, nwe = function() {
}, Oc = "RC_TREE_MOTION_".concat(Math.random()), SE = {
  key: Oc
}, gW = {
  key: Oc,
  level: 0,
  index: 0,
  pos: "0",
  node: SE,
  nodes: [SE]
}, L4 = {
  parent: null,
  children: [],
  pos: gW.pos,
  data: SE,
  title: null,
  key: Oc,
  /** Hold empty list here since we do not use it */
  isStart: [],
  isEnd: []
};
function k4(e, t, r, n) {
  return t === !1 || !r ? e : e.slice(0, Math.ceil(r / n) + 1);
}
function F4(e) {
  var t = e.key, r = e.pos;
  return _h(t, r);
}
function awe(e) {
  for (var t = String(e.data.key), r = e; r.parent; )
    r = r.parent, t = "".concat(r.data.key, " > ").concat(t);
  return t;
}
var yW = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.data;
  e.selectable, e.checkable;
  var a = e.expandedKeys, i = e.selectedKeys, o = e.checkedKeys, s = e.loadedKeys, l = e.loadingKeys, c = e.halfCheckedKeys, u = e.keyEntities, d = e.disabled, f = e.dragging, m = e.dragOverNodeKey, h = e.dropPosition, g = e.motion, y = e.height, S = e.itemHeight, x = e.virtual, b = e.focusable, _ = e.activeItem, $ = e.focused, w = e.tabIndex, O = e.onKeyDown, T = e.onFocus, I = e.onBlur, P = e.onActiveChange, D = e.onListChangeStart, B = e.onListChangeEnd, L = Kt(e, rwe), N = p.useRef(null), z = p.useRef(null);
  p.useImperativeHandle(t, function() {
    return {
      scrollTo: function(X) {
        N.current.scrollTo(X);
      },
      getIndentWidth: function() {
        return z.current.offsetWidth;
      }
    };
  });
  var F = p.useState(a), j = ye(F, 2), H = j[0], U = j[1], G = p.useState(n), V = ye(G, 2), K = V[0], Z = V[1], ee = p.useState(n), ae = ye(ee, 2), ue = ae[0], re = ae[1], oe = p.useState([]), fe = ye(oe, 2), le = fe[0], se = fe[1], Q = p.useState(null), he = ye(Q, 2), ne = he[0], me = he[1], k = p.useRef(n);
  k.current = n;
  function M() {
    var Y = k.current;
    Z(Y), re(Y), se([]), me(null), B();
  }
  hr(function() {
    U(a);
    var Y = twe(H, a);
    if (Y.key !== null)
      if (Y.add) {
        var X = K.findIndex(function(Ee) {
          var Te = Ee.key;
          return Te === Y.key;
        }), pe = k4(D4(K, n, Y.key), x, y, S), $e = K.slice();
        $e.splice(X + 1, 0, L4), re($e), se(pe), me("show");
      } else {
        var J = n.findIndex(function(Ee) {
          var Te = Ee.key;
          return Te === Y.key;
        }), de = k4(D4(n, K, Y.key), x, y, S), Se = n.slice();
        Se.splice(J + 1, 0, L4), re(Se), se(de), me("hide");
      }
    else K !== n && (Z(n), re(n));
  }, [a, n]), p.useEffect(function() {
    f || M();
  }, [f]);
  var R = g ? ue : n, q = {
    expandedKeys: a,
    selectedKeys: i,
    loadedKeys: s,
    loadingKeys: l,
    checkedKeys: o,
    halfCheckedKeys: c,
    dragOverNodeKey: m,
    dropPosition: h,
    keyEntities: u
  };
  return /* @__PURE__ */ p.createElement(p.Fragment, null, $ && _ && /* @__PURE__ */ p.createElement("span", {
    style: j4,
    "aria-live": "assertive"
  }, awe(_)), /* @__PURE__ */ p.createElement("div", null, /* @__PURE__ */ p.createElement("input", {
    style: j4,
    disabled: b === !1 || d,
    tabIndex: b !== !1 ? w : null,
    onKeyDown: O,
    onFocus: T,
    onBlur: I,
    value: "",
    onChange: nwe,
    "aria-label": "for screen reader"
  })), /* @__PURE__ */ p.createElement("div", {
    className: "".concat(r, "-treenode"),
    "aria-hidden": !0,
    style: {
      position: "absolute",
      pointerEvents: "none",
      visibility: "hidden",
      height: 0,
      overflow: "hidden",
      border: 0,
      padding: 0
    }
  }, /* @__PURE__ */ p.createElement("div", {
    className: "".concat(r, "-indent")
  }, /* @__PURE__ */ p.createElement("div", {
    ref: z,
    className: "".concat(r, "-indent-unit")
  }))), /* @__PURE__ */ p.createElement(D1, Pe({}, L, {
    data: R,
    itemKey: F4,
    height: y,
    fullHeight: !1,
    virtual: x,
    itemHeight: S,
    prefixCls: "".concat(r, "-list"),
    ref: N,
    onVisibleChange: function(X, pe) {
      var $e = new Set(X), J = pe.filter(function(de) {
        return !$e.has(de);
      });
      J.some(function(de) {
        return F4(de) === Oc;
      }) && M();
    }
  }), function(Y) {
    var X = Y.pos, pe = Object.assign({}, (vW(Y.data), Y.data)), $e = Y.title, J = Y.key, de = Y.isStart, Se = Y.isEnd, Ee = _h(J, X);
    delete pe.key, delete pe.children;
    var Te = D0(Ee, q);
    return /* @__PURE__ */ p.createElement(ewe, Pe({}, pe, Te, {
      title: $e,
      active: !!_ && J === _.key,
      pos: X,
      data: Y.data,
      isStart: de,
      isEnd: Se,
      motion: g,
      motionNodes: J === Oc ? le : null,
      motionType: ne,
      onMotionStart: D,
      onMotionEnd: M,
      treeNodeRequiredProps: q,
      onMouseMove: function() {
        P(null);
      }
    }));
  }));
});
yW.displayName = "NodeList";
var iwe = 10, ZI = /* @__PURE__ */ function(e) {
  ds(r, e);
  var t = fs(r);
  function r() {
    var n;
    Hn(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), te(at(n), "destroyed", !1), te(at(n), "delayedDragEnterLogic", void 0), te(at(n), "loadingRetryTimes", {}), te(at(n), "state", {
      keyEntities: {},
      indent: null,
      selectedKeys: [],
      checkedKeys: [],
      halfCheckedKeys: [],
      loadedKeys: [],
      loadingKeys: [],
      expandedKeys: [],
      draggingNodeKey: null,
      dragChildrenKeys: [],
      // dropTargetKey is the key of abstract-drop-node
      // the abstract-drop-node is the real drop node when drag and drop
      // not the DOM drag over node
      dropTargetKey: null,
      dropPosition: null,
      // the drop position of abstract-drop-node, inside 0, top -1, bottom 1
      dropContainerKey: null,
      // the container key of abstract-drop-node if dropPosition is -1 or 1
      dropLevelOffset: null,
      // the drop level offset of abstract-drag-over-node
      dropTargetPos: null,
      // the pos of abstract-drop-node
      dropAllowed: !0,
      // if drop to abstract-drop-node is allowed
      // the abstract-drag-over-node
      // if mouse is on the bottom of top dom node or no the top of the bottom dom node
      // abstract-drag-over-node is the top node
      dragOverNodeKey: null,
      treeData: [],
      flattenNodes: [],
      focused: !1,
      activeKey: null,
      listChanging: !1,
      prevProps: null,
      fieldNames: ud()
    }), te(at(n), "dragStartMousePosition", null), te(at(n), "dragNode", void 0), te(at(n), "currentMouseOverDroppableNodeKey", null), te(at(n), "listRef", /* @__PURE__ */ p.createRef()), te(at(n), "onNodeDragStart", function(s, l) {
      var c = n.state, u = c.expandedKeys, d = c.keyEntities, f = n.props.onDragStart, m = l.props.eventKey;
      n.dragNode = l, n.dragStartMousePosition = {
        x: s.clientX,
        y: s.clientY
      };
      var h = Jo(u, m);
      n.setState({
        draggingNodeKey: m,
        dragChildrenKeys: kEe(m, d),
        indent: n.listRef.current.getIndentWidth()
      }), n.setExpandedKeys(h), window.addEventListener("dragend", n.onWindowDragEnd), f?.({
        event: s,
        node: la(l.props)
      });
    }), te(at(n), "onNodeDragEnter", function(s, l) {
      var c = n.state, u = c.expandedKeys, d = c.keyEntities, f = c.dragChildrenKeys, m = c.flattenNodes, h = c.indent, g = n.props, y = g.onDragEnter, S = g.onExpand, x = g.allowDrop, b = g.direction, _ = l.props, $ = _.pos, w = _.eventKey, O = at(n), T = O.dragNode;
      if (n.currentMouseOverDroppableNodeKey !== w && (n.currentMouseOverDroppableNodeKey = w), !T) {
        n.resetDragState();
        return;
      }
      var I = P4(s, T, l, h, n.dragStartMousePosition, x, m, d, u, b), P = I.dropPosition, D = I.dropLevelOffset, B = I.dropTargetKey, L = I.dropContainerKey, N = I.dropTargetPos, z = I.dropAllowed, F = I.dragOverNodeKey;
      if (
        // don't allow drop inside its children
        f.indexOf(B) !== -1 || // don't allow drop when drop is not allowed caculated by calcDropPosition
        !z
      ) {
        n.resetDragState();
        return;
      }
      if (n.delayedDragEnterLogic || (n.delayedDragEnterLogic = {}), Object.keys(n.delayedDragEnterLogic).forEach(function(j) {
        clearTimeout(n.delayedDragEnterLogic[j]);
      }), T.props.eventKey !== l.props.eventKey && (s.persist(), n.delayedDragEnterLogic[$] = window.setTimeout(function() {
        if (n.state.draggingNodeKey !== null) {
          var j = ze(u), H = yi(d, l.props.eventKey);
          H && (H.children || []).length && (j = Ps(u, l.props.eventKey)), "expandedKeys" in n.props || n.setExpandedKeys(j), S?.(j, {
            node: la(l.props),
            expanded: !0,
            nativeEvent: s.nativeEvent
          });
        }
      }, 800)), T.props.eventKey === B && D === 0) {
        n.resetDragState();
        return;
      }
      n.setState({
        dragOverNodeKey: F,
        dropPosition: P,
        dropLevelOffset: D,
        dropTargetKey: B,
        dropContainerKey: L,
        dropTargetPos: N,
        dropAllowed: z
      }), y?.({
        event: s,
        node: la(l.props),
        expandedKeys: u
      });
    }), te(at(n), "onNodeDragOver", function(s, l) {
      var c = n.state, u = c.dragChildrenKeys, d = c.flattenNodes, f = c.keyEntities, m = c.expandedKeys, h = c.indent, g = n.props, y = g.onDragOver, S = g.allowDrop, x = g.direction, b = at(n), _ = b.dragNode;
      if (_) {
        var $ = P4(s, _, l, h, n.dragStartMousePosition, S, d, f, m, x), w = $.dropPosition, O = $.dropLevelOffset, T = $.dropTargetKey, I = $.dropContainerKey, P = $.dropAllowed, D = $.dropTargetPos, B = $.dragOverNodeKey;
        u.indexOf(T) !== -1 || !P || (_.props.eventKey === T && O === 0 ? n.state.dropPosition === null && n.state.dropLevelOffset === null && n.state.dropTargetKey === null && n.state.dropContainerKey === null && n.state.dropTargetPos === null && n.state.dropAllowed === !1 && n.state.dragOverNodeKey === null || n.resetDragState() : w === n.state.dropPosition && O === n.state.dropLevelOffset && T === n.state.dropTargetKey && I === n.state.dropContainerKey && D === n.state.dropTargetPos && P === n.state.dropAllowed && B === n.state.dragOverNodeKey || n.setState({
          dropPosition: w,
          dropLevelOffset: O,
          dropTargetKey: T,
          dropContainerKey: I,
          dropTargetPos: D,
          dropAllowed: P,
          dragOverNodeKey: B
        }), y?.({
          event: s,
          node: la(l.props)
        }));
      }
    }), te(at(n), "onNodeDragLeave", function(s, l) {
      n.currentMouseOverDroppableNodeKey === l.props.eventKey && !s.currentTarget.contains(s.relatedTarget) && (n.resetDragState(), n.currentMouseOverDroppableNodeKey = null);
      var c = n.props.onDragLeave;
      c?.({
        event: s,
        node: la(l.props)
      });
    }), te(at(n), "onWindowDragEnd", function(s) {
      n.onNodeDragEnd(s, null, !0), window.removeEventListener("dragend", n.onWindowDragEnd);
    }), te(at(n), "onNodeDragEnd", function(s, l) {
      var c = n.props.onDragEnd;
      n.setState({
        dragOverNodeKey: null
      }), n.cleanDragState(), c?.({
        event: s,
        node: la(l.props)
      }), n.dragNode = null, window.removeEventListener("dragend", n.onWindowDragEnd);
    }), te(at(n), "onNodeDrop", function(s, l) {
      var c, u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, d = n.state, f = d.dragChildrenKeys, m = d.dropPosition, h = d.dropTargetKey, g = d.dropTargetPos, y = d.dropAllowed;
      if (y) {
        var S = n.props.onDrop;
        if (n.setState({
          dragOverNodeKey: null
        }), n.cleanDragState(), h !== null) {
          var x = ce(ce({}, D0(h, n.getTreeNodeRequiredProps())), {}, {
            active: ((c = n.getActiveItem()) === null || c === void 0 ? void 0 : c.key) === h,
            data: yi(n.state.keyEntities, h).node
          }), b = f.indexOf(h) !== -1;
          jt(!b, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
          var _ = YI(g), $ = {
            event: s,
            node: la(x),
            dragNode: n.dragNode ? la(n.dragNode.props) : null,
            dragNodesKeys: [n.dragNode.props.eventKey].concat(f),
            dropToGap: m !== 0,
            dropPosition: m + Number(_[_.length - 1])
          };
          u || S?.($), n.dragNode = null;
        }
      }
    }), te(at(n), "cleanDragState", function() {
      var s = n.state.draggingNodeKey;
      s !== null && n.setState({
        draggingNodeKey: null,
        dropPosition: null,
        dropContainerKey: null,
        dropTargetKey: null,
        dropLevelOffset: null,
        dropAllowed: !0,
        dragOverNodeKey: null
      }), n.dragStartMousePosition = null, n.currentMouseOverDroppableNodeKey = null;
    }), te(at(n), "triggerExpandActionExpand", function(s, l) {
      var c = n.state, u = c.expandedKeys, d = c.flattenNodes, f = l.expanded, m = l.key, h = l.isLeaf;
      if (!(h || s.shiftKey || s.metaKey || s.ctrlKey)) {
        var g = d.filter(function(S) {
          return S.key === m;
        })[0], y = la(ce(ce({}, D0(m, n.getTreeNodeRequiredProps())), {}, {
          data: g.data
        }));
        n.setExpandedKeys(f ? Jo(u, m) : Ps(u, m)), n.onNodeExpand(s, y);
      }
    }), te(at(n), "onNodeClick", function(s, l) {
      var c = n.props, u = c.onClick, d = c.expandAction;
      d === "click" && n.triggerExpandActionExpand(s, l), u?.(s, l);
    }), te(at(n), "onNodeDoubleClick", function(s, l) {
      var c = n.props, u = c.onDoubleClick, d = c.expandAction;
      d === "doubleClick" && n.triggerExpandActionExpand(s, l), u?.(s, l);
    }), te(at(n), "onNodeSelect", function(s, l) {
      var c = n.state.selectedKeys, u = n.state, d = u.keyEntities, f = u.fieldNames, m = n.props, h = m.onSelect, g = m.multiple, y = l.selected, S = l[f.key], x = !y;
      x ? g ? c = Ps(c, S) : c = [S] : c = Jo(c, S);
      var b = c.map(function(_) {
        var $ = yi(d, _);
        return $ ? $.node : null;
      }).filter(function(_) {
        return _;
      });
      n.setUncontrolledState({
        selectedKeys: c
      }), h?.(c, {
        event: "select",
        selected: x,
        node: l,
        selectedNodes: b,
        nativeEvent: s.nativeEvent
      });
    }), te(at(n), "onNodeCheck", function(s, l, c) {
      var u = n.state, d = u.keyEntities, f = u.checkedKeys, m = u.halfCheckedKeys, h = n.props, g = h.checkStrictly, y = h.onCheck, S = l.key, x, b = {
        event: "check",
        node: l,
        checked: c,
        nativeEvent: s.nativeEvent
      };
      if (g) {
        var _ = c ? Ps(f, S) : Jo(f, S), $ = Jo(m, S);
        x = {
          checked: _,
          halfChecked: $
        }, b.checkedNodes = _.map(function(D) {
          return yi(d, D);
        }).filter(function(D) {
          return D;
        }).map(function(D) {
          return D.node;
        }), n.setUncontrolledState({
          checkedKeys: _
        });
      } else {
        var w = rd([].concat(ze(f), [S]), !0, d), O = w.checkedKeys, T = w.halfCheckedKeys;
        if (!c) {
          var I = new Set(O);
          I.delete(S);
          var P = rd(Array.from(I), {
            halfCheckedKeys: T
          }, d);
          O = P.checkedKeys, T = P.halfCheckedKeys;
        }
        x = O, b.checkedNodes = [], b.checkedNodesPositions = [], b.halfCheckedKeys = T, O.forEach(function(D) {
          var B = yi(d, D);
          if (B) {
            var L = B.node, N = B.pos;
            b.checkedNodes.push(L), b.checkedNodesPositions.push({
              node: L,
              pos: N
            });
          }
        }), n.setUncontrolledState({
          checkedKeys: O
        }, !1, {
          halfCheckedKeys: T
        });
      }
      y?.(x, b);
    }), te(at(n), "onNodeLoad", function(s) {
      var l, c = s.key, u = n.state.keyEntities, d = yi(u, c);
      if (!(d != null && (l = d.children) !== null && l !== void 0 && l.length)) {
        var f = new Promise(function(m, h) {
          n.setState(function(g) {
            var y = g.loadedKeys, S = y === void 0 ? [] : y, x = g.loadingKeys, b = x === void 0 ? [] : x, _ = n.props, $ = _.loadData, w = _.onLoad;
            if (!$ || S.indexOf(c) !== -1 || b.indexOf(c) !== -1)
              return null;
            var O = $(s);
            return O.then(function() {
              var T = n.state.loadedKeys, I = Ps(T, c);
              w?.(I, {
                event: "load",
                node: s
              }), n.setUncontrolledState({
                loadedKeys: I
              }), n.setState(function(P) {
                return {
                  loadingKeys: Jo(P.loadingKeys, c)
                };
              }), m();
            }).catch(function(T) {
              if (n.setState(function(P) {
                return {
                  loadingKeys: Jo(P.loadingKeys, c)
                };
              }), n.loadingRetryTimes[c] = (n.loadingRetryTimes[c] || 0) + 1, n.loadingRetryTimes[c] >= iwe) {
                var I = n.state.loadedKeys;
                jt(!1, "Retry for `loadData` many times but still failed. No more retry."), n.setUncontrolledState({
                  loadedKeys: Ps(I, c)
                }), m();
              }
              h(T);
            }), {
              loadingKeys: Ps(b, c)
            };
          });
        });
        return f.catch(function() {
        }), f;
      }
    }), te(at(n), "onNodeMouseEnter", function(s, l) {
      var c = n.props.onMouseEnter;
      c?.({
        event: s,
        node: l
      });
    }), te(at(n), "onNodeMouseLeave", function(s, l) {
      var c = n.props.onMouseLeave;
      c?.({
        event: s,
        node: l
      });
    }), te(at(n), "onNodeContextMenu", function(s, l) {
      var c = n.props.onRightClick;
      c && (s.preventDefault(), c({
        event: s,
        node: l
      }));
    }), te(at(n), "onFocus", function() {
      var s = n.props.onFocus;
      n.setState({
        focused: !0
      });
      for (var l = arguments.length, c = new Array(l), u = 0; u < l; u++)
        c[u] = arguments[u];
      s?.apply(void 0, c);
    }), te(at(n), "onBlur", function() {
      var s = n.props.onBlur;
      n.setState({
        focused: !1
      }), n.onActiveChange(null);
      for (var l = arguments.length, c = new Array(l), u = 0; u < l; u++)
        c[u] = arguments[u];
      s?.apply(void 0, c);
    }), te(at(n), "getTreeNodeRequiredProps", function() {
      var s = n.state, l = s.expandedKeys, c = s.selectedKeys, u = s.loadedKeys, d = s.loadingKeys, f = s.checkedKeys, m = s.halfCheckedKeys, h = s.dragOverNodeKey, g = s.dropPosition, y = s.keyEntities;
      return {
        expandedKeys: l || [],
        selectedKeys: c || [],
        loadedKeys: u || [],
        loadingKeys: d || [],
        checkedKeys: f || [],
        halfCheckedKeys: m || [],
        dragOverNodeKey: h,
        dropPosition: g,
        keyEntities: y
      };
    }), te(at(n), "setExpandedKeys", function(s) {
      var l = n.state, c = l.treeData, u = l.fieldNames, d = Ox(c, s, u);
      n.setUncontrolledState({
        expandedKeys: s,
        flattenNodes: d
      }, !0);
    }), te(at(n), "onNodeExpand", function(s, l) {
      var c = n.state.expandedKeys, u = n.state, d = u.listChanging, f = u.fieldNames, m = n.props, h = m.onExpand, g = m.loadData, y = l.expanded, S = l[f.key];
      if (!d) {
        var x = c.indexOf(S), b = !y;
        if (jt(y && x !== -1 || !y && x === -1, "Expand state not sync with index check"), b ? c = Ps(c, S) : c = Jo(c, S), n.setExpandedKeys(c), h?.(c, {
          node: l,
          expanded: b,
          nativeEvent: s.nativeEvent
        }), b && g) {
          var _ = n.onNodeLoad(l);
          _ && _.then(function() {
            var $ = Ox(n.state.treeData, c, f);
            n.setUncontrolledState({
              flattenNodes: $
            });
          }).catch(function() {
            var $ = n.state.expandedKeys, w = Jo($, S);
            n.setExpandedKeys(w);
          });
        }
      }
    }), te(at(n), "onListChangeStart", function() {
      n.setUncontrolledState({
        listChanging: !0
      });
    }), te(at(n), "onListChangeEnd", function() {
      setTimeout(function() {
        n.setUncontrolledState({
          listChanging: !1
        });
      });
    }), te(at(n), "onActiveChange", function(s) {
      var l = n.state.activeKey, c = n.props, u = c.onActiveChange, d = c.itemScrollOffset, f = d === void 0 ? 0 : d;
      l !== s && (n.setState({
        activeKey: s
      }), s !== null && n.scrollTo({
        key: s,
        offset: f
      }), u?.(s));
    }), te(at(n), "getActiveItem", function() {
      var s = n.state, l = s.activeKey, c = s.flattenNodes;
      return l === null ? null : c.find(function(u) {
        var d = u.key;
        return d === l;
      }) || null;
    }), te(at(n), "offsetActiveKey", function(s) {
      var l = n.state, c = l.flattenNodes, u = l.activeKey, d = c.findIndex(function(h) {
        var g = h.key;
        return g === u;
      });
      d === -1 && s < 0 && (d = c.length), d = (d + s + c.length) % c.length;
      var f = c[d];
      if (f) {
        var m = f.key;
        n.onActiveChange(m);
      } else
        n.onActiveChange(null);
    }), te(at(n), "onKeyDown", function(s) {
      var l = n.state, c = l.activeKey, u = l.expandedKeys, d = l.checkedKeys, f = l.fieldNames, m = n.props, h = m.onKeyDown, g = m.checkable, y = m.selectable;
      switch (s.which) {
        case Mt.UP: {
          n.offsetActiveKey(-1), s.preventDefault();
          break;
        }
        case Mt.DOWN: {
          n.offsetActiveKey(1), s.preventDefault();
          break;
        }
      }
      var S = n.getActiveItem();
      if (S && S.data) {
        var x = n.getTreeNodeRequiredProps(), b = S.data.isLeaf === !1 || !!(S.data[f.children] || []).length, _ = la(ce(ce({}, D0(c, x)), {}, {
          data: S.data,
          active: !0
        }));
        switch (s.which) {
          case Mt.LEFT: {
            b && u.includes(c) ? n.onNodeExpand({}, _) : S.parent && n.onActiveChange(S.parent.key), s.preventDefault();
            break;
          }
          case Mt.RIGHT: {
            b && !u.includes(c) ? n.onNodeExpand({}, _) : S.children && S.children.length && n.onActiveChange(S.children[0].key), s.preventDefault();
            break;
          }
          case Mt.ENTER:
          case Mt.SPACE: {
            g && !_.disabled && _.checkable !== !1 && !_.disableCheckbox ? n.onNodeCheck({}, _, !d.includes(c)) : !g && y && !_.disabled && _.selectable !== !1 && n.onNodeSelect({}, _);
            break;
          }
        }
      }
      h?.(s);
    }), te(at(n), "setUncontrolledState", function(s) {
      var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!n.destroyed) {
        var u = !1, d = !0, f = {};
        Object.keys(s).forEach(function(m) {
          if (m in n.props) {
            d = !1;
            return;
          }
          u = !0, f[m] = s[m];
        }), u && (!l || d) && n.setState(ce(ce({}, f), c));
      }
    }), te(at(n), "scrollTo", function(s) {
      n.listRef.current.scrollTo(s);
    }), n;
  }
  return Vn(r, [{
    key: "componentDidMount",
    value: function() {
      this.destroyed = !1, this.onUpdated();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.onUpdated();
    }
  }, {
    key: "onUpdated",
    value: function() {
      var a = this.props, i = a.activeKey, o = a.itemScrollOffset, s = o === void 0 ? 0 : o;
      i !== void 0 && i !== this.state.activeKey && (this.setState({
        activeKey: i
      }), i !== null && this.scrollTo({
        key: i,
        offset: s
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      window.removeEventListener("dragend", this.onWindowDragEnd), this.destroyed = !0;
    }
  }, {
    key: "resetDragState",
    value: function() {
      this.setState({
        dragOverNodeKey: null,
        dropPosition: null,
        dropLevelOffset: null,
        dropTargetKey: null,
        dropContainerKey: null,
        dropTargetPos: null,
        dropAllowed: !1
      });
    }
  }, {
    key: "render",
    value: function() {
      var a = this.state, i = a.focused, o = a.flattenNodes, s = a.keyEntities, l = a.draggingNodeKey, c = a.activeKey, u = a.dropLevelOffset, d = a.dropContainerKey, f = a.dropTargetKey, m = a.dropPosition, h = a.dragOverNodeKey, g = a.indent, y = this.props, S = y.prefixCls, x = y.className, b = y.style, _ = y.showLine, $ = y.focusable, w = y.tabIndex, O = w === void 0 ? 0 : w, T = y.selectable, I = y.showIcon, P = y.icon, D = y.switcherIcon, B = y.draggable, L = y.checkable, N = y.checkStrictly, z = y.disabled, F = y.motion, j = y.loadData, H = y.filterTreeNode, U = y.height, G = y.itemHeight, V = y.virtual, K = y.titleRender, Z = y.dropIndicatorRender, ee = y.onContextMenu, ae = y.onScroll, ue = y.direction, re = y.rootClassName, oe = y.rootStyle, fe = aa(this.props, {
        aria: !0,
        data: !0
      }), le;
      return B && (kt(B) === "object" ? le = B : typeof B == "function" ? le = {
        nodeDraggable: B
      } : le = {}), /* @__PURE__ */ p.createElement(KI.Provider, {
        value: {
          prefixCls: S,
          selectable: T,
          showIcon: I,
          icon: P,
          switcherIcon: D,
          draggable: le,
          draggingNodeKey: l,
          checkable: L,
          checkStrictly: N,
          disabled: z,
          keyEntities: s,
          dropLevelOffset: u,
          dropContainerKey: d,
          dropTargetKey: f,
          dropPosition: m,
          dragOverNodeKey: h,
          indent: g,
          direction: ue,
          dropIndicatorRender: Z,
          loadData: j,
          filterTreeNode: H,
          titleRender: K,
          onNodeClick: this.onNodeClick,
          onNodeDoubleClick: this.onNodeDoubleClick,
          onNodeExpand: this.onNodeExpand,
          onNodeSelect: this.onNodeSelect,
          onNodeCheck: this.onNodeCheck,
          onNodeLoad: this.onNodeLoad,
          onNodeMouseEnter: this.onNodeMouseEnter,
          onNodeMouseLeave: this.onNodeMouseLeave,
          onNodeContextMenu: this.onNodeContextMenu,
          onNodeDragStart: this.onNodeDragStart,
          onNodeDragEnter: this.onNodeDragEnter,
          onNodeDragOver: this.onNodeDragOver,
          onNodeDragLeave: this.onNodeDragLeave,
          onNodeDragEnd: this.onNodeDragEnd,
          onNodeDrop: this.onNodeDrop
        }
      }, /* @__PURE__ */ p.createElement("div", {
        role: "tree",
        className: be(S, x, re, te(te(te({}, "".concat(S, "-show-line"), _), "".concat(S, "-focused"), i), "".concat(S, "-active-focused"), c !== null)),
        style: oe
      }, /* @__PURE__ */ p.createElement(yW, Pe({
        ref: this.listRef,
        prefixCls: S,
        style: b,
        data: o,
        disabled: z,
        selectable: T,
        checkable: !!L,
        motion: F,
        dragging: l !== null,
        height: U,
        itemHeight: G,
        virtual: V,
        focusable: $,
        focused: i,
        tabIndex: O,
        activeItem: this.getActiveItem(),
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        onActiveChange: this.onActiveChange,
        onListChangeStart: this.onListChangeStart,
        onListChangeEnd: this.onListChangeEnd,
        onContextMenu: ee,
        onScroll: ae
      }, this.getTreeNodeRequiredProps(), fe))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(a, i) {
      var o = i.prevProps, s = {
        prevProps: a
      };
      function l(w) {
        return !o && w in a || o && o[w] !== a[w];
      }
      var c, u = i.fieldNames;
      if (l("fieldNames") && (u = ud(a.fieldNames), s.fieldNames = u), l("treeData") ? c = a.treeData : l("children") && (jt(!1, "`children` of Tree is deprecated. Please use `treeData` instead."), c = TG(a.children)), c) {
        s.treeData = c;
        var d = TI(c, {
          fieldNames: u
        });
        s.keyEntities = ce(te({}, Oc, gW), d.keyEntities), process.env.NODE_ENV !== "production" && oSe(c, u);
      }
      var f = s.keyEntities || i.keyEntities;
      if (l("expandedKeys") || o && l("autoExpandParent"))
        s.expandedKeys = a.autoExpandParent || !o && a.defaultExpandParent ? gE(a.expandedKeys, f) : a.expandedKeys;
      else if (!o && a.defaultExpandAll) {
        var m = ce({}, f);
        delete m[Oc], s.expandedKeys = Object.keys(m).map(function(w) {
          return m[w].key;
        });
      } else !o && a.defaultExpandedKeys && (s.expandedKeys = a.autoExpandParent || a.defaultExpandParent ? gE(a.defaultExpandedKeys, f) : a.defaultExpandedKeys);
      if (s.expandedKeys || delete s.expandedKeys, c || s.expandedKeys) {
        var h = Ox(c || i.treeData, s.expandedKeys || i.expandedKeys, u);
        s.flattenNodes = h;
      }
      if (a.selectable && (l("selectedKeys") ? s.selectedKeys = R4(a.selectedKeys, a) : !o && a.defaultSelectedKeys && (s.selectedKeys = R4(a.defaultSelectedKeys, a))), a.checkable) {
        var g;
        if (l("checkedKeys") ? g = Nx(a.checkedKeys) || {} : !o && a.defaultCheckedKeys ? g = Nx(a.defaultCheckedKeys) || {} : c && (g = Nx(a.checkedKeys) || {
          checkedKeys: i.checkedKeys,
          halfCheckedKeys: i.halfCheckedKeys
        }), g) {
          var y = g, S = y.checkedKeys, x = S === void 0 ? [] : S, b = y.halfCheckedKeys, _ = b === void 0 ? [] : b;
          if (!a.checkStrictly) {
            var $ = rd(x, !0, f);
            x = $.checkedKeys, _ = $.halfCheckedKeys;
          }
          s.checkedKeys = x, s.halfCheckedKeys = _;
        }
      }
      return l("loadedKeys") && (s.loadedKeys = a.loadedKeys), s;
    }
  }]), r;
}(p.Component);
te(ZI, "defaultProps", {
  prefixCls: "rc-tree",
  showLine: !1,
  showIcon: !0,
  selectable: !0,
  multiple: !1,
  checkable: !1,
  disabled: !1,
  checkStrictly: !1,
  draggable: !1,
  defaultExpandParent: !0,
  autoExpandParent: !1,
  defaultExpandAll: !1,
  defaultExpandedKeys: [],
  defaultCheckedKeys: [],
  defaultSelectedKeys: [],
  dropIndicatorRender: XEe,
  allowDrop: function() {
    return !0;
  },
  expandAction: !1
});
te(ZI, "TreeNode", dd);
var owe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, name: "file", theme: "outlined" }, swe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: owe
  }));
}, XI = /* @__PURE__ */ p.forwardRef(swe);
process.env.NODE_ENV !== "production" && (XI.displayName = "FileOutlined");
var lwe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" } }] }, name: "folder-open", theme: "outlined" }, cwe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: lwe
  }));
}, bW = /* @__PURE__ */ p.forwardRef(cwe);
process.env.NODE_ENV !== "production" && (bW.displayName = "FolderOpenOutlined");
var uwe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, name: "folder", theme: "outlined" }, dwe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: uwe
  }));
}, CW = /* @__PURE__ */ p.forwardRef(dwe);
process.env.NODE_ENV !== "production" && (CW.displayName = "FolderOutlined");
var fwe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z" } }] }, name: "holder", theme: "outlined" }, pwe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: fwe
  }));
}, SW = /* @__PURE__ */ p.forwardRef(pwe);
process.env.NODE_ENV !== "production" && (SW.displayName = "HolderOutlined");
const mwe = new Pr("ant-tree-node-fx-do-not-use", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), vwe = (e, t) => ({
  [`.${e}-switcher-icon`]: {
    display: "inline-block",
    fontSize: 10,
    verticalAlign: "baseline",
    svg: {
      transition: `transform ${t.motionDurationSlow}`
    }
  }
}), hwe = (e, t) => ({
  [`.${e}-drop-indicator`]: {
    position: "absolute",
    // it should displayed over the following node
    zIndex: 1,
    height: 2,
    backgroundColor: t.colorPrimary,
    borderRadius: 1,
    pointerEvents: "none",
    "&:after": {
      position: "absolute",
      top: -3,
      insetInlineStart: -6,
      width: 8,
      height: 8,
      backgroundColor: "transparent",
      border: `${ve(t.lineWidthBold)} solid ${t.colorPrimary}`,
      borderRadius: "50%",
      content: '""'
    }
  }
}), gwe = (e, t) => {
  const {
    treeCls: r,
    treeNodeCls: n,
    treeNodePadding: a,
    titleHeight: i,
    nodeSelectedBg: o,
    nodeHoverBg: s
  } = t, l = t.paddingXS;
  return {
    [r]: Object.assign(Object.assign({}, Yr(t)), {
      background: t.colorBgContainer,
      borderRadius: t.borderRadius,
      transition: `background-color ${t.motionDurationSlow}`,
      [`&${r}-rtl`]: {
        // >>> Switcher
        [`${r}-switcher`]: {
          "&_close": {
            [`${r}-switcher-icon`]: {
              svg: {
                transform: "rotate(90deg)"
              }
            }
          }
        }
      },
      [`&-focused:not(:hover):not(${r}-active-focused)`]: Object.assign({}, Sl(t)),
      // =================== Virtual List ===================
      [`${r}-list-holder-inner`]: {
        alignItems: "flex-start"
      },
      [`&${r}-block-node`]: {
        [`${r}-list-holder-inner`]: {
          alignItems: "stretch",
          // >>> Title
          [`${r}-node-content-wrapper`]: {
            flex: "auto"
          },
          // >>> Drag
          [`${n}.dragging`]: {
            position: "relative",
            "&:after": {
              position: "absolute",
              top: 0,
              insetInlineEnd: 0,
              bottom: a,
              insetInlineStart: 0,
              border: `1px solid ${t.colorPrimary}`,
              opacity: 0,
              animationName: mwe,
              animationDuration: t.motionDurationSlow,
              animationPlayState: "running",
              animationFillMode: "forwards",
              content: '""',
              pointerEvents: "none"
            }
          }
        }
      },
      // ===================== TreeNode =====================
      [`${n}`]: {
        display: "flex",
        alignItems: "flex-start",
        padding: `0 0 ${ve(a)} 0`,
        outline: "none",
        "&-rtl": {
          direction: "rtl"
        },
        // Disabled
        "&-disabled": {
          // >>> Title
          [`${r}-node-content-wrapper`]: {
            color: t.colorTextDisabled,
            cursor: "not-allowed",
            "&:hover": {
              background: "transparent"
            }
          }
        },
        [`&-active ${r}-node-content-wrapper`]: {
          background: t.controlItemBgHover
        },
        [`&:not(${n}-disabled).filter-node ${r}-title`]: {
          color: "inherit",
          fontWeight: 500
        },
        "&-draggable": {
          cursor: "grab",
          [`${r}-draggable-icon`]: {
            // https://github.com/ant-design/ant-design/issues/41915
            flexShrink: 0,
            width: i,
            lineHeight: `${ve(i)}`,
            textAlign: "center",
            visibility: "visible",
            opacity: 0.2,
            transition: `opacity ${t.motionDurationSlow}`,
            [`${n}:hover &`]: {
              opacity: 0.45
            }
          },
          [`&${n}-disabled`]: {
            [`${r}-draggable-icon`]: {
              visibility: "hidden"
            }
          }
        }
      },
      // >>> Indent
      [`${r}-indent`]: {
        alignSelf: "stretch",
        whiteSpace: "nowrap",
        userSelect: "none",
        "&-unit": {
          display: "inline-block",
          width: i
        }
      },
      // >>> Drag Handler
      [`${r}-draggable-icon`]: {
        visibility: "hidden"
      },
      // >>> Switcher
      [`${r}-switcher`]: Object.assign(Object.assign({}, vwe(e, t)), {
        position: "relative",
        flex: "none",
        alignSelf: "stretch",
        width: i,
        margin: 0,
        lineHeight: `${ve(i)}`,
        textAlign: "center",
        cursor: "pointer",
        userSelect: "none",
        transition: `all ${t.motionDurationSlow}`,
        borderRadius: t.borderRadius,
        "&-noop": {
          cursor: "unset"
        },
        [`&:not(${r}-switcher-noop):hover`]: {
          backgroundColor: t.colorBgTextHover
        },
        "&_close": {
          [`${r}-switcher-icon`]: {
            svg: {
              transform: "rotate(-90deg)"
            }
          }
        },
        "&-loading-icon": {
          color: t.colorPrimary
        },
        "&-leaf-line": {
          position: "relative",
          zIndex: 1,
          display: "inline-block",
          width: "100%",
          height: "100%",
          // https://github.com/ant-design/ant-design/issues/31884
          "&:before": {
            position: "absolute",
            top: 0,
            insetInlineEnd: t.calc(i).div(2).equal(),
            bottom: t.calc(a).mul(-1).equal(),
            marginInlineStart: -1,
            borderInlineEnd: `1px solid ${t.colorBorder}`,
            content: '""'
          },
          "&:after": {
            position: "absolute",
            width: t.calc(t.calc(i).div(2).equal()).mul(0.8).equal(),
            height: t.calc(i).div(2).equal(),
            borderBottom: `1px solid ${t.colorBorder}`,
            content: '""'
          }
        }
      }),
      // >>> Checkbox
      [`${r}-checkbox`]: {
        top: "initial",
        marginInlineEnd: l,
        alignSelf: "flex-start",
        marginTop: t.marginXXS
      },
      // >>> Title
      // add `${treeCls}-checkbox + span` to cover checkbox `${checkboxCls} + span`
      [`${r}-node-content-wrapper, ${r}-checkbox + span`]: {
        position: "relative",
        zIndex: "auto",
        minHeight: i,
        margin: 0,
        padding: `0 ${ve(t.calc(t.paddingXS).div(2).equal())}`,
        color: "inherit",
        lineHeight: `${ve(i)}`,
        background: "transparent",
        borderRadius: t.borderRadius,
        cursor: "pointer",
        transition: `all ${t.motionDurationMid}, border 0s, line-height 0s, box-shadow 0s`,
        "&:hover": {
          backgroundColor: s
        },
        [`&${r}-node-selected`]: {
          backgroundColor: o
        },
        // Icon
        [`${r}-iconEle`]: {
          display: "inline-block",
          width: i,
          height: i,
          lineHeight: `${ve(i)}`,
          textAlign: "center",
          verticalAlign: "top",
          "&:empty": {
            display: "none"
          }
        }
      },
      // https://github.com/ant-design/ant-design/issues/28217
      [`${r}-unselectable ${r}-node-content-wrapper:hover`]: {
        backgroundColor: "transparent"
      },
      // ==================== Draggable =====================
      [`${r}-node-content-wrapper`]: Object.assign({
        lineHeight: `${ve(i)}`,
        userSelect: "none"
      }, hwe(e, t)),
      [`${n}.drop-container`]: {
        "> [draggable]": {
          boxShadow: `0 0 0 2px ${t.colorPrimary}`
        }
      },
      // ==================== Show Line =====================
      "&-show-line": {
        // ================ Indent lines ================
        [`${r}-indent`]: {
          "&-unit": {
            position: "relative",
            height: "100%",
            "&:before": {
              position: "absolute",
              top: 0,
              insetInlineEnd: t.calc(i).div(2).equal(),
              bottom: t.calc(a).mul(-1).equal(),
              borderInlineEnd: `1px solid ${t.colorBorder}`,
              content: '""'
            },
            "&-end": {
              "&:before": {
                display: "none"
              }
            }
          }
        },
        // ============== Cover Background ==============
        [`${r}-switcher`]: {
          background: "transparent",
          "&-line-icon": {
            // https://github.com/ant-design/ant-design/issues/32813
            verticalAlign: "-0.15em"
          }
        }
      },
      [`${n}-leaf-last`]: {
        [`${r}-switcher`]: {
          "&-leaf-line": {
            "&:before": {
              top: "auto !important",
              bottom: "auto !important",
              height: `${ve(t.calc(i).div(2).equal())} !important`
            }
          }
        }
      }
    })
  };
}, ywe = (e) => {
  const {
    treeCls: t,
    treeNodeCls: r,
    treeNodePadding: n,
    directoryNodeSelectedBg: a,
    directoryNodeSelectedColor: i
  } = e;
  return {
    [`${t}${t}-directory`]: {
      // ================== TreeNode ==================
      [r]: {
        position: "relative",
        // Hover color
        "&:before": {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: n,
          insetInlineStart: 0,
          transition: `background-color ${e.motionDurationMid}`,
          content: '""',
          pointerEvents: "none"
        },
        "&:hover": {
          "&:before": {
            background: e.controlItemBgHover
          }
        },
        // Elements
        "> *": {
          zIndex: 1
        },
        // >>> Switcher
        [`${t}-switcher`]: {
          transition: `color ${e.motionDurationMid}`
        },
        // >>> Title
        [`${t}-node-content-wrapper`]: {
          borderRadius: 0,
          userSelect: "none",
          "&:hover": {
            background: "transparent"
          },
          [`&${t}-node-selected`]: {
            color: i,
            background: "transparent"
          }
        },
        // ============= Selected =============
        "&-selected": {
          "\n            &:hover::before,\n            &::before\n          ": {
            background: a
          },
          // >>> Switcher
          [`${t}-switcher`]: {
            color: i
          },
          // >>> Title
          [`${t}-node-content-wrapper`]: {
            color: i,
            background: "transparent"
          }
        }
      }
    }
  };
}, bwe = (e, t) => {
  const r = `.${e}`, n = `${r}-treenode`, a = t.calc(t.paddingXS).div(2).equal(), i = $r(t, {
    treeCls: r,
    treeNodeCls: n,
    treeNodePadding: a
  });
  return [
    // Basic
    gwe(e, i),
    // Directory
    ywe(i)
  ];
}, Cwe = (e) => {
  const {
    controlHeightSM: t
  } = e;
  return {
    titleHeight: t,
    nodeHoverBg: e.controlItemBgHover,
    nodeSelectedBg: e.controlItemBgActive
  };
}, Swe = (e) => {
  const {
    colorTextLightSolid: t,
    colorPrimary: r
  } = e;
  return Object.assign(Object.assign({}, Cwe(e)), {
    directoryNodeSelectedColor: t,
    directoryNodeSelectedBg: r
  });
}, xwe = Zr("Tree", (e, t) => {
  let {
    prefixCls: r
  } = t;
  return [{
    [e.componentCls]: MG(`${r}-checkbox`, e)
  }, bwe(r, e), WT(e)];
}, Swe), B4 = 4;
function $we(e) {
  const {
    dropPosition: t,
    dropLevelOffset: r,
    prefixCls: n,
    indent: a,
    direction: i = "ltr"
  } = e, o = i === "ltr" ? "left" : "right", s = i === "ltr" ? "right" : "left", l = {
    [o]: -r * a + B4,
    [s]: 0
  };
  switch (t) {
    case -1:
      l.top = -3;
      break;
    case 1:
      l.bottom = -3;
      break;
    default:
      l.bottom = -3, l[o] = a + B4;
      break;
  }
  return /* @__PURE__ */ xe.createElement("div", {
    style: l,
    className: `${n}-drop-indicator`
  });
}
var _we = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, name: "caret-down", theme: "filled" }, Ewe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: _we
  }));
}, xW = /* @__PURE__ */ p.forwardRef(Ewe);
process.env.NODE_ENV !== "production" && (xW.displayName = "CaretDownFilled");
var wwe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { tag: "path", attrs: { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, name: "minus-square", theme: "outlined" }, Owe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: wwe
  }));
}, $W = /* @__PURE__ */ p.forwardRef(Owe);
process.env.NODE_ENV !== "production" && ($W.displayName = "MinusSquareOutlined");
var Twe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { tag: "path", attrs: { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, name: "plus-square", theme: "outlined" }, Iwe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: Twe
  }));
}, _W = /* @__PURE__ */ p.forwardRef(Iwe);
process.env.NODE_ENV !== "production" && (_W.displayName = "PlusSquareOutlined");
const Mwe = (e) => {
  const {
    prefixCls: t,
    switcherIcon: r,
    treeNodeProps: n,
    showLine: a
  } = e, {
    isLeaf: i,
    expanded: o,
    loading: s
  } = n;
  if (s)
    return /* @__PURE__ */ p.createElement(Dc, {
      className: `${t}-switcher-loading-icon`
    });
  let l;
  if (a && typeof a == "object" && (l = a.showLeafIcon), i) {
    if (!a)
      return null;
    if (typeof l != "boolean" && l) {
      const d = typeof l == "function" ? l(n) : l, f = `${t}-switcher-line-custom-icon`;
      return /* @__PURE__ */ p.isValidElement(d) ? Si(d, {
        className: be(d.props.className || "", f)
      }) : d;
    }
    return l ? /* @__PURE__ */ p.createElement(XI, {
      className: `${t}-switcher-line-icon`
    }) : /* @__PURE__ */ p.createElement("span", {
      className: `${t}-switcher-leaf-line`
    });
  }
  const c = `${t}-switcher-icon`, u = typeof r == "function" ? r(n) : r;
  return /* @__PURE__ */ p.isValidElement(u) ? Si(u, {
    className: be(u.props.className || "", c)
  }) : u !== void 0 ? u : a ? o ? /* @__PURE__ */ p.createElement($W, {
    className: `${t}-switcher-line-icon`
  }) : /* @__PURE__ */ p.createElement(_W, {
    className: `${t}-switcher-line-icon`
  }) : /* @__PURE__ */ p.createElement(xW, {
    className: c
  });
}, JI = /* @__PURE__ */ xe.forwardRef((e, t) => {
  var r;
  const {
    getPrefixCls: n,
    direction: a,
    virtual: i,
    tree: o
  } = xe.useContext(Lt), {
    prefixCls: s,
    className: l,
    showIcon: c = !1,
    showLine: u,
    switcherIcon: d,
    blockNode: f = !1,
    children: m,
    checkable: h = !1,
    selectable: g = !0,
    draggable: y,
    motion: S,
    style: x
  } = e, b = n("tree", s), _ = n(), $ = S ?? Object.assign(Object.assign({}, Pb(_)), {
    motionAppear: !1
  }), w = Object.assign(Object.assign({}, e), {
    checkable: h,
    selectable: g,
    showIcon: c,
    motion: $,
    blockNode: f,
    showLine: !!u,
    dropIndicatorRender: $we
  }), [O, T, I] = xwe(b), [, P] = ua(), D = P.paddingXS / 2 + (((r = P.Tree) === null || r === void 0 ? void 0 : r.titleHeight) || P.controlHeightSM), B = xe.useMemo(() => {
    if (!y)
      return !1;
    let N = {};
    switch (typeof y) {
      case "function":
        N.nodeDraggable = y;
        break;
      case "object":
        N = Object.assign({}, y);
        break;
    }
    return N.icon !== !1 && (N.icon = N.icon || /* @__PURE__ */ xe.createElement(SW, null)), N;
  }, [y]), L = (N) => /* @__PURE__ */ xe.createElement(Mwe, {
    prefixCls: b,
    switcherIcon: d,
    treeNodeProps: N,
    showLine: u
  });
  return O(
    // @ts-ignore
    /* @__PURE__ */ xe.createElement(ZI, Object.assign({
      itemHeight: D,
      ref: t,
      virtual: i
    }, w, {
      // newProps may contain style so declare style below it
      style: Object.assign(Object.assign({}, o?.style), x),
      prefixCls: b,
      className: be({
        [`${b}-icon-hide`]: !c,
        [`${b}-block-node`]: f,
        [`${b}-unselectable`]: !g,
        [`${b}-rtl`]: a === "rtl"
      }, o?.className, l, T, I),
      direction: a,
      checkable: h && /* @__PURE__ */ xe.createElement("span", {
        className: `${b}-checkbox-inner`
      }),
      selectable: g,
      switcherIcon: L,
      draggable: B
    }), m)
  );
});
process.env.NODE_ENV !== "production" && (JI.displayName = "Tree");
const z4 = 0, Dx = 1, H4 = 2;
function QI(e, t, r) {
  const {
    key: n,
    children: a
  } = r;
  function i(o) {
    const s = o[n], l = o[a];
    t(s, o) !== !1 && QI(l || [], t, r);
  }
  e.forEach(i);
}
function Awe(e) {
  let {
    treeData: t,
    expandedKeys: r,
    startKey: n,
    endKey: a,
    fieldNames: i
  } = e;
  const o = [];
  let s = z4;
  if (n && n === a)
    return [n];
  if (!n || !a)
    return [];
  function l(c) {
    return c === n || c === a;
  }
  return QI(t, (c) => {
    if (s === H4)
      return !1;
    if (l(c)) {
      if (o.push(c), s === z4)
        s = Dx;
      else if (s === Dx)
        return s = H4, !1;
    } else s === Dx && o.push(c);
    return r.includes(c);
  }, ud(i)), o;
}
function jx(e, t, r) {
  const n = ze(t), a = [];
  return QI(e, (i, o) => {
    const s = n.indexOf(i);
    return s !== -1 && (a.push(o), n.splice(s, 1)), !!n.length;
  }, ud(r)), a;
}
var V4 = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function Pwe(e) {
  const {
    isLeaf: t,
    expanded: r
  } = e;
  return t ? /* @__PURE__ */ p.createElement(XI, null) : r ? /* @__PURE__ */ p.createElement(bW, null) : /* @__PURE__ */ p.createElement(CW, null);
}
function G4(e) {
  let {
    treeData: t,
    children: r
  } = e;
  return t || TG(r);
}
const Rwe = (e, t) => {
  var {
    defaultExpandAll: r,
    defaultExpandParent: n,
    defaultExpandedKeys: a
  } = e, i = V4(e, ["defaultExpandAll", "defaultExpandParent", "defaultExpandedKeys"]);
  const o = p.useRef(), s = p.useRef(), l = () => {
    const {
      keyEntities: T
    } = TI(G4(i));
    let I;
    return r ? I = Object.keys(T) : n ? I = gE(i.expandedKeys || a || [], T) : I = i.expandedKeys || a || [], I;
  }, [c, u] = p.useState(i.selectedKeys || i.defaultSelectedKeys || []), [d, f] = p.useState(() => l());
  p.useEffect(() => {
    "selectedKeys" in i && u(i.selectedKeys);
  }, [i.selectedKeys]), p.useEffect(() => {
    "expandedKeys" in i && f(i.expandedKeys);
  }, [i.expandedKeys]);
  const m = (T, I) => {
    var P;
    return "expandedKeys" in i || f(T), (P = i.onExpand) === null || P === void 0 ? void 0 : P.call(i, T, I);
  }, h = (T, I) => {
    var P;
    const {
      multiple: D,
      fieldNames: B
    } = i, {
      node: L,
      nativeEvent: N
    } = I, {
      key: z = ""
    } = L, F = G4(i), j = Object.assign(Object.assign({}, I), {
      selected: !0
    }), H = N?.ctrlKey || N?.metaKey, U = N?.shiftKey;
    let G;
    D && H ? (G = T, o.current = z, s.current = G, j.selectedNodes = jx(F, G, B)) : D && U ? (G = Array.from(new Set([].concat(ze(s.current || []), ze(Awe({
      treeData: F,
      expandedKeys: d,
      startKey: z,
      endKey: o.current,
      fieldNames: B
    }))))), j.selectedNodes = jx(F, G, B)) : (G = [z], o.current = z, s.current = G, j.selectedNodes = jx(F, G, B)), (P = i.onSelect) === null || P === void 0 || P.call(i, G, j), "selectedKeys" in i || u(G);
  }, {
    getPrefixCls: g,
    direction: y
  } = p.useContext(Lt), {
    prefixCls: S,
    className: x,
    showIcon: b = !0,
    expandAction: _ = "click"
  } = i, $ = V4(i, ["prefixCls", "className", "showIcon", "expandAction"]), w = g("tree", S), O = be(`${w}-directory`, {
    [`${w}-directory-rtl`]: y === "rtl"
  }, x);
  return /* @__PURE__ */ p.createElement(JI, Object.assign({
    icon: Pwe,
    ref: t,
    blockNode: !0
  }, $, {
    showIcon: b,
    expandAction: _,
    prefixCls: w,
    className: O,
    expandedKeys: d,
    selectedKeys: c,
    onSelect: h,
    onExpand: m
  }));
}, EW = /* @__PURE__ */ p.forwardRef(Rwe);
process.env.NODE_ENV !== "production" && (EW.displayName = "DirectoryTree");
const eM = JI;
eM.DirectoryTree = EW;
eM.TreeNode = dd;
function U4(e) {
  let {
    value: t,
    onChange: r,
    filterSearch: n,
    tablePrefixCls: a,
    locale: i
  } = e;
  return n ? /* @__PURE__ */ p.createElement("div", {
    className: `${a}-filter-dropdown-search`
  }, /* @__PURE__ */ p.createElement(Lr, {
    prefix: /* @__PURE__ */ p.createElement(L1, null),
    placeholder: i.filterSearchPlaceholder,
    onChange: r,
    value: t,
    // for skip min-width of input
    htmlSize: 1,
    className: `${a}-filter-dropdown-search-input`
  })) : null;
}
const Nwe = (e) => {
  const {
    keyCode: t
  } = e;
  t === Mt.ENTER && e.stopPropagation();
}, wW = /* @__PURE__ */ p.forwardRef((e, t) => /* @__PURE__ */ p.createElement("div", {
  className: e.className,
  onClick: (r) => r.stopPropagation(),
  onKeyDown: Nwe,
  ref: t
}, e.children));
process.env.NODE_ENV !== "production" && (wW.displayName = "FilterDropdownMenuWrapper");
function nd(e) {
  let t = [];
  return (e || []).forEach((r) => {
    let {
      value: n,
      children: a
    } = r;
    t.push(n), a && (t = [].concat(ze(t), ze(nd(a))));
  }), t;
}
function Dwe(e) {
  return e.some((t) => {
    let {
      children: r
    } = t;
    return r;
  });
}
function OW(e, t) {
  return typeof t == "string" || typeof t == "number" ? t?.toString().toLowerCase().includes(e.trim().toLowerCase()) : !1;
}
function TW(e) {
  let {
    filters: t,
    prefixCls: r,
    filteredKeys: n,
    filterMultiple: a,
    searchValue: i,
    filterSearch: o
  } = e;
  return t.map((s, l) => {
    const c = String(s.value);
    if (s.children)
      return {
        key: c || l,
        label: s.text,
        popupClassName: `${r}-dropdown-submenu`,
        children: TW({
          filters: s.children,
          prefixCls: r,
          filteredKeys: n,
          filterMultiple: a,
          searchValue: i,
          filterSearch: o
        })
      };
    const u = a ? co : Ba, d = {
      key: s.value !== void 0 ? c : l,
      label: /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement(u, {
        checked: n.includes(c)
      }), /* @__PURE__ */ p.createElement("span", null, s.text))
    };
    return i.trim() ? typeof o == "function" ? o(i, s) ? d : null : OW(i, s.text) ? d : null : d;
  });
}
function Lx(e) {
  return e || [];
}
function jwe(e) {
  var t, r;
  const {
    tablePrefixCls: n,
    prefixCls: a,
    column: i,
    dropdownPrefixCls: o,
    columnKey: s,
    filterOnClose: l,
    filterMultiple: c,
    filterMode: u = "menu",
    filterSearch: d = !1,
    filterState: f,
    triggerFilter: m,
    locale: h,
    children: g,
    getPopupContainer: y,
    rootClassName: S
  } = e, {
    filterDropdownOpen: x,
    onFilterDropdownOpenChange: b,
    filterResetToDefaultFilteredValue: _,
    defaultFilteredValue: $,
    // Deprecated
    filterDropdownVisible: w,
    onFilterDropdownVisibleChange: O
  } = i, [T, I] = p.useState(!1), P = !!(f && (!((t = f.filteredKeys) === null || t === void 0) && t.length || f.forceFiltered)), D = (M) => {
    I(M), b?.(M), O?.(M);
  };
  if (process.env.NODE_ENV !== "production") {
    const M = xr("Table");
    [["filterDropdownVisible", "filterDropdownOpen", w], ["onFilterDropdownVisibleChange", "onFilterDropdownOpenChange", O]].forEach((R) => {
      let [q, Y, X] = R;
      M.deprecated(X == null, q, Y);
    });
  }
  const B = (r = x ?? w) !== null && r !== void 0 ? r : T, L = f?.filteredKeys, [N, z] = ZEe(Lx(L)), F = (M) => {
    let {
      selectedKeys: R
    } = M;
    z(R);
  }, j = (M, R) => {
    let {
      node: q,
      checked: Y
    } = R;
    F(c ? {
      selectedKeys: M
    } : {
      selectedKeys: Y && q.key ? [q.key] : []
    });
  };
  p.useEffect(() => {
    T && F({
      selectedKeys: Lx(L)
    });
  }, [L]);
  const [H, U] = p.useState([]), G = (M) => {
    U(M);
  }, [V, K] = p.useState(""), Z = (M) => {
    const {
      value: R
    } = M.target;
    K(R);
  };
  p.useEffect(() => {
    T || K("");
  }, [T]);
  const ee = (M) => {
    const R = M && M.length ? M : null;
    if (R === null && (!f || !f.filteredKeys) || Do(R, f?.filteredKeys, !0))
      return null;
    m({
      column: i,
      key: s,
      filteredKeys: R
    });
  }, ae = () => {
    D(!1), ee(N());
  }, ue = function() {
    let {
      confirm: M,
      closeDropdown: R
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
      confirm: !1,
      closeDropdown: !1
    };
    M && ee([]), R && D(!1), K(""), z(_ ? ($ || []).map((q) => String(q)) : []);
  }, re = function() {
    let {
      closeDropdown: M
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
      closeDropdown: !0
    };
    M && D(!1), ee(N());
  }, oe = (M, R) => {
    R.source === "trigger" && (M && L !== void 0 && z(Lx(L)), D(M), !M && !i.filterDropdown && l && ae());
  }, fe = be({
    [`${o}-menu-without-submenu`]: !Dwe(i.filters || [])
  }), le = (M) => {
    if (M.target.checked) {
      const R = nd(i?.filters).map((q) => String(q));
      z(R);
    } else
      z([]);
  }, se = (M) => {
    let {
      filters: R
    } = M;
    return (R || []).map((q, Y) => {
      const X = String(q.value), pe = {
        title: q.text,
        key: q.value !== void 0 ? X : String(Y)
      };
      return q.children && (pe.children = se({
        filters: q.children
      })), pe;
    });
  }, Q = (M) => {
    var R;
    return Object.assign(Object.assign({}, M), {
      text: M.title,
      value: M.key,
      children: ((R = M.children) === null || R === void 0 ? void 0 : R.map((q) => Q(q))) || []
    });
  };
  let he;
  if (typeof i.filterDropdown == "function")
    he = i.filterDropdown({
      prefixCls: `${o}-custom`,
      setSelectedKeys: (M) => F({
        selectedKeys: M
      }),
      selectedKeys: N(),
      confirm: re,
      clearFilters: ue,
      filters: i.filters,
      visible: B,
      close: () => {
        D(!1);
      }
    });
  else if (i.filterDropdown)
    he = i.filterDropdown;
  else {
    const M = N() || [], R = () => {
      const Y = /* @__PURE__ */ p.createElement(Io, {
        image: Io.PRESENTED_IMAGE_SIMPLE,
        description: h.filterEmptyText,
        imageStyle: {
          height: 24
        },
        style: {
          margin: 0,
          padding: "16px 0"
        }
      });
      if ((i.filters || []).length === 0)
        return Y;
      if (u === "tree")
        return /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement(U4, {
          filterSearch: d,
          value: V,
          onChange: Z,
          tablePrefixCls: n,
          locale: h
        }), /* @__PURE__ */ p.createElement("div", {
          className: `${n}-filter-dropdown-tree`
        }, c ? /* @__PURE__ */ p.createElement(co, {
          checked: M.length === nd(i.filters).length,
          indeterminate: M.length > 0 && M.length < nd(i.filters).length,
          className: `${n}-filter-dropdown-checkall`,
          onChange: le
        }, h.filterCheckall) : null, /* @__PURE__ */ p.createElement(eM, {
          checkable: !0,
          selectable: !1,
          blockNode: !0,
          multiple: c,
          checkStrictly: !c,
          className: `${o}-menu`,
          onCheck: j,
          checkedKeys: M,
          selectedKeys: M,
          showIcon: !1,
          treeData: se({
            filters: i.filters
          }),
          autoExpandParent: !0,
          defaultExpandAll: !0,
          filterTreeNode: V.trim() ? ($e) => typeof d == "function" ? d(V, Q($e)) : OW(V, $e.title) : void 0
        })));
      const X = TW({
        filters: i.filters || [],
        filterSearch: d,
        prefixCls: a,
        filteredKeys: N(),
        filterMultiple: c,
        searchValue: V
      }), pe = X.every(($e) => $e === null);
      return /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement(U4, {
        filterSearch: d,
        value: V,
        onChange: Z,
        tablePrefixCls: n,
        locale: h
      }), pe ? Y : /* @__PURE__ */ p.createElement(Fc, {
        selectable: !0,
        multiple: c,
        prefixCls: `${o}-menu`,
        className: fe,
        onSelect: F,
        onDeselect: F,
        selectedKeys: M,
        getPopupContainer: y,
        openKeys: H,
        onOpenChange: G,
        items: X
      }));
    }, q = () => _ ? Do(($ || []).map((Y) => String(Y)), M, !0) : M.length === 0;
    he = /* @__PURE__ */ p.createElement(p.Fragment, null, R(), /* @__PURE__ */ p.createElement("div", {
      className: `${a}-dropdown-btns`
    }, /* @__PURE__ */ p.createElement(Nt, {
      type: "link",
      size: "small",
      disabled: q(),
      onClick: () => ue()
    }, h.filterReset), /* @__PURE__ */ p.createElement(Nt, {
      type: "primary",
      size: "small",
      onClick: ae
    }, h.filterConfirm)));
  }
  i.filterDropdown && (he = /* @__PURE__ */ p.createElement(yV, {
    selectable: void 0
  }, he));
  const ne = () => /* @__PURE__ */ p.createElement(wW, {
    className: `${a}-dropdown`
  }, he);
  let me;
  typeof i.filterIcon == "function" ? me = i.filterIcon(P) : i.filterIcon ? me = i.filterIcon : me = /* @__PURE__ */ p.createElement(mW, null);
  const {
    direction: k
  } = p.useContext(Lt);
  return /* @__PURE__ */ p.createElement("div", {
    className: `${a}-column`
  }, /* @__PURE__ */ p.createElement("span", {
    className: `${n}-column-title`
  }, g), /* @__PURE__ */ p.createElement(kI, {
    dropdownRender: ne,
    trigger: ["click"],
    open: B,
    onOpenChange: oe,
    getPopupContainer: y,
    placement: k === "rtl" ? "bottomLeft" : "bottomRight",
    rootClassName: S
  }, /* @__PURE__ */ p.createElement("span", {
    role: "button",
    tabIndex: -1,
    className: be(`${a}-trigger`, {
      active: P
    }),
    onClick: (M) => {
      M.stopPropagation();
    }
  }, me)));
}
function xE(e, t, r) {
  let n = [];
  return (e || []).forEach((a, i) => {
    var o;
    const s = Ih(i, r);
    if (a.filters || "filterDropdown" in a || "onFilter" in a)
      if ("filteredValue" in a) {
        let l = a.filteredValue;
        "filterDropdown" in a || (l = (o = l?.map(String)) !== null && o !== void 0 ? o : l), n.push({
          column: a,
          key: wc(a, s),
          filteredKeys: l,
          forceFiltered: a.filtered
        });
      } else
        n.push({
          column: a,
          key: wc(a, s),
          filteredKeys: t && a.defaultFilteredValue ? a.defaultFilteredValue : void 0,
          forceFiltered: a.filtered
        });
    "children" in a && (n = [].concat(ze(n), ze(xE(a.children, t, s))));
  }), n;
}
function IW(e, t, r, n, a, i, o, s, l) {
  return r.map((c, u) => {
    const d = Ih(u, s), {
      filterOnClose: f = !0,
      filterMultiple: m = !0,
      filterMode: h,
      filterSearch: g
    } = c;
    let y = c;
    if (y.filters || y.filterDropdown) {
      const S = wc(y, d), x = n.find((b) => {
        let {
          key: _
        } = b;
        return S === _;
      });
      y = Object.assign(Object.assign({}, y), {
        title: (b) => /* @__PURE__ */ p.createElement(jwe, {
          tablePrefixCls: e,
          prefixCls: `${e}-filter`,
          dropdownPrefixCls: t,
          column: y,
          columnKey: S,
          filterState: x,
          filterOnClose: f,
          filterMultiple: m,
          filterMode: h,
          filterSearch: g,
          triggerFilter: i,
          locale: a,
          getPopupContainer: o,
          rootClassName: l
        }, tC(c.title, b))
      });
    }
    return "children" in y && (y = Object.assign(Object.assign({}, y), {
      children: IW(e, t, y.children, n, a, i, o, d, l)
    })), y;
  });
}
function W4(e) {
  const t = {};
  return e.forEach((r) => {
    let {
      key: n,
      filteredKeys: a,
      column: i
    } = r;
    const o = n, {
      filters: s,
      filterDropdown: l
    } = i;
    if (l)
      t[o] = a || null;
    else if (Array.isArray(a)) {
      const c = nd(s);
      t[o] = c.filter((u) => a.includes(String(u)));
    } else
      t[o] = null;
  }), t;
}
function $E(e, t, r) {
  return t.reduce((n, a) => {
    const {
      column: {
        onFilter: i,
        filters: o
      },
      filteredKeys: s
    } = a;
    return i && s && s.length ? n.map((l) => Object.assign({}, l)).filter((l) => s.some((c) => {
      const u = nd(o), d = u.findIndex((m) => String(m) === String(c)), f = d !== -1 ? u[d] : c;
      return l[r] && (l[r] = $E(l[r], t, r)), i(f, l);
    })) : n;
  }, e);
}
const MW = (e) => e.flatMap((t) => "children" in t ? [t].concat(ze(MW(t.children || []))) : [t]);
function Lwe(e) {
  let {
    prefixCls: t,
    dropdownPrefixCls: r,
    mergedColumns: n,
    onFilterChange: a,
    getPopupContainer: i,
    locale: o,
    rootClassName: s
  } = e;
  const l = xr("Table"), c = p.useMemo(() => MW(n || []), [n]), [u, d] = p.useState(() => xE(c, !0)), f = p.useMemo(() => {
    const y = xE(c, !1);
    if (y.length === 0)
      return y;
    let S = !0, x = !0;
    if (y.forEach((b) => {
      let {
        filteredKeys: _
      } = b;
      _ !== void 0 ? S = !1 : x = !1;
    }), S) {
      const b = (c || []).map((_, $) => wc(_, Ih($)));
      return u.filter((_) => {
        let {
          key: $
        } = _;
        return b.includes($);
      }).map((_) => {
        const $ = c[b.findIndex((w) => w === _.key)];
        return Object.assign(Object.assign({}, _), {
          column: Object.assign(Object.assign({}, _.column), $),
          forceFiltered: $.filtered
        });
      });
    }
    return process.env.NODE_ENV !== "production" && l(x, "usage", "Columns should all contain `filteredValue` or not contain `filteredValue`."), y;
  }, [c, u]), m = p.useMemo(() => W4(f), [f]), h = (y) => {
    const S = f.filter((x) => {
      let {
        key: b
      } = x;
      return b !== y.key;
    });
    S.push(y), d(S), a(W4(S), S);
  };
  return [(y) => IW(t, r, y, f, o, h, i, void 0, s), f, m];
}
function kwe(e, t, r) {
  const n = p.useRef({});
  function a(i) {
    if (!n.current || n.current.data !== e || n.current.childrenColumnName !== t || n.current.getRowKey !== r) {
      let s = function(l) {
        l.forEach((c, u) => {
          const d = r(c, u);
          o.set(d, c), c && typeof c == "object" && t in c && s(c[t] || []);
        });
      };
      const o = /* @__PURE__ */ new Map();
      s(e), n.current = {
        data: e,
        childrenColumnName: t,
        kvMap: o,
        getRowKey: r
      };
    }
    return n.current.kvMap.get(i);
  }
  return [a];
}
var Fwe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const AW = 10;
function Bwe(e, t) {
  const r = {
    current: e.current,
    pageSize: e.pageSize
  };
  return Object.keys(t && typeof t == "object" ? t : {}).forEach((a) => {
    const i = e[a];
    typeof i != "function" && (r[a] = i);
  }), r;
}
function zwe(e, t, r) {
  const n = r && typeof r == "object" ? r : {}, {
    total: a = 0
  } = n, i = Fwe(n, ["total"]), [o, s] = He(() => ({
    current: "defaultCurrent" in i ? i.defaultCurrent : 1,
    pageSize: "defaultPageSize" in i ? i.defaultPageSize : AW
  })), l = V_e(o, i, {
    total: a > 0 ? a : e
  }), c = Math.ceil((a || e) / l.pageSize);
  l.current > c && (l.current = c || 1);
  const u = (f, m) => {
    s({
      current: f ?? 1,
      pageSize: m || l.pageSize
    });
  }, d = (f, m) => {
    var h;
    r && ((h = r.onChange) === null || h === void 0 || h.call(r, f, m)), u(f, m), t(f, m || l?.pageSize);
  };
  return r === !1 ? [{}, () => {
  }] : [Object.assign(Object.assign({}, l), {
    onChange: d
  }), u];
}
var Hwe = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, name: "caret-down", theme: "outlined" }, Vwe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: Hwe
  }));
}, PW = /* @__PURE__ */ p.forwardRef(Vwe);
process.env.NODE_ENV !== "production" && (PW.displayName = "CaretDownOutlined");
var Gwe = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] }, name: "caret-up", theme: "outlined" }, Uwe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: Gwe
  }));
}, RW = /* @__PURE__ */ p.forwardRef(Uwe);
process.env.NODE_ENV !== "production" && (RW.displayName = "CaretUpOutlined");
const mb = "ascend", kx = "descend";
function Kb(e) {
  return typeof e.sorter == "object" && typeof e.sorter.multiple == "number" ? e.sorter.multiple : !1;
}
function q4(e) {
  return typeof e == "function" ? e : e && typeof e == "object" && e.compare ? e.compare : !1;
}
function Wwe(e, t) {
  return t ? e[e.indexOf(t) + 1] : e[0];
}
function _E(e, t, r) {
  let n = [];
  function a(i, o) {
    n.push({
      column: i,
      key: wc(i, o),
      multiplePriority: Kb(i),
      sortOrder: i.sortOrder
    });
  }
  return (e || []).forEach((i, o) => {
    const s = Ih(o, r);
    i.children ? ("sortOrder" in i && a(i, s), n = [].concat(ze(n), ze(_E(i.children, t, s)))) : i.sorter && ("sortOrder" in i ? a(i, s) : t && i.defaultSortOrder && n.push({
      column: i,
      key: wc(i, s),
      multiplePriority: Kb(i),
      sortOrder: i.defaultSortOrder
    }));
  }), n;
}
function NW(e, t, r, n, a, i, o, s) {
  return (t || []).map((l, c) => {
    const u = Ih(c, s);
    let d = l;
    if (d.sorter) {
      const f = d.sortDirections || a, m = d.showSorterTooltip === void 0 ? o : d.showSorterTooltip, h = wc(d, u), g = r.find((T) => {
        let {
          key: I
        } = T;
        return I === h;
      }), y = g ? g.sortOrder : null, S = Wwe(f, y);
      let x;
      if (l.sortIcon)
        x = l.sortIcon({
          sortOrder: y
        });
      else {
        const T = f.includes(mb) && /* @__PURE__ */ p.createElement(RW, {
          className: be(`${e}-column-sorter-up`, {
            active: y === mb
          })
        }), I = f.includes(kx) && /* @__PURE__ */ p.createElement(PW, {
          className: be(`${e}-column-sorter-down`, {
            active: y === kx
          })
        });
        x = /* @__PURE__ */ p.createElement("span", {
          className: be(`${e}-column-sorter`, {
            [`${e}-column-sorter-full`]: !!(T && I)
          })
        }, /* @__PURE__ */ p.createElement("span", {
          className: `${e}-column-sorter-inner`,
          "aria-hidden": "true"
        }, T, I));
      }
      const {
        cancelSort: b,
        triggerAsc: _,
        triggerDesc: $
      } = i || {};
      let w = b;
      S === kx ? w = $ : S === mb && (w = _);
      const O = typeof m == "object" ? Object.assign({
        title: w
      }, m) : {
        title: w
      };
      d = Object.assign(Object.assign({}, d), {
        className: be(d.className, {
          [`${e}-column-sort`]: y
        }),
        title: (T) => {
          const I = `${e}-column-sorters`, P = /* @__PURE__ */ p.createElement("span", {
            className: `${e}-column-title`
          }, tC(l.title, T)), D = /* @__PURE__ */ p.createElement("div", {
            className: I
          }, P, x);
          return m ? typeof m != "boolean" && m?.target === "sorter-icon" ? /* @__PURE__ */ p.createElement("div", {
            className: `${I} ${e}-column-sorters-tooltip-target-sorter`
          }, P, /* @__PURE__ */ p.createElement(lo, Object.assign({}, O), x)) : /* @__PURE__ */ p.createElement(lo, Object.assign({}, O), D) : D;
        },
        onHeaderCell: (T) => {
          const I = l.onHeaderCell && l.onHeaderCell(T) || {}, P = I.onClick, D = I.onKeyDown;
          I.onClick = (N) => {
            n({
              column: l,
              key: h,
              sortOrder: S,
              multiplePriority: Kb(l)
            }), P?.(N);
          }, I.onKeyDown = (N) => {
            N.keyCode === Mt.ENTER && (n({
              column: l,
              key: h,
              sortOrder: S,
              multiplePriority: Kb(l)
            }), D?.(N));
          };
          const B = qEe(l.title, {}), L = B?.toString();
          return y ? I["aria-sort"] = y === "ascend" ? "ascending" : "descending" : I["aria-label"] = L || "", I.className = be(I.className, `${e}-column-has-sorters`), I.tabIndex = 0, l.ellipsis && (I.title = (B ?? "").toString()), I;
        }
      });
    }
    return "children" in d && (d = Object.assign(Object.assign({}, d), {
      children: NW(e, d.children, r, n, a, i, o, u)
    })), d;
  });
}
const K4 = (e) => {
  const {
    column: t,
    sortOrder: r
  } = e;
  return {
    column: t,
    order: r,
    field: t.dataIndex,
    columnKey: t.key
  };
}, Y4 = (e) => {
  const t = e.filter((r) => {
    let {
      sortOrder: n
    } = r;
    return n;
  }).map(K4);
  if (t.length === 0 && e.length) {
    const r = e.length - 1;
    return Object.assign(Object.assign({}, K4(e[r])), {
      column: void 0
    });
  }
  return t.length <= 1 ? t[0] || {} : t;
};
function EE(e, t, r) {
  const n = t.slice().sort((o, s) => s.multiplePriority - o.multiplePriority), a = e.slice(), i = n.filter((o) => {
    let {
      column: {
        sorter: s
      },
      sortOrder: l
    } = o;
    return q4(s) && l;
  });
  return i.length ? a.sort((o, s) => {
    for (let l = 0; l < i.length; l += 1) {
      const c = i[l], {
        column: {
          sorter: u
        },
        sortOrder: d
      } = c, f = q4(u);
      if (f && d) {
        const m = f(o, s, d);
        if (m !== 0)
          return d === mb ? m : -m;
      }
    }
    return 0;
  }).map((o) => {
    const s = o[r];
    return s ? Object.assign(Object.assign({}, o), {
      [r]: EE(s, t, r)
    }) : o;
  }) : a;
}
function qwe(e) {
  let {
    prefixCls: t,
    mergedColumns: r,
    onSorterChange: n,
    sortDirections: a,
    tableLocale: i,
    showSorterTooltip: o
  } = e;
  const [s, l] = p.useState(_E(r, !0)), c = p.useMemo(() => {
    let h = !0;
    const g = _E(r, !1);
    if (!g.length)
      return s;
    const y = [];
    function S(b) {
      h ? y.push(b) : y.push(Object.assign(Object.assign({}, b), {
        sortOrder: null
      }));
    }
    let x = null;
    return g.forEach((b) => {
      x === null ? (S(b), b.sortOrder && (b.multiplePriority === !1 ? h = !1 : x = !0)) : (x && b.multiplePriority !== !1 || (h = !1), S(b));
    }), y;
  }, [r, s]), u = p.useMemo(() => {
    const h = c.map((g) => {
      let {
        column: y,
        sortOrder: S
      } = g;
      return {
        column: y,
        order: S
      };
    });
    return {
      sortColumns: h,
      // Legacy
      sortColumn: h[0] && h[0].column,
      sortOrder: h[0] && h[0].order
    };
  }, [c]), d = (h) => {
    let g;
    h.multiplePriority === !1 || !c.length || c[0].multiplePriority === !1 ? g = [h] : g = [].concat(ze(c.filter((y) => {
      let {
        key: S
      } = y;
      return S !== h.key;
    })), [h]), l(g), n(Y4(g), g);
  };
  return [(h) => NW(t, h, c, d, a, i, o), c, u, () => Y4(c)];
}
function DW(e, t) {
  return e.map((r) => {
    const n = Object.assign({}, r);
    return n.title = tC(r.title, t), "children" in n && (n.children = DW(n.children, t)), n;
  });
}
function Kwe(e) {
  return [p.useCallback((r) => DW(r, e), [e])];
}
const Ywe = lW((e, t) => {
  const {
    _renderTimes: r
  } = e, {
    _renderTimes: n
  } = t;
  return r !== n;
}), Zwe = fW((e, t) => {
  const {
    _renderTimes: r
  } = e, {
    _renderTimes: n
  } = t;
  return r !== n;
}), Xwe = (e) => {
  const {
    componentCls: t,
    lineWidth: r,
    lineType: n,
    tableBorderColor: a,
    tableHeaderBg: i,
    tablePaddingVertical: o,
    tablePaddingHorizontal: s,
    calc: l
  } = e, c = `${ve(r)} ${n} ${a}`, u = (d, f, m) => ({
    [`&${t}-${d}`]: {
      [`> ${t}-container`]: {
        [`> ${t}-content, > ${t}-body`]: {
          "\n            > table > tbody > tr > th,\n            > table > tbody > tr > td\n          ": {
            [`> ${t}-expanded-row-fixed`]: {
              margin: `${ve(l(f).mul(-1).equal())}
              ${ve(l(l(m).add(r)).mul(-1).equal())}`
            }
          }
        }
      }
    }
  });
  return {
    [`${t}-wrapper`]: {
      [`${t}${t}-bordered`]: Object.assign(Object.assign(Object.assign({
        // ============================ Title =============================
        [`> ${t}-title`]: {
          border: c,
          borderBottom: 0
        },
        // ============================ Content ============================
        [`> ${t}-container`]: {
          borderInlineStart: c,
          borderTop: c,
          [`
            > ${t}-content,
            > ${t}-header,
            > ${t}-body,
            > ${t}-summary
          `]: {
            "> table": {
              // ============================= Cell =============================
              "\n                > thead > tr > th,\n                > thead > tr > td,\n                > tbody > tr > th,\n                > tbody > tr > td,\n                > tfoot > tr > th,\n                > tfoot > tr > td\n              ": {
                borderInlineEnd: c
              },
              // ============================ Header ============================
              "> thead": {
                "> tr:not(:last-child) > th": {
                  borderBottom: c
                },
                "> tr > th::before": {
                  backgroundColor: "transparent !important"
                }
              },
              // Fixed right should provides additional border
              "\n                > thead > tr,\n                > tbody > tr,\n                > tfoot > tr\n              ": {
                [`> ${t}-cell-fix-right-first::after`]: {
                  borderInlineEnd: c
                }
              },
              // ========================== Expandable ==========================
              "\n                > tbody > tr > th,\n                > tbody > tr > td\n              ": {
                [`> ${t}-expanded-row-fixed`]: {
                  margin: `${ve(l(o).mul(-1).equal())} ${ve(l(l(s).add(r)).mul(-1).equal())}`,
                  "&::after": {
                    position: "absolute",
                    top: 0,
                    insetInlineEnd: r,
                    bottom: 0,
                    borderInlineEnd: c,
                    content: '""'
                  }
                }
              }
            }
          }
        },
        // ============================ Scroll ============================
        [`&${t}-scroll-horizontal`]: {
          [`> ${t}-container > ${t}-body`]: {
            "> table > tbody": {
              [`
                > tr${t}-expanded-row,
                > tr${t}-placeholder
              `]: {
                "> th, > td": {
                  borderInlineEnd: 0
                }
              }
            }
          }
        }
      }, u("middle", e.tablePaddingVerticalMiddle, e.tablePaddingHorizontalMiddle)), u("small", e.tablePaddingVerticalSmall, e.tablePaddingHorizontalSmall)), {
        // ============================ Footer ============================
        [`> ${t}-footer`]: {
          border: c,
          borderTop: 0
        }
      }),
      // ============================ Nested ============================
      [`${t}-cell`]: {
        [`${t}-container:first-child`]: {
          // :first-child to avoid the case when bordered and title is set
          borderTop: 0
        },
        // https://github.com/ant-design/ant-design/issues/35577
        "&-scrollbar:not([rowspan])": {
          boxShadow: `0 ${ve(r)} 0 ${ve(r)} ${i}`
        }
      },
      [`${t}-bordered ${t}-cell-scrollbar`]: {
        borderInlineEnd: c
      }
    }
  };
}, Jwe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-wrapper`]: {
      [`${t}-cell-ellipsis`]: Object.assign(Object.assign({}, cs), {
        wordBreak: "keep-all",
        // Fixed first or last should special process
        [`
          &${t}-cell-fix-left-last,
          &${t}-cell-fix-right-first
        `]: {
          overflow: "visible",
          [`${t}-cell-content`]: {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }
        },
        [`${t}-column-title`]: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          wordBreak: "keep-all"
        }
      })
    }
  };
}, Qwe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-wrapper`]: {
      [`${t}-tbody > tr${t}-placeholder`]: {
        textAlign: "center",
        color: e.colorTextDisabled,
        "\n          &:hover > th,\n          &:hover > td,\n        ": {
          background: e.colorBgContainer
        }
      }
    }
  };
}, eOe = (e) => {
  const {
    componentCls: t,
    antCls: r,
    motionDurationSlow: n,
    lineWidth: a,
    paddingXS: i,
    lineType: o,
    tableBorderColor: s,
    tableExpandIconBg: l,
    tableExpandColumnWidth: c,
    borderRadius: u,
    tablePaddingVertical: d,
    tablePaddingHorizontal: f,
    tableExpandedRowBg: m,
    paddingXXS: h,
    expandIconMarginTop: g,
    expandIconSize: y,
    expandIconHalfInner: S,
    expandIconScale: x,
    calc: b
  } = e, _ = `${ve(a)} ${o} ${s}`, $ = b(h).sub(a).equal();
  return {
    [`${t}-wrapper`]: {
      [`${t}-expand-icon-col`]: {
        width: c
      },
      [`${t}-row-expand-icon-cell`]: {
        textAlign: "center",
        [`${t}-row-expand-icon`]: {
          display: "inline-flex",
          float: "none",
          verticalAlign: "sub"
        }
      },
      [`${t}-row-indent`]: {
        height: 1,
        float: "left"
      },
      [`${t}-row-expand-icon`]: Object.assign(Object.assign({}, MT(e)), {
        position: "relative",
        float: "left",
        boxSizing: "border-box",
        width: y,
        height: y,
        padding: 0,
        color: "inherit",
        lineHeight: ve(y),
        background: l,
        border: _,
        borderRadius: u,
        transform: `scale(${x})`,
        transition: `all ${n}`,
        userSelect: "none",
        "&:focus, &:hover, &:active": {
          borderColor: "currentcolor"
        },
        "&::before, &::after": {
          position: "absolute",
          background: "currentcolor",
          transition: `transform ${n} ease-out`,
          content: '""'
        },
        "&::before": {
          top: S,
          insetInlineEnd: $,
          insetInlineStart: $,
          height: a
        },
        "&::after": {
          top: $,
          bottom: $,
          insetInlineStart: S,
          width: a,
          transform: "rotate(90deg)"
        },
        // Motion effect
        "&-collapsed::before": {
          transform: "rotate(-180deg)"
        },
        "&-collapsed::after": {
          transform: "rotate(0deg)"
        },
        "&-spaced": {
          "&::before, &::after": {
            display: "none",
            content: "none"
          },
          background: "transparent",
          border: 0,
          visibility: "hidden"
        }
      }),
      [`${t}-row-indent + ${t}-row-expand-icon`]: {
        marginTop: g,
        marginInlineEnd: i
      },
      [`tr${t}-expanded-row`]: {
        "&, &:hover": {
          "> th, > td": {
            background: m
          }
        },
        // https://github.com/ant-design/ant-design/issues/25573
        [`${r}-descriptions-view`]: {
          display: "flex",
          table: {
            flex: "auto",
            width: "auto"
          }
        }
      },
      // With fixed
      [`${t}-expanded-row-fixed`]: {
        position: "relative",
        margin: `${ve(b(d).mul(-1).equal())} ${ve(b(f).mul(-1).equal())}`,
        padding: `${ve(d)} ${ve(f)}`
      }
    }
  };
}, tOe = (e) => {
  const {
    componentCls: t,
    antCls: r,
    iconCls: n,
    tableFilterDropdownWidth: a,
    tableFilterDropdownSearchWidth: i,
    paddingXXS: o,
    paddingXS: s,
    colorText: l,
    lineWidth: c,
    lineType: u,
    tableBorderColor: d,
    headerIconColor: f,
    fontSizeSM: m,
    tablePaddingHorizontal: h,
    borderRadius: g,
    motionDurationSlow: y,
    colorTextDescription: S,
    colorPrimary: x,
    tableHeaderFilterActiveBg: b,
    colorTextDisabled: _,
    tableFilterDropdownBg: $,
    tableFilterDropdownHeight: w,
    controlItemBgHover: O,
    controlItemBgActive: T,
    boxShadowSecondary: I,
    filterDropdownMenuBg: P,
    calc: D
  } = e, B = `${r}-dropdown`, L = `${t}-filter-dropdown`, N = `${r}-tree`, z = `${ve(c)} ${u} ${d}`;
  return [
    {
      [`${t}-wrapper`]: {
        [`${t}-filter-column`]: {
          display: "flex",
          justifyContent: "space-between"
        },
        [`${t}-filter-trigger`]: {
          position: "relative",
          display: "flex",
          alignItems: "center",
          marginBlock: D(o).mul(-1).equal(),
          marginInline: `${ve(o)} ${ve(D(h).div(2).mul(-1).equal())}`,
          padding: `0 ${ve(o)}`,
          color: f,
          fontSize: m,
          borderRadius: g,
          cursor: "pointer",
          transition: `all ${y}`,
          "&:hover": {
            color: S,
            background: b
          },
          "&.active": {
            color: x
          }
        }
      }
    },
    {
      // Dropdown
      [`${r}-dropdown`]: {
        [L]: Object.assign(Object.assign({}, Yr(e)), {
          minWidth: a,
          backgroundColor: $,
          borderRadius: g,
          boxShadow: I,
          overflow: "hidden",
          // Reset menu
          [`${B}-menu`]: {
            // https://github.com/ant-design/ant-design/issues/4916
            // https://github.com/ant-design/ant-design/issues/19542
            maxHeight: w,
            overflowX: "hidden",
            border: 0,
            boxShadow: "none",
            borderRadius: "unset",
            backgroundColor: P,
            "&:empty::after": {
              display: "block",
              padding: `${ve(s)} 0`,
              color: _,
              fontSize: m,
              textAlign: "center",
              content: '"Not Found"'
            }
          },
          [`${L}-tree`]: {
            paddingBlock: `${ve(s)} 0`,
            paddingInline: s,
            [N]: {
              padding: 0
            },
            [`${N}-treenode ${N}-node-content-wrapper:hover`]: {
              backgroundColor: O
            },
            [`${N}-treenode-checkbox-checked ${N}-node-content-wrapper`]: {
              "&, &:hover": {
                backgroundColor: T
              }
            }
          },
          [`${L}-search`]: {
            padding: s,
            borderBottom: z,
            "&-input": {
              input: {
                minWidth: i
              },
              [n]: {
                color: _
              }
            }
          },
          [`${L}-checkall`]: {
            width: "100%",
            marginBottom: o,
            marginInlineStart: o
          },
          // Operation
          [`${L}-btns`]: {
            display: "flex",
            justifyContent: "space-between",
            padding: `${ve(D(s).sub(c).equal())} ${ve(s)}`,
            overflow: "hidden",
            borderTop: z
          }
        })
      }
    },
    // Dropdown Menu & SubMenu
    {
      // submenu of table filter dropdown
      [`${r}-dropdown ${L}, ${L}-submenu`]: {
        // Checkbox
        [`${r}-checkbox-wrapper + span`]: {
          paddingInlineStart: s,
          color: l
        },
        "> ul": {
          maxHeight: "calc(100vh - 130px)",
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    }
  ];
}, rOe = (e) => {
  const {
    componentCls: t,
    lineWidth: r,
    colorSplit: n,
    motionDurationSlow: a,
    zIndexTableFixed: i,
    tableBg: o,
    zIndexTableSticky: s,
    calc: l
  } = e, c = n;
  return {
    [`${t}-wrapper`]: {
      [`
        ${t}-cell-fix-left,
        ${t}-cell-fix-right
      `]: {
        position: "sticky !important",
        zIndex: i,
        background: o
      },
      [`
        ${t}-cell-fix-left-first::after,
        ${t}-cell-fix-left-last::after
      `]: {
        position: "absolute",
        top: 0,
        right: {
          _skip_check_: !0,
          value: 0
        },
        bottom: l(r).mul(-1).equal(),
        width: 30,
        transform: "translateX(100%)",
        transition: `box-shadow ${a}`,
        content: '""',
        pointerEvents: "none"
      },
      [`${t}-cell-fix-left-all::after`]: {
        display: "none"
      },
      [`
        ${t}-cell-fix-right-first::after,
        ${t}-cell-fix-right-last::after
      `]: {
        position: "absolute",
        top: 0,
        bottom: l(r).mul(-1).equal(),
        left: {
          _skip_check_: !0,
          value: 0
        },
        width: 30,
        transform: "translateX(-100%)",
        transition: `box-shadow ${a}`,
        content: '""',
        pointerEvents: "none"
      },
      [`${t}-container`]: {
        position: "relative",
        "&::before, &::after": {
          position: "absolute",
          top: 0,
          bottom: 0,
          zIndex: l(s).add(1).equal({
            unit: !1
          }),
          width: 30,
          transition: `box-shadow ${a}`,
          content: '""',
          pointerEvents: "none"
        },
        "&::before": {
          insetInlineStart: 0
        },
        "&::after": {
          insetInlineEnd: 0
        }
      },
      [`${t}-ping-left`]: {
        [`&:not(${t}-has-fix-left) ${t}-container::before`]: {
          boxShadow: `inset 10px 0 8px -8px ${c}`
        },
        [`
          ${t}-cell-fix-left-first::after,
          ${t}-cell-fix-left-last::after
        `]: {
          boxShadow: `inset 10px 0 8px -8px ${c}`
        },
        [`${t}-cell-fix-left-last::before`]: {
          backgroundColor: "transparent !important"
        }
      },
      [`${t}-ping-right`]: {
        [`&:not(${t}-has-fix-right) ${t}-container::after`]: {
          boxShadow: `inset -10px 0 8px -8px ${c}`
        },
        [`
          ${t}-cell-fix-right-first::after,
          ${t}-cell-fix-right-last::after
        `]: {
          boxShadow: `inset -10px 0 8px -8px ${c}`
        }
      },
      // Gapped fixed Columns do not show the shadow
      [`${t}-fixed-column-gapped`]: {
        [`
        ${t}-cell-fix-left-first::after,
        ${t}-cell-fix-left-last::after,
        ${t}-cell-fix-right-first::after,
        ${t}-cell-fix-right-last::after
      `]: {
          boxShadow: "none"
        }
      }
    }
  };
}, nOe = (e) => {
  const {
    componentCls: t,
    antCls: r,
    margin: n
  } = e;
  return {
    [`${t}-wrapper`]: {
      // ========================== Pagination ==========================
      [`${t}-pagination${r}-pagination`]: {
        margin: `${ve(n)} 0`
      },
      [`${t}-pagination`]: {
        display: "flex",
        flexWrap: "wrap",
        rowGap: e.paddingXS,
        "> *": {
          flex: "none"
        },
        "&-left": {
          justifyContent: "flex-start"
        },
        "&-center": {
          justifyContent: "center"
        },
        "&-right": {
          justifyContent: "flex-end"
        }
      }
    }
  };
}, aOe = (e) => {
  const {
    componentCls: t,
    tableRadius: r
  } = e;
  return {
    [`${t}-wrapper`]: {
      [t]: {
        // https://github.com/ant-design/ant-design/issues/39115#issuecomment-1362314574
        [`${t}-title, ${t}-header`]: {
          borderRadius: `${ve(r)} ${ve(r)} 0 0`
        },
        [`${t}-title + ${t}-container`]: {
          borderStartStartRadius: 0,
          borderStartEndRadius: 0,
          // https://github.com/ant-design/ant-design/issues/41975
          [`${t}-header, table`]: {
            borderRadius: 0
          },
          "table > thead > tr:first-child": {
            "th:first-child, th:last-child, td:first-child, td:last-child": {
              borderRadius: 0
            }
          }
        },
        "&-container": {
          borderStartStartRadius: r,
          borderStartEndRadius: r,
          "table > thead > tr:first-child": {
            "> *:first-child": {
              borderStartStartRadius: r
            },
            "> *:last-child": {
              borderStartEndRadius: r
            }
          }
        },
        "&-footer": {
          borderRadius: `0 0 ${ve(r)} ${ve(r)}`
        }
      }
    }
  };
}, iOe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-wrapper-rtl`]: {
      direction: "rtl",
      table: {
        direction: "rtl"
      },
      [`${t}-pagination-left`]: {
        justifyContent: "flex-end"
      },
      [`${t}-pagination-right`]: {
        justifyContent: "flex-start"
      },
      [`${t}-row-expand-icon`]: {
        float: "right",
        "&::after": {
          transform: "rotate(-90deg)"
        },
        "&-collapsed::before": {
          transform: "rotate(180deg)"
        },
        "&-collapsed::after": {
          transform: "rotate(0deg)"
        }
      },
      [`${t}-container`]: {
        "&::before": {
          insetInlineStart: "unset",
          insetInlineEnd: 0
        },
        "&::after": {
          insetInlineStart: 0,
          insetInlineEnd: "unset"
        },
        [`${t}-row-indent`]: {
          float: "right"
        }
      }
    }
  };
}, oOe = (e) => {
  const {
    componentCls: t,
    antCls: r,
    iconCls: n,
    fontSizeIcon: a,
    padding: i,
    paddingXS: o,
    headerIconColor: s,
    headerIconHoverColor: l,
    tableSelectionColumnWidth: c,
    tableSelectedRowBg: u,
    tableSelectedRowHoverBg: d,
    tableRowHoverBg: f,
    tablePaddingHorizontal: m,
    calc: h
  } = e;
  return {
    [`${t}-wrapper`]: {
      // ========================== Selections ==========================
      [`${t}-selection-col`]: {
        width: c,
        [`&${t}-selection-col-with-dropdown`]: {
          width: h(c).add(a).add(h(i).div(4)).equal()
        }
      },
      [`${t}-bordered ${t}-selection-col`]: {
        width: h(c).add(h(o).mul(2)).equal(),
        [`&${t}-selection-col-with-dropdown`]: {
          width: h(c).add(a).add(h(i).div(4)).add(h(o).mul(2)).equal()
        }
      },
      [`
        table tr th${t}-selection-column,
        table tr td${t}-selection-column,
        ${t}-selection-column
      `]: {
        paddingInlineEnd: e.paddingXS,
        paddingInlineStart: e.paddingXS,
        textAlign: "center",
        [`${r}-radio-wrapper`]: {
          marginInlineEnd: 0
        }
      },
      [`table tr th${t}-selection-column${t}-cell-fix-left`]: {
        zIndex: e.zIndexTableFixed + 1
      },
      [`table tr th${t}-selection-column::after`]: {
        backgroundColor: "transparent !important"
      },
      [`${t}-selection`]: {
        position: "relative",
        display: "inline-flex",
        flexDirection: "column"
      },
      [`${t}-selection-extra`]: {
        position: "absolute",
        top: 0,
        zIndex: 1,
        cursor: "pointer",
        transition: `all ${e.motionDurationSlow}`,
        marginInlineStart: "100%",
        paddingInlineStart: ve(h(m).div(4).equal()),
        [n]: {
          color: s,
          fontSize: a,
          verticalAlign: "baseline",
          "&:hover": {
            color: l
          }
        }
      },
      // ============================= Rows =============================
      [`${t}-tbody`]: {
        [`${t}-row`]: {
          [`&${t}-row-selected`]: {
            [`> ${t}-cell`]: {
              background: u,
              "&-row-hover": {
                background: d
              }
            }
          },
          [`> ${t}-cell-row-hover`]: {
            background: f
          }
        }
      }
    }
  };
}, sOe = (e) => {
  const {
    componentCls: t,
    tableExpandColumnWidth: r,
    calc: n
  } = e, a = (i, o, s, l) => ({
    [`${t}${t}-${i}`]: {
      fontSize: l,
      [`
        ${t}-title,
        ${t}-footer,
        ${t}-cell,
        ${t}-thead > tr > th,
        ${t}-tbody > tr > th,
        ${t}-tbody > tr > td,
        tfoot > tr > th,
        tfoot > tr > td
      `]: {
        padding: `${ve(o)} ${ve(s)}`
      },
      [`${t}-filter-trigger`]: {
        marginInlineEnd: ve(n(s).div(2).mul(-1).equal())
      },
      [`${t}-expanded-row-fixed`]: {
        margin: `${ve(n(o).mul(-1).equal())} ${ve(n(s).mul(-1).equal())}`
      },
      [`${t}-tbody`]: {
        // ========================= Nest Table ===========================
        [`${t}-wrapper:only-child ${t}`]: {
          marginBlock: ve(n(o).mul(-1).equal()),
          marginInline: `${ve(n(r).sub(s).equal())} ${ve(n(s).mul(-1).equal())}`
        }
      },
      // https://github.com/ant-design/ant-design/issues/35167
      [`${t}-selection-extra`]: {
        paddingInlineStart: ve(n(s).div(4).equal())
      }
    }
  });
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({}, a("middle", e.tablePaddingVerticalMiddle, e.tablePaddingHorizontalMiddle, e.tableFontSizeMiddle)), a("small", e.tablePaddingVerticalSmall, e.tablePaddingHorizontalSmall, e.tableFontSizeSmall))
  };
}, lOe = (e) => {
  const {
    componentCls: t,
    marginXXS: r,
    fontSizeIcon: n,
    headerIconColor: a,
    headerIconHoverColor: i
  } = e;
  return {
    [`${t}-wrapper`]: {
      [`${t}-thead th${t}-column-has-sorters`]: {
        outline: "none",
        cursor: "pointer",
        transition: `all ${e.motionDurationSlow}`,
        "&:hover": {
          background: e.tableHeaderSortHoverBg,
          "&::before": {
            backgroundColor: "transparent !important"
          }
        },
        "&:focus-visible": {
          color: e.colorPrimary
        },
        // https://github.com/ant-design/ant-design/issues/30969
        [`
          &${t}-cell-fix-left:hover,
          &${t}-cell-fix-right:hover
        `]: {
          background: e.tableFixedHeaderSortActiveBg
        }
      },
      [`${t}-thead th${t}-column-sort`]: {
        background: e.tableHeaderSortBg,
        "&::before": {
          backgroundColor: "transparent !important"
        }
      },
      [`td${t}-column-sort`]: {
        background: e.tableBodySortBg
      },
      [`${t}-column-title`]: {
        position: "relative",
        zIndex: 1,
        flex: 1
      },
      [`${t}-column-sorters`]: {
        display: "flex",
        flex: "auto",
        alignItems: "center",
        justifyContent: "space-between",
        "&::after": {
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          content: '""'
        }
      },
      [`${t}-column-sorters-tooltip-target-sorter`]: {
        "&::after": {
          content: "none"
        }
      },
      [`${t}-column-sorter`]: {
        marginInlineStart: r,
        color: a,
        fontSize: 0,
        transition: `color ${e.motionDurationSlow}`,
        "&-inner": {
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center"
        },
        "&-up, &-down": {
          fontSize: n,
          "&.active": {
            color: e.colorPrimary
          }
        },
        [`${t}-column-sorter-up + ${t}-column-sorter-down`]: {
          marginTop: "-0.3em"
        }
      },
      [`${t}-column-sorters:hover ${t}-column-sorter`]: {
        color: i
      }
    }
  };
}, cOe = (e) => {
  const {
    componentCls: t,
    opacityLoading: r,
    tableScrollThumbBg: n,
    tableScrollThumbBgHover: a,
    tableScrollThumbSize: i,
    tableScrollBg: o,
    zIndexTableSticky: s,
    stickyScrollBarBorderRadius: l,
    lineWidth: c,
    lineType: u,
    tableBorderColor: d
  } = e, f = `${ve(c)} ${u} ${d}`;
  return {
    [`${t}-wrapper`]: {
      [`${t}-sticky`]: {
        "&-holder": {
          position: "sticky",
          zIndex: s,
          background: e.colorBgContainer
        },
        "&-scroll": {
          position: "sticky",
          bottom: 0,
          height: `${ve(i)} !important`,
          zIndex: s,
          display: "flex",
          alignItems: "center",
          background: o,
          borderTop: f,
          opacity: r,
          "&:hover": {
            transformOrigin: "center bottom"
          },
          // fake scrollbar style of sticky
          "&-bar": {
            height: i,
            backgroundColor: n,
            borderRadius: l,
            transition: `all ${e.motionDurationSlow}, transform none`,
            position: "absolute",
            bottom: 0,
            "&:hover, &-active": {
              backgroundColor: a
            }
          }
        }
      }
    }
  };
}, Z4 = (e) => {
  const {
    componentCls: t,
    lineWidth: r,
    tableBorderColor: n,
    calc: a
  } = e, i = `${ve(r)} ${e.lineType} ${n}`;
  return {
    [`${t}-wrapper`]: {
      [`${t}-summary`]: {
        position: "relative",
        zIndex: e.zIndexTableFixed,
        background: e.tableBg,
        "> tr": {
          "> th, > td": {
            borderBottom: i
          }
        }
      },
      [`div${t}-summary`]: {
        boxShadow: `0 ${ve(a(r).mul(-1).equal())} 0 ${n}`
      }
    }
  };
}, uOe = (e) => {
  const {
    componentCls: t,
    motionDurationMid: r,
    lineWidth: n,
    lineType: a,
    tableBorderColor: i,
    calc: o
  } = e, s = `${ve(n)} ${a} ${i}`, l = `${t}-expanded-row-cell`;
  return {
    [`${t}-wrapper`]: {
      // ========================== Row ==========================
      [`${t}-tbody-virtual`]: {
        [`${t}-row:not(tr)`]: {
          display: "flex",
          boxSizing: "border-box",
          width: "100%"
        },
        [`${t}-cell`]: {
          borderBottom: s,
          transition: `background ${r}`
        },
        [`${t}-expanded-row`]: {
          [`${l}${l}-fixed`]: {
            position: "sticky",
            insetInlineStart: 0,
            overflow: "hidden",
            width: `calc(var(--virtual-width) - ${ve(n)})`,
            borderInlineEnd: "none"
          }
        }
      },
      // ======================== Border =========================
      [`${t}-bordered`]: {
        [`${t}-tbody-virtual`]: {
          "&:after": {
            content: '""',
            insetInline: 0,
            bottom: 0,
            borderBottom: s,
            position: "absolute"
          },
          [`${t}-cell`]: {
            borderInlineEnd: s,
            [`&${t}-cell-fix-right-first:before`]: {
              content: '""',
              position: "absolute",
              insetBlock: 0,
              insetInlineStart: o(n).mul(-1).equal(),
              borderInlineStart: s
            }
          }
        },
        // Empty placeholder
        [`&${t}-virtual`]: {
          [`${t}-placeholder ${t}-cell`]: {
            borderInlineEnd: s,
            borderBottom: s
          }
        }
      }
    }
  };
}, dOe = (e) => {
  const {
    componentCls: t,
    fontWeightStrong: r,
    tablePaddingVertical: n,
    tablePaddingHorizontal: a,
    tableExpandColumnWidth: i,
    lineWidth: o,
    lineType: s,
    tableBorderColor: l,
    tableFontSize: c,
    tableBg: u,
    tableRadius: d,
    tableHeaderTextColor: f,
    motionDurationMid: m,
    tableHeaderBg: h,
    tableHeaderCellSplitColor: g,
    tableFooterTextColor: y,
    tableFooterBg: S,
    calc: x
  } = e, b = `${ve(o)} ${s} ${l}`;
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({
      clear: "both",
      maxWidth: "100%"
    }, Bs()), {
      [t]: Object.assign(Object.assign({}, Yr(e)), {
        fontSize: c,
        background: u,
        borderRadius: `${ve(d)} ${ve(d)} 0 0`,
        // https://github.com/ant-design/ant-design/issues/47486
        scrollbarColor: `${e.tableScrollThumbBg} ${e.tableScrollBg}`
      }),
      // https://github.com/ant-design/ant-design/issues/17611
      table: {
        width: "100%",
        textAlign: "start",
        borderRadius: `${ve(d)} ${ve(d)} 0 0`,
        borderCollapse: "separate",
        borderSpacing: 0
      },
      // ============================= Cell ==============================
      [`
          ${t}-cell,
          ${t}-thead > tr > th,
          ${t}-tbody > tr > th,
          ${t}-tbody > tr > td,
          tfoot > tr > th,
          tfoot > tr > td
        `]: {
        position: "relative",
        padding: `${ve(n)} ${ve(a)}`,
        overflowWrap: "break-word"
      },
      // ============================ Title =============================
      [`${t}-title`]: {
        padding: `${ve(n)} ${ve(a)}`
      },
      // ============================ Header ============================
      [`${t}-thead`]: {
        "\n          > tr > th,\n          > tr > td\n        ": {
          position: "relative",
          color: f,
          fontWeight: r,
          textAlign: "start",
          background: h,
          borderBottom: b,
          transition: `background ${m} ease`,
          "&[colspan]:not([colspan='1'])": {
            textAlign: "center"
          },
          [`&:not(:last-child):not(${t}-selection-column):not(${t}-row-expand-icon-cell):not([colspan])::before`]: {
            position: "absolute",
            top: "50%",
            insetInlineEnd: 0,
            width: 1,
            height: "1.6em",
            backgroundColor: g,
            transform: "translateY(-50%)",
            transition: `background-color ${m}`,
            content: '""'
          }
        },
        "> tr:not(:last-child) > th[colspan]": {
          borderBottom: 0
        }
      },
      // ============================ Body ============================
      [`${t}-tbody`]: {
        "> tr": {
          "> th, > td": {
            transition: `background ${m}, border-color ${m}`,
            borderBottom: b,
            // ========================= Nest Table ===========================
            [`
              > ${t}-wrapper:only-child,
              > ${t}-expanded-row-fixed > ${t}-wrapper:only-child
            `]: {
              [t]: {
                marginBlock: ve(x(n).mul(-1).equal()),
                marginInline: `${ve(x(i).sub(a).equal())}
                ${ve(x(a).mul(-1).equal())}`,
                [`${t}-tbody > tr:last-child > td`]: {
                  borderBottom: 0,
                  "&:first-child, &:last-child": {
                    borderRadius: 0
                  }
                }
              }
            }
          },
          "> th": {
            position: "relative",
            color: f,
            fontWeight: r,
            textAlign: "start",
            background: h,
            borderBottom: b,
            transition: `background ${m} ease`
          }
        }
      },
      // ============================ Footer ============================
      [`${t}-footer`]: {
        padding: `${ve(n)} ${ve(a)}`,
        color: y,
        background: S
      }
    })
  };
}, fOe = (e) => {
  const {
    colorFillAlter: t,
    colorBgContainer: r,
    colorTextHeading: n,
    colorFillSecondary: a,
    colorFillContent: i,
    controlItemBgActive: o,
    controlItemBgActiveHover: s,
    padding: l,
    paddingSM: c,
    paddingXS: u,
    colorBorderSecondary: d,
    borderRadiusLG: f,
    controlHeight: m,
    colorTextPlaceholder: h,
    fontSize: g,
    fontSizeSM: y,
    lineHeight: S,
    lineWidth: x,
    colorIcon: b,
    colorIconHover: _,
    opacityLoading: $,
    controlInteractiveSize: w
  } = e, O = new Br(a).onBackground(r).toHexShortString(), T = new Br(i).onBackground(r).toHexShortString(), I = new Br(t).onBackground(r).toHexShortString(), P = new Br(b), D = new Br(_), B = w / 2 - x, L = B * 2 + x * 3;
  return {
    headerBg: I,
    headerColor: n,
    headerSortActiveBg: O,
    headerSortHoverBg: T,
    bodySortBg: I,
    rowHoverBg: I,
    rowSelectedBg: o,
    rowSelectedHoverBg: s,
    rowExpandedBg: t,
    cellPaddingBlock: l,
    cellPaddingInline: l,
    cellPaddingBlockMD: c,
    cellPaddingInlineMD: u,
    cellPaddingBlockSM: u,
    cellPaddingInlineSM: u,
    borderColor: d,
    headerBorderRadius: f,
    footerBg: I,
    footerColor: n,
    cellFontSize: g,
    cellFontSizeMD: g,
    cellFontSizeSM: g,
    headerSplitColor: d,
    fixedHeaderSortActiveBg: O,
    headerFilterHoverBg: i,
    filterDropdownMenuBg: r,
    filterDropdownBg: r,
    expandIconBg: r,
    selectionColumnWidth: m,
    stickyScrollBarBg: h,
    stickyScrollBarBorderRadius: 100,
    expandIconMarginTop: (g * S - x * 3) / 2 - Math.ceil((y * 1.4 - x * 3) / 2),
    headerIconColor: P.clone().setAlpha(P.getAlpha() * $).toRgbString(),
    headerIconHoverColor: D.clone().setAlpha(D.getAlpha() * $).toRgbString(),
    expandIconHalfInner: B,
    expandIconSize: L,
    expandIconScale: w / L
  };
}, pOe = Zr("Table", (e) => {
  const {
    colorTextHeading: t,
    colorSplit: r,
    colorBgContainer: n,
    controlInteractiveSize: a,
    headerBg: i,
    headerColor: o,
    headerSortActiveBg: s,
    headerSortHoverBg: l,
    bodySortBg: c,
    rowHoverBg: u,
    rowSelectedBg: d,
    rowSelectedHoverBg: f,
    rowExpandedBg: m,
    cellPaddingBlock: h,
    cellPaddingInline: g,
    cellPaddingBlockMD: y,
    cellPaddingInlineMD: S,
    cellPaddingBlockSM: x,
    cellPaddingInlineSM: b,
    borderColor: _,
    footerBg: $,
    footerColor: w,
    headerBorderRadius: O,
    cellFontSize: T,
    cellFontSizeMD: I,
    cellFontSizeSM: P,
    headerSplitColor: D,
    fixedHeaderSortActiveBg: B,
    headerFilterHoverBg: L,
    filterDropdownBg: N,
    expandIconBg: z,
    selectionColumnWidth: F,
    stickyScrollBarBg: j,
    calc: H
  } = e, U = 2, G = $r(e, {
    tableFontSize: T,
    tableBg: n,
    tableRadius: O,
    tablePaddingVertical: h,
    tablePaddingHorizontal: g,
    tablePaddingVerticalMiddle: y,
    tablePaddingHorizontalMiddle: S,
    tablePaddingVerticalSmall: x,
    tablePaddingHorizontalSmall: b,
    tableBorderColor: _,
    tableHeaderTextColor: o,
    tableHeaderBg: i,
    tableFooterTextColor: w,
    tableFooterBg: $,
    tableHeaderCellSplitColor: D,
    tableHeaderSortBg: s,
    tableHeaderSortHoverBg: l,
    tableBodySortBg: c,
    tableFixedHeaderSortActiveBg: B,
    tableHeaderFilterActiveBg: L,
    tableFilterDropdownBg: N,
    tableRowHoverBg: u,
    tableSelectedRowBg: d,
    tableSelectedRowHoverBg: f,
    zIndexTableFixed: U,
    zIndexTableSticky: U + 1,
    tableFontSizeMiddle: I,
    tableFontSizeSmall: P,
    tableSelectionColumnWidth: F,
    tableExpandIconBg: z,
    tableExpandColumnWidth: H(a).add(H(e.padding).mul(2)).equal(),
    tableExpandedRowBg: m,
    // Dropdown
    tableFilterDropdownWidth: 120,
    tableFilterDropdownHeight: 264,
    tableFilterDropdownSearchWidth: 140,
    // Virtual Scroll Bar
    tableScrollThumbSize: 8,
    // Mac scroll bar size
    tableScrollThumbBg: j,
    tableScrollThumbBgHover: t,
    tableScrollBg: r
  });
  return [dOe(G), nOe(G), Z4(G), lOe(G), tOe(G), Xwe(G), aOe(G), eOe(G), Z4(G), Qwe(G), oOe(G), rOe(G), cOe(G), Jwe(G), sOe(G), iOe(G), uOe(G)];
}, fOe, {
  unitless: {
    expandIconScale: !0
  }
}), mOe = [], vOe = (e, t) => {
  var r, n;
  const {
    prefixCls: a,
    className: i,
    rootClassName: o,
    style: s,
    size: l,
    bordered: c,
    dropdownPrefixCls: u,
    dataSource: d,
    pagination: f,
    rowSelection: m,
    rowKey: h = "key",
    rowClassName: g,
    columns: y,
    children: S,
    childrenColumnName: x,
    onChange: b,
    getPopupContainer: _,
    loading: $,
    expandIcon: w,
    expandable: O,
    expandedRowRender: T,
    expandIconColumnIndex: I,
    indentSize: P,
    scroll: D,
    sortDirections: B,
    locale: L,
    showSorterTooltip: N = {
      target: "full-header"
    },
    virtual: z
  } = e, F = xr("Table");
  process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && F(!(typeof h == "function" && h.length > 1), "usage", "`index` parameter of `rowKey` function is deprecated. There is no guarantee that it will work as expected.");
  const j = p.useMemo(() => y || WI(S), [y, S]), H = p.useMemo(() => j.some((Ve) => Ve.responsive), [j]), U = qH(H), G = p.useMemo(() => {
    const Ve = new Set(Object.keys(U).filter((ke) => U[ke]));
    return j.filter((ke) => !ke.responsive || ke.responsive.some((ut) => Ve.has(ut)));
  }, [j, U]), V = bn(e, ["className", "style", "columns"]), {
    locale: K = jo,
    direction: Z,
    table: ee,
    renderEmpty: ae,
    getPrefixCls: ue,
    getPopupContainer: re
  } = p.useContext(Lt), oe = Xa(l), fe = Object.assign(Object.assign({}, K.Table), L), le = d || mOe, se = ue("table", a), Q = ue("dropdown", u), [, he] = ua(), ne = Mn(se), [me, k, M] = pOe(se, ne), R = Object.assign(Object.assign({
    childrenColumnName: x,
    expandIconColumnIndex: I
  }, O), {
    expandIcon: (r = O?.expandIcon) !== null && r !== void 0 ? r : (n = ee?.expandable) === null || n === void 0 ? void 0 : n.expandIcon
  }), {
    childrenColumnName: q = "children"
  } = R, Y = p.useMemo(() => le.some((Ve) => Ve?.[q]) ? "nest" : T || O && O.expandedRowRender ? "row" : null, [le]), X = {
    body: p.useRef()
  }, pe = WEe(se), $e = p.useRef(null), J = p.useRef(null);
  GEe(t, () => Object.assign(Object.assign({}, J.current), {
    nativeElement: $e.current
  }));
  const de = p.useMemo(() => typeof h == "function" ? h : (Ve) => Ve?.[h], [h]), [Se] = kwe(le, q, de), Ee = {}, Te = function(Ve, ke) {
    let ut = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    var st, Et, zt;
    const Be = Object.assign(Object.assign({}, Ee), Ve);
    ut && ((st = Ee.resetPagination) === null || st === void 0 || st.call(Ee), !((Et = Be.pagination) === null || Et === void 0) && Et.current && (Be.pagination.current = 1), f && f.onChange && f.onChange(1, (zt = Be.pagination) === null || zt === void 0 ? void 0 : zt.pageSize)), D && D.scrollToFirstRowOnChange !== !1 && X.body.current && Rfe(0, {
      getContainer: () => X.body.current
    }), b?.(Be.pagination, Be.filters, Be.sorter, {
      currentDataSource: $E(EE(le, Be.sorterStates, q), Be.filterStates, q),
      action: ke
    });
  }, Le = (Ve, ke) => {
    Te({
      sorter: Ve,
      sorterStates: ke
    }, "sort", !1);
  }, [Ie, De, Ae, Fe] = qwe({
    prefixCls: se,
    mergedColumns: G,
    onSorterChange: Le,
    sortDirections: B || ["ascend", "descend"],
    tableLocale: fe,
    showSorterTooltip: N
  }), Ne = p.useMemo(() => EE(le, De, q), [le, De]);
  Ee.sorter = Fe(), Ee.sorterStates = De;
  const qe = (Ve, ke) => {
    Te({
      filters: Ve,
      filterStates: ke
    }, "filter", !0);
  }, [Qe, tt, Ge] = Lwe({
    prefixCls: se,
    locale: fe,
    dropdownPrefixCls: Q,
    mergedColumns: G,
    onFilterChange: qe,
    getPopupContainer: _ || re,
    rootClassName: be(o, ne)
  }), it = $E(Ne, tt, q);
  Ee.filters = Ge, Ee.filterStates = tt;
  const ht = p.useMemo(() => {
    const Ve = {};
    return Object.keys(Ge).forEach((ke) => {
      Ge[ke] !== null && (Ve[ke] = Ge[ke]);
    }), Object.assign(Object.assign({}, Ae), {
      filters: Ve
    });
  }, [Ae, Ge]), [It] = Kwe(ht), xt = (Ve, ke) => {
    Te({
      pagination: Object.assign(Object.assign({}, Ee.pagination), {
        current: Ve,
        pageSize: ke
      })
    }, "paginate");
  }, [Xe, pt] = zwe(it.length, xt, f);
  Ee.pagination = f === !1 ? {} : Bwe(Xe, f), Ee.resetPagination = pt;
  const Ze = p.useMemo(() => {
    if (f === !1 || !Xe.pageSize)
      return it;
    const {
      current: Ve = 1,
      total: ke,
      pageSize: ut = AW
    } = Xe;
    return process.env.NODE_ENV !== "production" && F(Ve > 0, "usage", "`current` should be positive number."), it.length < ke ? it.length > ut ? (process.env.NODE_ENV !== "production" && F(!1, "usage", "`dataSource` length is less than `pagination.total` but large than `pagination.pageSize`. Please make sure your config correct data with async mode."), it.slice((Ve - 1) * ut, Ve * ut)) : it : it.slice((Ve - 1) * ut, Ve * ut);
  }, [!!f, it, Xe && Xe.current, Xe && Xe.pageSize, Xe && Xe.total]), [wt, bt] = HEe({
    prefixCls: se,
    data: it,
    pageData: Ze,
    getRowKey: de,
    getRecordByKey: Se,
    expandType: Y,
    childrenColumnName: q,
    locale: fe,
    getPopupContainer: _ || re
  }, m), Je = (Ve, ke, ut) => {
    let st;
    return typeof g == "function" ? st = be(g(Ve, ke, ut)) : st = be(g), be({
      [`${se}-row-selected`]: bt.has(de(Ve, ke))
    }, st);
  };
  R.__PARENT_RENDER_ICON__ = R.expandIcon, R.expandIcon = R.expandIcon || w || UEe(fe), Y === "nest" && R.expandIconColumnIndex === void 0 ? R.expandIconColumnIndex = m ? 1 : 0 : R.expandIconColumnIndex > 0 && m && (R.expandIconColumnIndex -= 1), typeof R.indentSize != "number" && (R.indentSize = typeof P == "number" ? P : 15);
  const _t = p.useCallback((Ve) => It(wt(Qe(Ie(Ve)))), [Ie, Qe, wt]);
  let Vt, ot;
  if (f !== !1 && Xe?.total) {
    let Ve;
    Xe.size ? Ve = Xe.size : Ve = oe === "small" || oe === "middle" ? "small" : void 0;
    const ke = (Et) => /* @__PURE__ */ p.createElement(HI, Object.assign({}, Xe, {
      className: be(`${se}-pagination ${se}-pagination-${Et}`, Xe.className),
      size: Ve
    })), ut = Z === "rtl" ? "left" : "right", {
      position: st
    } = Xe;
    if (st !== null && Array.isArray(st)) {
      const Et = st.find((ft) => ft.includes("top")), zt = st.find((ft) => ft.includes("bottom")), Be = st.every((ft) => `${ft}` == "none");
      !Et && !zt && !Be && (ot = ke(ut)), Et && (Vt = ke(Et.toLowerCase().replace("top", ""))), zt && (ot = ke(zt.toLowerCase().replace("bottom", "")));
    } else
      ot = ke(ut);
  }
  let Ct;
  typeof $ == "boolean" ? Ct = {
    spinning: $
  } : typeof $ == "object" && (Ct = Object.assign({
    spinning: !0
  }, $));
  const rt = be(M, ne, `${se}-wrapper`, ee?.className, {
    [`${se}-wrapper-rtl`]: Z === "rtl"
  }, i, o, k), $t = Object.assign(Object.assign({}, ee?.style), s), Wt = L && L.emptyText || ae?.("Table") || /* @__PURE__ */ p.createElement(LH, {
    componentName: "Table"
  }), _e = z ? Zwe : Ywe, Ke = {}, nt = p.useMemo(() => {
    const {
      fontSize: Ve,
      lineHeight: ke,
      padding: ut,
      paddingXS: st,
      paddingSM: Et
    } = he, zt = Math.floor(Ve * ke);
    switch (oe) {
      case "large":
        return ut * 2 + zt;
      case "small":
        return st * 2 + zt;
      default:
        return Et * 2 + zt;
    }
  }, [he, oe]);
  return z && (Ke.listItemHeight = nt), me(/* @__PURE__ */ p.createElement("div", {
    ref: $e,
    className: rt,
    style: $t
  }, /* @__PURE__ */ p.createElement(Td, Object.assign({
    spinning: !1
  }, Ct), Vt, /* @__PURE__ */ p.createElement(_e, Object.assign({}, Ke, V, {
    ref: J,
    columns: G,
    direction: Z,
    expandable: R,
    prefixCls: se,
    className: be({
      [`${se}-middle`]: oe === "middle",
      [`${se}-small`]: oe === "small",
      [`${se}-bordered`]: c,
      [`${se}-empty`]: le.length === 0
    }, M, ne, k),
    data: Ze,
    rowKey: de,
    rowClassName: Je,
    emptyText: Wt,
    // Internal
    internalHooks: Th,
    internalRefs: X,
    transformColumns: _t,
    getContainerWidth: pe
  })), ot)));
}, hOe = /* @__PURE__ */ p.forwardRef(vOe), gOe = (e, t) => {
  const r = p.useRef(0);
  return r.current += 1, /* @__PURE__ */ p.createElement(hOe, Object.assign({}, e, {
    ref: t,
    _renderTimes: r.current
  }));
}, zo = /* @__PURE__ */ p.forwardRef(gOe);
zo.SELECTION_COLUMN = Qo;
zo.EXPAND_COLUMN = es;
zo.SELECTION_ALL = yE;
zo.SELECTION_INVERT = bE;
zo.SELECTION_NONE = CE;
zo.Column = AEe;
zo.ColumnGroup = PEe;
zo.Summary = qU;
process.env.NODE_ENV !== "production" && (zo.displayName = "Table");
const yOe = (e) => {
  const {
    paddingXXS: t,
    lineWidth: r,
    tagPaddingHorizontal: n,
    componentCls: a,
    calc: i
  } = e, o = i(n).sub(r).equal(), s = i(t).sub(r).equal();
  return {
    // Result
    [a]: Object.assign(Object.assign({}, Yr(e)), {
      display: "inline-block",
      height: "auto",
      // https://github.com/ant-design/ant-design/pull/47504
      marginInlineEnd: e.marginXS,
      paddingInline: o,
      fontSize: e.tagFontSize,
      lineHeight: e.tagLineHeight,
      whiteSpace: "nowrap",
      background: e.defaultBg,
      border: `${ve(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
      borderRadius: e.borderRadiusSM,
      opacity: 1,
      transition: `all ${e.motionDurationMid}`,
      textAlign: "start",
      position: "relative",
      // RTL
      [`&${a}-rtl`]: {
        direction: "rtl"
      },
      "&, a, a:hover": {
        color: e.defaultColor
      },
      [`${a}-close-icon`]: {
        marginInlineStart: s,
        fontSize: e.tagIconSize,
        color: e.colorTextDescription,
        cursor: "pointer",
        transition: `all ${e.motionDurationMid}`,
        "&:hover": {
          color: e.colorTextHeading
        }
      },
      [`&${a}-has-color`]: {
        borderColor: "transparent",
        [`&, a, a:hover, ${e.iconCls}-close, ${e.iconCls}-close:hover`]: {
          color: e.colorTextLightSolid
        }
      },
      "&-checkable": {
        backgroundColor: "transparent",
        borderColor: "transparent",
        cursor: "pointer",
        [`&:not(${a}-checkable-checked):hover`]: {
          color: e.colorPrimary,
          backgroundColor: e.colorFillSecondary
        },
        "&:active, &-checked": {
          color: e.colorTextLightSolid
        },
        "&-checked": {
          backgroundColor: e.colorPrimary,
          "&:hover": {
            backgroundColor: e.colorPrimaryHover
          }
        },
        "&:active": {
          backgroundColor: e.colorPrimaryActive
        }
      },
      "&-hidden": {
        display: "none"
      },
      // To ensure that a space will be placed between character and `Icon`.
      [`> ${e.iconCls} + span, > span + ${e.iconCls}`]: {
        marginInlineStart: o
      }
    }),
    [`${a}-borderless`]: {
      borderColor: "transparent",
      background: e.tagBorderlessBg
    }
  };
}, tM = (e) => {
  const {
    lineWidth: t,
    fontSizeIcon: r,
    calc: n
  } = e, a = e.fontSizeSM;
  return $r(e, {
    tagFontSize: a,
    tagLineHeight: ve(n(e.lineHeightSM).mul(a).equal()),
    tagIconSize: n(r).sub(n(t).mul(2)).equal(),
    // Tag icon is much smaller
    tagPaddingHorizontal: 8,
    // Fixed padding.
    tagBorderlessBg: e.defaultBg
  });
}, rM = (e) => ({
  defaultBg: new Br(e.colorFillQuaternary).onBackground(e.colorBgContainer).toHexString(),
  defaultColor: e.colorText
}), jW = Zr("Tag", (e) => {
  const t = tM(e);
  return yOe(t);
}, rM);
var bOe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const COe = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    prefixCls: r,
    style: n,
    className: a,
    checked: i,
    onChange: o,
    onClick: s
  } = e, l = bOe(e, ["prefixCls", "style", "className", "checked", "onChange", "onClick"]), {
    getPrefixCls: c,
    tag: u
  } = p.useContext(Lt), d = (S) => {
    o?.(!i), s?.(S);
  }, f = c("tag", r), [m, h, g] = jW(f), y = be(f, `${f}-checkable`, {
    [`${f}-checkable-checked`]: i
  }, u?.className, a, h, g);
  return m(/* @__PURE__ */ p.createElement("span", Object.assign({}, l, {
    ref: t,
    style: Object.assign(Object.assign({}, n), u?.style),
    className: y,
    onClick: d
  })));
}), SOe = (e) => LB(e, (t, r) => {
  let {
    textColor: n,
    lightBorderColor: a,
    lightColor: i,
    darkColor: o
  } = r;
  return {
    [`${e.componentCls}${e.componentCls}-${t}`]: {
      color: n,
      background: i,
      borderColor: a,
      // Inverse color
      "&-inverse": {
        color: e.colorTextLightSolid,
        background: o,
        borderColor: o
      },
      [`&${e.componentCls}-borderless`]: {
        borderColor: "transparent"
      }
    }
  };
}), xOe = vd(["Tag", "preset"], (e) => {
  const t = tM(e);
  return SOe(t);
}, rM);
function $Oe(e) {
  return typeof e != "string" ? e : e.charAt(0).toUpperCase() + e.slice(1);
}
const uy = (e, t, r) => {
  const n = $Oe(r);
  return {
    [`${e.componentCls}${e.componentCls}-${t}`]: {
      color: e[`color${r}`],
      background: e[`color${n}Bg`],
      borderColor: e[`color${n}Border`],
      [`&${e.componentCls}-borderless`]: {
        borderColor: "transparent"
      }
    }
  };
}, _Oe = vd(["Tag", "status"], (e) => {
  const t = tM(e);
  return [uy(t, "success", "Success"), uy(t, "processing", "Info"), uy(t, "error", "Error"), uy(t, "warning", "Warning")];
}, rM);
var EOe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const wOe = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    prefixCls: r,
    className: n,
    rootClassName: a,
    style: i,
    children: o,
    icon: s,
    color: l,
    onClose: c,
    bordered: u = !0,
    visible: d
  } = e, f = EOe(e, ["prefixCls", "className", "rootClassName", "style", "children", "icon", "color", "onClose", "bordered", "visible"]), {
    getPrefixCls: m,
    direction: h,
    tag: g
  } = p.useContext(Lt), [y, S] = p.useState(!0), x = bn(f, ["closeIcon", "closable"]);
  process.env.NODE_ENV !== "production" && xr("Tag").deprecated(!("visible" in e), "visible", "visible && <Tag />"), p.useEffect(() => {
    d !== void 0 && S(d);
  }, [d]);
  const b = eV(l), _ = tye(l), $ = b || _, w = Object.assign(Object.assign({
    backgroundColor: l && !$ ? l : void 0
  }, g?.style), i), O = m("tag", r), [T, I, P] = jW(O), D = be(O, g?.className, {
    [`${O}-${l}`]: $,
    [`${O}-has-color`]: l && !$,
    [`${O}-hidden`]: !y,
    [`${O}-rtl`]: h === "rtl",
    [`${O}-borderless`]: !u
  }, n, a, I, P), B = (H) => {
    H.stopPropagation(), c?.(H), !H.defaultPrevented && S(!1);
  }, [, L] = BT(sd(e), sd(g), {
    closable: !1,
    closeIconRender: (H) => {
      const U = /* @__PURE__ */ p.createElement("span", {
        className: `${O}-close-icon`,
        onClick: B
      }, H);
      return oz(H, U, (G) => ({
        onClick: (V) => {
          var K;
          (K = G?.onClick) === null || K === void 0 || K.call(G, V), B(V);
        },
        className: be(G?.className, `${O}-close-icon`)
      }));
    }
  }), N = typeof f.onClick == "function" || o && o.type === "a", z = s || null, F = z ? /* @__PURE__ */ p.createElement(p.Fragment, null, z, o && /* @__PURE__ */ p.createElement("span", null, o)) : o, j = /* @__PURE__ */ p.createElement("span", Object.assign({}, x, {
    ref: t,
    className: D,
    style: w
  }), F, L, b && /* @__PURE__ */ p.createElement(xOe, {
    key: "preset",
    prefixCls: O
  }), _ && /* @__PURE__ */ p.createElement(_Oe, {
    key: "status",
    prefixCls: O
  }));
  return T(N ? /* @__PURE__ */ p.createElement(ch, {
    component: "Tag"
  }, j) : j);
}), nM = wOe;
process.env.NODE_ENV !== "production" && (nM.displayName = "Tag");
nM.CheckableTag = COe;
var OOe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const TOe = {
  border: 0,
  background: "transparent",
  padding: 0,
  lineHeight: "inherit",
  display: "inline-flex"
}, LW = /* @__PURE__ */ p.forwardRef((e, t) => {
  const r = (u) => {
    const {
      keyCode: d
    } = u;
    d === Mt.ENTER && u.preventDefault();
  }, n = (u) => {
    const {
      keyCode: d
    } = u, {
      onClick: f
    } = e;
    d === Mt.ENTER && f && f();
  }, {
    style: a,
    noStyle: i,
    disabled: o,
    tabIndex: s = 0
  } = e, l = OOe(e, ["style", "noStyle", "disabled", "tabIndex"]);
  let c = {};
  return i || (c = Object.assign({}, TOe)), o && (c.pointerEvents = "none"), c = Object.assign(Object.assign({}, c), a), /* @__PURE__ */ p.createElement("div", Object.assign({
    role: "button",
    tabIndex: s,
    ref: t
  }, l, {
    onKeyDown: r,
    onKeyUp: n,
    style: c
  }));
});
var IOe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, name: "edit", theme: "outlined" }, MOe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: IOe
  }));
}, kW = /* @__PURE__ */ p.forwardRef(MOe);
process.env.NODE_ENV !== "production" && (kW.displayName = "EditOutlined");
var AOe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z" } }] }, name: "enter", theme: "outlined" }, POe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: AOe
  }));
}, FW = /* @__PURE__ */ p.forwardRef(POe);
process.env.NODE_ENV !== "production" && (FW.displayName = "EnterOutlined");
const ROe = (e, t, r, n) => {
  const {
    titleMarginBottom: a,
    fontWeightStrong: i
  } = n;
  return {
    marginBottom: a,
    color: r,
    fontWeight: i,
    fontSize: e,
    lineHeight: t
  };
}, NOe = (e) => {
  const t = [1, 2, 3, 4, 5], r = {};
  return t.forEach((n) => {
    r[`
      h${n}&,
      div&-h${n},
      div&-h${n} > textarea,
      h${n}
    `] = ROe(e[`fontSizeHeading${n}`], e[`lineHeightHeading${n}`], e.colorTextHeading, e);
  }), r;
}, DOe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    "a&, a": Object.assign(Object.assign({}, MT(e)), {
      textDecoration: e.linkDecoration,
      "&:active, &:hover": {
        textDecoration: e.linkHoverDecoration
      },
      [`&[disabled], &${t}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        "&:active, &:hover": {
          color: e.colorTextDisabled
        },
        "&:active": {
          pointerEvents: "none"
        }
      }
    })
  };
}, jOe = (e) => ({
  code: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.2em 0.1em",
    fontSize: "85%",
    fontFamily: e.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3
  },
  kbd: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.15em 0.1em",
    fontSize: "90%",
    fontFamily: e.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.06)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderBottomWidth: 2,
    borderRadius: 3
  },
  mark: {
    padding: 0,
    // FIXME hardcode in v4
    backgroundColor: Kue[2]
  },
  "u, ins": {
    textDecoration: "underline",
    textDecorationSkipInk: "auto"
  },
  "s, del": {
    textDecoration: "line-through"
  },
  strong: {
    fontWeight: 600
  },
  // list
  "ul, ol": {
    marginInline: 0,
    marginBlock: "0 1em",
    padding: 0,
    li: {
      marginInline: "20px 0",
      marginBlock: 0,
      paddingInline: "4px 0",
      paddingBlock: 0
    }
  },
  ul: {
    listStyleType: "circle",
    ul: {
      listStyleType: "disc"
    }
  },
  ol: {
    listStyleType: "decimal"
  },
  // pre & block
  "pre, blockquote": {
    margin: "1em 0"
  },
  pre: {
    padding: "0.4em 0.6em",
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3,
    fontFamily: e.fontFamilyCode,
    // Compatible for marked
    code: {
      display: "inline",
      margin: 0,
      padding: 0,
      fontSize: "inherit",
      fontFamily: "inherit",
      background: "transparent",
      border: 0
    }
  },
  blockquote: {
    paddingInline: "0.6em 0",
    paddingBlock: 0,
    borderInlineStart: "4px solid rgba(100, 100, 100, 0.2)",
    opacity: 0.85
  }
}), LOe = (e) => {
  const {
    componentCls: t,
    paddingSM: r
  } = e, n = r;
  return {
    "&-edit-content": {
      position: "relative",
      "div&": {
        insetInlineStart: e.calc(e.paddingSM).mul(-1).equal(),
        marginTop: e.calc(n).mul(-1).equal(),
        marginBottom: `calc(1em - ${ve(n)})`
      },
      [`${t}-edit-content-confirm`]: {
        position: "absolute",
        insetInlineEnd: e.calc(e.marginXS).add(2).equal(),
        insetBlockEnd: e.marginXS,
        color: e.colorTextDescription,
        // default style
        fontWeight: "normal",
        fontSize: e.fontSize,
        fontStyle: "normal",
        pointerEvents: "none"
      },
      textarea: {
        margin: "0!important",
        // Fix Editable Textarea flash in Firefox
        MozTransition: "none",
        height: "1em"
      }
    }
  };
}, kOe = (e) => ({
  [`${e.componentCls}-copy-success`]: {
    "\n    &,\n    &:hover,\n    &:focus": {
      color: e.colorSuccess
    }
  },
  [`${e.componentCls}-copy-icon-only`]: {
    marginInlineStart: 0
  }
}), FOe = () => ({
  "\n  a&-ellipsis,\n  span&-ellipsis\n  ": {
    display: "inline-block",
    maxWidth: "100%"
  },
  "&-ellipsis-single-line": {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    // https://blog.csdn.net/iefreer/article/details/50421025
    "a&, span&": {
      verticalAlign: "bottom"
    },
    "> code": {
      paddingBlock: 0,
      maxWidth: "calc(100% - 1.2em)",
      display: "inline-block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      verticalAlign: "bottom",
      // https://github.com/ant-design/ant-design/issues/45953
      boxSizing: "content-box"
    }
  },
  "&-ellipsis-multiple-line": {
    display: "-webkit-box",
    overflow: "hidden",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical"
  }
}), BOe = (e) => {
  const {
    componentCls: t,
    titleMarginTop: r
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
      color: e.colorText,
      wordBreak: "break-word",
      lineHeight: e.lineHeight,
      [`&${t}-secondary`]: {
        color: e.colorTextDescription
      },
      [`&${t}-success`]: {
        color: e.colorSuccess
      },
      [`&${t}-warning`]: {
        color: e.colorWarning
      },
      [`&${t}-danger`]: {
        color: e.colorError,
        "a&:active, a&:focus": {
          color: e.colorErrorActive
        },
        "a&:hover": {
          color: e.colorErrorHover
        }
      },
      [`&${t}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        userSelect: "none"
      },
      "\n        div&,\n        p\n      ": {
        marginBottom: "1em"
      }
    }, NOe(e)), {
      [`
      & + h1${t},
      & + h2${t},
      & + h3${t},
      & + h4${t},
      & + h5${t}
      `]: {
        marginTop: r
      },
      "\n      div,\n      ul,\n      li,\n      p,\n      h1,\n      h2,\n      h3,\n      h4,\n      h5": {
        "\n        + h1,\n        + h2,\n        + h3,\n        + h4,\n        + h5\n        ": {
          marginTop: r
        }
      }
    }), jOe(e)), DOe(e)), {
      // Operation
      [`
        ${t}-expand,
        ${t}-collapse,
        ${t}-edit,
        ${t}-copy
      `]: Object.assign(Object.assign({}, MT(e)), {
        marginInlineStart: e.marginXXS
      })
    }), LOe(e)), kOe(e)), FOe()), {
      "&-rtl": {
        direction: "rtl"
      }
    })
  };
}, zOe = () => ({
  titleMarginTop: "1.2em",
  titleMarginBottom: "0.5em"
}), BW = Zr("Typography", (e) => [BOe(e)], zOe), HOe = (e) => {
  const {
    prefixCls: t,
    "aria-label": r,
    className: n,
    style: a,
    direction: i,
    maxLength: o,
    autoSize: s = !0,
    value: l,
    onSave: c,
    onCancel: u,
    onEnd: d,
    component: f,
    enterIcon: m = /* @__PURE__ */ p.createElement(FW, null)
  } = e, h = p.useRef(null), g = p.useRef(!1), y = p.useRef(), [S, x] = p.useState(l);
  p.useEffect(() => {
    x(l);
  }, [l]), p.useEffect(() => {
    if (h.current && h.current.resizableTextArea) {
      const {
        textArea: z
      } = h.current.resizableTextArea;
      z.focus();
      const {
        length: F
      } = z.value;
      z.setSelectionRange(F, F);
    }
  }, []);
  const b = (z) => {
    let {
      target: F
    } = z;
    x(F.value.replace(/[\n\r]/g, ""));
  }, _ = () => {
    g.current = !0;
  }, $ = () => {
    g.current = !1;
  }, w = (z) => {
    let {
      keyCode: F
    } = z;
    g.current || (y.current = F);
  }, O = () => {
    c(S.trim());
  }, T = (z) => {
    let {
      keyCode: F,
      ctrlKey: j,
      altKey: H,
      metaKey: U,
      shiftKey: G
    } = z;
    y.current === F && !g.current && !j && !H && !U && !G && (F === Mt.ENTER ? (O(), d?.()) : F === Mt.ESC && u());
  }, I = () => {
    O();
  }, P = f ? `${t}-${f}` : "", [D, B, L] = BW(t), N = be(t, `${t}-edit-content`, {
    [`${t}-rtl`]: i === "rtl"
  }, n, P, B, L);
  return D(/* @__PURE__ */ p.createElement("div", {
    className: N,
    style: a
  }, /* @__PURE__ */ p.createElement(UG, {
    ref: h,
    maxLength: o,
    value: S,
    onChange: b,
    onKeyDown: w,
    onKeyUp: T,
    onCompositionStart: _,
    onCompositionEnd: $,
    onBlur: I,
    "aria-label": r,
    rows: 1,
    autoSize: s
  }), m !== null ? Si(m, {
    className: `${t}-edit-content-confirm`
  }) : null));
};
var VOe = function() {
  var e = document.getSelection();
  if (!e.rangeCount)
    return function() {
    };
  for (var t = document.activeElement, r = [], n = 0; n < e.rangeCount; n++)
    r.push(e.getRangeAt(n));
  switch (t.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      t.blur();
      break;
    default:
      t = null;
      break;
  }
  return e.removeAllRanges(), function() {
    e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
      e.addRange(a);
    }), t && t.focus();
  };
}, GOe = VOe, X4 = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, UOe = "Copy to clipboard: #{key}, Enter";
function WOe(e) {
  var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return e.replace(/#{\s*key\s*}/g, t);
}
function qOe(e, t) {
  var r, n, a, i, o, s, l = !1;
  t || (t = {}), r = t.debug || !1;
  try {
    a = GOe(), i = document.createRange(), o = document.getSelection(), s = document.createElement("span"), s.textContent = e, s.ariaHidden = "true", s.style.all = "unset", s.style.position = "fixed", s.style.top = 0, s.style.clip = "rect(0, 0, 0, 0)", s.style.whiteSpace = "pre", s.style.webkitUserSelect = "text", s.style.MozUserSelect = "text", s.style.msUserSelect = "text", s.style.userSelect = "text", s.addEventListener("copy", function(u) {
      if (u.stopPropagation(), t.format)
        if (u.preventDefault(), typeof u.clipboardData > "u") {
          r && console.warn("unable to use e.clipboardData"), r && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var d = X4[t.format] || X4.default;
          window.clipboardData.setData(d, e);
        } else
          u.clipboardData.clearData(), u.clipboardData.setData(t.format, e);
      t.onCopy && (u.preventDefault(), t.onCopy(u.clipboardData));
    }), document.body.appendChild(s), i.selectNodeContents(s), o.addRange(i);
    var c = document.execCommand("copy");
    if (!c)
      throw new Error("copy command was unsuccessful");
    l = !0;
  } catch (u) {
    r && console.error("unable to copy using execCommand: ", u), r && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), l = !0;
    } catch (d) {
      r && console.error("unable to copy using clipboardData: ", d), r && console.error("falling back to prompt"), n = WOe("message" in t ? t.message : UOe), window.prompt(n, e);
    }
  } finally {
    o && (typeof o.removeRange == "function" ? o.removeRange(i) : o.removeAllRanges()), s && document.body.removeChild(s), a();
  }
  return l;
}
var KOe = qOe;
const YOe = /* @__PURE__ */ Ut(KOe);
var ZOe = function(e, t, r, n) {
  function a(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(u) {
      try {
        c(n.next(u));
      } catch (d) {
        o(d);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        o(d);
      }
    }
    function c(u) {
      u.done ? i(u.value) : a(u.value).then(s, l);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
const XOe = (e) => {
  let {
    copyConfig: t,
    children: r
  } = e;
  const [n, a] = p.useState(!1), [i, o] = p.useState(!1), s = p.useRef(null), l = () => {
    s.current && clearTimeout(s.current);
  }, c = {};
  t.format && (c.format = t.format), p.useEffect(() => l, []);
  const u = br((d) => ZOe(void 0, void 0, void 0, function* () {
    var f;
    d?.preventDefault(), d?.stopPropagation(), o(!0);
    try {
      const m = typeof t.text == "function" ? yield t.text() : t.text;
      YOe(m || String(r) || "", c), o(!1), a(!0), l(), s.current = setTimeout(() => {
        a(!1);
      }, 3e3), (f = t.onCopy) === null || f === void 0 || f.call(t, d);
    } catch (m) {
      throw o(!1), m;
    }
  }));
  return {
    copied: n,
    copyLoading: i,
    onClick: u
  };
};
function Fx(e, t) {
  return p.useMemo(() => {
    const r = !!e;
    return [r, Object.assign(Object.assign({}, t), r && typeof e == "object" ? e : null)];
  }, [e]);
}
const JOe = (e, t) => {
  const r = p.useRef(!1);
  p.useEffect(() => {
    r.current ? e() : r.current = !0;
  }, t);
}, QOe = (e) => {
  const t = ct();
  return St(() => {
    t.current = e;
  }), t.current;
};
var eTe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const aM = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    prefixCls: r,
    component: n = "article",
    className: a,
    rootClassName: i,
    setContentRef: o,
    children: s,
    direction: l,
    style: c
  } = e, u = eTe(e, ["prefixCls", "component", "className", "rootClassName", "setContentRef", "children", "direction", "style"]), {
    getPrefixCls: d,
    direction: f,
    typography: m
  } = p.useContext(Lt), h = l ?? f;
  let g = t;
  o && (g = Za(t, o)), process.env.NODE_ENV !== "production" && xr("Typography").deprecated(!o, "setContentRef", "ref");
  const y = d("typography", r), [S, x, b] = BW(y), _ = be(y, m?.className, {
    [`${y}-rtl`]: h === "rtl"
  }, a, i, x, b), $ = Object.assign(Object.assign({}, m?.style), c);
  return S(
    // @ts-expect-error: Expression produces a union type that is too complex to represent.
    /* @__PURE__ */ p.createElement(n, Object.assign({
      className: _,
      style: $,
      ref: g
    }, u), s)
  );
});
process.env.NODE_ENV !== "production" && (aM.displayName = "Typography");
var tTe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, name: "copy", theme: "outlined" }, rTe = function(t, r) {
  return /* @__PURE__ */ p.createElement(Er, Pe({}, t, {
    ref: r,
    icon: tTe
  }));
}, zW = /* @__PURE__ */ p.forwardRef(rTe);
process.env.NODE_ENV !== "production" && (zW.displayName = "CopyOutlined");
function J4(e) {
  return e === !1 ? [!1, !1] : Array.isArray(e) ? e : [e];
}
function dy(e, t, r) {
  return e === !0 || e === void 0 ? t : e || r && t;
}
const nTe = (e) => {
  const {
    prefixCls: t,
    copied: r,
    locale: n,
    iconOnly: a,
    tooltips: i,
    icon: o,
    loading: s,
    tabIndex: l,
    onCopy: c
  } = e, u = J4(i), d = J4(o), {
    copied: f,
    copy: m
  } = n ?? {}, h = r ? dy(u[1], f) : dy(u[0], m), y = typeof h == "string" ? h : r ? f : m;
  return /* @__PURE__ */ p.createElement(lo, {
    key: "copy",
    title: h
  }, /* @__PURE__ */ p.createElement(LW, {
    className: be(`${t}-copy`, {
      [`${t}-copy-success`]: r,
      [`${t}-copy-icon-only`]: a
    }),
    onClick: c,
    "aria-label": y,
    tabIndex: l
  }, r ? dy(d[1], /* @__PURE__ */ p.createElement(nI, null), !0) : dy(d[0], s ? /* @__PURE__ */ p.createElement(Dc, null) : /* @__PURE__ */ p.createElement(zW, null), !0)));
}, fy = /* @__PURE__ */ p.forwardRef((e, t) => {
  let {
    style: r,
    children: n
  } = e;
  const a = p.useRef(null);
  return p.useImperativeHandle(t, () => ({
    isExceed: () => {
      const i = a.current;
      return i.scrollHeight > i.clientHeight;
    },
    getHeight: () => a.current.clientHeight
  })), /* @__PURE__ */ p.createElement("span", {
    "aria-hidden": !0,
    ref: a,
    style: Object.assign({
      position: "fixed",
      display: "block",
      left: 0,
      top: 0,
      pointerEvents: "none",
      backgroundColor: "rgba(255, 0, 0, 0.65)"
    }, r)
  }, n);
});
function HW(e) {
  const t = typeof e;
  return t === "string" || t === "number";
}
function aTe(e) {
  let t = 0;
  return e.forEach((r) => {
    HW(r) ? t += String(r).length : t += 1;
  }), t;
}
function Q4(e, t) {
  let r = 0;
  const n = [];
  for (let a = 0; a < e.length; a += 1) {
    if (r === t)
      return n;
    const i = e[a], s = HW(i) ? String(i).length : 1, l = r + s;
    if (l > t) {
      const c = t - r;
      return n.push(String(i).slice(0, c)), n;
    }
    n.push(i), r = l;
  }
  return e;
}
const Bx = 0, zx = 1, Hx = 2, e6 = 3, py = {
  display: "-webkit-box",
  overflow: "hidden",
  WebkitBoxOrient: "vertical"
};
function iTe(e) {
  const {
    enableMeasure: t,
    width: r,
    text: n,
    children: a,
    rows: i,
    expanded: o,
    miscDeps: s,
    onEllipsis: l
  } = e, c = p.useMemo(() => Ma(n), [n]), u = p.useMemo(() => aTe(c), [n]), d = p.useMemo(() => a(c, !1), [n]), [f, m] = p.useState(null), h = p.useRef(null), g = p.useRef(null), y = p.useRef(null), S = p.useRef(null), [x, b] = p.useState(!1), [_, $] = p.useState(Bx), [w, O] = p.useState(0);
  hr(() => {
    $(t && r && u ? zx : Bx);
  }, [r, n, i, t, c]), hr(() => {
    var D, B, L, N;
    if (_ === zx) {
      const z = !!(!((D = g.current) === null || D === void 0) && D.isExceed());
      $(z ? Hx : e6), m(z ? [0, u] : null), b(z);
      const F = ((B = g.current) === null || B === void 0 ? void 0 : B.getHeight()) || 0, j = i === 1 ? 0 : ((L = y.current) === null || L === void 0 ? void 0 : L.getHeight()) || 0, H = ((N = S.current) === null || N === void 0 ? void 0 : N.getHeight()) || 0, U = j + H, G = Math.max(F, U);
      O(G + 1), l(z);
    }
  }, [_]);
  const T = f ? Math.ceil((f[0] + f[1]) / 2) : 0;
  hr(() => {
    var D;
    const [B, L] = f || [0, 0];
    if (B !== L) {
      const z = (((D = h.current) === null || D === void 0 ? void 0 : D.getHeight()) || 0) > w;
      let F = T;
      L - B === 1 && (F = z ? B : L), m(z ? [B, F] : [F, L]);
    }
  }, [f, T]);
  const I = p.useMemo(() => {
    if (_ !== Hx || !f || f[0] !== f[1]) {
      const D = a(c, !1);
      return _ !== e6 && _ !== Bx ? /* @__PURE__ */ p.createElement("span", {
        style: Object.assign(Object.assign({}, py), {
          WebkitLineClamp: i
        })
      }, D) : D;
    }
    return a(o ? c : Q4(c, f[0]), x);
  }, [o, _, f, c].concat(ze(s))), P = {
    width: r,
    margin: 0,
    padding: 0
  };
  return /* @__PURE__ */ p.createElement(p.Fragment, null, I, _ === zx && /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement(fy, {
    style: Object.assign(Object.assign(Object.assign({}, P), py), {
      WebkitLineClamp: i
    }),
    ref: g
  }, d), /* @__PURE__ */ p.createElement(fy, {
    style: Object.assign(Object.assign(Object.assign({}, P), py), {
      WebkitLineClamp: i - 1
    }),
    ref: y
  }, d), /* @__PURE__ */ p.createElement(fy, {
    style: Object.assign(Object.assign(Object.assign({}, P), py), {
      WebkitLineClamp: 1
    }),
    ref: S
  }, a([], !0))), _ === Hx && f && f[0] !== f[1] && /* @__PURE__ */ p.createElement(fy, {
    style: Object.assign(Object.assign({}, P), {
      top: 400
    }),
    ref: h
  }, a(Q4(c, T), !0)));
}
const VW = (e) => {
  let {
    enableEllipsis: t,
    isEllipsis: r,
    children: n,
    tooltipProps: a
  } = e;
  return !a?.title || !t ? n : /* @__PURE__ */ p.createElement(lo, Object.assign({
    open: r ? void 0 : !1
  }, a), n);
};
process.env.NODE_ENV !== "production" && (VW.displayName = "EllipsisTooltip");
var oTe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function sTe(e, t) {
  let {
    mark: r,
    code: n,
    underline: a,
    delete: i,
    strong: o,
    keyboard: s,
    italic: l
  } = e, c = t;
  function u(d, f) {
    f && (c = /* @__PURE__ */ p.createElement(d, {}, c));
  }
  return u("strong", o), u("u", a), u("del", i), u("code", n), u("mark", r), u("kbd", s), u("i", l), c;
}
const lTe = "...", rC = /* @__PURE__ */ p.forwardRef((e, t) => {
  var r, n, a;
  const {
    prefixCls: i,
    className: o,
    style: s,
    type: l,
    disabled: c,
    children: u,
    ellipsis: d,
    editable: f,
    copyable: m,
    component: h,
    title: g
  } = e, y = oTe(e, ["prefixCls", "className", "style", "type", "disabled", "children", "ellipsis", "editable", "copyable", "component", "title"]), {
    getPrefixCls: S,
    direction: x
  } = p.useContext(Lt), [b] = Ks("Text"), _ = p.useRef(null), $ = p.useRef(null), w = S("typography", i), O = bn(y, ["mark", "code", "delete", "underline", "strong", "keyboard", "italic"]), [T, I] = Fx(f), [P, D] = Kr(!1, {
    value: I.editing
  }), {
    triggerType: B = ["icon"]
  } = I, L = (Ge) => {
    var it;
    Ge && ((it = I.onStart) === null || it === void 0 || it.call(I)), D(Ge);
  }, N = QOe(P);
  JOe(() => {
    var Ge;
    !P && N && ((Ge = $.current) === null || Ge === void 0 || Ge.focus());
  }, [P]);
  const z = (Ge) => {
    Ge?.preventDefault(), L(!0);
  }, F = (Ge) => {
    var it;
    (it = I.onChange) === null || it === void 0 || it.call(I, Ge), L(!1);
  }, j = () => {
    var Ge;
    (Ge = I.onCancel) === null || Ge === void 0 || Ge.call(I), L(!1);
  }, [H, U] = Fx(m), {
    copied: G,
    copyLoading: V,
    onClick: K
  } = XOe({
    copyConfig: U,
    children: u
  }), [Z, ee] = p.useState(!1), [ae, ue] = p.useState(!1), [re, oe] = p.useState(!1), [fe, le] = p.useState(!1), [se, Q] = p.useState(!0), [he, ne] = Fx(d, {
    expandable: !1,
    symbol: (Ge) => Ge ? b?.collapse : b?.expand
  }), [me, k] = Kr(ne.defaultExpanded || !1, {
    value: ne.expanded
  }), M = he && (!me || ne.expandable === "collapsible"), {
    rows: R = 1
  } = ne, q = p.useMemo(() => (
    // Disable ellipsis
    M && // Provide suffix
    (ne.suffix !== void 0 || ne.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
    ne.expandable || T || H)
  ), [M, ne, T, H]);
  hr(() => {
    he && !q && (ee(N2("webkitLineClamp")), ue(N2("textOverflow")));
  }, [q, he]);
  const [Y, X] = p.useState(M), pe = p.useMemo(() => q ? !1 : R === 1 ? ae : Z, [q, ae, Z]);
  hr(() => {
    X(pe && M);
  }, [pe, M]);
  const $e = M && (Y ? fe : re), J = M && R === 1 && Y, de = M && R > 1 && Y, Se = (Ge, it) => {
    var ht;
    k(it.expanded), (ht = ne.onExpand) === null || ht === void 0 || ht.call(ne, Ge, it);
  }, [Ee, Te] = p.useState(0), Le = (Ge) => {
    let {
      offsetWidth: it
    } = Ge;
    Te(it);
  }, Ie = (Ge) => {
    var it;
    oe(Ge), re !== Ge && ((it = ne.onEllipsis) === null || it === void 0 || it.call(ne, Ge));
  };
  p.useEffect(() => {
    const Ge = _.current;
    if (he && Y && Ge) {
      const it = de ? Ge.offsetHeight < Ge.scrollHeight : Ge.offsetWidth < Ge.scrollWidth;
      fe !== it && le(it);
    }
  }, [he, Y, u, de, se, Ee]), p.useEffect(() => {
    const Ge = _.current;
    if (typeof IntersectionObserver > "u" || !Ge || !Y || !M)
      return;
    const it = new IntersectionObserver(() => {
      Q(!!Ge.offsetParent);
    });
    return it.observe(Ge), () => {
      it.disconnect();
    };
  }, [Y, M]);
  let De = {};
  ne.tooltip === !0 ? De = {
    title: (r = I.text) !== null && r !== void 0 ? r : u
  } : /* @__PURE__ */ p.isValidElement(ne.tooltip) ? De = {
    title: ne.tooltip
  } : typeof ne.tooltip == "object" ? De = Object.assign({
    title: (n = I.text) !== null && n !== void 0 ? n : u
  }, ne.tooltip) : De = {
    title: ne.tooltip
  };
  const Ae = p.useMemo(() => {
    const Ge = (it) => ["string", "number"].includes(typeof it);
    if (!(!he || Y)) {
      if (Ge(I.text))
        return I.text;
      if (Ge(u))
        return u;
      if (Ge(g))
        return g;
      if (Ge(De.title))
        return De.title;
    }
  }, [he, Y, g, De.title, $e]);
  if (P)
    return /* @__PURE__ */ p.createElement(HOe, {
      value: (a = I.text) !== null && a !== void 0 ? a : typeof u == "string" ? u : "",
      onSave: F,
      onCancel: j,
      onEnd: I.onEnd,
      prefixCls: w,
      className: o,
      style: s,
      direction: x,
      component: h,
      maxLength: I.maxLength,
      autoSize: I.autoSize,
      enterIcon: I.enterIcon
    });
  const Fe = () => {
    const {
      expandable: Ge,
      symbol: it
    } = ne;
    return !Ge || me && Ge !== "collapsible" ? null : /* @__PURE__ */ p.createElement("a", {
      key: "expand",
      className: `${w}-${me ? "collapse" : "expand"}`,
      onClick: (ht) => Se(ht, {
        expanded: !me
      }),
      "aria-label": me ? b.collapse : b?.expand
    }, typeof it == "function" ? it(me) : it);
  }, Ne = () => {
    if (!T)
      return;
    const {
      icon: Ge,
      tooltip: it,
      tabIndex: ht
    } = I, It = Ma(it)[0] || b?.edit, xt = typeof It == "string" ? It : "";
    return B.includes("icon") ? /* @__PURE__ */ p.createElement(lo, {
      key: "edit",
      title: it === !1 ? "" : It
    }, /* @__PURE__ */ p.createElement(LW, {
      ref: $,
      className: `${w}-edit`,
      onClick: z,
      "aria-label": xt,
      tabIndex: ht
    }, Ge || /* @__PURE__ */ p.createElement(kW, {
      role: "button"
    }))) : null;
  }, qe = () => H ? /* @__PURE__ */ p.createElement(nTe, Object.assign({
    key: "copy"
  }, U, {
    prefixCls: w,
    copied: G,
    locale: b,
    onCopy: K,
    loading: V,
    iconOnly: u == null
  })) : null, Qe = (Ge) => [
    // (renderExpanded || ellipsisConfig.collapsible) && renderExpand(),
    Ge && Fe(),
    Ne(),
    qe()
  ], tt = (Ge) => [Ge && !me && /* @__PURE__ */ p.createElement("span", {
    "aria-hidden": !0,
    key: "ellipsis"
  }, lTe), ne.suffix, Qe(Ge)];
  return /* @__PURE__ */ p.createElement(Ia, {
    onResize: Le,
    disabled: !M
  }, (Ge) => /* @__PURE__ */ p.createElement(VW, {
    tooltipProps: De,
    enableEllipsis: M,
    isEllipsis: $e
  }, /* @__PURE__ */ p.createElement(aM, Object.assign({
    className: be({
      [`${w}-${l}`]: l,
      [`${w}-disabled`]: c,
      [`${w}-ellipsis`]: he,
      [`${w}-ellipsis-single-line`]: J,
      [`${w}-ellipsis-multiple-line`]: de
    }, o),
    prefixCls: i,
    style: Object.assign(Object.assign({}, s), {
      WebkitLineClamp: de ? R : void 0
    }),
    component: h,
    ref: Za(Ge, _, t),
    direction: x,
    onClick: B.includes("text") ? z : void 0,
    "aria-label": Ae?.toString(),
    title: g
  }, O), /* @__PURE__ */ p.createElement(iTe, {
    enableMeasure: M && !Y,
    text: u,
    rows: R,
    width: Ee,
    onEllipsis: Ie,
    expanded: me,
    miscDeps: [G, me, V, T, H]
  }, (it, ht) => sTe(e, /* @__PURE__ */ p.createElement(p.Fragment, null, it.length > 0 && ht && !me && Ae ? /* @__PURE__ */ p.createElement("span", {
    key: "show-content",
    "aria-hidden": !0
  }, it) : it, tt(ht)))))));
});
var cTe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const uTe = /* @__PURE__ */ p.forwardRef((e, t) => {
  var {
    ellipsis: r,
    rel: n
  } = e, a = cTe(e, ["ellipsis", "rel"]);
  if (process.env.NODE_ENV !== "production") {
    const o = xr("Typography.Link");
    process.env.NODE_ENV !== "production" && o(typeof r != "object", "usage", "`ellipsis` only supports boolean value.");
  }
  const i = Object.assign(Object.assign({}, a), {
    rel: n === void 0 && a.target === "_blank" ? "noopener noreferrer" : n
  });
  return delete i.navigate, /* @__PURE__ */ p.createElement(rC, Object.assign({}, i, {
    ref: t,
    ellipsis: !!r,
    component: "a"
  }));
}), wE = /* @__PURE__ */ p.forwardRef((e, t) => /* @__PURE__ */ p.createElement(rC, Object.assign({
  ref: t
}, e, {
  component: "div"
})));
var dTe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const fTe = (e, t) => {
  var {
    ellipsis: r
  } = e, n = dTe(e, ["ellipsis"]);
  const a = p.useMemo(() => r && typeof r == "object" ? bn(r, ["expandable", "rows"]) : r, [r]);
  if (process.env.NODE_ENV !== "production") {
    const i = xr("Typography.Text");
    process.env.NODE_ENV !== "production" && i(typeof r != "object" || !r || !("expandable" in r) && !("rows" in r), "usage", "`ellipsis` do not support `expandable` or `rows` props.");
  }
  return /* @__PURE__ */ p.createElement(rC, Object.assign({
    ref: t
  }, n, {
    ellipsis: a,
    component: "span"
  }));
}, pTe = /* @__PURE__ */ p.forwardRef(fTe);
var mTe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
const t6 = [1, 2, 3, 4, 5], vTe = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    level: r = 1
  } = e, n = mTe(e, ["level"]);
  let a;
  if (process.env.NODE_ENV !== "production") {
    const i = xr("Typography.Title");
    process.env.NODE_ENV !== "production" && i(t6.includes(r), "usage", "Title only accept `1 | 2 | 3 | 4 | 5` as `level` value. And `5` need 4.6.0+ version.");
  }
  return t6.includes(r) ? a = `h${r}` : a = "h1", /* @__PURE__ */ p.createElement(rC, Object.assign({
    ref: t
  }, n, {
    component: a
  }));
}), Gn = aM;
Gn.Text = pTe;
Gn.Link = uTe;
Gn.Title = vTe;
Gn.Paragraph = wE;
var GW = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, r6 = xe.createContext && xe.createContext(GW), Cl = function() {
  return Cl = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Cl.apply(this, arguments);
}, hTe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function UW(e) {
  return e && e.map(function(t, r) {
    return xe.createElement(t.tag, Cl({
      key: r
    }, t.attr), UW(t.child));
  });
}
function $i(e) {
  return function(t) {
    return xe.createElement(gTe, Cl({
      attr: Cl({}, e.attr)
    }, t), UW(e.child));
  };
}
function gTe(e) {
  var t = function(r) {
    var n = e.attr, a = e.size, i = e.title, o = hTe(e, ["attr", "size", "title"]), s = a || r.size || "1em", l;
    return r.className && (l = r.className), e.className && (l = (l ? l + " " : "") + e.className), xe.createElement("svg", Cl({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, r.attr, n, o, {
      className: l,
      style: Cl(Cl({
        color: e.color || r.color
      }, r.style), e.style),
      height: s,
      width: s,
      xmlns: "http://www.w3.org/2000/svg"
    }), i && xe.createElement("title", null, i), e.children);
  };
  return r6 !== void 0 ? xe.createElement(r6.Consumer, null, function(r) {
    return t(r);
  }) : t(GW);
}
function yTe(e) {
  return $i({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M11.9997 13.1714L16.9495 8.22168L18.3637 9.63589L11.9997 15.9999L5.63574 9.63589L7.04996 8.22168L11.9997 13.1714Z" } }] })(e);
}
function bTe(e) {
  return $i({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M11.9997 10.8284L7.04996 15.7782L5.63574 14.364L11.9997 8L18.3637 14.364L16.9495 15.7782L11.9997 10.8284Z" } }] })(e);
}
function CTe(e) {
  return $i({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M2.00488 4C2.00488 3.44772 2.4526 3 3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V9.5C20.6242 9.5 19.5049 10.6193 19.5049 12C19.5049 13.3807 20.6242 14.5 22.0049 14.5V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V4ZM8.09024 19C8.29615 18.4174 8.85177 18 9.50488 18C10.158 18 10.7136 18.4174 10.9195 19H20.0049V16.0322C18.5232 15.2959 17.5049 13.7669 17.5049 12C17.5049 10.2331 18.5232 8.70411 20.0049 7.96776V5H10.9195C10.7136 5.5826 10.158 6 9.50488 6C8.85177 6 8.29615 5.5826 8.09024 5H4.00488V19H8.09024ZM9.50488 11C8.67646 11 8.00488 10.3284 8.00488 9.5C8.00488 8.67157 8.67646 8 9.50488 8C10.3333 8 11.0049 8.67157 11.0049 9.5C11.0049 10.3284 10.3333 11 9.50488 11ZM9.50488 16C8.67646 16 8.00488 15.3284 8.00488 14.5C8.00488 13.6716 8.67646 13 9.50488 13C10.3333 13 11.0049 13.6716 11.0049 14.5C11.0049 15.3284 10.3333 16 9.50488 16Z" } }] })(e);
}
function WW(e) {
  return $i({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M4.00436 6.41662L0.761719 3.17398L2.17593 1.75977L5.41857 5.00241H20.6603C21.2126 5.00241 21.6603 5.45012 21.6603 6.00241C21.6603 6.09973 21.6461 6.19653 21.6182 6.28975L19.2182 14.2898C19.0913 14.7127 18.7019 15.0024 18.2603 15.0024H6.00436V17.0024H17.0044V19.0024H5.00436C4.45207 19.0024 4.00436 18.5547 4.00436 18.0024V6.41662ZM6.00436 7.00241V13.0024H17.5163L19.3163 7.00241H6.00436ZM5.50436 23.0024C4.67593 23.0024 4.00436 22.3308 4.00436 21.5024C4.00436 20.674 4.67593 20.0024 5.50436 20.0024C6.33279 20.0024 7.00436 20.674 7.00436 21.5024C7.00436 22.3308 6.33279 23.0024 5.50436 23.0024ZM17.5044 23.0024C16.6759 23.0024 16.0044 22.3308 16.0044 21.5024C16.0044 20.674 16.6759 20.0024 17.5044 20.0024C18.3328 20.0024 19.0044 20.674 19.0044 21.5024C19.0044 22.3308 18.3328 23.0024 17.5044 23.0024Z" } }] })(e);
}
function qW(e) {
  return $i({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M10.0007 15.1709L19.1931 5.97852L20.6073 7.39273L10.0007 17.9993L3.63672 11.6354L5.05093 10.2212L10.0007 15.1709Z" } }] })(e);
}
function KW(e) {
  return $i({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z" } }] })(e);
}
function YW(e) {
  return $i({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z" } }] })(e);
}
function STe(e) {
  return $i({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z" } }] })(e);
}
function _l(e) {
  return $i({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 11V17H13V11H11ZM11 7V9H13V7H11Z" } }] })(e);
}
function xTe(e) {
  return $i({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M18.364 5.63604L16.9497 7.05025C15.683 5.7835 13.933 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12H21C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.4853 3 16.7353 4.00736 18.364 5.63604Z" } }] })(e);
}
function $Te(e) {
  return $i({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M12 3C16.9706 3 21 7.02944 21 12H19C19 8.13401 15.866 5 12 5V3Z" } }] })(e);
}
function _Te(e) {
  return $i({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM13 13.3551V14H11V12.5C11 11.9477 11.4477 11.5 12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.2723 8.5 10.6656 9.01823 10.5288 9.70577L8.56731 9.31346C8.88637 7.70919 10.302 6.5 12 6.5C13.933 6.5 15.5 8.067 15.5 10C15.5 11.5855 14.4457 12.9248 13 13.3551Z" } }] })(e);
}
function ZW(e) {
  return $i({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M5.46257 4.43262C7.21556 2.91688 9.5007 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C9.84982 4 7.89777 4.84827 6.46023 6.22842L5.46257 4.43262ZM18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 9.86386 2.66979 7.88416 3.8108 6.25944L7 12H4C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z" } }] })(e);
}
const ETe = ({ height: e = "h-screen", size: t = 64, theme: r = "WG" }) => /* @__PURE__ */ E.jsx(At, { className: `ttg-common-loading ttg-common-loading--skin--${r} ${e}`, children: /* @__PURE__ */ E.jsx(xTe, { className: "ttg-common-loading-icon", size: t }) });
/**
 * React Router v6.8.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
const wTe = /* @__PURE__ */ p.createContext(null);
process.env.NODE_ENV !== "production" && (wTe.displayName = "DataRouter");
const OTe = /* @__PURE__ */ p.createContext(null);
process.env.NODE_ENV !== "production" && (OTe.displayName = "DataRouterState");
const TTe = /* @__PURE__ */ p.createContext(null);
process.env.NODE_ENV !== "production" && (TTe.displayName = "Await");
const ITe = /* @__PURE__ */ p.createContext(null);
process.env.NODE_ENV !== "production" && (ITe.displayName = "Navigation");
const MTe = /* @__PURE__ */ p.createContext(null);
process.env.NODE_ENV !== "production" && (MTe.displayName = "Location");
const XW = /* @__PURE__ */ p.createContext({
  outlet: null,
  matches: []
});
process.env.NODE_ENV !== "production" && (XW.displayName = "Route");
const ATe = /* @__PURE__ */ p.createContext(null);
process.env.NODE_ENV !== "production" && (ATe.displayName = "RouteError");
const PTe = /* @__PURE__ */ p.createContext(null);
function RTe(e) {
  let t = p.useContext(XW).outlet;
  return t && /* @__PURE__ */ p.createElement(PTe.Provider, {
    value: e
  }, t);
}
var n6;
(function(e) {
  e.UseBlocker = "useBlocker", e.UseRevalidator = "useRevalidator";
})(n6 || (n6 = {}));
var a6;
(function(e) {
  e.UseLoaderData = "useLoaderData", e.UseActionData = "useActionData", e.UseRouteError = "useRouteError", e.UseNavigation = "useNavigation", e.UseRouteLoaderData = "useRouteLoaderData", e.UseMatches = "useMatches", e.UseRevalidator = "useRevalidator";
})(a6 || (a6 = {}));
function NTe(e) {
  return RTe(e.context);
}
var i6;
(function(e) {
  e[e.pending = 0] = "pending", e[e.success = 1] = "success", e[e.error = 2] = "error";
})(i6 || (i6 = {}));
new Promise(() => {
});
const { Content: DTe } = Ol, YZe = ({ loading: e = !1 }) => {
  const t = () => e ? /* @__PURE__ */ E.jsx(ETe, { height: "h-96" }) : /* @__PURE__ */ E.jsx(NTe, {});
  return /* @__PURE__ */ E.jsx(Ol, { className: "ttg-common-public-layout", children: /* @__PURE__ */ E.jsx(DTe, { children: t() }) });
};
var Ad = /* @__PURE__ */ ((e) => (e.TTG = "TTG", e.WG = "WG", e.SM = "SM", e))(Ad || {});
Object.values(Ad);
var Fi = /* @__PURE__ */ ((e) => (e.PASSWORD = "PASSWORD", e.GOOGLE = "GOOGLE", e.MICROSOFT = "MICROSOFT", e.LINKEDIN = "LINKEDIN", e))(Fi || {});
Object.values(Fi);
var fl = /* @__PURE__ */ ((e) => (e.PERMISSION = "PERMISSION", e.WG_CERTIFICATION = "WG_CERTIFICATION", e.WG_LICENSE = "WG_LICENSE", e.WG_ASSESSMENT = "WG_ASSESSMENT", e["5DOT_LICENSE"] = "5DOT_LICENSE", e.RESOURCE = "RESOURCE", e))(fl || {});
Object.values(fl);
var JW = /* @__PURE__ */ ((e) => (e.QUEUED = "QUEUED", e.IN_PROGRESS = "IN_PROGRESS", e.REQUIRES_ACTION = "REQUIRES_ACTION", e.CANCELLING = "CANCELLING", e.CANCELLED = "CANCELLED", e.FAILED = "FAILED", e.COMPLETED = "COMPLETED", e.INCOMPLETE = "INCOMPLETE", e.EXPIRED = "EXPIRED", e))(JW || {});
Object.values(JW);
var QW = /* @__PURE__ */ ((e) => (e.LOW = "LOW", e.FIRST_COMPETENCY_LOW = "FIRST_COMPETENCY_LOW", e.SECOND_COMPETENCY_LOW = "SECOND_COMPETENCY_LOW", e.MEDIUM_LOW = "MEDIUM_LOW", e.MEDIUM = "MEDIUM", e.MEDIUM_HIGH = "MEDIUM_HIGH", e.COMPETENCY_HIGH = "COMPETENCY_HIGH", e.HIGH = "HIGH", e))(QW || {});
Object.values(QW);
const nC = (
  // eslint-disable-next-line no-useless-escape,no-control-regex
  /(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
), eq = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/, tq = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im, rq = /^[a-zA-Z0-9]+(\s?\-?){1}[a-zA-Z0-9]+$/, iM = {
  required: "is required",
  string: {
    min: "must be at least ${min} characters",
    max: "must be up to ${max} characters"
  }
};
var nq = /* @__PURE__ */ ((e) => (e.cartDetails = "shopping-cart-view", e.checkout = "checkout-view", e))(nq || {}), mr = /* @__PURE__ */ ((e) => (e.Certification = "certification", e.CertificationForSomeoneElse = "certification-someone-else", e.AlumniIntensive = "alumni_intensive", e.Physical = "physical", e.Assessment = "assessment", e.Video = "video", e.WgAssessment = "wg_assessment", e.WgAssessmentStudent = "wg_assessment_student", e.AppGuide = "team_application_guide", e.Workshop = "workshop", e.WGBook = "wg_book", e.MeetingAdvantage = "meeting_advantage", e.SmartHireBundle = "smart_hire_bundle", e))(mr || {}), Qu = /* @__PURE__ */ ((e) => (e.PromoNoProduct = "PromoNoProduct", e.PromoWithProduct = "PromoWithProduct", e.PromoOnlyTrack = "PromoOnlyTrack", e))(Qu || {}), oM = /* @__PURE__ */ ((e) => (e.C_SUITE_LEADER = "C_SUITE_LEADER", e.DEPARTMENT_LEADER = "DEPARTMENT_LEADER", e.TEAM_LEADER = "TEAM_LEADER", e.INDIVIDUAL_CONTRIBUTOR = "INDIVIDUAL_CONTRIBUTOR", e.CONSULTANT_COACH = "CONSULTANT_COACH", e.STUDENT = "STUDENT", e.INCOMPLETE = "INCOMPLETE", e.OTHER = "OTHER", e))(oM || {});
const jTe = {
  C_SUITE_LEADER: "C Suite Leader",
  DEPARTMENT_LEADER: "Department Leader",
  TEAM_LEADER: "Team Leader",
  INDIVIDUAL_CONTRIBUTOR: "Individual Contributor",
  CONSULTANT_COACH: "Consultant / Coach",
  STUDENT: "Student"
};
Object.values(oM);
const LTe = "x-captcha-token";
var Tr = /* @__PURE__ */ ((e) => (e.Default = "default", e.TTGApp = "ttg-app", e.ITPApp = "itp-app", e))(Tr || {}), aq = /* @__PURE__ */ ((e) => (e.HUMBLE = "HUMBLE", e.HUNGRY = "HUNGRY", e.SMART = "SMART", e))(aq || {});
Object.values(aq);
const kTe = ({ appId: e }) => {
  const t = window.location.search;
  return /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "ttg-staffing-translator-login-footer", children: /* @__PURE__ */ E.jsxs("p", { children: [
    "Don't have an account?",
    " ",
    /* @__PURE__ */ E.jsx(
      Nt,
      {
        type: "link",
        tabIndex: 0,
        href: `${e === Ad.WG ? "/client/register" : "/register"}${t}`,
        children: "Create Account"
      }
    )
  ] }) }) });
}, ss = (e, t, r, n) => {
  const { value: a } = t.target, i = a.trim();
  e.setFields([{
    name: r,
    value: n ? i.toLowerCase() : i
  }]);
};
/*! @azure/msal-common v14.15.0 2024-09-20 */
const Ga = {
  EMPTY_STRING: ""
};
/*! @azure/msal-common v14.15.0 2024-09-20 */
class sM extends Error {
  constructor(t, r, n) {
    const a = r ? `${t}: ${r}` : t;
    super(a), Object.setPrototypeOf(this, sM.prototype), this.errorCode = t || Ga.EMPTY_STRING, this.errorMessage = r || Ga.EMPTY_STRING, this.subError = n || Ga.EMPTY_STRING, this.name = "AuthError";
  }
  setCorrelationId(t) {
    this.correlationId = t;
  }
}
/*! @azure/msal-common v14.15.0 2024-09-20 */
var Va;
(function(e) {
  e[e.Error = 0] = "Error", e[e.Warning = 1] = "Warning", e[e.Info = 2] = "Info", e[e.Verbose = 3] = "Verbose", e[e.Trace = 4] = "Trace";
})(Va || (Va = {}));
class Yb {
  constructor(t, r, n) {
    this.level = Va.Info;
    const a = () => {
    }, i = t || Yb.createDefaultLoggerOptions();
    this.localCallback = i.loggerCallback || a, this.piiLoggingEnabled = i.piiLoggingEnabled || !1, this.level = typeof i.logLevel == "number" ? i.logLevel : Va.Info, this.correlationId = i.correlationId || Ga.EMPTY_STRING, this.packageName = r || Ga.EMPTY_STRING, this.packageVersion = n || Ga.EMPTY_STRING;
  }
  static createDefaultLoggerOptions() {
    return {
      loggerCallback: () => {
      },
      piiLoggingEnabled: !1,
      logLevel: Va.Info
    };
  }
  /**
   * Create new Logger with existing configurations.
   */
  clone(t, r, n) {
    return new Yb({
      loggerCallback: this.localCallback,
      piiLoggingEnabled: this.piiLoggingEnabled,
      logLevel: this.level,
      correlationId: n || this.correlationId
    }, t, r);
  }
  /**
   * Log message with required options.
   */
  logMessage(t, r) {
    if (r.logLevel > this.level || !this.piiLoggingEnabled && r.containsPii)
      return;
    const i = `${`[${(/* @__PURE__ */ new Date()).toUTCString()}] : [${r.correlationId || this.correlationId || ""}]`} : ${this.packageName}@${this.packageVersion} : ${Va[r.logLevel]} - ${t}`;
    this.executeCallback(r.logLevel, i, r.containsPii || !1);
  }
  /**
   * Execute callback with message.
   */
  executeCallback(t, r, n) {
    this.localCallback && this.localCallback(t, r, n);
  }
  /**
   * Logs error messages.
   */
  error(t, r) {
    this.logMessage(t, {
      logLevel: Va.Error,
      containsPii: !1,
      correlationId: r || Ga.EMPTY_STRING
    });
  }
  /**
   * Logs error messages with PII.
   */
  errorPii(t, r) {
    this.logMessage(t, {
      logLevel: Va.Error,
      containsPii: !0,
      correlationId: r || Ga.EMPTY_STRING
    });
  }
  /**
   * Logs warning messages.
   */
  warning(t, r) {
    this.logMessage(t, {
      logLevel: Va.Warning,
      containsPii: !1,
      correlationId: r || Ga.EMPTY_STRING
    });
  }
  /**
   * Logs warning messages with PII.
   */
  warningPii(t, r) {
    this.logMessage(t, {
      logLevel: Va.Warning,
      containsPii: !0,
      correlationId: r || Ga.EMPTY_STRING
    });
  }
  /**
   * Logs info messages.
   */
  info(t, r) {
    this.logMessage(t, {
      logLevel: Va.Info,
      containsPii: !1,
      correlationId: r || Ga.EMPTY_STRING
    });
  }
  /**
   * Logs info messages with PII.
   */
  infoPii(t, r) {
    this.logMessage(t, {
      logLevel: Va.Info,
      containsPii: !0,
      correlationId: r || Ga.EMPTY_STRING
    });
  }
  /**
   * Logs verbose messages.
   */
  verbose(t, r) {
    this.logMessage(t, {
      logLevel: Va.Verbose,
      containsPii: !1,
      correlationId: r || Ga.EMPTY_STRING
    });
  }
  /**
   * Logs verbose messages with PII.
   */
  verbosePii(t, r) {
    this.logMessage(t, {
      logLevel: Va.Verbose,
      containsPii: !0,
      correlationId: r || Ga.EMPTY_STRING
    });
  }
  /**
   * Logs trace messages.
   */
  trace(t, r) {
    this.logMessage(t, {
      logLevel: Va.Trace,
      containsPii: !1,
      correlationId: r || Ga.EMPTY_STRING
    });
  }
  /**
   * Logs trace messages with PII.
   */
  tracePii(t, r) {
    this.logMessage(t, {
      logLevel: Va.Trace,
      containsPii: !0,
      correlationId: r || Ga.EMPTY_STRING
    });
  }
  /**
   * Returns whether PII Logging is enabled or not.
   */
  isPiiLoggingEnabled() {
    return this.piiLoggingEnabled || !1;
  }
}
/*! @azure/msal-browser v3.25.0 2024-10-03 */
var o6;
(function(e) {
  e.Redirect = "redirect", e.Popup = "popup", e.Silent = "silent", e.None = "none";
})(o6 || (o6 = {}));
const FTe = {
  /**
   * Status set when interaction is complete
   */
  None: "none"
};
/*! @azure/msal-browser v3.25.0 2024-10-03 */
const BTe = "storage_not_supported", Ea = "stubbed_public_client_application_called", zTe = "in_mem_redirect_unavailable";
/*! @azure/msal-browser v3.25.0 2024-10-03 */
const HTe = {
  [BTe]: "Given storage configuration option was not supported.",
  [Ea]: "Stub instance of Public Client Application was called. If using msal-react, please ensure context is not used without a provider. For more visit: aka.ms/msaljs/browser-errors",
  [zTe]: "Redirect cannot be supported. In-memory storage was selected and storeAuthStateInCookie=false, which would cause the library to be unable to handle the incoming hash. If you would like to use the redirect API, please use session/localStorage or set storeAuthStateInCookie=true."
};
class lM extends sM {
  constructor(t, r) {
    super(t, r), this.name = "BrowserConfigurationAuthError", Object.setPrototypeOf(this, lM.prototype);
  }
}
function Na(e) {
  return new lM(e, HTe[e]);
}
/*! @azure/msal-browser v3.25.0 2024-10-03 */
const VTe = {
  initialize: () => Promise.reject(Na(Ea)),
  acquireTokenPopup: () => Promise.reject(Na(Ea)),
  acquireTokenRedirect: () => Promise.reject(Na(Ea)),
  acquireTokenSilent: () => Promise.reject(Na(Ea)),
  acquireTokenByCode: () => Promise.reject(Na(Ea)),
  getAllAccounts: () => [],
  getAccount: () => null,
  getAccountByHomeId: () => null,
  getAccountByUsername: () => null,
  getAccountByLocalId: () => null,
  handleRedirectPromise: () => Promise.reject(Na(Ea)),
  loginPopup: () => Promise.reject(Na(Ea)),
  loginRedirect: () => Promise.reject(Na(Ea)),
  logout: () => Promise.reject(Na(Ea)),
  logoutRedirect: () => Promise.reject(Na(Ea)),
  logoutPopup: () => Promise.reject(Na(Ea)),
  ssoSilent: () => Promise.reject(Na(Ea)),
  addEventCallback: () => null,
  removeEventCallback: () => {
  },
  addPerformanceCallback: () => "",
  removePerformanceCallback: () => !1,
  enableAccountStorageEvents: () => {
  },
  disableAccountStorageEvents: () => {
  },
  getTokenCache: () => {
    throw Na(Ea);
  },
  getLogger: () => {
    throw Na(Ea);
  },
  setLogger: () => {
  },
  setActiveAccount: () => {
  },
  getActiveAccount: () => null,
  initializeWrapperLibrary: () => {
  },
  setNavigationClient: () => {
  },
  getConfiguration: () => {
    throw Na(Ea);
  },
  hydrateCache: () => Promise.reject(Na(Ea)),
  clearCache: () => Promise.reject(Na(Ea))
};
/*! @azure/msal-react v2.1.1 2024-10-03 */
const GTe = {
  instance: VTe,
  inProgress: FTe.None,
  accounts: [],
  logger: new Yb({})
}, iq = p.createContext(GTe);
iq.Consumer;
/*! @azure/msal-react v2.1.1 2024-10-03 */
const UTe = () => Cr(iq), WTe = Ws(null);
function qTe() {
  const e = Cr(WTe);
  if (!e)
    throw new Error("Google OAuth components must be used within GoogleOAuthProvider");
  return e;
}
function KTe({ flow: e = "implicit", scope: t = "", onSuccess: r, onError: n, onNonOAuthError: a, overrideScope: i, state: o, ...s }) {
  const { clientId: l, scriptLoadedSuccessfully: c } = qTe(), u = ct(), d = ct(r);
  d.current = r;
  const f = ct(n);
  f.current = n;
  const m = ct(a);
  m.current = a, St(() => {
    var y, S;
    if (!c)
      return;
    const x = e === "implicit" ? "initTokenClient" : "initCodeClient", b = (S = (y = window?.google) === null || y === void 0 ? void 0 : y.accounts) === null || S === void 0 ? void 0 : S.oauth2[x]({
      client_id: l,
      scope: i ? t : `openid profile email ${t}`,
      callback: (_) => {
        var $, w;
        if (_.error)
          return ($ = f.current) === null || $ === void 0 ? void 0 : $.call(f, _);
        (w = d.current) === null || w === void 0 || w.call(d, _);
      },
      error_callback: (_) => {
        var $;
        ($ = m.current) === null || $ === void 0 || $.call(m, _);
      },
      state: o,
      ...s
    });
    u.current = b;
  }, [l, c, e, t, o]);
  const h = Bt((y) => {
    var S;
    return (S = u.current) === null || S === void 0 ? void 0 : S.requestAccessToken(y);
  }, []), g = Bt(() => {
    var y;
    return (y = u.current) === null || y === void 0 ? void 0 : y.requestCode();
  }, []);
  return e === "implicit" ? h : g;
}
const Mh = Aa(({
  onClick: e,
  className: t,
  width: r,
  height: n,
  svg: a,
  tabIndex: i
}, o) => {
  const [s, l] = dr(() => {
    const d = (r || 0) * a.height / a.width, f = (n || 0) * a.width / a.height;
    return r && !n ? [d, r] : n && !r ? [n, f] : r && n ? d > n ? [f * a.height / a.width, f] : f > r ? [d, d * a.width / a.height] : [d, f] : [a.height, a.width];
  }, [n, r, a]), c = (d) => {
    e && (d.stopPropagation(), d.preventDefault(), e());
  }, u = (d) => {
    d.key !== "Enter" && d.key !== " " || c(d);
  };
  return /* @__PURE__ */ E.jsx(
    "div",
    {
      className: t,
      onClick: c,
      tabIndex: i ?? (e ? 0 : void 0),
      onKeyDown: u,
      ref: o,
      children: /* @__PURE__ */ E.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: a.viewBox || `0 0 ${a.width} ${a.height}`,
          height: s,
          width: l,
          children: a.pathing
        }
      )
    }
  );
});
Mh.displayName = "SVG";
const ZZe = ({ sortOrder: e }) => e === "descend" ? /* @__PURE__ */ E.jsx(yTe, { size: 20 }) : e === "ascend" ? /* @__PURE__ */ E.jsx(bTe, { size: 20 }) : null, YTe = Aa(({ pathing: e, ...t }, r) => /* @__PURE__ */ E.jsx(Mh, { svg: { height: 24, width: 24, pathing: e }, ref: r, ...t }));
YTe.displayName = "Icon";
const cM = {
  gear: /* @__PURE__ */ E.jsx("path", { className: "st0", d: `M88,52.8c-0.1-0.1-0.4-0.3-0.8-0.5c-1.6-0.6-3.2-1.3-4.8-2c-0.6-0.2-1-0.4-1.4-0.7c-0.4-0.2-0.7-0.6-0.8-1.1
	c-0.1-0.3-0.1-0.6-0.1-0.9c0-0.3,0-0.6,0.1-1l0-0.2c-0.1-3.2-0.2-6.5-0.4-9.9l0-0.5l0.4-0.2c1.9-1,4-2,6.1-3.1
	c0.5-0.2,0.8-0.5,0.9-0.6c0.1-0.2,0.2-0.3,0.2-0.5c0-0.2,0-0.5-0.2-0.9c-1.1-3.5-2.5-6.7-4.4-9.8c-0.3-0.4-0.6-0.9-1-1.3
	c-0.3-0.3-0.6-0.4-0.8-0.4c-0.2,0-0.4,0-0.7,0.2c-2.2,1-4.5,1.9-6.4,2.6l-0.5,0.2L73,21.9c-3.1-2.9-6-5.6-9.1-8.4l-0.4-0.3l0.2-0.5
	c0.7-2.1,1.5-4.4,2.2-6.7C66,5.7,66,5.5,66.1,5.3c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.3-0.3-0.6-0.5C61.7,2.4,57.9,0.9,54,0.1
	C53.7,0,53.6,0,53.4,0c-0.3,0-0.5,0.1-0.7,0.2c-0.2,0.1-0.4,0.4-0.5,0.8c-0.9,2-1.7,3.9-2.5,5.9c-0.1,0.4-0.3,0.7-0.7,1
	c-0.3,0.3-0.7,0.3-1.1,0.3l-0.4,0C46.9,8.1,46.3,8,45.7,8c-0.3,0-0.5,0-0.8,0c-2.8,0.1-5.6,0.3-8.5,0.5l-0.5,0l-0.2-0.4
	c-1.1-2.1-2.2-4.3-3.3-6.5c-0.2-0.3-0.3-0.5-0.5-0.6l-0.4-0.2l-0.3,0c-4.1,1.2-7.9,3-11.5,5.3c-0.5,0.4-0.6,0.6-0.7,1
	c0,0.2,0,0.5,0.2,0.8c0.4,0.9,0.8,1.9,1.2,2.9c0.5,1.3,1,2.7,1.6,4l0.2,0.5l-0.4,0.3c-2.9,2.3-5.4,4.9-7.4,7.9
	c-0.2,0.3-0.4,0.5-0.7,0.7c-0.3,0.2-0.6,0.3-0.9,0.3c-0.3,0-0.5-0.1-0.7-0.1C10,23.6,8,23,6,22.4c-0.4-0.1-0.7-0.2-1-0.2
	c-0.3,0-0.4,0-0.5,0.2c-0.1,0.1-0.3,0.4-0.5,0.8c-1.3,2.9-2.4,5.9-3.6,8.9c-0.3,0.8-0.4,1.7-0.4,2.6l0,0.1c0,0.3,0.1,0.6,0.2,0.7
	C0.3,35.8,0.6,36,1,36.1c2,0.8,4,1.7,6,2.5c0.3,0.1,0.6,0.3,0.8,0.6C8,39.5,8,39.9,8,40.2l0,0.3l0,0c-0.1,0.6-0.1,1.3-0.2,1.9
	c0,0.2,0,0.4,0,0.6c0.1,2.9,0.3,5.8,0.4,8.8l0,0.5l-0.4,0.2c-2,1-4.2,2.1-6.3,3.2c-0.4,0.2-0.6,0.4-0.7,0.5
	c-0.1,0.1-0.1,0.2-0.2,0.5c0,0.2,0,0.5,0.2,0.8c1.2,3.8,2.8,7.4,4.9,10.8C6,68.7,6.2,68.9,6.4,69c0.2,0.1,0.3,0.2,0.5,0.2
	c0.2,0,0.5-0.1,0.9-0.2c2-0.8,4.1-1.6,6.1-2.5c0.2-0.1,0.5-0.2,0.8-0.2c0.2,0,0.5,0.1,0.7,0.2c0.2,0.1,0.4,0.3,0.5,0.5
	c2.2,2.7,4.8,5,7.6,7.1c0.2,0.1,0.4,0.3,0.5,0.5c0.2,0.2,0.3,0.6,0.3,0.9c0,0.2-0.1,0.4-0.1,0.6c-0.7,2.1-1.4,4.3-2.1,6.5
	C22,82.8,22,83,22,83.1c0,0.2,0,0.4,0.1,0.5c0.1,0.1,0.3,0.3,0.6,0.5c3.6,1.9,7.3,3.3,11.3,4.2c0.2,0,0.4,0.1,0.6,0.1
	c0.4,0,0.6-0.1,0.7-0.2c0.2-0.1,0.4-0.4,0.6-0.9c0.8-2,1.6-3.9,2.5-5.9c0.2-0.3,0.4-0.6,0.6-0.8c0.3-0.2,0.5-0.4,1-0.4l0.1,0l0,0
	c1,0.1,1.9,0.1,2.9,0.2c2.8,0.1,5.5-0.2,8.3-0.7l0.5-0.1l0.3,0.5c0.3,0.6,0.6,1.1,0.9,1.7c0.9,1.7,1.7,3.4,2.6,5
	c0.2,0.4,0.4,0.6,0.6,0.7c0.1,0.1,0.2,0.1,0.4,0.1c0.2,0,0.5-0.1,0.9-0.2c2.3-0.9,4.6-1.7,6.8-2.7c1.4-0.7,2.8-1.5,4.1-2.5
	c0.3-0.2,0.4-0.4,0.5-0.5l0.1-0.4c0-0.2-0.1-0.5-0.3-1c-0.8-2-1.6-3.9-2.4-5.9l0,0c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.2,0-0.4,0.1-0.6
	c0.1-0.2,0.2-0.4,0.4-0.6c2.8-2.3,5.1-4.9,7.3-7.8c0.2-0.3,0.4-0.4,0.7-0.5c0.2-0.1,0.5-0.1,0.8-0.1l0.3,0c2.1,0.6,4.2,1.3,6.3,1.9
	c0.4,0.1,0.7,0.2,0.9,0.2c0.3,0,0.4,0,0.6-0.2c0.2-0.1,0.3-0.3,0.5-0.7c1-2.3,2-4.5,2.9-6.8c0.5-1.4,0.9-2.9,1.2-4.5
	c0.1-0.2,0.1-0.4,0.1-0.6C88.2,53.1,88.2,53,88,52.8z M64.9,51.9c-3.4,9.2-12.1,14.8-21.4,14.6c-2.4,0-4.9-0.5-7.3-1.4
	C27.1,61.8,21.5,53,21.6,43.8c0-2.4,0.5-4.9,1.4-7.3c3.4-9.2,12.1-14.8,21.4-14.6c2.4,0,4.9,0.5,7.3,1.4
	c9.2,3.4,14.8,12.1,14.6,21.4C66.2,47,65.8,49.5,64.9,51.9z` }),
  [Fi.GOOGLE]: /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
    /* @__PURE__ */ E.jsxs("g", { clipPath: "url(#clip0_16720_52397)", children: [
      /* @__PURE__ */ E.jsx("path", { d: "M10 8.18179V12.0545H15.3818C15.1455 13.3 14.4363 14.3546 13.3727 15.0636L16.6181 17.5818C18.509 15.8365 19.5999 13.2728 19.5999 10.2273C19.5999 9.51827 19.5363 8.83639 19.4181 8.1819L10 8.18179Z", fill: "#4285F4" }),
      /* @__PURE__ */ E.jsx("path", { d: "M4.39519 11.9034L3.66322 12.4637L1.07227 14.4818C2.71772 17.7454 6.09019 20 9.99925 20C12.6992 20 14.9628 19.1091 16.6174 17.5819L13.3719 15.0636C12.481 15.6636 11.3447 16.0273 9.99925 16.0273C7.39927 16.0273 5.19024 14.2728 4.39928 11.9091L4.39519 11.9034Z", fill: "#34A853" }),
      /* @__PURE__ */ E.jsx("path", { d: "M1.07265 5.51819C0.390868 6.86359 0 8.38179 0 9.99994C0 11.6181 0.390868 13.1363 1.07265 14.4817C1.07265 14.4907 4.39998 11.8999 4.39998 11.8999C4.19998 11.2999 4.08177 10.6636 4.08177 9.99984C4.08177 9.33612 4.19998 8.69979 4.39998 8.0998L1.07265 5.51819Z", fill: "#FBBC05" }),
      /* @__PURE__ */ E.jsx("path", { d: "M9.99946 3.98182C11.4722 3.98182 12.7813 4.49089 13.8267 5.47272L16.6903 2.60912C14.954 0.990971 12.6995 0 9.99946 0C6.0904 0 2.71772 2.24545 1.07227 5.51819L4.39949 8.10001C5.19035 5.73635 7.39947 3.98182 9.99946 3.98182Z", fill: "#EA4335" })
    ] }),
    /* @__PURE__ */ E.jsx("defs", { children: /* @__PURE__ */ E.jsx("clipPath", { id: "clip0_16720_52397", children: /* @__PURE__ */ E.jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
  ] }),
  [Fi.MICROSOFT]: /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
    /* @__PURE__ */ E.jsx("path", { d: "M9.16602 9.16666H2.49935L2.49935 2.49999L9.16602 2.49999V9.16666Z", fill: "#FF5722" }),
    /* @__PURE__ */ E.jsx("path", { d: "M17.5 9.16666H10.8333V2.49999L17.5 2.49999V9.16666Z", fill: "#4CAF50" }),
    /* @__PURE__ */ E.jsx("path", { d: "M17.5 17.5H10.8333V10.8333H17.5V17.5Z", fill: "#FFC107" }),
    /* @__PURE__ */ E.jsx("path", { d: "M9.16602 17.5H2.49935L2.49935 10.8333H9.16602V17.5Z", fill: "#03A9F4" })
  ] }),
  [Fi.LINKEDIN]: /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
    /* @__PURE__ */ E.jsx("g", { clipPath: "url(#clip0_16720_52403)", children: /* @__PURE__ */ E.jsx("path", { d: "M18.5236 0H1.47639C1.08483 0 0.709301 0.155548 0.432425 0.432425C0.155548 0.709301 0 1.08483 0 1.47639V18.5236C0 18.9152 0.155548 19.2907 0.432425 19.5676C0.709301 19.8445 1.08483 20 1.47639 20H18.5236C18.9152 20 19.2907 19.8445 19.5676 19.5676C19.8445 19.2907 20 18.9152 20 18.5236V1.47639C20 1.08483 19.8445 0.709301 19.5676 0.432425C19.2907 0.155548 18.9152 0 18.5236 0ZM5.96111 17.0375H2.95417V7.48611H5.96111V17.0375ZM4.45556 6.1625C4.11447 6.16058 3.7816 6.05766 3.49895 5.86674C3.21629 5.67582 2.99653 5.40544 2.8674 5.08974C2.73826 4.77404 2.70554 4.42716 2.77336 4.09288C2.84118 3.7586 3.0065 3.4519 3.24846 3.21148C3.49042 2.97107 3.79818 2.80772 4.13289 2.74205C4.4676 2.67638 4.81426 2.71133 5.12913 2.84249C5.44399 2.97365 5.71295 3.19514 5.90205 3.47901C6.09116 3.76288 6.19194 4.09641 6.19167 4.4375C6.19488 4.66586 6.15209 4.89253 6.06584 5.104C5.97959 5.31547 5.85165 5.50742 5.68964 5.66839C5.52763 5.82936 5.33487 5.95607 5.12285 6.04096C4.91083 6.12585 4.68389 6.16718 4.45556 6.1625ZM17.0444 17.0458H14.0389V11.8278C14.0389 10.2889 13.3847 9.81389 12.5403 9.81389C11.6486 9.81389 10.7736 10.4861 10.7736 11.8667V17.0458H7.76667V7.49306H10.6583V8.81667H10.6972C10.9875 8.22917 12.0042 7.225 13.5556 7.225C15.2333 7.225 17.0458 8.22083 17.0458 11.1375L17.0444 17.0458Z", fill: "#0A66C2" }) }),
    /* @__PURE__ */ E.jsx("defs", { children: /* @__PURE__ */ E.jsx("clipPath", { id: "clip0_16720_52403", children: /* @__PURE__ */ E.jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
  ] }),
  play: /* @__PURE__ */ E.jsx(
    "path",
    {
      d: "M2.41647 2.78729L18.0873 8.01062C18.1684 8.03751 18.2393 8.08868 18.2903 8.15721C18.3414 8.22574 18.3701 8.3083 18.3727 8.39371C18.3752 8.47913 18.3515 8.56326 18.3046 8.6347C18.2577 8.70615 18.19 8.76146 18.1106 8.79313L10.8331 11.704L7.14563 19.079C7.10811 19.1541 7.04878 19.2161 6.9754 19.2569C6.90203 19.2977 6.81805 19.3154 6.73446 19.3076C6.65086 19.2999 6.57156 19.267 6.50694 19.2135C6.44231 19.1599 6.39538 19.088 6.3723 19.0073L1.88313 3.29646C1.86234 3.22347 1.86187 3.14619 1.88179 3.07296C1.9017 2.99972 1.94124 2.93332 1.99613 2.88091C2.05103 2.82851 2.11919 2.79209 2.19327 2.77559C2.26734 2.75909 2.34452 2.76314 2.41647 2.78729Z"
    }
  )
}, ZTe = ({
  type: e,
  height: t,
  width: r,
  className: n
}) => /* @__PURE__ */ E.jsxs(
  "div",
  {
    className: n,
    style: {
      position: "relative",
      height: `${t}px`,
      width: `${r}px`
    },
    children: [
      /* @__PURE__ */ E.jsx(
        Mh,
        {
          height: t,
          width: r,
          svg: { height: 88, width: 88, pathing: cM.gear }
        }
      ),
      /* @__PURE__ */ E.jsx("div", { className: "flex absolute top-0 right-0 bottom-0 left-0 items-center justify-center content-center", children: /* @__PURE__ */ E.jsx(
        "span",
        {
          style: {
            fontSize: `calc(${t / 2}px - 4px)`,
            fontWeight: "bold",
            paddingTop: "2px"
          },
          children: e
        }
      ) })
    ]
  }
), oq = ({
  loading: e,
  oauthLoginUser: t,
  onLoad: r,
  onError: n,
  signInOrRegister: a,
  provider: i,
  linkedinClientId: o,
  linkedinRedirectUri: s,
  microsoftRedirectUri: l,
  microsoftClientId: c,
  ssoHook: u
}) => {
  const { instance: d } = UTe(), {
    authUser: f,
    onChangeAuthUser: m,
    onChangeSSOAuthError: h,
    fetchCsrfToken: g
  } = u, [y, S] = He();
  d.setActiveAccount(null);
  const x = KTe({
    onNonOAuthError: () => {
      r(!1);
    },
    onSuccess: (O) => b({
      provider: Fi.GOOGLE,
      accessToken: O.access_token,
      state: O?.state ?? ""
    }),
    onError: (O) => {
      if (r(!1), O.error)
        return h(O.error);
      h(O.toString());
    },
    state: y
  }), b = Bt(
    async (O) => t(O).then((T) => a(T)).catch((T) => {
      console.error("Error", T), r(!1), h(T);
    }).finally(() => {
      f && m(void 0);
    }),
    [
      f,
      t,
      m,
      h,
      r,
      a
    ]
  ), _ = Bt(async (O) => {
    await d.clearCache({});
    let T = null;
    try {
      if (O) {
        window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${c}&response_type=code&redirect_uri=${l}&state=${y}&scope=openid profile email User.Read`;
        return;
      }
      T = await d.acquireTokenPopup({
        state: y,
        scopes: ["openid", "profile", "email", "User.Read"],
        prompt: "select_account"
      }), await b({
        provider: Fi.MICROSOFT,
        accessToken: T.accessToken,
        code: T.code,
        state: T?.state ?? ""
      });
    } catch (I) {
      if (console.error("Login Error", I), r(!1), await d.clearCache(T ? { account: T.account } : {}), I) {
        const P = I ?? void 0;
        if (P?.errorCode === "popup_window_error") {
          await _(!0);
          return;
        }
        return h(["user_cancelled"].includes(P?.errorCode) ? void 0 : P?.errorMessage?.toString());
      }
      h("Oops, something went wrong.");
    }
  }, [
    b,
    d,
    c,
    l,
    h,
    r,
    y
  ]), $ = Bt(async () => {
    window.open(`https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${o}&redirect_uri=${s}&state=${y}&scope=${encodeURIComponent("openid profile email")}&prompt=login`, "_self");
  }, [o, s, y]), w = async () => {
    S(void 0), r(!0), n(void 0), h(void 0);
    try {
      const O = await g();
      S(O.token);
    } catch (O) {
      console.error("Error loading token", O), r(!1);
    }
  };
  return St(() => {
    f && !e && f.provider === i && (r(!0), b(f));
  }, [f]), St(() => {
    y && (i === Fi.GOOGLE && x(), i === Fi.MICROSOFT && _(), i === Fi.LINKEDIN && $());
  }, [y]), /* @__PURE__ */ E.jsx(
    Nt,
    {
      loading: e,
      htmlType: "button",
      type: "default",
      className: "icon-button",
      onClick: w,
      icon: i !== Fi.PASSWORD && /* @__PURE__ */ E.jsx(
        Mh,
        {
          className: "icon-svg",
          svg: {
            pathing: cM[i],
            width: 20,
            height: 20
          }
        }
      )
    }
  );
}, XZe = ({
  userHook: e,
  title: t,
  subtitle: r,
  onFinish: n,
  onForgotPassword: a,
  theme: i = "default",
  ssoHook: o,
  resource: s,
  userToken: l
}) => {
  const [c, u] = He(), [d] = Dt.useForm(), [f, m] = He(!1), [h, g] = He(!1), {
    onChangeRegisteringUser: y,
    ssoAuthError: S,
    allowedAuthProviders: x,
    linkedinClientId: b,
    linkedinRedirectUri: _,
    microsoftRedirectUri: $,
    microsoftClientId: w,
    appId: O
  } = o, { loginUser: T, oauthLoginUser: I } = e, P = async (L) => (m(!0), T({ ...L, resource: s }).then((N) => N ? n(N.user, () => m(!1), s?.redirectPath) : m(!1)).catch((N) => (m(!1), u(N?.response?.status === 409 ? "It looks like you signed up using a single sign-on (SSO) method such as Google, Microsoft, or LinkedIn. Please log in using the SSO option you used when creating your account." : "Looks like you have entered a wrong email address or password. Check your login details and try again.")))), D = () => {
    if (c || S)
      return /* @__PURE__ */ E.jsx(Oe, { className: "login-error", children: /* @__PURE__ */ E.jsx(uM, { children: c || S }) });
  }, B = (L) => {
    if (L) {
      if (L?.user)
        return y(void 0), n(L.user, () => m(!1), s?.redirectPath);
      if (L.email)
        return m(!1), y(L);
    }
    m(!1), u("Oops, something went wrong!");
  };
  return /* @__PURE__ */ E.jsx(
    At,
    {
      justify: "center",
      align: "top",
      className: `ttg-staffing-translator-login ttg-staffing-translator-login--skin--${i}`,
      children: /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "flex flex-col justify-center w-full", children: /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(Oe, { span: 24, children: [
        D(),
        /* @__PURE__ */ E.jsxs(
          zn,
          {
            type: "inner",
            size: "default",
            bordered: !1,
            className: `ttg-login ttg-login--skin--${i}`,
            children: [
              /* @__PURE__ */ E.jsx(
                lr,
                {
                  direction: "vertical",
                  align: "center",
                  size: 32,
                  className: "h-full pb-8 w-full text-center",
                  children: /* @__PURE__ */ E.jsxs(
                    lr,
                    {
                      direction: "vertical",
                      align: "center",
                      className: "h-full w-full",
                      children: [
                        /* @__PURE__ */ E.jsx("h1", { className: "login-title", children: t }),
                        /* @__PURE__ */ E.jsx("h2", { className: "login-sub-title", children: r })
                      ]
                    }
                  )
                }
              ),
              /* @__PURE__ */ E.jsx(
                Dt,
                {
                  form: d,
                  initialValues: s ?? l,
                  onFinish: P,
                  onFinishFailed: () => g(!0),
                  validateTrigger: h ? "onChange" : "onSubmit",
                  children: /* @__PURE__ */ E.jsxs(At, { gutter: [0, 4], children: [
                    /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
                      Dt.Item,
                      {
                        name: "email",
                        label: "Email Address",
                        labelCol: { span: 24 },
                        rules: [
                          {
                            required: !0,
                            message: "is required"
                          },
                          {
                            pattern: nC,
                            message: "Please enter a valid email address."
                          }
                        ],
                        children: /* @__PURE__ */ E.jsx(
                          Lr,
                          {
                            disabled: f || !!s?.email || !!l?.email,
                            autoComplete: "email",
                            onBlur: (L) => ss(
                              d,
                              L,
                              "email",
                              !1
                            )
                          }
                        )
                      }
                    ) }),
                    /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
                      Dt.Item,
                      {
                        name: "password",
                        label: "Password",
                        labelCol: { span: 24 },
                        rules: [{ required: !0, message: "is required" }],
                        children: /* @__PURE__ */ E.jsx(
                          Lr.Password,
                          {
                            disabled: f,
                            autoComplete: "current-password"
                          }
                        )
                      }
                    ) }),
                    /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
                      Nt,
                      {
                        type: "link",
                        onClick: a,
                        className: "w-full font-inherit",
                        children: "Forgot your password?"
                      }
                    ) }),
                    /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "pt-2", children: /* @__PURE__ */ E.jsx(
                      Nt,
                      {
                        htmlType: "submit",
                        type: "primary",
                        className: "w-full",
                        loading: f,
                        children: "Login"
                      }
                    ) }),
                    /* @__PURE__ */ E.jsx(Eh, { plain: !0, children: "Or continue with" }),
                    /* @__PURE__ */ E.jsx(At, { justify: "center", style: { width: "100%" }, children: x.map((L) => /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(
                      oq,
                      {
                        provider: L,
                        ssoHook: o,
                        loading: f,
                        oauthLoginUser: (N) => I(N, s, l),
                        onLoad: m,
                        onError: u,
                        signInOrRegister: B,
                        linkedinClientId: b,
                        linkedinRedirectUri: _,
                        microsoftClientId: w,
                        microsoftRedirectUri: $
                      }
                    ) }, L)) })
                  ] })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ E.jsx(kTe, { appId: O })
      ] }) }) })
    }
  );
}, uM = ({ title: e, children: t }) => /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "ttg-error-alert ttg-error-alert--skin--default", children: /* @__PURE__ */ E.jsxs(lr, { direction: "horizontal", size: 12, align: "start", className: "ttg-error-alert-content", children: [
  /* @__PURE__ */ E.jsx(YW, { size: 16, className: "ttg-error-alert-icon" }),
  /* @__PURE__ */ E.jsxs(lr, { direction: "vertical", children: [
    e && /* @__PURE__ */ E.jsx("p", { className: "ttg-error-alert-title", children: e }),
    /* @__PURE__ */ E.jsx("p", { className: "ttg-error-alert-content-error", children: t })
  ] })
] }) });
/*! js-cookie v3.0.5 | MIT */
function my(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      e[n] = r[n];
  }
  return e;
}
var XTe = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function OE(e, t) {
  function r(a, i, o) {
    if (!(typeof document > "u")) {
      o = my({}, t, o), typeof o.expires == "number" && (o.expires = new Date(Date.now() + o.expires * 864e5)), o.expires && (o.expires = o.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var l in o)
        o[l] && (s += "; " + l, o[l] !== !0 && (s += "=" + o[l].split(";")[0]));
      return document.cookie = a + "=" + e.write(i, a) + s;
    }
  }
  function n(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var i = document.cookie ? document.cookie.split("; ") : [], o = {}, s = 0; s < i.length; s++) {
        var l = i[s].split("="), c = l.slice(1).join("=");
        try {
          var u = decodeURIComponent(l[0]);
          if (o[u] = e.read(c, u), a === u)
            break;
        } catch {
        }
      }
      return a ? o[a] : o;
    }
  }
  return Object.create(
    {
      set: r,
      get: n,
      remove: function(a, i) {
        r(
          a,
          "",
          my({}, i, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return OE(this.converter, my({}, this.attributes, a));
      },
      withConverter: function(a) {
        return OE(my({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var ni = OE(XTe, { path: "/" }), TE = { exports: {} }, vy = { exports: {} }, ln = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var s6;
function JTe() {
  if (s6) return ln;
  s6 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
  function b($) {
    if (typeof $ == "object" && $ !== null) {
      var w = $.$$typeof;
      switch (w) {
        case t:
          switch ($ = $.type, $) {
            case l:
            case c:
            case n:
            case i:
            case a:
            case d:
              return $;
            default:
              switch ($ = $ && $.$$typeof, $) {
                case s:
                case u:
                case h:
                case m:
                case o:
                  return $;
                default:
                  return w;
              }
          }
        case r:
          return w;
      }
    }
  }
  function _($) {
    return b($) === c;
  }
  return ln.AsyncMode = l, ln.ConcurrentMode = c, ln.ContextConsumer = s, ln.ContextProvider = o, ln.Element = t, ln.ForwardRef = u, ln.Fragment = n, ln.Lazy = h, ln.Memo = m, ln.Portal = r, ln.Profiler = i, ln.StrictMode = a, ln.Suspense = d, ln.isAsyncMode = function($) {
    return _($) || b($) === l;
  }, ln.isConcurrentMode = _, ln.isContextConsumer = function($) {
    return b($) === s;
  }, ln.isContextProvider = function($) {
    return b($) === o;
  }, ln.isElement = function($) {
    return typeof $ == "object" && $ !== null && $.$$typeof === t;
  }, ln.isForwardRef = function($) {
    return b($) === u;
  }, ln.isFragment = function($) {
    return b($) === n;
  }, ln.isLazy = function($) {
    return b($) === h;
  }, ln.isMemo = function($) {
    return b($) === m;
  }, ln.isPortal = function($) {
    return b($) === r;
  }, ln.isProfiler = function($) {
    return b($) === i;
  }, ln.isStrictMode = function($) {
    return b($) === a;
  }, ln.isSuspense = function($) {
    return b($) === d;
  }, ln.isValidElementType = function($) {
    return typeof $ == "string" || typeof $ == "function" || $ === n || $ === c || $ === i || $ === a || $ === d || $ === f || typeof $ == "object" && $ !== null && ($.$$typeof === h || $.$$typeof === m || $.$$typeof === o || $.$$typeof === s || $.$$typeof === u || $.$$typeof === y || $.$$typeof === S || $.$$typeof === x || $.$$typeof === g);
  }, ln.typeOf = b, ln;
}
var cn = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l6;
function QTe() {
  return l6 || (l6 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
    function b(Q) {
      return typeof Q == "string" || typeof Q == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Q === n || Q === c || Q === i || Q === a || Q === d || Q === f || typeof Q == "object" && Q !== null && (Q.$$typeof === h || Q.$$typeof === m || Q.$$typeof === o || Q.$$typeof === s || Q.$$typeof === u || Q.$$typeof === y || Q.$$typeof === S || Q.$$typeof === x || Q.$$typeof === g);
    }
    function _(Q) {
      if (typeof Q == "object" && Q !== null) {
        var he = Q.$$typeof;
        switch (he) {
          case t:
            var ne = Q.type;
            switch (ne) {
              case l:
              case c:
              case n:
              case i:
              case a:
              case d:
                return ne;
              default:
                var me = ne && ne.$$typeof;
                switch (me) {
                  case s:
                  case u:
                  case h:
                  case m:
                  case o:
                    return me;
                  default:
                    return he;
                }
            }
          case r:
            return he;
        }
      }
    }
    var $ = l, w = c, O = s, T = o, I = t, P = u, D = n, B = h, L = m, N = r, z = i, F = a, j = d, H = !1;
    function U(Q) {
      return H || (H = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), G(Q) || _(Q) === l;
    }
    function G(Q) {
      return _(Q) === c;
    }
    function V(Q) {
      return _(Q) === s;
    }
    function K(Q) {
      return _(Q) === o;
    }
    function Z(Q) {
      return typeof Q == "object" && Q !== null && Q.$$typeof === t;
    }
    function ee(Q) {
      return _(Q) === u;
    }
    function ae(Q) {
      return _(Q) === n;
    }
    function ue(Q) {
      return _(Q) === h;
    }
    function re(Q) {
      return _(Q) === m;
    }
    function oe(Q) {
      return _(Q) === r;
    }
    function fe(Q) {
      return _(Q) === i;
    }
    function le(Q) {
      return _(Q) === a;
    }
    function se(Q) {
      return _(Q) === d;
    }
    cn.AsyncMode = $, cn.ConcurrentMode = w, cn.ContextConsumer = O, cn.ContextProvider = T, cn.Element = I, cn.ForwardRef = P, cn.Fragment = D, cn.Lazy = B, cn.Memo = L, cn.Portal = N, cn.Profiler = z, cn.StrictMode = F, cn.Suspense = j, cn.isAsyncMode = U, cn.isConcurrentMode = G, cn.isContextConsumer = V, cn.isContextProvider = K, cn.isElement = Z, cn.isForwardRef = ee, cn.isFragment = ae, cn.isLazy = ue, cn.isMemo = re, cn.isPortal = oe, cn.isProfiler = fe, cn.isStrictMode = le, cn.isSuspense = se, cn.isValidElementType = b, cn.typeOf = _;
  }()), cn;
}
var c6;
function sq() {
  return c6 || (c6 = 1, process.env.NODE_ENV === "production" ? vy.exports = JTe() : vy.exports = QTe()), vy.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Vx, u6;
function eIe() {
  if (u6) return Vx;
  u6 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(o).map(function(u) {
        return o[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Vx = a() ? Object.assign : function(i, o) {
    for (var s, l = n(i), c, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var d in s)
        t.call(s, d) && (l[d] = s[d]);
      if (e) {
        c = e(s);
        for (var f = 0; f < c.length; f++)
          r.call(s, c[f]) && (l[c[f]] = s[c[f]]);
      }
    }
    return l;
  }, Vx;
}
var Gx, d6;
function dM() {
  if (d6) return Gx;
  d6 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Gx = e, Gx;
}
var Ux, f6;
function lq() {
  return f6 || (f6 = 1, Ux = Function.call.bind(Object.prototype.hasOwnProperty)), Ux;
}
var Wx, p6;
function tIe() {
  if (p6) return Wx;
  p6 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = dM(), r = {}, n = lq();
    e = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (n(i, u)) {
          var d;
          try {
            if (typeof i[u] != "function") {
              var f = Error(
                (l || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = i[u](o, u, l, s, null, t);
          } catch (h) {
            d = h;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in r)) {
            r[d.message] = !0;
            var m = c ? c() : "";
            e(
              "Failed " + s + " type: " + d.message + (m ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Wx = a, Wx;
}
var qx, m6;
function rIe() {
  if (m6) return qx;
  m6 = 1;
  var e = sq(), t = eIe(), r = dM(), n = lq(), a = tIe(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return qx = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(G) {
      var V = G && (c && G[c] || G[u]);
      if (typeof V == "function")
        return V;
    }
    var f = "<<anonymous>>", m = {
      array: S("array"),
      bigint: S("bigint"),
      bool: S("boolean"),
      func: S("function"),
      number: S("number"),
      object: S("object"),
      string: S("string"),
      symbol: S("symbol"),
      any: x(),
      arrayOf: b,
      element: _(),
      elementType: $(),
      instanceOf: w,
      node: P(),
      objectOf: T,
      oneOf: O,
      oneOfType: I,
      shape: B,
      exact: L
    };
    function h(G, V) {
      return G === V ? G !== 0 || 1 / G === 1 / V : G !== G && V !== V;
    }
    function g(G, V) {
      this.message = G, this.data = V && typeof V == "object" ? V : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function y(G) {
      if (process.env.NODE_ENV !== "production")
        var V = {}, K = 0;
      function Z(ae, ue, re, oe, fe, le, se) {
        if (oe = oe || f, le = le || re, se !== r) {
          if (l) {
            var Q = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Q.name = "Invariant Violation", Q;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var he = oe + ":" + re;
            !V[he] && // Avoid spamming the console because they are often not actionable except for lib authors
            K < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + le + "` prop on `" + oe + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), V[he] = !0, K++);
          }
        }
        return ue[re] == null ? ae ? ue[re] === null ? new g("The " + fe + " `" + le + "` is marked as required " + ("in `" + oe + "`, but its value is `null`.")) : new g("The " + fe + " `" + le + "` is marked as required in " + ("`" + oe + "`, but its value is `undefined`.")) : null : G(ue, re, oe, fe, le);
      }
      var ee = Z.bind(null, !1);
      return ee.isRequired = Z.bind(null, !0), ee;
    }
    function S(G) {
      function V(K, Z, ee, ae, ue, re) {
        var oe = K[Z], fe = F(oe);
        if (fe !== G) {
          var le = j(oe);
          return new g(
            "Invalid " + ae + " `" + ue + "` of type " + ("`" + le + "` supplied to `" + ee + "`, expected ") + ("`" + G + "`."),
            { expectedType: G }
          );
        }
        return null;
      }
      return y(V);
    }
    function x() {
      return y(o);
    }
    function b(G) {
      function V(K, Z, ee, ae, ue) {
        if (typeof G != "function")
          return new g("Property `" + ue + "` of component `" + ee + "` has invalid PropType notation inside arrayOf.");
        var re = K[Z];
        if (!Array.isArray(re)) {
          var oe = F(re);
          return new g("Invalid " + ae + " `" + ue + "` of type " + ("`" + oe + "` supplied to `" + ee + "`, expected an array."));
        }
        for (var fe = 0; fe < re.length; fe++) {
          var le = G(re, fe, ee, ae, ue + "[" + fe + "]", r);
          if (le instanceof Error)
            return le;
        }
        return null;
      }
      return y(V);
    }
    function _() {
      function G(V, K, Z, ee, ae) {
        var ue = V[K];
        if (!s(ue)) {
          var re = F(ue);
          return new g("Invalid " + ee + " `" + ae + "` of type " + ("`" + re + "` supplied to `" + Z + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(G);
    }
    function $() {
      function G(V, K, Z, ee, ae) {
        var ue = V[K];
        if (!e.isValidElementType(ue)) {
          var re = F(ue);
          return new g("Invalid " + ee + " `" + ae + "` of type " + ("`" + re + "` supplied to `" + Z + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(G);
    }
    function w(G) {
      function V(K, Z, ee, ae, ue) {
        if (!(K[Z] instanceof G)) {
          var re = G.name || f, oe = U(K[Z]);
          return new g("Invalid " + ae + " `" + ue + "` of type " + ("`" + oe + "` supplied to `" + ee + "`, expected ") + ("instance of `" + re + "`."));
        }
        return null;
      }
      return y(V);
    }
    function O(G) {
      if (!Array.isArray(G))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function V(K, Z, ee, ae, ue) {
        for (var re = K[Z], oe = 0; oe < G.length; oe++)
          if (h(re, G[oe]))
            return null;
        var fe = JSON.stringify(G, function(se, Q) {
          var he = j(Q);
          return he === "symbol" ? String(Q) : Q;
        });
        return new g("Invalid " + ae + " `" + ue + "` of value `" + String(re) + "` " + ("supplied to `" + ee + "`, expected one of " + fe + "."));
      }
      return y(V);
    }
    function T(G) {
      function V(K, Z, ee, ae, ue) {
        if (typeof G != "function")
          return new g("Property `" + ue + "` of component `" + ee + "` has invalid PropType notation inside objectOf.");
        var re = K[Z], oe = F(re);
        if (oe !== "object")
          return new g("Invalid " + ae + " `" + ue + "` of type " + ("`" + oe + "` supplied to `" + ee + "`, expected an object."));
        for (var fe in re)
          if (n(re, fe)) {
            var le = G(re, fe, ee, ae, ue + "." + fe, r);
            if (le instanceof Error)
              return le;
          }
        return null;
      }
      return y(V);
    }
    function I(G) {
      if (!Array.isArray(G))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var V = 0; V < G.length; V++) {
        var K = G[V];
        if (typeof K != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + H(K) + " at index " + V + "."
          ), o;
      }
      function Z(ee, ae, ue, re, oe) {
        for (var fe = [], le = 0; le < G.length; le++) {
          var se = G[le], Q = se(ee, ae, ue, re, oe, r);
          if (Q == null)
            return null;
          Q.data && n(Q.data, "expectedType") && fe.push(Q.data.expectedType);
        }
        var he = fe.length > 0 ? ", expected one of type [" + fe.join(", ") + "]" : "";
        return new g("Invalid " + re + " `" + oe + "` supplied to " + ("`" + ue + "`" + he + "."));
      }
      return y(Z);
    }
    function P() {
      function G(V, K, Z, ee, ae) {
        return N(V[K]) ? null : new g("Invalid " + ee + " `" + ae + "` supplied to " + ("`" + Z + "`, expected a ReactNode."));
      }
      return y(G);
    }
    function D(G, V, K, Z, ee) {
      return new g(
        (G || "React class") + ": " + V + " type `" + K + "." + Z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ee + "`."
      );
    }
    function B(G) {
      function V(K, Z, ee, ae, ue) {
        var re = K[Z], oe = F(re);
        if (oe !== "object")
          return new g("Invalid " + ae + " `" + ue + "` of type `" + oe + "` " + ("supplied to `" + ee + "`, expected `object`."));
        for (var fe in G) {
          var le = G[fe];
          if (typeof le != "function")
            return D(ee, ae, ue, fe, j(le));
          var se = le(re, fe, ee, ae, ue + "." + fe, r);
          if (se)
            return se;
        }
        return null;
      }
      return y(V);
    }
    function L(G) {
      function V(K, Z, ee, ae, ue) {
        var re = K[Z], oe = F(re);
        if (oe !== "object")
          return new g("Invalid " + ae + " `" + ue + "` of type `" + oe + "` " + ("supplied to `" + ee + "`, expected `object`."));
        var fe = t({}, K[Z], G);
        for (var le in fe) {
          var se = G[le];
          if (n(G, le) && typeof se != "function")
            return D(ee, ae, ue, le, j(se));
          if (!se)
            return new g(
              "Invalid " + ae + " `" + ue + "` key `" + le + "` supplied to `" + ee + "`.\nBad object: " + JSON.stringify(K[Z], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(G), null, "  ")
            );
          var Q = se(re, le, ee, ae, ue + "." + le, r);
          if (Q)
            return Q;
        }
        return null;
      }
      return y(V);
    }
    function N(G) {
      switch (typeof G) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !G;
        case "object":
          if (Array.isArray(G))
            return G.every(N);
          if (G === null || s(G))
            return !0;
          var V = d(G);
          if (V) {
            var K = V.call(G), Z;
            if (V !== G.entries) {
              for (; !(Z = K.next()).done; )
                if (!N(Z.value))
                  return !1;
            } else
              for (; !(Z = K.next()).done; ) {
                var ee = Z.value;
                if (ee && !N(ee[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function z(G, V) {
      return G === "symbol" ? !0 : V ? V["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && V instanceof Symbol : !1;
    }
    function F(G) {
      var V = typeof G;
      return Array.isArray(G) ? "array" : G instanceof RegExp ? "object" : z(V, G) ? "symbol" : V;
    }
    function j(G) {
      if (typeof G > "u" || G === null)
        return "" + G;
      var V = F(G);
      if (V === "object") {
        if (G instanceof Date)
          return "date";
        if (G instanceof RegExp)
          return "regexp";
      }
      return V;
    }
    function H(G) {
      var V = j(G);
      switch (V) {
        case "array":
        case "object":
          return "an " + V;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + V;
        default:
          return V;
      }
    }
    function U(G) {
      return !G.constructor || !G.constructor.name ? f : G.constructor.name;
    }
    return m.checkPropTypes = a, m.resetWarningCache = a.resetWarningCache, m.PropTypes = m, m;
  }, qx;
}
var Kx, v6;
function nIe() {
  if (v6) return Kx;
  v6 = 1;
  var e = dM();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Kx = function() {
    function n(o, s, l, c, u, d) {
      if (d !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    n.isRequired = n;
    function a() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: a,
      element: n,
      elementType: n,
      instanceOf: a,
      node: n,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Kx;
}
if (process.env.NODE_ENV !== "production") {
  var aIe = sq(), iIe = !0;
  TE.exports = rIe()(aIe.isElement, iIe);
} else
  TE.exports = nIe()();
var oIe = TE.exports;
const Fr = /* @__PURE__ */ Ut(oIe);
var sIe = ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl", "isolated"];
function IE() {
  return IE = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, IE.apply(this, arguments);
}
function lIe(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function hy(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function cIe(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, ME(e, t);
}
function ME(e, t) {
  return ME = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, ME(e, t);
}
var aC = /* @__PURE__ */ function(e) {
  cIe(t, e);
  function t() {
    var n;
    return n = e.call(this) || this, n.handleExpired = n.handleExpired.bind(hy(n)), n.handleErrored = n.handleErrored.bind(hy(n)), n.handleChange = n.handleChange.bind(hy(n)), n.handleRecaptchaRef = n.handleRecaptchaRef.bind(hy(n)), n;
  }
  var r = t.prototype;
  return r.getCaptchaFunction = function(a) {
    return this.props.grecaptcha ? this.props.grecaptcha.enterprise ? this.props.grecaptcha.enterprise[a] : this.props.grecaptcha[a] : null;
  }, r.getValue = function() {
    var a = this.getCaptchaFunction("getResponse");
    return a && this._widgetId !== void 0 ? a(this._widgetId) : null;
  }, r.getWidgetId = function() {
    return this.props.grecaptcha && this._widgetId !== void 0 ? this._widgetId : null;
  }, r.execute = function() {
    var a = this.getCaptchaFunction("execute");
    if (a && this._widgetId !== void 0)
      return a(this._widgetId);
    this._executeRequested = !0;
  }, r.executeAsync = function() {
    var a = this;
    return new Promise(function(i, o) {
      a.executionResolve = i, a.executionReject = o, a.execute();
    });
  }, r.reset = function() {
    var a = this.getCaptchaFunction("reset");
    a && this._widgetId !== void 0 && a(this._widgetId);
  }, r.forceReset = function() {
    var a = this.getCaptchaFunction("reset");
    a && a();
  }, r.handleExpired = function() {
    this.props.onExpired ? this.props.onExpired() : this.handleChange(null);
  }, r.handleErrored = function() {
    this.props.onErrored && this.props.onErrored(), this.executionReject && (this.executionReject(), delete this.executionResolve, delete this.executionReject);
  }, r.handleChange = function(a) {
    this.props.onChange && this.props.onChange(a), this.executionResolve && (this.executionResolve(a), delete this.executionReject, delete this.executionResolve);
  }, r.explicitRender = function() {
    var a = this.getCaptchaFunction("render");
    if (a && this._widgetId === void 0) {
      var i = document.createElement("div");
      this._widgetId = a(i, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge,
        isolated: this.props.isolated
      }), this.captcha.appendChild(i);
    }
    this._executeRequested && this.props.grecaptcha && this._widgetId !== void 0 && (this._executeRequested = !1, this.execute());
  }, r.componentDidMount = function() {
    this.explicitRender();
  }, r.componentDidUpdate = function() {
    this.explicitRender();
  }, r.handleRecaptchaRef = function(a) {
    this.captcha = a;
  }, r.render = function() {
    var a = this.props;
    a.sitekey, a.onChange, a.theme, a.type, a.tabindex, a.onExpired, a.onErrored, a.size, a.stoken, a.grecaptcha, a.badge, a.hl, a.isolated;
    var i = lIe(a, sIe);
    return /* @__PURE__ */ p.createElement("div", IE({}, i, {
      ref: this.handleRecaptchaRef
    }));
  }, t;
}(p.Component);
aC.displayName = "ReCAPTCHA";
aC.propTypes = {
  sitekey: Fr.string.isRequired,
  onChange: Fr.func,
  grecaptcha: Fr.object,
  theme: Fr.oneOf(["dark", "light"]),
  type: Fr.oneOf(["image", "audio"]),
  tabindex: Fr.number,
  onExpired: Fr.func,
  onErrored: Fr.func,
  size: Fr.oneOf(["compact", "normal", "invisible"]),
  stoken: Fr.string,
  hl: Fr.string,
  badge: Fr.oneOf(["bottomright", "bottomleft", "inline"]),
  isolated: Fr.bool
};
aC.defaultProps = {
  onChange: function() {
  },
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
var AE = { exports: {} }, un = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h6;
function uIe() {
  if (h6) return un;
  h6 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
  function b($) {
    if (typeof $ == "object" && $ !== null) {
      var w = $.$$typeof;
      switch (w) {
        case t:
          switch ($ = $.type, $) {
            case l:
            case c:
            case n:
            case i:
            case a:
            case d:
              return $;
            default:
              switch ($ = $ && $.$$typeof, $) {
                case s:
                case u:
                case h:
                case m:
                case o:
                  return $;
                default:
                  return w;
              }
          }
        case r:
          return w;
      }
    }
  }
  function _($) {
    return b($) === c;
  }
  return un.AsyncMode = l, un.ConcurrentMode = c, un.ContextConsumer = s, un.ContextProvider = o, un.Element = t, un.ForwardRef = u, un.Fragment = n, un.Lazy = h, un.Memo = m, un.Portal = r, un.Profiler = i, un.StrictMode = a, un.Suspense = d, un.isAsyncMode = function($) {
    return _($) || b($) === l;
  }, un.isConcurrentMode = _, un.isContextConsumer = function($) {
    return b($) === s;
  }, un.isContextProvider = function($) {
    return b($) === o;
  }, un.isElement = function($) {
    return typeof $ == "object" && $ !== null && $.$$typeof === t;
  }, un.isForwardRef = function($) {
    return b($) === u;
  }, un.isFragment = function($) {
    return b($) === n;
  }, un.isLazy = function($) {
    return b($) === h;
  }, un.isMemo = function($) {
    return b($) === m;
  }, un.isPortal = function($) {
    return b($) === r;
  }, un.isProfiler = function($) {
    return b($) === i;
  }, un.isStrictMode = function($) {
    return b($) === a;
  }, un.isSuspense = function($) {
    return b($) === d;
  }, un.isValidElementType = function($) {
    return typeof $ == "string" || typeof $ == "function" || $ === n || $ === c || $ === i || $ === a || $ === d || $ === f || typeof $ == "object" && $ !== null && ($.$$typeof === h || $.$$typeof === m || $.$$typeof === o || $.$$typeof === s || $.$$typeof === u || $.$$typeof === y || $.$$typeof === S || $.$$typeof === x || $.$$typeof === g);
  }, un.typeOf = b, un;
}
var dn = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var g6;
function dIe() {
  return g6 || (g6 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
    function b(Q) {
      return typeof Q == "string" || typeof Q == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Q === n || Q === c || Q === i || Q === a || Q === d || Q === f || typeof Q == "object" && Q !== null && (Q.$$typeof === h || Q.$$typeof === m || Q.$$typeof === o || Q.$$typeof === s || Q.$$typeof === u || Q.$$typeof === y || Q.$$typeof === S || Q.$$typeof === x || Q.$$typeof === g);
    }
    function _(Q) {
      if (typeof Q == "object" && Q !== null) {
        var he = Q.$$typeof;
        switch (he) {
          case t:
            var ne = Q.type;
            switch (ne) {
              case l:
              case c:
              case n:
              case i:
              case a:
              case d:
                return ne;
              default:
                var me = ne && ne.$$typeof;
                switch (me) {
                  case s:
                  case u:
                  case h:
                  case m:
                  case o:
                    return me;
                  default:
                    return he;
                }
            }
          case r:
            return he;
        }
      }
    }
    var $ = l, w = c, O = s, T = o, I = t, P = u, D = n, B = h, L = m, N = r, z = i, F = a, j = d, H = !1;
    function U(Q) {
      return H || (H = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), G(Q) || _(Q) === l;
    }
    function G(Q) {
      return _(Q) === c;
    }
    function V(Q) {
      return _(Q) === s;
    }
    function K(Q) {
      return _(Q) === o;
    }
    function Z(Q) {
      return typeof Q == "object" && Q !== null && Q.$$typeof === t;
    }
    function ee(Q) {
      return _(Q) === u;
    }
    function ae(Q) {
      return _(Q) === n;
    }
    function ue(Q) {
      return _(Q) === h;
    }
    function re(Q) {
      return _(Q) === m;
    }
    function oe(Q) {
      return _(Q) === r;
    }
    function fe(Q) {
      return _(Q) === i;
    }
    function le(Q) {
      return _(Q) === a;
    }
    function se(Q) {
      return _(Q) === d;
    }
    dn.AsyncMode = $, dn.ConcurrentMode = w, dn.ContextConsumer = O, dn.ContextProvider = T, dn.Element = I, dn.ForwardRef = P, dn.Fragment = D, dn.Lazy = B, dn.Memo = L, dn.Portal = N, dn.Profiler = z, dn.StrictMode = F, dn.Suspense = j, dn.isAsyncMode = U, dn.isConcurrentMode = G, dn.isContextConsumer = V, dn.isContextProvider = K, dn.isElement = Z, dn.isForwardRef = ee, dn.isFragment = ae, dn.isLazy = ue, dn.isMemo = re, dn.isPortal = oe, dn.isProfiler = fe, dn.isStrictMode = le, dn.isSuspense = se, dn.isValidElementType = b, dn.typeOf = _;
  }()), dn;
}
process.env.NODE_ENV === "production" ? AE.exports = uIe() : AE.exports = dIe();
var fIe = AE.exports, fM = fIe, pIe = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, mIe = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, vIe = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, cq = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, pM = {};
pM[fM.ForwardRef] = vIe;
pM[fM.Memo] = cq;
function y6(e) {
  return fM.isMemo(e) ? cq : pM[e.$$typeof] || pIe;
}
var hIe = Object.defineProperty, gIe = Object.getOwnPropertyNames, b6 = Object.getOwnPropertySymbols, yIe = Object.getOwnPropertyDescriptor, bIe = Object.getPrototypeOf, C6 = Object.prototype;
function uq(e, t, r) {
  if (typeof t != "string") {
    if (C6) {
      var n = bIe(t);
      n && n !== C6 && uq(e, n, r);
    }
    var a = gIe(t);
    b6 && (a = a.concat(b6(t)));
    for (var i = y6(e), o = y6(t), s = 0; s < a.length; ++s) {
      var l = a[s];
      if (!mIe[l] && !(r && r[l]) && !(o && o[l]) && !(i && i[l])) {
        var c = yIe(t, l);
        try {
          hIe(e, l, c);
        } catch {
        }
      }
    }
  }
  return e;
}
var CIe = uq;
const SIe = /* @__PURE__ */ Ut(CIe);
function PE() {
  return PE = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, PE.apply(this, arguments);
}
function xIe(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function $Ie(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
var yo = {}, _Ie = 0;
function EIe(e, t) {
  return t = t || {}, function(n) {
    var a = n.displayName || n.name || "Component", i = /* @__PURE__ */ function(s) {
      $Ie(l, s);
      function l(u, d) {
        var f;
        return f = s.call(this, u, d) || this, f.state = {}, f.__scriptURL = "", f;
      }
      var c = l.prototype;
      return c.asyncScriptLoaderGetScriptLoaderID = function() {
        return this.__scriptLoaderID || (this.__scriptLoaderID = "async-script-loader-" + _Ie++), this.__scriptLoaderID;
      }, c.setupScriptURL = function() {
        return this.__scriptURL = typeof e == "function" ? e() : e, this.__scriptURL;
      }, c.asyncScriptLoaderHandleLoad = function(d) {
        var f = this;
        this.setState(d, function() {
          return f.props.asyncScriptOnLoad && f.props.asyncScriptOnLoad(f.state);
        });
      }, c.asyncScriptLoaderTriggerOnScriptLoaded = function() {
        var d = yo[this.__scriptURL];
        if (!d || !d.loaded)
          throw new Error("Script is not loaded.");
        for (var f in d.observers)
          d.observers[f](d);
        delete window[t.callbackName];
      }, c.componentDidMount = function() {
        var d = this, f = this.setupScriptURL(), m = this.asyncScriptLoaderGetScriptLoaderID(), h = t, g = h.globalName, y = h.callbackName, S = h.scriptId;
        if (g && typeof window[g] < "u" && (yo[f] = {
          loaded: !0,
          observers: {}
        }), yo[f]) {
          var x = yo[f];
          if (x && (x.loaded || x.errored)) {
            this.asyncScriptLoaderHandleLoad(x);
            return;
          }
          x.observers[m] = function(O) {
            return d.asyncScriptLoaderHandleLoad(O);
          };
          return;
        }
        var b = {};
        b[m] = function(O) {
          return d.asyncScriptLoaderHandleLoad(O);
        }, yo[f] = {
          loaded: !1,
          observers: b
        };
        var _ = document.createElement("script");
        _.src = f, _.async = !0;
        for (var $ in t.attributes)
          _.setAttribute($, t.attributes[$]);
        S && (_.id = S);
        var w = function(T) {
          if (yo[f]) {
            var I = yo[f], P = I.observers;
            for (var D in P)
              T(P[D]) && delete P[D];
          }
        };
        y && typeof window < "u" && (window[y] = function() {
          return d.asyncScriptLoaderTriggerOnScriptLoaded();
        }), _.onload = function() {
          var O = yo[f];
          O && (O.loaded = !0, w(function(T) {
            return y ? !1 : (T(O), !0);
          }));
        }, _.onerror = function() {
          var O = yo[f];
          O && (O.errored = !0, w(function(T) {
            return T(O), !0;
          }));
        }, document.body.appendChild(_);
      }, c.componentWillUnmount = function() {
        var d = this.__scriptURL;
        if (t.removeOnUnmount === !0)
          for (var f = document.getElementsByTagName("script"), m = 0; m < f.length; m += 1)
            f[m].src.indexOf(d) > -1 && f[m].parentNode && f[m].parentNode.removeChild(f[m]);
        var h = yo[d];
        h && (delete h.observers[this.asyncScriptLoaderGetScriptLoaderID()], t.removeOnUnmount === !0 && delete yo[d]);
      }, c.render = function() {
        var d = t.globalName, f = this.props;
        f.asyncScriptOnLoad;
        var m = f.forwardedRef, h = xIe(f, ["asyncScriptOnLoad", "forwardedRef"]);
        return d && typeof window < "u" && (h[d] = typeof window[d] < "u" ? window[d] : void 0), h.ref = m, _3(n, h);
      }, l;
    }(Ile), o = Aa(function(s, l) {
      return _3(i, PE({}, s, {
        forwardedRef: l
      }));
    });
    return o.displayName = "AsyncScriptLoader(" + a + ")", o.propTypes = {
      asyncScriptOnLoad: Fr.func
    }, SIe(o, n);
  };
}
var RE = "onloadcallback", wIe = "grecaptcha";
function NE() {
  return typeof window < "u" && window.recaptchaOptions || {};
}
function OIe() {
  var e = NE(), t = e.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return e.enterprise ? "https://" + t + "/recaptcha/enterprise.js?onload=" + RE + "&render=explicit" : "https://" + t + "/recaptcha/api.js?onload=" + RE + "&render=explicit";
}
const TIe = EIe(OIe, {
  callbackName: RE,
  globalName: wIe,
  attributes: NE().nonce ? {
    nonce: NE().nonce
  } : {}
})(aC), iC = Aa(({ captchaEnabled: e, captchaSiteKey: t }, r) => {
  const n = ct(null);
  return fo(r, () => ({
    async getCaptchaValue() {
      if (ni.get(LTe)) return "";
      const i = await n.current?.executeAsync();
      return n?.current?.reset(), i;
    }
  })), e ? /* @__PURE__ */ E.jsx(Oe, { span: 24, ref: r, children: /* @__PURE__ */ E.jsx(
    TIe,
    {
      ref: n,
      sitekey: t,
      size: "invisible",
      hidden: !0
    }
  ) }) : /* @__PURE__ */ E.jsx("div", { ref: r });
});
iC.displayName = "ReCaptcha";
const Yx = {
  Initial: "initial",
  Success: "success"
}, JZe = ({
  userHook: e,
  resetPasswordError: t,
  theme: r = "default",
  captchaKey: n,
  captchaEnabled: a
}) => {
  const [i] = Dt.useForm(), [o, s] = He(t ?? null), [l, c] = He(), [u, d] = He(!1), [f, m] = He(Yx.Initial), [h, g] = He(""), [y, S] = He(!1), x = ct("captcha"), [b, _] = He(!1), { notification: $ } = YT.useApp(), { forgotPassword: w } = e, O = () => {
    if (o)
      return /* @__PURE__ */ E.jsx(Oe, { className: "forgot-password-error", children: /* @__PURE__ */ E.jsx(uM, { children: o }) });
  }, T = () => l ? /* @__PURE__ */ E.jsxs(lr, { direction: "vertical", size: 32, align: "center", className: "h-full", children: [
    /* @__PURE__ */ E.jsx(qW, { size: 64, className: "forgot-password-success-icon" }),
    /* @__PURE__ */ E.jsx("h1", { className: "forgot-password-title", children: "Reset Password Email Sent!" })
  ] }) : /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
    O(),
    /* @__PURE__ */ E.jsx(lr, { direction: "vertical", align: "center", className: "h-full", children: /* @__PURE__ */ E.jsx("h1", { className: "forgot-password-title", children: "Forgot Password" }) })
  ] }), I = async (L) => {
    s(null), c(!1), g(L.email.trim());
    const N = await x?.current?.getCaptchaValue() ?? "";
    return d(!0), w({ ...L, email: L.email.trim(), captcha: N }).then(() => (c(!0), m(Yx.Success))).catch((z) => {
      if (z?.response?.status === 404) return s("We are sorry, but we could not find that email address in our system.");
      s(z?.response?.data?.message ?? "We are sorry, but we could not find that email address in our system.");
    }).finally(() => d(!1));
  }, P = async () => {
    if (b) return;
    const L = await x?.current?.getCaptchaValue() ?? null;
    return d(!0), _(!0), setTimeout(() => {
      _(!1);
    }, 5e3), w({ email: h, captcha: L }).then(() => (c(!0), $.success({
      message: "Reset Password Email Resent!",
      description: "We have resent the directions how to reset your password in your email address.",
      placement: "topRight",
      duration: 10
    }))).catch((N) => {
      s(N);
    }).finally(() => {
      d(!1);
    });
  }, D = (L, N) => {
    const { value: z } = L.target, F = z.trim();
    i.setFieldsValue({ [N]: F });
  }, B = () => f === Yx.Success ? /* @__PURE__ */ E.jsxs(At, { gutter: [0, 16], children: [
    /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(wE, { className: "text-sm text-center text-gray-500 font-normal", children: "Please check your email address, you have received the directions how to reset your password." }) }),
    /* @__PURE__ */ E.jsxs(Oe, { span: 24, className: "pt-2", children: [
      /* @__PURE__ */ E.jsx("p", { className: "ttg-forgot-password-receive-text", children: "Didn’t receive the email yet? " }),
      /* @__PURE__ */ E.jsx(
        Nt,
        {
          type: "primary",
          className: "w-full",
          onClick: () => P(),
          loading: u,
          children: "Resend Email"
        }
      )
    ] })
  ] }) : /* @__PURE__ */ E.jsx(
    Dt,
    {
      form: i,
      onFinish: I,
      onFinishFailed: () => S(!0),
      validateTrigger: y ? "onChange" : "onSubmit",
      children: /* @__PURE__ */ E.jsxs(At, { gutter: [0, 16], children: [
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(wE, { className: "text-sm text-center text-gray-500 font-normal", children: "Enter the email address associated with your account in the field provided below to request a password reset." }) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
          Dt.Item,
          {
            name: "email",
            label: "Email Address",
            labelCol: { span: 24 },
            rules: [
              {
                required: !0,
                message: "is required"
              },
              {
                pattern: nC,
                message: "Please enter a valid email address."
              }
            ],
            children: /* @__PURE__ */ E.jsx(Lr, { onBlur: (L) => D(L, "email") })
          }
        ) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "pt-2", children: /* @__PURE__ */ E.jsx(
          Nt,
          {
            htmlType: "submit",
            type: "primary",
            className: "w-full",
            loading: u,
            children: `${o ? "Try Again" : "Send Email"}`
          }
        ) })
      ] })
    }
  );
  return /* @__PURE__ */ E.jsxs(
    zn,
    {
      type: "inner",
      size: "default",
      bordered: !1,
      className: `ttg-forgot-password ttg-forgot-password--skin--${r}`,
      children: [
        /* @__PURE__ */ E.jsx(lr, { direction: "vertical", align: "center", size: 32, className: "h-full w-full pb-8", children: T() }),
        B(),
        /* @__PURE__ */ E.jsx(iC, { ref: x, captchaEnabled: a, captchaSiteKey: n })
      ]
    }
  );
};
var Zb = function() {
  return Zb = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Zb.apply(this, arguments);
}, IIe = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}, S6 = function(e) {
  var t = 0;
  if (e.length === 0)
    return !1;
  for (; t < e.length; ) {
    var r = e.charAt(t);
    if (r != r.toLowerCase()) {
      if (r == r.toUpperCase())
        return !0;
    }
    t++;
  }
  return !1;
}, x6 = function(e) {
  var t = 0;
  if (e.length === 0)
    return !1;
  for (; t < e.length; ) {
    var r = e.charAt(t);
    if (r != r.toUpperCase()) {
      if (r == r.toLowerCase())
        return !0;
    }
    t++;
  }
  return !1;
}, MIe = function(e) {
  var t = e.className, r = e.style, n = e.rules, a = e.value, i = e.valueAgain, o = e.minLength, s = e.maxLength, l = e.rtl, c = e.onChange, u = e.specialCharsRegex, d = u === void 0 ? /[~`¿¡!#$%\^&*€£@+÷=\-\[\]\\';,/{}\(\)|\\":<>\?\.\_]/g : u, f = e.messages, m = f === void 0 ? {} : f, h = IIe(e, ["className", "style", "rules", "value", "valueAgain", "minLength", "maxLength", "rtl", "onChange", "specialCharsRegex", "messages"]), g = {
    minLength: {
      valid: a.length >= (o || 100),
      message: m.minLength || "Password has at least ".concat(o, " characters.")
    },
    specialChar: {
      valid: d.test(a),
      message: m.specialChar || "Password has special characters."
    },
    number: {
      valid: /\d/g.test(a),
      message: m.number || "Password has a number."
    },
    match: {
      valid: a.length > 0 && a === i,
      message: m.match || "Passwords match."
    },
    capital: {
      valid: S6(a),
      message: m.capital || "Password has a capital letter."
    },
    lowercase: {
      valid: x6(a),
      message: m.lowercase || "Password has a lowercase letter."
    },
    capitalAndLowercase: {
      valid: S6(a) && x6(a),
      message: m.capitalAndLowercase || "Password contains at least one uppercase and lowercase characters."
    },
    letter: {
      valid: /[a-zA-Z]/g.test(a),
      message: m.letter || "Password has a letter."
    },
    maxLength: {
      valid: a.length <= (s || 16),
      message: m.maxLength || "Password has no more than ".concat(s, " characters.")
    },
    notEmpty: {
      valid: !!(a.length > 0 && i && i.length > 0),
      message: m.notEmpty || "Password fields are not empty."
    },
    noSpaces: {
      valid: a.length > 0 && !/\s/.test(a),
      message: m.noSpaces || "Password contains no spaces."
    }
  }, y = dr(function() {
    return n.filter(function(b) {
      return !!g[b];
    });
  }, [n]), S = y.every(function(b) {
    return g[b].valid;
  }), x = dr(function() {
    return y.filter(function(b) {
      return !g[b].valid;
    });
  }, [a, i, y]);
  return St(function() {
    typeof c == "function" && c(S, x);
  }, [S, x]), l && (t = t ? t + " rtl" : "rtl"), xe.createElement("ul", { className: t, style: Zb({ margin: 0, padding: 0 }, r) }, y.map(function(b) {
    var _ = g[b], $ = _.message, w = _.valid;
    return xe.createElement(AIe, Zb({ key: b, valid: w, iconSize: 18, validColor: "#4BCA81", invalidColor: "#FF0033", rtl: l }, h), $);
  }));
}, AIe = function(e) {
  var t = e.valid, r = e.iconSize, n = e.validColor, a = e.invalidColor, i = e.validTextColor, o = e.invalidTextColor, s = e.iconComponents, l = e.hideIcon, c = e.rtl, u = e.children, d = e.itemClassName;
  return xe.createElement(
    "li",
    { className: "".concat(d, " ").concat(t ? "valid" : "invalid"), style: {
      listStyleType: "none",
      display: "flex",
      alignItems: "center",
      margin: "2px 0"
    } },
    l ? null : s ? t ? s.ValidIcon : s.InvalidIcon : xe.createElement(
      "svg",
      { className: "checklist-icon", version: "1.1", xmlns: "http://www.w3.org/2000/svg", width: r, height: r, viewBox: "0 0 512 512", style: { marginRight: c ? 0 : 5, marginLeft: c ? 5 : 0 } },
      xe.createElement("path", { fill: t ? n : a, d: t ? "M432 64l-240 240-112-112-80 80 192 192 320-320z" : "M507.331 411.33c-0.002-0.002-0.004-0.004-0.006-0.005l-155.322-155.325 155.322-155.325c0.002-0.002 0.004-0.003 0.006-0.005 1.672-1.673 2.881-3.627 3.656-5.708 2.123-5.688 0.912-12.341-3.662-16.915l-73.373-73.373c-4.574-4.573-11.225-5.783-16.914-3.66-2.080 0.775-4.035 1.984-5.709 3.655 0 0.002-0.002 0.003-0.004 0.005l-155.324 155.326-155.324-155.325c-0.002-0.002-0.003-0.003-0.005-0.005-1.673-1.671-3.627-2.88-5.707-3.655-5.69-2.124-12.341-0.913-16.915 3.66l-73.374 73.374c-4.574 4.574-5.784 11.226-3.661 16.914 0.776 2.080 1.985 4.036 3.656 5.708 0.002 0.001 0.003 0.003 0.005 0.005l155.325 155.324-155.325 155.326c-0.001 0.002-0.003 0.003-0.004 0.005-1.671 1.673-2.88 3.627-3.657 5.707-2.124 5.688-0.913 12.341 3.661 16.915l73.374 73.373c4.575 4.574 11.226 5.784 16.915 3.661 2.080-0.776 4.035-1.985 5.708-3.656 0.001-0.002 0.003-0.003 0.005-0.005l155.324-155.325 155.324 155.325c0.002 0.001 0.004 0.003 0.006 0.004 1.674 1.672 3.627 2.881 5.707 3.657 5.689 2.123 12.342 0.913 16.914-3.661l73.373-73.374c4.574-4.574 5.785-11.227 3.662-16.915-0.776-2.080-1.985-4.034-3.657-5.707z" })
    ),
    xe.createElement("span", { style: {
      paddingTop: 2,
      opacity: t ? 1 : o ? void 0 : 0.5,
      flex: 1,
      color: t ? i : o
    } }, u)
  );
};
const dq = ({ showRestrictions: e, value: t, handleValidationChange: r }) => /* @__PURE__ */ E.jsxs("div", { className: `ttg-password-requirements ${e ? "" : "hidden"}`, children: [
  /* @__PURE__ */ E.jsx("h1", { className: "ttg-requirements-title", children: "Password requirements" }),
  /* @__PURE__ */ E.jsx(
    MIe,
    {
      rules: ["minLength", "capital", "lowercase", "number"],
      minLength: 8,
      value: t,
      iconComponents: {
        ValidIcon: /* @__PURE__ */ E.jsx(KW, { color: "#10B981" }),
        InvalidIcon: /* @__PURE__ */ E.jsx(STe, { color: "#F59E0B" })
      },
      messages: {
        minLength: "Must have at least 8 characters",
        capital: "Must have at least 1 uppercase letter",
        lowercase: "Must have at least 1 lowercase letter",
        number: "Must have at least 1 number"
      },
      className: "ttg-password-checklist",
      onChange: r
    }
  )
] }), QZe = ({
  userHook: e,
  token: t,
  onResetFinish: r,
  setResetError: n,
  theme: a = "default"
}) => {
  const [i] = Dt.useForm(), [o, s] = He(!1), [l, c] = He(!1), [u, d] = He(""), [f, m] = xe.useState(!1), { resetPassword: h } = e, g = (S, x) => {
    m(!S);
  }, y = async (S) => (s(!0), h({ ...S, token: t }).then((x) => x ? r(x.user, () => s(!1)) : s(!1)).catch((x) => n(x.message)).finally(() => s(!1)));
  return /* @__PURE__ */ E.jsxs(
    zn,
    {
      type: "inner",
      size: "default",
      bordered: !1,
      className: `ttg-forgot-password ttg-forgot-password--skin--${a}`,
      children: [
        /* @__PURE__ */ E.jsx(
          lr,
          {
            direction: "vertical",
            align: "center",
            size: 32,
            className: "h-full w-full pb-8",
            children: /* @__PURE__ */ E.jsx(lr, { direction: "vertical", align: "center", className: "h-full", children: /* @__PURE__ */ E.jsx("h1", { className: "forgot-password-title", children: "Reset Password" }) })
          }
        ),
        /* @__PURE__ */ E.jsx(
          Dt,
          {
            form: i,
            onFinish: y,
            onFinishFailed: () => c(!0),
            validateTrigger: l ? "onChange" : "onSubmit",
            children: /* @__PURE__ */ E.jsxs(At, { gutter: [0, 18], children: [
              /* @__PURE__ */ E.jsx(
                Oe,
                {
                  span: 24,
                  className: "text-sm text-center font-normal text-gray-600",
                  children: "Enter and confirm your new password in the fields provided below."
                }
              ),
              /* @__PURE__ */ E.jsxs(Oe, { span: 24, children: [
                /* @__PURE__ */ E.jsx(
                  Dt.Item,
                  {
                    name: "password",
                    label: "New Password",
                    labelCol: { span: 24 },
                    rules: [
                      { required: !0, message: "is required" },
                      {
                        pattern: eq,
                        message: "Your password doesn't meet the requirements."
                      }
                    ],
                    children: /* @__PURE__ */ E.jsx(
                      Lr.Password,
                      {
                        value: u,
                        onChange: (S) => {
                          d(S.target.value), i.setFieldValue("password", S.target.value);
                        }
                      }
                    )
                  }
                ),
                /* @__PURE__ */ E.jsx(dq, { showRestrictions: !!u && f, value: u, handleValidationChange: g })
              ] }),
              /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
                Dt.Item,
                {
                  name: "newPassword",
                  label: "Confirm new password",
                  labelCol: { span: 24 },
                  rules: [
                    { required: !0, message: "is required" },
                    ({ getFieldValue: S }) => ({
                      validator(x, b) {
                        return !b || S("password") === b ? Promise.resolve() : Promise.reject(new Error("Passwords do not match"));
                      }
                    })
                  ],
                  children: /* @__PURE__ */ E.jsx(Lr.Password, {})
                }
              ) }),
              /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "pt-2", children: /* @__PURE__ */ E.jsx(
                Nt,
                {
                  htmlType: "submit",
                  type: "primary",
                  className: "w-full",
                  loading: o,
                  children: "Reset Password"
                }
              ) })
            ] })
          }
        )
      ]
    }
  );
}, eXe = ({
  itemsPerPage: e,
  totalItems: t,
  currentPage: r,
  onChangePage: n,
  disabled: a
}) => /* @__PURE__ */ E.jsx(
  HI,
  {
    disabled: a,
    className: "mt-6 text-center",
    current: r,
    pageSize: e,
    total: t,
    onChange: n
  }
);
var Zx = {}, DE = function(e, t) {
  return DE = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
  }, DE(e, t);
};
function fq(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  DE(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var Xb = function() {
  return Xb = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, Xb.apply(this, arguments);
};
function pq(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
function mq(e, t, r, n) {
  var a = arguments.length, i = a < 3 ? t : n === null ? n = Object.getOwnPropertyDescriptor(t, r) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(e, t, r, n);
  else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (i = (a < 3 ? o(i) : a > 3 ? o(t, r, i) : o(t, r)) || i);
  return a > 3 && i && Object.defineProperty(t, r, i), i;
}
function vq(e, t) {
  return function(r, n) {
    t(r, n, e);
  };
}
function hq(e, t, r, n, a, i) {
  function o(S) {
    if (S !== void 0 && typeof S != "function") throw new TypeError("Function expected");
    return S;
  }
  for (var s = n.kind, l = s === "getter" ? "get" : s === "setter" ? "set" : "value", c = !t && e ? n.static ? e : e.prototype : null, u = t || (c ? Object.getOwnPropertyDescriptor(c, n.name) : {}), d, f = !1, m = r.length - 1; m >= 0; m--) {
    var h = {};
    for (var g in n) h[g] = g === "access" ? {} : n[g];
    for (var g in n.access) h.access[g] = n.access[g];
    h.addInitializer = function(S) {
      if (f) throw new TypeError("Cannot add initializers after decoration has completed");
      i.push(o(S || null));
    };
    var y = (0, r[m])(s === "accessor" ? { get: u.get, set: u.set } : u[l], h);
    if (s === "accessor") {
      if (y === void 0) continue;
      if (y === null || typeof y != "object") throw new TypeError("Object expected");
      (d = o(y.get)) && (u.get = d), (d = o(y.set)) && (u.set = d), (d = o(y.init)) && a.unshift(d);
    } else (d = o(y)) && (s === "field" ? a.unshift(d) : u[l] = d);
  }
  c && Object.defineProperty(c, n.name, u), f = !0;
}
function gq(e, t, r) {
  for (var n = arguments.length > 2, a = 0; a < t.length; a++)
    r = n ? t[a].call(e, r) : t[a].call(e);
  return n ? r : void 0;
}
function yq(e) {
  return typeof e == "symbol" ? e : "".concat(e);
}
function bq(e, t, r) {
  return typeof t == "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", { configurable: !0, value: r ? "".concat(r, " ", t) : t });
}
function Cq(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(e, t);
}
function Sq(e, t, r, n) {
  function a(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(u) {
      try {
        c(n.next(u));
      } catch (d) {
        o(d);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        o(d);
      }
    }
    function c(u) {
      u.done ? i(u.value) : a(u.value).then(s, l);
    }
    c((n = n.apply(e, t || [])).next());
  });
}
function xq(e, t) {
  var r = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = s(0), o.throw = s(1), o.return = s(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, c[0] && (r = 0)), r; ) try {
      if (n = 1, a && (i = c[0] & 2 ? a.return : c[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, c[1])).done) return i;
      switch (a = 0, i && (c = [c[0] & 2, i.value]), c[0]) {
        case 0:
        case 1:
          i = c;
          break;
        case 4:
          return r.label++, { value: c[1], done: !1 };
        case 5:
          r.label++, a = c[1], c = [0];
          continue;
        case 7:
          c = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (i = r.trys, !(i = i.length > 0 && i[i.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            r = 0;
            continue;
          }
          if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
            r.label = c[1];
            break;
          }
          if (c[0] === 6 && r.label < i[1]) {
            r.label = i[1], i = c;
            break;
          }
          if (i && r.label < i[2]) {
            r.label = i[2], r.ops.push(c);
            break;
          }
          i[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      c = t.call(e, r);
    } catch (u) {
      c = [6, u], a = 0;
    } finally {
      n = i = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
var oC = Object.create ? function(e, t, r, n) {
  n === void 0 && (n = r);
  var a = Object.getOwnPropertyDescriptor(t, r);
  (!a || ("get" in a ? !t.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, n, a);
} : function(e, t, r, n) {
  n === void 0 && (n = r), e[n] = t[r];
};
function $q(e, t) {
  for (var r in e) r !== "default" && !Object.prototype.hasOwnProperty.call(t, r) && oC(t, e, r);
}
function Jb(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function mM(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), a, i = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = n.next()).done; ) i.push(a.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      a && !a.done && (r = n.return) && r.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return i;
}
function _q() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e = e.concat(mM(arguments[t]));
  return e;
}
function Eq() {
  for (var e = 0, t = 0, r = arguments.length; t < r; t++) e += arguments[t].length;
  for (var n = Array(e), a = 0, t = 0; t < r; t++)
    for (var i = arguments[t], o = 0, s = i.length; o < s; o++, a++)
      n[a] = i[o];
  return n;
}
function wq(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, i; n < a; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function fd(e) {
  return this instanceof fd ? (this.v = e, this) : new fd(e);
}
function Oq(e, t, r) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = r.apply(e, t || []), a, i = [];
  return a = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), s("next"), s("throw"), s("return", o), a[Symbol.asyncIterator] = function() {
    return this;
  }, a;
  function o(m) {
    return function(h) {
      return Promise.resolve(h).then(m, d);
    };
  }
  function s(m, h) {
    n[m] && (a[m] = function(g) {
      return new Promise(function(y, S) {
        i.push([m, g, y, S]) > 1 || l(m, g);
      });
    }, h && (a[m] = h(a[m])));
  }
  function l(m, h) {
    try {
      c(n[m](h));
    } catch (g) {
      f(i[0][3], g);
    }
  }
  function c(m) {
    m.value instanceof fd ? Promise.resolve(m.value.v).then(u, d) : f(i[0][2], m);
  }
  function u(m) {
    l("next", m);
  }
  function d(m) {
    l("throw", m);
  }
  function f(m, h) {
    m(h), i.shift(), i.length && l(i[0][0], i[0][1]);
  }
}
function Tq(e) {
  var t, r;
  return t = {}, n("next"), n("throw", function(a) {
    throw a;
  }), n("return"), t[Symbol.iterator] = function() {
    return this;
  }, t;
  function n(a, i) {
    t[a] = e[a] ? function(o) {
      return (r = !r) ? { value: fd(e[a](o)), done: !1 } : i ? i(o) : o;
    } : i;
  }
}
function Iq(e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], r;
  return t ? t.call(e) : (e = typeof Jb == "function" ? Jb(e) : e[Symbol.iterator](), r = {}, n("next"), n("throw"), n("return"), r[Symbol.asyncIterator] = function() {
    return this;
  }, r);
  function n(i) {
    r[i] = e[i] && function(o) {
      return new Promise(function(s, l) {
        o = e[i](o), a(s, l, o.done, o.value);
      });
    };
  }
  function a(i, o, s, l) {
    Promise.resolve(l).then(function(c) {
      i({ value: c, done: s });
    }, o);
  }
}
function Mq(e, t) {
  return Object.defineProperty ? Object.defineProperty(e, "raw", { value: t }) : e.raw = t, e;
}
var PIe = Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}, jE = function(e) {
  return jE = Object.getOwnPropertyNames || function(t) {
    var r = [];
    for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (r[r.length] = n);
    return r;
  }, jE(e);
};
function Aq(e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (e != null) for (var r = jE(e), n = 0; n < r.length; n++) r[n] !== "default" && oC(t, e, r[n]);
  return PIe(t, e), t;
}
function Pq(e) {
  return e && e.__esModule ? e : { default: e };
}
function Rq(e, t, r, n) {
  if (r === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(e) : n ? n.value : t.get(e);
}
function Nq(e, t, r, n, a) {
  if (n === "m") throw new TypeError("Private method is not writable");
  if (n === "a" && !a) throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !a : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? a.call(e, r) : a ? a.value = r : t.set(e, r), r;
}
function Dq(e, t) {
  if (t === null || typeof t != "object" && typeof t != "function") throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof e == "function" ? t === e : e.has(t);
}
function jq(e, t, r) {
  if (t != null) {
    if (typeof t != "object" && typeof t != "function") throw new TypeError("Object expected.");
    var n, a;
    if (r) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      n = t[Symbol.asyncDispose];
    }
    if (n === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      n = t[Symbol.dispose], r && (a = n);
    }
    if (typeof n != "function") throw new TypeError("Object not disposable.");
    a && (n = function() {
      try {
        a.call(this);
      } catch (i) {
        return Promise.reject(i);
      }
    }), e.stack.push({ value: t, dispose: n, async: r });
  } else r && e.stack.push({ async: !0 });
  return t;
}
var RIe = typeof SuppressedError == "function" ? SuppressedError : function(e, t, r) {
  var n = new Error(r);
  return n.name = "SuppressedError", n.error = e, n.suppressed = t, n;
};
function Lq(e) {
  function t(i) {
    e.error = e.hasError ? new RIe(i, e.error, "An error was suppressed during disposal.") : i, e.hasError = !0;
  }
  var r, n = 0;
  function a() {
    for (; r = e.stack.pop(); )
      try {
        if (!r.async && n === 1) return n = 0, e.stack.push(r), Promise.resolve().then(a);
        if (r.dispose) {
          var i = r.dispose.call(r.value);
          if (r.async) return n |= 2, Promise.resolve(i).then(a, function(o) {
            return t(o), a();
          });
        } else n |= 1;
      } catch (o) {
        t(o);
      }
    if (n === 1) return e.hasError ? Promise.reject(e.error) : Promise.resolve();
    if (e.hasError) throw e.error;
  }
  return a();
}
function kq(e, t) {
  return typeof e == "string" && /^\.\.?\//.test(e) ? e.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(r, n, a, i, o) {
    return n ? t ? ".jsx" : ".js" : a && (!i || !o) ? r : a + i + "." + o.toLowerCase() + "js";
  }) : e;
}
const NIe = {
  __extends: fq,
  __assign: Xb,
  __rest: pq,
  __decorate: mq,
  __param: vq,
  __esDecorate: hq,
  __runInitializers: gq,
  __propKey: yq,
  __setFunctionName: bq,
  __metadata: Cq,
  __awaiter: Sq,
  __generator: xq,
  __createBinding: oC,
  __exportStar: $q,
  __values: Jb,
  __read: mM,
  __spread: _q,
  __spreadArrays: Eq,
  __spreadArray: wq,
  __await: fd,
  __asyncGenerator: Oq,
  __asyncDelegator: Tq,
  __asyncValues: Iq,
  __makeTemplateObject: Mq,
  __importStar: Aq,
  __importDefault: Pq,
  __classPrivateFieldGet: Rq,
  __classPrivateFieldSet: Nq,
  __classPrivateFieldIn: Dq,
  __addDisposableResource: jq,
  __disposeResources: Lq,
  __rewriteRelativeImportExtension: kq
}, DIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __addDisposableResource: jq,
  get __assign() {
    return Xb;
  },
  __asyncDelegator: Tq,
  __asyncGenerator: Oq,
  __asyncValues: Iq,
  __await: fd,
  __awaiter: Sq,
  __classPrivateFieldGet: Rq,
  __classPrivateFieldIn: Dq,
  __classPrivateFieldSet: Nq,
  __createBinding: oC,
  __decorate: mq,
  __disposeResources: Lq,
  __esDecorate: hq,
  __exportStar: $q,
  __extends: fq,
  __generator: xq,
  __importDefault: Pq,
  __importStar: Aq,
  __makeTemplateObject: Mq,
  __metadata: Cq,
  __param: vq,
  __propKey: yq,
  __read: mM,
  __rest: pq,
  __rewriteRelativeImportExtension: kq,
  __runInitializers: gq,
  __setFunctionName: bq,
  __spread: _q,
  __spreadArray: wq,
  __spreadArrays: Eq,
  __values: Jb,
  default: NIe
}, Symbol.toStringTag, { value: "Module" })), Gr = /* @__PURE__ */ p1(DIe);
/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var $6;
(function(e) {
  (function(t) {
    var r = typeof Ue == "object" ? Ue : typeof self == "object" ? self : typeof this == "object" ? this : Function("return this;")(), n = a(e);
    typeof r.Reflect > "u" ? r.Reflect = e : n = a(r.Reflect, n), t(n);
    function a(i, o) {
      return function(s, l) {
        typeof i[s] != "function" && Object.defineProperty(i, s, { configurable: !0, writable: !0, value: l }), o && o(s, l);
      };
    }
  })(function(t) {
    var r = Object.prototype.hasOwnProperty, n = typeof Symbol == "function", a = n && typeof Symbol.toPrimitive < "u" ? Symbol.toPrimitive : "@@toPrimitive", i = n && typeof Symbol.iterator < "u" ? Symbol.iterator : "@@iterator", o = typeof Object.create == "function", s = { __proto__: [] } instanceof Array, l = !o && !s, c = {
      // create an object in dictionary mode (a.k.a. "slow" mode in v8)
      create: o ? function() {
        return $e(/* @__PURE__ */ Object.create(null));
      } : s ? function() {
        return $e({ __proto__: null });
      } : function() {
        return $e({});
      },
      has: l ? function(J, de) {
        return r.call(J, de);
      } : function(J, de) {
        return de in J;
      },
      get: l ? function(J, de) {
        return r.call(J, de) ? J[de] : void 0;
      } : function(J, de) {
        return J[de];
      }
    }, u = Object.getPrototypeOf(Function), d = typeof process == "object" && process.env && process.env.REFLECT_METADATA_USE_MAP_POLYFILL === "true", f = !d && typeof Map == "function" && typeof Map.prototype.entries == "function" ? Map : Y(), m = !d && typeof Set == "function" && typeof Set.prototype.entries == "function" ? Set : X(), h = !d && typeof WeakMap == "function" ? WeakMap : pe(), g = new h();
    function y(J, de, Se, Ee) {
      if (V(Se)) {
        if (!le(J))
          throw new TypeError();
        if (!Q(de))
          throw new TypeError();
        return P(J, de);
      } else {
        if (!le(J))
          throw new TypeError();
        if (!ee(de))
          throw new TypeError();
        if (!ee(Ee) && !V(Ee) && !K(Ee))
          throw new TypeError();
        return K(Ee) && (Ee = void 0), Se = fe(Se), D(J, de, Se, Ee);
      }
    }
    t("decorate", y);
    function S(J, de) {
      function Se(Ee, Te) {
        if (!ee(Ee))
          throw new TypeError();
        if (!V(Te) && !he(Te))
          throw new TypeError();
        j(J, de, Ee, Te);
      }
      return Se;
    }
    t("metadata", S);
    function x(J, de, Se, Ee) {
      if (!ee(Se))
        throw new TypeError();
      return V(Ee) || (Ee = fe(Ee)), j(J, de, Se, Ee);
    }
    t("defineMetadata", x);
    function b(J, de, Se) {
      if (!ee(de))
        throw new TypeError();
      return V(Se) || (Se = fe(Se)), L(J, de, Se);
    }
    t("hasMetadata", b);
    function _(J, de, Se) {
      if (!ee(de))
        throw new TypeError();
      return V(Se) || (Se = fe(Se)), N(J, de, Se);
    }
    t("hasOwnMetadata", _);
    function $(J, de, Se) {
      if (!ee(de))
        throw new TypeError();
      return V(Se) || (Se = fe(Se)), z(J, de, Se);
    }
    t("getMetadata", $);
    function w(J, de, Se) {
      if (!ee(de))
        throw new TypeError();
      return V(Se) || (Se = fe(Se)), F(J, de, Se);
    }
    t("getOwnMetadata", w);
    function O(J, de) {
      if (!ee(J))
        throw new TypeError();
      return V(de) || (de = fe(de)), H(J, de);
    }
    t("getMetadataKeys", O);
    function T(J, de) {
      if (!ee(J))
        throw new TypeError();
      return V(de) || (de = fe(de)), U(J, de);
    }
    t("getOwnMetadataKeys", T);
    function I(J, de, Se) {
      if (!ee(de))
        throw new TypeError();
      V(Se) || (Se = fe(Se));
      var Ee = B(
        de,
        Se,
        /*Create*/
        !1
      );
      if (V(Ee) || !Ee.delete(J))
        return !1;
      if (Ee.size > 0)
        return !0;
      var Te = g.get(de);
      return Te.delete(Se), Te.size > 0 || g.delete(de), !0;
    }
    t("deleteMetadata", I);
    function P(J, de) {
      for (var Se = J.length - 1; Se >= 0; --Se) {
        var Ee = J[Se], Te = Ee(de);
        if (!V(Te) && !K(Te)) {
          if (!Q(Te))
            throw new TypeError();
          de = Te;
        }
      }
      return de;
    }
    function D(J, de, Se, Ee) {
      for (var Te = J.length - 1; Te >= 0; --Te) {
        var Le = J[Te], Ie = Le(de, Se, Ee);
        if (!V(Ie) && !K(Ie)) {
          if (!ee(Ie))
            throw new TypeError();
          Ee = Ie;
        }
      }
      return Ee;
    }
    function B(J, de, Se) {
      var Ee = g.get(J);
      if (V(Ee)) {
        if (!Se)
          return;
        Ee = new f(), g.set(J, Ee);
      }
      var Te = Ee.get(de);
      if (V(Te)) {
        if (!Se)
          return;
        Te = new f(), Ee.set(de, Te);
      }
      return Te;
    }
    function L(J, de, Se) {
      var Ee = N(J, de, Se);
      if (Ee)
        return !0;
      var Te = q(de);
      return K(Te) ? !1 : L(J, Te, Se);
    }
    function N(J, de, Se) {
      var Ee = B(
        de,
        Se,
        /*Create*/
        !1
      );
      return V(Ee) ? !1 : re(Ee.has(J));
    }
    function z(J, de, Se) {
      var Ee = N(J, de, Se);
      if (Ee)
        return F(J, de, Se);
      var Te = q(de);
      if (!K(Te))
        return z(J, Te, Se);
    }
    function F(J, de, Se) {
      var Ee = B(
        de,
        Se,
        /*Create*/
        !1
      );
      if (!V(Ee))
        return Ee.get(J);
    }
    function j(J, de, Se, Ee) {
      var Te = B(
        Se,
        Ee,
        /*Create*/
        !0
      );
      Te.set(J, de);
    }
    function H(J, de) {
      var Se = U(J, de), Ee = q(J);
      if (Ee === null)
        return Se;
      var Te = H(Ee, de);
      if (Te.length <= 0)
        return Se;
      if (Se.length <= 0)
        return Te;
      for (var Le = new m(), Ie = [], De = 0, Ae = Se; De < Ae.length; De++) {
        var Fe = Ae[De], Ne = Le.has(Fe);
        Ne || (Le.add(Fe), Ie.push(Fe));
      }
      for (var qe = 0, Qe = Te; qe < Qe.length; qe++) {
        var Fe = Qe[qe], Ne = Le.has(Fe);
        Ne || (Le.add(Fe), Ie.push(Fe));
      }
      return Ie;
    }
    function U(J, de) {
      var Se = [], Ee = B(
        J,
        de,
        /*Create*/
        !1
      );
      if (V(Ee))
        return Se;
      for (var Te = Ee.keys(), Le = me(Te), Ie = 0; ; ) {
        var De = M(Le);
        if (!De)
          return Se.length = Ie, Se;
        var Ae = k(De);
        try {
          Se[Ie] = Ae;
        } catch (Fe) {
          try {
            R(Le);
          } finally {
            throw Fe;
          }
        }
        Ie++;
      }
    }
    function G(J) {
      if (J === null)
        return 1;
      switch (typeof J) {
        case "undefined":
          return 0;
        case "boolean":
          return 2;
        case "string":
          return 3;
        case "symbol":
          return 4;
        case "number":
          return 5;
        case "object":
          return J === null ? 1 : 6;
        default:
          return 6;
      }
    }
    function V(J) {
      return J === void 0;
    }
    function K(J) {
      return J === null;
    }
    function Z(J) {
      return typeof J == "symbol";
    }
    function ee(J) {
      return typeof J == "object" ? J !== null : typeof J == "function";
    }
    function ae(J, de) {
      switch (G(J)) {
        case 0:
          return J;
        case 1:
          return J;
        case 2:
          return J;
        case 3:
          return J;
        case 4:
          return J;
        case 5:
          return J;
      }
      var Se = "string", Ee = ne(J, a);
      if (Ee !== void 0) {
        var Te = Ee.call(J, Se);
        if (ee(Te))
          throw new TypeError();
        return Te;
      }
      return ue(J);
    }
    function ue(J, de) {
      var Se, Ee, Te;
      {
        var Le = J.toString;
        if (se(Le)) {
          var Ee = Le.call(J);
          if (!ee(Ee))
            return Ee;
        }
        var Se = J.valueOf;
        if (se(Se)) {
          var Ee = Se.call(J);
          if (!ee(Ee))
            return Ee;
        }
      }
      throw new TypeError();
    }
    function re(J) {
      return !!J;
    }
    function oe(J) {
      return "" + J;
    }
    function fe(J) {
      var de = ae(J);
      return Z(de) ? de : oe(de);
    }
    function le(J) {
      return Array.isArray ? Array.isArray(J) : J instanceof Object ? J instanceof Array : Object.prototype.toString.call(J) === "[object Array]";
    }
    function se(J) {
      return typeof J == "function";
    }
    function Q(J) {
      return typeof J == "function";
    }
    function he(J) {
      switch (G(J)) {
        case 3:
          return !0;
        case 4:
          return !0;
        default:
          return !1;
      }
    }
    function ne(J, de) {
      var Se = J[de];
      if (Se != null) {
        if (!se(Se))
          throw new TypeError();
        return Se;
      }
    }
    function me(J) {
      var de = ne(J, i);
      if (!se(de))
        throw new TypeError();
      var Se = de.call(J);
      if (!ee(Se))
        throw new TypeError();
      return Se;
    }
    function k(J) {
      return J.value;
    }
    function M(J) {
      var de = J.next();
      return de.done ? !1 : de;
    }
    function R(J) {
      var de = J.return;
      de && de.call(J);
    }
    function q(J) {
      var de = Object.getPrototypeOf(J);
      if (typeof J != "function" || J === u || de !== u)
        return de;
      var Se = J.prototype, Ee = Se && Object.getPrototypeOf(Se);
      if (Ee == null || Ee === Object.prototype)
        return de;
      var Te = Ee.constructor;
      return typeof Te != "function" || Te === J ? de : Te;
    }
    function Y() {
      var J = {}, de = [], Se = (
        /** @class */
        function() {
          function Ie(De, Ae, Fe) {
            this._index = 0, this._keys = De, this._values = Ae, this._selector = Fe;
          }
          return Ie.prototype["@@iterator"] = function() {
            return this;
          }, Ie.prototype[i] = function() {
            return this;
          }, Ie.prototype.next = function() {
            var De = this._index;
            if (De >= 0 && De < this._keys.length) {
              var Ae = this._selector(this._keys[De], this._values[De]);
              return De + 1 >= this._keys.length ? (this._index = -1, this._keys = de, this._values = de) : this._index++, { value: Ae, done: !1 };
            }
            return { value: void 0, done: !0 };
          }, Ie.prototype.throw = function(De) {
            throw this._index >= 0 && (this._index = -1, this._keys = de, this._values = de), De;
          }, Ie.prototype.return = function(De) {
            return this._index >= 0 && (this._index = -1, this._keys = de, this._values = de), { value: De, done: !0 };
          }, Ie;
        }()
      );
      return (
        /** @class */
        function() {
          function Ie() {
            this._keys = [], this._values = [], this._cacheKey = J, this._cacheIndex = -2;
          }
          return Object.defineProperty(Ie.prototype, "size", {
            get: function() {
              return this._keys.length;
            },
            enumerable: !0,
            configurable: !0
          }), Ie.prototype.has = function(De) {
            return this._find(
              De,
              /*insert*/
              !1
            ) >= 0;
          }, Ie.prototype.get = function(De) {
            var Ae = this._find(
              De,
              /*insert*/
              !1
            );
            return Ae >= 0 ? this._values[Ae] : void 0;
          }, Ie.prototype.set = function(De, Ae) {
            var Fe = this._find(
              De,
              /*insert*/
              !0
            );
            return this._values[Fe] = Ae, this;
          }, Ie.prototype.delete = function(De) {
            var Ae = this._find(
              De,
              /*insert*/
              !1
            );
            if (Ae >= 0) {
              for (var Fe = this._keys.length, Ne = Ae + 1; Ne < Fe; Ne++)
                this._keys[Ne - 1] = this._keys[Ne], this._values[Ne - 1] = this._values[Ne];
              return this._keys.length--, this._values.length--, De === this._cacheKey && (this._cacheKey = J, this._cacheIndex = -2), !0;
            }
            return !1;
          }, Ie.prototype.clear = function() {
            this._keys.length = 0, this._values.length = 0, this._cacheKey = J, this._cacheIndex = -2;
          }, Ie.prototype.keys = function() {
            return new Se(this._keys, this._values, Ee);
          }, Ie.prototype.values = function() {
            return new Se(this._keys, this._values, Te);
          }, Ie.prototype.entries = function() {
            return new Se(this._keys, this._values, Le);
          }, Ie.prototype["@@iterator"] = function() {
            return this.entries();
          }, Ie.prototype[i] = function() {
            return this.entries();
          }, Ie.prototype._find = function(De, Ae) {
            return this._cacheKey !== De && (this._cacheIndex = this._keys.indexOf(this._cacheKey = De)), this._cacheIndex < 0 && Ae && (this._cacheIndex = this._keys.length, this._keys.push(De), this._values.push(void 0)), this._cacheIndex;
          }, Ie;
        }()
      );
      function Ee(Ie, De) {
        return Ie;
      }
      function Te(Ie, De) {
        return De;
      }
      function Le(Ie, De) {
        return [Ie, De];
      }
    }
    function X() {
      return (
        /** @class */
        function() {
          function J() {
            this._map = new f();
          }
          return Object.defineProperty(J.prototype, "size", {
            get: function() {
              return this._map.size;
            },
            enumerable: !0,
            configurable: !0
          }), J.prototype.has = function(de) {
            return this._map.has(de);
          }, J.prototype.add = function(de) {
            return this._map.set(de, de), this;
          }, J.prototype.delete = function(de) {
            return this._map.delete(de);
          }, J.prototype.clear = function() {
            this._map.clear();
          }, J.prototype.keys = function() {
            return this._map.keys();
          }, J.prototype.values = function() {
            return this._map.values();
          }, J.prototype.entries = function() {
            return this._map.entries();
          }, J.prototype["@@iterator"] = function() {
            return this.keys();
          }, J.prototype[i] = function() {
            return this.keys();
          }, J;
        }()
      );
    }
    function pe() {
      var J = 16, de = c.create(), Se = Ee();
      return (
        /** @class */
        function() {
          function Ae() {
            this._key = Ee();
          }
          return Ae.prototype.has = function(Fe) {
            var Ne = Te(
              Fe,
              /*create*/
              !1
            );
            return Ne !== void 0 ? c.has(Ne, this._key) : !1;
          }, Ae.prototype.get = function(Fe) {
            var Ne = Te(
              Fe,
              /*create*/
              !1
            );
            return Ne !== void 0 ? c.get(Ne, this._key) : void 0;
          }, Ae.prototype.set = function(Fe, Ne) {
            var qe = Te(
              Fe,
              /*create*/
              !0
            );
            return qe[this._key] = Ne, this;
          }, Ae.prototype.delete = function(Fe) {
            var Ne = Te(
              Fe,
              /*create*/
              !1
            );
            return Ne !== void 0 ? delete Ne[this._key] : !1;
          }, Ae.prototype.clear = function() {
            this._key = Ee();
          }, Ae;
        }()
      );
      function Ee() {
        var Ae;
        do
          Ae = "@@WeakMap@@" + De();
        while (c.has(de, Ae));
        return de[Ae] = !0, Ae;
      }
      function Te(Ae, Fe) {
        if (!r.call(Ae, Se)) {
          if (!Fe)
            return;
          Object.defineProperty(Ae, Se, { value: c.create() });
        }
        return Ae[Se];
      }
      function Le(Ae, Fe) {
        for (var Ne = 0; Ne < Fe; ++Ne)
          Ae[Ne] = Math.random() * 255 | 0;
        return Ae;
      }
      function Ie(Ae) {
        return typeof Uint8Array == "function" ? typeof crypto < "u" ? crypto.getRandomValues(new Uint8Array(Ae)) : typeof msCrypto < "u" ? msCrypto.getRandomValues(new Uint8Array(Ae)) : Le(new Uint8Array(Ae), Ae) : Le(new Array(Ae), Ae);
      }
      function De() {
        var Ae = Ie(J);
        Ae[6] = Ae[6] & 79 | 64, Ae[8] = Ae[8] & 191 | 128;
        for (var Fe = "", Ne = 0; Ne < J; ++Ne) {
          var qe = Ae[Ne];
          (Ne === 4 || Ne === 6 || Ne === 8) && (Fe += "-"), qe < 16 && (Fe += "0"), Fe += qe.toString(16).toLowerCase();
        }
        return Fe;
      }
    }
    function $e(J) {
      return J.__ = void 0, delete J.__, J;
    }
  });
})($6 || ($6 = {}));
var Xx = {}, Jx = {}, gy = {}, _6;
function jIe() {
  if (_6) return gy;
  _6 = 1, Object.defineProperty(gy, "__esModule", { value: !0 }), gy.Bind = e;
  function e(...t) {
    return (r, n, a) => (t.forEach((i, o) => i(r, n, o)), a);
  }
  return gy;
}
var yy = {}, Qx = {}, E6;
function Zn() {
  return E6 || (E6 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ENTRY_PROVIDER_WATERMARK = e.CATCH_WATERMARK = e.CONTROLLER_WATERMARK = e.INJECTABLE_WATERMARK = e.VERSION_METADATA = e.SSE_METADATA = e.RESPONSE_PASSTHROUGH_METADATA = e.REDIRECT_METADATA = e.HEADERS_METADATA = e.MODULE_PATH = e.HTTP_CODE_METADATA = e.RENDER_METADATA = e.ENHANCER_KEY_TO_SUBTYPE_MAP = e.EXCEPTION_FILTERS_METADATA = e.INTERCEPTORS_METADATA = e.GUARDS_METADATA = e.PIPES_METADATA = e.FILTER_CATCH_EXCEPTIONS = e.CUSTOM_ROUTE_ARGS_METADATA = e.ROUTE_ARGS_METADATA = e.METHOD_METADATA = e.SCOPE_OPTIONS_METADATA = e.OPTIONAL_PROPERTY_DEPS_METADATA = e.PROPERTY_DEPS_METADATA = e.OPTIONAL_DEPS_METADATA = e.SELF_DECLARED_DEPS_METADATA = e.PARAMTYPES_METADATA = e.PATH_METADATA = e.HOST_METADATA = e.GLOBAL_MODULE_METADATA = e.MODULE_METADATA = void 0, e.MODULE_METADATA = {
      IMPORTS: "imports",
      PROVIDERS: "providers",
      CONTROLLERS: "controllers",
      EXPORTS: "exports"
    }, e.GLOBAL_MODULE_METADATA = "__module:global__", e.HOST_METADATA = "host", e.PATH_METADATA = "path", e.PARAMTYPES_METADATA = "design:paramtypes", e.SELF_DECLARED_DEPS_METADATA = "self:paramtypes", e.OPTIONAL_DEPS_METADATA = "optional:paramtypes", e.PROPERTY_DEPS_METADATA = "self:properties_metadata", e.OPTIONAL_PROPERTY_DEPS_METADATA = "optional:properties_metadata", e.SCOPE_OPTIONS_METADATA = "scope:options", e.METHOD_METADATA = "method", e.ROUTE_ARGS_METADATA = "__routeArguments__", e.CUSTOM_ROUTE_ARGS_METADATA = "__customRouteArgs__", e.FILTER_CATCH_EXCEPTIONS = "__filterCatchExceptions__", e.PIPES_METADATA = "__pipes__", e.GUARDS_METADATA = "__guards__", e.INTERCEPTORS_METADATA = "__interceptors__", e.EXCEPTION_FILTERS_METADATA = "__exceptionFilters__", e.ENHANCER_KEY_TO_SUBTYPE_MAP = {
      [e.GUARDS_METADATA]: "guard",
      [e.INTERCEPTORS_METADATA]: "interceptor",
      [e.PIPES_METADATA]: "pipe",
      [e.EXCEPTION_FILTERS_METADATA]: "filter"
    }, e.RENDER_METADATA = "__renderTemplate__", e.HTTP_CODE_METADATA = "__httpCode__", e.MODULE_PATH = "__module_path__", e.HEADERS_METADATA = "__headers__", e.REDIRECT_METADATA = "__redirect__", e.RESPONSE_PASSTHROUGH_METADATA = "__responsePassthrough__", e.SSE_METADATA = "__sse__", e.VERSION_METADATA = "__version__", e.INJECTABLE_WATERMARK = "__injectable__", e.CONTROLLER_WATERMARK = "__controller__", e.CATCH_WATERMARK = "__catch__", e.ENTRY_PROVIDER_WATERMARK = "__entryProvider__";
  }(Qx)), Qx;
}
var w6;
function LIe() {
  if (w6) return yy;
  w6 = 1, Object.defineProperty(yy, "__esModule", { value: !0 }), yy.Catch = t;
  const e = Zn();
  function t(...r) {
    return (n) => {
      Reflect.defineMetadata(e.CATCH_WATERMARK, !0, n), Reflect.defineMetadata(e.FILTER_CATCH_EXCEPTIONS, r, n);
    };
  }
  return yy;
}
var by = {}, e$ = {}, O6;
function An() {
  return O6 || (O6 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.isSymbol = e.isEmpty = e.isNil = e.isConstructor = e.isNumber = e.isString = e.isFunction = e.stripEndSlash = e.normalizePath = e.addLeadingSlash = e.isPlainObject = e.isObject = e.isUndefined = void 0;
    const t = (h) => typeof h > "u";
    e.isUndefined = t;
    const r = (h) => !(0, e.isNil)(h) && typeof h == "object";
    e.isObject = r;
    const n = (h) => {
      if (!(0, e.isObject)(h))
        return !1;
      const g = Object.getPrototypeOf(h);
      if (g === null)
        return !0;
      const y = Object.prototype.hasOwnProperty.call(g, "constructor") && g.constructor;
      return typeof y == "function" && y instanceof y && Function.prototype.toString.call(y) === Function.prototype.toString.call(Object);
    };
    e.isPlainObject = n;
    const a = (h) => h && typeof h == "string" ? h.charAt(0) !== "/" && h.substring(0, 2) !== "{/" ? "/" + h : h : "";
    e.addLeadingSlash = a;
    const i = (h) => h ? h.startsWith("/") ? ("/" + h.replace(/\/+$/, "")).replace(/\/+/g, "/") : "/" + h.replace(/\/+$/, "") : "/";
    e.normalizePath = i;
    const o = (h) => h[h.length - 1] === "/" ? h.slice(0, h.length - 1) : h;
    e.stripEndSlash = o;
    const s = (h) => typeof h == "function";
    e.isFunction = s;
    const l = (h) => typeof h == "string";
    e.isString = l;
    const c = (h) => typeof h == "number";
    e.isNumber = c;
    const u = (h) => h === "constructor";
    e.isConstructor = u;
    const d = (h) => (0, e.isUndefined)(h) || h === null;
    e.isNil = d;
    const f = (h) => !(h && h.length > 0);
    e.isEmpty = f;
    const m = (h) => typeof h == "symbol";
    e.isSymbol = m;
  }(e$)), e$;
}
var T6;
function kIe() {
  if (T6) return by;
  T6 = 1, Object.defineProperty(by, "__esModule", { value: !0 }), by.Controller = r;
  const e = Zn(), t = An();
  function r(n) {
    const a = "/", [i, o, s, l] = (0, t.isUndefined)(n) ? [a, void 0, void 0, void 0] : (0, t.isString)(n) || Array.isArray(n) ? [n, void 0, void 0, void 0] : [
      n.path || a,
      n.host,
      { scope: n.scope, durable: n.durable },
      Array.isArray(n.version) ? Array.from(new Set(n.version)) : n.version
    ];
    return (c) => {
      Reflect.defineMetadata(e.CONTROLLER_WATERMARK, !0, c), Reflect.defineMetadata(e.PATH_METADATA, i, c), Reflect.defineMetadata(e.HOST_METADATA, o, c), Reflect.defineMetadata(e.SCOPE_OPTIONS_METADATA, s, c), Reflect.defineMetadata(e.VERSION_METADATA, l, c);
    };
  }
  return by;
}
var _u = {}, I6;
function FIe() {
  if (I6) return _u;
  I6 = 1, Object.defineProperty(_u, "__esModule", { value: !0 }), _u.Dependencies = void 0, _u.flatten = t;
  const e = Zn();
  function t(n) {
    const a = [].concat(...n);
    return a.some(Array.isArray) ? t(a) : a;
  }
  const r = (...n) => {
    const a = t(n);
    return (i) => {
      Reflect.defineMetadata(e.PARAMTYPES_METADATA, a, i);
    };
  };
  return _u.Dependencies = r, _u;
}
var Sf = {}, Cy = {}, M6;
function Ah() {
  if (M6) return Cy;
  M6 = 1, Object.defineProperty(Cy, "__esModule", { value: !0 }), Cy.extendArrayMetadata = e;
  function e(t, r, n) {
    const i = [...Reflect.getMetadata(t, n) || [], ...r];
    Reflect.defineMetadata(t, i, n);
  }
  return Cy;
}
var Eu = {}, A6;
function sC() {
  if (A6) return Eu;
  A6 = 1, Object.defineProperty(Eu, "__esModule", { value: !0 }), Eu.InvalidDecoratorItemException = void 0, Eu.validateEach = t;
  class e extends Error {
    constructor(n, a, i) {
      const o = `Invalid ${a} passed to ${n}() decorator (${i}).`;
      super(o), this.msg = o;
    }
    what() {
      return this.msg;
    }
  }
  Eu.InvalidDecoratorItemException = e;
  function t(r, n, a, i, o) {
    if (!r || !r.name)
      return !0;
    if (n.some((l) => !a(l)))
      throw new e(i, o, r.name);
    return !0;
  }
  return Eu;
}
var P6;
function BIe() {
  if (P6) return Sf;
  P6 = 1, Object.defineProperty(Sf, "__esModule", { value: !0 }), Sf.UseFilters = void 0;
  const e = Zn(), t = Ah(), r = An(), n = sC(), a = (...o) => i(...o);
  Sf.UseFilters = a;
  function i(...o) {
    return (s, l, c) => {
      const u = (d) => d && ((0, r.isFunction)(d) || (0, r.isFunction)(d.catch));
      return c ? ((0, n.validateEach)(s.constructor, o, u, "@UseFilters", "filter"), (0, t.extendArrayMetadata)(e.EXCEPTION_FILTERS_METADATA, o, c.value), c) : ((0, n.validateEach)(s, o, u, "@UseFilters", "filter"), (0, t.extendArrayMetadata)(e.EXCEPTION_FILTERS_METADATA, o, s), s);
    };
  }
  return Sf;
}
var Sy = {}, R6;
function zIe() {
  if (R6) return Sy;
  R6 = 1, Object.defineProperty(Sy, "__esModule", { value: !0 }), Sy.Inject = r;
  const e = Zn(), t = An();
  function r(n) {
    const a = arguments.length > 0;
    return (i, o, s) => {
      let l = n || Reflect.getMetadata("design:type", i, o);
      if (!l && !a && (l = Reflect.getMetadata(e.PARAMTYPES_METADATA, i, o)?.[s]), !(0, t.isUndefined)(s)) {
        let u = Reflect.getMetadata(e.SELF_DECLARED_DEPS_METADATA, i) || [];
        u = [...u, { index: s, param: l }], Reflect.defineMetadata(e.SELF_DECLARED_DEPS_METADATA, u, i);
        return;
      }
      let c = Reflect.getMetadata(e.PROPERTY_DEPS_METADATA, i.constructor) || [];
      c = [...c, { key: o, type: l }], Reflect.defineMetadata(e.PROPERTY_DEPS_METADATA, c, i.constructor);
    };
  }
  return Sy;
}
var xf = {}, t$ = {}, N6;
function vM() {
  if (N6) return t$;
  N6 = 1;
  for (var e = 256, t = [], r = 256, n; e--; ) t[e] = (e + 256).toString(16).substring(1);
  function a(i) {
    var o = 0, s = i || 11;
    if (!n || e + s > r * 2)
      for (n = "", e = 0; o < r; o++)
        n += t[Math.random() * 256 | 0];
    return n.substring(e, e++ + s);
  }
  return t$.uid = a, t$;
}
var D6;
function Vc() {
  if (D6) return xf;
  D6 = 1, Object.defineProperty(xf, "__esModule", { value: !0 }), xf.Injectable = r, xf.mixin = n;
  const e = vM(), t = Zn();
  function r(a) {
    return (i) => {
      Reflect.defineMetadata(t.INJECTABLE_WATERMARK, !0, i), Reflect.defineMetadata(t.SCOPE_OPTIONS_METADATA, a, i);
    };
  }
  function n(a) {
    return Object.defineProperty(a, "name", {
      value: (0, e.uid)(21)
    }), r()(a), a;
  }
  return xf;
}
var xy = {}, j6;
function Ph() {
  if (j6) return xy;
  j6 = 1, Object.defineProperty(xy, "__esModule", { value: !0 }), xy.Optional = r;
  const e = Zn(), t = An();
  function r() {
    return (n, a, i) => {
      if (!(0, t.isUndefined)(i)) {
        const s = Reflect.getMetadata(e.OPTIONAL_DEPS_METADATA, n) || [];
        Reflect.defineMetadata(e.OPTIONAL_DEPS_METADATA, [...s, i], n);
        return;
      }
      const o = Reflect.getMetadata(e.OPTIONAL_PROPERTY_DEPS_METADATA, n.constructor) || [];
      Reflect.defineMetadata(e.OPTIONAL_PROPERTY_DEPS_METADATA, [...o, a], n.constructor);
    };
  }
  return xy;
}
var $f = {}, L6;
function HIe() {
  if (L6) return $f;
  L6 = 1, Object.defineProperty($f, "__esModule", { value: !0 }), $f.SetMetadata = void 0;
  const e = (t, r) => {
    const n = (a, i, o) => o ? (Reflect.defineMetadata(t, r, o.value), o) : (Reflect.defineMetadata(t, r, a), a);
    return n.KEY = t, n;
  };
  return $f.SetMetadata = e, $f;
}
var $y = {}, k6;
function VIe() {
  if (k6) return $y;
  k6 = 1, Object.defineProperty($y, "__esModule", { value: !0 }), $y.UseGuards = a;
  const e = Zn(), t = Ah(), r = An(), n = sC();
  function a(...i) {
    return (o, s, l) => {
      const c = (u) => u && ((0, r.isFunction)(u) || (0, r.isFunction)(u.canActivate));
      return l ? ((0, n.validateEach)(o.constructor, i, c, "@UseGuards", "guard"), (0, t.extendArrayMetadata)(e.GUARDS_METADATA, i, l.value), l) : ((0, n.validateEach)(o, i, c, "@UseGuards", "guard"), (0, t.extendArrayMetadata)(e.GUARDS_METADATA, i, o), o);
    };
  }
  return $y;
}
var _y = {}, F6;
function GIe() {
  if (F6) return _y;
  F6 = 1, Object.defineProperty(_y, "__esModule", { value: !0 }), _y.UseInterceptors = a;
  const e = Zn(), t = Ah(), r = An(), n = sC();
  function a(...i) {
    return (o, s, l) => {
      const c = (u) => u && ((0, r.isFunction)(u) || (0, r.isFunction)(u.intercept));
      return l ? ((0, n.validateEach)(o.constructor, i, c, "@UseInterceptors", "interceptor"), (0, t.extendArrayMetadata)(e.INTERCEPTORS_METADATA, i, l.value), l) : ((0, n.validateEach)(o, i, c, "@UseInterceptors", "interceptor"), (0, t.extendArrayMetadata)(e.INTERCEPTORS_METADATA, i, o), o);
    };
  }
  return _y;
}
var Ey = {}, B6;
function UIe() {
  if (B6) return Ey;
  B6 = 1, Object.defineProperty(Ey, "__esModule", { value: !0 }), Ey.UsePipes = a;
  const e = Zn(), t = Ah(), r = An(), n = sC();
  function a(...i) {
    return (o, s, l) => {
      const c = (u) => u && ((0, r.isFunction)(u) || (0, r.isFunction)(u.transform));
      return l ? ((0, t.extendArrayMetadata)(e.PIPES_METADATA, i, l.value), l) : ((0, n.validateEach)(o, i, c, "@UsePipes", "pipe"), (0, t.extendArrayMetadata)(e.PIPES_METADATA, i, o), o);
    };
  }
  return Ey;
}
var wy = {}, z6;
function WIe() {
  if (z6) return wy;
  z6 = 1, Object.defineProperty(wy, "__esModule", { value: !0 }), wy.applyDecorators = e;
  function e(...t) {
    return (r, n, a) => {
      for (const i of t) {
        if (r instanceof Function && !a) {
          i(r);
          continue;
        }
        i(r, n, a);
      }
    };
  }
  return wy;
}
var Oy = {}, H6;
function qIe() {
  if (H6) return Oy;
  H6 = 1, Object.defineProperty(Oy, "__esModule", { value: !0 }), Oy.Version = t;
  const e = Zn();
  function t(r) {
    return Array.isArray(r) && (r = Array.from(new Set(r))), (n, a, i) => (Reflect.defineMetadata(e.VERSION_METADATA, r, i.value), i);
  }
  return Oy;
}
var V6;
function Tl() {
  return V6 || (V6 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = Gr;
    t.__exportStar(jIe(), e), t.__exportStar(LIe(), e), t.__exportStar(kIe(), e), t.__exportStar(FIe(), e), t.__exportStar(BIe(), e), t.__exportStar(zIe(), e), t.__exportStar(Vc(), e), t.__exportStar(Ph(), e), t.__exportStar(HIe(), e), t.__exportStar(VIe(), e), t.__exportStar(GIe(), e), t.__exportStar(UIe(), e), t.__exportStar(WIe(), e), t.__exportStar(qIe(), e);
  }(Jx)), Jx;
}
var r$ = {}, Ty = {}, G6;
function KIe() {
  if (G6) return Ty;
  G6 = 1, Object.defineProperty(Ty, "__esModule", { value: !0 }), Ty.Global = t;
  const e = Zn();
  function t() {
    return (r) => {
      Reflect.defineMetadata(e.GLOBAL_MODULE_METADATA, !0, r);
    };
  }
  return Ty;
}
var Iy = {}, n$ = {}, U6;
function YIe() {
  return U6 || (U6 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.INVALID_MODULE_CONFIG_MESSAGE = void 0, e.validateModuleKeys = a;
    const t = Zn(), r = (i, o) => `Invalid property '${o}' passed into the @Module() decorator.`;
    e.INVALID_MODULE_CONFIG_MESSAGE = r;
    const n = [
      t.MODULE_METADATA.IMPORTS,
      t.MODULE_METADATA.EXPORTS,
      t.MODULE_METADATA.CONTROLLERS,
      t.MODULE_METADATA.PROVIDERS
    ];
    function a(i) {
      const o = (s) => {
        if (!n.includes(s))
          throw new Error((0, e.INVALID_MODULE_CONFIG_MESSAGE)`${s}`);
      };
      i.forEach(o);
    }
  }(n$)), n$;
}
var W6;
function ZIe() {
  if (W6) return Iy;
  W6 = 1, Object.defineProperty(Iy, "__esModule", { value: !0 }), Iy.Module = t;
  const e = YIe();
  function t(r) {
    const n = Object.keys(r);
    return (0, e.validateModuleKeys)(n), (a) => {
      for (const i in r)
        Object.hasOwnProperty.call(r, i) && Reflect.defineMetadata(i, r[i], a);
    };
  }
  return Iy;
}
var q6;
function XIe() {
  return q6 || (q6 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = Gr;
    t.__exportStar(KIe(), e), t.__exportStar(ZIe(), e);
  }(r$)), r$;
}
var a$ = {}, i$ = {}, _f = {}, K6;
function hM() {
  if (K6) return _f;
  K6 = 1, Object.defineProperty(_f, "__esModule", { value: !0 }), _f.RequestMethod = void 0;
  var e;
  return function(t) {
    t[t.GET = 0] = "GET", t[t.POST = 1] = "POST", t[t.PUT = 2] = "PUT", t[t.DELETE = 3] = "DELETE", t[t.PATCH = 4] = "PATCH", t[t.ALL = 5] = "ALL", t[t.OPTIONS = 6] = "OPTIONS", t[t.HEAD = 7] = "HEAD", t[t.SEARCH = 8] = "SEARCH", t[t.PROPFIND = 9] = "PROPFIND", t[t.PROPPATCH = 10] = "PROPPATCH", t[t.MKCOL = 11] = "MKCOL", t[t.COPY = 12] = "COPY", t[t.MOVE = 13] = "MOVE", t[t.LOCK = 14] = "LOCK", t[t.UNLOCK = 15] = "UNLOCK";
  }(e || (_f.RequestMethod = e = {})), _f;
}
var Y6;
function JIe() {
  return Y6 || (Y6 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Unlock = e.Lock = e.Move = e.Copy = e.Mkcol = e.Proppatch = e.Propfind = e.Search = e.All = e.Head = e.Options = e.Patch = e.Put = e.Delete = e.Get = e.Post = e.RequestMapping = void 0;
    const t = Zn(), r = hM(), n = {
      [t.PATH_METADATA]: "/",
      [t.METHOD_METADATA]: r.RequestMethod.GET
    }, a = (o = n) => {
      const s = o[t.PATH_METADATA], l = s && s.length ? s : "/", c = o[t.METHOD_METADATA] || r.RequestMethod.GET;
      return (u, d, f) => (Reflect.defineMetadata(t.PATH_METADATA, l, f.value), Reflect.defineMetadata(t.METHOD_METADATA, c, f.value), f);
    };
    e.RequestMapping = a;
    const i = (o) => (s) => (0, e.RequestMapping)({
      [t.PATH_METADATA]: s,
      [t.METHOD_METADATA]: o
    });
    e.Post = i(r.RequestMethod.POST), e.Get = i(r.RequestMethod.GET), e.Delete = i(r.RequestMethod.DELETE), e.Put = i(r.RequestMethod.PUT), e.Patch = i(r.RequestMethod.PATCH), e.Options = i(r.RequestMethod.OPTIONS), e.Head = i(r.RequestMethod.HEAD), e.All = i(r.RequestMethod.ALL), e.Search = i(r.RequestMethod.SEARCH), e.Propfind = i(r.RequestMethod.PROPFIND), e.Proppatch = i(r.RequestMethod.PROPPATCH), e.Mkcol = i(r.RequestMethod.MKCOL), e.Copy = i(r.RequestMethod.COPY), e.Move = i(r.RequestMethod.MOVE), e.Lock = i(r.RequestMethod.LOCK), e.Unlock = i(r.RequestMethod.UNLOCK);
  }(i$)), i$;
}
var o$ = {}, Ef = {}, Z6;
function QIe() {
  if (Z6) return Ef;
  Z6 = 1, Object.defineProperty(Ef, "__esModule", { value: !0 }), Ef.RouteParamtypes = void 0;
  var e;
  return function(t) {
    t[t.REQUEST = 0] = "REQUEST", t[t.RESPONSE = 1] = "RESPONSE", t[t.NEXT = 2] = "NEXT", t[t.BODY = 3] = "BODY", t[t.QUERY = 4] = "QUERY", t[t.PARAM = 5] = "PARAM", t[t.HEADERS = 6] = "HEADERS", t[t.SESSION = 7] = "SESSION", t[t.FILE = 8] = "FILE", t[t.FILES = 9] = "FILES", t[t.HOST = 10] = "HOST", t[t.IP = 11] = "IP", t[t.RAW_BODY = 12] = "RAW_BODY";
  }(e || (Ef.RouteParamtypes = e = {})), Ef;
}
var X6;
function eMe() {
  return X6 || (X6 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Res = e.Req = e.Headers = e.Session = e.Ip = e.Next = e.Response = e.Request = void 0, e.assignMetadata = a, e.UploadedFile = l, e.UploadedFiles = c, e.Query = u, e.Body = d, e.RawBody = f, e.Param = m, e.HostParam = h;
    const t = Zn(), r = QIe(), n = An();
    function a(g, y, S, x, ...b) {
      return {
        ...g,
        [`${y}:${S}`]: {
          index: S,
          data: x,
          pipes: b
        }
      };
    }
    function i(g) {
      return (y) => (S, x, b) => {
        const _ = Reflect.getMetadata(t.ROUTE_ARGS_METADATA, S.constructor, x) || {};
        Reflect.defineMetadata(t.ROUTE_ARGS_METADATA, a(_, g, b, y), S.constructor, x);
      };
    }
    const o = (g) => (y, ...S) => (x, b, _) => {
      const $ = Reflect.getMetadata(t.ROUTE_ARGS_METADATA, x.constructor, b) || {}, w = (0, n.isNil)(y) || (0, n.isString)(y), O = w ? y : void 0, T = w ? S : [y, ...S];
      Reflect.defineMetadata(t.ROUTE_ARGS_METADATA, a($, g, _, O, ...T), x.constructor, b);
    };
    e.Request = i(r.RouteParamtypes.REQUEST);
    const s = (g) => (y, S, x) => (g?.passthrough && Reflect.defineMetadata(t.RESPONSE_PASSTHROUGH_METADATA, g?.passthrough, y.constructor, S), i(r.RouteParamtypes.RESPONSE)()(y, S, x));
    e.Response = s, e.Next = i(r.RouteParamtypes.NEXT), e.Ip = i(r.RouteParamtypes.IP), e.Session = i(r.RouteParamtypes.SESSION);
    function l(g, ...y) {
      return o(r.RouteParamtypes.FILE)(g, ...y);
    }
    function c(...g) {
      return o(r.RouteParamtypes.FILES)(void 0, ...g);
    }
    e.Headers = i(r.RouteParamtypes.HEADERS);
    function u(g, ...y) {
      return o(r.RouteParamtypes.QUERY)(g, ...y);
    }
    function d(g, ...y) {
      return o(r.RouteParamtypes.BODY)(g, ...y);
    }
    function f(...g) {
      return o(r.RouteParamtypes.RAW_BODY)(void 0, ...g);
    }
    function m(g, ...y) {
      return o(r.RouteParamtypes.PARAM)(g, ...y);
    }
    function h(g) {
      return i(r.RouteParamtypes.HOST)(g);
    }
    e.Req = e.Request, e.Res = e.Response;
  }(o$)), o$;
}
var My = {}, J6;
function tMe() {
  if (J6) return My;
  J6 = 1, Object.defineProperty(My, "__esModule", { value: !0 }), My.HttpCode = t;
  const e = Zn();
  function t(r) {
    return (n, a, i) => (Reflect.defineMetadata(e.HTTP_CODE_METADATA, r, i.value), i);
  }
  return My;
}
var Ay = {}, Py = {}, Q6;
function rMe() {
  if (Q6) return Py;
  Q6 = 1, Object.defineProperty(Py, "__esModule", { value: !0 }), Py.assignCustomParameterMetadata = t;
  const e = Zn();
  function t(r, n, a, i, o, ...s) {
    return {
      ...r,
      [`${n}${e.CUSTOM_ROUTE_ARGS_METADATA}:${a}`]: {
        index: a,
        factory: i,
        data: o,
        pipes: s
      }
    };
  }
  return Py;
}
var e9;
function nMe() {
  if (e9) return Ay;
  e9 = 1, Object.defineProperty(Ay, "__esModule", { value: !0 }), Ay.createParamDecorator = a;
  const e = vM(), t = Zn(), r = rMe(), n = An();
  function a(i, o = []) {
    const s = (0, e.uid)(21);
    return (l, ...c) => (u, d, f) => {
      const m = Reflect.getMetadata(t.ROUTE_ARGS_METADATA, u.constructor, d) || {}, h = (x) => x && ((0, n.isFunction)(x) && x.prototype && (0, n.isFunction)(x.prototype.transform) || (0, n.isFunction)(x.transform)), g = (0, n.isNil)(l) || !h(l), y = g ? l : void 0, S = g ? c : [l, ...c];
      Reflect.defineMetadata(t.ROUTE_ARGS_METADATA, (0, r.assignCustomParameterMetadata)(m, s, f, i, y, ...S), u.constructor, d), o.forEach((x) => x(u, d, f));
    };
  }
  return Ay;
}
var Ry = {}, t9;
function aMe() {
  if (t9) return Ry;
  t9 = 1, Object.defineProperty(Ry, "__esModule", { value: !0 }), Ry.Render = t;
  const e = Zn();
  function t(r) {
    return (n, a, i) => (Reflect.defineMetadata(e.RENDER_METADATA, r, i.value), i);
  }
  return Ry;
}
var Ny = {}, r9;
function iMe() {
  if (r9) return Ny;
  r9 = 1, Object.defineProperty(Ny, "__esModule", { value: !0 }), Ny.Header = r;
  const e = Zn(), t = Ah();
  function r(n, a) {
    return (i, o, s) => ((0, t.extendArrayMetadata)(e.HEADERS_METADATA, [{ name: n, value: a }], s.value), s);
  }
  return Ny;
}
var Dy = {}, n9;
function oMe() {
  if (n9) return Dy;
  n9 = 1, Object.defineProperty(Dy, "__esModule", { value: !0 }), Dy.Redirect = t;
  const e = Zn();
  function t(r = "", n) {
    return (a, i, o) => (Reflect.defineMetadata(e.REDIRECT_METADATA, { statusCode: n, url: r }, o.value), o);
  }
  return Dy;
}
var jy = {}, a9;
function sMe() {
  if (a9) return jy;
  a9 = 1, Object.defineProperty(jy, "__esModule", { value: !0 }), jy.Sse = r;
  const e = Zn(), t = hM();
  function r(n) {
    return (a, i, o) => (n = n && n.length ? n : "/", Reflect.defineMetadata(e.PATH_METADATA, n, o.value), Reflect.defineMetadata(e.METHOD_METADATA, t.RequestMethod.GET, o.value), Reflect.defineMetadata(e.SSE_METADATA, !0, o.value), o);
  }
  return jy;
}
var i9;
function lMe() {
  return i9 || (i9 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = Gr;
    t.__exportStar(JIe(), e), t.__exportStar(eMe(), e), t.__exportStar(tMe(), e), t.__exportStar(nMe(), e), t.__exportStar(aMe(), e), t.__exportStar(iMe(), e), t.__exportStar(oMe(), e), t.__exportStar(sMe(), e);
  }(a$)), a$;
}
var o9;
function gM() {
  return o9 || (o9 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = Gr;
    t.__exportStar(Tl(), e), t.__exportStar(XIe(), e), t.__exportStar(lMe(), e);
  }(Xx)), Xx;
}
var s$ = {}, wf = {}, s9;
function Cn() {
  if (s9) return wf;
  s9 = 1, Object.defineProperty(wf, "__esModule", { value: !0 }), wf.HttpStatus = void 0;
  var e;
  return function(t) {
    t[t.CONTINUE = 100] = "CONTINUE", t[t.SWITCHING_PROTOCOLS = 101] = "SWITCHING_PROTOCOLS", t[t.PROCESSING = 102] = "PROCESSING", t[t.EARLYHINTS = 103] = "EARLYHINTS", t[t.OK = 200] = "OK", t[t.CREATED = 201] = "CREATED", t[t.ACCEPTED = 202] = "ACCEPTED", t[t.NON_AUTHORITATIVE_INFORMATION = 203] = "NON_AUTHORITATIVE_INFORMATION", t[t.NO_CONTENT = 204] = "NO_CONTENT", t[t.RESET_CONTENT = 205] = "RESET_CONTENT", t[t.PARTIAL_CONTENT = 206] = "PARTIAL_CONTENT", t[t.MULTI_STATUS = 207] = "MULTI_STATUS", t[t.ALREADY_REPORTED = 208] = "ALREADY_REPORTED", t[t.CONTENT_DIFFERENT = 210] = "CONTENT_DIFFERENT", t[t.AMBIGUOUS = 300] = "AMBIGUOUS", t[t.MOVED_PERMANENTLY = 301] = "MOVED_PERMANENTLY", t[t.FOUND = 302] = "FOUND", t[t.SEE_OTHER = 303] = "SEE_OTHER", t[t.NOT_MODIFIED = 304] = "NOT_MODIFIED", t[t.TEMPORARY_REDIRECT = 307] = "TEMPORARY_REDIRECT", t[t.PERMANENT_REDIRECT = 308] = "PERMANENT_REDIRECT", t[t.BAD_REQUEST = 400] = "BAD_REQUEST", t[t.UNAUTHORIZED = 401] = "UNAUTHORIZED", t[t.PAYMENT_REQUIRED = 402] = "PAYMENT_REQUIRED", t[t.FORBIDDEN = 403] = "FORBIDDEN", t[t.NOT_FOUND = 404] = "NOT_FOUND", t[t.METHOD_NOT_ALLOWED = 405] = "METHOD_NOT_ALLOWED", t[t.NOT_ACCEPTABLE = 406] = "NOT_ACCEPTABLE", t[t.PROXY_AUTHENTICATION_REQUIRED = 407] = "PROXY_AUTHENTICATION_REQUIRED", t[t.REQUEST_TIMEOUT = 408] = "REQUEST_TIMEOUT", t[t.CONFLICT = 409] = "CONFLICT", t[t.GONE = 410] = "GONE", t[t.LENGTH_REQUIRED = 411] = "LENGTH_REQUIRED", t[t.PRECONDITION_FAILED = 412] = "PRECONDITION_FAILED", t[t.PAYLOAD_TOO_LARGE = 413] = "PAYLOAD_TOO_LARGE", t[t.URI_TOO_LONG = 414] = "URI_TOO_LONG", t[t.UNSUPPORTED_MEDIA_TYPE = 415] = "UNSUPPORTED_MEDIA_TYPE", t[t.REQUESTED_RANGE_NOT_SATISFIABLE = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE", t[t.EXPECTATION_FAILED = 417] = "EXPECTATION_FAILED", t[t.I_AM_A_TEAPOT = 418] = "I_AM_A_TEAPOT", t[t.MISDIRECTED = 421] = "MISDIRECTED", t[t.UNPROCESSABLE_ENTITY = 422] = "UNPROCESSABLE_ENTITY", t[t.LOCKED = 423] = "LOCKED", t[t.FAILED_DEPENDENCY = 424] = "FAILED_DEPENDENCY", t[t.PRECONDITION_REQUIRED = 428] = "PRECONDITION_REQUIRED", t[t.TOO_MANY_REQUESTS = 429] = "TOO_MANY_REQUESTS", t[t.UNRECOVERABLE_ERROR = 456] = "UNRECOVERABLE_ERROR", t[t.INTERNAL_SERVER_ERROR = 500] = "INTERNAL_SERVER_ERROR", t[t.NOT_IMPLEMENTED = 501] = "NOT_IMPLEMENTED", t[t.BAD_GATEWAY = 502] = "BAD_GATEWAY", t[t.SERVICE_UNAVAILABLE = 503] = "SERVICE_UNAVAILABLE", t[t.GATEWAY_TIMEOUT = 504] = "GATEWAY_TIMEOUT", t[t.HTTP_VERSION_NOT_SUPPORTED = 505] = "HTTP_VERSION_NOT_SUPPORTED", t[t.INSUFFICIENT_STORAGE = 507] = "INSUFFICIENT_STORAGE", t[t.LOOP_DETECTED = 508] = "LOOP_DETECTED";
  }(e || (wf.HttpStatus = e = {})), wf;
}
var Of = {}, l9;
function cMe() {
  if (l9) return Of;
  l9 = 1, Object.defineProperty(Of, "__esModule", { value: !0 }), Of.ShutdownSignal = void 0;
  var e;
  return function(t) {
    t.SIGHUP = "SIGHUP", t.SIGINT = "SIGINT", t.SIGQUIT = "SIGQUIT", t.SIGILL = "SIGILL", t.SIGTRAP = "SIGTRAP", t.SIGABRT = "SIGABRT", t.SIGBUS = "SIGBUS", t.SIGFPE = "SIGFPE", t.SIGSEGV = "SIGSEGV", t.SIGUSR2 = "SIGUSR2", t.SIGTERM = "SIGTERM";
  }(e || (Of.ShutdownSignal = e = {})), Of;
}
var Tf = {}, c9;
function uMe() {
  if (c9) return Tf;
  c9 = 1, Object.defineProperty(Tf, "__esModule", { value: !0 }), Tf.VersioningType = void 0;
  var e;
  return function(t) {
    t[t.URI = 0] = "URI", t[t.HEADER = 1] = "HEADER", t[t.MEDIA_TYPE = 2] = "MEDIA_TYPE", t[t.CUSTOM = 3] = "CUSTOM";
  }(e || (Tf.VersioningType = e = {})), Tf;
}
var u9;
function lC() {
  return u9 || (u9 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = Gr;
    t.__exportStar(hM(), e), t.__exportStar(Cn(), e), t.__exportStar(cMe(), e), t.__exportStar(uMe(), e);
  }(s$)), s$;
}
var l$ = {}, If = {}, Mf = {}, Af = {}, d9;
function Fq() {
  if (d9) return Af;
  d9 = 1, Object.defineProperty(Af, "__esModule", { value: !0 }), Af.IntrinsicException = void 0;
  class e extends Error {
  }
  return Af.IntrinsicException = e, Af;
}
var f9;
function Xn() {
  if (f9) return Mf;
  f9 = 1, Object.defineProperty(Mf, "__esModule", { value: !0 }), Mf.HttpException = void 0;
  const e = An(), t = Fq();
  class r extends t.IntrinsicException {
    /**
     * Instantiate a plain HTTP Exception.
     *
     * @example
     * throw new HttpException('message', HttpStatus.BAD_REQUEST)
     * throw new HttpException('custom message', HttpStatus.BAD_REQUEST, {
     *  cause: new Error('Cause Error'),
     * })
     *
     *
     * @usageNotes
     * The constructor arguments define the response and the HTTP response status code.
     * - The `response` argument (required) defines the JSON response body. alternatively, it can also be
     *  an error object that is used to define an error [cause](https://nodejs.org/en/blog/release/v16.9.0/#error-cause).
     * - The `status` argument (required) defines the HTTP Status Code.
     * - The `options` argument (optional) defines additional error options. Currently, it supports the `cause` attribute,
     *  and can be used as an alternative way to specify the error cause: `const error = new HttpException('description', 400, { cause: new Error() });`
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: the Http Status Code.
     * - `message`: a short description of the HTTP error by default; override this
     * by supplying a string in the `response` parameter.
     *
     * To override the entire JSON response body, pass an object to the `createBody`
     * method. Nest will serialize the object and return it as the JSON response body.
     *
     * The `status` argument is required, and should be a valid HTTP status code.
     * Best practice is to use the `HttpStatus` enum imported from `nestjs/common`.
     *
     * @param response string, object describing the error condition or the error cause.
     * @param status HTTP response status code.
     * @param options An object used to add an error cause.
     */
    constructor(a, i, o) {
      super(), this.response = a, this.status = i, this.options = o, this.initMessage(), this.initName(), this.initCause();
    }
    /**
     * Configures error chaining support
     *
     * @see https://nodejs.org/en/blog/release/v16.9.0/#error-cause
     * @see https://github.com/microsoft/TypeScript/issues/45167
     */
    initCause() {
      if (this.options?.cause) {
        this.cause = this.options.cause;
        return;
      }
    }
    initMessage() {
      (0, e.isString)(this.response) ? this.message = this.response : (0, e.isObject)(this.response) && (0, e.isString)(this.response.message) ? this.message = this.response.message : this.constructor && (this.message = this.constructor.name.match(/[A-Z][a-z]+|[0-9]+/g)?.join(" ") ?? "Error");
    }
    initName() {
      this.name = this.constructor.name;
    }
    getResponse() {
      return this.response;
    }
    getStatus() {
      return this.status;
    }
    static createBody(a, i, o) {
      return a ? (0, e.isString)(a) || Array.isArray(a) || (0, e.isNumber)(a) ? {
        message: a,
        error: i,
        statusCode: o
      } : a : {
        message: i,
        statusCode: o
      };
    }
    static getDescriptionFrom(a) {
      return (0, e.isString)(a) ? a : a?.description;
    }
    static getHttpExceptionOptionsFrom(a) {
      return (0, e.isString)(a) ? {} : a;
    }
    /**
     * Utility method used to extract the error description and httpExceptionOptions from the given argument.
     * This is used by inheriting classes to correctly parse both options.
     * @returns the error description and the httpExceptionOptions as an object.
     */
    static extractDescriptionAndOptionsFrom(a) {
      const i = (0, e.isString)(a) ? a : a?.description, o = (0, e.isString)(a) ? {} : a;
      return {
        description: i,
        httpExceptionOptions: o
      };
    }
  }
  return Mf.HttpException = r, Mf;
}
var p9;
function dMe() {
  if (p9) return If;
  p9 = 1, Object.defineProperty(If, "__esModule", { value: !0 }), If.BadGatewayException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate a `BadGatewayException` Exception.
     *
     * @example
     * `throw new BadGatewayException()`
     *
     * @usageNotes
     * The HTTP response status code will be 502.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 502.
     * - `message`: the string `'Bad Gateway'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "Bad Gateway") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.BAD_GATEWAY), e.HttpStatus.BAD_GATEWAY, s);
    }
  }
  return If.BadGatewayException = r, If;
}
var Pf = {}, m9;
function fMe() {
  if (m9) return Pf;
  m9 = 1, Object.defineProperty(Pf, "__esModule", { value: !0 }), Pf.BadRequestException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate a `BadRequestException` Exception.
     *
     * @example
     * `throw new BadRequestException()`
     *
     * @usageNotes
     * The HTTP response status code will be 400.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 400.
     * - `message`: the string `'Bad Request'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "Bad Request") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.BAD_REQUEST), e.HttpStatus.BAD_REQUEST, s);
    }
  }
  return Pf.BadRequestException = r, Pf;
}
var Rf = {}, v9;
function pMe() {
  if (v9) return Rf;
  v9 = 1, Object.defineProperty(Rf, "__esModule", { value: !0 }), Rf.ConflictException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate a `ConflictException` Exception.
     *
     * @example
     * `throw new ConflictException()`
     *
     * @usageNotes
     * The HTTP response status code will be 409.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 409.
     * - `message`: the string `'Conflict'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "Conflict") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.CONFLICT), e.HttpStatus.CONFLICT, s);
    }
  }
  return Rf.ConflictException = r, Rf;
}
var Nf = {}, h9;
function mMe() {
  if (h9) return Nf;
  h9 = 1, Object.defineProperty(Nf, "__esModule", { value: !0 }), Nf.ForbiddenException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate a `ForbiddenException` Exception.
     *
     * @example
     * `throw new ForbiddenException()`
     *
     * @usageNotes
     * The HTTP response status code will be 403.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 403.
     * - `message`: the string `'Forbidden'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "Forbidden") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.FORBIDDEN), e.HttpStatus.FORBIDDEN, s);
    }
  }
  return Nf.ForbiddenException = r, Nf;
}
var Df = {}, g9;
function vMe() {
  if (g9) return Df;
  g9 = 1, Object.defineProperty(Df, "__esModule", { value: !0 }), Df.GatewayTimeoutException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate a `GatewayTimeoutException` Exception.
     *
     * @example
     * `throw new GatewayTimeoutException()`
     *
     * @usageNotes
     * The HTTP response status code will be 504.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 504.
     * - `message`: the string `'Gateway Timeout'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "Gateway Timeout") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.GATEWAY_TIMEOUT), e.HttpStatus.GATEWAY_TIMEOUT, s);
    }
  }
  return Df.GatewayTimeoutException = r, Df;
}
var jf = {}, y9;
function hMe() {
  if (y9) return jf;
  y9 = 1, Object.defineProperty(jf, "__esModule", { value: !0 }), jf.GoneException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate a `GoneException` Exception.
     *
     * @example
     * `throw new GoneException()`
     *
     * @usageNotes
     * The HTTP response status code will be 410.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 410.
     * - `message`: the string `'Gone'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "Gone") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.GONE), e.HttpStatus.GONE, s);
    }
  }
  return jf.GoneException = r, jf;
}
var Lf = {}, b9;
function gMe() {
  if (b9) return Lf;
  b9 = 1, Object.defineProperty(Lf, "__esModule", { value: !0 }), Lf.HttpVersionNotSupportedException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate a `HttpVersionNotSupportedException` Exception.
     *
     * @example
     * `throw new HttpVersionNotSupportedException()`
     *
     * @usageNotes
     * The HTTP response status code will be 505.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 505.
     * - `message`: the string `'HTTP Version Not Supported'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "HTTP Version Not Supported") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.HTTP_VERSION_NOT_SUPPORTED), e.HttpStatus.HTTP_VERSION_NOT_SUPPORTED, s);
    }
  }
  return Lf.HttpVersionNotSupportedException = r, Lf;
}
var kf = {}, C9;
function yMe() {
  if (C9) return kf;
  C9 = 1, Object.defineProperty(kf, "__esModule", { value: !0 }), kf.ImATeapotException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate an `ImATeapotException` Exception.
     *
     * @example
     * `throw new ImATeapotException()`
     *
     * @usageNotes
     * The HTTP response status code will be 418.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 418.
     * - `message`: the string `"I'm a Teapot"` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "I'm a teapot") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.I_AM_A_TEAPOT), e.HttpStatus.I_AM_A_TEAPOT, s);
    }
  }
  return kf.ImATeapotException = r, kf;
}
var Ff = {}, S9;
function bMe() {
  if (S9) return Ff;
  S9 = 1, Object.defineProperty(Ff, "__esModule", { value: !0 }), Ff.InternalServerErrorException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate an `InternalServerErrorException` Exception.
     *
     * @example
     * `throw new InternalServerErrorException()`
     *
     * @usageNotes
     * The HTTP response status code will be 500.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 500.
     * - `message`: the string `'Internal Server Error'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "Internal Server Error") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.INTERNAL_SERVER_ERROR), e.HttpStatus.INTERNAL_SERVER_ERROR, s);
    }
  }
  return Ff.InternalServerErrorException = r, Ff;
}
var Bf = {}, x9;
function CMe() {
  if (x9) return Bf;
  x9 = 1, Object.defineProperty(Bf, "__esModule", { value: !0 }), Bf.MethodNotAllowedException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate a `MethodNotAllowedException` Exception.
     *
     * @example
     * `throw new MethodNotAllowedException()`
     *
     * @usageNotes
     * The HTTP response status code will be 405.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 405.
     * - `message`: the string `'Method Not Allowed'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "Method Not Allowed") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.METHOD_NOT_ALLOWED), e.HttpStatus.METHOD_NOT_ALLOWED, s);
    }
  }
  return Bf.MethodNotAllowedException = r, Bf;
}
var zf = {}, $9;
function SMe() {
  if ($9) return zf;
  $9 = 1, Object.defineProperty(zf, "__esModule", { value: !0 }), zf.MisdirectedException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate a `MisdirectedException` Exception.
     *
     * @example
     * `throw new MisdirectedException()`
     *
     * @usageNotes
     * The HTTP response status code will be 421.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 421.
     * - `message`: the string `'Bad Gateway'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "Misdirected") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.MISDIRECTED), e.HttpStatus.MISDIRECTED, s);
    }
  }
  return zf.MisdirectedException = r, zf;
}
var Hf = {}, _9;
function xMe() {
  if (_9) return Hf;
  _9 = 1, Object.defineProperty(Hf, "__esModule", { value: !0 }), Hf.NotAcceptableException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate a `NotAcceptableException` Exception.
     *
     * @example
     * `throw new NotAcceptableException()`
     *
     * @usageNotes
     * The HTTP response status code will be 406.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 406.
     * - `error`: the string `'Not Acceptable'` by default; override this by supplying
     * a string in the `error` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "Not Acceptable") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.NOT_ACCEPTABLE), e.HttpStatus.NOT_ACCEPTABLE, s);
    }
  }
  return Hf.NotAcceptableException = r, Hf;
}
var Vf = {}, E9;
function $Me() {
  if (E9) return Vf;
  E9 = 1, Object.defineProperty(Vf, "__esModule", { value: !0 }), Vf.NotFoundException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate a `NotFoundException` Exception.
     *
     * @example
     * `throw new NotFoundException()`
     *
     * @usageNotes
     * The HTTP response status code will be 404.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 404.
     * - `message`: the string `'Not Found'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "Not Found") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.NOT_FOUND), e.HttpStatus.NOT_FOUND, s);
    }
  }
  return Vf.NotFoundException = r, Vf;
}
var Gf = {}, w9;
function _Me() {
  if (w9) return Gf;
  w9 = 1, Object.defineProperty(Gf, "__esModule", { value: !0 }), Gf.NotImplementedException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate a `NotImplementedException` Exception.
     *
     * @example
     * `throw new NotImplementedException()`
     *
     * @usageNotes
     * The HTTP response status code will be 501.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 501.
     * - `message`: the string `'Not Implemented'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     * @param error a short description of the HTTP error.
     */
    constructor(a, i = "Not Implemented") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.NOT_IMPLEMENTED), e.HttpStatus.NOT_IMPLEMENTED, s);
    }
  }
  return Gf.NotImplementedException = r, Gf;
}
var Uf = {}, O9;
function EMe() {
  if (O9) return Uf;
  O9 = 1, Object.defineProperty(Uf, "__esModule", { value: !0 }), Uf.PayloadTooLargeException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate a `PayloadTooLargeException` Exception.
     *
     * @example
     * `throw new PayloadTooLargeException()`
     *
     * @usageNotes
     * The HTTP response status code will be 413.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 413.
     * - `message`: the string `'Payload Too Large'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "Payload Too Large") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.PAYLOAD_TOO_LARGE), e.HttpStatus.PAYLOAD_TOO_LARGE, s);
    }
  }
  return Uf.PayloadTooLargeException = r, Uf;
}
var Wf = {}, T9;
function wMe() {
  if (T9) return Wf;
  T9 = 1, Object.defineProperty(Wf, "__esModule", { value: !0 }), Wf.PreconditionFailedException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate a `PreconditionFailedException` Exception.
     *
     * @example
     * `throw new PreconditionFailedException()`
     *
     * @usageNotes
     * The HTTP response status code will be 412.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 412.
     * - `message`: the string `'Precondition Failed'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "Precondition Failed") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.PRECONDITION_FAILED), e.HttpStatus.PRECONDITION_FAILED, s);
    }
  }
  return Wf.PreconditionFailedException = r, Wf;
}
var qf = {}, I9;
function OMe() {
  if (I9) return qf;
  I9 = 1, Object.defineProperty(qf, "__esModule", { value: !0 }), qf.RequestTimeoutException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate a `RequestTimeoutException` Exception.
     *
     * @example
     * `throw new RequestTimeoutException()`
     *
     * @usageNotes
     * The HTTP response status code will be 408.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 408.
     * - `message`: the string `'Request Timeout'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "Request Timeout") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.REQUEST_TIMEOUT), e.HttpStatus.REQUEST_TIMEOUT, s);
    }
  }
  return qf.RequestTimeoutException = r, qf;
}
var Kf = {}, M9;
function TMe() {
  if (M9) return Kf;
  M9 = 1, Object.defineProperty(Kf, "__esModule", { value: !0 }), Kf.ServiceUnavailableException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate a `ServiceUnavailableException` Exception.
     *
     * @example
     * `throw new ServiceUnavailableException()`
     *
     * @usageNotes
     * The HTTP response status code will be 503.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 503.
     * - `message`: the string `'Service Unavailable'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "Service Unavailable") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.SERVICE_UNAVAILABLE), e.HttpStatus.SERVICE_UNAVAILABLE, s);
    }
  }
  return Kf.ServiceUnavailableException = r, Kf;
}
var Yf = {}, A9;
function IMe() {
  if (A9) return Yf;
  A9 = 1, Object.defineProperty(Yf, "__esModule", { value: !0 }), Yf.UnauthorizedException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate an `UnauthorizedException` Exception.
     *
     * @example
     * `throw new UnauthorizedException()`
     *
     * @usageNotes
     * The HTTP response status code will be 401.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 401.
     * - `message`: the string `'Unauthorized'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "Unauthorized") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.UNAUTHORIZED), e.HttpStatus.UNAUTHORIZED, s);
    }
  }
  return Yf.UnauthorizedException = r, Yf;
}
var Zf = {}, P9;
function MMe() {
  if (P9) return Zf;
  P9 = 1, Object.defineProperty(Zf, "__esModule", { value: !0 }), Zf.UnprocessableEntityException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate an `UnprocessableEntityException` Exception.
     *
     * @example
     * `throw new UnprocessableEntityException()`
     *
     * @usageNotes
     * The HTTP response status code will be 422.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 422.
     * - `message`: the string `'Unprocessable Entity'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "Unprocessable Entity") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.UNPROCESSABLE_ENTITY), e.HttpStatus.UNPROCESSABLE_ENTITY, s);
    }
  }
  return Zf.UnprocessableEntityException = r, Zf;
}
var Xf = {}, R9;
function AMe() {
  if (R9) return Xf;
  R9 = 1, Object.defineProperty(Xf, "__esModule", { value: !0 }), Xf.UnsupportedMediaTypeException = void 0;
  const e = Cn(), t = Xn();
  class r extends t.HttpException {
    /**
     * Instantiate an `UnsupportedMediaTypeException` Exception.
     *
     * @example
     * `throw new UnsupportedMediaTypeException()`
     *
     * @usageNotes
     * The HTTP response status code will be 415.
     * - The `objectOrError` argument defines the JSON response body or the message string.
     * - The `descriptionOrOptions` argument contains either a short description of the HTTP error or an options object used to provide an underlying error cause.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: this will be the value 415.
     * - `message`: the string `'Unsupported Media Type'` by default; override this by supplying
     * a string in the `objectOrError` parameter.
     *
     * If the parameter `objectOrError` is a string, the response body will contain an
     * additional property, `error`, with a short description of the HTTP error. To override the
     * entire JSON response body, pass an object instead. Nest will serialize the object
     * and return it as the JSON response body.
     *
     * @param objectOrError string or object describing the error condition.
     * @param descriptionOrOptions either a short description of the HTTP error or an options object used to provide an underlying error cause
     */
    constructor(a, i = "Unsupported Media Type") {
      const { description: o, httpExceptionOptions: s } = t.HttpException.extractDescriptionAndOptionsFrom(i);
      super(t.HttpException.createBody(a, o, e.HttpStatus.UNSUPPORTED_MEDIA_TYPE), e.HttpStatus.UNSUPPORTED_MEDIA_TYPE, s);
    }
  }
  return Xf.UnsupportedMediaTypeException = r, Xf;
}
var N9;
function Bq() {
  return N9 || (N9 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = Gr;
    t.__exportStar(dMe(), e), t.__exportStar(fMe(), e), t.__exportStar(pMe(), e), t.__exportStar(mMe(), e), t.__exportStar(vMe(), e), t.__exportStar(hMe(), e), t.__exportStar(gMe(), e), t.__exportStar(Xn(), e), t.__exportStar(yMe(), e), t.__exportStar(bMe(), e), t.__exportStar(Fq(), e), t.__exportStar(CMe(), e), t.__exportStar(SMe(), e), t.__exportStar(xMe(), e), t.__exportStar($Me(), e), t.__exportStar(_Me(), e), t.__exportStar(EMe(), e), t.__exportStar(wMe(), e), t.__exportStar(OMe(), e), t.__exportStar(TMe(), e), t.__exportStar(IMe(), e), t.__exportStar(MMe(), e), t.__exportStar(AMe(), e);
  }(l$)), l$;
}
var c$ = {}, Jf = {};
const PMe = {}, RMe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: PMe
}, Symbol.toStringTag, { value: "Module" })), Qb = /* @__PURE__ */ p1(RMe);
var u$ = {}, wu = {}, Ul = {}, D9;
function NMe() {
  if (D9) return Ul;
  D9 = 1, Object.defineProperty(Ul, "__esModule", { value: !0 }), Ul.yellow = Ul.clc = void 0;
  const e = () => !process.env.NO_COLOR, t = (r) => (n) => e() ? r(n) : n;
  return Ul.clc = {
    bold: t((r) => `\x1B[1m${r}\x1B[0m`),
    green: t((r) => `\x1B[32m${r}\x1B[39m`),
    yellow: t((r) => `\x1B[33m${r}\x1B[39m`),
    red: t((r) => `\x1B[31m${r}\x1B[39m`),
    magentaBright: t((r) => `\x1B[95m${r}\x1B[39m`),
    cyanBright: t((r) => `\x1B[96m${r}\x1B[39m`)
  }, Ul.yellow = t((r) => `\x1B[38;5;3m${r}\x1B[39m`), Ul;
}
var d$ = {}, Ly = {}, j9;
function DMe() {
  if (j9) return Ly;
  j9 = 1, Object.defineProperty(Ly, "__esModule", { value: !0 }), Ly.isLogLevelEnabled = t;
  const e = {
    verbose: 0,
    debug: 1,
    log: 2,
    warn: 3,
    error: 4,
    fatal: 5
  };
  function t(r, n) {
    if (!n || Array.isArray(n) && n?.length === 0)
      return !1;
    if (n.includes(r))
      return !0;
    const a = n.map((o) => e[o]).sort((o, s) => s - o)?.[0];
    return e[r] >= a;
  }
  return Ly;
}
var L9;
function zq() {
  return L9 || (L9 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), Gr.__exportStar(DMe(), e);
  }(d$)), d$;
}
var k9;
function Hq() {
  if (k9) return wu;
  k9 = 1;
  var e;
  Object.defineProperty(wu, "__esModule", { value: !0 }), wu.ConsoleLogger = void 0;
  const t = Gr, r = Qb, n = Tl(), a = NMe(), i = An(), o = zq(), s = 5, l = [
    "log",
    "error",
    "warn",
    "debug",
    "verbose",
    "fatal"
  ], c = new Intl.DateTimeFormat(void 0, {
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    day: "2-digit",
    month: "2-digit"
  });
  let u = e = class {
    constructor(f, m) {
      let [h, g] = (0, i.isString)(f) ? [f, m] : m ? [void 0, m] : [f?.context, f];
      g = g ?? {}, g.logLevels ?? (g.logLevels = l), g.colors ?? (g.colors = g.colors ?? !g.json), g.prefix ?? (g.prefix = "Nest"), this.options = g, this.inspectOptions = this.getInspectOptions(), h && (this.context = h, this.originalContext = h);
    }
    log(f, ...m) {
      if (!this.isLevelEnabled("log"))
        return;
      const { messages: h, context: g } = this.getContextAndMessagesToPrint([
        f,
        ...m
      ]);
      this.printMessages(h, g, "log");
    }
    error(f, ...m) {
      if (!this.isLevelEnabled("error"))
        return;
      const { messages: h, context: g, stack: y } = this.getContextAndStackAndMessagesToPrint([f, ...m]);
      this.printMessages(h, g, "error", "stderr", y), this.printStackTrace(y);
    }
    warn(f, ...m) {
      if (!this.isLevelEnabled("warn"))
        return;
      const { messages: h, context: g } = this.getContextAndMessagesToPrint([
        f,
        ...m
      ]);
      this.printMessages(h, g, "warn");
    }
    debug(f, ...m) {
      if (!this.isLevelEnabled("debug"))
        return;
      const { messages: h, context: g } = this.getContextAndMessagesToPrint([
        f,
        ...m
      ]);
      this.printMessages(h, g, "debug");
    }
    verbose(f, ...m) {
      if (!this.isLevelEnabled("verbose"))
        return;
      const { messages: h, context: g } = this.getContextAndMessagesToPrint([
        f,
        ...m
      ]);
      this.printMessages(h, g, "verbose");
    }
    fatal(f, ...m) {
      if (!this.isLevelEnabled("fatal"))
        return;
      const { messages: h, context: g } = this.getContextAndMessagesToPrint([
        f,
        ...m
      ]);
      this.printMessages(h, g, "fatal");
    }
    /**
     * Set log levels
     * @param levels log levels
     */
    setLogLevels(f) {
      this.options || (this.options = {}), this.options.logLevels = f;
    }
    /**
     * Set logger context
     * @param context context
     */
    setContext(f) {
      this.context = f;
    }
    /**
     * Resets the logger context to the value that was passed in the constructor.
     */
    resetContext() {
      this.context = this.originalContext;
    }
    isLevelEnabled(f) {
      const m = this.options?.logLevels;
      return (0, o.isLogLevelEnabled)(f, m);
    }
    getTimestamp() {
      return c.format(Date.now());
    }
    printMessages(f, m = "", h = "log", g, y) {
      f.forEach((S) => {
        if (this.options.json) {
          this.printAsJson(S, {
            context: m,
            logLevel: h,
            writeStreamType: g,
            errorStack: y
          });
          return;
        }
        const x = this.formatPid(process.pid), b = this.formatContext(m), _ = this.updateAndGetTimestampDiff(), $ = h.toUpperCase().padStart(7, " "), w = this.formatMessage(h, S, x, $, b, _);
        process[g ?? "stdout"].write(w);
      });
    }
    printAsJson(f, m) {
      const h = {
        level: m.logLevel,
        pid: process.pid,
        timestamp: Date.now(),
        message: f
      };
      m.context && (h.context = m.context), m.errorStack && (h.stack = m.errorStack);
      const g = !this.options.colors && this.inspectOptions.compact === !0 ? JSON.stringify(h, this.stringifyReplacer) : (0, r.inspect)(h, this.inspectOptions);
      process[m.writeStreamType ?? "stdout"].write(`${g}
`);
    }
    formatPid(f) {
      return `[${this.options.prefix}] ${f}  - `;
    }
    formatContext(f) {
      return f ? (f = `[${f}] `, this.options.colors ? (0, a.yellow)(f) : f) : "";
    }
    formatMessage(f, m, h, g, y, S) {
      const x = this.stringifyMessage(m, f);
      return h = this.colorize(h, f), g = this.colorize(g, f), `${h}${this.getTimestamp()} ${g} ${y}${x}${S}
`;
    }
    stringifyMessage(f, m) {
      if ((0, i.isFunction)(f))
        return Function.prototype.toString.call(f).startsWith("class ") ? this.stringifyMessage(f.name, m) : this.stringifyMessage(f(), m);
      if (typeof f == "string")
        return this.colorize(f, m);
      const h = (0, r.inspect)(f, this.inspectOptions);
      return (0, i.isPlainObject)(f) ? `Object(${Object.keys(f).length}) ${h}` : Array.isArray(f) ? `Array(${f.length}) ${h}` : h;
    }
    colorize(f, m) {
      return !this.options.colors || this.options.json ? f : this.getColorByLogLevel(m)(f);
    }
    printStackTrace(f) {
      !f || this.options.json || process.stderr.write(`${f}
`);
    }
    updateAndGetTimestampDiff() {
      const m = e.lastTimestampAt && this.options?.timestamp ? this.formatTimestampDiff(Date.now() - e.lastTimestampAt) : "";
      return e.lastTimestampAt = Date.now(), m;
    }
    formatTimestampDiff(f) {
      const m = ` +${f}ms`;
      return this.options.colors ? (0, a.yellow)(m) : m;
    }
    getInspectOptions() {
      let f = this.options.breakLength;
      typeof f > "u" && (f = this.options.colors ? this.options.compact ? 1 / 0 : void 0 : this.options.compact === !1 ? void 0 : 1 / 0);
      const m = {
        depth: this.options.depth ?? s,
        sorted: this.options.sorted,
        showHidden: this.options.showHidden,
        compact: this.options.compact ?? !!this.options.json,
        colors: this.options.colors,
        breakLength: f
      };
      return this.options.maxArrayLength && (m.maxArrayLength = this.options.maxArrayLength), this.options.maxStringLength && (m.maxStringLength = this.options.maxStringLength), m;
    }
    stringifyReplacer(f, m) {
      return typeof m == "bigint" || typeof m == "symbol" ? m.toString() : m instanceof Map || m instanceof Set || m instanceof Error ? `${(0, r.inspect)(m, this.inspectOptions)}` : m;
    }
    getContextAndMessagesToPrint(f) {
      if (f?.length <= 1)
        return { messages: f, context: this.context };
      const m = f[f.length - 1];
      return (0, i.isString)(m) ? {
        context: m,
        messages: f.slice(0, f.length - 1)
      } : { messages: f, context: this.context };
    }
    getContextAndStackAndMessagesToPrint(f) {
      if (f.length === 2)
        return this.isStackFormat(f[1]) ? {
          messages: [f[0]],
          stack: f[1],
          context: this.context
        } : {
          messages: [f[0]],
          context: f[1]
        };
      const { messages: m, context: h } = this.getContextAndMessagesToPrint(f);
      if (m?.length <= 1)
        return { messages: m, context: h };
      const g = m[m.length - 1];
      return !(0, i.isString)(g) && !(0, i.isUndefined)(g) ? { messages: m, context: h } : {
        stack: g,
        messages: m.slice(0, m.length - 1),
        context: h
      };
    }
    isStackFormat(f) {
      return !(0, i.isString)(f) && !(0, i.isUndefined)(f) ? !1 : /^(.)+\n\s+at .+:\d+:\d+/.test(f);
    }
    getColorByLogLevel(f) {
      switch (f) {
        case "debug":
          return a.clc.magentaBright;
        case "warn":
          return a.clc.yellow;
        case "error":
          return a.clc.red;
        case "verbose":
          return a.clc.cyanBright;
        case "fatal":
          return a.clc.bold;
        default:
          return a.clc.green;
      }
    }
  };
  return wu.ConsoleLogger = u, wu.ConsoleLogger = u = e = t.__decorate([
    (0, n.Injectable)(),
    t.__param(0, (0, n.Optional)()),
    t.__param(1, (0, n.Optional)()),
    t.__metadata("design:paramtypes", [Object, Object])
  ], u), wu;
}
var Ou = {}, F9;
function yM() {
  if (F9) return Ou;
  F9 = 1;
  var e;
  Object.defineProperty(Ou, "__esModule", { value: !0 }), Ou.Logger = void 0;
  const t = Gr, r = Tl(), n = An(), a = Hq(), i = zq(), o = new a.ConsoleLogger(), s = new Intl.DateTimeFormat(void 0, {
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    day: "2-digit",
    month: "2-digit"
  });
  let l = e = class {
    constructor(u, d = {}) {
      this.context = u, this.options = d;
    }
    get localInstance() {
      return e.staticInstanceRef === o ? this.registerLocalInstanceRef() : e.staticInstanceRef instanceof e && Object.getPrototypeOf(e.staticInstanceRef).constructor === e ? this.registerLocalInstanceRef() : e.staticInstanceRef;
    }
    error(u, ...d) {
      d = this.context ? (d.length ? d : [void 0]).concat(this.context) : d, this.localInstance?.error(u, ...d);
    }
    log(u, ...d) {
      d = this.context ? d.concat(this.context) : d, this.localInstance?.log(u, ...d);
    }
    warn(u, ...d) {
      d = this.context ? d.concat(this.context) : d, this.localInstance?.warn(u, ...d);
    }
    debug(u, ...d) {
      d = this.context ? d.concat(this.context) : d, this.localInstance?.debug?.(u, ...d);
    }
    verbose(u, ...d) {
      d = this.context ? d.concat(this.context) : d, this.localInstance?.verbose?.(u, ...d);
    }
    fatal(u, ...d) {
      d = this.context ? d.concat(this.context) : d, this.localInstance?.fatal?.(u, ...d);
    }
    static error(u, ...d) {
      this.staticInstanceRef?.error(u, ...d);
    }
    static log(u, ...d) {
      this.staticInstanceRef?.log(u, ...d);
    }
    static warn(u, ...d) {
      this.staticInstanceRef?.warn(u, ...d);
    }
    static debug(u, ...d) {
      this.staticInstanceRef?.debug?.(u, ...d);
    }
    static verbose(u, ...d) {
      this.staticInstanceRef?.verbose?.(u, ...d);
    }
    static fatal(u, ...d) {
      this.staticInstanceRef?.fatal?.(u, ...d);
    }
    /**
     * Print buffered logs and detach buffer.
     */
    static flush() {
      this.isBufferAttached = !1, this.logBuffer.forEach((u) => u.methodRef(...u.arguments)), this.logBuffer = [];
    }
    /**
     * Attach buffer.
     * Turns on initialization logs buffering.
     */
    static attachBuffer() {
      this.isBufferAttached = !0;
    }
    /**
     * Detach buffer.
     * Turns off initialization logs buffering.
     */
    static detachBuffer() {
      this.isBufferAttached = !1;
    }
    static getTimestamp() {
      return s.format(Date.now());
    }
    static overrideLogger(u) {
      if (Array.isArray(u))
        return e.logLevels = u, this.staticInstanceRef?.setLogLevels?.(u);
      if ((0, n.isObject)(u)) {
        if (u instanceof e && u.constructor !== e) {
          const d = 'Using the "extends Logger" instruction is not allowed in Nest v9. Please, use "extends ConsoleLogger" instead.';
          throw this.staticInstanceRef?.error(d), new Error(d);
        }
        this.staticInstanceRef = u;
      } else
        this.staticInstanceRef = void 0;
    }
    static isLevelEnabled(u) {
      const d = e.logLevels;
      return (0, i.isLogLevelEnabled)(u, d);
    }
    registerLocalInstanceRef() {
      return this.localInstanceRef ? this.localInstanceRef : (this.localInstanceRef = new a.ConsoleLogger(this.context, {
        timestamp: this.options?.timestamp,
        logLevels: e.logLevels
      }), this.localInstanceRef);
    }
  };
  return Ou.Logger = l, l.logBuffer = new Array(), l.staticInstanceRef = o, l.WrapBuffer = (c, u, d) => {
    const f = d.value;
    d.value = function(...m) {
      if (e.isBufferAttached) {
        e.logBuffer.push({
          methodRef: f.bind(this),
          arguments: m
        });
        return;
      }
      return f.call(this, ...m);
    };
  }, t.__decorate([
    l.WrapBuffer,
    t.__metadata("design:type", Function),
    t.__metadata("design:paramtypes", [Object, Object]),
    t.__metadata("design:returntype", void 0)
  ], l.prototype, "error", null), t.__decorate([
    l.WrapBuffer,
    t.__metadata("design:type", Function),
    t.__metadata("design:paramtypes", [Object, Object]),
    t.__metadata("design:returntype", void 0)
  ], l.prototype, "log", null), t.__decorate([
    l.WrapBuffer,
    t.__metadata("design:type", Function),
    t.__metadata("design:paramtypes", [Object, Object]),
    t.__metadata("design:returntype", void 0)
  ], l.prototype, "warn", null), t.__decorate([
    l.WrapBuffer,
    t.__metadata("design:type", Function),
    t.__metadata("design:paramtypes", [Object, Object]),
    t.__metadata("design:returntype", void 0)
  ], l.prototype, "debug", null), t.__decorate([
    l.WrapBuffer,
    t.__metadata("design:type", Function),
    t.__metadata("design:paramtypes", [Object, Object]),
    t.__metadata("design:returntype", void 0)
  ], l.prototype, "verbose", null), t.__decorate([
    l.WrapBuffer,
    t.__metadata("design:type", Function),
    t.__metadata("design:paramtypes", [Object, Object]),
    t.__metadata("design:returntype", void 0)
  ], l.prototype, "fatal", null), t.__decorate([
    l.WrapBuffer,
    t.__metadata("design:type", Function),
    t.__metadata("design:paramtypes", [Object, Object]),
    t.__metadata("design:returntype", void 0)
  ], l, "error", null), t.__decorate([
    l.WrapBuffer,
    t.__metadata("design:type", Function),
    t.__metadata("design:paramtypes", [Object, Object]),
    t.__metadata("design:returntype", void 0)
  ], l, "log", null), t.__decorate([
    l.WrapBuffer,
    t.__metadata("design:type", Function),
    t.__metadata("design:paramtypes", [Object, Object]),
    t.__metadata("design:returntype", void 0)
  ], l, "warn", null), t.__decorate([
    l.WrapBuffer,
    t.__metadata("design:type", Function),
    t.__metadata("design:paramtypes", [Object, Object]),
    t.__metadata("design:returntype", void 0)
  ], l, "debug", null), t.__decorate([
    l.WrapBuffer,
    t.__metadata("design:type", Function),
    t.__metadata("design:paramtypes", [Object, Object]),
    t.__metadata("design:returntype", void 0)
  ], l, "verbose", null), t.__decorate([
    l.WrapBuffer,
    t.__metadata("design:type", Function),
    t.__metadata("design:paramtypes", [Object, Object]),
    t.__metadata("design:returntype", void 0)
  ], l, "fatal", null), Ou.Logger = l = e = t.__decorate([
    (0, r.Injectable)(),
    t.__param(0, (0, r.Optional)()),
    t.__param(1, (0, r.Optional)()),
    t.__metadata("design:paramtypes", [String, Object])
  ], l), Ou;
}
var B9;
function Vq() {
  return B9 || (B9 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = Gr;
    t.__exportStar(Hq(), e), t.__exportStar(yM(), e);
  }(u$)), u$;
}
var z9;
function jMe() {
  if (z9) return Jf;
  z9 = 1, Object.defineProperty(Jf, "__esModule", { value: !0 }), Jf.StreamableFile = void 0;
  const e = Qb, t = Qb, r = lC(), n = Vq(), a = An();
  class i {
    constructor(s, l = {}) {
      var c;
      this.options = l, this.logger = new n.Logger("StreamableFile"), this.handleError = (u, d) => {
        if (!d.destroyed) {
          if (d.headersSent) {
            d.end();
            return;
          }
          d.statusCode = r.HttpStatus.BAD_REQUEST, d.send(u.message);
        }
      }, this.logError = (u) => {
        this.logger.error(u);
      }, t.types.isUint8Array(s) ? (this.stream = new e.Readable(), this.stream.push(s), this.stream.push(null), (c = this.options).length ?? (c.length = s.length)) : s.pipe && (0, a.isFunction)(s.pipe) && (this.stream = s);
    }
    getStream() {
      return this.stream;
    }
    getHeaders() {
      const { type: s = "application/octet-stream", disposition: l = void 0, length: c = void 0 } = this.options;
      return {
        type: s,
        disposition: l,
        length: c
      };
    }
    get errorHandler() {
      return this.handleError;
    }
    setErrorHandler(s) {
      return this.handleError = s, this;
    }
    get errorLogger() {
      return this.logError;
    }
    setErrorLogger(s) {
      return this.logError = s, this;
    }
  }
  return Jf.StreamableFile = i, Jf;
}
var H9;
function Gq() {
  return H9 || (H9 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), Gr.__exportStar(jMe(), e);
  }(c$)), c$;
}
var f$ = {}, p$ = {}, V9;
function LMe() {
  return V9 || (V9 = 1, Object.defineProperty(p$, "__esModule", { value: !0 })), p$;
}
var m$ = {}, G9;
function kMe() {
  return G9 || (G9 = 1, Object.defineProperty(m$, "__esModule", { value: !0 })), m$;
}
var v$ = {}, U9;
function FMe() {
  return U9 || (U9 = 1, Object.defineProperty(v$, "__esModule", { value: !0 })), v$;
}
var h$ = {}, W9;
function BMe() {
  return W9 || (W9 = 1, Object.defineProperty(h$, "__esModule", { value: !0 })), h$;
}
var g$ = {}, q9;
function zMe() {
  return q9 || (q9 = 1, Object.defineProperty(g$, "__esModule", { value: !0 })), g$;
}
var y$ = {}, K9;
function HMe() {
  return K9 || (K9 = 1, Object.defineProperty(y$, "__esModule", { value: !0 })), y$;
}
var b$ = {}, Y9;
function VMe() {
  return Y9 || (Y9 = 1, Object.defineProperty(b$, "__esModule", { value: !0 })), b$;
}
var C$ = {}, Z9;
function GMe() {
  return Z9 || (Z9 = 1, Object.defineProperty(C$, "__esModule", { value: !0 })), C$;
}
var S$ = {}, X9;
function UMe() {
  return X9 || (X9 = 1, Object.defineProperty(S$, "__esModule", { value: !0 })), S$;
}
var x$ = {}, J9;
function WMe() {
  return J9 || (J9 = 1, Object.defineProperty(x$, "__esModule", { value: !0 })), x$;
}
var $$ = {}, Q9;
function qMe() {
  return Q9 || (Q9 = 1, Object.defineProperty($$, "__esModule", { value: !0 })), $$;
}
var _$ = {}, e8;
function KMe() {
  return e8 || (e8 = 1, Object.defineProperty(_$, "__esModule", { value: !0 })), _$;
}
var E$ = {}, t8;
function YMe() {
  return t8 || (t8 = 1, Object.defineProperty(E$, "__esModule", { value: !0 })), E$;
}
var w$ = {}, r8;
function ZMe() {
  return r8 || (r8 = 1, Object.defineProperty(w$, "__esModule", { value: !0 })), w$;
}
var O$ = {}, n8;
function XMe() {
  return n8 || (n8 = 1, Object.defineProperty(O$, "__esModule", { value: !0 })), O$;
}
var T$ = {}, I$ = {}, a8;
function JMe() {
  return a8 || (a8 = 1, Object.defineProperty(I$, "__esModule", { value: !0 })), I$;
}
var M$ = {}, i8;
function QMe() {
  return i8 || (i8 = 1, Object.defineProperty(M$, "__esModule", { value: !0 })), M$;
}
var A$ = {}, o8;
function eAe() {
  return o8 || (o8 = 1, Object.defineProperty(A$, "__esModule", { value: !0 })), A$;
}
var P$ = {}, s8;
function tAe() {
  return s8 || (s8 = 1, Object.defineProperty(P$, "__esModule", { value: !0 })), P$;
}
var R$ = {}, l8;
function rAe() {
  return l8 || (l8 = 1, Object.defineProperty(R$, "__esModule", { value: !0 })), R$;
}
var c8;
function nAe() {
  return c8 || (c8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = Gr;
    t.__exportStar(JMe(), e), t.__exportStar(QMe(), e), t.__exportStar(eAe(), e), t.__exportStar(tAe(), e), t.__exportStar(rAe(), e);
  }(T$)), T$;
}
var N$ = {}, D$ = {}, u8;
function aAe() {
  return u8 || (u8 = 1, Object.defineProperty(D$, "__esModule", { value: !0 })), D$;
}
var j$ = {}, d8;
function iAe() {
  return d8 || (d8 = 1, Object.defineProperty(j$, "__esModule", { value: !0 })), j$;
}
var L$ = {}, f8;
function oAe() {
  return f8 || (f8 = 1, Object.defineProperty(L$, "__esModule", { value: !0 })), L$;
}
var k$ = {}, p8;
function sAe() {
  return p8 || (p8 = 1, Object.defineProperty(k$, "__esModule", { value: !0 })), k$;
}
var F$ = {}, m8;
function lAe() {
  return m8 || (m8 = 1, Object.defineProperty(F$, "__esModule", { value: !0 })), F$;
}
var v8;
function cAe() {
  return v8 || (v8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = Gr;
    t.__exportStar(aAe(), e), t.__exportStar(iAe(), e), t.__exportStar(oAe(), e), t.__exportStar(sAe(), e), t.__exportStar(lAe(), e);
  }(N$)), N$;
}
var B$ = {}, h8;
function uAe() {
  return h8 || (h8 = 1, Object.defineProperty(B$, "__esModule", { value: !0 })), B$;
}
var z$ = {}, g8;
function dAe() {
  return g8 || (g8 = 1, Object.defineProperty(z$, "__esModule", { value: !0 })), z$;
}
var H$ = {}, V$ = {}, y8;
function fAe() {
  return y8 || (y8 = 1, Object.defineProperty(V$, "__esModule", { value: !0 })), V$;
}
var G$ = {}, b8;
function pAe() {
  return b8 || (b8 = 1, Object.defineProperty(G$, "__esModule", { value: !0 })), G$;
}
var U$ = {}, C8;
function mAe() {
  return C8 || (C8 = 1, Object.defineProperty(U$, "__esModule", { value: !0 })), U$;
}
var W$ = {}, S8;
function vAe() {
  return S8 || (S8 = 1, Object.defineProperty(W$, "__esModule", { value: !0 })), W$;
}
var x8;
function hAe() {
  return x8 || (x8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = Gr;
    t.__exportStar(fAe(), e), t.__exportStar(pAe(), e), t.__exportStar(mAe(), e), t.__exportStar(vAe(), e);
  }(H$)), H$;
}
var q$ = {}, K$ = {}, $8;
function gAe() {
  return $8 || ($8 = 1, Object.defineProperty(K$, "__esModule", { value: !0 })), K$;
}
var Y$ = {}, _8;
function yAe() {
  return _8 || (_8 = 1, Object.defineProperty(Y$, "__esModule", { value: !0 })), Y$;
}
var Z$ = {}, E8;
function bAe() {
  return E8 || (E8 = 1, Object.defineProperty(Z$, "__esModule", { value: !0 })), Z$;
}
var X$ = {}, w8;
function CAe() {
  return w8 || (w8 = 1, Object.defineProperty(X$, "__esModule", { value: !0 })), X$;
}
var J$ = {}, O8;
function SAe() {
  return O8 || (O8 = 1, Object.defineProperty(J$, "__esModule", { value: !0 })), J$;
}
var Q$ = {}, T8;
function xAe() {
  return T8 || (T8 = 1, Object.defineProperty(Q$, "__esModule", { value: !0 })), Q$;
}
var e_ = {}, I8;
function $Ae() {
  return I8 || (I8 = 1, Object.defineProperty(e_, "__esModule", { value: !0 })), e_;
}
var t_ = {}, M8;
function _Ae() {
  return M8 || (M8 = 1, Object.defineProperty(t_, "__esModule", { value: !0 })), t_;
}
var A8;
function EAe() {
  return A8 || (A8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = Gr;
    t.__exportStar(gAe(), e), t.__exportStar(yAe(), e), t.__exportStar(bAe(), e), t.__exportStar(CAe(), e), t.__exportStar(SAe(), e), t.__exportStar(xAe(), e), t.__exportStar($Ae(), e), t.__exportStar(_Ae(), e);
  }(q$)), q$;
}
var r_ = {}, P8;
function wAe() {
  return P8 || (P8 = 1, Object.defineProperty(r_, "__esModule", { value: !0 })), r_;
}
var n_ = {}, R8;
function OAe() {
  return R8 || (R8 = 1, Object.defineProperty(n_, "__esModule", { value: !0 })), n_;
}
var a_ = {}, N8;
function TAe() {
  return N8 || (N8 = 1, Object.defineProperty(a_, "__esModule", { value: !0 })), a_;
}
var i_ = {}, D8;
function IAe() {
  return D8 || (D8 = 1, Object.defineProperty(i_, "__esModule", { value: !0 })), i_;
}
var Qf = {}, j8;
function MAe() {
  if (j8) return Qf;
  j8 = 1, Object.defineProperty(Qf, "__esModule", { value: !0 }), Qf.Scope = void 0;
  var e;
  return function(t) {
    t[t.DEFAULT = 0] = "DEFAULT", t[t.TRANSIENT = 1] = "TRANSIENT", t[t.REQUEST = 2] = "REQUEST";
  }(e || (Qf.Scope = e = {})), Qf;
}
var o_ = {}, L8;
function AAe() {
  return L8 || (L8 = 1, Object.defineProperty(o_, "__esModule", { value: !0 })), o_;
}
var ep = {}, k8;
function PAe() {
  return k8 || (k8 = 1, Object.defineProperty(ep, "__esModule", { value: !0 }), ep.VERSION_NEUTRAL = void 0, ep.VERSION_NEUTRAL = Symbol("VERSION_NEUTRAL")), ep;
}
var s_ = {}, F8;
function RAe() {
  return F8 || (F8 = 1, Object.defineProperty(s_, "__esModule", { value: !0 })), s_;
}
var B8;
function NAe() {
  return B8 || (B8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = Gr;
    t.__exportStar(LMe(), e), t.__exportStar(kMe(), e), t.__exportStar(FMe(), e), t.__exportStar(BMe(), e), t.__exportStar(zMe(), e), t.__exportStar(HMe(), e), t.__exportStar(VMe(), e), t.__exportStar(GMe(), e), t.__exportStar(UMe(), e), t.__exportStar(WMe(), e), t.__exportStar(qMe(), e), t.__exportStar(KMe(), e), t.__exportStar(YMe(), e), t.__exportStar(ZMe(), e), t.__exportStar(XMe(), e), t.__exportStar(nAe(), e), t.__exportStar(cAe(), e), t.__exportStar(uAe(), e), t.__exportStar(dAe(), e), t.__exportStar(hAe(), e), t.__exportStar(EAe(), e), t.__exportStar(wAe(), e), t.__exportStar(OAe(), e), t.__exportStar(TAe(), e), t.__exportStar(IAe(), e), t.__exportStar(MAe(), e), t.__exportStar(AAe(), e), t.__exportStar(PAe(), e), t.__exportStar(RAe(), e);
  }(f$)), f$;
}
var l_ = {}, tp = {}, rp = {}, z8;
function Uq() {
  if (z8) return rp;
  z8 = 1, Object.defineProperty(rp, "__esModule", { value: !0 }), rp.randomStringGenerator = void 0;
  const e = vM(), t = () => (0, e.uid)(21);
  return rp.randomStringGenerator = t, rp;
}
var bo = {}, H8;
function DAe() {
  return H8 || (H8 = 1, Object.defineProperty(bo, "__esModule", { value: !0 }), bo.CONFIGURABLE_MODULE_ID = bo.ASYNC_METHOD_SUFFIX = bo.DEFAULT_FACTORY_CLASS_METHOD_KEY = bo.DEFAULT_METHOD_KEY = void 0, bo.DEFAULT_METHOD_KEY = "register", bo.DEFAULT_FACTORY_CLASS_METHOD_KEY = "create", bo.ASYNC_METHOD_SUFFIX = "Async", bo.CONFIGURABLE_MODULE_ID = "CONFIGURABLE_MODULE_ID"), bo;
}
var c_ = {}, ky = {}, V8;
function jAe() {
  if (V8) return ky;
  V8 = 1, Object.defineProperty(ky, "__esModule", { value: !0 }), ky.generateOptionsInjectionToken = t;
  const e = Uq();
  function t() {
    return `CONFIGURABLE_MODULE_OPTIONS[${(0, e.randomStringGenerator)()}]`;
  }
  return ky;
}
var Fy = {}, G8;
function LAe() {
  if (G8) return Fy;
  G8 = 1, Object.defineProperty(Fy, "__esModule", { value: !0 }), Fy.getInjectionProviders = n;
  const e = An();
  function t(a) {
    return !(0, e.isUndefined)(a.token) && !(0, e.isUndefined)(a.optional) && !a.prototype;
  }
  const r = (a) => t(a) ? a.token : a;
  function n(a, i) {
    const o = [];
    let s = i.map(r);
    for (; s.length > 0; ) {
      const l = (a ?? []).filter((c) => !o.includes(c) && // this prevents circular loops and duplication
      (s.includes(c) || s.includes(c?.provide)));
      o.push(...l), s = l.filter((c) => c?.inject).flatMap((c) => c.inject).map(r);
    }
    return o;
  }
  return Fy;
}
var U8;
function kAe() {
  return U8 || (U8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = Gr;
    t.__exportStar(jAe(), e), t.__exportStar(LAe(), e);
  }(c_)), c_;
}
var W8;
function FAe() {
  if (W8) return tp;
  W8 = 1, Object.defineProperty(tp, "__esModule", { value: !0 }), tp.ConfigurableModuleBuilder = void 0;
  const e = yM(), t = Uq(), r = DAe(), n = kAe();
  class a {
    constructor(o = {}, s) {
      this.options = o, this.logger = new e.Logger(a.name), s && (this.staticMethodKey = s.staticMethodKey, this.factoryClassMethodKey = s.factoryClassMethodKey, this.transformModuleDefinition = s.transformModuleDefinition, this.extras = s.extras);
    }
    /**
     * Registers the "extras" object (a set of extra options that can be used to modify the dynamic module definition).
     * Values you specify within the "extras" object will be used as default values (that can be overridden by module consumers).
     *
     * This method also applies the so-called "module definition transform function" that takes the auto-generated
     * dynamic module object ("DynamicModule") and the actual consumer "extras" object as input parameters.
     * The "extras" object consists of values explicitly specified by module consumers and default values.
     *
     * @example
     * ```typescript
     * .setExtras<{ isGlobal?: boolean }>({ isGlobal: false }, (definition, extras) =>
     *    ({ ...definition, global: extras.isGlobal })
     * )
     * ```
     */
    setExtras(o, s = (l) => l) {
      const l = new a(this.options, this);
      return l.extras = o, l.transformModuleDefinition = s, l;
    }
    /**
     * Dynamic modules must expose public static methods that let you pass in
     * configuration parameters (control the module's behavior from the outside).
     * Some frequently used names that you may have seen in other modules are:
     * "forRoot", "forFeature", "register", "configure".
     *
     * This method "setClassMethodName" lets you specify the name of the
     * method that will be auto-generated.
     *
     * @param key name of the method
     */
    setClassMethodName(o) {
      const s = new a(this.options, this);
      return s.staticMethodKey = o, s;
    }
    /**
     * Asynchronously configured modules (that rely on other modules, i.e. "ConfigModule")
     * let you pass the configuration factory class that will be registered and instantiated as a provider.
     * This provider then will be used to retrieve the module's configuration. To provide the configuration,
     * the corresponding factory method must be implemented.
     *
     * This method ("setFactoryMethodName") lets you control what method name will have to be
     * implemented by the config factory (default is "create").
     *
     * @param key name of the method
     */
    setFactoryMethodName(o) {
      const s = new a(this.options, this);
      return s.factoryClassMethodKey = o, s;
    }
    /**
     * Returns an object consisting of multiple properties that lets you
     * easily construct dynamic configurable modules. See "ConfigurableModuleHost" interface for more details.
     */
    build() {
      var o;
      return this.staticMethodKey ?? (this.staticMethodKey = r.DEFAULT_METHOD_KEY), this.factoryClassMethodKey ?? (this.factoryClassMethodKey = r.DEFAULT_FACTORY_CLASS_METHOD_KEY), (o = this.options).optionsInjectionToken ?? (o.optionsInjectionToken = this.options.moduleName ? this.constructInjectionTokenString() : (0, n.generateOptionsInjectionToken)()), this.transformModuleDefinition ?? (this.transformModuleDefinition = (s) => s), {
        ConfigurableModuleClass: this.createConfigurableModuleCls(),
        MODULE_OPTIONS_TOKEN: this.options.optionsInjectionToken,
        ASYNC_OPTIONS_TYPE: this.createTypeProxy("ASYNC_OPTIONS_TYPE"),
        OPTIONS_TYPE: this.createTypeProxy("OPTIONS_TYPE")
      };
    }
    constructInjectionTokenString() {
      return `${this.options.moduleName.trim().split(/(?=[A-Z])/).join("_").toUpperCase()}_MODULE_OPTIONS`;
    }
    createConfigurableModuleCls() {
      const o = this, s = this.staticMethodKey + r.ASYNC_METHOD_SUFFIX;
      class l {
        static [o.staticMethodKey](u) {
          const d = [
            {
              provide: o.options.optionsInjectionToken,
              useValue: this.omitExtras(u, o.extras)
            }
          ];
          return o.options.alwaysTransient && d.push({
            provide: r.CONFIGURABLE_MODULE_ID,
            useValue: (0, t.randomStringGenerator)()
          }), o.transformModuleDefinition({
            module: this,
            providers: d
          }, {
            ...o.extras,
            ...u
          });
        }
        static [s](u) {
          const d = this.createAsyncProviders(u);
          return o.options.alwaysTransient && d.push({
            provide: r.CONFIGURABLE_MODULE_ID,
            useValue: (0, t.randomStringGenerator)()
          }), o.transformModuleDefinition({
            module: this,
            imports: u.imports || [],
            providers: d
          }, {
            ...o.extras,
            ...u
          });
        }
        static omitExtras(u, d) {
          if (!d)
            return u;
          const f = {}, m = Object.keys(d);
          return Object.keys(u).filter((h) => !m.includes(h)).forEach((h) => {
            f[h] = u[h];
          }), f;
        }
        static createAsyncProviders(u) {
          return u.useExisting || u.useFactory ? u.inject && u.provideInjectionTokensFrom ? [
            this.createAsyncOptionsProvider(u),
            ...(0, n.getInjectionProviders)(u.provideInjectionTokensFrom, u.inject)
          ] : [this.createAsyncOptionsProvider(u)] : [
            this.createAsyncOptionsProvider(u),
            {
              provide: u.useClass,
              useClass: u.useClass
            }
          ];
        }
        static createAsyncOptionsProvider(u) {
          return u.useFactory ? {
            provide: o.options.optionsInjectionToken,
            useFactory: u.useFactory,
            inject: u.inject || []
          } : {
            provide: o.options.optionsInjectionToken,
            useFactory: async (d) => await d[o.factoryClassMethodKey](),
            inject: [u.useExisting || u.useClass]
          };
        }
      }
      return l;
    }
    createTypeProxy(o) {
      return new Proxy({}, {
        get: () => {
          throw new Error(`"${o}" is not supposed to be used as a value.`);
        }
      });
    }
  }
  return tp.ConfigurableModuleBuilder = a, tp;
}
var u_ = {}, d_ = {}, q8;
function BAe() {
  return q8 || (q8 = 1, Object.defineProperty(d_, "__esModule", { value: !0 })), d_;
}
var f_ = {}, K8;
function zAe() {
  return K8 || (K8 = 1, Object.defineProperty(f_, "__esModule", { value: !0 })), f_;
}
var p_ = {}, Y8;
function HAe() {
  return Y8 || (Y8 = 1, Object.defineProperty(p_, "__esModule", { value: !0 })), p_;
}
var Z8;
function VAe() {
  return Z8 || (Z8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = Gr;
    t.__exportStar(BAe(), e), t.__exportStar(zAe(), e), t.__exportStar(HAe(), e);
  }(u_)), u_;
}
var X8;
function GAe() {
  return X8 || (X8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = Gr;
    t.__exportStar(FAe(), e), t.__exportStar(VAe(), e);
  }(l_)), l_;
}
var m_ = {}, Tu = {}, J8;
function UAe() {
  if (J8) return Tu;
  J8 = 1, Object.defineProperty(Tu, "__esModule", { value: !0 }), Tu.DefaultValuePipe = void 0;
  const e = Gr, t = Vc(), r = An();
  let n = class {
    constructor(i) {
      this.defaultValue = i;
    }
    transform(i, o) {
      return (0, r.isNil)(i) || (0, r.isNumber)(i) && isNaN(i) ? this.defaultValue : i;
    }
  };
  return Tu.DefaultValuePipe = n, Tu.DefaultValuePipe = n = e.__decorate([
    (0, t.Injectable)(),
    e.__metadata("design:paramtypes", [Object])
  ], n), Tu;
}
var v_ = {}, np = {}, ap = {}, Q8;
function bM() {
  if (Q8) return ap;
  Q8 = 1, Object.defineProperty(ap, "__esModule", { value: !0 }), ap.FileValidator = void 0;
  class e {
    constructor(r) {
      this.validationOptions = r;
    }
  }
  return ap.FileValidator = e, ap;
}
var e5;
function Wq() {
  if (e5) return np;
  e5 = 1, Object.defineProperty(np, "__esModule", { value: !0 }), np.FileTypeValidator = void 0;
  const e = bM();
  class t extends e.FileValidator {
    buildErrorMessage(n) {
      return n?.mimetype ? `Validation failed (current file type is ${n.mimetype}, expected type is ${this.validationOptions.fileType})` : `Validation failed (expected type is ${this.validationOptions.fileType})`;
    }
    isValid(n) {
      return this.validationOptions ? !!n && "mimetype" in n && !!n.mimetype.match(this.validationOptions.fileType) : !0;
    }
  }
  return np.FileTypeValidator = t, np;
}
var ip = {}, t5;
function qq() {
  if (t5) return ip;
  t5 = 1, Object.defineProperty(ip, "__esModule", { value: !0 }), ip.MaxFileSizeValidator = void 0;
  const e = bM();
  class t extends e.FileValidator {
    buildErrorMessage(n) {
      return "message" in this.validationOptions ? typeof this.validationOptions.message == "function" ? this.validationOptions.message(this.validationOptions.maxSize) : this.validationOptions.message : n?.size ? `Validation failed (current file size is ${n.size}, expected size is less than ${this.validationOptions.maxSize})` : `Validation failed (expected size is less than ${this.validationOptions.maxSize})`;
    }
    isValid(n) {
      return !this.validationOptions || !n ? !0 : "size" in n && n.size < this.validationOptions.maxSize;
    }
  }
  return ip.MaxFileSizeValidator = t, ip;
}
var h_ = {}, r5;
function WAe() {
  return r5 || (r5 = 1, Object.defineProperty(h_, "__esModule", { value: !0 })), h_;
}
var Iu = {}, op = {}, n5;
function Zs() {
  if (n5) return op;
  n5 = 1, Object.defineProperty(op, "__esModule", { value: !0 }), op.HttpErrorByCode = void 0;
  const e = lC(), t = Bq();
  return op.HttpErrorByCode = {
    [e.HttpStatus.BAD_GATEWAY]: t.BadGatewayException,
    [e.HttpStatus.BAD_REQUEST]: t.BadRequestException,
    [e.HttpStatus.CONFLICT]: t.ConflictException,
    [e.HttpStatus.FORBIDDEN]: t.ForbiddenException,
    [e.HttpStatus.GATEWAY_TIMEOUT]: t.GatewayTimeoutException,
    [e.HttpStatus.GONE]: t.GoneException,
    [e.HttpStatus.I_AM_A_TEAPOT]: t.ImATeapotException,
    [e.HttpStatus.INTERNAL_SERVER_ERROR]: t.InternalServerErrorException,
    [e.HttpStatus.METHOD_NOT_ALLOWED]: t.MethodNotAllowedException,
    [e.HttpStatus.NOT_ACCEPTABLE]: t.NotAcceptableException,
    [e.HttpStatus.NOT_FOUND]: t.NotFoundException,
    [e.HttpStatus.NOT_IMPLEMENTED]: t.NotImplementedException,
    [e.HttpStatus.PAYLOAD_TOO_LARGE]: t.PayloadTooLargeException,
    [e.HttpStatus.PRECONDITION_FAILED]: t.PreconditionFailedException,
    [e.HttpStatus.REQUEST_TIMEOUT]: t.RequestTimeoutException,
    [e.HttpStatus.SERVICE_UNAVAILABLE]: t.ServiceUnavailableException,
    [e.HttpStatus.UNAUTHORIZED]: t.UnauthorizedException,
    [e.HttpStatus.UNPROCESSABLE_ENTITY]: t.UnprocessableEntityException,
    [e.HttpStatus.UNSUPPORTED_MEDIA_TYPE]: t.UnsupportedMediaTypeException
  }, op;
}
var a5;
function Kq() {
  if (a5) return Iu;
  a5 = 1, Object.defineProperty(Iu, "__esModule", { value: !0 }), Iu.ParseFilePipe = void 0;
  const e = Gr, t = Tl(), r = lC(), n = Zs(), a = An();
  let i = class {
    constructor(s = {}) {
      const { exceptionFactory: l, errorHttpStatusCode: c = r.HttpStatus.BAD_REQUEST, validators: u = [], fileIsRequired: d } = s;
      this.exceptionFactory = l || ((f) => new n.HttpErrorByCode[c](f)), this.validators = u, this.fileIsRequired = d ?? !0;
    }
    async transform(s) {
      const l = this.thereAreNoFilesIn(s);
      if (l && this.fileIsRequired)
        throw this.exceptionFactory("File is required");
      return !l && this.validators.length && await this.validateFilesOrFile(s), s;
    }
    async validateFilesOrFile(s) {
      Array.isArray(s) ? await Promise.all(s.map((l) => this.validate(l))) : await this.validate(s);
    }
    thereAreNoFilesIn(s) {
      const l = Array.isArray(s) && (0, a.isEmpty)(s), c = (0, a.isObject)(s) && (0, a.isEmpty)(Object.keys(s));
      return (0, a.isUndefined)(s) || l || c;
    }
    async validate(s) {
      for (const l of this.validators)
        await this.validateOrThrow(s, l);
      return s;
    }
    async validateOrThrow(s, l) {
      if (!await l.isValid(s)) {
        const u = l.buildErrorMessage(s);
        throw this.exceptionFactory(u);
      }
    }
    /**
     * @returns list of validators used in this pipe.
     */
    getValidators() {
      return this.validators;
    }
  };
  return Iu.ParseFilePipe = i, Iu.ParseFilePipe = i = e.__decorate([
    (0, t.Injectable)(),
    e.__param(0, (0, t.Optional)()),
    e.__metadata("design:paramtypes", [Object])
  ], i), Iu;
}
var sp = {}, i5;
function qAe() {
  if (i5) return sp;
  i5 = 1, Object.defineProperty(sp, "__esModule", { value: !0 }), sp.ParseFilePipeBuilder = void 0;
  const e = Wq(), t = qq(), r = Kq();
  class n {
    constructor() {
      this.validators = [];
    }
    addMaxSizeValidator(i) {
      return this.addValidator(new t.MaxFileSizeValidator(i));
    }
    addFileTypeValidator(i) {
      return this.addValidator(new e.FileTypeValidator(i));
    }
    addValidator(i) {
      return this.validators.push(i), this;
    }
    build(i) {
      const o = new r.ParseFilePipe({
        ...i,
        validators: this.validators
      });
      return this.validators = [], o;
    }
  }
  return sp.ParseFilePipeBuilder = n, sp;
}
var o5;
function KAe() {
  return o5 || (o5 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = Gr;
    t.__exportStar(Wq(), e), t.__exportStar(bM(), e), t.__exportStar(qq(), e), t.__exportStar(WAe(), e), t.__exportStar(Kq(), e), t.__exportStar(qAe(), e);
  }(v_)), v_;
}
var Mu = {}, Au = {}, Pu = {}, Wl = {}, By = {}, s5;
function YAe() {
  if (s5) return By;
  s5 = 1, Object.defineProperty(By, "__esModule", { value: !0 });
  class e {
    constructor(r) {
      this.toConcat = r;
    }
    next() {
      if (this.toConcat.length === 0)
        return { done: !0 };
      const r = this.toConcat[0].next();
      return r.done ? (this.toConcat.shift(), this.next()) : r;
    }
  }
  return By.ConcatIterator = e, By;
}
var zy = {}, l5;
function ZAe() {
  if (l5) return zy;
  l5 = 1, Object.defineProperty(zy, "__esModule", { value: !0 });
  class e {
    constructor(r, n) {
      this.source = r, this.predicate = n;
    }
    next() {
      let r;
      do
        r = this.source.next();
      while (!r.done && !this.predicate(r.value));
      return r;
    }
  }
  return zy.FilterIterator = e, zy;
}
var Hy = {}, Ru = {}, c5;
function Yq() {
  if (c5) return Ru;
  c5 = 1, Object.defineProperty(Ru, "__esModule", { value: !0 });
  function e(n) {
    return typeof n == "object" && n !== null && typeof n.next == "function";
  }
  Ru.isIterator = e;
  function t(n) {
    return typeof n == "object" && n !== null && typeof n[Symbol.iterator] == "function";
  }
  Ru.isIterable = t;
  function r(n) {
    if (e(n))
      return n;
    if (t(n))
      return n[Symbol.iterator]();
    throw new Error("Passed collection is neither an Iterator nor an Iterable");
  }
  return Ru.toIterator = r, Ru;
}
var u5;
function XAe() {
  if (u5) return Hy;
  u5 = 1, Object.defineProperty(Hy, "__esModule", { value: !0 });
  const e = Yq();
  class t {
    constructor(n) {
      this.outer = n;
    }
    next() {
      if (this.inner) {
        const i = this.inner.next();
        if (!i.done)
          return i;
        this.inner = void 0;
      }
      const { value: n, done: a } = this.outer.next();
      return e.isIterable(n) ? (this.inner = n[Symbol.iterator](), this.next()) : { value: n, done: a };
    }
  }
  return Hy.FlattenIterator = t, Hy;
}
var Vy = {}, d5;
function JAe() {
  if (d5) return Vy;
  d5 = 1, Object.defineProperty(Vy, "__esModule", { value: !0 });
  class e {
    constructor(r, n) {
      this.source = r, this.iteratee = n;
    }
    next() {
      const { value: r, done: n } = this.source.next();
      return { value: !n && this.iteratee(r), done: n };
    }
  }
  return Vy.MapIterator = e, Vy;
}
var Gy = {}, f5;
function QAe() {
  if (f5) return Gy;
  f5 = 1, Object.defineProperty(Gy, "__esModule", { value: !0 });
  class e {
    /**
     * @param {Iterator<T>} source Source Iterator
     * @param {number} start Zero-based positive start index, inclusive
     * @param {number} end Zero-based positive end index, exclusive, defaults to end of iterator
     */
    constructor(r, n, a = 1 / 0) {
      this.source = r, this.start = n, this.end = a, this.i = 0;
    }
    next() {
      for (; this.i < this.start; ) {
        const r = this.source.next();
        if (r.done)
          return r;
        this.i++;
      }
      return this.i++, this.i >= this.end ? { done: !0 } : this.source.next();
    }
  }
  return Gy.SliceIterator = e, Gy;
}
var Uy = {}, p5;
function ePe() {
  if (p5) return Uy;
  p5 = 1, Object.defineProperty(Uy, "__esModule", { value: !0 });
  class e {
    constructor(r, n) {
      this.a = r, this.b = n;
    }
    next() {
      const r = this.a.next();
      if (r.done)
        return { done: !0 };
      const n = this.b.next();
      return n.done ? { done: !0 } : { value: [r.value, n.value], done: !1 };
    }
  }
  return Uy.ZipIterator = e, Uy;
}
var m5;
function tPe() {
  if (m5) return Wl;
  m5 = 1, Object.defineProperty(Wl, "__esModule", { value: !0 });
  const e = YAe(), t = ZAe(), r = XAe(), n = JAe(), a = QAe(), i = Yq(), o = ePe();
  class s {
    /**
     * @param source Iterator to wrap
     */
    constructor(d) {
      this.source = d;
    }
    /**
     * Returns a `{ value, done }` object that adheres to the Iterator protocol
     */
    next() {
      return this.source.next();
    }
    /**
     * The presence of this method makes the Iterator itself Iterable.
     * This makes it possible to pass it to `for of` and Iterable-accepting functions like `Array.from()`
     */
    [Symbol.iterator]() {
      return this;
    }
    /**
     * Returns a new Iterator by running each element thru iteratee
     */
    map(d) {
      return new s(new n.MapIterator(this.source, d));
    }
    filter(d) {
      return new s(new t.FilterIterator(this.source, d));
    }
    /**
     * Returns a new Iterator concatenating the Iterator with an additional Iterator or Iterable
     */
    concat(d) {
      return new s(new e.ConcatIterator([this.source, i.toIterator(d)]));
    }
    /**
     * Returns a new Iterator that emits slice of the source with n elements taken from the beginning
     *
     * @param limit The number of elements to take.
     */
    take(d) {
      return new s(new a.SliceIterator(this.source, 0, d + 1));
    }
    /**
     * Returns a new Iterator that emits slice of the source with n elements dropped from the beginning
     *
     * @param n The number of elements to drop.
     */
    drop(d) {
      return new s(new a.SliceIterator(this.source, d, 1 / 0));
    }
    /**
     * Returns a new Iterator that emits a slice of the source
     *
     * @param {number} start Zero-based positive start index, inclusive
     * @param {number} end Zero-based positive end index, exclusive, defaults to end of iterator
     */
    slice(d, f = 1 / 0) {
      return new s(new a.SliceIterator(this.source, d, f));
    }
    /**
     * Returns a new Iterator that flattens items emitted by the Iterator a single level deep
     */
    flatten() {
      return new s(new r.FlattenIterator(this.source));
    }
    reduce(d, f) {
      let m;
      if (f === void 0) {
        if (m = this.source.next(), m.done)
          throw new TypeError("Reduce of empty Iterator with no initial value");
        f = m.value;
      }
      for (; m = this.source.next(), !m.done; )
        f = d(f, m.value);
      return f;
    }
    find(d) {
      let f;
      for (; ; ) {
        if (f = this.source.next(), f.done)
          return;
        if (d(f.value))
          return f.value;
      }
    }
    /**
     * Iterates and checks if `value` is emitted by the Iterator
     *
     * @param value The value to search
     */
    includes(d) {
      let f;
      do
        if (f = this.source.next(), !f.done && f.value === d)
          return !0;
      while (!f.done);
      return !1;
    }
    /**
     * Iterates and checks if `predicate` returns truthy for any element emitted by the Iterator
     */
    some(d) {
      let f;
      do
        if (f = this.source.next(), !f.done && d(f.value))
          return !0;
      while (!f.done);
      return !1;
    }
    /**
     * Iterates and checks if `predicate` returns truthy for all elements emitted by the Iterator
     */
    every(d) {
      let f;
      do
        if (f = this.source.next(), !f.done && !d(f.value))
          return !1;
      while (!f.done);
      return !0;
    }
    /**
     * Iterates and invokes `iteratee` for every element emitted by the Iterator
     */
    forEach(d) {
      let f;
      for (; f = this.source.next(), !f.done; )
        d(f.value);
    }
    /**
     * Iterates and joins all elements emitted by the Iterator together as a string separated by an optional separator
     */
    join(d = ",") {
      let f = "", m;
      for (; m = this.source.next(), !m.done; )
        f += d + m.value;
      return f.substr(d.length);
    }
    /**
     * Iterates and returns all items emitted by the Iterator as an array.
     * Equivalent to passing the Iterator to `Array.from()`
     */
    toArray() {
      return Array.from(this);
    }
    /**
     * Iterates and returns all items emitted by the Iterator as an ES6 Set.
     * Equivalent to passing the Iterator to `new Set()`
     */
    toSet() {
      const d = /* @__PURE__ */ new Set();
      for (; ; ) {
        const { value: f, done: m } = this.next();
        if (m)
          return d;
        d.add(f);
      }
    }
    /**
     * Iterates and returns all `[key, value]` paris emitted by the Iterator as an ES6 Map.
     * Equivalent to passing the Iterator to `new Map()`
     */
    toMap() {
      return new Map(this);
    }
  }
  Wl.IteratorWithOperators = s;
  function l(u) {
    return new s(i.toIterator(u));
  }
  Wl.iterate = l;
  function c(u, d) {
    return new s(new o.ZipIterator(i.toIterator(u), i.toIterator(d)));
  }
  return Wl.zip = c, Wl.default = l, Wl;
}
var v5;
function rPe() {
  if (v5) return Pu;
  v5 = 1, Object.defineProperty(Pu, "__esModule", { value: !0 });
  const e = tPe();
  return Pu.iterate = e.iterate, Pu.zip = e.zip, Pu.default = e.iterate, Pu;
}
function nPe(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Wy = {}, h5;
function Zq() {
  if (h5) return Wy;
  h5 = 1, Object.defineProperty(Wy, "__esModule", { value: !0 }), Wy.loadPackage = n;
  const e = yM(), t = (a, i) => `The "${a}" package is missing. Please, make sure to install it to take advantage of ${i}.`, r = new e.Logger("PackageLoader");
  function n(a, i, o) {
    try {
      return o ? o() : nPe(a);
    } catch {
      r.error(t(a, i)), e.Logger.flush(), process.exit(1);
    }
  }
  return Wy;
}
var Il = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      this.groups = [], this.each = !1, this.context = void 0, this.type = t.type, this.name = t.name, this.target = t.target, this.propertyName = t.propertyName, this.constraints = t?.constraints, this.constraintCls = t.constraintCls, this.validationTypeOptions = t.validationTypeOptions, t.validationOptions && (this.message = t.validationOptions.message, this.groups = t.validationOptions.groups, this.always = t.validationOptions.always, this.each = t.validationOptions.each, this.context = t.validationOptions.context);
    }
    return e;
  }()
), aPe = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.transform = function(t) {
      var r = [];
      return Object.keys(t.properties).forEach(function(n) {
        t.properties[n].forEach(function(a) {
          var i = {
            message: a.message,
            groups: a.groups,
            always: a.always,
            each: a.each
          }, o = {
            type: a.type,
            name: a.name,
            target: t.name,
            propertyName: n,
            constraints: a.constraints,
            validationTypeOptions: a.options,
            validationOptions: i
          };
          r.push(new Il(o));
        });
      }), r;
    }, e;
  }()
);
function iPe(e) {
  return e instanceof Map ? Array.from(e.values()) : Array.isArray(e) ? e : Array.from(e);
}
function oPe() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof global < "u")
    return global;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
}
function g_(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var sPe = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, g5 = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), a, i = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = n.next()).done; ) i.push(a.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      a && !a.done && (r = n.return) && r.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return i;
}, lPe = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, i; n < a; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}, CM = (
  /** @class */
  function() {
    function e() {
      this.validationMetadatas = /* @__PURE__ */ new Map(), this.constraintMetadatas = /* @__PURE__ */ new Map();
    }
    return Object.defineProperty(e.prototype, "hasValidationMetaData", {
      get: function() {
        return !!this.validationMetadatas.size;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.addValidationSchema = function(t) {
      var r = this, n = new aPe().transform(t);
      n.forEach(function(a) {
        return r.addValidationMetadata(a);
      });
    }, e.prototype.addValidationMetadata = function(t) {
      var r = this.validationMetadatas.get(t.target);
      r ? r.push(t) : this.validationMetadatas.set(t.target, [t]);
    }, e.prototype.addConstraintMetadata = function(t) {
      var r = this.constraintMetadatas.get(t.target);
      r ? r.push(t) : this.constraintMetadatas.set(t.target, [t]);
    }, e.prototype.groupByPropertyName = function(t) {
      var r = {};
      return t.forEach(function(n) {
        r[n.propertyName] || (r[n.propertyName] = []), r[n.propertyName].push(n);
      }), r;
    }, e.prototype.getTargetValidationMetadatas = function(t, r, n, a, i) {
      var o, s, l = function(_) {
        return typeof _.always < "u" ? _.always : _.groups && _.groups.length ? !1 : n;
      }, c = function(_) {
        return !!(a && (!i || !i.length) && _.groups && _.groups.length);
      }, u = this.validationMetadatas.get(t) || [], d = u.filter(function(_) {
        return _.target !== t && _.target !== r ? !1 : l(_) ? !0 : c(_) ? !1 : i && i.length > 0 ? _.groups && !!_.groups.find(function($) {
          return i.indexOf($) !== -1;
        }) : !0;
      }), f = [];
      try {
        for (var m = sPe(this.validationMetadatas.entries()), h = m.next(); !h.done; h = m.next()) {
          var g = g5(h.value, 2), y = g[0], S = g[1];
          t.prototype instanceof y && f.push.apply(f, lPe([], g5(S), !1));
        }
      } catch (_) {
        o = { error: _ };
      } finally {
        try {
          h && !h.done && (s = m.return) && s.call(m);
        } finally {
          if (o) throw o.error;
        }
      }
      var x = f.filter(function(_) {
        return typeof _.target == "string" || _.target === t || _.target instanceof Function && !(t.prototype instanceof _.target) ? !1 : l(_) ? !0 : c(_) ? !1 : i && i.length > 0 ? _.groups && !!_.groups.find(function($) {
          return i.indexOf($) !== -1;
        }) : !0;
      }), b = x.filter(function(_) {
        return !d.find(function($) {
          return $.propertyName === _.propertyName && $.type === _.type;
        });
      });
      return d.concat(b);
    }, e.prototype.getTargetValidatorConstraints = function(t) {
      return this.constraintMetadatas.get(t) || [];
    }, e;
  }()
);
function uo() {
  var e = oPe();
  return e.classValidatorMetadataStorage || (e.classValidatorMetadataStorage = new CM()), e.classValidatorMetadataStorage;
}
var LE = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.toString = function(t, r, n, a) {
      var i = this;
      t === void 0 && (t = !1), r === void 0 && (r = !1), n === void 0 && (n = ""), a === void 0 && (a = !1);
      var o = t ? "\x1B[1m" : "", s = t ? "\x1B[22m" : "", l = function() {
        var d;
        return (a ? Object.values : Object.keys)((d = i.constraints) !== null && d !== void 0 ? d : {}).join(", ");
      }, c = function(d) {
        return " - property ".concat(o).concat(n).concat(d).concat(s, " has failed the following constraints: ").concat(o).concat(l()).concat(s, ` 
`);
      };
      if (r) {
        var u = Number.isInteger(+this.property) ? "[".concat(this.property, "]") : "".concat(n ? "." : "").concat(this.property);
        return this.constraints ? c(u) : this.children ? this.children.map(function(d) {
          return d.toString(t, !0, "".concat(n).concat(u), a);
        }).join("") : "";
      } else
        return "An instance of ".concat(o).concat(this.target ? this.target.constructor.name : "an object").concat(s, ` has failed the validation:
`) + (this.constraints ? c(this.property) : "") + (this.children ? this.children.map(function(d) {
          return d.toString(t, !0, i.property, a);
        }).join("") : "");
    }, e;
  }()
), na = (
  /** @class */
  function() {
    function e() {
    }
    return e.isValid = function(t) {
      var r = this;
      return t !== "isValid" && t !== "getMessage" && Object.keys(this).map(function(n) {
        return r[n];
      }).indexOf(t) !== -1;
    }, e.CUSTOM_VALIDATION = "customValidation", e.NESTED_VALIDATION = "nestedValidation", e.PROMISE_VALIDATION = "promiseValidation", e.CONDITIONAL_VALIDATION = "conditionalValidation", e.WHITELIST = "whitelistValidation", e.IS_DEFINED = "isDefined", e;
  }()
);
function cPe(e) {
  return Array.isArray(e) ? e.join(", ") : (typeof e == "symbol" && (e = e.description), "".concat(e));
}
var uPe = (
  /** @class */
  function() {
    function e() {
    }
    return e.replaceMessageSpecialTokens = function(t, r) {
      var n;
      return t instanceof Function ? n = t(r) : typeof t == "string" && (n = t), n && Array.isArray(r.constraints) && r.constraints.forEach(function(a, i) {
        n = n.replace(new RegExp("\\$constraint".concat(i + 1), "g"), cPe(a));
      }), n && r.value !== void 0 && r.value !== null && typeof r.value == "string" && (n = n.replace(/\$value/g, r.value)), n && (n = n.replace(/\$property/g, r.property)), n && (n = n.replace(/\$target/g, r.targetName)), n;
    }, e;
  }()
), lp = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), a, i = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = n.next()).done; ) i.push(a.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      a && !a.done && (r = n.return) && r.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return i;
}, y5 = (
  /** @class */
  function() {
    function e(t, r) {
      this.validator = t, this.validatorOptions = r, this.awaitingPromises = [], this.ignoreAsyncValidations = !1, this.metadataStorage = uo();
    }
    return e.prototype.execute = function(t, r, n) {
      var a = this, i, o;
      !this.metadataStorage.hasValidationMetaData && ((i = this.validatorOptions) === null || i === void 0 ? void 0 : i.enableDebugMessages) === !0 && console.warn(`No validation metadata found. No validation will be  performed. There are multiple possible reasons:
  - There may be multiple class-validator versions installed. You will need to flatten your dependencies to fix the issue.
  - This validation runs before any file with validation decorator was parsed by NodeJS.`);
      var s = this.validatorOptions ? this.validatorOptions.groups : void 0, l = this.validatorOptions && this.validatorOptions.strictGroups || !1, c = this.validatorOptions && this.validatorOptions.always || !1, u = ((o = this.validatorOptions) === null || o === void 0 ? void 0 : o.forbidUnknownValues) === void 0 || this.validatorOptions.forbidUnknownValues !== !1, d = this.metadataStorage.getTargetValidationMetadatas(t.constructor, r, c, l, s), f = this.metadataStorage.groupByPropertyName(d);
      if (this.validatorOptions && u && !d.length) {
        var m = new LE();
        (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.target === void 0 || this.validatorOptions.validationError.target === !0) && (m.target = t), m.value = void 0, m.property = void 0, m.children = [], m.constraints = { unknownValue: "an unknown value was passed to the validate function" }, n.push(m);
        return;
      }
      this.validatorOptions && this.validatorOptions.whitelist && this.whitelist(t, f, n), Object.keys(f).forEach(function(h) {
        var g = t[h], y = f[h].filter(function(x) {
          return x.type === na.IS_DEFINED;
        }), S = f[h].filter(function(x) {
          return x.type !== na.IS_DEFINED && x.type !== na.WHITELIST;
        });
        g instanceof Promise && S.find(function(x) {
          return x.type === na.PROMISE_VALIDATION;
        }) ? a.awaitingPromises.push(g.then(function(x) {
          a.performValidations(t, x, h, y, S, n);
        })) : a.performValidations(t, g, h, y, S, n);
      });
    }, e.prototype.whitelist = function(t, r, n) {
      var a = this, i = [];
      Object.keys(t).forEach(function(o) {
        (!r[o] || r[o].length === 0) && i.push(o);
      }), i.length > 0 && (this.validatorOptions && this.validatorOptions.forbidNonWhitelisted ? i.forEach(function(o) {
        var s, l = a.generateValidationError(t, t[o], o);
        l.constraints = (s = {}, s[na.WHITELIST] = "property ".concat(o, " should not exist"), s), l.children = void 0, n.push(l);
      }) : i.forEach(function(o) {
        return delete t[o];
      }));
    }, e.prototype.stripEmptyErrors = function(t) {
      var r = this;
      return t.filter(function(n) {
        if (n.children && (n.children = r.stripEmptyErrors(n.children)), Object.keys(n.constraints).length === 0) {
          if (n.children.length === 0)
            return !1;
          delete n.constraints;
        }
        return !0;
      });
    }, e.prototype.performValidations = function(t, r, n, a, i, o) {
      var s = i.filter(function(f) {
        return f.type === na.CUSTOM_VALIDATION;
      }), l = i.filter(function(f) {
        return f.type === na.NESTED_VALIDATION;
      }), c = i.filter(function(f) {
        return f.type === na.CONDITIONAL_VALIDATION;
      }), u = this.generateValidationError(t, r, n);
      o.push(u);
      var d = this.conditionalValidations(t, r, c);
      d && (this.customValidations(t, r, a, u), this.mapContexts(t, r, a, u), !(r === void 0 && this.validatorOptions && this.validatorOptions.skipUndefinedProperties === !0) && (r === null && this.validatorOptions && this.validatorOptions.skipNullProperties === !0 || r == null && this.validatorOptions && this.validatorOptions.skipMissingProperties === !0 || (this.customValidations(t, r, s, u), this.nestedValidations(r, l, u), this.mapContexts(t, r, i, u), this.mapContexts(t, r, s, u))));
    }, e.prototype.generateValidationError = function(t, r, n) {
      var a = new LE();
      return (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.target === void 0 || this.validatorOptions.validationError.target === !0) && (a.target = t), (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.value === void 0 || this.validatorOptions.validationError.value === !0) && (a.value = r), a.property = n, a.children = [], a.constraints = {}, a;
    }, e.prototype.conditionalValidations = function(t, r, n) {
      return n.map(function(a) {
        return a.constraints[0](t, r);
      }).reduce(function(a, i) {
        return a && i;
      }, !0);
    }, e.prototype.customValidations = function(t, r, n, a) {
      var i = this;
      n.forEach(function(o) {
        i.metadataStorage.getTargetValidatorConstraints(o.constraintCls).forEach(function(s) {
          if (!(s.async && i.ignoreAsyncValidations) && !(i.validatorOptions && i.validatorOptions.stopAtFirstError && Object.keys(a.constraints || {}).length > 0)) {
            var l = {
              targetName: t.constructor ? t.constructor.name : void 0,
              property: o.propertyName,
              object: t,
              value: r,
              constraints: o.constraints
            };
            if (!o.each || !(Array.isArray(r) || r instanceof Set || r instanceof Map)) {
              var c = s.instance.validate(r, l);
              if (g_(c)) {
                var u = c.then(function($) {
                  if (!$) {
                    var w = lp(i.createValidationError(t, r, o, s), 2), O = w[0], T = w[1];
                    a.constraints[O] = T, o.context && (a.contexts || (a.contexts = {}), a.contexts[O] = Object.assign(a.contexts[O] || {}, o.context));
                  }
                });
                i.awaitingPromises.push(u);
              } else if (!c) {
                var d = lp(i.createValidationError(t, r, o, s), 2), f = d[0], m = d[1];
                a.constraints[f] = m;
              }
              return;
            }
            var h = iPe(r), g = h.map(function($) {
              return s.instance.validate($, l);
            }), y = g.some(function($) {
              return g_($);
            });
            if (y) {
              var S = g.map(function($) {
                return g_($) ? $ : Promise.resolve($);
              }), x = Promise.all(S).then(function($) {
                var w = $.every(function(P) {
                  return P;
                });
                if (!w) {
                  var O = lp(i.createValidationError(t, r, o, s), 2), T = O[0], I = O[1];
                  a.constraints[T] = I, o.context && (a.contexts || (a.contexts = {}), a.contexts[T] = Object.assign(a.contexts[T] || {}, o.context));
                }
              });
              i.awaitingPromises.push(x);
              return;
            }
            var b = g.every(function($) {
              return $;
            });
            if (!b) {
              var _ = lp(i.createValidationError(t, r, o, s), 2), f = _[0], m = _[1];
              a.constraints[f] = m;
            }
          }
        });
      });
    }, e.prototype.nestedValidations = function(t, r, n) {
      var a = this;
      t !== void 0 && r.forEach(function(i) {
        if (!(i.type !== na.NESTED_VALIDATION && i.type !== na.PROMISE_VALIDATION) && !(a.validatorOptions && a.validatorOptions.stopAtFirstError && Object.keys(n.constraints || {}).length > 0))
          if (Array.isArray(t) || t instanceof Set || t instanceof Map) {
            var o = t instanceof Set ? Array.from(t) : t;
            o.forEach(function(d, f) {
              a.performValidations(t, d, f.toString(), [], r, n.children);
            });
          } else if (t instanceof Object) {
            var s = typeof i.target == "string" ? i.target : i.target.name;
            a.execute(t, s, n.children);
          } else {
            var l = lp(a.createValidationError(i.target, t, i), 2), c = l[0], u = l[1];
            n.constraints[c] = u;
          }
      });
    }, e.prototype.mapContexts = function(t, r, n, a) {
      var i = this;
      return n.forEach(function(o) {
        if (o.context) {
          var s = void 0;
          if (o.type === na.CUSTOM_VALIDATION) {
            var l = i.metadataStorage.getTargetValidatorConstraints(o.constraintCls);
            s = l[0];
          }
          var c = i.getConstraintType(o, s);
          a.constraints[c] && (a.contexts || (a.contexts = {}), a.contexts[c] = Object.assign(a.contexts[c] || {}, o.context));
        }
      });
    }, e.prototype.createValidationError = function(t, r, n, a) {
      var i = t.constructor ? t.constructor.name : void 0, o = this.getConstraintType(n, a), s = {
        targetName: i,
        property: n.propertyName,
        object: t,
        value: r,
        constraints: n.constraints
      }, l = n.message || "";
      !n.message && (!this.validatorOptions || this.validatorOptions && !this.validatorOptions.dismissDefaultMessages) && a && a.instance.defaultMessage instanceof Function && (l = a.instance.defaultMessage(s));
      var c = uPe.replaceMessageSpecialTokens(l, s);
      return [o, c];
    }, e.prototype.getConstraintType = function(t, r) {
      var n = r && r.name ? r.name : t.type;
      return n;
    }, e;
  }()
), dPe = function(e, t, r, n) {
  function a(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(u) {
      try {
        c(n.next(u));
      } catch (d) {
        o(d);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        o(d);
      }
    }
    function c(u) {
      u.done ? i(u.value) : a(u.value).then(s, l);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, fPe = function(e, t) {
  var r = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, c[0] && (r = 0)), r; ) try {
      if (n = 1, a && (i = c[0] & 2 ? a.return : c[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, c[1])).done) return i;
      switch (a = 0, i && (c = [c[0] & 2, i.value]), c[0]) {
        case 0:
        case 1:
          i = c;
          break;
        case 4:
          return r.label++, { value: c[1], done: !1 };
        case 5:
          r.label++, a = c[1], c = [0];
          continue;
        case 7:
          c = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (i = r.trys, !(i = i.length > 0 && i[i.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            r = 0;
            continue;
          }
          if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
            r.label = c[1];
            break;
          }
          if (c[0] === 6 && r.label < i[1]) {
            r.label = i[1], i = c;
            break;
          }
          if (i && r.label < i[2]) {
            r.label = i[2], r.ops.push(c);
            break;
          }
          i[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      c = t.call(e, r);
    } catch (u) {
      c = [6, u], a = 0;
    } finally {
      n = i = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}, Tc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.validate = function(t, r, n) {
      return this.coreValidate(t, r, n);
    }, e.prototype.validateOrReject = function(t, r, n) {
      return dPe(this, void 0, void 0, function() {
        var a;
        return fPe(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.coreValidate(t, r, n)];
            case 1:
              return a = i.sent(), a.length ? [2, Promise.reject(a)] : [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.validateSync = function(t, r, n) {
      var a = typeof t == "string" ? r : t, i = typeof t == "string" ? n : r, o = typeof t == "string" ? t : void 0, s = new y5(this, i);
      s.ignoreAsyncValidations = !0;
      var l = [];
      return s.execute(a, o, l), s.stripEmptyErrors(l);
    }, e.prototype.coreValidate = function(t, r, n) {
      var a = typeof t == "string" ? r : t, i = typeof t == "string" ? n : r, o = typeof t == "string" ? t : void 0, s = new y5(this, i), l = [];
      return s.execute(a, o, l), Promise.all(s.awaitingPromises).then(function() {
        return s.stripEmptyErrors(l);
      });
    }, e;
  }()
), pPe = new /** @class */
(function() {
  function e() {
    this.instances = [];
  }
  return e.prototype.get = function(t) {
    var r = this.instances.find(function(n) {
      return n.type === t;
    });
    return r || (r = { type: t, object: new t() }, this.instances.push(r)), r.object;
  }, e;
}())(), kE, O0;
function mPe(e, t) {
  kE = e, O0 = t;
}
function Gs(e) {
  if (kE)
    try {
      var t = kE.get(e);
      if (t || !O0 || !O0.fallback)
        return t;
    } catch (r) {
      if (!O0 || !O0.fallbackOnErrors)
        throw r;
    }
  return pPe.get(e);
}
function vPe(e) {
  return function(t, r) {
    var n = {
      type: na.WHITELIST,
      target: t.constructor,
      propertyName: r,
      validationOptions: e
    };
    uo().addValidationMetadata(new Il(n));
  };
}
var Xq = (
  /** @class */
  function() {
    function e(t, r, n) {
      n === void 0 && (n = !1), this.target = t, this.name = r, this.async = n;
    }
    return Object.defineProperty(e.prototype, "instance", {
      // -------------------------------------------------------------------------
      // Accessors
      // -------------------------------------------------------------------------
      /**
       * Instance of the target custom validation class which performs validation.
       */
      get: function() {
        return Gs(this.target);
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
function Jq(e) {
  var t;
  if (e.validator instanceof Function) {
    t = e.validator;
    var r = Gs(CM).getTargetValidatorConstraints(e.validator);
    if (r.length > 1)
      throw "More than one implementation of ValidatorConstraintInterface found for validator on: ".concat(e.target.name, ":").concat(e.propertyName);
  } else {
    var n = e.validator;
    t = /** @class */
    function() {
      function i() {
      }
      return i.prototype.validate = function(o, s) {
        return n.validate(o, s);
      }, i.prototype.defaultMessage = function(o) {
        return n.defaultMessage ? n.defaultMessage(o) : "";
      }, i;
    }(), uo().addConstraintMetadata(new Xq(t, e.name, e.async));
  }
  var a = {
    type: e.name && na.isValid(e.name) ? e.name : na.CUSTOM_VALIDATION,
    name: e.name,
    target: e.target,
    propertyName: e.propertyName,
    validationOptions: e.options,
    constraintCls: t,
    constraints: e.constraints
  };
  uo().addValidationMetadata(new Il(a));
}
function mt(e, t) {
  return function(r) {
    var n = t && t.each ? "each value in " : "";
    return e(n, r);
  };
}
function vt(e, t) {
  return function(r, n) {
    Jq({
      name: e.name,
      target: r.constructor,
      propertyName: n,
      options: t,
      constraints: e.constraints,
      validator: e.validator
    });
  };
}
var Qq = na.IS_DEFINED;
function eK(e) {
  return e != null;
}
function hPe(e) {
  return vt({
    name: Qq,
    validator: {
      validate: function(t) {
        return eK(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property should not be null or undefined";
      }, e)
    }
  }, e);
}
function gPe(e) {
  return function(t, r) {
    var n = {
      type: na.CONDITIONAL_VALIDATION,
      target: t.constructor,
      propertyName: r,
      constraints: [
        function(a, i) {
          return a[r] !== null && a[r] !== void 0;
        }
      ],
      validationOptions: e
    };
    uo().addValidationMetadata(new Il(n));
  };
}
function yPe(e) {
  return function(t) {
    var r = e && e.async, n = e && e.name ? e.name : "";
    n || (n = t.name, n || (n = n.replace(/\.?([A-Z]+)/g, function(i, o) {
      return "_" + o.toLowerCase();
    }).replace(/^_/, "")));
    var a = new Xq(t, n, r);
    uo().addConstraintMetadata(a);
  };
}
function bPe(e, t, r) {
  return function(n, a) {
    var i = {
      type: na.CUSTOM_VALIDATION,
      target: n.constructor,
      propertyName: a,
      constraintCls: e,
      constraints: Array.isArray(t) ? t : void 0,
      validationOptions: Array.isArray(t) ? r : t
    };
    uo().addValidationMetadata(new Il(i));
  };
}
function CPe(e, t) {
  return function(r, n) {
    var a = {
      type: na.CONDITIONAL_VALIDATION,
      target: r.constructor,
      propertyName: n,
      constraints: [e],
      validationOptions: t
    };
    uo().addValidationMetadata(new Il(a));
  };
}
var FE = function() {
  return FE = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, FE.apply(this, arguments);
};
function SPe(e) {
  var t = FE({}, e), r = t.each ? "each value in " : "";
  return t.message = t.message || r + "nested property $property must be either object or array", function(n, a) {
    var i = {
      type: na.NESTED_VALIDATION,
      target: n.constructor,
      propertyName: a,
      validationOptions: t
    };
    uo().addValidationMetadata(new Il(i));
  };
}
function xPe(e) {
  return function(t, r) {
    var n = {
      type: na.PROMISE_VALIDATION,
      target: t.constructor,
      propertyName: r,
      validationOptions: e
    };
    uo().addValidationMetadata(new Il(n));
  };
}
var BE = { exports: {} }, zE = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function r(a) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(o) {
      return typeof o;
    } : r = function(o) {
      return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, r(a);
  }
  function n(a) {
    var i = typeof a == "string" || a instanceof String;
    if (!i) {
      var o = r(a);
      throw a === null ? o = "null" : o === "object" && (o = a.constructor.name), new TypeError("Expected a string but received a ".concat(o));
    }
  }
  e.exports = t.default, e.exports.default = t.default;
})(zE, zE.exports);
var Pt = zE.exports, HE = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = arguments.length > 1 ? arguments[1] : void 0;
    for (var i in a)
      typeof n[i] > "u" && (n[i] = a[i]);
    return n;
  }
  e.exports = t.default, e.exports.default = t.default;
})(HE, HE.exports);
var si = HE.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var r = a(Pt), n = a(si);
  function a(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var i = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/, o = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/, s = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i, l = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i, c = {
    checkDMS: !1
  };
  function u(d, f) {
    if ((0, r.default)(d), f = (0, n.default)(f, c), !d.includes(",")) return !1;
    var m = d.split(",");
    return m[0].startsWith("(") && !m[1].endsWith(")") || m[1].endsWith(")") && !m[0].startsWith("(") ? !1 : f.checkDMS ? s.test(m[0]) && l.test(m[1]) : i.test(m[0]) && o.test(m[1]);
  }
  e.exports = t.default, e.exports.default = t.default;
})(BE, BE.exports);
var tK = BE.exports;
const $Pe = /* @__PURE__ */ Ut(tK);
var rK = "isLatLong";
function cC(e) {
  return typeof e == "string" && $Pe(e);
}
function _Pe(e) {
  return vt({
    name: rK,
    validator: {
      validate: function(t, r) {
        return cC(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a latitude,longitude string";
      }, e)
    }
  }, e);
}
var nK = "isLatitude";
function aK(e) {
  return (typeof e == "number" || typeof e == "string") && cC("".concat(e, ",0"));
}
function EPe(e) {
  return vt({
    name: nK,
    validator: {
      validate: function(t, r) {
        return aK(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a latitude string or number";
      }, e)
    }
  }, e);
}
var iK = "isLongitude";
function oK(e) {
  return (typeof e == "number" || typeof e == "string") && cC("0,".concat(e));
}
function wPe(e) {
  return vt({
    name: iK,
    validator: {
      validate: function(t, r) {
        return oK(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a longitude string or number";
      }, e)
    }
  }, e);
}
var sK = "equals";
function lK(e, t) {
  return e === t;
}
function OPe(e, t) {
  return vt({
    name: sK,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return lK(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be equal to $constraint1";
      }, t)
    }
  }, t);
}
var cK = "notEquals";
function uK(e, t) {
  return e !== t;
}
function TPe(e, t) {
  return vt({
    name: cK,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return uK(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property should not be equal to $constraint1";
      }, t)
    }
  }, t);
}
var dK = "isEmpty";
function fK(e) {
  return e === "" || e === null || e === void 0;
}
function IPe(e) {
  return vt({
    name: dK,
    validator: {
      validate: function(t, r) {
        return fK(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be empty";
      }, e)
    }
  }, e);
}
var pK = "isNotEmpty";
function mK(e) {
  return e !== "" && e !== null && e !== void 0;
}
function MPe(e) {
  return vt({
    name: pK,
    validator: {
      validate: function(t, r) {
        return mK(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property should not be empty";
      }, e)
    }
  }, e);
}
var vK = "isIn";
function hK(e, t) {
  return !Array.isArray(t) || t.some(function(r) {
    return r === e;
  });
}
function APe(e, t) {
  return vt({
    name: vK,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return hK(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be one of the following values: $constraint1";
      }, t)
    }
  }, t);
}
var gK = "isNotIn";
function yK(e, t) {
  return !Array.isArray(t) || !t.some(function(r) {
    return r === e;
  });
}
function PPe(e, t) {
  return vt({
    name: gK,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return yK(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property should not be one of the following values: $constraint1";
      }, t)
    }
  }, t);
}
var VE = { exports: {} }, GE = { exports: {} }, Pd = {}, Ln = {};
Object.defineProperty(Ln, "__esModule", {
  value: !0
});
Ln.commaDecimal = Ln.dotDecimal = Ln.bengaliLocales = Ln.farsiLocales = Ln.arabicLocales = Ln.englishLocales = Ln.decimal = Ln.alphanumeric = Ln.alpha = void 0;
var ii = {
  "en-US": /^[A-Z]+$/i,
  "az-AZ": /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
  "bg-BG": /^[А-Я]+$/i,
  "cs-CZ": /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  "da-DK": /^[A-ZÆØÅ]+$/i,
  "de-DE": /^[A-ZÄÖÜß]+$/i,
  "el-GR": /^[Α-ώ]+$/i,
  "es-ES": /^[A-ZÁÉÍÑÓÚÜ]+$/i,
  "fa-IR": /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
  "fi-FI": /^[A-ZÅÄÖ]+$/i,
  "fr-FR": /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  "it-IT": /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
  "ja-JP": /^[ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
  "nb-NO": /^[A-ZÆØÅ]+$/i,
  "nl-NL": /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
  "nn-NO": /^[A-ZÆØÅ]+$/i,
  "hu-HU": /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  "pl-PL": /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  "pt-PT": /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
  "ru-RU": /^[А-ЯЁ]+$/i,
  "sl-SI": /^[A-ZČĆĐŠŽ]+$/i,
  "sk-SK": /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  "sr-RS@latin": /^[A-ZČĆŽŠĐ]+$/i,
  "sr-RS": /^[А-ЯЂЈЉЊЋЏ]+$/i,
  "sv-SE": /^[A-ZÅÄÖ]+$/i,
  "th-TH": /^[ก-๐\s]+$/i,
  "tr-TR": /^[A-ZÇĞİıÖŞÜ]+$/i,
  "uk-UA": /^[А-ЩЬЮЯЄIЇҐі]+$/i,
  "vi-VN": /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
  "ko-KR": /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
  "ku-IQ": /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
  he: /^[א-ת]+$/,
  fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
  bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
  "hi-IN": /^[\u0900-\u0961]+[\u0972-\u097F]*$/i,
  "si-LK": /^[\u0D80-\u0DFF]+$/
};
Ln.alpha = ii;
var oi = {
  "en-US": /^[0-9A-Z]+$/i,
  "az-AZ": /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
  "bg-BG": /^[0-9А-Я]+$/i,
  "cs-CZ": /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  "da-DK": /^[0-9A-ZÆØÅ]+$/i,
  "de-DE": /^[0-9A-ZÄÖÜß]+$/i,
  "el-GR": /^[0-9Α-ω]+$/i,
  "es-ES": /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
  "fi-FI": /^[0-9A-ZÅÄÖ]+$/i,
  "fr-FR": /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  "it-IT": /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
  "ja-JP": /^[0-9０-９ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
  "hu-HU": /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  "nb-NO": /^[0-9A-ZÆØÅ]+$/i,
  "nl-NL": /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
  "nn-NO": /^[0-9A-ZÆØÅ]+$/i,
  "pl-PL": /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  "pt-PT": /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
  "ru-RU": /^[0-9А-ЯЁ]+$/i,
  "sl-SI": /^[0-9A-ZČĆĐŠŽ]+$/i,
  "sk-SK": /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  "sr-RS@latin": /^[0-9A-ZČĆŽŠĐ]+$/i,
  "sr-RS": /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
  "sv-SE": /^[0-9A-ZÅÄÖ]+$/i,
  "th-TH": /^[ก-๙\s]+$/i,
  "tr-TR": /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
  "uk-UA": /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
  "ko-KR": /^[0-9ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
  "ku-IQ": /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  "vi-VN": /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
  he: /^[0-9א-ת]+$/,
  fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
  bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
  "hi-IN": /^[\u0900-\u0963]+[\u0966-\u097F]*$/i,
  "si-LK": /^[0-9\u0D80-\u0DFF]+$/
};
Ln.alphanumeric = oi;
var Ya = {
  "en-US": ".",
  ar: "٫"
};
Ln.decimal = Ya;
var UE = ["AU", "GB", "HK", "IN", "NZ", "ZA", "ZM"];
Ln.englishLocales = UE;
for (var qy, y_ = 0; y_ < UE.length; y_++)
  qy = "en-".concat(UE[y_]), ii[qy] = ii["en-US"], oi[qy] = oi["en-US"], Ya[qy] = Ya["en-US"];
var WE = ["AE", "BH", "DZ", "EG", "IQ", "JO", "KW", "LB", "LY", "MA", "QM", "QA", "SA", "SD", "SY", "TN", "YE"];
Ln.arabicLocales = WE;
for (var Ky, b_ = 0; b_ < WE.length; b_++)
  Ky = "ar-".concat(WE[b_]), ii[Ky] = ii.ar, oi[Ky] = oi.ar, Ya[Ky] = Ya.ar;
var qE = ["IR", "AF"];
Ln.farsiLocales = qE;
for (var C_, S_ = 0; S_ < qE.length; S_++)
  C_ = "fa-".concat(qE[S_]), oi[C_] = oi.fa, Ya[C_] = Ya.ar;
var KE = ["BD", "IN"];
Ln.bengaliLocales = KE;
for (var Yy, x_ = 0; x_ < KE.length; x_++)
  Yy = "bn-".concat(KE[x_]), ii[Yy] = ii.bn, oi[Yy] = oi.bn, Ya[Yy] = Ya["en-US"];
var YE = ["ar-EG", "ar-LB", "ar-LY"];
Ln.dotDecimal = YE;
var ZE = ["bg-BG", "cs-CZ", "da-DK", "de-DE", "el-GR", "en-ZM", "es-ES", "fr-CA", "fr-FR", "id-ID", "it-IT", "ku-IQ", "hi-IN", "hu-HU", "nb-NO", "nn-NO", "nl-NL", "pl-PL", "pt-PT", "ru-RU", "si-LK", "sl-SI", "sr-RS@latin", "sr-RS", "sv-SE", "tr-TR", "uk-UA", "vi-VN"];
Ln.commaDecimal = ZE;
for (var $_ = 0; $_ < YE.length; $_++)
  Ya[YE[$_]] = Ya["en-US"];
for (var __ = 0; __ < ZE.length; __++)
  Ya[ZE[__]] = ",";
ii["fr-CA"] = ii["fr-FR"];
oi["fr-CA"] = oi["fr-FR"];
ii["pt-BR"] = ii["pt-PT"];
oi["pt-BR"] = oi["pt-PT"];
Ya["pt-BR"] = Ya["pt-PT"];
ii["pl-Pl"] = ii["pl-PL"];
oi["pl-Pl"] = oi["pl-PL"];
Ya["pl-Pl"] = Ya["pl-PL"];
ii["fa-AF"] = ii.fa;
Object.defineProperty(Pd, "__esModule", {
  value: !0
});
Pd.default = DPe;
Pd.locales = void 0;
var RPe = NPe(Pt), bK = Ln;
function NPe(e) {
  return e && e.__esModule ? e : { default: e };
}
function DPe(e, t) {
  (0, RPe.default)(e), t = t || {};
  var r = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(t.locale ? bK.decimal[t.locale] : ".", "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
  if (e === "" || e === "." || e === "," || e === "-" || e === "+")
    return !1;
  var n = parseFloat(e.replace(",", "."));
  return r.test(e) && (!t.hasOwnProperty("min") || n >= t.min) && (!t.hasOwnProperty("max") || n <= t.max) && (!t.hasOwnProperty("lt") || n < t.lt) && (!t.hasOwnProperty("gt") || n > t.gt);
}
var jPe = Object.keys(bK.decimal);
Pd.locales = jPe;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Pd);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i) {
    return (0, r.default)(i) ? parseFloat(i) : NaN;
  }
  e.exports = t.default, e.exports.default = t.default;
})(GE, GE.exports);
var CK = GE.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = a(Pt), n = a(CK);
  function a(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o, s) {
    return (0, r.default)(o), (0, n.default)(o) % parseInt(s, 10) === 0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(VE, VE.exports);
var SK = VE.exports;
const LPe = /* @__PURE__ */ Ut(SK);
var xK = "isDivisibleBy";
function $K(e, t) {
  return typeof e == "number" && typeof t == "number" && LPe(String(e), t);
}
function kPe(e, t) {
  return vt({
    name: xK,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return $K(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be divisible by $constraint1";
      }, t)
    }
  }, t);
}
var _K = "isPositive";
function EK(e) {
  return typeof e == "number" && e > 0;
}
function FPe(e) {
  return vt({
    name: _K,
    validator: {
      validate: function(t, r) {
        return EK(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a positive number";
      }, e)
    }
  }, e);
}
var wK = "isNegative";
function OK(e) {
  return typeof e == "number" && e < 0;
}
function BPe(e) {
  return vt({
    name: wK,
    validator: {
      validate: function(t, r) {
        return OK(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a negative number";
      }, e)
    }
  }, e);
}
var TK = "max";
function IK(e, t) {
  return typeof e == "number" && typeof t == "number" && e <= t;
}
function zPe(e, t) {
  return vt({
    name: TK,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return IK(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must not be greater than $constraint1";
      }, t)
    }
  }, t);
}
var MK = "min";
function AK(e, t) {
  return typeof e == "number" && typeof t == "number" && e >= t;
}
function HPe(e, t) {
  return vt({
    name: MK,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return AK(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must not be less than $constraint1";
      }, t)
    }
  }, t);
}
var PK = "minDate";
function RK(e, t) {
  return e instanceof Date && e.getTime() >= (t instanceof Date ? t : t()).getTime();
}
function VPe(e, t) {
  return vt({
    name: PK,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return RK(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return "minimal allowed date for " + r + "$property is $constraint1";
      }, t)
    }
  }, t);
}
var NK = "maxDate";
function DK(e, t) {
  return e instanceof Date && e.getTime() <= (t instanceof Date ? t : t()).getTime();
}
function GPe(e, t) {
  return vt({
    name: NK,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return DK(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return "maximal allowed date for " + r + "$property is $constraint1";
      }, t)
    }
  }, t);
}
var XE = { exports: {} }, JE = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function r(a) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(o) {
      return typeof o;
    } : r = function(o) {
      return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, r(a);
  }
  function n(a) {
    return r(a) === "object" && a !== null ? typeof a.toString == "function" ? a = a.toString() : a = "[object Object]" : (a === null || typeof a > "u" || isNaN(a) && !a.length) && (a = ""), String(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(JE, JE.exports);
var jK = JE.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = i(Pt), n = i(jK), a = i(si);
  function i(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var o = {
    ignoreCase: !1,
    minOccurrences: 1
  };
  function s(l, c, u) {
    return (0, r.default)(l), u = (0, a.default)(u, o), u.ignoreCase ? l.toLowerCase().split((0, n.default)(c).toLowerCase()).length > u.minOccurrences : l.split((0, n.default)(c)).length > u.minOccurrences;
  }
  e.exports = t.default, e.exports.default = t.default;
})(XE, XE.exports);
var LK = XE.exports;
const kK = /* @__PURE__ */ Ut(LK);
var FK = "contains";
function BK(e, t) {
  return typeof e == "string" && kK(e, t);
}
function UPe(e, t) {
  return vt({
    name: FK,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return BK(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must contain a $constraint1 string";
      }, t)
    }
  }, t);
}
var zK = "notContains";
function HK(e, t) {
  return typeof e == "string" && !kK(e, t);
}
function WPe(e, t) {
  return vt({
    name: zK,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return HK(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property should not contain a $constraint1 string";
      }, t)
    }
  }, t);
}
var Rh = {};
Object.defineProperty(Rh, "__esModule", {
  value: !0
});
var qPe = Rh.default = ZPe;
Rh.locales = void 0;
var KPe = YPe(Pt), QE = Ln;
function YPe(e) {
  return e && e.__esModule ? e : { default: e };
}
function ZPe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  (0, KPe.default)(e);
  var n = e, a = r.ignore;
  if (a)
    if (a instanceof RegExp)
      n = n.replace(a, "");
    else if (typeof a == "string")
      n = n.replace(new RegExp("[".concat(a.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
    else
      throw new Error("ignore should be instance of a String or RegExp");
  if (t in QE.alpha)
    return QE.alpha[t].test(n);
  throw new Error("Invalid locale '".concat(t, "'"));
}
var XPe = Object.keys(QE.alpha);
Rh.locales = XPe;
var VK = "isAlpha";
function GK(e, t) {
  return typeof e == "string" && qPe(e, t);
}
function JPe(e, t) {
  return vt({
    name: VK,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return GK(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must contain only letters (a-zA-Z)";
      }, t)
    }
  }, t);
}
var Nh = {};
Object.defineProperty(Nh, "__esModule", {
  value: !0
});
var QPe = Nh.default = r3e;
Nh.locales = void 0;
var e3e = t3e(Pt), ew = Ln;
function t3e(e) {
  return e && e.__esModule ? e : { default: e };
}
function r3e(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  (0, e3e.default)(e);
  var n = e, a = r.ignore;
  if (a)
    if (a instanceof RegExp)
      n = n.replace(a, "");
    else if (typeof a == "string")
      n = n.replace(new RegExp("[".concat(a.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
    else
      throw new Error("ignore should be instance of a String or RegExp");
  if (t in ew.alphanumeric)
    return ew.alphanumeric[t].test(n);
  throw new Error("Invalid locale '".concat(t, "'"));
}
var n3e = Object.keys(ew.alphanumeric);
Nh.locales = n3e;
var UK = "isAlphanumeric";
function WK(e, t) {
  return typeof e == "string" && QPe(e, t);
}
function a3e(e, t) {
  return vt({
    name: UK,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return WK(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must contain only letters and numbers";
      }, t)
    }
  }, t);
}
var tw = { exports: {} }, rw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = function(i, o) {
    return i.some(function(s) {
      return o === s;
    });
  }, n = r;
  t.default = n, e.exports = t.default, e.exports.default = t.default;
})(rw, rw.exports);
var i3e = rw.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var r = o(si), n = o(Pt), a = o(i3e), i = Ln;
  function o(d) {
    return d && d.__esModule ? d : { default: d };
  }
  function s(d) {
    var f = new RegExp("^[-+]?([0-9]+)?(\\".concat(i.decimal[d.locale], "[0-9]{").concat(d.decimal_digits, "})").concat(d.force_decimal ? "" : "?", "$"));
    return f;
  }
  var l = {
    force_decimal: !1,
    decimal_digits: "1,",
    locale: "en-US"
  }, c = ["", "-", "+"];
  function u(d, f) {
    if ((0, n.default)(d), f = (0, r.default)(f, l), f.locale in i.decimal)
      return !(0, a.default)(c, d.replace(/ /g, "")) && s(f).test(d);
    throw new Error("Invalid locale '".concat(f.locale, "'"));
  }
  e.exports = t.default, e.exports.default = t.default;
})(tw, tw.exports);
var qK = tw.exports;
const o3e = /* @__PURE__ */ Ut(qK);
var KK = "isDecimal";
function YK(e, t) {
  return typeof e == "string" && o3e(e, t);
}
function s3e(e, t) {
  return vt({
    name: KK,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return YK(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property is not a valid decimal number.";
      }, t)
    }
  }, t);
}
var nw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = /^[\x00-\x7F]+$/;
  function i(o) {
    return (0, r.default)(o), a.test(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(nw, nw.exports);
var ZK = nw.exports;
const l3e = /* @__PURE__ */ Ut(ZK);
var XK = "isAscii";
function JK(e) {
  return typeof e == "string" && l3e(e);
}
function c3e(e) {
  return vt({
    name: XK,
    validator: {
      validate: function(t, r) {
        return JK(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must contain only ASCII characters";
      }, e)
    }
  }, e);
}
var aw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var r = a(Pt), n = a(si);
  function a(c) {
    return c && c.__esModule ? c : { default: c };
  }
  var i = /[^A-Z0-9+\/=]/i, o = /^[A-Z0-9_\-]*$/i, s = {
    urlSafe: !1
  };
  function l(c, u) {
    (0, r.default)(c), u = (0, n.default)(u, s);
    var d = c.length;
    if (u.urlSafe)
      return o.test(c);
    if (d % 4 !== 0 || i.test(c))
      return !1;
    var f = c.indexOf("=");
    return f === -1 || f === d - 1 || f === d - 2 && c[d - 1] === "=";
  }
  e.exports = t.default, e.exports.default = t.default;
})(aw, aw.exports);
var SM = aw.exports;
const u3e = /* @__PURE__ */ Ut(SM);
var QK = "isBase64";
function eY(e) {
  return typeof e == "string" && u3e(e);
}
function d3e(e) {
  return vt({
    name: QK,
    validator: {
      validate: function(t, r) {
        return eY(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be base64 encoded";
      }, e)
    }
  }, e);
}
var iw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? a = function(l) {
      return typeof l;
    } : a = function(l) {
      return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
    }, a(o);
  }
  function i(o, s) {
    (0, r.default)(o);
    var l, c;
    a(s) === "object" ? (l = s.min || 0, c = s.max) : (l = arguments[1], c = arguments[2]);
    var u = encodeURI(o).split(/%..|./).length - 1;
    return u >= l && (typeof c > "u" || u <= c);
  }
  e.exports = t.default, e.exports.default = t.default;
})(iw, iw.exports);
var xM = iw.exports;
const f3e = /* @__PURE__ */ Ut(xM);
var tY = "isByteLength";
function rY(e, t, r) {
  return typeof e == "string" && f3e(e, { min: t, max: r });
}
function p3e(e, t, r) {
  return vt({
    name: tY,
    constraints: [e, t],
    validator: {
      validate: function(n, a) {
        return rY(n, a?.constraints[0], a?.constraints[1]);
      },
      defaultMessage: mt(function(n) {
        return n + "$property's byte length must fall into ($constraint1, $constraint2) range";
      }, r)
    }
  }, r);
}
var ow = { exports: {} }, sw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Pt);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i) {
    (0, r.default)(i);
    for (var o = i.replace(/[- ]+/g, ""), s = 0, l, c, u, d = o.length - 1; d >= 0; d--)
      l = o.substring(d, d + 1), c = parseInt(l, 10), u ? (c *= 2, c >= 10 ? s += c % 10 + 1 : s += c) : s += c, u = !u;
    return !!(s % 10 === 0 && o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(sw, sw.exports);
var nY = sw.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = a(Pt), n = a(nY);
  function a(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var i = {
    amex: /^3[47][0-9]{13}$/,
    dinersclub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
    discover: /^6(?:011|5[0-9][0-9])[0-9]{12,15}$/,
    jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
    mastercard: /^5[1-5][0-9]{2}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
    // /^[25][1-7][0-9]{14}$/;
    unionpay: /^(6[27][0-9]{14}|^(81[0-9]{14,17}))$/,
    visa: /^(?:4[0-9]{12})(?:[0-9]{3,6})?$/
  }, o = /^(?:4[0-9]{12}(?:[0-9]{3,6})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12,15}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14}|^(81[0-9]{14,17}))$/;
  function s(l) {
    var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, r.default)(l);
    var u = c.provider, d = l.replace(/[- ]+/g, "");
    if (u && u.toLowerCase() in i) {
      if (!i[u.toLowerCase()].test(d))
        return !1;
    } else {
      if (u && !(u.toLowerCase() in i))
        throw new Error("".concat(u, " is not a valid credit card provider."));
      if (!o.test(d))
        return !1;
    }
    return (0, n.default)(l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(ow, ow.exports);
var aY = ow.exports;
const m3e = /* @__PURE__ */ Ut(aY);
var iY = "isCreditCard";
function oY(e) {
  return typeof e == "string" && m3e(e);
}
function v3e(e) {
  return vt({
    name: iY,
    validator: {
      validate: function(t, r) {
        return oY(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a credit card";
      }, e)
    }
  }, e);
}
var lw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = a(si), n = a(Pt);
  function a(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function i(l) {
    var c = "\\d{".concat(l.digits_after_decimal[0], "}");
    l.digits_after_decimal.forEach(function(x, b) {
      b !== 0 && (c = "".concat(c, "|\\d{").concat(x, "}"));
    });
    var u = "(".concat(l.symbol.replace(/\W/, function(x) {
      return "\\".concat(x);
    }), ")").concat(l.require_symbol ? "" : "?"), d = "-?", f = "[1-9]\\d*", m = "[1-9]\\d{0,2}(\\".concat(l.thousands_separator, "\\d{3})*"), h = ["0", f, m], g = "(".concat(h.join("|"), ")?"), y = "(\\".concat(l.decimal_separator, "(").concat(c, "))").concat(l.require_decimal ? "" : "?"), S = g + (l.allow_decimal || l.require_decimal ? y : "");
    return l.allow_negatives && !l.parens_for_negatives && (l.negative_sign_after_digits ? S += d : l.negative_sign_before_digits && (S = d + S)), l.allow_negative_sign_placeholder ? S = "( (?!\\-))?".concat(S) : l.allow_space_after_symbol ? S = " ?".concat(S) : l.allow_space_after_digits && (S += "( (?!$))?"), l.symbol_after_digits ? S += u : S = u + S, l.allow_negatives && (l.parens_for_negatives ? S = "(\\(".concat(S, "\\)|").concat(S, ")") : l.negative_sign_before_digits || l.negative_sign_after_digits || (S = d + S)), new RegExp("^(?!-? )(?=.*\\d)".concat(S, "$"));
  }
  var o = {
    symbol: "$",
    require_symbol: !1,
    allow_space_after_symbol: !1,
    symbol_after_digits: !1,
    allow_negatives: !0,
    parens_for_negatives: !1,
    negative_sign_before_digits: !1,
    negative_sign_after_digits: !1,
    allow_negative_sign_placeholder: !1,
    thousands_separator: ",",
    decimal_separator: ".",
    allow_decimal: !0,
    require_decimal: !1,
    digits_after_decimal: [2],
    allow_space_after_digits: !1
  };
  function s(l, c) {
    return (0, n.default)(l), c = (0, r.default)(c, o), i(c).test(l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(lw, lw.exports);
var sY = lw.exports;
const h3e = /* @__PURE__ */ Ut(sY);
var lY = "isCurrency";
function cY(e, t) {
  return typeof e == "string" && h3e(e, t);
}
function g3e(e, t) {
  return vt({
    name: lY,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return cY(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be a currency";
      }, t)
    }
  }, t);
}
var cw = { exports: {} }, uw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = a(Pt), n = a(si);
  function a(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var i = {
    require_tld: !0,
    allow_underscores: !1,
    allow_trailing_dot: !1,
    allow_numeric_tld: !1,
    allow_wildcard: !1,
    ignore_max_length: !1
  };
  function o(s, l) {
    (0, r.default)(s), l = (0, n.default)(l, i), l.allow_trailing_dot && s[s.length - 1] === "." && (s = s.substring(0, s.length - 1)), l.allow_wildcard === !0 && s.indexOf("*.") === 0 && (s = s.substring(2));
    var c = s.split("."), u = c[c.length - 1];
    return l.require_tld && (c.length < 2 || !l.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(u) || /\s/.test(u)) || !l.allow_numeric_tld && /^\d+$/.test(u) ? !1 : c.every(function(d) {
      return !(d.length > 63 && !l.ignore_max_length || !/^[a-z_\u00a1-\uffff0-9-]+$/i.test(d) || /[\uff01-\uff5e]/.test(d) || /^-|-$/.test(d) || !l.allow_underscores && /_/.test(d));
    });
  }
  e.exports = t.default, e.exports.default = t.default;
})(uw, uw.exports);
var uC = uw.exports;
const y3e = /* @__PURE__ */ Ut(uC);
var dw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = c;
  var r = n(Pt);
  function n(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var a = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])", i = "(".concat(a, "[.]){3}").concat(a), o = new RegExp("^".concat(i, "$")), s = "(?:[0-9a-fA-F]{1,4})", l = new RegExp("^(" + "(?:".concat(s, ":){7}(?:").concat(s, "|:)|") + "(?:".concat(s, ":){6}(?:").concat(i, "|:").concat(s, "|:)|") + "(?:".concat(s, ":){5}(?::").concat(i, "|(:").concat(s, "){1,2}|:)|") + "(?:".concat(s, ":){4}(?:(:").concat(s, "){0,1}:").concat(i, "|(:").concat(s, "){1,3}|:)|") + "(?:".concat(s, ":){3}(?:(:").concat(s, "){0,2}:").concat(i, "|(:").concat(s, "){1,4}|:)|") + "(?:".concat(s, ":){2}(?:(:").concat(s, "){0,3}:").concat(i, "|(:").concat(s, "){1,5}|:)|") + "(?:".concat(s, ":){1}(?:(:").concat(s, "){0,4}:").concat(i, "|(:").concat(s, "){1,6}|:)|") + "(?::((?::".concat(s, "){0,5}:").concat(i, "|(?::").concat(s, "){1,7}|:))") + ")(%[0-9a-zA-Z-.:]{1,})?$");
  function c(u) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return (0, r.default)(u), d = String(d), d ? d === "4" ? o.test(u) : d === "6" ? l.test(u) : !1 : c(u, 4) || c(u, 6);
  }
  e.exports = t.default, e.exports.default = t.default;
})(dw, dw.exports);
var Dh = dw.exports;
const b3e = /* @__PURE__ */ Ut(Dh);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = S;
  var r = s(Pt), n = s(si), a = s(xM), i = s(uC), o = s(Dh);
  function s(x) {
    return x && x.__esModule ? x : { default: x };
  }
  var l = {
    allow_display_name: !1,
    require_display_name: !1,
    allow_utf8_local_part: !0,
    require_tld: !0,
    blacklisted_chars: "",
    ignore_max_length: !1,
    host_blacklist: [],
    host_whitelist: []
  }, c = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i, u = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i, d = /^[a-z\d]+$/, f = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i, m = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i, h = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i, g = 254;
  function y(x) {
    var b = x.replace(/^"(.+)"$/, "$1");
    if (!b.trim())
      return !1;
    var _ = /[\.";<>]/.test(b);
    if (_) {
      if (b === x)
        return !1;
      var $ = b.split('"').length === b.split('\\"').length;
      if (!$)
        return !1;
    }
    return !0;
  }
  function S(x, b) {
    if ((0, r.default)(x), b = (0, n.default)(b, l), b.require_display_name || b.allow_display_name) {
      var _ = x.match(c);
      if (_) {
        var $ = _[1];
        if (x = x.replace($, "").replace(/(^<|>$)/g, ""), $.endsWith(" ") && ($ = $.slice(0, -1)), !y($))
          return !1;
      } else if (b.require_display_name)
        return !1;
    }
    if (!b.ignore_max_length && x.length > g)
      return !1;
    var w = x.split("@"), O = w.pop(), T = O.toLowerCase();
    if (b.host_blacklist.includes(T) || b.host_whitelist.length > 0 && !b.host_whitelist.includes(T))
      return !1;
    var I = w.join("@");
    if (b.domain_specific_validation && (T === "gmail.com" || T === "googlemail.com")) {
      I = I.toLowerCase();
      var P = I.split("+")[0];
      if (!(0, a.default)(P.replace(/\./g, ""), {
        min: 6,
        max: 30
      }))
        return !1;
      for (var D = P.split("."), B = 0; B < D.length; B++)
        if (!d.test(D[B]))
          return !1;
    }
    if (b.ignore_max_length === !1 && (!(0, a.default)(I, {
      max: 64
    }) || !(0, a.default)(O, {
      max: 254
    })))
      return !1;
    if (!(0, i.default)(O, {
      require_tld: b.require_tld,
      ignore_max_length: b.ignore_max_length
    })) {
      if (!b.allow_ip_domain)
        return !1;
      if (!(0, o.default)(O)) {
        if (!O.startsWith("[") || !O.endsWith("]"))
          return !1;
        var L = O.slice(1, -1);
        if (L.length === 0 || !(0, o.default)(L))
          return !1;
      }
    }
    if (I[0] === '"')
      return I = I.slice(1, I.length - 1), b.allow_utf8_local_part ? h.test(I) : f.test(I);
    for (var N = b.allow_utf8_local_part ? m : u, z = I.split("."), F = 0; F < z.length; F++)
      if (!N.test(z[F]))
        return !1;
    return !(b.blacklisted_chars && I.search(new RegExp("[".concat(b.blacklisted_chars, "]+"), "g")) !== -1);
  }
  e.exports = t.default, e.exports.default = t.default;
})(cw, cw.exports);
var uY = cw.exports;
const C3e = /* @__PURE__ */ Ut(uY);
var dY = "isEmail";
function fY(e, t) {
  return typeof e == "string" && C3e(e, t);
}
function S3e(e, t) {
  return vt({
    name: dY,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return fY(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be an email";
      }, t)
    }
  }, t);
}
var pY = "isFqdn";
function mY(e, t) {
  return typeof e == "string" && y3e(e, t);
}
function x3e(e, t) {
  return vt({
    name: pY,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return mY(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be a valid domain name";
      }, t)
    }
  }, t);
}
var Rd = {};
Object.defineProperty(Rd, "__esModule", {
  value: !0
});
var $3e = Rd.default = w3e;
Rd.fullWidth = void 0;
var _3e = E3e(Pt);
function E3e(e) {
  return e && e.__esModule ? e : { default: e };
}
var vY = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
Rd.fullWidth = vY;
function w3e(e) {
  return (0, _3e.default)(e), vY.test(e);
}
var hY = "isFullWidth";
function gY(e) {
  return typeof e == "string" && $3e(e);
}
function O3e(e) {
  return vt({
    name: hY,
    validator: {
      validate: function(t, r) {
        return gY(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must contain a full-width characters";
      }, e)
    }
  }, e);
}
var Nd = {};
Object.defineProperty(Nd, "__esModule", {
  value: !0
});
var T3e = Nd.default = A3e;
Nd.halfWidth = void 0;
var I3e = M3e(Pt);
function M3e(e) {
  return e && e.__esModule ? e : { default: e };
}
var yY = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
Nd.halfWidth = yY;
function A3e(e) {
  return (0, I3e.default)(e), yY.test(e);
}
var bY = "isHalfWidth";
function CY(e) {
  return typeof e == "string" && T3e(e);
}
function P3e(e) {
  return vt({
    name: bY,
    validator: {
      validate: function(t, r) {
        return CY(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must contain a half-width characters";
      }, e)
    }
  }, e);
}
var fw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = i(Pt), n = Rd, a = Nd;
  function i(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function o(s) {
    return (0, r.default)(s), n.fullWidth.test(s) && a.halfWidth.test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(fw, fw.exports);
var SY = fw.exports;
const R3e = /* @__PURE__ */ Ut(SY);
var xY = "isVariableWidth";
function $Y(e) {
  return typeof e == "string" && R3e(e);
}
function N3e(e) {
  return vt({
    name: xY,
    validator: {
      validate: function(t, r) {
        return $Y(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must contain a full-width and half-width characters";
      }, e)
    }
  }, e);
}
var pw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
  function i(o) {
    return (0, r.default)(o), a.test(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(pw, pw.exports);
var _Y = pw.exports;
const D3e = /* @__PURE__ */ Ut(_Y);
var EY = "isHexColor";
function wY(e) {
  return typeof e == "string" && D3e(e);
}
function j3e(e) {
  return vt({
    name: EY,
    validator: {
      validate: function(t, r) {
        return wY(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a hexadecimal color";
      }, e)
    }
  }, e);
}
var mw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = /^(0x|0h)?[0-9A-F]+$/i;
  function i(o) {
    return (0, r.default)(o), a.test(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(mw, mw.exports);
var $M = mw.exports;
const L3e = /* @__PURE__ */ Ut($M);
var OY = "isHexadecimal";
function TY(e) {
  return typeof e == "string" && L3e(e);
}
function k3e(e) {
  return vt({
    name: OY,
    validator: {
      validate: function(t, r) {
        return TY(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a hexadecimal number";
      }, e)
    }
  }, e);
}
function vw(e) {
  return e ? "each" in e || "message" in e || "groups" in e || "always" in e || "context" in e : !1;
}
var hw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var r = n(Pt);
  function n(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var a = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){4}([0-9a-fA-F]{2})$/, i = /^([0-9a-fA-F]){12}$/, o = /^([0-9a-fA-F]{4}\.){2}([0-9a-fA-F]{4})$/, s = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){6}([0-9a-fA-F]{2})$/, l = /^([0-9a-fA-F]){16}$/, c = /^([0-9a-fA-F]{4}\.){3}([0-9a-fA-F]{4})$/;
  function u(d, f) {
    return (0, r.default)(d), f != null && f.eui && (f.eui = String(f.eui)), f != null && f.no_colons || f != null && f.no_separators ? f.eui === "48" ? i.test(d) : f.eui === "64" ? l.test(d) : i.test(d) || l.test(d) : f?.eui === "48" ? a.test(d) || o.test(d) : f?.eui === "64" ? s.test(d) || c.test(d) : u(d, {
      eui: "48"
    }) || u(d, {
      eui: "64"
    });
  }
  e.exports = t.default, e.exports.default = t.default;
})(hw, hw.exports);
var IY = hw.exports;
const F3e = /* @__PURE__ */ Ut(IY);
var MY = "isMacAddress";
function AY(e, t) {
  return typeof e == "string" && F3e(e, t);
}
function B3e(e, t) {
  var r = vw(e) ? void 0 : e, n = vw(e) ? e : t;
  return vt({
    name: MY,
    constraints: [r],
    validator: {
      validate: function(a, i) {
        return AY(a, r);
      },
      defaultMessage: mt(function(a) {
        return a + "$property must be a MAC Address";
      }, n)
    }
  }, n);
}
var PY = "isIp";
function RY(e, t) {
  var r = t ? "".concat(t) : void 0;
  return typeof e == "string" && b3e(e, r);
}
function z3e(e, t) {
  return vt({
    name: PY,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return RY(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be an ip address";
      }, t)
    }
  }, t);
}
var gw = { exports: {} }, yw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(Pt);
  function n(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var a = /^(?:[-+]?(?:0|[1-9][0-9]*))$/, i = /^[-+]?[0-9]+$/;
  function o(s, l) {
    (0, r.default)(s), l = l || {};
    var c = l.hasOwnProperty("allow_leading_zeroes") && !l.allow_leading_zeroes ? a : i, u = !l.hasOwnProperty("min") || s >= l.min, d = !l.hasOwnProperty("max") || s <= l.max, f = !l.hasOwnProperty("lt") || s < l.lt, m = !l.hasOwnProperty("gt") || s > l.gt;
    return c.test(s) && u && d && f && m;
  }
  e.exports = t.default, e.exports.default = t.default;
})(yw, yw.exports);
var _M = yw.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(_M);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i) {
    return (0, r.default)(i, {
      min: 0,
      max: 65535
    });
  }
  e.exports = t.default, e.exports.default = t.default;
})(gw, gw.exports);
var NY = gw.exports;
const H3e = /* @__PURE__ */ Ut(NY);
var DY = "isPort";
function jY(e) {
  return typeof e == "string" && H3e(e);
}
function V3e(e) {
  return vt({
    name: DY,
    validator: {
      validate: function(t, r) {
        return jY(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a port";
      }, e)
    }
  }, e);
}
var bw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = n(Pt);
  function n(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var a = /^(?:[0-9]{9}X|[0-9]{10})$/, i = /^(?:[0-9]{13})$/, o = [1, 3];
  function s(l, c) {
    (0, r.default)(l);
    var u = String(c?.version || c);
    if (!(c != null && c.version || c))
      return s(l, {
        version: 10
      }) || s(l, {
        version: 13
      });
    var d = l.replace(/[\s-]+/g, ""), f = 0;
    if (u === "10") {
      if (!a.test(d))
        return !1;
      for (var m = 0; m < u - 1; m++)
        f += (m + 1) * d.charAt(m);
      if (d.charAt(9) === "X" ? f += 10 * 10 : f += 10 * d.charAt(9), f % 11 === 0)
        return !0;
    } else if (u === "13") {
      if (!i.test(d))
        return !1;
      for (var h = 0; h < 12; h++)
        f += o[h % 2] * d.charAt(h);
      if (d.charAt(12) - (10 - f % 10) % 10 === 0)
        return !0;
    }
    return !1;
  }
  e.exports = t.default, e.exports.default = t.default;
})(bw, bw.exports);
var LY = bw.exports;
const G3e = /* @__PURE__ */ Ut(LY);
var kY = "isIsbn";
function FY(e, t) {
  var r = t ? "".concat(t) : void 0;
  return typeof e == "string" && G3e(e, r);
}
function U3e(e, t) {
  return vt({
    name: kY,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return FY(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be an ISBN";
      }, t)
    }
  }, t);
}
var Cw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
  function i(o) {
    if ((0, r.default)(o), !a.test(o))
      return !1;
    for (var s = !0, l = 0, c = o.length - 2; c >= 0; c--)
      if (o[c] >= "A" && o[c] <= "Z")
        for (var u = o[c].charCodeAt(0) - 55, d = u % 10, f = Math.trunc(u / 10), m = 0, h = [d, f]; m < h.length; m++) {
          var g = h[m];
          s ? g >= 5 ? l += 1 + (g - 5) * 2 : l += g * 2 : l += g, s = !s;
        }
      else {
        var y = o[c].charCodeAt(0) - 48;
        s ? y >= 5 ? l += 1 + (y - 5) * 2 : l += y * 2 : l += y, s = !s;
      }
    var S = Math.trunc((l + 9) / 10) * 10 - l;
    return +o[o.length - 1] === S;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Cw, Cw.exports);
var BY = Cw.exports;
const W3e = /* @__PURE__ */ Ut(BY);
var zY = "isIsin";
function HY(e) {
  return typeof e == "string" && W3e(e);
}
function q3e(e) {
  return vt({
    name: zY,
    validator: {
      validate: function(t, r) {
        return HY(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be an ISIN (stock/security identifier)";
      }, e)
    }
  }, e);
}
var Sw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = n(Pt);
  function n(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var a = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, i = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, o = function(c) {
    var u = c.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
    if (u) {
      var d = Number(u[1]), f = Number(u[2]);
      return d % 4 === 0 && d % 100 !== 0 || d % 400 === 0 ? f <= 366 : f <= 365;
    }
    var m = c.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number), h = m[1], g = m[2], y = m[3], S = g && "0".concat(g).slice(-2), x = y && "0".concat(y).slice(-2), b = new Date("".concat(h, "-").concat(S || "01", "-").concat(x || "01"));
    return g && y ? b.getUTCFullYear() === h && b.getUTCMonth() + 1 === g && b.getUTCDate() === y : !0;
  };
  function s(l) {
    var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, r.default)(l);
    var u = c.strictSeparator ? i.test(l) : a.test(l);
    return u && c.strict ? o(l) : u;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Sw, Sw.exports);
var VY = Sw.exports;
const K3e = /* @__PURE__ */ Ut(VY);
var GY = "isIso8601";
function EM(e, t) {
  return typeof e == "string" && K3e(e, t);
}
function Y3e(e, t) {
  return vt({
    name: GY,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return EM(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be a valid ISO 8601 date string";
      }, t)
    }
  }, t);
}
var xw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = a(Pt), n = a(si);
  function a(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function i(l) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? i = function(u) {
      return typeof u;
    } : i = function(u) {
      return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
    }, i(l);
  }
  var o = {
    allow_primitives: !1
  };
  function s(l, c) {
    (0, r.default)(l);
    try {
      c = (0, n.default)(c, o);
      var u = [];
      c.allow_primitives && (u = [null, !1, !0]);
      var d = JSON.parse(l);
      return u.includes(d) || !!d && i(d) === "object";
    } catch {
    }
    return !1;
  }
  e.exports = t.default, e.exports.default = t.default;
})(xw, xw.exports);
var UY = xw.exports;
const Z3e = /* @__PURE__ */ Ut(UY);
var WY = "isJson";
function qY(e) {
  return typeof e == "string" && Z3e(e);
}
function X3e(e) {
  return vt({
    name: WY,
    validator: {
      validate: function(t, r) {
        return qY(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a json string";
      }, e)
    }
  }, e);
}
var $w = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = a(Pt), n = a(SM);
  function a(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o) {
    (0, r.default)(o);
    var s = o.split("."), l = s.length;
    return l > 3 || l < 2 ? !1 : s.reduce(function(c, u) {
      return c && (0, n.default)(u, {
        urlSafe: !0
      });
    }, !0);
  }
  e.exports = t.default, e.exports.default = t.default;
})($w, $w.exports);
var KY = $w.exports;
const J3e = /* @__PURE__ */ Ut(KY);
var YY = "isJwt";
function ZY(e) {
  return typeof e == "string" && J3e(e);
}
function Q3e(e) {
  return vt({
    name: YY,
    validator: {
      validate: function(t, r) {
        return ZY(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a jwt string";
      }, e)
    }
  }, e);
}
var _w = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Pt);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i) {
    return (0, r.default)(i), i === i.toLowerCase();
  }
  e.exports = t.default, e.exports.default = t.default;
})(_w, _w.exports);
var XY = _w.exports;
const eRe = /* @__PURE__ */ Ut(XY);
var JY = "isLowercase";
function QY(e) {
  return typeof e == "string" && eRe(e);
}
function tRe(e) {
  return vt({
    name: JY,
    validator: {
      validate: function(t, r) {
        return QY(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a lowercase string";
      }, e)
    }
  }, e);
}
var jh = {};
Object.defineProperty(jh, "__esModule", {
  value: !0
});
var rRe = jh.default = iRe;
jh.locales = void 0;
var nRe = aRe(Pt);
function aRe(e) {
  return e && e.__esModule ? e : { default: e };
}
var kn = {
  "am-AM": /^(\+?374|0)((10|[9|7][0-9])\d{6}$|[2-4]\d{7}$)/,
  "ar-AE": /^((\+?971)|0)?5[024568]\d{7}$/,
  "ar-BH": /^(\+?973)?(3|6)\d{7}$/,
  "ar-DZ": /^(\+?213|0)(5|6|7)\d{8}$/,
  "ar-LB": /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
  "ar-EG": /^((\+?20)|0)?1[0125]\d{8}$/,
  "ar-IQ": /^(\+?964|0)?7[0-9]\d{8}$/,
  "ar-JO": /^(\+?962|0)?7[789]\d{7}$/,
  "ar-KW": /^(\+?965)([569]\d{7}|41\d{6})$/,
  "ar-LY": /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
  "ar-MA": /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
  "ar-OM": /^((\+|00)968)?(9[1-9])\d{6}$/,
  "ar-PS": /^(\+?970|0)5[6|9](\d{7})$/,
  "ar-SA": /^(!?(\+?966)|0)?5\d{8}$/,
  "ar-SY": /^(!?(\+?963)|0)?9\d{8}$/,
  "ar-TN": /^(\+?216)?[2459]\d{7}$/,
  "az-AZ": /^(\+994|0)(10|5[015]|7[07]|99)\d{7}$/,
  "bs-BA": /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
  "be-BY": /^(\+?375)?(24|25|29|33|44)\d{7}$/,
  "bg-BG": /^(\+?359|0)?8[789]\d{7}$/,
  "bn-BD": /^(\+?880|0)1[13456789][0-9]{8}$/,
  "ca-AD": /^(\+376)?[346]\d{5}$/,
  "cs-CZ": /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  "da-DK": /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
  "de-DE": /^((\+49|0)1)(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
  "de-AT": /^(\+43|0)\d{1,4}\d{3,12}$/,
  "de-CH": /^(\+41|0)([1-9])\d{1,9}$/,
  "de-LU": /^(\+352)?((6\d1)\d{6})$/,
  "dv-MV": /^(\+?960)?(7[2-9]|9[1-9])\d{5}$/,
  "el-GR": /^(\+?30|0)?6(8[5-9]|9(?![26])[0-9])\d{7}$/,
  "el-CY": /^(\+?357?)?(9(9|6)\d{6})$/,
  "en-AI": /^(\+?1|0)264(?:2(35|92)|4(?:6[1-2]|76|97)|5(?:3[6-9]|8[1-4])|7(?:2(4|9)|72))\d{4}$/,
  "en-AU": /^(\+?61|0)4\d{8}$/,
  "en-AG": /^(?:\+1|1)268(?:464|7(?:1[3-9]|[28]\d|3[0246]|64|7[0-689]))\d{4}$/,
  "en-BM": /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}$))/,
  "en-BS": /^(\+?1[-\s]?|0)?\(?242\)?[-\s]?\d{3}[-\s]?\d{4}$/,
  "en-GB": /^(\+?44|0)7\d{9}$/,
  "en-GG": /^(\+?44|0)1481\d{6}$/,
  "en-GH": /^(\+233|0)(20|50|24|54|27|57|26|56|23|28|55|59)\d{7}$/,
  "en-GY": /^(\+592|0)6\d{6}$/,
  "en-HK": /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
  "en-MO": /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
  "en-IE": /^(\+?353|0)8[356789]\d{7}$/,
  "en-IN": /^(\+?91|0)?[6789]\d{9}$/,
  "en-JM": /^(\+?876)?\d{7}$/,
  "en-KE": /^(\+?254|0)(7|1)\d{8}$/,
  "en-SS": /^(\+?211|0)(9[1257])\d{7}$/,
  "en-KI": /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
  "en-KN": /^(?:\+1|1)869(?:46\d|48[89]|55[6-8]|66\d|76[02-7])\d{4}$/,
  "en-LS": /^(\+?266)(22|28|57|58|59|27|52)\d{6}$/,
  "en-MT": /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
  "en-MU": /^(\+?230|0)?\d{8}$/,
  "en-NA": /^(\+?264|0)(6|8)\d{7}$/,
  "en-NG": /^(\+?234|0)?[789]\d{9}$/,
  "en-NZ": /^(\+?64|0)[28]\d{7,9}$/,
  "en-PG": /^(\+?675|0)?(7\d|8[18])\d{6}$/,
  "en-PK": /^((00|\+)?92|0)3[0-6]\d{8}$/,
  "en-PH": /^(09|\+639)\d{9}$/,
  "en-RW": /^(\+?250|0)?[7]\d{8}$/,
  "en-SG": /^(\+65)?[3689]\d{7}$/,
  "en-SL": /^(\+?232|0)\d{8}$/,
  "en-TZ": /^(\+?255|0)?[67]\d{8}$/,
  "en-UG": /^(\+?256|0)?[7]\d{8}$/,
  "en-US": /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
  "en-ZA": /^(\+?27|0)\d{9}$/,
  "en-ZM": /^(\+?26)?09[567]\d{7}$/,
  "en-ZW": /^(\+263)[0-9]{9}$/,
  "en-BW": /^(\+?267)?(7[1-8]{1})\d{6}$/,
  "es-AR": /^\+?549(11|[2368]\d)\d{8}$/,
  "es-BO": /^(\+?591)?(6|7)\d{7}$/,
  "es-CO": /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
  "es-CL": /^(\+?56|0)[2-9]\d{1}\d{7}$/,
  "es-CR": /^(\+506)?[2-8]\d{7}$/,
  "es-CU": /^(\+53|0053)?5\d{7}/,
  "es-DO": /^(\+?1)?8[024]9\d{7}$/,
  "es-HN": /^(\+?504)?[9|8|3|2]\d{7}$/,
  "es-EC": /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
  "es-ES": /^(\+?34)?[6|7]\d{8}$/,
  "es-PE": /^(\+?51)?9\d{8}$/,
  "es-MX": /^(\+?52)?(1|01)?\d{10,11}$/,
  "es-NI": /^(\+?505)\d{7,8}$/,
  "es-PA": /^(\+?507)\d{7,8}$/,
  "es-PY": /^(\+?595|0)9[9876]\d{7}$/,
  "es-SV": /^(\+?503)?[67]\d{7}$/,
  "es-UY": /^(\+598|0)9[1-9][\d]{6}$/,
  "es-VE": /^(\+?58)?(2|4)\d{9}$/,
  "et-EE": /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
  "fa-IR": /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
  "fi-FI": /^(\+?358|0)\s?(4[0-6]|50)\s?(\d\s?){4,8}$/,
  "fj-FJ": /^(\+?679)?\s?\d{3}\s?\d{4}$/,
  "fo-FO": /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  "fr-BF": /^(\+226|0)[67]\d{7}$/,
  "fr-BJ": /^(\+229)\d{8}$/,
  "fr-CD": /^(\+?243|0)?(8|9)\d{8}$/,
  "fr-CM": /^(\+?237)6[0-9]{8}$/,
  "fr-FR": /^(\+?33|0)[67]\d{8}$/,
  "fr-GF": /^(\+?594|0|00594)[67]\d{8}$/,
  "fr-GP": /^(\+?590|0|00590)[67]\d{8}$/,
  "fr-MQ": /^(\+?596|0|00596)[67]\d{8}$/,
  "fr-PF": /^(\+?689)?8[789]\d{6}$/,
  "fr-RE": /^(\+?262|0|00262)[67]\d{8}$/,
  "he-IL": /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
  "hu-HU": /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
  "id-ID": /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
  "ir-IR": /^(\+98|0)?9\d{9}$/,
  "it-IT": /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
  "it-SM": /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
  "ja-JP": /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
  "ka-GE": /^(\+?995)?(79\d{7}|5\d{8})$/,
  "kk-KZ": /^(\+?7|8)?7\d{9}$/,
  "kl-GL": /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  "ko-KR": /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
  "ky-KG": /^(\+?7\s?\+?7|0)\s?\d{2}\s?\d{3}\s?\d{4}$/,
  "lt-LT": /^(\+370|8)\d{8}$/,
  "lv-LV": /^(\+?371)2\d{7}$/,
  "mg-MG": /^((\+?261|0)(2|3)\d)?\d{7}$/,
  "mn-MN": /^(\+|00|011)?976(77|81|88|91|94|95|96|99)\d{6}$/,
  "my-MM": /^(\+?959|09|9)(2[5-7]|3[1-2]|4[0-5]|6[6-9]|7[5-9]|9[6-9])[0-9]{7}$/,
  "ms-MY": /^(\+?60|0)1(([0145](-|\s)?\d{7,8})|([236-9](-|\s)?\d{7}))$/,
  "mz-MZ": /^(\+?258)?8[234567]\d{7}$/,
  "nb-NO": /^(\+?47)?[49]\d{7}$/,
  "ne-NP": /^(\+?977)?9[78]\d{8}$/,
  "nl-BE": /^(\+?32|0)4\d{8}$/,
  "nl-NL": /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
  "nl-AW": /^(\+)?297(56|59|64|73|74|99)\d{5}$/,
  "nn-NO": /^(\+?47)?[49]\d{7}$/,
  "pl-PL": /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
  "pt-BR": /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/,
  "pt-PT": /^(\+?351)?9[1236]\d{7}$/,
  "pt-AO": /^(\+244)\d{9}$/,
  "ro-MD": /^(\+?373|0)((6(0|1|2|6|7|8|9))|(7(6|7|8|9)))\d{6}$/,
  "ro-RO": /^(\+?40|0)\s?7\d{2}(\/|\s|\.|-)?\d{3}(\s|\.|-)?\d{3}$/,
  "ru-RU": /^(\+?7|8)?9\d{9}$/,
  "si-LK": /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
  "sl-SI": /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
  "sk-SK": /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  "sq-AL": /^(\+355|0)6[789]\d{6}$/,
  "sr-RS": /^(\+3816|06)[- \d]{5,9}$/,
  "sv-SE": /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
  "tg-TJ": /^(\+?992)?[5][5]\d{7}$/,
  "th-TH": /^(\+66|66|0)\d{9}$/,
  "tr-TR": /^(\+?90|0)?5\d{9}$/,
  "tk-TM": /^(\+993|993|8)\d{8}$/,
  "uk-UA": /^(\+?38|8)?0\d{9}$/,
  "uz-UZ": /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
  "vi-VN": /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
  "zh-CN": /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
  "zh-TW": /^(\+?886\-?|0)?9\d{8}$/,
  "dz-BT": /^(\+?975|0)?(17|16|77|02)\d{6}$/,
  "ar-YE": /^(((\+|00)9677|0?7)[0137]\d{7}|((\+|00)967|0)[1-7]\d{6})$/,
  "ar-EH": /^(\+?212|0)[\s\-]?(5288|5289)[\s\-]?\d{5}$/,
  "fa-AF": /^(\+93|0)?(2{1}[0-8]{1}|[3-5]{1}[0-4]{1})(\d{7})$/
};
kn["en-CA"] = kn["en-US"];
kn["fr-CA"] = kn["en-CA"];
kn["fr-BE"] = kn["nl-BE"];
kn["zh-HK"] = kn["en-HK"];
kn["zh-MO"] = kn["en-MO"];
kn["ga-IE"] = kn["en-IE"];
kn["fr-CH"] = kn["de-CH"];
kn["it-CH"] = kn["fr-CH"];
function iRe(e, t, r) {
  if ((0, nRe.default)(e), r && r.strictMode && !e.startsWith("+"))
    return !1;
  if (Array.isArray(t))
    return t.some(function(i) {
      if (kn.hasOwnProperty(i)) {
        var o = kn[i];
        if (o.test(e))
          return !0;
      }
      return !1;
    });
  if (t in kn)
    return kn[t].test(e);
  if (!t || t === "any") {
    for (var n in kn)
      if (kn.hasOwnProperty(n)) {
        var a = kn[n];
        if (a.test(e))
          return !0;
      }
    return !1;
  }
  throw new Error("Invalid locale '".concat(t, "'"));
}
var oRe = Object.keys(kn);
jh.locales = oRe;
var eZ = "isMobilePhone";
function tZ(e, t, r) {
  return typeof e == "string" && rRe(e, t, r);
}
function sRe(e, t, r) {
  return vt({
    name: eZ,
    constraints: [e, t],
    validator: {
      validate: function(n, a) {
        return tZ(n, a?.constraints[0], a?.constraints[1]);
      },
      defaultMessage: mt(function(n) {
        return n + "$property must be a phone number";
      }, r)
    }
  }, r);
}
var Dd = {};
Object.defineProperty(Dd, "__esModule", {
  value: !0
});
var lRe = Dd.default = dRe;
Dd.CountryCodes = void 0;
var cRe = uRe(Pt);
function uRe(e) {
  return e && e.__esModule ? e : { default: e };
}
var rZ = /* @__PURE__ */ new Set(["AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AQ", "AR", "AS", "AT", "AU", "AW", "AX", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL", "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH", "ER", "ES", "ET", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GS", "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PS", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "YE", "YT", "ZA", "ZM", "ZW"]);
function dRe(e) {
  return (0, cRe.default)(e), rZ.has(e.toUpperCase());
}
var fRe = rZ;
Dd.CountryCodes = fRe;
var nZ = "isISO31661Alpha2";
function aZ(e) {
  return typeof e == "string" && lRe(e);
}
function pRe(e) {
  return vt({
    name: nZ,
    validator: {
      validate: function(t, r) {
        return aZ(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a valid ISO31661 Alpha2 code";
      }, e)
    }
  }, e);
}
var Ew = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = /* @__PURE__ */ new Set(["AFG", "ALA", "ALB", "DZA", "ASM", "AND", "AGO", "AIA", "ATA", "ATG", "ARG", "ARM", "ABW", "AUS", "AUT", "AZE", "BHS", "BHR", "BGD", "BRB", "BLR", "BEL", "BLZ", "BEN", "BMU", "BTN", "BOL", "BES", "BIH", "BWA", "BVT", "BRA", "IOT", "BRN", "BGR", "BFA", "BDI", "KHM", "CMR", "CAN", "CPV", "CYM", "CAF", "TCD", "CHL", "CHN", "CXR", "CCK", "COL", "COM", "COG", "COD", "COK", "CRI", "CIV", "HRV", "CUB", "CUW", "CYP", "CZE", "DNK", "DJI", "DMA", "DOM", "ECU", "EGY", "SLV", "GNQ", "ERI", "EST", "ETH", "FLK", "FRO", "FJI", "FIN", "FRA", "GUF", "PYF", "ATF", "GAB", "GMB", "GEO", "DEU", "GHA", "GIB", "GRC", "GRL", "GRD", "GLP", "GUM", "GTM", "GGY", "GIN", "GNB", "GUY", "HTI", "HMD", "VAT", "HND", "HKG", "HUN", "ISL", "IND", "IDN", "IRN", "IRQ", "IRL", "IMN", "ISR", "ITA", "JAM", "JPN", "JEY", "JOR", "KAZ", "KEN", "KIR", "PRK", "KOR", "KWT", "KGZ", "LAO", "LVA", "LBN", "LSO", "LBR", "LBY", "LIE", "LTU", "LUX", "MAC", "MKD", "MDG", "MWI", "MYS", "MDV", "MLI", "MLT", "MHL", "MTQ", "MRT", "MUS", "MYT", "MEX", "FSM", "MDA", "MCO", "MNG", "MNE", "MSR", "MAR", "MOZ", "MMR", "NAM", "NRU", "NPL", "NLD", "NCL", "NZL", "NIC", "NER", "NGA", "NIU", "NFK", "MNP", "NOR", "OMN", "PAK", "PLW", "PSE", "PAN", "PNG", "PRY", "PER", "PHL", "PCN", "POL", "PRT", "PRI", "QAT", "REU", "ROU", "RUS", "RWA", "BLM", "SHN", "KNA", "LCA", "MAF", "SPM", "VCT", "WSM", "SMR", "STP", "SAU", "SEN", "SRB", "SYC", "SLE", "SGP", "SXM", "SVK", "SVN", "SLB", "SOM", "ZAF", "SGS", "SSD", "ESP", "LKA", "SDN", "SUR", "SJM", "SWZ", "SWE", "CHE", "SYR", "TWN", "TJK", "TZA", "THA", "TLS", "TGO", "TKL", "TON", "TTO", "TUN", "TUR", "TKM", "TCA", "TUV", "UGA", "UKR", "ARE", "GBR", "USA", "UMI", "URY", "UZB", "VUT", "VEN", "VNM", "VGB", "VIR", "WLF", "ESH", "YEM", "ZMB", "ZWE"]);
  function i(o) {
    return (0, r.default)(o), a.has(o.toUpperCase());
  }
  e.exports = t.default, e.exports.default = t.default;
})(Ew, Ew.exports);
var iZ = Ew.exports;
const mRe = /* @__PURE__ */ Ut(iZ);
var oZ = "isISO31661Alpha3";
function sZ(e) {
  return typeof e == "string" && mRe(e);
}
function vRe(e) {
  return vt({
    name: oZ,
    validator: {
      validate: function(t, r) {
        return sZ(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a valid ISO31661 Alpha3 code";
      }, e)
    }
  }, e);
}
var ww = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = a(Pt), n = a($M);
  function a(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o) {
    return (0, r.default)(o), (0, n.default)(o) && o.length === 24;
  }
  e.exports = t.default, e.exports.default = t.default;
})(ww, ww.exports);
var lZ = ww.exports;
const hRe = /* @__PURE__ */ Ut(lZ);
var cZ = "isMongoId";
function uZ(e) {
  return typeof e == "string" && hRe(e);
}
function gRe(e) {
  return vt({
    name: cZ,
    validator: {
      validate: function(t, r) {
        return uZ(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a mongodb id";
      }, e)
    }
  }, e);
}
var Ow = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = /[^\x00-\x7F]/;
  function i(o) {
    return (0, r.default)(o), a.test(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Ow, Ow.exports);
var dZ = Ow.exports;
const yRe = /* @__PURE__ */ Ut(dZ);
var fZ = "isMultibyte";
function pZ(e) {
  return typeof e == "string" && yRe(e);
}
function bRe(e) {
  return vt({
    name: fZ,
    validator: {
      validate: function(t, r) {
        return pZ(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must contain one or more multibyte chars";
      }, e)
    }
  }, e);
}
var Tw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
  function i(o) {
    return (0, r.default)(o), a.test(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Tw, Tw.exports);
var mZ = Tw.exports;
const CRe = /* @__PURE__ */ Ut(mZ);
var vZ = "isSurrogatePair";
function hZ(e) {
  return typeof e == "string" && CRe(e);
}
function SRe(e) {
  return vt({
    name: vZ,
    validator: {
      validate: function(t, r) {
        return hZ(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must contain any surrogate pairs chars";
      }, e)
    }
  }, e);
}
var Iw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = S;
  var r = o(Pt), n = o(uC), a = o(Dh), i = o(si);
  function o(x) {
    return x && x.__esModule ? x : { default: x };
  }
  function s(x, b) {
    return f(x) || d(x, b) || c(x, b) || l();
  }
  function l() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function c(x, b) {
    if (x) {
      if (typeof x == "string") return u(x, b);
      var _ = Object.prototype.toString.call(x).slice(8, -1);
      if (_ === "Object" && x.constructor && (_ = x.constructor.name), _ === "Map" || _ === "Set") return Array.from(x);
      if (_ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_)) return u(x, b);
    }
  }
  function u(x, b) {
    (b == null || b > x.length) && (b = x.length);
    for (var _ = 0, $ = new Array(b); _ < b; _++)
      $[_] = x[_];
    return $;
  }
  function d(x, b) {
    if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(x)))) {
      var _ = [], $ = !0, w = !1, O = void 0;
      try {
        for (var T = x[Symbol.iterator](), I; !($ = (I = T.next()).done) && (_.push(I.value), !(b && _.length === b)); $ = !0)
          ;
      } catch (P) {
        w = !0, O = P;
      } finally {
        try {
          !$ && T.return != null && T.return();
        } finally {
          if (w) throw O;
        }
      }
      return _;
    }
  }
  function f(x) {
    if (Array.isArray(x)) return x;
  }
  var m = {
    protocols: ["http", "https", "ftp"],
    require_tld: !0,
    require_protocol: !1,
    require_host: !0,
    require_port: !1,
    require_valid_protocol: !0,
    allow_underscores: !1,
    allow_trailing_dot: !1,
    allow_protocol_relative_urls: !1,
    allow_fragments: !0,
    allow_query_components: !0,
    validate_length: !0
  }, h = /^\[([^\]]+)\](?::([0-9]+))?$/;
  function g(x) {
    return Object.prototype.toString.call(x) === "[object RegExp]";
  }
  function y(x, b) {
    for (var _ = 0; _ < b.length; _++) {
      var $ = b[_];
      if (x === $ || g($) && $.test(x))
        return !0;
    }
    return !1;
  }
  function S(x, b) {
    if ((0, r.default)(x), !x || /[\s<>]/.test(x) || x.indexOf("mailto:") === 0 || (b = (0, i.default)(b, m), b.validate_length && x.length >= 2083) || !b.allow_fragments && x.includes("#") || !b.allow_query_components && (x.includes("?") || x.includes("&")))
      return !1;
    var _, $, w, O, T, I, P, D;
    if (P = x.split("#"), x = P.shift(), P = x.split("?"), x = P.shift(), P = x.split("://"), P.length > 1) {
      if (_ = P.shift().toLowerCase(), b.require_valid_protocol && b.protocols.indexOf(_) === -1)
        return !1;
    } else {
      if (b.require_protocol)
        return !1;
      if (x.slice(0, 2) === "//") {
        if (!b.allow_protocol_relative_urls)
          return !1;
        P[0] = x.slice(2);
      }
    }
    if (x = P.join("://"), x === "")
      return !1;
    if (P = x.split("/"), x = P.shift(), x === "" && !b.require_host)
      return !0;
    if (P = x.split("@"), P.length > 1) {
      if (b.disallow_auth || P[0] === "" || ($ = P.shift(), $.indexOf(":") >= 0 && $.split(":").length > 2))
        return !1;
      var B = $.split(":"), L = s(B, 2), N = L[0], z = L[1];
      if (N === "" && z === "")
        return !1;
    }
    O = P.join("@"), I = null, D = null;
    var F = O.match(h);
    if (F ? (w = "", D = F[1], I = F[2] || null) : (P = O.split(":"), w = P.shift(), P.length && (I = P.join(":"))), I !== null && I.length > 0) {
      if (T = parseInt(I, 10), !/^[0-9]+$/.test(I) || T <= 0 || T > 65535)
        return !1;
    } else if (b.require_port)
      return !1;
    return b.host_whitelist ? y(w, b.host_whitelist) : w === "" && !b.require_host ? !0 : !(!(0, a.default)(w) && !(0, n.default)(w, b) && (!D || !(0, a.default)(D, 6)) || (w = w || D, b.host_blacklist && y(w, b.host_blacklist)));
  }
  e.exports = t.default, e.exports.default = t.default;
})(Iw, Iw.exports);
var gZ = Iw.exports;
const xRe = /* @__PURE__ */ Ut(gZ);
var yZ = "isUrl";
function bZ(e, t) {
  return typeof e == "string" && xRe(e, t);
}
function $Re(e, t) {
  return vt({
    name: yZ,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return bZ(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be a URL address";
      }, t)
    }
  }, t);
}
var Mw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = {
    1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
  };
  function i(o, s) {
    (0, r.default)(o);
    var l = a[[void 0, null].includes(s) ? "all" : s];
    return !!l && l.test(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Mw, Mw.exports);
var CZ = Mw.exports;
const _Re = /* @__PURE__ */ Ut(CZ);
var SZ = "isUuid";
function xZ(e, t) {
  return typeof e == "string" && _Re(e, t);
}
function ERe(e, t) {
  return vt({
    name: SZ,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return xZ(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be a UUID";
      }, t)
    }
  }, t);
}
var $Z = "IsFirebasePushId";
function _Z(e) {
  var t = /^[a-zA-Z0-9_-]*$/;
  return typeof e == "string" && e.length === 20 && t.test(e);
}
function wRe(e) {
  return vt({
    name: $Z,
    validator: {
      validate: function(t, r) {
        return _Z(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a Firebase Push Id";
      }, e)
    }
  }, e);
}
var Aw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Pt);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i) {
    return (0, r.default)(i), i === i.toUpperCase();
  }
  e.exports = t.default, e.exports.default = t.default;
})(Aw, Aw.exports);
var EZ = Aw.exports;
const ORe = /* @__PURE__ */ Ut(EZ);
var wZ = "isUppercase";
function OZ(e) {
  return typeof e == "string" && ORe(e);
}
function TRe(e) {
  return vt({
    name: wZ,
    validator: {
      validate: function(t, r) {
        return OZ(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be uppercase";
      }, e)
    }
  }, e);
}
var Pw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? a = function(l) {
      return typeof l;
    } : a = function(l) {
      return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
    }, a(o);
  }
  function i(o, s) {
    (0, r.default)(o);
    var l, c;
    a(s) === "object" ? (l = s.min || 0, c = s.max) : (l = arguments[1] || 0, c = arguments[2]);
    var u = o.match(/(\uFE0F|\uFE0E)/g) || [], d = o.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [], f = o.length - u.length - d.length;
    return f >= l && (typeof c > "u" || f <= c);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Pw, Pw.exports);
var TZ = Pw.exports;
const wM = /* @__PURE__ */ Ut(TZ);
var IZ = "isLength";
function MZ(e, t, r) {
  return typeof e == "string" && wM(e, { min: t, max: r });
}
function IRe(e, t, r) {
  return vt({
    name: IZ,
    constraints: [e, t],
    validator: {
      validate: function(n, a) {
        return MZ(n, a?.constraints[0], a?.constraints[1]);
      },
      defaultMessage: mt(function(n, a) {
        var i = a?.constraints[0] !== null && a?.constraints[0] !== void 0, o = a?.constraints[1] !== null && a?.constraints[1] !== void 0;
        return i && (!a.value || a.value.length < a?.constraints[0]) ? n + "$property must be longer than or equal to $constraint1 characters" : o && a.value.length > a?.constraints[1] ? n + "$property must be shorter than or equal to $constraint2 characters" : n + "$property must be longer than or equal to $constraint1 and shorter than or equal to $constraint2 characters";
      }, r)
    }
  }, r);
}
var AZ = "maxLength";
function PZ(e, t) {
  return typeof e == "string" && wM(e, { min: 0, max: t });
}
function MRe(e, t) {
  return vt({
    name: AZ,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return PZ(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be shorter than or equal to $constraint1 characters";
      }, t)
    }
  }, t);
}
var RZ = "minLength";
function NZ(e, t) {
  return typeof e == "string" && wM(e, { min: t });
}
function ARe(e, t) {
  return vt({
    name: RZ,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return NZ(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be longer than or equal to $constraint1 characters";
      }, t)
    }
  }, t);
}
var Rw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Pt);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i, o, s) {
    return (0, r.default)(i), Object.prototype.toString.call(o) !== "[object RegExp]" && (o = new RegExp(o, s)), !!i.match(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Rw, Rw.exports);
var DZ = Rw.exports;
const jZ = /* @__PURE__ */ Ut(DZ);
var LZ = "matches";
function kZ(e, t, r) {
  return typeof e == "string" && jZ(e, t, r);
}
function PRe(e, t, r) {
  var n;
  return t && t instanceof Object && !r ? r = t : n = t, vt({
    name: LZ,
    constraints: [e, n],
    validator: {
      validate: function(a, i) {
        return kZ(a, i?.constraints[0], i?.constraints[1]);
      },
      defaultMessage: mt(function(a, i) {
        return a + "$property must match $constraint1 regular expression";
      }, r)
    }
  }, r);
}
const RRe = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[047]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0(4(?:[14]4|56)|[579])?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[189]"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-579])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([3-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29[1289]|389)", "529(?:1[1-46-9]|2[013-8]|90)|5(?:298|389)[0-46-9]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5293[01]\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|9[0-289])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[0189]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}"], ["80\\d{7}"], ["89\\d{7}"], 0, 0, 0, 0, ["592(?:4[0-2]|93)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "1(?:(?:[27]2|44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[047]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[47]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-579]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|[89]0", "50(?:[0367]|88)|[89]0"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[59]|80"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7|86"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-4]))\\d{4}"], ["69(?:2\\d\\d|3(?:0[0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|6[0-6]|7[0-27]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]|9\\d))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-7]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["5056(?:[0-35-9]\\d|4[46])\\d{4}|(?:4722|505[2-57-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "(?:0004|4)\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [7, 8, 10, 13], [["(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "810", "(?:33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[35-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, "269|63|9(?:39|47)8"], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "[0-36-9]\\d{8}", [9], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[013-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function NRe(e, t) {
  var r = Array.prototype.slice.call(t);
  return r.push(RRe), e.apply(this, r);
}
function Nw(e) {
  "@babel/helpers - typeof";
  return Nw = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Nw(e);
}
function DRe(e, t, r) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function jRe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function LRe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && rh(e, t);
}
function kRe(e) {
  var t = BZ();
  return function() {
    var n = nh(e), a;
    if (t) {
      var i = nh(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return FRe(this, a);
  };
}
function FRe(e, t) {
  if (t && (Nw(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return FZ(e);
}
function FZ(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Dw(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Dw = function(n) {
    if (n === null || !BRe(n)) return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(n)) return t.get(n);
      t.set(n, a);
    }
    function a() {
      return vb(n, arguments, nh(this).constructor);
    }
    return a.prototype = Object.create(n.prototype, { constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 } }), rh(a, n);
  }, Dw(e);
}
function vb(e, t, r) {
  return BZ() ? vb = Reflect.construct : vb = function(a, i, o) {
    var s = [null];
    s.push.apply(s, i);
    var l = Function.bind.apply(a, s), c = new l();
    return o && rh(c, o.prototype), c;
  }, vb.apply(null, arguments);
}
function BZ() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function BRe(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function rh(e, t) {
  return rh = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, rh(e, t);
}
function nh(e) {
  return nh = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, nh(e);
}
var Ds = /* @__PURE__ */ function(e) {
  LRe(r, e);
  var t = kRe(r);
  function r(n) {
    var a;
    return jRe(this, r), a = t.call(this, n), Object.setPrototypeOf(FZ(a), r.prototype), a.name = a.constructor.name, a;
  }
  return DRe(r);
}(/* @__PURE__ */ Dw(Error)), OM = 2, zRe = 17, HRe = 3, ko = "0-9０-９٠-٩۰-۹", VRe = "-‐-―−ー－", GRe = "／/", URe = "．.", WRe = "  ­​⁠　", qRe = "()（）［］\\[\\]", KRe = "~⁓∼～", e1 = "".concat(VRe).concat(GRe).concat(URe).concat(WRe).concat(qRe).concat(KRe), TM = "+＋";
function b5(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var r = e[0].split("."), n = t[0].split("."), a = 0; a < 3; a++) {
    var i = Number(r[a]), o = Number(n[a]);
    if (i > o) return 1;
    if (o > i) return -1;
    if (!isNaN(i) && isNaN(o)) return 1;
    if (isNaN(i) && !isNaN(o)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
function t1(e) {
  "@babel/helpers - typeof";
  return t1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, t1(e);
}
function dC(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function YRe(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function fC(e, t, r) {
  return t && YRe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var ZRe = "1.2.0", XRe = "1.7.35", C5 = " ext. ", JRe = /^\d+$/, li = /* @__PURE__ */ function() {
  function e(t) {
    dC(this, e), rNe(t), this.metadata = t, zZ.call(this, t);
  }
  return fC(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(r) {
        return r !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(r) {
      return this.metadata.countries[r];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(r) {
      return this.getCountryMetadata(r) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(r) {
      if (this.getCountryCodesForCallingCode(r))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[r])
          return !0;
      } else {
        var n = this.countryCallingCodes()[r];
        if (n && n.length === 1 && n[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(r) {
      return this.nonGeographic() ? !!this.nonGeographic()[r] : !this.getCountryCodesForCallingCode(r);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(r) {
      return this.selectNumberingPlan(r);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(r, n) {
      if (r && JRe.test(r) && (n = r, r = null), r && r !== "001") {
        if (!this.hasCountry(r))
          throw new Error("Unknown country: ".concat(r));
        this.numberingPlan = new S5(this.getCountryMetadata(r), this);
      } else if (n) {
        if (!this.hasCallingCode(n))
          throw new Error("Unknown calling code: ".concat(n));
        this.numberingPlan = new S5(this.getNumberingPlanMetadata(n), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(r) {
      var n = this.countryCallingCodes()[r];
      if (n)
        return n.length === 1 && n[0].length === 3 ? void 0 : n;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(r) {
      var n = this.getCountryCodesForCallingCode(r);
      if (n)
        return n[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(r) {
      var n = this.getCountryCodeForCallingCode(r);
      if (n)
        return this.getCountryMetadata(n);
      if (this.nonGeographic()) {
        var a = this.nonGeographic()[r];
        if (a)
          return a;
      } else {
        var i = this.countryCallingCodes()[r];
        if (i && i.length === 1 && i[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(r) {
      return this.numberingPlan.type(r);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(r) {
      return this.selectNumberingPlan(r);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), S5 = /* @__PURE__ */ function() {
  function e(t, r) {
    dC(this, e), this.globalMetadataObject = r, this.metadata = t, zZ.call(this, r.metadata);
  }
  return fC(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(r) {
      return r[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var r = this, n = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return n.map(function(a) {
        return new QRe(a, r);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(r) {
      return r[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(r) {
      if (this.hasTypes() && x5(this.types(), r))
        return new tNe(x5(this.types(), r), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? C5 : this.metadata[13] || C5;
    }
  }]), e;
}(), QRe = /* @__PURE__ */ function() {
  function e(t, r) {
    dC(this, e), this._format = t, this.metadata = r;
  }
  return fC(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !eNe.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), eNe = /^\(?\$1\)?$/, tNe = /* @__PURE__ */ function() {
  function e(t, r) {
    dC(this, e), this.type = t, this.metadata = r;
  }
  return fC(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function x5(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function rNe(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!E_(e) || !E_(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(E_(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + nNe(e) + ": " + e, "."));
}
var E_ = function(t) {
  return t1(t) === "object";
}, nNe = function(t) {
  return t1(t);
};
function IM(e, t) {
  if (t = new li(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function aNe(e, t) {
  return t.countries[e] !== void 0;
}
function zZ(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? b5(t, ZRe) === -1 ? this.v2 = !0 : b5(t, XRe) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var iNe = ";ext=", Nu = function(t) {
  return "([".concat(ko, "]{1,").concat(t, "})");
};
function HZ(e) {
  var t = "20", r = "15", n = "9", a = "6", i = "[  \\t,]*", o = "[:\\.．]?[  \\t,-]*", s = "#?", l = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", c = "(?:[xｘ#＃~～]|int|ｉｎｔ)", u = "[- ]+", d = "[  \\t]*", f = "(?:,{2}|;)", m = iNe + Nu(t), h = i + l + o + Nu(t) + s, g = i + c + o + Nu(n) + s, y = u + Nu(a) + "#", S = d + f + o + Nu(r) + s, x = d + "(?:,)+" + o + Nu(n) + s;
  return m + "|" + h + "|" + g + "|" + y + "|" + S + "|" + x;
}
var oNe = "[" + ko + "]{" + OM + "}", sNe = "[" + TM + "]{0,1}(?:[" + e1 + "]*[" + ko + "]){3,}[" + e1 + ko + "]*", lNe = new RegExp("^[" + TM + "]{0,1}(?:[" + e1 + "]*[" + ko + "]){1,2}$", "i"), cNe = sNe + // Phone number extensions
"(?:" + HZ() + ")?", uNe = new RegExp(
  // Either a short two-digit-only phone number
  "^" + oNe + "$|^" + cNe + "$",
  "i"
);
function dNe(e) {
  return e.length >= OM && uNe.test(e);
}
function fNe(e) {
  return lNe.test(e);
}
var $5 = new RegExp("(?:" + HZ() + ")$", "i");
function pNe(e) {
  var t = e.search($5);
  if (t < 0)
    return {};
  for (var r = e.slice(0, t), n = e.match($5), a = 1; a < n.length; ) {
    if (n[a])
      return {
        number: r,
        ext: n[a]
      };
    a++;
  }
}
var mNe = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function vNe(e) {
  return mNe[e];
}
function hNe(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = gNe(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gNe(e, t) {
  if (e) {
    if (typeof e == "string") return _5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return _5(e, t);
  }
}
function _5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function E5(e) {
  for (var t = "", r = hNe(e.split("")), n; !(n = r()).done; ) {
    var a = n.value;
    t += yNe(a, t) || "";
  }
  return t;
}
function yNe(e, t) {
  return e === "+" ? t ? void 0 : "+" : vNe(e);
}
function MM(e, t) {
  return bNe(e, void 0, t);
}
function bNe(e, t, r) {
  var n = r.type(t), a = n && n.possibleLengths() || r.possibleLengths();
  if (!a)
    return "IS_POSSIBLE";
  var i = e.length, o = a[0];
  return o === i ? "IS_POSSIBLE" : o > i ? "TOO_SHORT" : a[a.length - 1] < i ? "TOO_LONG" : a.indexOf(i, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function CNe(e, t, r) {
  if (t === void 0 && (t = {}), r = new li(r), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    r.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!r.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      r.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      r.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (r.possibleLengths())
    return VZ(e.phone || e.nationalNumber, r);
  if (e.countryCallingCode && r.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function VZ(e, t) {
  switch (MM(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function Us(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function SNe(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = xNe(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xNe(e, t) {
  if (e) {
    if (typeof e == "string") return w5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return w5(e, t);
  }
}
function w5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var $Ne = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function AM(e, t, r) {
  if (t = t || {}, !!e.country) {
    r = new li(r), r.selectNumberingPlan(e.country, e.countryCallingCode);
    var n = t.v2 ? e.nationalNumber : e.phone;
    if (Us(n, r.nationalNumberPattern())) {
      if (w_(n, "FIXED_LINE", r))
        return r.type("MOBILE") && r.type("MOBILE").pattern() === "" || !r.type("MOBILE") || w_(n, "MOBILE", r) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var a = SNe($Ne), i; !(i = a()).done; ) {
        var o = i.value;
        if (w_(n, o, r))
          return o;
      }
    }
  }
}
function w_(e, t, r) {
  return t = r.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : Us(e, t.pattern());
}
function _Ne(e, t, r) {
  if (t = t || {}, r = new li(r), r.selectNumberingPlan(e.country, e.countryCallingCode), r.hasTypes())
    return AM(e, t, r.metadata) !== void 0;
  var n = t.v2 ? e.nationalNumber : e.phone;
  return Us(n, r.nationalNumberPattern());
}
function ENe(e, t, r) {
  var n = new li(r), a = n.getCountryCodesForCallingCode(e);
  return a ? a.filter(function(i) {
    return wNe(t, i, r);
  }) : [];
}
function wNe(e, t, r) {
  var n = new li(r);
  return n.selectNumberingPlan(t), n.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
function ONe(e) {
  return e.replace(new RegExp("[".concat(e1, "]+"), "g"), " ").trim();
}
var TNe = /(\$\d)/;
function INe(e, t, r) {
  var n = r.useInternationalFormat, a = r.withNationalPrefix, i = e.replace(new RegExp(t.pattern()), n ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    a && t.nationalPrefixFormattingRule() ? t.format().replace(TNe, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return n ? ONe(i) : i;
}
var MNe = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function ANe(e, t, r) {
  var n = new li(r);
  if (n.selectNumberingPlan(e, t), n.defaultIDDPrefix())
    return n.defaultIDDPrefix();
  if (MNe.test(n.IDDPrefix()))
    return n.IDDPrefix();
}
function PNe(e) {
  var t = e.number, r = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(r ? ";ext=" + r : "");
}
function RNe(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = NNe(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function NNe(e, t) {
  if (e) {
    if (typeof e == "string") return O5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return O5(e, t);
  }
}
function O5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function T5(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function I5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? T5(Object(r), !0).forEach(function(n) {
      DNe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : T5(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function DNe(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var M5 = {
  formatExtension: function(t, r, n) {
    return "".concat(t).concat(n.ext()).concat(r);
  }
};
function jNe(e, t, r, n) {
  if (r ? r = I5(I5({}, M5), r) : r = M5, n = new li(n), e.country && e.country !== "001") {
    if (!n.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    n.country(e.country);
  } else if (e.countryCallingCode)
    n.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var a = n.countryCallingCode(), i = r.v2 ? e.nationalNumber : e.phone, o;
  switch (t) {
    case "NATIONAL":
      return i ? (o = r1(i, e.carrierCode, "NATIONAL", n, r), O_(o, e.ext, n, r.formatExtension)) : "";
    case "INTERNATIONAL":
      return i ? (o = r1(i, null, "INTERNATIONAL", n, r), o = "+".concat(a, " ").concat(o), O_(o, e.ext, n, r.formatExtension)) : "+".concat(a);
    case "E.164":
      return "+".concat(a).concat(i);
    case "RFC3966":
      return PNe({
        number: "+".concat(a).concat(i),
        ext: e.ext
      });
    case "IDD":
      if (!r.fromCountry)
        return;
      var s = kNe(i, e.carrierCode, a, r.fromCountry, n);
      return O_(s, e.ext, n, r.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function r1(e, t, r, n, a) {
  var i = LNe(n.formats(), e);
  return i ? INe(e, i, {
    useInternationalFormat: r === "INTERNATIONAL",
    withNationalPrefix: !(i.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && a && a.nationalPrefix === !1)
  }) : e;
}
function LNe(e, t) {
  for (var r = RNe(e), n; !(n = r()).done; ) {
    var a = n.value;
    if (a.leadingDigitsPatterns().length > 0) {
      var i = a.leadingDigitsPatterns()[a.leadingDigitsPatterns().length - 1];
      if (t.search(i) !== 0)
        continue;
    }
    if (Us(t, a.pattern()))
      return a;
  }
}
function O_(e, t, r, n) {
  return t ? n(e, t, r) : e;
}
function kNe(e, t, r, n, a) {
  var i = IM(n, a.metadata);
  if (i === r) {
    var o = r1(e, t, "NATIONAL", a);
    return r === "1" ? r + " " + o : o;
  }
  var s = ANe(n, void 0, a.metadata);
  if (s)
    return "".concat(s, " ").concat(r, " ").concat(r1(e, null, "INTERNATIONAL", a));
}
function A5(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function P5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? A5(Object(r), !0).forEach(function(n) {
      FNe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : A5(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function FNe(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function BNe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function zNe(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function HNe(e, t, r) {
  return t && zNe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var VNe = /* @__PURE__ */ function() {
  function e(t, r, n) {
    if (BNe(this, e), !t)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!r)
      throw new TypeError("`nationalNumber` not passed");
    if (!n)
      throw new TypeError("`metadata` not passed");
    var a = UNe(t, n), i = a.country, o = a.countryCallingCode;
    this.country = i, this.countryCallingCode = o, this.nationalNumber = r, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return n;
    };
  }
  return HNe(e, [{
    key: "setExt",
    value: function(r) {
      this.ext = r;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : ENe(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return CNe(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return _Ne(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var r = new li(this.getMetadata());
      return r.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(r) {
      return this.number === r.number && this.ext === r.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return AM(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(r, n) {
      return jNe(this, r, n ? P5(P5({}, n), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(r) {
      return this.format("NATIONAL", r);
    }
  }, {
    key: "formatInternational",
    value: function(r) {
      return this.format("INTERNATIONAL", r);
    }
  }, {
    key: "getURI",
    value: function(r) {
      return this.format("RFC3966", r);
    }
  }]), e;
}(), GNe = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function UNe(e, t) {
  var r, n, a = new li(t);
  return GNe(e) ? (r = e, a.selectNumberingPlan(r), n = a.countryCallingCode()) : n = e, {
    country: r,
    countryCallingCode: n
  };
}
var WNe = new RegExp("([" + ko + "])");
function qNe(e, t, r, n) {
  if (t) {
    var a = new li(n);
    a.selectNumberingPlan(t, r);
    var i = new RegExp(a.IDDPrefix());
    if (e.search(i) === 0) {
      e = e.slice(e.match(i)[0].length);
      var o = e.match(WNe);
      if (!(o && o[1] != null && o[1].length > 0 && o[1] === "0"))
        return e;
    }
  }
}
function KNe(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var r = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), n = r.exec(e);
    if (n) {
      var a, i, o = n.length - 1, s = o > 0 && n[o];
      if (t.nationalPrefixTransformRule() && s)
        a = e.replace(r, t.nationalPrefixTransformRule()), o > 1 && (i = n[1]);
      else {
        var l = n[0];
        a = e.slice(l.length), s && (i = n[1]);
      }
      var c;
      if (s) {
        var u = e.indexOf(n[1]), d = e.slice(0, u);
        d === t.numberingPlan.nationalPrefix() && (c = t.numberingPlan.nationalPrefix());
      } else
        c = n[0];
      return {
        nationalNumber: a,
        nationalPrefix: c,
        carrierCode: i
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function jw(e, t) {
  var r = KNe(e, t), n = r.carrierCode, a = r.nationalNumber;
  if (a !== e) {
    if (!YNe(e, a, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !ZNe(a, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: a,
    carrierCode: n
  };
}
function YNe(e, t, r) {
  return !(Us(e, r.nationalNumberPattern()) && !Us(t, r.nationalNumberPattern()));
}
function ZNe(e, t) {
  switch (MM(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function XNe(e, t, r, n) {
  var a = t ? IM(t, n) : r;
  if (e.indexOf(a) === 0) {
    n = new li(n), n.selectNumberingPlan(t, r);
    var i = e.slice(a.length), o = jw(i, n), s = o.nationalNumber, l = jw(e, n), c = l.nationalNumber;
    if (!Us(c, n.nationalNumberPattern()) && Us(s, n.nationalNumberPattern()) || MM(c, n) === "TOO_LONG")
      return {
        countryCallingCode: a,
        number: i
      };
  }
  return {
    number: e
  };
}
function JNe(e, t, r, n) {
  if (!e)
    return {};
  var a;
  if (e[0] !== "+") {
    var i = qNe(e, t, r, n);
    if (i && i !== e)
      a = !0, e = "+" + i;
    else {
      if (t || r) {
        var o = XNe(e, t, r, n), s = o.countryCallingCode, l = o.number;
        if (s)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: s,
            number: l
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  n = new li(n);
  for (var c = 2; c - 1 <= HRe && c <= e.length; ) {
    var u = e.slice(1, c);
    if (n.hasCallingCode(u))
      return n.selectNumberingPlan(u), {
        countryCallingCodeSource: a ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: u,
        number: e.slice(c)
      };
    c++;
  }
  return {};
}
function QNe(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = e4e(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function e4e(e, t) {
  if (e) {
    if (typeof e == "string") return R5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return R5(e, t);
  }
}
function R5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function t4e(e, t) {
  var r = t.countries, n = t.defaultCountry, a = t.metadata;
  a = new li(a);
  for (var i = [], o = QNe(r), s; !(s = o()).done; ) {
    var l = s.value;
    if (a.country(l), a.leadingDigits()) {
      if (e && e.search(a.leadingDigits()) === 0)
        return l;
    } else if (AM({
      phone: e,
      country: l
    }, void 0, a.metadata))
      if (n) {
        if (l === n)
          return l;
        i.push(l);
      } else
        return l;
  }
  if (i.length > 0)
    return i[0];
}
function r4e(e, t) {
  var r = t.nationalNumber, n = t.defaultCountry, a = t.metadata, i = a.getCountryCodesForCallingCode(e);
  if (i)
    return i.length === 1 ? i[0] : t4e(r, {
      countries: i,
      defaultCountry: n,
      metadata: a.metadata
    });
}
var GZ = "+", n4e = "[\\-\\.\\(\\)]?", N5 = "([" + ko + "]|" + n4e + ")", a4e = "^\\" + GZ + N5 + "*[" + ko + "]" + N5 + "*$", i4e = new RegExp(a4e, "g"), Lw = ko, o4e = "[" + Lw + "]+((\\-)*[" + Lw + "])*", s4e = "a-zA-Z", l4e = "[" + s4e + "]+((\\-)*[" + Lw + "])*", c4e = "^(" + o4e + "\\.)*" + l4e + "\\.?$", u4e = new RegExp(c4e, "g"), D5 = "tel:", kw = ";phone-context=", d4e = ";isub=";
function f4e(e) {
  var t = e.indexOf(kw);
  if (t < 0)
    return null;
  var r = t + kw.length;
  if (r >= e.length)
    return "";
  var n = e.indexOf(";", r);
  return n >= 0 ? e.substring(r, n) : e.substring(r);
}
function p4e(e) {
  return e === null ? !0 : e.length === 0 ? !1 : i4e.test(e) || u4e.test(e);
}
function m4e(e, t) {
  var r = t.extractFormattedPhoneNumber, n = f4e(e);
  if (!p4e(n))
    throw new Ds("NOT_A_NUMBER");
  var a;
  if (n === null)
    a = r(e) || "";
  else {
    a = "", n.charAt(0) === GZ && (a += n);
    var i = e.indexOf(D5), o;
    i >= 0 ? o = i + D5.length : o = 0;
    var s = e.indexOf(kw);
    a += e.substring(o, s);
  }
  var l = a.indexOf(d4e);
  if (l > 0 && (a = a.substring(0, l)), a !== "")
    return a;
}
var v4e = 250, h4e = new RegExp("[" + TM + ko + "]"), g4e = new RegExp("[^" + ko + "#]+$");
function y4e(e, t, r) {
  if (t = t || {}, r = new li(r), t.defaultCountry && !r.hasCountry(t.defaultCountry))
    throw t.v2 ? new Ds("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var n = C4e(e, t.v2, t.extract), a = n.number, i = n.ext, o = n.error;
  if (!a) {
    if (t.v2)
      throw o === "TOO_SHORT" ? new Ds("TOO_SHORT") : new Ds("NOT_A_NUMBER");
    return {};
  }
  var s = x4e(a, t.defaultCountry, t.defaultCallingCode, r), l = s.country, c = s.nationalNumber, u = s.countryCallingCode, d = s.countryCallingCodeSource, f = s.carrierCode;
  if (!r.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new Ds("INVALID_COUNTRY");
    return {};
  }
  if (!c || c.length < OM) {
    if (t.v2)
      throw new Ds("TOO_SHORT");
    return {};
  }
  if (c.length > zRe) {
    if (t.v2)
      throw new Ds("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var m = new VNe(u, c, r.metadata);
    return l && (m.country = l), f && (m.carrierCode = f), i && (m.ext = i), m.__countryCallingCodeSource = d, m;
  }
  var h = (t.extended ? r.hasSelectedNumberingPlan() : l) ? Us(c, r.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: l,
    countryCallingCode: u,
    carrierCode: f,
    valid: h,
    possible: h ? !0 : !!(t.extended === !0 && r.possibleLengths() && VZ(c, r)),
    phone: c,
    ext: i
  } : h ? S4e(l, c, i) : {};
}
function b4e(e, t, r) {
  if (e) {
    if (e.length > v4e) {
      if (r)
        throw new Ds("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var n = e.search(h4e);
    if (!(n < 0))
      return e.slice(n).replace(g4e, "");
  }
}
function C4e(e, t, r) {
  var n = m4e(e, {
    extractFormattedPhoneNumber: function(o) {
      return b4e(o, r, t);
    }
  });
  if (!n)
    return {};
  if (!dNe(n))
    return fNe(n) ? {
      error: "TOO_SHORT"
    } : {};
  var a = pNe(n);
  return a.ext ? a : {
    number: n
  };
}
function S4e(e, t, r) {
  var n = {
    country: e,
    phone: t
  };
  return r && (n.ext = r), n;
}
function x4e(e, t, r, n) {
  var a = JNe(E5(e), t, r, n.metadata), i = a.countryCallingCodeSource, o = a.countryCallingCode, s = a.number, l;
  if (o)
    n.selectNumberingPlan(o);
  else if (s && (t || r))
    n.selectNumberingPlan(t, r), t && (l = t), o = r || IM(t, n.metadata);
  else return {};
  if (!s)
    return {
      countryCallingCodeSource: i,
      countryCallingCode: o
    };
  var c = jw(E5(s), n), u = c.nationalNumber, d = c.carrierCode, f = r4e(o, {
    nationalNumber: u,
    defaultCountry: t,
    metadata: n
  });
  return f && (l = f, f === "001" || n.country(l)), {
    country: l,
    countryCallingCode: o,
    countryCallingCodeSource: i,
    nationalNumber: u,
    carrierCode: d
  };
}
function j5(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function L5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? j5(Object(r), !0).forEach(function(n) {
      $4e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : j5(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function $4e(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function _4e(e, t, r) {
  return y4e(e, L5(L5({}, t), {}, {
    v2: !0
  }), r);
}
function Fw(e) {
  "@babel/helpers - typeof";
  return Fw = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fw(e);
}
function k5(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function E4e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? k5(Object(r), !0).forEach(function(n) {
      w4e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : k5(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function w4e(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function O4e(e, t) {
  return A4e(e) || M4e(e, t) || I4e(e, t) || T4e();
}
function T4e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function I4e(e, t) {
  if (e) {
    if (typeof e == "string") return F5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return F5(e, t);
  }
}
function F5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function M4e(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], a = !0, i = !1, o, s;
    try {
      for (r = r.call(e); !(a = (o = r.next()).done) && (n.push(o.value), !(t && n.length === t)); a = !0)
        ;
    } catch (l) {
      i = !0, s = l;
    } finally {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (i) throw s;
      }
    }
    return n;
  }
}
function A4e(e) {
  if (Array.isArray(e)) return e;
}
function P4e(e) {
  var t = Array.prototype.slice.call(e), r = O4e(t, 4), n = r[0], a = r[1], i = r[2], o = r[3], s, l, c;
  if (typeof n == "string")
    s = n;
  else throw new TypeError("A text for parsing must be a string.");
  if (!a || typeof a == "string")
    o ? (l = i, c = o) : (l = void 0, c = i), a && (l = E4e({
      defaultCountry: a
    }, l));
  else if (R4e(a))
    i ? (l = a, c = i) : c = a;
  else throw new Error("Invalid second argument: ".concat(a));
  return {
    text: s,
    options: l,
    metadata: c
  };
}
var R4e = function(t) {
  return Fw(t) === "object";
};
function B5(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function z5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? B5(Object(r), !0).forEach(function(n) {
      N4e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : B5(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function N4e(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function D4e(e, t, r) {
  t && t.defaultCountry && !aNe(t.defaultCountry, r) && (t = z5(z5({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return _4e(e, t, r);
  } catch (n) {
    if (!(n instanceof Ds)) throw n;
  }
}
function j4e() {
  var e = P4e(arguments), t = e.text, r = e.options, n = e.metadata;
  return D4e(t, r, n);
}
function L4e() {
  return NRe(j4e, arguments);
}
var UZ = "isPhoneNumber";
function WZ(e, t) {
  try {
    var r = L4e(e, t), n = r?.isValid();
    return !!n;
  } catch {
    return !1;
  }
}
function k4e(e, t) {
  return vt({
    name: UZ,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return WZ(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be a valid phone number";
      }, t)
    }
  }, t);
}
var qZ = "isMilitaryTime";
function KZ(e) {
  var t = /^([01]\d|2[0-3]):?([0-5]\d)$/;
  return typeof e == "string" && jZ(e, t);
}
function F4e(e) {
  return vt({
    name: qZ,
    validator: {
      validate: function(t, r) {
        return KZ(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a valid representation of military time in the format HH:MM";
      }, e)
    }
  }, e);
}
var Bw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = {
    md5: 32,
    md4: 32,
    sha1: 40,
    sha256: 64,
    sha384: 96,
    sha512: 128,
    ripemd128: 32,
    ripemd160: 40,
    tiger128: 32,
    tiger160: 40,
    tiger192: 48,
    crc32: 8,
    crc32b: 8
  };
  function i(o, s) {
    (0, r.default)(o);
    var l = new RegExp("^[a-fA-F0-9]{".concat(a[s], "}$"));
    return l.test(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Bw, Bw.exports);
var YZ = Bw.exports;
const B4e = /* @__PURE__ */ Ut(YZ);
var ZZ = "isHash";
function XZ(e, t) {
  return typeof e == "string" && B4e(e, t);
}
function z4e(e, t) {
  return vt({
    name: ZZ,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return XZ(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be a hash of type $constraint1";
      }, t)
    }
  }, t);
}
var zw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = "^\\d{4}-?\\d{3}[\\dX]$";
  function i(o) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, r.default)(o);
    var l = a;
    if (l = s.require_hyphen ? l.replace("?", "") : l, l = s.case_sensitive ? new RegExp(l) : new RegExp(l, "i"), !l.test(o))
      return !1;
    for (var c = o.replace("-", "").toUpperCase(), u = 0, d = 0; d < c.length; d++) {
      var f = c[d];
      u += (f === "X" ? 10 : +f) * (8 - d);
    }
    return u % 11 === 0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(zw, zw.exports);
var JZ = zw.exports;
const H4e = /* @__PURE__ */ Ut(JZ);
var QZ = "isISSN";
function eX(e, t) {
  return typeof e == "string" && H4e(e, t);
}
function V4e(e, t) {
  return vt({
    name: QZ,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return eX(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be a ISSN";
      }, t)
    }
  }, t);
}
var tX = "isDateString";
function rX(e, t) {
  return EM(e, t);
}
function G4e(e, t) {
  return vt({
    name: tX,
    constraints: [e],
    validator: {
      validate: function(r) {
        return rX(r, e);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be a valid ISO 8601 date string";
      }, t)
    }
  }, t);
}
var Hw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = n(Pt);
  function n(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var a = {
    loose: !1
  }, i = ["true", "false", "1", "0"], o = [].concat(i, ["yes", "no"]);
  function s(l) {
    var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : a;
    return (0, r.default)(l), c.loose ? o.includes(l.toLowerCase()) : i.includes(l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Hw, Hw.exports);
var nX = Hw.exports;
const U4e = /* @__PURE__ */ Ut(nX);
var aX = "isBooleanString";
function iX(e) {
  return typeof e == "string" && U4e(e);
}
function W4e(e) {
  return vt({
    name: aX,
    validator: {
      validate: function(t, r) {
        return iX(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a boolean string";
      }, e)
    }
  }, e);
}
var Vw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = a(Pt), n = Ln;
  function a(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var i = /^[0-9]+$/;
  function o(s, l) {
    return (0, r.default)(s), l && l.no_symbols ? i.test(s) : new RegExp("^[+-]?([0-9]*[".concat((l || {}).locale ? n.decimal[l.locale] : ".", "])?[0-9]+$")).test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Vw, Vw.exports);
var oX = Vw.exports;
const q4e = /* @__PURE__ */ Ut(oX);
var sX = "isNumberString";
function lX(e, t) {
  return typeof e == "string" && q4e(e, t);
}
function K4e(e, t) {
  return vt({
    name: sX,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return lX(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be a number string";
      }, t)
    }
  }, t);
}
var Gw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var r = a(Pt), n = a(si);
  function a(c) {
    return c && c.__esModule ? c : { default: c };
  }
  var i = /^[A-Z2-7]+=*$/, o = /^[A-HJKMNP-TV-Z0-9]+$/, s = {
    crockford: !1
  };
  function l(c, u) {
    if ((0, r.default)(c), u = (0, n.default)(u, s), u.crockford)
      return o.test(c);
    var d = c.length;
    return !!(d % 8 === 0 && i.test(c));
  }
  e.exports = t.default, e.exports.default = t.default;
})(Gw, Gw.exports);
var cX = Gw.exports;
const Y4e = /* @__PURE__ */ Ut(cX);
var uX = "isBase32";
function dX(e) {
  return typeof e == "string" && Y4e(e);
}
function Z4e(e) {
  return vt({
    name: uX,
    validator: {
      validate: function(t, r) {
        return dX(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be base32 encoded";
      }, e)
    }
  }, e);
}
var Uw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = a(Pt), n = Dd;
  function a(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var i = /^[A-Za-z]{6}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
  function o(s) {
    (0, r.default)(s);
    var l = s.slice(4, 6).toUpperCase();
    return !n.CountryCodes.has(l) && l !== "XK" ? !1 : i.test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Uw, Uw.exports);
var fX = Uw.exports;
const X4e = /* @__PURE__ */ Ut(fX);
var pX = "isBIC";
function mX(e) {
  return typeof e == "string" && X4e(e);
}
function J4e(e) {
  return vt({
    name: pX,
    validator: {
      validate: function(t, r) {
        return mX(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a BIC or SWIFT code";
      }, e)
    }
  }, e);
}
var Ww = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(Pt);
  function n(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var a = /^(bc1)[a-z0-9]{25,39}$/, i = /^(1|3)[A-HJ-NP-Za-km-z1-9]{25,39}$/;
  function o(s) {
    return (0, r.default)(s), a.test(s) || i.test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Ww, Ww.exports);
var vX = Ww.exports;
const Q4e = /* @__PURE__ */ Ut(vX);
var hX = "isBtcAddress";
function gX(e) {
  return typeof e == "string" && Q4e(e);
}
function e6e(e) {
  return vt({
    name: hX,
    validator: {
      validate: function(t, r) {
        return gX(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a BTC address";
      }, e)
    }
  }, e);
}
var qw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = n(Pt);
  function n(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var a = /^[a-z]+\/[a-z0-9\-\+\._]+$/i, i = /^[a-z\-]+=[a-z0-9\-]+$/i, o = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;
  function s(l) {
    (0, r.default)(l);
    var c = l.split(",");
    if (c.length < 2)
      return !1;
    var u = c.shift().trim().split(";"), d = u.shift();
    if (d.slice(0, 5) !== "data:")
      return !1;
    var f = d.slice(5);
    if (f !== "" && !a.test(f))
      return !1;
    for (var m = 0; m < u.length; m++)
      if (!(m === u.length - 1 && u[m].toLowerCase() === "base64") && !i.test(u[m]))
        return !1;
    for (var h = 0; h < c.length; h++)
      if (!o.test(c[h]))
        return !1;
    return !0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(qw, qw.exports);
var yX = qw.exports;
const t6e = /* @__PURE__ */ Ut(yX);
var bX = "isDataURI";
function CX(e) {
  return typeof e == "string" && t6e(e);
}
function r6e(e) {
  return vt({
    name: bX,
    validator: {
      validate: function(t, r) {
        return CX(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a data uri format";
      }, e)
    }
  }, e);
}
var Kw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = c;
  var r = n(Pt);
  function n(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var a = 8, i = 14, o = /^(\d{8}|\d{13}|\d{14})$/;
  function s(u, d) {
    return u === a || u === i ? d % 2 === 0 ? 3 : 1 : d % 2 === 0 ? 1 : 3;
  }
  function l(u) {
    var d = u.slice(0, -1).split("").map(function(m, h) {
      return Number(m) * s(u.length, h);
    }).reduce(function(m, h) {
      return m + h;
    }, 0), f = 10 - d % 10;
    return f < 10 ? f : 0;
  }
  function c(u) {
    (0, r.default)(u);
    var d = Number(u.slice(-1));
    return o.test(u) && d === l(u);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Kw, Kw.exports);
var SX = Kw.exports;
const n6e = /* @__PURE__ */ Ut(SX);
var xX = "isEAN";
function $X(e) {
  return typeof e == "string" && n6e(e);
}
function a6e(e) {
  return vt({
    name: xX,
    validator: {
      validate: function(t, r) {
        return $X(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be an EAN (European Article Number)";
      }, e)
    }
  }, e);
}
var Yw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = /^(0x)[0-9a-f]{40}$/i;
  function i(o) {
    return (0, r.default)(o), a.test(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Yw, Yw.exports);
var _X = Yw.exports;
const i6e = /* @__PURE__ */ Ut(_X);
var EX = "isEthereumAddress";
function wX(e) {
  return typeof e == "string" && i6e(e);
}
function o6e(e) {
  return vt({
    name: EX,
    validator: {
      validate: function(t, r) {
        return wX(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be an Ethereum address";
      }, e)
    }
  }, e);
}
var Zw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(Pt);
  function n(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var a = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(,(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}(,((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?))?\)$/i, i = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(\s(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s?(\/\s((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s?)?\)$/i;
  function o(s) {
    (0, r.default)(s);
    var l = s.replace(/\s+/g, " ").replace(/\s?(hsla?\(|\)|,)\s?/ig, "$1");
    return l.indexOf(",") !== -1 ? a.test(l) : i.test(l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Zw, Zw.exports);
var OX = Zw.exports;
const s6e = /* @__PURE__ */ Ut(OX);
var TX = "isHSL";
function IX(e) {
  return typeof e == "string" && s6e(e);
}
function l6e(e) {
  return vt({
    name: TX,
    validator: {
      validate: function(t, r) {
        return IX(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a HSL color";
      }, e)
    }
  }, e);
}
var Lh = {};
Object.defineProperty(Lh, "__esModule", {
  value: !0
});
var c6e = Lh.default = m6e;
Lh.locales = void 0;
var u6e = d6e(Pt);
function d6e(e) {
  return e && e.__esModule ? e : { default: e };
}
var Xw = {
  AD: /^(AD[0-9]{2})\d{8}[A-Z0-9]{12}$/,
  AE: /^(AE[0-9]{2})\d{3}\d{16}$/,
  AL: /^(AL[0-9]{2})\d{8}[A-Z0-9]{16}$/,
  AT: /^(AT[0-9]{2})\d{16}$/,
  AZ: /^(AZ[0-9]{2})[A-Z0-9]{4}\d{20}$/,
  BA: /^(BA[0-9]{2})\d{16}$/,
  BE: /^(BE[0-9]{2})\d{12}$/,
  BG: /^(BG[0-9]{2})[A-Z]{4}\d{6}[A-Z0-9]{8}$/,
  BH: /^(BH[0-9]{2})[A-Z]{4}[A-Z0-9]{14}$/,
  BR: /^(BR[0-9]{2})\d{23}[A-Z]{1}[A-Z0-9]{1}$/,
  BY: /^(BY[0-9]{2})[A-Z0-9]{4}\d{20}$/,
  CH: /^(CH[0-9]{2})\d{5}[A-Z0-9]{12}$/,
  CR: /^(CR[0-9]{2})\d{18}$/,
  CY: /^(CY[0-9]{2})\d{8}[A-Z0-9]{16}$/,
  CZ: /^(CZ[0-9]{2})\d{20}$/,
  DE: /^(DE[0-9]{2})\d{18}$/,
  DK: /^(DK[0-9]{2})\d{14}$/,
  DO: /^(DO[0-9]{2})[A-Z]{4}\d{20}$/,
  EE: /^(EE[0-9]{2})\d{16}$/,
  EG: /^(EG[0-9]{2})\d{25}$/,
  ES: /^(ES[0-9]{2})\d{20}$/,
  FI: /^(FI[0-9]{2})\d{14}$/,
  FO: /^(FO[0-9]{2})\d{14}$/,
  FR: /^(FR[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
  GB: /^(GB[0-9]{2})[A-Z]{4}\d{14}$/,
  GE: /^(GE[0-9]{2})[A-Z0-9]{2}\d{16}$/,
  GI: /^(GI[0-9]{2})[A-Z]{4}[A-Z0-9]{15}$/,
  GL: /^(GL[0-9]{2})\d{14}$/,
  GR: /^(GR[0-9]{2})\d{7}[A-Z0-9]{16}$/,
  GT: /^(GT[0-9]{2})[A-Z0-9]{4}[A-Z0-9]{20}$/,
  HR: /^(HR[0-9]{2})\d{17}$/,
  HU: /^(HU[0-9]{2})\d{24}$/,
  IE: /^(IE[0-9]{2})[A-Z0-9]{4}\d{14}$/,
  IL: /^(IL[0-9]{2})\d{19}$/,
  IQ: /^(IQ[0-9]{2})[A-Z]{4}\d{15}$/,
  IR: /^(IR[0-9]{2})0\d{2}0\d{18}$/,
  IS: /^(IS[0-9]{2})\d{22}$/,
  IT: /^(IT[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
  JO: /^(JO[0-9]{2})[A-Z]{4}\d{22}$/,
  KW: /^(KW[0-9]{2})[A-Z]{4}[A-Z0-9]{22}$/,
  KZ: /^(KZ[0-9]{2})\d{3}[A-Z0-9]{13}$/,
  LB: /^(LB[0-9]{2})\d{4}[A-Z0-9]{20}$/,
  LC: /^(LC[0-9]{2})[A-Z]{4}[A-Z0-9]{24}$/,
  LI: /^(LI[0-9]{2})\d{5}[A-Z0-9]{12}$/,
  LT: /^(LT[0-9]{2})\d{16}$/,
  LU: /^(LU[0-9]{2})\d{3}[A-Z0-9]{13}$/,
  LV: /^(LV[0-9]{2})[A-Z]{4}[A-Z0-9]{13}$/,
  MC: /^(MC[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
  MD: /^(MD[0-9]{2})[A-Z0-9]{20}$/,
  ME: /^(ME[0-9]{2})\d{18}$/,
  MK: /^(MK[0-9]{2})\d{3}[A-Z0-9]{10}\d{2}$/,
  MR: /^(MR[0-9]{2})\d{23}$/,
  MT: /^(MT[0-9]{2})[A-Z]{4}\d{5}[A-Z0-9]{18}$/,
  MU: /^(MU[0-9]{2})[A-Z]{4}\d{19}[A-Z]{3}$/,
  MZ: /^(MZ[0-9]{2})\d{21}$/,
  NL: /^(NL[0-9]{2})[A-Z]{4}\d{10}$/,
  NO: /^(NO[0-9]{2})\d{11}$/,
  PK: /^(PK[0-9]{2})[A-Z0-9]{4}\d{16}$/,
  PL: /^(PL[0-9]{2})\d{24}$/,
  PS: /^(PS[0-9]{2})[A-Z0-9]{4}\d{21}$/,
  PT: /^(PT[0-9]{2})\d{21}$/,
  QA: /^(QA[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
  RO: /^(RO[0-9]{2})[A-Z]{4}[A-Z0-9]{16}$/,
  RS: /^(RS[0-9]{2})\d{18}$/,
  SA: /^(SA[0-9]{2})\d{2}[A-Z0-9]{18}$/,
  SC: /^(SC[0-9]{2})[A-Z]{4}\d{20}[A-Z]{3}$/,
  SE: /^(SE[0-9]{2})\d{20}$/,
  SI: /^(SI[0-9]{2})\d{15}$/,
  SK: /^(SK[0-9]{2})\d{20}$/,
  SM: /^(SM[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
  SV: /^(SV[0-9]{2})[A-Z0-9]{4}\d{20}$/,
  TL: /^(TL[0-9]{2})\d{19}$/,
  TN: /^(TN[0-9]{2})\d{20}$/,
  TR: /^(TR[0-9]{2})\d{5}[A-Z0-9]{17}$/,
  UA: /^(UA[0-9]{2})\d{6}[A-Z0-9]{19}$/,
  VA: /^(VA[0-9]{2})\d{18}$/,
  VG: /^(VG[0-9]{2})[A-Z0-9]{4}\d{16}$/,
  XK: /^(XK[0-9]{2})\d{16}$/
};
function f6e(e) {
  var t = e.replace(/[\s\-]+/gi, "").toUpperCase(), r = t.slice(0, 2).toUpperCase();
  return r in Xw && Xw[r].test(t);
}
function p6e(e) {
  var t = e.replace(/[^A-Z0-9]+/gi, "").toUpperCase(), r = t.slice(4) + t.slice(0, 4), n = r.replace(/[A-Z]/g, function(i) {
    return i.charCodeAt(0) - 55;
  }), a = n.match(/\d{1,7}/g).reduce(function(i, o) {
    return Number(i + o) % 97;
  }, "");
  return a === 1;
}
function m6e(e) {
  return (0, u6e.default)(e), f6e(e) && p6e(e);
}
var v6e = Object.keys(Xw);
Lh.locales = v6e;
var MX = "isIBAN";
function AX(e) {
  return typeof e == "string" && c6e(e);
}
function h6e(e) {
  return vt({
    name: MX,
    validator: {
      validate: function(t, r) {
        return AX(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be an IBAN";
      }, e)
    }
  }, e);
}
var Jw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = a(Pt), n = a(_M);
  function a(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var i = {
    PL: function(l) {
      (0, r.default)(l);
      var c = {
        1: 1,
        2: 3,
        3: 7,
        4: 9,
        5: 1,
        6: 3,
        7: 7,
        8: 9,
        9: 1,
        10: 3,
        11: 0
      };
      if (l != null && l.length === 11 && (0, n.default)(l, {
        allow_leading_zeroes: !0
      })) {
        var u = l.split("").slice(0, -1), d = u.reduce(function(h, g, y) {
          return h + Number(g) * c[y + 1];
        }, 0), f = d % 10, m = Number(l.charAt(l.length - 1));
        if (f === 0 && m === 0 || m === 10 - f)
          return !0;
      }
      return !1;
    },
    ES: function(l) {
      (0, r.default)(l);
      var c = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/, u = {
        X: 0,
        Y: 1,
        Z: 2
      }, d = ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"], f = l.trim().toUpperCase();
      if (!c.test(f))
        return !1;
      var m = f.slice(0, -1).replace(/[X,Y,Z]/g, function(h) {
        return u[h];
      });
      return f.endsWith(d[m % 23]);
    },
    FI: function(l) {
      if ((0, r.default)(l), l.length !== 11 || !l.match(/^\d{6}[\-A\+]\d{3}[0-9ABCDEFHJKLMNPRSTUVWXY]{1}$/))
        return !1;
      var c = "0123456789ABCDEFHJKLMNPRSTUVWXY", u = parseInt(l.slice(0, 6), 10) * 1e3 + parseInt(l.slice(7, 10), 10), d = u % 31, f = c[d];
      return f === l.slice(10, 11);
    },
    IN: function(l) {
      var c = /^[1-9]\d{3}\s?\d{4}\s?\d{4}$/, u = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]], d = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]], f = l.trim();
      if (!c.test(f))
        return !1;
      var m = 0, h = f.replace(/\s/g, "").split("").map(Number).reverse();
      return h.forEach(function(g, y) {
        m = u[m][d[y % 8][g]];
      }), m === 0;
    },
    IR: function(l) {
      if (!l.match(/^\d{10}$/) || (l = "0000".concat(l).slice(l.length - 6), parseInt(l.slice(3, 9), 10) === 0)) return !1;
      for (var c = parseInt(l.slice(9, 10), 10), u = 0, d = 0; d < 9; d++)
        u += parseInt(l.slice(d, d + 1), 10) * (10 - d);
      return u %= 11, u < 2 && c === u || u >= 2 && c === 11 - u;
    },
    IT: function(l) {
      return l.length !== 9 || l === "CA00000AA" ? !1 : l.search(/C[A-Z][0-9]{5}[A-Z]{2}/i) > -1;
    },
    NO: function(l) {
      var c = l.trim();
      if (isNaN(Number(c)) || c.length !== 11 || c === "00000000000") return !1;
      var u = c.split("").map(Number), d = (11 - (3 * u[0] + 7 * u[1] + 6 * u[2] + 1 * u[3] + 8 * u[4] + 9 * u[5] + 4 * u[6] + 5 * u[7] + 2 * u[8]) % 11) % 11, f = (11 - (5 * u[0] + 4 * u[1] + 3 * u[2] + 2 * u[3] + 7 * u[4] + 6 * u[5] + 5 * u[6] + 4 * u[7] + 3 * u[8] + 2 * d) % 11) % 11;
      return !(d !== u[9] || f !== u[10]);
    },
    TH: function(l) {
      if (!l.match(/^[1-8]\d{12}$/)) return !1;
      for (var c = 0, u = 0; u < 12; u++)
        c += parseInt(l[u], 10) * (13 - u);
      return l[12] === ((11 - c % 11) % 10).toString();
    },
    LK: function(l) {
      var c = /^[1-9]\d{8}[vx]$/i, u = /^[1-9]\d{11}$/i;
      return l.length === 10 && c.test(l) ? !0 : !!(l.length === 12 && u.test(l));
    },
    "he-IL": function(l) {
      var c = /^\d{9}$/, u = l.trim();
      if (!c.test(u))
        return !1;
      for (var d = u, f = 0, m, h = 0; h < d.length; h++)
        m = Number(d[h]) * (h % 2 + 1), f += m > 9 ? m - 9 : m;
      return f % 10 === 0;
    },
    "ar-LY": function(l) {
      var c = /^(1|2)\d{11}$/, u = l.trim();
      return !!c.test(u);
    },
    "ar-TN": function(l) {
      var c = /^\d{8}$/, u = l.trim();
      return !!c.test(u);
    },
    "zh-CN": function(l) {
      var c = [
        "11",
        // 北京
        "12",
        // 天津
        "13",
        // 河北
        "14",
        // 山西
        "15",
        // 内蒙古
        "21",
        // 辽宁
        "22",
        // 吉林
        "23",
        // 黑龙江
        "31",
        // 上海
        "32",
        // 江苏
        "33",
        // 浙江
        "34",
        // 安徽
        "35",
        // 福建
        "36",
        // 江西
        "37",
        // 山东
        "41",
        // 河南
        "42",
        // 湖北
        "43",
        // 湖南
        "44",
        // 广东
        "45",
        // 广西
        "46",
        // 海南
        "50",
        // 重庆
        "51",
        // 四川
        "52",
        // 贵州
        "53",
        // 云南
        "54",
        // 西藏
        "61",
        // 陕西
        "62",
        // 甘肃
        "63",
        // 青海
        "64",
        // 宁夏
        "65",
        // 新疆
        "71",
        // 台湾
        "81",
        // 香港
        "82",
        // 澳门
        "91"
        // 国外
      ], u = ["7", "9", "10", "5", "8", "4", "2", "1", "6", "3", "7", "9", "10", "5", "8", "4", "2"], d = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"], f = function(_) {
        return c.includes(_);
      }, m = function(_) {
        var $ = parseInt(_.substring(0, 4), 10), w = parseInt(_.substring(4, 6), 10), O = parseInt(_.substring(6), 10), T = new Date($, w - 1, O);
        return T > /* @__PURE__ */ new Date() ? !1 : T.getFullYear() === $ && T.getMonth() === w - 1 && T.getDate() === O;
      }, h = function(_) {
        for (var $ = _.substring(0, 17), w = 0, O = 0; O < 17; O++)
          w += parseInt($.charAt(O), 10) * parseInt(u[O], 10);
        var T = w % 11;
        return d[T];
      }, g = function(_) {
        return h(_) === _.charAt(17).toUpperCase();
      }, y = function(_) {
        var $ = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(_);
        if (!$) return !1;
        var w = _.substring(0, 2);
        if ($ = f(w), !$) return !1;
        var O = "19".concat(_.substring(6, 12));
        return $ = m(O), !!$;
      }, S = function(_) {
        var $ = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(_);
        if (!$) return !1;
        var w = _.substring(0, 2);
        if ($ = f(w), !$) return !1;
        var O = _.substring(6, 14);
        return $ = m(O), $ ? g(_) : !1;
      }, x = function(_) {
        var $ = /^\d{15}|(\d{17}(\d|x|X))$/.test(_);
        return $ ? _.length === 15 ? y(_) : S(_) : !1;
      };
      return x(l);
    },
    "zh-HK": function(l) {
      l = l.trim();
      var c = /^[A-Z]{1,2}[0-9]{6}((\([0-9A]\))|(\[[0-9A]\])|([0-9A]))$/, u = /^[0-9]$/;
      if (l = l.toUpperCase(), !c.test(l)) return !1;
      l = l.replace(/\[|\]|\(|\)/g, ""), l.length === 8 && (l = "3".concat(l));
      for (var d = 0, f = 0; f <= 7; f++) {
        var m = void 0;
        u.test(l[f]) ? m = l[f] : m = (l[f].charCodeAt(0) - 55) % 11, d += m * (9 - f);
      }
      d %= 11;
      var h;
      return d === 0 ? h = "0" : d === 1 ? h = "A" : h = String(11 - d), h === l[l.length - 1];
    },
    "zh-TW": function(l) {
      var c = {
        A: 10,
        B: 11,
        C: 12,
        D: 13,
        E: 14,
        F: 15,
        G: 16,
        H: 17,
        I: 34,
        J: 18,
        K: 19,
        L: 20,
        M: 21,
        N: 22,
        O: 35,
        P: 23,
        Q: 24,
        R: 25,
        S: 26,
        T: 27,
        U: 28,
        V: 29,
        W: 32,
        X: 30,
        Y: 31,
        Z: 33
      }, u = l.trim().toUpperCase();
      return /^[A-Z][0-9]{9}$/.test(u) ? Array.from(u).reduce(function(d, f, m) {
        if (m === 0) {
          var h = c[f];
          return h % 10 * 9 + Math.floor(h / 10);
        }
        return m === 9 ? (10 - d % 10 - Number(f)) % 10 === 0 : d + Number(f) * (9 - m);
      }, 0) : !1;
    }
  };
  function o(s, l) {
    if ((0, r.default)(s), l in i)
      return i[l](s);
    if (l === "any") {
      for (var c in i)
        if (i.hasOwnProperty(c)) {
          var u = i[c];
          if (u(s))
            return !0;
        }
      return !1;
    }
    throw new Error("Invalid locale '".concat(l, "'"));
  }
  e.exports = t.default, e.exports.default = t.default;
})(Jw, Jw.exports);
var PX = Jw.exports;
const g6e = /* @__PURE__ */ Ut(PX);
var RX = "isIdentityCard";
function NX(e, t) {
  return typeof e == "string" && g6e(e, t);
}
function y6e(e, t) {
  return vt({
    name: RX,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return NX(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be a identity card number";
      }, t)
    }
  }, t);
}
var Qw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
  function i(o) {
    return (0, r.default)(o), a.test(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Qw, Qw.exports);
var DX = Qw.exports;
const b6e = /* @__PURE__ */ Ut(DX);
var jX = "isISRC";
function LX(e) {
  return typeof e == "string" && b6e(e);
}
function C6e(e) {
  return vt({
    name: jX,
    validator: {
      validate: function(t, r) {
        return LX(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be an ISRC";
      }, e)
    }
  }, e);
}
var eO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = /^[A-Za-z]{2,4}([_-]([A-Za-z]{4}|[\d]{3}))?([_-]([A-Za-z]{2}|[\d]{3}))?$/;
  function i(o) {
    return (0, r.default)(o), o === "en_US_POSIX" || o === "ca_ES_VALENCIA" ? !0 : a.test(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(eO, eO.exports);
var kX = eO.exports;
const S6e = /* @__PURE__ */ Ut(kX);
var FX = "isLocale";
function BX(e) {
  return typeof e == "string" && S6e(e);
}
function x6e(e) {
  return vt({
    name: FX,
    validator: {
      validate: function(t, r) {
        return BX(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be locale";
      }, e)
    }
  }, e);
}
var tO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = /(?:^magnet:\?|[^?&]&)xt(?:\.1)?=urn:(?:(?:aich|bitprint|btih|ed2k|ed2khash|kzhash|md5|sha1|tree:tiger):[a-z0-9]{32}(?:[a-z0-9]{8})?|btmh:1220[a-z0-9]{64})(?:$|&)/i;
  function i(o) {
    return (0, r.default)(o), o.indexOf("magnet:?") !== 0 ? !1 : a.test(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(tO, tO.exports);
var zX = tO.exports;
const $6e = /* @__PURE__ */ Ut(zX);
var HX = "isMagnetURI";
function VX(e) {
  return typeof e == "string" && $6e(e);
}
function _6e(e) {
  return vt({
    name: HX,
    validator: {
      validate: function(t, r) {
        return VX(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be magnet uri format";
      }, e)
    }
  }, e);
}
var rO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = n(Pt);
  function n(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var a = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+_]{1,100}$/i, i = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i, o = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i;
  function s(l) {
    return (0, r.default)(l), a.test(l) || i.test(l) || o.test(l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(rO, rO.exports);
var GX = rO.exports;
const E6e = /* @__PURE__ */ Ut(GX);
var UX = "isMimeType";
function WX(e) {
  return typeof e == "string" && E6e(e);
}
function w6e(e) {
  return vt({
    name: UX,
    validator: {
      validate: function(t, r) {
        return WX(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be MIME type format";
      }, e)
    }
  }, e);
}
var nO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = /^(0o)?[0-7]+$/i;
  function i(o) {
    return (0, r.default)(o), a.test(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(nO, nO.exports);
var qX = nO.exports;
const O6e = /* @__PURE__ */ Ut(qX);
var KX = "isOctal";
function YX(e) {
  return typeof e == "string" && O6e(e);
}
function T6e(e) {
  return vt({
    name: KX,
    validator: {
      validate: function(t, r) {
        return YX(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be valid octal number";
      }, e)
    }
  }, e);
}
var aO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = {
    AM: /^[A-Z]{2}\d{7}$/,
    // ARMENIA
    AR: /^[A-Z]{3}\d{6}$/,
    // ARGENTINA
    AT: /^[A-Z]\d{7}$/,
    // AUSTRIA
    AU: /^[A-Z]\d{7}$/,
    // AUSTRALIA
    AZ: /^[A-Z]{2,3}\d{7,8}$/,
    // AZERBAIJAN
    BE: /^[A-Z]{2}\d{6}$/,
    // BELGIUM
    BG: /^\d{9}$/,
    // BULGARIA
    BR: /^[A-Z]{2}\d{6}$/,
    // BRAZIL
    BY: /^[A-Z]{2}\d{7}$/,
    // BELARUS
    CA: /^[A-Z]{2}\d{6}$/,
    // CANADA
    CH: /^[A-Z]\d{7}$/,
    // SWITZERLAND
    CN: /^G\d{8}$|^E(?![IO])[A-Z0-9]\d{7}$/,
    // CHINA [G=Ordinary, E=Electronic] followed by 8-digits, or E followed by any UPPERCASE letter (except I and O) followed by 7 digits
    CY: /^[A-Z](\d{6}|\d{8})$/,
    // CYPRUS
    CZ: /^\d{8}$/,
    // CZECH REPUBLIC
    DE: /^[CFGHJKLMNPRTVWXYZ0-9]{9}$/,
    // GERMANY
    DK: /^\d{9}$/,
    // DENMARK
    DZ: /^\d{9}$/,
    // ALGERIA
    EE: /^([A-Z]\d{7}|[A-Z]{2}\d{7})$/,
    // ESTONIA (K followed by 7-digits), e-passports have 2 UPPERCASE followed by 7 digits
    ES: /^[A-Z0-9]{2}([A-Z0-9]?)\d{6}$/,
    // SPAIN
    FI: /^[A-Z]{2}\d{7}$/,
    // FINLAND
    FR: /^\d{2}[A-Z]{2}\d{5}$/,
    // FRANCE
    GB: /^\d{9}$/,
    // UNITED KINGDOM
    GR: /^[A-Z]{2}\d{7}$/,
    // GREECE
    HR: /^\d{9}$/,
    // CROATIA
    HU: /^[A-Z]{2}(\d{6}|\d{7})$/,
    // HUNGARY
    IE: /^[A-Z0-9]{2}\d{7}$/,
    // IRELAND
    IN: /^[A-Z]{1}-?\d{7}$/,
    // INDIA
    ID: /^[A-C]\d{7}$/,
    // INDONESIA
    IR: /^[A-Z]\d{8}$/,
    // IRAN
    IS: /^(A)\d{7}$/,
    // ICELAND
    IT: /^[A-Z0-9]{2}\d{7}$/,
    // ITALY
    JM: /^[Aa]\d{7}$/,
    // JAMAICA
    JP: /^[A-Z]{2}\d{7}$/,
    // JAPAN
    KR: /^[MS]\d{8}$/,
    // SOUTH KOREA, REPUBLIC OF KOREA, [S=PS Passports, M=PM Passports]
    KZ: /^[a-zA-Z]\d{7}$/,
    // KAZAKHSTAN
    LI: /^[a-zA-Z]\d{5}$/,
    // LIECHTENSTEIN
    LT: /^[A-Z0-9]{8}$/,
    // LITHUANIA
    LU: /^[A-Z0-9]{8}$/,
    // LUXEMBURG
    LV: /^[A-Z0-9]{2}\d{7}$/,
    // LATVIA
    LY: /^[A-Z0-9]{8}$/,
    // LIBYA
    MT: /^\d{7}$/,
    // MALTA
    MZ: /^([A-Z]{2}\d{7})|(\d{2}[A-Z]{2}\d{5})$/,
    // MOZAMBIQUE
    MY: /^[AHK]\d{8}$/,
    // MALAYSIA
    MX: /^\d{10,11}$/,
    // MEXICO
    NL: /^[A-Z]{2}[A-Z0-9]{6}\d$/,
    // NETHERLANDS
    NZ: /^([Ll]([Aa]|[Dd]|[Ff]|[Hh])|[Ee]([Aa]|[Pp])|[Nn])\d{6}$/,
    // NEW ZEALAND
    PH: /^([A-Z](\d{6}|\d{7}[A-Z]))|([A-Z]{2}(\d{6}|\d{7}))$/,
    // PHILIPPINES
    PK: /^[A-Z]{2}\d{7}$/,
    // PAKISTAN
    PL: /^[A-Z]{2}\d{7}$/,
    // POLAND
    PT: /^[A-Z]\d{6}$/,
    // PORTUGAL
    RO: /^\d{8,9}$/,
    // ROMANIA
    RU: /^\d{9}$/,
    // RUSSIAN FEDERATION
    SE: /^\d{8}$/,
    // SWEDEN
    SL: /^(P)[A-Z]\d{7}$/,
    // SLOVENIA
    SK: /^[0-9A-Z]\d{7}$/,
    // SLOVAKIA
    TH: /^[A-Z]{1,2}\d{6,7}$/,
    // THAILAND
    TR: /^[A-Z]\d{8}$/,
    // TURKEY
    UA: /^[A-Z]{2}\d{6}$/,
    // UKRAINE
    US: /^\d{9}$/
    // UNITED STATES
  };
  function i(o, s) {
    (0, r.default)(o);
    var l = o.replace(/\s/g, "").toUpperCase();
    return s.toUpperCase() in a && a[s].test(l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(aO, aO.exports);
var ZX = aO.exports;
const I6e = /* @__PURE__ */ Ut(ZX);
var XX = "isPassportNumber";
function JX(e, t) {
  return typeof e == "string" && I6e(e, t);
}
function M6e(e, t) {
  return vt({
    name: XX,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return JX(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be valid passport number";
      }, t)
    }
  }, t);
}
var kh = {};
Object.defineProperty(kh, "__esModule", {
  value: !0
});
var A6e = kh.default = D6e;
kh.locales = void 0;
var P6e = R6e(Pt);
function R6e(e) {
  return e && e.__esModule ? e : { default: e };
}
var H5 = /^\d{3}$/, ji = /^\d{4}$/, ti = /^\d{5}$/, T_ = /^\d{6}$/, Ku = {
  AD: /^AD\d{3}$/,
  AT: ji,
  AU: ji,
  AZ: /^AZ\d{4}$/,
  BA: /^([7-8]\d{4}$)/,
  BE: ji,
  BG: ji,
  BR: /^\d{5}-\d{3}$/,
  BY: /^2[1-4]\d{4}$/,
  CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
  CH: ji,
  CN: /^(0[1-7]|1[012356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[1-5]|8[1345]|9[09])\d{4}$/,
  CZ: /^\d{3}\s?\d{2}$/,
  DE: ti,
  DK: ji,
  DO: ti,
  DZ: ti,
  EE: ti,
  ES: /^(5[0-2]{1}|[0-4]{1}\d{1})\d{3}$/,
  FI: ti,
  FR: /^\d{2}\s?\d{3}$/,
  GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
  GR: /^\d{3}\s?\d{2}$/,
  HR: /^([1-5]\d{4}$)/,
  HT: /^HT\d{4}$/,
  HU: ji,
  ID: ti,
  IE: /^(?!.*(?:o))[A-Za-z]\d[\dw]\s\w{4}$/i,
  IL: /^(\d{5}|\d{7})$/,
  IN: /^((?!10|29|35|54|55|65|66|86|87|88|89)[1-9][0-9]{5})$/,
  IR: /^(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}$/,
  IS: H5,
  IT: ti,
  JP: /^\d{3}\-\d{4}$/,
  KE: ti,
  KR: /^(\d{5}|\d{6})$/,
  LI: /^(948[5-9]|949[0-7])$/,
  LT: /^LT\-\d{5}$/,
  LU: ji,
  LV: /^LV\-\d{4}$/,
  LK: ti,
  MG: H5,
  MX: ti,
  MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
  MY: ti,
  NL: /^\d{4}\s?[a-z]{2}$/i,
  NO: ji,
  NP: /^(10|21|22|32|33|34|44|45|56|57)\d{3}$|^(977)$/i,
  NZ: ji,
  PL: /^\d{2}\-\d{3}$/,
  PR: /^00[679]\d{2}([ -]\d{4})?$/,
  PT: /^\d{4}\-\d{3}?$/,
  RO: T_,
  RU: T_,
  SA: ti,
  SE: /^[1-9]\d{2}\s?\d{2}$/,
  SG: T_,
  SI: ji,
  SK: /^\d{3}\s?\d{2}$/,
  TH: ti,
  TN: ji,
  TW: /^\d{3}(\d{2})?$/,
  UA: ti,
  US: /^\d{5}(-\d{4})?$/,
  ZA: ji,
  ZM: ti
}, N6e = Object.keys(Ku);
kh.locales = N6e;
function D6e(e, t) {
  if ((0, P6e.default)(e), t in Ku)
    return Ku[t].test(e);
  if (t === "any") {
    for (var r in Ku)
      if (Ku.hasOwnProperty(r)) {
        var n = Ku[r];
        if (n.test(e))
          return !0;
      }
    return !1;
  }
  throw new Error("Invalid locale '".concat(t, "'"));
}
var QX = "isPostalCode";
function eJ(e, t) {
  return typeof e == "string" && A6e(e, t);
}
function j6e(e, t) {
  return vt({
    name: QX,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return eJ(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be a postal code";
      }, t)
    }
  }, t);
}
var iO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = S;
  var r = n(Pt);
  function n(x) {
    return x && x.__esModule ? x : { default: x };
  }
  var a = /[0-9]{4}/, i = /(0[1-9]|1[0-2])/, o = /([12]\d|0[1-9]|3[01])/, s = /([01][0-9]|2[0-3])/, l = /[0-5][0-9]/, c = /([0-5][0-9]|60)/, u = /(\.[0-9]+)?/, d = new RegExp("[-+]".concat(s.source, ":").concat(l.source)), f = new RegExp("([zZ]|".concat(d.source, ")")), m = new RegExp("".concat(s.source, ":").concat(l.source, ":").concat(c.source).concat(u.source)), h = new RegExp("".concat(a.source, "-").concat(i.source, "-").concat(o.source)), g = new RegExp("".concat(m.source).concat(f.source)), y = new RegExp("^".concat(h.source, "[ tT]").concat(g.source, "$"));
  function S(x) {
    return (0, r.default)(x), y.test(x);
  }
  e.exports = t.default, e.exports.default = t.default;
})(iO, iO.exports);
var tJ = iO.exports;
const L6e = /* @__PURE__ */ Ut(tJ);
var rJ = "isRFC3339";
function nJ(e) {
  return typeof e == "string" && L6e(e);
}
function k6e(e) {
  return vt({
    name: rJ,
    validator: {
      validate: function(t, r) {
        return nJ(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be RFC 3339 date";
      }, e)
    }
  }, e);
}
var oO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var r = n(Pt);
  function n(c) {
    return c && c.__esModule ? c : { default: c };
  }
  var a = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/, i = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/, o = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)$/, s = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/;
  function l(c) {
    var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    return (0, r.default)(c), u ? a.test(c) || i.test(c) || o.test(c) || s.test(c) : a.test(c) || i.test(c);
  }
  e.exports = t.default, e.exports.default = t.default;
})(oO, oO.exports);
var aJ = oO.exports;
const F6e = /* @__PURE__ */ Ut(aJ);
var iJ = "isRgbColor";
function oJ(e, t) {
  return typeof e == "string" && F6e(e, t);
}
function B6e(e, t) {
  return vt({
    name: iJ,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return oJ(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be RGB color";
      }, t)
    }
  }, t);
}
var sO = { exports: {} }, lO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n, a) {
    var i = n.join("");
    return new RegExp(i, a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(lO, lO.exports);
var z6e = lO.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = a(Pt), n = a(z6e);
  function a(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var i = (0, n.default)(["^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)", "(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))", "?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$"], "i");
  function o(s) {
    return (0, r.default)(s), i.test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(sO, sO.exports);
var sJ = sO.exports;
const H6e = /* @__PURE__ */ Ut(sJ);
var lJ = "isSemVer";
function cJ(e) {
  return typeof e == "string" && H6e(e);
}
function V6e(e) {
  return vt({
    name: lJ,
    validator: {
      validate: function(t, r) {
        return cJ(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a Semantic Versioning Specification";
      }, e)
    }
  }, e);
}
var cO = { exports: {} }, uO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Pt);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i) {
    return (0, r.default)(i), i = Date.parse(i), isNaN(i) ? null : new Date(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(uO, uO.exports);
var PM = uO.exports, dO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Pt);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i, o) {
    return (0, r.default)(i), parseInt(i, o || 10);
  }
  e.exports = t.default, e.exports.default = t.default;
})(dO, dO.exports);
var G6e = dO.exports, fO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Pt);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i, o) {
    return (0, r.default)(i), o ? i === "1" || /^true$/i.test(i) : i !== "0" && !/^false$/i.test(i) && i !== "";
  }
  e.exports = t.default, e.exports.default = t.default;
})(fO, fO.exports);
var U6e = fO.exports, pO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Pt);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i, o) {
    return (0, r.default)(i), i === o;
  }
  e.exports = t.default, e.exports.default = t.default;
})(pO, pO.exports);
var W6e = pO.exports, mO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var r = a(Pt), n = a(Dh);
  function a(c) {
    return c && c.__esModule ? c : { default: c };
  }
  var i = /^\d{1,3}$/, o = 32, s = 128;
  function l(c) {
    var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    (0, r.default)(c);
    var d = c.split("/");
    if (d.length !== 2 || !i.test(d[1]) || d[1].length > 1 && d[1].startsWith("0"))
      return !1;
    var f = (0, n.default)(d[0], u);
    if (!f)
      return !1;
    var m = null;
    switch (String(u)) {
      case "4":
        m = o;
        break;
      case "6":
        m = s;
        break;
      default:
        m = (0, n.default)(d[0], "6") ? s : o;
    }
    return d[1] <= m && d[1] >= 0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(mO, mO.exports);
var q6e = mO.exports, vO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = h;
  var r = n(si);
  function n(g) {
    return g && g.__esModule ? g : { default: g };
  }
  function a(g, y) {
    return s(g) || o(g, y) || c(g, y) || i();
  }
  function i() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function o(g, y) {
    if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(g)))) {
      var S = [], x = !0, b = !1, _ = void 0;
      try {
        for (var $ = g[Symbol.iterator](), w; !(x = (w = $.next()).done) && (S.push(w.value), !(y && S.length === y)); x = !0)
          ;
      } catch (O) {
        b = !0, _ = O;
      } finally {
        try {
          !x && $.return != null && $.return();
        } finally {
          if (b) throw _;
        }
      }
      return S;
    }
  }
  function s(g) {
    if (Array.isArray(g)) return g;
  }
  function l(g, y) {
    var S;
    if (typeof Symbol > "u" || g[Symbol.iterator] == null) {
      if (Array.isArray(g) || (S = c(g)) || y) {
        S && (g = S);
        var x = 0, b = function() {
        };
        return { s: b, n: function() {
          return x >= g.length ? { done: !0 } : { done: !1, value: g[x++] };
        }, e: function(T) {
          throw T;
        }, f: b };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var _ = !0, $ = !1, w;
    return { s: function() {
      S = g[Symbol.iterator]();
    }, n: function() {
      var T = S.next();
      return _ = T.done, T;
    }, e: function(T) {
      $ = !0, w = T;
    }, f: function() {
      try {
        !_ && S.return != null && S.return();
      } finally {
        if ($) throw w;
      }
    } };
  }
  function c(g, y) {
    if (g) {
      if (typeof g == "string") return u(g, y);
      var S = Object.prototype.toString.call(g).slice(8, -1);
      if (S === "Object" && g.constructor && (S = g.constructor.name), S === "Map" || S === "Set") return Array.from(g);
      if (S === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(S)) return u(g, y);
    }
  }
  function u(g, y) {
    (y == null || y > g.length) && (y = g.length);
    for (var S = 0, x = new Array(y); S < y; S++)
      x[S] = g[S];
    return x;
  }
  var d = {
    format: "YYYY/MM/DD",
    delimiters: ["/", "-"],
    strictMode: !1
  };
  function f(g) {
    return /(^(y{4}|y{2})[.\/-](m{1,2})[.\/-](d{1,2})$)|(^(m{1,2})[.\/-](d{1,2})[.\/-]((y{4}|y{2})$))|(^(d{1,2})[.\/-](m{1,2})[.\/-]((y{4}|y{2})$))/gi.test(g);
  }
  function m(g, y) {
    for (var S = [], x = Math.min(g.length, y.length), b = 0; b < x; b++)
      S.push([g[b], y[b]]);
    return S;
  }
  function h(g, y) {
    if (typeof y == "string" ? y = (0, r.default)({
      format: y
    }, d) : y = (0, r.default)(y, d), typeof g == "string" && f(y.format)) {
      var S = y.delimiters.find(function(P) {
        return y.format.indexOf(P) !== -1;
      }), x = y.strictMode ? S : y.delimiters.find(function(P) {
        return g.indexOf(P) !== -1;
      }), b = m(g.split(x), y.format.toLowerCase().split(S)), _ = {}, $ = l(b), w;
      try {
        for ($.s(); !(w = $.n()).done; ) {
          var O = a(w.value, 2), T = O[0], I = O[1];
          if (T.length !== I.length)
            return !1;
          _[I.charAt(0)] = T;
        }
      } catch (P) {
        $.e(P);
      } finally {
        $.f();
      }
      return new Date("".concat(_.m, "/").concat(_.d, "/").concat(_.y)).getDate() === +_.d;
    }
    return y.strictMode ? !1 : Object.prototype.toString.call(g) === "[object Date]" && isFinite(g);
  }
  e.exports = t.default, e.exports.default = t.default;
})(vO, vO.exports);
var uJ = vO.exports, hO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(si);
  function n(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var a = {
    hourFormat: "hour24",
    mode: "default"
  }, i = {
    hour24: {
      default: /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/,
      withSeconds: /^([01]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/
    },
    hour12: {
      default: /^(0?[1-9]|1[0-2]):([0-5][0-9]) (A|P)M$/,
      withSeconds: /^(0?[1-9]|1[0-2]):([0-5][0-9]):([0-5][0-9]) (A|P)M$/
    }
  };
  function o(s, l) {
    return l = (0, r.default)(l, a), typeof s != "string" ? !1 : i[l.hourFormat][l.mode].test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(hO, hO.exports);
var K6e = hO.exports, gO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(Pt);
  function n(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var a = /^[0-9]{15}$/, i = /^\d{2}-\d{6}-\d{6}-\d{1}$/;
  function o(s, l) {
    (0, r.default)(s), l = l || {};
    var c = a;
    if (l.allow_hyphens && (c = i), !c.test(s))
      return !1;
    s = s.replace(/-/g, "");
    for (var u = 0, d = 2, f = 14, m = 0; m < f; m++) {
      var h = s.substring(f - m - 1, f - m), g = parseInt(h, 10) * d;
      g >= 10 ? u += g % 10 + 1 : u += g, d === 1 ? d += 1 : d -= 1;
    }
    var y = (10 - u % 10) % 10;
    return y === parseInt(s.substring(14, 15), 10);
  }
  e.exports = t.default, e.exports.default = t.default;
})(gO, gO.exports);
var Y6e = gO.exports, yO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = /^[a-f0-9]{32}$/;
  function i(o) {
    return (0, r.default)(o), a.test(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(yO, yO.exports);
var Z6e = yO.exports, bO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = a(Pt), n = a(si);
  function a(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var i = {
    ignore_whitespace: !1
  };
  function o(s, l) {
    return (0, r.default)(s), l = (0, n.default)(l, i), (l.ignore_whitespace ? s.trim().length : s.length) === 0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(bO, bO.exports);
var X6e = bO.exports, CO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(PM);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i, o) {
    var s = o?.comparisonDate || o || Date().toString(), l = (0, r.default)(s), c = (0, r.default)(i);
    return !!(c && l && c > l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(CO, CO.exports);
var J6e = CO.exports, SO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = a(Pt), n = a(PM);
  function a(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : String(/* @__PURE__ */ new Date());
    (0, r.default)(o);
    var l = (0, n.default)(s), c = (0, n.default)(o);
    return !!(c && l && c < l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(SO, SO.exports);
var Q6e = SO.exports, xO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = a(Pt), n = a(jK);
  function a(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function i(s) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? i = function(c) {
      return typeof c;
    } : i = function(c) {
      return c && typeof Symbol == "function" && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
    }, i(s);
  }
  function o(s, l) {
    (0, r.default)(s);
    var c;
    if (Object.prototype.toString.call(l) === "[object Array]") {
      var u = [];
      for (c in l)
        ({}).hasOwnProperty.call(l, c) && (u[c] = (0, n.default)(l[c]));
      return u.indexOf(s) >= 0;
    } else {
      if (i(l) === "object")
        return l.hasOwnProperty(s);
      if (l && typeof l.indexOf == "function")
        return l.indexOf(s) >= 0;
    }
    return !1;
  }
  e.exports = t.default, e.exports.default = t.default;
})(xO, xO.exports);
var e9e = xO.exports, $O = { exports: {} }, Gc = {};
Object.defineProperty(Gc, "__esModule", {
  value: !0
});
Gc.iso7064Check = t9e;
Gc.luhnCheck = r9e;
Gc.reverseMultiplyAndSum = n9e;
Gc.verhoeffCheck = a9e;
function t9e(e) {
  for (var t = 10, r = 0; r < e.length - 1; r++)
    t = (parseInt(e[r], 10) + t) % 10 === 0 ? 10 * 2 % 11 : (parseInt(e[r], 10) + t) % 10 * 2 % 11;
  return t = t === 1 ? 0 : 11 - t, t === parseInt(e[10], 10);
}
function r9e(e) {
  for (var t = 0, r = !1, n = e.length - 1; n >= 0; n--) {
    if (r) {
      var a = parseInt(e[n], 10) * 2;
      a > 9 ? t += a.toString().split("").map(function(i) {
        return parseInt(i, 10);
      }).reduce(function(i, o) {
        return i + o;
      }, 0) : t += a;
    } else
      t += parseInt(e[n], 10);
    r = !r;
  }
  return t % 10 === 0;
}
function n9e(e, t) {
  for (var r = 0, n = 0; n < e.length; n++)
    r += e[n] * (t - n);
  return r;
}
function a9e(e) {
  for (var t = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]], r = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]], n = e.split("").reverse().join(""), a = 0, i = 0; i < n.length; i++)
    a = t[a][r[i % 8][parseInt(n[i], 10)]];
  return a === 0;
}
(function(e, t) {
  function r(k) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(R) {
      return typeof R;
    } : r = function(R) {
      return R && typeof Symbol == "function" && R.constructor === Symbol && R !== Symbol.prototype ? "symbol" : typeof R;
    }, r(k);
  }
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = me;
  var n = l(Pt), a = s(Gc), i = l(uJ);
  function o() {
    if (typeof WeakMap != "function") return null;
    var k = /* @__PURE__ */ new WeakMap();
    return o = function() {
      return k;
    }, k;
  }
  function s(k) {
    if (k && k.__esModule)
      return k;
    if (k === null || r(k) !== "object" && typeof k != "function")
      return { default: k };
    var M = o();
    if (M && M.has(k))
      return M.get(k);
    var R = {}, q = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var Y in k)
      if (Object.prototype.hasOwnProperty.call(k, Y)) {
        var X = q ? Object.getOwnPropertyDescriptor(k, Y) : null;
        X && (X.get || X.set) ? Object.defineProperty(R, Y, X) : R[Y] = k[Y];
      }
    return R.default = k, M && M.set(k, R), R;
  }
  function l(k) {
    return k && k.__esModule ? k : { default: k };
  }
  function c(k) {
    return m(k) || f(k) || d(k) || u();
  }
  function u() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function d(k, M) {
    if (k) {
      if (typeof k == "string") return h(k, M);
      var R = Object.prototype.toString.call(k).slice(8, -1);
      if (R === "Object" && k.constructor && (R = k.constructor.name), R === "Map" || R === "Set") return Array.from(k);
      if (R === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(R)) return h(k, M);
    }
  }
  function f(k) {
    if (typeof Symbol < "u" && Symbol.iterator in Object(k)) return Array.from(k);
  }
  function m(k) {
    if (Array.isArray(k)) return h(k);
  }
  function h(k, M) {
    (M == null || M > k.length) && (M = k.length);
    for (var R = 0, q = new Array(M); R < M; R++)
      q[R] = k[R];
    return q;
  }
  function g(k) {
    var M = k.slice(0, 2), R = parseInt(k.slice(2, 4), 10);
    R > 40 ? (R -= 40, M = "20".concat(M)) : R > 20 ? (R -= 20, M = "18".concat(M)) : M = "19".concat(M), R < 10 && (R = "0".concat(R));
    var q = "".concat(M, "/").concat(R, "/").concat(k.slice(4, 6));
    if (!(0, i.default)(q, "YYYY/MM/DD"))
      return !1;
    for (var Y = k.split("").map(function(J) {
      return parseInt(J, 10);
    }), X = [2, 4, 8, 5, 10, 9, 7, 3, 6], pe = 0, $e = 0; $e < X.length; $e++)
      pe += Y[$e] * X[$e];
    return pe = pe % 11 === 10 ? 0 : pe % 11, pe === Y[9];
  }
  function y(k) {
    var M = k.split(""), R = M.filter(function(Y, X) {
      return X % 2;
    }).map(function(Y) {
      return Number(Y) * 2;
    }).join("").split(""), q = M.filter(function(Y, X) {
      return !(X % 2);
    }).concat(R).map(function(Y) {
      return Number(Y);
    }).reduce(function(Y, X) {
      return Y + X;
    });
    return q % 10 === 0;
  }
  function S(k) {
    k = k.replace(/\W/, "");
    var M = parseInt(k.slice(0, 2), 10);
    if (k.length === 10)
      M < 54 ? M = "20".concat(M) : M = "19".concat(M);
    else {
      if (k.slice(6) === "000")
        return !1;
      if (M < 54)
        M = "19".concat(M);
      else
        return !1;
    }
    M.length === 3 && (M = [M.slice(0, 2), "0", M.slice(2)].join(""));
    var R = parseInt(k.slice(2, 4), 10);
    if (R > 50 && (R -= 50), R > 20) {
      if (parseInt(M, 10) < 2004)
        return !1;
      R -= 20;
    }
    R < 10 && (R = "0".concat(R));
    var q = "".concat(M, "/").concat(R, "/").concat(k.slice(4, 6));
    if (!(0, i.default)(q, "YYYY/MM/DD"))
      return !1;
    if (k.length === 10 && parseInt(k, 10) % 11 !== 0) {
      var Y = parseInt(k.slice(0, 9), 10) % 11;
      if (parseInt(M, 10) < 1986 && Y === 10) {
        if (parseInt(k.slice(9), 10) !== 0)
          return !1;
      } else
        return !1;
    }
    return !0;
  }
  function x(k) {
    return a.luhnCheck(k);
  }
  function b(k) {
    for (var M = k.split("").map(function(J) {
      return parseInt(J, 10);
    }), R = [], q = 0; q < M.length - 1; q++) {
      R.push("");
      for (var Y = 0; Y < M.length - 1; Y++)
        M[q] === M[Y] && (R[q] += Y);
    }
    if (R = R.filter(function(J) {
      return J.length > 1;
    }), R.length !== 2 && R.length !== 3)
      return !1;
    if (R[0].length === 3) {
      for (var X = R[0].split("").map(function(J) {
        return parseInt(J, 10);
      }), pe = 0, $e = 0; $e < X.length - 1; $e++)
        X[$e] + 1 === X[$e + 1] && (pe += 1);
      if (pe === 2)
        return !1;
    }
    return a.iso7064Check(k);
  }
  function _(k) {
    k = k.replace(/\W/, "");
    var M = parseInt(k.slice(4, 6), 10), R = k.slice(6, 7);
    switch (R) {
      case "0":
      case "1":
      case "2":
      case "3":
        M = "19".concat(M);
        break;
      case "4":
      case "9":
        M < 37 ? M = "20".concat(M) : M = "19".concat(M);
        break;
      default:
        if (M < 37)
          M = "20".concat(M);
        else if (M > 58)
          M = "18".concat(M);
        else
          return !1;
        break;
    }
    M.length === 3 && (M = [M.slice(0, 2), "0", M.slice(2)].join(""));
    var q = "".concat(M, "/").concat(k.slice(2, 4), "/").concat(k.slice(0, 2));
    if (!(0, i.default)(q, "YYYY/MM/DD"))
      return !1;
    for (var Y = k.split("").map(function(J) {
      return parseInt(J, 10);
    }), X = 0, pe = 4, $e = 0; $e < 9; $e++)
      X += Y[$e] * pe, pe -= 1, pe === 1 && (pe = 7);
    return X %= 11, X === 1 ? !1 : X === 0 ? Y[9] === 0 : Y[9] === 11 - X;
  }
  function $(k) {
    for (var M = k.slice(0, 8).split("").map(function(X) {
      return parseInt(X, 10);
    }), R = 0, q = 1; q < M.length; q += 2)
      R += M[q];
    for (var Y = 0; Y < M.length; Y += 2)
      M[Y] < 2 ? R += 1 - M[Y] : (R += 2 * (M[Y] - 2) + 5, M[Y] > 4 && (R += 2));
    return String.fromCharCode(R % 26 + 65) === k.charAt(8);
  }
  function w(k) {
    for (var M = k.split("").map(function(Y) {
      return parseInt(Y, 10);
    }), R = 0, q = 0; q < 8; q++)
      R += M[q] * Math.pow(2, 8 - q);
    return R % 11 % 10 === M[8];
  }
  function O(k) {
    var M = a.reverseMultiplyAndSum(k.split("").slice(0, 7).map(function(R) {
      return parseInt(R, 10);
    }), 8);
    return k.length === 9 && k[8] !== "W" && (M += (k[8].charCodeAt(0) - 64) * 9), M %= 23, M === 0 ? k[7].toUpperCase() === "W" : k[7].toUpperCase() === String.fromCharCode(64 + M);
  }
  var T = {
    andover: ["10", "12"],
    atlanta: ["60", "67"],
    austin: ["50", "53"],
    brookhaven: ["01", "02", "03", "04", "05", "06", "11", "13", "14", "16", "21", "22", "23", "25", "34", "51", "52", "54", "55", "56", "57", "58", "59", "65"],
    cincinnati: ["30", "32", "35", "36", "37", "38", "61"],
    fresno: ["15", "24"],
    internet: ["20", "26", "27", "45", "46", "47"],
    kansas: ["40", "44"],
    memphis: ["94", "95"],
    ogden: ["80", "90"],
    philadelphia: ["33", "39", "41", "42", "43", "46", "48", "62", "63", "64", "66", "68", "71", "72", "73", "74", "75", "76", "77", "81", "82", "83", "84", "85", "86", "87", "88", "91", "92", "93", "98", "99"],
    sba: ["31"]
  };
  function I() {
    var k = [];
    for (var M in T)
      T.hasOwnProperty(M) && k.push.apply(k, c(T[M]));
    return k;
  }
  function P(k) {
    return I().indexOf(k.slice(0, 2)) !== -1;
  }
  function D(k) {
    var M = k.toUpperCase().split("");
    if (isNaN(parseInt(M[0], 10)) && M.length > 1) {
      var R = 0;
      switch (M[0]) {
        case "Y":
          R = 1;
          break;
        case "Z":
          R = 2;
          break;
      }
      M.splice(0, 1, R);
    } else
      for (; M.length < 9; )
        M.unshift(0);
    var q = ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"];
    M = M.join("");
    var Y = parseInt(M.slice(0, 8), 10) % 23;
    return M[8] === q[Y];
  }
  function B(k) {
    var M = k.slice(1, 3), R = k.slice(0, 1);
    switch (R) {
      case "1":
      case "2":
        M = "18".concat(M);
        break;
      case "3":
      case "4":
        M = "19".concat(M);
        break;
      default:
        M = "20".concat(M);
        break;
    }
    var q = "".concat(M, "/").concat(k.slice(3, 5), "/").concat(k.slice(5, 7));
    if (!(0, i.default)(q, "YYYY/MM/DD"))
      return !1;
    for (var Y = k.split("").map(function(de) {
      return parseInt(de, 10);
    }), X = 0, pe = 1, $e = 0; $e < 10; $e++)
      X += Y[$e] * pe, pe += 1, pe === 10 && (pe = 1);
    if (X % 11 === 10) {
      X = 0, pe = 3;
      for (var J = 0; J < 10; J++)
        X += Y[J] * pe, pe += 1, pe === 10 && (pe = 1);
      if (X % 11 === 10)
        return Y[10] === 0;
    }
    return X % 11 === Y[10];
  }
  function L(k) {
    var M = k.slice(4, 6), R = k.slice(6, 7);
    switch (R) {
      case "+":
        M = "18".concat(M);
        break;
      case "-":
        M = "19".concat(M);
        break;
      default:
        M = "20".concat(M);
        break;
    }
    var q = "".concat(M, "/").concat(k.slice(2, 4), "/").concat(k.slice(0, 2));
    if (!(0, i.default)(q, "YYYY/MM/DD"))
      return !1;
    var Y = parseInt(k.slice(0, 6) + k.slice(7, 10), 10) % 31;
    if (Y < 10)
      return Y === parseInt(k.slice(10), 10);
    Y -= 10;
    var X = ["A", "B", "C", "D", "E", "F", "H", "J", "K", "L", "M", "N", "P", "R", "S", "T", "U", "V", "W", "X", "Y"];
    return X[Y] === k.slice(10);
  }
  function N(k) {
    if (k.slice(2, 4) !== "00" || k.slice(4, 6) !== "00") {
      var M = "".concat(k.slice(0, 2), "/").concat(k.slice(2, 4), "/").concat(k.slice(4, 6));
      if (!(0, i.default)(M, "YY/MM/DD"))
        return !1;
    }
    var R = 97 - parseInt(k.slice(0, 9), 10) % 97, q = parseInt(k.slice(9, 11), 10);
    return !(R !== q && (R = 97 - parseInt("2".concat(k.slice(0, 9)), 10) % 97, R !== q));
  }
  function z(k) {
    k = k.replace(/\s/g, "");
    var M = parseInt(k.slice(0, 10), 10) % 511, R = parseInt(k.slice(10, 13), 10);
    return M === R;
  }
  function F(k) {
    var M = "".concat(k.slice(0, 4), "/").concat(k.slice(4, 6), "/").concat(k.slice(6, 8));
    return !(0, i.default)(M, "YYYY/MM/DD") || !a.luhnCheck(k.slice(0, 12)) ? !1 : a.verhoeffCheck("".concat(k.slice(0, 11)).concat(k[12]));
  }
  function j(k) {
    return a.iso7064Check(k);
  }
  function H(k) {
    for (var M = k.split("").map(function(Y) {
      return parseInt(Y, 10);
    }), R = 8, q = 1; q < 9; q++)
      R += M[q] * (q + 1);
    return R % 11 === M[9];
  }
  function U(k) {
    for (var M = !1, R = !1, q = 0; q < 3; q++)
      if (!M && /[AEIOU]/.test(k[q]))
        M = !0;
      else if (!R && M && k[q] === "X")
        R = !0;
      else if (q > 0 && (M && !R && !/[AEIOU]/.test(k[q]) || R && !/X/.test(k[q])))
        return !1;
    return !0;
  }
  function G(k) {
    var M = k.toUpperCase().split("");
    if (!U(M.slice(0, 3)) || !U(M.slice(3, 6)))
      return !1;
    for (var R = [6, 7, 9, 10, 12, 13, 14], q = {
      L: "0",
      M: "1",
      N: "2",
      P: "3",
      Q: "4",
      R: "5",
      S: "6",
      T: "7",
      U: "8",
      V: "9"
    }, Y = 0, X = R; Y < X.length; Y++) {
      var pe = X[Y];
      M[pe] in q && M.splice(pe, 1, q[M[pe]]);
    }
    var $e = {
      A: "01",
      B: "02",
      C: "03",
      D: "04",
      E: "05",
      H: "06",
      L: "07",
      M: "08",
      P: "09",
      R: "10",
      S: "11",
      T: "12"
    }, J = $e[M[8]], de = parseInt(M[9] + M[10], 10);
    de > 40 && (de -= 40), de < 10 && (de = "0".concat(de));
    var Se = "".concat(M[6]).concat(M[7], "/").concat(J, "/").concat(de);
    if (!(0, i.default)(Se, "YY/MM/DD"))
      return !1;
    for (var Ee = 0, Te = 1; Te < M.length - 1; Te += 2) {
      var Le = parseInt(M[Te], 10);
      isNaN(Le) && (Le = M[Te].charCodeAt(0) - 65), Ee += Le;
    }
    for (var Ie = {
      // Maps of characters at odd places
      A: 1,
      B: 0,
      C: 5,
      D: 7,
      E: 9,
      F: 13,
      G: 15,
      H: 17,
      I: 19,
      J: 21,
      K: 2,
      L: 4,
      M: 18,
      N: 20,
      O: 11,
      P: 3,
      Q: 6,
      R: 8,
      S: 12,
      T: 14,
      U: 16,
      V: 10,
      W: 22,
      X: 25,
      Y: 24,
      Z: 23,
      0: 1,
      1: 0
    }, De = 0; De < M.length - 1; De += 2) {
      var Ae = 0;
      if (M[De] in Ie)
        Ae = Ie[M[De]];
      else {
        var Fe = parseInt(M[De], 10);
        Ae = 2 * Fe + 1, Fe > 4 && (Ae += 2);
      }
      Ee += Ae;
    }
    return String.fromCharCode(65 + Ee % 26) === M[15];
  }
  function V(k) {
    k = k.replace(/\W/, "");
    var M = k.slice(0, 2);
    if (M !== "32") {
      var R = k.slice(2, 4);
      if (R !== "00") {
        var q = k.slice(4, 6);
        switch (k[6]) {
          case "0":
            q = "18".concat(q);
            break;
          case "1":
            q = "19".concat(q);
            break;
          default:
            q = "20".concat(q);
            break;
        }
        var Y = "".concat(q, "/").concat(k.slice(2, 4), "/").concat(M);
        if (!(0, i.default)(Y, "YYYY/MM/DD"))
          return !1;
      }
      for (var X = 1101, pe = [1, 6, 3, 7, 9, 10, 5, 8, 4, 2], $e = 0; $e < k.length - 1; $e++)
        X -= parseInt(k[$e], 10) * pe[$e];
      return parseInt(k[10], 10) === X % 11;
    }
    return !0;
  }
  function K(k) {
    if (k.length !== 9) {
      for (var M = k.toUpperCase().split(""); M.length < 8; )
        M.unshift(0);
      switch (k[7]) {
        case "A":
        case "P":
          if (parseInt(M[6], 10) === 0)
            return !1;
          break;
        default: {
          var R = parseInt(M.join("").slice(0, 5), 10);
          if (R > 32e3)
            return !1;
          var q = parseInt(M.join("").slice(5, 7), 10);
          if (R === q)
            return !1;
        }
      }
    }
    return !0;
  }
  function Z(k) {
    return a.reverseMultiplyAndSum(k.split("").slice(0, 8).map(function(M) {
      return parseInt(M, 10);
    }), 9) % 11 === parseInt(k[8], 10);
  }
  function ee(k) {
    if (k.length === 10) {
      for (var M = [6, 5, 7, 2, 3, 4, 5, 6, 7], R = 0, q = 0; q < M.length; q++)
        R += parseInt(k[q], 10) * M[q];
      return R %= 11, R === 10 ? !1 : R === parseInt(k[9], 10);
    }
    var Y = k.slice(0, 2), X = parseInt(k.slice(2, 4), 10);
    X > 80 ? (Y = "18".concat(Y), X -= 80) : X > 60 ? (Y = "22".concat(Y), X -= 60) : X > 40 ? (Y = "21".concat(Y), X -= 40) : X > 20 ? (Y = "20".concat(Y), X -= 20) : Y = "19".concat(Y), X < 10 && (X = "0".concat(X));
    var pe = "".concat(Y, "/").concat(X, "/").concat(k.slice(4, 6));
    if (!(0, i.default)(pe, "YYYY/MM/DD"))
      return !1;
    for (var $e = 0, J = 1, de = 0; de < k.length - 1; de++)
      $e += parseInt(k[de], 10) * J % 10, J += 2, J > 10 ? J = 1 : J === 5 && (J += 2);
    return $e = 10 - $e % 10, $e === parseInt(k[10], 10);
  }
  function ae(k) {
    if (k.length === 11) {
      var M, R;
      if (M = 0, // Reject known invalid CPFs
      k === "11111111111" || k === "22222222222" || k === "33333333333" || k === "44444444444" || k === "55555555555" || k === "66666666666" || k === "77777777777" || k === "88888888888" || k === "99999999999" || k === "00000000000") return !1;
      for (var q = 1; q <= 9; q++)
        M += parseInt(k.substring(q - 1, q), 10) * (11 - q);
      if (R = M * 10 % 11, R === 10 && (R = 0), R !== parseInt(k.substring(9, 10), 10)) return !1;
      M = 0;
      for (var Y = 1; Y <= 10; Y++)
        M += parseInt(k.substring(Y - 1, Y), 10) * (12 - Y);
      return R = M * 10 % 11, R === 10 && (R = 0), R === parseInt(k.substring(10, 11), 10);
    }
    if (
      // Reject know invalid CNPJs
      k === "00000000000000" || k === "11111111111111" || k === "22222222222222" || k === "33333333333333" || k === "44444444444444" || k === "55555555555555" || k === "66666666666666" || k === "77777777777777" || k === "88888888888888" || k === "99999999999999"
    )
      return !1;
    for (var X = k.length - 2, pe = k.substring(0, X), $e = k.substring(X), J = 0, de = X - 7, Se = X; Se >= 1; Se--)
      J += pe.charAt(X - Se) * de, de -= 1, de < 2 && (de = 9);
    var Ee = J % 11 < 2 ? 0 : 11 - J % 11;
    if (Ee !== parseInt($e.charAt(0), 10))
      return !1;
    X += 1, pe = k.substring(0, X), J = 0, de = X - 7;
    for (var Te = X; Te >= 1; Te--)
      J += pe.charAt(X - Te) * de, de -= 1, de < 2 && (de = 9);
    return Ee = J % 11 < 2 ? 0 : 11 - J % 11, Ee === parseInt($e.charAt(1), 10);
  }
  function ue(k) {
    var M = 11 - a.reverseMultiplyAndSum(k.split("").slice(0, 8).map(function(R) {
      return parseInt(R, 10);
    }), 9) % 11;
    return M > 9 ? parseInt(k[8], 10) === 0 : M === parseInt(k[8], 10);
  }
  function re(k) {
    if (k.slice(0, 4) !== "9000") {
      var M = k.slice(1, 3);
      switch (k[0]) {
        case "1":
        case "2":
          M = "19".concat(M);
          break;
        case "3":
        case "4":
          M = "18".concat(M);
          break;
        case "5":
        case "6":
          M = "20".concat(M);
          break;
      }
      var R = "".concat(M, "/").concat(k.slice(3, 5), "/").concat(k.slice(5, 7));
      if (R.length === 8) {
        if (!(0, i.default)(R, "YY/MM/DD"))
          return !1;
      } else if (!(0, i.default)(R, "YYYY/MM/DD"))
        return !1;
      for (var q = k.split("").map(function($e) {
        return parseInt($e, 10);
      }), Y = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9], X = 0, pe = 0; pe < Y.length; pe++)
        X += q[pe] * Y[pe];
      return X % 11 === 10 ? q[12] === 1 : q[12] === X % 11;
    }
    return !0;
  }
  function oe(k) {
    if (k.length === 9) {
      if (k = k.replace(/\W/, ""), k.slice(6) === "000")
        return !1;
      var M = parseInt(k.slice(0, 2), 10);
      if (M > 53)
        return !1;
      M < 10 ? M = "190".concat(M) : M = "19".concat(M);
      var R = parseInt(k.slice(2, 4), 10);
      R > 50 && (R -= 50), R < 10 && (R = "0".concat(R));
      var q = "".concat(M, "/").concat(R, "/").concat(k.slice(4, 6));
      if (!(0, i.default)(q, "YYYY/MM/DD"))
        return !1;
    }
    return !0;
  }
  function fe(k) {
    var M = 11 - a.reverseMultiplyAndSum(k.split("").slice(0, 7).map(function(R) {
      return parseInt(R, 10);
    }), 8) % 11;
    return M === 10 ? parseInt(k[7], 10) === 0 : M === parseInt(k[7], 10);
  }
  function le(k) {
    var M = k.slice(0);
    k.length > 11 && (M = M.slice(2));
    var R = "", q = M.slice(2, 4), Y = parseInt(M.slice(4, 6), 10);
    if (k.length > 11)
      R = k.slice(0, 4);
    else if (R = k.slice(0, 2), k.length === 11 && Y < 60) {
      var X = (/* @__PURE__ */ new Date()).getFullYear().toString(), pe = parseInt(X.slice(0, 2), 10);
      if (X = parseInt(X, 10), k[6] === "-")
        parseInt("".concat(pe).concat(R), 10) > X ? R = "".concat(pe - 1).concat(R) : R = "".concat(pe).concat(R);
      else if (R = "".concat(pe - 1).concat(R), X - parseInt(R, 10) < 100)
        return !1;
    }
    Y > 60 && (Y -= 60), Y < 10 && (Y = "0".concat(Y));
    var $e = "".concat(R, "/").concat(q, "/").concat(Y);
    if ($e.length === 8) {
      if (!(0, i.default)($e, "YY/MM/DD"))
        return !1;
    } else if (!(0, i.default)($e, "YYYY/MM/DD"))
      return !1;
    return a.luhnCheck(k.replace(/\W/, ""));
  }
  var se = {
    "bg-BG": /^\d{10}$/,
    "cs-CZ": /^\d{6}\/{0,1}\d{3,4}$/,
    "de-AT": /^\d{9}$/,
    "de-DE": /^[1-9]\d{10}$/,
    "dk-DK": /^\d{6}-{0,1}\d{4}$/,
    "el-CY": /^[09]\d{7}[A-Z]$/,
    "el-GR": /^([0-4]|[7-9])\d{8}$/,
    "en-CA": /^\d{9}$/,
    "en-GB": /^\d{10}$|^(?!GB|NK|TN|ZZ)(?![DFIQUV])[A-Z](?![DFIQUVO])[A-Z]\d{6}[ABCD ]$/i,
    "en-IE": /^\d{7}[A-W][A-IW]{0,1}$/i,
    "en-US": /^\d{2}[- ]{0,1}\d{7}$/,
    "es-ES": /^(\d{0,8}|[XYZKLM]\d{7})[A-HJ-NP-TV-Z]$/i,
    "et-EE": /^[1-6]\d{6}(00[1-9]|0[1-9][0-9]|[1-6][0-9]{2}|70[0-9]|710)\d$/,
    "fi-FI": /^\d{6}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/i,
    "fr-BE": /^\d{11}$/,
    "fr-FR": /^[0-3]\d{12}$|^[0-3]\d\s\d{2}(\s\d{3}){3}$/,
    // Conforms both to official spec and provided example
    "fr-LU": /^\d{13}$/,
    "hr-HR": /^\d{11}$/,
    "hu-HU": /^8\d{9}$/,
    "it-IT": /^[A-Z]{6}[L-NP-V0-9]{2}[A-EHLMPRST][L-NP-V0-9]{2}[A-ILMZ][L-NP-V0-9]{3}[A-Z]$/i,
    "lv-LV": /^\d{6}-{0,1}\d{5}$/,
    // Conforms both to DG TAXUD spec and original research
    "mt-MT": /^\d{3,7}[APMGLHBZ]$|^([1-8])\1\d{7}$/i,
    "nl-NL": /^\d{9}$/,
    "pl-PL": /^\d{10,11}$/,
    "pt-BR": /(?:^\d{11}$)|(?:^\d{14}$)/,
    "pt-PT": /^\d{9}$/,
    "ro-RO": /^\d{13}$/,
    "sk-SK": /^\d{6}\/{0,1}\d{3,4}$/,
    "sl-SI": /^[1-9]\d{7}$/,
    "sv-SE": /^(\d{6}[-+]{0,1}\d{4}|(18|19|20)\d{6}[-+]{0,1}\d{4})$/
  };
  se["lb-LU"] = se["fr-LU"], se["lt-LT"] = se["et-EE"], se["nl-BE"] = se["fr-BE"], se["fr-CA"] = se["en-CA"];
  var Q = {
    "bg-BG": g,
    "cs-CZ": S,
    "de-AT": x,
    "de-DE": b,
    "dk-DK": _,
    "el-CY": $,
    "el-GR": w,
    "en-CA": y,
    "en-IE": O,
    "en-US": P,
    "es-ES": D,
    "et-EE": B,
    "fi-FI": L,
    "fr-BE": N,
    "fr-FR": z,
    "fr-LU": F,
    "hr-HR": j,
    "hu-HU": H,
    "it-IT": G,
    "lv-LV": V,
    "mt-MT": K,
    "nl-NL": Z,
    "pl-PL": ee,
    "pt-BR": ae,
    "pt-PT": ue,
    "ro-RO": re,
    "sk-SK": oe,
    "sl-SI": fe,
    "sv-SE": le
  };
  Q["lb-LU"] = Q["fr-LU"], Q["lt-LT"] = Q["et-EE"], Q["nl-BE"] = Q["fr-BE"], Q["fr-CA"] = Q["en-CA"];
  var he = /[-\\\/!@#$%\^&\*\(\)\+\=\[\]]+/g, ne = {
    "de-AT": he,
    "de-DE": /[\/\\]/g,
    "fr-BE": he
  };
  ne["nl-BE"] = ne["fr-BE"];
  function me(k) {
    var M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
    (0, n.default)(k);
    var R = k.slice(0);
    if (M in se)
      return M in ne && (R = R.replace(ne[M], "")), se[M].test(R) ? M in Q ? Q[M](R) : !0 : !1;
    throw new Error("Invalid locale '".concat(M, "'"));
  }
  e.exports = t.default, e.exports.default = t.default;
})($O, $O.exports);
var dJ = $O.exports;
const i9e = /* @__PURE__ */ Ut(dJ);
var _O = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = /* @__PURE__ */ new Set(["aa", "ab", "ae", "af", "ak", "am", "an", "ar", "as", "av", "ay", "az", "az", "ba", "be", "bg", "bh", "bi", "bm", "bn", "bo", "br", "bs", "ca", "ce", "ch", "co", "cr", "cs", "cu", "cv", "cy", "da", "de", "dv", "dz", "ee", "el", "en", "eo", "es", "et", "eu", "fa", "ff", "fi", "fj", "fo", "fr", "fy", "ga", "gd", "gl", "gn", "gu", "gv", "ha", "he", "hi", "ho", "hr", "ht", "hu", "hy", "hz", "ia", "id", "ie", "ig", "ii", "ik", "io", "is", "it", "iu", "ja", "jv", "ka", "kg", "ki", "kj", "kk", "kl", "km", "kn", "ko", "kr", "ks", "ku", "kv", "kw", "ky", "la", "lb", "lg", "li", "ln", "lo", "lt", "lu", "lv", "mg", "mh", "mi", "mk", "ml", "mn", "mr", "ms", "mt", "my", "na", "nb", "nd", "ne", "ng", "nl", "nn", "no", "nr", "nv", "ny", "oc", "oj", "om", "or", "os", "pa", "pi", "pl", "ps", "pt", "qu", "rm", "rn", "ro", "ru", "rw", "sa", "sc", "sd", "se", "sg", "si", "sk", "sl", "sm", "sn", "so", "sq", "sr", "ss", "st", "su", "sv", "sw", "ta", "te", "tg", "th", "ti", "tk", "tl", "tn", "to", "tr", "ts", "tt", "tw", "ty", "ug", "uk", "ur", "uz", "ve", "vi", "vo", "wa", "wo", "xh", "yi", "yo", "za", "zh", "zu"]);
  function i(o) {
    return (0, r.default)(o), a.has(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(_O, _O.exports);
var o9e = _O.exports, Fh = {};
Object.defineProperty(Fh, "__esModule", {
  value: !0
});
var s9e = Fh.default = u9e;
Fh.CurrencyCodes = void 0;
var l9e = c9e(Pt);
function c9e(e) {
  return e && e.__esModule ? e : { default: e };
}
var fJ = /* @__PURE__ */ new Set(["AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN", "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BOV", "BRL", "BSD", "BTN", "BWP", "BYN", "BZD", "CAD", "CDF", "CHE", "CHF", "CHW", "CLF", "CLP", "CNY", "COP", "COU", "CRC", "CUC", "CUP", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EGP", "ERN", "ETB", "EUR", "FJD", "FKP", "GBP", "GEL", "GHS", "GIP", "GMD", "GNF", "GTQ", "GYD", "HKD", "HNL", "HRK", "HTG", "HUF", "IDR", "ILS", "INR", "IQD", "IRR", "ISK", "JMD", "JOD", "JPY", "KES", "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT", "LAK", "LBP", "LKR", "LRD", "LSL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRU", "MUR", "MVR", "MWK", "MXN", "MXV", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SLL", "SOS", "SRD", "SSP", "STN", "SVC", "SYP", "SZL", "THB", "TJS", "TMT", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "USD", "USN", "UYI", "UYU", "UYW", "UZS", "VES", "VND", "VUV", "WST", "XAF", "XAG", "XAU", "XBA", "XBB", "XBC", "XBD", "XCD", "XDR", "XOF", "XPD", "XPF", "XPT", "XSU", "XTS", "XUA", "XXX", "YER", "ZAR", "ZMW", "ZWL"]);
function u9e(e) {
  return (0, l9e.default)(e), fJ.has(e.toUpperCase());
}
var d9e = fJ;
Fh.CurrencyCodes = d9e;
var EO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = /^[A-HJ-NP-Za-km-z1-9]*$/;
  function i(o) {
    return (0, r.default)(o), !!a.test(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(EO, EO.exports);
var pJ = EO.exports;
const f9e = /* @__PURE__ */ Ut(pJ);
var wO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Pt);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i, o) {
    (0, r.default)(i);
    var s = o ? new RegExp("^[".concat(o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+"), "g") : /^\s+/g;
    return i.replace(s, "");
  }
  e.exports = t.default, e.exports.default = t.default;
})(wO, wO.exports);
var mJ = wO.exports, OO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Pt);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i, o) {
    if ((0, r.default)(i), o) {
      var s = new RegExp("[".concat(o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+$"), "g");
      return i.replace(s, "");
    }
    for (var l = i.length - 1; /\s/.test(i.charAt(l)); )
      l -= 1;
    return i.slice(0, l + 1);
  }
  e.exports = t.default, e.exports.default = t.default;
})(OO, OO.exports);
var vJ = OO.exports, TO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = a(vJ), n = a(mJ);
  function a(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o, s) {
    return (0, r.default)((0, n.default)(o, s), s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(TO, TO.exports);
var p9e = TO.exports, IO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Pt);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i) {
    return (0, r.default)(i), i.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\//g, "&#x2F;").replace(/\\/g, "&#x5C;").replace(/`/g, "&#96;");
  }
  e.exports = t.default, e.exports.default = t.default;
})(IO, IO.exports);
var m9e = IO.exports, MO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Pt);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i) {
    return (0, r.default)(i), i.replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#x2F;/g, "/").replace(/&#x5C;/g, "\\").replace(/&#96;/g, "`").replace(/&amp;/g, "&");
  }
  e.exports = t.default, e.exports.default = t.default;
})(MO, MO.exports);
var v9e = MO.exports, AO = { exports: {} }, PO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Pt);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i, o) {
    return (0, r.default)(i), i.replace(new RegExp("[".concat(o, "]+"), "g"), "");
  }
  e.exports = t.default, e.exports.default = t.default;
})(PO, PO.exports);
var hJ = PO.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = a(Pt), n = a(hJ);
  function a(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o, s) {
    (0, r.default)(o);
    var l = s ? "\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F" : "\\x00-\\x1F\\x7F";
    return (0, n.default)(o, l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(AO, AO.exports);
var h9e = AO.exports, RO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Pt);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i, o) {
    return (0, r.default)(i), i.replace(new RegExp("[^".concat(o, "]+"), "g"), "");
  }
  e.exports = t.default, e.exports.default = t.default;
})(RO, RO.exports);
var g9e = RO.exports, NO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Pt);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i, o) {
    (0, r.default)(i);
    for (var s = i.length - 1; s >= 0; s--)
      if (o.indexOf(i[s]) === -1)
        return !1;
    return !0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(NO, NO.exports);
var y9e = NO.exports, DO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var r = n(si);
  function n(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var a = {
    // The following options apply to all email addresses
    // Lowercases the local part of the email address.
    // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
    // The domain is always lowercased, as per RFC 1035
    all_lowercase: !0,
    // The following conversions are specific to GMail
    // Lowercases the local part of the GMail address (known to be case-insensitive)
    gmail_lowercase: !0,
    // Removes dots from the local part of the email address, as that's ignored by GMail
    gmail_remove_dots: !0,
    // Removes the subaddress (e.g. "+foo") from the email address
    gmail_remove_subaddress: !0,
    // Conversts the googlemail.com domain to gmail.com
    gmail_convert_googlemaildotcom: !0,
    // The following conversions are specific to Outlook.com / Windows Live / Hotmail
    // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
    outlookdotcom_lowercase: !0,
    // Removes the subaddress (e.g. "+foo") from the email address
    outlookdotcom_remove_subaddress: !0,
    // The following conversions are specific to Yahoo
    // Lowercases the local part of the Yahoo address (known to be case-insensitive)
    yahoo_lowercase: !0,
    // Removes the subaddress (e.g. "-foo") from the email address
    yahoo_remove_subaddress: !0,
    // The following conversions are specific to Yandex
    // Lowercases the local part of the Yandex address (known to be case-insensitive)
    yandex_lowercase: !0,
    // The following conversions are specific to iCloud
    // Lowercases the local part of the iCloud address (known to be case-insensitive)
    icloud_lowercase: !0,
    // Removes the subaddress (e.g. "+foo") from the email address
    icloud_remove_subaddress: !0
  }, i = ["icloud.com", "me.com"], o = ["hotmail.at", "hotmail.be", "hotmail.ca", "hotmail.cl", "hotmail.co.il", "hotmail.co.nz", "hotmail.co.th", "hotmail.co.uk", "hotmail.com", "hotmail.com.ar", "hotmail.com.au", "hotmail.com.br", "hotmail.com.gr", "hotmail.com.mx", "hotmail.com.pe", "hotmail.com.tr", "hotmail.com.vn", "hotmail.cz", "hotmail.de", "hotmail.dk", "hotmail.es", "hotmail.fr", "hotmail.hu", "hotmail.id", "hotmail.ie", "hotmail.in", "hotmail.it", "hotmail.jp", "hotmail.kr", "hotmail.lv", "hotmail.my", "hotmail.ph", "hotmail.pt", "hotmail.sa", "hotmail.sg", "hotmail.sk", "live.be", "live.co.uk", "live.com", "live.com.ar", "live.com.mx", "live.de", "live.es", "live.eu", "live.fr", "live.it", "live.nl", "msn.com", "outlook.at", "outlook.be", "outlook.cl", "outlook.co.il", "outlook.co.nz", "outlook.co.th", "outlook.com", "outlook.com.ar", "outlook.com.au", "outlook.com.br", "outlook.com.gr", "outlook.com.pe", "outlook.com.tr", "outlook.com.vn", "outlook.cz", "outlook.de", "outlook.dk", "outlook.es", "outlook.fr", "outlook.hu", "outlook.id", "outlook.ie", "outlook.in", "outlook.it", "outlook.jp", "outlook.kr", "outlook.lv", "outlook.my", "outlook.ph", "outlook.pt", "outlook.sa", "outlook.sg", "outlook.sk", "passport.com"], s = ["rocketmail.com", "yahoo.ca", "yahoo.co.uk", "yahoo.com", "yahoo.de", "yahoo.fr", "yahoo.in", "yahoo.it", "ymail.com"], l = ["yandex.ru", "yandex.ua", "yandex.kz", "yandex.com", "yandex.by", "ya.ru"];
  function c(d) {
    return d.length > 1 ? d : "";
  }
  function u(d, f) {
    f = (0, r.default)(f, a);
    var m = d.split("@"), h = m.pop(), g = m.join("@"), y = [g, h];
    if (y[1] = y[1].toLowerCase(), y[1] === "gmail.com" || y[1] === "googlemail.com") {
      if (f.gmail_remove_subaddress && (y[0] = y[0].split("+")[0]), f.gmail_remove_dots && (y[0] = y[0].replace(/\.+/g, c)), !y[0].length)
        return !1;
      (f.all_lowercase || f.gmail_lowercase) && (y[0] = y[0].toLowerCase()), y[1] = f.gmail_convert_googlemaildotcom ? "gmail.com" : y[1];
    } else if (i.indexOf(y[1]) >= 0) {
      if (f.icloud_remove_subaddress && (y[0] = y[0].split("+")[0]), !y[0].length)
        return !1;
      (f.all_lowercase || f.icloud_lowercase) && (y[0] = y[0].toLowerCase());
    } else if (o.indexOf(y[1]) >= 0) {
      if (f.outlookdotcom_remove_subaddress && (y[0] = y[0].split("+")[0]), !y[0].length)
        return !1;
      (f.all_lowercase || f.outlookdotcom_lowercase) && (y[0] = y[0].toLowerCase());
    } else if (s.indexOf(y[1]) >= 0) {
      if (f.yahoo_remove_subaddress) {
        var S = y[0].split("-");
        y[0] = S.length > 1 ? S.slice(0, -1).join("-") : S[0];
      }
      if (!y[0].length)
        return !1;
      (f.all_lowercase || f.yahoo_lowercase) && (y[0] = y[0].toLowerCase());
    } else l.indexOf(y[1]) >= 0 ? ((f.all_lowercase || f.yandex_lowercase) && (y[0] = y[0].toLowerCase()), y[1] = "yandex.ru") : f.all_lowercase && (y[0] = y[0].toLowerCase());
    return y.join("@");
  }
  e.exports = t.default, e.exports.default = t.default;
})(DO, DO.exports);
var b9e = DO.exports, jO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = /^[^\s-_](?!.*?[-_]{2,})[a-z0-9-\\][^\s]*[^-_\s]$/;
  function i(o) {
    return (0, r.default)(o), a.test(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(jO, jO.exports);
var C9e = jO.exports, LO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Pt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = {
    "cs-CZ": function(s) {
      return /^(([ABCDEFHIJKLMNPRSTUVXYZ]|[0-9])-?){5,8}$/.test(s);
    },
    "de-DE": function(s) {
      return /^((A|AA|AB|AC|AE|AH|AK|AM|AN|AÖ|AP|AS|AT|AU|AW|AZ|B|BA|BB|BC|BE|BF|BH|BI|BK|BL|BM|BN|BO|BÖ|BS|BT|BZ|C|CA|CB|CE|CO|CR|CW|D|DA|DD|DE|DH|DI|DL|DM|DN|DO|DU|DW|DZ|E|EA|EB|ED|EE|EF|EG|EH|EI|EL|EM|EN|ER|ES|EU|EW|F|FB|FD|FF|FG|FI|FL|FN|FO|FR|FS|FT|FÜ|FW|FZ|G|GA|GC|GD|GE|GF|GG|GI|GK|GL|GM|GN|GÖ|GP|GR|GS|GT|GÜ|GV|GW|GZ|H|HA|HB|HC|HD|HE|HF|HG|HH|HI|HK|HL|HM|HN|HO|HP|HR|HS|HU|HV|HX|HY|HZ|IK|IL|IN|IZ|J|JE|JL|K|KA|KB|KC|KE|KF|KG|KH|KI|KK|KL|KM|KN|KO|KR|KS|KT|KU|KW|KY|L|LA|LB|LC|LD|LF|LG|LH|LI|LL|LM|LN|LÖ|LP|LR|LU|M|MA|MB|MC|MD|ME|MG|MH|MI|MK|ML|MM|MN|MO|MQ|MR|MS|MÜ|MW|MY|MZ|N|NB|ND|NE|NF|NH|NI|NK|NM|NÖ|NP|NR|NT|NU|NW|NY|NZ|OA|OB|OC|OD|OE|OF|OG|OH|OK|OL|OP|OS|OZ|P|PA|PB|PE|PF|PI|PL|PM|PN|PR|PS|PW|PZ|R|RA|RC|RD|RE|RG|RH|RI|RL|RM|RN|RO|RP|RS|RT|RU|RV|RW|RZ|S|SB|SC|SE|SG|SI|SK|SL|SM|SN|SO|SP|SR|ST|SU|SW|SY|SZ|TE|TF|TG|TO|TP|TR|TS|TT|TÜ|ÜB|UE|UH|UL|UM|UN|V|VB|VG|VK|VR|VS|W|WA|WB|WE|WF|WI|WK|WL|WM|WN|WO|WR|WS|WT|WÜ|WW|WZ|Z|ZE|ZI|ZP|ZR|ZW|ZZ)[- ]?[A-Z]{1,2}[- ]?\d{1,4}|(ABG|ABI|AIB|AIC|ALF|ALZ|ANA|ANG|ANK|APD|ARN|ART|ASL|ASZ|AUR|AZE|BAD|BAR|BBG|BCH|BED|BER|BGD|BGL|BID|BIN|BIR|BIT|BIW|BKS|BLB|BLK|BNA|BOG|BOH|BOR|BOT|BRA|BRB|BRG|BRK|BRL|BRV|BSB|BSK|BTF|BÜD|BUL|BÜR|BÜS|BÜZ|CAS|CHA|CLP|CLZ|COC|COE|CUX|DAH|DAN|DAU|DBR|DEG|DEL|DGF|DIL|DIN|DIZ|DKB|DLG|DON|DUD|DÜW|EBE|EBN|EBS|ECK|EIC|EIL|EIN|EIS|EMD|EMS|ERB|ERH|ERK|ERZ|ESB|ESW|FDB|FDS|FEU|FFB|FKB|FLÖ|FOR|FRG|FRI|FRW|FTL|FÜS|GAN|GAP|GDB|GEL|GEO|GER|GHA|GHC|GLA|GMN|GNT|GOA|GOH|GRA|GRH|GRI|GRM|GRZ|GTH|GUB|GUN|GVM|HAB|HAL|HAM|HAS|HBN|HBS|HCH|HDH|HDL|HEB|HEF|HEI|HER|HET|HGN|HGW|HHM|HIG|HIP|HMÜ|HOG|HOH|HOL|HOM|HOR|HÖS|HOT|HRO|HSK|HST|HVL|HWI|IGB|ILL|JÜL|KEH|KEL|KEM|KIB|KLE|KLZ|KÖN|KÖT|KÖZ|KRU|KÜN|KUS|KYF|LAN|LAU|LBS|LBZ|LDK|LDS|LEO|LER|LEV|LIB|LIF|LIP|LÖB|LOS|LRO|LSZ|LÜN|LUP|LWL|MAB|MAI|MAK|MAL|MED|MEG|MEI|MEK|MEL|MER|MET|MGH|MGN|MHL|MIL|MKK|MOD|MOL|MON|MOS|MSE|MSH|MSP|MST|MTK|MTL|MÜB|MÜR|MYK|MZG|NAB|NAI|NAU|NDH|NEA|NEB|NEC|NEN|NES|NEW|NMB|NMS|NOH|NOL|NOM|NOR|NVP|NWM|OAL|OBB|OBG|OCH|OHA|ÖHR|OHV|OHZ|OPR|OSL|OVI|OVL|OVP|PAF|PAN|PAR|PCH|PEG|PIR|PLÖ|PRÜ|QFT|QLB|RDG|REG|REH|REI|RID|RIE|ROD|ROF|ROK|ROL|ROS|ROT|ROW|RSL|RÜD|RÜG|SAB|SAD|SAN|SAW|SBG|SBK|SCZ|SDH|SDL|SDT|SEB|SEE|SEF|SEL|SFB|SFT|SGH|SHA|SHG|SHK|SHL|SIG|SIM|SLE|SLF|SLK|SLN|SLS|SLÜ|SLZ|SMÜ|SOB|SOG|SOK|SÖM|SON|SPB|SPN|SRB|SRO|STA|STB|STD|STE|STL|SUL|SÜW|SWA|SZB|TBB|TDO|TET|TIR|TÖL|TUT|UEM|UER|UFF|USI|VAI|VEC|VER|VIB|VIE|VIT|VOH|WAF|WAK|WAN|WAR|WAT|WBS|WDA|WEL|WEN|WER|WES|WHV|WIL|WIS|WIT|WIZ|WLG|WMS|WND|WOB|WOH|WOL|WOR|WOS|WRN|WSF|WST|WSW|WTL|WTM|WUG|WÜM|WUN|WUR|WZL|ZEL|ZIG)[- ]?(([A-Z][- ]?\d{1,4})|([A-Z]{2}[- ]?\d{1,3})))[- ]?(E|H)?$/.test(s);
    },
    "de-LI": function(s) {
      return /^FL[- ]?\d{1,5}[UZ]?$/.test(s);
    },
    "en-IN": function(s) {
      return /^[A-Z]{2}[ -]?[0-9]{1,2}(?:[ -]?[A-Z])(?:[ -]?[A-Z]*)?[ -]?[0-9]{4}$/.test(s);
    },
    "es-AR": function(s) {
      return /^(([A-Z]{2} ?[0-9]{3} ?[A-Z]{2})|([A-Z]{3} ?[0-9]{3}))$/.test(s);
    },
    "fi-FI": function(s) {
      return /^(?=.{4,7})(([A-Z]{1,3}|[0-9]{1,3})[\s-]?([A-Z]{1,3}|[0-9]{1,5}))$/.test(s);
    },
    "hu-HU": function(s) {
      return /^((((?!AAA)(([A-NPRSTVZWXY]{1})([A-PR-Z]{1})([A-HJ-NPR-Z]))|(A[ABC]I)|A[ABC]O|A[A-W]Q|BPI|BPO|UCO|UDO|XAO)-(?!000)\d{3})|(M\d{6})|((CK|DT|CD|HC|H[ABEFIKLMNPRSTVX]|MA|OT|R[A-Z]) \d{2}-\d{2})|(CD \d{3}-\d{3})|(C-(C|X) \d{4})|(X-(A|B|C) \d{4})|(([EPVZ]-\d{5}))|(S A[A-Z]{2} \d{2})|(SP \d{2}-\d{2}))$/.test(s);
    },
    "pt-BR": function(s) {
      return /^[A-Z]{3}[ -]?[0-9][A-Z][0-9]{2}|[A-Z]{3}[ -]?[0-9]{4}$/.test(s);
    },
    "pt-PT": function(s) {
      return /^([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})$/.test(s);
    },
    "sq-AL": function(s) {
      return /^[A-Z]{2}[- ]?((\d{3}[- ]?(([A-Z]{2})|T))|(R[- ]?\d{3}))$/.test(s);
    },
    "sv-SE": function(s) {
      return /^[A-HJ-PR-UW-Z]{3} ?[\d]{2}[A-HJ-PR-UW-Z1-9]$|(^[A-ZÅÄÖ ]{2,7}$)/.test(s.trim());
    }
  };
  function i(o, s) {
    if ((0, r.default)(o), s in a)
      return a[s](o);
    if (s === "any") {
      for (var l in a) {
        var c = a[l];
        if (c(o))
          return !0;
      }
      return !1;
    }
    throw new Error("Invalid locale '".concat(s, "'"));
  }
  e.exports = t.default, e.exports.default = t.default;
})(LO, LO.exports);
var S9e = LO.exports, kO = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = m;
  var r = a(si), n = a(Pt);
  function a(h) {
    return h && h.__esModule ? h : { default: h };
  }
  var i = /^[A-Z]$/, o = /^[a-z]$/, s = /^[0-9]$/, l = /^[-#!$@£%^&*()_+|~=`{}\[\]:";'<>?,.\/ ]$/, c = {
    minLength: 8,
    minLowercase: 1,
    minUppercase: 1,
    minNumbers: 1,
    minSymbols: 1,
    returnScore: !1,
    pointsPerUnique: 1,
    pointsPerRepeat: 0.5,
    pointsForContainingLower: 10,
    pointsForContainingUpper: 10,
    pointsForContainingNumber: 10,
    pointsForContainingSymbol: 10
  };
  function u(h) {
    var g = {};
    return Array.from(h).forEach(function(y) {
      var S = g[y];
      S ? g[y] += 1 : g[y] = 1;
    }), g;
  }
  function d(h) {
    var g = u(h), y = {
      length: h.length,
      uniqueChars: Object.keys(g).length,
      uppercaseCount: 0,
      lowercaseCount: 0,
      numberCount: 0,
      symbolCount: 0
    };
    return Object.keys(g).forEach(function(S) {
      i.test(S) ? y.uppercaseCount += g[S] : o.test(S) ? y.lowercaseCount += g[S] : s.test(S) ? y.numberCount += g[S] : l.test(S) && (y.symbolCount += g[S]);
    }), y;
  }
  function f(h, g) {
    var y = 0;
    return y += h.uniqueChars * g.pointsPerUnique, y += (h.length - h.uniqueChars) * g.pointsPerRepeat, h.lowercaseCount > 0 && (y += g.pointsForContainingLower), h.uppercaseCount > 0 && (y += g.pointsForContainingUpper), h.numberCount > 0 && (y += g.pointsForContainingNumber), h.symbolCount > 0 && (y += g.pointsForContainingSymbol), y;
  }
  function m(h) {
    var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    (0, n.default)(h);
    var y = d(h);
    return g = (0, r.default)(g || {}, c), g.returnScore ? f(y, g) : y.length >= g.minLength && y.lowercaseCount >= g.minLowercase && y.uppercaseCount >= g.minUppercase && y.numberCount >= g.minNumbers && y.symbolCount >= g.minSymbols;
  }
  e.exports = t.default, e.exports.default = t.default;
})(kO, kO.exports);
var x9e = kO.exports, Bh = {};
function hb(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? hb = function(r) {
    return typeof r;
  } : hb = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, hb(e);
}
Object.defineProperty(Bh, "__esModule", {
  value: !0
});
Bh.default = O9e;
Bh.vatMatchers = void 0;
var V5 = E9e(Pt), $9e = _9e(Gc);
function gJ() {
  if (typeof WeakMap != "function") return null;
  var e = /* @__PURE__ */ new WeakMap();
  return gJ = function() {
    return e;
  }, e;
}
function _9e(e) {
  if (e && e.__esModule)
    return e;
  if (e === null || hb(e) !== "object" && typeof e != "function")
    return { default: e };
  var t = gJ();
  if (t && t.has(e))
    return t.get(e);
  var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var a in e)
    if (Object.prototype.hasOwnProperty.call(e, a)) {
      var i = n ? Object.getOwnPropertyDescriptor(e, a) : null;
      i && (i.get || i.set) ? Object.defineProperty(r, a, i) : r[a] = e[a];
    }
  return r.default = e, t && t.set(e, r), r;
}
function E9e(e) {
  return e && e.__esModule ? e : { default: e };
}
var w9e = function(t) {
  var r = t.match(/^(PT)?(\d{9})$/);
  if (!r)
    return !1;
  var n = r[2], a = 11 - $9e.reverseMultiplyAndSum(n.split("").slice(0, 8).map(function(i) {
    return parseInt(i, 10);
  }), 9) % 11;
  return a > 9 ? parseInt(n[8], 10) === 0 : a === parseInt(n[8], 10);
}, FO = {
  /**
   * European Union VAT identification numbers
   */
  AT: function(t) {
    return /^(AT)?U\d{8}$/.test(t);
  },
  BE: function(t) {
    return /^(BE)?\d{10}$/.test(t);
  },
  BG: function(t) {
    return /^(BG)?\d{9,10}$/.test(t);
  },
  HR: function(t) {
    return /^(HR)?\d{11}$/.test(t);
  },
  CY: function(t) {
    return /^(CY)?\w{9}$/.test(t);
  },
  CZ: function(t) {
    return /^(CZ)?\d{8,10}$/.test(t);
  },
  DK: function(t) {
    return /^(DK)?\d{8}$/.test(t);
  },
  EE: function(t) {
    return /^(EE)?\d{9}$/.test(t);
  },
  FI: function(t) {
    return /^(FI)?\d{8}$/.test(t);
  },
  FR: function(t) {
    return /^(FR)?\w{2}\d{9}$/.test(t);
  },
  DE: function(t) {
    return /^(DE)?\d{9}$/.test(t);
  },
  EL: function(t) {
    return /^(EL)?\d{9}$/.test(t);
  },
  HU: function(t) {
    return /^(HU)?\d{8}$/.test(t);
  },
  IE: function(t) {
    return /^(IE)?\d{7}\w{1}(W)?$/.test(t);
  },
  IT: function(t) {
    return /^(IT)?\d{11}$/.test(t);
  },
  LV: function(t) {
    return /^(LV)?\d{11}$/.test(t);
  },
  LT: function(t) {
    return /^(LT)?\d{9,12}$/.test(t);
  },
  LU: function(t) {
    return /^(LU)?\d{8}$/.test(t);
  },
  MT: function(t) {
    return /^(MT)?\d{8}$/.test(t);
  },
  NL: function(t) {
    return /^(NL)?\d{9}B\d{2}$/.test(t);
  },
  PL: function(t) {
    return /^(PL)?(\d{10}|(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3}))$/.test(t);
  },
  PT: w9e,
  RO: function(t) {
    return /^(RO)?\d{2,10}$/.test(t);
  },
  SK: function(t) {
    return /^(SK)?\d{10}$/.test(t);
  },
  SI: function(t) {
    return /^(SI)?\d{8}$/.test(t);
  },
  ES: function(t) {
    return /^(ES)?\w\d{7}[A-Z]$/.test(t);
  },
  SE: function(t) {
    return /^(SE)?\d{12}$/.test(t);
  },
  /**
   * VAT numbers of non-EU countries
   */
  AL: function(t) {
    return /^(AL)?\w{9}[A-Z]$/.test(t);
  },
  MK: function(t) {
    return /^(MK)?\d{13}$/.test(t);
  },
  AU: function(t) {
    return /^(AU)?\d{11}$/.test(t);
  },
  BY: function(t) {
    return /^(УНП )?\d{9}$/.test(t);
  },
  CA: function(t) {
    return /^(CA)?\d{9}$/.test(t);
  },
  IS: function(t) {
    return /^(IS)?\d{5,6}$/.test(t);
  },
  IN: function(t) {
    return /^(IN)?\d{15}$/.test(t);
  },
  ID: function(t) {
    return /^(ID)?(\d{15}|(\d{2}.\d{3}.\d{3}.\d{1}-\d{3}.\d{3}))$/.test(t);
  },
  IL: function(t) {
    return /^(IL)?\d{9}$/.test(t);
  },
  KZ: function(t) {
    return /^(KZ)?\d{9}$/.test(t);
  },
  NZ: function(t) {
    return /^(NZ)?\d{9}$/.test(t);
  },
  NG: function(t) {
    return /^(NG)?(\d{12}|(\d{8}-\d{4}))$/.test(t);
  },
  NO: function(t) {
    return /^(NO)?\d{9}MVA$/.test(t);
  },
  PH: function(t) {
    return /^(PH)?(\d{12}|\d{3} \d{3} \d{3} \d{3})$/.test(t);
  },
  RU: function(t) {
    return /^(RU)?(\d{10}|\d{12})$/.test(t);
  },
  SM: function(t) {
    return /^(SM)?\d{5}$/.test(t);
  },
  SA: function(t) {
    return /^(SA)?\d{15}$/.test(t);
  },
  RS: function(t) {
    return /^(RS)?\d{9}$/.test(t);
  },
  CH: function(t) {
    return /^(CH)?(\d{6}|\d{9}|(\d{3}.\d{3})|(\d{3}.\d{3}.\d{3}))(TVA|MWST|IVA)$/.test(t);
  },
  TR: function(t) {
    return /^(TR)?\d{10}$/.test(t);
  },
  UA: function(t) {
    return /^(UA)?\d{12}$/.test(t);
  },
  GB: function(t) {
    return /^GB((\d{3} \d{4} ([0-8][0-9]|9[0-6]))|(\d{9} \d{3})|(((GD[0-4])|(HA[5-9]))[0-9]{2}))$/.test(t);
  },
  UZ: function(t) {
    return /^(UZ)?\d{9}$/.test(t);
  },
  /**
   * VAT numbers of Latin American countries
   */
  AR: function(t) {
    return /^(AR)?\d{11}$/.test(t);
  },
  BO: function(t) {
    return /^(BO)?\d{7}$/.test(t);
  },
  BR: function(t) {
    return /^(BR)?((\d{2}.\d{3}.\d{3}\/\d{4}-\d{2})|(\d{3}.\d{3}.\d{3}-\d{2}))$/.test(t);
  },
  CL: function(t) {
    return /^(CL)?\d{8}-\d{1}$/.test(t);
  },
  CO: function(t) {
    return /^(CO)?\d{10}$/.test(t);
  },
  CR: function(t) {
    return /^(CR)?\d{9,12}$/.test(t);
  },
  EC: function(t) {
    return /^(EC)?\d{13}$/.test(t);
  },
  SV: function(t) {
    return /^(SV)?\d{4}-\d{6}-\d{3}-\d{1}$/.test(t);
  },
  GT: function(t) {
    return /^(GT)?\d{7}-\d{1}$/.test(t);
  },
  HN: function(t) {
    return /^(HN)?$/.test(t);
  },
  MX: function(t) {
    return /^(MX)?\w{3,4}\d{6}\w{3}$/.test(t);
  },
  NI: function(t) {
    return /^(NI)?\d{3}-\d{6}-\d{4}\w{1}$/.test(t);
  },
  PA: function(t) {
    return /^(PA)?$/.test(t);
  },
  PY: function(t) {
    return /^(PY)?\d{6,8}-\d{1}$/.test(t);
  },
  PE: function(t) {
    return /^(PE)?\d{11}$/.test(t);
  },
  DO: function(t) {
    return /^(DO)?(\d{11}|(\d{3}-\d{7}-\d{1})|[1,4,5]{1}\d{8}|([1,4,5]{1})-\d{2}-\d{5}-\d{1})$/.test(t);
  },
  UY: function(t) {
    return /^(UY)?\d{12}$/.test(t);
  },
  VE: function(t) {
    return /^(VE)?[J,G,V,E]{1}-(\d{9}|(\d{8}-\d{1}))$/.test(t);
  }
};
Bh.vatMatchers = FO;
function O9e(e, t) {
  if ((0, V5.default)(e), (0, V5.default)(t), t in FO)
    return FO[t](e);
  throw new Error("Invalid country code: '".concat(t, "'"));
}
(function(e, t) {
  function r(Ht) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(ar) {
      return typeof ar;
    } : r = function(ar) {
      return ar && typeof Symbol == "function" && ar.constructor === Symbol && ar !== Symbol.prototype ? "symbol" : typeof ar;
    }, r(Ht);
  }
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = Be(PM), a = Be(CK), i = Be(G6e), o = Be(U6e), s = Be(W6e), l = Be(LK), c = Be(DZ), u = Be(uY), d = Be(gZ), f = Be(IY), m = Be(Dh), h = Be(q6e), g = Be(uC), y = Be(uJ), S = Be(K6e), x = Be(nX), b = Be(kX), _ = zt(Rh), $ = zt(Nh), w = Be(oX), O = Be(ZX), T = Be(NY), I = Be(XY), P = Be(EZ), D = Be(Y6e), B = Be(ZK), L = Be(Rd), N = Be(Nd), z = Be(SY), F = Be(dZ), j = Be(sJ), H = Be(mZ), U = Be(_M), G = zt(Pd), V = Be(qK), K = Be($M), Z = Be(qX), ee = Be(SK), ae = Be(_Y), ue = Be(aJ), re = Be(OX), oe = Be(DX), fe = zt(Lh), le = Be(fX), se = Be(Z6e), Q = Be(YZ), he = Be(KY), ne = Be(UY), me = Be(X6e), k = Be(TZ), M = Be(xM), R = Be(CZ), q = Be(lZ), Y = Be(J6e), X = Be(Q6e), pe = Be(e9e), $e = Be(nY), J = Be(aY), de = Be(PX), Se = Be(SX), Ee = Be(BY), Te = Be(LY), Le = Be(JZ), Ie = Be(dJ), De = zt(jh), Ae = Be(_X), Fe = Be(sY), Ne = Be(vX), qe = Be(o9e), Qe = Be(VY), tt = Be(tJ), Ge = Be(Dd), it = Be(iZ), ht = Be(Fh), It = Be(cX), xt = Be(pJ), Xe = Be(SM), pt = Be(yX), Ze = Be(zX), wt = Be(GX), bt = Be(tK), Je = zt(kh), _t = Be(mJ), Vt = Be(vJ), ot = Be(p9e), Ct = Be(m9e), rt = Be(v9e), $t = Be(h9e), Wt = Be(g9e), _e = Be(hJ), Ke = Be(y9e), nt = Be(b9e), Ve = Be(C9e), ke = Be(S9e), ut = Be(x9e), st = Be(Bh);
  function Et() {
    if (typeof WeakMap != "function") return null;
    var Ht = /* @__PURE__ */ new WeakMap();
    return Et = function() {
      return Ht;
    }, Ht;
  }
  function zt(Ht) {
    if (Ht && Ht.__esModule)
      return Ht;
    if (Ht === null || r(Ht) !== "object" && typeof Ht != "function")
      return { default: Ht };
    var ir = Et();
    if (ir && ir.has(Ht))
      return ir.get(Ht);
    var ar = {}, Nr = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var Xr in Ht)
      if (Object.prototype.hasOwnProperty.call(Ht, Xr)) {
        var Qr = Nr ? Object.getOwnPropertyDescriptor(Ht, Xr) : null;
        Qr && (Qr.get || Qr.set) ? Object.defineProperty(ar, Xr, Qr) : ar[Xr] = Ht[Xr];
      }
    return ar.default = Ht, ir && ir.set(Ht, ar), ar;
  }
  function Be(Ht) {
    return Ht && Ht.__esModule ? Ht : { default: Ht };
  }
  var ft = "13.9.0", yt = {
    version: ft,
    toDate: n.default,
    toFloat: a.default,
    toInt: i.default,
    toBoolean: o.default,
    equals: s.default,
    contains: l.default,
    matches: c.default,
    isEmail: u.default,
    isURL: d.default,
    isMACAddress: f.default,
    isIP: m.default,
    isIPRange: h.default,
    isFQDN: g.default,
    isBoolean: x.default,
    isIBAN: fe.default,
    isBIC: le.default,
    isAlpha: _.default,
    isAlphaLocales: _.locales,
    isAlphanumeric: $.default,
    isAlphanumericLocales: $.locales,
    isNumeric: w.default,
    isPassportNumber: O.default,
    isPort: T.default,
    isLowercase: I.default,
    isUppercase: P.default,
    isAscii: B.default,
    isFullWidth: L.default,
    isHalfWidth: N.default,
    isVariableWidth: z.default,
    isMultibyte: F.default,
    isSemVer: j.default,
    isSurrogatePair: H.default,
    isInt: U.default,
    isIMEI: D.default,
    isFloat: G.default,
    isFloatLocales: G.locales,
    isDecimal: V.default,
    isHexadecimal: K.default,
    isOctal: Z.default,
    isDivisibleBy: ee.default,
    isHexColor: ae.default,
    isRgbColor: ue.default,
    isHSL: re.default,
    isISRC: oe.default,
    isMD5: se.default,
    isHash: Q.default,
    isJWT: he.default,
    isJSON: ne.default,
    isEmpty: me.default,
    isLength: k.default,
    isLocale: b.default,
    isByteLength: M.default,
    isUUID: R.default,
    isMongoId: q.default,
    isAfter: Y.default,
    isBefore: X.default,
    isIn: pe.default,
    isLuhnNumber: $e.default,
    isCreditCard: J.default,
    isIdentityCard: de.default,
    isEAN: Se.default,
    isISIN: Ee.default,
    isISBN: Te.default,
    isISSN: Le.default,
    isMobilePhone: De.default,
    isMobilePhoneLocales: De.locales,
    isPostalCode: Je.default,
    isPostalCodeLocales: Je.locales,
    isEthereumAddress: Ae.default,
    isCurrency: Fe.default,
    isBtcAddress: Ne.default,
    isISO6391: qe.default,
    isISO8601: Qe.default,
    isRFC3339: tt.default,
    isISO31661Alpha2: Ge.default,
    isISO31661Alpha3: it.default,
    isISO4217: ht.default,
    isBase32: It.default,
    isBase58: xt.default,
    isBase64: Xe.default,
    isDataURI: pt.default,
    isMagnetURI: Ze.default,
    isMimeType: wt.default,
    isLatLong: bt.default,
    ltrim: _t.default,
    rtrim: Vt.default,
    trim: ot.default,
    escape: Ct.default,
    unescape: rt.default,
    stripLow: $t.default,
    whitelist: Wt.default,
    blacklist: _e.default,
    isWhitelisted: Ke.default,
    normalizeEmail: nt.default,
    toString,
    isSlug: Ve.default,
    isStrongPassword: ut.default,
    isTaxID: Ie.default,
    isDate: y.default,
    isTime: S.default,
    isLicensePlate: ke.default,
    isVAT: st.default,
    ibanLocales: fe.locales
  }, Rt = yt;
  t.default = Rt, e.exports = t.default, e.exports.default = t.default;
})(cO, cO.exports);
var T9e = cO.exports;
const I9e = /* @__PURE__ */ Ut(T9e);
var yJ = "isStrongPassword";
function bJ(e, t) {
  return typeof e == "string" && I9e.isStrongPassword(e, t);
}
function M9e(e, t) {
  return vt({
    name: yJ,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return bJ(r, n.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property is not strong enough";
      }, t)
    }
  }, t);
}
var CJ = "isTimeZone";
function SJ(e) {
  try {
    return typeof e != "string" ? !1 : (Intl.DateTimeFormat(void 0, { timeZone: e }), !0);
  } catch {
    return !1;
  }
}
function A9e(e) {
  return vt({
    name: CJ,
    validator: {
      validate: function(t, r) {
        return SJ(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a valid IANA time-zone";
      }, e)
    }
  }, e);
}
var xJ = "isBase58";
function $J(e) {
  return typeof e == "string" && f9e(e);
}
function P9e(e) {
  return vt({
    name: xJ,
    validator: {
      validate: function(t, r) {
        return $J(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be base58 encoded";
      }, e)
    }
  }, e);
}
var _J = "isTaxId";
function EJ(e, t) {
  return typeof e == "string" && i9e(e, t || "en-US");
}
function R9e(e, t) {
  return vt({
    name: _J,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return EJ(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be a Tax Identification Number";
      }, t)
    }
  }, t);
}
var wJ = "isISO4217CurrencyCode";
function OJ(e) {
  return typeof e == "string" && s9e(e);
}
function N9e(e) {
  return vt({
    name: wJ,
    validator: {
      validate: function(t, r) {
        return OJ(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a valid ISO4217 currency code";
      }, e)
    }
  }, e);
}
var TJ = "isBoolean";
function IJ(e) {
  return e instanceof Boolean || typeof e == "boolean";
}
function D9e(e) {
  return vt({
    name: TJ,
    validator: {
      validate: function(t, r) {
        return IJ(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a boolean value";
      }, e)
    }
  }, e);
}
var MJ = "isDate";
function AJ(e) {
  return e instanceof Date && !isNaN(e.getTime());
}
function j9e(e) {
  return vt({
    name: MJ,
    validator: {
      validate: function(t, r) {
        return AJ(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a Date instance";
      }, e)
    }
  }, e);
}
var PJ = "isNumber";
function RJ(e, t) {
  if (t === void 0 && (t = {}), typeof e != "number")
    return !1;
  if (e === 1 / 0 || e === -1 / 0)
    return !!t.allowInfinity;
  if (Number.isNaN(e))
    return !!t.allowNaN;
  if (t.maxDecimalPlaces !== void 0) {
    var r = 0;
    if (e % 1 !== 0 && (r = e.toString().split(".")[1].length), r > t.maxDecimalPlaces)
      return !1;
  }
  return Number.isFinite(e);
}
function L9e(e, t) {
  return e === void 0 && (e = {}), vt({
    name: PJ,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return RJ(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be a number conforming to the specified constraints";
      }, t)
    }
  }, t);
}
var G5 = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), a, i = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = n.next()).done; ) i.push(a.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      a && !a.done && (r = n.return) && r.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return i;
}, NJ = "isEnum";
function DJ(e, t) {
  var r = Object.keys(t).map(function(n) {
    return t[n];
  });
  return r.includes(e);
}
function k9e(e) {
  return Object.entries(e).filter(function(t) {
    var r = G5(t, 2), n = r[0];
    return r[1], isNaN(parseInt(n));
  }).map(function(t) {
    var r = G5(t, 2);
    r[0];
    var n = r[1];
    return n;
  });
}
function F9e(e, t) {
  return vt({
    name: NJ,
    constraints: [e, k9e(e)],
    validator: {
      validate: function(r, n) {
        return DJ(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be one of the following values: $constraint2";
      }, t)
    }
  }, t);
}
var jJ = "isInt";
function LJ(e) {
  return typeof e == "number" && Number.isInteger(e);
}
function B9e(e) {
  return vt({
    name: jJ,
    validator: {
      validate: function(t, r) {
        return LJ(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be an integer number";
      }, e)
    }
  }, e);
}
var kJ = "isString";
function FJ(e) {
  return e instanceof String || typeof e == "string";
}
function z9e(e) {
  return vt({
    name: kJ,
    validator: {
      validate: function(t, r) {
        return FJ(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be a string";
      }, e)
    }
  }, e);
}
var BJ = "isArray";
function zJ(e) {
  return Array.isArray(e);
}
function H9e(e) {
  return vt({
    name: BJ,
    validator: {
      validate: function(t, r) {
        return zJ(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be an array";
      }, e)
    }
  }, e);
}
var HJ = "isObject";
function RM(e) {
  return e != null && (typeof e == "object" || typeof e == "function") && !Array.isArray(e);
}
function V9e(e) {
  return vt({
    name: HJ,
    validator: {
      validate: function(t, r) {
        return RM(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property must be an object";
      }, e)
    }
  }, e);
}
var VJ = "arrayContains";
function GJ(e, t) {
  return Array.isArray(e) ? t.every(function(r) {
    return e.indexOf(r) !== -1;
  }) : !1;
}
function G9e(e, t) {
  return vt({
    name: VJ,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return GJ(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must contain $constraint1 values";
      }, t)
    }
  }, t);
}
var UJ = "arrayNotContains";
function WJ(e, t) {
  return Array.isArray(e) ? t.every(function(r) {
    return e.indexOf(r) === -1;
  }) : !1;
}
function U9e(e, t) {
  return vt({
    name: UJ,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return WJ(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property should not contain $constraint1 values";
      }, t)
    }
  }, t);
}
var qJ = "arrayNotEmpty";
function KJ(e) {
  return Array.isArray(e) && e.length > 0;
}
function W9e(e) {
  return vt({
    name: qJ,
    validator: {
      validate: function(t, r) {
        return KJ(t);
      },
      defaultMessage: mt(function(t) {
        return t + "$property should not be empty";
      }, e)
    }
  }, e);
}
var YJ = "arrayMinSize";
function ZJ(e, t) {
  return Array.isArray(e) && e.length >= t;
}
function q9e(e, t) {
  return vt({
    name: YJ,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return ZJ(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must contain at least $constraint1 elements";
      }, t)
    }
  }, t);
}
var XJ = "arrayMaxSize";
function JJ(e, t) {
  return Array.isArray(e) && e.length <= t;
}
function K9e(e, t) {
  return vt({
    name: XJ,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return JJ(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must contain no more than $constraint1 elements";
      }, t)
    }
  }, t);
}
var QJ = "arrayUnique";
function eQ(e, t) {
  if (!Array.isArray(e))
    return !1;
  t && (e = e.map(function(n) {
    return n != null ? t(n) : n;
  }));
  var r = e.filter(function(n, a, i) {
    return i.indexOf(n) === a;
  });
  return e.length === r.length;
}
function Y9e(e, t) {
  var r = typeof e == "function" ? e : void 0, n = typeof e != "function" ? e : t;
  return vt({
    name: QJ,
    validator: {
      validate: function(a, i) {
        return eQ(a, r);
      },
      defaultMessage: mt(function(a) {
        return a + "All $property's elements must be unique";
      }, n)
    }
  }, n);
}
var tQ = "isNotEmptyObject";
function rQ(e, t) {
  if (!RM(e))
    return !1;
  if (t?.nullable === !0)
    return !Object.values(e).every(function(n) {
      return n == null;
    });
  for (var r in e)
    if (e.hasOwnProperty(r))
      return !0;
  return !1;
}
function Z9e(e, t) {
  return vt({
    name: tQ,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return rQ(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r) {
        return r + "$property must be a non-empty object";
      }, t)
    }
  }, t);
}
var BO = "isInstance";
function nQ(e, t) {
  return t && typeof t == "function" && e instanceof t;
}
function X9e(e, t) {
  return vt({
    name: BO,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return nQ(r, n?.constraints[0]);
      },
      defaultMessage: mt(function(r, n) {
        return n?.constraints[0] ? r + "$property must be an instance of ".concat(n?.constraints[0].name) : r + "".concat(BO, " decorator expects and object as value, but got falsy value.");
      }, t)
    }
  }, t);
}
function J9e(e, t, r) {
  return typeof e == "string" ? Gs(Tc).validate(e, t, r) : Gs(Tc).validate(e, t);
}
function Q9e(e, t, r) {
  return typeof e == "string" ? Gs(Tc).validateOrReject(e, t, r) : Gs(Tc).validateOrReject(e, t);
}
function e8e(e, t, r) {
  return typeof e == "string" ? Gs(Tc).validateSync(e, t, r) : Gs(Tc).validateSync(e, t);
}
function t8e(e) {
  uo().addValidationSchema(e);
}
const r8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ARRAY_CONTAINS: VJ,
  ARRAY_MAX_SIZE: XJ,
  ARRAY_MIN_SIZE: YJ,
  ARRAY_NOT_CONTAINS: UJ,
  ARRAY_NOT_EMPTY: qJ,
  ARRAY_UNIQUE: QJ,
  Allow: vPe,
  ArrayContains: G9e,
  ArrayMaxSize: K9e,
  ArrayMinSize: q9e,
  ArrayNotContains: U9e,
  ArrayNotEmpty: W9e,
  ArrayUnique: Y9e,
  CONTAINS: FK,
  Contains: UPe,
  EQUALS: sK,
  Equals: OPe,
  IS_ALPHA: VK,
  IS_ALPHANUMERIC: UK,
  IS_ARRAY: BJ,
  IS_ASCII: XK,
  IS_BASE32: uX,
  IS_BASE58: xJ,
  IS_BASE64: QK,
  IS_BIC: pX,
  IS_BOOLEAN: TJ,
  IS_BOOLEAN_STRING: aX,
  IS_BTC_ADDRESS: hX,
  IS_BYTE_LENGTH: tY,
  IS_CREDIT_CARD: iY,
  IS_CURRENCY: lY,
  IS_DATA_URI: bX,
  IS_DATE: MJ,
  IS_DATE_STRING: tX,
  IS_DECIMAL: KK,
  IS_DEFINED: Qq,
  IS_DIVISIBLE_BY: xK,
  IS_EAN: xX,
  IS_EMAIL: dY,
  IS_EMPTY: dK,
  IS_ENUM: NJ,
  IS_ETHEREUM_ADDRESS: EX,
  IS_FIREBASE_PUSH_ID: $Z,
  IS_FQDN: pY,
  IS_FULL_WIDTH: hY,
  IS_HALF_WIDTH: bY,
  IS_HASH: ZZ,
  IS_HEXADECIMAL: OY,
  IS_HEX_COLOR: EY,
  IS_HSL: TX,
  IS_IBAN: MX,
  IS_IDENTITY_CARD: RX,
  IS_IN: vK,
  IS_INSTANCE: BO,
  IS_INT: jJ,
  IS_IP: PY,
  IS_ISBN: kY,
  IS_ISIN: zY,
  IS_ISO31661_ALPHA_2: nZ,
  IS_ISO31661_ALPHA_3: oZ,
  IS_ISO4217_CURRENCY_CODE: wJ,
  IS_ISO8601: GY,
  IS_ISRC: jX,
  IS_ISSN: QZ,
  IS_JSON: WY,
  IS_JWT: YY,
  IS_LATITUDE: nK,
  IS_LATLONG: rK,
  IS_LENGTH: IZ,
  IS_LOCALE: FX,
  IS_LONGITUDE: iK,
  IS_LOWERCASE: JY,
  IS_MAC_ADDRESS: MY,
  IS_MAGNET_URI: HX,
  IS_MILITARY_TIME: qZ,
  IS_MIME_TYPE: UX,
  IS_MOBILE_PHONE: eZ,
  IS_MONGO_ID: cZ,
  IS_MULTIBYTE: fZ,
  IS_NEGATIVE: wK,
  IS_NOT_EMPTY: pK,
  IS_NOT_EMPTY_OBJECT: tQ,
  IS_NOT_IN: gK,
  IS_NUMBER: PJ,
  IS_NUMBER_STRING: sX,
  IS_OBJECT: HJ,
  IS_OCTAL: KX,
  IS_PASSPORT_NUMBER: XX,
  IS_PHONE_NUMBER: UZ,
  IS_PORT: DY,
  IS_POSITIVE: _K,
  IS_POSTAL_CODE: QX,
  IS_RFC_3339: rJ,
  IS_RGB_COLOR: iJ,
  IS_SEM_VER: lJ,
  IS_STRING: kJ,
  IS_STRONG_PASSWORD: yJ,
  IS_SURROGATE_PAIR: vZ,
  IS_TAX_ID: _J,
  IS_TIMEZONE: CJ,
  IS_UPPERCASE: wZ,
  IS_URL: yZ,
  IS_UUID: SZ,
  IS_VARIABLE_WIDTH: xY,
  IsAlpha: JPe,
  IsAlphanumeric: a3e,
  IsArray: H9e,
  IsAscii: c3e,
  IsBIC: J4e,
  IsBase32: Z4e,
  IsBase58: P9e,
  IsBase64: d3e,
  IsBoolean: D9e,
  IsBooleanString: W4e,
  IsBtcAddress: e6e,
  IsByteLength: p3e,
  IsCreditCard: v3e,
  IsCurrency: g3e,
  IsDataURI: r6e,
  IsDate: j9e,
  IsDateString: G4e,
  IsDecimal: s3e,
  IsDefined: hPe,
  IsDivisibleBy: kPe,
  IsEAN: a6e,
  IsEmail: S3e,
  IsEmpty: IPe,
  IsEnum: F9e,
  IsEthereumAddress: o6e,
  IsFQDN: x3e,
  IsFirebasePushId: wRe,
  IsFullWidth: O3e,
  IsHSL: l6e,
  IsHalfWidth: P3e,
  IsHash: z4e,
  IsHexColor: j3e,
  IsHexadecimal: k3e,
  IsIBAN: h6e,
  IsIP: z3e,
  IsISBN: U3e,
  IsISIN: q3e,
  IsISO31661Alpha2: pRe,
  IsISO31661Alpha3: vRe,
  IsISO4217CurrencyCode: N9e,
  IsISO8601: Y3e,
  IsISRC: C6e,
  IsISSN: V4e,
  IsIdentityCard: y6e,
  IsIn: APe,
  IsInstance: X9e,
  IsInt: B9e,
  IsJSON: X3e,
  IsJWT: Q3e,
  IsLatLong: _Pe,
  IsLatitude: EPe,
  IsLocale: x6e,
  IsLongitude: wPe,
  IsLowercase: tRe,
  IsMACAddress: B3e,
  IsMagnetURI: _6e,
  IsMilitaryTime: F4e,
  IsMimeType: w6e,
  IsMobilePhone: sRe,
  IsMongoId: gRe,
  IsMultibyte: bRe,
  IsNegative: BPe,
  IsNotEmpty: MPe,
  IsNotEmptyObject: Z9e,
  IsNotIn: PPe,
  IsNumber: L9e,
  IsNumberString: K4e,
  IsObject: V9e,
  IsOctal: T6e,
  IsOptional: gPe,
  IsPassportNumber: M6e,
  IsPhoneNumber: k4e,
  IsPort: V3e,
  IsPositive: FPe,
  IsPostalCode: j6e,
  IsRFC3339: k6e,
  IsRgbColor: B6e,
  IsSemVer: V6e,
  IsString: z9e,
  IsStrongPassword: M9e,
  IsSurrogatePair: SRe,
  IsTaxId: R9e,
  IsTimeZone: A9e,
  IsUUID: ERe,
  IsUppercase: TRe,
  IsUrl: $Re,
  IsVariableWidth: N3e,
  Length: IRe,
  MATCHES: LZ,
  MAX: TK,
  MAX_DATE: NK,
  MAX_LENGTH: AZ,
  MIN: MK,
  MIN_DATE: PK,
  MIN_LENGTH: RZ,
  Matches: PRe,
  Max: zPe,
  MaxDate: GPe,
  MaxLength: MRe,
  MetadataStorage: CM,
  Min: HPe,
  MinDate: VPe,
  MinLength: ARe,
  NOT_CONTAINS: zK,
  NOT_EQUALS: cK,
  NotContains: WPe,
  NotEquals: TPe,
  Validate: bPe,
  ValidateBy: vt,
  ValidateIf: CPe,
  ValidateNested: SPe,
  ValidatePromise: xPe,
  ValidationError: LE,
  ValidationTypes: na,
  Validator: Tc,
  ValidatorConstraint: yPe,
  arrayContains: GJ,
  arrayMaxSize: JJ,
  arrayMinSize: ZJ,
  arrayNotContains: WJ,
  arrayNotEmpty: KJ,
  arrayUnique: eQ,
  buildMessage: mt,
  contains: BK,
  equals: lK,
  getFromContainer: Gs,
  getMetadataStorage: uo,
  isAlpha: GK,
  isAlphanumeric: WK,
  isArray: zJ,
  isAscii: JK,
  isBIC: mX,
  isBase32: dX,
  isBase58: $J,
  isBase64: eY,
  isBoolean: IJ,
  isBooleanString: iX,
  isBtcAddress: gX,
  isByteLength: rY,
  isCreditCard: oY,
  isCurrency: cY,
  isDataURI: CX,
  isDate: AJ,
  isDateString: rX,
  isDecimal: YK,
  isDefined: eK,
  isDivisibleBy: $K,
  isEAN: $X,
  isEmail: fY,
  isEmpty: fK,
  isEnum: DJ,
  isEthereumAddress: wX,
  isFQDN: mY,
  isFirebasePushId: _Z,
  isFullWidth: gY,
  isHSL: IX,
  isHalfWidth: CY,
  isHash: XZ,
  isHexColor: wY,
  isHexadecimal: TY,
  isIBAN: AX,
  isIP: RY,
  isISBN: FY,
  isISIN: HY,
  isISO31661Alpha2: aZ,
  isISO31661Alpha3: sZ,
  isISO4217CurrencyCode: OJ,
  isISO8601: EM,
  isISRC: LX,
  isISSN: eX,
  isIdentityCard: NX,
  isIn: hK,
  isInstance: nQ,
  isInt: LJ,
  isJSON: qY,
  isJWT: ZY,
  isLatLong: cC,
  isLatitude: aK,
  isLocale: BX,
  isLongitude: oK,
  isLowercase: QY,
  isMACAddress: AY,
  isMagnetURI: VX,
  isMilitaryTime: KZ,
  isMimeType: WX,
  isMobilePhone: tZ,
  isMongoId: uZ,
  isMultibyte: pZ,
  isNegative: OK,
  isNotEmpty: mK,
  isNotEmptyObject: rQ,
  isNotIn: yK,
  isNumber: RJ,
  isNumberString: lX,
  isObject: RM,
  isOctal: YX,
  isPassportNumber: JX,
  isPhoneNumber: WZ,
  isPort: jY,
  isPositive: EK,
  isPostalCode: eJ,
  isRFC3339: nJ,
  isRgbColor: oJ,
  isSemVer: cJ,
  isString: FJ,
  isStrongPassword: bJ,
  isSurrogatePair: hZ,
  isTaxId: EJ,
  isTimeZone: SJ,
  isURL: bZ,
  isUUID: xZ,
  isUppercase: OZ,
  isValidationOptions: vw,
  isVariableWidth: $Y,
  length: MZ,
  matches: kZ,
  max: IK,
  maxDate: DK,
  maxLength: PZ,
  min: AK,
  minDate: RK,
  minLength: NZ,
  notContains: HK,
  notEquals: uK,
  registerDecorator: Jq,
  registerSchema: t8e,
  useContainer: mPe,
  validate: J9e,
  validateOrReject: Q9e,
  validateSync: e8e
}, Symbol.toStringTag, { value: "Module" })), n8e = /* @__PURE__ */ p1(r8e);
var jr;
(function(e) {
  e[e.PLAIN_TO_CLASS = 0] = "PLAIN_TO_CLASS", e[e.CLASS_TO_PLAIN = 1] = "CLASS_TO_PLAIN", e[e.CLASS_TO_CLASS = 2] = "CLASS_TO_CLASS";
})(jr || (jr = {}));
var a8e = (
  /** @class */
  function() {
    function e() {
      this._typeMetadatas = /* @__PURE__ */ new Map(), this._transformMetadatas = /* @__PURE__ */ new Map(), this._exposeMetadatas = /* @__PURE__ */ new Map(), this._excludeMetadatas = /* @__PURE__ */ new Map(), this._ancestorsMap = /* @__PURE__ */ new Map();
    }
    return e.prototype.addTypeMetadata = function(t) {
      this._typeMetadatas.has(t.target) || this._typeMetadatas.set(t.target, /* @__PURE__ */ new Map()), this._typeMetadatas.get(t.target).set(t.propertyName, t);
    }, e.prototype.addTransformMetadata = function(t) {
      this._transformMetadatas.has(t.target) || this._transformMetadatas.set(t.target, /* @__PURE__ */ new Map()), this._transformMetadatas.get(t.target).has(t.propertyName) || this._transformMetadatas.get(t.target).set(t.propertyName, []), this._transformMetadatas.get(t.target).get(t.propertyName).push(t);
    }, e.prototype.addExposeMetadata = function(t) {
      this._exposeMetadatas.has(t.target) || this._exposeMetadatas.set(t.target, /* @__PURE__ */ new Map()), this._exposeMetadatas.get(t.target).set(t.propertyName, t);
    }, e.prototype.addExcludeMetadata = function(t) {
      this._excludeMetadatas.has(t.target) || this._excludeMetadatas.set(t.target, /* @__PURE__ */ new Map()), this._excludeMetadatas.get(t.target).set(t.propertyName, t);
    }, e.prototype.findTransformMetadatas = function(t, r, n) {
      return this.findMetadatas(this._transformMetadatas, t, r).filter(function(a) {
        return !a.options || a.options.toClassOnly === !0 && a.options.toPlainOnly === !0 ? !0 : a.options.toClassOnly === !0 ? n === jr.CLASS_TO_CLASS || n === jr.PLAIN_TO_CLASS : a.options.toPlainOnly === !0 ? n === jr.CLASS_TO_PLAIN : !0;
      });
    }, e.prototype.findExcludeMetadata = function(t, r) {
      return this.findMetadata(this._excludeMetadatas, t, r);
    }, e.prototype.findExposeMetadata = function(t, r) {
      return this.findMetadata(this._exposeMetadatas, t, r);
    }, e.prototype.findExposeMetadataByCustomName = function(t, r) {
      return this.getExposedMetadatas(t).find(function(n) {
        return n.options && n.options.name === r;
      });
    }, e.prototype.findTypeMetadata = function(t, r) {
      return this.findMetadata(this._typeMetadatas, t, r);
    }, e.prototype.getStrategy = function(t) {
      var r = this._excludeMetadatas.get(t), n = r && r.get(void 0), a = this._exposeMetadatas.get(t), i = a && a.get(void 0);
      return n && i || !n && !i ? "none" : n ? "excludeAll" : "exposeAll";
    }, e.prototype.getExposedMetadatas = function(t) {
      return this.getMetadata(this._exposeMetadatas, t);
    }, e.prototype.getExcludedMetadatas = function(t) {
      return this.getMetadata(this._excludeMetadatas, t);
    }, e.prototype.getExposedProperties = function(t, r) {
      return this.getExposedMetadatas(t).filter(function(n) {
        return !n.options || n.options.toClassOnly === !0 && n.options.toPlainOnly === !0 ? !0 : n.options.toClassOnly === !0 ? r === jr.CLASS_TO_CLASS || r === jr.PLAIN_TO_CLASS : n.options.toPlainOnly === !0 ? r === jr.CLASS_TO_PLAIN : !0;
      }).map(function(n) {
        return n.propertyName;
      });
    }, e.prototype.getExcludedProperties = function(t, r) {
      return this.getExcludedMetadatas(t).filter(function(n) {
        return !n.options || n.options.toClassOnly === !0 && n.options.toPlainOnly === !0 ? !0 : n.options.toClassOnly === !0 ? r === jr.CLASS_TO_CLASS || r === jr.PLAIN_TO_CLASS : n.options.toPlainOnly === !0 ? r === jr.CLASS_TO_PLAIN : !0;
      }).map(function(n) {
        return n.propertyName;
      });
    }, e.prototype.clear = function() {
      this._typeMetadatas.clear(), this._exposeMetadatas.clear(), this._excludeMetadatas.clear(), this._ancestorsMap.clear();
    }, e.prototype.getMetadata = function(t, r) {
      var n = t.get(r), a;
      n && (a = Array.from(n.values()).filter(function(d) {
        return d.propertyName !== void 0;
      }));
      for (var i = [], o = 0, s = this.getAncestors(r); o < s.length; o++) {
        var l = s[o], c = t.get(l);
        if (c) {
          var u = Array.from(c.values()).filter(function(d) {
            return d.propertyName !== void 0;
          });
          i.push.apply(i, u);
        }
      }
      return i.concat(a || []);
    }, e.prototype.findMetadata = function(t, r, n) {
      var a = t.get(r);
      if (a) {
        var i = a.get(n);
        if (i)
          return i;
      }
      for (var o = 0, s = this.getAncestors(r); o < s.length; o++) {
        var l = s[o], c = t.get(l);
        if (c) {
          var u = c.get(n);
          if (u)
            return u;
        }
      }
    }, e.prototype.findMetadatas = function(t, r, n) {
      var a = t.get(r), i;
      a && (i = a.get(n));
      for (var o = [], s = 0, l = this.getAncestors(r); s < l.length; s++) {
        var c = l[s], u = t.get(c);
        u && u.has(n) && o.push.apply(o, u.get(n));
      }
      return o.slice().reverse().concat((i || []).slice().reverse());
    }, e.prototype.getAncestors = function(t) {
      if (!t)
        return [];
      if (!this._ancestorsMap.has(t)) {
        for (var r = [], n = Object.getPrototypeOf(t.prototype.constructor); typeof n.prototype < "u"; n = Object.getPrototypeOf(n.prototype.constructor))
          r.push(n);
        this._ancestorsMap.set(t, r);
      }
      return this._ancestorsMap.get(t);
    }, e;
  }()
), Ta = new a8e();
function i8e() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof global < "u")
    return global;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
}
function o8e(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var U5 = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, i; n < a; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
};
function s8e(e) {
  var t = new e();
  return !(t instanceof Set) && !("push" in t) ? [] : t;
}
var Du = (
  /** @class */
  function() {
    function e(t, r) {
      this.transformationType = t, this.options = r, this.recursionStack = /* @__PURE__ */ new Set();
    }
    return e.prototype.transform = function(t, r, n, a, i, o) {
      var s = this;
      if (o === void 0 && (o = 0), Array.isArray(r) || r instanceof Set) {
        var l = a && this.transformationType === jr.PLAIN_TO_CLASS ? s8e(a) : [];
        return r.forEach(function(y, S) {
          var x = t ? t[S] : void 0;
          if (!s.options.enableCircularCheck || !s.isCircular(y)) {
            var b = void 0;
            if (typeof n != "function" && n && n.options && n.options.discriminator && n.options.discriminator.property && n.options.discriminator.subTypes) {
              if (s.transformationType === jr.PLAIN_TO_CLASS) {
                b = n.options.discriminator.subTypes.find(function(O) {
                  return O.name === y[n.options.discriminator.property];
                });
                var _ = { newObject: l, object: y, property: void 0 }, $ = n.typeFunction(_);
                b === void 0 ? b = $ : b = b.value, n.options.keepDiscriminatorProperty || delete y[n.options.discriminator.property];
              }
              s.transformationType === jr.CLASS_TO_CLASS && (b = y.constructor), s.transformationType === jr.CLASS_TO_PLAIN && (y[n.options.discriminator.property] = n.options.discriminator.subTypes.find(function(O) {
                return O.value === y.constructor;
              }).name);
            } else
              b = n;
            var w = s.transform(x, y, b, void 0, y instanceof Map, o + 1);
            l instanceof Set ? l.add(w) : l.push(w);
          } else s.transformationType === jr.CLASS_TO_CLASS && (l instanceof Set ? l.add(y) : l.push(y));
        }), l;
      } else {
        if (n === String && !i)
          return r == null ? r : String(r);
        if (n === Number && !i)
          return r == null ? r : Number(r);
        if (n === Boolean && !i)
          return r == null ? r : !!r;
        if ((n === Date || r instanceof Date) && !i)
          return r instanceof Date ? new Date(r.valueOf()) : r == null ? r : new Date(r);
        if (i8e().Buffer && (n === Buffer || r instanceof Buffer) && !i)
          return r == null ? r : Buffer.from(r);
        if (o8e(r) && !i)
          return new Promise(function(y, S) {
            r.then(function(x) {
              return y(s.transform(void 0, x, n, void 0, void 0, o + 1));
            }, S);
          });
        if (!i && r !== null && typeof r == "object" && typeof r.then == "function")
          return r;
        if (typeof r == "object" && r !== null) {
          !n && r.constructor !== Object && (!Array.isArray(r) && r.constructor === Array || (n = r.constructor)), !n && t && (n = t.constructor), this.options.enableCircularCheck && this.recursionStack.add(r);
          var c = this.getKeys(n, r, i), u = t || {};
          !t && (this.transformationType === jr.PLAIN_TO_CLASS || this.transformationType === jr.CLASS_TO_CLASS) && (i ? u = /* @__PURE__ */ new Map() : n ? u = new n() : u = {});
          for (var d = function(y) {
            if (y === "__proto__" || y === "constructor")
              return "continue";
            var S = y, x = y, b = y;
            if (!f.options.ignoreDecorators && n) {
              if (f.transformationType === jr.PLAIN_TO_CLASS) {
                var _ = Ta.findExposeMetadataByCustomName(n, y);
                _ && (b = _.propertyName, x = _.propertyName);
              } else if (f.transformationType === jr.CLASS_TO_PLAIN || f.transformationType === jr.CLASS_TO_CLASS) {
                var _ = Ta.findExposeMetadata(n, y);
                _ && _.options && _.options.name && (x = _.options.name);
              }
            }
            var $ = void 0;
            f.transformationType === jr.PLAIN_TO_CLASS ? $ = r[S] : r instanceof Map ? $ = r.get(S) : r[S] instanceof Function ? $ = r[S]() : $ = r[S];
            var w = void 0, O = $ instanceof Map;
            if (n && i)
              w = n;
            else if (n) {
              var T = Ta.findTypeMetadata(n, b);
              if (T) {
                var I = { newObject: u, object: r, property: b }, P = T.typeFunction ? T.typeFunction(I) : T.reflectedType;
                T.options && T.options.discriminator && T.options.discriminator.property && T.options.discriminator.subTypes ? r[S] instanceof Array ? w = T : (f.transformationType === jr.PLAIN_TO_CLASS && (w = T.options.discriminator.subTypes.find(function(j) {
                  if ($ && $ instanceof Object && T.options.discriminator.property in $)
                    return j.name === $[T.options.discriminator.property];
                }), w === void 0 ? w = P : w = w.value, T.options.keepDiscriminatorProperty || $ && $ instanceof Object && T.options.discriminator.property in $ && delete $[T.options.discriminator.property]), f.transformationType === jr.CLASS_TO_CLASS && (w = $.constructor), f.transformationType === jr.CLASS_TO_PLAIN && $ && ($[T.options.discriminator.property] = T.options.discriminator.subTypes.find(function(j) {
                  return j.value === $.constructor;
                }).name)) : w = P, O = O || T.reflectedType === Map;
              } else if (f.options.targetMaps)
                f.options.targetMaps.filter(function(j) {
                  return j.target === n && !!j.properties[b];
                }).forEach(function(j) {
                  return w = j.properties[b];
                });
              else if (f.options.enableImplicitConversion && f.transformationType === jr.PLAIN_TO_CLASS) {
                var D = Reflect.getMetadata("design:type", n.prototype, b);
                D && (w = D);
              }
            }
            var B = Array.isArray(r[S]) ? f.getReflectedType(n, b) : void 0, L = t ? t[S] : void 0;
            if (u.constructor.prototype) {
              var N = Object.getOwnPropertyDescriptor(u.constructor.prototype, x);
              if ((f.transformationType === jr.PLAIN_TO_CLASS || f.transformationType === jr.CLASS_TO_CLASS) && // eslint-disable-next-line @typescript-eslint/unbound-method
              (N && !N.set || u[x] instanceof Function))
                return "continue";
            }
            if (!f.options.enableCircularCheck || !f.isCircular($)) {
              var z = f.transformationType === jr.PLAIN_TO_CLASS ? x : y, F = void 0;
              f.transformationType === jr.CLASS_TO_PLAIN ? (F = r[z], F = f.applyCustomTransformations(F, n, z, r, f.transformationType), F = r[z] === F ? $ : F, F = f.transform(L, F, w, B, O, o + 1)) : $ === void 0 && f.options.exposeDefaultValues ? F = u[x] : (F = f.transform(L, $, w, B, O, o + 1), F = f.applyCustomTransformations(F, n, z, r, f.transformationType)), (F !== void 0 || f.options.exposeUnsetFields) && (u instanceof Map ? u.set(x, F) : u[x] = F);
            } else if (f.transformationType === jr.CLASS_TO_CLASS) {
              var F = $;
              F = f.applyCustomTransformations(F, n, y, r, f.transformationType), (F !== void 0 || f.options.exposeUnsetFields) && (u instanceof Map ? u.set(x, F) : u[x] = F);
            }
          }, f = this, m = 0, h = c; m < h.length; m++) {
            var g = h[m];
            d(g);
          }
          return this.options.enableCircularCheck && this.recursionStack.delete(r), u;
        } else
          return r;
      }
    }, e.prototype.applyCustomTransformations = function(t, r, n, a, i) {
      var o = this, s = Ta.findTransformMetadatas(r, n, this.transformationType);
      return this.options.version !== void 0 && (s = s.filter(function(l) {
        return l.options ? o.checkVersion(l.options.since, l.options.until) : !0;
      })), this.options.groups && this.options.groups.length ? s = s.filter(function(l) {
        return l.options ? o.checkGroups(l.options.groups) : !0;
      }) : s = s.filter(function(l) {
        return !l.options || !l.options.groups || !l.options.groups.length;
      }), s.forEach(function(l) {
        t = l.transformFn({ value: t, key: n, obj: a, type: i, options: o.options });
      }), t;
    }, e.prototype.isCircular = function(t) {
      return this.recursionStack.has(t);
    }, e.prototype.getReflectedType = function(t, r) {
      if (t) {
        var n = Ta.findTypeMetadata(t, r);
        return n ? n.reflectedType : void 0;
      }
    }, e.prototype.getKeys = function(t, r, n) {
      var a = this, i = Ta.getStrategy(t);
      i === "none" && (i = this.options.strategy || "exposeAll");
      var o = [];
      if ((i === "exposeAll" || n) && (r instanceof Map ? o = Array.from(r.keys()) : o = Object.keys(r)), n)
        return o;
      if (this.options.ignoreDecorators && this.options.excludeExtraneousValues && t) {
        var s = Ta.getExposedProperties(t, this.transformationType), l = Ta.getExcludedProperties(t, this.transformationType);
        o = U5(U5([], s, !0), l, !0);
      }
      if (!this.options.ignoreDecorators && t) {
        var s = Ta.getExposedProperties(t, this.transformationType);
        this.transformationType === jr.PLAIN_TO_CLASS && (s = s.map(function(d) {
          var f = Ta.findExposeMetadata(t, d);
          return f && f.options && f.options.name ? f.options.name : d;
        })), this.options.excludeExtraneousValues ? o = s : o = o.concat(s);
        var c = Ta.getExcludedProperties(t, this.transformationType);
        c.length > 0 && (o = o.filter(function(d) {
          return !c.includes(d);
        })), this.options.version !== void 0 && (o = o.filter(function(d) {
          var f = Ta.findExposeMetadata(t, d);
          return !f || !f.options ? !0 : a.checkVersion(f.options.since, f.options.until);
        })), this.options.groups && this.options.groups.length ? o = o.filter(function(d) {
          var f = Ta.findExposeMetadata(t, d);
          return !f || !f.options ? !0 : a.checkGroups(f.options.groups);
        }) : o = o.filter(function(d) {
          var f = Ta.findExposeMetadata(t, d);
          return !f || !f.options || !f.options.groups || !f.options.groups.length;
        });
      }
      return this.options.excludePrefixes && this.options.excludePrefixes.length && (o = o.filter(function(u) {
        return a.options.excludePrefixes.every(function(d) {
          return u.substr(0, d.length) !== d;
        });
      })), o = o.filter(function(u, d, f) {
        return f.indexOf(u) === d;
      }), o;
    }, e.prototype.checkVersion = function(t, r) {
      var n = !0;
      return n && t && (n = this.options.version >= t), n && r && (n = this.options.version < r), n;
    }, e.prototype.checkGroups = function(t) {
      return t ? this.options.groups.some(function(r) {
        return t.includes(r);
      }) : !0;
    }, e;
  }()
), ju = {
  enableCircularCheck: !1,
  enableImplicitConversion: !1,
  excludeExtraneousValues: !1,
  excludePrefixes: void 0,
  exposeDefaultValues: !1,
  exposeUnsetFields: !0,
  groups: void 0,
  ignoreDecorators: !1,
  strategy: void 0,
  targetMaps: void 0,
  version: void 0
}, gi = function() {
  return gi = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, gi.apply(this, arguments);
}, zh = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.instanceToPlain = function(t, r) {
      var n = new Du(jr.CLASS_TO_PLAIN, gi(gi({}, ju), r));
      return n.transform(void 0, t, void 0, void 0, void 0, void 0);
    }, e.prototype.classToPlainFromExist = function(t, r, n) {
      var a = new Du(jr.CLASS_TO_PLAIN, gi(gi({}, ju), n));
      return a.transform(r, t, void 0, void 0, void 0, void 0);
    }, e.prototype.plainToInstance = function(t, r, n) {
      var a = new Du(jr.PLAIN_TO_CLASS, gi(gi({}, ju), n));
      return a.transform(void 0, r, t, void 0, void 0, void 0);
    }, e.prototype.plainToClassFromExist = function(t, r, n) {
      var a = new Du(jr.PLAIN_TO_CLASS, gi(gi({}, ju), n));
      return a.transform(t, r, void 0, void 0, void 0, void 0);
    }, e.prototype.instanceToInstance = function(t, r) {
      var n = new Du(jr.CLASS_TO_CLASS, gi(gi({}, ju), r));
      return n.transform(void 0, t, void 0, void 0, void 0, void 0);
    }, e.prototype.classToClassFromExist = function(t, r, n) {
      var a = new Du(jr.CLASS_TO_CLASS, gi(gi({}, ju), n));
      return a.transform(r, t, void 0, void 0, void 0, void 0);
    }, e.prototype.serialize = function(t, r) {
      return JSON.stringify(this.instanceToPlain(t, r));
    }, e.prototype.deserialize = function(t, r, n) {
      var a = JSON.parse(r);
      return this.plainToInstance(t, a, n);
    }, e.prototype.deserializeArray = function(t, r, n) {
      var a = JSON.parse(r);
      return this.plainToInstance(t, a, n);
    }, e;
  }()
);
function l8e(e) {
  return e === void 0 && (e = {}), function(t, r) {
    Ta.addExcludeMetadata({
      target: t instanceof Function ? t : t.constructor,
      propertyName: r,
      options: e
    });
  };
}
function c8e(e) {
  return e === void 0 && (e = {}), function(t, r) {
    Ta.addExposeMetadata({
      target: t instanceof Function ? t : t.constructor,
      propertyName: r,
      options: e
    });
  };
}
function u8e(e) {
  return function(t, r, n) {
    var a = new zh(), i = n.value;
    n.value = function() {
      for (var o = [], s = 0; s < arguments.length; s++)
        o[s] = arguments[s];
      var l = i.apply(this, o), c = !!l && (typeof l == "object" || typeof l == "function") && typeof l.then == "function";
      return c ? l.then(function(u) {
        return a.instanceToInstance(u, e);
      }) : a.instanceToInstance(l, e);
    };
  };
}
function d8e(e) {
  return function(t, r, n) {
    var a = new zh(), i = n.value;
    n.value = function() {
      for (var o = [], s = 0; s < arguments.length; s++)
        o[s] = arguments[s];
      var l = i.apply(this, o), c = !!l && (typeof l == "object" || typeof l == "function") && typeof l.then == "function";
      return c ? l.then(function(u) {
        return a.instanceToPlain(u, e);
      }) : a.instanceToPlain(l, e);
    };
  };
}
function f8e(e, t) {
  return function(r, n, a) {
    var i = new zh(), o = a.value;
    a.value = function() {
      for (var s = [], l = 0; l < arguments.length; l++)
        s[l] = arguments[l];
      var c = o.apply(this, s), u = !!c && (typeof c == "object" || typeof c == "function") && typeof c.then == "function";
      return u ? c.then(function(d) {
        return i.plainToInstance(e, d, t);
      }) : i.plainToInstance(e, c, t);
    };
  };
}
function p8e(e, t) {
  return t === void 0 && (t = {}), function(r, n) {
    Ta.addTransformMetadata({
      target: r.constructor,
      propertyName: n,
      transformFn: e,
      options: t
    });
  };
}
function m8e(e, t) {
  return t === void 0 && (t = {}), function(r, n) {
    var a = Reflect.getMetadata("design:type", r, n);
    Ta.addTypeMetadata({
      target: r.constructor,
      propertyName: n,
      reflectedType: a,
      typeFunction: e,
      options: t
    });
  };
}
var Ho = new zh();
function v8e(e, t) {
  return Ho.instanceToPlain(e, t);
}
function h8e(e, t) {
  return Ho.instanceToPlain(e, t);
}
function g8e(e, t, r) {
  return Ho.classToPlainFromExist(e, t, r);
}
function y8e(e, t, r) {
  return Ho.plainToInstance(e, t, r);
}
function b8e(e, t, r) {
  return Ho.plainToInstance(e, t, r);
}
function C8e(e, t, r) {
  return Ho.plainToClassFromExist(e, t, r);
}
function S8e(e, t) {
  return Ho.instanceToInstance(e, t);
}
function x8e(e, t, r) {
  return Ho.classToClassFromExist(e, t, r);
}
function $8e(e, t) {
  return Ho.serialize(e, t);
}
function _8e(e, t, r) {
  return Ho.deserialize(e, t, r);
}
function E8e(e, t, r) {
  return Ho.deserializeArray(e, t, r);
}
const w8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ClassTransformer: zh,
  Exclude: l8e,
  Expose: c8e,
  Transform: p8e,
  TransformInstanceToInstance: u8e,
  TransformInstanceToPlain: d8e,
  TransformPlainToInstance: f8e,
  get TransformationType() {
    return jr;
  },
  Type: m8e,
  classToClassFromExist: x8e,
  classToPlain: v8e,
  classToPlainFromExist: g8e,
  deserialize: _8e,
  deserializeArray: E8e,
  instanceToInstance: S8e,
  instanceToPlain: h8e,
  plainToClass: y8e,
  plainToClassFromExist: C8e,
  plainToInstance: b8e,
  serialize: $8e
}, Symbol.toStringTag, { value: "Module" })), aQ = /* @__PURE__ */ p1(w8e);
var W5;
function iQ() {
  if (W5) return Au;
  W5 = 1, Object.defineProperty(Au, "__esModule", { value: !0 }), Au.ValidationPipe = void 0;
  const e = Gr, t = rPe(), r = Qb, n = gM(), a = Tl(), i = Cn(), o = Zs(), s = Zq(), l = An();
  let c = {}, u = {}, d = class {
    constructor(m) {
      m = m || {};
      const { transform: h, disableErrorMessages: g, errorHttpStatusCode: y, expectedType: S, transformOptions: x, validateCustomDecorators: b, ..._ } = m;
      this.validatorOptions = { forbidUnknownValues: !1, ..._ }, this.isTransformEnabled = !!h, this.transformOptions = x, this.isDetailedOutputDisabled = g, this.validateCustomDecorators = b || !1, this.errorHttpStatusCode = y || i.HttpStatus.BAD_REQUEST, this.expectedType = S, this.exceptionFactory = m.exceptionFactory || this.createExceptionFactory(), c = this.loadValidator(m.validatorPackage), u = this.loadTransformer(m.transformerPackage);
    }
    loadValidator(m) {
      return m ?? (0, s.loadPackage)("class-validator", "ValidationPipe", () => n8e);
    }
    loadTransformer(m) {
      return m ?? (0, s.loadPackage)("class-transformer", "ValidationPipe", () => aQ);
    }
    async transform(m, h) {
      this.expectedType && (h = { ...h, metatype: this.expectedType });
      const g = h.metatype;
      if (!g || !this.toValidate(h))
        return this.isTransformEnabled ? this.transformPrimitive(m, h) : m;
      const y = m;
      m = this.toEmptyIfNil(m, g);
      const S = m !== y, x = this.isPrimitive(m);
      this.stripProtoKeys(m);
      let b = u.plainToInstance(g, m, this.transformOptions);
      const _ = b, $ = b.constructor !== g;
      $ && !x ? b.constructor = g : $ && (b = { constructor: g });
      const w = await this.validate(b, this.validatorOptions);
      if (w.length > 0)
        throw await this.exceptionFactory(w);
      return x && (b = _), this.isTransformEnabled ? b : S ? y : Object.keys(this.validatorOptions).length > 1 ? u.classToPlain(b, this.transformOptions) : m;
    }
    createExceptionFactory() {
      return (m = []) => {
        if (this.isDetailedOutputDisabled)
          return new o.HttpErrorByCode[this.errorHttpStatusCode]();
        const h = this.flattenValidationErrors(m);
        return new o.HttpErrorByCode[this.errorHttpStatusCode](h);
      };
    }
    toValidate(m) {
      const { metatype: h, type: g } = m;
      return g === "custom" && !this.validateCustomDecorators ? !1 : ![String, Boolean, Number, Array, Object, Buffer, Date].some((S) => h === S) && !(0, l.isNil)(h);
    }
    transformPrimitive(m, h) {
      if (!h.data)
        return m;
      const { type: g, metatype: y } = h;
      return g !== "param" && g !== "query" ? m : y === Boolean ? (0, l.isUndefined)(m) ? void 0 : m === !0 || m === "true" : y === Number ? (0, l.isUndefined)(m) ? void 0 : +m : y === String && !(0, l.isUndefined)(m) ? String(m) : m;
    }
    toEmptyIfNil(m, h) {
      return (0, l.isNil)(m) ? typeof h == "function" || h && "prototype" in h && h.prototype?.constructor ? {} : "" : m;
    }
    stripProtoKeys(m) {
      if (!(m == null || typeof m != "object" || r.types.isTypedArray(m))) {
        if (Array.isArray(m)) {
          for (const h of m)
            this.stripProtoKeys(h);
          return;
        }
        delete m.__proto__;
        for (const h in m)
          this.stripProtoKeys(m[h]);
      }
    }
    isPrimitive(m) {
      return ["number", "boolean", "string"].includes(typeof m);
    }
    validate(m, h) {
      return c.validate(m, h);
    }
    flattenValidationErrors(m) {
      return (0, t.iterate)(m).map((h) => this.mapChildrenToValidationErrors(h)).flatten().filter((h) => !!h.constraints).map((h) => Object.values(h.constraints)).flatten().toArray();
    }
    mapChildrenToValidationErrors(m, h) {
      if (!(m.children && m.children.length))
        return [m];
      const g = [];
      h = h ? `${h}.${m.property}` : m.property;
      for (const y of m.children)
        y.children && y.children.length && g.push(...this.mapChildrenToValidationErrors(y, h)), g.push(this.prependConstraintsWithParentProp(h, y));
      return g;
    }
    prependConstraintsWithParentProp(m, h) {
      const g = {};
      for (const y in h.constraints)
        g[y] = `${m}.${h.constraints[y]}`;
      return {
        ...h,
        constraints: g
      };
    }
  };
  return Au.ValidationPipe = d, Au.ValidationPipe = d = e.__decorate([
    (0, a.Injectable)(),
    e.__param(0, (0, n.Optional)()),
    e.__metadata("design:paramtypes", [Object])
  ], d), Au;
}
var q5;
function O8e() {
  if (q5) return Mu;
  q5 = 1, Object.defineProperty(Mu, "__esModule", { value: !0 }), Mu.ParseArrayPipe = void 0;
  const e = Gr, t = Vc(), r = Ph(), n = Cn(), a = Zs(), i = An(), o = iQ(), s = "Validation failed (parsable array expected)", l = ",";
  let c = class {
    constructor(d = {}) {
      this.options = d, this.validationPipe = new o.ValidationPipe({
        transform: !0,
        validateCustomDecorators: !0,
        ...d
      });
      const { exceptionFactory: f, errorHttpStatusCode: m = n.HttpStatus.BAD_REQUEST } = d;
      this.exceptionFactory = f || ((h) => new a.HttpErrorByCode[m](h));
    }
    /**
     * Method that accesses and performs optional transformation on argument for
     * in-flight requests.
     *
     * @param value currently processed route argument
     * @param metadata contains metadata about the currently processed route argument
     */
    async transform(d, f) {
      if (!d && !this.options.optional)
        throw this.exceptionFactory(s);
      if ((0, i.isNil)(d) && this.options.optional)
        return d;
      if (!Array.isArray(d))
        if ((0, i.isString)(d))
          try {
            d = d.trim().split(this.options.separator || l);
          } catch {
            throw this.exceptionFactory(s);
          }
        else
          throw this.exceptionFactory(s);
      if (this.options.items) {
        const m = {
          metatype: this.options.items,
          type: "query"
        }, h = this.isExpectedTypePrimitive(), g = (y, S) => {
          if (this.options.items !== String)
            try {
              y = JSON.parse(y);
            } catch {
            }
          return h ? this.validatePrimitive(y, S) : this.validationPipe.transform(y, m);
        };
        if (this.options.stopAtFirstError === !1) {
          let y = [];
          const S = d;
          for (let x = 0; x < S.length; x++)
            try {
              S[x] = await g(S[x]);
            } catch (b) {
              let _;
              if (b.getResponse) {
                const $ = b.getResponse();
                Array.isArray($.message) ? _ = $.message.map((w) => `[${x}] ${w}`) : _ = `[${x}] ${$.message}`;
              } else
                _ = b;
              y = y.concat(_);
            }
          if (y.length > 0)
            throw this.exceptionFactory(y);
          return S;
        } else
          d = await Promise.all(d.map(g));
      }
      return d;
    }
    isExpectedTypePrimitive() {
      return [Boolean, Number, String].includes(this.options.items);
    }
    validatePrimitive(d, f) {
      if (this.options.items === Number) {
        const m = d !== null && d !== "" ? +d : NaN;
        if (isNaN(m))
          throw this.exceptionFactory(`${(0, i.isUndefined)(f) ? "" : `[${f}] `}item must be a number`);
        return m;
      } else if (this.options.items === String) {
        if (!(0, i.isString)(d))
          return `${d}`;
      } else if (this.options.items === Boolean && typeof d != "boolean")
        throw this.exceptionFactory(`${(0, i.isUndefined)(f) ? "" : `[${f}] `}item must be a boolean value`);
      return d;
    }
  };
  return Mu.ParseArrayPipe = c, Mu.ParseArrayPipe = c = e.__decorate([
    (0, t.Injectable)(),
    e.__param(0, (0, r.Optional)()),
    e.__metadata("design:paramtypes", [Object])
  ], c), Mu;
}
var Lu = {}, K5;
function T8e() {
  if (K5) return Lu;
  K5 = 1, Object.defineProperty(Lu, "__esModule", { value: !0 }), Lu.ParseBoolPipe = void 0;
  const e = Gr, t = Vc(), r = Ph(), n = Cn(), a = Zs(), i = An();
  let o = class {
    constructor(l) {
      this.options = l, l = l || {};
      const { exceptionFactory: c, errorHttpStatusCode: u = n.HttpStatus.BAD_REQUEST } = l;
      this.exceptionFactory = c || ((d) => new a.HttpErrorByCode[u](d));
    }
    /**
     * Method that accesses and performs optional transformation on argument for
     * in-flight requests.
     *
     * @param value currently processed route argument
     * @param metadata contains metadata about the currently processed route argument
     */
    async transform(l, c) {
      if ((0, i.isNil)(l) && this.options?.optional)
        return l;
      if (this.isTrue(l))
        return !0;
      if (this.isFalse(l))
        return !1;
      throw this.exceptionFactory("Validation failed (boolean string is expected)");
    }
    /**
     * @param value currently processed route argument
     * @returns `true` if `value` is said 'true', ie., if it is equal to the boolean
     * `true` or the string `"true"`
     */
    isTrue(l) {
      return l === !0 || l === "true";
    }
    /**
     * @param value currently processed route argument
     * @returns `true` if `value` is said 'false', ie., if it is equal to the boolean
     * `false` or the string `"false"`
     */
    isFalse(l) {
      return l === !1 || l === "false";
    }
  };
  return Lu.ParseBoolPipe = o, Lu.ParseBoolPipe = o = e.__decorate([
    (0, t.Injectable)(),
    e.__param(0, (0, r.Optional)()),
    e.__metadata("design:paramtypes", [Object])
  ], o), Lu;
}
var ku = {}, Y5;
function I8e() {
  if (Y5) return ku;
  Y5 = 1, Object.defineProperty(ku, "__esModule", { value: !0 }), ku.ParseDatePipe = void 0;
  const e = Gr, t = Vc(), r = Cn(), n = Zs(), a = An();
  let i = class {
    constructor(s = {}) {
      this.options = s;
      const { exceptionFactory: l, errorHttpStatusCode: c = r.HttpStatus.BAD_REQUEST } = s;
      this.exceptionFactory = l || ((u) => new n.HttpErrorByCode[c](u));
    }
    /**
     * Method that accesses and performs optional transformation on argument for
     * in-flight requests.
     *
     * @param value currently processed route argument
     * @param metadata contains metadata about the currently processed route argument
     */
    transform(s) {
      if (this.options.optional && (0, a.isNil)(s))
        return this.options.default ? this.options.default() : s;
      if (!s)
        throw this.exceptionFactory("Validation failed (no Date provided)");
      const l = new Date(s);
      if (isNaN(l.getTime()))
        throw this.exceptionFactory("Validation failed (invalid date format)");
      return l;
    }
  };
  return ku.ParseDatePipe = i, ku.ParseDatePipe = i = e.__decorate([
    (0, t.Injectable)(),
    e.__metadata("design:paramtypes", [Object])
  ], i), ku;
}
var Fu = {}, Z5;
function M8e() {
  if (Z5) return Fu;
  Z5 = 1, Object.defineProperty(Fu, "__esModule", { value: !0 }), Fu.ParseEnumPipe = void 0;
  const e = Gr, t = Tl(), r = XM(), n = Zs(), a = An();
  let i = class {
    constructor(s, l) {
      if (this.enumType = s, this.options = l, !s)
        throw new Error('"ParseEnumPipe" requires "enumType" argument specified (to validate input values).');
      l = l || {};
      const { exceptionFactory: c, errorHttpStatusCode: u = r.HttpStatus.BAD_REQUEST } = l;
      this.exceptionFactory = c || ((d) => new n.HttpErrorByCode[u](d));
    }
    /**
     * Method that accesses and performs optional transformation on argument for
     * in-flight requests.
     *
     * @param value currently processed route argument
     * @param metadata contains metadata about the currently processed route argument
     */
    async transform(s, l) {
      if ((0, a.isNil)(s) && this.options?.optional)
        return s;
      if (!this.isEnum(s))
        throw this.exceptionFactory("Validation failed (enum string is expected)");
      return s;
    }
    isEnum(s) {
      return Object.keys(this.enumType).map((c) => this.enumType[c]).includes(s);
    }
  };
  return Fu.ParseEnumPipe = i, Fu.ParseEnumPipe = i = e.__decorate([
    (0, t.Injectable)(),
    e.__param(1, (0, t.Optional)()),
    e.__metadata("design:paramtypes", [Object, Object])
  ], i), Fu;
}
var Bu = {}, X5;
function A8e() {
  if (X5) return Bu;
  X5 = 1, Object.defineProperty(Bu, "__esModule", { value: !0 }), Bu.ParseFloatPipe = void 0;
  const e = Gr, t = Tl(), r = XM(), n = Zs(), a = An();
  let i = class {
    constructor(s) {
      this.options = s, s = s || {};
      const { exceptionFactory: l, errorHttpStatusCode: c = r.HttpStatus.BAD_REQUEST } = s;
      this.exceptionFactory = l || ((u) => new n.HttpErrorByCode[c](u));
    }
    /**
     * Method that accesses and performs optional transformation on argument for
     * in-flight requests.
     *
     * @param value currently processed route argument
     * @param metadata contains metadata about the currently processed route argument
     */
    async transform(s, l) {
      if ((0, a.isNil)(s) && this.options?.optional)
        return s;
      if (!this.isNumeric(s))
        throw this.exceptionFactory("Validation failed (numeric string is expected)");
      return parseFloat(s);
    }
    /**
     * @param value currently processed route argument
     * @returns `true` if `value` is a valid float number
     */
    isNumeric(s) {
      return ["string", "number"].includes(typeof s) && !isNaN(parseFloat(s)) && isFinite(s);
    }
  };
  return Bu.ParseFloatPipe = i, Bu.ParseFloatPipe = i = e.__decorate([
    (0, t.Injectable)(),
    e.__param(0, (0, t.Optional)()),
    e.__metadata("design:paramtypes", [Object])
  ], i), Bu;
}
var zu = {}, J5;
function P8e() {
  if (J5) return zu;
  J5 = 1, Object.defineProperty(zu, "__esModule", { value: !0 }), zu.ParseIntPipe = void 0;
  const e = Gr, t = Vc(), r = Ph(), n = Cn(), a = Zs(), i = An();
  let o = class {
    constructor(l) {
      this.options = l, l = l || {};
      const { exceptionFactory: c, errorHttpStatusCode: u = n.HttpStatus.BAD_REQUEST } = l;
      this.exceptionFactory = c || ((d) => new a.HttpErrorByCode[u](d));
    }
    /**
     * Method that accesses and performs optional transformation on argument for
     * in-flight requests.
     *
     * @param value currently processed route argument
     * @param metadata contains metadata about the currently processed route argument
     */
    async transform(l, c) {
      if ((0, i.isNil)(l) && this.options?.optional)
        return l;
      if (!this.isNumeric(l))
        throw this.exceptionFactory("Validation failed (numeric string is expected)");
      return parseInt(l, 10);
    }
    /**
     * @param value currently processed route argument
     * @returns `true` if `value` is a valid integer number
     */
    isNumeric(l) {
      return ["string", "number"].includes(typeof l) && /^-?\d+$/.test(l) && isFinite(l);
    }
  };
  return zu.ParseIntPipe = o, zu.ParseIntPipe = o = e.__decorate([
    (0, t.Injectable)(),
    e.__param(0, (0, r.Optional)()),
    e.__metadata("design:paramtypes", [Object])
  ], o), zu;
}
var Hu = {}, Q5;
function R8e() {
  if (Q5) return Hu;
  Q5 = 1;
  var e;
  Object.defineProperty(Hu, "__esModule", { value: !0 }), Hu.ParseUUIDPipe = void 0;
  const t = Gr, r = Vc(), n = Ph(), a = Cn(), i = Zs(), o = An();
  let s = e = class {
    constructor(c) {
      this.options = c, c = c || {};
      const { exceptionFactory: u, errorHttpStatusCode: d = a.HttpStatus.BAD_REQUEST, version: f } = c;
      this.version = f, this.exceptionFactory = u || ((m) => new i.HttpErrorByCode[d](m));
    }
    async transform(c, u) {
      if ((0, o.isNil)(c) && this.options?.optional)
        return c;
      if (!this.isUUID(c, this.version))
        throw this.exceptionFactory(`Validation failed (uuid${this.version ? ` v ${this.version}` : ""} is expected)`);
      return c;
    }
    isUUID(c, u = "all") {
      if (!(0, o.isString)(c))
        throw this.exceptionFactory("The value passed as UUID is not a string");
      return e.uuidRegExps[u]?.test(c);
    }
  };
  return Hu.ParseUUIDPipe = s, s.uuidRegExps = {
    3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    7: /^[0-9A-F]{8}-[0-9A-F]{4}-7[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
  }, Hu.ParseUUIDPipe = s = e = t.__decorate([
    (0, r.Injectable)(),
    t.__param(0, (0, n.Optional)()),
    t.__metadata("design:paramtypes", [Object])
  ], s), Hu;
}
var eD;
function N8e() {
  return eD || (eD = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = Gr;
    t.__exportStar(UAe(), e), t.__exportStar(KAe(), e), t.__exportStar(O8e(), e), t.__exportStar(T8e(), e), t.__exportStar(I8e(), e), t.__exportStar(M8e(), e), t.__exportStar(A8e(), e), t.__exportStar(P8e(), e), t.__exportStar(R8e(), e), t.__exportStar(iQ(), e);
  }(m_)), m_;
}
var I_ = {}, Vu = {}, M_ = {}, cp = {}, ql = {}, up = {}, tD;
function Pn() {
  if (tD) return up;
  tD = 1, Object.defineProperty(up, "__esModule", { value: !0 }), up.isFunction = void 0;
  function e(t) {
    return typeof t == "function";
  }
  return up.isFunction = e, up;
}
var rD;
function Yt() {
  if (rD) return ql;
  rD = 1, Object.defineProperty(ql, "__esModule", { value: !0 }), ql.operate = ql.hasLift = void 0;
  var e = Pn();
  function t(n) {
    return e.isFunction(n?.lift);
  }
  ql.hasLift = t;
  function r(n) {
    return function(a) {
      if (t(a))
        return a.lift(function(i) {
          try {
            return n(i, this);
          } catch (o) {
            this.error(o);
          }
        });
      throw new TypeError("Unable to lift unknown Observable type");
    };
  }
  return ql.operate = r, ql;
}
var Da = {}, dp = {}, nD;
function oQ() {
  return nD || (nD = 1, Object.defineProperty(dp, "__esModule", { value: !0 }), dp.isArrayLike = void 0, dp.isArrayLike = function(e) {
    return e && typeof e.length == "number" && typeof e != "function";
  }), dp;
}
var fp = {}, aD;
function sQ() {
  if (aD) return fp;
  aD = 1, Object.defineProperty(fp, "__esModule", { value: !0 }), fp.isPromise = void 0;
  var e = Pn();
  function t(r) {
    return e.isFunction(r?.then);
  }
  return fp.isPromise = t, fp;
}
var pp = {}, A_ = {}, Ts = {}, mp = {}, vp = {}, iD;
function Uc() {
  if (iD) return vp;
  iD = 1, Object.defineProperty(vp, "__esModule", { value: !0 }), vp.createErrorClass = void 0;
  function e(t) {
    var r = function(a) {
      Error.call(a), a.stack = new Error().stack;
    }, n = t(r);
    return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
  }
  return vp.createErrorClass = e, vp;
}
var oD;
function D8e() {
  if (oD) return mp;
  oD = 1, Object.defineProperty(mp, "__esModule", { value: !0 }), mp.UnsubscriptionError = void 0;
  var e = Uc();
  return mp.UnsubscriptionError = e.createErrorClass(function(t) {
    return function(n) {
      t(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(a, i) {
        return i + 1 + ") " + a.toString();
      }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n;
    };
  }), mp;
}
var hp = {}, sD;
function Ml() {
  if (sD) return hp;
  sD = 1, Object.defineProperty(hp, "__esModule", { value: !0 }), hp.arrRemove = void 0;
  function e(t, r) {
    if (t) {
      var n = t.indexOf(r);
      0 <= n && t.splice(n, 1);
    }
  }
  return hp.arrRemove = e, hp;
}
var lD;
function Xs() {
  if (lD) return Ts;
  lD = 1;
  var e = Ue && Ue.__values || function(c) {
    var u = typeof Symbol == "function" && Symbol.iterator, d = u && c[u], f = 0;
    if (d) return d.call(c);
    if (c && typeof c.length == "number") return {
      next: function() {
        return c && f >= c.length && (c = void 0), { value: c && c[f++], done: !c };
      }
    };
    throw new TypeError(u ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }, t = Ue && Ue.__read || function(c, u) {
    var d = typeof Symbol == "function" && c[Symbol.iterator];
    if (!d) return c;
    var f = d.call(c), m, h = [], g;
    try {
      for (; (u === void 0 || u-- > 0) && !(m = f.next()).done; ) h.push(m.value);
    } catch (y) {
      g = { error: y };
    } finally {
      try {
        m && !m.done && (d = f.return) && d.call(f);
      } finally {
        if (g) throw g.error;
      }
    }
    return h;
  }, r = Ue && Ue.__spreadArray || function(c, u) {
    for (var d = 0, f = u.length, m = c.length; d < f; d++, m++)
      c[m] = u[d];
    return c;
  };
  Object.defineProperty(Ts, "__esModule", { value: !0 }), Ts.isSubscription = Ts.EMPTY_SUBSCRIPTION = Ts.Subscription = void 0;
  var n = Pn(), a = D8e(), i = Ml(), o = function() {
    function c(u) {
      this.initialTeardown = u, this.closed = !1, this._parentage = null, this._finalizers = null;
    }
    return c.prototype.unsubscribe = function() {
      var u, d, f, m, h;
      if (!this.closed) {
        this.closed = !0;
        var g = this._parentage;
        if (g)
          if (this._parentage = null, Array.isArray(g))
            try {
              for (var y = e(g), S = y.next(); !S.done; S = y.next()) {
                var x = S.value;
                x.remove(this);
              }
            } catch (T) {
              u = { error: T };
            } finally {
              try {
                S && !S.done && (d = y.return) && d.call(y);
              } finally {
                if (u) throw u.error;
              }
            }
          else
            g.remove(this);
        var b = this.initialTeardown;
        if (n.isFunction(b))
          try {
            b();
          } catch (T) {
            h = T instanceof a.UnsubscriptionError ? T.errors : [T];
          }
        var _ = this._finalizers;
        if (_) {
          this._finalizers = null;
          try {
            for (var $ = e(_), w = $.next(); !w.done; w = $.next()) {
              var O = w.value;
              try {
                l(O);
              } catch (T) {
                h = h ?? [], T instanceof a.UnsubscriptionError ? h = r(r([], t(h)), t(T.errors)) : h.push(T);
              }
            }
          } catch (T) {
            f = { error: T };
          } finally {
            try {
              w && !w.done && (m = $.return) && m.call($);
            } finally {
              if (f) throw f.error;
            }
          }
        }
        if (h)
          throw new a.UnsubscriptionError(h);
      }
    }, c.prototype.add = function(u) {
      var d;
      if (u && u !== this)
        if (this.closed)
          l(u);
        else {
          if (u instanceof c) {
            if (u.closed || u._hasParent(this))
              return;
            u._addParent(this);
          }
          (this._finalizers = (d = this._finalizers) !== null && d !== void 0 ? d : []).push(u);
        }
    }, c.prototype._hasParent = function(u) {
      var d = this._parentage;
      return d === u || Array.isArray(d) && d.includes(u);
    }, c.prototype._addParent = function(u) {
      var d = this._parentage;
      this._parentage = Array.isArray(d) ? (d.push(u), d) : d ? [d, u] : u;
    }, c.prototype._removeParent = function(u) {
      var d = this._parentage;
      d === u ? this._parentage = null : Array.isArray(d) && i.arrRemove(d, u);
    }, c.prototype.remove = function(u) {
      var d = this._finalizers;
      d && i.arrRemove(d, u), u instanceof c && u._removeParent(this);
    }, c.EMPTY = function() {
      var u = new c();
      return u.closed = !0, u;
    }(), c;
  }();
  Ts.Subscription = o, Ts.EMPTY_SUBSCRIPTION = o.EMPTY;
  function s(c) {
    return c instanceof o || c && "closed" in c && n.isFunction(c.remove) && n.isFunction(c.add) && n.isFunction(c.unsubscribe);
  }
  Ts.isSubscription = s;
  function l(c) {
    n.isFunction(c) ? c() : c.unsubscribe();
  }
  return Ts;
}
var gp = {}, cD;
function pC() {
  return cD || (cD = 1, Object.defineProperty(gp, "__esModule", { value: !0 }), gp.config = void 0, gp.config = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: void 0,
    useDeprecatedSynchronousErrorHandling: !1,
    useDeprecatedNextContext: !1
  }), gp;
}
var yp = {}, P_ = {}, uD;
function lQ() {
  return uD || (uD = 1, function(e) {
    var t = Ue && Ue.__read || function(n, a) {
      var i = typeof Symbol == "function" && n[Symbol.iterator];
      if (!i) return n;
      var o = i.call(n), s, l = [], c;
      try {
        for (; (a === void 0 || a-- > 0) && !(s = o.next()).done; ) l.push(s.value);
      } catch (u) {
        c = { error: u };
      } finally {
        try {
          s && !s.done && (i = o.return) && i.call(o);
        } finally {
          if (c) throw c.error;
        }
      }
      return l;
    }, r = Ue && Ue.__spreadArray || function(n, a) {
      for (var i = 0, o = a.length, s = n.length; i < o; i++, s++)
        n[s] = a[i];
      return n;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.timeoutProvider = void 0, e.timeoutProvider = {
      setTimeout: function(n, a) {
        for (var i = [], o = 2; o < arguments.length; o++)
          i[o - 2] = arguments[o];
        var s = e.timeoutProvider.delegate;
        return s?.setTimeout ? s.setTimeout.apply(s, r([n, a], t(i))) : setTimeout.apply(void 0, r([n, a], t(i)));
      },
      clearTimeout: function(n) {
        var a = e.timeoutProvider.delegate;
        return (a?.clearTimeout || clearTimeout)(n);
      },
      delegate: void 0
    };
  }(P_)), P_;
}
var dD;
function cQ() {
  if (dD) return yp;
  dD = 1, Object.defineProperty(yp, "__esModule", { value: !0 }), yp.reportUnhandledError = void 0;
  var e = pC(), t = lQ();
  function r(n) {
    t.timeoutProvider.setTimeout(function() {
      var a = e.config.onUnhandledError;
      if (a)
        a(n);
      else
        throw n;
    });
  }
  return yp.reportUnhandledError = r, yp;
}
var bp = {}, fD;
function _i() {
  if (fD) return bp;
  fD = 1, Object.defineProperty(bp, "__esModule", { value: !0 }), bp.noop = void 0;
  function e() {
  }
  return bp.noop = e, bp;
}
var Co = {}, pD;
function j8e() {
  if (pD) return Co;
  pD = 1, Object.defineProperty(Co, "__esModule", { value: !0 }), Co.createNotification = Co.nextNotification = Co.errorNotification = Co.COMPLETE_NOTIFICATION = void 0, Co.COMPLETE_NOTIFICATION = function() {
    return r("C", void 0, void 0);
  }();
  function e(n) {
    return r("E", void 0, n);
  }
  Co.errorNotification = e;
  function t(n) {
    return r("N", n, void 0);
  }
  Co.nextNotification = t;
  function r(n, a, i) {
    return {
      kind: n,
      value: a,
      error: i
    };
  }
  return Co.createNotification = r, Co;
}
var Kl = {}, mD;
function NM() {
  if (mD) return Kl;
  mD = 1, Object.defineProperty(Kl, "__esModule", { value: !0 }), Kl.captureError = Kl.errorContext = void 0;
  var e = pC(), t = null;
  function r(a) {
    if (e.config.useDeprecatedSynchronousErrorHandling) {
      var i = !t;
      if (i && (t = { errorThrown: !1, error: null }), a(), i) {
        var o = t, s = o.errorThrown, l = o.error;
        if (t = null, s)
          throw l;
      }
    } else
      a();
  }
  Kl.errorContext = r;
  function n(a) {
    e.config.useDeprecatedSynchronousErrorHandling && t && (t.errorThrown = !0, t.error = a);
  }
  return Kl.captureError = n, Kl;
}
var vD;
function DM() {
  return vD || (vD = 1, function(e) {
    var t = Ue && Ue.__extends || /* @__PURE__ */ function() {
      var x = function(b, _) {
        return x = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function($, w) {
          $.__proto__ = w;
        } || function($, w) {
          for (var O in w) Object.prototype.hasOwnProperty.call(w, O) && ($[O] = w[O]);
        }, x(b, _);
      };
      return function(b, _) {
        if (typeof _ != "function" && _ !== null)
          throw new TypeError("Class extends value " + String(_) + " is not a constructor or null");
        x(b, _);
        function $() {
          this.constructor = b;
        }
        b.prototype = _ === null ? Object.create(_) : ($.prototype = _.prototype, new $());
      };
    }();
    Object.defineProperty(e, "__esModule", { value: !0 }), e.EMPTY_OBSERVER = e.SafeSubscriber = e.Subscriber = void 0;
    var r = Pn(), n = Xs(), a = pC(), i = cQ(), o = _i(), s = j8e(), l = lQ(), c = NM(), u = function(x) {
      t(b, x);
      function b(_) {
        var $ = x.call(this) || this;
        return $.isStopped = !1, _ ? ($.destination = _, n.isSubscription(_) && _.add($)) : $.destination = e.EMPTY_OBSERVER, $;
      }
      return b.create = function(_, $, w) {
        return new h(_, $, w);
      }, b.prototype.next = function(_) {
        this.isStopped ? S(s.nextNotification(_), this) : this._next(_);
      }, b.prototype.error = function(_) {
        this.isStopped ? S(s.errorNotification(_), this) : (this.isStopped = !0, this._error(_));
      }, b.prototype.complete = function() {
        this.isStopped ? S(s.COMPLETE_NOTIFICATION, this) : (this.isStopped = !0, this._complete());
      }, b.prototype.unsubscribe = function() {
        this.closed || (this.isStopped = !0, x.prototype.unsubscribe.call(this), this.destination = null);
      }, b.prototype._next = function(_) {
        this.destination.next(_);
      }, b.prototype._error = function(_) {
        try {
          this.destination.error(_);
        } finally {
          this.unsubscribe();
        }
      }, b.prototype._complete = function() {
        try {
          this.destination.complete();
        } finally {
          this.unsubscribe();
        }
      }, b;
    }(n.Subscription);
    e.Subscriber = u;
    var d = Function.prototype.bind;
    function f(x, b) {
      return d.call(x, b);
    }
    var m = function() {
      function x(b) {
        this.partialObserver = b;
      }
      return x.prototype.next = function(b) {
        var _ = this.partialObserver;
        if (_.next)
          try {
            _.next(b);
          } catch ($) {
            g($);
          }
      }, x.prototype.error = function(b) {
        var _ = this.partialObserver;
        if (_.error)
          try {
            _.error(b);
          } catch ($) {
            g($);
          }
        else
          g(b);
      }, x.prototype.complete = function() {
        var b = this.partialObserver;
        if (b.complete)
          try {
            b.complete();
          } catch (_) {
            g(_);
          }
      }, x;
    }(), h = function(x) {
      t(b, x);
      function b(_, $, w) {
        var O = x.call(this) || this, T;
        if (r.isFunction(_) || !_)
          T = {
            next: _ ?? void 0,
            error: $ ?? void 0,
            complete: w ?? void 0
          };
        else {
          var I;
          O && a.config.useDeprecatedNextContext ? (I = Object.create(_), I.unsubscribe = function() {
            return O.unsubscribe();
          }, T = {
            next: _.next && f(_.next, I),
            error: _.error && f(_.error, I),
            complete: _.complete && f(_.complete, I)
          }) : T = _;
        }
        return O.destination = new m(T), O;
      }
      return b;
    }(u);
    e.SafeSubscriber = h;
    function g(x) {
      a.config.useDeprecatedSynchronousErrorHandling ? c.captureError(x) : i.reportUnhandledError(x);
    }
    function y(x) {
      throw x;
    }
    function S(x, b) {
      var _ = a.config.onStoppedNotification;
      _ && l.timeoutProvider.setTimeout(function() {
        return _(x, b);
      });
    }
    e.EMPTY_OBSERVER = {
      closed: !0,
      next: o.noop,
      error: y,
      complete: o.noop
    };
  }(A_)), A_;
}
var Cp = {}, hD;
function jM() {
  return hD || (hD = 1, Object.defineProperty(Cp, "__esModule", { value: !0 }), Cp.observable = void 0, Cp.observable = function() {
    return typeof Symbol == "function" && Symbol.observable || "@@observable";
  }()), Cp;
}
var Yl = {}, Sp = {}, gD;
function Ei() {
  if (gD) return Sp;
  gD = 1, Object.defineProperty(Sp, "__esModule", { value: !0 }), Sp.identity = void 0;
  function e(t) {
    return t;
  }
  return Sp.identity = e, Sp;
}
var yD;
function LM() {
  if (yD) return Yl;
  yD = 1, Object.defineProperty(Yl, "__esModule", { value: !0 }), Yl.pipeFromArray = Yl.pipe = void 0;
  var e = Ei();
  function t() {
    for (var n = [], a = 0; a < arguments.length; a++)
      n[a] = arguments[a];
    return r(n);
  }
  Yl.pipe = t;
  function r(n) {
    return n.length === 0 ? e.identity : n.length === 1 ? n[0] : function(i) {
      return n.reduce(function(o, s) {
        return s(o);
      }, i);
    };
  }
  return Yl.pipeFromArray = r, Yl;
}
var bD;
function ci() {
  if (bD) return pp;
  bD = 1, Object.defineProperty(pp, "__esModule", { value: !0 }), pp.Observable = void 0;
  var e = DM(), t = Xs(), r = jM(), n = LM(), a = pC(), i = Pn(), o = NM(), s = function() {
    function d(f) {
      f && (this._subscribe = f);
    }
    return d.prototype.lift = function(f) {
      var m = new d();
      return m.source = this, m.operator = f, m;
    }, d.prototype.subscribe = function(f, m, h) {
      var g = this, y = u(f) ? f : new e.SafeSubscriber(f, m, h);
      return o.errorContext(function() {
        var S = g, x = S.operator, b = S.source;
        y.add(x ? x.call(y, b) : b ? g._subscribe(y) : g._trySubscribe(y));
      }), y;
    }, d.prototype._trySubscribe = function(f) {
      try {
        return this._subscribe(f);
      } catch (m) {
        f.error(m);
      }
    }, d.prototype.forEach = function(f, m) {
      var h = this;
      return m = l(m), new m(function(g, y) {
        var S = new e.SafeSubscriber({
          next: function(x) {
            try {
              f(x);
            } catch (b) {
              y(b), S.unsubscribe();
            }
          },
          error: y,
          complete: g
        });
        h.subscribe(S);
      });
    }, d.prototype._subscribe = function(f) {
      var m;
      return (m = this.source) === null || m === void 0 ? void 0 : m.subscribe(f);
    }, d.prototype[r.observable] = function() {
      return this;
    }, d.prototype.pipe = function() {
      for (var f = [], m = 0; m < arguments.length; m++)
        f[m] = arguments[m];
      return n.pipeFromArray(f)(this);
    }, d.prototype.toPromise = function(f) {
      var m = this;
      return f = l(f), new f(function(h, g) {
        var y;
        m.subscribe(function(S) {
          return y = S;
        }, function(S) {
          return g(S);
        }, function() {
          return h(y);
        });
      });
    }, d.create = function(f) {
      return new d(f);
    }, d;
  }();
  pp.Observable = s;
  function l(d) {
    var f;
    return (f = d ?? a.config.Promise) !== null && f !== void 0 ? f : Promise;
  }
  function c(d) {
    return d && i.isFunction(d.next) && i.isFunction(d.error) && i.isFunction(d.complete);
  }
  function u(d) {
    return d && d instanceof e.Subscriber || c(d) && t.isSubscription(d);
  }
  return pp;
}
var xp = {}, CD;
function uQ() {
  if (CD) return xp;
  CD = 1, Object.defineProperty(xp, "__esModule", { value: !0 }), xp.isInteropObservable = void 0;
  var e = jM(), t = Pn();
  function r(n) {
    return t.isFunction(n[e.observable]);
  }
  return xp.isInteropObservable = r, xp;
}
var $p = {}, SD;
function dQ() {
  if (SD) return $p;
  SD = 1, Object.defineProperty($p, "__esModule", { value: !0 }), $p.isAsyncIterable = void 0;
  var e = Pn();
  function t(r) {
    return Symbol.asyncIterator && e.isFunction(r?.[Symbol.asyncIterator]);
  }
  return $p.isAsyncIterable = t, $p;
}
var _p = {}, xD;
function fQ() {
  if (xD) return _p;
  xD = 1, Object.defineProperty(_p, "__esModule", { value: !0 }), _p.createInvalidObservableTypeError = void 0;
  function e(t) {
    return new TypeError("You provided " + (t !== null && typeof t == "object" ? "an invalid object" : "'" + t + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
  }
  return _p.createInvalidObservableTypeError = e, _p;
}
var Ep = {}, Zl = {}, $D;
function pQ() {
  if ($D) return Zl;
  $D = 1, Object.defineProperty(Zl, "__esModule", { value: !0 }), Zl.iterator = Zl.getSymbolIterator = void 0;
  function e() {
    return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
  }
  return Zl.getSymbolIterator = e, Zl.iterator = e(), Zl;
}
var _D;
function mQ() {
  if (_D) return Ep;
  _D = 1, Object.defineProperty(Ep, "__esModule", { value: !0 }), Ep.isIterable = void 0;
  var e = pQ(), t = Pn();
  function r(n) {
    return t.isFunction(n?.[e.iterator]);
  }
  return Ep.isIterable = r, Ep;
}
var Xl = {}, ED;
function kM() {
  if (ED) return Xl;
  ED = 1;
  var e = Ue && Ue.__generator || function(o, s) {
    var l = { label: 0, sent: function() {
      if (d[0] & 1) throw d[1];
      return d[1];
    }, trys: [], ops: [] }, c, u, d, f;
    return f = { next: m(0), throw: m(1), return: m(2) }, typeof Symbol == "function" && (f[Symbol.iterator] = function() {
      return this;
    }), f;
    function m(g) {
      return function(y) {
        return h([g, y]);
      };
    }
    function h(g) {
      if (c) throw new TypeError("Generator is already executing.");
      for (; l; ) try {
        if (c = 1, u && (d = g[0] & 2 ? u.return : g[0] ? u.throw || ((d = u.return) && d.call(u), 0) : u.next) && !(d = d.call(u, g[1])).done) return d;
        switch (u = 0, d && (g = [g[0] & 2, d.value]), g[0]) {
          case 0:
          case 1:
            d = g;
            break;
          case 4:
            return l.label++, { value: g[1], done: !1 };
          case 5:
            l.label++, u = g[1], g = [0];
            continue;
          case 7:
            g = l.ops.pop(), l.trys.pop();
            continue;
          default:
            if (d = l.trys, !(d = d.length > 0 && d[d.length - 1]) && (g[0] === 6 || g[0] === 2)) {
              l = 0;
              continue;
            }
            if (g[0] === 3 && (!d || g[1] > d[0] && g[1] < d[3])) {
              l.label = g[1];
              break;
            }
            if (g[0] === 6 && l.label < d[1]) {
              l.label = d[1], d = g;
              break;
            }
            if (d && l.label < d[2]) {
              l.label = d[2], l.ops.push(g);
              break;
            }
            d[2] && l.ops.pop(), l.trys.pop();
            continue;
        }
        g = s.call(o, l);
      } catch (y) {
        g = [6, y], u = 0;
      } finally {
        c = d = 0;
      }
      if (g[0] & 5) throw g[1];
      return { value: g[0] ? g[1] : void 0, done: !0 };
    }
  }, t = Ue && Ue.__await || function(o) {
    return this instanceof t ? (this.v = o, this) : new t(o);
  }, r = Ue && Ue.__asyncGenerator || function(o, s, l) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var c = l.apply(o, s || []), u, d = [];
    return u = {}, f("next"), f("throw"), f("return"), u[Symbol.asyncIterator] = function() {
      return this;
    }, u;
    function f(x) {
      c[x] && (u[x] = function(b) {
        return new Promise(function(_, $) {
          d.push([x, b, _, $]) > 1 || m(x, b);
        });
      });
    }
    function m(x, b) {
      try {
        h(c[x](b));
      } catch (_) {
        S(d[0][3], _);
      }
    }
    function h(x) {
      x.value instanceof t ? Promise.resolve(x.value.v).then(g, y) : S(d[0][2], x);
    }
    function g(x) {
      m("next", x);
    }
    function y(x) {
      m("throw", x);
    }
    function S(x, b) {
      x(b), d.shift(), d.length && m(d[0][0], d[0][1]);
    }
  };
  Object.defineProperty(Xl, "__esModule", { value: !0 }), Xl.isReadableStreamLike = Xl.readableStreamLikeToAsyncGenerator = void 0;
  var n = Pn();
  function a(o) {
    return r(this, arguments, function() {
      var l, c, u, d;
      return e(this, function(f) {
        switch (f.label) {
          case 0:
            l = o.getReader(), f.label = 1;
          case 1:
            f.trys.push([1, , 9, 10]), f.label = 2;
          case 2:
            return [4, t(l.read())];
          case 3:
            return c = f.sent(), u = c.value, d = c.done, d ? [4, t(void 0)] : [3, 5];
          case 4:
            return [2, f.sent()];
          case 5:
            return [4, t(u)];
          case 6:
            return [4, f.sent()];
          case 7:
            return f.sent(), [3, 2];
          case 8:
            return [3, 10];
          case 9:
            return l.releaseLock(), [7];
          case 10:
            return [2];
        }
      });
    });
  }
  Xl.readableStreamLikeToAsyncGenerator = a;
  function i(o) {
    return n.isFunction(o?.getReader);
  }
  return Xl.isReadableStreamLike = i, Xl;
}
var wD;
function qr() {
  if (wD) return Da;
  wD = 1;
  var e = Ue && Ue.__awaiter || function(O, T, I, P) {
    function D(B) {
      return B instanceof I ? B : new I(function(L) {
        L(B);
      });
    }
    return new (I || (I = Promise))(function(B, L) {
      function N(j) {
        try {
          F(P.next(j));
        } catch (H) {
          L(H);
        }
      }
      function z(j) {
        try {
          F(P.throw(j));
        } catch (H) {
          L(H);
        }
      }
      function F(j) {
        j.done ? B(j.value) : D(j.value).then(N, z);
      }
      F((P = P.apply(O, T || [])).next());
    });
  }, t = Ue && Ue.__generator || function(O, T) {
    var I = { label: 0, sent: function() {
      if (B[0] & 1) throw B[1];
      return B[1];
    }, trys: [], ops: [] }, P, D, B, L;
    return L = { next: N(0), throw: N(1), return: N(2) }, typeof Symbol == "function" && (L[Symbol.iterator] = function() {
      return this;
    }), L;
    function N(F) {
      return function(j) {
        return z([F, j]);
      };
    }
    function z(F) {
      if (P) throw new TypeError("Generator is already executing.");
      for (; I; ) try {
        if (P = 1, D && (B = F[0] & 2 ? D.return : F[0] ? D.throw || ((B = D.return) && B.call(D), 0) : D.next) && !(B = B.call(D, F[1])).done) return B;
        switch (D = 0, B && (F = [F[0] & 2, B.value]), F[0]) {
          case 0:
          case 1:
            B = F;
            break;
          case 4:
            return I.label++, { value: F[1], done: !1 };
          case 5:
            I.label++, D = F[1], F = [0];
            continue;
          case 7:
            F = I.ops.pop(), I.trys.pop();
            continue;
          default:
            if (B = I.trys, !(B = B.length > 0 && B[B.length - 1]) && (F[0] === 6 || F[0] === 2)) {
              I = 0;
              continue;
            }
            if (F[0] === 3 && (!B || F[1] > B[0] && F[1] < B[3])) {
              I.label = F[1];
              break;
            }
            if (F[0] === 6 && I.label < B[1]) {
              I.label = B[1], B = F;
              break;
            }
            if (B && I.label < B[2]) {
              I.label = B[2], I.ops.push(F);
              break;
            }
            B[2] && I.ops.pop(), I.trys.pop();
            continue;
        }
        F = T.call(O, I);
      } catch (j) {
        F = [6, j], D = 0;
      } finally {
        P = B = 0;
      }
      if (F[0] & 5) throw F[1];
      return { value: F[0] ? F[1] : void 0, done: !0 };
    }
  }, r = Ue && Ue.__asyncValues || function(O) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var T = O[Symbol.asyncIterator], I;
    return T ? T.call(O) : (O = typeof n == "function" ? n(O) : O[Symbol.iterator](), I = {}, P("next"), P("throw"), P("return"), I[Symbol.asyncIterator] = function() {
      return this;
    }, I);
    function P(B) {
      I[B] = O[B] && function(L) {
        return new Promise(function(N, z) {
          L = O[B](L), D(N, z, L.done, L.value);
        });
      };
    }
    function D(B, L, N, z) {
      Promise.resolve(z).then(function(F) {
        B({ value: F, done: N });
      }, L);
    }
  }, n = Ue && Ue.__values || function(O) {
    var T = typeof Symbol == "function" && Symbol.iterator, I = T && O[T], P = 0;
    if (I) return I.call(O);
    if (O && typeof O.length == "number") return {
      next: function() {
        return O && P >= O.length && (O = void 0), { value: O && O[P++], done: !O };
      }
    };
    throw new TypeError(T ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(Da, "__esModule", { value: !0 }), Da.fromReadableStreamLike = Da.fromAsyncIterable = Da.fromIterable = Da.fromPromise = Da.fromArrayLike = Da.fromInteropObservable = Da.innerFrom = void 0;
  var a = oQ(), i = sQ(), o = ci(), s = uQ(), l = dQ(), c = fQ(), u = mQ(), d = kM(), f = Pn(), m = cQ(), h = jM();
  function g(O) {
    if (O instanceof o.Observable)
      return O;
    if (O != null) {
      if (s.isInteropObservable(O))
        return y(O);
      if (a.isArrayLike(O))
        return S(O);
      if (i.isPromise(O))
        return x(O);
      if (l.isAsyncIterable(O))
        return _(O);
      if (u.isIterable(O))
        return b(O);
      if (d.isReadableStreamLike(O))
        return $(O);
    }
    throw c.createInvalidObservableTypeError(O);
  }
  Da.innerFrom = g;
  function y(O) {
    return new o.Observable(function(T) {
      var I = O[h.observable]();
      if (f.isFunction(I.subscribe))
        return I.subscribe(T);
      throw new TypeError("Provided object does not correctly implement Symbol.observable");
    });
  }
  Da.fromInteropObservable = y;
  function S(O) {
    return new o.Observable(function(T) {
      for (var I = 0; I < O.length && !T.closed; I++)
        T.next(O[I]);
      T.complete();
    });
  }
  Da.fromArrayLike = S;
  function x(O) {
    return new o.Observable(function(T) {
      O.then(function(I) {
        T.closed || (T.next(I), T.complete());
      }, function(I) {
        return T.error(I);
      }).then(null, m.reportUnhandledError);
    });
  }
  Da.fromPromise = x;
  function b(O) {
    return new o.Observable(function(T) {
      var I, P;
      try {
        for (var D = n(O), B = D.next(); !B.done; B = D.next()) {
          var L = B.value;
          if (T.next(L), T.closed)
            return;
        }
      } catch (N) {
        I = { error: N };
      } finally {
        try {
          B && !B.done && (P = D.return) && P.call(D);
        } finally {
          if (I) throw I.error;
        }
      }
      T.complete();
    });
  }
  Da.fromIterable = b;
  function _(O) {
    return new o.Observable(function(T) {
      w(O, T).catch(function(I) {
        return T.error(I);
      });
    });
  }
  Da.fromAsyncIterable = _;
  function $(O) {
    return _(d.readableStreamLikeToAsyncGenerator(O));
  }
  Da.fromReadableStreamLike = $;
  function w(O, T) {
    var I, P, D, B;
    return e(this, void 0, void 0, function() {
      var L, N;
      return t(this, function(z) {
        switch (z.label) {
          case 0:
            z.trys.push([0, 5, 6, 11]), I = r(O), z.label = 1;
          case 1:
            return [4, I.next()];
          case 2:
            if (P = z.sent(), !!P.done) return [3, 4];
            if (L = P.value, T.next(L), T.closed)
              return [2];
            z.label = 3;
          case 3:
            return [3, 1];
          case 4:
            return [3, 11];
          case 5:
            return N = z.sent(), D = { error: N }, [3, 11];
          case 6:
            return z.trys.push([6, , 9, 10]), P && !P.done && (B = I.return) ? [4, B.call(I)] : [3, 8];
          case 7:
            z.sent(), z.label = 8;
          case 8:
            return [3, 10];
          case 9:
            if (D) throw D.error;
            return [7];
          case 10:
            return [7];
          case 11:
            return T.complete(), [2];
        }
      });
    });
  }
  return Da;
}
var Jl = {}, OD;
function nr() {
  if (OD) return Jl;
  OD = 1;
  var e = Ue && Ue.__extends || /* @__PURE__ */ function() {
    var a = function(i, o) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, l) {
        s.__proto__ = l;
      } || function(s, l) {
        for (var c in l) Object.prototype.hasOwnProperty.call(l, c) && (s[c] = l[c]);
      }, a(i, o);
    };
    return function(i, o) {
      if (typeof o != "function" && o !== null)
        throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
      a(i, o);
      function s() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (s.prototype = o.prototype, new s());
    };
  }();
  Object.defineProperty(Jl, "__esModule", { value: !0 }), Jl.OperatorSubscriber = Jl.createOperatorSubscriber = void 0;
  var t = DM();
  function r(a, i, o, s, l) {
    return new n(a, i, o, s, l);
  }
  Jl.createOperatorSubscriber = r;
  var n = function(a) {
    e(i, a);
    function i(o, s, l, c, u, d) {
      var f = a.call(this, o) || this;
      return f.onFinalize = u, f.shouldUnsubscribe = d, f._next = s ? function(m) {
        try {
          s(m);
        } catch (h) {
          o.error(h);
        }
      } : a.prototype._next, f._error = c ? function(m) {
        try {
          c(m);
        } catch (h) {
          o.error(h);
        } finally {
          this.unsubscribe();
        }
      } : a.prototype._error, f._complete = l ? function() {
        try {
          l();
        } catch (m) {
          o.error(m);
        } finally {
          this.unsubscribe();
        }
      } : a.prototype._complete, f;
    }
    return i.prototype.unsubscribe = function() {
      var o;
      if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
        var s = this.closed;
        a.prototype.unsubscribe.call(this), !s && ((o = this.onFinalize) === null || o === void 0 || o.call(this));
      }
    }, i;
  }(t.Subscriber);
  return Jl.OperatorSubscriber = n, Jl;
}
var TD;
function vQ() {
  if (TD) return cp;
  TD = 1, Object.defineProperty(cp, "__esModule", { value: !0 }), cp.audit = void 0;
  var e = Yt(), t = qr(), r = nr();
  function n(a) {
    return e.operate(function(i, o) {
      var s = !1, l = null, c = null, u = !1, d = function() {
        if (c?.unsubscribe(), c = null, s) {
          s = !1;
          var m = l;
          l = null, o.next(m);
        }
        u && o.complete();
      }, f = function() {
        c = null, u && o.complete();
      };
      i.subscribe(r.createOperatorSubscriber(o, function(m) {
        s = !0, l = m, c || t.innerFrom(a(m)).subscribe(c = r.createOperatorSubscriber(o, d, f));
      }, function() {
        u = !0, (!s || !c || c.closed) && o.complete();
      }));
    });
  }
  return cp.audit = n, cp;
}
var wp = {}, R_ = {}, Op = {}, Tp = {}, ID;
function L8e() {
  if (ID) return Tp;
  ID = 1;
  var e = Ue && Ue.__extends || /* @__PURE__ */ function() {
    var n = function(a, i) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, s) {
        o.__proto__ = s;
      } || function(o, s) {
        for (var l in s) Object.prototype.hasOwnProperty.call(s, l) && (o[l] = s[l]);
      }, n(a, i);
    };
    return function(a, i) {
      if (typeof i != "function" && i !== null)
        throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
      n(a, i);
      function o() {
        this.constructor = a;
      }
      a.prototype = i === null ? Object.create(i) : (o.prototype = i.prototype, new o());
    };
  }();
  Object.defineProperty(Tp, "__esModule", { value: !0 }), Tp.Action = void 0;
  var t = Xs(), r = function(n) {
    e(a, n);
    function a(i, o) {
      return n.call(this) || this;
    }
    return a.prototype.schedule = function(i, o) {
      return this;
    }, a;
  }(t.Subscription);
  return Tp.Action = r, Tp;
}
var N_ = {}, MD;
function k8e() {
  return MD || (MD = 1, function(e) {
    var t = Ue && Ue.__read || function(n, a) {
      var i = typeof Symbol == "function" && n[Symbol.iterator];
      if (!i) return n;
      var o = i.call(n), s, l = [], c;
      try {
        for (; (a === void 0 || a-- > 0) && !(s = o.next()).done; ) l.push(s.value);
      } catch (u) {
        c = { error: u };
      } finally {
        try {
          s && !s.done && (i = o.return) && i.call(o);
        } finally {
          if (c) throw c.error;
        }
      }
      return l;
    }, r = Ue && Ue.__spreadArray || function(n, a) {
      for (var i = 0, o = a.length, s = n.length; i < o; i++, s++)
        n[s] = a[i];
      return n;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.intervalProvider = void 0, e.intervalProvider = {
      setInterval: function(n, a) {
        for (var i = [], o = 2; o < arguments.length; o++)
          i[o - 2] = arguments[o];
        var s = e.intervalProvider.delegate;
        return s?.setInterval ? s.setInterval.apply(s, r([n, a], t(i))) : setInterval.apply(void 0, r([n, a], t(i)));
      },
      clearInterval: function(n) {
        var a = e.intervalProvider.delegate;
        return (a?.clearInterval || clearInterval)(n);
      },
      delegate: void 0
    };
  }(N_)), N_;
}
var AD;
function F8e() {
  if (AD) return Op;
  AD = 1;
  var e = Ue && Ue.__extends || /* @__PURE__ */ function() {
    var i = function(o, s) {
      return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, c) {
        l.__proto__ = c;
      } || function(l, c) {
        for (var u in c) Object.prototype.hasOwnProperty.call(c, u) && (l[u] = c[u]);
      }, i(o, s);
    };
    return function(o, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      i(o, s);
      function l() {
        this.constructor = o;
      }
      o.prototype = s === null ? Object.create(s) : (l.prototype = s.prototype, new l());
    };
  }();
  Object.defineProperty(Op, "__esModule", { value: !0 }), Op.AsyncAction = void 0;
  var t = L8e(), r = k8e(), n = Ml(), a = function(i) {
    e(o, i);
    function o(s, l) {
      var c = i.call(this, s, l) || this;
      return c.scheduler = s, c.work = l, c.pending = !1, c;
    }
    return o.prototype.schedule = function(s, l) {
      var c;
      if (l === void 0 && (l = 0), this.closed)
        return this;
      this.state = s;
      var u = this.id, d = this.scheduler;
      return u != null && (this.id = this.recycleAsyncId(d, u, l)), this.pending = !0, this.delay = l, this.id = (c = this.id) !== null && c !== void 0 ? c : this.requestAsyncId(d, this.id, l), this;
    }, o.prototype.requestAsyncId = function(s, l, c) {
      return c === void 0 && (c = 0), r.intervalProvider.setInterval(s.flush.bind(s, this), c);
    }, o.prototype.recycleAsyncId = function(s, l, c) {
      if (c === void 0 && (c = 0), c != null && this.delay === c && this.pending === !1)
        return l;
      l != null && r.intervalProvider.clearInterval(l);
    }, o.prototype.execute = function(s, l) {
      if (this.closed)
        return new Error("executing a cancelled action");
      this.pending = !1;
      var c = this._execute(s, l);
      if (c)
        return c;
      this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
    }, o.prototype._execute = function(s, l) {
      var c = !1, u;
      try {
        this.work(s);
      } catch (d) {
        c = !0, u = d || new Error("Scheduled action threw falsy error");
      }
      if (c)
        return this.unsubscribe(), u;
    }, o.prototype.unsubscribe = function() {
      if (!this.closed) {
        var s = this, l = s.id, c = s.scheduler, u = c.actions;
        this.work = this.state = this.scheduler = null, this.pending = !1, n.arrRemove(u, this), l != null && (this.id = this.recycleAsyncId(c, l, null)), this.delay = null, i.prototype.unsubscribe.call(this);
      }
    }, o;
  }(t.Action);
  return Op.AsyncAction = a, Op;
}
var Ip = {}, Mp = {}, D_ = {}, PD;
function FM() {
  return PD || (PD = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.dateTimestampProvider = void 0, e.dateTimestampProvider = {
      now: function() {
        return (e.dateTimestampProvider.delegate || Date).now();
      },
      delegate: void 0
    };
  }(D_)), D_;
}
var RD;
function B8e() {
  if (RD) return Mp;
  RD = 1, Object.defineProperty(Mp, "__esModule", { value: !0 }), Mp.Scheduler = void 0;
  var e = FM(), t = function() {
    function r(n, a) {
      a === void 0 && (a = r.now), this.schedulerActionCtor = n, this.now = a;
    }
    return r.prototype.schedule = function(n, a, i) {
      return a === void 0 && (a = 0), new this.schedulerActionCtor(this, n).schedule(i, a);
    }, r.now = e.dateTimestampProvider.now, r;
  }();
  return Mp.Scheduler = t, Mp;
}
var ND;
function z8e() {
  if (ND) return Ip;
  ND = 1;
  var e = Ue && Ue.__extends || /* @__PURE__ */ function() {
    var n = function(a, i) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, s) {
        o.__proto__ = s;
      } || function(o, s) {
        for (var l in s) Object.prototype.hasOwnProperty.call(s, l) && (o[l] = s[l]);
      }, n(a, i);
    };
    return function(a, i) {
      if (typeof i != "function" && i !== null)
        throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
      n(a, i);
      function o() {
        this.constructor = a;
      }
      a.prototype = i === null ? Object.create(i) : (o.prototype = i.prototype, new o());
    };
  }();
  Object.defineProperty(Ip, "__esModule", { value: !0 }), Ip.AsyncScheduler = void 0;
  var t = B8e(), r = function(n) {
    e(a, n);
    function a(i, o) {
      o === void 0 && (o = t.Scheduler.now);
      var s = n.call(this, i, o) || this;
      return s.actions = [], s._active = !1, s;
    }
    return a.prototype.flush = function(i) {
      var o = this.actions;
      if (this._active) {
        o.push(i);
        return;
      }
      var s;
      this._active = !0;
      do
        if (s = i.execute(i.state, i.delay))
          break;
      while (i = o.shift());
      if (this._active = !1, s) {
        for (; i = o.shift(); )
          i.unsubscribe();
        throw s;
      }
    }, a;
  }(t.Scheduler);
  return Ip.AsyncScheduler = r, Ip;
}
var DD;
function po() {
  return DD || (DD = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.async = e.asyncScheduler = void 0;
    var t = F8e(), r = z8e();
    e.asyncScheduler = new r.AsyncScheduler(t.AsyncAction), e.async = e.asyncScheduler;
  }(R_)), R_;
}
var Ap = {}, Pp = {}, jD;
function hQ() {
  if (jD) return Pp;
  jD = 1, Object.defineProperty(Pp, "__esModule", { value: !0 }), Pp.isScheduler = void 0;
  var e = Pn();
  function t(r) {
    return r && e.isFunction(r.schedule);
  }
  return Pp.isScheduler = t, Pp;
}
var Rp = {}, LD;
function BM() {
  if (LD) return Rp;
  LD = 1, Object.defineProperty(Rp, "__esModule", { value: !0 }), Rp.isValidDate = void 0;
  function e(t) {
    return t instanceof Date && !isNaN(t);
  }
  return Rp.isValidDate = e, Rp;
}
var kD;
function jd() {
  if (kD) return Ap;
  kD = 1, Object.defineProperty(Ap, "__esModule", { value: !0 }), Ap.timer = void 0;
  var e = ci(), t = po(), r = hQ(), n = BM();
  function a(i, o, s) {
    i === void 0 && (i = 0), s === void 0 && (s = t.async);
    var l = -1;
    return o != null && (r.isScheduler(o) ? s = o : l = o), new e.Observable(function(c) {
      var u = n.isValidDate(i) ? +i - s.now() : i;
      u < 0 && (u = 0);
      var d = 0;
      return s.schedule(function() {
        c.closed || (c.next(d++), 0 <= l ? this.schedule(void 0, l) : c.complete());
      }, u);
    });
  }
  return Ap.timer = a, Ap;
}
var FD;
function H8e() {
  if (FD) return wp;
  FD = 1, Object.defineProperty(wp, "__esModule", { value: !0 }), wp.auditTime = void 0;
  var e = po(), t = vQ(), r = jd();
  function n(a, i) {
    return i === void 0 && (i = e.asyncScheduler), t.audit(function() {
      return r.timer(a, i);
    });
  }
  return wp.auditTime = n, wp;
}
var Np = {}, BD;
function V8e() {
  if (BD) return Np;
  BD = 1, Object.defineProperty(Np, "__esModule", { value: !0 }), Np.buffer = void 0;
  var e = Yt(), t = _i(), r = nr(), n = qr();
  function a(i) {
    return e.operate(function(o, s) {
      var l = [];
      return o.subscribe(r.createOperatorSubscriber(s, function(c) {
        return l.push(c);
      }, function() {
        s.next(l), s.complete();
      })), n.innerFrom(i).subscribe(r.createOperatorSubscriber(s, function() {
        var c = l;
        l = [], s.next(c);
      }, t.noop)), function() {
        l = null;
      };
    });
  }
  return Np.buffer = a, Np;
}
var Dp = {}, zD;
function G8e() {
  if (zD) return Dp;
  zD = 1;
  var e = Ue && Ue.__values || function(i) {
    var o = typeof Symbol == "function" && Symbol.iterator, s = o && i[o], l = 0;
    if (s) return s.call(i);
    if (i && typeof i.length == "number") return {
      next: function() {
        return i && l >= i.length && (i = void 0), { value: i && i[l++], done: !i };
      }
    };
    throw new TypeError(o ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(Dp, "__esModule", { value: !0 }), Dp.bufferCount = void 0;
  var t = Yt(), r = nr(), n = Ml();
  function a(i, o) {
    return o === void 0 && (o = null), o = o ?? i, t.operate(function(s, l) {
      var c = [], u = 0;
      s.subscribe(r.createOperatorSubscriber(l, function(d) {
        var f, m, h, g, y = null;
        u++ % o === 0 && c.push([]);
        try {
          for (var S = e(c), x = S.next(); !x.done; x = S.next()) {
            var b = x.value;
            b.push(d), i <= b.length && (y = y ?? [], y.push(b));
          }
        } catch (w) {
          f = { error: w };
        } finally {
          try {
            x && !x.done && (m = S.return) && m.call(S);
          } finally {
            if (f) throw f.error;
          }
        }
        if (y)
          try {
            for (var _ = e(y), $ = _.next(); !$.done; $ = _.next()) {
              var b = $.value;
              n.arrRemove(c, b), l.next(b);
            }
          } catch (w) {
            h = { error: w };
          } finally {
            try {
              $ && !$.done && (g = _.return) && g.call(_);
            } finally {
              if (h) throw h.error;
            }
          }
      }, function() {
        var d, f;
        try {
          for (var m = e(c), h = m.next(); !h.done; h = m.next()) {
            var g = h.value;
            l.next(g);
          }
        } catch (y) {
          d = { error: y };
        } finally {
          try {
            h && !h.done && (f = m.return) && f.call(m);
          } finally {
            if (d) throw d.error;
          }
        }
        l.complete();
      }, void 0, function() {
        c = null;
      }));
    });
  }
  return Dp.bufferCount = a, Dp;
}
var jp = {}, Is = {}, HD;
function Vo() {
  if (HD) return Is;
  HD = 1, Object.defineProperty(Is, "__esModule", { value: !0 }), Is.popNumber = Is.popScheduler = Is.popResultSelector = void 0;
  var e = Pn(), t = hQ();
  function r(o) {
    return o[o.length - 1];
  }
  function n(o) {
    return e.isFunction(r(o)) ? o.pop() : void 0;
  }
  Is.popResultSelector = n;
  function a(o) {
    return t.isScheduler(r(o)) ? o.pop() : void 0;
  }
  Is.popScheduler = a;
  function i(o, s) {
    return typeof r(o) == "number" ? o.pop() : s;
  }
  return Is.popNumber = i, Is;
}
var Lp = {}, VD;
function Al() {
  if (VD) return Lp;
  VD = 1, Object.defineProperty(Lp, "__esModule", { value: !0 }), Lp.executeSchedule = void 0;
  function e(t, r, n, a, i) {
    a === void 0 && (a = 0), i === void 0 && (i = !1);
    var o = r.schedule(function() {
      n(), i ? t.add(this.schedule(null, a)) : this.unsubscribe();
    }, a);
    if (t.add(o), !i)
      return o;
  }
  return Lp.executeSchedule = e, Lp;
}
var GD;
function U8e() {
  if (GD) return jp;
  GD = 1;
  var e = Ue && Ue.__values || function(c) {
    var u = typeof Symbol == "function" && Symbol.iterator, d = u && c[u], f = 0;
    if (d) return d.call(c);
    if (c && typeof c.length == "number") return {
      next: function() {
        return c && f >= c.length && (c = void 0), { value: c && c[f++], done: !c };
      }
    };
    throw new TypeError(u ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(jp, "__esModule", { value: !0 }), jp.bufferTime = void 0;
  var t = Xs(), r = Yt(), n = nr(), a = Ml(), i = po(), o = Vo(), s = Al();
  function l(c) {
    for (var u, d, f = [], m = 1; m < arguments.length; m++)
      f[m - 1] = arguments[m];
    var h = (u = o.popScheduler(f)) !== null && u !== void 0 ? u : i.asyncScheduler, g = (d = f[0]) !== null && d !== void 0 ? d : null, y = f[1] || 1 / 0;
    return r.operate(function(S, x) {
      var b = [], _ = !1, $ = function(T) {
        var I = T.buffer, P = T.subs;
        P.unsubscribe(), a.arrRemove(b, T), x.next(I), _ && w();
      }, w = function() {
        if (b) {
          var T = new t.Subscription();
          x.add(T);
          var I = [], P = {
            buffer: I,
            subs: T
          };
          b.push(P), s.executeSchedule(T, h, function() {
            return $(P);
          }, c);
        }
      };
      g !== null && g >= 0 ? s.executeSchedule(x, h, w, g, !0) : _ = !0, w();
      var O = n.createOperatorSubscriber(x, function(T) {
        var I, P, D = b.slice();
        try {
          for (var B = e(D), L = B.next(); !L.done; L = B.next()) {
            var N = L.value, z = N.buffer;
            z.push(T), y <= z.length && $(N);
          }
        } catch (F) {
          I = { error: F };
        } finally {
          try {
            L && !L.done && (P = B.return) && P.call(B);
          } finally {
            if (I) throw I.error;
          }
        }
      }, function() {
        for (; b?.length; )
          x.next(b.shift().buffer);
        O?.unsubscribe(), x.complete(), x.unsubscribe();
      }, void 0, function() {
        return b = null;
      });
      S.subscribe(O);
    });
  }
  return jp.bufferTime = l, jp;
}
var kp = {}, UD;
function W8e() {
  if (UD) return kp;
  UD = 1;
  var e = Ue && Ue.__values || function(l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = c && l[c], d = 0;
    if (u) return u.call(l);
    if (l && typeof l.length == "number") return {
      next: function() {
        return l && d >= l.length && (l = void 0), { value: l && l[d++], done: !l };
      }
    };
    throw new TypeError(c ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(kp, "__esModule", { value: !0 }), kp.bufferToggle = void 0;
  var t = Xs(), r = Yt(), n = qr(), a = nr(), i = _i(), o = Ml();
  function s(l, c) {
    return r.operate(function(u, d) {
      var f = [];
      n.innerFrom(l).subscribe(a.createOperatorSubscriber(d, function(m) {
        var h = [];
        f.push(h);
        var g = new t.Subscription(), y = function() {
          o.arrRemove(f, h), d.next(h), g.unsubscribe();
        };
        g.add(n.innerFrom(c(m)).subscribe(a.createOperatorSubscriber(d, y, i.noop)));
      }, i.noop)), u.subscribe(a.createOperatorSubscriber(d, function(m) {
        var h, g;
        try {
          for (var y = e(f), S = y.next(); !S.done; S = y.next()) {
            var x = S.value;
            x.push(m);
          }
        } catch (b) {
          h = { error: b };
        } finally {
          try {
            S && !S.done && (g = y.return) && g.call(y);
          } finally {
            if (h) throw h.error;
          }
        }
      }, function() {
        for (; f.length > 0; )
          d.next(f.shift());
        d.complete();
      }));
    });
  }
  return kp.bufferToggle = s, kp;
}
var Fp = {}, WD;
function q8e() {
  if (WD) return Fp;
  WD = 1, Object.defineProperty(Fp, "__esModule", { value: !0 }), Fp.bufferWhen = void 0;
  var e = Yt(), t = _i(), r = nr(), n = qr();
  function a(i) {
    return e.operate(function(o, s) {
      var l = null, c = null, u = function() {
        c?.unsubscribe();
        var d = l;
        l = [], d && s.next(d), n.innerFrom(i()).subscribe(c = r.createOperatorSubscriber(s, u, t.noop));
      };
      u(), o.subscribe(r.createOperatorSubscriber(s, function(d) {
        return l?.push(d);
      }, function() {
        l && s.next(l), s.complete();
      }, void 0, function() {
        return l = c = null;
      }));
    });
  }
  return Fp.bufferWhen = a, Fp;
}
var Bp = {}, qD;
function K8e() {
  if (qD) return Bp;
  qD = 1, Object.defineProperty(Bp, "__esModule", { value: !0 }), Bp.catchError = void 0;
  var e = qr(), t = nr(), r = Yt();
  function n(a) {
    return r.operate(function(i, o) {
      var s = null, l = !1, c;
      s = i.subscribe(t.createOperatorSubscriber(o, void 0, void 0, function(u) {
        c = e.innerFrom(a(u, n(a)(i))), s ? (s.unsubscribe(), s = null, c.subscribe(o)) : l = !0;
      })), l && (s.unsubscribe(), s = null, c.subscribe(o));
    });
  }
  return Bp.catchError = n, Bp;
}
var zp = {}, Hp = {}, Ql = {}, Vp = {}, KD;
function Y8e() {
  if (KD) return Vp;
  KD = 1, Object.defineProperty(Vp, "__esModule", { value: !0 }), Vp.argsArgArrayOrObject = void 0;
  var e = Array.isArray, t = Object.getPrototypeOf, r = Object.prototype, n = Object.keys;
  function a(o) {
    if (o.length === 1) {
      var s = o[0];
      if (e(s))
        return { args: s, keys: null };
      if (i(s)) {
        var l = n(s);
        return {
          args: l.map(function(c) {
            return s[c];
          }),
          keys: l
        };
      }
    }
    return { args: o, keys: null };
  }
  Vp.argsArgArrayOrObject = a;
  function i(o) {
    return o && typeof o == "object" && t(o) === r;
  }
  return Vp;
}
var Gp = {}, Up = {}, Wp = {}, qp = {}, YD;
function zM() {
  if (YD) return qp;
  YD = 1, Object.defineProperty(qp, "__esModule", { value: !0 }), qp.observeOn = void 0;
  var e = Al(), t = Yt(), r = nr();
  function n(a, i) {
    return i === void 0 && (i = 0), t.operate(function(o, s) {
      o.subscribe(r.createOperatorSubscriber(s, function(l) {
        return e.executeSchedule(s, a, function() {
          return s.next(l);
        }, i);
      }, function() {
        return e.executeSchedule(s, a, function() {
          return s.complete();
        }, i);
      }, function(l) {
        return e.executeSchedule(s, a, function() {
          return s.error(l);
        }, i);
      }));
    });
  }
  return qp.observeOn = n, qp;
}
var Kp = {}, ZD;
function HM() {
  if (ZD) return Kp;
  ZD = 1, Object.defineProperty(Kp, "__esModule", { value: !0 }), Kp.subscribeOn = void 0;
  var e = Yt();
  function t(r, n) {
    return n === void 0 && (n = 0), e.operate(function(a, i) {
      i.add(r.schedule(function() {
        return a.subscribe(i);
      }, n));
    });
  }
  return Kp.subscribeOn = t, Kp;
}
var XD;
function Z8e() {
  if (XD) return Wp;
  XD = 1, Object.defineProperty(Wp, "__esModule", { value: !0 }), Wp.scheduleObservable = void 0;
  var e = qr(), t = zM(), r = HM();
  function n(a, i) {
    return e.innerFrom(a).pipe(r.subscribeOn(i), t.observeOn(i));
  }
  return Wp.scheduleObservable = n, Wp;
}
var Yp = {}, JD;
function X8e() {
  if (JD) return Yp;
  JD = 1, Object.defineProperty(Yp, "__esModule", { value: !0 }), Yp.schedulePromise = void 0;
  var e = qr(), t = zM(), r = HM();
  function n(a, i) {
    return e.innerFrom(a).pipe(r.subscribeOn(i), t.observeOn(i));
  }
  return Yp.schedulePromise = n, Yp;
}
var Zp = {}, QD;
function J8e() {
  if (QD) return Zp;
  QD = 1, Object.defineProperty(Zp, "__esModule", { value: !0 }), Zp.scheduleArray = void 0;
  var e = ci();
  function t(r, n) {
    return new e.Observable(function(a) {
      var i = 0;
      return n.schedule(function() {
        i === r.length ? a.complete() : (a.next(r[i++]), a.closed || this.schedule());
      });
    });
  }
  return Zp.scheduleArray = t, Zp;
}
var Xp = {}, ej;
function Q8e() {
  if (ej) return Xp;
  ej = 1, Object.defineProperty(Xp, "__esModule", { value: !0 }), Xp.scheduleIterable = void 0;
  var e = ci(), t = pQ(), r = Pn(), n = Al();
  function a(i, o) {
    return new e.Observable(function(s) {
      var l;
      return n.executeSchedule(s, o, function() {
        l = i[t.iterator](), n.executeSchedule(s, o, function() {
          var c, u, d;
          try {
            c = l.next(), u = c.value, d = c.done;
          } catch (f) {
            s.error(f);
            return;
          }
          d ? s.complete() : s.next(u);
        }, 0, !0);
      }), function() {
        return r.isFunction(l?.return) && l.return();
      };
    });
  }
  return Xp.scheduleIterable = a, Xp;
}
var Jp = {}, tj;
function gQ() {
  if (tj) return Jp;
  tj = 1, Object.defineProperty(Jp, "__esModule", { value: !0 }), Jp.scheduleAsyncIterable = void 0;
  var e = ci(), t = Al();
  function r(n, a) {
    if (!n)
      throw new Error("Iterable cannot be null");
    return new e.Observable(function(i) {
      t.executeSchedule(i, a, function() {
        var o = n[Symbol.asyncIterator]();
        t.executeSchedule(i, a, function() {
          o.next().then(function(s) {
            s.done ? i.complete() : i.next(s.value);
          });
        }, 0, !0);
      });
    });
  }
  return Jp.scheduleAsyncIterable = r, Jp;
}
var Qp = {}, rj;
function e5e() {
  if (rj) return Qp;
  rj = 1, Object.defineProperty(Qp, "__esModule", { value: !0 }), Qp.scheduleReadableStreamLike = void 0;
  var e = gQ(), t = kM();
  function r(n, a) {
    return e.scheduleAsyncIterable(t.readableStreamLikeToAsyncGenerator(n), a);
  }
  return Qp.scheduleReadableStreamLike = r, Qp;
}
var nj;
function t5e() {
  if (nj) return Up;
  nj = 1, Object.defineProperty(Up, "__esModule", { value: !0 }), Up.scheduled = void 0;
  var e = Z8e(), t = X8e(), r = J8e(), n = Q8e(), a = gQ(), i = uQ(), o = sQ(), s = oQ(), l = mQ(), c = dQ(), u = fQ(), d = kM(), f = e5e();
  function m(h, g) {
    if (h != null) {
      if (i.isInteropObservable(h))
        return e.scheduleObservable(h, g);
      if (s.isArrayLike(h))
        return r.scheduleArray(h, g);
      if (o.isPromise(h))
        return t.schedulePromise(h, g);
      if (c.isAsyncIterable(h))
        return a.scheduleAsyncIterable(h, g);
      if (l.isIterable(h))
        return n.scheduleIterable(h, g);
      if (d.isReadableStreamLike(h))
        return f.scheduleReadableStreamLike(h, g);
    }
    throw u.createInvalidObservableTypeError(h);
  }
  return Up.scheduled = m, Up;
}
var aj;
function Hh() {
  if (aj) return Gp;
  aj = 1, Object.defineProperty(Gp, "__esModule", { value: !0 }), Gp.from = void 0;
  var e = t5e(), t = qr();
  function r(n, a) {
    return a ? e.scheduled(n, a) : t.innerFrom(n);
  }
  return Gp.from = r, Gp;
}
var em = {}, tm = {}, ij;
function Wc() {
  if (ij) return tm;
  ij = 1, Object.defineProperty(tm, "__esModule", { value: !0 }), tm.map = void 0;
  var e = Yt(), t = nr();
  function r(n, a) {
    return e.operate(function(i, o) {
      var s = 0;
      i.subscribe(t.createOperatorSubscriber(o, function(l) {
        o.next(n.call(a, l, s++));
      }));
    });
  }
  return tm.map = r, tm;
}
var oj;
function VM() {
  if (oj) return em;
  oj = 1;
  var e = Ue && Ue.__read || function(o, s) {
    var l = typeof Symbol == "function" && o[Symbol.iterator];
    if (!l) return o;
    var c = l.call(o), u, d = [], f;
    try {
      for (; (s === void 0 || s-- > 0) && !(u = c.next()).done; ) d.push(u.value);
    } catch (m) {
      f = { error: m };
    } finally {
      try {
        u && !u.done && (l = c.return) && l.call(c);
      } finally {
        if (f) throw f.error;
      }
    }
    return d;
  }, t = Ue && Ue.__spreadArray || function(o, s) {
    for (var l = 0, c = s.length, u = o.length; l < c; l++, u++)
      o[u] = s[l];
    return o;
  };
  Object.defineProperty(em, "__esModule", { value: !0 }), em.mapOneOrManyArgs = void 0;
  var r = Wc(), n = Array.isArray;
  function a(o, s) {
    return n(s) ? o.apply(void 0, t([], e(s))) : o(s);
  }
  function i(o) {
    return r.map(function(s) {
      return a(o, s);
    });
  }
  return em.mapOneOrManyArgs = i, em;
}
var rm = {}, sj;
function r5e() {
  if (sj) return rm;
  sj = 1, Object.defineProperty(rm, "__esModule", { value: !0 }), rm.createObject = void 0;
  function e(t, r) {
    return t.reduce(function(n, a, i) {
      return n[a] = r[i], n;
    }, {});
  }
  return rm.createObject = e, rm;
}
var lj;
function yQ() {
  if (lj) return Ql;
  lj = 1, Object.defineProperty(Ql, "__esModule", { value: !0 }), Ql.combineLatestInit = Ql.combineLatest = void 0;
  var e = ci(), t = Y8e(), r = Hh(), n = Ei(), a = VM(), i = Vo(), o = r5e(), s = nr(), l = Al();
  function c() {
    for (var f = [], m = 0; m < arguments.length; m++)
      f[m] = arguments[m];
    var h = i.popScheduler(f), g = i.popResultSelector(f), y = t.argsArgArrayOrObject(f), S = y.args, x = y.keys;
    if (S.length === 0)
      return r.from([], h);
    var b = new e.Observable(u(S, h, x ? function(_) {
      return o.createObject(x, _);
    } : n.identity));
    return g ? b.pipe(a.mapOneOrManyArgs(g)) : b;
  }
  Ql.combineLatest = c;
  function u(f, m, h) {
    return h === void 0 && (h = n.identity), function(g) {
      d(m, function() {
        for (var y = f.length, S = new Array(y), x = y, b = y, _ = function(w) {
          d(m, function() {
            var O = r.from(f[w], m), T = !1;
            O.subscribe(s.createOperatorSubscriber(g, function(I) {
              S[w] = I, T || (T = !0, b--), b || g.next(h(S.slice()));
            }, function() {
              --x || g.complete();
            }));
          }, g);
        }, $ = 0; $ < y; $++)
          _($);
      }, g);
    };
  }
  Ql.combineLatestInit = u;
  function d(f, m, h) {
    f ? l.executeSchedule(h, f, m) : m();
  }
  return Ql;
}
var nm = {}, am = {}, im = {}, cj;
function GM() {
  if (cj) return im;
  cj = 1, Object.defineProperty(im, "__esModule", { value: !0 }), im.mergeInternals = void 0;
  var e = qr(), t = Al(), r = nr();
  function n(a, i, o, s, l, c, u, d) {
    var f = [], m = 0, h = 0, g = !1, y = function() {
      g && !f.length && !m && i.complete();
    }, S = function(b) {
      return m < s ? x(b) : f.push(b);
    }, x = function(b) {
      c && i.next(b), m++;
      var _ = !1;
      e.innerFrom(o(b, h++)).subscribe(r.createOperatorSubscriber(i, function($) {
        l?.($), c ? S($) : i.next($);
      }, function() {
        _ = !0;
      }, void 0, function() {
        if (_)
          try {
            m--;
            for (var $ = function() {
              var w = f.shift();
              u ? t.executeSchedule(i, u, function() {
                return x(w);
              }) : x(w);
            }; f.length && m < s; )
              $();
            y();
          } catch (w) {
            i.error(w);
          }
      }));
    };
    return a.subscribe(r.createOperatorSubscriber(i, S, function() {
      g = !0, y();
    })), function() {
      d?.();
    };
  }
  return im.mergeInternals = n, im;
}
var uj;
function qc() {
  if (uj) return am;
  uj = 1, Object.defineProperty(am, "__esModule", { value: !0 }), am.mergeMap = void 0;
  var e = Wc(), t = qr(), r = Yt(), n = GM(), a = Pn();
  function i(o, s, l) {
    return l === void 0 && (l = 1 / 0), a.isFunction(s) ? i(function(c, u) {
      return e.map(function(d, f) {
        return s(c, d, u, f);
      })(t.innerFrom(o(c, u)));
    }, l) : (typeof s == "number" && (l = s), r.operate(function(c, u) {
      return n.mergeInternals(c, u, o, l);
    }));
  }
  return am.mergeMap = i, am;
}
var om = {}, sm = {}, lm = {}, dj;
function bQ() {
  if (dj) return lm;
  dj = 1, Object.defineProperty(lm, "__esModule", { value: !0 }), lm.scanInternals = void 0;
  var e = nr();
  function t(r, n, a, i, o) {
    return function(s, l) {
      var c = a, u = n, d = 0;
      s.subscribe(e.createOperatorSubscriber(l, function(f) {
        var m = d++;
        u = c ? r(u, f, m) : (c = !0, f), i && l.next(u);
      }, o && function() {
        c && l.next(u), l.complete();
      }));
    };
  }
  return lm.scanInternals = t, lm;
}
var fj;
function Vh() {
  if (fj) return sm;
  fj = 1, Object.defineProperty(sm, "__esModule", { value: !0 }), sm.reduce = void 0;
  var e = bQ(), t = Yt();
  function r(n, a) {
    return t.operate(e.scanInternals(n, a, arguments.length >= 2, !1, !0));
  }
  return sm.reduce = r, sm;
}
var pj;
function CQ() {
  if (pj) return om;
  pj = 1, Object.defineProperty(om, "__esModule", { value: !0 }), om.toArray = void 0;
  var e = Vh(), t = Yt(), r = function(a, i) {
    return a.push(i), a;
  };
  function n() {
    return t.operate(function(a, i) {
      e.reduce(r, [])(a).subscribe(i);
    });
  }
  return om.toArray = n, om;
}
var mj;
function SQ() {
  if (mj) return nm;
  mj = 1, Object.defineProperty(nm, "__esModule", { value: !0 }), nm.joinAllInternals = void 0;
  var e = Ei(), t = VM(), r = LM(), n = qc(), a = CQ();
  function i(o, s) {
    return r.pipe(a.toArray(), n.mergeMap(function(l) {
      return o(l);
    }), s ? t.mapOneOrManyArgs(s) : e.identity);
  }
  return nm.joinAllInternals = i, nm;
}
var vj;
function xQ() {
  if (vj) return Hp;
  vj = 1, Object.defineProperty(Hp, "__esModule", { value: !0 }), Hp.combineLatestAll = void 0;
  var e = yQ(), t = SQ();
  function r(n) {
    return t.joinAllInternals(e.combineLatest, n);
  }
  return Hp.combineLatestAll = r, Hp;
}
var hj;
function n5e() {
  if (hj) return zp;
  hj = 1, Object.defineProperty(zp, "__esModule", { value: !0 }), zp.combineAll = void 0;
  var e = xQ();
  return zp.combineAll = e.combineLatestAll, zp;
}
var cm = {}, um = {}, gj;
function Kc() {
  if (gj) return um;
  gj = 1, Object.defineProperty(um, "__esModule", { value: !0 }), um.argsOrArgArray = void 0;
  var e = Array.isArray;
  function t(r) {
    return r.length === 1 && e(r[0]) ? r[0] : r;
  }
  return um.argsOrArgArray = t, um;
}
var yj;
function $Q() {
  if (yj) return cm;
  yj = 1;
  var e = Ue && Ue.__read || function(c, u) {
    var d = typeof Symbol == "function" && c[Symbol.iterator];
    if (!d) return c;
    var f = d.call(c), m, h = [], g;
    try {
      for (; (u === void 0 || u-- > 0) && !(m = f.next()).done; ) h.push(m.value);
    } catch (y) {
      g = { error: y };
    } finally {
      try {
        m && !m.done && (d = f.return) && d.call(f);
      } finally {
        if (g) throw g.error;
      }
    }
    return h;
  }, t = Ue && Ue.__spreadArray || function(c, u) {
    for (var d = 0, f = u.length, m = c.length; d < f; d++, m++)
      c[m] = u[d];
    return c;
  };
  Object.defineProperty(cm, "__esModule", { value: !0 }), cm.combineLatest = void 0;
  var r = yQ(), n = Yt(), a = Kc(), i = VM(), o = LM(), s = Vo();
  function l() {
    for (var c = [], u = 0; u < arguments.length; u++)
      c[u] = arguments[u];
    var d = s.popResultSelector(c);
    return d ? o.pipe(l.apply(void 0, t([], e(c))), i.mapOneOrManyArgs(d)) : n.operate(function(f, m) {
      r.combineLatestInit(t([f], e(a.argsOrArgArray(c))))(m);
    });
  }
  return cm.combineLatest = l, cm;
}
var dm = {}, bj;
function a5e() {
  if (bj) return dm;
  bj = 1;
  var e = Ue && Ue.__read || function(a, i) {
    var o = typeof Symbol == "function" && a[Symbol.iterator];
    if (!o) return a;
    var s = o.call(a), l, c = [], u;
    try {
      for (; (i === void 0 || i-- > 0) && !(l = s.next()).done; ) c.push(l.value);
    } catch (d) {
      u = { error: d };
    } finally {
      try {
        l && !l.done && (o = s.return) && o.call(s);
      } finally {
        if (u) throw u.error;
      }
    }
    return c;
  }, t = Ue && Ue.__spreadArray || function(a, i) {
    for (var o = 0, s = i.length, l = a.length; o < s; o++, l++)
      a[l] = i[o];
    return a;
  };
  Object.defineProperty(dm, "__esModule", { value: !0 }), dm.combineLatestWith = void 0;
  var r = $Q();
  function n() {
    for (var a = [], i = 0; i < arguments.length; i++)
      a[i] = arguments[i];
    return r.combineLatest.apply(void 0, t([], e(a)));
  }
  return dm.combineLatestWith = n, dm;
}
var fm = {}, pm = {}, mm = {}, Cj;
function UM() {
  if (Cj) return mm;
  Cj = 1, Object.defineProperty(mm, "__esModule", { value: !0 }), mm.mergeAll = void 0;
  var e = qc(), t = Ei();
  function r(n) {
    return n === void 0 && (n = 1 / 0), e.mergeMap(t.identity, n);
  }
  return mm.mergeAll = r, mm;
}
var Sj;
function WM() {
  if (Sj) return pm;
  Sj = 1, Object.defineProperty(pm, "__esModule", { value: !0 }), pm.concatAll = void 0;
  var e = UM();
  function t() {
    return e.mergeAll(1);
  }
  return pm.concatAll = t, pm;
}
var xj;
function _Q() {
  if (xj) return fm;
  xj = 1;
  var e = Ue && Ue.__read || function(s, l) {
    var c = typeof Symbol == "function" && s[Symbol.iterator];
    if (!c) return s;
    var u = c.call(s), d, f = [], m;
    try {
      for (; (l === void 0 || l-- > 0) && !(d = u.next()).done; ) f.push(d.value);
    } catch (h) {
      m = { error: h };
    } finally {
      try {
        d && !d.done && (c = u.return) && c.call(u);
      } finally {
        if (m) throw m.error;
      }
    }
    return f;
  }, t = Ue && Ue.__spreadArray || function(s, l) {
    for (var c = 0, u = l.length, d = s.length; c < u; c++, d++)
      s[d] = l[c];
    return s;
  };
  Object.defineProperty(fm, "__esModule", { value: !0 }), fm.concat = void 0;
  var r = Yt(), n = WM(), a = Vo(), i = Hh();
  function o() {
    for (var s = [], l = 0; l < arguments.length; l++)
      s[l] = arguments[l];
    var c = a.popScheduler(s);
    return r.operate(function(u, d) {
      n.concatAll()(i.from(t([u], e(s)), c)).subscribe(d);
    });
  }
  return fm.concat = o, fm;
}
var vm = {}, $j;
function EQ() {
  if ($j) return vm;
  $j = 1, Object.defineProperty(vm, "__esModule", { value: !0 }), vm.concatMap = void 0;
  var e = qc(), t = Pn();
  function r(n, a) {
    return t.isFunction(a) ? e.mergeMap(n, a, 1) : e.mergeMap(n, 1);
  }
  return vm.concatMap = r, vm;
}
var hm = {}, _j;
function i5e() {
  if (_j) return hm;
  _j = 1, Object.defineProperty(hm, "__esModule", { value: !0 }), hm.concatMapTo = void 0;
  var e = EQ(), t = Pn();
  function r(n, a) {
    return t.isFunction(a) ? e.concatMap(function() {
      return n;
    }, a) : e.concatMap(function() {
      return n;
    });
  }
  return hm.concatMapTo = r, hm;
}
var gm = {}, Ej;
function o5e() {
  if (Ej) return gm;
  Ej = 1;
  var e = Ue && Ue.__read || function(a, i) {
    var o = typeof Symbol == "function" && a[Symbol.iterator];
    if (!o) return a;
    var s = o.call(a), l, c = [], u;
    try {
      for (; (i === void 0 || i-- > 0) && !(l = s.next()).done; ) c.push(l.value);
    } catch (d) {
      u = { error: d };
    } finally {
      try {
        l && !l.done && (o = s.return) && o.call(s);
      } finally {
        if (u) throw u.error;
      }
    }
    return c;
  }, t = Ue && Ue.__spreadArray || function(a, i) {
    for (var o = 0, s = i.length, l = a.length; o < s; o++, l++)
      a[l] = i[o];
    return a;
  };
  Object.defineProperty(gm, "__esModule", { value: !0 }), gm.concatWith = void 0;
  var r = _Q();
  function n() {
    for (var a = [], i = 0; i < arguments.length; i++)
      a[i] = arguments[i];
    return r.concat.apply(void 0, t([], e(a)));
  }
  return gm.concatWith = n, gm;
}
var ym = {}, ec = {}, bm = {}, wj;
function s5e() {
  if (wj) return bm;
  wj = 1, Object.defineProperty(bm, "__esModule", { value: !0 }), bm.ObjectUnsubscribedError = void 0;
  var e = Uc();
  return bm.ObjectUnsubscribedError = e.createErrorClass(function(t) {
    return function() {
      t(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
    };
  }), bm;
}
var Oj;
function wi() {
  if (Oj) return ec;
  Oj = 1;
  var e = Ue && Ue.__extends || /* @__PURE__ */ function() {
    var c = function(u, d) {
      return c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, m) {
        f.__proto__ = m;
      } || function(f, m) {
        for (var h in m) Object.prototype.hasOwnProperty.call(m, h) && (f[h] = m[h]);
      }, c(u, d);
    };
    return function(u, d) {
      if (typeof d != "function" && d !== null)
        throw new TypeError("Class extends value " + String(d) + " is not a constructor or null");
      c(u, d);
      function f() {
        this.constructor = u;
      }
      u.prototype = d === null ? Object.create(d) : (f.prototype = d.prototype, new f());
    };
  }(), t = Ue && Ue.__values || function(c) {
    var u = typeof Symbol == "function" && Symbol.iterator, d = u && c[u], f = 0;
    if (d) return d.call(c);
    if (c && typeof c.length == "number") return {
      next: function() {
        return c && f >= c.length && (c = void 0), { value: c && c[f++], done: !c };
      }
    };
    throw new TypeError(u ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(ec, "__esModule", { value: !0 }), ec.AnonymousSubject = ec.Subject = void 0;
  var r = ci(), n = Xs(), a = s5e(), i = Ml(), o = NM(), s = function(c) {
    e(u, c);
    function u() {
      var d = c.call(this) || this;
      return d.closed = !1, d.currentObservers = null, d.observers = [], d.isStopped = !1, d.hasError = !1, d.thrownError = null, d;
    }
    return u.prototype.lift = function(d) {
      var f = new l(this, this);
      return f.operator = d, f;
    }, u.prototype._throwIfClosed = function() {
      if (this.closed)
        throw new a.ObjectUnsubscribedError();
    }, u.prototype.next = function(d) {
      var f = this;
      o.errorContext(function() {
        var m, h;
        if (f._throwIfClosed(), !f.isStopped) {
          f.currentObservers || (f.currentObservers = Array.from(f.observers));
          try {
            for (var g = t(f.currentObservers), y = g.next(); !y.done; y = g.next()) {
              var S = y.value;
              S.next(d);
            }
          } catch (x) {
            m = { error: x };
          } finally {
            try {
              y && !y.done && (h = g.return) && h.call(g);
            } finally {
              if (m) throw m.error;
            }
          }
        }
      });
    }, u.prototype.error = function(d) {
      var f = this;
      o.errorContext(function() {
        if (f._throwIfClosed(), !f.isStopped) {
          f.hasError = f.isStopped = !0, f.thrownError = d;
          for (var m = f.observers; m.length; )
            m.shift().error(d);
        }
      });
    }, u.prototype.complete = function() {
      var d = this;
      o.errorContext(function() {
        if (d._throwIfClosed(), !d.isStopped) {
          d.isStopped = !0;
          for (var f = d.observers; f.length; )
            f.shift().complete();
        }
      });
    }, u.prototype.unsubscribe = function() {
      this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
    }, Object.defineProperty(u.prototype, "observed", {
      get: function() {
        var d;
        return ((d = this.observers) === null || d === void 0 ? void 0 : d.length) > 0;
      },
      enumerable: !1,
      configurable: !0
    }), u.prototype._trySubscribe = function(d) {
      return this._throwIfClosed(), c.prototype._trySubscribe.call(this, d);
    }, u.prototype._subscribe = function(d) {
      return this._throwIfClosed(), this._checkFinalizedStatuses(d), this._innerSubscribe(d);
    }, u.prototype._innerSubscribe = function(d) {
      var f = this, m = this, h = m.hasError, g = m.isStopped, y = m.observers;
      return h || g ? n.EMPTY_SUBSCRIPTION : (this.currentObservers = null, y.push(d), new n.Subscription(function() {
        f.currentObservers = null, i.arrRemove(y, d);
      }));
    }, u.prototype._checkFinalizedStatuses = function(d) {
      var f = this, m = f.hasError, h = f.thrownError, g = f.isStopped;
      m ? d.error(h) : g && d.complete();
    }, u.prototype.asObservable = function() {
      var d = new r.Observable();
      return d.source = this, d;
    }, u.create = function(d, f) {
      return new l(d, f);
    }, u;
  }(r.Observable);
  ec.Subject = s;
  var l = function(c) {
    e(u, c);
    function u(d, f) {
      var m = c.call(this) || this;
      return m.destination = d, m.source = f, m;
    }
    return u.prototype.next = function(d) {
      var f, m;
      (m = (f = this.destination) === null || f === void 0 ? void 0 : f.next) === null || m === void 0 || m.call(f, d);
    }, u.prototype.error = function(d) {
      var f, m;
      (m = (f = this.destination) === null || f === void 0 ? void 0 : f.error) === null || m === void 0 || m.call(f, d);
    }, u.prototype.complete = function() {
      var d, f;
      (f = (d = this.destination) === null || d === void 0 ? void 0 : d.complete) === null || f === void 0 || f.call(d);
    }, u.prototype._subscribe = function(d) {
      var f, m;
      return (m = (f = this.source) === null || f === void 0 ? void 0 : f.subscribe(d)) !== null && m !== void 0 ? m : n.EMPTY_SUBSCRIPTION;
    }, u;
  }(s);
  return ec.AnonymousSubject = l, ec;
}
var Cm = {}, Tj;
function l5e() {
  if (Tj) return Cm;
  Tj = 1, Object.defineProperty(Cm, "__esModule", { value: !0 }), Cm.fromSubscribable = void 0;
  var e = ci();
  function t(r) {
    return new e.Observable(function(n) {
      return r.subscribe(n);
    });
  }
  return Cm.fromSubscribable = t, Cm;
}
var Ij;
function qM() {
  if (Ij) return ym;
  Ij = 1, Object.defineProperty(ym, "__esModule", { value: !0 }), ym.connect = void 0;
  var e = wi(), t = qr(), r = Yt(), n = l5e(), a = {
    connector: function() {
      return new e.Subject();
    }
  };
  function i(o, s) {
    s === void 0 && (s = a);
    var l = s.connector;
    return r.operate(function(c, u) {
      var d = l();
      t.innerFrom(o(n.fromSubscribable(d))).subscribe(u), u.add(c.subscribe(d));
    });
  }
  return ym.connect = i, ym;
}
var Sm = {}, Mj;
function c5e() {
  if (Mj) return Sm;
  Mj = 1, Object.defineProperty(Sm, "__esModule", { value: !0 }), Sm.count = void 0;
  var e = Vh();
  function t(r) {
    return e.reduce(function(n, a, i) {
      return !r || r(a, i) ? n + 1 : n;
    }, 0);
  }
  return Sm.count = t, Sm;
}
var xm = {}, Aj;
function u5e() {
  if (Aj) return xm;
  Aj = 1, Object.defineProperty(xm, "__esModule", { value: !0 }), xm.debounce = void 0;
  var e = Yt(), t = _i(), r = nr(), n = qr();
  function a(i) {
    return e.operate(function(o, s) {
      var l = !1, c = null, u = null, d = function() {
        if (u?.unsubscribe(), u = null, l) {
          l = !1;
          var f = c;
          c = null, s.next(f);
        }
      };
      o.subscribe(r.createOperatorSubscriber(s, function(f) {
        u?.unsubscribe(), l = !0, c = f, u = r.createOperatorSubscriber(s, d, t.noop), n.innerFrom(i(f)).subscribe(u);
      }, function() {
        d(), s.complete();
      }, void 0, function() {
        c = u = null;
      }));
    });
  }
  return xm.debounce = a, xm;
}
var $m = {}, Pj;
function d5e() {
  if (Pj) return $m;
  Pj = 1, Object.defineProperty($m, "__esModule", { value: !0 }), $m.debounceTime = void 0;
  var e = po(), t = Yt(), r = nr();
  function n(a, i) {
    return i === void 0 && (i = e.asyncScheduler), t.operate(function(o, s) {
      var l = null, c = null, u = null, d = function() {
        if (l) {
          l.unsubscribe(), l = null;
          var m = c;
          c = null, s.next(m);
        }
      };
      function f() {
        var m = u + a, h = i.now();
        if (h < m) {
          l = this.schedule(void 0, m - h), s.add(l);
          return;
        }
        d();
      }
      o.subscribe(r.createOperatorSubscriber(s, function(m) {
        c = m, u = i.now(), l || (l = i.schedule(f, a), s.add(l));
      }, function() {
        d(), s.complete();
      }, void 0, function() {
        c = l = null;
      }));
    });
  }
  return $m.debounceTime = n, $m;
}
var _m = {}, Rj;
function mC() {
  if (Rj) return _m;
  Rj = 1, Object.defineProperty(_m, "__esModule", { value: !0 }), _m.defaultIfEmpty = void 0;
  var e = Yt(), t = nr();
  function r(n) {
    return e.operate(function(a, i) {
      var o = !1;
      a.subscribe(t.createOperatorSubscriber(i, function(s) {
        o = !0, i.next(s);
      }, function() {
        o || i.next(n), i.complete();
      }));
    });
  }
  return _m.defaultIfEmpty = r, _m;
}
var Em = {}, wm = {}, Om = {}, Nj;
function KM() {
  if (Nj) return Om;
  Nj = 1, Object.defineProperty(Om, "__esModule", { value: !0 }), Om.concat = void 0;
  var e = WM(), t = Vo(), r = Hh();
  function n() {
    for (var a = [], i = 0; i < arguments.length; i++)
      a[i] = arguments[i];
    return e.concatAll()(r.from(a, t.popScheduler(a)));
  }
  return Om.concat = n, Om;
}
var Tm = {}, j_ = {}, Dj;
function Gh() {
  return Dj || (Dj = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.empty = e.EMPTY = void 0;
    var t = ci();
    e.EMPTY = new t.Observable(function(a) {
      return a.complete();
    });
    function r(a) {
      return a ? n(a) : e.EMPTY;
    }
    e.empty = r;
    function n(a) {
      return new t.Observable(function(i) {
        return a.schedule(function() {
          return i.complete();
        });
      });
    }
  }(j_)), j_;
}
var jj;
function vC() {
  if (jj) return Tm;
  jj = 1, Object.defineProperty(Tm, "__esModule", { value: !0 }), Tm.take = void 0;
  var e = Gh(), t = Yt(), r = nr();
  function n(a) {
    return a <= 0 ? function() {
      return e.EMPTY;
    } : t.operate(function(i, o) {
      var s = 0;
      i.subscribe(r.createOperatorSubscriber(o, function(l) {
        ++s <= a && (o.next(l), a <= s && o.complete());
      }));
    });
  }
  return Tm.take = n, Tm;
}
var Im = {}, Lj;
function wQ() {
  if (Lj) return Im;
  Lj = 1, Object.defineProperty(Im, "__esModule", { value: !0 }), Im.ignoreElements = void 0;
  var e = Yt(), t = nr(), r = _i();
  function n() {
    return e.operate(function(a, i) {
      a.subscribe(t.createOperatorSubscriber(i, r.noop));
    });
  }
  return Im.ignoreElements = n, Im;
}
var Mm = {}, kj;
function OQ() {
  if (kj) return Mm;
  kj = 1, Object.defineProperty(Mm, "__esModule", { value: !0 }), Mm.mapTo = void 0;
  var e = Wc();
  function t(r) {
    return e.map(function() {
      return r;
    });
  }
  return Mm.mapTo = t, Mm;
}
var Fj;
function TQ() {
  if (Fj) return wm;
  Fj = 1, Object.defineProperty(wm, "__esModule", { value: !0 }), wm.delayWhen = void 0;
  var e = KM(), t = vC(), r = wQ(), n = OQ(), a = qc(), i = qr();
  function o(s, l) {
    return l ? function(c) {
      return e.concat(l.pipe(t.take(1), r.ignoreElements()), c.pipe(o(s)));
    } : a.mergeMap(function(c, u) {
      return i.innerFrom(s(c, u)).pipe(t.take(1), n.mapTo(c));
    });
  }
  return wm.delayWhen = o, wm;
}
var Bj;
function f5e() {
  if (Bj) return Em;
  Bj = 1, Object.defineProperty(Em, "__esModule", { value: !0 }), Em.delay = void 0;
  var e = po(), t = TQ(), r = jd();
  function n(a, i) {
    i === void 0 && (i = e.asyncScheduler);
    var o = r.timer(a, i);
    return t.delayWhen(function() {
      return o;
    });
  }
  return Em.delay = n, Em;
}
var Am = {}, L_ = {}, Pm = {}, zj;
function IQ() {
  if (zj) return Pm;
  zj = 1, Object.defineProperty(Pm, "__esModule", { value: !0 }), Pm.of = void 0;
  var e = Vo(), t = Hh();
  function r() {
    for (var n = [], a = 0; a < arguments.length; a++)
      n[a] = arguments[a];
    var i = e.popScheduler(n);
    return t.from(n, i);
  }
  return Pm.of = r, Pm;
}
var Rm = {}, Hj;
function p5e() {
  if (Hj) return Rm;
  Hj = 1, Object.defineProperty(Rm, "__esModule", { value: !0 }), Rm.throwError = void 0;
  var e = ci(), t = Pn();
  function r(n, a) {
    var i = t.isFunction(n) ? n : function() {
      return n;
    }, o = function(s) {
      return s.error(i());
    };
    return new e.Observable(a ? function(s) {
      return a.schedule(o, 0, s);
    } : o);
  }
  return Rm.throwError = r, Rm;
}
var Vj;
function MQ() {
  return Vj || (Vj = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.observeNotification = e.Notification = e.NotificationKind = void 0;
    var t = Gh(), r = IQ(), n = p5e(), a = Pn();
    (function(s) {
      s.NEXT = "N", s.ERROR = "E", s.COMPLETE = "C";
    })(e.NotificationKind || (e.NotificationKind = {}));
    var i = function() {
      function s(l, c, u) {
        this.kind = l, this.value = c, this.error = u, this.hasValue = l === "N";
      }
      return s.prototype.observe = function(l) {
        return o(this, l);
      }, s.prototype.do = function(l, c, u) {
        var d = this, f = d.kind, m = d.value, h = d.error;
        return f === "N" ? l?.(m) : f === "E" ? c?.(h) : u?.();
      }, s.prototype.accept = function(l, c, u) {
        var d;
        return a.isFunction((d = l) === null || d === void 0 ? void 0 : d.next) ? this.observe(l) : this.do(l, c, u);
      }, s.prototype.toObservable = function() {
        var l = this, c = l.kind, u = l.value, d = l.error, f = c === "N" ? r.of(u) : c === "E" ? n.throwError(function() {
          return d;
        }) : c === "C" ? t.EMPTY : 0;
        if (!f)
          throw new TypeError("Unexpected notification kind " + c);
        return f;
      }, s.createNext = function(l) {
        return new s("N", l);
      }, s.createError = function(l) {
        return new s("E", void 0, l);
      }, s.createComplete = function() {
        return s.completeNotification;
      }, s.completeNotification = new s("C"), s;
    }();
    e.Notification = i;
    function o(s, l) {
      var c, u, d, f = s, m = f.kind, h = f.value, g = f.error;
      if (typeof m != "string")
        throw new TypeError('Invalid notification, missing "kind"');
      m === "N" ? (c = l.next) === null || c === void 0 || c.call(l, h) : m === "E" ? (u = l.error) === null || u === void 0 || u.call(l, g) : (d = l.complete) === null || d === void 0 || d.call(l);
    }
    e.observeNotification = o;
  }(L_)), L_;
}
var Gj;
function m5e() {
  if (Gj) return Am;
  Gj = 1, Object.defineProperty(Am, "__esModule", { value: !0 }), Am.dematerialize = void 0;
  var e = MQ(), t = Yt(), r = nr();
  function n() {
    return t.operate(function(a, i) {
      a.subscribe(r.createOperatorSubscriber(i, function(o) {
        return e.observeNotification(o, i);
      }));
    });
  }
  return Am.dematerialize = n, Am;
}
var Nm = {}, Uj;
function v5e() {
  if (Uj) return Nm;
  Uj = 1, Object.defineProperty(Nm, "__esModule", { value: !0 }), Nm.distinct = void 0;
  var e = Yt(), t = nr(), r = _i(), n = qr();
  function a(i, o) {
    return e.operate(function(s, l) {
      var c = /* @__PURE__ */ new Set();
      s.subscribe(t.createOperatorSubscriber(l, function(u) {
        var d = i ? i(u) : u;
        c.has(d) || (c.add(d), l.next(u));
      })), o && n.innerFrom(o).subscribe(t.createOperatorSubscriber(l, function() {
        return c.clear();
      }, r.noop));
    });
  }
  return Nm.distinct = a, Nm;
}
var Dm = {}, Wj;
function AQ() {
  if (Wj) return Dm;
  Wj = 1, Object.defineProperty(Dm, "__esModule", { value: !0 }), Dm.distinctUntilChanged = void 0;
  var e = Ei(), t = Yt(), r = nr();
  function n(i, o) {
    return o === void 0 && (o = e.identity), i = i ?? a, t.operate(function(s, l) {
      var c, u = !0;
      s.subscribe(r.createOperatorSubscriber(l, function(d) {
        var f = o(d);
        (u || !i(c, f)) && (u = !1, c = f, l.next(d));
      }));
    });
  }
  Dm.distinctUntilChanged = n;
  function a(i, o) {
    return i === o;
  }
  return Dm;
}
var jm = {}, qj;
function h5e() {
  if (qj) return jm;
  qj = 1, Object.defineProperty(jm, "__esModule", { value: !0 }), jm.distinctUntilKeyChanged = void 0;
  var e = AQ();
  function t(r, n) {
    return e.distinctUntilChanged(function(a, i) {
      return n ? n(a[r], i[r]) : a[r] === i[r];
    });
  }
  return jm.distinctUntilKeyChanged = t, jm;
}
var Lm = {}, km = {}, Kj;
function g5e() {
  if (Kj) return km;
  Kj = 1, Object.defineProperty(km, "__esModule", { value: !0 }), km.ArgumentOutOfRangeError = void 0;
  var e = Uc();
  return km.ArgumentOutOfRangeError = e.createErrorClass(function(t) {
    return function() {
      t(this), this.name = "ArgumentOutOfRangeError", this.message = "argument out of range";
    };
  }), km;
}
var Fm = {}, Yj;
function Ld() {
  if (Yj) return Fm;
  Yj = 1, Object.defineProperty(Fm, "__esModule", { value: !0 }), Fm.filter = void 0;
  var e = Yt(), t = nr();
  function r(n, a) {
    return e.operate(function(i, o) {
      var s = 0;
      i.subscribe(t.createOperatorSubscriber(o, function(l) {
        return n.call(a, l, s++) && o.next(l);
      }));
    });
  }
  return Fm.filter = r, Fm;
}
var Bm = {}, zm = {}, Zj;
function hC() {
  if (Zj) return zm;
  Zj = 1, Object.defineProperty(zm, "__esModule", { value: !0 }), zm.EmptyError = void 0;
  var e = Uc();
  return zm.EmptyError = e.createErrorClass(function(t) {
    return function() {
      t(this), this.name = "EmptyError", this.message = "no elements in sequence";
    };
  }), zm;
}
var Xj;
function gC() {
  if (Xj) return Bm;
  Xj = 1, Object.defineProperty(Bm, "__esModule", { value: !0 }), Bm.throwIfEmpty = void 0;
  var e = hC(), t = Yt(), r = nr();
  function n(i) {
    return i === void 0 && (i = a), t.operate(function(o, s) {
      var l = !1;
      o.subscribe(r.createOperatorSubscriber(s, function(c) {
        l = !0, s.next(c);
      }, function() {
        return l ? s.complete() : s.error(i());
      }));
    });
  }
  Bm.throwIfEmpty = n;
  function a() {
    return new e.EmptyError();
  }
  return Bm;
}
var Jj;
function y5e() {
  if (Jj) return Lm;
  Jj = 1, Object.defineProperty(Lm, "__esModule", { value: !0 }), Lm.elementAt = void 0;
  var e = g5e(), t = Ld(), r = gC(), n = mC(), a = vC();
  function i(o, s) {
    if (o < 0)
      throw new e.ArgumentOutOfRangeError();
    var l = arguments.length >= 2;
    return function(c) {
      return c.pipe(t.filter(function(u, d) {
        return d === o;
      }), a.take(1), l ? n.defaultIfEmpty(s) : r.throwIfEmpty(function() {
        return new e.ArgumentOutOfRangeError();
      }));
    };
  }
  return Lm.elementAt = i, Lm;
}
var Hm = {}, Qj;
function b5e() {
  if (Qj) return Hm;
  Qj = 1;
  var e = Ue && Ue.__read || function(i, o) {
    var s = typeof Symbol == "function" && i[Symbol.iterator];
    if (!s) return i;
    var l = s.call(i), c, u = [], d;
    try {
      for (; (o === void 0 || o-- > 0) && !(c = l.next()).done; ) u.push(c.value);
    } catch (f) {
      d = { error: f };
    } finally {
      try {
        c && !c.done && (s = l.return) && s.call(l);
      } finally {
        if (d) throw d.error;
      }
    }
    return u;
  }, t = Ue && Ue.__spreadArray || function(i, o) {
    for (var s = 0, l = o.length, c = i.length; s < l; s++, c++)
      i[c] = o[s];
    return i;
  };
  Object.defineProperty(Hm, "__esModule", { value: !0 }), Hm.endWith = void 0;
  var r = KM(), n = IQ();
  function a() {
    for (var i = [], o = 0; o < arguments.length; o++)
      i[o] = arguments[o];
    return function(s) {
      return r.concat(s, n.of.apply(void 0, t([], e(i))));
    };
  }
  return Hm.endWith = a, Hm;
}
var Vm = {}, eL;
function C5e() {
  if (eL) return Vm;
  eL = 1, Object.defineProperty(Vm, "__esModule", { value: !0 }), Vm.every = void 0;
  var e = Yt(), t = nr();
  function r(n, a) {
    return e.operate(function(i, o) {
      var s = 0;
      i.subscribe(t.createOperatorSubscriber(o, function(l) {
        n.call(a, l, s++, i) || (o.next(!1), o.complete());
      }, function() {
        o.next(!0), o.complete();
      }));
    });
  }
  return Vm.every = r, Vm;
}
var Gm = {}, Um = {}, Wm = {}, tL;
function PQ() {
  if (tL) return Wm;
  tL = 1, Object.defineProperty(Wm, "__esModule", { value: !0 }), Wm.exhaustMap = void 0;
  var e = Wc(), t = qr(), r = Yt(), n = nr();
  function a(i, o) {
    return o ? function(s) {
      return s.pipe(a(function(l, c) {
        return t.innerFrom(i(l, c)).pipe(e.map(function(u, d) {
          return o(l, u, c, d);
        }));
      }));
    } : r.operate(function(s, l) {
      var c = 0, u = null, d = !1;
      s.subscribe(n.createOperatorSubscriber(l, function(f) {
        u || (u = n.createOperatorSubscriber(l, void 0, function() {
          u = null, d && l.complete();
        }), t.innerFrom(i(f, c++)).subscribe(u));
      }, function() {
        d = !0, !u && l.complete();
      }));
    });
  }
  return Wm.exhaustMap = a, Wm;
}
var rL;
function RQ() {
  if (rL) return Um;
  rL = 1, Object.defineProperty(Um, "__esModule", { value: !0 }), Um.exhaustAll = void 0;
  var e = PQ(), t = Ei();
  function r() {
    return e.exhaustMap(t.identity);
  }
  return Um.exhaustAll = r, Um;
}
var nL;
function S5e() {
  if (nL) return Gm;
  nL = 1, Object.defineProperty(Gm, "__esModule", { value: !0 }), Gm.exhaust = void 0;
  var e = RQ();
  return Gm.exhaust = e.exhaustAll, Gm;
}
var qm = {}, aL;
function x5e() {
  if (aL) return qm;
  aL = 1, Object.defineProperty(qm, "__esModule", { value: !0 }), qm.expand = void 0;
  var e = Yt(), t = GM();
  function r(n, a, i) {
    return a === void 0 && (a = 1 / 0), a = (a || 0) < 1 ? 1 / 0 : a, e.operate(function(o, s) {
      return t.mergeInternals(o, s, n, a, void 0, !0, i);
    });
  }
  return qm.expand = r, qm;
}
var Km = {}, iL;
function $5e() {
  if (iL) return Km;
  iL = 1, Object.defineProperty(Km, "__esModule", { value: !0 }), Km.finalize = void 0;
  var e = Yt();
  function t(r) {
    return e.operate(function(n, a) {
      try {
        n.subscribe(a);
      } finally {
        a.add(r);
      }
    });
  }
  return Km.finalize = t, Km;
}
var tc = {}, oL;
function NQ() {
  if (oL) return tc;
  oL = 1, Object.defineProperty(tc, "__esModule", { value: !0 }), tc.createFind = tc.find = void 0;
  var e = Yt(), t = nr();
  function r(a, i) {
    return e.operate(n(a, i, "value"));
  }
  tc.find = r;
  function n(a, i, o) {
    var s = o === "index";
    return function(l, c) {
      var u = 0;
      l.subscribe(t.createOperatorSubscriber(c, function(d) {
        var f = u++;
        a.call(i, d, f, l) && (c.next(s ? f : d), c.complete());
      }, function() {
        c.next(s ? -1 : void 0), c.complete();
      }));
    };
  }
  return tc.createFind = n, tc;
}
var Ym = {}, sL;
function _5e() {
  if (sL) return Ym;
  sL = 1, Object.defineProperty(Ym, "__esModule", { value: !0 }), Ym.findIndex = void 0;
  var e = Yt(), t = NQ();
  function r(n, a) {
    return e.operate(t.createFind(n, a, "index"));
  }
  return Ym.findIndex = r, Ym;
}
var Zm = {}, lL;
function E5e() {
  if (lL) return Zm;
  lL = 1, Object.defineProperty(Zm, "__esModule", { value: !0 }), Zm.first = void 0;
  var e = hC(), t = Ld(), r = vC(), n = mC(), a = gC(), i = Ei();
  function o(s, l) {
    var c = arguments.length >= 2;
    return function(u) {
      return u.pipe(s ? t.filter(function(d, f) {
        return s(d, f, u);
      }) : i.identity, r.take(1), c ? n.defaultIfEmpty(l) : a.throwIfEmpty(function() {
        return new e.EmptyError();
      }));
    };
  }
  return Zm.first = o, Zm;
}
var Xm = {}, cL;
function w5e() {
  if (cL) return Xm;
  cL = 1, Object.defineProperty(Xm, "__esModule", { value: !0 }), Xm.groupBy = void 0;
  var e = ci(), t = qr(), r = wi(), n = Yt(), a = nr();
  function i(o, s, l, c) {
    return n.operate(function(u, d) {
      var f;
      !s || typeof s == "function" ? f = s : (l = s.duration, f = s.element, c = s.connector);
      var m = /* @__PURE__ */ new Map(), h = function(_) {
        m.forEach(_), _(d);
      }, g = function(_) {
        return h(function($) {
          return $.error(_);
        });
      }, y = 0, S = !1, x = new a.OperatorSubscriber(d, function(_) {
        try {
          var $ = o(_), w = m.get($);
          if (!w) {
            m.set($, w = c ? c() : new r.Subject());
            var O = b($, w);
            if (d.next(O), l) {
              var T = a.createOperatorSubscriber(w, function() {
                w.complete(), T?.unsubscribe();
              }, void 0, void 0, function() {
                return m.delete($);
              });
              x.add(t.innerFrom(l(O)).subscribe(T));
            }
          }
          w.next(f ? f(_) : _);
        } catch (I) {
          g(I);
        }
      }, function() {
        return h(function(_) {
          return _.complete();
        });
      }, g, function() {
        return m.clear();
      }, function() {
        return S = !0, y === 0;
      });
      u.subscribe(x);
      function b(_, $) {
        var w = new e.Observable(function(O) {
          y++;
          var T = $.subscribe(O);
          return function() {
            T.unsubscribe(), --y === 0 && S && x.unsubscribe();
          };
        });
        return w.key = _, w;
      }
    });
  }
  return Xm.groupBy = i, Xm;
}
var Jm = {}, uL;
function O5e() {
  if (uL) return Jm;
  uL = 1, Object.defineProperty(Jm, "__esModule", { value: !0 }), Jm.isEmpty = void 0;
  var e = Yt(), t = nr();
  function r() {
    return e.operate(function(n, a) {
      n.subscribe(t.createOperatorSubscriber(a, function() {
        a.next(!1), a.complete();
      }, function() {
        a.next(!0), a.complete();
      }));
    });
  }
  return Jm.isEmpty = r, Jm;
}
var Qm = {}, ev = {}, dL;
function DQ() {
  if (dL) return ev;
  dL = 1;
  var e = Ue && Ue.__values || function(i) {
    var o = typeof Symbol == "function" && Symbol.iterator, s = o && i[o], l = 0;
    if (s) return s.call(i);
    if (i && typeof i.length == "number") return {
      next: function() {
        return i && l >= i.length && (i = void 0), { value: i && i[l++], done: !i };
      }
    };
    throw new TypeError(o ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(ev, "__esModule", { value: !0 }), ev.takeLast = void 0;
  var t = Gh(), r = Yt(), n = nr();
  function a(i) {
    return i <= 0 ? function() {
      return t.EMPTY;
    } : r.operate(function(o, s) {
      var l = [];
      o.subscribe(n.createOperatorSubscriber(s, function(c) {
        l.push(c), i < l.length && l.shift();
      }, function() {
        var c, u;
        try {
          for (var d = e(l), f = d.next(); !f.done; f = d.next()) {
            var m = f.value;
            s.next(m);
          }
        } catch (h) {
          c = { error: h };
        } finally {
          try {
            f && !f.done && (u = d.return) && u.call(d);
          } finally {
            if (c) throw c.error;
          }
        }
        s.complete();
      }, void 0, function() {
        l = null;
      }));
    });
  }
  return ev.takeLast = a, ev;
}
var fL;
function T5e() {
  if (fL) return Qm;
  fL = 1, Object.defineProperty(Qm, "__esModule", { value: !0 }), Qm.last = void 0;
  var e = hC(), t = Ld(), r = DQ(), n = gC(), a = mC(), i = Ei();
  function o(s, l) {
    var c = arguments.length >= 2;
    return function(u) {
      return u.pipe(s ? t.filter(function(d, f) {
        return s(d, f, u);
      }) : i.identity, r.takeLast(1), c ? a.defaultIfEmpty(l) : n.throwIfEmpty(function() {
        return new e.EmptyError();
      }));
    };
  }
  return Qm.last = o, Qm;
}
var tv = {}, pL;
function I5e() {
  if (pL) return tv;
  pL = 1, Object.defineProperty(tv, "__esModule", { value: !0 }), tv.materialize = void 0;
  var e = MQ(), t = Yt(), r = nr();
  function n() {
    return t.operate(function(a, i) {
      a.subscribe(r.createOperatorSubscriber(i, function(o) {
        i.next(e.Notification.createNext(o));
      }, function() {
        i.next(e.Notification.createComplete()), i.complete();
      }, function(o) {
        i.next(e.Notification.createError(o)), i.complete();
      }));
    });
  }
  return tv.materialize = n, tv;
}
var rv = {}, mL;
function M5e() {
  if (mL) return rv;
  mL = 1, Object.defineProperty(rv, "__esModule", { value: !0 }), rv.max = void 0;
  var e = Vh(), t = Pn();
  function r(n) {
    return e.reduce(t.isFunction(n) ? function(a, i) {
      return n(a, i) > 0 ? a : i;
    } : function(a, i) {
      return a > i ? a : i;
    });
  }
  return rv.max = r, rv;
}
var nv = {}, vL;
function jQ() {
  if (vL) return nv;
  vL = 1;
  var e = Ue && Ue.__read || function(l, c) {
    var u = typeof Symbol == "function" && l[Symbol.iterator];
    if (!u) return l;
    var d = u.call(l), f, m = [], h;
    try {
      for (; (c === void 0 || c-- > 0) && !(f = d.next()).done; ) m.push(f.value);
    } catch (g) {
      h = { error: g };
    } finally {
      try {
        f && !f.done && (u = d.return) && u.call(d);
      } finally {
        if (h) throw h.error;
      }
    }
    return m;
  }, t = Ue && Ue.__spreadArray || function(l, c) {
    for (var u = 0, d = c.length, f = l.length; u < d; u++, f++)
      l[f] = c[u];
    return l;
  };
  Object.defineProperty(nv, "__esModule", { value: !0 }), nv.merge = void 0;
  var r = Yt(), n = Kc(), a = UM(), i = Vo(), o = Hh();
  function s() {
    for (var l = [], c = 0; c < arguments.length; c++)
      l[c] = arguments[c];
    var u = i.popScheduler(l), d = i.popNumber(l, 1 / 0);
    return l = n.argsOrArgArray(l), r.operate(function(f, m) {
      a.mergeAll(d)(o.from(t([f], e(l)), u)).subscribe(m);
    });
  }
  return nv.merge = s, nv;
}
var av = {}, hL;
function A5e() {
  if (hL) return av;
  hL = 1, Object.defineProperty(av, "__esModule", { value: !0 }), av.flatMap = void 0;
  var e = qc();
  return av.flatMap = e.mergeMap, av;
}
var iv = {}, gL;
function P5e() {
  if (gL) return iv;
  gL = 1, Object.defineProperty(iv, "__esModule", { value: !0 }), iv.mergeMapTo = void 0;
  var e = qc(), t = Pn();
  function r(n, a, i) {
    return i === void 0 && (i = 1 / 0), t.isFunction(a) ? e.mergeMap(function() {
      return n;
    }, a, i) : (typeof a == "number" && (i = a), e.mergeMap(function() {
      return n;
    }, i));
  }
  return iv.mergeMapTo = r, iv;
}
var ov = {}, yL;
function R5e() {
  if (yL) return ov;
  yL = 1, Object.defineProperty(ov, "__esModule", { value: !0 }), ov.mergeScan = void 0;
  var e = Yt(), t = GM();
  function r(n, a, i) {
    return i === void 0 && (i = 1 / 0), e.operate(function(o, s) {
      var l = a;
      return t.mergeInternals(o, s, function(c, u) {
        return n(l, c, u);
      }, i, function(c) {
        l = c;
      }, !1, void 0, function() {
        return l = null;
      });
    });
  }
  return ov.mergeScan = r, ov;
}
var sv = {}, bL;
function N5e() {
  if (bL) return sv;
  bL = 1;
  var e = Ue && Ue.__read || function(a, i) {
    var o = typeof Symbol == "function" && a[Symbol.iterator];
    if (!o) return a;
    var s = o.call(a), l, c = [], u;
    try {
      for (; (i === void 0 || i-- > 0) && !(l = s.next()).done; ) c.push(l.value);
    } catch (d) {
      u = { error: d };
    } finally {
      try {
        l && !l.done && (o = s.return) && o.call(s);
      } finally {
        if (u) throw u.error;
      }
    }
    return c;
  }, t = Ue && Ue.__spreadArray || function(a, i) {
    for (var o = 0, s = i.length, l = a.length; o < s; o++, l++)
      a[l] = i[o];
    return a;
  };
  Object.defineProperty(sv, "__esModule", { value: !0 }), sv.mergeWith = void 0;
  var r = jQ();
  function n() {
    for (var a = [], i = 0; i < arguments.length; i++)
      a[i] = arguments[i];
    return r.merge.apply(void 0, t([], e(a)));
  }
  return sv.mergeWith = n, sv;
}
var lv = {}, CL;
function D5e() {
  if (CL) return lv;
  CL = 1, Object.defineProperty(lv, "__esModule", { value: !0 }), lv.min = void 0;
  var e = Vh(), t = Pn();
  function r(n) {
    return e.reduce(t.isFunction(n) ? function(a, i) {
      return n(a, i) < 0 ? a : i;
    } : function(a, i) {
      return a < i ? a : i;
    });
  }
  return lv.min = r, lv;
}
var cv = {}, uv = {}, dv = {}, SL;
function LQ() {
  if (SL) return dv;
  SL = 1, Object.defineProperty(dv, "__esModule", { value: !0 }), dv.refCount = void 0;
  var e = Yt(), t = nr();
  function r() {
    return e.operate(function(n, a) {
      var i = null;
      n._refCount++;
      var o = t.createOperatorSubscriber(a, void 0, void 0, void 0, function() {
        if (!n || n._refCount <= 0 || 0 < --n._refCount) {
          i = null;
          return;
        }
        var s = n._connection, l = i;
        i = null, s && (!l || s === l) && s.unsubscribe(), a.unsubscribe();
      });
      n.subscribe(o), o.closed || (i = n.connect());
    });
  }
  return dv.refCount = r, dv;
}
var xL;
function YM() {
  if (xL) return uv;
  xL = 1;
  var e = Ue && Ue.__extends || /* @__PURE__ */ function() {
    var s = function(l, c) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, d) {
        u.__proto__ = d;
      } || function(u, d) {
        for (var f in d) Object.prototype.hasOwnProperty.call(d, f) && (u[f] = d[f]);
      }, s(l, c);
    };
    return function(l, c) {
      if (typeof c != "function" && c !== null)
        throw new TypeError("Class extends value " + String(c) + " is not a constructor or null");
      s(l, c);
      function u() {
        this.constructor = l;
      }
      l.prototype = c === null ? Object.create(c) : (u.prototype = c.prototype, new u());
    };
  }();
  Object.defineProperty(uv, "__esModule", { value: !0 }), uv.ConnectableObservable = void 0;
  var t = ci(), r = Xs(), n = LQ(), a = nr(), i = Yt(), o = function(s) {
    e(l, s);
    function l(c, u) {
      var d = s.call(this) || this;
      return d.source = c, d.subjectFactory = u, d._subject = null, d._refCount = 0, d._connection = null, i.hasLift(c) && (d.lift = c.lift), d;
    }
    return l.prototype._subscribe = function(c) {
      return this.getSubject().subscribe(c);
    }, l.prototype.getSubject = function() {
      var c = this._subject;
      return (!c || c.isStopped) && (this._subject = this.subjectFactory()), this._subject;
    }, l.prototype._teardown = function() {
      this._refCount = 0;
      var c = this._connection;
      this._subject = this._connection = null, c?.unsubscribe();
    }, l.prototype.connect = function() {
      var c = this, u = this._connection;
      if (!u) {
        u = this._connection = new r.Subscription();
        var d = this.getSubject();
        u.add(this.source.subscribe(a.createOperatorSubscriber(d, void 0, function() {
          c._teardown(), d.complete();
        }, function(f) {
          c._teardown(), d.error(f);
        }, function() {
          return c._teardown();
        }))), u.closed && (this._connection = null, u = r.Subscription.EMPTY);
      }
      return u;
    }, l.prototype.refCount = function() {
      return n.refCount()(this);
    }, l;
  }(t.Observable);
  return uv.ConnectableObservable = o, uv;
}
var $L;
function ZM() {
  if ($L) return cv;
  $L = 1, Object.defineProperty(cv, "__esModule", { value: !0 }), cv.multicast = void 0;
  var e = YM(), t = Pn(), r = qM();
  function n(a, i) {
    var o = t.isFunction(a) ? a : function() {
      return a;
    };
    return t.isFunction(i) ? r.connect(i, {
      connector: o
    }) : function(s) {
      return new e.ConnectableObservable(s, o);
    };
  }
  return cv.multicast = n, cv;
}
var rc = {}, fv = {}, _L;
function j5e() {
  if (_L) return fv;
  _L = 1, Object.defineProperty(fv, "__esModule", { value: !0 }), fv.onErrorResumeNext = void 0;
  var e = ci(), t = Kc(), r = nr(), n = _i(), a = qr();
  function i() {
    for (var o = [], s = 0; s < arguments.length; s++)
      o[s] = arguments[s];
    var l = t.argsOrArgArray(o);
    return new e.Observable(function(c) {
      var u = 0, d = function() {
        if (u < l.length) {
          var f = void 0;
          try {
            f = a.innerFrom(l[u++]);
          } catch {
            d();
            return;
          }
          var m = new r.OperatorSubscriber(c, void 0, n.noop, n.noop);
          f.subscribe(m), m.add(d);
        } else
          c.complete();
      };
      d();
    });
  }
  return fv.onErrorResumeNext = i, fv;
}
var EL;
function L5e() {
  if (EL) return rc;
  EL = 1;
  var e = Ue && Ue.__read || function(i, o) {
    var s = typeof Symbol == "function" && i[Symbol.iterator];
    if (!s) return i;
    var l = s.call(i), c, u = [], d;
    try {
      for (; (o === void 0 || o-- > 0) && !(c = l.next()).done; ) u.push(c.value);
    } catch (f) {
      d = { error: f };
    } finally {
      try {
        c && !c.done && (s = l.return) && s.call(l);
      } finally {
        if (d) throw d.error;
      }
    }
    return u;
  }, t = Ue && Ue.__spreadArray || function(i, o) {
    for (var s = 0, l = o.length, c = i.length; s < l; s++, c++)
      i[c] = o[s];
    return i;
  };
  Object.defineProperty(rc, "__esModule", { value: !0 }), rc.onErrorResumeNext = rc.onErrorResumeNextWith = void 0;
  var r = Kc(), n = j5e();
  function a() {
    for (var i = [], o = 0; o < arguments.length; o++)
      i[o] = arguments[o];
    var s = r.argsOrArgArray(i);
    return function(l) {
      return n.onErrorResumeNext.apply(void 0, t([l], e(s)));
    };
  }
  return rc.onErrorResumeNextWith = a, rc.onErrorResumeNext = a, rc;
}
var pv = {}, wL;
function k5e() {
  if (wL) return pv;
  wL = 1, Object.defineProperty(pv, "__esModule", { value: !0 }), pv.pairwise = void 0;
  var e = Yt(), t = nr();
  function r() {
    return e.operate(function(n, a) {
      var i, o = !1;
      n.subscribe(t.createOperatorSubscriber(a, function(s) {
        var l = i;
        i = s, o && a.next([l, s]), o = !0;
      }));
    });
  }
  return pv.pairwise = r, pv;
}
var mv = {}, vv = {}, OL;
function F5e() {
  if (OL) return vv;
  OL = 1, Object.defineProperty(vv, "__esModule", { value: !0 }), vv.not = void 0;
  function e(t, r) {
    return function(n, a) {
      return !t.call(r, n, a);
    };
  }
  return vv.not = e, vv;
}
var TL;
function B5e() {
  if (TL) return mv;
  TL = 1, Object.defineProperty(mv, "__esModule", { value: !0 }), mv.partition = void 0;
  var e = F5e(), t = Ld();
  function r(n, a) {
    return function(i) {
      return [t.filter(n, a)(i), t.filter(e.not(n, a))(i)];
    };
  }
  return mv.partition = r, mv;
}
var hv = {}, IL;
function z5e() {
  if (IL) return hv;
  IL = 1, Object.defineProperty(hv, "__esModule", { value: !0 }), hv.pluck = void 0;
  var e = Wc();
  function t() {
    for (var r = [], n = 0; n < arguments.length; n++)
      r[n] = arguments[n];
    var a = r.length;
    if (a === 0)
      throw new Error("list of properties cannot be empty.");
    return e.map(function(i) {
      for (var o = i, s = 0; s < a; s++) {
        var l = o?.[r[s]];
        if (typeof l < "u")
          o = l;
        else
          return;
      }
      return o;
    });
  }
  return hv.pluck = t, hv;
}
var gv = {}, ML;
function H5e() {
  if (ML) return gv;
  ML = 1, Object.defineProperty(gv, "__esModule", { value: !0 }), gv.publish = void 0;
  var e = wi(), t = ZM(), r = qM();
  function n(a) {
    return a ? function(i) {
      return r.connect(a)(i);
    } : function(i) {
      return t.multicast(new e.Subject())(i);
    };
  }
  return gv.publish = n, gv;
}
var yv = {}, bv = {}, AL;
function V5e() {
  if (AL) return bv;
  AL = 1;
  var e = Ue && Ue.__extends || /* @__PURE__ */ function() {
    var n = function(a, i) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, s) {
        o.__proto__ = s;
      } || function(o, s) {
        for (var l in s) Object.prototype.hasOwnProperty.call(s, l) && (o[l] = s[l]);
      }, n(a, i);
    };
    return function(a, i) {
      if (typeof i != "function" && i !== null)
        throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
      n(a, i);
      function o() {
        this.constructor = a;
      }
      a.prototype = i === null ? Object.create(i) : (o.prototype = i.prototype, new o());
    };
  }();
  Object.defineProperty(bv, "__esModule", { value: !0 }), bv.BehaviorSubject = void 0;
  var t = wi(), r = function(n) {
    e(a, n);
    function a(i) {
      var o = n.call(this) || this;
      return o._value = i, o;
    }
    return Object.defineProperty(a.prototype, "value", {
      get: function() {
        return this.getValue();
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype._subscribe = function(i) {
      var o = n.prototype._subscribe.call(this, i);
      return !o.closed && i.next(this._value), o;
    }, a.prototype.getValue = function() {
      var i = this, o = i.hasError, s = i.thrownError, l = i._value;
      if (o)
        throw s;
      return this._throwIfClosed(), l;
    }, a.prototype.next = function(i) {
      n.prototype.next.call(this, this._value = i);
    }, a;
  }(t.Subject);
  return bv.BehaviorSubject = r, bv;
}
var PL;
function G5e() {
  if (PL) return yv;
  PL = 1, Object.defineProperty(yv, "__esModule", { value: !0 }), yv.publishBehavior = void 0;
  var e = V5e(), t = YM();
  function r(n) {
    return function(a) {
      var i = new e.BehaviorSubject(n);
      return new t.ConnectableObservable(a, function() {
        return i;
      });
    };
  }
  return yv.publishBehavior = r, yv;
}
var Cv = {}, Sv = {}, RL;
function U5e() {
  if (RL) return Sv;
  RL = 1;
  var e = Ue && Ue.__extends || /* @__PURE__ */ function() {
    var n = function(a, i) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, s) {
        o.__proto__ = s;
      } || function(o, s) {
        for (var l in s) Object.prototype.hasOwnProperty.call(s, l) && (o[l] = s[l]);
      }, n(a, i);
    };
    return function(a, i) {
      if (typeof i != "function" && i !== null)
        throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
      n(a, i);
      function o() {
        this.constructor = a;
      }
      a.prototype = i === null ? Object.create(i) : (o.prototype = i.prototype, new o());
    };
  }();
  Object.defineProperty(Sv, "__esModule", { value: !0 }), Sv.AsyncSubject = void 0;
  var t = wi(), r = function(n) {
    e(a, n);
    function a() {
      var i = n !== null && n.apply(this, arguments) || this;
      return i._value = null, i._hasValue = !1, i._isComplete = !1, i;
    }
    return a.prototype._checkFinalizedStatuses = function(i) {
      var o = this, s = o.hasError, l = o._hasValue, c = o._value, u = o.thrownError, d = o.isStopped, f = o._isComplete;
      s ? i.error(u) : (d || f) && (l && i.next(c), i.complete());
    }, a.prototype.next = function(i) {
      this.isStopped || (this._value = i, this._hasValue = !0);
    }, a.prototype.complete = function() {
      var i = this, o = i._hasValue, s = i._value, l = i._isComplete;
      l || (this._isComplete = !0, o && n.prototype.next.call(this, s), n.prototype.complete.call(this));
    }, a;
  }(t.Subject);
  return Sv.AsyncSubject = r, Sv;
}
var NL;
function W5e() {
  if (NL) return Cv;
  NL = 1, Object.defineProperty(Cv, "__esModule", { value: !0 }), Cv.publishLast = void 0;
  var e = U5e(), t = YM();
  function r() {
    return function(n) {
      var a = new e.AsyncSubject();
      return new t.ConnectableObservable(n, function() {
        return a;
      });
    };
  }
  return Cv.publishLast = r, Cv;
}
var xv = {}, $v = {}, DL;
function kQ() {
  if (DL) return $v;
  DL = 1;
  var e = Ue && Ue.__extends || /* @__PURE__ */ function() {
    var a = function(i, o) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, l) {
        s.__proto__ = l;
      } || function(s, l) {
        for (var c in l) Object.prototype.hasOwnProperty.call(l, c) && (s[c] = l[c]);
      }, a(i, o);
    };
    return function(i, o) {
      if (typeof o != "function" && o !== null)
        throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
      a(i, o);
      function s() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (s.prototype = o.prototype, new s());
    };
  }();
  Object.defineProperty($v, "__esModule", { value: !0 }), $v.ReplaySubject = void 0;
  var t = wi(), r = FM(), n = function(a) {
    e(i, a);
    function i(o, s, l) {
      o === void 0 && (o = 1 / 0), s === void 0 && (s = 1 / 0), l === void 0 && (l = r.dateTimestampProvider);
      var c = a.call(this) || this;
      return c._bufferSize = o, c._windowTime = s, c._timestampProvider = l, c._buffer = [], c._infiniteTimeWindow = !0, c._infiniteTimeWindow = s === 1 / 0, c._bufferSize = Math.max(1, o), c._windowTime = Math.max(1, s), c;
    }
    return i.prototype.next = function(o) {
      var s = this, l = s.isStopped, c = s._buffer, u = s._infiniteTimeWindow, d = s._timestampProvider, f = s._windowTime;
      l || (c.push(o), !u && c.push(d.now() + f)), this._trimBuffer(), a.prototype.next.call(this, o);
    }, i.prototype._subscribe = function(o) {
      this._throwIfClosed(), this._trimBuffer();
      for (var s = this._innerSubscribe(o), l = this, c = l._infiniteTimeWindow, u = l._buffer, d = u.slice(), f = 0; f < d.length && !o.closed; f += c ? 1 : 2)
        o.next(d[f]);
      return this._checkFinalizedStatuses(o), s;
    }, i.prototype._trimBuffer = function() {
      var o = this, s = o._bufferSize, l = o._timestampProvider, c = o._buffer, u = o._infiniteTimeWindow, d = (u ? 1 : 2) * s;
      if (s < 1 / 0 && d < c.length && c.splice(0, c.length - d), !u) {
        for (var f = l.now(), m = 0, h = 1; h < c.length && c[h] <= f; h += 2)
          m = h;
        m && c.splice(0, m + 1);
      }
    }, i;
  }(t.Subject);
  return $v.ReplaySubject = n, $v;
}
var jL;
function q5e() {
  if (jL) return xv;
  jL = 1, Object.defineProperty(xv, "__esModule", { value: !0 }), xv.publishReplay = void 0;
  var e = kQ(), t = ZM(), r = Pn();
  function n(a, i, o, s) {
    o && !r.isFunction(o) && (s = o);
    var l = r.isFunction(o) ? o : void 0;
    return function(c) {
      return t.multicast(new e.ReplaySubject(a, i, s), l)(c);
    };
  }
  return xv.publishReplay = n, xv;
}
var _v = {}, Ev = {}, nc = {}, LL;
function K5e() {
  if (LL) return nc;
  LL = 1, Object.defineProperty(nc, "__esModule", { value: !0 }), nc.raceInit = nc.race = void 0;
  var e = ci(), t = qr(), r = Kc(), n = nr();
  function a() {
    for (var o = [], s = 0; s < arguments.length; s++)
      o[s] = arguments[s];
    return o = r.argsOrArgArray(o), o.length === 1 ? t.innerFrom(o[0]) : new e.Observable(i(o));
  }
  nc.race = a;
  function i(o) {
    return function(s) {
      for (var l = [], c = function(d) {
        l.push(t.innerFrom(o[d]).subscribe(n.createOperatorSubscriber(s, function(f) {
          if (l) {
            for (var m = 0; m < l.length; m++)
              m !== d && l[m].unsubscribe();
            l = null;
          }
          s.next(f);
        })));
      }, u = 0; l && !s.closed && u < o.length; u++)
        c(u);
    };
  }
  return nc.raceInit = i, nc;
}
var kL;
function FQ() {
  if (kL) return Ev;
  kL = 1;
  var e = Ue && Ue.__read || function(o, s) {
    var l = typeof Symbol == "function" && o[Symbol.iterator];
    if (!l) return o;
    var c = l.call(o), u, d = [], f;
    try {
      for (; (s === void 0 || s-- > 0) && !(u = c.next()).done; ) d.push(u.value);
    } catch (m) {
      f = { error: m };
    } finally {
      try {
        u && !u.done && (l = c.return) && l.call(c);
      } finally {
        if (f) throw f.error;
      }
    }
    return d;
  }, t = Ue && Ue.__spreadArray || function(o, s) {
    for (var l = 0, c = s.length, u = o.length; l < c; l++, u++)
      o[u] = s[l];
    return o;
  };
  Object.defineProperty(Ev, "__esModule", { value: !0 }), Ev.raceWith = void 0;
  var r = K5e(), n = Yt(), a = Ei();
  function i() {
    for (var o = [], s = 0; s < arguments.length; s++)
      o[s] = arguments[s];
    return o.length ? n.operate(function(l, c) {
      r.raceInit(t([l], e(o)))(c);
    }) : a.identity;
  }
  return Ev.raceWith = i, Ev;
}
var FL;
function Y5e() {
  if (FL) return _v;
  FL = 1;
  var e = Ue && Ue.__read || function(i, o) {
    var s = typeof Symbol == "function" && i[Symbol.iterator];
    if (!s) return i;
    var l = s.call(i), c, u = [], d;
    try {
      for (; (o === void 0 || o-- > 0) && !(c = l.next()).done; ) u.push(c.value);
    } catch (f) {
      d = { error: f };
    } finally {
      try {
        c && !c.done && (s = l.return) && s.call(l);
      } finally {
        if (d) throw d.error;
      }
    }
    return u;
  }, t = Ue && Ue.__spreadArray || function(i, o) {
    for (var s = 0, l = o.length, c = i.length; s < l; s++, c++)
      i[c] = o[s];
    return i;
  };
  Object.defineProperty(_v, "__esModule", { value: !0 }), _v.race = void 0;
  var r = Kc(), n = FQ();
  function a() {
    for (var i = [], o = 0; o < arguments.length; o++)
      i[o] = arguments[o];
    return n.raceWith.apply(void 0, t([], e(r.argsOrArgArray(i))));
  }
  return _v.race = a, _v;
}
var wv = {}, BL;
function Z5e() {
  if (BL) return wv;
  BL = 1, Object.defineProperty(wv, "__esModule", { value: !0 }), wv.repeat = void 0;
  var e = Gh(), t = Yt(), r = nr(), n = qr(), a = jd();
  function i(o) {
    var s, l = 1 / 0, c;
    return o != null && (typeof o == "object" ? (s = o.count, l = s === void 0 ? 1 / 0 : s, c = o.delay) : l = o), l <= 0 ? function() {
      return e.EMPTY;
    } : t.operate(function(u, d) {
      var f = 0, m, h = function() {
        if (m?.unsubscribe(), m = null, c != null) {
          var y = typeof c == "number" ? a.timer(c) : n.innerFrom(c(f)), S = r.createOperatorSubscriber(d, function() {
            S.unsubscribe(), g();
          });
          y.subscribe(S);
        } else
          g();
      }, g = function() {
        var y = !1;
        m = u.subscribe(r.createOperatorSubscriber(d, void 0, function() {
          ++f < l ? m ? h() : y = !0 : d.complete();
        })), y && h();
      };
      g();
    });
  }
  return wv.repeat = i, wv;
}
var Ov = {}, zL;
function X5e() {
  if (zL) return Ov;
  zL = 1, Object.defineProperty(Ov, "__esModule", { value: !0 }), Ov.repeatWhen = void 0;
  var e = qr(), t = wi(), r = Yt(), n = nr();
  function a(i) {
    return r.operate(function(o, s) {
      var l, c = !1, u, d = !1, f = !1, m = function() {
        return f && d && (s.complete(), !0);
      }, h = function() {
        return u || (u = new t.Subject(), e.innerFrom(i(u)).subscribe(n.createOperatorSubscriber(s, function() {
          l ? g() : c = !0;
        }, function() {
          d = !0, m();
        }))), u;
      }, g = function() {
        f = !1, l = o.subscribe(n.createOperatorSubscriber(s, void 0, function() {
          f = !0, !m() && h().next();
        })), c && (l.unsubscribe(), l = null, c = !1, g());
      };
      g();
    });
  }
  return Ov.repeatWhen = a, Ov;
}
var Tv = {}, HL;
function J5e() {
  if (HL) return Tv;
  HL = 1, Object.defineProperty(Tv, "__esModule", { value: !0 }), Tv.retry = void 0;
  var e = Yt(), t = nr(), r = Ei(), n = jd(), a = qr();
  function i(o) {
    o === void 0 && (o = 1 / 0);
    var s;
    o && typeof o == "object" ? s = o : s = {
      count: o
    };
    var l = s.count, c = l === void 0 ? 1 / 0 : l, u = s.delay, d = s.resetOnSuccess, f = d === void 0 ? !1 : d;
    return c <= 0 ? r.identity : e.operate(function(m, h) {
      var g = 0, y, S = function() {
        var x = !1;
        y = m.subscribe(t.createOperatorSubscriber(h, function(b) {
          f && (g = 0), h.next(b);
        }, void 0, function(b) {
          if (g++ < c) {
            var _ = function() {
              y ? (y.unsubscribe(), y = null, S()) : x = !0;
            };
            if (u != null) {
              var $ = typeof u == "number" ? n.timer(u) : a.innerFrom(u(b, g)), w = t.createOperatorSubscriber(h, function() {
                w.unsubscribe(), _();
              }, function() {
                h.complete();
              });
              $.subscribe(w);
            } else
              _();
          } else
            h.error(b);
        })), x && (y.unsubscribe(), y = null, S());
      };
      S();
    });
  }
  return Tv.retry = i, Tv;
}
var Iv = {}, VL;
function Q5e() {
  if (VL) return Iv;
  VL = 1, Object.defineProperty(Iv, "__esModule", { value: !0 }), Iv.retryWhen = void 0;
  var e = qr(), t = wi(), r = Yt(), n = nr();
  function a(i) {
    return r.operate(function(o, s) {
      var l, c = !1, u, d = function() {
        l = o.subscribe(n.createOperatorSubscriber(s, void 0, void 0, function(f) {
          u || (u = new t.Subject(), e.innerFrom(i(u)).subscribe(n.createOperatorSubscriber(s, function() {
            return l ? d() : c = !0;
          }))), u && u.next(f);
        })), c && (l.unsubscribe(), l = null, c = !1, d());
      };
      d();
    });
  }
  return Iv.retryWhen = a, Iv;
}
var Mv = {}, GL;
function BQ() {
  if (GL) return Mv;
  GL = 1, Object.defineProperty(Mv, "__esModule", { value: !0 }), Mv.sample = void 0;
  var e = qr(), t = Yt(), r = _i(), n = nr();
  function a(i) {
    return t.operate(function(o, s) {
      var l = !1, c = null;
      o.subscribe(n.createOperatorSubscriber(s, function(u) {
        l = !0, c = u;
      })), e.innerFrom(i).subscribe(n.createOperatorSubscriber(s, function() {
        if (l) {
          l = !1;
          var u = c;
          c = null, s.next(u);
        }
      }, r.noop));
    });
  }
  return Mv.sample = a, Mv;
}
var Av = {}, Pv = {}, UL;
function eDe() {
  if (UL) return Pv;
  UL = 1, Object.defineProperty(Pv, "__esModule", { value: !0 }), Pv.interval = void 0;
  var e = po(), t = jd();
  function r(n, a) {
    return n === void 0 && (n = 0), a === void 0 && (a = e.asyncScheduler), n < 0 && (n = 0), t.timer(n, n, a);
  }
  return Pv.interval = r, Pv;
}
var WL;
function tDe() {
  if (WL) return Av;
  WL = 1, Object.defineProperty(Av, "__esModule", { value: !0 }), Av.sampleTime = void 0;
  var e = po(), t = BQ(), r = eDe();
  function n(a, i) {
    return i === void 0 && (i = e.asyncScheduler), t.sample(r.interval(a, i));
  }
  return Av.sampleTime = n, Av;
}
var Rv = {}, qL;
function rDe() {
  if (qL) return Rv;
  qL = 1, Object.defineProperty(Rv, "__esModule", { value: !0 }), Rv.scan = void 0;
  var e = Yt(), t = bQ();
  function r(n, a) {
    return e.operate(t.scanInternals(n, a, arguments.length >= 2, !0));
  }
  return Rv.scan = r, Rv;
}
var Nv = {}, KL;
function nDe() {
  if (KL) return Nv;
  KL = 1, Object.defineProperty(Nv, "__esModule", { value: !0 }), Nv.sequenceEqual = void 0;
  var e = Yt(), t = nr(), r = qr();
  function n(i, o) {
    return o === void 0 && (o = function(s, l) {
      return s === l;
    }), e.operate(function(s, l) {
      var c = a(), u = a(), d = function(m) {
        l.next(m), l.complete();
      }, f = function(m, h) {
        var g = t.createOperatorSubscriber(l, function(y) {
          var S = h.buffer, x = h.complete;
          S.length === 0 ? x ? d(!1) : m.buffer.push(y) : !o(y, S.shift()) && d(!1);
        }, function() {
          m.complete = !0;
          var y = h.complete, S = h.buffer;
          y && d(S.length === 0), g?.unsubscribe();
        });
        return g;
      };
      s.subscribe(f(c, u)), r.innerFrom(i).subscribe(f(u, c));
    });
  }
  Nv.sequenceEqual = n;
  function a() {
    return {
      buffer: [],
      complete: !1
    };
  }
  return Nv;
}
var Dv = {}, YL;
function zQ() {
  if (YL) return Dv;
  YL = 1;
  var e = Ue && Ue.__read || function(l, c) {
    var u = typeof Symbol == "function" && l[Symbol.iterator];
    if (!u) return l;
    var d = u.call(l), f, m = [], h;
    try {
      for (; (c === void 0 || c-- > 0) && !(f = d.next()).done; ) m.push(f.value);
    } catch (g) {
      h = { error: g };
    } finally {
      try {
        f && !f.done && (u = d.return) && u.call(d);
      } finally {
        if (h) throw h.error;
      }
    }
    return m;
  }, t = Ue && Ue.__spreadArray || function(l, c) {
    for (var u = 0, d = c.length, f = l.length; u < d; u++, f++)
      l[f] = c[u];
    return l;
  };
  Object.defineProperty(Dv, "__esModule", { value: !0 }), Dv.share = void 0;
  var r = qr(), n = wi(), a = DM(), i = Yt();
  function o(l) {
    l === void 0 && (l = {});
    var c = l.connector, u = c === void 0 ? function() {
      return new n.Subject();
    } : c, d = l.resetOnError, f = d === void 0 ? !0 : d, m = l.resetOnComplete, h = m === void 0 ? !0 : m, g = l.resetOnRefCountZero, y = g === void 0 ? !0 : g;
    return function(S) {
      var x, b, _, $ = 0, w = !1, O = !1, T = function() {
        b?.unsubscribe(), b = void 0;
      }, I = function() {
        T(), x = _ = void 0, w = O = !1;
      }, P = function() {
        var D = x;
        I(), D?.unsubscribe();
      };
      return i.operate(function(D, B) {
        $++, !O && !w && T();
        var L = _ = _ ?? u();
        B.add(function() {
          $--, $ === 0 && !O && !w && (b = s(P, y));
        }), L.subscribe(B), !x && $ > 0 && (x = new a.SafeSubscriber({
          next: function(N) {
            return L.next(N);
          },
          error: function(N) {
            O = !0, T(), b = s(I, f, N), L.error(N);
          },
          complete: function() {
            w = !0, T(), b = s(I, h), L.complete();
          }
        }), r.innerFrom(D).subscribe(x));
      })(S);
    };
  }
  Dv.share = o;
  function s(l, c) {
    for (var u = [], d = 2; d < arguments.length; d++)
      u[d - 2] = arguments[d];
    if (c === !0) {
      l();
      return;
    }
    if (c !== !1) {
      var f = new a.SafeSubscriber({
        next: function() {
          f.unsubscribe(), l();
        }
      });
      return r.innerFrom(c.apply(void 0, t([], e(u)))).subscribe(f);
    }
  }
  return Dv;
}
var jv = {}, ZL;
function aDe() {
  if (ZL) return jv;
  ZL = 1, Object.defineProperty(jv, "__esModule", { value: !0 }), jv.shareReplay = void 0;
  var e = kQ(), t = zQ();
  function r(n, a, i) {
    var o, s, l, c, u = !1;
    return n && typeof n == "object" ? (o = n.bufferSize, c = o === void 0 ? 1 / 0 : o, s = n.windowTime, a = s === void 0 ? 1 / 0 : s, l = n.refCount, u = l === void 0 ? !1 : l, i = n.scheduler) : c = n ?? 1 / 0, t.share({
      connector: function() {
        return new e.ReplaySubject(c, a, i);
      },
      resetOnError: !0,
      resetOnComplete: !1,
      resetOnRefCountZero: u
    });
  }
  return jv.shareReplay = r, jv;
}
var Lv = {}, kv = {}, XL;
function iDe() {
  if (XL) return kv;
  XL = 1, Object.defineProperty(kv, "__esModule", { value: !0 }), kv.SequenceError = void 0;
  var e = Uc();
  return kv.SequenceError = e.createErrorClass(function(t) {
    return function(n) {
      t(this), this.name = "SequenceError", this.message = n;
    };
  }), kv;
}
var Fv = {}, JL;
function oDe() {
  if (JL) return Fv;
  JL = 1, Object.defineProperty(Fv, "__esModule", { value: !0 }), Fv.NotFoundError = void 0;
  var e = Uc();
  return Fv.NotFoundError = e.createErrorClass(function(t) {
    return function(n) {
      t(this), this.name = "NotFoundError", this.message = n;
    };
  }), Fv;
}
var QL;
function sDe() {
  if (QL) return Lv;
  QL = 1, Object.defineProperty(Lv, "__esModule", { value: !0 }), Lv.single = void 0;
  var e = hC(), t = iDe(), r = oDe(), n = Yt(), a = nr();
  function i(o) {
    return n.operate(function(s, l) {
      var c = !1, u, d = !1, f = 0;
      s.subscribe(a.createOperatorSubscriber(l, function(m) {
        d = !0, (!o || o(m, f++, s)) && (c && l.error(new t.SequenceError("Too many matching values")), c = !0, u = m);
      }, function() {
        c ? (l.next(u), l.complete()) : l.error(d ? new r.NotFoundError("No matching values") : new e.EmptyError());
      }));
    });
  }
  return Lv.single = i, Lv;
}
var Bv = {}, e7;
function lDe() {
  if (e7) return Bv;
  e7 = 1, Object.defineProperty(Bv, "__esModule", { value: !0 }), Bv.skip = void 0;
  var e = Ld();
  function t(r) {
    return e.filter(function(n, a) {
      return r <= a;
    });
  }
  return Bv.skip = t, Bv;
}
var zv = {}, t7;
function cDe() {
  if (t7) return zv;
  t7 = 1, Object.defineProperty(zv, "__esModule", { value: !0 }), zv.skipLast = void 0;
  var e = Ei(), t = Yt(), r = nr();
  function n(a) {
    return a <= 0 ? e.identity : t.operate(function(i, o) {
      var s = new Array(a), l = 0;
      return i.subscribe(r.createOperatorSubscriber(o, function(c) {
        var u = l++;
        if (u < a)
          s[u] = c;
        else {
          var d = u % a, f = s[d];
          s[d] = c, o.next(f);
        }
      })), function() {
        s = null;
      };
    });
  }
  return zv.skipLast = n, zv;
}
var Hv = {}, r7;
function uDe() {
  if (r7) return Hv;
  r7 = 1, Object.defineProperty(Hv, "__esModule", { value: !0 }), Hv.skipUntil = void 0;
  var e = Yt(), t = nr(), r = qr(), n = _i();
  function a(i) {
    return e.operate(function(o, s) {
      var l = !1, c = t.createOperatorSubscriber(s, function() {
        c?.unsubscribe(), l = !0;
      }, n.noop);
      r.innerFrom(i).subscribe(c), o.subscribe(t.createOperatorSubscriber(s, function(u) {
        return l && s.next(u);
      }));
    });
  }
  return Hv.skipUntil = a, Hv;
}
var Vv = {}, n7;
function dDe() {
  if (n7) return Vv;
  n7 = 1, Object.defineProperty(Vv, "__esModule", { value: !0 }), Vv.skipWhile = void 0;
  var e = Yt(), t = nr();
  function r(n) {
    return e.operate(function(a, i) {
      var o = !1, s = 0;
      a.subscribe(t.createOperatorSubscriber(i, function(l) {
        return (o || (o = !n(l, s++))) && i.next(l);
      }));
    });
  }
  return Vv.skipWhile = r, Vv;
}
var Gv = {}, a7;
function fDe() {
  if (a7) return Gv;
  a7 = 1, Object.defineProperty(Gv, "__esModule", { value: !0 }), Gv.startWith = void 0;
  var e = KM(), t = Vo(), r = Yt();
  function n() {
    for (var a = [], i = 0; i < arguments.length; i++)
      a[i] = arguments[i];
    var o = t.popScheduler(a);
    return r.operate(function(s, l) {
      (o ? e.concat(a, s, o) : e.concat(a, s)).subscribe(l);
    });
  }
  return Gv.startWith = n, Gv;
}
var Uv = {}, Wv = {}, i7;
function yC() {
  if (i7) return Wv;
  i7 = 1, Object.defineProperty(Wv, "__esModule", { value: !0 }), Wv.switchMap = void 0;
  var e = qr(), t = Yt(), r = nr();
  function n(a, i) {
    return t.operate(function(o, s) {
      var l = null, c = 0, u = !1, d = function() {
        return u && !l && s.complete();
      };
      o.subscribe(r.createOperatorSubscriber(s, function(f) {
        l?.unsubscribe();
        var m = 0, h = c++;
        e.innerFrom(a(f, h)).subscribe(l = r.createOperatorSubscriber(s, function(g) {
          return s.next(i ? i(f, g, h, m++) : g);
        }, function() {
          l = null, d();
        }));
      }, function() {
        u = !0, d();
      }));
    });
  }
  return Wv.switchMap = n, Wv;
}
var o7;
function pDe() {
  if (o7) return Uv;
  o7 = 1, Object.defineProperty(Uv, "__esModule", { value: !0 }), Uv.switchAll = void 0;
  var e = yC(), t = Ei();
  function r() {
    return e.switchMap(t.identity);
  }
  return Uv.switchAll = r, Uv;
}
var qv = {}, s7;
function mDe() {
  if (s7) return qv;
  s7 = 1, Object.defineProperty(qv, "__esModule", { value: !0 }), qv.switchMapTo = void 0;
  var e = yC(), t = Pn();
  function r(n, a) {
    return t.isFunction(a) ? e.switchMap(function() {
      return n;
    }, a) : e.switchMap(function() {
      return n;
    });
  }
  return qv.switchMapTo = r, qv;
}
var Kv = {}, l7;
function vDe() {
  if (l7) return Kv;
  l7 = 1, Object.defineProperty(Kv, "__esModule", { value: !0 }), Kv.switchScan = void 0;
  var e = yC(), t = Yt();
  function r(n, a) {
    return t.operate(function(i, o) {
      var s = a;
      return e.switchMap(function(l, c) {
        return n(s, l, c);
      }, function(l, c) {
        return s = c, c;
      })(i).subscribe(o), function() {
        s = null;
      };
    });
  }
  return Kv.switchScan = r, Kv;
}
var Yv = {}, c7;
function hDe() {
  if (c7) return Yv;
  c7 = 1, Object.defineProperty(Yv, "__esModule", { value: !0 }), Yv.takeUntil = void 0;
  var e = Yt(), t = nr(), r = qr(), n = _i();
  function a(i) {
    return e.operate(function(o, s) {
      r.innerFrom(i).subscribe(t.createOperatorSubscriber(s, function() {
        return s.complete();
      }, n.noop)), !s.closed && o.subscribe(s);
    });
  }
  return Yv.takeUntil = a, Yv;
}
var Zv = {}, u7;
function gDe() {
  if (u7) return Zv;
  u7 = 1, Object.defineProperty(Zv, "__esModule", { value: !0 }), Zv.takeWhile = void 0;
  var e = Yt(), t = nr();
  function r(n, a) {
    return a === void 0 && (a = !1), e.operate(function(i, o) {
      var s = 0;
      i.subscribe(t.createOperatorSubscriber(o, function(l) {
        var c = n(l, s++);
        (c || a) && o.next(l), !c && o.complete();
      }));
    });
  }
  return Zv.takeWhile = r, Zv;
}
var Xv = {}, d7;
function yDe() {
  if (d7) return Xv;
  d7 = 1, Object.defineProperty(Xv, "__esModule", { value: !0 }), Xv.tap = void 0;
  var e = Pn(), t = Yt(), r = nr(), n = Ei();
  function a(i, o, s) {
    var l = e.isFunction(i) || o || s ? { next: i, error: o, complete: s } : i;
    return l ? t.operate(function(c, u) {
      var d;
      (d = l.subscribe) === null || d === void 0 || d.call(l);
      var f = !0;
      c.subscribe(r.createOperatorSubscriber(u, function(m) {
        var h;
        (h = l.next) === null || h === void 0 || h.call(l, m), u.next(m);
      }, function() {
        var m;
        f = !1, (m = l.complete) === null || m === void 0 || m.call(l), u.complete();
      }, function(m) {
        var h;
        f = !1, (h = l.error) === null || h === void 0 || h.call(l, m), u.error(m);
      }, function() {
        var m, h;
        f && ((m = l.unsubscribe) === null || m === void 0 || m.call(l)), (h = l.finalize) === null || h === void 0 || h.call(l);
      }));
    }) : n.identity;
  }
  return Xv.tap = a, Xv;
}
var Jv = {}, f7;
function HQ() {
  if (f7) return Jv;
  f7 = 1, Object.defineProperty(Jv, "__esModule", { value: !0 }), Jv.throttle = void 0;
  var e = Yt(), t = nr(), r = qr();
  function n(a, i) {
    return e.operate(function(o, s) {
      var l = i ?? {}, c = l.leading, u = c === void 0 ? !0 : c, d = l.trailing, f = d === void 0 ? !1 : d, m = !1, h = null, g = null, y = !1, S = function() {
        g?.unsubscribe(), g = null, f && (_(), y && s.complete());
      }, x = function() {
        g = null, y && s.complete();
      }, b = function($) {
        return g = r.innerFrom(a($)).subscribe(t.createOperatorSubscriber(s, S, x));
      }, _ = function() {
        if (m) {
          m = !1;
          var $ = h;
          h = null, s.next($), !y && b($);
        }
      };
      o.subscribe(t.createOperatorSubscriber(s, function($) {
        m = !0, h = $, !(g && !g.closed) && (u ? _() : b($));
      }, function() {
        y = !0, !(f && m && g && !g.closed) && s.complete();
      }));
    });
  }
  return Jv.throttle = n, Jv;
}
var Qv = {}, p7;
function bDe() {
  if (p7) return Qv;
  p7 = 1, Object.defineProperty(Qv, "__esModule", { value: !0 }), Qv.throttleTime = void 0;
  var e = po(), t = HQ(), r = jd();
  function n(a, i, o) {
    i === void 0 && (i = e.asyncScheduler);
    var s = r.timer(a, i);
    return t.throttle(function() {
      return s;
    }, o);
  }
  return Qv.throttleTime = n, Qv;
}
var ac = {}, m7;
function CDe() {
  if (m7) return ac;
  m7 = 1, Object.defineProperty(ac, "__esModule", { value: !0 }), ac.TimeInterval = ac.timeInterval = void 0;
  var e = po(), t = Yt(), r = nr();
  function n(i) {
    return i === void 0 && (i = e.asyncScheduler), t.operate(function(o, s) {
      var l = i.now();
      o.subscribe(r.createOperatorSubscriber(s, function(c) {
        var u = i.now(), d = u - l;
        l = u, s.next(new a(c, d));
      }));
    });
  }
  ac.timeInterval = n;
  var a = /* @__PURE__ */ function() {
    function i(o, s) {
      this.value = o, this.interval = s;
    }
    return i;
  }();
  return ac.TimeInterval = a, ac;
}
var k_ = {}, v7;
function VQ() {
  return v7 || (v7 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.timeout = e.TimeoutError = void 0;
    var t = po(), r = BM(), n = Yt(), a = qr(), i = Uc(), o = nr(), s = Al();
    e.TimeoutError = i.createErrorClass(function(u) {
      return function(f) {
        f === void 0 && (f = null), u(this), this.message = "Timeout has occurred", this.name = "TimeoutError", this.info = f;
      };
    });
    function l(u, d) {
      var f = r.isValidDate(u) ? { first: u } : typeof u == "number" ? { each: u } : u, m = f.first, h = f.each, g = f.with, y = g === void 0 ? c : g, S = f.scheduler, x = S === void 0 ? d ?? t.asyncScheduler : S, b = f.meta, _ = b === void 0 ? null : b;
      if (m == null && h == null)
        throw new TypeError("No timeout provided.");
      return n.operate(function($, w) {
        var O, T, I = null, P = 0, D = function(B) {
          T = s.executeSchedule(w, x, function() {
            try {
              O.unsubscribe(), a.innerFrom(y({
                meta: _,
                lastValue: I,
                seen: P
              })).subscribe(w);
            } catch (L) {
              w.error(L);
            }
          }, B);
        };
        O = $.subscribe(o.createOperatorSubscriber(w, function(B) {
          T?.unsubscribe(), P++, w.next(I = B), h > 0 && D(h);
        }, void 0, void 0, function() {
          T?.closed || T?.unsubscribe(), I = null;
        })), !P && D(m != null ? typeof m == "number" ? m : +m - x.now() : h);
      });
    }
    e.timeout = l;
    function c(u) {
      throw new e.TimeoutError(u);
    }
  }(k_)), k_;
}
var e0 = {}, h7;
function SDe() {
  if (h7) return e0;
  h7 = 1, Object.defineProperty(e0, "__esModule", { value: !0 }), e0.timeoutWith = void 0;
  var e = po(), t = BM(), r = VQ();
  function n(a, i, o) {
    var s, l, c;
    if (o = o ?? e.async, t.isValidDate(a) ? s = a : typeof a == "number" && (l = a), i)
      c = function() {
        return i;
      };
    else
      throw new TypeError("No observable provided to switch to");
    if (s == null && l == null)
      throw new TypeError("No timeout provided.");
    return r.timeout({
      first: s,
      each: l,
      scheduler: o,
      with: c
    });
  }
  return e0.timeoutWith = n, e0;
}
var t0 = {}, g7;
function xDe() {
  if (g7) return t0;
  g7 = 1, Object.defineProperty(t0, "__esModule", { value: !0 }), t0.timestamp = void 0;
  var e = FM(), t = Wc();
  function r(n) {
    return n === void 0 && (n = e.dateTimestampProvider), t.map(function(a) {
      return { value: a, timestamp: n.now() };
    });
  }
  return t0.timestamp = r, t0;
}
var r0 = {}, y7;
function $De() {
  if (y7) return r0;
  y7 = 1, Object.defineProperty(r0, "__esModule", { value: !0 }), r0.window = void 0;
  var e = wi(), t = Yt(), r = nr(), n = _i(), a = qr();
  function i(o) {
    return t.operate(function(s, l) {
      var c = new e.Subject();
      l.next(c.asObservable());
      var u = function(d) {
        c.error(d), l.error(d);
      };
      return s.subscribe(r.createOperatorSubscriber(l, function(d) {
        return c?.next(d);
      }, function() {
        c.complete(), l.complete();
      }, u)), a.innerFrom(o).subscribe(r.createOperatorSubscriber(l, function() {
        c.complete(), l.next(c = new e.Subject());
      }, n.noop, u)), function() {
        c?.unsubscribe(), c = null;
      };
    });
  }
  return r0.window = i, r0;
}
var n0 = {}, b7;
function _De() {
  if (b7) return n0;
  b7 = 1;
  var e = Ue && Ue.__values || function(i) {
    var o = typeof Symbol == "function" && Symbol.iterator, s = o && i[o], l = 0;
    if (s) return s.call(i);
    if (i && typeof i.length == "number") return {
      next: function() {
        return i && l >= i.length && (i = void 0), { value: i && i[l++], done: !i };
      }
    };
    throw new TypeError(o ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(n0, "__esModule", { value: !0 }), n0.windowCount = void 0;
  var t = wi(), r = Yt(), n = nr();
  function a(i, o) {
    o === void 0 && (o = 0);
    var s = o > 0 ? o : i;
    return r.operate(function(l, c) {
      var u = [new t.Subject()], d = 0;
      c.next(u[0].asObservable()), l.subscribe(n.createOperatorSubscriber(c, function(f) {
        var m, h;
        try {
          for (var g = e(u), y = g.next(); !y.done; y = g.next()) {
            var S = y.value;
            S.next(f);
          }
        } catch (_) {
          m = { error: _ };
        } finally {
          try {
            y && !y.done && (h = g.return) && h.call(g);
          } finally {
            if (m) throw m.error;
          }
        }
        var x = d - i + 1;
        if (x >= 0 && x % s === 0 && u.shift().complete(), ++d % s === 0) {
          var b = new t.Subject();
          u.push(b), c.next(b.asObservable());
        }
      }, function() {
        for (; u.length > 0; )
          u.shift().complete();
        c.complete();
      }, function(f) {
        for (; u.length > 0; )
          u.shift().error(f);
        c.error(f);
      }, function() {
        u = null;
      }));
    });
  }
  return n0.windowCount = a, n0;
}
var a0 = {}, C7;
function EDe() {
  if (C7) return a0;
  C7 = 1, Object.defineProperty(a0, "__esModule", { value: !0 }), a0.windowTime = void 0;
  var e = wi(), t = po(), r = Xs(), n = Yt(), a = nr(), i = Ml(), o = Vo(), s = Al();
  function l(c) {
    for (var u, d, f = [], m = 1; m < arguments.length; m++)
      f[m - 1] = arguments[m];
    var h = (u = o.popScheduler(f)) !== null && u !== void 0 ? u : t.asyncScheduler, g = (d = f[0]) !== null && d !== void 0 ? d : null, y = f[1] || 1 / 0;
    return n.operate(function(S, x) {
      var b = [], _ = !1, $ = function(I) {
        var P = I.window, D = I.subs;
        P.complete(), D.unsubscribe(), i.arrRemove(b, I), _ && w();
      }, w = function() {
        if (b) {
          var I = new r.Subscription();
          x.add(I);
          var P = new e.Subject(), D = {
            window: P,
            subs: I,
            seen: 0
          };
          b.push(D), x.next(P.asObservable()), s.executeSchedule(I, h, function() {
            return $(D);
          }, c);
        }
      };
      g !== null && g >= 0 ? s.executeSchedule(x, h, w, g, !0) : _ = !0, w();
      var O = function(I) {
        return b.slice().forEach(I);
      }, T = function(I) {
        O(function(P) {
          var D = P.window;
          return I(D);
        }), I(x), x.unsubscribe();
      };
      return S.subscribe(a.createOperatorSubscriber(x, function(I) {
        O(function(P) {
          P.window.next(I), y <= ++P.seen && $(P);
        });
      }, function() {
        return T(function(I) {
          return I.complete();
        });
      }, function(I) {
        return T(function(P) {
          return P.error(I);
        });
      })), function() {
        b = null;
      };
    });
  }
  return a0.windowTime = l, a0;
}
var i0 = {}, S7;
function wDe() {
  if (S7) return i0;
  S7 = 1;
  var e = Ue && Ue.__values || function(c) {
    var u = typeof Symbol == "function" && Symbol.iterator, d = u && c[u], f = 0;
    if (d) return d.call(c);
    if (c && typeof c.length == "number") return {
      next: function() {
        return c && f >= c.length && (c = void 0), { value: c && c[f++], done: !c };
      }
    };
    throw new TypeError(u ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(i0, "__esModule", { value: !0 }), i0.windowToggle = void 0;
  var t = wi(), r = Xs(), n = Yt(), a = qr(), i = nr(), o = _i(), s = Ml();
  function l(c, u) {
    return n.operate(function(d, f) {
      var m = [], h = function(g) {
        for (; 0 < m.length; )
          m.shift().error(g);
        f.error(g);
      };
      a.innerFrom(c).subscribe(i.createOperatorSubscriber(f, function(g) {
        var y = new t.Subject();
        m.push(y);
        var S = new r.Subscription(), x = function() {
          s.arrRemove(m, y), y.complete(), S.unsubscribe();
        }, b;
        try {
          b = a.innerFrom(u(g));
        } catch (_) {
          h(_);
          return;
        }
        f.next(y.asObservable()), S.add(b.subscribe(i.createOperatorSubscriber(f, x, o.noop, h)));
      }, o.noop)), d.subscribe(i.createOperatorSubscriber(f, function(g) {
        var y, S, x = m.slice();
        try {
          for (var b = e(x), _ = b.next(); !_.done; _ = b.next()) {
            var $ = _.value;
            $.next(g);
          }
        } catch (w) {
          y = { error: w };
        } finally {
          try {
            _ && !_.done && (S = b.return) && S.call(b);
          } finally {
            if (y) throw y.error;
          }
        }
      }, function() {
        for (; 0 < m.length; )
          m.shift().complete();
        f.complete();
      }, h, function() {
        for (; 0 < m.length; )
          m.shift().unsubscribe();
      }));
    });
  }
  return i0.windowToggle = l, i0;
}
var o0 = {}, x7;
function ODe() {
  if (x7) return o0;
  x7 = 1, Object.defineProperty(o0, "__esModule", { value: !0 }), o0.windowWhen = void 0;
  var e = wi(), t = Yt(), r = nr(), n = qr();
  function a(i) {
    return t.operate(function(o, s) {
      var l, c, u = function(f) {
        l.error(f), s.error(f);
      }, d = function() {
        c?.unsubscribe(), l?.complete(), l = new e.Subject(), s.next(l.asObservable());
        var f;
        try {
          f = n.innerFrom(i());
        } catch (m) {
          u(m);
          return;
        }
        f.subscribe(c = r.createOperatorSubscriber(s, d, d, u));
      };
      d(), o.subscribe(r.createOperatorSubscriber(s, function(f) {
        return l.next(f);
      }, function() {
        l.complete(), s.complete();
      }, u, function() {
        c?.unsubscribe(), l = null;
      }));
    });
  }
  return o0.windowWhen = a, o0;
}
var s0 = {}, $7;
function TDe() {
  if ($7) return s0;
  $7 = 1;
  var e = Ue && Ue.__read || function(c, u) {
    var d = typeof Symbol == "function" && c[Symbol.iterator];
    if (!d) return c;
    var f = d.call(c), m, h = [], g;
    try {
      for (; (u === void 0 || u-- > 0) && !(m = f.next()).done; ) h.push(m.value);
    } catch (y) {
      g = { error: y };
    } finally {
      try {
        m && !m.done && (d = f.return) && d.call(f);
      } finally {
        if (g) throw g.error;
      }
    }
    return h;
  }, t = Ue && Ue.__spreadArray || function(c, u) {
    for (var d = 0, f = u.length, m = c.length; d < f; d++, m++)
      c[m] = u[d];
    return c;
  };
  Object.defineProperty(s0, "__esModule", { value: !0 }), s0.withLatestFrom = void 0;
  var r = Yt(), n = nr(), a = qr(), i = Ei(), o = _i(), s = Vo();
  function l() {
    for (var c = [], u = 0; u < arguments.length; u++)
      c[u] = arguments[u];
    var d = s.popResultSelector(c);
    return r.operate(function(f, m) {
      for (var h = c.length, g = new Array(h), y = c.map(function() {
        return !1;
      }), S = !1, x = function(_) {
        a.innerFrom(c[_]).subscribe(n.createOperatorSubscriber(m, function($) {
          g[_] = $, !S && !y[_] && (y[_] = !0, (S = y.every(i.identity)) && (y = null));
        }, o.noop));
      }, b = 0; b < h; b++)
        x(b);
      f.subscribe(n.createOperatorSubscriber(m, function(_) {
        if (S) {
          var $ = t([_], e(g));
          m.next(d ? d.apply(void 0, t([], e($))) : $);
        }
      }));
    });
  }
  return s0.withLatestFrom = l, s0;
}
var l0 = {}, c0 = {}, _7;
function GQ() {
  if (_7) return c0;
  _7 = 1;
  var e = Ue && Ue.__read || function(c, u) {
    var d = typeof Symbol == "function" && c[Symbol.iterator];
    if (!d) return c;
    var f = d.call(c), m, h = [], g;
    try {
      for (; (u === void 0 || u-- > 0) && !(m = f.next()).done; ) h.push(m.value);
    } catch (y) {
      g = { error: y };
    } finally {
      try {
        m && !m.done && (d = f.return) && d.call(f);
      } finally {
        if (g) throw g.error;
      }
    }
    return h;
  }, t = Ue && Ue.__spreadArray || function(c, u) {
    for (var d = 0, f = u.length, m = c.length; d < f; d++, m++)
      c[m] = u[d];
    return c;
  };
  Object.defineProperty(c0, "__esModule", { value: !0 }), c0.zip = void 0;
  var r = ci(), n = qr(), a = Kc(), i = Gh(), o = nr(), s = Vo();
  function l() {
    for (var c = [], u = 0; u < arguments.length; u++)
      c[u] = arguments[u];
    var d = s.popResultSelector(c), f = a.argsOrArgArray(c);
    return f.length ? new r.Observable(function(m) {
      var h = f.map(function() {
        return [];
      }), g = f.map(function() {
        return !1;
      });
      m.add(function() {
        h = g = null;
      });
      for (var y = function(x) {
        n.innerFrom(f[x]).subscribe(o.createOperatorSubscriber(m, function(b) {
          if (h[x].push(b), h.every(function($) {
            return $.length;
          })) {
            var _ = h.map(function($) {
              return $.shift();
            });
            m.next(d ? d.apply(void 0, t([], e(_))) : _), h.some(function($, w) {
              return !$.length && g[w];
            }) && m.complete();
          }
        }, function() {
          g[x] = !0, !h[x].length && m.complete();
        }));
      }, S = 0; !m.closed && S < f.length; S++)
        y(S);
      return function() {
        h = g = null;
      };
    }) : i.EMPTY;
  }
  return c0.zip = l, c0;
}
var E7;
function UQ() {
  if (E7) return l0;
  E7 = 1;
  var e = Ue && Ue.__read || function(i, o) {
    var s = typeof Symbol == "function" && i[Symbol.iterator];
    if (!s) return i;
    var l = s.call(i), c, u = [], d;
    try {
      for (; (o === void 0 || o-- > 0) && !(c = l.next()).done; ) u.push(c.value);
    } catch (f) {
      d = { error: f };
    } finally {
      try {
        c && !c.done && (s = l.return) && s.call(l);
      } finally {
        if (d) throw d.error;
      }
    }
    return u;
  }, t = Ue && Ue.__spreadArray || function(i, o) {
    for (var s = 0, l = o.length, c = i.length; s < l; s++, c++)
      i[c] = o[s];
    return i;
  };
  Object.defineProperty(l0, "__esModule", { value: !0 }), l0.zip = void 0;
  var r = GQ(), n = Yt();
  function a() {
    for (var i = [], o = 0; o < arguments.length; o++)
      i[o] = arguments[o];
    return n.operate(function(s, l) {
      r.zip.apply(void 0, t([s], e(i))).subscribe(l);
    });
  }
  return l0.zip = a, l0;
}
var u0 = {}, w7;
function IDe() {
  if (w7) return u0;
  w7 = 1, Object.defineProperty(u0, "__esModule", { value: !0 }), u0.zipAll = void 0;
  var e = GQ(), t = SQ();
  function r(n) {
    return t.joinAllInternals(e.zip, n);
  }
  return u0.zipAll = r, u0;
}
var d0 = {}, O7;
function MDe() {
  if (O7) return d0;
  O7 = 1;
  var e = Ue && Ue.__read || function(a, i) {
    var o = typeof Symbol == "function" && a[Symbol.iterator];
    if (!o) return a;
    var s = o.call(a), l, c = [], u;
    try {
      for (; (i === void 0 || i-- > 0) && !(l = s.next()).done; ) c.push(l.value);
    } catch (d) {
      u = { error: d };
    } finally {
      try {
        l && !l.done && (o = s.return) && o.call(s);
      } finally {
        if (u) throw u.error;
      }
    }
    return c;
  }, t = Ue && Ue.__spreadArray || function(a, i) {
    for (var o = 0, s = i.length, l = a.length; o < s; o++, l++)
      a[l] = i[o];
    return a;
  };
  Object.defineProperty(d0, "__esModule", { value: !0 }), d0.zipWith = void 0;
  var r = UQ();
  function n() {
    for (var a = [], i = 0; i < arguments.length; i++)
      a[i] = arguments[i];
    return r.zip.apply(void 0, t([], e(a)));
  }
  return d0.zipWith = n, d0;
}
var T7;
function ADe() {
  return T7 || (T7 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.mergeAll = e.merge = e.max = e.materialize = e.mapTo = e.map = e.last = e.isEmpty = e.ignoreElements = e.groupBy = e.first = e.findIndex = e.find = e.finalize = e.filter = e.expand = e.exhaustMap = e.exhaustAll = e.exhaust = e.every = e.endWith = e.elementAt = e.distinctUntilKeyChanged = e.distinctUntilChanged = e.distinct = e.dematerialize = e.delayWhen = e.delay = e.defaultIfEmpty = e.debounceTime = e.debounce = e.count = e.connect = e.concatWith = e.concatMapTo = e.concatMap = e.concatAll = e.concat = e.combineLatestWith = e.combineLatest = e.combineLatestAll = e.combineAll = e.catchError = e.bufferWhen = e.bufferToggle = e.bufferTime = e.bufferCount = e.buffer = e.auditTime = e.audit = void 0, e.timeInterval = e.throwIfEmpty = e.throttleTime = e.throttle = e.tap = e.takeWhile = e.takeUntil = e.takeLast = e.take = e.switchScan = e.switchMapTo = e.switchMap = e.switchAll = e.subscribeOn = e.startWith = e.skipWhile = e.skipUntil = e.skipLast = e.skip = e.single = e.shareReplay = e.share = e.sequenceEqual = e.scan = e.sampleTime = e.sample = e.refCount = e.retryWhen = e.retry = e.repeatWhen = e.repeat = e.reduce = e.raceWith = e.race = e.publishReplay = e.publishLast = e.publishBehavior = e.publish = e.pluck = e.partition = e.pairwise = e.onErrorResumeNext = e.observeOn = e.multicast = e.min = e.mergeWith = e.mergeScan = e.mergeMapTo = e.mergeMap = e.flatMap = void 0, e.zipWith = e.zipAll = e.zip = e.withLatestFrom = e.windowWhen = e.windowToggle = e.windowTime = e.windowCount = e.window = e.toArray = e.timestamp = e.timeoutWith = e.timeout = void 0;
    var t = vQ();
    Object.defineProperty(e, "audit", { enumerable: !0, get: function() {
      return t.audit;
    } });
    var r = H8e();
    Object.defineProperty(e, "auditTime", { enumerable: !0, get: function() {
      return r.auditTime;
    } });
    var n = V8e();
    Object.defineProperty(e, "buffer", { enumerable: !0, get: function() {
      return n.buffer;
    } });
    var a = G8e();
    Object.defineProperty(e, "bufferCount", { enumerable: !0, get: function() {
      return a.bufferCount;
    } });
    var i = U8e();
    Object.defineProperty(e, "bufferTime", { enumerable: !0, get: function() {
      return i.bufferTime;
    } });
    var o = W8e();
    Object.defineProperty(e, "bufferToggle", { enumerable: !0, get: function() {
      return o.bufferToggle;
    } });
    var s = q8e();
    Object.defineProperty(e, "bufferWhen", { enumerable: !0, get: function() {
      return s.bufferWhen;
    } });
    var l = K8e();
    Object.defineProperty(e, "catchError", { enumerable: !0, get: function() {
      return l.catchError;
    } });
    var c = n5e();
    Object.defineProperty(e, "combineAll", { enumerable: !0, get: function() {
      return c.combineAll;
    } });
    var u = xQ();
    Object.defineProperty(e, "combineLatestAll", { enumerable: !0, get: function() {
      return u.combineLatestAll;
    } });
    var d = $Q();
    Object.defineProperty(e, "combineLatest", { enumerable: !0, get: function() {
      return d.combineLatest;
    } });
    var f = a5e();
    Object.defineProperty(e, "combineLatestWith", { enumerable: !0, get: function() {
      return f.combineLatestWith;
    } });
    var m = _Q();
    Object.defineProperty(e, "concat", { enumerable: !0, get: function() {
      return m.concat;
    } });
    var h = WM();
    Object.defineProperty(e, "concatAll", { enumerable: !0, get: function() {
      return h.concatAll;
    } });
    var g = EQ();
    Object.defineProperty(e, "concatMap", { enumerable: !0, get: function() {
      return g.concatMap;
    } });
    var y = i5e();
    Object.defineProperty(e, "concatMapTo", { enumerable: !0, get: function() {
      return y.concatMapTo;
    } });
    var S = o5e();
    Object.defineProperty(e, "concatWith", { enumerable: !0, get: function() {
      return S.concatWith;
    } });
    var x = qM();
    Object.defineProperty(e, "connect", { enumerable: !0, get: function() {
      return x.connect;
    } });
    var b = c5e();
    Object.defineProperty(e, "count", { enumerable: !0, get: function() {
      return b.count;
    } });
    var _ = u5e();
    Object.defineProperty(e, "debounce", { enumerable: !0, get: function() {
      return _.debounce;
    } });
    var $ = d5e();
    Object.defineProperty(e, "debounceTime", { enumerable: !0, get: function() {
      return $.debounceTime;
    } });
    var w = mC();
    Object.defineProperty(e, "defaultIfEmpty", { enumerable: !0, get: function() {
      return w.defaultIfEmpty;
    } });
    var O = f5e();
    Object.defineProperty(e, "delay", { enumerable: !0, get: function() {
      return O.delay;
    } });
    var T = TQ();
    Object.defineProperty(e, "delayWhen", { enumerable: !0, get: function() {
      return T.delayWhen;
    } });
    var I = m5e();
    Object.defineProperty(e, "dematerialize", { enumerable: !0, get: function() {
      return I.dematerialize;
    } });
    var P = v5e();
    Object.defineProperty(e, "distinct", { enumerable: !0, get: function() {
      return P.distinct;
    } });
    var D = AQ();
    Object.defineProperty(e, "distinctUntilChanged", { enumerable: !0, get: function() {
      return D.distinctUntilChanged;
    } });
    var B = h5e();
    Object.defineProperty(e, "distinctUntilKeyChanged", { enumerable: !0, get: function() {
      return B.distinctUntilKeyChanged;
    } });
    var L = y5e();
    Object.defineProperty(e, "elementAt", { enumerable: !0, get: function() {
      return L.elementAt;
    } });
    var N = b5e();
    Object.defineProperty(e, "endWith", { enumerable: !0, get: function() {
      return N.endWith;
    } });
    var z = C5e();
    Object.defineProperty(e, "every", { enumerable: !0, get: function() {
      return z.every;
    } });
    var F = S5e();
    Object.defineProperty(e, "exhaust", { enumerable: !0, get: function() {
      return F.exhaust;
    } });
    var j = RQ();
    Object.defineProperty(e, "exhaustAll", { enumerable: !0, get: function() {
      return j.exhaustAll;
    } });
    var H = PQ();
    Object.defineProperty(e, "exhaustMap", { enumerable: !0, get: function() {
      return H.exhaustMap;
    } });
    var U = x5e();
    Object.defineProperty(e, "expand", { enumerable: !0, get: function() {
      return U.expand;
    } });
    var G = Ld();
    Object.defineProperty(e, "filter", { enumerable: !0, get: function() {
      return G.filter;
    } });
    var V = $5e();
    Object.defineProperty(e, "finalize", { enumerable: !0, get: function() {
      return V.finalize;
    } });
    var K = NQ();
    Object.defineProperty(e, "find", { enumerable: !0, get: function() {
      return K.find;
    } });
    var Z = _5e();
    Object.defineProperty(e, "findIndex", { enumerable: !0, get: function() {
      return Z.findIndex;
    } });
    var ee = E5e();
    Object.defineProperty(e, "first", { enumerable: !0, get: function() {
      return ee.first;
    } });
    var ae = w5e();
    Object.defineProperty(e, "groupBy", { enumerable: !0, get: function() {
      return ae.groupBy;
    } });
    var ue = wQ();
    Object.defineProperty(e, "ignoreElements", { enumerable: !0, get: function() {
      return ue.ignoreElements;
    } });
    var re = O5e();
    Object.defineProperty(e, "isEmpty", { enumerable: !0, get: function() {
      return re.isEmpty;
    } });
    var oe = T5e();
    Object.defineProperty(e, "last", { enumerable: !0, get: function() {
      return oe.last;
    } });
    var fe = Wc();
    Object.defineProperty(e, "map", { enumerable: !0, get: function() {
      return fe.map;
    } });
    var le = OQ();
    Object.defineProperty(e, "mapTo", { enumerable: !0, get: function() {
      return le.mapTo;
    } });
    var se = I5e();
    Object.defineProperty(e, "materialize", { enumerable: !0, get: function() {
      return se.materialize;
    } });
    var Q = M5e();
    Object.defineProperty(e, "max", { enumerable: !0, get: function() {
      return Q.max;
    } });
    var he = jQ();
    Object.defineProperty(e, "merge", { enumerable: !0, get: function() {
      return he.merge;
    } });
    var ne = UM();
    Object.defineProperty(e, "mergeAll", { enumerable: !0, get: function() {
      return ne.mergeAll;
    } });
    var me = A5e();
    Object.defineProperty(e, "flatMap", { enumerable: !0, get: function() {
      return me.flatMap;
    } });
    var k = qc();
    Object.defineProperty(e, "mergeMap", { enumerable: !0, get: function() {
      return k.mergeMap;
    } });
    var M = P5e();
    Object.defineProperty(e, "mergeMapTo", { enumerable: !0, get: function() {
      return M.mergeMapTo;
    } });
    var R = R5e();
    Object.defineProperty(e, "mergeScan", { enumerable: !0, get: function() {
      return R.mergeScan;
    } });
    var q = N5e();
    Object.defineProperty(e, "mergeWith", { enumerable: !0, get: function() {
      return q.mergeWith;
    } });
    var Y = D5e();
    Object.defineProperty(e, "min", { enumerable: !0, get: function() {
      return Y.min;
    } });
    var X = ZM();
    Object.defineProperty(e, "multicast", { enumerable: !0, get: function() {
      return X.multicast;
    } });
    var pe = zM();
    Object.defineProperty(e, "observeOn", { enumerable: !0, get: function() {
      return pe.observeOn;
    } });
    var $e = L5e();
    Object.defineProperty(e, "onErrorResumeNext", { enumerable: !0, get: function() {
      return $e.onErrorResumeNext;
    } });
    var J = k5e();
    Object.defineProperty(e, "pairwise", { enumerable: !0, get: function() {
      return J.pairwise;
    } });
    var de = B5e();
    Object.defineProperty(e, "partition", { enumerable: !0, get: function() {
      return de.partition;
    } });
    var Se = z5e();
    Object.defineProperty(e, "pluck", { enumerable: !0, get: function() {
      return Se.pluck;
    } });
    var Ee = H5e();
    Object.defineProperty(e, "publish", { enumerable: !0, get: function() {
      return Ee.publish;
    } });
    var Te = G5e();
    Object.defineProperty(e, "publishBehavior", { enumerable: !0, get: function() {
      return Te.publishBehavior;
    } });
    var Le = W5e();
    Object.defineProperty(e, "publishLast", { enumerable: !0, get: function() {
      return Le.publishLast;
    } });
    var Ie = q5e();
    Object.defineProperty(e, "publishReplay", { enumerable: !0, get: function() {
      return Ie.publishReplay;
    } });
    var De = Y5e();
    Object.defineProperty(e, "race", { enumerable: !0, get: function() {
      return De.race;
    } });
    var Ae = FQ();
    Object.defineProperty(e, "raceWith", { enumerable: !0, get: function() {
      return Ae.raceWith;
    } });
    var Fe = Vh();
    Object.defineProperty(e, "reduce", { enumerable: !0, get: function() {
      return Fe.reduce;
    } });
    var Ne = Z5e();
    Object.defineProperty(e, "repeat", { enumerable: !0, get: function() {
      return Ne.repeat;
    } });
    var qe = X5e();
    Object.defineProperty(e, "repeatWhen", { enumerable: !0, get: function() {
      return qe.repeatWhen;
    } });
    var Qe = J5e();
    Object.defineProperty(e, "retry", { enumerable: !0, get: function() {
      return Qe.retry;
    } });
    var tt = Q5e();
    Object.defineProperty(e, "retryWhen", { enumerable: !0, get: function() {
      return tt.retryWhen;
    } });
    var Ge = LQ();
    Object.defineProperty(e, "refCount", { enumerable: !0, get: function() {
      return Ge.refCount;
    } });
    var it = BQ();
    Object.defineProperty(e, "sample", { enumerable: !0, get: function() {
      return it.sample;
    } });
    var ht = tDe();
    Object.defineProperty(e, "sampleTime", { enumerable: !0, get: function() {
      return ht.sampleTime;
    } });
    var It = rDe();
    Object.defineProperty(e, "scan", { enumerable: !0, get: function() {
      return It.scan;
    } });
    var xt = nDe();
    Object.defineProperty(e, "sequenceEqual", { enumerable: !0, get: function() {
      return xt.sequenceEqual;
    } });
    var Xe = zQ();
    Object.defineProperty(e, "share", { enumerable: !0, get: function() {
      return Xe.share;
    } });
    var pt = aDe();
    Object.defineProperty(e, "shareReplay", { enumerable: !0, get: function() {
      return pt.shareReplay;
    } });
    var Ze = sDe();
    Object.defineProperty(e, "single", { enumerable: !0, get: function() {
      return Ze.single;
    } });
    var wt = lDe();
    Object.defineProperty(e, "skip", { enumerable: !0, get: function() {
      return wt.skip;
    } });
    var bt = cDe();
    Object.defineProperty(e, "skipLast", { enumerable: !0, get: function() {
      return bt.skipLast;
    } });
    var Je = uDe();
    Object.defineProperty(e, "skipUntil", { enumerable: !0, get: function() {
      return Je.skipUntil;
    } });
    var _t = dDe();
    Object.defineProperty(e, "skipWhile", { enumerable: !0, get: function() {
      return _t.skipWhile;
    } });
    var Vt = fDe();
    Object.defineProperty(e, "startWith", { enumerable: !0, get: function() {
      return Vt.startWith;
    } });
    var ot = HM();
    Object.defineProperty(e, "subscribeOn", { enumerable: !0, get: function() {
      return ot.subscribeOn;
    } });
    var Ct = pDe();
    Object.defineProperty(e, "switchAll", { enumerable: !0, get: function() {
      return Ct.switchAll;
    } });
    var rt = yC();
    Object.defineProperty(e, "switchMap", { enumerable: !0, get: function() {
      return rt.switchMap;
    } });
    var $t = mDe();
    Object.defineProperty(e, "switchMapTo", { enumerable: !0, get: function() {
      return $t.switchMapTo;
    } });
    var Wt = vDe();
    Object.defineProperty(e, "switchScan", { enumerable: !0, get: function() {
      return Wt.switchScan;
    } });
    var _e = vC();
    Object.defineProperty(e, "take", { enumerable: !0, get: function() {
      return _e.take;
    } });
    var Ke = DQ();
    Object.defineProperty(e, "takeLast", { enumerable: !0, get: function() {
      return Ke.takeLast;
    } });
    var nt = hDe();
    Object.defineProperty(e, "takeUntil", { enumerable: !0, get: function() {
      return nt.takeUntil;
    } });
    var Ve = gDe();
    Object.defineProperty(e, "takeWhile", { enumerable: !0, get: function() {
      return Ve.takeWhile;
    } });
    var ke = yDe();
    Object.defineProperty(e, "tap", { enumerable: !0, get: function() {
      return ke.tap;
    } });
    var ut = HQ();
    Object.defineProperty(e, "throttle", { enumerable: !0, get: function() {
      return ut.throttle;
    } });
    var st = bDe();
    Object.defineProperty(e, "throttleTime", { enumerable: !0, get: function() {
      return st.throttleTime;
    } });
    var Et = gC();
    Object.defineProperty(e, "throwIfEmpty", { enumerable: !0, get: function() {
      return Et.throwIfEmpty;
    } });
    var zt = CDe();
    Object.defineProperty(e, "timeInterval", { enumerable: !0, get: function() {
      return zt.timeInterval;
    } });
    var Be = VQ();
    Object.defineProperty(e, "timeout", { enumerable: !0, get: function() {
      return Be.timeout;
    } });
    var ft = SDe();
    Object.defineProperty(e, "timeoutWith", { enumerable: !0, get: function() {
      return ft.timeoutWith;
    } });
    var yt = xDe();
    Object.defineProperty(e, "timestamp", { enumerable: !0, get: function() {
      return yt.timestamp;
    } });
    var Rt = CQ();
    Object.defineProperty(e, "toArray", { enumerable: !0, get: function() {
      return Rt.toArray;
    } });
    var Ht = $De();
    Object.defineProperty(e, "window", { enumerable: !0, get: function() {
      return Ht.window;
    } });
    var ir = _De();
    Object.defineProperty(e, "windowCount", { enumerable: !0, get: function() {
      return ir.windowCount;
    } });
    var ar = EDe();
    Object.defineProperty(e, "windowTime", { enumerable: !0, get: function() {
      return ar.windowTime;
    } });
    var Nr = wDe();
    Object.defineProperty(e, "windowToggle", { enumerable: !0, get: function() {
      return Nr.windowToggle;
    } });
    var Xr = ODe();
    Object.defineProperty(e, "windowWhen", { enumerable: !0, get: function() {
      return Xr.windowWhen;
    } });
    var Qr = TDe();
    Object.defineProperty(e, "withLatestFrom", { enumerable: !0, get: function() {
      return Qr.withLatestFrom;
    } });
    var Ur = UQ();
    Object.defineProperty(e, "zip", { enumerable: !0, get: function() {
      return Ur.zip;
    } });
    var gn = IDe();
    Object.defineProperty(e, "zipAll", { enumerable: !0, get: function() {
      return gn.zipAll;
    } });
    var Zt = MDe();
    Object.defineProperty(e, "zipWith", { enumerable: !0, get: function() {
      return Zt.zipWith;
    } });
  }(M_)), M_;
}
var f0 = {}, I7;
function WQ() {
  return I7 || (I7 = 1, Object.defineProperty(f0, "__esModule", { value: !0 }), f0.CLASS_SERIALIZER_OPTIONS = void 0, f0.CLASS_SERIALIZER_OPTIONS = "class_serializer:options"), f0;
}
var M7;
function PDe() {
  if (M7) return Vu;
  M7 = 1, Object.defineProperty(Vu, "__esModule", { value: !0 }), Vu.ClassSerializerInterceptor = void 0;
  const e = Gr, t = ADe(), r = Tl(), n = Gq(), a = Zq(), i = An(), o = WQ();
  let s = {};
  const l = "Reflector";
  let c = class {
    constructor(d, f = {}) {
      this.reflector = d, this.defaultOptions = f, s = f?.transformerPackage ?? (0, a.loadPackage)("class-transformer", "ClassSerializerInterceptor", () => aQ), f?.transformerPackage;
    }
    intercept(d, f) {
      const m = this.getContextOptions(d), h = {
        ...this.defaultOptions,
        ...m
      };
      return f.handle().pipe((0, t.map)((g) => this.serialize(g, h)));
    }
    /**
     * Serializes responses that are non-null objects nor streamable files.
     */
    serialize(d, f) {
      return !(0, i.isObject)(d) || d instanceof n.StreamableFile ? d : Array.isArray(d) ? d.map((m) => this.transformToPlain(m, f)) : this.transformToPlain(d, f);
    }
    transformToPlain(d, f) {
      if (!d)
        return d;
      if (!f.type || d instanceof f.type)
        return s.classToPlain(d, f);
      const m = s.plainToInstance(f.type, d, f);
      return s.classToPlain(m, f);
    }
    getContextOptions(d) {
      return this.reflector.getAllAndOverride(o.CLASS_SERIALIZER_OPTIONS, [
        d.getHandler(),
        d.getClass()
      ]);
    }
  };
  return Vu.ClassSerializerInterceptor = c, Vu.ClassSerializerInterceptor = c = e.__decorate([
    (0, r.Injectable)(),
    e.__param(0, (0, r.Inject)(l)),
    e.__param(1, (0, r.Optional)()),
    e.__metadata("design:paramtypes", [Object, Object])
  ], c), Vu;
}
var F_ = {}, p0 = {}, A7;
function RDe() {
  if (A7) return p0;
  A7 = 1, Object.defineProperty(p0, "__esModule", { value: !0 }), p0.SerializeOptions = void 0;
  const e = gM(), t = WQ(), r = (n) => (0, e.SetMetadata)(t.CLASS_SERIALIZER_OPTIONS, n);
  return p0.SerializeOptions = r, p0;
}
var P7;
function NDe() {
  return P7 || (P7 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), Gr.__exportStar(RDe(), e);
  }(F_)), F_;
}
var B_ = {}, R7;
function DDe() {
  return R7 || (R7 = 1, Object.defineProperty(B_, "__esModule", { value: !0 })), B_;
}
var N7;
function jDe() {
  return N7 || (N7 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = Gr;
    t.__exportStar(PDe(), e), t.__exportStar(NDe(), e), t.__exportStar(DDe(), e);
  }(I_)), I_;
}
var z_ = {}, m0 = {}, D7;
function LDe() {
  if (D7) return m0;
  D7 = 1, Object.defineProperty(m0, "__esModule", { value: !0 }), m0.forwardRef = void 0;
  const e = (t) => ({
    forwardRef: t
  });
  return m0.forwardRef = e, m0;
}
var j7;
function kDe() {
  return j7 || (j7 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), Gr.__exportStar(LDe(), e);
  }(z_)), z_;
}
var L7;
function XM() {
  return L7 || (L7 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.VERSION_NEUTRAL = e.Scope = void 0;
    const t = Gr;
    t.__exportStar(gM(), e), t.__exportStar(lC(), e), t.__exportStar(Bq(), e), t.__exportStar(Gq(), e);
    var r = NAe();
    Object.defineProperty(e, "Scope", { enumerable: !0, get: function() {
      return r.Scope;
    } }), Object.defineProperty(e, "VERSION_NEUTRAL", { enumerable: !0, get: function() {
      return r.VERSION_NEUTRAL;
    } }), t.__exportStar(GAe(), e), t.__exportStar(N8e(), e), t.__exportStar(jDe(), e), t.__exportStar(Vq(), e), t.__exportStar(kDe(), e);
  }(Zx)), Zx;
}
var k0 = XM();
function qQ(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: FDe } = Object.prototype, { getPrototypeOf: JM } = Object, bC = /* @__PURE__ */ ((e) => (t) => {
  const r = FDe.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Go = (e) => (e = e.toLowerCase(), (t) => bC(t) === e), CC = (e) => (t) => typeof t === e, { isArray: kd } = Array, ah = CC("undefined");
function BDe(e) {
  return e !== null && !ah(e) && e.constructor !== null && !ah(e.constructor) && Hi(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const KQ = Go("ArrayBuffer");
function zDe(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && KQ(e.buffer), t;
}
const HDe = CC("string"), Hi = CC("function"), YQ = CC("number"), SC = (e) => e !== null && typeof e == "object", VDe = (e) => e === !0 || e === !1, gb = (e) => {
  if (bC(e) !== "object")
    return !1;
  const t = JM(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, GDe = Go("Date"), UDe = Go("File"), WDe = Go("Blob"), qDe = Go("FileList"), KDe = (e) => SC(e) && Hi(e.pipe), YDe = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Hi(e.append) && ((t = bC(e)) === "formdata" || // detect form-data instance
  t === "object" && Hi(e.toString) && e.toString() === "[object FormData]"));
}, ZDe = Go("URLSearchParams"), [XDe, JDe, QDe, eje] = ["ReadableStream", "Request", "Response", "Headers"].map(Go), tje = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Uh(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, a;
  if (typeof e != "object" && (e = [e]), kd(e))
    for (n = 0, a = e.length; n < a; n++)
      t.call(null, e[n], n, e);
  else {
    const i = r ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let s;
    for (n = 0; n < o; n++)
      s = i[n], t.call(null, e[s], s, e);
  }
}
function ZQ(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, a;
  for (; n-- > 0; )
    if (a = r[n], t === a.toLowerCase())
      return a;
  return null;
}
const mc = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, XQ = (e) => !ah(e) && e !== mc;
function zO() {
  const { caseless: e } = XQ(this) && this || {}, t = {}, r = (n, a) => {
    const i = e && ZQ(t, a) || a;
    gb(t[i]) && gb(n) ? t[i] = zO(t[i], n) : gb(n) ? t[i] = zO({}, n) : kd(n) ? t[i] = n.slice() : t[i] = n;
  };
  for (let n = 0, a = arguments.length; n < a; n++)
    arguments[n] && Uh(arguments[n], r);
  return t;
}
const rje = (e, t, r, { allOwnKeys: n } = {}) => (Uh(t, (a, i) => {
  r && Hi(a) ? e[i] = qQ(a, r) : e[i] = a;
}, { allOwnKeys: n }), e), nje = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), aje = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, ije = (e, t, r, n) => {
  let a, i, o;
  const s = {};
  if (t = t || {}, e == null) return t;
  do {
    for (a = Object.getOwnPropertyNames(e), i = a.length; i-- > 0; )
      o = a[i], (!n || n(o, e, t)) && !s[o] && (t[o] = e[o], s[o] = !0);
    e = r !== !1 && JM(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, oje = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, sje = (e) => {
  if (!e) return null;
  if (kd(e)) return e;
  let t = e.length;
  if (!YQ(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, lje = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && JM(Uint8Array)), cje = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let a;
  for (; (a = n.next()) && !a.done; ) {
    const i = a.value;
    t.call(e, i[0], i[1]);
  }
}, uje = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, dje = Go("HTMLFormElement"), fje = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, a) {
    return n.toUpperCase() + a;
  }
), k7 = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), pje = Go("RegExp"), JQ = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  Uh(r, (a, i) => {
    let o;
    (o = t(a, i, e)) !== !1 && (n[i] = o || a);
  }), Object.defineProperties(e, n);
}, mje = (e) => {
  JQ(e, (t, r) => {
    if (Hi(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (Hi(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, vje = (e, t) => {
  const r = {}, n = (a) => {
    a.forEach((i) => {
      r[i] = !0;
    });
  };
  return kd(e) ? n(e) : n(String(e).split(t)), r;
}, hje = () => {
}, gje = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function yje(e) {
  return !!(e && Hi(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const bje = (e) => {
  const t = new Array(10), r = (n, a) => {
    if (SC(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[a] = n;
        const i = kd(n) ? [] : {};
        return Uh(n, (o, s) => {
          const l = r(o, a + 1);
          !ah(l) && (i[s] = l);
        }), t[a] = void 0, i;
      }
    }
    return n;
  };
  return r(e, 0);
}, Cje = Go("AsyncFunction"), Sje = (e) => e && (SC(e) || Hi(e)) && Hi(e.then) && Hi(e.catch), QQ = ((e, t) => e ? setImmediate : t ? ((r, n) => (mc.addEventListener("message", ({ source: a, data: i }) => {
  a === mc && i === r && n.length && n.shift()();
}, !1), (a) => {
  n.push(a), mc.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  Hi(mc.postMessage)
), xje = typeof queueMicrotask < "u" ? queueMicrotask.bind(mc) : typeof process < "u" && process.nextTick || QQ, Ye = {
  isArray: kd,
  isArrayBuffer: KQ,
  isBuffer: BDe,
  isFormData: YDe,
  isArrayBufferView: zDe,
  isString: HDe,
  isNumber: YQ,
  isBoolean: VDe,
  isObject: SC,
  isPlainObject: gb,
  isReadableStream: XDe,
  isRequest: JDe,
  isResponse: QDe,
  isHeaders: eje,
  isUndefined: ah,
  isDate: GDe,
  isFile: UDe,
  isBlob: WDe,
  isRegExp: pje,
  isFunction: Hi,
  isStream: KDe,
  isURLSearchParams: ZDe,
  isTypedArray: lje,
  isFileList: qDe,
  forEach: Uh,
  merge: zO,
  extend: rje,
  trim: tje,
  stripBOM: nje,
  inherits: aje,
  toFlatObject: ije,
  kindOf: bC,
  kindOfTest: Go,
  endsWith: oje,
  toArray: sje,
  forEachEntry: cje,
  matchAll: uje,
  isHTMLForm: dje,
  hasOwnProperty: k7,
  hasOwnProp: k7,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: JQ,
  freezeMethods: mje,
  toObjectSet: vje,
  toCamelCase: fje,
  noop: hje,
  toFiniteNumber: gje,
  findKey: ZQ,
  global: mc,
  isContextDefined: XQ,
  isSpecCompliantForm: yje,
  toJSONObject: bje,
  isAsyncFn: Cje,
  isThenable: Sje,
  setImmediate: QQ,
  asap: xje
};
function Ir(e, t, r, n, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), a && (this.response = a, this.status = a.status ? a.status : null);
}
Ye.inherits(Ir, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: Ye.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const eee = Ir.prototype, tee = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  tee[e] = { value: e };
});
Object.defineProperties(Ir, tee);
Object.defineProperty(eee, "isAxiosError", { value: !0 });
Ir.from = (e, t, r, n, a, i) => {
  const o = Object.create(eee);
  return Ye.toFlatObject(e, o, function(l) {
    return l !== Error.prototype;
  }, (s) => s !== "isAxiosError"), Ir.call(o, e.message, t, r, n, a), o.cause = e, o.name = e.name, i && Object.assign(o, i), o;
};
const $je = null;
function HO(e) {
  return Ye.isPlainObject(e) || Ye.isArray(e);
}
function ree(e) {
  return Ye.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function F7(e, t, r) {
  return e ? e.concat(t).map(function(a, i) {
    return a = ree(a), !r && i ? "[" + a + "]" : a;
  }).join(r ? "." : "") : t;
}
function _je(e) {
  return Ye.isArray(e) && !e.some(HO);
}
const Eje = Ye.toFlatObject(Ye, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function xC(e, t, r) {
  if (!Ye.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = Ye.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(g, y) {
    return !Ye.isUndefined(y[g]);
  });
  const n = r.metaTokens, a = r.visitor || u, i = r.dots, o = r.indexes, l = (r.Blob || typeof Blob < "u" && Blob) && Ye.isSpecCompliantForm(t);
  if (!Ye.isFunction(a))
    throw new TypeError("visitor must be a function");
  function c(h) {
    if (h === null) return "";
    if (Ye.isDate(h))
      return h.toISOString();
    if (!l && Ye.isBlob(h))
      throw new Ir("Blob is not supported. Use a Buffer instead.");
    return Ye.isArrayBuffer(h) || Ye.isTypedArray(h) ? l && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function u(h, g, y) {
    let S = h;
    if (h && !y && typeof h == "object") {
      if (Ye.endsWith(g, "{}"))
        g = n ? g : g.slice(0, -2), h = JSON.stringify(h);
      else if (Ye.isArray(h) && _je(h) || (Ye.isFileList(h) || Ye.endsWith(g, "[]")) && (S = Ye.toArray(h)))
        return g = ree(g), S.forEach(function(b, _) {
          !(Ye.isUndefined(b) || b === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? F7([g], _, i) : o === null ? g : g + "[]",
            c(b)
          );
        }), !1;
    }
    return HO(h) ? !0 : (t.append(F7(y, g, i), c(h)), !1);
  }
  const d = [], f = Object.assign(Eje, {
    defaultVisitor: u,
    convertValue: c,
    isVisitable: HO
  });
  function m(h, g) {
    if (!Ye.isUndefined(h)) {
      if (d.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + g.join("."));
      d.push(h), Ye.forEach(h, function(S, x) {
        (!(Ye.isUndefined(S) || S === null) && a.call(
          t,
          S,
          Ye.isString(x) ? x.trim() : x,
          g,
          f
        )) === !0 && m(S, g ? g.concat(x) : [x]);
      }), d.pop();
    }
  }
  if (!Ye.isObject(e))
    throw new TypeError("data must be an object");
  return m(e), t;
}
function B7(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function QM(e, t) {
  this._pairs = [], e && xC(e, this, t);
}
const nee = QM.prototype;
nee.append = function(t, r) {
  this._pairs.push([t, r]);
};
nee.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, B7);
  } : B7;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function wje(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function aee(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || wje;
  Ye.isFunction(r) && (r = {
    serialize: r
  });
  const a = r && r.serialize;
  let i;
  if (a ? i = a(t, r) : i = Ye.isURLSearchParams(t) ? t.toString() : new QM(t, r).toString(n), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class z7 {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    Ye.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const iee = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Oje = typeof URLSearchParams < "u" ? URLSearchParams : QM, Tje = typeof FormData < "u" ? FormData : null, Ije = typeof Blob < "u" ? Blob : null, Mje = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Oje,
    FormData: Tje,
    Blob: Ije
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, eA = typeof window < "u" && typeof document < "u", VO = typeof navigator == "object" && navigator || void 0, Aje = eA && (!VO || ["ReactNative", "NativeScript", "NS"].indexOf(VO.product) < 0), Pje = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Rje = eA && window.location.href || "http://localhost", Nje = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: eA,
  hasStandardBrowserEnv: Aje,
  hasStandardBrowserWebWorkerEnv: Pje,
  navigator: VO,
  origin: Rje
}, Symbol.toStringTag, { value: "Module" })), Wa = {
  ...Nje,
  ...Mje
};
function Dje(e, t) {
  return xC(e, new Wa.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, a, i) {
      return Wa.isNode && Ye.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function jje(e) {
  return Ye.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Lje(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const a = r.length;
  let i;
  for (n = 0; n < a; n++)
    i = r[n], t[i] = e[i];
  return t;
}
function oee(e) {
  function t(r, n, a, i) {
    let o = r[i++];
    if (o === "__proto__") return !0;
    const s = Number.isFinite(+o), l = i >= r.length;
    return o = !o && Ye.isArray(a) ? a.length : o, l ? (Ye.hasOwnProp(a, o) ? a[o] = [a[o], n] : a[o] = n, !s) : ((!a[o] || !Ye.isObject(a[o])) && (a[o] = []), t(r, n, a[o], i) && Ye.isArray(a[o]) && (a[o] = Lje(a[o])), !s);
  }
  if (Ye.isFormData(e) && Ye.isFunction(e.entries)) {
    const r = {};
    return Ye.forEachEntry(e, (n, a) => {
      t(jje(n), a, r, 0);
    }), r;
  }
  return null;
}
function kje(e, t, r) {
  if (Ye.isString(e))
    try {
      return (t || JSON.parse)(e), Ye.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const Wh = {
  transitional: iee,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", a = n.indexOf("application/json") > -1, i = Ye.isObject(t);
    if (i && Ye.isHTMLForm(t) && (t = new FormData(t)), Ye.isFormData(t))
      return a ? JSON.stringify(oee(t)) : t;
    if (Ye.isArrayBuffer(t) || Ye.isBuffer(t) || Ye.isStream(t) || Ye.isFile(t) || Ye.isBlob(t) || Ye.isReadableStream(t))
      return t;
    if (Ye.isArrayBufferView(t))
      return t.buffer;
    if (Ye.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let s;
    if (i) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return Dje(t, this.formSerializer).toString();
      if ((s = Ye.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return xC(
          s ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return i || a ? (r.setContentType("application/json", !1), kje(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || Wh.transitional, n = r && r.forcedJSONParsing, a = this.responseType === "json";
    if (Ye.isResponse(t) || Ye.isReadableStream(t))
      return t;
    if (t && Ye.isString(t) && (n && !this.responseType || a)) {
      const o = !(r && r.silentJSONParsing) && a;
      try {
        return JSON.parse(t);
      } catch (s) {
        if (o)
          throw s.name === "SyntaxError" ? Ir.from(s, Ir.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Wa.classes.FormData,
    Blob: Wa.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
Ye.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Wh.headers[e] = {};
});
const Fje = Ye.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Bje = (e) => {
  const t = {};
  let r, n, a;
  return e && e.split(`
`).forEach(function(o) {
    a = o.indexOf(":"), r = o.substring(0, a).trim().toLowerCase(), n = o.substring(a + 1).trim(), !(!r || t[r] && Fje[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, H7 = Symbol("internals");
function v0(e) {
  return e && String(e).trim().toLowerCase();
}
function yb(e) {
  return e === !1 || e == null ? e : Ye.isArray(e) ? e.map(yb) : String(e);
}
function zje(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const Hje = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function H_(e, t, r, n, a) {
  if (Ye.isFunction(n))
    return n.call(this, t, r);
  if (a && (t = r), !!Ye.isString(t)) {
    if (Ye.isString(n))
      return t.indexOf(n) !== -1;
    if (Ye.isRegExp(n))
      return n.test(t);
  }
}
function Vje(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function Gje(e, t) {
  const r = Ye.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(a, i, o) {
        return this[n].call(this, t, a, i, o);
      },
      configurable: !0
    });
  });
}
let bi = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const a = this;
    function i(s, l, c) {
      const u = v0(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = Ye.findKey(a, u);
      (!d || a[d] === void 0 || c === !0 || c === void 0 && a[d] !== !1) && (a[d || l] = yb(s));
    }
    const o = (s, l) => Ye.forEach(s, (c, u) => i(c, u, l));
    if (Ye.isPlainObject(t) || t instanceof this.constructor)
      o(t, r);
    else if (Ye.isString(t) && (t = t.trim()) && !Hje(t))
      o(Bje(t), r);
    else if (Ye.isHeaders(t))
      for (const [s, l] of t.entries())
        i(l, s, n);
    else
      t != null && i(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = v0(t), t) {
      const n = Ye.findKey(this, t);
      if (n) {
        const a = this[n];
        if (!r)
          return a;
        if (r === !0)
          return zje(a);
        if (Ye.isFunction(r))
          return r.call(this, a, n);
        if (Ye.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = v0(t), t) {
      const n = Ye.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || H_(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let a = !1;
    function i(o) {
      if (o = v0(o), o) {
        const s = Ye.findKey(n, o);
        s && (!r || H_(n, n[s], s, r)) && (delete n[s], a = !0);
      }
    }
    return Ye.isArray(t) ? t.forEach(i) : i(t), a;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, a = !1;
    for (; n--; ) {
      const i = r[n];
      (!t || H_(this, this[i], i, t, !0)) && (delete this[i], a = !0);
    }
    return a;
  }
  normalize(t) {
    const r = this, n = {};
    return Ye.forEach(this, (a, i) => {
      const o = Ye.findKey(n, i);
      if (o) {
        r[o] = yb(a), delete r[i];
        return;
      }
      const s = t ? Vje(i) : String(i).trim();
      s !== i && delete r[i], r[s] = yb(a), n[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return Ye.forEach(this, (n, a) => {
      n != null && n !== !1 && (r[a] = t && Ye.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((a) => n.set(a)), n;
  }
  static accessor(t) {
    const n = (this[H7] = this[H7] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function i(o) {
      const s = v0(o);
      n[s] || (Gje(a, o), n[s] = !0);
    }
    return Ye.isArray(t) ? t.forEach(i) : i(t), this;
  }
};
bi.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
Ye.reduceDescriptors(bi.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
Ye.freezeMethods(bi);
function V_(e, t) {
  const r = this || Wh, n = t || r, a = bi.from(n.headers);
  let i = n.data;
  return Ye.forEach(e, function(s) {
    i = s.call(r, i, a.normalize(), t ? t.status : void 0);
  }), a.normalize(), i;
}
function see(e) {
  return !!(e && e.__CANCEL__);
}
function Fd(e, t, r) {
  Ir.call(this, e ?? "canceled", Ir.ERR_CANCELED, t, r), this.name = "CanceledError";
}
Ye.inherits(Fd, Ir, {
  __CANCEL__: !0
});
function lee(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new Ir(
    "Request failed with status code " + r.status,
    [Ir.ERR_BAD_REQUEST, Ir.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function Uje(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Wje(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let a = 0, i = 0, o;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const c = Date.now(), u = n[i];
    o || (o = c), r[a] = l, n[a] = c;
    let d = i, f = 0;
    for (; d !== a; )
      f += r[d++], d = d % e;
    if (a = (a + 1) % e, a === i && (i = (i + 1) % e), c - o < t)
      return;
    const m = u && c - u;
    return m ? Math.round(f * 1e3 / m) : void 0;
  };
}
function qje(e, t) {
  let r = 0, n = 1e3 / t, a, i;
  const o = (c, u = Date.now()) => {
    r = u, a = null, i && (clearTimeout(i), i = null), e.apply(null, c);
  };
  return [(...c) => {
    const u = Date.now(), d = u - r;
    d >= n ? o(c, u) : (a = c, i || (i = setTimeout(() => {
      i = null, o(a);
    }, n - d)));
  }, () => a && o(a)];
}
const n1 = (e, t, r = 3) => {
  let n = 0;
  const a = Wje(50, 250);
  return qje((i) => {
    const o = i.loaded, s = i.lengthComputable ? i.total : void 0, l = o - n, c = a(l), u = o <= s;
    n = o;
    const d = {
      loaded: o,
      total: s,
      progress: s ? o / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - o) / c : void 0,
      event: i,
      lengthComputable: s != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, r);
}, V7 = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, G7 = (e) => (...t) => Ye.asap(() => e(...t)), Kje = Wa.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (r) => (r = new URL(r, Wa.origin), e.protocol === r.protocol && e.host === r.host && (t || e.port === r.port)))(
  new URL(Wa.origin),
  Wa.navigator && /(msie|trident)/i.test(Wa.navigator.userAgent)
) : () => !0, Yje = Wa.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, a, i) {
      const o = [e + "=" + encodeURIComponent(t)];
      Ye.isNumber(r) && o.push("expires=" + new Date(r).toGMTString()), Ye.isString(n) && o.push("path=" + n), Ye.isString(a) && o.push("domain=" + a), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Zje(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Xje(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function cee(e, t, r) {
  let n = !Zje(t);
  return e && (n || r == !1) ? Xje(e, t) : t;
}
const U7 = (e) => e instanceof bi ? { ...e } : e;
function Ic(e, t) {
  t = t || {};
  const r = {};
  function n(c, u, d, f) {
    return Ye.isPlainObject(c) && Ye.isPlainObject(u) ? Ye.merge.call({ caseless: f }, c, u) : Ye.isPlainObject(u) ? Ye.merge({}, u) : Ye.isArray(u) ? u.slice() : u;
  }
  function a(c, u, d, f) {
    if (Ye.isUndefined(u)) {
      if (!Ye.isUndefined(c))
        return n(void 0, c, d, f);
    } else return n(c, u, d, f);
  }
  function i(c, u) {
    if (!Ye.isUndefined(u))
      return n(void 0, u);
  }
  function o(c, u) {
    if (Ye.isUndefined(u)) {
      if (!Ye.isUndefined(c))
        return n(void 0, c);
    } else return n(void 0, u);
  }
  function s(c, u, d) {
    if (d in t)
      return n(c, u);
    if (d in e)
      return n(void 0, c);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: s,
    headers: (c, u, d) => a(U7(c), U7(u), d, !0)
  };
  return Ye.forEach(Object.keys(Object.assign({}, e, t)), function(u) {
    const d = l[u] || a, f = d(e[u], t[u], u);
    Ye.isUndefined(f) && d !== s || (r[u] = f);
  }), r;
}
const uee = (e) => {
  const t = Ic({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: a, xsrfCookieName: i, headers: o, auth: s } = t;
  t.headers = o = bi.from(o), t.url = aee(cee(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), s && o.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let l;
  if (Ye.isFormData(r)) {
    if (Wa.hasStandardBrowserEnv || Wa.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((l = o.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      o.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (Wa.hasStandardBrowserEnv && (n && Ye.isFunction(n) && (n = n(t)), n || n !== !1 && Kje(t.url))) {
    const c = a && i && Yje.read(i);
    c && o.set(a, c);
  }
  return t;
}, Jje = typeof XMLHttpRequest < "u", Qje = Jje && function(e) {
  return new Promise(function(r, n) {
    const a = uee(e);
    let i = a.data;
    const o = bi.from(a.headers).normalize();
    let { responseType: s, onUploadProgress: l, onDownloadProgress: c } = a, u, d, f, m, h;
    function g() {
      m && m(), h && h(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let y = new XMLHttpRequest();
    y.open(a.method.toUpperCase(), a.url, !0), y.timeout = a.timeout;
    function S() {
      if (!y)
        return;
      const b = bi.from(
        "getAllResponseHeaders" in y && y.getAllResponseHeaders()
      ), $ = {
        data: !s || s === "text" || s === "json" ? y.responseText : y.response,
        status: y.status,
        statusText: y.statusText,
        headers: b,
        config: e,
        request: y
      };
      lee(function(O) {
        r(O), g();
      }, function(O) {
        n(O), g();
      }, $), y = null;
    }
    "onloadend" in y ? y.onloadend = S : y.onreadystatechange = function() {
      !y || y.readyState !== 4 || y.status === 0 && !(y.responseURL && y.responseURL.indexOf("file:") === 0) || setTimeout(S);
    }, y.onabort = function() {
      y && (n(new Ir("Request aborted", Ir.ECONNABORTED, e, y)), y = null);
    }, y.onerror = function() {
      n(new Ir("Network Error", Ir.ERR_NETWORK, e, y)), y = null;
    }, y.ontimeout = function() {
      let _ = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const $ = a.transitional || iee;
      a.timeoutErrorMessage && (_ = a.timeoutErrorMessage), n(new Ir(
        _,
        $.clarifyTimeoutError ? Ir.ETIMEDOUT : Ir.ECONNABORTED,
        e,
        y
      )), y = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in y && Ye.forEach(o.toJSON(), function(_, $) {
      y.setRequestHeader($, _);
    }), Ye.isUndefined(a.withCredentials) || (y.withCredentials = !!a.withCredentials), s && s !== "json" && (y.responseType = a.responseType), c && ([f, h] = n1(c, !0), y.addEventListener("progress", f)), l && y.upload && ([d, m] = n1(l), y.upload.addEventListener("progress", d), y.upload.addEventListener("loadend", m)), (a.cancelToken || a.signal) && (u = (b) => {
      y && (n(!b || b.type ? new Fd(null, e, y) : b), y.abort(), y = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const x = Uje(a.url);
    if (x && Wa.protocols.indexOf(x) === -1) {
      n(new Ir("Unsupported protocol " + x + ":", Ir.ERR_BAD_REQUEST, e));
      return;
    }
    y.send(i || null);
  });
}, eLe = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let n = new AbortController(), a;
    const i = function(c) {
      if (!a) {
        a = !0, s();
        const u = c instanceof Error ? c : this.reason;
        n.abort(u instanceof Ir ? u : new Fd(u instanceof Error ? u.message : u));
      }
    };
    let o = t && setTimeout(() => {
      o = null, i(new Ir(`timeout ${t} of ms exceeded`, Ir.ETIMEDOUT));
    }, t);
    const s = () => {
      e && (o && clearTimeout(o), o = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", i));
    const { signal: l } = n;
    return l.unsubscribe = () => Ye.asap(s), l;
  }
}, tLe = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, a;
  for (; n < r; )
    a = n + t, yield e.slice(n, a), n = a;
}, rLe = async function* (e, t) {
  for await (const r of nLe(e))
    yield* tLe(r, t);
}, nLe = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await t.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, W7 = (e, t, r, n) => {
  const a = rLe(e, t);
  let i = 0, o, s = (l) => {
    o || (o = !0, n && n(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: u } = await a.next();
        if (c) {
          s(), l.close();
          return;
        }
        let d = u.byteLength;
        if (r) {
          let f = i += d;
          r(f);
        }
        l.enqueue(new Uint8Array(u));
      } catch (c) {
        throw s(c), c;
      }
    },
    cancel(l) {
      return s(l), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, $C = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", dee = $C && typeof ReadableStream == "function", aLe = $C && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), fee = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, iLe = dee && fee(() => {
  let e = !1;
  const t = new Request(Wa.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), q7 = 64 * 1024, GO = dee && fee(() => Ye.isReadableStream(new Response("").body)), a1 = {
  stream: GO && ((e) => e.body)
};
$C && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !a1[t] && (a1[t] = Ye.isFunction(e[t]) ? (r) => r[t]() : (r, n) => {
      throw new Ir(`Response type '${t}' is not supported`, Ir.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const oLe = async (e) => {
  if (e == null)
    return 0;
  if (Ye.isBlob(e))
    return e.size;
  if (Ye.isSpecCompliantForm(e))
    return (await new Request(Wa.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (Ye.isArrayBufferView(e) || Ye.isArrayBuffer(e))
    return e.byteLength;
  if (Ye.isURLSearchParams(e) && (e = e + ""), Ye.isString(e))
    return (await aLe(e)).byteLength;
}, sLe = async (e, t) => {
  const r = Ye.toFiniteNumber(e.getContentLength());
  return r ?? oLe(t);
}, lLe = $C && (async (e) => {
  let {
    url: t,
    method: r,
    data: n,
    signal: a,
    cancelToken: i,
    timeout: o,
    onDownloadProgress: s,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: f
  } = uee(e);
  c = c ? (c + "").toLowerCase() : "text";
  let m = eLe([a, i && i.toAbortSignal()], o), h;
  const g = m && m.unsubscribe && (() => {
    m.unsubscribe();
  });
  let y;
  try {
    if (l && iLe && r !== "get" && r !== "head" && (y = await sLe(u, n)) !== 0) {
      let $ = new Request(t, {
        method: "POST",
        body: n,
        duplex: "half"
      }), w;
      if (Ye.isFormData(n) && (w = $.headers.get("content-type")) && u.setContentType(w), $.body) {
        const [O, T] = V7(
          y,
          n1(G7(l))
        );
        n = W7($.body, q7, O, T);
      }
    }
    Ye.isString(d) || (d = d ? "include" : "omit");
    const S = "credentials" in Request.prototype;
    h = new Request(t, {
      ...f,
      signal: m,
      method: r.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: S ? d : void 0
    });
    let x = await fetch(h);
    const b = GO && (c === "stream" || c === "response");
    if (GO && (s || b && g)) {
      const $ = {};
      ["status", "statusText", "headers"].forEach((I) => {
        $[I] = x[I];
      });
      const w = Ye.toFiniteNumber(x.headers.get("content-length")), [O, T] = s && V7(
        w,
        n1(G7(s), !0)
      ) || [];
      x = new Response(
        W7(x.body, q7, O, () => {
          T && T(), g && g();
        }),
        $
      );
    }
    c = c || "text";
    let _ = await a1[Ye.findKey(a1, c) || "text"](x, e);
    return !b && g && g(), await new Promise(($, w) => {
      lee($, w, {
        data: _,
        headers: bi.from(x.headers),
        status: x.status,
        statusText: x.statusText,
        config: e,
        request: h
      });
    });
  } catch (S) {
    throw g && g(), S && S.name === "TypeError" && /fetch/i.test(S.message) ? Object.assign(
      new Ir("Network Error", Ir.ERR_NETWORK, e, h),
      {
        cause: S.cause || S
      }
    ) : Ir.from(S, S && S.code, e, h);
  }
}), UO = {
  http: $je,
  xhr: Qje,
  fetch: lLe
};
Ye.forEach(UO, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const K7 = (e) => `- ${e}`, cLe = (e) => Ye.isFunction(e) || e === null || e === !1, pee = {
  getAdapter: (e) => {
    e = Ye.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const a = {};
    for (let i = 0; i < t; i++) {
      r = e[i];
      let o;
      if (n = r, !cLe(r) && (n = UO[(o = String(r)).toLowerCase()], n === void 0))
        throw new Ir(`Unknown adapter '${o}'`);
      if (n)
        break;
      a[o || "#" + i] = n;
    }
    if (!n) {
      const i = Object.entries(a).map(
        ([s, l]) => `adapter ${s} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = t ? i.length > 1 ? `since :
` + i.map(K7).join(`
`) : " " + K7(i[0]) : "as no adapter specified";
      throw new Ir(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: UO
};
function G_(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Fd(null, e);
}
function Y7(e) {
  return G_(e), e.headers = bi.from(e.headers), e.data = V_.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), pee.getAdapter(e.adapter || Wh.adapter)(e).then(function(n) {
    return G_(e), n.data = V_.call(
      e,
      e.transformResponse,
      n
    ), n.headers = bi.from(n.headers), n;
  }, function(n) {
    return see(n) || (G_(e), n && n.response && (n.response.data = V_.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = bi.from(n.response.headers))), Promise.reject(n);
  });
}
const mee = "1.8.4", _C = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  _C[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Z7 = {};
_C.transitional = function(t, r, n) {
  function a(i, o) {
    return "[Axios v" + mee + "] Transitional option '" + i + "'" + o + (n ? ". " + n : "");
  }
  return (i, o, s) => {
    if (t === !1)
      throw new Ir(
        a(o, " has been removed" + (r ? " in " + r : "")),
        Ir.ERR_DEPRECATED
      );
    return r && !Z7[o] && (Z7[o] = !0, console.warn(
      a(
        o,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(i, o, s) : !0;
  };
};
_C.spelling = function(t) {
  return (r, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
function uLe(e, t, r) {
  if (typeof e != "object")
    throw new Ir("options must be an object", Ir.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let a = n.length;
  for (; a-- > 0; ) {
    const i = n[a], o = t[i];
    if (o) {
      const s = e[i], l = s === void 0 || o(s, i, e);
      if (l !== !0)
        throw new Ir("option " + i + " must be " + l, Ir.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new Ir("Unknown option " + i, Ir.ERR_BAD_OPTION);
  }
}
const bb = {
  assertOptions: uLe,
  validators: _C
}, Ko = bb.validators;
let bc = class {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new z7(),
      response: new z7()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const i = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? i && !String(n.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + i) : n.stack = i;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = Ic(this.defaults, r);
    const { transitional: n, paramsSerializer: a, headers: i } = r;
    n !== void 0 && bb.assertOptions(n, {
      silentJSONParsing: Ko.transitional(Ko.boolean),
      forcedJSONParsing: Ko.transitional(Ko.boolean),
      clarifyTimeoutError: Ko.transitional(Ko.boolean)
    }, !1), a != null && (Ye.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : bb.assertOptions(a, {
      encode: Ko.function,
      serialize: Ko.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), bb.assertOptions(r, {
      baseUrl: Ko.spelling("baseURL"),
      withXsrfToken: Ko.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let o = i && Ye.merge(
      i.common,
      i[r.method]
    );
    i && Ye.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete i[h];
      }
    ), r.headers = bi.concat(o, i);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(g) {
      typeof g.runWhen == "function" && g.runWhen(r) === !1 || (l = l && g.synchronous, s.unshift(g.fulfilled, g.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(g) {
      c.push(g.fulfilled, g.rejected);
    });
    let u, d = 0, f;
    if (!l) {
      const h = [Y7.bind(this), void 0];
      for (h.unshift.apply(h, s), h.push.apply(h, c), f = h.length, u = Promise.resolve(r); d < f; )
        u = u.then(h[d++], h[d++]);
      return u;
    }
    f = s.length;
    let m = r;
    for (d = 0; d < f; ) {
      const h = s[d++], g = s[d++];
      try {
        m = h(m);
      } catch (y) {
        g.call(this, y);
        break;
      }
    }
    try {
      u = Y7.call(this, m);
    } catch (h) {
      return Promise.reject(h);
    }
    for (d = 0, f = c.length; d < f; )
      u = u.then(c[d++], c[d++]);
    return u;
  }
  getUri(t) {
    t = Ic(this.defaults, t);
    const r = cee(t.baseURL, t.url, t.allowAbsoluteUrls);
    return aee(r, t.params, t.paramsSerializer);
  }
};
Ye.forEach(["delete", "get", "head", "options"], function(t) {
  bc.prototype[t] = function(r, n) {
    return this.request(Ic(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
Ye.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(i, o, s) {
      return this.request(Ic(s || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  bc.prototype[t] = r(), bc.prototype[t + "Form"] = r(!0);
});
let dLe = class vee {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(i) {
      r = i;
    });
    const n = this;
    this.promise.then((a) => {
      if (!n._listeners) return;
      let i = n._listeners.length;
      for (; i-- > 0; )
        n._listeners[i](a);
      n._listeners = null;
    }), this.promise.then = (a) => {
      let i;
      const o = new Promise((s) => {
        n.subscribe(s), i = s;
      }).then(a);
      return o.cancel = function() {
        n.unsubscribe(i);
      }, o;
    }, t(function(i, o, s) {
      n.reason || (n.reason = new Fd(i, o, s), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new vee(function(a) {
        t = a;
      }),
      cancel: t
    };
  }
};
function fLe(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function pLe(e) {
  return Ye.isObject(e) && e.isAxiosError === !0;
}
const WO = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(WO).forEach(([e, t]) => {
  WO[t] = e;
});
function hee(e) {
  const t = new bc(e), r = qQ(bc.prototype.request, t);
  return Ye.extend(r, bc.prototype, t, { allOwnKeys: !0 }), Ye.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(a) {
    return hee(Ic(e, a));
  }, r;
}
const Yn = hee(Wh);
Yn.Axios = bc;
Yn.CanceledError = Fd;
Yn.CancelToken = dLe;
Yn.isCancel = see;
Yn.VERSION = mee;
Yn.toFormData = xC;
Yn.AxiosError = Ir;
Yn.Cancel = Yn.CanceledError;
Yn.all = function(t) {
  return Promise.all(t);
};
Yn.spread = fLe;
Yn.isAxiosError = pLe;
Yn.mergeConfig = Ic;
Yn.AxiosHeaders = bi;
Yn.formToJSON = (e) => oee(Ye.isHTMLForm(e) ? new FormData(e) : e);
Yn.getAdapter = pee.getAdapter;
Yn.HttpStatusCode = WO;
Yn.default = Yn;
const {
  Axios: hXe,
  AxiosError: tA,
  CanceledError: gXe,
  isCancel: yXe,
  CancelToken: bXe,
  VERSION: CXe,
  all: SXe,
  Cancel: xXe,
  isAxiosError: $Xe,
  spread: _Xe,
  toFormData: EXe,
  AxiosHeaders: wXe,
  HttpStatusCode: OXe,
  formToJSON: TXe,
  getAdapter: IXe,
  mergeConfig: MXe
} = Yn;
class fa {
  constructor(t, r) {
    if (this.applicationId = "WG", this.CAPTCHA_TOKEN_KEY = "x-captcha-token", !t)
      throw new Error("apiEndpoint is required.");
    this.axiosInstance = Yn.create({
      baseURL: t,
      headers: { "Content-Type": "application/json" }
    }), this.axiosInstance.defaults.timeout = 3e4, this.axiosInstance.interceptors.response.use((n) => (n.headers[this.CAPTCHA_TOKEN_KEY] && ni.set(this.CAPTCHA_TOKEN_KEY, n.headers[this.CAPTCHA_TOKEN_KEY], { expires: 1 / 24 * 1.5 }), n)), this.applicationId = r;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  argsToQueryParams(t) {
    const r = Object.fromEntries(Object.entries(t).filter(([, a]) => a !== void 0)), n = new URLSearchParams();
    return Object.entries(r).forEach(([a, i]) => Array.isArray(i) ? i.forEach((o) => n.append(a, o.toString())) : n.append(a, i.toString())), n.toString();
  }
  request(t, r, n) {
    n && n.headers && (this.axiosInstance.defaults.headers.common = {
      ...this.axiosInstance.defaults.headers.common,
      ...n.headers
    });
    const a = ni.get("TTG_USER");
    this.checkIfItHasValidToken(a) ? this.axiosInstance.defaults.headers.common.Authorization = a : delete this.axiosInstance.defaults.headers.common?.Authorization;
    const i = ni.get("checkout_application_id") ?? this.applicationId;
    if (!i)
      throw new Error("Missing application_id cookie! application_id cookie is required.");
    return this.axiosInstance.defaults.headers.common["X-Application-Id"] = i, this.axiosInstance.defaults.headers.common[this.CAPTCHA_TOKEN_KEY] = ni.get(this.CAPTCHA_TOKEN_KEY), this.axiosInstance.request({
      method: t,
      url: r,
      ...n
    });
  }
  checkIfItHasValidToken(t) {
    return !(t == null || typeof t == "string" && ["", "undefined", "null"].includes(t.trim().toLowerCase()));
  }
  get(t, r) {
    return this.request("get", t, r);
  }
  post(t, r, n) {
    return this.request("post", t, { ...n, data: r });
  }
  put(t, r, n) {
    return this.request("put", t, { ...n, data: r });
  }
  delete(t, r) {
    return this.request("delete", t, r);
  }
  handleError(t) {
    throw new k0.HttpException(
      t?.response?.data || t?.message || "Something went wrong",
      t?.response?.status || 400
    );
  }
}
const ts = class ts extends fa {
  getAddresses() {
    return this.get(`${ts.REALTIVE_URL}`).then((t) => t.data).catch((t) => {
      if (t.response.status === 404) return null;
      throw t;
    });
  }
  addAddress(t) {
    return this.post(`${ts.REALTIVE_URL}`, t).then((r) => r.data).catch((r) => {
      throw r;
    });
  }
  updateAddress(t, r) {
    return this.put(`${ts.REALTIVE_URL}/${t}`, r).then((n) => n.data).catch((n) => {
      if (n.response.status === 404) return null;
      throw n;
    });
  }
  static getInstance(t) {
    return ts.instance || (ts.instance = new ts(t)), ts.instance;
  }
};
ts.REALTIVE_URL = "/api-ttg-commerce/v1/address";
let qO = ts;
const rs = class rs extends fa {
  getCartByUser() {
    return this.get(`${rs.REALTIVE_URL}`).then((t) => t.data).catch((t) => {
      if (t.response.status === 404) return null;
      throw t;
    });
  }
  createCart(t) {
    return this.post(`${rs.REALTIVE_URL}`, t).then((r) => r.data).catch((r) => {
      if (r.response.status === 404) return null;
      throw r;
    });
  }
  getTax() {
    return this.get(`${rs.REALTIVE_URL}/taxes`).then((t) => t.data).catch((t) => {
      if (t.response.status === 404) return null;
      throw t;
    });
  }
  static getInstance(t) {
    return rs.instance || (rs.instance = new rs(t)), rs.instance;
  }
};
rs.REALTIVE_URL = "/api-ttg-commerce/v1/cart";
let KO = rs;
const pl = class pl extends fa {
  estimateShipping(t, r) {
    return this.post(`${pl.REALTIVE_URL}/estimate`, {
      cartItems: t,
      address: r
    }).then((n) => n.data).catch((n) => {
      if (n.response.status === 404) return [];
      throw n;
    });
  }
  static getInstance(t) {
    return pl.instance || (pl.instance = new pl(t)), pl.instance;
  }
};
pl.REALTIVE_URL = "/api-ttg-commerce/v1/cart/shipping";
let YO = pl;
const Rs = class Rs extends fa {
  getCountries() {
    return this.get(`${Rs.REALTIVE_URL}/countries`).then((t) => t.data).catch((t) => {
      if (t.response.status === 404) return null;
      throw t;
    });
  }
  getStates(t) {
    return this.get(`${Rs.REALTIVE_URL}/country/${t}/states`).then((r) => r.data).catch((r) => {
      if (r.response.status === 404) return null;
      throw r;
    });
  }
  static getInstance(t) {
    return Rs.instance || (Rs.instance = new Rs(t)), Rs.instance;
  }
};
Rs.REALTIVE_URL = "/api-ttg-commerce/v1/address";
let ZO = Rs;
const ml = class ml extends fa {
  getCSRFToken() {
    return this.get(`${ml.RELATIVE_URL}/csrf/token`).then((t) => t?.data).catch((t) => {
      throw t;
    });
  }
  static getInstance(t) {
    return ml.instance || (ml.instance = new ml(t)), ml.instance;
  }
};
ml.RELATIVE_URL = "/api-ttg-commerce/v1";
let X7 = ml;
const vl = class vl extends fa {
  getAllExamples() {
    return this.get(vl.REALTIVE_URL).then((t) => t.data);
  }
  static getInstance(t) {
    return vl.instance || (vl.instance = new vl(t)), vl.instance;
  }
};
vl.REALTIVE_URL = "/api-ttg-commerce/v1/example";
let XO = vl;
const Eo = class Eo extends fa {
  async getQuestions() {
    return this.get(`${Eo.RELATIVE_URL}/questions`).then((t) => t.data);
  }
  async getTeam(t, r) {
    return this.get(`${Eo.RELATIVE_URL}/take/team/${t}${r ? `?rosterId=${r}` : ""}`).then((n) => n.data);
  }
  async startAssessment(t, r, n) {
    return this.post(`${Eo.RELATIVE_URL}/take/team/start/${t}${n ? `?rosterId=${n}` : ""}`, r).then((a) => a.data);
  }
  async updateResponses(t, r, n) {
    return this.put(`${Eo.RELATIVE_URL}/take/team/${t}/${r}`, n).then((a) => a.data);
  }
  static getInstance(t) {
    return Eo.instance || (Eo.instance = new Eo(t)), Eo.instance;
  }
};
Eo.RELATIVE_URL = "api-ttg-commerce/v1/itp";
let J7 = Eo;
const ya = class ya extends fa {
  async getAssessments(t) {
    const r = this.argsToQueryParams(t);
    return this.get(`${ya.RELATIVE_URL}/teams?${r}`).then((n) => n.data);
  }
  async createAssessment(t) {
    return this.post(`${ya.RELATIVE_URL}/team`, t).then((r) => r.data);
  }
  async updateAssessment(t, r) {
    return this.put(`${ya.RELATIVE_URL}/team/${t}`, r).then((n) => n.data);
  }
  async getAssessment(t) {
    return this.get(`${ya.RELATIVE_URL}/team/${t}`).then((r) => r.data);
  }
  async deleteAssessment(t) {
    return this.delete(`${ya.RELATIVE_URL}/take/${t}`).then((r) => r.data);
  }
  async getRosters(t, r) {
    const n = this.argsToQueryParams(r);
    return this.get(`${ya.RELATIVE_URL}/rosters/${t}?${n}`).then((a) => a.data);
  }
  async updateRoster(t, r) {
    return this.put(`${ya.RELATIVE_URL}/roster/${t}`, r).then((n) => n.data);
  }
  async deleteRosters(t, r) {
    return this.delete(`${ya.RELATIVE_URL}/rosters/${t}`, { data: { rosterIds: r } }).then((n) => n.data);
  }
  async getTags() {
    return this.get(`${ya.RELATIVE_URL}/tags`).then((t) => t.data);
  }
  getEmailTemplate() {
    return this.get(`${ya.RELATIVE_URL}/email-template`).then((t) => t.data).catch((t) => {
      if (t.response.status === 404) return null;
      throw t;
    });
  }
  addEmailTemplate(t) {
    return this.post(`${ya.RELATIVE_URL}/email-template`, t).then((r) => r.data);
  }
  sendTestEmailTemplate(t) {
    return this.post(`${ya.RELATIVE_URL}/email-template/test`, t).then((r) => r.data);
  }
  static getInstance(t) {
    return ya.instance || (ya.instance = new ya(t)), ya.instance;
  }
};
ya.RELATIVE_URL = "api-ttg-commerce/v1/itp";
let Q7 = ya;
const gee = "%[a-f0-9]{2}", ek = new RegExp("(" + gee + ")|([^%]+?)", "gi"), tk = new RegExp("(" + gee + ")+", "gi");
function JO(e, t) {
  try {
    return [decodeURIComponent(e.join(""))];
  } catch {
  }
  if (e.length === 1)
    return e;
  t = t || 1;
  const r = e.slice(0, t), n = e.slice(t);
  return Array.prototype.concat.call([], JO(r), JO(n));
}
function mLe(e) {
  try {
    return decodeURIComponent(e);
  } catch {
    let t = e.match(ek) || [];
    for (let r = 1; r < t.length; r++)
      e = JO(t, r).join(""), t = e.match(ek) || [];
    return e;
  }
}
function vLe(e) {
  const t = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  };
  let r = tk.exec(e);
  for (; r; ) {
    try {
      t[r[0]] = decodeURIComponent(r[0]);
    } catch {
      const a = mLe(r[0]);
      a !== r[0] && (t[r[0]] = a);
    }
    r = tk.exec(e);
  }
  t["%C2"] = "�";
  const n = Object.keys(t);
  for (const a of n)
    e = e.replace(new RegExp(a, "g"), t[a]);
  return e;
}
function hLe(e) {
  if (typeof e != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e + "`");
  try {
    return decodeURIComponent(e);
  } catch {
    return vLe(e);
  }
}
function yee(e, t) {
  if (!(typeof e == "string" && typeof t == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (e === "" || t === "")
    return [];
  const r = e.indexOf(t);
  return r === -1 ? [] : [
    e.slice(0, r),
    e.slice(r + t.length)
  ];
}
function gLe(e, t) {
  const r = {};
  if (Array.isArray(t))
    for (const n of t) {
      const a = Object.getOwnPropertyDescriptor(e, n);
      a?.enumerable && Object.defineProperty(r, n, a);
    }
  else
    for (const n of Reflect.ownKeys(e)) {
      const a = Object.getOwnPropertyDescriptor(e, n);
      if (a.enumerable) {
        const i = e[n];
        t(n, i, e) && Object.defineProperty(r, n, a);
      }
    }
  return r;
}
const yLe = (e) => e == null, bLe = (e) => encodeURIComponent(e).replace(/[!'()*]/g, (t) => `%${t.charCodeAt(0).toString(16).toUpperCase()}`), QO = Symbol("encodeFragmentIdentifier");
function CLe(e) {
  switch (e.arrayFormat) {
    case "index":
      return (t) => (r, n) => {
        const a = r.length;
        return n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
          ...r,
          [sa(t, e), "[", a, "]"].join("")
        ] : [
          ...r,
          [sa(t, e), "[", sa(a, e), "]=", sa(n, e)].join("")
        ];
      };
    case "bracket":
      return (t) => (r, n) => n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        [sa(t, e), "[]"].join("")
      ] : [
        ...r,
        [sa(t, e), "[]=", sa(n, e)].join("")
      ];
    case "colon-list-separator":
      return (t) => (r, n) => n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        [sa(t, e), ":list="].join("")
      ] : [
        ...r,
        [sa(t, e), ":list=", sa(n, e)].join("")
      ];
    case "comma":
    case "separator":
    case "bracket-separator": {
      const t = e.arrayFormat === "bracket-separator" ? "[]=" : "=";
      return (r) => (n, a) => a === void 0 || e.skipNull && a === null || e.skipEmptyString && a === "" ? n : (a = a === null ? "" : a, n.length === 0 ? [[sa(r, e), t, sa(a, e)].join("")] : [[n, sa(a, e)].join(e.arrayFormatSeparator)]);
    }
    default:
      return (t) => (r, n) => n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        sa(t, e)
      ] : [
        ...r,
        [sa(t, e), "=", sa(n, e)].join("")
      ];
  }
}
function SLe(e) {
  let t;
  switch (e.arrayFormat) {
    case "index":
      return (r, n, a) => {
        if (t = /\[(\d*)]$/.exec(r), r = r.replace(/\[\d*]$/, ""), !t) {
          a[r] = n;
          return;
        }
        a[r] === void 0 && (a[r] = {}), a[r][t[1]] = n;
      };
    case "bracket":
      return (r, n, a) => {
        if (t = /(\[])$/.exec(r), r = r.replace(/\[]$/, ""), !t) {
          a[r] = n;
          return;
        }
        if (a[r] === void 0) {
          a[r] = [n];
          return;
        }
        a[r] = [...a[r], n];
      };
    case "colon-list-separator":
      return (r, n, a) => {
        if (t = /(:list)$/.exec(r), r = r.replace(/:list$/, ""), !t) {
          a[r] = n;
          return;
        }
        if (a[r] === void 0) {
          a[r] = [n];
          return;
        }
        a[r] = [...a[r], n];
      };
    case "comma":
    case "separator":
      return (r, n, a) => {
        const i = typeof n == "string" && n.includes(e.arrayFormatSeparator), o = typeof n == "string" && !i && js(n, e).includes(e.arrayFormatSeparator);
        n = o ? js(n, e) : n;
        const s = i || o ? n.split(e.arrayFormatSeparator).map((l) => js(l, e)) : n === null ? n : js(n, e);
        a[r] = s;
      };
    case "bracket-separator":
      return (r, n, a) => {
        const i = /(\[])$/.test(r);
        if (r = r.replace(/\[]$/, ""), !i) {
          a[r] = n && js(n, e);
          return;
        }
        const o = n === null ? [] : n.split(e.arrayFormatSeparator).map((s) => js(s, e));
        if (a[r] === void 0) {
          a[r] = o;
          return;
        }
        a[r] = [...a[r], ...o];
      };
    default:
      return (r, n, a) => {
        if (a[r] === void 0) {
          a[r] = n;
          return;
        }
        a[r] = [...[a[r]].flat(), n];
      };
  }
}
function bee(e) {
  if (typeof e != "string" || e.length !== 1)
    throw new TypeError("arrayFormatSeparator must be single character string");
}
function sa(e, t) {
  return t.encode ? t.strict ? bLe(e) : encodeURIComponent(e) : e;
}
function js(e, t) {
  return t.decode ? hLe(e) : e;
}
function Cee(e) {
  return Array.isArray(e) ? e.sort() : typeof e == "object" ? Cee(Object.keys(e)).sort((t, r) => Number(t) - Number(r)).map((t) => e[t]) : e;
}
function See(e) {
  const t = e.indexOf("#");
  return t !== -1 && (e = e.slice(0, t)), e;
}
function xLe(e) {
  let t = "";
  const r = e.indexOf("#");
  return r !== -1 && (t = e.slice(r)), t;
}
function rk(e, t) {
  return t.parseNumbers && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? e = Number(e) : t.parseBooleans && e !== null && (e.toLowerCase() === "true" || e.toLowerCase() === "false") && (e = e.toLowerCase() === "true"), e;
}
function rA(e) {
  e = See(e);
  const t = e.indexOf("?");
  return t === -1 ? "" : e.slice(t + 1);
}
function nA(e, t) {
  t = {
    decode: !0,
    sort: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    parseNumbers: !1,
    parseBooleans: !1,
    ...t
  }, bee(t.arrayFormatSeparator);
  const r = SLe(t), n = /* @__PURE__ */ Object.create(null);
  if (typeof e != "string" || (e = e.trim().replace(/^[?#&]/, ""), !e))
    return n;
  for (const a of e.split("&")) {
    if (a === "")
      continue;
    const i = t.decode ? a.replace(/\+/g, " ") : a;
    let [o, s] = yee(i, "=");
    o === void 0 && (o = i), s = s === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(t.arrayFormat) ? s : js(s, t), r(js(o, t), s, n);
  }
  for (const [a, i] of Object.entries(n))
    if (typeof i == "object" && i !== null)
      for (const [o, s] of Object.entries(i))
        i[o] = rk(s, t);
    else
      n[a] = rk(i, t);
  return t.sort === !1 ? n : (t.sort === !0 ? Object.keys(n).sort() : Object.keys(n).sort(t.sort)).reduce((a, i) => {
    const o = n[i];
    return o && typeof o == "object" && !Array.isArray(o) ? a[i] = Cee(o) : a[i] = o, a;
  }, /* @__PURE__ */ Object.create(null));
}
function xee(e, t) {
  if (!e)
    return "";
  t = {
    encode: !0,
    strict: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    ...t
  }, bee(t.arrayFormatSeparator);
  const r = (o) => t.skipNull && yLe(e[o]) || t.skipEmptyString && e[o] === "", n = CLe(t), a = {};
  for (const [o, s] of Object.entries(e))
    r(o) || (a[o] = s);
  const i = Object.keys(a);
  return t.sort !== !1 && i.sort(t.sort), i.map((o) => {
    const s = e[o];
    return s === void 0 ? "" : s === null ? sa(o, t) : Array.isArray(s) ? s.length === 0 && t.arrayFormat === "bracket-separator" ? sa(o, t) + "[]" : s.reduce(n(o), []).join("&") : sa(o, t) + "=" + sa(s, t);
  }).filter((o) => o.length > 0).join("&");
}
function $ee(e, t) {
  t = {
    decode: !0,
    ...t
  };
  let [r, n] = yee(e, "#");
  return r === void 0 && (r = e), {
    url: r?.split("?")?.[0] ?? "",
    query: nA(rA(e), t),
    ...t && t.parseFragmentIdentifier && n ? { fragmentIdentifier: js(n, t) } : {}
  };
}
function _ee(e, t) {
  t = {
    encode: !0,
    strict: !0,
    [QO]: !0,
    ...t
  };
  const r = See(e.url).split("?")[0] || "", n = rA(e.url), a = {
    ...nA(n, { sort: !1 }),
    ...e.query
  };
  let i = xee(a, t);
  i && (i = `?${i}`);
  let o = xLe(e.url);
  if (e.fragmentIdentifier) {
    const s = new URL(r);
    s.hash = e.fragmentIdentifier, o = t[QO] ? s.hash : `#${e.fragmentIdentifier}`;
  }
  return `${r}${i}${o}`;
}
function Eee(e, t, r) {
  r = {
    parseFragmentIdentifier: !0,
    [QO]: !1,
    ...r
  };
  const { url: n, query: a, fragmentIdentifier: i } = $ee(e, r);
  return _ee({
    url: n,
    query: gLe(a, t),
    fragmentIdentifier: i
  }, r);
}
function $Le(e, t, r) {
  const n = Array.isArray(t) ? (a) => !t.includes(a) : (a, i) => !t(a, i);
  return Eee(e, n, r);
}
const Mc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  exclude: $Le,
  extract: rA,
  parse: nA,
  parseUrl: $ee,
  pick: Eee,
  stringify: xee,
  stringifyUrl: _ee
}, Symbol.toStringTag, { value: "Module" })), ao = class ao extends fa {
  getLicenseCount(t) {
    return this.get(
      `${ao.REALTIVE_URL}/count?${t ? Mc.stringify(t) : ""}`,
      {
        headers: {
          "x-admin-token": ao.tokenSecret,
          "x-admin-id": ao.adminID
        }
      }
    ).then((r) => r?.data).catch((r) => {
      throw new k0.HttpException(
        r?.response?.data || "Something went wrong",
        r?.status || 400
      );
    });
  }
  static getInstance(t, r, n) {
    return ao.instance || (ao.instance = new ao(t), ao.tokenSecret = r, ao.adminID = n), ao.instance;
  }
};
ao.REALTIVE_URL = "/api-ttg-commerce/v1/user-wg-products/license";
let nk = ao;
const ta = class ta extends fa {
  searchAlumniIntensiveOrders(t) {
    const r = `${ta.REALTIVE_URL}/list?${Mc.stringify(t, {
      encode: !0,
      strict: !0
    })}`;
    return this.get(r, {
      headers: {
        "x-admin-token": ta.tokenSecret,
        "x-admin-id": ta.adminID
      }
    }).then((n) => {
      if (n?.data?.length === 0)
        throw new tA("No data was found with that search criteria");
      return n?.data;
    }).catch(this.handleError);
  }
  deleteAlumniIntensiveOrder(t) {
    return this.delete(`${ta.REALTIVE_URL}/${t.orderId}`, {
      headers: {
        "x-admin-token": ta.tokenSecret,
        "x-admin-id": ta.adminID
      },
      data: t
    }).then((r) => r?.data).catch(this.handleError);
  }
  transferAlumniIntensiveOrder(t) {
    return this.put(
      `${ta.REALTIVE_URL}/transfer`,
      t,
      {
        headers: {
          "x-admin-token": ta.tokenSecret,
          "x-admin-id": ta.adminID
        }
      }
    ).then((r) => r?.data).catch(this.handleError);
  }
  getAlumniIntensiveOrdersCSV(t) {
    const r = `${ta.REALTIVE_URL}/list/csv?${Mc.stringify(t, {
      encode: !0,
      strict: !0
    })}`;
    return this.get(r, {
      responseType: "text",
      headers: {
        "x-admin-token": ta.tokenSecret,
        "x-admin-id": ta.adminID
      }
    }).catch(this.handleError);
  }
  static getInstance(t, r, n) {
    return ta.instance || (ta.instance = new ta(t), ta.tokenSecret = r, ta.adminID = n), ta.instance;
  }
};
ta.REALTIVE_URL = "/api-ttg-commerce/v1/order/alumni-intensive";
let ak = ta;
const vn = class vn extends fa {
  searchCertificationOrders(t) {
    const r = `${vn.REALTIVE_URL}/list?${Mc.stringify(t, {
      encode: !0,
      strict: !0
    })}`;
    return this.get(r, {
      headers: {
        "x-admin-token": vn.tokenSecret,
        "x-admin-id": vn.adminID
      }
    }).then((n) => {
      if (n?.data?.orders?.length === 0 && n?.data?.specialCustomers?.length === 0)
        throw new tA("No data was found with that search criteria");
      return n?.data;
    }).catch(this.handleError);
  }
  getCertificationStatuses() {
    return this.get(`${vn.REALTIVE_URL}/statuses`, {
      headers: {
        "x-admin-token": vn.tokenSecret,
        "x-admin-id": vn.adminID
      }
    }).then((t) => t.data).catch(this.handleError);
  }
  addCertificationOrder(t) {
    return this.post(
      `${vn.REALTIVE_URL}`,
      t,
      {
        headers: {
          "x-admin-token": vn.tokenSecret,
          "x-admin-id": vn.adminID
        }
      }
    ).then((r) => r.data).catch(this.handleError);
  }
  deleteCertificationOrder(t) {
    return this.delete(`${vn.REALTIVE_URL}/${t.orderId}`, {
      headers: {
        "x-admin-token": vn.tokenSecret,
        "x-admin-id": vn.adminID
      },
      data: t
    }).then((r) => r?.data).catch(this.handleError);
  }
  switchCertificationOrder(t) {
    return this.put(
      `${vn.REALTIVE_URL}/switch`,
      t,
      {
        headers: {
          "x-admin-token": vn.tokenSecret,
          "x-admin-id": vn.adminID
        }
      }
    ).then((r) => r?.data).catch(this.handleError);
  }
  transferAttendee(t) {
    return this.put(
      `${vn.REALTIVE_URL}/transfer`,
      t,
      {
        headers: {
          "x-admin-token": vn.tokenSecret,
          "x-admin-id": vn.adminID
        }
      }
    ).then((r) => r?.data).catch(this.handleError);
  }
  getCertificationOrdersCSV(t) {
    const r = `${vn.REALTIVE_URL}/list/csv?${Mc.stringify(t, {
      encode: !0,
      strict: !0
    })}`;
    return this.get(r, {
      responseType: "text",
      headers: {
        "x-admin-id": vn.adminID
      }
    });
  }
  static getInstance(t, r, n) {
    return vn.instance || (vn.instance = new vn(t), vn.tokenSecret = r, vn.adminID = n), vn.instance;
  }
};
vn.REALTIVE_URL = "/api-ttg-commerce/v1/order/certification";
let ik = vn;
const hl = class hl extends fa {
  getCouponById(t) {
    return this.get(`${hl.REALTIVE_URL}/${t}`).then((r) => r.data).catch((r) => {
      throw r;
    });
  }
  static getInstance(t) {
    return hl.instance || (hl.instance = new hl(t)), hl.instance;
  }
};
hl.REALTIVE_URL = "/api-ttg-commerce/v1/coupons";
let eT = hl;
const ns = class ns extends fa {
  paymentByCC() {
    return this.payOrder("cc");
  }
  paymentByPO(t, r) {
    const n = { authorizedBy: t, purchaseOrderNumber: r };
    return this.payOrder("po", n);
  }
  payOrder(t, r) {
    return this.post(`${ns.REALTIVE_URL}/payment/${t}`, r).then((n) => n.data).catch((n) => {
      throw n;
    });
  }
  getInvoiceById(t) {
    return this.get(`${ns.REALTIVE_URL}/payment/${t}`).then((r) => r.data).catch((r) => {
      throw r;
    });
  }
  getOrderById(t) {
    return this.get(`${ns.REALTIVE_URL}/order/${t}`).then((r) => r.data).catch((r) => {
      throw r;
    });
  }
  static getInstance(t) {
    return ns.instance || (ns.instance = new ns(t)), ns.instance;
  }
};
ns.REALTIVE_URL = "/api-ttg-commerce/v1";
let tT = ns;
const as = class as extends fa {
  getProducts(t) {
    const r = t ? `${as.REALTIVE_URL}?${Mc.stringify(t)}` : as.REALTIVE_URL;
    return this.get(r).then((n) => n.data);
  }
  getPromoProducts(t) {
    return this.get(`${as.REALTIVE_URL}/promo?code=${t}`).then((r) => r.data).catch((r) => {
      if (r.response.status === 404) return null;
      throw r;
    });
  }
  static getInstance(t) {
    return as.instance || (as.instance = new as(t)), as.instance;
  }
};
as.REALTIVE_URL = "/api-ttg-commerce/v1/products";
let rT = as;
const jn = class jn extends fa {
  searchProductVariations(t) {
    const r = `${jn.REALTIVE_URL}/search?${t ? Mc.stringify(t) : ""}`;
    return this.get(r, {
      headers: {
        "x-admin-token": jn.tokenSecret,
        "x-admin-id": jn.adminID
      }
    }).then((n) => n.data);
  }
  getProductVariation(t) {
    return this.get(
      `${jn.REALTIVE_URL}/${t}`,
      {
        headers: {
          "x-admin-token": jn.tokenSecret,
          "x-admin-id": jn.adminID
        }
      }
    ).then((r) => r.data);
  }
  updateProductVariation(t, r) {
    return this.put(
      `${jn.REALTIVE_URL}/${t}`,
      r,
      {
        headers: {
          "x-admin-token": jn.tokenSecret,
          "x-admin-id": jn.adminID
        }
      }
    ).then((n) => n.data).catch(this.handleError);
  }
  deleteProductVariation(t) {
    return this.delete(`${jn.REALTIVE_URL}/${t}`, {
      headers: {
        "x-admin-token": jn.tokenSecret,
        "x-admin-id": jn.adminID
      }
    }).then((r) => r.data).catch(this.handleError);
  }
  createProductVariations(t) {
    return this.post(
      `${jn.REALTIVE_URL}`,
      t,
      {
        headers: {
          "x-admin-token": jn.tokenSecret,
          "x-admin-id": jn.adminID
        }
      }
    ).then((r) => r.data).catch(this.handleError);
  }
  static getInstance(t, r, n) {
    return jn.instance || (jn.instance = new jn(t), jn.tokenSecret = r, jn.adminID = n), jn.instance;
  }
};
jn.REALTIVE_URL = "/api-ttg-commerce/v1/product-variation";
let ok = jn;
function Ac(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function ui(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function ms(e) {
  ui(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || kt(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function _Le(e, t) {
  ui(2, arguments);
  var r = ms(e).getTime(), n = Ac(t);
  return new Date(r + n);
}
var ELe = {};
function EC() {
  return ELe;
}
function wLe(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function OLe(e) {
  return ui(1, arguments), e instanceof Date || kt(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function TLe(e) {
  if (ui(1, arguments), !OLe(e) && typeof e != "number")
    return !1;
  var t = ms(e);
  return !isNaN(Number(t));
}
function ILe(e, t) {
  ui(2, arguments);
  var r = Ac(t);
  return _Le(e, -r);
}
var MLe = 864e5;
function ALe(e) {
  ui(1, arguments);
  var t = ms(e), r = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var n = t.getTime(), a = r - n;
  return Math.floor(a / MLe) + 1;
}
function i1(e) {
  ui(1, arguments);
  var t = 1, r = ms(e), n = r.getUTCDay(), a = (n < t ? 7 : 0) + n - t;
  return r.setUTCDate(r.getUTCDate() - a), r.setUTCHours(0, 0, 0, 0), r;
}
function wee(e) {
  ui(1, arguments);
  var t = ms(e), r = t.getUTCFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(r + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var a = i1(n), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(r, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = i1(i);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function PLe(e) {
  ui(1, arguments);
  var t = wee(e), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var n = i1(r);
  return n;
}
var RLe = 6048e5;
function NLe(e) {
  ui(1, arguments);
  var t = ms(e), r = i1(t).getTime() - PLe(t).getTime();
  return Math.round(r / RLe) + 1;
}
function o1(e, t) {
  var r, n, a, i, o, s, l, c;
  ui(1, arguments);
  var u = EC(), d = Ac((r = (n = (a = (i = t?.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : u.weekStartsOn) !== null && n !== void 0 ? n : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = ms(e), m = f.getUTCDay(), h = (m < d ? 7 : 0) + m - d;
  return f.setUTCDate(f.getUTCDate() - h), f.setUTCHours(0, 0, 0, 0), f;
}
function Oee(e, t) {
  var r, n, a, i, o, s, l, c;
  ui(1, arguments);
  var u = ms(e), d = u.getUTCFullYear(), f = EC(), m = Ac((r = (n = (a = (i = t?.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : f.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(m >= 1 && m <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(d + 1, 0, m), h.setUTCHours(0, 0, 0, 0);
  var g = o1(h, t), y = /* @__PURE__ */ new Date(0);
  y.setUTCFullYear(d, 0, m), y.setUTCHours(0, 0, 0, 0);
  var S = o1(y, t);
  return u.getTime() >= g.getTime() ? d + 1 : u.getTime() >= S.getTime() ? d : d - 1;
}
function DLe(e, t) {
  var r, n, a, i, o, s, l, c;
  ui(1, arguments);
  var u = EC(), d = Ac((r = (n = (a = (i = t?.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : u.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), f = Oee(e, t), m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(f, 0, d), m.setUTCHours(0, 0, 0, 0);
  var h = o1(m, t);
  return h;
}
var jLe = 6048e5;
function LLe(e, t) {
  ui(1, arguments);
  var r = ms(e), n = o1(r, t).getTime() - DLe(r, t).getTime();
  return Math.round(n / jLe) + 1;
}
function hn(e, t) {
  for (var r = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return r + n;
}
var cl = {
  // Year
  y: function(t, r) {
    var n = t.getUTCFullYear(), a = n > 0 ? n : 1 - n;
    return hn(r === "yy" ? a % 100 : a, r.length);
  },
  // Month
  M: function(t, r) {
    var n = t.getUTCMonth();
    return r === "M" ? String(n + 1) : hn(n + 1, 2);
  },
  // Day of the month
  d: function(t, r) {
    return hn(t.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(t, r) {
    var n = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, r) {
    return hn(t.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(t, r) {
    return hn(t.getUTCHours(), r.length);
  },
  // Minute
  m: function(t, r) {
    return hn(t.getUTCMinutes(), r.length);
  },
  // Second
  s: function(t, r) {
    return hn(t.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(t, r) {
    var n = r.length, a = t.getUTCMilliseconds(), i = Math.floor(a * Math.pow(10, n - 3));
    return hn(i, r.length);
  }
}, Gu = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, kLe = {
  // Era
  G: function(t, r, n) {
    var a = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, {
          width: "abbreviated"
        });
      case "GGGGG":
        return n.era(a, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return n.era(a, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, r, n) {
    if (r === "yo") {
      var a = t.getUTCFullYear(), i = a > 0 ? a : 1 - a;
      return n.ordinalNumber(i, {
        unit: "year"
      });
    }
    return cl.y(t, r);
  },
  // Local week-numbering year
  Y: function(t, r, n, a) {
    var i = Oee(t, a), o = i > 0 ? i : 1 - i;
    if (r === "YY") {
      var s = o % 100;
      return hn(s, 2);
    }
    return r === "Yo" ? n.ordinalNumber(o, {
      unit: "year"
    }) : hn(o, r.length);
  },
  // ISO week-numbering year
  R: function(t, r) {
    var n = wee(t);
    return hn(n, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, r) {
    var n = t.getUTCFullYear();
    return hn(n, r.length);
  },
  // Quarter
  Q: function(t, r, n) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(a);
      case "QQ":
        return hn(a, 2);
      case "Qo":
        return n.ordinalNumber(a, {
          unit: "quarter"
        });
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, r, n) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(a);
      case "qq":
        return hn(a, 2);
      case "qo":
        return n.ordinalNumber(a, {
          unit: "quarter"
        });
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, r, n) {
    var a = t.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return cl.M(t, r);
      case "Mo":
        return n.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, r, n) {
    var a = t.getUTCMonth();
    switch (r) {
      case "L":
        return String(a + 1);
      case "LL":
        return hn(a + 1, 2);
      case "Lo":
        return n.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, r, n, a) {
    var i = LLe(t, a);
    return r === "wo" ? n.ordinalNumber(i, {
      unit: "week"
    }) : hn(i, r.length);
  },
  // ISO week of year
  I: function(t, r, n) {
    var a = NLe(t);
    return r === "Io" ? n.ordinalNumber(a, {
      unit: "week"
    }) : hn(a, r.length);
  },
  // Day of the month
  d: function(t, r, n) {
    return r === "do" ? n.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : cl.d(t, r);
  },
  // Day of year
  D: function(t, r, n) {
    var a = ALe(t);
    return r === "Do" ? n.ordinalNumber(a, {
      unit: "dayOfYear"
    }) : hn(a, r.length);
  },
  // Day of week
  E: function(t, r, n) {
    var a = t.getUTCDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, r, n, a) {
    var i = t.getUTCDay(), o = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(o);
      case "ee":
        return hn(o, 2);
      case "eo":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, r, n, a) {
    var i = t.getUTCDay(), o = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(o);
      case "cc":
        return hn(o, r.length);
      case "co":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, r, n) {
    var a = t.getUTCDay(), i = a === 0 ? 7 : a;
    switch (r) {
      case "i":
        return String(i);
      case "ii":
        return hn(i, r.length);
      case "io":
        return n.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, r, n) {
    var a = t.getUTCHours(), i = a / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, r, n) {
    var a = t.getUTCHours(), i;
    switch (a === 12 ? i = Gu.noon : a === 0 ? i = Gu.midnight : i = a / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, r, n) {
    var a = t.getUTCHours(), i;
    switch (a >= 17 ? i = Gu.evening : a >= 12 ? i = Gu.afternoon : a >= 4 ? i = Gu.morning : i = Gu.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, r, n) {
    if (r === "ho") {
      var a = t.getUTCHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, {
        unit: "hour"
      });
    }
    return cl.h(t, r);
  },
  // Hour [0-23]
  H: function(t, r, n) {
    return r === "Ho" ? n.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : cl.H(t, r);
  },
  // Hour [0-11]
  K: function(t, r, n) {
    var a = t.getUTCHours() % 12;
    return r === "Ko" ? n.ordinalNumber(a, {
      unit: "hour"
    }) : hn(a, r.length);
  },
  // Hour [1-24]
  k: function(t, r, n) {
    var a = t.getUTCHours();
    return a === 0 && (a = 24), r === "ko" ? n.ordinalNumber(a, {
      unit: "hour"
    }) : hn(a, r.length);
  },
  // Minute
  m: function(t, r, n) {
    return r === "mo" ? n.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : cl.m(t, r);
  },
  // Second
  s: function(t, r, n) {
    return r === "so" ? n.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : cl.s(t, r);
  },
  // Fraction of second
  S: function(t, r) {
    return cl.S(t, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (r) {
      case "X":
        return lk(o);
      case "XXXX":
      case "XX":
        return oc(o);
      case "XXXXX":
      case "XXX":
      default:
        return oc(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "x":
        return lk(o);
      case "xxxx":
      case "xx":
        return oc(o);
      case "xxxxx":
      case "xxx":
      default:
        return oc(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + sk(o, ":");
      case "OOOO":
      default:
        return "GMT" + oc(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + sk(o, ":");
      case "zzzz":
      default:
        return "GMT" + oc(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, r, n, a) {
    var i = a._originalDate || t, o = Math.floor(i.getTime() / 1e3);
    return hn(o, r.length);
  },
  // Milliseconds timestamp
  T: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTime();
    return hn(o, r.length);
  }
};
function sk(e, t) {
  var r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.floor(n / 60), i = n % 60;
  if (i === 0)
    return r + String(a);
  var o = t;
  return r + String(a) + o + hn(i, 2);
}
function lk(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + hn(Math.abs(e) / 60, 2);
  }
  return oc(e, t);
}
function oc(e, t) {
  var r = t || "", n = e > 0 ? "-" : "+", a = Math.abs(e), i = hn(Math.floor(a / 60), 2), o = hn(a % 60, 2);
  return n + i + r + o;
}
var ck = function(t, r) {
  switch (t) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    case "PPPP":
    default:
      return r.date({
        width: "full"
      });
  }
}, Tee = function(t, r) {
  switch (t) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    case "pppp":
    default:
      return r.time({
        width: "full"
      });
  }
}, FLe = function(t, r) {
  var n = t.match(/(P+)(p+)?/) || [], a = n[1], i = n[2];
  if (!i)
    return ck(t, r);
  var o;
  switch (a) {
    case "P":
      o = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = r.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = r.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", ck(a, r)).replace("{{time}}", Tee(i, r));
}, BLe = {
  p: Tee,
  P: FLe
}, zLe = ["D", "DD"], HLe = ["YY", "YYYY"];
function VLe(e) {
  return zLe.indexOf(e) !== -1;
}
function GLe(e) {
  return HLe.indexOf(e) !== -1;
}
function uk(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var ULe = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, WLe = function(t, r, n) {
  var a, i = ULe[t];
  return typeof i == "string" ? a = i : r === 1 ? a = i.one : a = i.other.replace("{{count}}", r.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
function U_(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.width ? String(t.width) : e.defaultWidth, n = e.formats[r] || e.formats[e.defaultWidth];
    return n;
  };
}
var qLe = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, KLe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, YLe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ZLe = {
  date: U_({
    formats: qLe,
    defaultWidth: "full"
  }),
  time: U_({
    formats: KLe,
    defaultWidth: "full"
  }),
  dateTime: U_({
    formats: YLe,
    defaultWidth: "full"
  })
}, XLe = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, JLe = function(t, r, n, a) {
  return XLe[t];
};
function h0(e) {
  return function(t, r) {
    var n = r != null && r.context ? String(r.context) : "standalone", a;
    if (n === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth, o = r != null && r.width ? String(r.width) : i;
      a = e.formattingValues[o] || e.formattingValues[i];
    } else {
      var s = e.defaultWidth, l = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[l] || e.values[s];
    }
    var c = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[c];
  };
}
var QLe = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, e7e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, t7e = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, r7e = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, n7e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, a7e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, i7e = function(t, r) {
  var n = Number(t), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, o7e = {
  ordinalNumber: i7e,
  era: h0({
    values: QLe,
    defaultWidth: "wide"
  }),
  quarter: h0({
    values: e7e,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: h0({
    values: t7e,
    defaultWidth: "wide"
  }),
  day: h0({
    values: r7e,
    defaultWidth: "wide"
  }),
  dayPeriod: h0({
    values: n7e,
    defaultWidth: "wide",
    formattingValues: a7e,
    defaultFormattingWidth: "wide"
  })
};
function g0(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    var o = i[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? l7e(s, function(d) {
      return d.test(o);
    }) : s7e(s, function(d) {
      return d.test(o);
    }), c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = r.valueCallback ? r.valueCallback(c) : c;
    var u = t.slice(o.length);
    return {
      value: c,
      rest: u
    };
  };
}
function s7e(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r) && t(e[r]))
      return r;
}
function l7e(e, t) {
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function c7e(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.match(e.matchPattern);
    if (!n) return null;
    var a = n[0], i = t.match(e.parsePattern);
    if (!i) return null;
    var o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    var s = t.slice(a.length);
    return {
      value: o,
      rest: s
    };
  };
}
var u7e = /^(\d+)(th|st|nd|rd)?/i, d7e = /\d+/i, f7e = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, p7e = {
  any: [/^b/i, /^(a|c)/i]
}, m7e = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, v7e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, h7e = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, g7e = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, y7e = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, b7e = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, C7e = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, S7e = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, x7e = {
  ordinalNumber: c7e({
    matchPattern: u7e,
    parsePattern: d7e,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: g0({
    matchPatterns: f7e,
    defaultMatchWidth: "wide",
    parsePatterns: p7e,
    defaultParseWidth: "any"
  }),
  quarter: g0({
    matchPatterns: m7e,
    defaultMatchWidth: "wide",
    parsePatterns: v7e,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: g0({
    matchPatterns: h7e,
    defaultMatchWidth: "wide",
    parsePatterns: g7e,
    defaultParseWidth: "any"
  }),
  day: g0({
    matchPatterns: y7e,
    defaultMatchWidth: "wide",
    parsePatterns: b7e,
    defaultParseWidth: "any"
  }),
  dayPeriod: g0({
    matchPatterns: C7e,
    defaultMatchWidth: "any",
    parsePatterns: S7e,
    defaultParseWidth: "any"
  })
}, $7e = {
  code: "en-US",
  formatDistance: WLe,
  formatLong: ZLe,
  formatRelative: JLe,
  localize: o7e,
  match: x7e,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, _7e = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, E7e = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, w7e = /^'([^]*?)'?$/, O7e = /''/g, T7e = /[a-zA-Z]/;
function W_(e, t, r) {
  var n, a, i, o, s, l, c, u, d, f, m, h, g, y;
  ui(2, arguments);
  var S = String(t), x = EC(), b = (n = (a = void 0) !== null && a !== void 0 ? a : x.locale) !== null && n !== void 0 ? n : $7e, _ = Ac((i = (o = (s = (l = void 0) !== null && l !== void 0 ? l : void 0) !== null && s !== void 0 ? s : x.firstWeekContainsDate) !== null && o !== void 0 ? o : (c = x.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(_ >= 1 && _ <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var $ = Ac((d = (f = (m = (h = void 0) !== null && h !== void 0 ? h : void 0) !== null && m !== void 0 ? m : x.weekStartsOn) !== null && f !== void 0 ? f : (g = x.locale) === null || g === void 0 || (y = g.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && d !== void 0 ? d : 0);
  if (!($ >= 0 && $ <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!b.localize)
    throw new RangeError("locale must contain localize property");
  if (!b.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var w = ms(e);
  if (!TLe(w))
    throw new RangeError("Invalid time value");
  var O = wLe(w), T = ILe(w, O), I = {
    firstWeekContainsDate: _,
    weekStartsOn: $,
    locale: b,
    _originalDate: w
  }, P = S.match(E7e).map(function(D) {
    var B = D[0];
    if (B === "p" || B === "P") {
      var L = BLe[B];
      return L(D, b.formatLong);
    }
    return D;
  }).join("").match(_7e).map(function(D) {
    if (D === "''")
      return "'";
    var B = D[0];
    if (B === "'")
      return I7e(D);
    var L = kLe[B];
    if (L)
      return GLe(D) && uk(D, t, String(e)), VLe(D) && uk(D, t, String(e)), L(T, D, b.localize, I);
    if (B.match(T7e))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + B + "`");
    return D;
  }).join("");
  return P;
}
function I7e(e) {
  var t = e.match(w7e);
  return t ? t[1].replace(O7e, "'") : e;
}
const wo = class wo extends fa {
  constructor(t, r) {
    super(t), this.axiosInstance = Yn.create({
      baseURL: t,
      headers: { "Content-Type": "application/json", "x-admin-token": r }
    });
  }
  getSummaryPayout(t) {
    const r = `${wo.REALTIVE_URL}/payout/summary?${this.objectToQueryString(t)}`;
    return this.get(r).then((n) => {
      const a = this.toTable(n.data.data);
      return { ...n.data, data: a };
    });
  }
  getSummaryPayoutCsv(t) {
    const r = `${wo.REALTIVE_URL}/payout/summary/csv?${this.objectToQueryString(t)}`;
    return this.get(r);
  }
  getDetailedPayout(t) {
    const r = `${wo.REALTIVE_URL}/payout/detailed?${this.objectToQueryString(t)}`;
    return this.get(r).then((n) => {
      const a = n.data.data.map((i) => {
        const o = new Date(i.paymentDate), s = W_(o, "MM/dd/yyyy HH:mm:ss");
        return { ...i, paymentDate: s, key: `${i.automaticTransferId}-${i.id}` };
      });
      return { ...n.data, data: a };
    });
  }
  getDetailedPayoutCsv(t) {
    const r = `${wo.REALTIVE_URL}/payout/detailed/csv?${this.objectToQueryString(t)}`;
    return this.get(r, {
      responseType: "text"
      // Ensure the response is treated as a binary blob
    });
  }
  objectToQueryString(t) {
    return Object.entries(t).map(([n, a]) => `${encodeURIComponent(n)}=${encodeURIComponent(a)}`).join("&");
  }
  toTable(t) {
    const r = t.filter((a) => a.type !== "payout").map((a, i) => {
      const o = new Date(a.arrivalDate), s = W_(o, "MM/dd/yyyy HH:mm:ss");
      return {
        key: `${a.payoutId}-${i}`,
        dateCreated: s,
        type: a.type,
        name: a.name,
        quantity: a.quantity,
        amount: a.amount,
        summaryPayoutTotalId: a.payoutId
      };
    });
    return t.filter((a) => a.type === "payout").map((a) => {
      const i = new Date(a.arrivalDate), o = W_(i, "MM/dd/yyyy HH:mm:ss");
      return {
        key: a.payoutId,
        id: a.payoutId,
        dateCreated: o,
        type: a.type,
        name: a.name,
        amount: a.amount,
        dataItems: r.filter((s) => s.summaryPayoutTotalId === a.payoutId)
      };
    });
  }
  static getInstance(t, r) {
    return wo.instance || (wo.instance = new wo(t, r)), wo.instance;
  }
};
wo.REALTIVE_URL = "/api-ttg-commerce/v1/reports/stripe";
let dk = wo;
const wa = class wa extends fa {
  getThreads(t) {
    const r = this.argsToQueryParams(t);
    return this.get(`${wa.RELATIVE_URL}s?${r}`).then((n) => n.data).catch((n) => {
      throw n;
    });
  }
  getThread(t) {
    return this.get(`${wa.RELATIVE_URL}/${t}`).then((r) => r.data).catch((r) => {
      throw r;
    });
  }
  countThreads() {
    return this.get(`${wa.RELATIVE_URL}/count`).then((t) => t.data).catch((t) => {
      throw t;
    });
  }
  createThread(t) {
    return this.post(
      `${wa.RELATIVE_URL}`,
      t
    ).then((r) => r.data).catch((r) => {
      if (r.response.status === 404) return null;
      throw r;
    });
  }
  resendThread(t) {
    return this.put(`${wa.RELATIVE_URL}/${t}/resend`).then((r) => r.data).catch((r) => {
      throw r;
    });
  }
  createMatch(t, r) {
    return this.post(
      `${wa.RELATIVE_URL}/${t}/match`,
      r
    ).then((n) => n.data).catch((n) => {
      if (n.response.status === 404) return null;
      throw n;
    });
  }
  updateMatch(t, r, n) {
    return this.put(
      `${wa.RELATIVE_URL}/${t}/match/${r}`,
      n
    ).then((a) => a.data).catch((a) => {
      if (a.response.status === 404) return null;
      throw a;
    });
  }
  getMatches(t, r) {
    const n = this.argsToQueryParams(r);
    return this.get(`${wa.RELATIVE_URL}/${t}/matches?${n}`).then((a) => a.data).catch((a) => {
      throw a;
    });
  }
  deleteMatches(t, r) {
    return this.delete(
      `${wa.RELATIVE_URL}/${t}/match`,
      {
        data: { matchIds: r }
      }
    ).then((n) => n.data).catch((n) => {
      throw n;
    });
  }
  getDetailedThread(t, r) {
    return this.get(
      `${wa.RELATIVE_URL}/detailed/${t}`,
      {
        headers: {
          "x-pdf-token": r
        }
      }
    ).then((n) => n.data).catch((n) => {
      throw n;
    });
  }
  getSummaryReportPdf(t, r) {
    return this.get(`${wa.RELATIVE_URL}/${t}/pdf/summary-report`).then((n) => {
      const a = window.atob(n.data), i = a.length, o = new Uint8Array(i);
      for (let u = 0; u < i; u++)
        o[u] = a.charCodeAt(u);
      const s = new Uint8Array(o.buffer), l = document.createElement("a");
      document.body.appendChild(l);
      const c = window.URL.createObjectURL(new Blob([s], { type: "application/pdf" }));
      return l.href = c, l.download = `Job Report for the ${r} role.pdf`, l.click(), window.URL.revokeObjectURL(c), "";
    }).catch((n) => {
      throw n;
    });
  }
  static getInstance(t) {
    return wa.instance || (wa.instance = new wa(t, "SM")), wa.instance;
  }
};
wa.RELATIVE_URL = "/api-ttg-commerce/v1/staffing-translator/thread";
let nT = wa;
const gl = class gl extends fa {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addFeedback(t) {
    return this.post(`${gl.RELATIVE_URL}/${t}`).then((r) => r.data).catch((r) => {
      throw r;
    });
  }
  static getInstance(t) {
    return gl.instance || (gl.instance = new gl(t)), gl.instance;
  }
};
gl.RELATIVE_URL = "/api-ttg-commerce/v1/payment/feedback";
let aT = gl;
const Oa = class Oa extends fa {
  wgAdjustLicenses(t) {
    return Promise.all(t.map((r) => this.post(
      `${Oa.REALTIVE_URL}/licenses`,
      r,
      {
        headers: {
          "x-admin-token": Oa.tokenSecret,
          "x-admin-id": Oa.adminID
        }
      }
    ))).then((r) => r?.[0]?.data).catch((r) => {
      throw new k0.HttpException(
        r?.response?.data || "Something went wrong",
        r?.response?.status || 400
      );
    });
  }
  updateCertificationStatus(t) {
    return this.put(
      `${Oa.REALTIVE_URL}/certification-status`,
      t,
      {
        headers: {
          "x-admin-token": Oa.tokenSecret,
          "x-admin-id": Oa.adminID
        }
      }
    ).then((r) => r?.data).catch((r) => {
      throw new k0.HttpException(r?.response?.data || "Something went wrong", r?.status || 400);
    });
  }
  deleteCertificationStatus(t) {
    return this.delete(`${Oa.REALTIVE_URL}/certification-status`, {
      headers: {
        "x-admin-token": Oa.tokenSecret,
        "x-admin-id": Oa.adminID
      },
      data: t
    }).then((r) => r?.data).catch((r) => {
      throw new k0.HttpException(r?.response?.data || "Something went wrong", r?.status || 400);
    });
  }
  static getInstance(t, r = "", n) {
    return Oa.instance || (Oa.instance = new Oa(t), Oa.tokenSecret = r, Oa.adminID = n), Oa.instance;
  }
};
Oa.REALTIVE_URL = "/api-ttg-commerce/v1/user-wg-products";
let fk = Oa;
const Tn = class Tn extends fa {
  getUser() {
    return this.get(`${Tn.RELATIVE_URL}/user`).then((t) => t.data).catch((t) => {
      if (t.response.status === 404) return null;
      throw t;
    });
  }
  getUserExists(t, r) {
    return this.get(`${Tn.RELATIVE_URL}/user/${t}?recaptcha=${r}`).then((n) => n.data).catch((n) => {
      if (n.response.status === 404) return null;
      throw n;
    });
  }
  createUser(t) {
    return this.post(`${Tn.RELATIVE_URL}/user/register`, t).then((r) => (localStorage.removeItem(Tn.CSRF_TOKEN_KEY), r.data)).catch((r) => {
      if (r.response.status === 404) return null;
      throw r;
    });
  }
  login(t) {
    return this.post(`${Tn.RELATIVE_URL}/user/login`, t).then(({ data: r }) => (ni.set("TTG_USER", r.token, { expires: new Date(Date.now() + 3600 * 1e3), secure: !0 }), localStorage.removeItem(Tn.CSRF_TOKEN_KEY), r)).catch((r) => {
      if (r.response.status === 404) return null;
      throw r;
    });
  }
  oauthLogin(t, r, n) {
    return this.post(
      `${Tn.RELATIVE_URL}/auth/${t.provider}`,
      { ssoParams: t, resource: r, userToken: n }
    ).then((a) => (ni.set("TTG_USER", a.data?.token, {
      expires: new Date(Date.now() + 3600 * 1e3),
      secure: !0
    }), localStorage.removeItem(Tn.CSRF_TOKEN_KEY), a.data)).catch((a) => {
      if (a.response.status === 404) return null;
      throw a?.response?.data?.message ?? a;
    });
  }
  logout() {
    return this.post(`${Tn.RELATIVE_URL}/user/logout`).then((t) => (localStorage.removeItem(Tn.CSRF_TOKEN_KEY), t)).catch((t) => {
      if (t.response.status === 404) return null;
      throw t;
    });
  }
  forgotPassword(t) {
    return this.post(`${Tn.RELATIVE_URL}/user/password/forgot`, t).then(() => {
    }).catch((r) => {
      throw r;
    });
  }
  resetPassword(t) {
    return this.post(`${Tn.RELATIVE_URL}/user/password/reset`, t).then((r) => (ni.set("TTG_USER", r.data?.token, { expires: new Date(Date.now() + 3600 * 1e3), secure: !0 }), r.data)).catch((r) => {
      throw r;
    });
  }
  verifyResetLink(t) {
    return this.get(`${Tn.RELATIVE_URL}/user/password/reset/verify?token=${t}`).then((r) => r?.data).catch((r) => {
      throw r;
    });
  }
  sendRegisterInvitation(t) {
    return this.post(
      `${Tn.RELATIVE_URL}/user/invite`,
      t,
      {
        headers: {
          "x-admin-token": Tn.tokenSecret
        }
      }
    ).then((r) => r.data).catch((r) => {
      throw r;
    });
  }
  getUserToken(t) {
    return this.get(`${Tn.RELATIVE_URL}/user/token/verify?${Object.entries(t).map(([r, n]) => n !== void 0 ? `${encodeURIComponent(r)}=${encodeURIComponent(n)}` : null).filter((r) => r).join("&")}`).then((r) => r.data).catch((r) => {
      if (r.response.status === 404) return null;
      throw r;
    });
  }
  static getInstance(t, r = "") {
    return Tn.instance || (Tn.instance = new Tn(t)), r && (Tn.tokenSecret = r), Tn.instance;
  }
};
Tn.RELATIVE_URL = "/api-ttg-commerce/v1", Tn.CSRF_TOKEN_KEY = "x-csrf";
let iT = Tn;
const M7e = ({ page: e }) => /* @__PURE__ */ E.jsx("div", { className: "footer", children: /* @__PURE__ */ E.jsxs("div", { className: "layout", children: [
  /* @__PURE__ */ E.jsx("div", { className: "logo", children: /* @__PURE__ */ E.jsx("img", { src: oT.FooterLogo, alt: "" }) }),
  /* @__PURE__ */ E.jsxs("div", { className: "text-container", children: [
    /* @__PURE__ */ E.jsx("p", { className: "paragraph", children: /* @__PURE__ */ E.jsx("a", { href: "https://www.workinggenius.ai", children: "www.workinggenius.ai" }) }),
    /* @__PURE__ */ E.jsxs("p", { className: "paragraph", children: [
      "© Copyright ",
      fn().format("YYYY"),
      " The Table Group, Inc."
    ] })
  ] }),
  /* @__PURE__ */ E.jsx("div", { className: "page-container", children: /* @__PURE__ */ E.jsxs("p", { className: "footer-page", children: [
    e,
    /* @__PURE__ */ E.jsx("span", { className: "gear", children: /* @__PURE__ */ E.jsx("img", { src: oT.Gear, alt: "" }) })
  ] }) })
] }) }), A7e = ({ title: e }) => /* @__PURE__ */ E.jsxs("div", { className: "header", children: [
  /* @__PURE__ */ E.jsx("img", { src: oT.Magnifier, alt: "" }),
  /* @__PURE__ */ E.jsx("span", { className: "title", children: e })
] }), pk = ({ children: e, pageNumber: t }) => /* @__PURE__ */ E.jsxs("section", { role: "region", className: "page", children: [
  /* @__PURE__ */ E.jsx(A7e, { title: "JOB ANALYSIS REPORT" }),
  /* @__PURE__ */ E.jsx("div", { className: "content", children: e }),
  /* @__PURE__ */ E.jsx(M7e, { page: t })
] }), oT = {
  Magnifier: "https://files.tablegroup.com/wp-content/uploads/2024/08/15093411/WG-MAgnifier.png",
  Gear: "https://files.tablegroup.com/wp-content/uploads/2024/08/14071932/yhwCse7F-gear.svg",
  FooterLogo: "https://files.tablegroup.com/wp-content/uploads/2024/08/15034415/Leadr-Advantage-Presentation-2024-Footer.png"
}, P7e = ({ thread: e, appUrl: t }) => {
  const [r, n] = He([]), a = ct(null), i = ct([]), o = new RegExp("There were no tasks found related to this Genius.*"), s = [
    { type: "wg", level: "level1", title: "Top Working Geniuses Level 1:" },
    { type: "wg", level: "level2", title: "Top Working Geniuses Level 2:" },
    { type: "wc", level: "level1", title: "Working Competencies Level 1:" },
    { type: "wc", level: "level2", title: "Working Competencies Level 2:" },
    { type: "wf", level: "level1", title: "Working Frustrations Level 1:" },
    { type: "wf", level: "level2", title: "Working Frustrations Level 2:" }
  ], l = (h, g) => {
    if (h && !(h && h?.length === 1 && o.test(h[0])))
      return h && h?.length > 1 ? /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
        "Here are the key tasks aligned with ",
        g,
        " and how this Genius supports each one."
      ] }) : /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
        "Here is the key task aligned with ",
        g,
        " and how this Genius supports it."
      ] });
  }, c = (h, g, y) => e.summary && /* @__PURE__ */ E.jsx("div", { className: "widget-description-container", children: /* @__PURE__ */ E.jsxs("div", { className: "widget-text-container relative", children: [
    /* @__PURE__ */ E.jsx(
      ZTe,
      {
        type: e.summary[h][g].levelShort,
        className: `gear ${h} ${g} mt-1`,
        height: 40,
        width: 40
      }
    ),
    /* @__PURE__ */ E.jsx("div", { className: "flex flex-col", children: /* @__PURE__ */ E.jsxs("p", { className: "widget-text ml-4", children: [
      /* @__PURE__ */ E.jsxs("span", { className: "font-semibold", children: [
        e.summary[h][g].level,
        ":"
      ] }),
      " ",
      /* @__PURE__ */ E.jsxs("span", { className: "font-normal", children: [
        e.summary[h][g].text,
        " ",
        l(e.summary[h][g]?.tasks, e.summary[h][g].level)
      ] })
    ] }) })
  ] }) }), u = (h, g) => e.summary?.[h][g]?.tasks?.map((y, S) => {
    const x = y.indexOf(":");
    if (!o.test(y)) {
      if (x !== -1) {
        const b = y.substring(0, x + 1), _ = y.substring(x + 1);
        return /* @__PURE__ */ E.jsxs("p", { className: "task-list", children: [
          /* @__PURE__ */ E.jsx("span", { className: "task-list-title", children: b }),
          _
        ] }, `${h}-${g}-${S}`);
      }
      return /* @__PURE__ */ E.jsx("p", { className: "task-list", children: /* @__PURE__ */ E.jsx("span", { className: "task-list-description", children: y }) }, `${h}-${g}-${S}`);
    }
  }), d = [
    { title: "Job Title", content: /* @__PURE__ */ E.jsx("div", { className: "title", children: e.jobTitle }) },
    {
      title: "Introduction",
      content: /* @__PURE__ */ E.jsx("div", { className: "intro", children: "After a detailed analysis of the job description, the Staffing Translator has carefully ranked the Geniuses based on their relevance to the tasks required in this role. Each Genius is aligned to specific responsibilities, and their overall contribution is then considered to create the final ranking." })
    },
    {
      title: "Recommended Profile",
      content: /* @__PURE__ */ E.jsxs("div", { className: "recommended-profile", children: [
        "Working Genius Ranking",
        " ",
        s.map(({ type: h, level: g }, y) => e.summary && /* @__PURE__ */ E.jsx("span", { children: /* @__PURE__ */ E.jsx(
          "span",
          {
            className: `gear ${h} letter ${g}`,
            children: e.summary[h][g].levelShort
          }
        ) }, `type${y}`))
      ] })
    },
    ...s.flatMap(({ type: h, level: g, title: y }, S) => [
      { title: y, content: c(h, g) },
      {
        title: `${y} List`,
        isList: !!e.summary?.[h][g]?.tasks,
        content: u(h, g)
      }
    ]),
    {
      title: "Report Summary",
      content: e.summary && /* @__PURE__ */ E.jsxs("div", { className: "report-summary", children: [
        /* @__PURE__ */ E.jsx("div", { className: "report-title", children: "Report Summary" }),
        /* @__PURE__ */ E.jsx("div", { className: "report-text", children: e.summary.summaryText })
      ] })
    },
    {
      title: "Comparison Section",
      content: /* @__PURE__ */ E.jsxs("div", { children: [
        /* @__PURE__ */ E.jsxs("div", { className: "compare-container", children: [
          "Do you have a candidate that you would like to compare for match level?",
          /* @__PURE__ */ E.jsx(
            Nt,
            {
              type: "primary",
              href: `${t}/analysis/run/${e.id}`,
              children: "Compare Now"
            }
          )
        ] }),
        /* @__PURE__ */ E.jsxs("div", { className: "note-container thank-you-note", children: [
          /* @__PURE__ */ E.jsx("p", { children: "This report provides valuable insights based on The Working Genius model but may contain inaccuracies. Please use it as a supplement to your hiring practices, not the sole decision-making tool. Thank you for helping us test our new Staffing Translator." }),
          /* @__PURE__ */ E.jsx("p", { className: "font-medium text-right", children: "— The Table Group Team" })
        ] })
      ] })
    }
  ], f = Bt((h, g) => {
    const S = [];
    let x = [], b = 0;
    const _ = ($, w) => {
      b + w > 918 ? (S.push(x), x = [$], b = w) : (x.push($), b += w);
    };
    return h.forEach(($) => {
      if ($.isList)
        xe.Children.toArray($.content).forEach((O) => {
          const T = g.shift();
          T && _(O, T);
        });
      else {
        const w = g.shift();
        w && _($.content, w);
      }
    }), x.length > 0 && S.push(x), S;
  }, []), m = Bt(() => i.current.map((h, g) => {
    if (!h) return 0;
    if (d[g].isList) {
      const S = h.querySelectorAll("p");
      return Array.from(S).map((x) => x.getBoundingClientRect().height);
    }
    return [h.getBoundingClientRect().height];
  }).flat(), []);
  return St(() => {
    const h = new ResizeObserver(() => {
      const g = m();
      n(f(d, g));
    });
    return i.current.forEach((g) => {
      g && h.observe(g);
    }), () => {
      h.disconnect();
    };
  }, [m, f]), /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
    /* @__PURE__ */ E.jsx(
      "div",
      {
        className: "ttg-staffing-pdf-doc helper",
        ref: a,
        children: /* @__PURE__ */ E.jsx(pk, { pageNumber: 0, children: d.map((h, g) => /* @__PURE__ */ E.jsx(
          "div",
          {
            ref: (y) => i.current[g] = y,
            children: h.content
          },
          g
        )) })
      }
    ),
    /* @__PURE__ */ E.jsx("div", { className: "ttg-staffing-pdf-doc", children: r.map((h, g) => /* @__PURE__ */ E.jsx(pk, { pageNumber: g + 1, children: h.map((y, S) => /* @__PURE__ */ E.jsx(xe.Fragment, { children: y }, S)) }, g)) })
  ] });
}, AXe = ({
  apiEndpoint: e,
  appUrl: t,
  threadId: r,
  token: n,
  onError: a
}) => {
  const [i, o] = He(!0), [s, l] = He(), c = nT.getInstance(e), u = Bt(() => c.getDetailedThread(r, n).then((d) => l(d)).catch((d) => a(d)).finally(() => o(!1)), [n, c, r, a]);
  return St(() => {
    u();
  }, [u]), i || !s ? null : /* @__PURE__ */ E.jsx(P7e, { appUrl: t, thread: s });
}, Iee = "https://files.tablegroup.com/wp-content/uploads/2024/08/21114701/Meeting-Advantage.webp", R7e = "https://files.tablegroup.com/wp-content/uploads/2024/08/21114658/Five-Dysfunctions.webp", N7e = "https://files.tablegroup.com/wp-content/uploads/2024/08/21114707/Team-Application-Guide.webp", D7e = "https://files.tablegroup.com/wp-content/uploads/2024/08/21114710/WG-Assessment.webp", j7e = "https://files.tablegroup.com/wp-content/uploads/2024/08/21114654/Certification.webp", L7e = "https://files.tablegroup.com/wp-content/uploads/2024/08/21114704/Streaming.webp", k7e = ({ baseUrl: e, token: t }) => /* @__PURE__ */ E.jsxs("div", { className: "ttg-tools-card", children: [
  /* @__PURE__ */ E.jsx("div", { className: "w-1/3", children: /* @__PURE__ */ E.jsx(
    "img",
    {
      src: Iee,
      alt: "MeetingAdvantage",
      className: "object-contain"
    }
  ) }),
  /* @__PURE__ */ E.jsxs("div", { className: "tools-card-content", children: [
    /* @__PURE__ */ E.jsxs("div", { className: "tools-card-description-container", children: [
      /* @__PURE__ */ E.jsxs("h3", { className: "tools-card-title", children: [
        "CAPA",
        /* @__PURE__ */ E.jsx("sup", { children: "PRO" })
      ] }),
      /* @__PURE__ */ E.jsxs("p", { className: "tools-card-description", children: [
        "Access your CAPA",
        /* @__PURE__ */ E.jsx("sup", { children: "PRO" }),
        " subscription."
      ] })
    ] }),
    /* @__PURE__ */ E.jsxs(
      "a",
      {
        className: "tools-card-button",
        href: `${e}/capapro/`,
        children: [
          "CAPA",
          /* @__PURE__ */ E.jsx("sup", { children: "PRO" }),
          " CONSOLE"
        ]
      }
    )
  ] })
] }), F7e = ({ baseUrl: e, token: t, showAssessment: r }) => /* @__PURE__ */ E.jsxs("div", { className: "ttg-tools-card", children: [
  /* @__PURE__ */ E.jsx("div", { className: "w-1/3", children: /* @__PURE__ */ E.jsx(
    "img",
    {
      src: R7e,
      alt: "FiveDysfunctionsReport",
      className: "object-contain"
    }
  ) }),
  /* @__PURE__ */ E.jsxs("div", { className: "tools-card-content", children: [
    /* @__PURE__ */ E.jsxs("div", { className: "tools-card-description-container", children: [
      /* @__PURE__ */ E.jsx("h3", { className: "tools-card-title", children: "The Five Dysfunctions Online Team Assessment" }),
      /* @__PURE__ */ E.jsx("p", { className: "tools-card-description", children: "Access your console and set up an Online Team Assessment, edit or check the status of existing assessments, or view/change account information." })
    ] }),
    /* @__PURE__ */ E.jsx(
      "a",
      {
        className: "tools-card-button",
        href: r ? `${e}/client/` : `${e}/product/online-team-assessment/`,
        children: r ? "ASSESSMENT CONSOLE" : "LEARN MORE"
      }
    )
  ] })
] }), B7e = ({ baseUrl: e }) => /* @__PURE__ */ E.jsxs("div", { className: "ttg-tools-card", children: [
  /* @__PURE__ */ E.jsx("div", { className: "w-1/3", children: /* @__PURE__ */ E.jsx(
    "img",
    {
      src: Iee,
      alt: "MeetingAdvantage",
      className: "object-contain"
    }
  ) }),
  /* @__PURE__ */ E.jsxs("div", { className: "tools-card-content", children: [
    /* @__PURE__ */ E.jsxs("div", { className: "tools-card-description-container", children: [
      /* @__PURE__ */ E.jsx("h3", { className: "tools-card-title", children: "The Meeting Advantage" }),
      /* @__PURE__ */ E.jsx("p", { className: "tools-card-description", children: "Access your console and create a meeting, edit or view existing meetings, or view/change team information." })
    ] }),
    /* @__PURE__ */ E.jsx(
      "a",
      {
        className: "tools-card-button",
        href: `${e}/meetings/dashboard/`,
        children: "MEETING CONSOLE"
      }
    )
  ] })
] }), z7e = ({ baseUrl: e, token: t, showVideos: r }) => /* @__PURE__ */ E.jsxs("div", { className: "ttg-tools-card", children: [
  /* @__PURE__ */ E.jsx("div", { className: "w-1/3", children: /* @__PURE__ */ E.jsx(
    "img",
    {
      src: L7e,
      alt: "PatVideoMonitor",
      className: "object-contain"
    }
  ) }),
  /* @__PURE__ */ E.jsxs("div", { className: "tools-card-content", children: [
    /* @__PURE__ */ E.jsxs("div", { className: "tools-card-description-container", children: [
      /* @__PURE__ */ E.jsx("h3", { className: "tools-card-title", children: "Streaming Video Subscription" }),
      /* @__PURE__ */ E.jsx("p", { className: "tools-card-description", children: "Access your streaming video subscription." })
    ] }),
    /* @__PURE__ */ E.jsx(
      "a",
      {
        className: "tools-card-button",
        href: r ? `${e}/client/video/` : `${e}/store/`,
        children: r ? "VIDEO SUBSCRIPTION CONSOLE" : "LEARN MORE"
      }
    )
  ] })
] }), H7e = ({
  baseUrl: e,
  token: t,
  showCapaPro: r,
  showAssessment: n,
  showMeetingAdvantage: a,
  showVideos: i
}) => /* @__PURE__ */ E.jsxs("div", { className: "tools-page tools-page--skin--ttg-app", children: [
  /* @__PURE__ */ E.jsx("h2", { className: "tools-header", children: "Table Group" }),
  /* @__PURE__ */ E.jsxs("div", { className: "tools-container", children: [
    /* @__PURE__ */ E.jsx(F7e, { baseUrl: e, token: t, showAssessment: n }),
    a && /* @__PURE__ */ E.jsx(B7e, { baseUrl: e }),
    r && /* @__PURE__ */ E.jsx(k7e, { baseUrl: e, token: t }),
    /* @__PURE__ */ E.jsx(z7e, { baseUrl: e, token: t, showVideos: i })
  ] })
] }), V7e = ({ baseUrl: e, token: t }) => /* @__PURE__ */ E.jsxs("div", { className: "ttg-tools-card", children: [
  /* @__PURE__ */ E.jsx("div", { className: "w-1/3", children: /* @__PURE__ */ E.jsx(
    "img",
    {
      src: D7e,
      alt: "WGAssessmentReport",
      className: "object-contain"
    }
  ) }),
  /* @__PURE__ */ E.jsxs("div", { className: "tools-card-content", children: [
    /* @__PURE__ */ E.jsxs("div", { className: "tools-card-description-container", children: [
      /* @__PURE__ */ E.jsx("h3", { className: "tools-card-title", children: "Working Genius Assessment" }),
      /* @__PURE__ */ E.jsx("p", { className: "tools-card-description", children: "Access your console and set up or take a Working Genius Assessment, edit or check the status of existing assessments, create teams and team maps, or view/change account info." })
    ] }),
    /* @__PURE__ */ E.jsx(
      "a",
      {
        className: "wg-tools-button",
        href: `${e}client/?token=${t}`,
        children: "ASSESSMENT CONSOLE"
      }
    )
  ] })
] }), G7e = ({
  baseUrl: e,
  wgCertification: t,
  token: r,
  isRegisteredInAlumniIntensives: n
}) => /* @__PURE__ */ E.jsxs("div", { className: "ttg-tools-card", children: [
  /* @__PURE__ */ E.jsx("div", { className: "w-1/3", children: /* @__PURE__ */ E.jsx(
    "img",
    {
      src: j7e,
      alt: "WGCertificationIcon",
      className: "object-contain"
    }
  ) }),
  /* @__PURE__ */ E.jsxs("div", { className: "tools-card-content", children: [
    /* @__PURE__ */ E.jsxs("div", { className: "tools-card-description-container", children: [
      /* @__PURE__ */ E.jsx("h3", { className: "tools-card-title", children: "Working Genius Certification" }),
      /* @__PURE__ */ E.jsx("p", { className: "tools-card-description", children: "Access the various tools and resources available to our Certified Network." })
    ] }),
    t !== -1 ? /* @__PURE__ */ E.jsx(E.Fragment, { children: t !== 4 ? /* @__PURE__ */ E.jsx(
      "a",
      {
        className: "wg-tools-button",
        href: `${e}client/certification/prework/?token=${r}`,
        children: "PRE-CERTIFICATION"
      }
    ) : /* @__PURE__ */ E.jsxs("div", { className: "flex flex-wrap gap-1", children: [
      /* @__PURE__ */ E.jsx(
        "a",
        {
          className: "wg-tools-button",
          href: `${e}client/certification/prework/?token=${r}`,
          children: "PRE-CERTIFICATION"
        }
      ),
      /* @__PURE__ */ E.jsx(
        "a",
        {
          className: "wg-tools-button",
          href: `${e}client/certification?token=${r}`,
          children: "CERTIFICATION RESOURCES"
        }
      ),
      /* @__PURE__ */ E.jsx(
        "a",
        {
          className: "wg-tools-button",
          href: "https://working-genius-facilitator-network.mn.co/feed",
          target: "_blank",
          rel: "noreferrer",
          children: "MIGHTY NETWORKS"
        }
      )
    ] }) }) : /* @__PURE__ */ E.jsx("div", { children: /* @__PURE__ */ E.jsx(
      "a",
      {
        className: "wg-tools-button",
        href: `${e}client/certification/?token=${r}`,
        children: "LEARN MORE"
      }
    ) })
  ] })
] }), U7e = ({ baseUrl: e, token: t, hasTeamApplicationGuide: r }) => /* @__PURE__ */ E.jsxs("div", { className: "ttg-tools-card", children: [
  /* @__PURE__ */ E.jsx("div", { className: "w-1/3", children: /* @__PURE__ */ E.jsx(
    "img",
    {
      src: N7e,
      alt: "WGApplicationGuideTablet",
      className: "object-contain"
    }
  ) }),
  /* @__PURE__ */ E.jsxs("div", { className: "tools-card-content", children: [
    /* @__PURE__ */ E.jsxs("div", { className: "tools-card-description-container", children: [
      /* @__PURE__ */ E.jsx("h3", { className: "tools-card-title", children: "Working Genius Team Application Guide" }),
      /* @__PURE__ */ E.jsx("p", { className: "tools-card-description", children: "Access your Team Application Guide console." })
    ] }),
    /* @__PURE__ */ E.jsx(
      "a",
      {
        className: "wg-tools-button",
        href: r ? `${e}application-guide-product/?token=${t}` : `${e}teamapplicationguide/?token=${t}`,
        children: r ? "ACCESS" : "LEARN MORE"
      }
    )
  ] })
] }), W7e = ({
  baseUrl: e,
  wgCertification: t,
  token: r,
  hasTeamApplicationGuide: n,
  isRegisteredInAlumniIntensives: a
}) => /* @__PURE__ */ E.jsxs("div", { className: "tools-page tools-page--skin-default", children: [
  /* @__PURE__ */ E.jsx("h2", { className: "tools-header", children: "Working Genius" }),
  /* @__PURE__ */ E.jsxs("div", { className: "tools-container", children: [
    /* @__PURE__ */ E.jsx(V7e, { baseUrl: e, token: r }),
    /* @__PURE__ */ E.jsx(
      G7e,
      {
        baseUrl: e,
        wgCertification: t,
        token: r,
        isRegisteredInAlumniIntensives: a
      }
    ),
    /* @__PURE__ */ E.jsx(U7e, { baseUrl: e, token: r, hasTeamApplicationGuide: n })
  ] })
] }), PXe = ({
  type: e,
  wgBaseUrl: t,
  ttgBaseUrl: r,
  wgCertification: n,
  showCapaPro: a,
  hasTeamApplicationGuide: i,
  showAssessment: o,
  showMeetingAdvantage: s,
  showVideos: l,
  isRegisteredInAlumniIntensives: c
}) => {
  const u = () => {
    const d = ni.get("TTG_USER");
    if (d) {
      const f = fn().add(90, "minute").unix();
      return `${d}@${f}`;
    }
  };
  return /* @__PURE__ */ E.jsxs("div", { className: "container mx-auto", children: [
    /* @__PURE__ */ E.jsx("div", { className: "flex justify-center items-center pt-16", children: /* @__PURE__ */ E.jsx("h1", { className: "text-3xl font-semibold", children: "Select Your Tool" }) }),
    /* @__PURE__ */ E.jsx("div", { className: "pb-8 pt-4", children: /* @__PURE__ */ E.jsx("hr", { className: "border-t-2 border-gray-800" }) }),
    /* @__PURE__ */ E.jsxs(
      "div",
      {
        className: `flex ${e === "wg" ? "flex-col-reverse" : "flex-col"} bg-white gap-8 p-4`,
        children: [
          /* @__PURE__ */ E.jsx(
            H7e,
            {
              baseUrl: r,
              token: u(),
              showCapaPro: a,
              showAssessment: o,
              showMeetingAdvantage: s,
              showVideos: l
            }
          ),
          /* @__PURE__ */ E.jsx("hr", { className: "border-t-2 border-gray-800" }),
          /* @__PURE__ */ E.jsx(
            W7e,
            {
              baseUrl: t,
              wgCertification: n,
              token: u(),
              hasTeamApplicationGuide: i,
              isRegisteredInAlumniIntensives: c
            }
          )
        ]
      }
    )
  ] });
}, q7e = ({
  form: e,
  nextStep: t,
  previousStep: r,
  theme: n = "default",
  defaultUser: a
}) => {
  const [i, o] = He(!1), s = dr(() => Object.entries(jTe).map(([f, m]) => ({
    value: f,
    label: m
  })), []), { useWatch: l } = Dt, c = l("company", e), u = ["firstName", "lastName", "company", "role", "phone"], d = async () => await e.validateFields(u).catch(() => console.error("Validation Error")) ? t && t() : o(!0);
  return /* @__PURE__ */ E.jsx(zn, { type: "inner", size: "default", bordered: !1, className: `ttg-account-details-step ttg-account-details-step--skin--${n}`, children: /* @__PURE__ */ E.jsx(
    Dt,
    {
      form: e,
      initialValues: a,
      validateMessages: iM,
      validateTrigger: i ? "onChange" : "onSubmit",
      children: /* @__PURE__ */ E.jsxs(At, { gutter: [0, 18], children: [
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
          Dt.Item,
          {
            name: "firstName",
            label: "First Name",
            labelCol: { span: 24 },
            rules: [
              {
                required: !0,
                message: "is required"
              },
              { max: 32 }
            ],
            children: /* @__PURE__ */ E.jsx(Lr, { autoComplete: "given-name", onBlur: (f) => ss(e, f, "firstName") })
          }
        ) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
          Dt.Item,
          {
            name: "lastName",
            label: "Last Name",
            labelCol: { span: 24 },
            rules: [
              {
                required: !0,
                message: "is required"
              },
              { max: 32 }
            ],
            children: /* @__PURE__ */ E.jsx(Lr, { autoComplete: "family-name", onBlur: (f) => ss(e, f, "lastName") })
          }
        ) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
          Dt.Item,
          {
            name: "company",
            initialValue: "",
            label: /* @__PURE__ */ E.jsxs("p", { children: [
              "Company Name ",
              /* @__PURE__ */ E.jsx("span", { className: "font-normal text-gray-500", children: "(Optional)" })
            ] }),
            labelCol: { span: 24 },
            rules: [
              { max: 64 }
            ],
            children: /* @__PURE__ */ E.jsx(Lr, { autoComplete: "organization", onBlur: (f) => ss(e, f, "company") })
          }
        ) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
          Dt.Item,
          {
            name: "role",
            label: "Role",
            labelCol: { span: 24 },
            rules: [
              { required: !!c, message: "is required" }
            ],
            children: /* @__PURE__ */ E.jsx(
              Kn,
              {
                showSearch: !0,
                allowClear: !0,
                "aria-autocomplete": "inline",
                optionFilterProp: "label",
                options: s
              }
            )
          }
        ) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
          Dt.Item,
          {
            name: "phone",
            initialValue: "",
            label: /* @__PURE__ */ E.jsxs("p", { children: [
              " Phone Number ",
              /* @__PURE__ */ E.jsx("span", { className: "font-normal text-gray-500", children: "(Optional)" }),
              " "
            ] }),
            labelCol: { span: 24 },
            rules: [
              { max: 32 },
              {
                pattern: tq,
                message: "You must enter a valid phone number"
              }
            ],
            children: /* @__PURE__ */ E.jsx(Lr, { autoComplete: "tel", onBlur: (f) => ss(e, f, "phone") })
          }
        ) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(lr, { direction: "horizontal", className: "ttg-account-details-step-navigation", children: [
          /* @__PURE__ */ E.jsx(Nt, { className: "w-full", onClick: r, children: "Back" }),
          /* @__PURE__ */ E.jsx(Nt, { type: "primary", className: "w-full", onClick: d, children: "Next" })
        ] }) })
      ] })
    }
  ) });
}, K7e = ({
  form: e,
  previousStep: t,
  userHook: r,
  countryHook: n,
  captchaRef: a,
  optionalAddress: i = !0,
  onRegisterFinish: o,
  theme: s = "default",
  defaultUser: l
}) => {
  const [c, u] = He(!1), [d, f] = He(!1), [m, h] = He(i), g = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" }
  ], {
    getStates: y,
    states: S,
    statesLoading: x,
    countries: b,
    countryLoading: _,
    mapCountryOrZones: $
  } = n, { createUser: w } = r, [O, T] = He({}), I = (L, N, z = "") => {
    const F = Array.isArray(L) ? L.join(".") : L, j = N !== z;
    T((H) => {
      const U = {
        ...H,
        [F]: j
      }, G = Object.values(U).some((V) => V === !0);
      return h(!G), G || e.resetFields([
        ["address", "streetAddress"],
        ["address", "suburb"],
        ["address", "city"],
        ["address", "stateCode"],
        ["address", "countryCode"],
        ["address", "postCode"]
      ]), U;
    });
  };
  St(() => {
    y("US");
  }, []);
  const P = async () => {
    const L = await e.getFieldsValue(), N = await a.current.getCaptchaValue() ?? null;
    u(!0);
    const { password: z, ...F } = L, j = !F.loginMethod || F.loginMethod === Fi.PASSWORD ? L : F, H = Object.keys(j.address || {}).filter((U) => j.address[U] !== void 0 && j.address[U] !== "");
    return H.length === 1 && H[0] === "countryCode" && delete j.address.countryCode, w({
      ...j,
      ...l || {},
      role: L.role ?? oM.OTHER,
      captcha: N
    }).then((U) => {
      if (ni.set("TTG_USER", U?.token, { expires: new Date(Date.now() + 3600 * 1e3), secure: !0 }), o && U?.user)
        return o(U.user, () => u(!1));
      throw new Error("Something went wrong!");
    }).catch((U) => {
      console.error(U), u(!1);
    });
  }, D = () => {
    if (S && S.length > 0)
      return /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
        Dt.Item,
        {
          name: ["address", "stateCode"],
          initialValue: "",
          label: /* @__PURE__ */ E.jsx("p", { children: "State" }),
          labelCol: { span: 24 },
          rules: [
            { required: !m, message: "You must select a state" },
            { max: 32 }
          ],
          children: /* @__PURE__ */ E.jsx(
            Kn,
            {
              showSearch: !0,
              allowClear: !0,
              "aria-autocomplete": "inline",
              loading: x,
              optionFilterProp: "label",
              options: $(S)
            }
          )
        }
      ) });
  }, B = () => /* @__PURE__ */ E.jsxs("div", { className: "ttg-address-details-step-opt-in-label", children: [
    "I’d like to receive helpful content from",
    " ",
    /* @__PURE__ */ E.jsx("a", { tabIndex: 0, target: "_blank", href: "https://www.workinggenius.com/", rel: "noreferrer", children: "Working Genius" }),
    " ",
    "and",
    " ",
    /* @__PURE__ */ E.jsx("a", { tabIndex: 0, target: "_blank", href: "https://www.tablegroup.com/", rel: "noreferrer", children: "The Table Group" })
  ] });
  return /* @__PURE__ */ E.jsx(
    zn,
    {
      type: "inner",
      size: "default",
      bordered: !1,
      className: `ttg-address-details-step ttg-address-details-step--skin--${s}`,
      children: /* @__PURE__ */ E.jsx(
        Dt,
        {
          form: e,
          onFinish: P,
          onFinishFailed: () => f(!0),
          validateMessages: iM,
          validateTrigger: d ? "onChange" : "onSubmit",
          children: /* @__PURE__ */ E.jsxs(At, { gutter: [0, 18], children: [
            /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
              Dt.Item,
              {
                name: ["address", "streetAddress"],
                initialValue: "",
                label: /* @__PURE__ */ E.jsx("p", { children: "Street Address" }),
                labelCol: { span: 24 },
                rules: [
                  {
                    required: !m,
                    message: "You must enter a street address"
                  },
                  {
                    min: 5
                  },
                  {
                    max: 64
                  }
                ],
                children: /* @__PURE__ */ E.jsx(
                  Lr,
                  {
                    autoComplete: "street-address",
                    onBlur: (L) => ss(e, L, ["address", "streetAddress"]),
                    onChange: (L) => I(["address", "streetAddress"], L.target.value, "")
                  }
                )
              }
            ) }),
            /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
              Dt.Item,
              {
                name: ["address", "suburb"],
                initialValue: "",
                label: /* @__PURE__ */ E.jsx("p", { children: "Address Line 2" }),
                labelCol: { span: 24 },
                rules: [
                  {
                    max: 64
                  }
                ],
                children: /* @__PURE__ */ E.jsx(
                  Lr,
                  {
                    autoComplete: "address-line2",
                    onBlur: (L) => ss(e, L, ["address", "suburb"]),
                    onChange: (L) => I(["address", "suburb"], L.target.value, "")
                  }
                )
              }
            ) }),
            /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
              Dt.Item,
              {
                name: ["address", "countryCode"],
                initialValue: "US",
                label: /* @__PURE__ */ E.jsx("p", { children: "Country" }),
                labelCol: { span: 24 },
                rules: [
                  { required: !m, message: "You must select a country" },
                  { max: 3 }
                ],
                children: /* @__PURE__ */ E.jsx(
                  Kn,
                  {
                    showSearch: !0,
                    allowClear: !0,
                    "aria-autocomplete": "inline",
                    loading: _,
                    onChange: (L) => {
                      y(L), e.setFieldValue(["address", "stateCode"], ""), I(["address", "countryCode"], L, "US");
                    },
                    optionFilterProp: "label",
                    options: b ? $(b) : []
                  }
                )
              }
            ) }),
            /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
              Dt.Item,
              {
                name: ["address", "city"],
                initialValue: "",
                label: /* @__PURE__ */ E.jsx("p", { children: "City" }),
                labelCol: { span: 24 },
                rules: [
                  {
                    required: !m,
                    message: "You must enter a city"
                  },
                  { min: 3 },
                  { max: 32 }
                ],
                children: /* @__PURE__ */ E.jsx(
                  Lr,
                  {
                    autoComplete: "address-level2",
                    onBlur: (L) => ss(e, L, ["address", "city"]),
                    onChange: (L) => I(["address", "city"], L.target.value, "")
                  }
                )
              }
            ) }),
            D(),
            /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
              Dt.Item,
              {
                name: ["address", "postCode"],
                initialValue: "",
                label: /* @__PURE__ */ E.jsx("p", { children: "Postal Code/Zip" }),
                labelCol: { span: 24 },
                rules: [
                  {
                    required: !m,
                    message: "You must enter a Postal Code/Zip"
                  },
                  {
                    pattern: rq,
                    message: "You must enter a valid Postal Code/Zip"
                  },
                  {
                    min: 4
                  },
                  {
                    max: 10
                  }
                ],
                children: /* @__PURE__ */ E.jsx(
                  Lr,
                  {
                    autoComplete: "postal-code",
                    onBlur: (L) => ss(e, L, ["address", "postCode"]),
                    onChange: (L) => I(["address", "postCode"], L.target.value, "")
                  }
                )
              }
            ) }),
            /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
              Dt.Item,
              {
                name: "optIn",
                label: B(),
                labelCol: { span: 24 },
                rules: [
                  { required: !0 }
                ],
                children: /* @__PURE__ */ E.jsx(Ba.Group, { className: `ant-radio-group--skin--${s}`, children: g.map((L, N) => /* @__PURE__ */ E.jsx(Ba, { value: L.value, children: L.label }, N)) })
              }
            ) }),
            /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(lr, { direction: "horizontal", className: "ttg-address-details-step-navigation", children: [
              /* @__PURE__ */ E.jsx(Nt, { className: "w-full", onClick: t, children: "Back" }),
              /* @__PURE__ */ E.jsx(Nt, { htmlType: "submit", type: "primary", className: "w-full", loading: c, children: "Create Account" })
            ] }) })
          ] })
        }
      )
    }
  );
}, mk = ["email", "password", "confirmPassword"], Y7e = ({
  form: e,
  nextStep: t,
  userHook: r,
  captchaRef: n,
  theme: a = "default",
  defaultUser: i,
  ssoHook: o,
  onFinish: s,
  onError: l,
  resource: c,
  loading: u,
  onLoad: d
}) => {
  const [f, m] = He(!1), [h, g] = He(""), [y, S] = xe.useState(!1), { getUserByEmail: x } = r, {
    allowedAuthProviders: b,
    linkedinClientId: _,
    linkedinRedirectUri: $,
    microsoftRedirectUri: w,
    microsoftClientId: O,
    onChangeRegisteringUser: T,
    onChangeSSOAuthError: I
  } = o, { oauthLoginUser: P } = r, D = dr(() => !i?.loginMethod || i?.loginMethod === Fi.PASSWORD, [i]), B = (z) => {
    if (z) {
      if (z?.user)
        return s(z.user, () => d(!1), c?.redirectPath);
      if (z.email) {
        const F = z;
        return e.resetFields(), Object.entries(F).forEach(([j, H]) => {
          H && e.setFieldValue(j, H);
        }), d(!1), T(F);
      }
    }
    d(!1), l("Oops, something went wrong.");
  }, L = Bt(async () => {
    if (l(void 0), I(void 0), !D) return t && t();
    if (!await e.validateFields(mk).catch(() => console.error("Validation Error")))
      return m(!0);
    const F = await n?.current?.getCaptchaValue(), j = e.getFieldValue("email");
    return d(!0), x(j, F).then((H) => H?.exists ? l("An account already exists with this email address.") : t && t()).catch((H) => console.error(H)).finally(() => d(!1));
  }, [
    n,
    i,
    e,
    x,
    t,
    mk
  ]);
  St(() => {
    D || (["passowrd", "confirmPassword"].forEach((z) => e.setFieldValue(z, void 0)), L());
  }, [D]);
  const N = (z, F) => {
    S(!z);
  };
  return /* @__PURE__ */ E.jsx(
    zn,
    {
      type: "inner",
      size: "default",
      bordered: !1,
      className: `ttg-sign-in-details-step ttg-sign-in-details-step--skin--${a}`,
      children: /* @__PURE__ */ E.jsx(
        Dt,
        {
          initialValues: i,
          form: e,
          validateMessages: iM,
          validateTrigger: f ? "onChange" : "onSubmit",
          children: /* @__PURE__ */ E.jsxs(At, { gutter: [0, 10], children: [
            /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
              Dt.Item,
              {
                name: "email",
                label: "Email Address",
                labelCol: { span: 24 },
                rules: [
                  {
                    required: !0
                  },
                  { max: 96 },
                  {
                    pattern: nC,
                    message: "Please enter a valid email address."
                  }
                ],
                children: /* @__PURE__ */ E.jsx(
                  Lr,
                  {
                    disabled: !!i?.email,
                    autoComplete: "email",
                    onBlur: (z) => ss(
                      e,
                      z,
                      "email",
                      !1
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ E.jsxs(Oe, { span: 24, children: [
              /* @__PURE__ */ E.jsx(
                Dt.Item,
                {
                  hidden: !D,
                  name: "password",
                  label: "Password",
                  labelCol: { span: 24 },
                  rules: D ? [
                    { required: !0, message: "is required" },
                    {
                      pattern: eq,
                      message: "Your password doesn't meet the requirements."
                    }
                  ] : [],
                  children: /* @__PURE__ */ E.jsx(
                    Lr.Password,
                    {
                      autoComplete: "new-password",
                      value: h,
                      onChange: (z) => {
                        g(z.target.value), e.setFieldValue("password", z.target.value);
                      }
                    }
                  )
                }
              ),
              /* @__PURE__ */ E.jsx(dq, { showRestrictions: !!h && y, value: h, handleValidationChange: N })
            ] }),
            /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
              Dt.Item,
              {
                hidden: !D,
                name: "confirmPassword",
                label: "Confirm Password",
                labelCol: { span: 24 },
                rules: D ? [
                  { required: !0, message: "is required" },
                  ({ getFieldValue: z }) => ({
                    validator(F, j) {
                      return !j || z("password") === j ? Promise.resolve() : Promise.reject(new Error("Passwords do not match"));
                    }
                  })
                ] : [],
                children: /* @__PURE__ */ E.jsx(Lr.Password, { autoComplete: "new-password" })
              }
            ) }),
            /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "pt-2", children: /* @__PURE__ */ E.jsx(
              Nt,
              {
                type: "primary",
                className: "w-full",
                loading: u,
                onClick: L,
                children: "Next"
              }
            ) }),
            D && /* @__PURE__ */ E.jsx(Eh, { plain: !0, children: "Or continue with" }),
            /* @__PURE__ */ E.jsx(At, { justify: "center", style: { width: "100%" }, children: D && b.map((z) => /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(
              oq,
              {
                provider: z,
                ssoHook: o,
                loading: u,
                oauthLoginUser: (F) => P(F, c, i),
                onLoad: d,
                onError: l,
                signInOrRegister: B,
                linkedinClientId: _,
                linkedinRedirectUri: $,
                microsoftClientId: O,
                microsoftRedirectUri: w
              }
            ) }, z)) })
          ] })
        }
      )
    }
  );
};
var sT = { exports: {} };
(function(e, t) {
  (function(r, n) {
    n(t, xe);
  })(Ue, function(r, n) {
    var a = "default" in n ? n.default : n;
    function i(b) {
      return (i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(_) {
        return typeof _;
      } : function(_) {
        return _ && typeof Symbol == "function" && _.constructor === Symbol && _ !== Symbol.prototype ? "symbol" : typeof _;
      })(b);
    }
    function o(b, _) {
      for (var $ = 0; $ < _.length; $++) {
        var w = _[$];
        w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(b, w.key, w);
      }
    }
    function s(b, _, $) {
      return _ in b ? Object.defineProperty(b, _, { value: $, enumerable: !0, configurable: !0, writable: !0 }) : b[_] = $, b;
    }
    function l(b) {
      return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function(_) {
        return _.__proto__ || Object.getPrototypeOf(_);
      })(b);
    }
    function c(b, _) {
      return (c = Object.setPrototypeOf || function($, w) {
        return $.__proto__ = w, $;
      })(b, _);
    }
    function u(b) {
      if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return b;
    }
    function d(b) {
      var _ = function() {
        if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
        if (typeof Proxy == "function") return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
          })), !0;
        } catch {
          return !1;
        }
      }();
      return function() {
        var $, w = l(b);
        return $ = _ ? ($ = l(this).constructor, Reflect.construct(w, arguments, $)) : w.apply(this, arguments), w = this, !($ = $) || typeof $ != "object" && typeof $ != "function" ? u(w) : $;
      };
    }
    function f(b, _) {
      var $, w = (_ = _ === void 0 ? {} : _).insertAt;
      b && typeof document < "u" && ($ = document.head || document.getElementsByTagName("head")[0], (_ = document.createElement("style")).type = "text/css", w === "top" && $.firstChild ? $.insertBefore(_, $.firstChild) : $.appendChild(_), _.styleSheet ? _.styleSheet.cssText = b : _.appendChild(document.createTextNode(b)));
    }
    var m = { animated: "rsw_1z", fadeInRight: "rsw_1M", fadeInLeft: "rsw_19", fadeOutRight: "rsw_3C", fadeOutLeft: "rsw_1u" };
    f(`/**
 * Snippets from animate.css
 * Credit goes to https://github.com/daneden
 * github.com/daneden/animate.css
*/
.rsw_1z {
  -webkit-animation-duration: .8192s;
  animation-duration: .8192s;
  -webkit-animation-fill-mode: backwards;
  animation-fill-mode: backwards;
}

/** fadeInRight */
@-webkit-keyframes rsw_1M {
  from {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes rsw_1M {
  from {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

.rsw_1M {
  -webkit-animation-name: rsw_1M;
  animation-name: rsw_1M;
}

/** fadeInLeft */
@-webkit-keyframes rsw_19 {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes rsw_19 {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

.rsw_19 {
  -webkit-animation-name: rsw_19;
  animation-name: rsw_19;
}

/** fadeOutRight */
@-webkit-keyframes rsw_3C {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}

@keyframes rsw_3C {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}

.rsw_3C {
  -webkit-animation-name: rsw_3C;
  animation-name: rsw_3C;
}

/** fadeOutLeft */
@-webkit-keyframes rsw_1u {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

@keyframes rsw_1u {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

.rsw_1u {
  -webkit-animation-name: rsw_1u;
  animation-name: rsw_1u;
}
`);
    var h = "rsw_2Y", g = "rsw_2f", y = "rsw_3G";
    f(`/** Step Wizard */
.rsw_2Y {
    position: relative;
}

.rsw_2f {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0;
}

.rsw_3G {
    opacity: 1;
    pointer-events: inherit;
    position: relative;
    z-index: 1;
}
`);
    var S = function() {
      (function(O, T) {
        if (typeof T != "function" && T !== null) throw new TypeError("Super expression must either be null or a function");
        O.prototype = Object.create(T && T.prototype, { constructor: { value: O, writable: !0, configurable: !0 } }), T && c(O, T);
      })(w, n.PureComponent);
      var b, _, $ = d(w);
      function w(O) {
        var T;
        return function(I, P) {
          if (!(I instanceof P)) throw new TypeError("Cannot call a class as a function");
        }(this, w), s(u(T = $.call(this, O)), "initialState", function() {
          var I = { activeStep: 0, classes: {}, hashKeys: {}, namedSteps: {} }, P = (typeof window > "u" ? "undefined" : i(window)) === "object" ? T.getHash() : "", D = T.getSteps();
          D.forEach(function(L, N) {
            I.hashKeys[N] = L.props && L.props.hashKey || "step".concat(N + 1), I.hashKeys[I.hashKeys[N]] = N, I.namedSteps[N] = L.props && L.props.stepName || "step".concat(N + 1), I.namedSteps[I.namedSteps[N]] = N;
          });
          var B = T.props.initialStep - 1;
          return B && D[B] && (I.activeStep = B), T.props.isHashEnabled && P && I.hashKeys[P] !== void 0 && (I.activeStep = I.hashKeys[P]), T.props.transitions && (I.classes[I.activeStep] = T.props.transitions.intro || ""), I;
        }), s(u(T), "getHash", function() {
          return decodeURI(window.location.hash).replace(/^#/, "");
        }), s(u(T), "getTransitions", function() {
          return T.props.transitions || { enterRight: "".concat(m.animated, " ").concat(m.fadeInRight), enterLeft: "".concat(m.animated, " ").concat(m.fadeInLeft), exitRight: "".concat(m.animated, " ").concat(m.fadeOutRight), exitLeft: "".concat(m.animated, " ").concat(m.fadeOutLeft) };
        }), s(u(T), "onHashChange", function() {
          T.setActiveStep(T.state.hashKeys[T.getHash()] || 0);
        }), s(u(T), "isInvalidStep", function(I) {
          return I < 0 || I >= T.totalSteps;
        }), s(u(T), "setActiveStep", function(I) {
          var P, D, B = T.state.activeStep;
          B !== I && (T.isInvalidStep(I) ? process.env.NODE_ENV !== "production" && console.error("".concat(I + 1, " is an invalid step")) : (P = T.state.classes, D = T.getTransitions(), B < I ? (P[B] = D.exitLeft, P[I] = D.enterRight) : (P[B] = D.exitRight, P[I] = D.enterLeft), T.setState({ activeStep: I, classes: P }, function() {
            T.onStepChange({ previousStep: B + 1, activeStep: I + 1 });
          })));
        }), s(u(T), "onStepChange", function(I) {
          T.props.onStepChange(I), T.props.isHashEnabled && T.updateHash(T.state.activeStep);
        }), s(u(T), "getSteps", function() {
          return a.Children.toArray(T.props.children);
        }), s(u(T), "firstStep", function() {
          return T.goToStep(1);
        }), s(u(T), "lastStep", function() {
          return T.goToStep(T.totalSteps);
        }), s(u(T), "nextStep", function() {
          return T.setActiveStep(T.state.activeStep + 1);
        }), s(u(T), "previousStep", function() {
          return T.setActiveStep(T.state.activeStep - 1);
        }), s(u(T), "goToStep", function(I) {
          T.props.isHashEnabled && typeof I == "string" && T.state.hashKeys[I] !== void 0 ? T.setActiveStep(T.state.hashKeys[I]) : T.setActiveStep(I - 1);
        }), s(u(T), "goToNamedStep", function(I) {
          typeof I == "string" && T.state.namedSteps[I] !== void 0 ? T.setActiveStep(T.state.namedSteps[I]) : console.error('Cannot find step with name "'.concat(I, '"'));
        }), s(u(T), "updateHash", function(I) {
          window.location.hash = T.state.hashKeys[I];
        }), s(u(T), "isReactComponent", function(I) {
          return I = I.type, typeof I == "function" || i(I) === "object";
        }), T.state = T.initialState(), T;
      }
      return b = w, (_ = [{ key: "componentDidMount", value: function() {
        this.props.isHashEnabled && window.addEventListener("hashchange", this.onHashChange), this.props.instance(this);
      } }, { key: "componentWillUnmount", value: function() {
        this.props.isHashEnabled && window.removeEventListener("hashchange", this.onHashChange);
      } }, { key: "currentStep", get: function() {
        return this.state.activeStep + 1;
      } }, { key: "totalSteps", get: function() {
        return this.getSteps().length;
      } }, { key: "render", value: function() {
        var O = this, T = { currentStep: this.currentStep, totalSteps: this.totalSteps, nextStep: this.nextStep, previousStep: this.previousStep, goToStep: this.goToStep, goToNamedStep: this.goToNamedStep, firstStep: this.firstStep, lastStep: this.lastStep }, I = this.state.classes, P = a.Children.map(this.getSteps(), function(D, B) {
          return D ? (T.isActive = B === O.state.activeStep, T.transitions = I[B], !O.props.isLazyMount || O.props.isLazyMount && T.isActive ? a.createElement(x, T, O.isReactComponent(D) ? a.cloneElement(D, T) : D) : null) : null;
        });
        return a.createElement("div", { className: this.props.className }, this.props.nav && a.cloneElement(this.props.nav, T), a.createElement("div", { className: h }, P));
      } }]) && o(b.prototype, _), w;
    }();
    S.defaultProps = { children: [], className: null, initialStep: 1, instance: function() {
    }, isHashEnabled: !1, isLazyMount: !1, nav: null, onStepChange: function() {
    }, transitions: void 0 };
    var x = function(w) {
      var _ = w.children, $ = w.isActive, w = w.transitions;
      return a.createElement("div", { className: "".concat(g, " ").concat(w, " ").concat($ ? y : "").trim() }, _);
    };
    process.env.NODE_ENV, x.defaultProps = { children: [], isActive: !1, transitions: "" }, r.Step = x, r.default = S, Object.defineProperty(r, "__esModule", { value: !0 });
  });
})(sT, sT.exports);
var Z7e = sT.exports;
const X7e = /* @__PURE__ */ Ut(Z7e), RXe = ({
  theme: e,
  initialStep: t,
  userHook: r,
  useCountry: n,
  onFinish: a,
  userToken: i,
  ssoHook: o,
  captchaKey: s,
  captchaEnabled: l,
  resource: c
}) => {
  const [u, d] = He(!1), [f] = Dt.useForm(), [m, h] = He(t ?? 1), g = ct("captcha"), [y, S] = He(), {
    privacyUrl: x,
    termsOfServiceUrl: b,
    dataPrivacyUrl: _,
    appId: $,
    registeringUser: w,
    ssoAuthError: O
  } = o, T = dr(() => {
    if (i && w)
      return i.email !== w.email ? i : { ...w, ...i };
    const D = c && c.email ? { email: c.email, resource: c } : void 0;
    return D && w ? D.email !== w.email ? D : { ...w, ...D } : i || D || w;
  }, [i, w, c]), I = () => {
    if (y || O)
      return /* @__PURE__ */ E.jsx(Oe, { className: "mb-6", children: /* @__PURE__ */ E.jsx(uM, { children: y || O }) });
  }, P = () => {
    if (w)
      return /* @__PURE__ */ E.jsx(Oe, { className: `sso-register-text sso-register-text--skin--${e}`, children: "You are currently setting your account up via single sign-on authorization. As part of your one-time account setup, we will ask you for a few additional details on the following screens." });
  };
  return /* @__PURE__ */ E.jsx(
    At,
    {
      justify: "center",
      align: "top",
      className: `ttg-app-register ttg-app-register--skin--${e}`,
      children: /* @__PURE__ */ E.jsxs(Oe, { span: 24, className: "flex flex-col justify-center w-full max-w-md", children: [
        /* @__PURE__ */ E.jsxs(
          lr,
          {
            direction: "vertical",
            align: "center",
            className: "h-full gap-0",
            children: [
              I(),
              P()
            ]
          }
        ),
        /* @__PURE__ */ E.jsxs(Oe, { span: 24, className: "register-wizard", children: [
          /* @__PURE__ */ E.jsxs(
            X7e,
            {
              initialStep: t,
              nav: /* @__PURE__ */ E.jsx(J7e, { currentStep: m }),
              className: "bg-white",
              onStepChange: ({ activeStep: D }) => h(D),
              children: [
                /* @__PURE__ */ E.jsx(
                  Y7e,
                  {
                    error: y,
                    onError: S,
                    ssoHook: o,
                    onFinish: a,
                    theme: e,
                    form: f,
                    userHook: r,
                    captchaRef: g,
                    defaultUser: T,
                    resource: c,
                    loading: u,
                    onLoad: d
                  }
                ),
                /* @__PURE__ */ E.jsx(
                  q7e,
                  {
                    theme: e,
                    form: f,
                    defaultUser: T
                  }
                ),
                /* @__PURE__ */ E.jsx(
                  K7e,
                  {
                    theme: e,
                    form: f,
                    defaultUser: T,
                    userHook: r,
                    countryHook: n,
                    captchaRef: g,
                    onRegisterFinish: a
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ E.jsx(
            Q7e,
            {
              step: m,
              privacyUrl: x,
              appId: $,
              termsOfServiceUrl: b,
              dataPrivacyUrl: _
            }
          ),
          /* @__PURE__ */ E.jsx(
            iC,
            {
              ref: g,
              captchaSiteKey: s,
              captchaEnabled: l
            }
          )
        ] })
      ] })
    }
  );
}, { Text: vk } = Gn, J7e = ({
  currentStep: e
}) => {
  const t = [
    { number: 1, label: "Login Details" },
    { number: 2, label: "Account Details" },
    { number: 3, label: "Address Details (Optional)" }
  ];
  return e && e > 3 ? null : /* @__PURE__ */ E.jsxs(Oe, { span: 24, className: "ttg-register-step-navigator", children: [
    /* @__PURE__ */ E.jsx("h1", { className: "create-account-title", children: "Create Account" }),
    /* @__PURE__ */ E.jsxs(vk, { className: "ttg-register-step-navigator-number", children: [
      "Step ",
      e,
      " of 3"
    ] }),
    /* @__PURE__ */ E.jsx(vk, { className: "ttg-register-step-navigator-title", children: t.find((r) => r.number === e)?.label })
  ] });
}, Q7e = ({
  step: e,
  appId: t,
  privacyUrl: r,
  termsOfServiceUrl: n
}) => e === 1 || e === 3 ? /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "ttg-app-register-footer", children: /* @__PURE__ */ E.jsxs("p", { children: [
  e === 1 && /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
    "Already have an account? ",
    /* @__PURE__ */ E.jsx(
      Nt,
      {
        type: "link",
        href: `${t === Ad.WG ? "/client" : ""}/login`,
        children: "Login"
      }
    )
  ] }),
  e === 3 && /* @__PURE__ */ E.jsxs("p", { className: "agreement-terms", children: [
    "By clicking “Create Account” you agree to Working Genius’s and Tablegroup’s",
    " ",
    /* @__PURE__ */ E.jsx(
      Nt,
      {
        type: "link",
        href: n,
        target: "_blank",
        tabIndex: 0,
        children: "Terms of Service"
      }
    ),
    " and ",
    /* @__PURE__ */ E.jsx(
      Nt,
      {
        type: "link",
        href: r,
        target: "_blank",
        tabIndex: 0,
        children: "Privacy Policy"
      }
    ),
    "."
  ] })
] }) }) : null;
function eke(e) {
  return $i({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" } }, { tag: "path", attr: { d: "M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.43-.98 2.63-2.31 2.98l1.46 1.46C20.88 15.61 22 13.95 22 12c0-2.76-2.24-5-5-5zm-1 4h-2.19l2 2H16zM2 4.27l3.11 3.11A4.991 4.991 0 002 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4L20 19.74 3.27 3 2 4.27z" } }, { tag: "path", attr: { fill: "none", d: "M0 24V0" } }] })(e);
}
const NXe = ({ error: e, theme: t, appId: r }) => /* @__PURE__ */ E.jsxs(
  "div",
  {
    className: `ttg-app-register-token-error ttg-app-register-token-error--skin--${t}`,
    children: [
      /* @__PURE__ */ E.jsx(eke, { className: "text-red-500 text-7xl text-center items-center" }),
      e.expired && /* @__PURE__ */ E.jsx("h1", { className: "token-error-title", children: "Expired Link" }),
      /* @__PURE__ */ E.jsx("p", { className: "token-error-text", children: e.message }),
      /* @__PURE__ */ E.jsx(
        Nt,
        {
          type: "link",
          href: `${r === Ad.WG ? "/client" : ""}/login`,
          className: "token-error-login-button",
          children: "Login"
        }
      )
    ]
  }
), DXe = ({
  theme: e,
  tokenType: t,
  onContinue: r,
  loading: n
}) => /* @__PURE__ */ E.jsx(
  zn,
  {
    type: "inner",
    size: "default",
    bordered: !1,
    className: `ttg-sign-in-details-step ttg-sign-in-details-step--skin--${e}`,
    children: /* @__PURE__ */ E.jsxs("div", { className: "flex flex-col justify-center gap-4", children: [
      (t === fl.WG_LICENSE || t === fl["5DOT_LICENSE"]) && `You have been invited to join ${t === fl.WG_LICENSE ? "The Working Genius" : "The Table Group"}.
        To receive the licenses transferred to your account you need to create an account first.`,
      t === fl.PERMISSION && "You have been invited to join The Working Genius. You have been granted access to an account and need to create an account first to access the granted permissions.",
      t === fl.WG_ASSESSMENT && "To gain access to your assessment(s) you need to create an account first.",
      t === fl.WG_CERTIFICATION && "You have been invited to join The Working Genius. To gain access to your certification resources you need to create an account first.",
      /* @__PURE__ */ E.jsx(lo, { title: "For security purposes a Google Captcha might appear. Please fill it out in order to continue.", children: /* @__PURE__ */ E.jsx(Nt, { tabIndex: 0, onClick: r, loading: n, icon: /* @__PURE__ */ E.jsx(_l, {}), children: "Continue" }) })
    ] })
  }
), { Text: tke, Paragraph: hk } = Gn, jXe = ({ source: e }) => /* @__PURE__ */ E.jsx(At, { justify: "center", className: "ttg-staffing-translator-not-found-page", children: /* @__PURE__ */ E.jsxs(Oe, { span: 24, className: "content", children: [
  /* @__PURE__ */ E.jsx("h1", { className: "text-xl md:text-3xl font-semibold my-6", children: "Page Not Found" }),
  /* @__PURE__ */ E.jsx(hk, { className: "text-lg font-normal mb-4", children: "We’re sorry. The page you requested cannot be found. The address may have been typed incorrectly or the page may have been moved." }),
  /* @__PURE__ */ E.jsxs(hk, { className: "text-lg font-normal mb-4", children: [
    "You will be automatically redirected to the homepage after ten seconds. If the problem persists, please contact our office at 925.299.9700 or via email to",
    " ",
    e === Ad.TTG ? /* @__PURE__ */ E.jsx("a", { href: "mailto:support@tablegroup.com", children: "support@tablegroup.com" }) : /* @__PURE__ */ E.jsx("a", { href: "mailto:support@workinggenius.com", children: "support@workinggenius.com" }),
    "."
  ] }),
  /* @__PURE__ */ E.jsx(tke, { className: "text-lg font-normal mb-4", children: "Thank you." })
] }) }), Mee = ({
  type: e = "span",
  size: t = "sm",
  fontWeight: r = "regular",
  leading: n,
  children: a,
  className: i,
  href: o,
  onClick: s,
  title: l
}) => /* @__PURE__ */ E.jsx(
  e,
  {
    className: be(
      `text-${t}`,
      `font-${r}`,
      n && `leading-${n}`,
      i
    ),
    onClick: s,
    title: l,
    children: o ? /* @__PURE__ */ E.jsx("a", { target: "_blank", href: o, rel: "noopener noreferrer", children: a }) : a
  }
), LXe = (e) => /* @__PURE__ */ E.jsx(Mee, { type: "p", ...e }), Aee = (e) => /* @__PURE__ */ E.jsx(Mee, { type: "span", ...e }), rke = ({
  onClick: e,
  onKeyDown: t,
  disabled: r,
  loading: n,
  ...a
}) => {
  const i = (o) => {
    r || n || !e || (o.key === "Enter" || o.key === " ") && e();
  };
  return /* @__PURE__ */ E.jsx(
    Nt,
    {
      ...a,
      disabled: r,
      loading: n,
      onClick: e,
      onKeyDown: t || i
    }
  );
}, kXe = ({
  value: e = [],
  onChange: t,
  onChangeError: r,
  max: n,
  maxLength: a,
  placeholder: i,
  className: o,
  duplicateError: s,
  invalidError: l,
  maxError: c,
  maxLengthError: u,
  onValidate: d,
  ...f
}) => {
  const [m, h] = He(""), [g, y] = He([]), [S, x] = He(!1), b = Bt(
    () => {
      if (!S) return;
      y([]);
      const I = m.split(/[\s,]+/).map((D) => D.trim()).filter((D) => D.toLowerCase()), P = [...e, ...I];
      t?.(P), h(""), x(!1);
    },
    [m, t, S, e]
  ), _ = ct(null), $ = (I) => {
    const P = Math.abs(I.target.value.length - m.length) > 1;
    h(I.target.value), x(P);
  }, w = (I) => {
    (I.key === " " || I.key === "," || I.key === "Enter") && (I.preventDefault(), I.stopPropagation(), x(!0));
  }, O = (I) => {
    I.preventDefault(), I.stopPropagation(), x(!0);
  }, T = (I, P) => {
    I.stopPropagation(), I.preventDefault(), t?.(e.filter((D, B) => B !== P));
  };
  return St(() => {
    const I = e.filter((F, j) => e.findIndex((H) => H === F) !== j), P = d ? e.filter((F) => !d(F)) : [], D = a ? e.filter((F) => F.length > a) : [], B = n && e.length > n ? [...e] : [], L = [
      ...I,
      ...P,
      ...D,
      ...B
    ].filter((F, j, H) => H.findIndex((U) => U === F) === j);
    if (L.filter((F, j) => g.findIndex((H) => H === F) !== j).length === 0 && L.length === g.length)
      return;
    y(L);
    const z = P.length > 0 && l ? [l] : I.length > 0 && s ? [s] : P.length > 0 && l ? [l] : n && e.length > n && c ? [c] : [];
    r?.(z);
  }, [
    s,
    g,
    l,
    n,
    c,
    a,
    u,
    r,
    d,
    e
  ]), St(() => {
    b();
  }, [b]), /* @__PURE__ */ E.jsxs(
    "div",
    {
      className: `csv-tags-container ${g.length > 0 && "ant-input-outlined ant-input-status-error"}`,
      children: [
        e.map((I, P) => /* @__PURE__ */ E.jsx(
          nM,
          {
            closable: !0,
            onClose: (D) => T(D, P),
            className: `py-[2px] m-1 ${g.includes(I) ? "border-red-50 bg-red-50" : "border-gray-100  bg-gray-100"}`,
            children: /* @__PURE__ */ E.jsx(Aee, { leading: 4, size: "xs", className: "text-gray-800 px-[4px]", children: I })
          },
          `${P}`
        )),
        /* @__PURE__ */ E.jsx(
          Lr,
          {
            ref: _,
            autoComplete: "off",
            value: m,
            onChange: $,
            onKeyDown: w,
            placeholder: i,
            className: `border-none outline-none flex-grow ${o}`,
            onBlur: O,
            ...f
          }
        )
      ]
    }
  );
}, FXe = ({
  columns: e,
  expandable: t,
  data: r,
  ...n
}) => /* @__PURE__ */ E.jsx(
  zo,
  {
    columns: e,
    expandable: t,
    dataSource: r,
    className: "ttg-common-table",
    ...n
  }
), { Text: gk } = Gn, BXe = ({
  dataSource: e = [],
  columns: t = [],
  loading: r = !1,
  rowClassName: n,
  emptyState: a,
  headerRenderer: i
}) => {
  const o = Bt((s, l, c, u) => {
    const d = typeof s.title == "function" ? s.title({}) : s.title, f = s.key?.toString() || u.toString(), m = s.dataIndex, h = m ? l[m] : null, g = s.render ? s.render(h, l, c) : h;
    return /* @__PURE__ */ E.jsx(xe.Fragment, { children: /* @__PURE__ */ E.jsxs(At, { className: `ttg-mobile-table-card-row ${s.className ? `${s.className}-mobile` : ""}`, children: [
      /* @__PURE__ */ E.jsx(Oe, { span: 12, className: "ttg-mobile-table-card-row-header", children: /* @__PURE__ */ E.jsx(gk, { children: d }) }),
      /* @__PURE__ */ E.jsx(Oe, { span: 12, className: "ttg-mobile-table-card-row-content", children: g })
    ] }) }, f);
  }, []);
  return r ? /* @__PURE__ */ E.jsx(At, { justify: "center", align: "middle", className: "my-6", children: /* @__PURE__ */ E.jsx(Td, {}) }) : e.length === 0 && a ? /* @__PURE__ */ E.jsxs(FI, { vertical: !0, justify: "center", align: "center", children: [
    a.icon,
    /* @__PURE__ */ E.jsx(gk, { className: "text-gray-400", children: a.text })
  ] }) : /* @__PURE__ */ E.jsx(lr, { direction: "vertical", className: "ttg-mobile-table-card", children: e.map((s, l) => /* @__PURE__ */ E.jsx(
    zn,
    {
      className: `${n?.(s, l) ?? ""}`,
      size: "small",
      title: i?.(s),
      children: t.map((c, u) => o(
        c,
        s,
        l,
        u
      ))
    },
    l
  )) });
}, zXe = ({
  loading: e,
  pagination: t,
  onLoadMore: r,
  theme: n = "default"
}) => /* @__PURE__ */ E.jsx(FI, { justify: "center", className: `ttg-table-load-more ttg-table-load-more--skin--${n}`, children: !e && t.page < t.totalPages && /* @__PURE__ */ E.jsx(
  Nt,
  {
    type: "link",
    onClick: r,
    children: "Load More"
  }
) });
var Pee = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(Ue, function() {
    var r = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, n = {};
    return function(a, i, o) {
      var s, l = function(f, m, h) {
        h === void 0 && (h = {});
        var g = new Date(f), y = function(S, x) {
          x === void 0 && (x = {});
          var b = x.timeZoneName || "short", _ = S + "|" + b, $ = n[_];
          return $ || ($ = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: S, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: b }), n[_] = $), $;
        }(m, h);
        return y.formatToParts(g);
      }, c = function(f, m) {
        for (var h = l(f, m), g = [], y = 0; y < h.length; y += 1) {
          var S = h[y], x = S.type, b = S.value, _ = r[x];
          _ >= 0 && (g[_] = parseInt(b, 10));
        }
        var $ = g[3], w = $ === 24 ? 0 : $, O = g[0] + "-" + g[1] + "-" + g[2] + " " + w + ":" + g[4] + ":" + g[5] + ":000", T = +f;
        return (o.utc(O).valueOf() - (T -= T % 1e3)) / 6e4;
      }, u = i.prototype;
      u.tz = function(f, m) {
        f === void 0 && (f = s);
        var h = this.utcOffset(), g = this.toDate(), y = g.toLocaleString("en-US", { timeZone: f }), S = Math.round((g - new Date(y)) / 1e3 / 60), x = o(y, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(g.getTimezoneOffset() / 15) - S, !0);
        if (m) {
          var b = x.utcOffset();
          x = x.add(h - b, "minute");
        }
        return x.$x.$timezone = f, x;
      }, u.offsetName = function(f) {
        var m = this.$x.$timezone || o.tz.guess(), h = l(this.valueOf(), m, { timeZoneName: f }).find(function(g) {
          return g.type.toLowerCase() === "timezonename";
        });
        return h && h.value;
      };
      var d = u.startOf;
      u.startOf = function(f, m) {
        if (!this.$x || !this.$x.$timezone) return d.call(this, f, m);
        var h = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return d.call(h, f, m).tz(this.$x.$timezone, !0);
      }, o.tz = function(f, m, h) {
        var g = h && m, y = h || m || s, S = c(+o(), y);
        if (typeof f != "string") return o(f).tz(y);
        var x = function(w, O, T) {
          var I = w - 60 * O * 1e3, P = c(I, T);
          if (O === P) return [I, O];
          var D = c(I -= 60 * (P - O) * 1e3, T);
          return P === D ? [I, P] : [w - 60 * Math.min(P, D) * 1e3, Math.max(P, D)];
        }(o.utc(f, g).valueOf(), S, y), b = x[0], _ = x[1], $ = o(b).utcOffset(_);
        return $.$x.$timezone = y, $;
      }, o.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, o.tz.setDefault = function(f) {
        s = f;
      };
    };
  });
})(Pee);
var nke = Pee.exports;
const Ree = /* @__PURE__ */ Ut(nke), ake = ({ onChange: e, value: t }) => {
  const r = Bt((i) => {
    const o = t || fn().startOf("day");
    e(o.add(i === "AM" && t.hour() >= 12 ? -12 : i === "PM" && t.hour() <= 12 ? 12 : 0, "hours"));
  }, [e, t]), n = Bt(
    (i) => {
      if (!i) return;
      const o = (t || fn().startOf("day")).format("A"), s = (Number(i) + (o === "PM" ? 12 : 0)) % 24;
      e((t || fn().startOf("day")).hour(s));
    },
    [e, t]
  ), a = Bt(
    (i) => {
      i && e((t || fn().startOf("day")).minute(Number(i)));
    },
    [e, t]
  );
  return /* @__PURE__ */ E.jsxs("div", { className: "flex flex-col gap-[4px] flex-1", children: [
    /* @__PURE__ */ E.jsx(Aee, { leading: 5, fontWeight: "medium", size: "sm", children: "Select time" }),
    /* @__PURE__ */ E.jsxs("div", { className: "flex justify-between flex-1 gap-[4px]", children: [
      /* @__PURE__ */ E.jsx(
        Lr,
        {
          style: { height: "unset", textAlign: "center" },
          type: "number",
          min: "0",
          max: "12",
          value: t?.format("h"),
          onChange: (i) => n(i.target.value)
        }
      ),
      /* @__PURE__ */ E.jsx("span", { children: ":" }),
      /* @__PURE__ */ E.jsx(
        Lr,
        {
          style: { height: "unset", textAlign: "center" },
          type: "number",
          min: "0",
          max: "59",
          value: t?.minute(),
          onChange: (i) => a(i.target.value)
        }
      ),
      /* @__PURE__ */ E.jsx(
        Kn,
        {
          options: [
            {
              label: "AM",
              value: "AM"
            },
            {
              label: "PM",
              value: "PM"
            }
          ],
          value: t?.format("A"),
          onChange: r
        }
      )
    ] })
  ] });
};
var Nee = {};
const ike = [
  {
    label: "Pacific/Midway (GMT-11:00)",
    tzCode: "Pacific/Midway",
    name: "(GMT-11:00) Midway",
    utc: "-11:00"
  },
  {
    label: "Pacific/Niue (GMT-11:00)",
    tzCode: "Pacific/Niue",
    name: "(GMT-11:00) Alofi",
    utc: "-11:00"
  },
  {
    label: "Pacific/Pago_Pago (GMT-11:00)",
    tzCode: "Pacific/Pago_Pago",
    name: "(GMT-11:00) Pago Pago, Tāfuna, Ta`ū, Taulaga",
    utc: "-11:00"
  },
  {
    label: "America/Adak (GMT-10:00)",
    tzCode: "America/Adak",
    name: "(GMT-10:00) Adak",
    utc: "-10:00"
  },
  {
    label: "Pacific/Honolulu (GMT-10:00)",
    tzCode: "Pacific/Honolulu",
    name: "(GMT-10:00) Honolulu, East Honolulu, Pearl City, Hilo, Kailua",
    utc: "-10:00"
  },
  {
    label: "Pacific/Rarotonga (GMT-10:00)",
    tzCode: "Pacific/Rarotonga",
    name: "(GMT-10:00) Avarua",
    utc: "-10:00"
  },
  {
    label: "Pacific/Tahiti (GMT-10:00)",
    tzCode: "Pacific/Tahiti",
    name: "(GMT-10:00) Faaa, Papeete, Punaauia, Pirae, Mahina",
    utc: "-10:00"
  },
  {
    label: "Pacific/Marquesas (GMT-09:30)",
    tzCode: "Pacific/Marquesas",
    name: "(GMT-09:30) Taiohae",
    utc: "-09:30"
  },
  {
    label: "America/Anchorage (GMT-09:00)",
    tzCode: "America/Anchorage",
    name: "(GMT-09:00) Anchorage, Fairbanks, Eagle River, Badger, Knik-Fairview",
    utc: "-09:00"
  },
  {
    label: "America/Juneau (GMT-09:00)",
    tzCode: "America/Juneau",
    name: "(GMT-09:00) Juneau",
    utc: "-09:00"
  },
  {
    label: "America/Metlakatla (GMT-09:00)",
    tzCode: "America/Metlakatla",
    name: "(GMT-09:00) Metlakatla",
    utc: "-09:00"
  },
  {
    label: "America/Nome (GMT-09:00)",
    tzCode: "America/Nome",
    name: "(GMT-09:00) Nome",
    utc: "-09:00"
  },
  {
    label: "America/Sitka (GMT-09:00)",
    tzCode: "America/Sitka",
    name: "(GMT-09:00) Sitka, Ketchikan",
    utc: "-09:00"
  },
  {
    label: "America/Yakutat (GMT-09:00)",
    tzCode: "America/Yakutat",
    name: "(GMT-09:00) Yakutat",
    utc: "-09:00"
  },
  {
    label: "Pacific/Gambier (GMT-09:00)",
    tzCode: "Pacific/Gambier",
    name: "(GMT-09:00) Gambier",
    utc: "-09:00"
  },
  {
    label: "America/Los_Angeles (GMT-08:00)",
    tzCode: "America/Los_Angeles",
    name: "(GMT-08:00) Los Angeles, San Diego, San Jose, San Francisco, Seattle",
    utc: "-08:00"
  },
  {
    label: "America/Tijuana (GMT-08:00)",
    tzCode: "America/Tijuana",
    name: "(GMT-08:00) Tijuana, Mexicali, Ensenada, Rosarito, Tecate",
    utc: "-08:00"
  },
  {
    label: "America/Vancouver (GMT-08:00)",
    tzCode: "America/Vancouver",
    name: "(GMT-08:00) Vancouver, Surrey, Okanagan, Victoria, Burnaby",
    utc: "-08:00"
  },
  {
    label: "Pacific/Pitcairn (GMT-08:00)",
    tzCode: "Pacific/Pitcairn",
    name: "(GMT-08:00) Adamstown",
    utc: "-08:00"
  },
  {
    label: "America/Boise (GMT-07:00)",
    tzCode: "America/Boise",
    name: "(GMT-07:00) Boise, Meridian, Nampa, Idaho Falls, Pocatello",
    utc: "-07:00"
  },
  {
    label: "America/Cambridge_Bay (GMT-07:00)",
    tzCode: "America/Cambridge_Bay",
    name: "(GMT-07:00) Cambridge Bay",
    utc: "-07:00"
  },
  {
    label: "America/Chihuahua (GMT-07:00)",
    tzCode: "America/Chihuahua",
    name: "(GMT-07:00) Chihuahua, Ciudad Delicias, Cuauhtémoc, Parral, Nuevo Casas Grandes",
    utc: "-07:00"
  },
  {
    label: "America/Creston (GMT-07:00)",
    tzCode: "America/Creston",
    name: "(GMT-07:00) Creston",
    utc: "-07:00"
  },
  {
    label: "America/Dawson (GMT-07:00)",
    tzCode: "America/Dawson",
    name: "(GMT-07:00) Dawson",
    utc: "-07:00"
  },
  {
    label: "America/Dawson_Creek (GMT-07:00)",
    tzCode: "America/Dawson_Creek",
    name: "(GMT-07:00) Fort St. John, Dawson Creek",
    utc: "-07:00"
  },
  {
    label: "America/Denver (GMT-07:00)",
    tzCode: "America/Denver",
    name: "(GMT-07:00) Denver, El Paso, Albuquerque, Colorado Springs, Aurora",
    utc: "-07:00"
  },
  {
    label: "America/Edmonton (GMT-07:00)",
    tzCode: "America/Edmonton",
    name: "(GMT-07:00) Calgary, Edmonton, Fort McMurray, Red Deer, Lethbridge",
    utc: "-07:00"
  },
  {
    label: "America/Fort_Nelson (GMT-07:00)",
    tzCode: "America/Fort_Nelson",
    name: "(GMT-07:00) Fort Nelson",
    utc: "-07:00"
  },
  {
    label: "America/Hermosillo (GMT-07:00)",
    tzCode: "America/Hermosillo",
    name: "(GMT-07:00) Hermosillo, Ciudad Obregón, Nogales, San Luis Río Colorado, Navojoa",
    utc: "-07:00"
  },
  {
    label: "America/Inuvik (GMT-07:00)",
    tzCode: "America/Inuvik",
    name: "(GMT-07:00) Inuvik",
    utc: "-07:00"
  },
  {
    label: "America/Mazatlan (GMT-07:00)",
    tzCode: "America/Mazatlan",
    name: "(GMT-07:00) Culiacán, Mazatlán, Tepic, Los Mochis, La Paz",
    utc: "-07:00"
  },
  {
    label: "America/Ojinaga (GMT-07:00)",
    tzCode: "America/Ojinaga",
    name: "(GMT-07:00) Ciudad Juárez, Manuel Ojinaga, Ojinaga",
    utc: "-07:00"
  },
  {
    label: "America/Phoenix (GMT-07:00)",
    tzCode: "America/Phoenix",
    name: "(GMT-07:00) Phoenix, Tucson, Mesa, Chandler, Gilbert",
    utc: "-07:00"
  },
  {
    label: "America/Whitehorse (GMT-07:00)",
    tzCode: "America/Whitehorse",
    name: "(GMT-07:00) Whitehorse",
    utc: "-07:00"
  },
  {
    label: "America/Yellowknife (GMT-07:00)",
    tzCode: "America/Yellowknife",
    name: "(GMT-07:00) Yellowknife",
    utc: "-07:00"
  },
  {
    label: "America/Bahia_Banderas (GMT-06:00)",
    tzCode: "America/Bahia_Banderas",
    name: "(GMT-06:00) Mezcales, San Vicente, Bucerías, Valle de Banderas",
    utc: "-06:00"
  },
  {
    label: "America/Belize (GMT-06:00)",
    tzCode: "America/Belize",
    name: "(GMT-06:00) Belize City, San Ignacio, Orange Walk, Belmopan, Dangriga",
    utc: "-06:00"
  },
  {
    label: "America/Chicago (GMT-06:00)",
    tzCode: "America/Chicago",
    name: "(GMT-06:00) Chicago, Houston, San Antonio, Dallas, Austin",
    utc: "-06:00"
  },
  {
    label: "America/Costa_Rica (GMT-06:00)",
    tzCode: "America/Costa_Rica",
    name: "(GMT-06:00) San José, Limón, San Francisco, Alajuela, Liberia",
    utc: "-06:00"
  },
  {
    label: "America/El_Salvador (GMT-06:00)",
    tzCode: "America/El_Salvador",
    name: "(GMT-06:00) San Salvador, Soyapango, Santa Ana, San Miguel, Mejicanos",
    utc: "-06:00"
  },
  {
    label: "America/Guatemala (GMT-06:00)",
    tzCode: "America/Guatemala",
    name: "(GMT-06:00) Guatemala City, Mixco, Villa Nueva, Petapa, San Juan Sacatepéquez",
    utc: "-06:00"
  },
  {
    label: "America/Indiana/Knox (GMT-06:00)",
    tzCode: "America/Indiana/Knox",
    name: "(GMT-06:00) Knox",
    utc: "-06:00"
  },
  {
    label: "America/Indiana/Tell_City (GMT-06:00)",
    tzCode: "America/Indiana/Tell_City",
    name: "(GMT-06:00) Tell City",
    utc: "-06:00"
  },
  {
    label: "America/Managua (GMT-06:00)",
    tzCode: "America/Managua",
    name: "(GMT-06:00) Managua, León, Masaya, Chinandega, Matagalpa",
    utc: "-06:00"
  },
  {
    label: "America/Matamoros (GMT-06:00)",
    tzCode: "America/Matamoros",
    name: "(GMT-06:00) Reynosa, Heroica Matamoros, Nuevo Laredo, Piedras Negras, Ciudad Acuña",
    utc: "-06:00"
  },
  {
    label: "America/Menominee (GMT-06:00)",
    tzCode: "America/Menominee",
    name: "(GMT-06:00) Menominee, Iron Mountain, Kingsford, Ironwood, Iron River",
    utc: "-06:00"
  },
  {
    label: "America/Merida (GMT-06:00)",
    tzCode: "America/Merida",
    name: "(GMT-06:00) Mérida, Campeche, Ciudad del Carmen, Kanasín, Valladolid",
    utc: "-06:00"
  },
  {
    label: "America/Mexico_City (GMT-06:00)",
    tzCode: "America/Mexico_City",
    name: "(GMT-06:00) Mexico City, Iztapalapa, Ecatepec de Morelos, Guadalajara, Puebla",
    utc: "-06:00"
  },
  {
    label: "America/Monterrey (GMT-06:00)",
    tzCode: "America/Monterrey",
    name: "(GMT-06:00) Monterrey, Saltillo, Guadalupe, Torreón, Victoria de Durango",
    utc: "-06:00"
  },
  {
    label: "America/North_Dakota/Beulah (GMT-06:00)",
    tzCode: "America/North_Dakota/Beulah",
    name: "(GMT-06:00) Beulah",
    utc: "-06:00"
  },
  {
    label: "America/North_Dakota/Center (GMT-06:00)",
    tzCode: "America/North_Dakota/Center",
    name: "(GMT-06:00) Center",
    utc: "-06:00"
  },
  {
    label: "America/North_Dakota/New_Salem (GMT-06:00)",
    tzCode: "America/North_Dakota/New_Salem",
    name: "(GMT-06:00) Mandan",
    utc: "-06:00"
  },
  {
    label: "America/Rainy_River (GMT-06:00)",
    tzCode: "America/Rainy_River",
    name: "(GMT-06:00) Rainy River",
    utc: "-06:00"
  },
  {
    label: "America/Rankin_Inlet (GMT-06:00)",
    tzCode: "America/Rankin_Inlet",
    name: "(GMT-06:00) Rankin Inlet",
    utc: "-06:00"
  },
  {
    label: "America/Regina (GMT-06:00)",
    tzCode: "America/Regina",
    name: "(GMT-06:00) Saskatoon, Regina, Prince Albert, Moose Jaw, North Battleford",
    utc: "-06:00"
  },
  {
    label: "America/Resolute (GMT-06:00)",
    tzCode: "America/Resolute",
    name: "(GMT-06:00) Resolute",
    utc: "-06:00"
  },
  {
    label: "America/Swift_Current (GMT-06:00)",
    tzCode: "America/Swift_Current",
    name: "(GMT-06:00) Swift Current",
    utc: "-06:00"
  },
  {
    label: "America/Tegucigalpa (GMT-06:00)",
    tzCode: "America/Tegucigalpa",
    name: "(GMT-06:00) Tegucigalpa, San Pedro Sula, Choloma, La Ceiba, El Progreso",
    utc: "-06:00"
  },
  {
    label: "America/Winnipeg (GMT-06:00)",
    tzCode: "America/Winnipeg",
    name: "(GMT-06:00) Winnipeg, Brandon, Kenora, Portage la Prairie, Thompson",
    utc: "-06:00"
  },
  {
    label: "Pacific/Easter (GMT-06:00)",
    tzCode: "Pacific/Easter",
    name: "(GMT-06:00) Easter",
    utc: "-06:00"
  },
  {
    label: "Pacific/Galapagos (GMT-06:00)",
    tzCode: "Pacific/Galapagos",
    name: "(GMT-06:00) Puerto Ayora, Puerto Baquerizo Moreno",
    utc: "-06:00"
  },
  {
    label: "America/Atikokan (GMT-05:00)",
    tzCode: "America/Atikokan",
    name: "(GMT-05:00) Atikokan",
    utc: "-05:00"
  },
  {
    label: "America/Bogota (GMT-05:00)",
    tzCode: "America/Bogota",
    name: "(GMT-05:00) Bogotá, Cali, Medellín, Barranquilla, Cartagena",
    utc: "-05:00"
  },
  {
    label: "America/Cancun (GMT-05:00)",
    tzCode: "America/Cancun",
    name: "(GMT-05:00) Cancún, Chetumal, Playa del Carmen, Cozumel, Felipe Carrillo Puerto",
    utc: "-05:00"
  },
  {
    label: "America/Cayman (GMT-05:00)",
    tzCode: "America/Cayman",
    name: "(GMT-05:00) George Town, West Bay, Bodden Town, East End, North Side",
    utc: "-05:00"
  },
  {
    label: "America/Detroit (GMT-05:00)",
    tzCode: "America/Detroit",
    name: "(GMT-05:00) Detroit, Grand Rapids, Warren, Sterling Heights, Ann Arbor",
    utc: "-05:00"
  },
  {
    label: "America/Eirunepe (GMT-05:00)",
    tzCode: "America/Eirunepe",
    name: "(GMT-05:00) Eirunepé, Benjamin Constant, Envira",
    utc: "-05:00"
  },
  {
    label: "America/Grand_Turk (GMT-05:00)",
    tzCode: "America/Grand_Turk",
    name: "(GMT-05:00) Cockburn Town",
    utc: "-05:00"
  },
  {
    label: "America/Guayaquil (GMT-05:00)",
    tzCode: "America/Guayaquil",
    name: "(GMT-05:00) Guayaquil, Quito, Cuenca, Santo Domingo de los Colorados, Machala",
    utc: "-05:00"
  },
  {
    label: "America/Havana (GMT-05:00)",
    tzCode: "America/Havana",
    name: "(GMT-05:00) Havana, Santiago de Cuba, Camagüey, Holguín, Guantánamo",
    utc: "-05:00"
  },
  {
    label: "America/Indiana/Indianapolis (GMT-05:00)",
    tzCode: "America/Indiana/Indianapolis",
    name: "(GMT-05:00) Indianapolis, Fort Wayne, South Bend, Carmel, Bloomington",
    utc: "-05:00"
  },
  {
    label: "America/Indiana/Marengo (GMT-05:00)",
    tzCode: "America/Indiana/Marengo",
    name: "(GMT-05:00) Marengo",
    utc: "-05:00"
  },
  {
    label: "America/Indiana/Petersburg (GMT-05:00)",
    tzCode: "America/Indiana/Petersburg",
    name: "(GMT-05:00) Petersburg",
    utc: "-05:00"
  },
  {
    label: "America/Indiana/Vevay (GMT-05:00)",
    tzCode: "America/Indiana/Vevay",
    name: "(GMT-05:00) Vevay",
    utc: "-05:00"
  },
  {
    label: "America/Indiana/Vincennes (GMT-05:00)",
    tzCode: "America/Indiana/Vincennes",
    name: "(GMT-05:00) Vincennes, Jasper, Washington, Huntingburg",
    utc: "-05:00"
  },
  {
    label: "America/Indiana/Winamac (GMT-05:00)",
    tzCode: "America/Indiana/Winamac",
    name: "(GMT-05:00) Winamac",
    utc: "-05:00"
  },
  {
    label: "America/Iqaluit (GMT-05:00)",
    tzCode: "America/Iqaluit",
    name: "(GMT-05:00) Iqaluit",
    utc: "-05:00"
  },
  {
    label: "America/Jamaica (GMT-05:00)",
    tzCode: "America/Jamaica",
    name: "(GMT-05:00) Kingston, New Kingston, Spanish Town, Portmore, Montego Bay",
    utc: "-05:00"
  },
  {
    label: "America/Kentucky/Louisville (GMT-05:00)",
    tzCode: "America/Kentucky/Louisville",
    name: "(GMT-05:00) Louisville, Jeffersonville, New Albany, Jeffersontown, Pleasure Ridge Park",
    utc: "-05:00"
  },
  {
    label: "America/Kentucky/Monticello (GMT-05:00)",
    tzCode: "America/Kentucky/Monticello",
    name: "(GMT-05:00) Monticello",
    utc: "-05:00"
  },
  {
    label: "America/Lima (GMT-05:00)",
    tzCode: "America/Lima",
    name: "(GMT-05:00) Lima, Arequipa, Callao, Trujillo, Chiclayo",
    utc: "-05:00"
  },
  {
    label: "America/Nassau (GMT-05:00)",
    tzCode: "America/Nassau",
    name: "(GMT-05:00) Nassau, Lucaya, Freeport, West End, Cooper’s Town",
    utc: "-05:00"
  },
  {
    label: "America/New_York (GMT-05:00)",
    tzCode: "America/New_York",
    name: "(GMT-05:00) New York City, Brooklyn, Queens, Philadelphia, Manhattan",
    utc: "-05:00"
  },
  {
    label: "America/Nipigon (GMT-05:00)",
    tzCode: "America/Nipigon",
    name: "(GMT-05:00) Nipigon",
    utc: "-05:00"
  },
  {
    label: "America/Panama (GMT-05:00)",
    tzCode: "America/Panama",
    name: "(GMT-05:00) Panamá, San Miguelito, Juan Díaz, David, Arraiján",
    utc: "-05:00"
  },
  {
    label: "America/Pangnirtung (GMT-05:00)",
    tzCode: "America/Pangnirtung",
    name: "(GMT-05:00) Pangnirtung",
    utc: "-05:00"
  },
  {
    label: "America/Port-au-Prince (GMT-05:00)",
    tzCode: "America/Port-au-Prince",
    name: "(GMT-05:00) Port-au-Prince, Carrefour, Delmas 73, Pétionville, Port-de-Paix",
    utc: "-05:00"
  },
  {
    label: "America/Rio_Branco (GMT-05:00)",
    tzCode: "America/Rio_Branco",
    name: "(GMT-05:00) Rio Branco, Cruzeiro do Sul, Sena Madureira, Tarauacá, Feijó",
    utc: "-05:00"
  },
  {
    label: "America/Thunder_Bay (GMT-05:00)",
    tzCode: "America/Thunder_Bay",
    name: "(GMT-05:00) Thunder Bay",
    utc: "-05:00"
  },
  {
    label: "America/Toronto (GMT-05:00)",
    tzCode: "America/Toronto",
    name: "(GMT-05:00) Toronto, Montréal, Ottawa, Mississauga, Québec",
    utc: "-05:00"
  },
  {
    label: "America/Anguilla (GMT-04:00)",
    tzCode: "America/Anguilla",
    name: "(GMT-04:00) The Valley, Blowing Point Village, Sandy Ground Village, The Quarter, Sandy Hill",
    utc: "-04:00"
  },
  {
    label: "America/Antigua (GMT-04:00)",
    tzCode: "America/Antigua",
    name: "(GMT-04:00) Saint John’s, Piggotts, Bolands, Codrington, Parham",
    utc: "-04:00"
  },
  {
    label: "America/Aruba (GMT-04:00)",
    tzCode: "America/Aruba",
    name: "(GMT-04:00) Oranjestad, Tanki Leendert, San Nicolas, Santa Cruz, Paradera",
    utc: "-04:00"
  },
  {
    label: "America/Asuncion (GMT-04:00)",
    tzCode: "America/Asuncion",
    name: "(GMT-04:00) Asunción, Ciudad del Este, San Lorenzo, Capiatá, Lambaré",
    utc: "-04:00"
  },
  {
    label: "America/Barbados (GMT-04:00)",
    tzCode: "America/Barbados",
    name: "(GMT-04:00) Bridgetown, Speightstown, Oistins, Bathsheba, Holetown",
    utc: "-04:00"
  },
  {
    label: "America/Blanc-Sablon (GMT-04:00)",
    tzCode: "America/Blanc-Sablon",
    name: "(GMT-04:00) Lévis",
    utc: "-04:00"
  },
  {
    label: "America/Boa_Vista (GMT-04:00)",
    tzCode: "America/Boa_Vista",
    name: "(GMT-04:00) Boa Vista",
    utc: "-04:00"
  },
  {
    label: "America/Campo_Grande (GMT-04:00)",
    tzCode: "America/Campo_Grande",
    name: "(GMT-04:00) Campo Grande, Dourados, Corumbá, Três Lagoas, Ponta Porã",
    utc: "-04:00"
  },
  {
    label: "America/Caracas (GMT-04:00)",
    tzCode: "America/Caracas",
    name: "(GMT-04:00) Caracas, Maracaibo, Maracay, Valencia, Barquisimeto",
    utc: "-04:00"
  },
  {
    label: "America/Cuiaba (GMT-04:00)",
    tzCode: "America/Cuiaba",
    name: "(GMT-04:00) Cuiabá, Várzea Grande, Rondonópolis, Sinop, Barra do Garças",
    utc: "-04:00"
  },
  {
    label: "America/Curacao (GMT-04:00)",
    tzCode: "America/Curacao",
    name: "(GMT-04:00) Willemstad, Sint Michiel Liber",
    utc: "-04:00"
  },
  {
    label: "America/Dominica (GMT-04:00)",
    tzCode: "America/Dominica",
    name: "(GMT-04:00) Roseau, Portsmouth, Berekua, Saint Joseph, Wesley",
    utc: "-04:00"
  },
  {
    label: "America/Glace_Bay (GMT-04:00)",
    tzCode: "America/Glace_Bay",
    name: "(GMT-04:00) Sydney, Glace Bay, Sydney Mines",
    utc: "-04:00"
  },
  {
    label: "America/Goose_Bay (GMT-04:00)",
    tzCode: "America/Goose_Bay",
    name: "(GMT-04:00) Labrador City, Happy Valley-Goose Bay",
    utc: "-04:00"
  },
  {
    label: "America/Grenada (GMT-04:00)",
    tzCode: "America/Grenada",
    name: "(GMT-04:00) Saint George's, Gouyave, Grenville, Victoria, Saint David’s",
    utc: "-04:00"
  },
  {
    label: "America/Guadeloupe (GMT-04:00)",
    tzCode: "America/Guadeloupe",
    name: "(GMT-04:00) Les Abymes, Baie-Mahault, Le Gosier, Petit-Bourg, Sainte-Anne",
    utc: "-04:00"
  },
  {
    label: "America/Guyana (GMT-04:00)",
    tzCode: "America/Guyana",
    name: "(GMT-04:00) Georgetown, Linden, New Amsterdam, Anna Regina, Bartica",
    utc: "-04:00"
  },
  {
    label: "America/Halifax (GMT-04:00)",
    tzCode: "America/Halifax",
    name: "(GMT-04:00) Halifax, Dartmouth, Charlottetown, Lower Sackville, Truro",
    utc: "-04:00"
  },
  {
    label: "America/Kralendijk (GMT-04:00)",
    tzCode: "America/Kralendijk",
    name: "(GMT-04:00) Kralendijk, Oranjestad, The Bottom",
    utc: "-04:00"
  },
  {
    label: "America/La_Paz (GMT-04:00)",
    tzCode: "America/La_Paz",
    name: "(GMT-04:00) Santa Cruz de la Sierra, Cochabamba, La Paz, Sucre, Oruro",
    utc: "-04:00"
  },
  {
    label: "America/Lower_Princes (GMT-04:00)",
    tzCode: "America/Lower_Princes",
    name: "(GMT-04:00) Cul de Sac, Lower Prince’s Quarter, Koolbaai, Philipsburg",
    utc: "-04:00"
  },
  {
    label: "America/Manaus (GMT-04:00)",
    tzCode: "America/Manaus",
    name: "(GMT-04:00) Manaus, Itacoatiara, Parintins, Manacapuru, Coari",
    utc: "-04:00"
  },
  {
    label: "America/Marigot (GMT-04:00)",
    tzCode: "America/Marigot",
    name: "(GMT-04:00) Marigot",
    utc: "-04:00"
  },
  {
    label: "America/Martinique (GMT-04:00)",
    tzCode: "America/Martinique",
    name: "(GMT-04:00) Fort-de-France, Le Lamentin, Le Robert, Sainte-Marie, Le François",
    utc: "-04:00"
  },
  {
    label: "America/Moncton (GMT-04:00)",
    tzCode: "America/Moncton",
    name: "(GMT-04:00) Moncton, Saint John, Fredericton, Dieppe, Miramichi",
    utc: "-04:00"
  },
  {
    label: "America/Montserrat (GMT-04:00)",
    tzCode: "America/Montserrat",
    name: "(GMT-04:00) Brades, Saint Peters, Plymouth",
    utc: "-04:00"
  },
  {
    label: "America/Porto_Velho (GMT-04:00)",
    tzCode: "America/Porto_Velho",
    name: "(GMT-04:00) Porto Velho, Ji Paraná, Vilhena, Ariquemes, Cacoal",
    utc: "-04:00"
  },
  {
    label: "America/Port_of_Spain (GMT-04:00)",
    tzCode: "America/Port_of_Spain",
    name: "(GMT-04:00) Chaguanas, Mon Repos, San Fernando, Port of Spain, Rio Claro",
    utc: "-04:00"
  },
  {
    label: "America/Puerto_Rico (GMT-04:00)",
    tzCode: "America/Puerto_Rico",
    name: "(GMT-04:00) San Juan, Bayamón, Carolina, Ponce, Caguas",
    utc: "-04:00"
  },
  {
    label: "America/Santiago (GMT-04:00)",
    tzCode: "America/Santiago",
    name: "(GMT-04:00) Santiago, Puente Alto, Antofagasta, Viña del Mar, Valparaíso",
    utc: "-04:00"
  },
  {
    label: "America/Santo_Domingo (GMT-04:00)",
    tzCode: "America/Santo_Domingo",
    name: "(GMT-04:00) Santo Domingo, Santiago de los Caballeros, Santo Domingo Oeste, Santo Domingo Este, San Pedro de Macorís",
    utc: "-04:00"
  },
  {
    label: "America/St_Barthelemy (GMT-04:00)",
    tzCode: "America/St_Barthelemy",
    name: "(GMT-04:00) Gustavia",
    utc: "-04:00"
  },
  {
    label: "America/St_Kitts (GMT-04:00)",
    tzCode: "America/St_Kitts",
    name: "(GMT-04:00) Basseterre, Fig Tree, Market Shop, Saint Paul’s, Middle Island",
    utc: "-04:00"
  },
  {
    label: "America/St_Lucia (GMT-04:00)",
    tzCode: "America/St_Lucia",
    name: "(GMT-04:00) Castries, Bisee, Vieux Fort, Micoud, Soufrière",
    utc: "-04:00"
  },
  {
    label: "America/St_Thomas (GMT-04:00)",
    tzCode: "America/St_Thomas",
    name: "(GMT-04:00) Saint Croix, Charlotte Amalie, Cruz Bay",
    utc: "-04:00"
  },
  {
    label: "America/St_Vincent (GMT-04:00)",
    tzCode: "America/St_Vincent",
    name: "(GMT-04:00) Kingstown, Kingstown Park, Georgetown, Barrouallie, Port Elizabeth",
    utc: "-04:00"
  },
  {
    label: "America/Thule (GMT-04:00)",
    tzCode: "America/Thule",
    name: "(GMT-04:00) Thule",
    utc: "-04:00"
  },
  {
    label: "America/Tortola (GMT-04:00)",
    tzCode: "America/Tortola",
    name: "(GMT-04:00) Road Town",
    utc: "-04:00"
  },
  {
    label: "Atlantic/Bermuda (GMT-04:00)",
    tzCode: "Atlantic/Bermuda",
    name: "(GMT-04:00) Hamilton",
    utc: "-04:00"
  },
  {
    label: "America/St_Johns (GMT-03:30)",
    tzCode: "America/St_Johns",
    name: "(GMT-03:30) St. John's, Mount Pearl, Corner Brook, Conception Bay South, Bay Roberts",
    utc: "-03:30"
  },
  {
    label: "America/Araguaina (GMT-03:00)",
    tzCode: "America/Araguaina",
    name: "(GMT-03:00) Palmas, Araguaína, Gurupi, Miracema do Tocantins, Porto Franco",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/Buenos_Aires (GMT-03:00)",
    tzCode: "America/Argentina/Buenos_Aires",
    name: "(GMT-03:00) Buenos Aires, La Plata, Mar del Plata, Morón, Bahía Blanca",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/Catamarca (GMT-03:00)",
    tzCode: "America/Argentina/Catamarca",
    name: "(GMT-03:00) San Fernando del Valle de Catamarca, Trelew, Puerto Madryn, Esquel, Rawson",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/Cordoba (GMT-03:00)",
    tzCode: "America/Argentina/Cordoba",
    name: "(GMT-03:00) Córdoba, Rosario, Santa Fe, Resistencia, Santiago del Estero",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/Jujuy (GMT-03:00)",
    tzCode: "America/Argentina/Jujuy",
    name: "(GMT-03:00) San Salvador de Jujuy, San Pedro de Jujuy, Libertador General San Martín, Palpalá, La Quiaca",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/La_Rioja (GMT-03:00)",
    tzCode: "America/Argentina/La_Rioja",
    name: "(GMT-03:00) La Rioja, Chilecito, Arauco, Chamical",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/Mendoza (GMT-03:00)",
    tzCode: "America/Argentina/Mendoza",
    name: "(GMT-03:00) Mendoza, San Rafael, San Martín",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/Rio_Gallegos (GMT-03:00)",
    tzCode: "America/Argentina/Rio_Gallegos",
    name: "(GMT-03:00) Comodoro Rivadavia, Río Gallegos, Caleta Olivia, Pico Truncado, Puerto Deseado",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/Salta (GMT-03:00)",
    tzCode: "America/Argentina/Salta",
    name: "(GMT-03:00) Salta, Neuquén, Santa Rosa, San Carlos de Bariloche, Cipolletti",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/San_Juan (GMT-03:00)",
    tzCode: "America/Argentina/San_Juan",
    name: "(GMT-03:00) San Juan, Chimbas, Santa Lucía, Pocito, Caucete",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/San_Luis (GMT-03:00)",
    tzCode: "America/Argentina/San_Luis",
    name: "(GMT-03:00) San Luis, Villa Mercedes, La Punta, Merlo, Justo Daract",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/Tucuman (GMT-03:00)",
    tzCode: "America/Argentina/Tucuman",
    name: "(GMT-03:00) San Miguel de Tucumán, Yerba Buena, Tafí Viejo, Alderetes, Aguilares",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/Ushuaia (GMT-03:00)",
    tzCode: "America/Argentina/Ushuaia",
    name: "(GMT-03:00) Ushuaia, Río Grande",
    utc: "-03:00"
  },
  {
    label: "America/Bahia (GMT-03:00)",
    tzCode: "America/Bahia",
    name: "(GMT-03:00) Salvador, Feira de Santana, Vitória da Conquista, Itabuna, Camaçari",
    utc: "-03:00"
  },
  {
    label: "America/Belem (GMT-03:00)",
    tzCode: "America/Belem",
    name: "(GMT-03:00) Belém, Ananindeua, Macapá, Parauapebas, Marabá",
    utc: "-03:00"
  },
  {
    label: "America/Cayenne (GMT-03:00)",
    tzCode: "America/Cayenne",
    name: "(GMT-03:00) Cayenne, Matoury, Saint-Laurent-du-Maroni, Kourou, Rémire-Montjoly",
    utc: "-03:00"
  },
  {
    label: "America/Fortaleza (GMT-03:00)",
    tzCode: "America/Fortaleza",
    name: "(GMT-03:00) Fortaleza, São Luís, Natal, Teresina, João Pessoa",
    utc: "-03:00"
  },
  {
    label: "America/Godthab (GMT-03:00)",
    tzCode: "America/Godthab",
    name: "(GMT-03:00) Nuuk, Sisimiut, Ilulissat, Qaqortoq, Aasiaat",
    utc: "-03:00"
  },
  {
    label: "America/Maceio (GMT-03:00)",
    tzCode: "America/Maceio",
    name: "(GMT-03:00) Maceió, Aracaju, Arapiraca, Nossa Senhora do Socorro, São Cristóvão",
    utc: "-03:00"
  },
  {
    label: "America/Miquelon (GMT-03:00)",
    tzCode: "America/Miquelon",
    name: "(GMT-03:00) Saint-Pierre, Miquelon",
    utc: "-03:00"
  },
  {
    label: "America/Montevideo (GMT-03:00)",
    tzCode: "America/Montevideo",
    name: "(GMT-03:00) Montevideo, Salto, Paysandú, Las Piedras, Rivera",
    utc: "-03:00"
  },
  {
    label: "America/Paramaribo (GMT-03:00)",
    tzCode: "America/Paramaribo",
    name: "(GMT-03:00) Paramaribo, Lelydorp, Brokopondo, Nieuw Nickerie, Moengo",
    utc: "-03:00"
  },
  {
    label: "America/Punta_Arenas (GMT-03:00)",
    tzCode: "America/Punta_Arenas",
    name: "(GMT-03:00) Punta Arenas, Puerto Natales",
    utc: "-03:00"
  },
  {
    label: "America/Recife (GMT-03:00)",
    tzCode: "America/Recife",
    name: "(GMT-03:00) Recife, Jaboatão, Jaboatão dos Guararapes, Olinda, Paulista",
    utc: "-03:00"
  },
  {
    label: "America/Santarem (GMT-03:00)",
    tzCode: "America/Santarem",
    name: "(GMT-03:00) Santarém, Altamira, Itaituba, Oriximiná, Alenquer",
    utc: "-03:00"
  },
  {
    label: "America/Sao_Paulo (GMT-03:00)",
    tzCode: "America/Sao_Paulo",
    name: "(GMT-03:00) São Paulo, Rio de Janeiro, Belo Horizonte, Brasília, Curitiba",
    utc: "-03:00"
  },
  {
    label: "Antarctica/Palmer (GMT-03:00)",
    tzCode: "Antarctica/Palmer",
    name: "(GMT-03:00) Palmer",
    utc: "-03:00"
  },
  {
    label: "Antarctica/Rothera (GMT-03:00)",
    tzCode: "Antarctica/Rothera",
    name: "(GMT-03:00) Rothera",
    utc: "-03:00"
  },
  {
    label: "Atlantic/Stanley (GMT-03:00)",
    tzCode: "Atlantic/Stanley",
    name: "(GMT-03:00) Stanley",
    utc: "-03:00"
  },
  {
    label: "America/Noronha (GMT-02:00)",
    tzCode: "America/Noronha",
    name: "(GMT-02:00) Itamaracá",
    utc: "-02:00"
  },
  {
    label: "Atlantic/South_Georgia (GMT-02:00)",
    tzCode: "Atlantic/South_Georgia",
    name: "(GMT-02:00) Grytviken",
    utc: "-02:00"
  },
  {
    label: "America/Scoresbysund (GMT-01:00)",
    tzCode: "America/Scoresbysund",
    name: "(GMT-01:00) Scoresbysund",
    utc: "-01:00"
  },
  {
    label: "Atlantic/Azores (GMT-01:00)",
    tzCode: "Atlantic/Azores",
    name: "(GMT-01:00) Ponta Delgada, Lagoa, Angra do Heroísmo, Rosto de Cão, Rabo de Peixe",
    utc: "-01:00"
  },
  {
    label: "Atlantic/Cape_Verde (GMT-01:00)",
    tzCode: "Atlantic/Cape_Verde",
    name: "(GMT-01:00) Praia, Mindelo, Santa Maria, Cova Figueira, Santa Cruz",
    utc: "-01:00"
  },
  {
    label: "Africa/Abidjan (GMT+00:00)",
    tzCode: "Africa/Abidjan",
    name: "(GMT+00:00) Abidjan, Abobo, Bouaké, Daloa, San-Pédro",
    utc: "+00:00"
  },
  {
    label: "Africa/Accra (GMT+00:00)",
    tzCode: "Africa/Accra",
    name: "(GMT+00:00) Accra, Kumasi, Tamale, Takoradi, Atsiaman",
    utc: "+00:00"
  },
  {
    label: "Africa/Bamako (GMT+00:00)",
    tzCode: "Africa/Bamako",
    name: "(GMT+00:00) Bamako, Sikasso, Mopti, Koutiala, Ségou",
    utc: "+00:00"
  },
  {
    label: "Africa/Banjul (GMT+00:00)",
    tzCode: "Africa/Banjul",
    name: "(GMT+00:00) Serekunda, Brikama, Bakau, Banjul, Farafenni",
    utc: "+00:00"
  },
  {
    label: "Africa/Bissau (GMT+00:00)",
    tzCode: "Africa/Bissau",
    name: "(GMT+00:00) Bissau, Bafatá, Gabú, Bissorã, Bolama",
    utc: "+00:00"
  },
  {
    label: "Africa/Casablanca (GMT+00:00)",
    tzCode: "Africa/Casablanca",
    name: "(GMT+00:00) Casablanca, Rabat, Fès, Sale, Marrakesh",
    utc: "+00:00"
  },
  {
    label: "Africa/Conakry (GMT+00:00)",
    tzCode: "Africa/Conakry",
    name: "(GMT+00:00) Camayenne, Conakry, Nzérékoré, Kindia, Kankan",
    utc: "+00:00"
  },
  {
    label: "Africa/Dakar (GMT+00:00)",
    tzCode: "Africa/Dakar",
    name: "(GMT+00:00) Dakar, Pikine, Touba, Thiès, Thiès Nones",
    utc: "+00:00"
  },
  {
    label: "Africa/El_Aaiun (GMT+00:00)",
    tzCode: "Africa/El_Aaiun",
    name: "(GMT+00:00) Laayoune, Dakhla, Laayoune Plage",
    utc: "+00:00"
  },
  {
    label: "Africa/Freetown (GMT+00:00)",
    tzCode: "Africa/Freetown",
    name: "(GMT+00:00) Freetown, Bo, Kenema, Koidu, Makeni",
    utc: "+00:00"
  },
  {
    label: "Africa/Lome (GMT+00:00)",
    tzCode: "Africa/Lome",
    name: "(GMT+00:00) Lomé, Sokodé, Kara, Atakpamé, Kpalimé",
    utc: "+00:00"
  },
  {
    label: "Africa/Monrovia (GMT+00:00)",
    tzCode: "Africa/Monrovia",
    name: "(GMT+00:00) Monrovia, Gbarnga, Kakata, Bensonville, Harper",
    utc: "+00:00"
  },
  {
    label: "Africa/Nouakchott (GMT+00:00)",
    tzCode: "Africa/Nouakchott",
    name: "(GMT+00:00) Nouakchott, Nouadhibou, Néma, Kaédi, Rosso",
    utc: "+00:00"
  },
  {
    label: "Africa/Ouagadougou (GMT+00:00)",
    tzCode: "Africa/Ouagadougou",
    name: "(GMT+00:00) Ouagadougou, Bobo-Dioulasso, Koudougou, Ouahigouya, Banfora",
    utc: "+00:00"
  },
  {
    label: "Africa/Sao_Tome (GMT+00:00)",
    tzCode: "Africa/Sao_Tome",
    name: "(GMT+00:00) São Tomé, Santo António",
    utc: "+00:00"
  },
  {
    label: "America/Danmarkshavn (GMT+00:00)",
    tzCode: "America/Danmarkshavn",
    name: "(GMT+00:00) Danmarkshavn",
    utc: "+00:00"
  },
  {
    label: "Antarctica/Troll (GMT+00:00)",
    tzCode: "Antarctica/Troll",
    name: "(GMT+00:00) Troll",
    utc: "+00:00"
  },
  {
    label: "Atlantic/Canary (GMT+00:00)",
    tzCode: "Atlantic/Canary",
    name: "(GMT+00:00) Las Palmas de Gran Canaria, Santa Cruz de Tenerife, La Laguna, Telde, Arona",
    utc: "+00:00"
  },
  {
    label: "Atlantic/Faroe (GMT+00:00)",
    tzCode: "Atlantic/Faroe",
    name: "(GMT+00:00) Tórshavn, Klaksvík, Fuglafjørður, Tvøroyri, Miðvágur",
    utc: "+00:00"
  },
  {
    label: "Atlantic/Madeira (GMT+00:00)",
    tzCode: "Atlantic/Madeira",
    name: "(GMT+00:00) Funchal, Câmara de Lobos, São Martinho, Caniço, Machico",
    utc: "+00:00"
  },
  {
    label: "Atlantic/Reykjavik (GMT+00:00)",
    tzCode: "Atlantic/Reykjavik",
    name: "(GMT+00:00) Reykjavík, Kópavogur, Hafnarfjörður, Akureyri, Garðabær",
    utc: "+00:00"
  },
  {
    label: "Atlantic/St_Helena (GMT+00:00)",
    tzCode: "Atlantic/St_Helena",
    name: "(GMT+00:00) Jamestown, Georgetown, Edinburgh of the Seven Seas",
    utc: "+00:00"
  },
  {
    label: "Europe/Dublin (GMT+00:00)",
    tzCode: "Europe/Dublin",
    name: "(GMT+00:00) Dublin, Cork, Luimneach, Gaillimh, Tallaght",
    utc: "+00:00"
  },
  {
    label: "Europe/Guernsey (GMT+00:00)",
    tzCode: "Europe/Guernsey",
    name: "(GMT+00:00) Saint Peter Port, St Martin, Saint Sampson, St Anne, Saint Saviour",
    utc: "+00:00"
  },
  {
    label: "Europe/Isle_of_Man (GMT+00:00)",
    tzCode: "Europe/Isle_of_Man",
    name: "(GMT+00:00) Douglas, Ramsey, Peel, Port Erin, Castletown",
    utc: "+00:00"
  },
  {
    label: "Europe/Jersey (GMT+00:00)",
    tzCode: "Europe/Jersey",
    name: "(GMT+00:00) Saint Helier, Le Hocq",
    utc: "+00:00"
  },
  {
    label: "Europe/Lisbon (GMT+00:00)",
    tzCode: "Europe/Lisbon",
    name: "(GMT+00:00) Lisbon, Porto, Amadora, Braga, Setúbal",
    utc: "+00:00"
  },
  {
    label: "Europe/London (GMT+00:00)",
    tzCode: "Europe/London",
    name: "(GMT+00:00) London, Birmingham, Liverpool, Sheffield, Bristol",
    utc: "+00:00"
  },
  {
    label: "Africa/Algiers (GMT+01:00)",
    tzCode: "Africa/Algiers",
    name: "(GMT+01:00) Algiers, Boumerdas, Oran, Tébessa, Constantine",
    utc: "+01:00"
  },
  {
    label: "Africa/Bangui (GMT+01:00)",
    tzCode: "Africa/Bangui",
    name: "(GMT+01:00) Bangui, Bimbo, Mbaïki, Berbérati, Kaga Bandoro",
    utc: "+01:00"
  },
  {
    label: "Africa/Brazzaville (GMT+01:00)",
    tzCode: "Africa/Brazzaville",
    name: "(GMT+01:00) Brazzaville, Pointe-Noire, Dolisie, Kayes, Owando",
    utc: "+01:00"
  },
  {
    label: "Africa/Ceuta (GMT+01:00)",
    tzCode: "Africa/Ceuta",
    name: "(GMT+01:00) Ceuta, Melilla",
    utc: "+01:00"
  },
  {
    label: "Africa/Douala (GMT+01:00)",
    tzCode: "Africa/Douala",
    name: "(GMT+01:00) Douala, Yaoundé, Garoua, Kousséri, Bamenda",
    utc: "+01:00"
  },
  {
    label: "Africa/Kinshasa (GMT+01:00)",
    tzCode: "Africa/Kinshasa",
    name: "(GMT+01:00) Kinshasa, Masina, Kikwit, Mbandaka, Matadi",
    utc: "+01:00"
  },
  {
    label: "Africa/Lagos (GMT+01:00)",
    tzCode: "Africa/Lagos",
    name: "(GMT+01:00) Lagos, Kano, Ibadan, Kaduna, Port Harcourt",
    utc: "+01:00"
  },
  {
    label: "Africa/Libreville (GMT+01:00)",
    tzCode: "Africa/Libreville",
    name: "(GMT+01:00) Libreville, Port-Gentil, Franceville, Oyem, Moanda",
    utc: "+01:00"
  },
  {
    label: "Africa/Luanda (GMT+01:00)",
    tzCode: "Africa/Luanda",
    name: "(GMT+01:00) Luanda, N’dalatando, Huambo, Lobito, Benguela",
    utc: "+01:00"
  },
  {
    label: "Africa/Malabo (GMT+01:00)",
    tzCode: "Africa/Malabo",
    name: "(GMT+01:00) Bata, Malabo, Ebebiyin, Aconibe, Añisoc",
    utc: "+01:00"
  },
  {
    label: "Africa/Ndjamena (GMT+01:00)",
    tzCode: "Africa/Ndjamena",
    name: "(GMT+01:00) N'Djamena, Moundou, Sarh, Abéché, Kelo",
    utc: "+01:00"
  },
  {
    label: "Africa/Niamey (GMT+01:00)",
    tzCode: "Africa/Niamey",
    name: "(GMT+01:00) Niamey, Zinder, Maradi, Agadez, Alaghsas",
    utc: "+01:00"
  },
  {
    label: "Africa/Porto-Novo (GMT+01:00)",
    tzCode: "Africa/Porto-Novo",
    name: "(GMT+01:00) Cotonou, Abomey-Calavi, Djougou, Porto-Novo, Parakou",
    utc: "+01:00"
  },
  {
    label: "Africa/Tunis (GMT+01:00)",
    tzCode: "Africa/Tunis",
    name: "(GMT+01:00) Tunis, Sfax, Sousse, Kairouan, Bizerte",
    utc: "+01:00"
  },
  {
    label: "Africa/Windhoek (GMT+01:00)",
    tzCode: "Africa/Windhoek",
    name: "(GMT+01:00) Windhoek, Rundu, Walvis Bay, Oshakati, Swakopmund",
    utc: "+01:00"
  },
  {
    label: "Arctic/Longyearbyen (GMT+01:00)",
    tzCode: "Arctic/Longyearbyen",
    name: "(GMT+01:00) Longyearbyen, Olonkinbyen",
    utc: "+01:00"
  },
  {
    label: "Europe/Amsterdam (GMT+01:00)",
    tzCode: "Europe/Amsterdam",
    name: "(GMT+01:00) Amsterdam, Rotterdam, The Hague, Utrecht, Eindhoven",
    utc: "+01:00"
  },
  {
    label: "Europe/Andorra (GMT+01:00)",
    tzCode: "Europe/Andorra",
    name: "(GMT+01:00) Andorra la Vella, les Escaldes, Encamp, Sant Julià de Lòria, la Massana",
    utc: "+01:00"
  },
  {
    label: "Europe/Belgrade (GMT+01:00)",
    tzCode: "Europe/Belgrade",
    name: "(GMT+01:00) Belgrade, Pristina, Niš, Novi Sad, Prizren",
    utc: "+01:00"
  },
  {
    label: "Europe/Berlin (GMT+01:00)",
    tzCode: "Europe/Berlin",
    name: "(GMT+01:00) Berlin, Hamburg, Munich, Köln, Frankfurt am Main",
    utc: "+01:00"
  },
  {
    label: "Europe/Bratislava (GMT+01:00)",
    tzCode: "Europe/Bratislava",
    name: "(GMT+01:00) Bratislava, Košice, Prešov, Nitra, Žilina",
    utc: "+01:00"
  },
  {
    label: "Europe/Brussels (GMT+01:00)",
    tzCode: "Europe/Brussels",
    name: "(GMT+01:00) Brussels, Antwerpen, Gent, Charleroi, Liège",
    utc: "+01:00"
  },
  {
    label: "Europe/Budapest (GMT+01:00)",
    tzCode: "Europe/Budapest",
    name: "(GMT+01:00) Budapest, Debrecen, Miskolc, Szeged, Pécs",
    utc: "+01:00"
  },
  {
    label: "Europe/Copenhagen (GMT+01:00)",
    tzCode: "Europe/Copenhagen",
    name: "(GMT+01:00) Copenhagen, Århus, Odense, Aalborg, Frederiksberg",
    utc: "+01:00"
  },
  {
    label: "Europe/Gibraltar (GMT+01:00)",
    tzCode: "Europe/Gibraltar",
    name: "(GMT+01:00) Gibraltar",
    utc: "+01:00"
  },
  {
    label: "Europe/Ljubljana (GMT+01:00)",
    tzCode: "Europe/Ljubljana",
    name: "(GMT+01:00) Ljubljana, Maribor, Celje, Kranj, Velenje",
    utc: "+01:00"
  },
  {
    label: "Europe/Luxembourg (GMT+01:00)",
    tzCode: "Europe/Luxembourg",
    name: "(GMT+01:00) Luxembourg, Esch-sur-Alzette, Dudelange, Schifflange, Bettembourg",
    utc: "+01:00"
  },
  {
    label: "Europe/Madrid (GMT+01:00)",
    tzCode: "Europe/Madrid",
    name: "(GMT+01:00) Madrid, Barcelona, Valencia, Sevilla, Zaragoza",
    utc: "+01:00"
  },
  {
    label: "Europe/Malta (GMT+01:00)",
    tzCode: "Europe/Malta",
    name: "(GMT+01:00) Birkirkara, Qormi, Mosta, Żabbar, San Pawl il-Baħar",
    utc: "+01:00"
  },
  {
    label: "Europe/Monaco (GMT+01:00)",
    tzCode: "Europe/Monaco",
    name: "(GMT+01:00) Monaco, Monte-Carlo, La Condamine",
    utc: "+01:00"
  },
  {
    label: "Europe/Oslo (GMT+01:00)",
    tzCode: "Europe/Oslo",
    name: "(GMT+01:00) Oslo, Bergen, Trondheim, Stavanger, Drammen",
    utc: "+01:00"
  },
  {
    label: "Europe/Paris (GMT+01:00)",
    tzCode: "Europe/Paris",
    name: "(GMT+01:00) Paris, Marseille, Lyon, Toulouse, Nice",
    utc: "+01:00"
  },
  {
    label: "Europe/Podgorica (GMT+01:00)",
    tzCode: "Europe/Podgorica",
    name: "(GMT+01:00) Podgorica, Nikšić, Herceg Novi, Pljevlja, Budva",
    utc: "+01:00"
  },
  {
    label: "Europe/Prague (GMT+01:00)",
    tzCode: "Europe/Prague",
    name: "(GMT+01:00) Prague, Brno, Ostrava, Pilsen, Olomouc",
    utc: "+01:00"
  },
  {
    label: "Europe/Rome (GMT+01:00)",
    tzCode: "Europe/Rome",
    name: "(GMT+01:00) Rome, Milan, Naples, Turin, Palermo",
    utc: "+01:00"
  },
  {
    label: "Europe/San_Marino (GMT+01:00)",
    tzCode: "Europe/San_Marino",
    name: "(GMT+01:00) Serravalle, Borgo Maggiore, San Marino, Domagnano, Fiorentino",
    utc: "+01:00"
  },
  {
    label: "Europe/Sarajevo (GMT+01:00)",
    tzCode: "Europe/Sarajevo",
    name: "(GMT+01:00) Sarajevo, Banja Luka, Zenica, Tuzla, Mostar",
    utc: "+01:00"
  },
  {
    label: "Europe/Skopje (GMT+01:00)",
    tzCode: "Europe/Skopje",
    name: "(GMT+01:00) Skopje, Bitola, Kumanovo, Prilep, Tetovo",
    utc: "+01:00"
  },
  {
    label: "Europe/Stockholm (GMT+01:00)",
    tzCode: "Europe/Stockholm",
    name: "(GMT+01:00) Stockholm, Göteborg, Malmö, Uppsala, Sollentuna",
    utc: "+01:00"
  },
  {
    label: "Europe/Tirane (GMT+01:00)",
    tzCode: "Europe/Tirane",
    name: "(GMT+01:00) Tirana, Durrës, Elbasan, Vlorë, Shkodër",
    utc: "+01:00"
  },
  {
    label: "Europe/Vaduz (GMT+01:00)",
    tzCode: "Europe/Vaduz",
    name: "(GMT+01:00) Schaan, Vaduz, Triesen, Balzers, Eschen",
    utc: "+01:00"
  },
  {
    label: "Europe/Vatican (GMT+01:00)",
    tzCode: "Europe/Vatican",
    name: "(GMT+01:00) Vatican City",
    utc: "+01:00"
  },
  {
    label: "Europe/Vienna (GMT+01:00)",
    tzCode: "Europe/Vienna",
    name: "(GMT+01:00) Vienna, Graz, Linz, Favoriten, Donaustadt",
    utc: "+01:00"
  },
  {
    label: "Europe/Warsaw (GMT+01:00)",
    tzCode: "Europe/Warsaw",
    name: "(GMT+01:00) Warsaw, Łódź, Kraków, Wrocław, Poznań",
    utc: "+01:00"
  },
  {
    label: "Europe/Zagreb (GMT+01:00)",
    tzCode: "Europe/Zagreb",
    name: "(GMT+01:00) Zagreb, Split, Rijeka, Osijek, Zadar",
    utc: "+01:00"
  },
  {
    label: "Europe/Zurich (GMT+01:00)",
    tzCode: "Europe/Zurich",
    name: "(GMT+01:00) Zürich, Genève, Basel, Lausanne, Bern",
    utc: "+01:00"
  },
  {
    label: "Africa/Blantyre (GMT+02:00)",
    tzCode: "Africa/Blantyre",
    name: "(GMT+02:00) Lilongwe, Blantyre, Mzuzu, Zomba, Kasungu",
    utc: "+02:00"
  },
  {
    label: "Africa/Bujumbura (GMT+02:00)",
    tzCode: "Africa/Bujumbura",
    name: "(GMT+02:00) Bujumbura, Muyinga, Gitega, Ruyigi, Ngozi",
    utc: "+02:00"
  },
  {
    label: "Africa/Cairo (GMT+02:00)",
    tzCode: "Africa/Cairo",
    name: "(GMT+02:00) Cairo, Alexandria, Giza, Port Said, Suez",
    utc: "+02:00"
  },
  {
    label: "Africa/Gaborone (GMT+02:00)",
    tzCode: "Africa/Gaborone",
    name: "(GMT+02:00) Gaborone, Francistown, Molepolole, Selebi-Phikwe, Maun",
    utc: "+02:00"
  },
  {
    label: "Africa/Harare (GMT+02:00)",
    tzCode: "Africa/Harare",
    name: "(GMT+02:00) Harare, Bulawayo, Chitungwiza, Mutare, Gweru",
    utc: "+02:00"
  },
  {
    label: "Africa/Johannesburg (GMT+02:00)",
    tzCode: "Africa/Johannesburg",
    name: "(GMT+02:00) Cape Town, Durban, Johannesburg, Soweto, Pretoria",
    utc: "+02:00"
  },
  {
    label: "Africa/Juba (GMT+02:00)",
    tzCode: "Africa/Juba",
    name: "(GMT+02:00) Juba, Winejok, Malakal, Wau, Kuacjok",
    utc: "+02:00"
  },
  {
    label: "Africa/Khartoum (GMT+02:00)",
    tzCode: "Africa/Khartoum",
    name: "(GMT+02:00) Khartoum, Omdurman, Nyala, Port Sudan, Kassala",
    utc: "+02:00"
  },
  {
    label: "Africa/Kigali (GMT+02:00)",
    tzCode: "Africa/Kigali",
    name: "(GMT+02:00) Kigali, Butare, Gitarama, Musanze, Gisenyi",
    utc: "+02:00"
  },
  {
    label: "Africa/Lubumbashi (GMT+02:00)",
    tzCode: "Africa/Lubumbashi",
    name: "(GMT+02:00) Lubumbashi, Mbuji-Mayi, Kisangani, Kananga, Likasi",
    utc: "+02:00"
  },
  {
    label: "Africa/Lusaka (GMT+02:00)",
    tzCode: "Africa/Lusaka",
    name: "(GMT+02:00) Lusaka, Kitwe, Ndola, Kabwe, Chingola",
    utc: "+02:00"
  },
  {
    label: "Africa/Maputo (GMT+02:00)",
    tzCode: "Africa/Maputo",
    name: "(GMT+02:00) Maputo, Matola, Beira, Nampula, Chimoio",
    utc: "+02:00"
  },
  {
    label: "Africa/Maseru (GMT+02:00)",
    tzCode: "Africa/Maseru",
    name: "(GMT+02:00) Maseru, Mafeteng, Leribe, Maputsoe, Mohale’s Hoek",
    utc: "+02:00"
  },
  {
    label: "Africa/Mbabane (GMT+02:00)",
    tzCode: "Africa/Mbabane",
    name: "(GMT+02:00) Manzini, Mbabane, Big Bend, Malkerns, Nhlangano",
    utc: "+02:00"
  },
  {
    label: "Africa/Tripoli (GMT+02:00)",
    tzCode: "Africa/Tripoli",
    name: "(GMT+02:00) Tripoli, Benghazi, Mişrātah, Tarhuna, Al Khums",
    utc: "+02:00"
  },
  {
    label: "Asia/Amman (GMT+02:00)",
    tzCode: "Asia/Amman",
    name: "(GMT+02:00) Amman, Zarqa, Irbid, Russeifa, Wādī as Sīr",
    utc: "+02:00"
  },
  {
    label: "Asia/Beirut (GMT+02:00)",
    tzCode: "Asia/Beirut",
    name: "(GMT+02:00) Beirut, Ra’s Bayrūt, Tripoli, Sidon, Tyre",
    utc: "+02:00"
  },
  {
    label: "Asia/Damascus (GMT+02:00)",
    tzCode: "Asia/Damascus",
    name: "(GMT+02:00) Aleppo, Damascus, Homs, Ḩamāh, Latakia",
    utc: "+02:00"
  },
  {
    label: "Asia/Famagusta (GMT+02:00)",
    tzCode: "Asia/Famagusta",
    name: "(GMT+02:00) Famagusta, Kyrenia, Protaras, Paralímni, Lápithos",
    utc: "+02:00"
  },
  {
    label: "Asia/Gaza (GMT+02:00)",
    tzCode: "Asia/Gaza",
    name: "(GMT+02:00) Gaza, Khān Yūnis, Jabālyā, Rafaḩ, Dayr al Balaḩ",
    utc: "+02:00"
  },
  {
    label: "Asia/Hebron (GMT+02:00)",
    tzCode: "Asia/Hebron",
    name: "(GMT+02:00) East Jerusalem, Hebron, Nablus, Battir, Ţūlkarm",
    utc: "+02:00"
  },
  {
    label: "Asia/Jerusalem (GMT+02:00)",
    tzCode: "Asia/Jerusalem",
    name: "(GMT+02:00) Jerusalem, Tel Aviv, West Jerusalem, Haifa, Ashdod",
    utc: "+02:00"
  },
  {
    label: "Asia/Nicosia (GMT+02:00)",
    tzCode: "Asia/Nicosia",
    name: "(GMT+02:00) Nicosia, Limassol, Larnaca, Stróvolos, Paphos",
    utc: "+02:00"
  },
  {
    label: "Europe/Athens (GMT+02:00)",
    tzCode: "Europe/Athens",
    name: "(GMT+02:00) Athens, Thessaloníki, Pátra, Piraeus, Lárisa",
    utc: "+02:00"
  },
  {
    label: "Europe/Bucharest (GMT+02:00)",
    tzCode: "Europe/Bucharest",
    name: "(GMT+02:00) Bucharest, Sector 3, Sector 6, Sector 2, Iaşi",
    utc: "+02:00"
  },
  {
    label: "Europe/Chisinau (GMT+02:00)",
    tzCode: "Europe/Chisinau",
    name: "(GMT+02:00) Chisinau, Tiraspol, Bălţi, Bender, Rîbniţa",
    utc: "+02:00"
  },
  {
    label: "Europe/Helsinki (GMT+02:00)",
    tzCode: "Europe/Helsinki",
    name: "(GMT+02:00) Helsinki, Espoo, Tampere, Vantaa, Turku",
    utc: "+02:00"
  },
  {
    label: "Europe/Kaliningrad (GMT+02:00)",
    tzCode: "Europe/Kaliningrad",
    name: "(GMT+02:00) Kaliningrad, Chernyakhovsk, Sovetsk, Baltiysk, Gusev",
    utc: "+02:00"
  },
  {
    label: "Europe/Kyiv (GMT+02:00)",
    tzCode: "Europe/Kyiv",
    name: "(GMT+02:00) Kyiv, Kharkiv, Donetsk, Odesa, Dnipro",
    utc: "+02:00"
  },
  {
    label: "Europe/Mariehamn (GMT+02:00)",
    tzCode: "Europe/Mariehamn",
    name: "(GMT+02:00) Mariehamn",
    utc: "+02:00"
  },
  {
    label: "Europe/Riga (GMT+02:00)",
    tzCode: "Europe/Riga",
    name: "(GMT+02:00) Riga, Daugavpils, Liepāja, Jelgava, Jūrmala",
    utc: "+02:00"
  },
  {
    label: "Europe/Sofia (GMT+02:00)",
    tzCode: "Europe/Sofia",
    name: "(GMT+02:00) Sofia, Plovdiv, Varna, Burgas, Ruse",
    utc: "+02:00"
  },
  {
    label: "Europe/Tallinn (GMT+02:00)",
    tzCode: "Europe/Tallinn",
    name: "(GMT+02:00) Tallinn, Tartu, Narva, Kohtla-Järve, Pärnu",
    utc: "+02:00"
  },
  {
    label: "Europe/Uzhgorod (GMT+02:00)",
    tzCode: "Europe/Uzhgorod",
    name: "(GMT+02:00) Uzhgorod, Mukachevo, Khust, Berehove, Tyachiv",
    utc: "+02:00"
  },
  {
    label: "Europe/Vilnius (GMT+02:00)",
    tzCode: "Europe/Vilnius",
    name: "(GMT+02:00) Vilnius, Kaunas, Klaipėda, Šiauliai, Panevėžys",
    utc: "+02:00"
  },
  {
    label: "Europe/Zaporizhzhia (GMT+02:00)",
    tzCode: "Europe/Zaporizhzhia",
    name: "(GMT+02:00) Luhansk, Sevastopol, Sievierodonetsk, Alchevsk, Lysychansk",
    utc: "+02:00"
  },
  {
    label: "Africa/Addis_Ababa (GMT+03:00)",
    tzCode: "Africa/Addis_Ababa",
    name: "(GMT+03:00) Addis Ababa, Dire Dawa, Mek'ele, Nazrēt, Bahir Dar",
    utc: "+03:00"
  },
  {
    label: "Africa/Asmara (GMT+03:00)",
    tzCode: "Africa/Asmara",
    name: "(GMT+03:00) Asmara, Keren, Massawa, Assab, Mendefera",
    utc: "+03:00"
  },
  {
    label: "Africa/Dar_es_Salaam (GMT+03:00)",
    tzCode: "Africa/Dar_es_Salaam",
    name: "(GMT+03:00) Dar es Salaam, Mwanza, Zanzibar, Arusha, Mbeya",
    utc: "+03:00"
  },
  {
    label: "Africa/Djibouti (GMT+03:00)",
    tzCode: "Africa/Djibouti",
    name: "(GMT+03:00) Djibouti, 'Ali Sabieh, Tadjourah, Obock, Dikhil",
    utc: "+03:00"
  },
  {
    label: "Africa/Kampala (GMT+03:00)",
    tzCode: "Africa/Kampala",
    name: "(GMT+03:00) Kampala, Gulu, Lira, Mbarara, Jinja",
    utc: "+03:00"
  },
  {
    label: "Africa/Mogadishu (GMT+03:00)",
    tzCode: "Africa/Mogadishu",
    name: "(GMT+03:00) Mogadishu, Hargeysa, Berbera, Kismayo, Marka",
    utc: "+03:00"
  },
  {
    label: "Africa/Nairobi (GMT+03:00)",
    tzCode: "Africa/Nairobi",
    name: "(GMT+03:00) Nairobi, Mombasa, Nakuru, Eldoret, Kisumu",
    utc: "+03:00"
  },
  {
    label: "Antarctica/Syowa (GMT+03:00)",
    tzCode: "Antarctica/Syowa",
    name: "(GMT+03:00) Syowa",
    utc: "+03:00"
  },
  {
    label: "Asia/Aden (GMT+03:00)",
    tzCode: "Asia/Aden",
    name: "(GMT+03:00) Sanaa, Al Ḩudaydah, Taiz, Aden, Mukalla",
    utc: "+03:00"
  },
  {
    label: "Asia/Baghdad (GMT+03:00)",
    tzCode: "Asia/Baghdad",
    name: "(GMT+03:00) Baghdad, Basrah, Al Mawşil al Jadīdah, Al Başrah al Qadīmah, Mosul",
    utc: "+03:00"
  },
  {
    label: "Asia/Bahrain (GMT+03:00)",
    tzCode: "Asia/Bahrain",
    name: "(GMT+03:00) Manama, Al Muharraq, Ar Rifā‘, Dār Kulayb, Madīnat Ḩamad",
    utc: "+03:00"
  },
  {
    label: "Asia/Kuwait (GMT+03:00)",
    tzCode: "Asia/Kuwait",
    name: "(GMT+03:00) Al Aḩmadī, Ḩawallī, As Sālimīyah, Şabāḩ as Sālim, Al Farwānīyah",
    utc: "+03:00"
  },
  {
    label: "Asia/Qatar (GMT+03:00)",
    tzCode: "Asia/Qatar",
    name: "(GMT+03:00) Doha, Ar Rayyān, Umm Şalāl Muḩammad, Al Wakrah, Al Khawr",
    utc: "+03:00"
  },
  {
    label: "Asia/Riyadh (GMT+03:00)",
    tzCode: "Asia/Riyadh",
    name: "(GMT+03:00) Riyadh, Jeddah, Mecca, Medina, Sulţānah",
    utc: "+03:00"
  },
  {
    label: "Europe/Istanbul (GMT+03:00)",
    tzCode: "Europe/Istanbul",
    name: "(GMT+03:00) Istanbul, Ankara, İzmir, Bursa, Adana",
    utc: "+03:00"
  },
  {
    label: "Europe/Kirov (GMT+03:00)",
    tzCode: "Europe/Kirov",
    name: "(GMT+03:00) Kirov, Kirovo-Chepetsk, Vyatskiye Polyany, Slobodskoy, Kotel’nich",
    utc: "+03:00"
  },
  {
    label: "Europe/Minsk (GMT+03:00)",
    tzCode: "Europe/Minsk",
    name: "(GMT+03:00) Minsk, Homyel', Mahilyow, Vitebsk, Hrodna",
    utc: "+03:00"
  },
  {
    label: "Europe/Moscow (GMT+03:00)",
    tzCode: "Europe/Moscow",
    name: "(GMT+03:00) Moscow, Saint Petersburg, Nizhniy Novgorod, Kazan, Rostov-na-Donu",
    utc: "+03:00"
  },
  {
    label: "Europe/Simferopol (GMT+03:00)",
    tzCode: "Europe/Simferopol",
    name: "(GMT+03:00) Simferopol, Kerch, Yevpatoriya, Yalta, Feodosiya",
    utc: "+03:00"
  },
  {
    label: "Europe/Volgograd (GMT+03:00)",
    tzCode: "Europe/Volgograd",
    name: "(GMT+03:00) Volgograd, Volzhskiy, Kamyshin, Mikhaylovka, Uryupinsk",
    utc: "+03:00"
  },
  {
    label: "Indian/Antananarivo (GMT+03:00)",
    tzCode: "Indian/Antananarivo",
    name: "(GMT+03:00) Antananarivo, Toamasina, Antsirabe, Fianarantsoa, Mahajanga",
    utc: "+03:00"
  },
  {
    label: "Indian/Comoro (GMT+03:00)",
    tzCode: "Indian/Comoro",
    name: "(GMT+03:00) Moroni, Moutsamoudou, Fomboni, Domoni, Tsimbeo",
    utc: "+03:00"
  },
  {
    label: "Indian/Mayotte (GMT+03:00)",
    tzCode: "Indian/Mayotte",
    name: "(GMT+03:00) Mamoudzou, Koungou, Dzaoudzi, Dembeni, Sada",
    utc: "+03:00"
  },
  {
    label: "Asia/Tehran (GMT+03:30)",
    tzCode: "Asia/Tehran",
    name: "(GMT+03:30) Tehran, Mashhad, Isfahan, Karaj, Tabriz",
    utc: "+03:30"
  },
  {
    label: "Asia/Baku (GMT+04:00)",
    tzCode: "Asia/Baku",
    name: "(GMT+04:00) Baku, Ganja, Sumqayıt, Lankaran, Yevlakh",
    utc: "+04:00"
  },
  {
    label: "Asia/Dubai (GMT+04:00)",
    tzCode: "Asia/Dubai",
    name: "(GMT+04:00) Dubai, Sharjah, Abu Dhabi, Ajman City, Ras Al Khaimah City",
    utc: "+04:00"
  },
  {
    label: "Asia/Muscat (GMT+04:00)",
    tzCode: "Asia/Muscat",
    name: "(GMT+04:00) Muscat, Seeb, Şalālah, Bawshar, Sohar",
    utc: "+04:00"
  },
  {
    label: "Asia/Tbilisi (GMT+04:00)",
    tzCode: "Asia/Tbilisi",
    name: "(GMT+04:00) Tbilisi, Kutaisi, Batumi, Sokhumi, Zugdidi",
    utc: "+04:00"
  },
  {
    label: "Asia/Yerevan (GMT+04:00)",
    tzCode: "Asia/Yerevan",
    name: "(GMT+04:00) Yerevan, Gyumri, Vanadzor, Vagharshapat, Hrazdan",
    utc: "+04:00"
  },
  {
    label: "Europe/Astrakhan (GMT+04:00)",
    tzCode: "Europe/Astrakhan",
    name: "(GMT+04:00) Astrakhan, Akhtubinsk, Znamensk, Kharabali, Kamyzyak",
    utc: "+04:00"
  },
  {
    label: "Europe/Samara (GMT+04:00)",
    tzCode: "Europe/Samara",
    name: "(GMT+04:00) Samara, Togliatti-on-the-Volga, Izhevsk, Syzran’, Novokuybyshevsk",
    utc: "+04:00"
  },
  {
    label: "Europe/Saratov (GMT+04:00)",
    tzCode: "Europe/Saratov",
    name: "(GMT+04:00) Saratov, Balakovo, Engel’s, Balashov, Vol’sk",
    utc: "+04:00"
  },
  {
    label: "Europe/Ulyanovsk (GMT+04:00)",
    tzCode: "Europe/Ulyanovsk",
    name: "(GMT+04:00) Ulyanovsk, Dimitrovgrad, Inza, Barysh, Novoul’yanovsk",
    utc: "+04:00"
  },
  {
    label: "Indian/Mahe (GMT+04:00)",
    tzCode: "Indian/Mahe",
    name: "(GMT+04:00) Victoria, Anse Boileau, Bel Ombre, Beau Vallon, Cascade",
    utc: "+04:00"
  },
  {
    label: "Indian/Mauritius (GMT+04:00)",
    tzCode: "Indian/Mauritius",
    name: "(GMT+04:00) Port Louis, Beau Bassin-Rose Hill, Vacoas, Curepipe, Quatre Bornes",
    utc: "+04:00"
  },
  {
    label: "Indian/Reunion (GMT+04:00)",
    tzCode: "Indian/Reunion",
    name: "(GMT+04:00) Saint-Denis, Saint-Paul, Saint-Pierre, Le Tampon, Saint-André",
    utc: "+04:00"
  },
  {
    label: "Asia/Kabul (GMT+04:30)",
    tzCode: "Asia/Kabul",
    name: "(GMT+04:30) Kabul, Kandahār, Mazār-e Sharīf, Herāt, Jalālābād",
    utc: "+04:30"
  },
  {
    label: "Antarctica/Mawson (GMT+05:00)",
    tzCode: "Antarctica/Mawson",
    name: "(GMT+05:00) Mawson",
    utc: "+05:00"
  },
  {
    label: "Asia/Aqtau (GMT+05:00)",
    tzCode: "Asia/Aqtau",
    name: "(GMT+05:00) Shevchenko, Zhanaozen, Beyneu, Shetpe, Yeraliyev",
    utc: "+05:00"
  },
  {
    label: "Asia/Aqtobe (GMT+05:00)",
    tzCode: "Asia/Aqtobe",
    name: "(GMT+05:00) Aktobe, Kandyagash, Shalqar, Khromtau, Embi",
    utc: "+05:00"
  },
  {
    label: "Asia/Ashgabat (GMT+05:00)",
    tzCode: "Asia/Ashgabat",
    name: "(GMT+05:00) Ashgabat, Türkmenabat, Daşoguz, Mary, Balkanabat",
    utc: "+05:00"
  },
  {
    label: "Asia/Atyrau (GMT+05:00)",
    tzCode: "Asia/Atyrau",
    name: "(GMT+05:00) Atyrau, Qulsary, Shalkar, Balykshi, Maqat",
    utc: "+05:00"
  },
  {
    label: "Asia/Dushanbe (GMT+05:00)",
    tzCode: "Asia/Dushanbe",
    name: "(GMT+05:00) Dushanbe, Khujand, Kŭlob, Bokhtar, Istaravshan",
    utc: "+05:00"
  },
  {
    label: "Asia/Karachi (GMT+05:00)",
    tzCode: "Asia/Karachi",
    name: "(GMT+05:00) Karachi, Lahore, Faisalabad, Rawalpindi, Multan",
    utc: "+05:00"
  },
  {
    label: "Asia/Oral (GMT+05:00)",
    tzCode: "Asia/Oral",
    name: "(GMT+05:00) Oral, Aqsay, Zhänibek, Tasqala, Zhumysker",
    utc: "+05:00"
  },
  {
    label: "Asia/Qyzylorda (GMT+05:00)",
    tzCode: "Asia/Qyzylorda",
    name: "(GMT+05:00) Kyzylorda, Baikonur, Novokazalinsk, Aral, Chiili",
    utc: "+05:00"
  },
  {
    label: "Asia/Samarkand (GMT+05:00)",
    tzCode: "Asia/Samarkand",
    name: "(GMT+05:00) Samarkand, Bukhara, Nukus, Qarshi, Jizzax",
    utc: "+05:00"
  },
  {
    label: "Asia/Tashkent (GMT+05:00)",
    tzCode: "Asia/Tashkent",
    name: "(GMT+05:00) Tashkent, Namangan, Andijon, Qo‘qon, Chirchiq",
    utc: "+05:00"
  },
  {
    label: "Asia/Yekaterinburg (GMT+05:00)",
    tzCode: "Asia/Yekaterinburg",
    name: "(GMT+05:00) Yekaterinburg, Chelyabinsk, Ufa, Perm, Orenburg",
    utc: "+05:00"
  },
  {
    label: "Indian/Kerguelen (GMT+05:00)",
    tzCode: "Indian/Kerguelen",
    name: "(GMT+05:00) Port-aux-Français",
    utc: "+05:00"
  },
  {
    label: "Indian/Maldives (GMT+05:00)",
    tzCode: "Indian/Maldives",
    name: "(GMT+05:00) Male, Fuvahmulah, Hithadhoo, Kulhudhuffushi, Thinadhoo",
    utc: "+05:00"
  },
  {
    label: "Asia/Colombo (GMT+05:30)",
    tzCode: "Asia/Colombo",
    name: "(GMT+05:30) Colombo, Dehiwala-Mount Lavinia, Moratuwa, Jaffna, Negombo",
    utc: "+05:30"
  },
  {
    label: "Asia/Kolkata (GMT+05:30)",
    tzCode: "Asia/Kolkata",
    name: "(GMT+05:30) Mumbai, Delhi, Bengaluru, Kolkata, Chennai",
    utc: "+05:30"
  },
  {
    label: "Asia/Kathmandu (GMT+05:45)",
    tzCode: "Asia/Kathmandu",
    name: "(GMT+05:45) Kathmandu, Pokhara, Pātan, Biratnagar, Birgañj",
    utc: "+05:45"
  },
  {
    label: "Antarctica/Vostok (GMT+06:00)",
    tzCode: "Antarctica/Vostok",
    name: "(GMT+06:00) Vostok",
    utc: "+06:00"
  },
  {
    label: "Asia/Almaty (GMT+05:00)",
    tzCode: "Asia/Almaty",
    name: "(GMT+05:00) Almaty, Karagandy, Shymkent, Taraz, Nur-Sultan",
    utc: "+05:00"
  },
  {
    label: "Asia/Bishkek (GMT+06:00)",
    tzCode: "Asia/Bishkek",
    name: "(GMT+06:00) Bishkek, Osh, Jalal-Abad, Karakol, Tokmok",
    utc: "+06:00"
  },
  {
    label: "Asia/Dhaka (GMT+06:00)",
    tzCode: "Asia/Dhaka",
    name: "(GMT+06:00) Dhaka, Chattogram, Khulna, Rājshāhi, Comilla",
    utc: "+06:00"
  },
  {
    label: "Asia/Omsk (GMT+06:00)",
    tzCode: "Asia/Omsk",
    name: "(GMT+06:00) Omsk, Tara, Kalachinsk, Znamenskoye, Tavricheskoye",
    utc: "+06:00"
  },
  {
    label: "Asia/Qostanay (GMT+06:00)",
    tzCode: "Asia/Qostanay",
    name: "(GMT+06:00) Kostanay, Rudnyy, Dzhetygara, Arkalyk, Lisakovsk",
    utc: "+06:00"
  },
  {
    label: "Asia/Thimphu (GMT+06:00)",
    tzCode: "Asia/Thimphu",
    name: "(GMT+06:00) himphu, Punākha, Tsirang, Phuntsholing, Pemagatshel",
    utc: "+06:00"
  },
  {
    label: "Asia/Urumqi (GMT+06:00)",
    tzCode: "Asia/Urumqi",
    name: "(GMT+06:00) Zhongshan, Ürümqi, Zhanjiang, Shihezi, Huocheng",
    utc: "+06:00"
  },
  {
    label: "Indian/Chagos (GMT+06:00)",
    tzCode: "Indian/Chagos",
    name: "(GMT+06:00) British Indian Ocean Territory",
    utc: "+06:00"
  },
  {
    label: "Asia/Yangon (GMT+06:30)",
    tzCode: "Asia/Yangon",
    name: "(GMT+06:30) Yangon, Mandalay, Nay Pyi Taw, Mawlamyine, Kyain Seikgyi Township",
    utc: "+06:30"
  },
  {
    label: "Indian/Cocos (GMT+06:30)",
    tzCode: "Indian/Cocos",
    name: "(GMT+06:30) West Island",
    utc: "+06:30"
  },
  {
    label: "Antarctica/Davis (GMT+07:00)",
    tzCode: "Antarctica/Davis",
    name: "(GMT+07:00) Davis",
    utc: "+07:00"
  },
  {
    label: "Asia/Bangkok (GMT+07:00)",
    tzCode: "Asia/Bangkok",
    name: "(GMT+07:00) Bangkok, Hanoi, Haiphong, Samut Prakan, Mueang Nonthaburi",
    utc: "+07:00"
  },
  {
    label: "Asia/Barnaul (GMT+07:00)",
    tzCode: "Asia/Barnaul",
    name: "(GMT+07:00) Barnaul, Biysk, Rubtsovsk, Novoaltaysk, Gorno-Altaysk",
    utc: "+07:00"
  },
  {
    label: "Asia/Hovd (GMT+07:00)",
    tzCode: "Asia/Hovd",
    name: "(GMT+07:00) Khovd, Ölgii, Ulaangom, Uliastay, Altai",
    utc: "+07:00"
  },
  {
    label: "Asia/Ho_Chi_Minh (GMT+07:00)",
    tzCode: "Asia/Ho_Chi_Minh",
    name: "(GMT+07:00) Ho Chi Minh City, Da Nang, Biên Hòa, Nha Trang, Cần Thơ",
    utc: "+07:00"
  },
  {
    label: "Asia/Jakarta (GMT+07:00)",
    tzCode: "Asia/Jakarta",
    name: "(GMT+07:00) Jakarta, Surabaya, Medan, Bandung, Bekasi",
    utc: "+07:00"
  },
  {
    label: "Asia/Krasnoyarsk (GMT+07:00)",
    tzCode: "Asia/Krasnoyarsk",
    name: "(GMT+07:00) Krasnoyarsk, Abakan, Norilsk, Achinsk, Kyzyl",
    utc: "+07:00"
  },
  {
    label: "Asia/Novokuznetsk (GMT+07:00)",
    tzCode: "Asia/Novokuznetsk",
    name: "(GMT+07:00) Novokuznetsk, Kemerovo, Prokop’yevsk, Leninsk-Kuznetsky, Kiselëvsk",
    utc: "+07:00"
  },
  {
    label: "Asia/Novosibirsk (GMT+07:00)",
    tzCode: "Asia/Novosibirsk",
    name: "(GMT+07:00) Novosibirsk, Berdsk, Iskitim, Akademgorodok, Kuybyshev",
    utc: "+07:00"
  },
  {
    label: "Asia/Phnom_Penh (GMT+07:00)",
    tzCode: "Asia/Phnom_Penh",
    name: "(GMT+07:00) Phnom Penh, Takeo, Sihanoukville, Battambang, Siem Reap",
    utc: "+07:00"
  },
  {
    label: "Asia/Pontianak (GMT+07:00)",
    tzCode: "Asia/Pontianak",
    name: "(GMT+07:00) Pontianak, Tanjung Pinang, Palangkaraya, Singkawang, Sampit",
    utc: "+07:00"
  },
  {
    label: "Asia/Tomsk (GMT+07:00)",
    tzCode: "Asia/Tomsk",
    name: "(GMT+07:00) Tomsk, Seversk, Strezhevoy, Kolpashevo, Asino",
    utc: "+07:00"
  },
  {
    label: "Asia/Vientiane (GMT+07:00)",
    tzCode: "Asia/Vientiane",
    name: "(GMT+07:00) Vientiane, Pakse, Thakhèk, Savannakhet, Luang Prabang",
    utc: "+07:00"
  },
  {
    label: "Indian/Christmas (GMT+07:00)",
    tzCode: "Indian/Christmas",
    name: "(GMT+07:00) Flying Fish Cove",
    utc: "+07:00"
  },
  {
    label: "Asia/Brunei (GMT+08:00)",
    tzCode: "Asia/Brunei",
    name: "(GMT+08:00) Bandar Seri Begawan, Kuala Belait, Seria, Tutong, Bangar",
    utc: "+08:00"
  },
  {
    label: "Asia/Choibalsan (GMT+08:00)",
    tzCode: "Asia/Choibalsan",
    name: "(GMT+08:00) Baruun-Urt, Choibalsan",
    utc: "+08:00"
  },
  {
    label: "Asia/Hong_Kong (GMT+08:00)",
    tzCode: "Asia/Hong_Kong",
    name: "(GMT+08:00) Hong Kong, Kowloon, Tsuen Wan, Yuen Long Kau Hui, Tung Chung",
    utc: "+08:00"
  },
  {
    label: "Asia/Irkutsk (GMT+08:00)",
    tzCode: "Asia/Irkutsk",
    name: "(GMT+08:00) Irkutsk, Ulan-Ude, Bratsk, Angarsk, Ust’-Ilimsk",
    utc: "+08:00"
  },
  {
    label: "Asia/Kuala_Lumpur (GMT+08:00)",
    tzCode: "Asia/Kuala_Lumpur",
    name: "(GMT+08:00) Kota Bharu, Kuala Lumpur, Klang, Kampung Baru Subang, Johor Bahru",
    utc: "+08:00"
  },
  {
    label: "Asia/Kuching (GMT+08:00)",
    tzCode: "Asia/Kuching",
    name: "(GMT+08:00) Kuching, Kota Kinabalu, Sandakan, Tawau, Miri",
    utc: "+08:00"
  },
  {
    label: "Asia/Macau (GMT+08:00)",
    tzCode: "Asia/Macau",
    name: "(GMT+08:00) Macau",
    utc: "+08:00"
  },
  {
    label: "Asia/Makassar (GMT+08:00)",
    tzCode: "Asia/Makassar",
    name: "(GMT+08:00) Makassar, Denpasar, City of Balikpapan, Banjarmasin, Manado",
    utc: "+08:00"
  },
  {
    label: "Asia/Manila (GMT+08:00)",
    tzCode: "Asia/Manila",
    name: "(GMT+08:00) Quezon City, Manila, Caloocan City, Budta, Davao",
    utc: "+08:00"
  },
  {
    label: "Asia/Shanghai (GMT+08:00)",
    tzCode: "Asia/Shanghai",
    name: "(GMT+08:00) Shanghai, Beijing, Tianjin, Guangzhou, Shenzhen",
    utc: "+08:00"
  },
  {
    label: "Asia/Singapore (GMT+08:00)",
    tzCode: "Asia/Singapore",
    name: "(GMT+08:00) Singapore, Woodlands",
    utc: "+08:00"
  },
  {
    label: "Asia/Taipei (GMT+08:00)",
    tzCode: "Asia/Taipei",
    name: "(GMT+08:00) Taipei, Kaohsiung, Taichung, Tainan, Banqiao",
    utc: "+08:00"
  },
  {
    label: "Asia/Ulaanbaatar (GMT+08:00)",
    tzCode: "Asia/Ulaanbaatar",
    name: "(GMT+08:00) Ulan Bator, Erdenet, Darhan, Hovd, Mörön",
    utc: "+08:00"
  },
  {
    label: "Australia/Perth (GMT+08:00)",
    tzCode: "Australia/Perth",
    name: "(GMT+08:00) Perth, Rockingham, Mandurah, Bunbury, Albany",
    utc: "+08:00"
  },
  {
    label: "Australia/Eucla (GMT+08:45)",
    tzCode: "Australia/Eucla",
    name: "(GMT+08:45) Eucla",
    utc: "+08:45"
  },
  {
    label: "Asia/Chita (GMT+09:00)",
    tzCode: "Asia/Chita",
    name: "(GMT+09:00) Chita, Krasnokamensk, Borzya, Petrovsk-Zabaykal’skiy, Aginskoye",
    utc: "+09:00"
  },
  {
    label: "Asia/Dili (GMT+09:00)",
    tzCode: "Asia/Dili",
    name: "(GMT+09:00) Dili, Maliana, Suai, Likisá, Aileu",
    utc: "+09:00"
  },
  {
    label: "Asia/Jayapura (GMT+09:00)",
    tzCode: "Asia/Jayapura",
    name: "(GMT+09:00) Ambon, Jayapura, Sorong, Ternate, Abepura",
    utc: "+09:00"
  },
  {
    label: "Asia/Khandyga (GMT+09:00)",
    tzCode: "Asia/Khandyga",
    name: "(GMT+09:00) Khandyga",
    utc: "+09:00"
  },
  {
    label: "Asia/Pyongyang (GMT+09:00)",
    tzCode: "Asia/Pyongyang",
    name: "(GMT+09:00) Pyongyang, Hamhŭng, Namp’o, Sunch’ŏn, Hŭngnam",
    utc: "+09:00"
  },
  {
    label: "Asia/Seoul (GMT+09:00)",
    tzCode: "Asia/Seoul",
    name: "(GMT+09:00) Seoul, Busan, Incheon, Daegu, Daejeon",
    utc: "+09:00"
  },
  {
    label: "Asia/Tokyo (GMT+09:00)",
    tzCode: "Asia/Tokyo",
    name: "(GMT+09:00) Tokyo, Yokohama, Osaka, Nagoya, Sapporo",
    utc: "+09:00"
  },
  {
    label: "Asia/Yakutsk (GMT+09:00)",
    tzCode: "Asia/Yakutsk",
    name: "(GMT+09:00) Yakutsk, Blagoveshchensk, Belogorsk, Neryungri, Svobodnyy",
    utc: "+09:00"
  },
  {
    label: "Pacific/Palau (GMT+09:00)",
    tzCode: "Pacific/Palau",
    name: "(GMT+09:00) Koror, Koror Town, Kloulklubed, Ulimang, Mengellang",
    utc: "+09:00"
  },
  {
    label: "Australia/Adelaide (GMT+09:30)",
    tzCode: "Australia/Adelaide",
    name: "(GMT+09:30) Adelaide, Adelaide Hills, Mount Gambier, Morphett Vale, Gawler",
    utc: "+09:30"
  },
  {
    label: "Australia/Broken_Hill (GMT+09:30)",
    tzCode: "Australia/Broken_Hill",
    name: "(GMT+09:30) Broken Hill",
    utc: "+09:30"
  },
  {
    label: "Australia/Darwin (GMT+09:30)",
    tzCode: "Australia/Darwin",
    name: "(GMT+09:30) Darwin, Alice Springs, Palmerston, Howard Springs",
    utc: "+09:30"
  },
  {
    label: "Antarctica/DumontDUrville (GMT+10:00)",
    tzCode: "Antarctica/DumontDUrville",
    name: "(GMT+10:00) DumontDUrville",
    utc: "+10:00"
  },
  {
    label: "Antarctica/Macquarie (GMT+10:00)",
    tzCode: "Antarctica/Macquarie",
    name: "(GMT+10:00) Macquarie",
    utc: "+10:00"
  },
  {
    label: "Asia/Ust-Nera (GMT+10:00)",
    tzCode: "Asia/Ust-Nera",
    name: "(GMT+10:00) Ust-Nera",
    utc: "+10:00"
  },
  {
    label: "Asia/Vladivostok (GMT+10:00)",
    tzCode: "Asia/Vladivostok",
    name: "(GMT+10:00) Vladivostok, Khabarovsk, Khabarovsk Vtoroy, Komsomolsk-on-Amur, Ussuriysk",
    utc: "+10:00"
  },
  {
    label: "Australia/Brisbane (GMT+10:00)",
    tzCode: "Australia/Brisbane",
    name: "(GMT+10:00) Brisbane, Gold Coast, Logan City, Townsville, Cairns",
    utc: "+10:00"
  },
  {
    label: "Australia/Currie (GMT+10:00)",
    tzCode: "Australia/Currie",
    name: "(GMT+10:00) Currie",
    utc: "+10:00"
  },
  {
    label: "Australia/Hobart (GMT+10:00)",
    tzCode: "Australia/Hobart",
    name: "(GMT+10:00) Hobart, Launceston, Burnie, Devonport, Sandy Bay",
    utc: "+10:00"
  },
  {
    label: "Australia/Lindeman (GMT+10:00)",
    tzCode: "Australia/Lindeman",
    name: "(GMT+10:00) Lindeman",
    utc: "+10:00"
  },
  {
    label: "Australia/Melbourne (GMT+10:00)",
    tzCode: "Australia/Melbourne",
    name: "(GMT+10:00) Melbourne, Geelong, Bendigo, Ballarat, Melbourne City Centre",
    utc: "+10:00"
  },
  {
    label: "Australia/Sydney (GMT+10:00)",
    tzCode: "Australia/Sydney",
    name: "(GMT+10:00) Sydney, Canberra, Newcastle, Wollongong, Maitland",
    utc: "+10:00"
  },
  {
    label: "Pacific/Chuuk (GMT+10:00)",
    tzCode: "Pacific/Chuuk",
    name: "(GMT+10:00) Weno, Colonia",
    utc: "+10:00"
  },
  {
    label: "Pacific/Guam (GMT+10:00)",
    tzCode: "Pacific/Guam",
    name: "(GMT+10:00) Dededo Village, Yigo Village, Tamuning, Tamuning-Tumon-Harmon Village, Mangilao Village",
    utc: "+10:00"
  },
  {
    label: "Pacific/Port_Moresby (GMT+10:00)",
    tzCode: "Pacific/Port_Moresby",
    name: "(GMT+10:00) Port Moresby, Lae, Mount Hagen, Popondetta, Madang",
    utc: "+10:00"
  },
  {
    label: "Pacific/Saipan (GMT+10:00)",
    tzCode: "Pacific/Saipan",
    name: "(GMT+10:00) Saipan, San Jose Village",
    utc: "+10:00"
  },
  {
    label: "Australia/Lord_Howe (GMT+10:30)",
    tzCode: "Australia/Lord_Howe",
    name: "(GMT+10:30) Lord Howe",
    utc: "+10:30"
  },
  {
    label: "Antarctica/Casey (GMT+8:00)",
    tzCode: "Antarctica/Casey",
    name: "(GMT+8:00) Casey",
    utc: "+8:00"
  },
  {
    label: "Asia/Magadan (GMT+11:00)",
    tzCode: "Asia/Magadan",
    name: "(GMT+11:00) Magadan, Ust-Nera, Susuman, Ola",
    utc: "+11:00"
  },
  {
    label: "Asia/Sakhalin (GMT+11:00)",
    tzCode: "Asia/Sakhalin",
    name: "(GMT+11:00) Yuzhno-Sakhalinsk, Korsakov, Kholmsk, Okha, Nevel’sk",
    utc: "+11:00"
  },
  {
    label: "Asia/Srednekolymsk (GMT+11:00)",
    tzCode: "Asia/Srednekolymsk",
    name: "(GMT+11:00) Srednekolymsk",
    utc: "+11:00"
  },
  {
    label: "Pacific/Bougainville (GMT+11:00)",
    tzCode: "Pacific/Bougainville",
    name: "(GMT+11:00) Arawa, Buka",
    utc: "+11:00"
  },
  {
    label: "Pacific/Efate (GMT+11:00)",
    tzCode: "Pacific/Efate",
    name: "(GMT+11:00) Port-Vila, Luganville, Isangel, Sola, Lakatoro",
    utc: "+11:00"
  },
  {
    label: "Pacific/Guadalcanal (GMT+11:00)",
    tzCode: "Pacific/Guadalcanal",
    name: "(GMT+11:00) Honiara, Malango, Auki, Gizo, Buala",
    utc: "+11:00"
  },
  {
    label: "Pacific/Kosrae (GMT+11:00)",
    tzCode: "Pacific/Kosrae",
    name: "(GMT+11:00) Tofol",
    utc: "+11:00"
  },
  {
    label: "Pacific/Norfolk (GMT+11:00)",
    tzCode: "Pacific/Norfolk",
    name: "(GMT+11:00) Kingston",
    utc: "+11:00"
  },
  {
    label: "Pacific/Noumea (GMT+11:00)",
    tzCode: "Pacific/Noumea",
    name: "(GMT+11:00) Nouméa, Mont-Dore, Dumbéa, Païta, Wé",
    utc: "+11:00"
  },
  {
    label: "Pacific/Pohnpei (GMT+11:00)",
    tzCode: "Pacific/Pohnpei",
    name: "(GMT+11:00) Kolonia, Kolonia Town, Palikir - National Government Center",
    utc: "+11:00"
  },
  {
    label: "Antarctica/McMurdo (GMT+12:00)",
    tzCode: "Antarctica/McMurdo",
    name: "(GMT+12:00) McMurdo",
    utc: "+12:00"
  },
  {
    label: "Asia/Anadyr (GMT+12:00)",
    tzCode: "Asia/Anadyr",
    name: "(GMT+12:00) Anadyr, Bilibino",
    utc: "+12:00"
  },
  {
    label: "Asia/Kamchatka (GMT+12:00)",
    tzCode: "Asia/Kamchatka",
    name: "(GMT+12:00) Petropavlovsk-Kamchatsky, Yelizovo, Vilyuchinsk, Klyuchi, Mil’kovo",
    utc: "+12:00"
  },
  {
    label: "Pacific/Auckland (GMT+12:00)",
    tzCode: "Pacific/Auckland",
    name: "(GMT+12:00) Auckland, Wellington, Christchurch, Manukau City, North Shore",
    utc: "+12:00"
  },
  {
    label: "Pacific/Fiji (GMT+12:00)",
    tzCode: "Pacific/Fiji",
    name: "(GMT+12:00) Suva, Lautoka, Nadi, Labasa, Ba",
    utc: "+12:00"
  },
  {
    label: "Pacific/Funafuti (GMT+12:00)",
    tzCode: "Pacific/Funafuti",
    name: "(GMT+12:00) Funafuti, Savave Village, Tanrake Village, Toga Village, Asau Village",
    utc: "+12:00"
  },
  {
    label: "Pacific/Kwajalein (GMT+12:00)",
    tzCode: "Pacific/Kwajalein",
    name: "(GMT+12:00) Ebaye, Jabat",
    utc: "+12:00"
  },
  {
    label: "Pacific/Majuro (GMT+12:00)",
    tzCode: "Pacific/Majuro",
    name: "(GMT+12:00) Majuro, Arno, Jabor, Wotje, Mili",
    utc: "+12:00"
  },
  {
    label: "Pacific/Nauru (GMT+12:00)",
    tzCode: "Pacific/Nauru",
    name: "(GMT+12:00) Yaren, Baiti, Anabar, Uaboe, Ijuw",
    utc: "+12:00"
  },
  {
    label: "Pacific/Tarawa (GMT+12:00)",
    tzCode: "Pacific/Tarawa",
    name: "(GMT+12:00) Tarawa, Betio Village, Bikenibeu Village",
    utc: "+12:00"
  },
  {
    label: "Pacific/Wake (GMT+12:00)",
    tzCode: "Pacific/Wake",
    name: "(GMT+12:00) Wake",
    utc: "+12:00"
  },
  {
    label: "Pacific/Wallis (GMT+12:00)",
    tzCode: "Pacific/Wallis",
    name: "(GMT+12:00) Mata-Utu, Leava, Alo",
    utc: "+12:00"
  },
  {
    label: "Pacific/Chatham (GMT+12:45)",
    tzCode: "Pacific/Chatham",
    name: "(GMT+12:45) Waitangi",
    utc: "+12:45"
  },
  {
    label: "Pacific/Apia (GMT+13:00)",
    tzCode: "Pacific/Apia",
    name: "(GMT+13:00) Apia, Asau, Mulifanua, Afega, Leulumoega",
    utc: "+13:00"
  },
  {
    label: "Pacific/Enderbury (GMT+13:00)",
    tzCode: "Pacific/Enderbury",
    name: "(GMT+13:00) Enderbury",
    utc: "+13:00"
  },
  {
    label: "Pacific/Fakaofo (GMT+13:00)",
    tzCode: "Pacific/Fakaofo",
    name: "(GMT+13:00) Atafu Village, Nukunonu, Fale old settlement",
    utc: "+13:00"
  },
  {
    label: "Pacific/Tongatapu (GMT+13:00)",
    tzCode: "Pacific/Tongatapu",
    name: "(GMT+13:00) Nuku‘alofa, Lapaha, Neiafu, Pangai, ‘Ohonua",
    utc: "+13:00"
  },
  {
    label: "Pacific/Kiritimati (GMT+14:00)",
    tzCode: "Pacific/Kiritimati",
    name: "(GMT+14:00) Kiritimati",
    utc: "+14:00"
  }
];
var oke = Ue && Ue.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Nee, "__esModule", { value: !0 });
const ske = oke(ike);
var lke = Nee.default = ske.default;
const cke = ({ onChange: e, value: t }) => {
  const r = lke.map((n) => ({
    value: n.tzCode,
    label: n.label
  }));
  return /* @__PURE__ */ E.jsx(
    Kn,
    {
      showSearch: !0,
      value: t,
      onChange: e,
      options: r
    }
  );
};
fn.extend(Ree);
const HXe = ({
  value: e = {
    dateTime: fn().endOf("day"),
    timezone: fn.tz.guess() || "America/Los_Angeles"
  },
  onChange: t,
  ...r
}) => {
  const [n, a] = He(!1), i = Bt(
    (l) => {
      t({ dateTime: l, timezone: e?.timezone });
    },
    [t, e?.timezone]
  ), o = Bt(
    (l) => {
      const c = l && l?.hour(e?.dateTime?.hour() ?? 8)?.minute(e?.dateTime?.minute() ?? 0)?.second(0);
      t({ dateTime: c, timezone: e?.timezone });
    },
    [t, e]
  ), s = Bt(
    (l) => {
      t({ dateTime: e.dateTime, timezone: l });
    },
    [t, e.dateTime]
  );
  return St(() => {
    e.dateTime && e.timezone && r.minDate && e.dateTime.tz(e.timezone).isBefore(r.minDate.tz(e.timezone)) && t({ dateTime: r.minDate, timezone: e.timezone });
  }, [t, r.minDate, e.dateTime, e.timezone]), /* @__PURE__ */ E.jsx(
    Od,
    {
      ...r,
      minDate: r?.minDate?.tz(e?.timezone),
      value: e.dateTime,
      onOk: o,
      showSecond: !1,
      showNow: !1,
      open: n,
      onOpenChange: a,
      format: `YYYY-DD-MM ${e?.dateTime ? `[${e?.dateTime?.format("hh:mm A")}]` : "hh:mm A"} [${e?.timezone ?? ""}]`,
      onChange: o,
      renderExtraFooter: () => /* @__PURE__ */ E.jsxs("div", { className: "flex flex-col my-[16px] w-full", children: [
        /* @__PURE__ */ E.jsx(ake, { onChange: i, value: e?.dateTime }),
        /* @__PURE__ */ E.jsx(Eh, {}),
        /* @__PURE__ */ E.jsxs("div", { className: "flex gap-[12px] w-full", children: [
          /* @__PURE__ */ E.jsx("div", { className: "flex-1 flex flex-wrap w-[230px]", children: /* @__PURE__ */ E.jsx(
            cke,
            {
              value: e?.timezone,
              onChange: s
            }
          ) }),
          /* @__PURE__ */ E.jsx(
            rke,
            {
              type: "text",
              shape: "circle",
              disabled: !e?.dateTime,
              icon: /* @__PURE__ */ E.jsx(
                Mh,
                {
                  className: e?.dateTime ? "fill-[#4B5563]" : "fill-gray-200",
                  svg: {
                    pathing: cM.play,
                    height: 21,
                    width: 20
                  }
                }
              ),
              onClick: () => a(!1)
            }
          )
        ] })
      ] })
    }
  );
};
function uke() {
  this.__data__ = [], this.size = 0;
}
var dke = uke;
function fke(e, t) {
  return e === t || e !== e && t !== t;
}
var wC = fke, pke = wC;
function mke(e, t) {
  for (var r = e.length; r--; )
    if (pke(e[r][0], t))
      return r;
  return -1;
}
var OC = mke, vke = OC, hke = Array.prototype, gke = hke.splice;
function yke(e) {
  var t = this.__data__, r = vke(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : gke.call(t, r, 1), --this.size, !0;
}
var bke = yke, Cke = OC;
function Ske(e) {
  var t = this.__data__, r = Cke(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var xke = Ske, $ke = OC;
function _ke(e) {
  return $ke(this.__data__, e) > -1;
}
var Eke = _ke, wke = OC;
function Oke(e, t) {
  var r = this.__data__, n = wke(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var Tke = Oke, Ike = dke, Mke = bke, Ake = xke, Pke = Eke, Rke = Tke;
function Bd(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Bd.prototype.clear = Ike;
Bd.prototype.delete = Mke;
Bd.prototype.get = Ake;
Bd.prototype.has = Pke;
Bd.prototype.set = Rke;
var TC = Bd, Nke = TC;
function Dke() {
  this.__data__ = new Nke(), this.size = 0;
}
var jke = Dke;
function Lke(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var kke = Lke;
function Fke(e) {
  return this.__data__.get(e);
}
var Bke = Fke;
function zke(e) {
  return this.__data__.has(e);
}
var Hke = zke, Vke = typeof Ue == "object" && Ue && Ue.Object === Object && Ue, Dee = Vke, Gke = Dee, Uke = typeof self == "object" && self && self.Object === Object && self, Wke = Gke || Uke || Function("return this")(), vs = Wke, qke = vs, Kke = qke.Symbol, IC = Kke, yk = IC, jee = Object.prototype, Yke = jee.hasOwnProperty, Zke = jee.toString, y0 = yk ? yk.toStringTag : void 0;
function Xke(e) {
  var t = Yke.call(e, y0), r = e[y0];
  try {
    e[y0] = void 0;
    var n = !0;
  } catch {
  }
  var a = Zke.call(e);
  return n && (t ? e[y0] = r : delete e[y0]), a;
}
var Jke = Xke, Qke = Object.prototype, eFe = Qke.toString;
function tFe(e) {
  return eFe.call(e);
}
var rFe = tFe, bk = IC, nFe = Jke, aFe = rFe, iFe = "[object Null]", oFe = "[object Undefined]", Ck = bk ? bk.toStringTag : void 0;
function sFe(e) {
  return e == null ? e === void 0 ? oFe : iFe : Ck && Ck in Object(e) ? nFe(e) : aFe(e);
}
var qh = sFe;
function lFe(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Yc = lFe, cFe = qh, uFe = Yc, dFe = "[object AsyncFunction]", fFe = "[object Function]", pFe = "[object GeneratorFunction]", mFe = "[object Proxy]";
function vFe(e) {
  if (!uFe(e))
    return !1;
  var t = cFe(e);
  return t == fFe || t == pFe || t == dFe || t == mFe;
}
var Lee = vFe, hFe = vs, gFe = hFe["__core-js_shared__"], yFe = gFe, q_ = yFe, Sk = function() {
  var e = /[^.]+$/.exec(q_ && q_.keys && q_.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function bFe(e) {
  return !!Sk && Sk in e;
}
var CFe = bFe, SFe = Function.prototype, xFe = SFe.toString;
function $Fe(e) {
  if (e != null) {
    try {
      return xFe.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var kee = $Fe, _Fe = Lee, EFe = CFe, wFe = Yc, OFe = kee, TFe = /[\\^$.*+?()[\]{}|]/g, IFe = /^\[object .+?Constructor\]$/, MFe = Function.prototype, AFe = Object.prototype, PFe = MFe.toString, RFe = AFe.hasOwnProperty, NFe = RegExp(
  "^" + PFe.call(RFe).replace(TFe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function DFe(e) {
  if (!wFe(e) || EFe(e))
    return !1;
  var t = _Fe(e) ? NFe : IFe;
  return t.test(OFe(e));
}
var jFe = DFe;
function LFe(e, t) {
  return e?.[t];
}
var kFe = LFe, FFe = jFe, BFe = kFe;
function zFe(e, t) {
  var r = BFe(e, t);
  return FFe(r) ? r : void 0;
}
var Zc = zFe, HFe = Zc, VFe = vs, GFe = HFe(VFe, "Map"), aA = GFe, UFe = Zc, WFe = UFe(Object, "create"), MC = WFe, xk = MC;
function qFe() {
  this.__data__ = xk ? xk(null) : {}, this.size = 0;
}
var KFe = qFe;
function YFe(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var ZFe = YFe, XFe = MC, JFe = "__lodash_hash_undefined__", QFe = Object.prototype, eBe = QFe.hasOwnProperty;
function tBe(e) {
  var t = this.__data__;
  if (XFe) {
    var r = t[e];
    return r === JFe ? void 0 : r;
  }
  return eBe.call(t, e) ? t[e] : void 0;
}
var rBe = tBe, nBe = MC, aBe = Object.prototype, iBe = aBe.hasOwnProperty;
function oBe(e) {
  var t = this.__data__;
  return nBe ? t[e] !== void 0 : iBe.call(t, e);
}
var sBe = oBe, lBe = MC, cBe = "__lodash_hash_undefined__";
function uBe(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = lBe && t === void 0 ? cBe : t, this;
}
var dBe = uBe, fBe = KFe, pBe = ZFe, mBe = rBe, vBe = sBe, hBe = dBe;
function zd(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
zd.prototype.clear = fBe;
zd.prototype.delete = pBe;
zd.prototype.get = mBe;
zd.prototype.has = vBe;
zd.prototype.set = hBe;
var gBe = zd, $k = gBe, yBe = TC, bBe = aA;
function CBe() {
  this.size = 0, this.__data__ = {
    hash: new $k(),
    map: new (bBe || yBe)(),
    string: new $k()
  };
}
var SBe = CBe;
function xBe(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var $Be = xBe, _Be = $Be;
function EBe(e, t) {
  var r = e.__data__;
  return _Be(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var AC = EBe, wBe = AC;
function OBe(e) {
  var t = wBe(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var TBe = OBe, IBe = AC;
function MBe(e) {
  return IBe(this, e).get(e);
}
var ABe = MBe, PBe = AC;
function RBe(e) {
  return PBe(this, e).has(e);
}
var NBe = RBe, DBe = AC;
function jBe(e, t) {
  var r = DBe(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var LBe = jBe, kBe = SBe, FBe = TBe, BBe = ABe, zBe = NBe, HBe = LBe;
function Hd(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Hd.prototype.clear = kBe;
Hd.prototype.delete = FBe;
Hd.prototype.get = BBe;
Hd.prototype.has = zBe;
Hd.prototype.set = HBe;
var Fee = Hd, VBe = TC, GBe = aA, UBe = Fee, WBe = 200;
function qBe(e, t) {
  var r = this.__data__;
  if (r instanceof VBe) {
    var n = r.__data__;
    if (!GBe || n.length < WBe - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new UBe(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var KBe = qBe, YBe = TC, ZBe = jke, XBe = kke, JBe = Bke, QBe = Hke, eze = KBe;
function Vd(e) {
  var t = this.__data__ = new YBe(e);
  this.size = t.size;
}
Vd.prototype.clear = ZBe;
Vd.prototype.delete = XBe;
Vd.prototype.get = JBe;
Vd.prototype.has = QBe;
Vd.prototype.set = eze;
var Bee = Vd;
function tze(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n && t(e[r], r, e) !== !1; )
    ;
  return e;
}
var rze = tze, nze = Zc, aze = function() {
  try {
    var e = nze(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), ize = aze, _k = ize;
function oze(e, t, r) {
  t == "__proto__" && _k ? _k(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var zee = oze, sze = zee, lze = wC, cze = Object.prototype, uze = cze.hasOwnProperty;
function dze(e, t, r) {
  var n = e[t];
  (!(uze.call(e, t) && lze(n, r)) || r === void 0 && !(t in e)) && sze(e, t, r);
}
var Hee = dze, fze = Hee, pze = zee;
function mze(e, t, r, n) {
  var a = !r;
  r || (r = {});
  for (var i = -1, o = t.length; ++i < o; ) {
    var s = t[i], l = n ? n(r[s], e[s], s, r, e) : void 0;
    l === void 0 && (l = e[s]), a ? pze(r, s, l) : fze(r, s, l);
  }
  return r;
}
var PC = mze;
function vze(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var hze = vze;
function gze(e) {
  return e != null && typeof e == "object";
}
var Xc = gze, yze = qh, bze = Xc, Cze = "[object Arguments]";
function Sze(e) {
  return bze(e) && yze(e) == Cze;
}
var xze = Sze, Ek = xze, $ze = Xc, Vee = Object.prototype, _ze = Vee.hasOwnProperty, Eze = Vee.propertyIsEnumerable, wze = Ek(/* @__PURE__ */ function() {
  return arguments;
}()) ? Ek : function(e) {
  return $ze(e) && _ze.call(e, "callee") && !Eze.call(e, "callee");
}, Oze = wze, Tze = Array.isArray, Kh = Tze;
const wk = /* @__PURE__ */ Ut(Kh);
var s1 = { exports: {} };
function Ize() {
  return !1;
}
var Mze = Ize;
s1.exports;
(function(e, t) {
  var r = vs, n = Mze, a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, s = o ? r.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || n;
  e.exports = c;
})(s1, s1.exports);
var iA = s1.exports, Aze = 9007199254740991, Pze = /^(?:0|[1-9]\d*)$/;
function Rze(e, t) {
  var r = typeof e;
  return t = t ?? Aze, !!t && (r == "number" || r != "symbol" && Pze.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Gee = Rze, Nze = 9007199254740991;
function Dze(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Nze;
}
var Uee = Dze, jze = qh, Lze = Uee, kze = Xc, Fze = "[object Arguments]", Bze = "[object Array]", zze = "[object Boolean]", Hze = "[object Date]", Vze = "[object Error]", Gze = "[object Function]", Uze = "[object Map]", Wze = "[object Number]", qze = "[object Object]", Kze = "[object RegExp]", Yze = "[object Set]", Zze = "[object String]", Xze = "[object WeakMap]", Jze = "[object ArrayBuffer]", Qze = "[object DataView]", eHe = "[object Float32Array]", tHe = "[object Float64Array]", rHe = "[object Int8Array]", nHe = "[object Int16Array]", aHe = "[object Int32Array]", iHe = "[object Uint8Array]", oHe = "[object Uint8ClampedArray]", sHe = "[object Uint16Array]", lHe = "[object Uint32Array]", In = {};
In[eHe] = In[tHe] = In[rHe] = In[nHe] = In[aHe] = In[iHe] = In[oHe] = In[sHe] = In[lHe] = !0;
In[Fze] = In[Bze] = In[Jze] = In[zze] = In[Qze] = In[Hze] = In[Vze] = In[Gze] = In[Uze] = In[Wze] = In[qze] = In[Kze] = In[Yze] = In[Zze] = In[Xze] = !1;
function cHe(e) {
  return kze(e) && Lze(e.length) && !!In[jze(e)];
}
var uHe = cHe;
function dHe(e) {
  return function(t) {
    return e(t);
  };
}
var oA = dHe, l1 = { exports: {} };
l1.exports;
(function(e, t) {
  var r = Dee, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, o = i && r.process, s = function() {
    try {
      var l = a && a.require && a.require("util").types;
      return l || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(l1, l1.exports);
var sA = l1.exports, fHe = uHe, pHe = oA, Ok = sA, Tk = Ok && Ok.isTypedArray, mHe = Tk ? pHe(Tk) : fHe, Wee = mHe, vHe = hze, hHe = Oze, gHe = Kh, yHe = iA, bHe = Gee, CHe = Wee, SHe = Object.prototype, xHe = SHe.hasOwnProperty;
function $He(e, t) {
  var r = gHe(e), n = !r && hHe(e), a = !r && !n && yHe(e), i = !r && !n && !a && CHe(e), o = r || n || a || i, s = o ? vHe(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || xHe.call(e, c)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    bHe(c, l))) && s.push(c);
  return s;
}
var qee = $He, _He = Object.prototype;
function EHe(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || _He;
  return e === r;
}
var lA = EHe;
function wHe(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var Kee = wHe, OHe = Kee, THe = OHe(Object.keys, Object), IHe = THe, MHe = lA, AHe = IHe, PHe = Object.prototype, RHe = PHe.hasOwnProperty;
function NHe(e) {
  if (!MHe(e))
    return AHe(e);
  var t = [];
  for (var r in Object(e))
    RHe.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var DHe = NHe, jHe = Lee, LHe = Uee;
function kHe(e) {
  return e != null && LHe(e.length) && !jHe(e);
}
var cA = kHe, FHe = qee, BHe = DHe, zHe = cA;
function HHe(e) {
  return zHe(e) ? FHe(e) : BHe(e);
}
var uA = HHe, VHe = PC, GHe = uA;
function UHe(e, t) {
  return e && VHe(t, GHe(t), e);
}
var WHe = UHe;
function qHe(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var KHe = qHe, YHe = Yc, ZHe = lA, XHe = KHe, JHe = Object.prototype, QHe = JHe.hasOwnProperty;
function eVe(e) {
  if (!YHe(e))
    return XHe(e);
  var t = ZHe(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !QHe.call(e, n)) || r.push(n);
  return r;
}
var tVe = eVe, rVe = qee, nVe = tVe, aVe = cA;
function iVe(e) {
  return aVe(e) ? rVe(e, !0) : nVe(e);
}
var dA = iVe, oVe = PC, sVe = dA;
function lVe(e, t) {
  return e && oVe(t, sVe(t), e);
}
var cVe = lVe, c1 = { exports: {} };
c1.exports;
(function(e, t) {
  var r = vs, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, o = i ? r.Buffer : void 0, s = o ? o.allocUnsafe : void 0;
  function l(c, u) {
    if (u)
      return c.slice();
    var d = c.length, f = s ? s(d) : new c.constructor(d);
    return c.copy(f), f;
  }
  e.exports = l;
})(c1, c1.exports);
var uVe = c1.exports;
function dVe(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var fVe = dVe;
function pVe(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (i[a++] = o);
  }
  return i;
}
var mVe = pVe;
function vVe() {
  return [];
}
var Yee = vVe, hVe = mVe, gVe = Yee, yVe = Object.prototype, bVe = yVe.propertyIsEnumerable, Ik = Object.getOwnPropertySymbols, CVe = Ik ? function(e) {
  return e == null ? [] : (e = Object(e), hVe(Ik(e), function(t) {
    return bVe.call(e, t);
  }));
} : gVe, fA = CVe, SVe = PC, xVe = fA;
function $Ve(e, t) {
  return SVe(e, xVe(e), t);
}
var _Ve = $Ve;
function EVe(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var Zee = EVe, wVe = Kee, OVe = wVe(Object.getPrototypeOf, Object), Xee = OVe, TVe = Zee, IVe = Xee, MVe = fA, AVe = Yee, PVe = Object.getOwnPropertySymbols, RVe = PVe ? function(e) {
  for (var t = []; e; )
    TVe(t, MVe(e)), e = IVe(e);
  return t;
} : AVe, Jee = RVe, NVe = PC, DVe = Jee;
function jVe(e, t) {
  return NVe(e, DVe(e), t);
}
var LVe = jVe, kVe = Zee, FVe = Kh;
function BVe(e, t, r) {
  var n = t(e);
  return FVe(e) ? n : kVe(n, r(e));
}
var Qee = BVe, zVe = Qee, HVe = fA, VVe = uA;
function GVe(e) {
  return zVe(e, VVe, HVe);
}
var ete = GVe, UVe = Qee, WVe = Jee, qVe = dA;
function KVe(e) {
  return UVe(e, qVe, WVe);
}
var YVe = KVe, ZVe = Zc, XVe = vs, JVe = ZVe(XVe, "DataView"), QVe = JVe, eGe = Zc, tGe = vs, rGe = eGe(tGe, "Promise"), nGe = rGe, aGe = Zc, iGe = vs, oGe = aGe(iGe, "Set"), sGe = oGe, lGe = Zc, cGe = vs, uGe = lGe(cGe, "WeakMap"), dGe = uGe, lT = QVe, cT = aA, uT = nGe, dT = sGe, fT = dGe, tte = qh, Gd = kee, Mk = "[object Map]", fGe = "[object Object]", Ak = "[object Promise]", Pk = "[object Set]", Rk = "[object WeakMap]", Nk = "[object DataView]", pGe = Gd(lT), mGe = Gd(cT), vGe = Gd(uT), hGe = Gd(dT), gGe = Gd(fT), sc = tte;
(lT && sc(new lT(new ArrayBuffer(1))) != Nk || cT && sc(new cT()) != Mk || uT && sc(uT.resolve()) != Ak || dT && sc(new dT()) != Pk || fT && sc(new fT()) != Rk) && (sc = function(e) {
  var t = tte(e), r = t == fGe ? e.constructor : void 0, n = r ? Gd(r) : "";
  if (n)
    switch (n) {
      case pGe:
        return Nk;
      case mGe:
        return Mk;
      case vGe:
        return Ak;
      case hGe:
        return Pk;
      case gGe:
        return Rk;
    }
  return t;
});
var RC = sc, yGe = Object.prototype, bGe = yGe.hasOwnProperty;
function CGe(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && bGe.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var SGe = CGe, xGe = vs, $Ge = xGe.Uint8Array, rte = $Ge, Dk = rte;
function _Ge(e) {
  var t = new e.constructor(e.byteLength);
  return new Dk(t).set(new Dk(e)), t;
}
var pA = _Ge, EGe = pA;
function wGe(e, t) {
  var r = t ? EGe(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var OGe = wGe, TGe = /\w*$/;
function IGe(e) {
  var t = new e.constructor(e.source, TGe.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var MGe = IGe, jk = IC, Lk = jk ? jk.prototype : void 0, kk = Lk ? Lk.valueOf : void 0;
function AGe(e) {
  return kk ? Object(kk.call(e)) : {};
}
var PGe = AGe, RGe = pA;
function NGe(e, t) {
  var r = t ? RGe(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var DGe = NGe, jGe = pA, LGe = OGe, kGe = MGe, FGe = PGe, BGe = DGe, zGe = "[object Boolean]", HGe = "[object Date]", VGe = "[object Map]", GGe = "[object Number]", UGe = "[object RegExp]", WGe = "[object Set]", qGe = "[object String]", KGe = "[object Symbol]", YGe = "[object ArrayBuffer]", ZGe = "[object DataView]", XGe = "[object Float32Array]", JGe = "[object Float64Array]", QGe = "[object Int8Array]", eUe = "[object Int16Array]", tUe = "[object Int32Array]", rUe = "[object Uint8Array]", nUe = "[object Uint8ClampedArray]", aUe = "[object Uint16Array]", iUe = "[object Uint32Array]";
function oUe(e, t, r) {
  var n = e.constructor;
  switch (t) {
    case YGe:
      return jGe(e);
    case zGe:
    case HGe:
      return new n(+e);
    case ZGe:
      return LGe(e, r);
    case XGe:
    case JGe:
    case QGe:
    case eUe:
    case tUe:
    case rUe:
    case nUe:
    case aUe:
    case iUe:
      return BGe(e, r);
    case VGe:
      return new n();
    case GGe:
    case qGe:
      return new n(e);
    case UGe:
      return kGe(e);
    case WGe:
      return new n();
    case KGe:
      return FGe(e);
  }
}
var sUe = oUe, lUe = Yc, Fk = Object.create, cUe = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!lUe(t))
      return {};
    if (Fk)
      return Fk(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}(), uUe = cUe, dUe = uUe, fUe = Xee, pUe = lA;
function mUe(e) {
  return typeof e.constructor == "function" && !pUe(e) ? dUe(fUe(e)) : {};
}
var vUe = mUe, hUe = RC, gUe = Xc, yUe = "[object Map]";
function bUe(e) {
  return gUe(e) && hUe(e) == yUe;
}
var CUe = bUe, SUe = CUe, xUe = oA, Bk = sA, zk = Bk && Bk.isMap, $Ue = zk ? xUe(zk) : SUe, _Ue = $Ue, EUe = RC, wUe = Xc, OUe = "[object Set]";
function TUe(e) {
  return wUe(e) && EUe(e) == OUe;
}
var IUe = TUe, MUe = IUe, AUe = oA, Hk = sA, Vk = Hk && Hk.isSet, PUe = Vk ? AUe(Vk) : MUe, RUe = PUe, NUe = Bee, DUe = rze, jUe = Hee, LUe = WHe, kUe = cVe, FUe = uVe, BUe = fVe, zUe = _Ve, HUe = LVe, VUe = ete, GUe = YVe, UUe = RC, WUe = SGe, qUe = sUe, KUe = vUe, YUe = Kh, ZUe = iA, XUe = _Ue, JUe = Yc, QUe = RUe, eWe = uA, tWe = dA, rWe = 1, nWe = 2, aWe = 4, nte = "[object Arguments]", iWe = "[object Array]", oWe = "[object Boolean]", sWe = "[object Date]", lWe = "[object Error]", ate = "[object Function]", cWe = "[object GeneratorFunction]", uWe = "[object Map]", dWe = "[object Number]", ite = "[object Object]", fWe = "[object RegExp]", pWe = "[object Set]", mWe = "[object String]", vWe = "[object Symbol]", hWe = "[object WeakMap]", gWe = "[object ArrayBuffer]", yWe = "[object DataView]", bWe = "[object Float32Array]", CWe = "[object Float64Array]", SWe = "[object Int8Array]", xWe = "[object Int16Array]", $We = "[object Int32Array]", _We = "[object Uint8Array]", EWe = "[object Uint8ClampedArray]", wWe = "[object Uint16Array]", OWe = "[object Uint32Array]", wn = {};
wn[nte] = wn[iWe] = wn[gWe] = wn[yWe] = wn[oWe] = wn[sWe] = wn[bWe] = wn[CWe] = wn[SWe] = wn[xWe] = wn[$We] = wn[uWe] = wn[dWe] = wn[ite] = wn[fWe] = wn[pWe] = wn[mWe] = wn[vWe] = wn[_We] = wn[EWe] = wn[wWe] = wn[OWe] = !0;
wn[lWe] = wn[ate] = wn[hWe] = !1;
function Cb(e, t, r, n, a, i) {
  var o, s = t & rWe, l = t & nWe, c = t & aWe;
  if (r && (o = a ? r(e, n, a, i) : r(e)), o !== void 0)
    return o;
  if (!JUe(e))
    return e;
  var u = YUe(e);
  if (u) {
    if (o = WUe(e), !s)
      return BUe(e, o);
  } else {
    var d = UUe(e), f = d == ate || d == cWe;
    if (ZUe(e))
      return FUe(e, s);
    if (d == ite || d == nte || f && !a) {
      if (o = l || f ? {} : KUe(e), !s)
        return l ? HUe(e, kUe(o, e)) : zUe(e, LUe(o, e));
    } else {
      if (!wn[d])
        return a ? e : {};
      o = qUe(e, d, s);
    }
  }
  i || (i = new NUe());
  var m = i.get(e);
  if (m)
    return m;
  i.set(e, o), QUe(e) ? e.forEach(function(y) {
    o.add(Cb(y, t, r, y, e, i));
  }) : XUe(e) && e.forEach(function(y, S) {
    o.set(S, Cb(y, t, r, S, e, i));
  });
  var h = c ? l ? GUe : VUe : l ? tWe : eWe, g = u ? void 0 : h(e);
  return DUe(g || e, function(y, S) {
    g && (S = y, y = e[S]), jUe(o, S, Cb(y, t, r, S, e, i));
  }), o;
}
var TWe = Cb, IWe = TWe, MWe = 1, AWe = 4;
function PWe(e) {
  return IWe(e, MWe | AWe);
}
var RWe = PWe;
const mA = /* @__PURE__ */ Ut(RWe);
var Zy, NWe = new Uint8Array(16);
function DWe() {
  if (!Zy && (Zy = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !Zy))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Zy(NWe);
}
const jWe = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function LWe(e) {
  return typeof e == "string" && jWe.test(e);
}
var La = [];
for (var K_ = 0; K_ < 256; ++K_)
  La.push((K_ + 256).toString(16).substr(1));
function kWe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (La[e[t + 0]] + La[e[t + 1]] + La[e[t + 2]] + La[e[t + 3]] + "-" + La[e[t + 4]] + La[e[t + 5]] + "-" + La[e[t + 6]] + La[e[t + 7]] + "-" + La[e[t + 8]] + La[e[t + 9]] + "-" + La[e[t + 10]] + La[e[t + 11]] + La[e[t + 12]] + La[e[t + 13]] + La[e[t + 14]] + La[e[t + 15]]).toLowerCase();
  if (!LWe(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
function Gk(e, t, r) {
  e = e || {};
  var n = e.random || (e.rng || DWe)();
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, kWe(n);
}
const FWe = ({ cartService: e }) => {
  const [t, r] = He(!0), [n, a] = He(), i = Bt((l) => {
    r(!0);
    const c = { ...l };
    return e.createCart(c).then((u) => u).catch((u) => {
      throw u;
    }).finally(() => {
      r(!1);
    });
  }, [e]), o = Bt(() => (r(!0), e.getCartByUser().then((l) => l).catch(() => null).finally(() => {
    r(!1);
  })), [e]), s = Bt(() => e.getTax().then((l) => (a(l), l)).catch(() => (a(null), null)), [e]);
  return {
    loading: t,
    setLoading: r,
    getCart: o,
    createCart: i,
    tax: n,
    getTax: s
  };
}, BWe = ({ shippingService: e }) => {
  const [t, r] = He(""), [n, a] = He(!1), [i, o] = He(null), s = Bt((c, u) => (a(!0), r(""), e.estimateShipping(c, u).then((d) => (d && d.sort((f, m) => f.carrierCode.localeCompare(m.carrierCode) || f.totalCharges - m.totalCharges), o(d), d)).catch((d) => (d.response.status === 422 && r(d.response.data.message), o([]))).finally(() => {
    a(!1);
  })), [e]);
  return {
    loading: n,
    availableShippingMethods: i,
    resetAvailableShippingMethods: () => {
      o(null);
    },
    estimateShipping: s,
    addressError: t
  };
}, zWe = ({ productService: e }) => {
  const [t, r] = He(!0), [n, a] = He([]);
  St(() => {
    r(!0), e.getProducts({ limit: 100 }).then((o) => (a(o), o)).catch((o) => {
      throw console.error("Error retrieving products:", o), o;
    }).finally(() => {
      r(!1);
    });
  }, [e]);
  const i = Bt((o) => (r(!0), e.getPromoProducts(o).then((s) => s).catch((s) => {
    throw s;
  }).finally(() => {
    r(!1);
  })), [e]);
  return {
    loading: t,
    products: n,
    getPromoProducts: i
  };
}, HWe = (e, t, r, n) => {
  const a = ni.get("checkout_application_id"), i = `${e}-${a}`, o = Bt((d, f) => {
    const m = new Event(`localstorage:${i}:updated`);
    m.data = { value: d, newItem: f }, window.dispatchEvent(m);
  }, [i]), s = Bt((d) => {
    const f = localStorage.getItem(i);
    if (!f) return null;
    if (r) {
      const m = JSON.parse(f);
      return d ? m[d] : m[r];
    }
    return d ? JSON.parse(f) : null;
  }, [i, r]), l = Bt((d) => {
    if (!r) return localStorage.removeItem(i);
    const f = localStorage.getItem(i);
    if (!f) return;
    const m = JSON.parse(f);
    return delete m[d || r], localStorage.setItem(i, JSON.stringify(m));
  }, [i, r]), [c, u] = He(() => {
    const d = s();
    return d || t;
  });
  return St(() => {
    const d = (f) => {
      u(() => {
        const m = f?.data ? f.data : { value: t }, { value: h } = m, g = r ? { [r]: h } : h, y = localStorage.getItem(i), x = { ...y ? JSON.parse(y) : {}, ...g };
        return localStorage.setItem(i, JSON.stringify(x)), m?.newItem && n && n(f), h;
      });
    };
    return window.addEventListener(`localstorage:${i}:updated`, d), () => {
      window.removeEventListener(`localstorage:${i}:updated`, d);
    };
  }, [i, r]), [c, o, s, l];
}, VWe = (e = "xs") => {
  const t = [
    { name: "xs", maxWidth: 576 },
    { name: "sm", maxWidth: 768 },
    { name: "md", maxWidth: 992 },
    { name: "lg", maxWidth: 1200 },
    { name: "xl", maxWidth: 1 / 0 }
  ], [r, n] = He({
    isMobileView: !1,
    breakpoint: "xs"
  }), a = {
    getByWidth: (i) => t.find((o) => i < o.maxWidth).name,
    getWidth: (i) => t.find((o) => o.name === i).maxWidth
  };
  return St(() => {
    if (typeof window > "u") return;
    const i = () => {
      const o = window.innerWidth;
      n({
        isMobileView: o < a.getWidth(e),
        breakpoint: a.getByWidth(o)
      });
    };
    return i(), window.addEventListener("resize", i), () => {
      window.removeEventListener("resize", i);
    };
  }, []), r;
}, GWe = ({ addressService: e }) => {
  const [t, r] = He(!0), [n, a] = He(!1), [i, o] = He(), s = Bt(() => (r(!0), e.getAddresses().then((u) => (o(u), u)).catch((u) => {
    throw o(null), u;
  }).finally(() => {
    r(!1);
  })), [e]), l = Bt((u, d) => {
    a(!0), e.updateAddress(u, d).then((f) => (s(), f)).catch((f) => {
      throw console.error("Error updating address:", f), f;
    }).finally(() => {
      a(!1);
    });
  }, [e, s]);
  return {
    addressLoading: t,
    isUpdatingAddress: n,
    addresses: i,
    getAddresses: s,
    updateAddress: l,
    addAddress: (u) => (a(!0), e.addAddress(u).then((d) => (s(), d)).catch((d) => {
      throw console.error("Error adding address:", d), d;
    }).finally(() => {
      a(!1);
    }))
  };
}, UWe = (e) => {
  const [t, r] = He(!1), [n, a] = He(!1), [i, o] = He(), [s, l] = He();
  St(() => {
    r(!0), e.getCountries().then((u) => (o(u), u)).catch((u) => {
      console.error("Error retrieving countries:", u);
    }).finally(() => {
      r(!1);
    });
  }, [e]);
  const c = Bt((u) => (a(!0), e.getStates(u).then((d) => (l(d), d)).catch((d) => {
    console.error("Error retrieving states:", d);
  }).finally(() => {
    a(!1);
  })), [e]);
  return {
    countryLoading: t,
    statesLoading: n,
    countries: i,
    getStates: c,
    states: s
  };
}, WWe = ({ paymentService: e }) => {
  const [t, r] = He(!1), [n, a] = He(!1), [i, o] = He(), [s, l] = He(null), [c, u] = He(), d = (g) => (r(!0), e.paymentByCC().then((y) => (l(y), y)).catch((y) => {
    throw y;
  }).finally(() => {
    r(!1);
  })), f = async (g, y, S) => {
    if (!y || !S)
      throw new Error("Stripe and Elements must be initialized");
    let x = "", b;
    return r(!0), e.paymentByCC().then((_) => {
      if (!_) throw new Error("Error creating invoice");
      return x = _?.paymentIntent?.client_secret || "", b = _, S.submit();
    }).then(({ error: _ }) => {
      if (_) throw _;
      return y.confirmPayment({
        elements: S,
        clientSecret: x,
        redirect: "if_required",
        confirmParams: {
          // eslint-disable-next-line camelcase
          payment_method_data: {
            // eslint-disable-next-line camelcase
            billing_details: {
              name: b.customerName,
              email: b.customersEmail,
              address: {
                city: b?.customerAddress?.city || "",
                line1: b?.customerAddress?.line1 || "",
                line2: b?.customerAddress?.line2 || "",
                country: b?.customerAddress?.country || "",
                // eslint-disable-next-line camelcase
                postal_code: b?.customerAddress?.postal_code || "",
                state: b?.customerAddress?.state || ""
              },
              phone: b?.customersPhone || ""
            }
          }
        }
      });
    }).then(({ error: _ }) => {
      if (_) throw _;
      return h(b?.id);
    }).then((_) => (l(_), _)).catch((_) => {
      throw _;
    }).finally(() => {
      r(!1);
    });
  }, m = (g, y) => (r(!0), e.paymentByPO(g, y).then((S) => (l(S), S)).catch((S) => {
    throw S;
  }).finally(() => {
    r(!1);
  })), h = Bt(
    (g) => (a(!0), e.getInvoiceById(g).then((y) => (u(y), o(!1), y)).catch((y) => {
      throw y;
    }).finally(() => {
      a(!1);
    })),
    [e]
  );
  return St(() => {
    if (!c || i)
      return;
    const g = setInterval(() => {
      e.getOrderById(c.metadata.zen_cart_order_id).then((y) => o(y.status !== "Processing")).catch(() => {
        o(!0), zU.error({ content: "There was an issue loading you order, please refresh the page or contact the support team: support@tablegroup.com", duration: 1e4 });
      });
    }, 3e3);
    return () => clearInterval(g);
  }, [c, e, i]), {
    invoicePaymentByCC: d,
    invoicePaymentSignedByCC: f,
    invoicePaymentByPO: m,
    getInvoiceById: h,
    isPaying: t,
    isLoadingInvoice: n,
    paymentInvoice: s,
    currentInvoice: c,
    setCurrentInvoice: u,
    setIsLoadingInvoice: a,
    isOrderProcessed: i
  };
}, qWe = ({ couponService: e }) => {
  const [t, r] = He(!0), [n, a] = He();
  return {
    getCouponById: Bt((o) => (r(!0), e.getCouponById(o).then((s) => (a(s), s)).catch((s) => {
      throw s;
    }).finally(() => {
      r(!1);
    })), [e]),
    coupon: n,
    isLoadingCoupon: t
  };
}, ote = (e, t) => {
  const [r, n] = He(!0), [a, i] = He(), [o, s] = He(!1), [l, c] = He(), u = Bt(($, w) => (s(!0), t.getUserExists($, w).then((O) => (c(O), O)).catch((O) => {
    throw O;
  }).finally(() => {
    s(!1);
  })), [t]), d = Bt(() => (n(!0), t.getUser().then(($) => (i($), $)).catch(($) => {
    throw $;
  }).finally(() => {
    n(!1);
  })), [t]), f = Bt(() => {
    const $ = ni.get("TTG_USER");
    return $ && $ !== "undefined" ? (n(!0), t.getUser().then((O) => (i(O), O)).catch((O) => {
      throw i(null), O;
    }).finally(() => {
      n(!1);
    })) : (n(!1), i(null), Promise.resolve(null));
  }, [t]), m = Bt(($) => (n(!0), t.sendRegisterInvitation($).catch((w) => {
    throw w;
  })), [t]), h = Bt(($) => (n(!0), t.createUser($).then((w) => (i(w?.user), w)).catch((w) => {
    throw w;
  }).finally(() => {
    n(!1);
  })), [t]), g = Bt(($) => (n(!0), t.login($).then((w) => (i(w?.user), w)).catch((w) => {
    throw w;
  }).finally(() => {
    n(!1);
  })), [t]), y = Bt(($, w, O) => (n(!0), t.oauthLogin($, w, O).then((T) => (T?.user && i(T.user), T)).catch((T) => {
    throw T;
  }).finally(() => {
    n(!1);
  })), [t]), S = Bt(($) => (n(!0), t.resetPassword($).then((w) => (i(w?.user), w)).catch((w) => {
    throw w;
  }).finally(() => {
    n(!1);
  })), [t]), x = Bt(($) => (n(!0), t.verifyResetLink($).then((w) => w).catch((w) => {
    throw w;
  }).finally(() => {
    n(!1);
  })), [t]), b = Bt(($) => (n(!0), t.forgotPassword($).then((w) => w).catch((w) => {
    throw w;
  }).finally(() => {
    n(!1);
  })), [t]), _ = Bt(() => (n(!0), t.logout().then(() => {
    i(null);
  }).catch(($) => {
    throw $;
  }).finally(() => {
    n(!1);
  })), [t]);
  return St(() => {
    if (!e)
      return n(!1);
    n(!0), d();
  }, [e, d]), {
    loading: r,
    user: a,
    getUserByEmail: u,
    getCustomer: f,
    createUser: h,
    loginUser: g,
    oauthLoginUser: y,
    logoutUser: _,
    forgotPassword: b,
    resetPassword: S,
    verifyResetPassword: x,
    userExists: l,
    isUserExistsLoading: o,
    sendRegisterInvitation: m,
    setUser: i
  };
}, KWe = ({ feedbackService: e }) => {
  const [t, r] = He(!1), [n, a] = He(!1);
  return {
    isLoadingFeedback: t,
    isSubmittedFeedback: n,
    addFeedback: (o) => (r(!0), e.addFeedback(o).then((s) => s).catch((s) => {
      throw s;
    }).finally(() => {
      r(!1), a(!0);
    }))
  };
};
var u1 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
u1.exports;
(function(e, t) {
  (function() {
    var r, n = "4.17.21", a = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", o = "Expected a function", s = "Invalid `variable` option passed into `_.template`", l = "__lodash_hash_undefined__", c = 500, u = "__lodash_placeholder__", d = 1, f = 2, m = 4, h = 1, g = 2, y = 1, S = 2, x = 4, b = 8, _ = 16, $ = 32, w = 64, O = 128, T = 256, I = 512, P = 30, D = "...", B = 800, L = 16, N = 1, z = 2, F = 3, j = 1 / 0, H = 9007199254740991, U = 17976931348623157e292, G = NaN, V = 4294967295, K = V - 1, Z = V >>> 1, ee = [
      ["ary", O],
      ["bind", y],
      ["bindKey", S],
      ["curry", b],
      ["curryRight", _],
      ["flip", I],
      ["partial", $],
      ["partialRight", w],
      ["rearg", T]
    ], ae = "[object Arguments]", ue = "[object Array]", re = "[object AsyncFunction]", oe = "[object Boolean]", fe = "[object Date]", le = "[object DOMException]", se = "[object Error]", Q = "[object Function]", he = "[object GeneratorFunction]", ne = "[object Map]", me = "[object Number]", k = "[object Null]", M = "[object Object]", R = "[object Promise]", q = "[object Proxy]", Y = "[object RegExp]", X = "[object Set]", pe = "[object String]", $e = "[object Symbol]", J = "[object Undefined]", de = "[object WeakMap]", Se = "[object WeakSet]", Ee = "[object ArrayBuffer]", Te = "[object DataView]", Le = "[object Float32Array]", Ie = "[object Float64Array]", De = "[object Int8Array]", Ae = "[object Int16Array]", Fe = "[object Int32Array]", Ne = "[object Uint8Array]", qe = "[object Uint8ClampedArray]", Qe = "[object Uint16Array]", tt = "[object Uint32Array]", Ge = /\b__p \+= '';/g, it = /\b(__p \+=) '' \+/g, ht = /(__e\(.*?\)|\b__t\)) \+\n'';/g, It = /&(?:amp|lt|gt|quot|#39);/g, xt = /[&<>"']/g, Xe = RegExp(It.source), pt = RegExp(xt.source), Ze = /<%-([\s\S]+?)%>/g, wt = /<%([\s\S]+?)%>/g, bt = /<%=([\s\S]+?)%>/g, Je = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, _t = /^\w*$/, Vt = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ot = /[\\^$.*+?()[\]{}|]/g, Ct = RegExp(ot.source), rt = /^\s+/, $t = /\s/, Wt = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, _e = /\{\n\/\* \[wrapped with (.+)\] \*/, Ke = /,? & /, nt = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Ve = /[()=,{}\[\]\/\s]/, ke = /\\(\\)?/g, ut = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, st = /\w*$/, Et = /^[-+]0x[0-9a-f]+$/i, zt = /^0b[01]+$/i, Be = /^\[object .+?Constructor\]$/, ft = /^0o[0-7]+$/i, yt = /^(?:0|[1-9]\d*)$/, Rt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Ht = /($^)/, ir = /['\n\r\u2028\u2029\\]/g, ar = "\\ud800-\\udfff", Nr = "\\u0300-\\u036f", Xr = "\\ufe20-\\ufe2f", Qr = "\\u20d0-\\u20ff", Ur = Nr + Xr + Qr, gn = "\\u2700-\\u27bf", Zt = "a-z\\xdf-\\xf6\\xf8-\\xff", er = "\\xac\\xb1\\xd7\\xf7", _r = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Sn = "\\u2000-\\u206f", On = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Un = "A-Z\\xc0-\\xd6\\xd8-\\xde", oa = "\\ufe0e\\ufe0f", va = er + _r + Sn + On, Fn = "['’]", or = "[" + ar + "]", tr = "[" + va + "]", Jr = "[" + Ur + "]", tn = "\\d+", zr = "[" + gn + "]", cr = "[" + Zt + "]", Ot = "[^" + ar + va + tn + gn + Zt + Un + "]", Tt = "\\ud83c[\\udffb-\\udfff]", Sr = "(?:" + Jr + "|" + Tt + ")", Mr = "[^" + ar + "]", en = "(?:\\ud83c[\\udde6-\\uddff]){2}", Rn = "[\\ud800-\\udbff][\\udc00-\\udfff]", sr = "[" + Un + "]", qt = "\\u200d", gr = "(?:" + cr + "|" + Ot + ")", Ft = "(?:" + sr + "|" + Ot + ")", rr = "(?:" + Fn + "(?:d|ll|m|re|s|t|ve))?", pn = "(?:" + Fn + "(?:D|LL|M|RE|S|T|VE))?", Wn = Sr + "?", $n = "[" + oa + "]?", di = "(?:" + qt + "(?:" + [Mr, en, Rn].join("|") + ")" + $n + Wn + ")*", fi = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Oi = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Wi = $n + Wn + di, hs = "(?:" + [zr, en, Rn].join("|") + ")" + Wi, Kd = "(?:" + [Mr + Jr + "?", Jr, en, Rn, or].join("|") + ")", Jt = RegExp(Fn, "g"), yr = RegExp(Jr, "g"), _n = RegExp(Tt + "(?=" + Tt + ")|" + Kd + Wi, "g"), Jn = RegExp([
      sr + "?" + cr + "+" + rr + "(?=" + [tr, sr, "$"].join("|") + ")",
      Ft + "+" + pn + "(?=" + [tr, sr + gr, "$"].join("|") + ")",
      sr + "?" + gr + "+" + rr,
      sr + "+" + pn,
      Oi,
      fi,
      tn,
      hs
    ].join("|"), "g"), Nn = RegExp("[" + qt + ar + Ur + oa + "]"), eu = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Yd = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Qh = -1, nn = {};
    nn[Le] = nn[Ie] = nn[De] = nn[Ae] = nn[Fe] = nn[Ne] = nn[qe] = nn[Qe] = nn[tt] = !0, nn[ae] = nn[ue] = nn[Ee] = nn[oe] = nn[Te] = nn[fe] = nn[se] = nn[Q] = nn[ne] = nn[me] = nn[M] = nn[Y] = nn[X] = nn[pe] = nn[de] = !1;
    var En = {};
    En[ae] = En[ue] = En[Ee] = En[Te] = En[oe] = En[fe] = En[Le] = En[Ie] = En[De] = En[Ae] = En[Fe] = En[ne] = En[me] = En[M] = En[Y] = En[X] = En[pe] = En[$e] = En[Ne] = En[qe] = En[Qe] = En[tt] = !0, En[se] = En[Q] = En[de] = !1;
    var Fte = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Bte = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, zte = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Hte = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Vte = parseFloat, Gte = parseInt, gA = typeof Ue == "object" && Ue && Ue.Object === Object && Ue, Ute = typeof self == "object" && self && self.Object === Object && self, Pa = gA || Ute || Function("return this")(), FC = t && !t.nodeType && t, Rl = FC && !0 && e && !e.nodeType && e, yA = Rl && Rl.exports === FC, BC = yA && gA.process, qi = function() {
      try {
        var Re = Rl && Rl.require && Rl.require("util").types;
        return Re || BC && BC.binding && BC.binding("util");
      } catch {
      }
    }(), bA = qi && qi.isArrayBuffer, CA = qi && qi.isDate, SA = qi && qi.isMap, xA = qi && qi.isRegExp, $A = qi && qi.isSet, _A = qi && qi.isTypedArray;
    function Ti(Re, et, We) {
      switch (We.length) {
        case 0:
          return Re.call(et);
        case 1:
          return Re.call(et, We[0]);
        case 2:
          return Re.call(et, We[0], We[1]);
        case 3:
          return Re.call(et, We[0], We[1], We[2]);
      }
      return Re.apply(et, We);
    }
    function Wte(Re, et, We, Xt) {
      for (var wr = -1, rn = Re == null ? 0 : Re.length; ++wr < rn; ) {
        var ha = Re[wr];
        et(Xt, ha, We(ha), Re);
      }
      return Xt;
    }
    function Ki(Re, et) {
      for (var We = -1, Xt = Re == null ? 0 : Re.length; ++We < Xt && et(Re[We], We, Re) !== !1; )
        ;
      return Re;
    }
    function qte(Re, et) {
      for (var We = Re == null ? 0 : Re.length; We-- && et(Re[We], We, Re) !== !1; )
        ;
      return Re;
    }
    function EA(Re, et) {
      for (var We = -1, Xt = Re == null ? 0 : Re.length; ++We < Xt; )
        if (!et(Re[We], We, Re))
          return !1;
      return !0;
    }
    function Js(Re, et) {
      for (var We = -1, Xt = Re == null ? 0 : Re.length, wr = 0, rn = []; ++We < Xt; ) {
        var ha = Re[We];
        et(ha, We, Re) && (rn[wr++] = ha);
      }
      return rn;
    }
    function eg(Re, et) {
      var We = Re == null ? 0 : Re.length;
      return !!We && tu(Re, et, 0) > -1;
    }
    function zC(Re, et, We) {
      for (var Xt = -1, wr = Re == null ? 0 : Re.length; ++Xt < wr; )
        if (We(et, Re[Xt]))
          return !0;
      return !1;
    }
    function Dn(Re, et) {
      for (var We = -1, Xt = Re == null ? 0 : Re.length, wr = Array(Xt); ++We < Xt; )
        wr[We] = et(Re[We], We, Re);
      return wr;
    }
    function Qs(Re, et) {
      for (var We = -1, Xt = et.length, wr = Re.length; ++We < Xt; )
        Re[wr + We] = et[We];
      return Re;
    }
    function HC(Re, et, We, Xt) {
      var wr = -1, rn = Re == null ? 0 : Re.length;
      for (Xt && rn && (We = Re[++wr]); ++wr < rn; )
        We = et(We, Re[wr], wr, Re);
      return We;
    }
    function Kte(Re, et, We, Xt) {
      var wr = Re == null ? 0 : Re.length;
      for (Xt && wr && (We = Re[--wr]); wr--; )
        We = et(We, Re[wr], wr, Re);
      return We;
    }
    function VC(Re, et) {
      for (var We = -1, Xt = Re == null ? 0 : Re.length; ++We < Xt; )
        if (et(Re[We], We, Re))
          return !0;
      return !1;
    }
    var Yte = GC("length");
    function Zte(Re) {
      return Re.split("");
    }
    function Xte(Re) {
      return Re.match(nt) || [];
    }
    function wA(Re, et, We) {
      var Xt;
      return We(Re, function(wr, rn, ha) {
        if (et(wr, rn, ha))
          return Xt = rn, !1;
      }), Xt;
    }
    function tg(Re, et, We, Xt) {
      for (var wr = Re.length, rn = We + (Xt ? 1 : -1); Xt ? rn-- : ++rn < wr; )
        if (et(Re[rn], rn, Re))
          return rn;
      return -1;
    }
    function tu(Re, et, We) {
      return et === et ? cre(Re, et, We) : tg(Re, OA, We);
    }
    function Jte(Re, et, We, Xt) {
      for (var wr = We - 1, rn = Re.length; ++wr < rn; )
        if (Xt(Re[wr], et))
          return wr;
      return -1;
    }
    function OA(Re) {
      return Re !== Re;
    }
    function TA(Re, et) {
      var We = Re == null ? 0 : Re.length;
      return We ? WC(Re, et) / We : G;
    }
    function GC(Re) {
      return function(et) {
        return et == null ? r : et[Re];
      };
    }
    function UC(Re) {
      return function(et) {
        return Re == null ? r : Re[et];
      };
    }
    function IA(Re, et, We, Xt, wr) {
      return wr(Re, function(rn, ha, xn) {
        We = Xt ? (Xt = !1, rn) : et(We, rn, ha, xn);
      }), We;
    }
    function Qte(Re, et) {
      var We = Re.length;
      for (Re.sort(et); We--; )
        Re[We] = Re[We].value;
      return Re;
    }
    function WC(Re, et) {
      for (var We, Xt = -1, wr = Re.length; ++Xt < wr; ) {
        var rn = et(Re[Xt]);
        rn !== r && (We = We === r ? rn : We + rn);
      }
      return We;
    }
    function qC(Re, et) {
      for (var We = -1, Xt = Array(Re); ++We < Re; )
        Xt[We] = et(We);
      return Xt;
    }
    function ere(Re, et) {
      return Dn(et, function(We) {
        return [We, Re[We]];
      });
    }
    function MA(Re) {
      return Re && Re.slice(0, NA(Re) + 1).replace(rt, "");
    }
    function Ii(Re) {
      return function(et) {
        return Re(et);
      };
    }
    function KC(Re, et) {
      return Dn(et, function(We) {
        return Re[We];
      });
    }
    function Zd(Re, et) {
      return Re.has(et);
    }
    function AA(Re, et) {
      for (var We = -1, Xt = Re.length; ++We < Xt && tu(et, Re[We], 0) > -1; )
        ;
      return We;
    }
    function PA(Re, et) {
      for (var We = Re.length; We-- && tu(et, Re[We], 0) > -1; )
        ;
      return We;
    }
    function tre(Re, et) {
      for (var We = Re.length, Xt = 0; We--; )
        Re[We] === et && ++Xt;
      return Xt;
    }
    var rre = UC(Fte), nre = UC(Bte);
    function are(Re) {
      return "\\" + Hte[Re];
    }
    function ire(Re, et) {
      return Re == null ? r : Re[et];
    }
    function ru(Re) {
      return Nn.test(Re);
    }
    function ore(Re) {
      return eu.test(Re);
    }
    function sre(Re) {
      for (var et, We = []; !(et = Re.next()).done; )
        We.push(et.value);
      return We;
    }
    function YC(Re) {
      var et = -1, We = Array(Re.size);
      return Re.forEach(function(Xt, wr) {
        We[++et] = [wr, Xt];
      }), We;
    }
    function RA(Re, et) {
      return function(We) {
        return Re(et(We));
      };
    }
    function el(Re, et) {
      for (var We = -1, Xt = Re.length, wr = 0, rn = []; ++We < Xt; ) {
        var ha = Re[We];
        (ha === et || ha === u) && (Re[We] = u, rn[wr++] = We);
      }
      return rn;
    }
    function rg(Re) {
      var et = -1, We = Array(Re.size);
      return Re.forEach(function(Xt) {
        We[++et] = Xt;
      }), We;
    }
    function lre(Re) {
      var et = -1, We = Array(Re.size);
      return Re.forEach(function(Xt) {
        We[++et] = [Xt, Xt];
      }), We;
    }
    function cre(Re, et, We) {
      for (var Xt = We - 1, wr = Re.length; ++Xt < wr; )
        if (Re[Xt] === et)
          return Xt;
      return -1;
    }
    function ure(Re, et, We) {
      for (var Xt = We + 1; Xt--; )
        if (Re[Xt] === et)
          return Xt;
      return Xt;
    }
    function nu(Re) {
      return ru(Re) ? fre(Re) : Yte(Re);
    }
    function mo(Re) {
      return ru(Re) ? pre(Re) : Zte(Re);
    }
    function NA(Re) {
      for (var et = Re.length; et-- && $t.test(Re.charAt(et)); )
        ;
      return et;
    }
    var dre = UC(zte);
    function fre(Re) {
      for (var et = _n.lastIndex = 0; _n.test(Re); )
        ++et;
      return et;
    }
    function pre(Re) {
      return Re.match(_n) || [];
    }
    function mre(Re) {
      return Re.match(Jn) || [];
    }
    var vre = function Re(et) {
      et = et == null ? Pa : au.defaults(Pa.Object(), et, au.pick(Pa, Yd));
      var We = et.Array, Xt = et.Date, wr = et.Error, rn = et.Function, ha = et.Math, xn = et.Object, ZC = et.RegExp, hre = et.String, Yi = et.TypeError, ng = We.prototype, gre = rn.prototype, iu = xn.prototype, ag = et["__core-js_shared__"], ig = gre.toString, mn = iu.hasOwnProperty, yre = 0, DA = function() {
        var v = /[^.]+$/.exec(ag && ag.keys && ag.keys.IE_PROTO || "");
        return v ? "Symbol(src)_1." + v : "";
      }(), og = iu.toString, bre = ig.call(xn), Cre = Pa._, Sre = ZC(
        "^" + ig.call(mn).replace(ot, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), sg = yA ? et.Buffer : r, tl = et.Symbol, lg = et.Uint8Array, jA = sg ? sg.allocUnsafe : r, cg = RA(xn.getPrototypeOf, xn), LA = xn.create, kA = iu.propertyIsEnumerable, ug = ng.splice, FA = tl ? tl.isConcatSpreadable : r, Xd = tl ? tl.iterator : r, Nl = tl ? tl.toStringTag : r, dg = function() {
        try {
          var v = Fl(xn, "defineProperty");
          return v({}, "", {}), v;
        } catch {
        }
      }(), xre = et.clearTimeout !== Pa.clearTimeout && et.clearTimeout, $re = Xt && Xt.now !== Pa.Date.now && Xt.now, _re = et.setTimeout !== Pa.setTimeout && et.setTimeout, fg = ha.ceil, pg = ha.floor, XC = xn.getOwnPropertySymbols, Ere = sg ? sg.isBuffer : r, BA = et.isFinite, wre = ng.join, Ore = RA(xn.keys, xn), ga = ha.max, za = ha.min, Tre = Xt.now, Ire = et.parseInt, zA = ha.random, Mre = ng.reverse, JC = Fl(et, "DataView"), Jd = Fl(et, "Map"), QC = Fl(et, "Promise"), ou = Fl(et, "Set"), Qd = Fl(et, "WeakMap"), ef = Fl(xn, "create"), mg = Qd && new Qd(), su = {}, Are = Bl(JC), Pre = Bl(Jd), Rre = Bl(QC), Nre = Bl(ou), Dre = Bl(Qd), vg = tl ? tl.prototype : r, tf = vg ? vg.valueOf : r, HA = vg ? vg.toString : r;
      function ge(v) {
        if (qn(v) && !Or(v) && !(v instanceof Hr)) {
          if (v instanceof Zi)
            return v;
          if (mn.call(v, "__wrapped__"))
            return VP(v);
        }
        return new Zi(v);
      }
      var lu = /* @__PURE__ */ function() {
        function v() {
        }
        return function(C) {
          if (!Bn(C))
            return {};
          if (LA)
            return LA(C);
          v.prototype = C;
          var A = new v();
          return v.prototype = r, A;
        };
      }();
      function hg() {
      }
      function Zi(v, C) {
        this.__wrapped__ = v, this.__actions__ = [], this.__chain__ = !!C, this.__index__ = 0, this.__values__ = r;
      }
      ge.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Ze,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: wt,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: bt,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: ge
        }
      }, ge.prototype = hg.prototype, ge.prototype.constructor = ge, Zi.prototype = lu(hg.prototype), Zi.prototype.constructor = Zi;
      function Hr(v) {
        this.__wrapped__ = v, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = V, this.__views__ = [];
      }
      function jre() {
        var v = new Hr(this.__wrapped__);
        return v.__actions__ = pi(this.__actions__), v.__dir__ = this.__dir__, v.__filtered__ = this.__filtered__, v.__iteratees__ = pi(this.__iteratees__), v.__takeCount__ = this.__takeCount__, v.__views__ = pi(this.__views__), v;
      }
      function Lre() {
        if (this.__filtered__) {
          var v = new Hr(this);
          v.__dir__ = -1, v.__filtered__ = !0;
        } else
          v = this.clone(), v.__dir__ *= -1;
        return v;
      }
      function kre() {
        var v = this.__wrapped__.value(), C = this.__dir__, A = Or(v), W = C < 0, ie = A ? v.length : 0, Ce = Zne(0, ie, this.__views__), we = Ce.start, Me = Ce.end, je = Me - we, lt = W ? Me : we - 1, dt = this.__iteratees__, gt = dt.length, Gt = 0, Qt = za(je, this.__takeCount__);
        if (!A || !W && ie == je && Qt == je)
          return fP(v, this.__actions__);
        var fr = [];
        e:
          for (; je-- && Gt < Qt; ) {
            lt += C;
            for (var Rr = -1, pr = v[lt]; ++Rr < gt; ) {
              var kr = dt[Rr], Wr = kr.iteratee, Pi = kr.type, ei = Wr(pr);
              if (Pi == z)
                pr = ei;
              else if (!ei) {
                if (Pi == N)
                  continue e;
                break e;
              }
            }
            fr[Gt++] = pr;
          }
        return fr;
      }
      Hr.prototype = lu(hg.prototype), Hr.prototype.constructor = Hr;
      function Dl(v) {
        var C = -1, A = v == null ? 0 : v.length;
        for (this.clear(); ++C < A; ) {
          var W = v[C];
          this.set(W[0], W[1]);
        }
      }
      function Fre() {
        this.__data__ = ef ? ef(null) : {}, this.size = 0;
      }
      function Bre(v) {
        var C = this.has(v) && delete this.__data__[v];
        return this.size -= C ? 1 : 0, C;
      }
      function zre(v) {
        var C = this.__data__;
        if (ef) {
          var A = C[v];
          return A === l ? r : A;
        }
        return mn.call(C, v) ? C[v] : r;
      }
      function Hre(v) {
        var C = this.__data__;
        return ef ? C[v] !== r : mn.call(C, v);
      }
      function Vre(v, C) {
        var A = this.__data__;
        return this.size += this.has(v) ? 0 : 1, A[v] = ef && C === r ? l : C, this;
      }
      Dl.prototype.clear = Fre, Dl.prototype.delete = Bre, Dl.prototype.get = zre, Dl.prototype.has = Hre, Dl.prototype.set = Vre;
      function gs(v) {
        var C = -1, A = v == null ? 0 : v.length;
        for (this.clear(); ++C < A; ) {
          var W = v[C];
          this.set(W[0], W[1]);
        }
      }
      function Gre() {
        this.__data__ = [], this.size = 0;
      }
      function Ure(v) {
        var C = this.__data__, A = gg(C, v);
        if (A < 0)
          return !1;
        var W = C.length - 1;
        return A == W ? C.pop() : ug.call(C, A, 1), --this.size, !0;
      }
      function Wre(v) {
        var C = this.__data__, A = gg(C, v);
        return A < 0 ? r : C[A][1];
      }
      function qre(v) {
        return gg(this.__data__, v) > -1;
      }
      function Kre(v, C) {
        var A = this.__data__, W = gg(A, v);
        return W < 0 ? (++this.size, A.push([v, C])) : A[W][1] = C, this;
      }
      gs.prototype.clear = Gre, gs.prototype.delete = Ure, gs.prototype.get = Wre, gs.prototype.has = qre, gs.prototype.set = Kre;
      function ys(v) {
        var C = -1, A = v == null ? 0 : v.length;
        for (this.clear(); ++C < A; ) {
          var W = v[C];
          this.set(W[0], W[1]);
        }
      }
      function Yre() {
        this.size = 0, this.__data__ = {
          hash: new Dl(),
          map: new (Jd || gs)(),
          string: new Dl()
        };
      }
      function Zre(v) {
        var C = Ig(this, v).delete(v);
        return this.size -= C ? 1 : 0, C;
      }
      function Xre(v) {
        return Ig(this, v).get(v);
      }
      function Jre(v) {
        return Ig(this, v).has(v);
      }
      function Qre(v, C) {
        var A = Ig(this, v), W = A.size;
        return A.set(v, C), this.size += A.size == W ? 0 : 1, this;
      }
      ys.prototype.clear = Yre, ys.prototype.delete = Zre, ys.prototype.get = Xre, ys.prototype.has = Jre, ys.prototype.set = Qre;
      function jl(v) {
        var C = -1, A = v == null ? 0 : v.length;
        for (this.__data__ = new ys(); ++C < A; )
          this.add(v[C]);
      }
      function ene(v) {
        return this.__data__.set(v, l), this;
      }
      function tne(v) {
        return this.__data__.has(v);
      }
      jl.prototype.add = jl.prototype.push = ene, jl.prototype.has = tne;
      function vo(v) {
        var C = this.__data__ = new gs(v);
        this.size = C.size;
      }
      function rne() {
        this.__data__ = new gs(), this.size = 0;
      }
      function nne(v) {
        var C = this.__data__, A = C.delete(v);
        return this.size = C.size, A;
      }
      function ane(v) {
        return this.__data__.get(v);
      }
      function ine(v) {
        return this.__data__.has(v);
      }
      function one(v, C) {
        var A = this.__data__;
        if (A instanceof gs) {
          var W = A.__data__;
          if (!Jd || W.length < a - 1)
            return W.push([v, C]), this.size = ++A.size, this;
          A = this.__data__ = new ys(W);
        }
        return A.set(v, C), this.size = A.size, this;
      }
      vo.prototype.clear = rne, vo.prototype.delete = nne, vo.prototype.get = ane, vo.prototype.has = ine, vo.prototype.set = one;
      function VA(v, C) {
        var A = Or(v), W = !A && zl(v), ie = !A && !W && ol(v), Ce = !A && !W && !ie && fu(v), we = A || W || ie || Ce, Me = we ? qC(v.length, hre) : [], je = Me.length;
        for (var lt in v)
          (C || mn.call(v, lt)) && !(we && // Safari 9 has enumerable `arguments.length` in strict mode.
          (lt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          ie && (lt == "offset" || lt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          Ce && (lt == "buffer" || lt == "byteLength" || lt == "byteOffset") || // Skip index properties.
          xs(lt, je))) && Me.push(lt);
        return Me;
      }
      function GA(v) {
        var C = v.length;
        return C ? v[uS(0, C - 1)] : r;
      }
      function sne(v, C) {
        return Mg(pi(v), Ll(C, 0, v.length));
      }
      function lne(v) {
        return Mg(pi(v));
      }
      function eS(v, C, A) {
        (A !== r && !ho(v[C], A) || A === r && !(C in v)) && bs(v, C, A);
      }
      function rf(v, C, A) {
        var W = v[C];
        (!(mn.call(v, C) && ho(W, A)) || A === r && !(C in v)) && bs(v, C, A);
      }
      function gg(v, C) {
        for (var A = v.length; A--; )
          if (ho(v[A][0], C))
            return A;
        return -1;
      }
      function cne(v, C, A, W) {
        return rl(v, function(ie, Ce, we) {
          C(W, ie, A(ie), we);
        }), W;
      }
      function UA(v, C) {
        return v && Wo(C, $a(C), v);
      }
      function une(v, C) {
        return v && Wo(C, vi(C), v);
      }
      function bs(v, C, A) {
        C == "__proto__" && dg ? dg(v, C, {
          configurable: !0,
          enumerable: !0,
          value: A,
          writable: !0
        }) : v[C] = A;
      }
      function tS(v, C) {
        for (var A = -1, W = C.length, ie = We(W), Ce = v == null; ++A < W; )
          ie[A] = Ce ? r : DS(v, C[A]);
        return ie;
      }
      function Ll(v, C, A) {
        return v === v && (A !== r && (v = v <= A ? v : A), C !== r && (v = v >= C ? v : C)), v;
      }
      function Xi(v, C, A, W, ie, Ce) {
        var we, Me = C & d, je = C & f, lt = C & m;
        if (A && (we = ie ? A(v, W, ie, Ce) : A(v)), we !== r)
          return we;
        if (!Bn(v))
          return v;
        var dt = Or(v);
        if (dt) {
          if (we = Jne(v), !Me)
            return pi(v, we);
        } else {
          var gt = Ha(v), Gt = gt == Q || gt == he;
          if (ol(v))
            return vP(v, Me);
          if (gt == M || gt == ae || Gt && !ie) {
            if (we = je || Gt ? {} : NP(v), !Me)
              return je ? zne(v, une(we, v)) : Bne(v, UA(we, v));
          } else {
            if (!En[gt])
              return ie ? v : {};
            we = Qne(v, gt, Me);
          }
        }
        Ce || (Ce = new vo());
        var Qt = Ce.get(v);
        if (Qt)
          return Qt;
        Ce.set(v, we), c3(v) ? v.forEach(function(pr) {
          we.add(Xi(pr, C, A, pr, v, Ce));
        }) : s3(v) && v.forEach(function(pr, kr) {
          we.set(kr, Xi(pr, C, A, kr, v, Ce));
        });
        var fr = lt ? je ? SS : CS : je ? vi : $a, Rr = dt ? r : fr(v);
        return Ki(Rr || v, function(pr, kr) {
          Rr && (kr = pr, pr = v[kr]), rf(we, kr, Xi(pr, C, A, kr, v, Ce));
        }), we;
      }
      function dne(v) {
        var C = $a(v);
        return function(A) {
          return WA(A, v, C);
        };
      }
      function WA(v, C, A) {
        var W = A.length;
        if (v == null)
          return !W;
        for (v = xn(v); W--; ) {
          var ie = A[W], Ce = C[ie], we = v[ie];
          if (we === r && !(ie in v) || !Ce(we))
            return !1;
        }
        return !0;
      }
      function qA(v, C, A) {
        if (typeof v != "function")
          throw new Yi(o);
        return uf(function() {
          v.apply(r, A);
        }, C);
      }
      function nf(v, C, A, W) {
        var ie = -1, Ce = eg, we = !0, Me = v.length, je = [], lt = C.length;
        if (!Me)
          return je;
        A && (C = Dn(C, Ii(A))), W ? (Ce = zC, we = !1) : C.length >= a && (Ce = Zd, we = !1, C = new jl(C));
        e:
          for (; ++ie < Me; ) {
            var dt = v[ie], gt = A == null ? dt : A(dt);
            if (dt = W || dt !== 0 ? dt : 0, we && gt === gt) {
              for (var Gt = lt; Gt--; )
                if (C[Gt] === gt)
                  continue e;
              je.push(dt);
            } else Ce(C, gt, W) || je.push(dt);
          }
        return je;
      }
      var rl = CP(Uo), KA = CP(nS, !0);
      function fne(v, C) {
        var A = !0;
        return rl(v, function(W, ie, Ce) {
          return A = !!C(W, ie, Ce), A;
        }), A;
      }
      function yg(v, C, A) {
        for (var W = -1, ie = v.length; ++W < ie; ) {
          var Ce = v[W], we = C(Ce);
          if (we != null && (Me === r ? we === we && !Ai(we) : A(we, Me)))
            var Me = we, je = Ce;
        }
        return je;
      }
      function pne(v, C, A, W) {
        var ie = v.length;
        for (A = Ar(A), A < 0 && (A = -A > ie ? 0 : ie + A), W = W === r || W > ie ? ie : Ar(W), W < 0 && (W += ie), W = A > W ? 0 : d3(W); A < W; )
          v[A++] = C;
        return v;
      }
      function YA(v, C) {
        var A = [];
        return rl(v, function(W, ie, Ce) {
          C(W, ie, Ce) && A.push(W);
        }), A;
      }
      function Ra(v, C, A, W, ie) {
        var Ce = -1, we = v.length;
        for (A || (A = tae), ie || (ie = []); ++Ce < we; ) {
          var Me = v[Ce];
          C > 0 && A(Me) ? C > 1 ? Ra(Me, C - 1, A, W, ie) : Qs(ie, Me) : W || (ie[ie.length] = Me);
        }
        return ie;
      }
      var rS = SP(), ZA = SP(!0);
      function Uo(v, C) {
        return v && rS(v, C, $a);
      }
      function nS(v, C) {
        return v && ZA(v, C, $a);
      }
      function bg(v, C) {
        return Js(C, function(A) {
          return $s(v[A]);
        });
      }
      function kl(v, C) {
        C = al(C, v);
        for (var A = 0, W = C.length; v != null && A < W; )
          v = v[qo(C[A++])];
        return A && A == W ? v : r;
      }
      function XA(v, C, A) {
        var W = C(v);
        return Or(v) ? W : Qs(W, A(v));
      }
      function Ja(v) {
        return v == null ? v === r ? J : k : Nl && Nl in xn(v) ? Yne(v) : lae(v);
      }
      function aS(v, C) {
        return v > C;
      }
      function mne(v, C) {
        return v != null && mn.call(v, C);
      }
      function vne(v, C) {
        return v != null && C in xn(v);
      }
      function hne(v, C, A) {
        return v >= za(C, A) && v < ga(C, A);
      }
      function iS(v, C, A) {
        for (var W = A ? zC : eg, ie = v[0].length, Ce = v.length, we = Ce, Me = We(Ce), je = 1 / 0, lt = []; we--; ) {
          var dt = v[we];
          we && C && (dt = Dn(dt, Ii(C))), je = za(dt.length, je), Me[we] = !A && (C || ie >= 120 && dt.length >= 120) ? new jl(we && dt) : r;
        }
        dt = v[0];
        var gt = -1, Gt = Me[0];
        e:
          for (; ++gt < ie && lt.length < je; ) {
            var Qt = dt[gt], fr = C ? C(Qt) : Qt;
            if (Qt = A || Qt !== 0 ? Qt : 0, !(Gt ? Zd(Gt, fr) : W(lt, fr, A))) {
              for (we = Ce; --we; ) {
                var Rr = Me[we];
                if (!(Rr ? Zd(Rr, fr) : W(v[we], fr, A)))
                  continue e;
              }
              Gt && Gt.push(fr), lt.push(Qt);
            }
          }
        return lt;
      }
      function gne(v, C, A, W) {
        return Uo(v, function(ie, Ce, we) {
          C(W, A(ie), Ce, we);
        }), W;
      }
      function af(v, C, A) {
        C = al(C, v), v = kP(v, C);
        var W = v == null ? v : v[qo(Qi(C))];
        return W == null ? r : Ti(W, v, A);
      }
      function JA(v) {
        return qn(v) && Ja(v) == ae;
      }
      function yne(v) {
        return qn(v) && Ja(v) == Ee;
      }
      function bne(v) {
        return qn(v) && Ja(v) == fe;
      }
      function of(v, C, A, W, ie) {
        return v === C ? !0 : v == null || C == null || !qn(v) && !qn(C) ? v !== v && C !== C : Cne(v, C, A, W, of, ie);
      }
      function Cne(v, C, A, W, ie, Ce) {
        var we = Or(v), Me = Or(C), je = we ? ue : Ha(v), lt = Me ? ue : Ha(C);
        je = je == ae ? M : je, lt = lt == ae ? M : lt;
        var dt = je == M, gt = lt == M, Gt = je == lt;
        if (Gt && ol(v)) {
          if (!ol(C))
            return !1;
          we = !0, dt = !1;
        }
        if (Gt && !dt)
          return Ce || (Ce = new vo()), we || fu(v) ? AP(v, C, A, W, ie, Ce) : qne(v, C, je, A, W, ie, Ce);
        if (!(A & h)) {
          var Qt = dt && mn.call(v, "__wrapped__"), fr = gt && mn.call(C, "__wrapped__");
          if (Qt || fr) {
            var Rr = Qt ? v.value() : v, pr = fr ? C.value() : C;
            return Ce || (Ce = new vo()), ie(Rr, pr, A, W, Ce);
          }
        }
        return Gt ? (Ce || (Ce = new vo()), Kne(v, C, A, W, ie, Ce)) : !1;
      }
      function Sne(v) {
        return qn(v) && Ha(v) == ne;
      }
      function oS(v, C, A, W) {
        var ie = A.length, Ce = ie, we = !W;
        if (v == null)
          return !Ce;
        for (v = xn(v); ie--; ) {
          var Me = A[ie];
          if (we && Me[2] ? Me[1] !== v[Me[0]] : !(Me[0] in v))
            return !1;
        }
        for (; ++ie < Ce; ) {
          Me = A[ie];
          var je = Me[0], lt = v[je], dt = Me[1];
          if (we && Me[2]) {
            if (lt === r && !(je in v))
              return !1;
          } else {
            var gt = new vo();
            if (W)
              var Gt = W(lt, dt, je, v, C, gt);
            if (!(Gt === r ? of(dt, lt, h | g, W, gt) : Gt))
              return !1;
          }
        }
        return !0;
      }
      function QA(v) {
        if (!Bn(v) || nae(v))
          return !1;
        var C = $s(v) ? Sre : Be;
        return C.test(Bl(v));
      }
      function xne(v) {
        return qn(v) && Ja(v) == Y;
      }
      function $ne(v) {
        return qn(v) && Ha(v) == X;
      }
      function _ne(v) {
        return qn(v) && jg(v.length) && !!nn[Ja(v)];
      }
      function eP(v) {
        return typeof v == "function" ? v : v == null ? hi : typeof v == "object" ? Or(v) ? nP(v[0], v[1]) : rP(v) : x3(v);
      }
      function sS(v) {
        if (!cf(v))
          return Ore(v);
        var C = [];
        for (var A in xn(v))
          mn.call(v, A) && A != "constructor" && C.push(A);
        return C;
      }
      function Ene(v) {
        if (!Bn(v))
          return sae(v);
        var C = cf(v), A = [];
        for (var W in v)
          W == "constructor" && (C || !mn.call(v, W)) || A.push(W);
        return A;
      }
      function lS(v, C) {
        return v < C;
      }
      function tP(v, C) {
        var A = -1, W = mi(v) ? We(v.length) : [];
        return rl(v, function(ie, Ce, we) {
          W[++A] = C(ie, Ce, we);
        }), W;
      }
      function rP(v) {
        var C = $S(v);
        return C.length == 1 && C[0][2] ? jP(C[0][0], C[0][1]) : function(A) {
          return A === v || oS(A, v, C);
        };
      }
      function nP(v, C) {
        return ES(v) && DP(C) ? jP(qo(v), C) : function(A) {
          var W = DS(A, v);
          return W === r && W === C ? jS(A, v) : of(C, W, h | g);
        };
      }
      function Cg(v, C, A, W, ie) {
        v !== C && rS(C, function(Ce, we) {
          if (ie || (ie = new vo()), Bn(Ce))
            wne(v, C, we, A, Cg, W, ie);
          else {
            var Me = W ? W(OS(v, we), Ce, we + "", v, C, ie) : r;
            Me === r && (Me = Ce), eS(v, we, Me);
          }
        }, vi);
      }
      function wne(v, C, A, W, ie, Ce, we) {
        var Me = OS(v, A), je = OS(C, A), lt = we.get(je);
        if (lt) {
          eS(v, A, lt);
          return;
        }
        var dt = Ce ? Ce(Me, je, A + "", v, C, we) : r, gt = dt === r;
        if (gt) {
          var Gt = Or(je), Qt = !Gt && ol(je), fr = !Gt && !Qt && fu(je);
          dt = je, Gt || Qt || fr ? Or(Me) ? dt = Me : Qn(Me) ? dt = pi(Me) : Qt ? (gt = !1, dt = vP(je, !0)) : fr ? (gt = !1, dt = hP(je, !0)) : dt = [] : df(je) || zl(je) ? (dt = Me, zl(Me) ? dt = f3(Me) : (!Bn(Me) || $s(Me)) && (dt = NP(je))) : gt = !1;
        }
        gt && (we.set(je, dt), ie(dt, je, W, Ce, we), we.delete(je)), eS(v, A, dt);
      }
      function aP(v, C) {
        var A = v.length;
        if (A)
          return C += C < 0 ? A : 0, xs(C, A) ? v[C] : r;
      }
      function iP(v, C, A) {
        C.length ? C = Dn(C, function(Ce) {
          return Or(Ce) ? function(we) {
            return kl(we, Ce.length === 1 ? Ce[0] : Ce);
          } : Ce;
        }) : C = [hi];
        var W = -1;
        C = Dn(C, Ii(ur()));
        var ie = tP(v, function(Ce, we, Me) {
          var je = Dn(C, function(lt) {
            return lt(Ce);
          });
          return { criteria: je, index: ++W, value: Ce };
        });
        return Qte(ie, function(Ce, we) {
          return Fne(Ce, we, A);
        });
      }
      function One(v, C) {
        return oP(v, C, function(A, W) {
          return jS(v, W);
        });
      }
      function oP(v, C, A) {
        for (var W = -1, ie = C.length, Ce = {}; ++W < ie; ) {
          var we = C[W], Me = kl(v, we);
          A(Me, we) && sf(Ce, al(we, v), Me);
        }
        return Ce;
      }
      function Tne(v) {
        return function(C) {
          return kl(C, v);
        };
      }
      function cS(v, C, A, W) {
        var ie = W ? Jte : tu, Ce = -1, we = C.length, Me = v;
        for (v === C && (C = pi(C)), A && (Me = Dn(v, Ii(A))); ++Ce < we; )
          for (var je = 0, lt = C[Ce], dt = A ? A(lt) : lt; (je = ie(Me, dt, je, W)) > -1; )
            Me !== v && ug.call(Me, je, 1), ug.call(v, je, 1);
        return v;
      }
      function sP(v, C) {
        for (var A = v ? C.length : 0, W = A - 1; A--; ) {
          var ie = C[A];
          if (A == W || ie !== Ce) {
            var Ce = ie;
            xs(ie) ? ug.call(v, ie, 1) : pS(v, ie);
          }
        }
        return v;
      }
      function uS(v, C) {
        return v + pg(zA() * (C - v + 1));
      }
      function Ine(v, C, A, W) {
        for (var ie = -1, Ce = ga(fg((C - v) / (A || 1)), 0), we = We(Ce); Ce--; )
          we[W ? Ce : ++ie] = v, v += A;
        return we;
      }
      function dS(v, C) {
        var A = "";
        if (!v || C < 1 || C > H)
          return A;
        do
          C % 2 && (A += v), C = pg(C / 2), C && (v += v);
        while (C);
        return A;
      }
      function Dr(v, C) {
        return TS(LP(v, C, hi), v + "");
      }
      function Mne(v) {
        return GA(pu(v));
      }
      function Ane(v, C) {
        var A = pu(v);
        return Mg(A, Ll(C, 0, A.length));
      }
      function sf(v, C, A, W) {
        if (!Bn(v))
          return v;
        C = al(C, v);
        for (var ie = -1, Ce = C.length, we = Ce - 1, Me = v; Me != null && ++ie < Ce; ) {
          var je = qo(C[ie]), lt = A;
          if (je === "__proto__" || je === "constructor" || je === "prototype")
            return v;
          if (ie != we) {
            var dt = Me[je];
            lt = W ? W(dt, je, Me) : r, lt === r && (lt = Bn(dt) ? dt : xs(C[ie + 1]) ? [] : {});
          }
          rf(Me, je, lt), Me = Me[je];
        }
        return v;
      }
      var lP = mg ? function(v, C) {
        return mg.set(v, C), v;
      } : hi, Pne = dg ? function(v, C) {
        return dg(v, "toString", {
          configurable: !0,
          enumerable: !1,
          value: kS(C),
          writable: !0
        });
      } : hi;
      function Rne(v) {
        return Mg(pu(v));
      }
      function Ji(v, C, A) {
        var W = -1, ie = v.length;
        C < 0 && (C = -C > ie ? 0 : ie + C), A = A > ie ? ie : A, A < 0 && (A += ie), ie = C > A ? 0 : A - C >>> 0, C >>>= 0;
        for (var Ce = We(ie); ++W < ie; )
          Ce[W] = v[W + C];
        return Ce;
      }
      function Nne(v, C) {
        var A;
        return rl(v, function(W, ie, Ce) {
          return A = C(W, ie, Ce), !A;
        }), !!A;
      }
      function Sg(v, C, A) {
        var W = 0, ie = v == null ? W : v.length;
        if (typeof C == "number" && C === C && ie <= Z) {
          for (; W < ie; ) {
            var Ce = W + ie >>> 1, we = v[Ce];
            we !== null && !Ai(we) && (A ? we <= C : we < C) ? W = Ce + 1 : ie = Ce;
          }
          return ie;
        }
        return fS(v, C, hi, A);
      }
      function fS(v, C, A, W) {
        var ie = 0, Ce = v == null ? 0 : v.length;
        if (Ce === 0)
          return 0;
        C = A(C);
        for (var we = C !== C, Me = C === null, je = Ai(C), lt = C === r; ie < Ce; ) {
          var dt = pg((ie + Ce) / 2), gt = A(v[dt]), Gt = gt !== r, Qt = gt === null, fr = gt === gt, Rr = Ai(gt);
          if (we)
            var pr = W || fr;
          else lt ? pr = fr && (W || Gt) : Me ? pr = fr && Gt && (W || !Qt) : je ? pr = fr && Gt && !Qt && (W || !Rr) : Qt || Rr ? pr = !1 : pr = W ? gt <= C : gt < C;
          pr ? ie = dt + 1 : Ce = dt;
        }
        return za(Ce, K);
      }
      function cP(v, C) {
        for (var A = -1, W = v.length, ie = 0, Ce = []; ++A < W; ) {
          var we = v[A], Me = C ? C(we) : we;
          if (!A || !ho(Me, je)) {
            var je = Me;
            Ce[ie++] = we === 0 ? 0 : we;
          }
        }
        return Ce;
      }
      function uP(v) {
        return typeof v == "number" ? v : Ai(v) ? G : +v;
      }
      function Mi(v) {
        if (typeof v == "string")
          return v;
        if (Or(v))
          return Dn(v, Mi) + "";
        if (Ai(v))
          return HA ? HA.call(v) : "";
        var C = v + "";
        return C == "0" && 1 / v == -1 / 0 ? "-0" : C;
      }
      function nl(v, C, A) {
        var W = -1, ie = eg, Ce = v.length, we = !0, Me = [], je = Me;
        if (A)
          we = !1, ie = zC;
        else if (Ce >= a) {
          var lt = C ? null : Une(v);
          if (lt)
            return rg(lt);
          we = !1, ie = Zd, je = new jl();
        } else
          je = C ? [] : Me;
        e:
          for (; ++W < Ce; ) {
            var dt = v[W], gt = C ? C(dt) : dt;
            if (dt = A || dt !== 0 ? dt : 0, we && gt === gt) {
              for (var Gt = je.length; Gt--; )
                if (je[Gt] === gt)
                  continue e;
              C && je.push(gt), Me.push(dt);
            } else ie(je, gt, A) || (je !== Me && je.push(gt), Me.push(dt));
          }
        return Me;
      }
      function pS(v, C) {
        return C = al(C, v), v = kP(v, C), v == null || delete v[qo(Qi(C))];
      }
      function dP(v, C, A, W) {
        return sf(v, C, A(kl(v, C)), W);
      }
      function xg(v, C, A, W) {
        for (var ie = v.length, Ce = W ? ie : -1; (W ? Ce-- : ++Ce < ie) && C(v[Ce], Ce, v); )
          ;
        return A ? Ji(v, W ? 0 : Ce, W ? Ce + 1 : ie) : Ji(v, W ? Ce + 1 : 0, W ? ie : Ce);
      }
      function fP(v, C) {
        var A = v;
        return A instanceof Hr && (A = A.value()), HC(C, function(W, ie) {
          return ie.func.apply(ie.thisArg, Qs([W], ie.args));
        }, A);
      }
      function mS(v, C, A) {
        var W = v.length;
        if (W < 2)
          return W ? nl(v[0]) : [];
        for (var ie = -1, Ce = We(W); ++ie < W; )
          for (var we = v[ie], Me = -1; ++Me < W; )
            Me != ie && (Ce[ie] = nf(Ce[ie] || we, v[Me], C, A));
        return nl(Ra(Ce, 1), C, A);
      }
      function pP(v, C, A) {
        for (var W = -1, ie = v.length, Ce = C.length, we = {}; ++W < ie; ) {
          var Me = W < Ce ? C[W] : r;
          A(we, v[W], Me);
        }
        return we;
      }
      function vS(v) {
        return Qn(v) ? v : [];
      }
      function hS(v) {
        return typeof v == "function" ? v : hi;
      }
      function al(v, C) {
        return Or(v) ? v : ES(v, C) ? [v] : HP(an(v));
      }
      var Dne = Dr;
      function il(v, C, A) {
        var W = v.length;
        return A = A === r ? W : A, !C && A >= W ? v : Ji(v, C, A);
      }
      var mP = xre || function(v) {
        return Pa.clearTimeout(v);
      };
      function vP(v, C) {
        if (C)
          return v.slice();
        var A = v.length, W = jA ? jA(A) : new v.constructor(A);
        return v.copy(W), W;
      }
      function gS(v) {
        var C = new v.constructor(v.byteLength);
        return new lg(C).set(new lg(v)), C;
      }
      function jne(v, C) {
        var A = C ? gS(v.buffer) : v.buffer;
        return new v.constructor(A, v.byteOffset, v.byteLength);
      }
      function Lne(v) {
        var C = new v.constructor(v.source, st.exec(v));
        return C.lastIndex = v.lastIndex, C;
      }
      function kne(v) {
        return tf ? xn(tf.call(v)) : {};
      }
      function hP(v, C) {
        var A = C ? gS(v.buffer) : v.buffer;
        return new v.constructor(A, v.byteOffset, v.length);
      }
      function gP(v, C) {
        if (v !== C) {
          var A = v !== r, W = v === null, ie = v === v, Ce = Ai(v), we = C !== r, Me = C === null, je = C === C, lt = Ai(C);
          if (!Me && !lt && !Ce && v > C || Ce && we && je && !Me && !lt || W && we && je || !A && je || !ie)
            return 1;
          if (!W && !Ce && !lt && v < C || lt && A && ie && !W && !Ce || Me && A && ie || !we && ie || !je)
            return -1;
        }
        return 0;
      }
      function Fne(v, C, A) {
        for (var W = -1, ie = v.criteria, Ce = C.criteria, we = ie.length, Me = A.length; ++W < we; ) {
          var je = gP(ie[W], Ce[W]);
          if (je) {
            if (W >= Me)
              return je;
            var lt = A[W];
            return je * (lt == "desc" ? -1 : 1);
          }
        }
        return v.index - C.index;
      }
      function yP(v, C, A, W) {
        for (var ie = -1, Ce = v.length, we = A.length, Me = -1, je = C.length, lt = ga(Ce - we, 0), dt = We(je + lt), gt = !W; ++Me < je; )
          dt[Me] = C[Me];
        for (; ++ie < we; )
          (gt || ie < Ce) && (dt[A[ie]] = v[ie]);
        for (; lt--; )
          dt[Me++] = v[ie++];
        return dt;
      }
      function bP(v, C, A, W) {
        for (var ie = -1, Ce = v.length, we = -1, Me = A.length, je = -1, lt = C.length, dt = ga(Ce - Me, 0), gt = We(dt + lt), Gt = !W; ++ie < dt; )
          gt[ie] = v[ie];
        for (var Qt = ie; ++je < lt; )
          gt[Qt + je] = C[je];
        for (; ++we < Me; )
          (Gt || ie < Ce) && (gt[Qt + A[we]] = v[ie++]);
        return gt;
      }
      function pi(v, C) {
        var A = -1, W = v.length;
        for (C || (C = We(W)); ++A < W; )
          C[A] = v[A];
        return C;
      }
      function Wo(v, C, A, W) {
        var ie = !A;
        A || (A = {});
        for (var Ce = -1, we = C.length; ++Ce < we; ) {
          var Me = C[Ce], je = W ? W(A[Me], v[Me], Me, A, v) : r;
          je === r && (je = v[Me]), ie ? bs(A, Me, je) : rf(A, Me, je);
        }
        return A;
      }
      function Bne(v, C) {
        return Wo(v, _S(v), C);
      }
      function zne(v, C) {
        return Wo(v, PP(v), C);
      }
      function $g(v, C) {
        return function(A, W) {
          var ie = Or(A) ? Wte : cne, Ce = C ? C() : {};
          return ie(A, v, ur(W, 2), Ce);
        };
      }
      function cu(v) {
        return Dr(function(C, A) {
          var W = -1, ie = A.length, Ce = ie > 1 ? A[ie - 1] : r, we = ie > 2 ? A[2] : r;
          for (Ce = v.length > 3 && typeof Ce == "function" ? (ie--, Ce) : r, we && Qa(A[0], A[1], we) && (Ce = ie < 3 ? r : Ce, ie = 1), C = xn(C); ++W < ie; ) {
            var Me = A[W];
            Me && v(C, Me, W, Ce);
          }
          return C;
        });
      }
      function CP(v, C) {
        return function(A, W) {
          if (A == null)
            return A;
          if (!mi(A))
            return v(A, W);
          for (var ie = A.length, Ce = C ? ie : -1, we = xn(A); (C ? Ce-- : ++Ce < ie) && W(we[Ce], Ce, we) !== !1; )
            ;
          return A;
        };
      }
      function SP(v) {
        return function(C, A, W) {
          for (var ie = -1, Ce = xn(C), we = W(C), Me = we.length; Me--; ) {
            var je = we[v ? Me : ++ie];
            if (A(Ce[je], je, Ce) === !1)
              break;
          }
          return C;
        };
      }
      function Hne(v, C, A) {
        var W = C & y, ie = lf(v);
        function Ce() {
          var we = this && this !== Pa && this instanceof Ce ? ie : v;
          return we.apply(W ? A : this, arguments);
        }
        return Ce;
      }
      function xP(v) {
        return function(C) {
          C = an(C);
          var A = ru(C) ? mo(C) : r, W = A ? A[0] : C.charAt(0), ie = A ? il(A, 1).join("") : C.slice(1);
          return W[v]() + ie;
        };
      }
      function uu(v) {
        return function(C) {
          return HC(C3(b3(C).replace(Jt, "")), v, "");
        };
      }
      function lf(v) {
        return function() {
          var C = arguments;
          switch (C.length) {
            case 0:
              return new v();
            case 1:
              return new v(C[0]);
            case 2:
              return new v(C[0], C[1]);
            case 3:
              return new v(C[0], C[1], C[2]);
            case 4:
              return new v(C[0], C[1], C[2], C[3]);
            case 5:
              return new v(C[0], C[1], C[2], C[3], C[4]);
            case 6:
              return new v(C[0], C[1], C[2], C[3], C[4], C[5]);
            case 7:
              return new v(C[0], C[1], C[2], C[3], C[4], C[5], C[6]);
          }
          var A = lu(v.prototype), W = v.apply(A, C);
          return Bn(W) ? W : A;
        };
      }
      function Vne(v, C, A) {
        var W = lf(v);
        function ie() {
          for (var Ce = arguments.length, we = We(Ce), Me = Ce, je = du(ie); Me--; )
            we[Me] = arguments[Me];
          var lt = Ce < 3 && we[0] !== je && we[Ce - 1] !== je ? [] : el(we, je);
          if (Ce -= lt.length, Ce < A)
            return OP(
              v,
              C,
              _g,
              ie.placeholder,
              r,
              we,
              lt,
              r,
              r,
              A - Ce
            );
          var dt = this && this !== Pa && this instanceof ie ? W : v;
          return Ti(dt, this, we);
        }
        return ie;
      }
      function $P(v) {
        return function(C, A, W) {
          var ie = xn(C);
          if (!mi(C)) {
            var Ce = ur(A, 3);
            C = $a(C), A = function(Me) {
              return Ce(ie[Me], Me, ie);
            };
          }
          var we = v(C, A, W);
          return we > -1 ? ie[Ce ? C[we] : we] : r;
        };
      }
      function _P(v) {
        return Ss(function(C) {
          var A = C.length, W = A, ie = Zi.prototype.thru;
          for (v && C.reverse(); W--; ) {
            var Ce = C[W];
            if (typeof Ce != "function")
              throw new Yi(o);
            if (ie && !we && Tg(Ce) == "wrapper")
              var we = new Zi([], !0);
          }
          for (W = we ? W : A; ++W < A; ) {
            Ce = C[W];
            var Me = Tg(Ce), je = Me == "wrapper" ? xS(Ce) : r;
            je && wS(je[0]) && je[1] == (O | b | $ | T) && !je[4].length && je[9] == 1 ? we = we[Tg(je[0])].apply(we, je[3]) : we = Ce.length == 1 && wS(Ce) ? we[Me]() : we.thru(Ce);
          }
          return function() {
            var lt = arguments, dt = lt[0];
            if (we && lt.length == 1 && Or(dt))
              return we.plant(dt).value();
            for (var gt = 0, Gt = A ? C[gt].apply(this, lt) : dt; ++gt < A; )
              Gt = C[gt].call(this, Gt);
            return Gt;
          };
        });
      }
      function _g(v, C, A, W, ie, Ce, we, Me, je, lt) {
        var dt = C & O, gt = C & y, Gt = C & S, Qt = C & (b | _), fr = C & I, Rr = Gt ? r : lf(v);
        function pr() {
          for (var kr = arguments.length, Wr = We(kr), Pi = kr; Pi--; )
            Wr[Pi] = arguments[Pi];
          if (Qt)
            var ei = du(pr), Ri = tre(Wr, ei);
          if (W && (Wr = yP(Wr, W, ie, Qt)), Ce && (Wr = bP(Wr, Ce, we, Qt)), kr -= Ri, Qt && kr < lt) {
            var ea = el(Wr, ei);
            return OP(
              v,
              C,
              _g,
              pr.placeholder,
              A,
              Wr,
              ea,
              Me,
              je,
              lt - kr
            );
          }
          var go = gt ? A : this, Es = Gt ? go[v] : v;
          return kr = Wr.length, Me ? Wr = cae(Wr, Me) : fr && kr > 1 && Wr.reverse(), dt && je < kr && (Wr.length = je), this && this !== Pa && this instanceof pr && (Es = Rr || lf(Es)), Es.apply(go, Wr);
        }
        return pr;
      }
      function EP(v, C) {
        return function(A, W) {
          return gne(A, v, C(W), {});
        };
      }
      function Eg(v, C) {
        return function(A, W) {
          var ie;
          if (A === r && W === r)
            return C;
          if (A !== r && (ie = A), W !== r) {
            if (ie === r)
              return W;
            typeof A == "string" || typeof W == "string" ? (A = Mi(A), W = Mi(W)) : (A = uP(A), W = uP(W)), ie = v(A, W);
          }
          return ie;
        };
      }
      function yS(v) {
        return Ss(function(C) {
          return C = Dn(C, Ii(ur())), Dr(function(A) {
            var W = this;
            return v(C, function(ie) {
              return Ti(ie, W, A);
            });
          });
        });
      }
      function wg(v, C) {
        C = C === r ? " " : Mi(C);
        var A = C.length;
        if (A < 2)
          return A ? dS(C, v) : C;
        var W = dS(C, fg(v / nu(C)));
        return ru(C) ? il(mo(W), 0, v).join("") : W.slice(0, v);
      }
      function Gne(v, C, A, W) {
        var ie = C & y, Ce = lf(v);
        function we() {
          for (var Me = -1, je = arguments.length, lt = -1, dt = W.length, gt = We(dt + je), Gt = this && this !== Pa && this instanceof we ? Ce : v; ++lt < dt; )
            gt[lt] = W[lt];
          for (; je--; )
            gt[lt++] = arguments[++Me];
          return Ti(Gt, ie ? A : this, gt);
        }
        return we;
      }
      function wP(v) {
        return function(C, A, W) {
          return W && typeof W != "number" && Qa(C, A, W) && (A = W = r), C = _s(C), A === r ? (A = C, C = 0) : A = _s(A), W = W === r ? C < A ? 1 : -1 : _s(W), Ine(C, A, W, v);
        };
      }
      function Og(v) {
        return function(C, A) {
          return typeof C == "string" && typeof A == "string" || (C = eo(C), A = eo(A)), v(C, A);
        };
      }
      function OP(v, C, A, W, ie, Ce, we, Me, je, lt) {
        var dt = C & b, gt = dt ? we : r, Gt = dt ? r : we, Qt = dt ? Ce : r, fr = dt ? r : Ce;
        C |= dt ? $ : w, C &= ~(dt ? w : $), C & x || (C &= -4);
        var Rr = [
          v,
          C,
          ie,
          Qt,
          gt,
          fr,
          Gt,
          Me,
          je,
          lt
        ], pr = A.apply(r, Rr);
        return wS(v) && FP(pr, Rr), pr.placeholder = W, BP(pr, v, C);
      }
      function bS(v) {
        var C = ha[v];
        return function(A, W) {
          if (A = eo(A), W = W == null ? 0 : za(Ar(W), 292), W && BA(A)) {
            var ie = (an(A) + "e").split("e"), Ce = C(ie[0] + "e" + (+ie[1] + W));
            return ie = (an(Ce) + "e").split("e"), +(ie[0] + "e" + (+ie[1] - W));
          }
          return C(A);
        };
      }
      var Une = ou && 1 / rg(new ou([, -0]))[1] == j ? function(v) {
        return new ou(v);
      } : zS;
      function TP(v) {
        return function(C) {
          var A = Ha(C);
          return A == ne ? YC(C) : A == X ? lre(C) : ere(C, v(C));
        };
      }
      function Cs(v, C, A, W, ie, Ce, we, Me) {
        var je = C & S;
        if (!je && typeof v != "function")
          throw new Yi(o);
        var lt = W ? W.length : 0;
        if (lt || (C &= -97, W = ie = r), we = we === r ? we : ga(Ar(we), 0), Me = Me === r ? Me : Ar(Me), lt -= ie ? ie.length : 0, C & w) {
          var dt = W, gt = ie;
          W = ie = r;
        }
        var Gt = je ? r : xS(v), Qt = [
          v,
          C,
          A,
          W,
          ie,
          dt,
          gt,
          Ce,
          we,
          Me
        ];
        if (Gt && oae(Qt, Gt), v = Qt[0], C = Qt[1], A = Qt[2], W = Qt[3], ie = Qt[4], Me = Qt[9] = Qt[9] === r ? je ? 0 : v.length : ga(Qt[9] - lt, 0), !Me && C & (b | _) && (C &= -25), !C || C == y)
          var fr = Hne(v, C, A);
        else C == b || C == _ ? fr = Vne(v, C, Me) : (C == $ || C == (y | $)) && !ie.length ? fr = Gne(v, C, A, W) : fr = _g.apply(r, Qt);
        var Rr = Gt ? lP : FP;
        return BP(Rr(fr, Qt), v, C);
      }
      function IP(v, C, A, W) {
        return v === r || ho(v, iu[A]) && !mn.call(W, A) ? C : v;
      }
      function MP(v, C, A, W, ie, Ce) {
        return Bn(v) && Bn(C) && (Ce.set(C, v), Cg(v, C, r, MP, Ce), Ce.delete(C)), v;
      }
      function Wne(v) {
        return df(v) ? r : v;
      }
      function AP(v, C, A, W, ie, Ce) {
        var we = A & h, Me = v.length, je = C.length;
        if (Me != je && !(we && je > Me))
          return !1;
        var lt = Ce.get(v), dt = Ce.get(C);
        if (lt && dt)
          return lt == C && dt == v;
        var gt = -1, Gt = !0, Qt = A & g ? new jl() : r;
        for (Ce.set(v, C), Ce.set(C, v); ++gt < Me; ) {
          var fr = v[gt], Rr = C[gt];
          if (W)
            var pr = we ? W(Rr, fr, gt, C, v, Ce) : W(fr, Rr, gt, v, C, Ce);
          if (pr !== r) {
            if (pr)
              continue;
            Gt = !1;
            break;
          }
          if (Qt) {
            if (!VC(C, function(kr, Wr) {
              if (!Zd(Qt, Wr) && (fr === kr || ie(fr, kr, A, W, Ce)))
                return Qt.push(Wr);
            })) {
              Gt = !1;
              break;
            }
          } else if (!(fr === Rr || ie(fr, Rr, A, W, Ce))) {
            Gt = !1;
            break;
          }
        }
        return Ce.delete(v), Ce.delete(C), Gt;
      }
      function qne(v, C, A, W, ie, Ce, we) {
        switch (A) {
          case Te:
            if (v.byteLength != C.byteLength || v.byteOffset != C.byteOffset)
              return !1;
            v = v.buffer, C = C.buffer;
          case Ee:
            return !(v.byteLength != C.byteLength || !Ce(new lg(v), new lg(C)));
          case oe:
          case fe:
          case me:
            return ho(+v, +C);
          case se:
            return v.name == C.name && v.message == C.message;
          case Y:
          case pe:
            return v == C + "";
          case ne:
            var Me = YC;
          case X:
            var je = W & h;
            if (Me || (Me = rg), v.size != C.size && !je)
              return !1;
            var lt = we.get(v);
            if (lt)
              return lt == C;
            W |= g, we.set(v, C);
            var dt = AP(Me(v), Me(C), W, ie, Ce, we);
            return we.delete(v), dt;
          case $e:
            if (tf)
              return tf.call(v) == tf.call(C);
        }
        return !1;
      }
      function Kne(v, C, A, W, ie, Ce) {
        var we = A & h, Me = CS(v), je = Me.length, lt = CS(C), dt = lt.length;
        if (je != dt && !we)
          return !1;
        for (var gt = je; gt--; ) {
          var Gt = Me[gt];
          if (!(we ? Gt in C : mn.call(C, Gt)))
            return !1;
        }
        var Qt = Ce.get(v), fr = Ce.get(C);
        if (Qt && fr)
          return Qt == C && fr == v;
        var Rr = !0;
        Ce.set(v, C), Ce.set(C, v);
        for (var pr = we; ++gt < je; ) {
          Gt = Me[gt];
          var kr = v[Gt], Wr = C[Gt];
          if (W)
            var Pi = we ? W(Wr, kr, Gt, C, v, Ce) : W(kr, Wr, Gt, v, C, Ce);
          if (!(Pi === r ? kr === Wr || ie(kr, Wr, A, W, Ce) : Pi)) {
            Rr = !1;
            break;
          }
          pr || (pr = Gt == "constructor");
        }
        if (Rr && !pr) {
          var ei = v.constructor, Ri = C.constructor;
          ei != Ri && "constructor" in v && "constructor" in C && !(typeof ei == "function" && ei instanceof ei && typeof Ri == "function" && Ri instanceof Ri) && (Rr = !1);
        }
        return Ce.delete(v), Ce.delete(C), Rr;
      }
      function Ss(v) {
        return TS(LP(v, r, WP), v + "");
      }
      function CS(v) {
        return XA(v, $a, _S);
      }
      function SS(v) {
        return XA(v, vi, PP);
      }
      var xS = mg ? function(v) {
        return mg.get(v);
      } : zS;
      function Tg(v) {
        for (var C = v.name + "", A = su[C], W = mn.call(su, C) ? A.length : 0; W--; ) {
          var ie = A[W], Ce = ie.func;
          if (Ce == null || Ce == v)
            return ie.name;
        }
        return C;
      }
      function du(v) {
        var C = mn.call(ge, "placeholder") ? ge : v;
        return C.placeholder;
      }
      function ur() {
        var v = ge.iteratee || FS;
        return v = v === FS ? eP : v, arguments.length ? v(arguments[0], arguments[1]) : v;
      }
      function Ig(v, C) {
        var A = v.__data__;
        return rae(C) ? A[typeof C == "string" ? "string" : "hash"] : A.map;
      }
      function $S(v) {
        for (var C = $a(v), A = C.length; A--; ) {
          var W = C[A], ie = v[W];
          C[A] = [W, ie, DP(ie)];
        }
        return C;
      }
      function Fl(v, C) {
        var A = ire(v, C);
        return QA(A) ? A : r;
      }
      function Yne(v) {
        var C = mn.call(v, Nl), A = v[Nl];
        try {
          v[Nl] = r;
          var W = !0;
        } catch {
        }
        var ie = og.call(v);
        return W && (C ? v[Nl] = A : delete v[Nl]), ie;
      }
      var _S = XC ? function(v) {
        return v == null ? [] : (v = xn(v), Js(XC(v), function(C) {
          return kA.call(v, C);
        }));
      } : HS, PP = XC ? function(v) {
        for (var C = []; v; )
          Qs(C, _S(v)), v = cg(v);
        return C;
      } : HS, Ha = Ja;
      (JC && Ha(new JC(new ArrayBuffer(1))) != Te || Jd && Ha(new Jd()) != ne || QC && Ha(QC.resolve()) != R || ou && Ha(new ou()) != X || Qd && Ha(new Qd()) != de) && (Ha = function(v) {
        var C = Ja(v), A = C == M ? v.constructor : r, W = A ? Bl(A) : "";
        if (W)
          switch (W) {
            case Are:
              return Te;
            case Pre:
              return ne;
            case Rre:
              return R;
            case Nre:
              return X;
            case Dre:
              return de;
          }
        return C;
      });
      function Zne(v, C, A) {
        for (var W = -1, ie = A.length; ++W < ie; ) {
          var Ce = A[W], we = Ce.size;
          switch (Ce.type) {
            case "drop":
              v += we;
              break;
            case "dropRight":
              C -= we;
              break;
            case "take":
              C = za(C, v + we);
              break;
            case "takeRight":
              v = ga(v, C - we);
              break;
          }
        }
        return { start: v, end: C };
      }
      function Xne(v) {
        var C = v.match(_e);
        return C ? C[1].split(Ke) : [];
      }
      function RP(v, C, A) {
        C = al(C, v);
        for (var W = -1, ie = C.length, Ce = !1; ++W < ie; ) {
          var we = qo(C[W]);
          if (!(Ce = v != null && A(v, we)))
            break;
          v = v[we];
        }
        return Ce || ++W != ie ? Ce : (ie = v == null ? 0 : v.length, !!ie && jg(ie) && xs(we, ie) && (Or(v) || zl(v)));
      }
      function Jne(v) {
        var C = v.length, A = new v.constructor(C);
        return C && typeof v[0] == "string" && mn.call(v, "index") && (A.index = v.index, A.input = v.input), A;
      }
      function NP(v) {
        return typeof v.constructor == "function" && !cf(v) ? lu(cg(v)) : {};
      }
      function Qne(v, C, A) {
        var W = v.constructor;
        switch (C) {
          case Ee:
            return gS(v);
          case oe:
          case fe:
            return new W(+v);
          case Te:
            return jne(v, A);
          case Le:
          case Ie:
          case De:
          case Ae:
          case Fe:
          case Ne:
          case qe:
          case Qe:
          case tt:
            return hP(v, A);
          case ne:
            return new W();
          case me:
          case pe:
            return new W(v);
          case Y:
            return Lne(v);
          case X:
            return new W();
          case $e:
            return kne(v);
        }
      }
      function eae(v, C) {
        var A = C.length;
        if (!A)
          return v;
        var W = A - 1;
        return C[W] = (A > 1 ? "& " : "") + C[W], C = C.join(A > 2 ? ", " : " "), v.replace(Wt, `{
/* [wrapped with ` + C + `] */
`);
      }
      function tae(v) {
        return Or(v) || zl(v) || !!(FA && v && v[FA]);
      }
      function xs(v, C) {
        var A = typeof v;
        return C = C ?? H, !!C && (A == "number" || A != "symbol" && yt.test(v)) && v > -1 && v % 1 == 0 && v < C;
      }
      function Qa(v, C, A) {
        if (!Bn(A))
          return !1;
        var W = typeof C;
        return (W == "number" ? mi(A) && xs(C, A.length) : W == "string" && C in A) ? ho(A[C], v) : !1;
      }
      function ES(v, C) {
        if (Or(v))
          return !1;
        var A = typeof v;
        return A == "number" || A == "symbol" || A == "boolean" || v == null || Ai(v) ? !0 : _t.test(v) || !Je.test(v) || C != null && v in xn(C);
      }
      function rae(v) {
        var C = typeof v;
        return C == "string" || C == "number" || C == "symbol" || C == "boolean" ? v !== "__proto__" : v === null;
      }
      function wS(v) {
        var C = Tg(v), A = ge[C];
        if (typeof A != "function" || !(C in Hr.prototype))
          return !1;
        if (v === A)
          return !0;
        var W = xS(A);
        return !!W && v === W[0];
      }
      function nae(v) {
        return !!DA && DA in v;
      }
      var aae = ag ? $s : VS;
      function cf(v) {
        var C = v && v.constructor, A = typeof C == "function" && C.prototype || iu;
        return v === A;
      }
      function DP(v) {
        return v === v && !Bn(v);
      }
      function jP(v, C) {
        return function(A) {
          return A == null ? !1 : A[v] === C && (C !== r || v in xn(A));
        };
      }
      function iae(v) {
        var C = Ng(v, function(W) {
          return A.size === c && A.clear(), W;
        }), A = C.cache;
        return C;
      }
      function oae(v, C) {
        var A = v[1], W = C[1], ie = A | W, Ce = ie < (y | S | O), we = W == O && A == b || W == O && A == T && v[7].length <= C[8] || W == (O | T) && C[7].length <= C[8] && A == b;
        if (!(Ce || we))
          return v;
        W & y && (v[2] = C[2], ie |= A & y ? 0 : x);
        var Me = C[3];
        if (Me) {
          var je = v[3];
          v[3] = je ? yP(je, Me, C[4]) : Me, v[4] = je ? el(v[3], u) : C[4];
        }
        return Me = C[5], Me && (je = v[5], v[5] = je ? bP(je, Me, C[6]) : Me, v[6] = je ? el(v[5], u) : C[6]), Me = C[7], Me && (v[7] = Me), W & O && (v[8] = v[8] == null ? C[8] : za(v[8], C[8])), v[9] == null && (v[9] = C[9]), v[0] = C[0], v[1] = ie, v;
      }
      function sae(v) {
        var C = [];
        if (v != null)
          for (var A in xn(v))
            C.push(A);
        return C;
      }
      function lae(v) {
        return og.call(v);
      }
      function LP(v, C, A) {
        return C = ga(C === r ? v.length - 1 : C, 0), function() {
          for (var W = arguments, ie = -1, Ce = ga(W.length - C, 0), we = We(Ce); ++ie < Ce; )
            we[ie] = W[C + ie];
          ie = -1;
          for (var Me = We(C + 1); ++ie < C; )
            Me[ie] = W[ie];
          return Me[C] = A(we), Ti(v, this, Me);
        };
      }
      function kP(v, C) {
        return C.length < 2 ? v : kl(v, Ji(C, 0, -1));
      }
      function cae(v, C) {
        for (var A = v.length, W = za(C.length, A), ie = pi(v); W--; ) {
          var Ce = C[W];
          v[W] = xs(Ce, A) ? ie[Ce] : r;
        }
        return v;
      }
      function OS(v, C) {
        if (!(C === "constructor" && typeof v[C] == "function") && C != "__proto__")
          return v[C];
      }
      var FP = zP(lP), uf = _re || function(v, C) {
        return Pa.setTimeout(v, C);
      }, TS = zP(Pne);
      function BP(v, C, A) {
        var W = C + "";
        return TS(v, eae(W, uae(Xne(W), A)));
      }
      function zP(v) {
        var C = 0, A = 0;
        return function() {
          var W = Tre(), ie = L - (W - A);
          if (A = W, ie > 0) {
            if (++C >= B)
              return arguments[0];
          } else
            C = 0;
          return v.apply(r, arguments);
        };
      }
      function Mg(v, C) {
        var A = -1, W = v.length, ie = W - 1;
        for (C = C === r ? W : C; ++A < C; ) {
          var Ce = uS(A, ie), we = v[Ce];
          v[Ce] = v[A], v[A] = we;
        }
        return v.length = C, v;
      }
      var HP = iae(function(v) {
        var C = [];
        return v.charCodeAt(0) === 46 && C.push(""), v.replace(Vt, function(A, W, ie, Ce) {
          C.push(ie ? Ce.replace(ke, "$1") : W || A);
        }), C;
      });
      function qo(v) {
        if (typeof v == "string" || Ai(v))
          return v;
        var C = v + "";
        return C == "0" && 1 / v == -1 / 0 ? "-0" : C;
      }
      function Bl(v) {
        if (v != null) {
          try {
            return ig.call(v);
          } catch {
          }
          try {
            return v + "";
          } catch {
          }
        }
        return "";
      }
      function uae(v, C) {
        return Ki(ee, function(A) {
          var W = "_." + A[0];
          C & A[1] && !eg(v, W) && v.push(W);
        }), v.sort();
      }
      function VP(v) {
        if (v instanceof Hr)
          return v.clone();
        var C = new Zi(v.__wrapped__, v.__chain__);
        return C.__actions__ = pi(v.__actions__), C.__index__ = v.__index__, C.__values__ = v.__values__, C;
      }
      function dae(v, C, A) {
        (A ? Qa(v, C, A) : C === r) ? C = 1 : C = ga(Ar(C), 0);
        var W = v == null ? 0 : v.length;
        if (!W || C < 1)
          return [];
        for (var ie = 0, Ce = 0, we = We(fg(W / C)); ie < W; )
          we[Ce++] = Ji(v, ie, ie += C);
        return we;
      }
      function fae(v) {
        for (var C = -1, A = v == null ? 0 : v.length, W = 0, ie = []; ++C < A; ) {
          var Ce = v[C];
          Ce && (ie[W++] = Ce);
        }
        return ie;
      }
      function pae() {
        var v = arguments.length;
        if (!v)
          return [];
        for (var C = We(v - 1), A = arguments[0], W = v; W--; )
          C[W - 1] = arguments[W];
        return Qs(Or(A) ? pi(A) : [A], Ra(C, 1));
      }
      var mae = Dr(function(v, C) {
        return Qn(v) ? nf(v, Ra(C, 1, Qn, !0)) : [];
      }), vae = Dr(function(v, C) {
        var A = Qi(C);
        return Qn(A) && (A = r), Qn(v) ? nf(v, Ra(C, 1, Qn, !0), ur(A, 2)) : [];
      }), hae = Dr(function(v, C) {
        var A = Qi(C);
        return Qn(A) && (A = r), Qn(v) ? nf(v, Ra(C, 1, Qn, !0), r, A) : [];
      });
      function gae(v, C, A) {
        var W = v == null ? 0 : v.length;
        return W ? (C = A || C === r ? 1 : Ar(C), Ji(v, C < 0 ? 0 : C, W)) : [];
      }
      function yae(v, C, A) {
        var W = v == null ? 0 : v.length;
        return W ? (C = A || C === r ? 1 : Ar(C), C = W - C, Ji(v, 0, C < 0 ? 0 : C)) : [];
      }
      function bae(v, C) {
        return v && v.length ? xg(v, ur(C, 3), !0, !0) : [];
      }
      function Cae(v, C) {
        return v && v.length ? xg(v, ur(C, 3), !0) : [];
      }
      function Sae(v, C, A, W) {
        var ie = v == null ? 0 : v.length;
        return ie ? (A && typeof A != "number" && Qa(v, C, A) && (A = 0, W = ie), pne(v, C, A, W)) : [];
      }
      function GP(v, C, A) {
        var W = v == null ? 0 : v.length;
        if (!W)
          return -1;
        var ie = A == null ? 0 : Ar(A);
        return ie < 0 && (ie = ga(W + ie, 0)), tg(v, ur(C, 3), ie);
      }
      function UP(v, C, A) {
        var W = v == null ? 0 : v.length;
        if (!W)
          return -1;
        var ie = W - 1;
        return A !== r && (ie = Ar(A), ie = A < 0 ? ga(W + ie, 0) : za(ie, W - 1)), tg(v, ur(C, 3), ie, !0);
      }
      function WP(v) {
        var C = v == null ? 0 : v.length;
        return C ? Ra(v, 1) : [];
      }
      function xae(v) {
        var C = v == null ? 0 : v.length;
        return C ? Ra(v, j) : [];
      }
      function $ae(v, C) {
        var A = v == null ? 0 : v.length;
        return A ? (C = C === r ? 1 : Ar(C), Ra(v, C)) : [];
      }
      function _ae(v) {
        for (var C = -1, A = v == null ? 0 : v.length, W = {}; ++C < A; ) {
          var ie = v[C];
          W[ie[0]] = ie[1];
        }
        return W;
      }
      function qP(v) {
        return v && v.length ? v[0] : r;
      }
      function Eae(v, C, A) {
        var W = v == null ? 0 : v.length;
        if (!W)
          return -1;
        var ie = A == null ? 0 : Ar(A);
        return ie < 0 && (ie = ga(W + ie, 0)), tu(v, C, ie);
      }
      function wae(v) {
        var C = v == null ? 0 : v.length;
        return C ? Ji(v, 0, -1) : [];
      }
      var Oae = Dr(function(v) {
        var C = Dn(v, vS);
        return C.length && C[0] === v[0] ? iS(C) : [];
      }), Tae = Dr(function(v) {
        var C = Qi(v), A = Dn(v, vS);
        return C === Qi(A) ? C = r : A.pop(), A.length && A[0] === v[0] ? iS(A, ur(C, 2)) : [];
      }), Iae = Dr(function(v) {
        var C = Qi(v), A = Dn(v, vS);
        return C = typeof C == "function" ? C : r, C && A.pop(), A.length && A[0] === v[0] ? iS(A, r, C) : [];
      });
      function Mae(v, C) {
        return v == null ? "" : wre.call(v, C);
      }
      function Qi(v) {
        var C = v == null ? 0 : v.length;
        return C ? v[C - 1] : r;
      }
      function Aae(v, C, A) {
        var W = v == null ? 0 : v.length;
        if (!W)
          return -1;
        var ie = W;
        return A !== r && (ie = Ar(A), ie = ie < 0 ? ga(W + ie, 0) : za(ie, W - 1)), C === C ? ure(v, C, ie) : tg(v, OA, ie, !0);
      }
      function Pae(v, C) {
        return v && v.length ? aP(v, Ar(C)) : r;
      }
      var Rae = Dr(KP);
      function KP(v, C) {
        return v && v.length && C && C.length ? cS(v, C) : v;
      }
      function Nae(v, C, A) {
        return v && v.length && C && C.length ? cS(v, C, ur(A, 2)) : v;
      }
      function Dae(v, C, A) {
        return v && v.length && C && C.length ? cS(v, C, r, A) : v;
      }
      var jae = Ss(function(v, C) {
        var A = v == null ? 0 : v.length, W = tS(v, C);
        return sP(v, Dn(C, function(ie) {
          return xs(ie, A) ? +ie : ie;
        }).sort(gP)), W;
      });
      function Lae(v, C) {
        var A = [];
        if (!(v && v.length))
          return A;
        var W = -1, ie = [], Ce = v.length;
        for (C = ur(C, 3); ++W < Ce; ) {
          var we = v[W];
          C(we, W, v) && (A.push(we), ie.push(W));
        }
        return sP(v, ie), A;
      }
      function IS(v) {
        return v == null ? v : Mre.call(v);
      }
      function kae(v, C, A) {
        var W = v == null ? 0 : v.length;
        return W ? (A && typeof A != "number" && Qa(v, C, A) ? (C = 0, A = W) : (C = C == null ? 0 : Ar(C), A = A === r ? W : Ar(A)), Ji(v, C, A)) : [];
      }
      function Fae(v, C) {
        return Sg(v, C);
      }
      function Bae(v, C, A) {
        return fS(v, C, ur(A, 2));
      }
      function zae(v, C) {
        var A = v == null ? 0 : v.length;
        if (A) {
          var W = Sg(v, C);
          if (W < A && ho(v[W], C))
            return W;
        }
        return -1;
      }
      function Hae(v, C) {
        return Sg(v, C, !0);
      }
      function Vae(v, C, A) {
        return fS(v, C, ur(A, 2), !0);
      }
      function Gae(v, C) {
        var A = v == null ? 0 : v.length;
        if (A) {
          var W = Sg(v, C, !0) - 1;
          if (ho(v[W], C))
            return W;
        }
        return -1;
      }
      function Uae(v) {
        return v && v.length ? cP(v) : [];
      }
      function Wae(v, C) {
        return v && v.length ? cP(v, ur(C, 2)) : [];
      }
      function qae(v) {
        var C = v == null ? 0 : v.length;
        return C ? Ji(v, 1, C) : [];
      }
      function Kae(v, C, A) {
        return v && v.length ? (C = A || C === r ? 1 : Ar(C), Ji(v, 0, C < 0 ? 0 : C)) : [];
      }
      function Yae(v, C, A) {
        var W = v == null ? 0 : v.length;
        return W ? (C = A || C === r ? 1 : Ar(C), C = W - C, Ji(v, C < 0 ? 0 : C, W)) : [];
      }
      function Zae(v, C) {
        return v && v.length ? xg(v, ur(C, 3), !1, !0) : [];
      }
      function Xae(v, C) {
        return v && v.length ? xg(v, ur(C, 3)) : [];
      }
      var Jae = Dr(function(v) {
        return nl(Ra(v, 1, Qn, !0));
      }), Qae = Dr(function(v) {
        var C = Qi(v);
        return Qn(C) && (C = r), nl(Ra(v, 1, Qn, !0), ur(C, 2));
      }), eie = Dr(function(v) {
        var C = Qi(v);
        return C = typeof C == "function" ? C : r, nl(Ra(v, 1, Qn, !0), r, C);
      });
      function tie(v) {
        return v && v.length ? nl(v) : [];
      }
      function rie(v, C) {
        return v && v.length ? nl(v, ur(C, 2)) : [];
      }
      function nie(v, C) {
        return C = typeof C == "function" ? C : r, v && v.length ? nl(v, r, C) : [];
      }
      function MS(v) {
        if (!(v && v.length))
          return [];
        var C = 0;
        return v = Js(v, function(A) {
          if (Qn(A))
            return C = ga(A.length, C), !0;
        }), qC(C, function(A) {
          return Dn(v, GC(A));
        });
      }
      function YP(v, C) {
        if (!(v && v.length))
          return [];
        var A = MS(v);
        return C == null ? A : Dn(A, function(W) {
          return Ti(C, r, W);
        });
      }
      var aie = Dr(function(v, C) {
        return Qn(v) ? nf(v, C) : [];
      }), iie = Dr(function(v) {
        return mS(Js(v, Qn));
      }), oie = Dr(function(v) {
        var C = Qi(v);
        return Qn(C) && (C = r), mS(Js(v, Qn), ur(C, 2));
      }), sie = Dr(function(v) {
        var C = Qi(v);
        return C = typeof C == "function" ? C : r, mS(Js(v, Qn), r, C);
      }), lie = Dr(MS);
      function cie(v, C) {
        return pP(v || [], C || [], rf);
      }
      function uie(v, C) {
        return pP(v || [], C || [], sf);
      }
      var die = Dr(function(v) {
        var C = v.length, A = C > 1 ? v[C - 1] : r;
        return A = typeof A == "function" ? (v.pop(), A) : r, YP(v, A);
      });
      function ZP(v) {
        var C = ge(v);
        return C.__chain__ = !0, C;
      }
      function fie(v, C) {
        return C(v), v;
      }
      function Ag(v, C) {
        return C(v);
      }
      var pie = Ss(function(v) {
        var C = v.length, A = C ? v[0] : 0, W = this.__wrapped__, ie = function(Ce) {
          return tS(Ce, v);
        };
        return C > 1 || this.__actions__.length || !(W instanceof Hr) || !xs(A) ? this.thru(ie) : (W = W.slice(A, +A + (C ? 1 : 0)), W.__actions__.push({
          func: Ag,
          args: [ie],
          thisArg: r
        }), new Zi(W, this.__chain__).thru(function(Ce) {
          return C && !Ce.length && Ce.push(r), Ce;
        }));
      });
      function mie() {
        return ZP(this);
      }
      function vie() {
        return new Zi(this.value(), this.__chain__);
      }
      function hie() {
        this.__values__ === r && (this.__values__ = u3(this.value()));
        var v = this.__index__ >= this.__values__.length, C = v ? r : this.__values__[this.__index__++];
        return { done: v, value: C };
      }
      function gie() {
        return this;
      }
      function yie(v) {
        for (var C, A = this; A instanceof hg; ) {
          var W = VP(A);
          W.__index__ = 0, W.__values__ = r, C ? ie.__wrapped__ = W : C = W;
          var ie = W;
          A = A.__wrapped__;
        }
        return ie.__wrapped__ = v, C;
      }
      function bie() {
        var v = this.__wrapped__;
        if (v instanceof Hr) {
          var C = v;
          return this.__actions__.length && (C = new Hr(this)), C = C.reverse(), C.__actions__.push({
            func: Ag,
            args: [IS],
            thisArg: r
          }), new Zi(C, this.__chain__);
        }
        return this.thru(IS);
      }
      function Cie() {
        return fP(this.__wrapped__, this.__actions__);
      }
      var Sie = $g(function(v, C, A) {
        mn.call(v, A) ? ++v[A] : bs(v, A, 1);
      });
      function xie(v, C, A) {
        var W = Or(v) ? EA : fne;
        return A && Qa(v, C, A) && (C = r), W(v, ur(C, 3));
      }
      function $ie(v, C) {
        var A = Or(v) ? Js : YA;
        return A(v, ur(C, 3));
      }
      var _ie = $P(GP), Eie = $P(UP);
      function wie(v, C) {
        return Ra(Pg(v, C), 1);
      }
      function Oie(v, C) {
        return Ra(Pg(v, C), j);
      }
      function Tie(v, C, A) {
        return A = A === r ? 1 : Ar(A), Ra(Pg(v, C), A);
      }
      function XP(v, C) {
        var A = Or(v) ? Ki : rl;
        return A(v, ur(C, 3));
      }
      function JP(v, C) {
        var A = Or(v) ? qte : KA;
        return A(v, ur(C, 3));
      }
      var Iie = $g(function(v, C, A) {
        mn.call(v, A) ? v[A].push(C) : bs(v, A, [C]);
      });
      function Mie(v, C, A, W) {
        v = mi(v) ? v : pu(v), A = A && !W ? Ar(A) : 0;
        var ie = v.length;
        return A < 0 && (A = ga(ie + A, 0)), Lg(v) ? A <= ie && v.indexOf(C, A) > -1 : !!ie && tu(v, C, A) > -1;
      }
      var Aie = Dr(function(v, C, A) {
        var W = -1, ie = typeof C == "function", Ce = mi(v) ? We(v.length) : [];
        return rl(v, function(we) {
          Ce[++W] = ie ? Ti(C, we, A) : af(we, C, A);
        }), Ce;
      }), Pie = $g(function(v, C, A) {
        bs(v, A, C);
      });
      function Pg(v, C) {
        var A = Or(v) ? Dn : tP;
        return A(v, ur(C, 3));
      }
      function Rie(v, C, A, W) {
        return v == null ? [] : (Or(C) || (C = C == null ? [] : [C]), A = W ? r : A, Or(A) || (A = A == null ? [] : [A]), iP(v, C, A));
      }
      var Nie = $g(function(v, C, A) {
        v[A ? 0 : 1].push(C);
      }, function() {
        return [[], []];
      });
      function Die(v, C, A) {
        var W = Or(v) ? HC : IA, ie = arguments.length < 3;
        return W(v, ur(C, 4), A, ie, rl);
      }
      function jie(v, C, A) {
        var W = Or(v) ? Kte : IA, ie = arguments.length < 3;
        return W(v, ur(C, 4), A, ie, KA);
      }
      function Lie(v, C) {
        var A = Or(v) ? Js : YA;
        return A(v, Dg(ur(C, 3)));
      }
      function kie(v) {
        var C = Or(v) ? GA : Mne;
        return C(v);
      }
      function Fie(v, C, A) {
        (A ? Qa(v, C, A) : C === r) ? C = 1 : C = Ar(C);
        var W = Or(v) ? sne : Ane;
        return W(v, C);
      }
      function Bie(v) {
        var C = Or(v) ? lne : Rne;
        return C(v);
      }
      function zie(v) {
        if (v == null)
          return 0;
        if (mi(v))
          return Lg(v) ? nu(v) : v.length;
        var C = Ha(v);
        return C == ne || C == X ? v.size : sS(v).length;
      }
      function Hie(v, C, A) {
        var W = Or(v) ? VC : Nne;
        return A && Qa(v, C, A) && (C = r), W(v, ur(C, 3));
      }
      var Vie = Dr(function(v, C) {
        if (v == null)
          return [];
        var A = C.length;
        return A > 1 && Qa(v, C[0], C[1]) ? C = [] : A > 2 && Qa(C[0], C[1], C[2]) && (C = [C[0]]), iP(v, Ra(C, 1), []);
      }), Rg = $re || function() {
        return Pa.Date.now();
      };
      function Gie(v, C) {
        if (typeof C != "function")
          throw new Yi(o);
        return v = Ar(v), function() {
          if (--v < 1)
            return C.apply(this, arguments);
        };
      }
      function QP(v, C, A) {
        return C = A ? r : C, C = v && C == null ? v.length : C, Cs(v, O, r, r, r, r, C);
      }
      function e3(v, C) {
        var A;
        if (typeof C != "function")
          throw new Yi(o);
        return v = Ar(v), function() {
          return --v > 0 && (A = C.apply(this, arguments)), v <= 1 && (C = r), A;
        };
      }
      var AS = Dr(function(v, C, A) {
        var W = y;
        if (A.length) {
          var ie = el(A, du(AS));
          W |= $;
        }
        return Cs(v, W, C, A, ie);
      }), t3 = Dr(function(v, C, A) {
        var W = y | S;
        if (A.length) {
          var ie = el(A, du(t3));
          W |= $;
        }
        return Cs(C, W, v, A, ie);
      });
      function r3(v, C, A) {
        C = A ? r : C;
        var W = Cs(v, b, r, r, r, r, r, C);
        return W.placeholder = r3.placeholder, W;
      }
      function n3(v, C, A) {
        C = A ? r : C;
        var W = Cs(v, _, r, r, r, r, r, C);
        return W.placeholder = n3.placeholder, W;
      }
      function a3(v, C, A) {
        var W, ie, Ce, we, Me, je, lt = 0, dt = !1, gt = !1, Gt = !0;
        if (typeof v != "function")
          throw new Yi(o);
        C = eo(C) || 0, Bn(A) && (dt = !!A.leading, gt = "maxWait" in A, Ce = gt ? ga(eo(A.maxWait) || 0, C) : Ce, Gt = "trailing" in A ? !!A.trailing : Gt);
        function Qt(ea) {
          var go = W, Es = ie;
          return W = ie = r, lt = ea, we = v.apply(Es, go), we;
        }
        function fr(ea) {
          return lt = ea, Me = uf(kr, C), dt ? Qt(ea) : we;
        }
        function Rr(ea) {
          var go = ea - je, Es = ea - lt, $3 = C - go;
          return gt ? za($3, Ce - Es) : $3;
        }
        function pr(ea) {
          var go = ea - je, Es = ea - lt;
          return je === r || go >= C || go < 0 || gt && Es >= Ce;
        }
        function kr() {
          var ea = Rg();
          if (pr(ea))
            return Wr(ea);
          Me = uf(kr, Rr(ea));
        }
        function Wr(ea) {
          return Me = r, Gt && W ? Qt(ea) : (W = ie = r, we);
        }
        function Pi() {
          Me !== r && mP(Me), lt = 0, W = je = ie = Me = r;
        }
        function ei() {
          return Me === r ? we : Wr(Rg());
        }
        function Ri() {
          var ea = Rg(), go = pr(ea);
          if (W = arguments, ie = this, je = ea, go) {
            if (Me === r)
              return fr(je);
            if (gt)
              return mP(Me), Me = uf(kr, C), Qt(je);
          }
          return Me === r && (Me = uf(kr, C)), we;
        }
        return Ri.cancel = Pi, Ri.flush = ei, Ri;
      }
      var Uie = Dr(function(v, C) {
        return qA(v, 1, C);
      }), Wie = Dr(function(v, C, A) {
        return qA(v, eo(C) || 0, A);
      });
      function qie(v) {
        return Cs(v, I);
      }
      function Ng(v, C) {
        if (typeof v != "function" || C != null && typeof C != "function")
          throw new Yi(o);
        var A = function() {
          var W = arguments, ie = C ? C.apply(this, W) : W[0], Ce = A.cache;
          if (Ce.has(ie))
            return Ce.get(ie);
          var we = v.apply(this, W);
          return A.cache = Ce.set(ie, we) || Ce, we;
        };
        return A.cache = new (Ng.Cache || ys)(), A;
      }
      Ng.Cache = ys;
      function Dg(v) {
        if (typeof v != "function")
          throw new Yi(o);
        return function() {
          var C = arguments;
          switch (C.length) {
            case 0:
              return !v.call(this);
            case 1:
              return !v.call(this, C[0]);
            case 2:
              return !v.call(this, C[0], C[1]);
            case 3:
              return !v.call(this, C[0], C[1], C[2]);
          }
          return !v.apply(this, C);
        };
      }
      function Kie(v) {
        return e3(2, v);
      }
      var Yie = Dne(function(v, C) {
        C = C.length == 1 && Or(C[0]) ? Dn(C[0], Ii(ur())) : Dn(Ra(C, 1), Ii(ur()));
        var A = C.length;
        return Dr(function(W) {
          for (var ie = -1, Ce = za(W.length, A); ++ie < Ce; )
            W[ie] = C[ie].call(this, W[ie]);
          return Ti(v, this, W);
        });
      }), PS = Dr(function(v, C) {
        var A = el(C, du(PS));
        return Cs(v, $, r, C, A);
      }), i3 = Dr(function(v, C) {
        var A = el(C, du(i3));
        return Cs(v, w, r, C, A);
      }), Zie = Ss(function(v, C) {
        return Cs(v, T, r, r, r, C);
      });
      function Xie(v, C) {
        if (typeof v != "function")
          throw new Yi(o);
        return C = C === r ? C : Ar(C), Dr(v, C);
      }
      function Jie(v, C) {
        if (typeof v != "function")
          throw new Yi(o);
        return C = C == null ? 0 : ga(Ar(C), 0), Dr(function(A) {
          var W = A[C], ie = il(A, 0, C);
          return W && Qs(ie, W), Ti(v, this, ie);
        });
      }
      function Qie(v, C, A) {
        var W = !0, ie = !0;
        if (typeof v != "function")
          throw new Yi(o);
        return Bn(A) && (W = "leading" in A ? !!A.leading : W, ie = "trailing" in A ? !!A.trailing : ie), a3(v, C, {
          leading: W,
          maxWait: C,
          trailing: ie
        });
      }
      function eoe(v) {
        return QP(v, 1);
      }
      function toe(v, C) {
        return PS(hS(C), v);
      }
      function roe() {
        if (!arguments.length)
          return [];
        var v = arguments[0];
        return Or(v) ? v : [v];
      }
      function noe(v) {
        return Xi(v, m);
      }
      function aoe(v, C) {
        return C = typeof C == "function" ? C : r, Xi(v, m, C);
      }
      function ioe(v) {
        return Xi(v, d | m);
      }
      function ooe(v, C) {
        return C = typeof C == "function" ? C : r, Xi(v, d | m, C);
      }
      function soe(v, C) {
        return C == null || WA(v, C, $a(C));
      }
      function ho(v, C) {
        return v === C || v !== v && C !== C;
      }
      var loe = Og(aS), coe = Og(function(v, C) {
        return v >= C;
      }), zl = JA(/* @__PURE__ */ function() {
        return arguments;
      }()) ? JA : function(v) {
        return qn(v) && mn.call(v, "callee") && !kA.call(v, "callee");
      }, Or = We.isArray, uoe = bA ? Ii(bA) : yne;
      function mi(v) {
        return v != null && jg(v.length) && !$s(v);
      }
      function Qn(v) {
        return qn(v) && mi(v);
      }
      function doe(v) {
        return v === !0 || v === !1 || qn(v) && Ja(v) == oe;
      }
      var ol = Ere || VS, foe = CA ? Ii(CA) : bne;
      function poe(v) {
        return qn(v) && v.nodeType === 1 && !df(v);
      }
      function moe(v) {
        if (v == null)
          return !0;
        if (mi(v) && (Or(v) || typeof v == "string" || typeof v.splice == "function" || ol(v) || fu(v) || zl(v)))
          return !v.length;
        var C = Ha(v);
        if (C == ne || C == X)
          return !v.size;
        if (cf(v))
          return !sS(v).length;
        for (var A in v)
          if (mn.call(v, A))
            return !1;
        return !0;
      }
      function voe(v, C) {
        return of(v, C);
      }
      function hoe(v, C, A) {
        A = typeof A == "function" ? A : r;
        var W = A ? A(v, C) : r;
        return W === r ? of(v, C, r, A) : !!W;
      }
      function RS(v) {
        if (!qn(v))
          return !1;
        var C = Ja(v);
        return C == se || C == le || typeof v.message == "string" && typeof v.name == "string" && !df(v);
      }
      function goe(v) {
        return typeof v == "number" && BA(v);
      }
      function $s(v) {
        if (!Bn(v))
          return !1;
        var C = Ja(v);
        return C == Q || C == he || C == re || C == q;
      }
      function o3(v) {
        return typeof v == "number" && v == Ar(v);
      }
      function jg(v) {
        return typeof v == "number" && v > -1 && v % 1 == 0 && v <= H;
      }
      function Bn(v) {
        var C = typeof v;
        return v != null && (C == "object" || C == "function");
      }
      function qn(v) {
        return v != null && typeof v == "object";
      }
      var s3 = SA ? Ii(SA) : Sne;
      function yoe(v, C) {
        return v === C || oS(v, C, $S(C));
      }
      function boe(v, C, A) {
        return A = typeof A == "function" ? A : r, oS(v, C, $S(C), A);
      }
      function Coe(v) {
        return l3(v) && v != +v;
      }
      function Soe(v) {
        if (aae(v))
          throw new wr(i);
        return QA(v);
      }
      function xoe(v) {
        return v === null;
      }
      function $oe(v) {
        return v == null;
      }
      function l3(v) {
        return typeof v == "number" || qn(v) && Ja(v) == me;
      }
      function df(v) {
        if (!qn(v) || Ja(v) != M)
          return !1;
        var C = cg(v);
        if (C === null)
          return !0;
        var A = mn.call(C, "constructor") && C.constructor;
        return typeof A == "function" && A instanceof A && ig.call(A) == bre;
      }
      var NS = xA ? Ii(xA) : xne;
      function _oe(v) {
        return o3(v) && v >= -9007199254740991 && v <= H;
      }
      var c3 = $A ? Ii($A) : $ne;
      function Lg(v) {
        return typeof v == "string" || !Or(v) && qn(v) && Ja(v) == pe;
      }
      function Ai(v) {
        return typeof v == "symbol" || qn(v) && Ja(v) == $e;
      }
      var fu = _A ? Ii(_A) : _ne;
      function Eoe(v) {
        return v === r;
      }
      function woe(v) {
        return qn(v) && Ha(v) == de;
      }
      function Ooe(v) {
        return qn(v) && Ja(v) == Se;
      }
      var Toe = Og(lS), Ioe = Og(function(v, C) {
        return v <= C;
      });
      function u3(v) {
        if (!v)
          return [];
        if (mi(v))
          return Lg(v) ? mo(v) : pi(v);
        if (Xd && v[Xd])
          return sre(v[Xd]());
        var C = Ha(v), A = C == ne ? YC : C == X ? rg : pu;
        return A(v);
      }
      function _s(v) {
        if (!v)
          return v === 0 ? v : 0;
        if (v = eo(v), v === j || v === -1 / 0) {
          var C = v < 0 ? -1 : 1;
          return C * U;
        }
        return v === v ? v : 0;
      }
      function Ar(v) {
        var C = _s(v), A = C % 1;
        return C === C ? A ? C - A : C : 0;
      }
      function d3(v) {
        return v ? Ll(Ar(v), 0, V) : 0;
      }
      function eo(v) {
        if (typeof v == "number")
          return v;
        if (Ai(v))
          return G;
        if (Bn(v)) {
          var C = typeof v.valueOf == "function" ? v.valueOf() : v;
          v = Bn(C) ? C + "" : C;
        }
        if (typeof v != "string")
          return v === 0 ? v : +v;
        v = MA(v);
        var A = zt.test(v);
        return A || ft.test(v) ? Gte(v.slice(2), A ? 2 : 8) : Et.test(v) ? G : +v;
      }
      function f3(v) {
        return Wo(v, vi(v));
      }
      function Moe(v) {
        return v ? Ll(Ar(v), -9007199254740991, H) : v === 0 ? v : 0;
      }
      function an(v) {
        return v == null ? "" : Mi(v);
      }
      var Aoe = cu(function(v, C) {
        if (cf(C) || mi(C)) {
          Wo(C, $a(C), v);
          return;
        }
        for (var A in C)
          mn.call(C, A) && rf(v, A, C[A]);
      }), p3 = cu(function(v, C) {
        Wo(C, vi(C), v);
      }), kg = cu(function(v, C, A, W) {
        Wo(C, vi(C), v, W);
      }), Poe = cu(function(v, C, A, W) {
        Wo(C, $a(C), v, W);
      }), Roe = Ss(tS);
      function Noe(v, C) {
        var A = lu(v);
        return C == null ? A : UA(A, C);
      }
      var Doe = Dr(function(v, C) {
        v = xn(v);
        var A = -1, W = C.length, ie = W > 2 ? C[2] : r;
        for (ie && Qa(C[0], C[1], ie) && (W = 1); ++A < W; )
          for (var Ce = C[A], we = vi(Ce), Me = -1, je = we.length; ++Me < je; ) {
            var lt = we[Me], dt = v[lt];
            (dt === r || ho(dt, iu[lt]) && !mn.call(v, lt)) && (v[lt] = Ce[lt]);
          }
        return v;
      }), joe = Dr(function(v) {
        return v.push(r, MP), Ti(m3, r, v);
      });
      function Loe(v, C) {
        return wA(v, ur(C, 3), Uo);
      }
      function koe(v, C) {
        return wA(v, ur(C, 3), nS);
      }
      function Foe(v, C) {
        return v == null ? v : rS(v, ur(C, 3), vi);
      }
      function Boe(v, C) {
        return v == null ? v : ZA(v, ur(C, 3), vi);
      }
      function zoe(v, C) {
        return v && Uo(v, ur(C, 3));
      }
      function Hoe(v, C) {
        return v && nS(v, ur(C, 3));
      }
      function Voe(v) {
        return v == null ? [] : bg(v, $a(v));
      }
      function Goe(v) {
        return v == null ? [] : bg(v, vi(v));
      }
      function DS(v, C, A) {
        var W = v == null ? r : kl(v, C);
        return W === r ? A : W;
      }
      function Uoe(v, C) {
        return v != null && RP(v, C, mne);
      }
      function jS(v, C) {
        return v != null && RP(v, C, vne);
      }
      var Woe = EP(function(v, C, A) {
        C != null && typeof C.toString != "function" && (C = og.call(C)), v[C] = A;
      }, kS(hi)), qoe = EP(function(v, C, A) {
        C != null && typeof C.toString != "function" && (C = og.call(C)), mn.call(v, C) ? v[C].push(A) : v[C] = [A];
      }, ur), Koe = Dr(af);
      function $a(v) {
        return mi(v) ? VA(v) : sS(v);
      }
      function vi(v) {
        return mi(v) ? VA(v, !0) : Ene(v);
      }
      function Yoe(v, C) {
        var A = {};
        return C = ur(C, 3), Uo(v, function(W, ie, Ce) {
          bs(A, C(W, ie, Ce), W);
        }), A;
      }
      function Zoe(v, C) {
        var A = {};
        return C = ur(C, 3), Uo(v, function(W, ie, Ce) {
          bs(A, ie, C(W, ie, Ce));
        }), A;
      }
      var Xoe = cu(function(v, C, A) {
        Cg(v, C, A);
      }), m3 = cu(function(v, C, A, W) {
        Cg(v, C, A, W);
      }), Joe = Ss(function(v, C) {
        var A = {};
        if (v == null)
          return A;
        var W = !1;
        C = Dn(C, function(Ce) {
          return Ce = al(Ce, v), W || (W = Ce.length > 1), Ce;
        }), Wo(v, SS(v), A), W && (A = Xi(A, d | f | m, Wne));
        for (var ie = C.length; ie--; )
          pS(A, C[ie]);
        return A;
      });
      function Qoe(v, C) {
        return v3(v, Dg(ur(C)));
      }
      var ese = Ss(function(v, C) {
        return v == null ? {} : One(v, C);
      });
      function v3(v, C) {
        if (v == null)
          return {};
        var A = Dn(SS(v), function(W) {
          return [W];
        });
        return C = ur(C), oP(v, A, function(W, ie) {
          return C(W, ie[0]);
        });
      }
      function tse(v, C, A) {
        C = al(C, v);
        var W = -1, ie = C.length;
        for (ie || (ie = 1, v = r); ++W < ie; ) {
          var Ce = v == null ? r : v[qo(C[W])];
          Ce === r && (W = ie, Ce = A), v = $s(Ce) ? Ce.call(v) : Ce;
        }
        return v;
      }
      function rse(v, C, A) {
        return v == null ? v : sf(v, C, A);
      }
      function nse(v, C, A, W) {
        return W = typeof W == "function" ? W : r, v == null ? v : sf(v, C, A, W);
      }
      var h3 = TP($a), g3 = TP(vi);
      function ase(v, C, A) {
        var W = Or(v), ie = W || ol(v) || fu(v);
        if (C = ur(C, 4), A == null) {
          var Ce = v && v.constructor;
          ie ? A = W ? new Ce() : [] : Bn(v) ? A = $s(Ce) ? lu(cg(v)) : {} : A = {};
        }
        return (ie ? Ki : Uo)(v, function(we, Me, je) {
          return C(A, we, Me, je);
        }), A;
      }
      function ise(v, C) {
        return v == null ? !0 : pS(v, C);
      }
      function ose(v, C, A) {
        return v == null ? v : dP(v, C, hS(A));
      }
      function sse(v, C, A, W) {
        return W = typeof W == "function" ? W : r, v == null ? v : dP(v, C, hS(A), W);
      }
      function pu(v) {
        return v == null ? [] : KC(v, $a(v));
      }
      function lse(v) {
        return v == null ? [] : KC(v, vi(v));
      }
      function cse(v, C, A) {
        return A === r && (A = C, C = r), A !== r && (A = eo(A), A = A === A ? A : 0), C !== r && (C = eo(C), C = C === C ? C : 0), Ll(eo(v), C, A);
      }
      function use(v, C, A) {
        return C = _s(C), A === r ? (A = C, C = 0) : A = _s(A), v = eo(v), hne(v, C, A);
      }
      function dse(v, C, A) {
        if (A && typeof A != "boolean" && Qa(v, C, A) && (C = A = r), A === r && (typeof C == "boolean" ? (A = C, C = r) : typeof v == "boolean" && (A = v, v = r)), v === r && C === r ? (v = 0, C = 1) : (v = _s(v), C === r ? (C = v, v = 0) : C = _s(C)), v > C) {
          var W = v;
          v = C, C = W;
        }
        if (A || v % 1 || C % 1) {
          var ie = zA();
          return za(v + ie * (C - v + Vte("1e-" + ((ie + "").length - 1))), C);
        }
        return uS(v, C);
      }
      var fse = uu(function(v, C, A) {
        return C = C.toLowerCase(), v + (A ? y3(C) : C);
      });
      function y3(v) {
        return LS(an(v).toLowerCase());
      }
      function b3(v) {
        return v = an(v), v && v.replace(Rt, rre).replace(yr, "");
      }
      function pse(v, C, A) {
        v = an(v), C = Mi(C);
        var W = v.length;
        A = A === r ? W : Ll(Ar(A), 0, W);
        var ie = A;
        return A -= C.length, A >= 0 && v.slice(A, ie) == C;
      }
      function mse(v) {
        return v = an(v), v && pt.test(v) ? v.replace(xt, nre) : v;
      }
      function vse(v) {
        return v = an(v), v && Ct.test(v) ? v.replace(ot, "\\$&") : v;
      }
      var hse = uu(function(v, C, A) {
        return v + (A ? "-" : "") + C.toLowerCase();
      }), gse = uu(function(v, C, A) {
        return v + (A ? " " : "") + C.toLowerCase();
      }), yse = xP("toLowerCase");
      function bse(v, C, A) {
        v = an(v), C = Ar(C);
        var W = C ? nu(v) : 0;
        if (!C || W >= C)
          return v;
        var ie = (C - W) / 2;
        return wg(pg(ie), A) + v + wg(fg(ie), A);
      }
      function Cse(v, C, A) {
        v = an(v), C = Ar(C);
        var W = C ? nu(v) : 0;
        return C && W < C ? v + wg(C - W, A) : v;
      }
      function Sse(v, C, A) {
        v = an(v), C = Ar(C);
        var W = C ? nu(v) : 0;
        return C && W < C ? wg(C - W, A) + v : v;
      }
      function xse(v, C, A) {
        return A || C == null ? C = 0 : C && (C = +C), Ire(an(v).replace(rt, ""), C || 0);
      }
      function $se(v, C, A) {
        return (A ? Qa(v, C, A) : C === r) ? C = 1 : C = Ar(C), dS(an(v), C);
      }
      function _se() {
        var v = arguments, C = an(v[0]);
        return v.length < 3 ? C : C.replace(v[1], v[2]);
      }
      var Ese = uu(function(v, C, A) {
        return v + (A ? "_" : "") + C.toLowerCase();
      });
      function wse(v, C, A) {
        return A && typeof A != "number" && Qa(v, C, A) && (C = A = r), A = A === r ? V : A >>> 0, A ? (v = an(v), v && (typeof C == "string" || C != null && !NS(C)) && (C = Mi(C), !C && ru(v)) ? il(mo(v), 0, A) : v.split(C, A)) : [];
      }
      var Ose = uu(function(v, C, A) {
        return v + (A ? " " : "") + LS(C);
      });
      function Tse(v, C, A) {
        return v = an(v), A = A == null ? 0 : Ll(Ar(A), 0, v.length), C = Mi(C), v.slice(A, A + C.length) == C;
      }
      function Ise(v, C, A) {
        var W = ge.templateSettings;
        A && Qa(v, C, A) && (C = r), v = an(v), C = kg({}, C, W, IP);
        var ie = kg({}, C.imports, W.imports, IP), Ce = $a(ie), we = KC(ie, Ce), Me, je, lt = 0, dt = C.interpolate || Ht, gt = "__p += '", Gt = ZC(
          (C.escape || Ht).source + "|" + dt.source + "|" + (dt === bt ? ut : Ht).source + "|" + (C.evaluate || Ht).source + "|$",
          "g"
        ), Qt = "//# sourceURL=" + (mn.call(C, "sourceURL") ? (C.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Qh + "]") + `
`;
        v.replace(Gt, function(pr, kr, Wr, Pi, ei, Ri) {
          return Wr || (Wr = Pi), gt += v.slice(lt, Ri).replace(ir, are), kr && (Me = !0, gt += `' +
__e(` + kr + `) +
'`), ei && (je = !0, gt += `';
` + ei + `;
__p += '`), Wr && (gt += `' +
((__t = (` + Wr + `)) == null ? '' : __t) +
'`), lt = Ri + pr.length, pr;
        }), gt += `';
`;
        var fr = mn.call(C, "variable") && C.variable;
        if (!fr)
          gt = `with (obj) {
` + gt + `
}
`;
        else if (Ve.test(fr))
          throw new wr(s);
        gt = (je ? gt.replace(Ge, "") : gt).replace(it, "$1").replace(ht, "$1;"), gt = "function(" + (fr || "obj") + `) {
` + (fr ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Me ? ", __e = _.escape" : "") + (je ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + gt + `return __p
}`;
        var Rr = S3(function() {
          return rn(Ce, Qt + "return " + gt).apply(r, we);
        });
        if (Rr.source = gt, RS(Rr))
          throw Rr;
        return Rr;
      }
      function Mse(v) {
        return an(v).toLowerCase();
      }
      function Ase(v) {
        return an(v).toUpperCase();
      }
      function Pse(v, C, A) {
        if (v = an(v), v && (A || C === r))
          return MA(v);
        if (!v || !(C = Mi(C)))
          return v;
        var W = mo(v), ie = mo(C), Ce = AA(W, ie), we = PA(W, ie) + 1;
        return il(W, Ce, we).join("");
      }
      function Rse(v, C, A) {
        if (v = an(v), v && (A || C === r))
          return v.slice(0, NA(v) + 1);
        if (!v || !(C = Mi(C)))
          return v;
        var W = mo(v), ie = PA(W, mo(C)) + 1;
        return il(W, 0, ie).join("");
      }
      function Nse(v, C, A) {
        if (v = an(v), v && (A || C === r))
          return v.replace(rt, "");
        if (!v || !(C = Mi(C)))
          return v;
        var W = mo(v), ie = AA(W, mo(C));
        return il(W, ie).join("");
      }
      function Dse(v, C) {
        var A = P, W = D;
        if (Bn(C)) {
          var ie = "separator" in C ? C.separator : ie;
          A = "length" in C ? Ar(C.length) : A, W = "omission" in C ? Mi(C.omission) : W;
        }
        v = an(v);
        var Ce = v.length;
        if (ru(v)) {
          var we = mo(v);
          Ce = we.length;
        }
        if (A >= Ce)
          return v;
        var Me = A - nu(W);
        if (Me < 1)
          return W;
        var je = we ? il(we, 0, Me).join("") : v.slice(0, Me);
        if (ie === r)
          return je + W;
        if (we && (Me += je.length - Me), NS(ie)) {
          if (v.slice(Me).search(ie)) {
            var lt, dt = je;
            for (ie.global || (ie = ZC(ie.source, an(st.exec(ie)) + "g")), ie.lastIndex = 0; lt = ie.exec(dt); )
              var gt = lt.index;
            je = je.slice(0, gt === r ? Me : gt);
          }
        } else if (v.indexOf(Mi(ie), Me) != Me) {
          var Gt = je.lastIndexOf(ie);
          Gt > -1 && (je = je.slice(0, Gt));
        }
        return je + W;
      }
      function jse(v) {
        return v = an(v), v && Xe.test(v) ? v.replace(It, dre) : v;
      }
      var Lse = uu(function(v, C, A) {
        return v + (A ? " " : "") + C.toUpperCase();
      }), LS = xP("toUpperCase");
      function C3(v, C, A) {
        return v = an(v), C = A ? r : C, C === r ? ore(v) ? mre(v) : Xte(v) : v.match(C) || [];
      }
      var S3 = Dr(function(v, C) {
        try {
          return Ti(v, r, C);
        } catch (A) {
          return RS(A) ? A : new wr(A);
        }
      }), kse = Ss(function(v, C) {
        return Ki(C, function(A) {
          A = qo(A), bs(v, A, AS(v[A], v));
        }), v;
      });
      function Fse(v) {
        var C = v == null ? 0 : v.length, A = ur();
        return v = C ? Dn(v, function(W) {
          if (typeof W[1] != "function")
            throw new Yi(o);
          return [A(W[0]), W[1]];
        }) : [], Dr(function(W) {
          for (var ie = -1; ++ie < C; ) {
            var Ce = v[ie];
            if (Ti(Ce[0], this, W))
              return Ti(Ce[1], this, W);
          }
        });
      }
      function Bse(v) {
        return dne(Xi(v, d));
      }
      function kS(v) {
        return function() {
          return v;
        };
      }
      function zse(v, C) {
        return v == null || v !== v ? C : v;
      }
      var Hse = _P(), Vse = _P(!0);
      function hi(v) {
        return v;
      }
      function FS(v) {
        return eP(typeof v == "function" ? v : Xi(v, d));
      }
      function Gse(v) {
        return rP(Xi(v, d));
      }
      function Use(v, C) {
        return nP(v, Xi(C, d));
      }
      var Wse = Dr(function(v, C) {
        return function(A) {
          return af(A, v, C);
        };
      }), qse = Dr(function(v, C) {
        return function(A) {
          return af(v, A, C);
        };
      });
      function BS(v, C, A) {
        var W = $a(C), ie = bg(C, W);
        A == null && !(Bn(C) && (ie.length || !W.length)) && (A = C, C = v, v = this, ie = bg(C, $a(C)));
        var Ce = !(Bn(A) && "chain" in A) || !!A.chain, we = $s(v);
        return Ki(ie, function(Me) {
          var je = C[Me];
          v[Me] = je, we && (v.prototype[Me] = function() {
            var lt = this.__chain__;
            if (Ce || lt) {
              var dt = v(this.__wrapped__), gt = dt.__actions__ = pi(this.__actions__);
              return gt.push({ func: je, args: arguments, thisArg: v }), dt.__chain__ = lt, dt;
            }
            return je.apply(v, Qs([this.value()], arguments));
          });
        }), v;
      }
      function Kse() {
        return Pa._ === this && (Pa._ = Cre), this;
      }
      function zS() {
      }
      function Yse(v) {
        return v = Ar(v), Dr(function(C) {
          return aP(C, v);
        });
      }
      var Zse = yS(Dn), Xse = yS(EA), Jse = yS(VC);
      function x3(v) {
        return ES(v) ? GC(qo(v)) : Tne(v);
      }
      function Qse(v) {
        return function(C) {
          return v == null ? r : kl(v, C);
        };
      }
      var ele = wP(), tle = wP(!0);
      function HS() {
        return [];
      }
      function VS() {
        return !1;
      }
      function rle() {
        return {};
      }
      function nle() {
        return "";
      }
      function ale() {
        return !0;
      }
      function ile(v, C) {
        if (v = Ar(v), v < 1 || v > H)
          return [];
        var A = V, W = za(v, V);
        C = ur(C), v -= V;
        for (var ie = qC(W, C); ++A < v; )
          C(A);
        return ie;
      }
      function ole(v) {
        return Or(v) ? Dn(v, qo) : Ai(v) ? [v] : pi(HP(an(v)));
      }
      function sle(v) {
        var C = ++yre;
        return an(v) + C;
      }
      var lle = Eg(function(v, C) {
        return v + C;
      }, 0), cle = bS("ceil"), ule = Eg(function(v, C) {
        return v / C;
      }, 1), dle = bS("floor");
      function fle(v) {
        return v && v.length ? yg(v, hi, aS) : r;
      }
      function ple(v, C) {
        return v && v.length ? yg(v, ur(C, 2), aS) : r;
      }
      function mle(v) {
        return TA(v, hi);
      }
      function vle(v, C) {
        return TA(v, ur(C, 2));
      }
      function hle(v) {
        return v && v.length ? yg(v, hi, lS) : r;
      }
      function gle(v, C) {
        return v && v.length ? yg(v, ur(C, 2), lS) : r;
      }
      var yle = Eg(function(v, C) {
        return v * C;
      }, 1), ble = bS("round"), Cle = Eg(function(v, C) {
        return v - C;
      }, 0);
      function Sle(v) {
        return v && v.length ? WC(v, hi) : 0;
      }
      function xle(v, C) {
        return v && v.length ? WC(v, ur(C, 2)) : 0;
      }
      return ge.after = Gie, ge.ary = QP, ge.assign = Aoe, ge.assignIn = p3, ge.assignInWith = kg, ge.assignWith = Poe, ge.at = Roe, ge.before = e3, ge.bind = AS, ge.bindAll = kse, ge.bindKey = t3, ge.castArray = roe, ge.chain = ZP, ge.chunk = dae, ge.compact = fae, ge.concat = pae, ge.cond = Fse, ge.conforms = Bse, ge.constant = kS, ge.countBy = Sie, ge.create = Noe, ge.curry = r3, ge.curryRight = n3, ge.debounce = a3, ge.defaults = Doe, ge.defaultsDeep = joe, ge.defer = Uie, ge.delay = Wie, ge.difference = mae, ge.differenceBy = vae, ge.differenceWith = hae, ge.drop = gae, ge.dropRight = yae, ge.dropRightWhile = bae, ge.dropWhile = Cae, ge.fill = Sae, ge.filter = $ie, ge.flatMap = wie, ge.flatMapDeep = Oie, ge.flatMapDepth = Tie, ge.flatten = WP, ge.flattenDeep = xae, ge.flattenDepth = $ae, ge.flip = qie, ge.flow = Hse, ge.flowRight = Vse, ge.fromPairs = _ae, ge.functions = Voe, ge.functionsIn = Goe, ge.groupBy = Iie, ge.initial = wae, ge.intersection = Oae, ge.intersectionBy = Tae, ge.intersectionWith = Iae, ge.invert = Woe, ge.invertBy = qoe, ge.invokeMap = Aie, ge.iteratee = FS, ge.keyBy = Pie, ge.keys = $a, ge.keysIn = vi, ge.map = Pg, ge.mapKeys = Yoe, ge.mapValues = Zoe, ge.matches = Gse, ge.matchesProperty = Use, ge.memoize = Ng, ge.merge = Xoe, ge.mergeWith = m3, ge.method = Wse, ge.methodOf = qse, ge.mixin = BS, ge.negate = Dg, ge.nthArg = Yse, ge.omit = Joe, ge.omitBy = Qoe, ge.once = Kie, ge.orderBy = Rie, ge.over = Zse, ge.overArgs = Yie, ge.overEvery = Xse, ge.overSome = Jse, ge.partial = PS, ge.partialRight = i3, ge.partition = Nie, ge.pick = ese, ge.pickBy = v3, ge.property = x3, ge.propertyOf = Qse, ge.pull = Rae, ge.pullAll = KP, ge.pullAllBy = Nae, ge.pullAllWith = Dae, ge.pullAt = jae, ge.range = ele, ge.rangeRight = tle, ge.rearg = Zie, ge.reject = Lie, ge.remove = Lae, ge.rest = Xie, ge.reverse = IS, ge.sampleSize = Fie, ge.set = rse, ge.setWith = nse, ge.shuffle = Bie, ge.slice = kae, ge.sortBy = Vie, ge.sortedUniq = Uae, ge.sortedUniqBy = Wae, ge.split = wse, ge.spread = Jie, ge.tail = qae, ge.take = Kae, ge.takeRight = Yae, ge.takeRightWhile = Zae, ge.takeWhile = Xae, ge.tap = fie, ge.throttle = Qie, ge.thru = Ag, ge.toArray = u3, ge.toPairs = h3, ge.toPairsIn = g3, ge.toPath = ole, ge.toPlainObject = f3, ge.transform = ase, ge.unary = eoe, ge.union = Jae, ge.unionBy = Qae, ge.unionWith = eie, ge.uniq = tie, ge.uniqBy = rie, ge.uniqWith = nie, ge.unset = ise, ge.unzip = MS, ge.unzipWith = YP, ge.update = ose, ge.updateWith = sse, ge.values = pu, ge.valuesIn = lse, ge.without = aie, ge.words = C3, ge.wrap = toe, ge.xor = iie, ge.xorBy = oie, ge.xorWith = sie, ge.zip = lie, ge.zipObject = cie, ge.zipObjectDeep = uie, ge.zipWith = die, ge.entries = h3, ge.entriesIn = g3, ge.extend = p3, ge.extendWith = kg, BS(ge, ge), ge.add = lle, ge.attempt = S3, ge.camelCase = fse, ge.capitalize = y3, ge.ceil = cle, ge.clamp = cse, ge.clone = noe, ge.cloneDeep = ioe, ge.cloneDeepWith = ooe, ge.cloneWith = aoe, ge.conformsTo = soe, ge.deburr = b3, ge.defaultTo = zse, ge.divide = ule, ge.endsWith = pse, ge.eq = ho, ge.escape = mse, ge.escapeRegExp = vse, ge.every = xie, ge.find = _ie, ge.findIndex = GP, ge.findKey = Loe, ge.findLast = Eie, ge.findLastIndex = UP, ge.findLastKey = koe, ge.floor = dle, ge.forEach = XP, ge.forEachRight = JP, ge.forIn = Foe, ge.forInRight = Boe, ge.forOwn = zoe, ge.forOwnRight = Hoe, ge.get = DS, ge.gt = loe, ge.gte = coe, ge.has = Uoe, ge.hasIn = jS, ge.head = qP, ge.identity = hi, ge.includes = Mie, ge.indexOf = Eae, ge.inRange = use, ge.invoke = Koe, ge.isArguments = zl, ge.isArray = Or, ge.isArrayBuffer = uoe, ge.isArrayLike = mi, ge.isArrayLikeObject = Qn, ge.isBoolean = doe, ge.isBuffer = ol, ge.isDate = foe, ge.isElement = poe, ge.isEmpty = moe, ge.isEqual = voe, ge.isEqualWith = hoe, ge.isError = RS, ge.isFinite = goe, ge.isFunction = $s, ge.isInteger = o3, ge.isLength = jg, ge.isMap = s3, ge.isMatch = yoe, ge.isMatchWith = boe, ge.isNaN = Coe, ge.isNative = Soe, ge.isNil = $oe, ge.isNull = xoe, ge.isNumber = l3, ge.isObject = Bn, ge.isObjectLike = qn, ge.isPlainObject = df, ge.isRegExp = NS, ge.isSafeInteger = _oe, ge.isSet = c3, ge.isString = Lg, ge.isSymbol = Ai, ge.isTypedArray = fu, ge.isUndefined = Eoe, ge.isWeakMap = woe, ge.isWeakSet = Ooe, ge.join = Mae, ge.kebabCase = hse, ge.last = Qi, ge.lastIndexOf = Aae, ge.lowerCase = gse, ge.lowerFirst = yse, ge.lt = Toe, ge.lte = Ioe, ge.max = fle, ge.maxBy = ple, ge.mean = mle, ge.meanBy = vle, ge.min = hle, ge.minBy = gle, ge.stubArray = HS, ge.stubFalse = VS, ge.stubObject = rle, ge.stubString = nle, ge.stubTrue = ale, ge.multiply = yle, ge.nth = Pae, ge.noConflict = Kse, ge.noop = zS, ge.now = Rg, ge.pad = bse, ge.padEnd = Cse, ge.padStart = Sse, ge.parseInt = xse, ge.random = dse, ge.reduce = Die, ge.reduceRight = jie, ge.repeat = $se, ge.replace = _se, ge.result = tse, ge.round = ble, ge.runInContext = Re, ge.sample = kie, ge.size = zie, ge.snakeCase = Ese, ge.some = Hie, ge.sortedIndex = Fae, ge.sortedIndexBy = Bae, ge.sortedIndexOf = zae, ge.sortedLastIndex = Hae, ge.sortedLastIndexBy = Vae, ge.sortedLastIndexOf = Gae, ge.startCase = Ose, ge.startsWith = Tse, ge.subtract = Cle, ge.sum = Sle, ge.sumBy = xle, ge.template = Ise, ge.times = ile, ge.toFinite = _s, ge.toInteger = Ar, ge.toLength = d3, ge.toLower = Mse, ge.toNumber = eo, ge.toSafeInteger = Moe, ge.toString = an, ge.toUpper = Ase, ge.trim = Pse, ge.trimEnd = Rse, ge.trimStart = Nse, ge.truncate = Dse, ge.unescape = jse, ge.uniqueId = sle, ge.upperCase = Lse, ge.upperFirst = LS, ge.each = XP, ge.eachRight = JP, ge.first = qP, BS(ge, function() {
        var v = {};
        return Uo(ge, function(C, A) {
          mn.call(ge.prototype, A) || (v[A] = C);
        }), v;
      }(), { chain: !1 }), ge.VERSION = n, Ki(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(v) {
        ge[v].placeholder = ge;
      }), Ki(["drop", "take"], function(v, C) {
        Hr.prototype[v] = function(A) {
          A = A === r ? 1 : ga(Ar(A), 0);
          var W = this.__filtered__ && !C ? new Hr(this) : this.clone();
          return W.__filtered__ ? W.__takeCount__ = za(A, W.__takeCount__) : W.__views__.push({
            size: za(A, V),
            type: v + (W.__dir__ < 0 ? "Right" : "")
          }), W;
        }, Hr.prototype[v + "Right"] = function(A) {
          return this.reverse()[v](A).reverse();
        };
      }), Ki(["filter", "map", "takeWhile"], function(v, C) {
        var A = C + 1, W = A == N || A == F;
        Hr.prototype[v] = function(ie) {
          var Ce = this.clone();
          return Ce.__iteratees__.push({
            iteratee: ur(ie, 3),
            type: A
          }), Ce.__filtered__ = Ce.__filtered__ || W, Ce;
        };
      }), Ki(["head", "last"], function(v, C) {
        var A = "take" + (C ? "Right" : "");
        Hr.prototype[v] = function() {
          return this[A](1).value()[0];
        };
      }), Ki(["initial", "tail"], function(v, C) {
        var A = "drop" + (C ? "" : "Right");
        Hr.prototype[v] = function() {
          return this.__filtered__ ? new Hr(this) : this[A](1);
        };
      }), Hr.prototype.compact = function() {
        return this.filter(hi);
      }, Hr.prototype.find = function(v) {
        return this.filter(v).head();
      }, Hr.prototype.findLast = function(v) {
        return this.reverse().find(v);
      }, Hr.prototype.invokeMap = Dr(function(v, C) {
        return typeof v == "function" ? new Hr(this) : this.map(function(A) {
          return af(A, v, C);
        });
      }), Hr.prototype.reject = function(v) {
        return this.filter(Dg(ur(v)));
      }, Hr.prototype.slice = function(v, C) {
        v = Ar(v);
        var A = this;
        return A.__filtered__ && (v > 0 || C < 0) ? new Hr(A) : (v < 0 ? A = A.takeRight(-v) : v && (A = A.drop(v)), C !== r && (C = Ar(C), A = C < 0 ? A.dropRight(-C) : A.take(C - v)), A);
      }, Hr.prototype.takeRightWhile = function(v) {
        return this.reverse().takeWhile(v).reverse();
      }, Hr.prototype.toArray = function() {
        return this.take(V);
      }, Uo(Hr.prototype, function(v, C) {
        var A = /^(?:filter|find|map|reject)|While$/.test(C), W = /^(?:head|last)$/.test(C), ie = ge[W ? "take" + (C == "last" ? "Right" : "") : C], Ce = W || /^find/.test(C);
        ie && (ge.prototype[C] = function() {
          var we = this.__wrapped__, Me = W ? [1] : arguments, je = we instanceof Hr, lt = Me[0], dt = je || Or(we), gt = function(kr) {
            var Wr = ie.apply(ge, Qs([kr], Me));
            return W && Gt ? Wr[0] : Wr;
          };
          dt && A && typeof lt == "function" && lt.length != 1 && (je = dt = !1);
          var Gt = this.__chain__, Qt = !!this.__actions__.length, fr = Ce && !Gt, Rr = je && !Qt;
          if (!Ce && dt) {
            we = Rr ? we : new Hr(this);
            var pr = v.apply(we, Me);
            return pr.__actions__.push({ func: Ag, args: [gt], thisArg: r }), new Zi(pr, Gt);
          }
          return fr && Rr ? v.apply(this, Me) : (pr = this.thru(gt), fr ? W ? pr.value()[0] : pr.value() : pr);
        });
      }), Ki(["pop", "push", "shift", "sort", "splice", "unshift"], function(v) {
        var C = ng[v], A = /^(?:push|sort|unshift)$/.test(v) ? "tap" : "thru", W = /^(?:pop|shift)$/.test(v);
        ge.prototype[v] = function() {
          var ie = arguments;
          if (W && !this.__chain__) {
            var Ce = this.value();
            return C.apply(Or(Ce) ? Ce : [], ie);
          }
          return this[A](function(we) {
            return C.apply(Or(we) ? we : [], ie);
          });
        };
      }), Uo(Hr.prototype, function(v, C) {
        var A = ge[C];
        if (A) {
          var W = A.name + "";
          mn.call(su, W) || (su[W] = []), su[W].push({ name: C, func: A });
        }
      }), su[_g(r, S).name] = [{
        name: "wrapper",
        func: r
      }], Hr.prototype.clone = jre, Hr.prototype.reverse = Lre, Hr.prototype.value = kre, ge.prototype.at = pie, ge.prototype.chain = mie, ge.prototype.commit = vie, ge.prototype.next = hie, ge.prototype.plant = yie, ge.prototype.reverse = bie, ge.prototype.toJSON = ge.prototype.valueOf = ge.prototype.value = Cie, ge.prototype.first = ge.prototype.head, Xd && (ge.prototype[Xd] = gie), ge;
    }, au = vre();
    Rl ? ((Rl.exports = au)._ = au, FC._ = au) : Pa._ = au;
  }).call(Ue);
})(u1, u1.exports);
u1.exports;
var ste = { exports: {} }, pT = { exports: {} };
typeof Object.create == "function" ? pT.exports = function(t, r) {
  r && (t.super_ = r, t.prototype = Object.create(r.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : pT.exports = function(t, r) {
  if (r) {
    t.super_ = r;
    var n = function() {
    };
    n.prototype = r.prototype, t.prototype = new n(), t.prototype.constructor = t;
  }
};
var Ud = pT.exports, mT = { exports: {} }, lte = {}, NC = {};
NC.byteLength = XWe;
NC.toByteArray = QWe;
NC.fromByteArray = rqe;
var is = [], io = [], YWe = typeof Uint8Array < "u" ? Uint8Array : Array, Y_ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Uu = 0, ZWe = Y_.length; Uu < ZWe; ++Uu)
  is[Uu] = Y_[Uu], io[Y_.charCodeAt(Uu)] = Uu;
io[45] = 62;
io[95] = 63;
function cte(e) {
  var t = e.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = e.indexOf("=");
  r === -1 && (r = t);
  var n = r === t ? 0 : 4 - r % 4;
  return [r, n];
}
function XWe(e) {
  var t = cte(e), r = t[0], n = t[1];
  return (r + n) * 3 / 4 - n;
}
function JWe(e, t, r) {
  return (t + r) * 3 / 4 - r;
}
function QWe(e) {
  var t, r = cte(e), n = r[0], a = r[1], i = new YWe(JWe(e, n, a)), o = 0, s = a > 0 ? n - 4 : n, l;
  for (l = 0; l < s; l += 4)
    t = io[e.charCodeAt(l)] << 18 | io[e.charCodeAt(l + 1)] << 12 | io[e.charCodeAt(l + 2)] << 6 | io[e.charCodeAt(l + 3)], i[o++] = t >> 16 & 255, i[o++] = t >> 8 & 255, i[o++] = t & 255;
  return a === 2 && (t = io[e.charCodeAt(l)] << 2 | io[e.charCodeAt(l + 1)] >> 4, i[o++] = t & 255), a === 1 && (t = io[e.charCodeAt(l)] << 10 | io[e.charCodeAt(l + 1)] << 4 | io[e.charCodeAt(l + 2)] >> 2, i[o++] = t >> 8 & 255, i[o++] = t & 255), i;
}
function eqe(e) {
  return is[e >> 18 & 63] + is[e >> 12 & 63] + is[e >> 6 & 63] + is[e & 63];
}
function tqe(e, t, r) {
  for (var n, a = [], i = t; i < r; i += 3)
    n = (e[i] << 16 & 16711680) + (e[i + 1] << 8 & 65280) + (e[i + 2] & 255), a.push(eqe(n));
  return a.join("");
}
function rqe(e) {
  for (var t, r = e.length, n = r % 3, a = [], i = 16383, o = 0, s = r - n; o < s; o += i)
    a.push(tqe(e, o, o + i > s ? s : o + i));
  return n === 1 ? (t = e[r - 1], a.push(
    is[t >> 2] + is[t << 4 & 63] + "=="
  )) : n === 2 && (t = (e[r - 2] << 8) + e[r - 1], a.push(
    is[t >> 10] + is[t >> 4 & 63] + is[t << 2 & 63] + "="
  )), a.join("");
}
var vA = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
vA.read = function(e, t, r, n, a) {
  var i, o, s = a * 8 - n - 1, l = (1 << s) - 1, c = l >> 1, u = -7, d = r ? a - 1 : 0, f = r ? -1 : 1, m = e[t + d];
  for (d += f, i = m & (1 << -u) - 1, m >>= -u, u += s; u > 0; i = i * 256 + e[t + d], d += f, u -= 8)
    ;
  for (o = i & (1 << -u) - 1, i >>= -u, u += n; u > 0; o = o * 256 + e[t + d], d += f, u -= 8)
    ;
  if (i === 0)
    i = 1 - c;
  else {
    if (i === l)
      return o ? NaN : (m ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, n), i = i - c;
  }
  return (m ? -1 : 1) * o * Math.pow(2, i - n);
};
vA.write = function(e, t, r, n, a, i) {
  var o, s, l, c = i * 8 - a - 1, u = (1 << c) - 1, d = u >> 1, f = a === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, m = n ? 0 : i - 1, h = n ? 1 : -1, g = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, o = u) : (o = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), o + d >= 1 ? t += f / l : t += f * Math.pow(2, 1 - d), t * l >= 2 && (o++, l /= 2), o + d >= u ? (s = 0, o = u) : o + d >= 1 ? (s = (t * l - 1) * Math.pow(2, a), o = o + d) : (s = t * Math.pow(2, d - 1) * Math.pow(2, a), o = 0)); a >= 8; e[r + m] = s & 255, m += h, s /= 256, a -= 8)
    ;
  for (o = o << a | s, c += a; c > 0; e[r + m] = o & 255, m += h, o /= 256, c -= 8)
    ;
  e[r + m - h] |= g * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(e) {
  var t = NC, r = vA, n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  e.Buffer = s, e.SlowBuffer = x, e.INSPECT_MAX_BYTES = 50;
  var a = 2147483647;
  e.kMaxLength = a, s.TYPED_ARRAY_SUPPORT = i(), !s.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function i() {
    try {
      var k = new Uint8Array(1), M = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(M, Uint8Array.prototype), Object.setPrototypeOf(k, M), k.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(s.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (s.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(s.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (s.isBuffer(this))
        return this.byteOffset;
    }
  });
  function o(k) {
    if (k > a)
      throw new RangeError('The value "' + k + '" is invalid for option "size"');
    var M = new Uint8Array(k);
    return Object.setPrototypeOf(M, s.prototype), M;
  }
  function s(k, M, R) {
    if (typeof k == "number") {
      if (typeof M == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return d(k);
    }
    return l(k, M, R);
  }
  s.poolSize = 8192;
  function l(k, M, R) {
    if (typeof k == "string")
      return f(k, M);
    if (ArrayBuffer.isView(k))
      return h(k);
    if (k == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof k
      );
    if (he(k, ArrayBuffer) || k && he(k.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (he(k, SharedArrayBuffer) || k && he(k.buffer, SharedArrayBuffer)))
      return g(k, M, R);
    if (typeof k == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    var q = k.valueOf && k.valueOf();
    if (q != null && q !== k)
      return s.from(q, M, R);
    var Y = y(k);
    if (Y) return Y;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof k[Symbol.toPrimitive] == "function")
      return s.from(
        k[Symbol.toPrimitive]("string"),
        M,
        R
      );
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof k
    );
  }
  s.from = function(k, M, R) {
    return l(k, M, R);
  }, Object.setPrototypeOf(s.prototype, Uint8Array.prototype), Object.setPrototypeOf(s, Uint8Array);
  function c(k) {
    if (typeof k != "number")
      throw new TypeError('"size" argument must be of type number');
    if (k < 0)
      throw new RangeError('The value "' + k + '" is invalid for option "size"');
  }
  function u(k, M, R) {
    return c(k), k <= 0 ? o(k) : M !== void 0 ? typeof R == "string" ? o(k).fill(M, R) : o(k).fill(M) : o(k);
  }
  s.alloc = function(k, M, R) {
    return u(k, M, R);
  };
  function d(k) {
    return c(k), o(k < 0 ? 0 : S(k) | 0);
  }
  s.allocUnsafe = function(k) {
    return d(k);
  }, s.allocUnsafeSlow = function(k) {
    return d(k);
  };
  function f(k, M) {
    if ((typeof M != "string" || M === "") && (M = "utf8"), !s.isEncoding(M))
      throw new TypeError("Unknown encoding: " + M);
    var R = b(k, M) | 0, q = o(R), Y = q.write(k, M);
    return Y !== R && (q = q.slice(0, Y)), q;
  }
  function m(k) {
    for (var M = k.length < 0 ? 0 : S(k.length) | 0, R = o(M), q = 0; q < M; q += 1)
      R[q] = k[q] & 255;
    return R;
  }
  function h(k) {
    if (he(k, Uint8Array)) {
      var M = new Uint8Array(k);
      return g(M.buffer, M.byteOffset, M.byteLength);
    }
    return m(k);
  }
  function g(k, M, R) {
    if (M < 0 || k.byteLength < M)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (k.byteLength < M + (R || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    var q;
    return M === void 0 && R === void 0 ? q = new Uint8Array(k) : R === void 0 ? q = new Uint8Array(k, M) : q = new Uint8Array(k, M, R), Object.setPrototypeOf(q, s.prototype), q;
  }
  function y(k) {
    if (s.isBuffer(k)) {
      var M = S(k.length) | 0, R = o(M);
      return R.length === 0 || k.copy(R, 0, 0, M), R;
    }
    if (k.length !== void 0)
      return typeof k.length != "number" || ne(k.length) ? o(0) : m(k);
    if (k.type === "Buffer" && Array.isArray(k.data))
      return m(k.data);
  }
  function S(k) {
    if (k >= a)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a.toString(16) + " bytes");
    return k | 0;
  }
  function x(k) {
    return +k != k && (k = 0), s.alloc(+k);
  }
  s.isBuffer = function(M) {
    return M != null && M._isBuffer === !0 && M !== s.prototype;
  }, s.compare = function(M, R) {
    if (he(M, Uint8Array) && (M = s.from(M, M.offset, M.byteLength)), he(R, Uint8Array) && (R = s.from(R, R.offset, R.byteLength)), !s.isBuffer(M) || !s.isBuffer(R))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (M === R) return 0;
    for (var q = M.length, Y = R.length, X = 0, pe = Math.min(q, Y); X < pe; ++X)
      if (M[X] !== R[X]) {
        q = M[X], Y = R[X];
        break;
      }
    return q < Y ? -1 : Y < q ? 1 : 0;
  }, s.isEncoding = function(M) {
    switch (String(M).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, s.concat = function(M, R) {
    if (!Array.isArray(M))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (M.length === 0)
      return s.alloc(0);
    var q;
    if (R === void 0)
      for (R = 0, q = 0; q < M.length; ++q)
        R += M[q].length;
    var Y = s.allocUnsafe(R), X = 0;
    for (q = 0; q < M.length; ++q) {
      var pe = M[q];
      if (he(pe, Uint8Array))
        X + pe.length > Y.length ? s.from(pe).copy(Y, X) : Uint8Array.prototype.set.call(
          Y,
          pe,
          X
        );
      else if (s.isBuffer(pe))
        pe.copy(Y, X);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      X += pe.length;
    }
    return Y;
  };
  function b(k, M) {
    if (s.isBuffer(k))
      return k.length;
    if (ArrayBuffer.isView(k) || he(k, ArrayBuffer))
      return k.byteLength;
    if (typeof k != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof k
      );
    var R = k.length, q = arguments.length > 2 && arguments[2] === !0;
    if (!q && R === 0) return 0;
    for (var Y = !1; ; )
      switch (M) {
        case "ascii":
        case "latin1":
        case "binary":
          return R;
        case "utf8":
        case "utf-8":
          return oe(k).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return R * 2;
        case "hex":
          return R >>> 1;
        case "base64":
          return se(k).length;
        default:
          if (Y)
            return q ? -1 : oe(k).length;
          M = ("" + M).toLowerCase(), Y = !0;
      }
  }
  s.byteLength = b;
  function _(k, M, R) {
    var q = !1;
    if ((M === void 0 || M < 0) && (M = 0), M > this.length || ((R === void 0 || R > this.length) && (R = this.length), R <= 0) || (R >>>= 0, M >>>= 0, R <= M))
      return "";
    for (k || (k = "utf8"); ; )
      switch (k) {
        case "hex":
          return U(this, M, R);
        case "utf8":
        case "utf-8":
          return N(this, M, R);
        case "ascii":
          return j(this, M, R);
        case "latin1":
        case "binary":
          return H(this, M, R);
        case "base64":
          return L(this, M, R);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return G(this, M, R);
        default:
          if (q) throw new TypeError("Unknown encoding: " + k);
          k = (k + "").toLowerCase(), q = !0;
      }
  }
  s.prototype._isBuffer = !0;
  function $(k, M, R) {
    var q = k[M];
    k[M] = k[R], k[R] = q;
  }
  s.prototype.swap16 = function() {
    var M = this.length;
    if (M % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (var R = 0; R < M; R += 2)
      $(this, R, R + 1);
    return this;
  }, s.prototype.swap32 = function() {
    var M = this.length;
    if (M % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (var R = 0; R < M; R += 4)
      $(this, R, R + 3), $(this, R + 1, R + 2);
    return this;
  }, s.prototype.swap64 = function() {
    var M = this.length;
    if (M % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (var R = 0; R < M; R += 8)
      $(this, R, R + 7), $(this, R + 1, R + 6), $(this, R + 2, R + 5), $(this, R + 3, R + 4);
    return this;
  }, s.prototype.toString = function() {
    var M = this.length;
    return M === 0 ? "" : arguments.length === 0 ? N(this, 0, M) : _.apply(this, arguments);
  }, s.prototype.toLocaleString = s.prototype.toString, s.prototype.equals = function(M) {
    if (!s.isBuffer(M)) throw new TypeError("Argument must be a Buffer");
    return this === M ? !0 : s.compare(this, M) === 0;
  }, s.prototype.inspect = function() {
    var M = "", R = e.INSPECT_MAX_BYTES;
    return M = this.toString("hex", 0, R).replace(/(.{2})/g, "$1 ").trim(), this.length > R && (M += " ... "), "<Buffer " + M + ">";
  }, n && (s.prototype[n] = s.prototype.inspect), s.prototype.compare = function(M, R, q, Y, X) {
    if (he(M, Uint8Array) && (M = s.from(M, M.offset, M.byteLength)), !s.isBuffer(M))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof M
      );
    if (R === void 0 && (R = 0), q === void 0 && (q = M ? M.length : 0), Y === void 0 && (Y = 0), X === void 0 && (X = this.length), R < 0 || q > M.length || Y < 0 || X > this.length)
      throw new RangeError("out of range index");
    if (Y >= X && R >= q)
      return 0;
    if (Y >= X)
      return -1;
    if (R >= q)
      return 1;
    if (R >>>= 0, q >>>= 0, Y >>>= 0, X >>>= 0, this === M) return 0;
    for (var pe = X - Y, $e = q - R, J = Math.min(pe, $e), de = this.slice(Y, X), Se = M.slice(R, q), Ee = 0; Ee < J; ++Ee)
      if (de[Ee] !== Se[Ee]) {
        pe = de[Ee], $e = Se[Ee];
        break;
      }
    return pe < $e ? -1 : $e < pe ? 1 : 0;
  };
  function w(k, M, R, q, Y) {
    if (k.length === 0) return -1;
    if (typeof R == "string" ? (q = R, R = 0) : R > 2147483647 ? R = 2147483647 : R < -2147483648 && (R = -2147483648), R = +R, ne(R) && (R = Y ? 0 : k.length - 1), R < 0 && (R = k.length + R), R >= k.length) {
      if (Y) return -1;
      R = k.length - 1;
    } else if (R < 0)
      if (Y) R = 0;
      else return -1;
    if (typeof M == "string" && (M = s.from(M, q)), s.isBuffer(M))
      return M.length === 0 ? -1 : O(k, M, R, q, Y);
    if (typeof M == "number")
      return M = M & 255, typeof Uint8Array.prototype.indexOf == "function" ? Y ? Uint8Array.prototype.indexOf.call(k, M, R) : Uint8Array.prototype.lastIndexOf.call(k, M, R) : O(k, [M], R, q, Y);
    throw new TypeError("val must be string, number or Buffer");
  }
  function O(k, M, R, q, Y) {
    var X = 1, pe = k.length, $e = M.length;
    if (q !== void 0 && (q = String(q).toLowerCase(), q === "ucs2" || q === "ucs-2" || q === "utf16le" || q === "utf-16le")) {
      if (k.length < 2 || M.length < 2)
        return -1;
      X = 2, pe /= 2, $e /= 2, R /= 2;
    }
    function J(Le, Ie) {
      return X === 1 ? Le[Ie] : Le.readUInt16BE(Ie * X);
    }
    var de;
    if (Y) {
      var Se = -1;
      for (de = R; de < pe; de++)
        if (J(k, de) === J(M, Se === -1 ? 0 : de - Se)) {
          if (Se === -1 && (Se = de), de - Se + 1 === $e) return Se * X;
        } else
          Se !== -1 && (de -= de - Se), Se = -1;
    } else
      for (R + $e > pe && (R = pe - $e), de = R; de >= 0; de--) {
        for (var Ee = !0, Te = 0; Te < $e; Te++)
          if (J(k, de + Te) !== J(M, Te)) {
            Ee = !1;
            break;
          }
        if (Ee) return de;
      }
    return -1;
  }
  s.prototype.includes = function(M, R, q) {
    return this.indexOf(M, R, q) !== -1;
  }, s.prototype.indexOf = function(M, R, q) {
    return w(this, M, R, q, !0);
  }, s.prototype.lastIndexOf = function(M, R, q) {
    return w(this, M, R, q, !1);
  };
  function T(k, M, R, q) {
    R = Number(R) || 0;
    var Y = k.length - R;
    q ? (q = Number(q), q > Y && (q = Y)) : q = Y;
    var X = M.length;
    q > X / 2 && (q = X / 2);
    for (var pe = 0; pe < q; ++pe) {
      var $e = parseInt(M.substr(pe * 2, 2), 16);
      if (ne($e)) return pe;
      k[R + pe] = $e;
    }
    return pe;
  }
  function I(k, M, R, q) {
    return Q(oe(M, k.length - R), k, R, q);
  }
  function P(k, M, R, q) {
    return Q(fe(M), k, R, q);
  }
  function D(k, M, R, q) {
    return Q(se(M), k, R, q);
  }
  function B(k, M, R, q) {
    return Q(le(M, k.length - R), k, R, q);
  }
  s.prototype.write = function(M, R, q, Y) {
    if (R === void 0)
      Y = "utf8", q = this.length, R = 0;
    else if (q === void 0 && typeof R == "string")
      Y = R, q = this.length, R = 0;
    else if (isFinite(R))
      R = R >>> 0, isFinite(q) ? (q = q >>> 0, Y === void 0 && (Y = "utf8")) : (Y = q, q = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    var X = this.length - R;
    if ((q === void 0 || q > X) && (q = X), M.length > 0 && (q < 0 || R < 0) || R > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    Y || (Y = "utf8");
    for (var pe = !1; ; )
      switch (Y) {
        case "hex":
          return T(this, M, R, q);
        case "utf8":
        case "utf-8":
          return I(this, M, R, q);
        case "ascii":
        case "latin1":
        case "binary":
          return P(this, M, R, q);
        case "base64":
          return D(this, M, R, q);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return B(this, M, R, q);
        default:
          if (pe) throw new TypeError("Unknown encoding: " + Y);
          Y = ("" + Y).toLowerCase(), pe = !0;
      }
  }, s.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function L(k, M, R) {
    return M === 0 && R === k.length ? t.fromByteArray(k) : t.fromByteArray(k.slice(M, R));
  }
  function N(k, M, R) {
    R = Math.min(k.length, R);
    for (var q = [], Y = M; Y < R; ) {
      var X = k[Y], pe = null, $e = X > 239 ? 4 : X > 223 ? 3 : X > 191 ? 2 : 1;
      if (Y + $e <= R) {
        var J, de, Se, Ee;
        switch ($e) {
          case 1:
            X < 128 && (pe = X);
            break;
          case 2:
            J = k[Y + 1], (J & 192) === 128 && (Ee = (X & 31) << 6 | J & 63, Ee > 127 && (pe = Ee));
            break;
          case 3:
            J = k[Y + 1], de = k[Y + 2], (J & 192) === 128 && (de & 192) === 128 && (Ee = (X & 15) << 12 | (J & 63) << 6 | de & 63, Ee > 2047 && (Ee < 55296 || Ee > 57343) && (pe = Ee));
            break;
          case 4:
            J = k[Y + 1], de = k[Y + 2], Se = k[Y + 3], (J & 192) === 128 && (de & 192) === 128 && (Se & 192) === 128 && (Ee = (X & 15) << 18 | (J & 63) << 12 | (de & 63) << 6 | Se & 63, Ee > 65535 && Ee < 1114112 && (pe = Ee));
        }
      }
      pe === null ? (pe = 65533, $e = 1) : pe > 65535 && (pe -= 65536, q.push(pe >>> 10 & 1023 | 55296), pe = 56320 | pe & 1023), q.push(pe), Y += $e;
    }
    return F(q);
  }
  var z = 4096;
  function F(k) {
    var M = k.length;
    if (M <= z)
      return String.fromCharCode.apply(String, k);
    for (var R = "", q = 0; q < M; )
      R += String.fromCharCode.apply(
        String,
        k.slice(q, q += z)
      );
    return R;
  }
  function j(k, M, R) {
    var q = "";
    R = Math.min(k.length, R);
    for (var Y = M; Y < R; ++Y)
      q += String.fromCharCode(k[Y] & 127);
    return q;
  }
  function H(k, M, R) {
    var q = "";
    R = Math.min(k.length, R);
    for (var Y = M; Y < R; ++Y)
      q += String.fromCharCode(k[Y]);
    return q;
  }
  function U(k, M, R) {
    var q = k.length;
    (!M || M < 0) && (M = 0), (!R || R < 0 || R > q) && (R = q);
    for (var Y = "", X = M; X < R; ++X)
      Y += me[k[X]];
    return Y;
  }
  function G(k, M, R) {
    for (var q = k.slice(M, R), Y = "", X = 0; X < q.length - 1; X += 2)
      Y += String.fromCharCode(q[X] + q[X + 1] * 256);
    return Y;
  }
  s.prototype.slice = function(M, R) {
    var q = this.length;
    M = ~~M, R = R === void 0 ? q : ~~R, M < 0 ? (M += q, M < 0 && (M = 0)) : M > q && (M = q), R < 0 ? (R += q, R < 0 && (R = 0)) : R > q && (R = q), R < M && (R = M);
    var Y = this.subarray(M, R);
    return Object.setPrototypeOf(Y, s.prototype), Y;
  };
  function V(k, M, R) {
    if (k % 1 !== 0 || k < 0) throw new RangeError("offset is not uint");
    if (k + M > R) throw new RangeError("Trying to access beyond buffer length");
  }
  s.prototype.readUintLE = s.prototype.readUIntLE = function(M, R, q) {
    M = M >>> 0, R = R >>> 0, q || V(M, R, this.length);
    for (var Y = this[M], X = 1, pe = 0; ++pe < R && (X *= 256); )
      Y += this[M + pe] * X;
    return Y;
  }, s.prototype.readUintBE = s.prototype.readUIntBE = function(M, R, q) {
    M = M >>> 0, R = R >>> 0, q || V(M, R, this.length);
    for (var Y = this[M + --R], X = 1; R > 0 && (X *= 256); )
      Y += this[M + --R] * X;
    return Y;
  }, s.prototype.readUint8 = s.prototype.readUInt8 = function(M, R) {
    return M = M >>> 0, R || V(M, 1, this.length), this[M];
  }, s.prototype.readUint16LE = s.prototype.readUInt16LE = function(M, R) {
    return M = M >>> 0, R || V(M, 2, this.length), this[M] | this[M + 1] << 8;
  }, s.prototype.readUint16BE = s.prototype.readUInt16BE = function(M, R) {
    return M = M >>> 0, R || V(M, 2, this.length), this[M] << 8 | this[M + 1];
  }, s.prototype.readUint32LE = s.prototype.readUInt32LE = function(M, R) {
    return M = M >>> 0, R || V(M, 4, this.length), (this[M] | this[M + 1] << 8 | this[M + 2] << 16) + this[M + 3] * 16777216;
  }, s.prototype.readUint32BE = s.prototype.readUInt32BE = function(M, R) {
    return M = M >>> 0, R || V(M, 4, this.length), this[M] * 16777216 + (this[M + 1] << 16 | this[M + 2] << 8 | this[M + 3]);
  }, s.prototype.readIntLE = function(M, R, q) {
    M = M >>> 0, R = R >>> 0, q || V(M, R, this.length);
    for (var Y = this[M], X = 1, pe = 0; ++pe < R && (X *= 256); )
      Y += this[M + pe] * X;
    return X *= 128, Y >= X && (Y -= Math.pow(2, 8 * R)), Y;
  }, s.prototype.readIntBE = function(M, R, q) {
    M = M >>> 0, R = R >>> 0, q || V(M, R, this.length);
    for (var Y = R, X = 1, pe = this[M + --Y]; Y > 0 && (X *= 256); )
      pe += this[M + --Y] * X;
    return X *= 128, pe >= X && (pe -= Math.pow(2, 8 * R)), pe;
  }, s.prototype.readInt8 = function(M, R) {
    return M = M >>> 0, R || V(M, 1, this.length), this[M] & 128 ? (255 - this[M] + 1) * -1 : this[M];
  }, s.prototype.readInt16LE = function(M, R) {
    M = M >>> 0, R || V(M, 2, this.length);
    var q = this[M] | this[M + 1] << 8;
    return q & 32768 ? q | 4294901760 : q;
  }, s.prototype.readInt16BE = function(M, R) {
    M = M >>> 0, R || V(M, 2, this.length);
    var q = this[M + 1] | this[M] << 8;
    return q & 32768 ? q | 4294901760 : q;
  }, s.prototype.readInt32LE = function(M, R) {
    return M = M >>> 0, R || V(M, 4, this.length), this[M] | this[M + 1] << 8 | this[M + 2] << 16 | this[M + 3] << 24;
  }, s.prototype.readInt32BE = function(M, R) {
    return M = M >>> 0, R || V(M, 4, this.length), this[M] << 24 | this[M + 1] << 16 | this[M + 2] << 8 | this[M + 3];
  }, s.prototype.readFloatLE = function(M, R) {
    return M = M >>> 0, R || V(M, 4, this.length), r.read(this, M, !0, 23, 4);
  }, s.prototype.readFloatBE = function(M, R) {
    return M = M >>> 0, R || V(M, 4, this.length), r.read(this, M, !1, 23, 4);
  }, s.prototype.readDoubleLE = function(M, R) {
    return M = M >>> 0, R || V(M, 8, this.length), r.read(this, M, !0, 52, 8);
  }, s.prototype.readDoubleBE = function(M, R) {
    return M = M >>> 0, R || V(M, 8, this.length), r.read(this, M, !1, 52, 8);
  };
  function K(k, M, R, q, Y, X) {
    if (!s.isBuffer(k)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (M > Y || M < X) throw new RangeError('"value" argument is out of bounds');
    if (R + q > k.length) throw new RangeError("Index out of range");
  }
  s.prototype.writeUintLE = s.prototype.writeUIntLE = function(M, R, q, Y) {
    if (M = +M, R = R >>> 0, q = q >>> 0, !Y) {
      var X = Math.pow(2, 8 * q) - 1;
      K(this, M, R, q, X, 0);
    }
    var pe = 1, $e = 0;
    for (this[R] = M & 255; ++$e < q && (pe *= 256); )
      this[R + $e] = M / pe & 255;
    return R + q;
  }, s.prototype.writeUintBE = s.prototype.writeUIntBE = function(M, R, q, Y) {
    if (M = +M, R = R >>> 0, q = q >>> 0, !Y) {
      var X = Math.pow(2, 8 * q) - 1;
      K(this, M, R, q, X, 0);
    }
    var pe = q - 1, $e = 1;
    for (this[R + pe] = M & 255; --pe >= 0 && ($e *= 256); )
      this[R + pe] = M / $e & 255;
    return R + q;
  }, s.prototype.writeUint8 = s.prototype.writeUInt8 = function(M, R, q) {
    return M = +M, R = R >>> 0, q || K(this, M, R, 1, 255, 0), this[R] = M & 255, R + 1;
  }, s.prototype.writeUint16LE = s.prototype.writeUInt16LE = function(M, R, q) {
    return M = +M, R = R >>> 0, q || K(this, M, R, 2, 65535, 0), this[R] = M & 255, this[R + 1] = M >>> 8, R + 2;
  }, s.prototype.writeUint16BE = s.prototype.writeUInt16BE = function(M, R, q) {
    return M = +M, R = R >>> 0, q || K(this, M, R, 2, 65535, 0), this[R] = M >>> 8, this[R + 1] = M & 255, R + 2;
  }, s.prototype.writeUint32LE = s.prototype.writeUInt32LE = function(M, R, q) {
    return M = +M, R = R >>> 0, q || K(this, M, R, 4, 4294967295, 0), this[R + 3] = M >>> 24, this[R + 2] = M >>> 16, this[R + 1] = M >>> 8, this[R] = M & 255, R + 4;
  }, s.prototype.writeUint32BE = s.prototype.writeUInt32BE = function(M, R, q) {
    return M = +M, R = R >>> 0, q || K(this, M, R, 4, 4294967295, 0), this[R] = M >>> 24, this[R + 1] = M >>> 16, this[R + 2] = M >>> 8, this[R + 3] = M & 255, R + 4;
  }, s.prototype.writeIntLE = function(M, R, q, Y) {
    if (M = +M, R = R >>> 0, !Y) {
      var X = Math.pow(2, 8 * q - 1);
      K(this, M, R, q, X - 1, -X);
    }
    var pe = 0, $e = 1, J = 0;
    for (this[R] = M & 255; ++pe < q && ($e *= 256); )
      M < 0 && J === 0 && this[R + pe - 1] !== 0 && (J = 1), this[R + pe] = (M / $e >> 0) - J & 255;
    return R + q;
  }, s.prototype.writeIntBE = function(M, R, q, Y) {
    if (M = +M, R = R >>> 0, !Y) {
      var X = Math.pow(2, 8 * q - 1);
      K(this, M, R, q, X - 1, -X);
    }
    var pe = q - 1, $e = 1, J = 0;
    for (this[R + pe] = M & 255; --pe >= 0 && ($e *= 256); )
      M < 0 && J === 0 && this[R + pe + 1] !== 0 && (J = 1), this[R + pe] = (M / $e >> 0) - J & 255;
    return R + q;
  }, s.prototype.writeInt8 = function(M, R, q) {
    return M = +M, R = R >>> 0, q || K(this, M, R, 1, 127, -128), M < 0 && (M = 255 + M + 1), this[R] = M & 255, R + 1;
  }, s.prototype.writeInt16LE = function(M, R, q) {
    return M = +M, R = R >>> 0, q || K(this, M, R, 2, 32767, -32768), this[R] = M & 255, this[R + 1] = M >>> 8, R + 2;
  }, s.prototype.writeInt16BE = function(M, R, q) {
    return M = +M, R = R >>> 0, q || K(this, M, R, 2, 32767, -32768), this[R] = M >>> 8, this[R + 1] = M & 255, R + 2;
  }, s.prototype.writeInt32LE = function(M, R, q) {
    return M = +M, R = R >>> 0, q || K(this, M, R, 4, 2147483647, -2147483648), this[R] = M & 255, this[R + 1] = M >>> 8, this[R + 2] = M >>> 16, this[R + 3] = M >>> 24, R + 4;
  }, s.prototype.writeInt32BE = function(M, R, q) {
    return M = +M, R = R >>> 0, q || K(this, M, R, 4, 2147483647, -2147483648), M < 0 && (M = 4294967295 + M + 1), this[R] = M >>> 24, this[R + 1] = M >>> 16, this[R + 2] = M >>> 8, this[R + 3] = M & 255, R + 4;
  };
  function Z(k, M, R, q, Y, X) {
    if (R + q > k.length) throw new RangeError("Index out of range");
    if (R < 0) throw new RangeError("Index out of range");
  }
  function ee(k, M, R, q, Y) {
    return M = +M, R = R >>> 0, Y || Z(k, M, R, 4), r.write(k, M, R, q, 23, 4), R + 4;
  }
  s.prototype.writeFloatLE = function(M, R, q) {
    return ee(this, M, R, !0, q);
  }, s.prototype.writeFloatBE = function(M, R, q) {
    return ee(this, M, R, !1, q);
  };
  function ae(k, M, R, q, Y) {
    return M = +M, R = R >>> 0, Y || Z(k, M, R, 8), r.write(k, M, R, q, 52, 8), R + 8;
  }
  s.prototype.writeDoubleLE = function(M, R, q) {
    return ae(this, M, R, !0, q);
  }, s.prototype.writeDoubleBE = function(M, R, q) {
    return ae(this, M, R, !1, q);
  }, s.prototype.copy = function(M, R, q, Y) {
    if (!s.isBuffer(M)) throw new TypeError("argument should be a Buffer");
    if (q || (q = 0), !Y && Y !== 0 && (Y = this.length), R >= M.length && (R = M.length), R || (R = 0), Y > 0 && Y < q && (Y = q), Y === q || M.length === 0 || this.length === 0) return 0;
    if (R < 0)
      throw new RangeError("targetStart out of bounds");
    if (q < 0 || q >= this.length) throw new RangeError("Index out of range");
    if (Y < 0) throw new RangeError("sourceEnd out of bounds");
    Y > this.length && (Y = this.length), M.length - R < Y - q && (Y = M.length - R + q);
    var X = Y - q;
    return this === M && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(R, q, Y) : Uint8Array.prototype.set.call(
      M,
      this.subarray(q, Y),
      R
    ), X;
  }, s.prototype.fill = function(M, R, q, Y) {
    if (typeof M == "string") {
      if (typeof R == "string" ? (Y = R, R = 0, q = this.length) : typeof q == "string" && (Y = q, q = this.length), Y !== void 0 && typeof Y != "string")
        throw new TypeError("encoding must be a string");
      if (typeof Y == "string" && !s.isEncoding(Y))
        throw new TypeError("Unknown encoding: " + Y);
      if (M.length === 1) {
        var X = M.charCodeAt(0);
        (Y === "utf8" && X < 128 || Y === "latin1") && (M = X);
      }
    } else typeof M == "number" ? M = M & 255 : typeof M == "boolean" && (M = Number(M));
    if (R < 0 || this.length < R || this.length < q)
      throw new RangeError("Out of range index");
    if (q <= R)
      return this;
    R = R >>> 0, q = q === void 0 ? this.length : q >>> 0, M || (M = 0);
    var pe;
    if (typeof M == "number")
      for (pe = R; pe < q; ++pe)
        this[pe] = M;
    else {
      var $e = s.isBuffer(M) ? M : s.from(M, Y), J = $e.length;
      if (J === 0)
        throw new TypeError('The value "' + M + '" is invalid for argument "value"');
      for (pe = 0; pe < q - R; ++pe)
        this[pe + R] = $e[pe % J];
    }
    return this;
  };
  var ue = /[^+/0-9A-Za-z-_]/g;
  function re(k) {
    if (k = k.split("=")[0], k = k.trim().replace(ue, ""), k.length < 2) return "";
    for (; k.length % 4 !== 0; )
      k = k + "=";
    return k;
  }
  function oe(k, M) {
    M = M || 1 / 0;
    for (var R, q = k.length, Y = null, X = [], pe = 0; pe < q; ++pe) {
      if (R = k.charCodeAt(pe), R > 55295 && R < 57344) {
        if (!Y) {
          if (R > 56319) {
            (M -= 3) > -1 && X.push(239, 191, 189);
            continue;
          } else if (pe + 1 === q) {
            (M -= 3) > -1 && X.push(239, 191, 189);
            continue;
          }
          Y = R;
          continue;
        }
        if (R < 56320) {
          (M -= 3) > -1 && X.push(239, 191, 189), Y = R;
          continue;
        }
        R = (Y - 55296 << 10 | R - 56320) + 65536;
      } else Y && (M -= 3) > -1 && X.push(239, 191, 189);
      if (Y = null, R < 128) {
        if ((M -= 1) < 0) break;
        X.push(R);
      } else if (R < 2048) {
        if ((M -= 2) < 0) break;
        X.push(
          R >> 6 | 192,
          R & 63 | 128
        );
      } else if (R < 65536) {
        if ((M -= 3) < 0) break;
        X.push(
          R >> 12 | 224,
          R >> 6 & 63 | 128,
          R & 63 | 128
        );
      } else if (R < 1114112) {
        if ((M -= 4) < 0) break;
        X.push(
          R >> 18 | 240,
          R >> 12 & 63 | 128,
          R >> 6 & 63 | 128,
          R & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return X;
  }
  function fe(k) {
    for (var M = [], R = 0; R < k.length; ++R)
      M.push(k.charCodeAt(R) & 255);
    return M;
  }
  function le(k, M) {
    for (var R, q, Y, X = [], pe = 0; pe < k.length && !((M -= 2) < 0); ++pe)
      R = k.charCodeAt(pe), q = R >> 8, Y = R % 256, X.push(Y), X.push(q);
    return X;
  }
  function se(k) {
    return t.toByteArray(re(k));
  }
  function Q(k, M, R, q) {
    for (var Y = 0; Y < q && !(Y + R >= M.length || Y >= k.length); ++Y)
      M[Y + R] = k[Y];
    return Y;
  }
  function he(k, M) {
    return k instanceof M || k != null && k.constructor != null && k.constructor.name != null && k.constructor.name === M.name;
  }
  function ne(k) {
    return k !== k;
  }
  var me = function() {
    for (var k = "0123456789abcdef", M = new Array(256), R = 0; R < 16; ++R)
      for (var q = R * 16, Y = 0; Y < 16; ++Y)
        M[q + Y] = k[R] + k[Y];
    return M;
  }();
})(lte);
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(e, t) {
  var r = lte, n = r.Buffer;
  function a(o, s) {
    for (var l in o)
      s[l] = o[l];
  }
  n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow ? e.exports = r : (a(r, t), t.Buffer = i);
  function i(o, s, l) {
    return n(o, s, l);
  }
  i.prototype = Object.create(n.prototype), a(n, i), i.from = function(o, s, l) {
    if (typeof o == "number")
      throw new TypeError("Argument must not be a number");
    return n(o, s, l);
  }, i.alloc = function(o, s, l) {
    if (typeof o != "number")
      throw new TypeError("Argument must be a number");
    var c = n(o);
    return s !== void 0 ? typeof l == "string" ? c.fill(s, l) : c.fill(s) : c.fill(0), c;
  }, i.allocUnsafe = function(o) {
    if (typeof o != "number")
      throw new TypeError("Argument must be a number");
    return n(o);
  }, i.allocUnsafeSlow = function(o) {
    if (typeof o != "number")
      throw new TypeError("Argument must be a number");
    return r.SlowBuffer(o);
  };
})(mT, mT.exports);
var Jc = mT.exports, ute = Jc.Buffer;
function DC(e, t) {
  this._block = ute.alloc(e), this._finalSize = t, this._blockSize = e, this._len = 0;
}
DC.prototype.update = function(e, t) {
  typeof e == "string" && (t = t || "utf8", e = ute.from(e, t));
  for (var r = this._block, n = this._blockSize, a = e.length, i = this._len, o = 0; o < a; ) {
    for (var s = i % n, l = Math.min(a - o, n - s), c = 0; c < l; c++)
      r[s + c] = e[o + c];
    i += l, o += l, i % n === 0 && this._update(r);
  }
  return this._len += a, this;
};
DC.prototype.digest = function(e) {
  var t = this._len % this._blockSize;
  this._block[t] = 128, this._block.fill(0, t + 1), t >= this._finalSize && (this._update(this._block), this._block.fill(0));
  var r = this._len * 8;
  if (r <= 4294967295)
    this._block.writeUInt32BE(r, this._blockSize - 4);
  else {
    var n = (r & 4294967295) >>> 0, a = (r - n) / 4294967296;
    this._block.writeUInt32BE(a, this._blockSize - 8), this._block.writeUInt32BE(n, this._blockSize - 4);
  }
  this._update(this._block);
  var i = this._hash();
  return e ? i.toString(e) : i;
};
DC.prototype._update = function() {
  throw new Error("_update must be implemented by subclass");
};
var Wd = DC, nqe = Ud, dte = Wd, aqe = Jc.Buffer, iqe = [
  1518500249,
  1859775393,
  -1894007588,
  -899497514
], oqe = new Array(80);
function Yh() {
  this.init(), this._w = oqe, dte.call(this, 64, 56);
}
nqe(Yh, dte);
Yh.prototype.init = function() {
  return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
};
function sqe(e) {
  return e << 5 | e >>> 27;
}
function lqe(e) {
  return e << 30 | e >>> 2;
}
function cqe(e, t, r, n) {
  return e === 0 ? t & r | ~t & n : e === 2 ? t & r | t & n | r & n : t ^ r ^ n;
}
Yh.prototype._update = function(e) {
  for (var t = this._w, r = this._a | 0, n = this._b | 0, a = this._c | 0, i = this._d | 0, o = this._e | 0, s = 0; s < 16; ++s) t[s] = e.readInt32BE(s * 4);
  for (; s < 80; ++s) t[s] = t[s - 3] ^ t[s - 8] ^ t[s - 14] ^ t[s - 16];
  for (var l = 0; l < 80; ++l) {
    var c = ~~(l / 20), u = sqe(r) + cqe(c, n, a, i) + o + t[l] + iqe[c] | 0;
    o = i, i = a, a = lqe(n), n = r, r = u;
  }
  this._a = r + this._a | 0, this._b = n + this._b | 0, this._c = a + this._c | 0, this._d = i + this._d | 0, this._e = o + this._e | 0;
};
Yh.prototype._hash = function() {
  var e = aqe.allocUnsafe(20);
  return e.writeInt32BE(this._a | 0, 0), e.writeInt32BE(this._b | 0, 4), e.writeInt32BE(this._c | 0, 8), e.writeInt32BE(this._d | 0, 12), e.writeInt32BE(this._e | 0, 16), e;
};
var uqe = Yh, dqe = Ud, fte = Wd, fqe = Jc.Buffer, pqe = [
  1518500249,
  1859775393,
  -1894007588,
  -899497514
], mqe = new Array(80);
function Zh() {
  this.init(), this._w = mqe, fte.call(this, 64, 56);
}
dqe(Zh, fte);
Zh.prototype.init = function() {
  return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
};
function vqe(e) {
  return e << 1 | e >>> 31;
}
function hqe(e) {
  return e << 5 | e >>> 27;
}
function gqe(e) {
  return e << 30 | e >>> 2;
}
function yqe(e, t, r, n) {
  return e === 0 ? t & r | ~t & n : e === 2 ? t & r | t & n | r & n : t ^ r ^ n;
}
Zh.prototype._update = function(e) {
  for (var t = this._w, r = this._a | 0, n = this._b | 0, a = this._c | 0, i = this._d | 0, o = this._e | 0, s = 0; s < 16; ++s) t[s] = e.readInt32BE(s * 4);
  for (; s < 80; ++s) t[s] = vqe(t[s - 3] ^ t[s - 8] ^ t[s - 14] ^ t[s - 16]);
  for (var l = 0; l < 80; ++l) {
    var c = ~~(l / 20), u = hqe(r) + yqe(c, n, a, i) + o + t[l] + pqe[c] | 0;
    o = i, i = a, a = gqe(n), n = r, r = u;
  }
  this._a = r + this._a | 0, this._b = n + this._b | 0, this._c = a + this._c | 0, this._d = i + this._d | 0, this._e = o + this._e | 0;
};
Zh.prototype._hash = function() {
  var e = fqe.allocUnsafe(20);
  return e.writeInt32BE(this._a | 0, 0), e.writeInt32BE(this._b | 0, 4), e.writeInt32BE(this._c | 0, 8), e.writeInt32BE(this._d | 0, 12), e.writeInt32BE(this._e | 0, 16), e;
};
var bqe = Zh, Cqe = Ud, pte = Wd, Sqe = Jc.Buffer, xqe = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
], $qe = new Array(64);
function Xh() {
  this.init(), this._w = $qe, pte.call(this, 64, 56);
}
Cqe(Xh, pte);
Xh.prototype.init = function() {
  return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
};
function _qe(e, t, r) {
  return r ^ e & (t ^ r);
}
function Eqe(e, t, r) {
  return e & t | r & (e | t);
}
function wqe(e) {
  return (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10);
}
function Oqe(e) {
  return (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
}
function Tqe(e) {
  return (e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3;
}
function Iqe(e) {
  return (e >>> 17 | e << 15) ^ (e >>> 19 | e << 13) ^ e >>> 10;
}
Xh.prototype._update = function(e) {
  for (var t = this._w, r = this._a | 0, n = this._b | 0, a = this._c | 0, i = this._d | 0, o = this._e | 0, s = this._f | 0, l = this._g | 0, c = this._h | 0, u = 0; u < 16; ++u) t[u] = e.readInt32BE(u * 4);
  for (; u < 64; ++u) t[u] = Iqe(t[u - 2]) + t[u - 7] + Tqe(t[u - 15]) + t[u - 16] | 0;
  for (var d = 0; d < 64; ++d) {
    var f = c + Oqe(o) + _qe(o, s, l) + xqe[d] + t[d] | 0, m = wqe(r) + Eqe(r, n, a) | 0;
    c = l, l = s, s = o, o = i + f | 0, i = a, a = n, n = r, r = f + m | 0;
  }
  this._a = r + this._a | 0, this._b = n + this._b | 0, this._c = a + this._c | 0, this._d = i + this._d | 0, this._e = o + this._e | 0, this._f = s + this._f | 0, this._g = l + this._g | 0, this._h = c + this._h | 0;
};
Xh.prototype._hash = function() {
  var e = Sqe.allocUnsafe(32);
  return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e.writeInt32BE(this._h, 28), e;
};
var mte = Xh, Mqe = Ud, Aqe = mte, Pqe = Wd, Rqe = Jc.Buffer, Nqe = new Array(64);
function jC() {
  this.init(), this._w = Nqe, Pqe.call(this, 64, 56);
}
Mqe(jC, Aqe);
jC.prototype.init = function() {
  return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
};
jC.prototype._hash = function() {
  var e = Rqe.allocUnsafe(28);
  return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e;
};
var Dqe = jC, jqe = Ud, vte = Wd, Lqe = Jc.Buffer, Uk = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
], kqe = new Array(160);
function Jh() {
  this.init(), this._w = kqe, vte.call(this, 128, 112);
}
jqe(Jh, vte);
Jh.prototype.init = function() {
  return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
};
function Wk(e, t, r) {
  return r ^ e & (t ^ r);
}
function qk(e, t, r) {
  return e & t | r & (e | t);
}
function Kk(e, t) {
  return (e >>> 28 | t << 4) ^ (t >>> 2 | e << 30) ^ (t >>> 7 | e << 25);
}
function Yk(e, t) {
  return (e >>> 14 | t << 18) ^ (e >>> 18 | t << 14) ^ (t >>> 9 | e << 23);
}
function Fqe(e, t) {
  return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ e >>> 7;
}
function Bqe(e, t) {
  return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ (e >>> 7 | t << 25);
}
function zqe(e, t) {
  return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ e >>> 6;
}
function Hqe(e, t) {
  return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ (e >>> 6 | t << 26);
}
function _a(e, t) {
  return e >>> 0 < t >>> 0 ? 1 : 0;
}
Jh.prototype._update = function(e) {
  for (var t = this._w, r = this._ah | 0, n = this._bh | 0, a = this._ch | 0, i = this._dh | 0, o = this._eh | 0, s = this._fh | 0, l = this._gh | 0, c = this._hh | 0, u = this._al | 0, d = this._bl | 0, f = this._cl | 0, m = this._dl | 0, h = this._el | 0, g = this._fl | 0, y = this._gl | 0, S = this._hl | 0, x = 0; x < 32; x += 2)
    t[x] = e.readInt32BE(x * 4), t[x + 1] = e.readInt32BE(x * 4 + 4);
  for (; x < 160; x += 2) {
    var b = t[x - 30], _ = t[x - 15 * 2 + 1], $ = Fqe(b, _), w = Bqe(_, b);
    b = t[x - 2 * 2], _ = t[x - 2 * 2 + 1];
    var O = zqe(b, _), T = Hqe(_, b), I = t[x - 7 * 2], P = t[x - 7 * 2 + 1], D = t[x - 16 * 2], B = t[x - 16 * 2 + 1], L = w + P | 0, N = $ + I + _a(L, w) | 0;
    L = L + T | 0, N = N + O + _a(L, T) | 0, L = L + B | 0, N = N + D + _a(L, B) | 0, t[x] = N, t[x + 1] = L;
  }
  for (var z = 0; z < 160; z += 2) {
    N = t[z], L = t[z + 1];
    var F = qk(r, n, a), j = qk(u, d, f), H = Kk(r, u), U = Kk(u, r), G = Yk(o, h), V = Yk(h, o), K = Uk[z], Z = Uk[z + 1], ee = Wk(o, s, l), ae = Wk(h, g, y), ue = S + V | 0, re = c + G + _a(ue, S) | 0;
    ue = ue + ae | 0, re = re + ee + _a(ue, ae) | 0, ue = ue + Z | 0, re = re + K + _a(ue, Z) | 0, ue = ue + L | 0, re = re + N + _a(ue, L) | 0;
    var oe = U + j | 0, fe = H + F + _a(oe, U) | 0;
    c = l, S = y, l = s, y = g, s = o, g = h, h = m + ue | 0, o = i + re + _a(h, m) | 0, i = a, m = f, a = n, f = d, n = r, d = u, u = ue + oe | 0, r = re + fe + _a(u, ue) | 0;
  }
  this._al = this._al + u | 0, this._bl = this._bl + d | 0, this._cl = this._cl + f | 0, this._dl = this._dl + m | 0, this._el = this._el + h | 0, this._fl = this._fl + g | 0, this._gl = this._gl + y | 0, this._hl = this._hl + S | 0, this._ah = this._ah + r + _a(this._al, u) | 0, this._bh = this._bh + n + _a(this._bl, d) | 0, this._ch = this._ch + a + _a(this._cl, f) | 0, this._dh = this._dh + i + _a(this._dl, m) | 0, this._eh = this._eh + o + _a(this._el, h) | 0, this._fh = this._fh + s + _a(this._fl, g) | 0, this._gh = this._gh + l + _a(this._gl, y) | 0, this._hh = this._hh + c + _a(this._hl, S) | 0;
};
Jh.prototype._hash = function() {
  var e = Lqe.allocUnsafe(64);
  function t(r, n, a) {
    e.writeInt32BE(r, a), e.writeInt32BE(n, a + 4);
  }
  return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), t(this._gh, this._gl, 48), t(this._hh, this._hl, 56), e;
};
var hte = Jh, Vqe = Ud, Gqe = hte, Uqe = Wd, Wqe = Jc.Buffer, qqe = new Array(160);
function LC() {
  this.init(), this._w = qqe, Uqe.call(this, 128, 112);
}
Vqe(LC, Gqe);
LC.prototype.init = function() {
  return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
};
LC.prototype._hash = function() {
  var e = Wqe.allocUnsafe(48);
  function t(r, n, a) {
    e.writeInt32BE(r, a), e.writeInt32BE(n, a + 4);
  }
  return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), e;
};
var Kqe = LC, Qc = ste.exports = function(t) {
  t = t.toLowerCase();
  var r = Qc[t];
  if (!r) throw new Error(t + " is not supported (we accept pull requests)");
  return new r();
};
Qc.sha = uqe;
Qc.sha1 = bqe;
Qc.sha224 = Dqe;
Qc.sha256 = mte;
Qc.sha384 = Kqe;
Qc.sha512 = hte;
var Yqe = ste.exports;
const Zk = /* @__PURE__ */ Ut(Yqe), qd = () => {
  const e = (m) => m.product?.metadata?.type === mr.Certification || m.product?.metadata?.type === mr.AppGuide || m.product?.metadata?.type === mr.AlumniIntensive, t = (m) => (Number(m.product?.metadata?.max_quantity) || 9999) < m.quantity, r = (m, h) => [
    mr.Certification.toString(),
    mr.AppGuide.toString()
  ].includes(m.product?.metadata?.type?.toString() || "") ? h.findIndex((g) => g.product?.metadata?.type === m.product?.metadata?.type) : -1, n = (m, h) => !wk(h) && h === mr.Physical ? m.some((g) => g.isPhysical) : m.some((g) => {
    const y = g?.product?.metadata.type;
    return wk(h) ? h.some((S) => S === y) : y === h;
  }), a = (m, h) => {
    const g = {
      discountTotal: 0,
      discountMessage: "",
      discountTotalOff: 0
    };
    if (!h) return g;
    const { coupons: y } = h;
    return !y || !y.length ? g : (y.forEach((S) => {
      const x = S.metadata?.min || void 0, b = S.metadata?.max || void 0, _ = S.metadata?.description;
      (x === void 0 || m >= Number(x)) && (b === void 0 || m <= Number(b)) && (g.discountTotal = S.percentOff ?? 0, g.discountTotalOff = S.amountOff ?? 0, g.discountMessage = _ ?? S.name, g.bulkDiscountId = S.id);
    }), { ...g });
  }, i = (m, h, g) => {
    const y = h * m, {
      discountTotal: S,
      discountTotalOff: x,
      discountMessage: b,
      bulkDiscountId: _
    } = a(m, g), $ = S ? y * ((S ?? 0) / 100) : (x ?? 0) * m / 100;
    return {
      total: y - $,
      subTotal: y,
      discountTotal: S || x || 0,
      discountMessage: b,
      bulkDiscountId: _
    };
  }, o = (m, h) => {
    const g = m.map((y) => h.find((S) => S.stripeProductId === y.stripeProductId && S.variationId === y.stripeProductId) ?? y);
    return h.map((y) => {
      g.findIndex((x) => x.stripeProductId === y.stripeProductId && x.variationId === y.variationId) > -1 || g.push(y);
    }), g.map((y) => JSON.stringify(y));
  }, s = (m, h) => m.map((y) => {
    if (y.type === mr.Physical) {
      const S = y.total * ((h?.percentage || 0) / 100);
      return { ...y, tax: S, total: y.total + S };
    }
    return y;
  }), l = Bt((m, h, g) => {
    const y = (z, F, j) => z.map((H) => {
      const U = x(H, F);
      H = { ...H, discountTotal: U, total: H.total - U };
      const G = S(H, j);
      return { ...H, tax: G, total: H.total + G };
    }), S = (z, F) => !z?.weight || z.weight === 0 ? 0 : z.total * ((F?.percentage || 0) / 100), x = (z, F) => !g || g?.appliesTo?.length && !g?.appliesTo?.includes(z.stripeProductId) ? 0 : z.total * F / 100, b = (z, F, j) => {
      let H = 0;
      return g?.appliesTo?.length ? H = z.reduce((U, G) => g?.appliesTo?.includes(G.stripeProductId) ? U + G.total : U, 0) : H = j, F > H ? 100 : F / H * 100;
    }, { cartItems: _, cartShippingCost: $ } = m, w = _.reduce((z, F) => z + F.total, 0);
    let O = g?.percentOff || 0;
    g?.amountOff && (O = b(_, g.amountOff / 100, w));
    const T = mA(y(_, O, h)), I = $?.totalCharges || 0, P = $?.title || "", D = Math.trunc(T.reduce((z, F) => z + (F.discountTotal || 0), 0) * 100 | 0) / 100, B = Math.trunc((w + I - D) * 100 | 0) / 100, L = Math.trunc(T.reduce((z, F) => z + (F.tax || 0), 0) * 100 | 0) / 100, N = Math.trunc((B + L) * 100 | 0) / 100;
    return {
      subtotal: w,
      shipping: I,
      shippingTitle: P,
      totalTaxExcluded: B,
      total: N,
      tax: L,
      discount: D,
      couponName: g?.name
    };
  }, []);
  return {
    canBeBoughtOnlyOnce: e,
    isQuantityExceedingMax: t,
    showContentOnProductType: n,
    mergeCartItems: o,
    findDuplicateInCart: r,
    getShippingItemsTotalValue: s,
    calculateInvoiceTotal: l,
    calculateProductValues: i,
    addBeginCheckoutEvent: (m) => {
      window.dataLayer.push({ ecommerce: null }), window.dataLayer.push({
        event: "begin_checkout",
        ecommerce: {
          currency: "USD",
          value: m?.reduce((h, g) => h + (g?.total || 0), 0),
          items: m?.map((h) => ({
            item_id: h?.variationId || h?.stripeProductId,
            item_name: h?.name || "",
            coupon: h?.bulkDiscountId || "",
            discount: h?.discountTotal || 0,
            item_category: h?.category || "Product",
            price: h?.price || 0,
            quantity: h?.quantity || 1
          }))
        }
      });
    },
    addProductToCartEvent: (m, h) => (window.dataLayer.push({ ecommerce: null }), window.dataLayer.push({
      event: "add_to_cart",
      email: Zk("sha256").update(h?.email || "").digest("hex"),
      ecommerce: {
        currency: "USD",
        value: (m?.defaultPrice?.unit_amount || 0) / 100,
        items: [
          {
            item_id: m?.id || "",
            item_name: m?.name || "",
            item_category: m?.metadata?.category || "Product",
            price: (m?.defaultPrice?.unit_amount || 0) / 100,
            quantity: 1
          }
        ]
      }
    }), m),
    addOrderCompleteEvent: (m) => {
      window.dataLayer.push({ ecommerce: null }), window.dataLayer.push({
        event: "purchase",
        email: Zk("sha256").update(m.customersEmail).digest("hex"),
        ecommerce: {
          transaction_id: m?.id,
          value: (m?.total || 0) / 100,
          tax: (m?.totalTax || 0) / 100,
          shipping: (m?.shippingCost?.amount_total || 0) / 100,
          currency: "USD",
          coupon: m?.discount?.coupon?.id || "",
          items: m?.lines?.data?.map((h) => ({
            item_id: h?.price?.product?.toString() || h?.price?.id || h?.id,
            item_name: h?.metadata?.type === "certification" ? "Working Genius Certification" : h?.description || "",
            coupon: h?.discounts?.join(","),
            discount: h?.discount_amounts?.filter((g) => g?.amount > 0)?.reduce((g, y) => g + (y?.amount || 0) / 100, 0),
            item_category: h?.metadata?.category || "Product",
            price: (h?.price?.unit_amount || 0) / 100,
            quantity: h?.quantity || 1
          }))
        }
      });
    },
    alumniFormData: [
      {
        type: "CHECKBOX",
        label: "How would you be most likely to describe what you do?",
        name: "jobDescription",
        options: [
          {
            value: "Workshop facilitator/trainer",
            label: "Workshop facilitator/trainer"
          },
          {
            value: "Coach",
            label: "Coach"
          },
          {
            value: "Consultant",
            label: "Consultant"
          },
          {
            value: "Internal practitioner",
            label: "Internal practitioner"
          }
        ],
        id: "jobDescriptionId",
        required: !0
      },
      {
        type: "SELECT",
        label: "How long have you been doing this work?",
        name: "howLong",
        options: [
          {
            value: "Less than 2 years",
            label: "Less than 2 years"
          },
          {
            value: "2-5 years",
            label: "2-5 years"
          },
          {
            value: "More than 5 years",
            label: "More than 5 years"
          },
          {
            value: "I’m just getting started",
            label: "I’m just getting started"
          }
        ],
        id: "howLongId",
        required: !0
      },
      {
        type: "SELECT",
        label: "Which of these is currently your biggest challenge?",
        name: "currentChallenge",
        options: [
          {
            value: "Getting new clients",
            label: "Getting new clients"
          },
          {
            value: "Retaining current clients",
            label: "Retaining current clients"
          },
          {
            value: "Delivering amazing value",
            label: "Delivering amazing value"
          },
          {
            value: "Scaling my business",
            label: "Scaling my business"
          }
        ],
        id: "currentChallengeId",
        required: !0
      }
    ],
    ProductTypeEnum: mr
  };
}, Zqe = (e) => {
  const {
    addressLoading: t,
    isUpdatingAddress: r,
    addresses: n,
    getAddresses: a,
    updateAddress: i,
    addAddress: o
  } = GWe(e), s = () => n && n.find((u) => u.isDefault);
  return {
    addressLoading: t,
    isUpdatingAddress: r,
    addresses: n,
    getAddresses: a,
    updateAddress: i,
    addAddress: o,
    getDefaultAddress: s,
    getSelectedAddress: (u) => {
      const d = n && n.find((f) => Number(f.id) === Number(u));
      return d || s();
    },
    prepareAddressPayload: (u) => ({
      ...u,
      state: u?.state || "",
      stateCode: u?.stateCode || ""
    })
  };
}, Xqe = (e) => {
  const {
    invoicePaymentByPO: t,
    invoicePaymentByCC: r,
    invoicePaymentSignedByCC: n,
    getInvoiceById: a,
    isPaying: i,
    isLoadingInvoice: o,
    paymentInvoice: s,
    currentInvoice: l,
    setCurrentInvoice: c,
    setIsLoadingInvoice: u,
    isOrderProcessed: d
  } = WWe(e);
  return {
    invoicePaymentByPO: t,
    invoicePaymentByCC: r,
    invoicePaymentSignedByCC: n,
    getInvoiceById: a,
    isPaying: i,
    isLoadingInvoice: o,
    paymentInvoice: s,
    currentInvoice: l,
    setIsLoadingInvoice: u,
    isOrderProcessed: d,
    setCurrentInvoice: c
  };
}, Jqe = (e) => {
  const { loading: t, products: r, getPromoProducts: n } = zWe(e);
  return {
    loadingProducts: t,
    products: r,
    getPromoProducts: n
  };
}, Qqe = (e, t) => {
  const {
    getUserByEmail: r,
    userExists: n,
    isUserExistsLoading: a
  } = ote(e, t.userService);
  return {
    getUserByEmail: r,
    userExists: n,
    isUserExistsLoading: a
  };
}, gte = Ws({ theme: Tr.Default }), ia = () => xe.useContext(gte), VXe = ({
  apiEndpoint: e,
  applicationId: t = "TTG",
  captchaEnabled: r,
  captchaSiteKey: n,
  children: a
}) => {
  const i = t === "TTG" ? Tr.TTGApp : Tr.Default, [o, s] = He(i || Tr.Default), { isMobileView: l } = VWe(), c = (N) => s(N);
  if (!Object.values(["TTG", "WG"]).includes(t))
    throw new Error("Invalid applicationId. It must be one of the allowed application.");
  ni.set("checkout_application_id", t);
  const u = ni.get("TTG_USER"), d = !!u && u !== "undefined", f = `${e}/websocket-commerce`, m = XO.getInstance(e), h = KO.getInstance(e), g = rT.getInstance(e), y = YO.getInstance(e), S = qO.getInstance(e), x = ZO.getInstance(e), b = tT.getInstance(e), _ = iT.getInstance(e), $ = eT.getInstance(e), w = aT.getInstance(e), O = {
    exampleService: m,
    cartService: h,
    productService: g,
    addressService: S,
    shippingService: y,
    countryService: x,
    paymentService: b,
    userService: _,
    couponService: $,
    feedbackService: w
  }, T = Zqe(O), I = Xqe(O), P = Qqe(!1, O), D = Jqe(O), B = {
    addressHook: T,
    paymentHook: I,
    userHook: P,
    productHook: D
  }, L = { isMobileView: l };
  return /* @__PURE__ */ E.jsx(gte.Provider, { value: {
    theme: o,
    changeTheme: c,
    services: O,
    customHooks: B,
    screensSize: L,
    applicationId: t,
    webSocketCommerceUrl: f,
    captchaEnabled: r,
    captchaSiteKey: n,
    isUserLoggedIn: d
  }, children: a });
}, hA = (e, t, r = !1, n = 5) => {
  const a = t || "default", i = dr(() => ({
    id: Gk(),
    cartItems: [],
    cartShippingCost: void 0,
    created: /* @__PURE__ */ new Date()
  }), []), o = (q) => n * 24 * 60 * 60 * 1e3 - ((/* @__PURE__ */ new Date()).getTime() - q.getTime()) < 0, [s, l, c, u] = HWe(
    "usersCart",
    i,
    a,
    e
  ), d = dr(
    () => o(new Date(s.created)) ? i : {
      ...s,
      created: new Date(s.created)
    },
    [s]
  ), {
    mergeCartItems: f,
    canBeBoughtOnlyOnce: m,
    findDuplicateInCart: h,
    calculateProductValues: g,
    addProductToCartEvent: y
  } = qd(), {
    services: S,
    customHooks: { productHook: x, paymentHook: b }
  } = ia(), [_, $] = He(!0), [w, O] = He(!1), [T, I] = He(null), {
    createCart: P,
    getCart: D,
    tax: B,
    getTax: L,
    loading: N
  } = FWe(S), { currentInvoice: z } = b, { products: F, getPromoProducts: j } = x, {
    loading: H,
    availableShippingMethods: U,
    resetAvailableShippingMethods: G,
    estimateShipping: V,
    addressError: K
  } = BWe(S), { user: Z } = ote(!!t, S.userService), [ee, ae] = He([]), [ue, re] = He(!1), [oe, fe] = He(!1), le = Bt(
    (q, Y) => {
      l(q, Y);
    },
    [l]
  ), se = Bt(
    (q) => {
      const Y = { ...d }, X = Y?.cartItems?.findIndex((pe) => pe.stripeProductId === q.stripeProductId && (!pe.variationId || pe.variationId === q.variationId));
      X !== -1 && (Y.cartItems[X] = { ...q }, le(Y, q));
    },
    [d, le]
  ), Q = Bt(
    (q, Y = null, X) => {
      const pe = { ...d }, $e = h(
        q,
        pe?.cartItems ?? []
      );
      $e !== -1 && pe.cartItems.splice($e, 1);
      const J = pe?.cartItems?.findIndex((de) => de.stripeProductId === q.stripeProductId && (!de.variationId || de.variationId === q.variationId));
      if (J === -1) {
        const de = q?.product, { quantity: Se, price: Ee } = q, Te = g(
          Se,
          Ee,
          de
        );
        pe.cartItems.push({ ...q, ...Te });
      } else {
        const de = d.cartItems[J];
        de.quantity = Y ?? (m(de) ? 1 : de.quantity + 1);
        const { quantity: Se, price: Ee } = d.cartItems[J], Te = X ? q.product : d.cartItems[J].product, Le = g(
          Se,
          Ee,
          Te
        );
        pe.cartItems[J] = {
          ...pe.cartItems[J],
          ...Le
        };
      }
      le(
        {
          ...pe,
          cartShippingCost: void 0,
          promoCode: X ?? pe.promoCode
        },
        q
      );
    },
    [d, le]
  ), he = Bt(
    (q) => {
      if (!d) return;
      const Y = { ...d }, X = [mr.Certification.toString(), mr.AlumniIntensive.toString()].includes(q?.type) || q?.variationId;
      Y.cartItems = Y?.cartItems.filter((pe) => X ? q?.variationId && pe?.variationId !== q?.variationId : pe.stripeProductId !== q.stripeProductId), le({
        ...Y,
        cartShippingCost: void 0,
        promoCode: Y.cartItems.length === 0 ? null : Y.promoCode
      });
    },
    [d, le]
  ), ne = Bt(
    (q, Y) => {
      const X = F.find((Ee) => (Ee.id || "") === q && (!Y || Ee.metadata?.variation_id === Y));
      if (!X) throw new Error("Product not found");
      const pe = X?.metadata?.virtual?.toString() !== "true", $e = pe && X?.metadata?.allow_international_order?.toString() === "true", J = {
        zenCartProductId: q,
        stripeProductId: X.id,
        stripePriceId: X?.defaultPrice?.id,
        quantity: 1,
        price: (X?.defaultPrice?.unit_amount || 0) / 100,
        subTotal: (X?.defaultPrice?.unit_amount || 0) / 100,
        total: (X?.defaultPrice?.unit_amount || 0) / 100,
        isPhysical: pe,
        type: X?.metadata?.type || "",
        tags: X?.metadata?.tags || "",
        category: X?.metadata?.category || "Product",
        name: X.name,
        product: X,
        weight: X?.packageDimensions?.weight ?? 0,
        length: X?.packageDimensions?.length ?? 0,
        height: X?.packageDimensions?.height ?? 0,
        width: X?.packageDimensions?.width ?? 0,
        variationId: Y,
        metadata: {},
        allowIntlOrder: $e,
        intlTag: X?.metadata?.international_order_tag?.toString()
      }, de = d?.cartItems?.some((Ee) => Ee.type === mr.Certification), Se = d?.cartItems?.some((Ee) => Ee.type === mr.AlumniIntensive);
      if (J.type === mr.Certification && Se || X.type === mr.AlumniIntensive.toString() && de)
        throw new Error("Cannot combine Certification and Alumni Intensive");
      if (J.type === mr.AlumniIntensive && d?.cartItems?.some((Ee) => Ee?.name === J?.name && Ee?.type === mr.AlumniIntensive))
        throw new Error("This product is already in cart");
      if (J.type === mr.AlumniIntensive && Z?.wgAlumniIntensives?.some((Ee) => Ee.id === J.variationId || Ee.name === J.name))
        throw new Error("You have already purchased this product");
      return Q(J), y(X, Z), X;
    },
    [Q, F]
  ), me = Bt(
    async (q) => {
      if (!t || !d?.id || _)
        return Promise.resolve(null);
      const Y = mA(d);
      Y.cartItems?.map(($e) => delete $e?.product);
      const X = await P({
        ...Y,
        ...q
      }), pe = z ? null : await L();
      return X && I(X), [X, pe];
    },
    [t, d, _, P, L]
  ), k = Bt(
    (q) => {
      if (!d?.cartItems || d?.cartItems?.length === 0 || !q.postCode || !q.country.code)
        return;
      const Y = d.cartItems.map((X) => ({
        id: X.stripeProductId,
        cartId: d.id,
        quantity: X.quantity,
        isPhysical: X.isPhysical,
        weight: X.weight || 0,
        length: X.length || 0,
        height: X.height || 0,
        width: X.width || 0,
        allowIntlOrder: X?.allowIntlOrder
      }));
      V(Y, q);
    },
    [V, d]
  ), M = Bt(
    (q) => (O(!0), j(q).then((Y) => !Y || Y.length === 0 ? (le({ ...d, promoCode: q }), Y?.length === 0 ? Qu.PromoNoProduct : Qu.PromoOnlyTrack) : (Y.forEach((X) => {
      const pe = X?.metadata?.virtual?.toString() !== "true", $e = pe && X?.metadata?.allow_international_order?.toString() === "true", J = X?.coupons && X.coupons.length ? Number(X.coupons[0].metadata?.quantity ?? 1) : 1, de = {
        zenCartProductId: X.id,
        stripeProductId: X.id,
        stripePriceId: X?.defaultPrice?.id,
        quantity: J,
        price: (X?.defaultPrice?.unit_amount || 0) / 100,
        subTotal: (X?.defaultPrice?.unit_amount || 0) / 100,
        total: (X?.defaultPrice?.unit_amount || 0) / 100,
        isPhysical: pe,
        type: X?.metadata?.type || "",
        tags: X?.metadata?.tags || "",
        name: X.name,
        product: X,
        weight: X?.packageDimensions?.weight ?? 0,
        variationId: X?.metadata?.variation_id,
        allowIntlOrder: $e,
        metadata: {},
        intlTag: X?.metadata?.international_order_tag?.toString()
      };
      Q(de, J, q);
    }), Qu.PromoWithProduct)).catch((Y) => (le({ ...d, promoCode: q }), Qu.PromoOnlyTrack)).finally(() => O(!1))),
    [j, d]
  );
  St(() => {
    if (d?.cartItems?.length && F?.length) {
      let q = [];
      d.cartItems.forEach((X) => {
        const pe = X?.product?.metadata?.suggested_products?.split(",") || [], $e = F.filter((J) => pe.includes(J.id || "") && !q.find((de) => de.id === J.id)).sort((J, de) => pe.indexOf(J.id) - pe.indexOf(de.id));
        q = [
          ...q,
          ...$e
        ];
      });
      const Y = q.filter((X, pe) => pe === q.findIndex(($e) => $e.id === X.id) && (X.metadata?.type !== mr.Certification || d.cartItems.findIndex(($e) => $e.product?.metadata?.type === mr.Certification) === -1)).filter((X) => !d.cartItems.find((pe) => pe.stripeProductId === X.id)).map((X) => ({
        product: X,
        previewOnly: X.metadata?.type === mr.Certification || X.metadata?.type === mr.Workshop || X.metadata?.type === mr.WGBook,
        description: X.metadata?.type !== mr.Certification ? X.description : "Working Genius Certification"
      }));
      ae(Y);
    }
  }, [d, F]), St(() => {
    r && d?.id && me();
  }, [d, r]);
  const R = Bt(() => d?.cartItems && d.cartItems.some((q) => q.product?.metadata?.type === mr.AppGuide), [d]);
  return St(() => {
    if (!t) return $(!1);
    let q;
    const Y = c("default");
    $(!0), D().then((X) => {
      const pe = [...Y?.cartItems || []], $e = [
        ...d?.cartItems || []
      ].filter((Fe, Ne) => Fe?.product?.metadata?.type !== mr.Certification || pe?.findIndex((qe) => qe?.product?.metadata?.type === mr.Certification) === -1), J = f(
        $e,
        pe
      ), de = new Set(J), Se = Array.from(de).map((Fe) => JSON.parse(Fe)), Ee = Y?.promoCode ?? d?.promoCode, Te = {
        ...d,
        ...Y,
        promoCode: Ee || null,
        cartItems: Se
      }, Le = Te?.cartItems?.length > 0 ? Te.cartItems : [];
      X?.cartItems?.forEach((Fe) => {
        const Ne = Le.findIndex((it) => it.stripeProductId === Fe.stripeProductId && (!it.variationId || it.variationId === Fe.variationId)), qe = h(
          Fe,
          Le
        );
        if (Ne > -1 || qe > -1)
          return;
        const { id: Qe, cartId: tt, ...Ge } = Fe;
        Le.push(Ge);
      });
      const Ie = Te?.promoCode || X?.promoCode, De = {
        ...Te,
        cartItems: Le,
        id: X?.id || Te?.id || Gk(),
        cartShippingCost: X?.cartShippingCost,
        promoCode: Ie || null
      };
      q = De;
      const Ae = X ? {
        ...X,
        id: De.id,
        promoCode: De.promoCode,
        cartItems: De.cartItems
      } : null;
      I(Ae);
    }).finally(() => {
      u("default"), $(!1), le(q);
    });
  }, [t]), St(() => {
    re(R() && Z?.hasTeamApplicationGuide);
  }, [R, Z]), St(() => {
    fe(!Z?.hasTeamApplicationGuide && !Z?.hasWg && !Z?.hasCertification);
  }, [Z]), {
    localUserCartData: d,
    cartData: T,
    updateCart: le,
    updateCartItem: se,
    removeCartItem: he,
    addItemToCart: Q,
    onAddPreviewItem: ne,
    loadingCartHook: _,
    addMoreViewItems: ee,
    handleCreateCart: me,
    loadingEstimateShipping: H,
    estimateShippingCost: k,
    availableShippingMethods: U,
    resetAvailableShippingMethods: G,
    hasTeamAppGuide: ue,
    isFirstTimeWgPurchaser: oe,
    tax: B,
    getTax: L,
    loadPromoProducts: M,
    loadingPromoProducts: w,
    addressError: K,
    resetCart: (q) => u(q),
    loadingCart: N
  };
}, eKe = ({ onContinueShopping: e }) => {
  const { theme: t } = ia(), r = t !== Tr.Default ? `ttg-cart-empty-state--skin--${t}` : "", n = dr(() => /* @__PURE__ */ E.jsxs(lr, { size: "middle", direction: "vertical", children: [
    /* @__PURE__ */ E.jsx("span", { className: "cart-empty-title", children: "Your Cart is empty" }),
    /* @__PURE__ */ E.jsx("span", { className: "cart-empty-subtitle", children: "There are currently no products in your shopping cart." })
  ] }), []);
  return /* @__PURE__ */ E.jsx(Io, { image: /* @__PURE__ */ E.jsx(WW, { className: "shopping-cart-icon" }), description: n, className: `ttg-cart-empty-state ${r}`, children: /* @__PURE__ */ E.jsx(Nt, { type: "primary", onClick: e, children: "Continue Shopping" }) });
}, yte = ({ cartItems: e, children: t, onContinueShopping: r }) => dr(() => e ? /* @__PURE__ */ E.jsx(At, { className: "w-full", children: t }) : /* @__PURE__ */ E.jsx(At, { justify: "center", align: "middle", className: "card-content-empty-state", children: /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(eKe, { onContinueShopping: r }) }) }), [e, t]), Xk = "data:image/png;base64,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", Jk = {
  en: {
    learnMoreButton: "Learn More"
  },
  es: {
    learnMoreButton: "Más Info"
  },
  de: {
    learnMoreButton: "Lern Mehr"
  }
}, { Text: Yo, Title: Qk } = Gn, tKe = ({
  item: e,
  preview: t = !1,
  details: r = !1,
  onAddClick: n,
  onRemoveClick: a,
  onItemQuantityChange: i,
  highlightItem: o = !1
}) => {
  const { product: s, previewOnly: l, description: c } = e, u = () => s?.url && window.open(s?.url, "_blank"), { theme: d } = ia(), f = d !== Tr.Default ? `ttg-cart-item--skin--${d}` : "", m = localStorage.getItem("wglang") || "en", {
    quantity: h,
    total: g,
    discountTotal: y,
    price: S,
    discountMessage: x
  } = e, b = t ? c ?? s?.name : e?.product?.name, _ = e?.product?.metadata?.type === mr.Certification, $ = e?.product?.metadata?.type === mr.AlumniIntensive, w = e?.product?.metadata?.type === mr.AppGuide, O = () => t ? s ? (s?.defaultPrice?.unit_amount || 0) / 100 : 0 : S, T = l ? !1 : new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(O()), I = () => t ? s?.images?.[0] ?? Xk : e?.product?.images?.[0] || Xk, P = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(g), D = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(e?.subTotal), B = (F) => {
    i && F && !_ && !w && !$ && i(e, F);
  };
  St(() => {
    o && document.getElementById(e?.stripeProductId)?.scrollIntoView({
      behavior: "smooth",
      block: "end"
    });
  }, [o, e]);
  const L = () => r ? /* @__PURE__ */ E.jsx(Oe, { xs: 24, sm: t ? 12 : 24, md: 12, children: /* @__PURE__ */ E.jsxs(lr, { direction: "horizontal", align: "center", size: 16, children: [
    /* @__PURE__ */ E.jsx(qb, { src: I(), alt: b }),
    /* @__PURE__ */ E.jsxs(lr, { direction: "vertical", size: 8, children: [
      /* @__PURE__ */ E.jsx(Yo, { id: "cart-item-name", children: b }),
      y && y !== 0 ? /* @__PURE__ */ E.jsx(Qk, { level: 5, children: x }) : null,
      t && !!T && /* @__PURE__ */ E.jsx(Yo, { children: T })
    ] })
  ] }) }) : /* @__PURE__ */ E.jsx(Oe, { flex: "1", children: /* @__PURE__ */ E.jsxs(lr, { direction: "vertical", size: 8, children: [
    /* @__PURE__ */ E.jsx(Yo, { id: "cart-item-name", children: b }),
    y && y !== 0 ? /* @__PURE__ */ E.jsx(Qk, { level: 5, children: x }) : null,
    t && /* @__PURE__ */ E.jsx(Yo, { children: T })
  ] }) }), N = () => t ? /* @__PURE__ */ E.jsx(Oe, { xs: 24, sm: 12, children: /* @__PURE__ */ E.jsxs(
    At,
    {
      justify: "space-between",
      align: "middle",
      gutter: [12, 12],
      className: "ttg-cart-details-preview-items",
      children: [
        /* @__PURE__ */ E.jsx(Oe, { sm: 24, children: !!n && !l && /* @__PURE__ */ E.jsx(
          Nt,
          {
            className: "uppercase",
            onClick: () => n(s?.id),
            children: "Add"
          }
        ) }),
        /* @__PURE__ */ E.jsx(Oe, { sm: 24, children: /* @__PURE__ */ E.jsx(
          Nt,
          {
            id: "learn-more-cart-item-button",
            type: "primary",
            className: "uppercase",
            onClick: u,
            children: Jk[m].learnMoreButton
          }
        ) })
      ]
    }
  ) }) : /* @__PURE__ */ E.jsx(Oe, { sm: 24, md: 12, className: "ttg-cart-details-item-details", children: /* @__PURE__ */ E.jsxs(At, { align: "middle", justify: "space-between", children: [
    /* @__PURE__ */ E.jsx(Oe, { className: "ttg-cart-item-body-values", children: /* @__PURE__ */ E.jsx(Yo, { children: T }) }),
    /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsxs(At, { className: "flex-col", justify: "center", align: "middle", children: [
      /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(
        Vb,
        {
          min: 1,
          max: 9999,
          value: h,
          controls: !_ && !w && !$,
          onChange: B
        }
      ) }),
      a && /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(
        Nt,
        {
          type: "link",
          size: "small",
          onClick: () => a(e),
          children: "Remove"
        }
      ) })
    ] }) }),
    /* @__PURE__ */ E.jsx(Oe, { className: "ttg-cart-item-body-values right", children: /* @__PURE__ */ E.jsxs(lr, { direction: "vertical", size: 0, children: [
      /* @__PURE__ */ E.jsx(Yo, { children: P }),
      y && y !== 0 ? /* @__PURE__ */ E.jsx(Yo, { className: "subtotal-value", children: D }) : null
    ] }) })
  ] }) }), z = () => t ? /* @__PURE__ */ E.jsx(Oe, { xs: 24, sm: 12, className: "ttg-sidebar-preview-items", children: /* @__PURE__ */ E.jsxs(At, { justify: "space-between", align: "middle", gutter: [12, 12], children: [
    !!n && !l && /* @__PURE__ */ E.jsx(Oe, { xs: 12, sm: 24, children: /* @__PURE__ */ E.jsx(
      Nt,
      {
        className: "uppercase",
        onClick: () => n(s?.id),
        children: "Add"
      }
    ) }),
    /* @__PURE__ */ E.jsx(Oe, { xs: 12, sm: 24, children: /* @__PURE__ */ E.jsx(
      Nt,
      {
        id: "learn-more-cart-item-button",
        type: "primary",
        className: "uppercase",
        onClick: u,
        children: Jk[m].learnMoreButton
      }
    ) })
  ] }) }) : /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(
    At,
    {
      align: "middle",
      justify: "space-between",
      className: "ttg-card-item-body",
      children: [
        /* @__PURE__ */ E.jsx(Oe, { className: "ttg-cart-item-body-values", children: /* @__PURE__ */ E.jsx(Yo, { children: T }) }),
        /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsxs(At, { className: "flex-col", justify: "center", align: "middle", children: [
          /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(
            Vb,
            {
              min: 1,
              max: 9999,
              value: h,
              controls: !_ && !w && !$,
              onChange: B
            }
          ) }),
          a && /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(
            Nt,
            {
              type: "link",
              size: "small",
              onClick: () => a(e),
              children: "Remove"
            }
          ) })
        ] }) }),
        /* @__PURE__ */ E.jsx(Oe, { className: "ttg-cart-item-body-values right", children: /* @__PURE__ */ E.jsxs(lr, { direction: "vertical", size: 0, children: [
          /* @__PURE__ */ E.jsx(Yo, { children: P }),
          y && y !== 0 ? /* @__PURE__ */ E.jsx(Yo, { className: "subtotal-value", children: D }) : null
        ] }) })
      ]
    }
  ) });
  return /* @__PURE__ */ E.jsx(
    zn,
    {
      id: e?.stripeProductId,
      type: "inner",
      bordered: !1,
      className: `ttg-cart-item w-full ${f}`,
      children: /* @__PURE__ */ E.jsxs(
        lr,
        {
          direction: "horizontal",
          size: 16,
          align: "start",
          className: `w-full ${o ? "highlighted" : ""}`,
          children: [
            !r && /* @__PURE__ */ E.jsx(qb, { src: I(), alt: b }),
            /* @__PURE__ */ E.jsxs(At, { gutter: [12, 12], justify: "space-between", className: "w-full", children: [
              L(),
              r ? N() : z()
            ] })
          ]
        }
      )
    }
  );
}, d1 = ({
  items: e,
  preview: t = !1,
  details: r = !1,
  onAddClick: n,
  onRemoveItemClick: a,
  onItemQuantityChange: i,
  loading: o = !1,
  highlightItem: s = ""
}) => {
  const l = dr(() => e ? e.map((c, u) => /* @__PURE__ */ E.jsx(At, { justify: "center", align: "middle", children: /* @__PURE__ */ E.jsx(
    Oe,
    {
      span: 24,
      className: `${r && u < e.length - 1 ? "border-b border-gray-200" : ""}`,
      children: /* @__PURE__ */ E.jsx(
        tKe,
        {
          onAddClick: n,
          onRemoveClick: (d) => a && a(d),
          onItemQuantityChange: i,
          details: r,
          preview: t,
          item: { ...c },
          highlightItem: c.stripeProductId === s
        }
      )
    }
  ) }, u)) : null, [
    e,
    r,
    n,
    i,
    t,
    s,
    a
  ]);
  return /* @__PURE__ */ E.jsx(Ui, { loading: o, children: l });
}, { Text: eF } = Gn, rKe = [
  "Wonder",
  "Discernment",
  "Enablement",
  "Invention",
  "Galvanizing",
  "Tenacity"
], nKe = ({ name: e, form: t }) => {
  const { theme: r } = ia(), { useWatch: n } = Dt, a = r !== Tr.Default ? `ant-checkbox-group--skin--${r}` : "", i = !!n("registerSelect", t), o = (u) => {
    if (u.length > 2) {
      const d = u.slice(1);
      t.setFieldValue(e, d);
    } else
      t.setFieldValue(e, u);
  }, s = () => rKe.map((u, d) => /* @__PURE__ */ E.jsx(Oe, { xs: 12, sm: 12, md: 8, children: /* @__PURE__ */ E.jsx(co, { value: u, children: u }) }, d)), l = () => /* @__PURE__ */ E.jsxs(lr, { direction: "vertical", size: 4, className: "ttg-cart-details-working-geniuses", children: [
    /* @__PURE__ */ E.jsx(eF, { className: "ttg-cart-details-working-geniuses-header", children: `What are ${i ? "their" : "your"} Working Geniuses?` }),
    /* @__PURE__ */ E.jsx(eF, { className: "ttg-cart-details-working-geniuses-subheader", children: "You need to select 2 of these geniuses" })
  ] }), c = (u, d) => d.length >= 2 ? Promise.resolve() : d.length === 0 ? Promise.reject(new Error("is required")) : Promise.reject(new Error("Please select two of these geniuses."));
  return /* @__PURE__ */ E.jsx(At, { className: "py-3", children: /* @__PURE__ */ E.jsx(
    Dt.Item,
    {
      label: l(),
      labelCol: { span: 24 },
      className: "ttg-cart-details-working-geniuses-form-item",
      name: e,
      initialValue: [],
      rules: [
        { validator: c }
      ],
      children: /* @__PURE__ */ E.jsx(co.Group, { onChange: o, className: `${a} w-full`, children: /* @__PURE__ */ E.jsx(At, { className: "pt-3", children: s() }) })
    }
  ) });
}, Z_ = ({
  step: e,
  setStep: t,
  setOpen: r,
  onCheckoutClick: n,
  registerSelect: a
}) => {
  const { theme: i } = ia(), o = i !== Tr.Default ? `sidebar-register-modal-footer--skin--${i}` : "", s = () => {
    r && r(!1);
  }, l = () => {
    e === 2 && n();
  }, c = () => t(1);
  return dr(() => /* @__PURE__ */ E.jsx(Oe, { span: 24, className: `px-3 pt-4 pb-2 sidebar-register-modal-footer ${o}`, children: /* @__PURE__ */ E.jsx(At, { justify: "end", children: /* @__PURE__ */ E.jsxs(lr, { children: [
    e === 1 ? /* @__PURE__ */ E.jsx(Nt, { onClick: s, children: "Cancel" }) : /* @__PURE__ */ E.jsx(Nt, { onClick: c, children: "Back" }),
    a && e === 1 ? /* @__PURE__ */ E.jsx(Nt, { type: "primary", htmlType: "submit", children: "Continue" }) : /* @__PURE__ */ E.jsx(Nt, { type: "primary", htmlType: "submit", onClick: l, children: "Proceed with Checkout" })
  ] }) }) }), [a, e]);
}, { Text: So, Paragraph: aKe } = Gn, bte = ({
  onCheckoutClick: e,
  setOpen: t,
  checkoutFromSidebar: r = !1,
  cartItems: n,
  exceedsMaxQuantity: a = !1,
  updateCartItem: i
}) => {
  const {
    theme: o,
    customHooks: { userHook: s },
    captchaEnabled: l = !0,
    captchaSiteKey: c,
    isUserLoggedIn: u
  } = ia(), d = o !== Tr.Default ? `ttg-cart-details-register--skin--${o}` : "", f = o !== Tr.Default ? `register-modal-footer--skin--${o}` : "", m = ct("recaptcha"), [h] = Dt.useForm(), { useWatch: g } = Dt, { userExists: y, getUserByEmail: S, isUserExistsLoading: x } = s, [b, _] = xe.useState(!1), $ = !!g("registerSelect", h), [w, O] = He(!1), [T, I] = He(""), [P, D] = He(n?.find((re) => re?.product?.metadata?.type === mr.Certification)), [B, L] = He(1), N = [
    { value: 0, label: "No" },
    { value: 1, label: "Yes" }
  ], z = {
    registerSelect: P?.participantEmail ? 1 : 0,
    participantEmail: P?.participantEmail || "",
    yourWG: P?.yourWorkingGeniuses?.split(",") || []
  }, F = (re) => {
    const oe = {
      ...P,
      registerSelect: re?.registerSelect,
      participantEmail: re?.participantEmail || void 0,
      yourWorkingGeniuses: re?.yourWG?.join(",") || void 0
    };
    return D(oe), oe;
  }, j = (re) => {
    Object.prototype.hasOwnProperty.call(re, "registerSelect") && delete re.registerSelect;
    const oe = Object.assign({}, re);
    oe && re && i(oe), e();
  }, H = () => y?.exists ? /* @__PURE__ */ E.jsxs(At, { className: "ttg-cart-details-register-modal", children: [
    /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "mb-4", children: /* @__PURE__ */ E.jsxs(
      lr,
      {
        direction: "vertical",
        size: 20,
        className: "ttg-cart-details-register-modal-content",
        children: [
          /* @__PURE__ */ E.jsxs(So, { children: [
            /* @__PURE__ */ E.jsx(So, { className: "user-email", children: T }),
            " will access their Certification materials through the account they have already set up at ",
            /* @__PURE__ */ E.jsx("a", { type: "link", href: "https://www.workinggenius.com", target: "_blank", rel: "noreferrer", children: "www.workinggenius.com" }),
            "."
          ] }),
          /* @__PURE__ */ E.jsx(So, { children: "At checkout, please make sure to use the shipping information of the person being registered for Certification since the Welcome Kit will be shipped to that address." })
        ]
      }
    ) }),
    r && /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
      Z_,
      {
        registerSelect: $,
        step: B,
        setStep: L,
        setOpen: t,
        onCheckoutClick: () => P && j(P)
      }
    ) })
  ] }) : /* @__PURE__ */ E.jsxs(At, { className: "ttg-cart-details-register-modal", children: [
    /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "mb-4", children: /* @__PURE__ */ E.jsxs(
      lr,
      {
        direction: "vertical",
        size: 20,
        className: "ttg-cart-details-register-modal-content",
        children: [
          /* @__PURE__ */ E.jsxs(So, { children: [
            /* @__PURE__ */ E.jsx(So, { className: "user-email", children: T }),
            " doesn't have an account with the Working Genius."
          ] }),
          /* @__PURE__ */ E.jsx(So, { children: "At checkout, please make sure to use the shipping information of the person being registered for Certification since the Welcome Kit will be shipped to that address." }),
          /* @__PURE__ */ E.jsx(So, { children: "Proceeding with checkout will send the person being registered for an invitation to create an account in order to access their Certification materials." })
        ]
      }
    ) }),
    r && /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
      Z_,
      {
        registerSelect: $,
        step: B,
        setStep: L,
        setOpen: t,
        onCheckoutClick: () => P && j(P)
      }
    ) })
  ] }), U = () => /* @__PURE__ */ E.jsxs(lr, { direction: "vertical", size: 8, className: "w-full", children: [
    /* @__PURE__ */ E.jsx(
      Dt.Item,
      {
        label: "Email Address",
        name: "participantEmail",
        labelCol: { span: 24 },
        rules: [
          {
            required: !0,
            message: "is required"
          },
          {
            pattern: nC,
            message: "Please enter a valid email address."
          }
        ],
        children: /* @__PURE__ */ E.jsx(
          Lr,
          {
            onBlur: (re) => h.setFieldValue("participantEmail", re.target.value.trim())
          }
        )
      }
    ),
    /* @__PURE__ */ E.jsx(So, { className: "ttg-cart-details-register-participant-info", children: "Email address of the participant you would like to register for Working Genius certification" })
  ] }), G = () => r ? /* @__PURE__ */ E.jsxs(At, { align: "middle", justify: "space-between", children: [
    /* @__PURE__ */ E.jsx(Oe, { span: 18, children: /* @__PURE__ */ E.jsxs(lr, { direction: "horizontal", align: "center", children: [
      /* @__PURE__ */ E.jsx(So, { className: "text-sm leading-5 font-medium", children: "Are you registering for someone else?" }),
      /* @__PURE__ */ E.jsx(lo, { zIndex: 2100, title: 'Select "Yes" if you are purchasing for someone else. They will get notified by email.', children: /* @__PURE__ */ E.jsx(_l, { className: "tooltip-icon", size: 16 }) })
    ] }) }),
    /* @__PURE__ */ E.jsx(Oe, { span: 6, flex: "0 1 5.75rem", children: /* @__PURE__ */ E.jsx(
      Dt.Item,
      {
        name: "registerSelect",
        initialValue: 0,
        children: /* @__PURE__ */ E.jsx(
          Kn,
          {
            options: N
          }
        )
      }
    ) })
  ] }) : /* @__PURE__ */ E.jsx(
    Dt.Item,
    {
      label: "Are you registering for someone else?",
      labelCol: { span: 24 },
      name: "registerSelect",
      tooltip: { title: 'Select "Yes" if you are purchasing for someone else. They will get notified by email.', icon: /* @__PURE__ */ E.jsx(_l, { className: "tooltip-icon", size: 20 }) },
      children: /* @__PURE__ */ E.jsx(
        Kn,
        {
          options: N
        }
      )
    }
  ), V = () => /* @__PURE__ */ E.jsxs(At, { className: `register-modal-footer ${f}`, gutter: [12, 0], children: [
    /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(Nt, { onClick: ae, children: "Cancel" }) }),
    /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(Nt, { type: "primary", onClick: ue, children: "Proceed with checkout" }) })
  ] }), K = async (re) => {
    if (re.registerSelect) {
      const oe = await m?.current?.getCaptchaValue() ?? null;
      return I(re.participantEmail), S(re.participantEmail, oe).then(() => F(re)).finally(() => O(!0));
    } else {
      const oe = F(re);
      j(oe);
    }
  }, Z = async (re) => {
    if (re.registerSelect && B === 1) {
      const oe = await m?.current?.getCaptchaValue() ?? null;
      return I(re.participantEmail), S(re.participantEmail, oe).then(() => F(re)).finally(() => L(2));
    } else {
      const oe = F(re);
      j(oe);
    }
  }, ee = (re) => r ? Z(re) : K(re), ae = () => O(!w), ue = () => {
    P && j(P), O(!w);
  };
  return r && B === 2 ? H() : /* @__PURE__ */ E.jsxs(At, { align: "middle", className: `ttg-cart-details-register ${d}`, children: [
    /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(
      Dt,
      {
        form: h,
        onFinish: ee,
        onFinishFailed: () => _(!0),
        validateTrigger: b ? "onChange" : "onSubmit",
        initialValues: z,
        children: [
          /* @__PURE__ */ E.jsxs(At, { justify: "start", children: [
            !r && /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "py-3", children: /* @__PURE__ */ E.jsx(So, { className: "ttg-cart-details-register-header", children: "Please confirm the following:" }) }),
            /* @__PURE__ */ E.jsx(
              Oe,
              {
                xs: 24,
                sm: 24,
                md: r ? 24 : 12,
                className: `py-3 ${r ? "" : "md:pr-4 lg:pr-8"}`,
                children: /* @__PURE__ */ E.jsxs(lr, { direction: "vertical", size: 20, className: "w-full", children: [
                  G(),
                  $ && U()
                ] })
              }
            ),
            /* @__PURE__ */ E.jsx(
              Oe,
              {
                xs: 24,
                sm: 24,
                md: r ? 24 : 12,
                className: `ttg-cart-details-register-bordered-tab ${r ? "register-modal" : ""}`,
                children: /* @__PURE__ */ E.jsx(nKe, { name: "yourWG", form: h })
              }
            ),
            /* @__PURE__ */ E.jsxs(Oe, { span: 24, className: `ttg-cart-details-register-note-container ${r ? "sidebar" : ""}`, children: [
              /* @__PURE__ */ E.jsx(So, { className: "ttg-cart-details-register-note-title", children: "Note:" }),
              /* @__PURE__ */ E.jsx(aKe, { className: "ttg-cart-details-register-note-description", children: "Please note that we will be shipping a Working Genius Certification Welcome Kit to participants that provide a US domestic shipping address at checkout. Other arrangements will be made for those with an international shipping address." })
            ] }),
            r ? /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
              Z_,
              {
                registerSelect: $,
                step: B,
                setStep: L,
                setOpen: t,
                onCheckoutClick: e
              }
            ) }) : /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "px-3 pt-4 pb-2", children: /* @__PURE__ */ E.jsx(At, { justify: "end", children: /* @__PURE__ */ E.jsx(Nt, { id: "checkout-button", type: "primary", className: "ttg-cart-details-checkout-button", htmlType: "submit", loading: x, disabled: a, children: "Checkout" }) }) })
          ] }),
          /* @__PURE__ */ E.jsx(iC, { ref: m, captchaEnabled: l && !u, captchaSiteKey: c })
        ]
      }
    ) }),
    !r && /* @__PURE__ */ E.jsx(
      da,
      {
        open: w,
        width: "657px",
        className: `tg-cart-details-register ${d}`,
        title: "Please answer the following:",
        onCancel: ae,
        footer: V(),
        centered: !0,
        children: H()
      }
    )
  ] });
};
var iKe = Math.floor, oKe = Math.random;
function sKe(e, t) {
  return e + iKe(oKe() * (t - e + 1));
}
var lKe = sKe, cKe = wC, uKe = cA, dKe = Gee, fKe = Yc;
function pKe(e, t, r) {
  if (!fKe(r))
    return !1;
  var n = typeof t;
  return (n == "number" ? uKe(r) && dKe(t, r.length) : n == "string" && t in r) ? cKe(r[t], e) : !1;
}
var mKe = pKe, vKe = /\s/;
function hKe(e) {
  for (var t = e.length; t-- && vKe.test(e.charAt(t)); )
    ;
  return t;
}
var gKe = hKe, yKe = gKe, bKe = /^\s+/;
function CKe(e) {
  return e && e.slice(0, yKe(e) + 1).replace(bKe, "");
}
var SKe = CKe, xKe = qh, $Ke = Xc, _Ke = "[object Symbol]";
function EKe(e) {
  return typeof e == "symbol" || $Ke(e) && xKe(e) == _Ke;
}
var wKe = EKe, OKe = SKe, tF = Yc, TKe = wKe, rF = NaN, IKe = /^[-+]0x[0-9a-f]+$/i, MKe = /^0b[01]+$/i, AKe = /^0o[0-7]+$/i, PKe = parseInt;
function RKe(e) {
  if (typeof e == "number")
    return e;
  if (TKe(e))
    return rF;
  if (tF(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = tF(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = OKe(e);
  var r = MKe.test(e);
  return r || AKe.test(e) ? PKe(e.slice(2), r ? 2 : 8) : IKe.test(e) ? rF : +e;
}
var NKe = RKe, DKe = NKe, jKe = 1 / 0, LKe = 17976931348623157e292;
function kKe(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = DKe(e), e === jKe || e === -1 / 0) {
    var t = e < 0 ? -1 : 1;
    return t * LKe;
  }
  return e === e ? e : 0;
}
var FKe = kKe, BKe = lKe, zKe = mKe, nF = FKe, HKe = parseFloat, VKe = Math.min, GKe = Math.random;
function UKe(e, t, r) {
  if (r && typeof r != "boolean" && zKe(e, t, r) && (t = r = void 0), r === void 0 && (typeof t == "boolean" ? (r = t, t = void 0) : typeof e == "boolean" && (r = e, e = void 0)), e === void 0 && t === void 0 ? (e = 0, t = 1) : (e = nF(e), t === void 0 ? (t = e, e = 0) : t = nF(t)), e > t) {
    var n = e;
    e = t, t = n;
  }
  if (r || e % 1 || t % 1) {
    var a = GKe();
    return VKe(e + a * (t - e + HKe("1e-" + ((a + "").length - 1))), t);
  }
  return BKe(e, t);
}
var WKe = UKe;
const qKe = /* @__PURE__ */ Ut(WKe), { Text: KKe } = Gn, Cte = ({
  onCheckoutClick: e,
  setOpen: t,
  checkoutFromSidebar: r = !1,
  updateCartItem: n,
  cartItems: a,
  exceedsMaxQuantity: i = !1,
  alumniFormData: o
}) => {
  const { theme: s } = ia(), l = s !== Tr.Default ? `ttg-cart-details-register--skin--${s}` : "", [c] = Dt.useForm(), [u, d] = He(a?.find((b) => b?.product?.metadata?.type === mr.AlumniIntensive)), f = (b) => {
    const _ = o?.map((O) => O.name)?.flat(), $ = Object.keys(b).filter((O) => _.includes(O)).reduce((O, T) => {
      const I = o?.find((P) => P.name === T)?.label || `NO_LABEL_${qKe(1, 29)}`;
      return O[I] = b[T], O;
    }, {}), w = {
      ...u,
      metadata: {
        ...u?.metadata,
        questions: {
          ...$
        }
      }
    };
    return d(w), w;
  }, m = (b) => {
    const _ = Object.assign({}, b);
    _ && b && n(_), e();
  }, h = async (b) => {
    const _ = f(b);
    m(_);
  }, g = async (b) => {
    const _ = f(b);
    m(_);
  }, y = (b) => r ? g(b) : h(b), S = () => {
    t && t(!1);
  }, x = () => {
    const b = o?.filter(($) => $.type === "SELECT"), _ = o?.filter(($) => $.type === "CHECKBOX");
    return /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
      _?.map(($) => /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "py-3", children: /* @__PURE__ */ E.jsx(
        Dt.Item,
        {
          label: $.label,
          name: $.name,
          required: $.required,
          rules: [{ required: !0, message: "Please select one" }],
          children: /* @__PURE__ */ E.jsx(co.Group, { children: $.options?.map((w, O) => /* @__PURE__ */ E.jsx(co, { value: w.value, children: w.label }, `checkbox-field-${$.id}-${O}`)) })
        },
        `form-item-${$.id}`
      ) }, `col-field-${$.id}`)),
      b?.map(($) => /* @__PURE__ */ E.jsx(Oe, { xs: 24, sm: 24, md: 24, className: "py-3", children: /* @__PURE__ */ E.jsx(
        Dt.Item,
        {
          label: $.label,
          name: $.name,
          required: $.required,
          rules: [{ required: !0, message: "Please select one" }],
          children: /* @__PURE__ */ E.jsx(
            Kn,
            {
              options: $.options
            },
            `select-input-item-${$.id}`
          )
        },
        `form-item-${$.id}`
      ) }, `col-field-${$.id}`))
    ] });
  };
  return /* @__PURE__ */ E.jsx(At, { align: "middle", className: `ttg-cart-details-register ${l}`, children: /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
    Dt,
    {
      form: c,
      onFinish: y,
      layout: "vertical",
      children: /* @__PURE__ */ E.jsxs(At, { justify: "start", children: [
        !r && /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "py-3", children: /* @__PURE__ */ E.jsx(KKe, { className: "ttg-cart-details-register-header", children: "Please answer the following:" }) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: x() }),
        r ? /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(Oe, { span: 24, className: `px-3 pt-4 pb-2 sidebar-register-modal-footer ${l}`, children: /* @__PURE__ */ E.jsx(At, { justify: "end", children: /* @__PURE__ */ E.jsxs(lr, { children: [
          /* @__PURE__ */ E.jsx(Nt, { onClick: S, children: "Cancel" }),
          /* @__PURE__ */ E.jsx(Nt, { type: "primary", htmlType: "submit", children: "Continue" })
        ] }) }) }) }) : /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "px-3 pt-4 pb-2", children: /* @__PURE__ */ E.jsx(At, { justify: "end", children: /* @__PURE__ */ E.jsx(
          Nt,
          {
            id: "checkout-button",
            type: "primary",
            className: "ttg-cart-details-checkout-button",
            htmlType: "submit",
            loading: !1,
            disabled: i,
            children: "Checkout"
          }
        ) }) })
      ] })
    }
  ) }) });
}, { Text: X_ } = Gn, { Content: YKe } = Ol, ZKe = Aa(({
  userId: e,
  onCheckoutClick: t,
  onViewCartClick: r,
  onContinueShopping: n,
  onOpenClick: a,
  cartExpirationDays: i = 5
}, o) => {
  const {
    showContentOnProductType: s,
    addBeginCheckoutEvent: l,
    isQuantityExceedingMax: c,
    alumniFormData: u
  } = qd(), [d, f] = He(""), { theme: m, customHooks: { productHook: h }, screensSize: { isMobileView: g } } = ia(), { loadingProducts: y } = h, S = m !== Tr.Default ? `ttg-sidebar-cart-view--skin--${m} ttg-sidebar-cart-view--bg-hover` : "", [x, b] = He(!1), [_] = He(!1), [$, w] = He(!1), [O, T] = He(0), [I, P] = He(!1), D = Bt((oe) => {
    if (!window.location.pathname.includes(nq.cartDetails) && !x) {
      if (g && a) return a();
      g || b(!0);
    }
    if (oe?.data?.newItem) {
      const { newItem: fe } = oe.data;
      f(fe?.stripeProductId || "");
    }
  }, [g, a, x]), {
    loadingCartHook: B,
    localUserCartData: L,
    addItemToCart: N,
    removeCartItem: z,
    onAddPreviewItem: F,
    addMoreViewItems: j,
    updateCartItem: H,
    resetCart: U
  } = hA(
    D,
    e,
    !0,
    i
  ), G = () => (l(L?.cartItems), t()), V = () => b(!1), K = () => {
    a ? a() : b(!0);
  }, Z = Bt(() => L?.cartItems && s(L?.cartItems, [
    mr.Certification,
    mr.AlumniIntensive
  ]) ? w(!0) : G(), [L?.cartItems, t, s]);
  fo(o, () => ({
    addItemToCart: N,
    onAddPreviewItem: F,
    resetCart: U
  })), St(() => T(L?.cartItems?.reduce((oe, fe) => oe + fe.quantity, 0) || 0), [L]), xe.useEffect(() => {
    P(!1), L?.cartItems?.map((oe) => {
      c(oe) && P(!0);
    });
  }, [L?.cartItems, c]);
  const ee = dr(() => {
    if (!L || L?.cartItems?.length === 0)
      return null;
    const oe = L?.cartItems?.reduce((fe, le) => fe + le.total, 0) || 0;
    return /* @__PURE__ */ E.jsxs(YKe, { className: "ttg-sidebar-cart-view-footer", children: [
      /* @__PURE__ */ E.jsxs(At, { justify: "space-between", align: "middle", className: "ttg-sidebar-cart-view-footer-subtotal", children: [
        I && /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(zn, { type: "inner", size: "default", bordered: !1, className: "notice mb-4", children: /* @__PURE__ */ E.jsxs(At, { align: "middle", children: [
          /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(_l, { className: "information-icon", size: 22 }) }),
          /* @__PURE__ */ E.jsx(Oe, { span: 22, children: /* @__PURE__ */ E.jsxs("p", { className: "ml-2", children: [
            /* @__PURE__ */ E.jsx("span", { className: "text-base text-gray-900 font-bold", children: "Note: " }),
            "The maximum quantity allowed per book is 10. Please adjust your cart to proceed to checkout. If you would like to place a bulk order of books, please contact ",
            /* @__PURE__ */ E.jsx("a", { href: "mailto:support@tablegroup.com", className: "text-bold", children: "support@tablegroup.com" }),
            "."
          ] }) })
        ] }) }) }),
        /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(X_, { children: "Subtotal" }) }),
        /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(X_, { children: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(oe) }) })
      ] }),
      /* @__PURE__ */ E.jsxs(At, { className: "ttg-sidebar-cart-view-footer-actions", children: [
        /* @__PURE__ */ E.jsx(Oe, { span: 12, children: /* @__PURE__ */ E.jsx(Nt, { onClick: r, className: "w-full mr-2 uppercase", children: "View Cart" }) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 12, children: /* @__PURE__ */ E.jsx(Nt, { id: "checkout-button", type: "primary", onClick: Z, className: "w-full ml-2 uppercase", disabled: I, children: "Checkout" }) })
      ] })
    ] });
  }, [L, Z, r]), ae = () => w(!$), ue = () => /* @__PURE__ */ E.jsx(yte, { cartItems: L?.cartItems?.length !== 0, onContinueShopping: n, children: /* @__PURE__ */ E.jsxs(At, { className: "w-full m-4", children: [
    /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
      d1,
      {
        preview: !1,
        items: L?.cartItems || [],
        loading: B,
        onRemoveItemClick: z,
        onItemQuantityChange: N,
        highlightItem: d
      }
    ) }),
    j.length > 0 && /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
      /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
        At,
        {
          justify: "space-between",
          align: "middle",
          className: "ttg-sidebar-cart-also-like-title",
          children: /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(X_, { children: "You might also like:" }) })
        }
      ) }),
      /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
        d1,
        {
          preview: !0,
          items: j,
          loading: y,
          onAddClick: F
        }
      ) })
    ] })
  ] }) }), re = () => /* @__PURE__ */ E.jsxs(
    da,
    {
      open: $,
      centered: !0,
      destroyOnClose: !0,
      width: "657px",
      title: "Please confirm the following:",
      onCancel: ae,
      footer: null,
      zIndex: 2e3,
      children: [
        L?.cartItems?.some((oe) => oe.type === mr?.Certification) && /* @__PURE__ */ E.jsx(
          bte,
          {
            onCheckoutClick: t,
            setOpen: w,
            checkoutFromSidebar: !0,
            cartItems: L?.cartItems || [],
            updateCartItem: H
          }
        ),
        L?.cartItems?.some((oe) => oe.type === mr?.AlumniIntensive) && /* @__PURE__ */ E.jsx(
          Cte,
          {
            onCheckoutClick: t,
            checkoutFromSidebar: !0,
            cartItems: L?.cartItems || [],
            exceedsMaxQuantity: I,
            alumniFormData: u,
            setOpen: w,
            updateCartItem: H
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
    /* @__PURE__ */ E.jsx(Nt, { type: "text", onClick: K, className: `ttg-sidebar-cart-view cart-btn h-full ${S}`, children: /* @__PURE__ */ E.jsx(At, { justify: "center", align: "middle", children: _ ? /* @__PURE__ */ E.jsx(Td, { indicator: /* @__PURE__ */ E.jsx("div", { className: "spin-icon", children: /* @__PURE__ */ E.jsx(ZW, { size: 24 }) }), className: "text-white" }) : /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
      /* @__PURE__ */ E.jsx(WW, { size: 24 }),
      /* @__PURE__ */ E.jsx("span", { children: O || 0 })
    ] }) }) }),
    /* @__PURE__ */ E.jsx(
      LI,
      {
        title: "Shopping Cart",
        closable: !0,
        onClose: V,
        open: x,
        placement: "right",
        maskClosable: !0,
        className: `ttg-sidebar-cart-view h-full ${S}`,
        footer: ee,
        destroyOnClose: !0,
        width: "28rem",
        children: ue()
      }
    ),
    re()
  ] });
});
ZKe.displayName = "SidebarCartView";
const Ste = () => {
  const { services: e } = ia(), {
    countryLoading: t,
    statesLoading: r,
    countries: n,
    states: a,
    getStates: i
  } = UWe(e.countryService);
  return {
    countryLoading: t,
    statesLoading: r,
    countries: n,
    getStates: i,
    states: a,
    mapCountryOrZones: (s) => s.map((l) => ({
      label: l.name,
      value: l.code
    }))
  };
}, { Text: xo } = Gn, XKe = ({
  cartItems: e,
  loading: t,
  estimateShippingCost: r,
  availableShippingMethods: n,
  addressError: a
}) => {
  const { theme: i, customHooks: { addressHook: o } } = ia(), s = i !== Tr.Default ? `ttg-estimate-shipping--skin--${i}` : "", { addressLoading: l, addresses: c } = o, u = dr(
    () => e.filter((O) => O.isPhysical),
    [e]
  ), d = dr(() => e.filter((O) => O.isPhysical).reduce((O, T) => O + (T.weight || 0) * T.quantity, 0) / 16, [e]), { countryLoading: f, countries: m, mapCountryOrZones: h } = Ste(), [g] = Dt.useForm(), y = Dt.useWatch("countrySelect", g), S = Dt.useWatch("postCode", g), x = Dt.useWatch("addressSelect", g);
  St(() => {
    if (!x || !c) return;
    const O = c.find((T) => T.id === x);
    O && (g.setFieldValue("countrySelect", O?.country.code), g.setFieldValue("postCode", O?.postCode), r({ ...O, id: 0 }));
  }, [c, x, g, r, e]);
  const b = dr(() => {
    const O = c?.find((T) => x && T.id === x);
    return !O || O.postCode !== S || O.country.code !== y ? {
      country: { code: y, name: "" },
      postCode: S,
      firstName: "",
      lastName: "",
      streetAddress: "",
      suburb: "",
      city: "",
      state: { code: "", name: "" },
      phone: "",
      company: "",
      id: 0,
      isDefault: !1
    } : { ...O, id: 0 };
  }, [c, S, y, x]), _ = () => r(b), $ = /^[a-zA-Z0-9]+(\s?\-?){1}[a-zA-Z0-9]+$/, w = dr(() => n ? n.length > 0 ? /* @__PURE__ */ E.jsxs(At, { className: "ttg-available-shipping-header", children: [
    /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "ttg-available-shipping-header-text title", children: /* @__PURE__ */ E.jsxs(lr, { className: `ttg-available-shipping-header-space ${n[0].deliveryByTime ? "delivery-time" : ""}`, children: [
      /* @__PURE__ */ E.jsx(xo, { children: "Available shipping methods" }),
      /* @__PURE__ */ E.jsx(xo, { children: "Rates" }),
      n[0].deliveryByTime && /* @__PURE__ */ E.jsx(xo, { className: "time", children: "Delivered by:" })
    ] }) }),
    n.map((O) => /* @__PURE__ */ E.jsx(
      Oe,
      {
        span: 24,
        className: "ttg-available-shipping-header-text",
        children: /* @__PURE__ */ E.jsxs(lr, { className: `ttg-available-shipping-header-space ${O.deliveryByTime ? "delivery-time" : ""}`, children: [
          /* @__PURE__ */ E.jsx(xo, { className: "title", children: O.title }),
          /* @__PURE__ */ E.jsx(xo, { children: new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: O.currencyCode
          }).format(O.totalCharges) }),
          O.deliveryByTime && /* @__PURE__ */ E.jsx(xo, { className: "time", children: fn(O.deliveryByTime).format("MMM D") })
        ] })
      },
      O.code
    ))
  ] }) : n.length === 0 && d > 70 && !a ? /* @__PURE__ */ E.jsxs(xo, { className: "pb-3 text-red-500", children: [
    "We currently do not support shipments of more than 70lbs in our store. For alternate shipping methods please contact our support team: ",
    /* @__PURE__ */ E.jsx("a", { href: "mailto:support@tablegroup.com", children: "support@tablegroup.com" })
  ] }) : /* @__PURE__ */ E.jsxs(xo, { className: "text-red-500", children: [
    "We are unable to obtain a rate quote for shipping. ",
    /* @__PURE__ */ E.jsx("br", {}),
    a || "Please check if the address is correct or contact the store if no other alternative is shown."
  ] }) : null, [d, n, a]);
  return /* @__PURE__ */ E.jsxs(At, { gutter: [0, 24], className: `ttg-estimate-shipping ${s}`, children: [
    /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(lr, { className: "ttg-shipping-items-details-container", children: [
      /* @__PURE__ */ E.jsxs(xo, { children: [
        "Total items:",
        " ",
        u.reduce(
          (O, T) => O + T.quantity,
          0
        )
      ] }),
      /* @__PURE__ */ E.jsxs(xo, { children: [
        "Weight:",
        " ",
        d.toFixed(2),
        " lbs"
      ] }),
      /* @__PURE__ */ E.jsxs(xo, { children: [
        "Amount:",
        " ",
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD"
        }).format(u.reduce(
          (O, T) => O + T.total,
          0
        ))
      ] })
    ] }) }),
    /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
      Dt,
      {
        form: g,
        initialValues: {
          addressSelect: c && c.length > 0 ? c[0].id : void 0,
          countrySelect: "US"
        },
        children: /* @__PURE__ */ E.jsxs(At, { gutter: [0, 12], children: [
          c && /* @__PURE__ */ E.jsx(Oe, { span: c.length > 0 ? 24 : 0, children: /* @__PURE__ */ E.jsx(
            Dt.Item,
            {
              name: "addressSelect",
              label: "Address",
              labelCol: { span: 24 },
              children: /* @__PURE__ */ E.jsx(
                Kn,
                {
                  showSearch: !0,
                  optionFilterProp: "label",
                  placeholder: "Address",
                  disabled: t,
                  notFoundContent: "No Data",
                  loading: l,
                  options: c.map((O) => ({
                    value: O.id,
                    label: `${O.streetAddress}, ${O.suburb || ""} ${O.city}, ${O.state?.name || ""} ${O.postCode} ${O.country?.name}`
                  }))
                }
              )
            }
          ) }),
          /* @__PURE__ */ E.jsx(Oe, { span: 16, children: /* @__PURE__ */ E.jsx(
            Dt.Item,
            {
              name: "countrySelect",
              label: "Country",
              labelCol: { span: 24 },
              children: /* @__PURE__ */ E.jsx(
                Kn,
                {
                  showSearch: !0,
                  optionFilterProp: "label",
                  disabled: t,
                  notFoundContent: "No Data",
                  loading: f,
                  options: m ? h(m) : [],
                  onChange: () => g.setFieldsValue({ addressSelect: void 0 })
                }
              )
            }
          ) }),
          /* @__PURE__ */ E.jsx(Oe, { span: 16, children: /* @__PURE__ */ E.jsx(
            Dt.Item,
            {
              name: "postCode",
              label: "Post/Zip code",
              labelCol: { span: 24 },
              rules: [
                {
                  pattern: $,
                  message: "You must enter a valid zip code"
                }
              ],
              children: /* @__PURE__ */ E.jsx(Lr, { disabled: t, onChange: () => g.setFieldsValue({ addressSelect: void 0 }) })
            }
          ) })
        ] })
      }
    ) }),
    /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
      Nt,
      {
        disabled: !(S && S.length >= 4 && y),
        onClick: _,
        type: "primary",
        loading: t,
        children: "UPDATE"
      }
    ) }),
    !t && w
  ] });
}, { Text: ul } = Gn, GXe = ({
  userId: e,
  onCheckoutClick: t,
  onContinueShopping: r,
  cartExpirationDays: n = 5
}) => {
  const [a, i] = He(""), o = Bt((me) => {
    if (me?.data?.newItem) {
      const { newItem: k } = me.data;
      i(k?.stripeProductId || "");
    }
  }, []), { theme: s, customHooks: { addressHook: l, productHook: c } } = ia(), { loadingProducts: u } = c, d = s !== Tr.Default ? `ttg-cart-details-view--skin--${s}` : "", [f, m] = He(!1), [h, g] = He(!1), [y, S] = He(!1), [x, b] = He(!1), [_, $] = He(!1), [w, O] = He({}), { getAddresses: T, addresses: I } = l;
  St(() => {
    const me = new URLSearchParams(window.location.search), k = me.get("ref")?.toUpperCase(), M = me.get("redirect");
    O({ promoCode: k, redirect: M }), k && S(!0);
  }, []);
  const {
    loadingCartHook: P,
    localUserCartData: D,
    updateCartItem: B,
    addItemToCart: L,
    removeCartItem: N,
    onAddPreviewItem: z,
    addMoreViewItems: F,
    loadingEstimateShipping: j,
    estimateShippingCost: H,
    availableShippingMethods: U,
    addressError: G,
    resetAvailableShippingMethods: V,
    loadPromoProducts: K,
    loadingPromoProducts: Z
  } = hA(
    o,
    e,
    !0,
    n
  );
  St(() => {
    I || T();
  }, [I, T]), St(() => {
    (async () => !w?.promoCode || Z || P || !y ? void 0 : (S(!1), await K(w?.promoCode) === Qu.PromoNoProduct ? b(!0) : g(!0)))();
  }, [
    y,
    w?.promoCode,
    Z,
    P,
    D?.promoCode,
    K
  ]);
  const ee = () => {
    b(!1), g(!0);
  };
  St(() => {
    h && w.redirect && !x && (window.location.href = w.redirect);
  }, [h, w?.redirect, x]);
  const {
    showContentOnProductType: ae,
    addBeginCheckoutEvent: ue,
    isQuantityExceedingMax: re,
    alumniFormData: oe
  } = qd(), fe = () => {
    ue(D?.cartItems), t();
  }, le = () => se.length < 1 ? null : /* @__PURE__ */ E.jsxs(Oe, { span: 24, children: [
    /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "mx-3 py-4", children: /* @__PURE__ */ E.jsx(ul, { className: "text-2xl leading-8 font-medium", children: "You might also like:" }) }),
    /* @__PURE__ */ E.jsx(zn, { className: "ttg-cart-details-card-content", children: /* @__PURE__ */ E.jsx(
      d1,
      {
        details: !0,
        preview: !0,
        items: F,
        loading: u,
        onAddClick: z
      }
    ) })
  ] }), se = D?.cartItems || [], Q = D?.cartItems?.reduce((me, k) => me + k.total, 0) || 0, he = D?.cartItems?.reduce((me, k) => me + k.quantity, 0) || 0;
  xe.useEffect(() => {
    $(!1), se.map((me) => {
      re(me) && $(!0);
    });
  }, [se, re]);
  const ne = () => ae(se, mr.Certification) ? /* @__PURE__ */ E.jsx(
    bte,
    {
      onCheckoutClick: fe,
      checkoutFromSidebar: !1,
      cartItems: D?.cartItems || [],
      exceedsMaxQuantity: _,
      updateCartItem: B
    }
  ) : ae(se, mr.AlumniIntensive) ? /* @__PURE__ */ E.jsx(
    Cte,
    {
      onCheckoutClick: fe,
      checkoutFromSidebar: !1,
      cartItems: D?.cartItems || [],
      exceedsMaxQuantity: _,
      alumniFormData: oe,
      updateCartItem: B
    }
  ) : /* @__PURE__ */ E.jsx(At, { justify: "end", className: "pt-4 pb-2", children: /* @__PURE__ */ E.jsx(
    Nt,
    {
      id: "checkout-button",
      type: "primary",
      className: "ttg-cart-details-checkout-button",
      onClick: fe,
      disabled: _,
      children: "Checkout"
    }
  ) });
  return /* @__PURE__ */ E.jsxs(At, { justify: "center", className: `ttg-cart-details-view ${d}`, children: [
    /* @__PURE__ */ E.jsxs(yte, { cartItems: se.length !== 0, onContinueShopping: r, children: [
      /* @__PURE__ */ E.jsxs(Oe, { span: 24, children: [
        /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "mx-3", children: /* @__PURE__ */ E.jsxs(lr, { direction: "vertical", size: 40, className: "w-full", children: [
          /* @__PURE__ */ E.jsx(ul, { className: "ttg-cart-details-header", children: "Your Cart" }),
          /* @__PURE__ */ E.jsxs(ul, { className: "ttg-cart-details-subheader", children: [
            he,
            " ",
            `${he > 1 ? "items" : "item"}`,
            " in Cart"
          ] })
        ] }) }),
        /* @__PURE__ */ E.jsxs(zn, { className: "ttg-cart-details-card-content", children: [
          /* @__PURE__ */ E.jsx(
            d1,
            {
              preview: !1,
              details: !0,
              items: D?.cartItems || [],
              loading: P || Z,
              onRemoveItemClick: N,
              onItemQuantityChange: L,
              highlightItem: a
            }
          ),
          _ && /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(zn, { type: "inner", size: "default", bordered: !1, className: "notice", children: /* @__PURE__ */ E.jsxs(At, { align: "middle", children: [
            /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(_l, { className: "information-icon", size: 22 }) }),
            /* @__PURE__ */ E.jsx(Oe, { span: 22, children: /* @__PURE__ */ E.jsxs("p", { className: "p-2", children: [
              /* @__PURE__ */ E.jsx("span", { className: "text-base text-gray-900 font-bold", children: "Note: " }),
              "The maximum quantity allowed per book is 10. Please adjust your cart to proceed to checkout. If you would like to place a bulk order of books, please contact ",
              /* @__PURE__ */ E.jsx("a", { href: "mailto:support@tablegroup.com", children: "support@tablegroup.com" }),
              "."
            ] }) })
          ] }) }) }),
          /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "border-y border-gray-200 py-4", children: /* @__PURE__ */ E.jsxs(At, { justify: "space-between", align: "middle", gutter: [12, 12], children: [
            /* @__PURE__ */ E.jsx(Oe, { span: 12, children: /* @__PURE__ */ E.jsxs(At, { justify: "start", align: "middle", children: [
              /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(ul, { className: "ttg-cart-details-subtotal-text", children: "Subtotal" }) }),
              ae(se, mr.Physical) && /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
                ul,
                {
                  className: "ttg-cart-details-subtotal-description",
                  children: "Shipping and taxes will be calculated at checkout."
                }
              ) })
            ] }) }),
            /* @__PURE__ */ E.jsx(Oe, { span: 12, children: /* @__PURE__ */ E.jsxs(At, { className: "ttg-cart-details-subtotal-value", children: [
              /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(ul, { className: "ttg-cart-details-subtotal-value-text", children: new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD"
              }).format(Q) }) }),
              se.reduce((me, k) => me + (k?.weight ?? 0), 0) > 0 && /* @__PURE__ */ E.jsxs(Oe, { span: 24, children: [
                /* @__PURE__ */ E.jsxs(
                  lr,
                  {
                    direction: "horizontal",
                    align: "center",
                    size: 10,
                    children: [
                      /* @__PURE__ */ E.jsx(
                        Nt,
                        {
                          type: "link",
                          onClick: () => m(!0),
                          className: "ttg-cart-details-estimate-button",
                          children: "Estimate shipping"
                        }
                      ),
                      /* @__PURE__ */ E.jsx(lo, { title: "Calculate the expected shipping costs and delivery time for your order. Get an instant estimate before proceeding to checkout, ensuring transparency and convenience in your shopping experience.", children: /* @__PURE__ */ E.jsx(
                        _Te,
                        {
                          className: "ttg-cart-details-estimate-icon",
                          size: 16
                        }
                      ) })
                    ]
                  }
                ),
                /* @__PURE__ */ E.jsx(
                  da,
                  {
                    centered: !0,
                    destroyOnClose: !0,
                    footer: null,
                    title: "Estimate shipping costs",
                    open: f,
                    onCancel: () => {
                      m(!1), V();
                    },
                    children: /* @__PURE__ */ E.jsx(
                      XKe,
                      {
                        addressError: G,
                        cartItems: se || [],
                        loading: j,
                        estimateShippingCost: H,
                        availableShippingMethods: U
                      }
                    )
                  }
                )
              ] })
            ] }) })
          ] }) }),
          /* @__PURE__ */ E.jsx(Oe, { span: 24, children: ne() })
        ] })
      ] }),
      (F.length > 0 || u) && le()
    ] }),
    /* @__PURE__ */ E.jsx(
      da,
      {
        closable: !1,
        open: x,
        footer: null,
        closeIcon: !1,
        centered: !0,
        width: "560px",
        zIndex: 2200,
        children: /* @__PURE__ */ E.jsxs(At, { justify: "center", gutter: [0, 24], className: `ttg-cart-details-promo-modal ttg-cart-details-promo-modal--skin--${s}`, children: [
          /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
            CTe,
            {
              className: "ttg-cart-details-promo-icon",
              size: 48
            }
          ) }) }),
          /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(At, { gutter: [0, 4], children: [
            /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "ttg-cart-details-promo-modal-title", children: /* @__PURE__ */ E.jsx(ul, { className: "text-lg leading-6 font-medium w-full", children: "Affiliate discount" }) }),
            /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(ul, { className: "ttg-cart-details-promo-modal-text", children: [
              "Thank you for visiting our site through an Affiliate Partnership! An exclusive discount has been loaded to your shopping cart that will be reflected on the final step of the checkout process. ",
              /* @__PURE__ */ E.jsx("br", {}),
              "Once you have finished adding all items to your cart, please proceed through checkout (which includes setting up an account if you do not already have one)."
            ] }) })
          ] }) }),
          /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(Nt, { type: "primary", className: "uppercase w-full", onClick: ee, children: "Continue" }) })
        ] })
      }
    )
  ] });
};
var xte = "https://js.stripe.com", JKe = "".concat(xte, "/v3"), QKe = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/, eYe = /^https:\/\/js\.stripe\.com\/(v3|[a-z]+)\/stripe\.js(\?.*)?$/;
var tYe = function(t) {
  return QKe.test(t) || eYe.test(t);
}, rYe = function() {
  for (var t = document.querySelectorAll('script[src^="'.concat(xte, '"]')), r = 0; r < t.length; r++) {
    var n = t[r];
    if (tYe(n.src))
      return n;
  }
  return null;
}, aF = function(t) {
  var r = "", n = document.createElement("script");
  n.src = "".concat(JKe).concat(r);
  var a = document.head || document.body;
  if (!a)
    throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
  return a.appendChild(n), n;
}, nYe = function(t, r) {
  !t || !t._registerWrapper || t._registerWrapper({
    name: "stripe-js",
    version: "5.9.2",
    startTime: r
  });
}, b0 = null, Xy = null, Jy = null, aYe = function(t) {
  return function(r) {
    t(new Error("Failed to load Stripe.js", {
      cause: r
    }));
  };
}, iYe = function(t, r) {
  return function() {
    window.Stripe ? t(window.Stripe) : r(new Error("Stripe.js not available"));
  };
}, oYe = function(t) {
  return b0 !== null ? b0 : (b0 = new Promise(function(r, n) {
    if (typeof window > "u" || typeof document > "u") {
      r(null);
      return;
    }
    if (window.Stripe) {
      r(window.Stripe);
      return;
    }
    try {
      var a = rYe();
      if (!(a && t)) {
        if (!a)
          a = aF(t);
        else if (a && Jy !== null && Xy !== null) {
          var i;
          a.removeEventListener("load", Jy), a.removeEventListener("error", Xy), (i = a.parentNode) === null || i === void 0 || i.removeChild(a), a = aF(t);
        }
      }
      Jy = iYe(r, n), Xy = aYe(n), a.addEventListener("load", Jy), a.addEventListener("error", Xy);
    } catch (o) {
      n(o);
      return;
    }
  }), b0.catch(function(r) {
    return b0 = null, Promise.reject(r);
  }));
}, sYe = function(t, r, n) {
  if (t === null)
    return null;
  var a = t.apply(void 0, r);
  return nYe(a, n), a;
}, C0, $te = !1, _te = function() {
  return C0 || (C0 = oYe(null).catch(function(t) {
    return C0 = null, Promise.reject(t);
  }), C0);
};
Promise.resolve().then(function() {
  return _te();
}).catch(function(e) {
  $te || console.warn(e);
});
var lYe = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  $te = !0;
  var a = Date.now();
  return _te().then(function(i) {
    return sYe(i, r, a);
  });
}, cYe = "__lodash_hash_undefined__";
function uYe(e) {
  return this.__data__.set(e, cYe), this;
}
var dYe = uYe;
function fYe(e) {
  return this.__data__.has(e);
}
var pYe = fYe, mYe = Fee, vYe = dYe, hYe = pYe;
function f1(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new mYe(); ++t < r; )
    this.add(e[t]);
}
f1.prototype.add = f1.prototype.push = vYe;
f1.prototype.has = hYe;
var gYe = f1;
function yYe(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var bYe = yYe;
function CYe(e, t) {
  return e.has(t);
}
var SYe = CYe, xYe = gYe, $Ye = bYe, _Ye = SYe, EYe = 1, wYe = 2;
function OYe(e, t, r, n, a, i) {
  var o = r & EYe, s = e.length, l = t.length;
  if (s != l && !(o && l > s))
    return !1;
  var c = i.get(e), u = i.get(t);
  if (c && u)
    return c == t && u == e;
  var d = -1, f = !0, m = r & wYe ? new xYe() : void 0;
  for (i.set(e, t), i.set(t, e); ++d < s; ) {
    var h = e[d], g = t[d];
    if (n)
      var y = o ? n(g, h, d, t, e, i) : n(h, g, d, e, t, i);
    if (y !== void 0) {
      if (y)
        continue;
      f = !1;
      break;
    }
    if (m) {
      if (!$Ye(t, function(S, x) {
        if (!_Ye(m, x) && (h === S || a(h, S, r, n, i)))
          return m.push(x);
      })) {
        f = !1;
        break;
      }
    } else if (!(h === g || a(h, g, r, n, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), f;
}
var Ete = OYe;
function TYe(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
var IYe = TYe;
function MYe(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var AYe = MYe, iF = IC, oF = rte, PYe = wC, RYe = Ete, NYe = IYe, DYe = AYe, jYe = 1, LYe = 2, kYe = "[object Boolean]", FYe = "[object Date]", BYe = "[object Error]", zYe = "[object Map]", HYe = "[object Number]", VYe = "[object RegExp]", GYe = "[object Set]", UYe = "[object String]", WYe = "[object Symbol]", qYe = "[object ArrayBuffer]", KYe = "[object DataView]", sF = iF ? iF.prototype : void 0, J_ = sF ? sF.valueOf : void 0;
function YYe(e, t, r, n, a, i, o) {
  switch (r) {
    case KYe:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case qYe:
      return !(e.byteLength != t.byteLength || !i(new oF(e), new oF(t)));
    case kYe:
    case FYe:
    case HYe:
      return PYe(+e, +t);
    case BYe:
      return e.name == t.name && e.message == t.message;
    case VYe:
    case UYe:
      return e == t + "";
    case zYe:
      var s = NYe;
    case GYe:
      var l = n & jYe;
      if (s || (s = DYe), e.size != t.size && !l)
        return !1;
      var c = o.get(e);
      if (c)
        return c == t;
      n |= LYe, o.set(e, t);
      var u = RYe(s(e), s(t), n, a, i, o);
      return o.delete(e), u;
    case WYe:
      if (J_)
        return J_.call(e) == J_.call(t);
  }
  return !1;
}
var ZYe = YYe, lF = ete, XYe = 1, JYe = Object.prototype, QYe = JYe.hasOwnProperty;
function eZe(e, t, r, n, a, i) {
  var o = r & XYe, s = lF(e), l = s.length, c = lF(t), u = c.length;
  if (l != u && !o)
    return !1;
  for (var d = l; d--; ) {
    var f = s[d];
    if (!(o ? f in t : QYe.call(t, f)))
      return !1;
  }
  var m = i.get(e), h = i.get(t);
  if (m && h)
    return m == t && h == e;
  var g = !0;
  i.set(e, t), i.set(t, e);
  for (var y = o; ++d < l; ) {
    f = s[d];
    var S = e[f], x = t[f];
    if (n)
      var b = o ? n(x, S, f, t, e, i) : n(S, x, f, e, t, i);
    if (!(b === void 0 ? S === x || a(S, x, r, n, i) : b)) {
      g = !1;
      break;
    }
    y || (y = f == "constructor");
  }
  if (g && !y) {
    var _ = e.constructor, $ = t.constructor;
    _ != $ && "constructor" in e && "constructor" in t && !(typeof _ == "function" && _ instanceof _ && typeof $ == "function" && $ instanceof $) && (g = !1);
  }
  return i.delete(e), i.delete(t), g;
}
var tZe = eZe, Q_ = Bee, rZe = Ete, nZe = ZYe, aZe = tZe, cF = RC, uF = Kh, dF = iA, iZe = Wee, oZe = 1, fF = "[object Arguments]", pF = "[object Array]", Qy = "[object Object]", sZe = Object.prototype, mF = sZe.hasOwnProperty;
function lZe(e, t, r, n, a, i) {
  var o = uF(e), s = uF(t), l = o ? pF : cF(e), c = s ? pF : cF(t);
  l = l == fF ? Qy : l, c = c == fF ? Qy : c;
  var u = l == Qy, d = c == Qy, f = l == c;
  if (f && dF(e)) {
    if (!dF(t))
      return !1;
    o = !0, u = !1;
  }
  if (f && !u)
    return i || (i = new Q_()), o || iZe(e) ? rZe(e, t, r, n, a, i) : nZe(e, t, l, r, n, a, i);
  if (!(r & oZe)) {
    var m = u && mF.call(e, "__wrapped__"), h = d && mF.call(t, "__wrapped__");
    if (m || h) {
      var g = m ? e.value() : e, y = h ? t.value() : t;
      return i || (i = new Q_()), a(g, y, r, n, i);
    }
  }
  return f ? (i || (i = new Q_()), aZe(e, t, r, n, a, i)) : !1;
}
var cZe = lZe, uZe = cZe, vF = Xc;
function wte(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !vF(e) && !vF(t) ? e !== e && t !== t : uZe(e, t, r, n, wte, a);
}
var dZe = wte, fZe = dZe;
function pZe(e, t) {
  return fZe(e, t);
}
var mZe = pZe;
const Ote = /* @__PURE__ */ Ut(mZe);
function hF(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function gF(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hF(Object(r), !0).forEach(function(n) {
      Tte(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : hF(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Sb(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Sb = function(t) {
    return typeof t;
  } : Sb = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Sb(e);
}
function Tte(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function Ite(e, t) {
  return vZe(e) || hZe(e, t) || gZe(e, t) || yZe();
}
function vZe(e) {
  if (Array.isArray(e)) return e;
}
function hZe(e, t) {
  var r = e && (typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"]);
  if (r != null) {
    var n = [], a = !0, i = !1, o, s;
    try {
      for (r = r.call(e); !(a = (o = r.next()).done) && (n.push(o.value), !(t && n.length === t)); a = !0)
        ;
    } catch (l) {
      i = !0, s = l;
    } finally {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (i) throw s;
      }
    }
    return n;
  }
}
function gZe(e, t) {
  if (e) {
    if (typeof e == "string") return yF(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return yF(e, t);
  }
}
function yF(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function yZe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Li = function(t, r, n) {
  var a = !!n, i = xe.useRef(n);
  xe.useEffect(function() {
    i.current = n;
  }, [n]), xe.useEffect(function() {
    if (!a || !t)
      return function() {
      };
    var o = function() {
      i.current && i.current.apply(i, arguments);
    };
    return t.on(r, o), function() {
      t.off(r, o);
    };
  }, [a, r, t, i]);
}, vT = function(t) {
  var r = xe.useRef(t);
  return xe.useEffect(function() {
    r.current = t;
  }, [t]), r.current;
}, pd = function(t) {
  return t !== null && Sb(t) === "object";
}, bZe = function(t) {
  return pd(t) && typeof t.then == "function";
}, CZe = function(t) {
  return pd(t) && typeof t.elements == "function" && typeof t.createToken == "function" && typeof t.createPaymentMethod == "function" && typeof t.confirmCardPayment == "function";
}, bF = "[object Object]", SZe = function e(t, r) {
  if (!pd(t) || !pd(r))
    return t === r;
  var n = Array.isArray(t), a = Array.isArray(r);
  if (n !== a) return !1;
  var i = Object.prototype.toString.call(t) === bF, o = Object.prototype.toString.call(r) === bF;
  if (i !== o) return !1;
  if (!i && !n) return t === r;
  var s = Object.keys(t), l = Object.keys(r);
  if (s.length !== l.length) return !1;
  for (var c = {}, u = 0; u < s.length; u += 1)
    c[s[u]] = !0;
  for (var d = 0; d < l.length; d += 1)
    c[l[d]] = !0;
  var f = Object.keys(c);
  if (f.length !== s.length)
    return !1;
  var m = t, h = r, g = function(S) {
    return e(m[S], h[S]);
  };
  return f.every(g);
}, Mte = function(t, r, n) {
  return pd(t) ? Object.keys(t).reduce(function(a, i) {
    var o = !pd(r) || !SZe(t[i], r[i]);
    return n.includes(i) ? (o && console.warn("Unsupported prop change: options.".concat(i, " is not a mutable property.")), a) : o ? gF(gF({}, a || {}), {}, Tte({}, i, t[i])) : a;
  }, null) : null;
}, Ate = "Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.", CF = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ate;
  if (t === null || CZe(t))
    return t;
  throw new Error(r);
}, xZe = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ate;
  if (bZe(t))
    return {
      tag: "async",
      stripePromise: Promise.resolve(t).then(function(a) {
        return CF(a, r);
      })
    };
  var n = CF(t, r);
  return n === null ? {
    tag: "empty"
  } : {
    tag: "sync",
    stripe: n
  };
}, $Ze = function(t) {
  !t || !t._registerWrapper || !t.registerAppInfo || (t._registerWrapper({
    name: "react-stripe-js",
    version: "3.1.0"
  }), t.registerAppInfo({
    name: "react-stripe-js",
    version: "3.1.0",
    url: "https://stripe.com/docs/stripe-js/react"
  }));
}, kC = /* @__PURE__ */ xe.createContext(null);
kC.displayName = "ElementsContext";
var Pte = function(t, r) {
  if (!t)
    throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(r, " in an <Elements> provider."));
  return t;
}, Rte = function(t) {
  var r = t.stripe, n = t.options, a = t.children, i = xe.useMemo(function() {
    return xZe(r);
  }, [r]), o = xe.useState(function() {
    return {
      stripe: i.tag === "sync" ? i.stripe : null,
      elements: i.tag === "sync" ? i.stripe.elements(n) : null
    };
  }), s = Ite(o, 2), l = s[0], c = s[1];
  xe.useEffect(function() {
    var f = !0, m = function(g) {
      c(function(y) {
        return y.stripe ? y : {
          stripe: g,
          elements: g.elements(n)
        };
      });
    };
    return i.tag === "async" && !l.stripe ? i.stripePromise.then(function(h) {
      h && f && m(h);
    }) : i.tag === "sync" && !l.stripe && m(i.stripe), function() {
      f = !1;
    };
  }, [i, l, n]);
  var u = vT(r);
  xe.useEffect(function() {
    u !== null && u !== r && console.warn("Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.");
  }, [u, r]);
  var d = vT(n);
  return xe.useEffect(function() {
    if (l.elements) {
      var f = Mte(n, d, ["clientSecret", "fonts"]);
      f && l.elements.update(f);
    }
  }, [n, d, l.elements]), xe.useEffect(function() {
    $Ze(l.stripe);
  }, [l.stripe]), /* @__PURE__ */ xe.createElement(kC.Provider, {
    value: l
  }, a);
};
Rte.propTypes = {
  stripe: Fr.any,
  options: Fr.object
};
var _Ze = function(t) {
  var r = xe.useContext(kC);
  return Pte(r, t);
}, Nte = function() {
  var t = _Ze("calls useElements()"), r = t.elements;
  return r;
};
Fr.func.isRequired;
var Dte = /* @__PURE__ */ xe.createContext(null);
Dte.displayName = "CheckoutSdkContext";
var EZe = function(t, r) {
  if (!t)
    throw new Error("Could not find CheckoutProvider context; You need to wrap the part of your app that ".concat(r, " in an <CheckoutProvider> provider."));
  return t;
}, wZe = /* @__PURE__ */ xe.createContext(null);
wZe.displayName = "CheckoutContext";
Fr.any, Fr.shape({
  clientSecret: Fr.string.isRequired,
  elementsOptions: Fr.object
}).isRequired;
var hT = function(t) {
  var r = xe.useContext(Dte), n = xe.useContext(kC);
  if (r && n)
    throw new Error("You cannot wrap the part of your app that ".concat(t, " in both <CheckoutProvider> and <Elements> providers."));
  return r ? EZe(r, t) : Pte(n, t);
}, OZe = function(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}, pa = function(t, r) {
  var n = "".concat(OZe(t), "Element"), a = function(l) {
    var c = l.id, u = l.className, d = l.options, f = d === void 0 ? {} : d, m = l.onBlur, h = l.onFocus, g = l.onReady, y = l.onChange, S = l.onEscape, x = l.onClick, b = l.onLoadError, _ = l.onLoaderStart, $ = l.onNetworksChange, w = l.onConfirm, O = l.onCancel, T = l.onShippingAddressChange, I = l.onShippingRateChange, P = hT("mounts <".concat(n, ">")), D = "elements" in P ? P.elements : null, B = "checkoutSdk" in P ? P.checkoutSdk : null, L = xe.useState(null), N = Ite(L, 2), z = N[0], F = N[1], j = xe.useRef(null), H = xe.useRef(null);
    Li(z, "blur", m), Li(z, "focus", h), Li(z, "escape", S), Li(z, "click", x), Li(z, "loaderror", b), Li(z, "loaderstart", _), Li(z, "networkschange", $), Li(z, "confirm", w), Li(z, "cancel", O), Li(z, "shippingaddresschange", T), Li(z, "shippingratechange", I), Li(z, "change", y);
    var U;
    g && (t === "expressCheckout" ? U = g : U = function() {
      g(z);
    }), Li(z, "ready", U), xe.useLayoutEffect(function() {
      if (j.current === null && H.current !== null && (D || B)) {
        var V = null;
        B ? V = B.createElement(t, f) : D && (V = D.create(t, f)), j.current = V, F(V), V && V.mount(H.current);
      }
    }, [D, B, f]);
    var G = vT(f);
    return xe.useEffect(function() {
      if (j.current) {
        var V = Mte(f, G, ["paymentRequest"]);
        V && "update" in j.current && j.current.update(V);
      }
    }, [f, G]), xe.useLayoutEffect(function() {
      return function() {
        if (j.current && typeof j.current.destroy == "function")
          try {
            j.current.destroy(), j.current = null;
          } catch {
          }
      };
    }, []), /* @__PURE__ */ xe.createElement("div", {
      id: c,
      className: u,
      ref: H
    });
  }, i = function(l) {
    hT("mounts <".concat(n, ">"));
    var c = l.id, u = l.className;
    return /* @__PURE__ */ xe.createElement("div", {
      id: c,
      className: u
    });
  }, o = r ? i : a;
  return o.propTypes = {
    id: Fr.string,
    className: Fr.string,
    onChange: Fr.func,
    onBlur: Fr.func,
    onFocus: Fr.func,
    onReady: Fr.func,
    onEscape: Fr.func,
    onClick: Fr.func,
    onLoadError: Fr.func,
    onLoaderStart: Fr.func,
    onNetworksChange: Fr.func,
    onConfirm: Fr.func,
    onCancel: Fr.func,
    onShippingAddressChange: Fr.func,
    onShippingRateChange: Fr.func,
    options: Fr.object
  }, o.displayName = n, o.__elementType = t, o;
}, ma = typeof window > "u", TZe = /* @__PURE__ */ xe.createContext(null);
TZe.displayName = "EmbeddedCheckoutProviderContext";
var IZe = function() {
  var t = hT("calls useStripe()"), r = t.stripe;
  return r;
};
pa("auBankAccount", ma);
pa("card", ma);
pa("cardNumber", ma);
pa("cardExpiry", ma);
pa("cardCvc", ma);
pa("fpxBank", ma);
pa("iban", ma);
pa("idealBank", ma);
pa("p24Bank", ma);
pa("epsBank", ma);
var MZe = pa("payment", ma), AZe = pa("expressCheckout", ma);
pa("currencySelector", ma);
pa("paymentRequestButton", ma);
pa("linkAuthentication", ma);
pa("address", ma);
pa("shippingAddress", ma);
pa("paymentMethodMessaging", ma);
pa("affirmMessage", ma);
pa("afterpayClearpayMessage", ma);
const { Text: PZe } = Gn, jte = ({
  address: e,
  open: t,
  type: r = "billing",
  onCancel: n,
  onNewAddressCreated: a,
  hasShippingAddress: i = !1
}) => {
  const { updateUserCartData: o } = Cr(Pl), { theme: s, customHooks: { addressHook: l } } = ia(), {
    addressLoading: c,
    isUpdatingAddress: u,
    updateAddress: d,
    addAddress: f,
    getDefaultAddress: m,
    prepareAddressPayload: h
  } = l, g = (U) => {
    let G;
    return f(h(U)).then((V) => {
      const K = r === "billing" ? { billingAddressId: `${V?.id}` } : { shippingAddressId: `${V?.id}` };
      return G = V, o({ ...K });
    }).then(() => a && a(G)).finally(() => n(G));
  }, {
    countryLoading: y,
    statesLoading: S,
    getStates: x,
    countries: b,
    states: _,
    mapCountryOrZones: $
  } = Ste(), [w] = Dt.useForm();
  St(() => {
    e && e?.country ? x(e?.country?.code) : x("US");
  }, []);
  const O = s !== Tr.Default ? `ttg-edit-address-modal--skin--${s}` : "", T = s !== Tr.Default ? `ant-checkbox-wrapper--skin--${s}` : "", [I, P] = xe.useState(!1), [D, B] = xe.useState(!1), [L] = xe.useState({
    firstName: e?.firstName || "",
    lastName: e?.lastName || "",
    company: e && e?.company || "",
    phone: e?.phone || "",
    streetAddress: e?.streetAddress || "",
    suburb: e && e?.suburb || "",
    countryCode: e && Object.keys(e).length !== 0 ? e?.country.code : "US",
    stateCode: e && Object.keys(e).length !== 0 ? e?.state?.code : "",
    city: e?.city || "",
    postCode: e?.postCode || "",
    isDefault: m() ? e && e?.isDefault || !1 : !0
  }), N = xe.useCallback((U) => {
    e ? d(e?.id, h(U)) : g(U);
  }, [c]), z = {
    required: "is required",
    string: {
      min: "must be at least ${min} characters",
      max: "must be up to ${max} characters"
    }
  }, F = () => {
    if (_ && _?.length > 0)
      return /* @__PURE__ */ E.jsx(
        Dt.Item,
        {
          name: "stateCode",
          label: "State/Province",
          rules: [
            { required: !0 }
          ],
          children: /* @__PURE__ */ E.jsx(
            Kn,
            {
              showSearch: !0,
              optionFilterProp: "label",
              loading: S,
              options: $(_)
            }
          )
        }
      );
  }, j = (U, G) => {
    const { value: V } = U.target, K = V.trim();
    w.setFieldsValue({ [G]: K });
  }, H = () => {
    const U = w.getFieldsValue();
    B(!Ote(U, L));
  };
  return /* @__PURE__ */ E.jsx(
    da,
    {
      title: /* @__PURE__ */ E.jsx("span", { id: "address-form-modal", children: `${e?.id ? "Edit your address" : "Add a new address"}` }),
      open: t,
      onCancel: () => n(),
      className: `ttg-edit-address-modal ${O}`,
      footer: null,
      width: "743px",
      destroyOnClose: !0,
      closable: !1,
      maskClosable: !1,
      children: /* @__PURE__ */ E.jsxs(
        Dt,
        {
          layout: "vertical",
          form: w,
          onFinish: N,
          onFinishFailed: () => P(!0),
          onFieldsChange: () => H(),
          initialValues: L,
          validateMessages: z,
          validateTrigger: I ? "onChange" : "onSubmit",
          className: "pt-4",
          children: [
            /* @__PURE__ */ E.jsxs(At, { gutter: [24, 12], id: "address-form-modal", children: [
              /* @__PURE__ */ E.jsx(Oe, { span: 12, children: /* @__PURE__ */ E.jsx(
                Dt.Item,
                {
                  name: "firstName",
                  label: "First name",
                  rules: [{ required: !0 }, { min: 2 }, { max: 32 }],
                  children: /* @__PURE__ */ E.jsx(Lr, { onBlur: (U) => j(U, "firstName") })
                }
              ) }),
              /* @__PURE__ */ E.jsx(Oe, { span: 12, children: /* @__PURE__ */ E.jsx(
                Dt.Item,
                {
                  name: "lastName",
                  label: "Last name",
                  rules: [{ required: !0 }, { min: 2 }, { max: 32 }],
                  children: /* @__PURE__ */ E.jsx(Lr, { onBlur: (U) => j(U, "lastName") })
                }
              ) }),
              /* @__PURE__ */ E.jsx(Oe, { span: 12, children: /* @__PURE__ */ E.jsx(
                Dt.Item,
                {
                  name: "company",
                  label: /* @__PURE__ */ E.jsxs("span", { children: [
                    "Company name ",
                    /* @__PURE__ */ E.jsx("span", { className: "font-normal", children: "(Optional)" })
                  ] }),
                  rules: [{ max: 64 }],
                  children: /* @__PURE__ */ E.jsx(Lr, { onBlur: (U) => j(U, "company") })
                }
              ) }),
              /* @__PURE__ */ E.jsx(Oe, { span: 12, children: /* @__PURE__ */ E.jsx(
                Dt.Item,
                {
                  name: "phone",
                  label: "Phone number",
                  rules: [
                    { required: !0 },
                    {
                      pattern: tq,
                      message: "You must enter a valid phone number"
                    },
                    { min: 2 },
                    { max: 32 }
                  ],
                  validateFirst: !0,
                  children: /* @__PURE__ */ E.jsx(Lr, {})
                }
              ) }),
              /* @__PURE__ */ E.jsx(Oe, { span: 12, children: /* @__PURE__ */ E.jsx(
                Dt.Item,
                {
                  name: "streetAddress",
                  label: "Street address",
                  rules: [{ required: !0 }, { min: 5 }, { max: 64 }],
                  children: /* @__PURE__ */ E.jsx(Lr, { onBlur: (U) => j(U, "streetAddress") })
                }
              ) }),
              /* @__PURE__ */ E.jsx(Oe, { span: 12, children: /* @__PURE__ */ E.jsx(
                Dt.Item,
                {
                  name: "suburb",
                  label: /* @__PURE__ */ E.jsxs("span", { children: [
                    "Address line 2 ",
                    /* @__PURE__ */ E.jsx("span", { className: "font-normal", children: "(Optional)" })
                  ] }),
                  rules: [{ max: 64 }],
                  children: /* @__PURE__ */ E.jsx(Lr, { onBlur: (U) => j(U, "suburb") })
                }
              ) }),
              /* @__PURE__ */ E.jsx(Oe, { span: 12, children: /* @__PURE__ */ E.jsx(
                Dt.Item,
                {
                  name: "countryCode",
                  label: "Country",
                  rules: [{ required: !0 }],
                  children: /* @__PURE__ */ E.jsx(
                    Kn,
                    {
                      showSearch: !0,
                      optionFilterProp: "label",
                      loading: y,
                      options: b ? $(b) : [],
                      onChange: (U) => {
                        x(U), w.setFieldValue("stateCode", "");
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ E.jsx(Oe, { span: 12, children: F() }),
              /* @__PURE__ */ E.jsx(Oe, { span: 12, children: /* @__PURE__ */ E.jsx(
                Dt.Item,
                {
                  name: "city",
                  label: "City",
                  rules: [{ required: !0 }, { min: 3 }, { max: 32 }],
                  children: /* @__PURE__ */ E.jsx(Lr, { onBlur: (U) => j(U, "city") })
                }
              ) }),
              /* @__PURE__ */ E.jsx(Oe, { span: 12, children: /* @__PURE__ */ E.jsx(
                Dt.Item,
                {
                  name: "postCode",
                  label: "Post/Zip code",
                  rules: [
                    { required: !0 },
                    { min: 4 },
                    { max: 10 },
                    {
                      pattern: rq,
                      message: "You must enter a valid zip code"
                    }
                  ],
                  children: /* @__PURE__ */ E.jsx(Lr, {})
                }
              ) }),
              /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(Dt.Item, { name: "isDefault", valuePropName: "checked", children: /* @__PURE__ */ E.jsx(co, { disabled: !m(), className: `${T}`, children: "Set as primary address" }) }) })
            ] }),
            i && /* @__PURE__ */ E.jsx(At, { className: "border-t border-gray-200 pt-5", children: /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(zn, { type: "inner", size: "default", bordered: !1, children: [
              /* @__PURE__ */ E.jsx(PZe, { className: "text-base text-gray-900 font-bold", children: "Please Note!" }),
              /* @__PURE__ */ E.jsxs("p", { className: "pt-2", children: [
                "The shipping and billing addresses are linked. If you've selected this address as your ",
                r === "billing" ? "shipping" : "billing",
                " address too, any modifications made here will also affect your ",
                r === "billing" ? "shipping" : "billing",
                " address."
              ] })
            ] }) }) }),
            /* @__PURE__ */ E.jsxs(
              At,
              {
                justify: "space-between",
                className: "pt-5",
                id: "address-form-modal",
                children: [
                  /* @__PURE__ */ E.jsx(Nt, { type: "default", onClick: () => n(), children: "Cancel" }),
                  /* @__PURE__ */ E.jsx(Dt.Item, { children: /* @__PURE__ */ E.jsx(Nt, { type: "primary", htmlType: "submit", loading: c || u, disabled: !D, children: "Save" }) })
                ]
              }
            )
          ]
        }
      )
    }
  );
}, { Text: Ms } = Gn, SF = ({
  title: e,
  address: t,
  onChange: r,
  hasAlternateAddress: n,
  highlighted: a
}) => {
  const { screensSize: i } = ia(), { isMobileView: o } = i, s = n ? "Change" : "Add address", l = (u) => /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
    /* @__PURE__ */ E.jsx(Ms, { id: "ttg-address-info-fullname-id", children: `${u.firstName} ${u.lastName}` }),
    /* @__PURE__ */ E.jsx(Ms, { id: "ttg-address-info-street-id", children: u.streetAddress }),
    /* @__PURE__ */ E.jsx(Ms, { id: "ttg-address-info-suburb-id", children: u.suburb || "" }),
    /* @__PURE__ */ E.jsx(Ms, { id: "ttg-address-info-location-id", children: `${u.city}, ${u.state?.name || ""} ${u.postCode}` }),
    /* @__PURE__ */ E.jsx(Ms, { id: "ttg-address-info-country-id", children: u.country.name })
  ] }), c = () => n ? /* @__PURE__ */ E.jsx(Ms, { children: 'Click "Change" to add a new address or select from your alternate addresses' }) : /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
    /* @__PURE__ */ E.jsx(Ms, { children: "No address added yet." }),
    /* @__PURE__ */ E.jsx(Ms, { children: "Click “Add address” button to continue with the checkout process." })
  ] });
  return (
    // eslint-disable-next-line no-sparse-arrays
    /* @__PURE__ */ E.jsxs(At, { gutter: [, 32], id: `address-${t?.id}`, className: `checkout-address-info ${a && "highlighted"}`, children: [
      /* @__PURE__ */ E.jsx(Oe, { span: o ? 12 : 8, order: 1, children: /* @__PURE__ */ E.jsx(Ms, { className: "text-base text-gray-900 font-medium", children: e }) }),
      /* @__PURE__ */ E.jsx(Oe, { span: o ? 24 : 13, order: o ? 3 : 2, className: "text-sm text-gray-800 font-normal", children: t ? l(t) : c() }),
      /* @__PURE__ */ E.jsx(Oe, { span: o ? 12 : 3, order: o ? 2 : 3, style: { display: "flex", justifyContent: "flex-end" }, children: /* @__PURE__ */ E.jsx(Nt, { type: "link", className: "font-medium", onClick: r, children: s }) })
    ] })
  );
}, { Text: S0 } = Gn, xF = ({
  title: e,
  addresses: t,
  type: r,
  setAddress: n,
  onClose: a,
  onNewAddressCreated: i,
  hasShippingAddress: o
}) => {
  const { userCartData: s } = Cr(Pl), { theme: l } = ia(), c = 20, u = l !== Tr.Default ? `ant-radio-group--skin--${l}` : "", d = t && t.find((O) => O.isDefault), f = t && t.filter((O) => !O.isDefault), [m, h] = He(-1);
  St(() => {
    const T = [d, ...f]?.findIndex((I) => Number(I?.id) === Number(s && s[`${r}AddressId`]));
    h(T > -1 ? T : 0);
  }, [s]);
  const [g, y] = xe.useState(!1), [S, x] = xe.useState(null), b = (O) => {
    h(O.target.value);
  }, _ = () => {
    const T = [d, ...f][m];
    T && n(r, T);
  }, $ = (O) => {
    if (O)
      return O && a(r, O);
    const I = [d, ...f][m];
    I && a(r, I);
  }, w = xe.useCallback((O) => /* @__PURE__ */ E.jsx(S0, { children: `${O.firstName} ${O.lastName} ${O.streetAddress} ${O.suburb || ""} ${O.city}, ${O.state?.name || ""} ${O.postCode} ${O.country?.name}` }), []);
  return /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
    /* @__PURE__ */ E.jsxs(
      At,
      {
        className: "checkout-address-info",
        align: "middle",
        justify: "space-between",
        children: [
          /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(S0, { className: "text-base text-gray-900 font-medium", children: e }) }),
          /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(Nt, { type: "link", className: "font-medium", onClick: () => $(), children: "Close" }) }),
          /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(zn, { className: "px-6 py-4", children: /* @__PURE__ */ E.jsx(Ba.Group, { value: m, onChange: b, className: u + " w-full", children: /* @__PURE__ */ E.jsxs(At, { children: [
            d && Object.keys(d ?? {}).length !== 0 && /* @__PURE__ */ E.jsxs(Oe, { span: 24, children: [
              /* @__PURE__ */ E.jsx(At, { children: /* @__PURE__ */ E.jsx(S0, { className: "text-sm leading-5 font-medium text-gray-900 mb-2", children: "Primary Address" }) }),
              /* @__PURE__ */ E.jsxs(At, { align: "middle", justify: "space-between", style: { flexWrap: "nowrap" }, children: [
                /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(Ba, { value: 0, children: w(d) }) }),
                /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(
                  Nt,
                  {
                    type: "link",
                    onClick: () => {
                      x(d), y(!0);
                    },
                    children: "Edit"
                  }
                ) })
              ] })
            ] }),
            f && f?.length !== 0 && /* @__PURE__ */ E.jsxs(
              Oe,
              {
                span: 24,
                className: "border-t border-gray-200 pt-2 mt-2",
                children: [
                  t.length >= c && /* @__PURE__ */ E.jsx(At, { children: /* @__PURE__ */ E.jsx(S0, { className: "text-sm leading-5 font-normal text-red-500 mb-2", children: "You have reached the maximum limit for addresses. To add a new address, please remove an existing address from your account." }) }),
                  /* @__PURE__ */ E.jsx(At, { children: /* @__PURE__ */ E.jsx(S0, { className: "text-sm leading-5 font-medium text-gray-900 mb-2", children: "Alternate Addresses" }) }),
                  f.map((O, T) => /* @__PURE__ */ E.jsxs(
                    At,
                    {
                      align: "middle",
                      justify: "space-between",
                      style: { flexWrap: "nowrap" },
                      children: [
                        /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(Ba, { value: T + 1, children: w(O) }) }),
                        /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(
                          Nt,
                          {
                            type: "link",
                            onClick: () => {
                              x(O), y(!0);
                            },
                            children: "Edit"
                          }
                        ) })
                      ]
                    },
                    T
                  ))
                ]
              }
            )
          ] }) }) }) }),
          t && t.length < c && /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
            Nt,
            {
              type: "link",
              onClick: () => {
                x(null), y(!0);
              },
              children: "+ Add new address"
            }
          ) }),
          /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(
            At,
            {
              className: "ant-card-footer",
              align: "middle",
              justify: "space-between",
              children: [
                /* @__PURE__ */ E.jsx(
                  Nt,
                  {
                    type: "default",
                    className: "uppercase py-2 px-3",
                    onClick: () => $(),
                    children: "Cancel"
                  }
                ),
                /* @__PURE__ */ E.jsx(
                  Nt,
                  {
                    type: "primary",
                    className: "uppercase py-2 px-3",
                    onClick: _,
                    children: "Save"
                  }
                )
              ]
            }
          ) })
        ]
      }
    ),
    g && /* @__PURE__ */ E.jsx(
      jte,
      {
        address: S,
        open: g,
        onCancel: (O) => {
          y(!1), $(O);
        },
        type: r,
        onNewAddressCreated: i,
        hasShippingAddress: o
      }
    )
  ] });
}, { Text: ri, Paragraph: ja } = Gn, RZe = ({
  onCompleteOrder: e,
  isFirstTimeWgPurchaser: t
}) => {
  const {
    customHooks: { paymentHook: r },
    theme: n,
    applicationId: a,
    services: i
  } = ia(), { currentInvoice: o, isOrderProcessed: s } = r, l = o?.lines?.data, { isLoadingFeedback: c, isSubmittedFeedback: u, addFeedback: d } = KWe(i), { addOrderCompleteEvent: f } = qd();
  St(() => {
    !o || s === !1 || (window.scrollTo({ top: 0, behavior: "smooth" }), e && e(o), f(o));
  }, [o, s]);
  const m = (H, U, G, V, K) => {
    const Z = ni.get("TTG_USER"), ee = window.location.host, ae = [
      "dev.theworkinggenius.link",
      "stage.theworkinggenius.link",
      "www.workinggenius.com",
      "host.docker.internal:3001"
    ], ue = [
      "app.dev.thetablegroup.link",
      "app.stage.thetablegroup.link",
      "www.tablegroup.com",
      "host.docker.internal:3002"
    ], re = ae.findIndex((le) => le === ee), oe = ue.findIndex((le) => le === ee);
    if (H === Tr.Default && re !== -1 || H === Tr.TTGApp && oe !== -1)
      return window.location.assign(`${U}${K || ""}`);
    const fe = re !== -1 ? ue[re] : oe !== -1 ? ae[oe] : ee;
    if (G) {
      const le = V ? `${V}?token=${Z}` : `${U}?token=${Z}`;
      return window.open(`https://${fe}${le}${K || ""}`);
    }
    return window.open(`https://${fe}${V ?? U}${K || ""}`);
  }, h = () => m(
    n,
    n === Tr.Default ? "/client/licenses?tab=orders" : "/client/account/orders",
    !1,
    n !== Tr.Default ? "/client/licenses?tab=orders" : "/client/account/orders"
  ), g = () => m(Tr.Default, "/client/certification", n !== Tr.Default), y = () => m(
    Tr.Default,
    "/client/certification",
    n !== Tr.Default,
    void 0,
    "#alumni_intensives"
  ), S = () => m(
    Tr.Default,
    "/client",
    n !== Tr.Default
  ), x = () => m(Tr.TTGApp, "/meetings/dashboard", !1), b = () => m(Tr.TTGApp, "/client/video", n !== Tr.TTGApp), _ = () => m(Tr.TTGApp, "/client", n !== Tr.TTGApp), $ = () => m(Tr.Default, "/client", n !== Tr.Default), w = (H) => {
    const U = [];
    return H?.map((G) => {
      const V = G?.metadata?.participant_email ? `${G?.metadata?.type}-someone-else` : G?.metadata?.type;
      return V && U.includes(V) ? null : V && U.push(V);
    }), U.sort();
  }, O = () => /* @__PURE__ */ E.jsxs("span", { className: "flex items-center", children: [
    /* @__PURE__ */ E.jsx(KW, { className: "ttg-order-complete-icon", size: 32 }),
    " ",
    "Order Complete!"
  ] }), T = [
    {
      type: mr.AlumniIntensive,
      component: /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(ja, { children: [
          "Thank you for purchasing",
          " ",
          /* @__PURE__ */ E.jsx(ri, { strong: !0, children: "Alumni Intensive: Growing Your Business." }),
          /* @__PURE__ */ E.jsx("br", {}),
          "You will be receiving updates via email with more information regarding your session in the upcoming weeks.",
          /* @__PURE__ */ E.jsx("br", {}),
          "Additionally, you can access your session pre-work in your Certification Resources.",
          /* @__PURE__ */ E.jsx("br", {}),
          "Enjoy!"
        ] }) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "py-2 mb-3", children: /* @__PURE__ */ E.jsx(Nt, { onClick: y, children: "Go To Alumni Intensive Portal" }) })
      ] })
    },
    {
      type: mr.Certification,
      component: /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(ja, { children: [
          "Thank you for purchasing",
          " ",
          /* @__PURE__ */ E.jsx(ri, { strong: !0, children: "The Six Types of Working Genius Certification." }),
          /* @__PURE__ */ E.jsx("br", {}),
          "You will be receiving updates via email with more information regarding your session in the upcoming weeks.",
          /* @__PURE__ */ E.jsx("br", {}),
          "Additionally, you have received 10 free Working Genius Assessments with the purchase of your Certification.",
          /* @__PURE__ */ E.jsx("br", {}),
          "Enjoy!"
        ] }) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "py-2 mb-3", children: /* @__PURE__ */ E.jsx(Nt, { onClick: g, children: "Go To Certification Portal" }) })
      ] })
    },
    {
      type: mr.CertificationForSomeoneElse,
      component: /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(ja, { children: [
          "Thank you for purchasing",
          " ",
          /* @__PURE__ */ E.jsx(ri, { strong: !0, children: "The Six Types of Working Genius Certification." }),
          /* @__PURE__ */ E.jsx("br", {}),
          "The individual you registered for will be receiving updates via email with more information regarding their session in the upcoming weeks.",
          /* @__PURE__ */ E.jsx("br", {}),
          "Additionally, they have received 10 free Working Genius Assessments with the purchase of Certification.",
          /* @__PURE__ */ E.jsx("br", {}),
          "Thanks!"
        ] }) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "py-2 mb-3", children: /* @__PURE__ */ E.jsx(Nt, { onClick: g, children: "Go To Certification Portal" }) })
      ] })
    },
    {
      type: mr.Assessment,
      component: /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(ja, { className: "py-3", children: [
          "You now have access to the Administrator’s Console.",
          /* @__PURE__ */ E.jsx("br", {}),
          "If you wish to set up a Team Assessment or initiate your streaming video service, click the link below to log in.",
          /* @__PURE__ */ E.jsx("br", {}),
          "You can navigate between products using the menu tabs at the top of the Administrator’s Console.",
          /* @__PURE__ */ E.jsx("br", {})
        ] }) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(ja, { className: "py-3", children: [
          "You will also receive a confirmation email with information on how to access your Administrator's dashboard.",
          /* @__PURE__ */ E.jsx("br", {})
        ] }) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "mb-5", children: /* @__PURE__ */ E.jsx(
          lr,
          {
            direction: "horizontal",
            wrap: !0,
            align: "start",
            size: "middle",
            children: /* @__PURE__ */ E.jsx(Nt, { onClick: _, children: "Click here to go to the Administrator's Console" })
          }
        ) })
      ] })
    },
    {
      type: mr.WgAssessment,
      component: /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(ja, { className: "py-3", children: [
          "Thank you for ordering",
          " ",
          /* @__PURE__ */ E.jsx(ri, { strong: !0, children: "The 6 Types of Working Genius Assessment" }),
          ". To take the Assessment or if you wish to set up either Group or Individual Assessments, you can do so from your Administrator’s Console.",
          /* @__PURE__ */ E.jsx("br", {})
        ] }) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "mb-5", children: /* @__PURE__ */ E.jsx(
          lr,
          {
            direction: "horizontal",
            wrap: !0,
            align: "start",
            size: "middle",
            children: /* @__PURE__ */ E.jsx(Nt, { onClick: $, children: "Take or send assessment to others" })
          }
        ) })
      ] })
    },
    {
      type: mr.WgAssessmentStudent,
      component: /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
        /* @__PURE__ */ E.jsxs(Oe, { span: 24, children: [
          /* @__PURE__ */ E.jsxs(ja, { className: "pt-3", children: [
            "Thank you for ordering",
            " ",
            /* @__PURE__ */ E.jsx(ri, { strong: !0, children: "The 6 Types of Working Genius Assessment for Students" }),
            ". To take the Assessment or if you wish to set up either Group or Individual Student Assessments, you can do so from your Administrator’s Console."
          ] }),
          /* @__PURE__ */ E.jsxs(ja, { className: "py-3", children: [
            /* @__PURE__ */ E.jsx(ri, { strong: !0, children: "Special Note: " }),
            "Student and Standard Working Genius Licenses are interchangeable. When logging into your portal, you will have the option to choose the Student Assessment after choosing to take the assessment now or send assessment to others."
          ] })
        ] }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "mb-5", children: /* @__PURE__ */ E.jsx(
          lr,
          {
            direction: "horizontal",
            wrap: !0,
            align: "start",
            size: "middle",
            children: /* @__PURE__ */ E.jsx(Nt, { onClick: $, children: "Take or send assessment to others" })
          }
        ) })
      ] })
    },
    {
      type: mr.AppGuide,
      component: /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(ja, { className: "py-3", children: [
          "Thank you for ordering the",
          " ",
          /* @__PURE__ */ E.jsx(ri, { strong: !0, children: "Working Genius Team Application Guide" }),
          ". To access it, login to your Administrator’s Console and click on the “Application Guide” tab.",
          /* @__PURE__ */ E.jsx("br", {})
        ] }) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "mb-5", children: /* @__PURE__ */ E.jsx(
          lr,
          {
            direction: "horizontal",
            wrap: !0,
            align: "start",
            size: "middle",
            children: /* @__PURE__ */ E.jsx(Nt, { onClick: S, children: "Go to the website" })
          }
        ) })
      ] })
    },
    {
      type: mr.Physical,
      component: /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(ja, { className: "py-3", children: [
          "Thank for your purchase. To view the details of this order click on the button below.",
          /* @__PURE__ */ E.jsx("br", {})
        ] }) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "mb-3", children: /* @__PURE__ */ E.jsx(
          lr,
          {
            direction: "horizontal",
            wrap: !0,
            align: "start",
            size: "middle",
            children: /* @__PURE__ */ E.jsx(Nt, { onClick: h, children: "Go to the orders" })
          }
        ) })
      ] })
    },
    {
      type: mr.Video,
      component: /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(ja, { className: "py-3", children: [
          "You can view these videos in your Administrator's console.",
          /* @__PURE__ */ E.jsx("br", {})
        ] }) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "mb-3", children: /* @__PURE__ */ E.jsx(
          lr,
          {
            direction: "horizontal",
            wrap: !0,
            align: "start",
            size: "middle",
            children: /* @__PURE__ */ E.jsx(Nt, { onClick: b, children: "Click here to go to Administrator's console" })
          }
        ) })
      ] })
    },
    {
      type: mr.MeetingAdvantage,
      component: /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(ja, { className: "py-3", children: [
          "Thank you for your purchase of",
          " ",
          /* @__PURE__ */ E.jsx(ri, { strong: !0, children: "The Meeting Advantage." }),
          /* @__PURE__ */ E.jsx("br", {}),
          "Please click the button below to log-in and get started. Once you are logged in, you can take a tour of The Meeting Advantage and set-up your team.",
          /* @__PURE__ */ E.jsx("br", {}),
          "There are video and text explanations throughout the tool to help you along the way.",
          /* @__PURE__ */ E.jsx("br", {})
        ] }) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(ja, { className: "py-3", children: [
          "You will also receive a confirmation email with information on how to access your team dashboard.",
          /* @__PURE__ */ E.jsx("br", {})
        ] }) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "mb-3", children: /* @__PURE__ */ E.jsx(
          lr,
          {
            direction: "horizontal",
            wrap: !0,
            align: "start",
            size: "middle",
            children: /* @__PURE__ */ E.jsx(Nt, { onClick: x, children: "Log in" })
          }
        ) })
      ] })
    },
    {
      type: mr.SmartHireBundle,
      component: /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(ja, { className: "py-3", children: [
          "Thank you for ordering",
          " ",
          /* @__PURE__ */ E.jsx(ri, { strong: !0, children: "The 6 Types of Working Genius Assessment" }),
          ". To take the Assessment or if you wish to set up either Group or Individual Assessments, you can do so from your Administrator’s Console.",
          /* @__PURE__ */ E.jsx("br", {})
        ] }) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "mb-5", children: /* @__PURE__ */ E.jsx(
          lr,
          {
            direction: "horizontal",
            wrap: !0,
            align: "start",
            size: "middle",
            children: /* @__PURE__ */ E.jsx(Nt, { onClick: $, children: "Take or send assessment to others" })
          }
        ) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(ja, { className: "py-3", children: [
          "Thank you for ordering the",
          " ",
          /* @__PURE__ */ E.jsx(ri, { strong: !0, children: "Working Genius Team Application Guide" }),
          ". To access it, login to your Administrator’s Console and click on the “Application Guide” tab.",
          /* @__PURE__ */ E.jsx("br", {})
        ] }) }),
        /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "mb-5", children: /* @__PURE__ */ E.jsx(
          lr,
          {
            direction: "horizontal",
            wrap: !0,
            align: "start",
            size: "middle",
            children: /* @__PURE__ */ E.jsx(Nt, { onClick: S, children: "Go to the website" })
          }
        ) })
      ] })
    }
  ], I = dr(() => {
    const H = w(l);
    return T.sort((U, G) => U.type.localeCompare(G.type)).map((U, G) => H.includes(U.type) && /* @__PURE__ */ E.jsx(
      At,
      {
        className: `${H.length > 1 && U.type !== H[H.length - 1] ? "border-b-2 border-gray-200" : ""} `,
        children: U.component
      },
      G
    ));
  }, [l]), P = [
    {
      label: "I saw an advertisement",
      value: "WG_Lead_Ad"
    },
    {
      label: "Heard a speech or presentation",
      value: "WG_Lead_Speech"
    },
    {
      label: "On a podcast",
      value: "WG_Lead_Podcast"
    },
    {
      label: "A friend or coworker",
      value: "WG_Lead_Friend"
    },
    {
      label: "Other",
      value: "WG_Lead_Other"
    }
  ], [D, B] = He(!1), [L, N] = He(""), z = () => {
    d(L);
  }, F = () => /* @__PURE__ */ E.jsx(At, { children: /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(
    Nt,
    {
      type: "primary",
      onClick: z,
      disabled: !L,
      loading: c,
      children: "Submit"
    }
  ) }) }), j = () => /* @__PURE__ */ E.jsx(
    da,
    {
      centered: !0,
      destroyOnClose: !0,
      onCancel: () => B(!1),
      footer: u ? null : F(),
      title: u ? "" : "How did you hear about Working Genius?",
      open: D,
      children: u ? /* @__PURE__ */ E.jsxs("div", { className: "flex flex-col items-center py-4", children: [
        /* @__PURE__ */ E.jsx(qW, { className: "text-green-400", size: 40 }),
        /* @__PURE__ */ E.jsx(ri, { className: "block text-lg text-gray-800 font-medium my-3", children: "Thank you for your feedback" }),
        /* @__PURE__ */ E.jsx(ri, { className: "block text-sm text-gray-600 font-normal", children: "Your response has been submitted." })
      ] }) : /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
        /* @__PURE__ */ E.jsx(ri, { className: "block text-sm text-gray-600 font-normal my-4", children: "You have to select only one answer" }),
        /* @__PURE__ */ E.jsx(Ba.Group, { onChange: (H) => N(H.target.value), children: /* @__PURE__ */ E.jsx(lr, { direction: "vertical", children: P?.map((H, U) => /* @__PURE__ */ E.jsx(
          Ba,
          {
            value: H.value,
            className: "text-sm text-gray-800 leading-5 font-normal py-1",
            children: H.label
          },
          U
        )) }) })
      ] })
    }
  );
  return St(() => {
    const H = setTimeout(() => {
      B(!0);
    }, 1e3);
    return () => {
      clearTimeout(H);
    };
  }, []), /* @__PURE__ */ E.jsx(At, { className: "ttg-order-complete", children: /* @__PURE__ */ E.jsxs(zn, { title: O(), className: "ttg-order-complete-card", children: [
    /* @__PURE__ */ E.jsx(At, { className: "m-4", children: I }),
    o?.status === "draft" && /* @__PURE__ */ E.jsx(At, { className: "m-4", children: /* @__PURE__ */ E.jsxs(ja, { children: [
      /* @__PURE__ */ E.jsx(ri, { strong: !0, children: "PLEASE NOTE:" }),
      " Your order is not complete until your purchase order is approved. We will notify you via e-mail regarding the status of your order."
    ] }) }),
    !s && /* @__PURE__ */ E.jsx(At, { className: "m-4", children: /* @__PURE__ */ E.jsxs(ja, { children: [
      /* @__PURE__ */ E.jsx(ri, { strong: !0, children: "NOTE:" }),
      " Please wait a few seconds till your order is fully processed."
    ] }) }),
    a === "WG" && t && j()
  ] }) });
}, NZe = ({ onPaymentValidationForm: e, children: t }) => {
  const [r, n] = He(!1), [, a] = He(null), i = Nte();
  St(() => {
    const s = (l) => {
      const c = l.reason;
      n(!0), e(!1), a(c);
    };
    return window.addEventListener("unhandledrejection", s), i?.getElement("payment")?.on("loaderror", () => {
      n(!0), e(!1), a({ message: "Error loading Stripe", name: "StripeError" });
    }), () => {
      window.removeEventListener("unhandledrejection", s);
    };
  }, [i]);
  const o = () => {
    window.location.reload();
  };
  return r ? /* @__PURE__ */ E.jsxs(At, { className: "error-boundary", children: [
    /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(lr, { direction: "horizontal", size: 12, className: "error-boundary-body", children: [
      /* @__PURE__ */ E.jsx(_l, { size: 22, className: "tooltip-icon" }),
      /* @__PURE__ */ E.jsxs(lr, { direction: "vertical", size: 0, children: [
        /* @__PURE__ */ E.jsx("span", { className: "error-boundary-title", children: "Error!" }),
        /* @__PURE__ */ E.jsx("span", { children: "A network error occured. Please reload this page and try again." })
      ] })
    ] }) }),
    /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "error-boundary-footer", children: /* @__PURE__ */ E.jsx(Nt, { onClick: o, children: /* @__PURE__ */ E.jsx(At, { justify: "center", align: "middle", children: /* @__PURE__ */ E.jsxs(lr, { direction: "horizontal", size: 8, children: [
      /* @__PURE__ */ E.jsx(ZW, { size: 20 }),
      /* @__PURE__ */ E.jsx("span", { children: "Reload Page" })
    ] }) }) }) })
  ] }) : t;
}, { Text: x0 } = Gn, Lte = Aa(({
  user: e,
  cartTotal: t,
  disabled: r = !1,
  onPaymentValidationForm: n,
  onPaymentClick: a,
  showAddressError: i
}, o) => {
  const {
    theme: s,
    customHooks: { paymentHook: l },
    screensSize: { isMobileView: c },
    applicationId: u
  } = ia(), d = IZe(), f = Nte(), [m, h] = He(!1);
  St(() => {
    if (!f) return;
    const H = f.getElement("expressCheckout");
    if (H) {
      const U = (G) => {
        G?.elementType === "expressCheckout" && Object.keys(G?.availablePaymentMethods || {}).length > 0 && h(!0);
      };
      return H.on("ready", U), () => {
        H.off("ready", U);
      };
    }
  }, [f]);
  const [g] = Dt.useForm(), y = s !== Tr.Default ? `ant-radio-group--skin--${s}` : "", S = s !== Tr.Default ? `checkout-payment-info--skin--${s}` : "", [x, b] = He("creditCard"), _ = (H) => {
    $(H.target.value);
  }, $ = Bt((H) => {
    b(H), n(!1), g.resetFields();
  }, [g, n]);
  St(() => {
    (!d || !f) && n(!1);
  }, [d, f, n]), St(() => {
    t < 500 && !e.allowPO && x === "purchaseOrder" && $("creditCard");
  }, [t, $, x]);
  const { invoicePaymentSignedByCC: w, invoicePaymentByPO: O } = l, { cartHook: { localUserCartData: T } } = Cr(Pl), I = {
    fields: { billingDetails: "never" },
    layout: {
      type: "tabs",
      spacedAccordionItems: !1
    },
    business: { name: "The Table Group" },
    wallets: {
      applePay: "never",
      googlePay: "never"
    }
  }, P = {
    required: "is required",
    string: {
      min: "must be at least ${min} characters",
      max: "must be up to ${max} characters"
    }
  }, D = async ({ authorizedBy: H, poNumber: U } = {}) => {
    if (x === "purchaseOrder") return O(H || e?.email, U || e?.id);
    if (x === "creditCard") return w(T.id, d, f);
    throw new Error("Invalid payment method");
  }, B = async () => g.validateFields().then(D);
  fo(o, () => ({ handleSubmit: B }));
  const L = {
    creditCard: () => /* @__PURE__ */ E.jsxs("p", { children: [
      "You are paying by ",
      /* @__PURE__ */ E.jsx("b", { children: "Credit Card" }),
      '. If you wish to pay via Purchase Order, please select the "Purchase Order" button.',
      /* @__PURE__ */ E.jsx("p", { className: "pt-2", children: t < 500 ? "Please note that purchase orders are not available for orders under $500.00." : "" })
    ] }),
    purchaseOrder: () => /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
      /* @__PURE__ */ E.jsxs("p", { children: [
        "You are paying by ",
        /* @__PURE__ */ E.jsx("b", { children: "Purchase Order" }),
        ". Please enter any number for your reference."
      ] }),
      /* @__PURE__ */ E.jsx("p", { children: 'If you wish to pay via Credit Card, please select the "Credit Card" button.' })
    ] })
  }, N = () => /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(zn, { type: "inner", size: "default", bordered: !1, children: [
    /* @__PURE__ */ E.jsx(x0, { className: "text-base text-gray-900 font-bold", children: "Please Note!" }),
    /* @__PURE__ */ E.jsxs(x0, { children: [
      "Working Genius and",
      " ",
      /* @__PURE__ */ E.jsx(
        "a",
        {
          href: "https://www.workinggenius.com",
          target: "_blank",
          rel: "noreferrer",
          children: "www.workinggenius.com"
        }
      ),
      " ",
      "are a subsidiary of ",
      /* @__PURE__ */ E.jsx("b", { children: "The Table Group" }),
      ", a Patrick Lencioni Company. The charge listed on your credit card statement for this purchase will reflect The Table Group company name."
    ] })
  ] }) }), z = ["google_pay", "apple_pay"], F = (H) => {
    const { empty: U, complete: G, value: V } = H, K = z.includes(V.type);
    n(K || !U && G);
  }, j = async () => {
    g.validateFields({ validateOnly: !0 }).then(() => {
      n(!0);
    }).catch((H) => {
      n(H?.errorFields?.length === 0);
    });
  };
  return (
    // eslint-disable-next-line no-sparse-arrays
    /* @__PURE__ */ E.jsxs(At, { gutter: [0, 12], className: `checkout-payment-info ${S}`, children: [
      /* @__PURE__ */ E.jsx(Oe, { span: c ? 24 : 8, children: /* @__PURE__ */ E.jsx(x0, { className: "text-base text-gray-900 font-medium", children: "Payment Method" }) }),
      /* @__PURE__ */ E.jsx(
        Oe,
        {
          span: c ? 24 : 16,
          className: "text-sm text-gray-800 font-normal",
          children: /* @__PURE__ */ E.jsxs(At, { gutter: [0, 24], children: [
            u === "WG" && N(),
            /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
              Ba.Group,
              {
                onChange: _,
                value: x,
                disabled: r,
                className: y,
                children: /* @__PURE__ */ E.jsxs(lr, { direction: "vertical", children: [
                  /* @__PURE__ */ E.jsx(Ba, { checked: !0, value: "creditCard", children: "Credit Card" }),
                  /* @__PURE__ */ E.jsx(Ba, { value: "purchaseOrder", disabled: e.allowPO && !r ? !1 : r || t < 500, children: "Purchase Order" })
                ] })
              }
            ) }),
            /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(zn, { type: "inner", size: "default", bordered: !1, children: [
              /* @__PURE__ */ E.jsx(x0, { className: "text-base text-gray-900 font-bold", children: "Please Note!" }),
              L[x]()
            ] }) }),
            x === "creditCard" && /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "checkout-payment-info-input-container", children: /* @__PURE__ */ E.jsx(NZe, { onPaymentValidationForm: n, children: /* @__PURE__ */ E.jsx(Dt, { form: g, onFinish: D, children: /* @__PURE__ */ E.jsxs(Dt.Item, { children: [
              /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
                MZe,
                {
                  id: "credit-card-container-stripe",
                  options: I,
                  onChange: F
                }
              ) }),
              /* @__PURE__ */ E.jsx(Oe, { span: 24, children: !r && /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
                m && /* @__PURE__ */ E.jsx(Eh, { plain: !0, children: "Or complete order with" }),
                /* @__PURE__ */ E.jsx(
                  AZe,
                  {
                    options: {
                      paymentMethods: {
                        applePay: "always",
                        googlePay: "always",
                        paypal: "never",
                        link: "never",
                        amazonPay: "never"
                      },
                      layout: {
                        overflow: "auto"
                      },
                      buttonType: {
                        applePay: "buy",
                        googlePay: "buy"
                      },
                      buttonTheme: {
                        applePay: "black",
                        googlePay: "black",
                        paypal: "black"
                      },
                      emailRequired: !1,
                      billingAddressRequired: !1
                    },
                    onConfirm: a,
                    onLoadError: (H) => {
                      console.log("Error while loading ExpressCheckout component", H);
                    }
                  }
                )
              ] }) })
            ] }) }) }) }),
            x === "purchaseOrder" && /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "checkout-payment-info-input-container", children: /* @__PURE__ */ E.jsxs(
              Dt,
              {
                form: g,
                onFinish: D,
                validateMessages: P,
                initialValues: { authorizedBy: `${e?.firstName || ""} ${e?.lastName || ""}` },
                onChangeCapture: j,
                onBlurCapture: j,
                children: [
                  /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
                    Dt.Item,
                    {
                      name: "authorizedBy",
                      rules: [{ required: !0 }, { min: 5 }, { max: 64 }],
                      className: "pb-4",
                      children: /* @__PURE__ */ E.jsx(Lr, { type: "text", placeholder: "Authorized By" })
                    }
                  ) }),
                  /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(
                    Dt.Item,
                    {
                      name: "poNumber",
                      rules: [{ required: !0 }, { min: 5 }, { max: 32 }],
                      children: /* @__PURE__ */ E.jsx(
                        Lr,
                        {
                          type: "text",
                          placeholder: "Purchase Order Number"
                        }
                      )
                    }
                  ) })
                ]
              }
            ) }),
            i && /* @__PURE__ */ E.jsxs(Oe, { span: 24, className: "checkout-payment-info-input-container error-boundary flex gap-3", children: [
              /* @__PURE__ */ E.jsx(_l, { size: 22, className: "tooltip-icon" }),
              /* @__PURE__ */ E.jsx(x0, { children: "Please complete the Billing Information section to complete your order." })
            ] })
          ] })
        }
      )
    ] })
  );
});
Lte.displayName = "PaymentMethod";
var kte = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(Ue, function() {
    var r = "minute", n = /[+-]\d\d(?::?\d\d)?/g, a = /([+-]|\d\d)/g;
    return function(i, o, s) {
      var l = o.prototype;
      s.utc = function(g) {
        var y = { date: g, utc: !0, args: arguments };
        return new o(y);
      }, l.utc = function(g) {
        var y = s(this.toDate(), { locale: this.$L, utc: !0 });
        return g ? y.add(this.utcOffset(), r) : y;
      }, l.local = function() {
        return s(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var c = l.parse;
      l.parse = function(g) {
        g.utc && (this.$u = !0), this.$utils().u(g.$offset) || (this.$offset = g.$offset), c.call(this, g);
      };
      var u = l.init;
      l.init = function() {
        if (this.$u) {
          var g = this.$d;
          this.$y = g.getUTCFullYear(), this.$M = g.getUTCMonth(), this.$D = g.getUTCDate(), this.$W = g.getUTCDay(), this.$H = g.getUTCHours(), this.$m = g.getUTCMinutes(), this.$s = g.getUTCSeconds(), this.$ms = g.getUTCMilliseconds();
        } else u.call(this);
      };
      var d = l.utcOffset;
      l.utcOffset = function(g, y) {
        var S = this.$utils().u;
        if (S(g)) return this.$u ? 0 : S(this.$offset) ? d.call(this) : this.$offset;
        if (typeof g == "string" && (g = function($) {
          $ === void 0 && ($ = "");
          var w = $.match(n);
          if (!w) return null;
          var O = ("" + w[0]).match(a) || ["-", 0, 0], T = O[0], I = 60 * +O[1] + +O[2];
          return I === 0 ? 0 : T === "+" ? I : -I;
        }(g), g === null)) return this;
        var x = Math.abs(g) <= 16 ? 60 * g : g, b = this;
        if (y) return b.$offset = x, b.$u = g === 0, b;
        if (g !== 0) {
          var _ = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (b = this.local().add(x + _, r)).$offset = x, b.$x.$localOffset = _;
        } else b = this.utc();
        return b;
      };
      var f = l.format;
      l.format = function(g) {
        var y = g || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return f.call(this, y);
      }, l.valueOf = function() {
        var g = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * g;
      }, l.isUTC = function() {
        return !!this.$u;
      }, l.toISOString = function() {
        return this.toDate().toISOString();
      }, l.toString = function() {
        return this.toDate().toUTCString();
      };
      var m = l.toDate;
      l.toDate = function(g) {
        return g === "s" && this.$offset ? s(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : m.call(this);
      };
      var h = l.diff;
      l.diff = function(g, y, S) {
        if (g && this.$u === g.$u) return h.call(this, g, y, S);
        var x = this.local(), b = s(g).local();
        return h.call(x, b, y, S);
      };
    };
  });
})(kte);
var DZe = kte.exports;
const jZe = /* @__PURE__ */ Ut(DZe);
fn.extend(Ree);
fn.extend(jZe);
fn.extend(wV);
const { Text: Zo } = Gn, LZe = ({
  address: e,
  onLearnMore: t,
  productsWeight: r,
  isEditingShippingInformation: n
}) => {
  const [a, i] = He(!1), [o, s] = He(), { theme: l, screensSize: { isMobileView: c } } = ia(), u = l !== Tr.Default ? `ant-modal--skin--${l}` : "", {
    cartHook: {
      loadingEstimateShipping: d,
      estimateShippingCost: f,
      availableShippingMethods: m,
      localUserCartData: h,
      updateCart: g,
      addressError: y
    },
    exceedsMaxQuantity: S
  } = Cr(Pl), x = `Unfortunately, we are not currently able to ship physical products
  to countries outside the United States of America. You may either
  change the shipping address or remove the physical products from
  your cart to continue.`, b = () => fn.utc().tz("America/Los_Angeles").format("z") === "PDT" ? -7 : -8, _ = () => {
    const T = fn(), I = T.utcOffset();
    return T.subtract(I, "minute");
  }, $ = (T) => {
    const I = fn(T), D = _().subtract(b(), "hour"), B = D.day(), L = D.format("HH:mm"), N = {
      6: 2,
      0: 1
    };
    return B === 5 && L > "11:30" ? I.add(2, "day") : I.add(N[B] || 0, "day");
  };
  xe.useEffect(() => {
    n || (e?.country?.code === "US" ? f(e) : g({ ...h, cartShippingCost: void 0 }));
  }, [e]);
  const w = Bt((T) => {
    const { id: I, cardId: P, ...D } = T.target.value;
    g({ ...h, cartShippingCost: D }), s(T.target.value);
  }, [h, g]);
  xe.useEffect(() => {
    m && m[0] && (g({ ...h, cartShippingCost: m[0] }), s(m[0]));
  }, [m]);
  const O = dr(() => {
    const T = l !== Tr.Default ? `ant-radio-group--skin--${l}` : "";
    return !m || m.length === 0 ? null : /* @__PURE__ */ E.jsx(
      Ba.Group,
      {
        onChange: w,
        value: o,
        className: T,
        children: /* @__PURE__ */ E.jsxs(lr, { direction: "vertical", children: [
          /* @__PURE__ */ E.jsxs(Zo, { className: "underline", children: [
            h?.cartShippingCost && h.cartShippingCost.title,
            h?.cartShippingCost && h?.cartShippingCost.deliveryByTime ? /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
              " ",
              "Delivered by",
              ": ",
              $(h?.cartShippingCost.deliveryByTime).format("MMM D")
            ] }) : null
          ] }),
          m?.map((I, P) => /* @__PURE__ */ E.jsxs(
            Ba,
            {
              value: I,
              className: "text-sm uppercase",
              children: [
                I?.description,
                " ",
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: I?.currencyCode
                }).format(I?.totalCharges)
              ]
            },
            P
          ))
        ] })
      }
    );
  }, [m, w, o, l]);
  return /* @__PURE__ */ E.jsxs(At, { className: "checkout-address-info", children: [
    /* @__PURE__ */ E.jsx(Oe, { span: c ? 24 : 8, children: /* @__PURE__ */ E.jsx(Zo, { className: "text-base text-gray-900 font-medium", children: "Shipping method" }) }),
    S ? /* @__PURE__ */ E.jsx(Oe, { span: c ? 24 : 16, className: "text-sm text-gray-800 font-normal", children: /* @__PURE__ */ E.jsxs(Zo, { className: "pb-3 text-red-500", children: [
      'Please adjust your cart by clicking "Edit" to the right of Order Summary. If you would like to place a bulk order of books, please contact ',
      /* @__PURE__ */ E.jsx("a", { href: "mailto:support@tablegroup.com", children: "support@tablegroup.com" }),
      "."
    ] }) }) : e && e.country?.code === "US" ? /* @__PURE__ */ E.jsxs(Oe, { span: c ? 24 : 16, className: "text-sm text-gray-800 font-normal", children: [
      /* @__PURE__ */ E.jsxs(Zo, { children: [
        "Our deadline for same day shipping is 11:30 AM PST, Monday - Friday. Any orders placed after 11:30 AM will ship the following business day. ",
        /* @__PURE__ */ E.jsx("br", {}),
        " Thank you!"
      ] }),
      /* @__PURE__ */ E.jsx("br", {}),
      /* @__PURE__ */ E.jsxs(Ui, { loading: d, className: "py-3", children: [
        (!m || m.length === 0) && (r > 70 && !y ? /* @__PURE__ */ E.jsxs(Zo, { className: "pb-3 text-red-500", children: [
          "We currently do not support shipments of more than 70lbs in our store. For alternate shipping methods please contact our support team: ",
          /* @__PURE__ */ E.jsx("a", { href: "mailto:support@tablegroup.com", children: "support@tablegroup.com" })
        ] }) : /* @__PURE__ */ E.jsxs(Zo, { className: "pb-3 text-red-500", children: [
          "We are unable to obtain a rate quote for shipping. ",
          /* @__PURE__ */ E.jsx("br", {}),
          y || "Please check if your address is correct or contact the store if no other alternative is shown."
        ] })),
        m && m.length === 1 && /* @__PURE__ */ E.jsx(Zo, { className: "pb-3", children: "This is currently the only shipping method available to use on this order." }),
        O
      ] })
    ] }) : /* @__PURE__ */ E.jsx(Oe, { span: c ? 24 : 16, children: /* @__PURE__ */ E.jsxs(Zo, { className: "text-sm text-red-500 font-normal mb-6", children: [
      x,
      " ",
      /* @__PURE__ */ E.jsx(
        "span",
        {
          className: "text-blue-600 cursor-pointer",
          onClick: () => i(!0),
          children: "Learn More"
        }
      )
    ] }) }),
    /* @__PURE__ */ E.jsxs(
      da,
      {
        open: a,
        centered: !0,
        destroyOnClose: !0,
        width: "480px",
        title: "Checkout process",
        onCancel: () => i(!1),
        footer: null,
        zIndex: 2e3,
        className: u,
        children: [
          /* @__PURE__ */ E.jsxs(Zo, { className: "text-sm text-gray-500 font-normal", children: [
            "Unfortunately, we are not currently able to ship physical products to countries outside the United States of America. To order your product, visit",
            " ",
            /* @__PURE__ */ E.jsx(
              "a",
              {
                rel: "noreferrer",
                href: "https://www.wiley.com/en-ie",
                target: "_blank",
                children: "Wiley"
              }
            ),
            " ",
            "or contact:",
            " "
          ] }),
          /* @__PURE__ */ E.jsxs(lr, { direction: "vertical", className: "block my-4", children: [
            /* @__PURE__ */ E.jsxs(Zo, { className: "text-sm text-gray-500", children: [
              /* @__PURE__ */ E.jsx("span", { className: "font-medium block", children: "John Skinner" }),
              " Sr. Account Representative",
              /* @__PURE__ */ E.jsx("br", {}),
              "John Wiley & Sons, Inc.",
              /* @__PURE__ */ E.jsx("br", {}),
              "317-572-3203 Direct Phon",
              /* @__PURE__ */ E.jsx("br", {}),
              "800-245-6217 Ext 23203",
              /* @__PURE__ */ E.jsx("br", {}),
              "317-572-4203 Fax",
              /* @__PURE__ */ E.jsx("br", {}),
              "jskinner@wiley.com"
            ] }),
            /* @__PURE__ */ E.jsx(
              Nt,
              {
                type: "default",
                className: "mt-2",
                onClick: () => {
                  i(!1), t();
                },
                children: "Change address"
              }
            )
          ] })
        ]
      }
    )
  ] });
}, kZe = ({
  stripePromise: e,
  hasPhysicalProducts: t,
  productsWeight: r,
  user: n,
  onCompleteOrder: a,
  totalInvoice: i,
  loading: o
}) => {
  const s = ct(null), { theme: l, customHooks: { addressHook: c, paymentHook: u } } = ia(), d = l !== Tr.Default ? `ttg-checkout-card--skin--${l}` : "", {
    cartHook: {
      addressError: f,
      updateCart: m,
      localUserCartData: h,
      isFirstTimeWgPurchaser: g,
      loadingCartHook: y,
      availableShippingMethods: S,
      loadingCart: x
    },
    userCartData: b,
    updateUserCartData: _,
    loadingPayment: $,
    setLoadingPayment: w
  } = Cr(Pl), {
    invoicePaymentByCC: O,
    getInvoiceById: T,
    currentInvoice: I,
    isOrderProcessed: P
  } = u, {
    getAddresses: D,
    addresses: B,
    getSelectedAddress: L,
    addressLoading: N
  } = c;
  St(() => {
    I || D();
  }, [D, I]);
  const [z, F] = He(null), [j, H] = He(null), [U, G] = He(i);
  St(() => {
    if (y || N || $ || I) return;
    const Ee = b?.billingAddressId, Te = L(Ee || "");
    Te && F(Te);
  }, [N, I, L, y, $]), St(() => {
    !z || !z?.id || z.id.toString() === b?.billingAddressId || _({ billingAddressId: z?.id?.toString() });
  }, [z, _]), St(() => {
    if (y || N || $ || I) return;
    const Ee = b?.shippingAddressId, Te = L(Ee || "");
    Te && H(Te);
  }, [N, I, L, y, $]), St(() => {
    !j || !j?.id || j.id.toString() === b?.shippingAddressId || I || _({ shippingAddressId: !t && z?.id?.toString() ? z?.id?.toString() : j?.id?.toString() });
  }, [j, _]), St(() => {
    G(i);
  }, [i]), St(() => {
    f && document.getElementById(`address-${t ? j?.id : z?.id}`)?.scrollIntoView({
      behavior: "smooth",
      block: "end"
    });
  }, [f, j?.id, z?.id, t]);
  const { Text: V } = Gn, [K, Z] = xe.useState(!1), [ee, ae] = xe.useState(!1), [ue, re] = xe.useState(!1), [oe, fe] = He(!1), [le, se] = He({ status: !1 }), [Q, he] = He(i === 0), ne = h?.cartItems?.filter((Ee) => Ee?.isPhysical)?.every((Ee) => Ee?.allowIntlOrder) || !1;
  St(() => {
    he(i === 0), i === 0 && fe(!0);
  }, [i]);
  const me = {
    mode: "payment",
    amount: Math.round(U * 100),
    //need to be cartTotal here.
    currency: "usd",
    paymentMethodCreation: "manual",
    appearance: { theme: "stripe" },
    payment_method_types: ["card"]
  }, k = l !== Tr.Default ? `ttg-payment-error-modal--skin--${l}` : "", M = Bt(() => t ? ne && j && j?.country?.code !== "US" ? !0 : !S || S.length === 0 || r > 70 ? !1 : r > 0 ? !f && j && j.country.code === "US" : !f && !!j : !f && z && B && B.length > 0, [
    B,
    z,
    j,
    t,
    r,
    S,
    f
  ]), R = Bt(() => t && B && B?.length > 0, [B, t]), q = Bt((Ee) => {
    let Te = "Something went wrong";
    Ee instanceof tA ? Ee?.response?.status && Ee.response.status >= 400 && Ee.response.status < 500 && (Te = Ee?.response?.data?.message ? Ee.response.data.message : Te) : Te = Ee?.message ? Ee.message : Te, se({ status: !le.status, message: Te });
  }, [le.status]), Y = xe.useCallback(() => {
    w(!0);
    const Ee = async (Te) => Te.then((Le) => T(Le.id)).then((Le) => _({
      cartShippingCost: void 0,
      couponCode: null,
      promoCode: null,
      billingAddressId: null,
      shippingAddressId: null
    })).then(() => {
      m({
        ...h,
        cartItems: [],
        cartShippingCost: void 0,
        promoCode: null,
        invoiceId: null
      });
    }).catch(q).finally(() => {
      w(!1);
    });
    s.current && !Q ? Ee(s.current.handleSubmit()) : (Q || !M()) && b && Ee(O(b.id));
  }, [
    Q,
    T,
    O,
    h,
    q,
    w,
    m,
    _,
    b
  ]), X = () => se({ status: !le.status }), pe = xe.useMemo(
    () => !(ne && j?.country?.code !== "US"),
    [ne, j]
  ), $e = xe.useMemo(() => /* @__PURE__ */ E.jsx(
    Nt,
    {
      type: "primary",
      htmlType: "submit",
      onClick: Y,
      disabled: !M() || !oe,
      loading: $ || x,
      children: "Complete Order"
    }
  ), [M, oe, $, Y, x]), J = (Ee, Te) => {
    Ee === "billing" ? Z(!1) : ae(!1), Ee === "billing" ? F({ ...Te }) : H({ ...Te });
    const Le = Ee === "billing" ? { billingAddressId: `${Te?.id}` } : { shippingAddressId: `${Te?.id}` };
    !t && Ee === "billing" && (Le.shippingAddressId = `${Te?.id}`), _({ ...Le, cartShippingCost: h.cartShippingCost });
  }, de = (Ee, Te) => {
    Ee === "billing" ? Z(!1) : ae(!1), Ee === "billing" ? F({ ...Te }) : H({ ...Te });
  }, Se = (Ee) => /* @__PURE__ */ E.jsxs(At, { justify: "center", className: `ttg-payment-error-modal ${k}`, gutter: [0, 16], children: [
    /* @__PURE__ */ E.jsx(Oe, { children: /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "ttg-payment-error-modal-icon-container", children: /* @__PURE__ */ E.jsx(YW, { className: "ttg-payment-error-modal-icon", size: 24 }) }) }),
    /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsxs(At, { gutter: [0, 4], children: [
      /* @__PURE__ */ E.jsx(Oe, { span: 24, className: "ttg-payment-error-modal-title", children: /* @__PURE__ */ E.jsx(V, { children: "Order not completed" }) }),
      /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(V, { className: "ttg-payment-error-modal-subtitle", children: Ee || "Something went wrong. Please try again later." }) })
    ] }) })
  ] });
  return I ? /* @__PURE__ */ E.jsx(RZe, { isFirstTimeWgPurchaser: g, onCompleteOrder: a }) : /* @__PURE__ */ E.jsxs(zn, { title: "Checkout", className: `ttg-checkout-card ${d}`, actions: [$e], children: [
    /* @__PURE__ */ E.jsx(At, { className: "content", children: /* @__PURE__ */ E.jsxs(Ui, { loading: o || P === !1, className: "py-3", children: [
      /* @__PURE__ */ E.jsx(Oe, { span: 24, children: K ? /* @__PURE__ */ E.jsx(
        xF,
        {
          title: "Billing Information",
          addresses: B,
          type: "billing",
          setAddress: J,
          onClose: de,
          onNewAddressCreated: (Ee) => F(Ee),
          hasShippingAddress: R()
        }
      ) : /* @__PURE__ */ E.jsx(
        SF,
        {
          title: "Billing Information",
          address: z,
          onChange: z || B && B?.length > 0 ? () => Z(!0) : () => re(!0),
          hasAlternateAddress: B && B?.length > 0 || !1
        }
      ) }),
      R() && /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
        /* @__PURE__ */ E.jsx(Oe, { span: 24, children: ee ? /* @__PURE__ */ E.jsx(
          xF,
          {
            title: "Shipping Information",
            addresses: B,
            type: "shipping",
            setAddress: J,
            onClose: de,
            onNewAddressCreated: (Ee) => H(Ee),
            hasShippingAddress: R()
          }
        ) : /* @__PURE__ */ E.jsx(
          SF,
          {
            highlighted: !!f,
            title: "Shipping Information",
            address: j,
            onChange: () => ae(!0),
            hasAlternateAddress: B && B?.length > 0 || !1
          }
        ) }),
        !o && j && !N && pe && /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(
          LZe,
          {
            productsWeight: r,
            address: j,
            onLearnMore: () => ae(!0),
            isEditingShippingInformation: ee
          }
        ) })
      ] }),
      !Q && /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(Rte, { stripe: e, options: me, children: /* @__PURE__ */ E.jsx(
        Lte,
        {
          user: n,
          cartTotal: U,
          disabled: !M(),
          onPaymentValidationForm: (Ee) => fe(Ee),
          ref: s,
          onPaymentClick: Y,
          showAddressError: !(z && B && B.length > 0)
        }
      ) }) })
    ] }) }),
    ue && /* @__PURE__ */ E.jsx(
      jte,
      {
        open: ue,
        address: null,
        onCancel: () => re(!1),
        onNewAddressCreated: (Ee) => F(Ee)
      }
    ),
    /* @__PURE__ */ E.jsx(
      da,
      {
        open: le.status,
        footer: null,
        closeIcon: !0,
        onCancel: X,
        centered: !0,
        width: "348px",
        zIndex: 2200,
        children: Se(le.message)
      }
    )
  ] });
}, FZe = ({ setCoupon: e }) => {
  const { services: t } = ia(), { getCouponById: r } = qWe(t), [n] = Dt.useForm(), { useWatch: a } = Dt, i = a("promotionalCode", n), { userCartData: o, updateUserCartData: s, cartHook: { localUserCartData: l } } = Cr(Pl), [c, u] = He(!1), [d, f] = He({}), [m, h] = He(null), g = Bt((_, $, w) => {
    const O = _ && w?.id || null;
    e(w), u(_), f($), s({ couponCode: O, cartShippingCost: l.cartShippingCost });
  }, [l.cartShippingCost, e, s]), y = Bt(({ promotionalCode: _ }, $ = !1) => r(_).then((w) => (g(
    !0,
    {
      text: "Congratulations! You have redeemed the Discount Coupon!",
      type: "success"
    },
    w
  ), !0)).catch((w) => {
    if ($)
      return g(!1, {}), !1;
    let O = "Coupon is not valid!";
    return w?.response?.status && w.response.status >= 400 && w.response.status < 500 && (O = w?.response?.data?.message ? w.response.data.message : O), g(!1, { text: O, type: "error" }), !1;
  }), [r, g]);
  St(() => {
    if (!o || !o?.couponCode && !o.promoCode) return;
    const _ = o.cartItems?.some((O) => !!O.bulkDiscountId), $ = !_ && !!o?.promoCode, w = _ ? null : $ ? o?.promoCode : o?.couponCode;
    if (!w) return h({
      couponCode: w,
      hasPromoXItemApplied: _ && !!o?.promoCode,
      isPromoCode: $
    });
    h({
      couponCode: w,
      hasPromoXItemApplied: _ && !!o?.promoCode,
      isPromoCode: $
    });
  }, [o?.promoCode]), St(() => {
    if (m) {
      if (!m?.couponCode || m.hasPromoXItemApplied) return S();
      y({ promotionalCode: m.couponCode }, m.isPromoCode).then((_) => {
        if (_) return n.setFieldsValue({ promotionalCode: m.couponCode });
      });
    }
  }, [m]);
  const S = () => {
    n.resetFields(), g(!1, {});
  }, x = (_) => c ? S() : y(_), b = (_) => {
    !c && d && f({});
    const $ = _.target.value;
    n.setFieldValue("promotionalCode", $.toUpperCase());
  };
  return /* @__PURE__ */ E.jsx(
    Dt,
    {
      form: n,
      onFinish: x,
      className: "border-t-2 border-gray-200 pt-3 pb-5",
      children: /* @__PURE__ */ E.jsxs(At, { gutter: [16, 16], justify: "space-between", align: "bottom", children: [
        /* @__PURE__ */ E.jsx(Oe, { span: 16, children: /* @__PURE__ */ E.jsx(
          Dt.Item,
          {
            label: "Promotional Code",
            name: "promotionalCode",
            labelCol: { span: 24 },
            tooltip: {
              title: "Promotion codes are used to redeem special offers. In order to redeem your special offer, simply enter your Promotion Code in the box provided. All offers will be applied upon checking out.",
              icon: /* @__PURE__ */ E.jsx(_l, { className: "tooltip-icon", size: 22 })
            },
            children: /* @__PURE__ */ E.jsx(
              Lr,
              {
                disabled: c || m?.hasPromoXItemApplied,
                onChange: b,
                placeholder: "Promotional Code"
              }
            )
          }
        ) }),
        c ? /* @__PURE__ */ E.jsx(Oe, { span: 8, className: "mb-1", children: /* @__PURE__ */ E.jsx(Nt, { disabled: m?.hasPromoXItemApplied || m?.isPromoCode, type: "primary", htmlType: "submit", className: "uppercase", children: "Remove" }) }) : /* @__PURE__ */ E.jsx(Oe, { span: 8, className: "mb-1", children: /* @__PURE__ */ E.jsx(
          Nt,
          {
            disabled: !i && !m?.couponCode || m?.hasPromoXItemApplied,
            type: "primary",
            htmlType: "submit",
            className: "uppercase",
            children: "Redeem"
          }
        ) }),
        d.text && /* @__PURE__ */ E.jsx(
          Oe,
          {
            span: 16,
            className: `promotional-code-validation-message ${d.type === "error" ? "text-red-600" : "text-green-600"}`,
            children: d.text
          }
        ),
        m?.hasPromoXItemApplied && /* @__PURE__ */ E.jsx(
          Oe,
          {
            span: 16,
            className: "promotional-code-validation-message text-green-600",
            children: "Coupons to individual items have been applied."
          }
        )
      ] })
    }
  );
}, { Text: Xo } = Gn, BZe = ({
  cartResults: e,
  couponApplied: t,
  getTotalInvoice: r,
  isCompleted: n = !1
}) => {
  const a = (i) => new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(i);
  return St(() => {
    e && r && r(e.total);
  }, [e, r]), /* @__PURE__ */ E.jsxs(At, { children: [
    /* @__PURE__ */ E.jsxs(Oe, { span: 24, className: "table-footer-row", children: [
      /* @__PURE__ */ E.jsx(Xo, { className: "text-sm leading-5 font-medium", children: "Subtotal" }),
      /* @__PURE__ */ E.jsx(
        Xo,
        {
          className: "flex items-start text-sm leading-5 font-medium mr-1",
          children: a(e.subtotal)
        }
      )
    ] }),
    !!e.shipping && /* @__PURE__ */ E.jsxs(Oe, { span: 24, className: "table-footer-row", children: [
      /* @__PURE__ */ E.jsx(Oe, { span: 16, children: /* @__PURE__ */ E.jsx(Xo, { className: "text-sm leading-5 font-medium", children: `Shipping${n ? ` (${e.shippingTitle})` : ""}` }) }),
      /* @__PURE__ */ E.jsx(
        Xo,
        {
          className: "flex items-start text-sm leading-5 font-medium mr-1",
          children: a(e.shipping)
        }
      )
    ] }),
    !!e.tax && /* @__PURE__ */ E.jsxs(Oe, { span: 24, className: "table-footer-row", children: [
      /* @__PURE__ */ E.jsx(Xo, { className: "text-sm leading-5 font-medium", children: "Tax" }),
      /* @__PURE__ */ E.jsx(
        Xo,
        {
          className: "flex items-start text-sm leading-5 font-medium mr-1",
          children: a(e.tax)
        }
      )
    ] }),
    !n && /* @__PURE__ */ E.jsx(Oe, { span: 24, children: /* @__PURE__ */ E.jsx(FZe, { setCoupon: t }) }),
    !!e.discount && /* @__PURE__ */ E.jsxs(Oe, { span: 24, className: "ttg-cart-order-discount-text table-footer-row", children: [
      /* @__PURE__ */ E.jsx(Xo, { children: `Discount (${e.couponName})` }),
      /* @__PURE__ */ E.jsxs(
        Xo,
        {
          className: "flex items-start mr-1",
          children: [
            "-",
            a(e.discount)
          ]
        }
      )
    ] }),
    /* @__PURE__ */ E.jsxs(Oe, { span: 24, className: "table-footer-row", children: [
      /* @__PURE__ */ E.jsx(Xo, { className: "text-sm leading-5 font-medium", children: "Total" }),
      /* @__PURE__ */ E.jsx(
        Xo,
        {
          className: "flex items-start text-sm leading-5 font-medium mr-1",
          children: a(e.total)
        }
      )
    ] })
  ] });
}, $F = (e) => new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
}).format(e), zZe = [
  {
    title: "",
    dataIndex: "name",
    width: "50%",
    align: "left",
    render: (e) => e.discountMessage ? /* @__PURE__ */ E.jsxs(lr, { direction: "vertical", size: 0, children: [
      /* @__PURE__ */ E.jsx("span", { className: "ttg-cart-order-product-name", children: e.name }),
      /* @__PURE__ */ E.jsx("span", { className: "ttg-cart-order-product-name discount-message", children: e.discountMessage })
    ] }) : /* @__PURE__ */ E.jsx("span", { className: "ttg-cart-order-product-name", children: e.name })
  },
  {
    title: "Unit Price",
    dataIndex: "price",
    width: "20%",
    align: "right",
    className: "vertically-top",
    render: $F
  },
  {
    title: "Qty",
    dataIndex: "quantity",
    width: "10%",
    align: "center",
    className: "vertically-top",
    render: (e) => new Intl.NumberFormat("en-US").format(e)
  },
  {
    title: "Total",
    dataIndex: "total",
    width: "20%",
    align: "right",
    className: "vertically-top",
    render: $F
  }
], HZe = [
  {
    title: "Qty",
    dataIndex: "quantity",
    width: "10%",
    align: "center",
    render: (e) => /* @__PURE__ */ E.jsx("span", { className: "font-medium", children: new Intl.NumberFormat("en-US").format(e) })
  },
  {
    title: "Item",
    dataIndex: "name",
    width: "90%",
    align: "left",
    render: (e) => /* @__PURE__ */ E.jsx("span", { className: "ttg-cart-order-product-name", children: e })
  }
], UXe = [
  {
    id: "",
    zenCartProductId: "",
    stripeProductId: "",
    stripePriceId: "",
    quantity: 22,
    subTotal: 12,
    discountTotal: 21,
    tax: 2,
    total: 1231,
    isPhysical: !0,
    type: "assessment",
    width: 20,
    height: 20,
    length: 12,
    weight: 23,
    name: "Working Genius Certification - November 4 – 8:30 AM – 12:30 PM PT & November 5 – 8:30 AM – 12:30 PM PT (Session #2)",
    tags: "",
    discountMessage: "",
    product: {
      id: "",
      name: "Working Genius Certification - November 4 – 8:30 AM – 12:30 PM PT & November 5 – 8:30 AM – 12:30 PM PT (Session #2)",
      object: "product",
      active: !1,
      attributes: [],
      created: 1,
      description: "description",
      defaultPrice: "25",
      images: [""],
      livemode: !1,
      metadata: {
        meta: "meta",
        type: "physical"
      },
      packageDimensions: {
        height: 23,
        length: 12,
        weight: 32,
        width: 21
      },
      shippable: !1,
      taxCode: "",
      type: "service",
      updated: 0,
      url: ""
    }
  },
  {
    id: "",
    zenCartProductId: "",
    stripeProductId: "",
    stripePriceId: "",
    quantity: 32,
    subTotal: 12,
    discountTotal: 21,
    tax: 2,
    total: 12,
    isPhysical: !1,
    type: "assessment",
    width: 20,
    height: 20,
    length: 12,
    weight: 23,
    name: "Working Genius Certification - November 4 – 8:30 AM – 12:30 PM PT & November 5 – 8:30 AM – 12:30 PM PT (Session #2)",
    tags: "",
    discountMessage: "",
    product: {
      id: "",
      name: "Working Genius Certification - November 4 – 8:30 AM – 12:30 PM PT & November 5 – 8:30 AM – 12:30 PM PT (Session #1)",
      object: "product",
      active: !1,
      attributes: [],
      created: 1,
      description: "description",
      defaultPrice: "32",
      images: [""],
      livemode: !1,
      metadata: {
        meta: "meta",
        type: "assessment"
      },
      packageDimensions: {
        height: 23,
        length: 12,
        weight: 32,
        width: 21
      },
      shippable: !1,
      taxCode: "",
      type: "service",
      updated: 0,
      url: ""
    }
  },
  {
    id: "",
    zenCartProductId: "",
    stripeProductId: "",
    stripePriceId: "",
    quantity: 44,
    subTotal: 12,
    discountTotal: 21,
    tax: 2,
    total: 12,
    isPhysical: !1,
    type: "assessment",
    width: 20,
    height: 20,
    length: 12,
    weight: 23,
    name: "Working Genius Certification - November 4 – 8:30 AM – 12:30 PM PT & November 5 – 8:30 AM – 12:30 PM PT (Session #3)",
    tags: "",
    discountMessage: "",
    product: {
      id: "",
      name: "item",
      object: "product",
      active: !1,
      attributes: [],
      created: 1,
      description: "description",
      defaultPrice: "123",
      images: [""],
      livemode: !1,
      metadata: {
        meta: "meta",
        type: "certification"
      },
      packageDimensions: {
        height: 23,
        length: 12,
        weight: 32,
        width: 21
      },
      shippable: !1,
      taxCode: "",
      type: "service",
      updated: 0,
      url: ""
    }
  },
  {
    id: "",
    zenCartProductId: "",
    stripeProductId: "",
    stripePriceId: "",
    quantity: 11,
    subTotal: 12,
    discountTotal: 21,
    tax: 2,
    total: 12,
    isPhysical: !1,
    type: "assessment",
    width: 20,
    height: 20,
    length: 12,
    weight: 23,
    name: "Working Genius Certification",
    tags: "",
    discountMessage: "",
    product: {
      id: "",
      name: "item",
      object: "product",
      active: !1,
      attributes: [],
      created: 1,
      description: "description",
      defaultPrice: "1000",
      images: [""],
      livemode: !1,
      metadata: {
        meta: "meta",
        type: "team_application_guide"
      },
      packageDimensions: {
        height: 23,
        length: 12,
        weight: 32,
        width: 21
      },
      shippable: !1,
      taxCode: "",
      type: "service",
      updated: 0,
      url: ""
    }
  },
  {
    id: "",
    zenCartProductId: "",
    stripeProductId: "",
    stripePriceId: "",
    quantity: 8,
    subTotal: 12,
    discountTotal: 21,
    tax: 2,
    total: 12,
    isPhysical: !0,
    type: "assessment",
    width: 20,
    height: 20,
    length: 12,
    weight: 23,
    name: "Working Genius Certification - November 4 – 8:30 AM – 12:30 PM PT & November 5 – 8:30 AM – 12:30 PM PT (Session #2)",
    tags: "",
    discountMessage: "",
    product: {
      id: "",
      name: "Working Genius Certification - November 4 – 8:30 AM – 12:30 PM PT & November 5 – 8:30 AM – 12:30 PM PT (Session #2)",
      object: "product",
      active: !1,
      attributes: [],
      created: 1,
      description: "description",
      defaultPrice: "32",
      images: [""],
      livemode: !1,
      metadata: {
        meta: "meta",
        type: "physical"
      },
      packageDimensions: {
        height: 23,
        length: 12,
        weight: 32,
        width: 21
      },
      shippable: !1,
      taxCode: "",
      type: "service",
      updated: 0,
      url: ""
    }
  }
], VZe = ({
  cartItems: e,
  className: t,
  onEditCard: r,
  getTotalInvoice: n
}) => {
  const { theme: a, customHooks: { paymentHook: i } } = ia(), { cartHook: { tax: o, localUserCartData: s } } = Cr(Pl), { calculateInvoiceTotal: l } = qd(), [c, u] = He(), d = a !== Tr.Default ? `ttg-cart-order-summary--skin--${a}` : "", { currentInvoice: f } = i, m = f ? HZe : zZe, h = f ? f.lines?.data.map((_, $) => ({
    key: $,
    quantity: _.quantity,
    name: _.description
  })) : e.map((_, $) => ({
    key: $,
    quantity: _.quantity,
    name: _,
    price: _.price,
    total: _.total
  })), g = () => /* @__PURE__ */ E.jsx(Nt, { type: "link", onClick: r, className: "font-medium", children: "Edit" }), y = Bt(() => ({
    subtotal: (f?.subtotal || 0) / 100,
    shipping: (f?.shippingCost?.amount_total || 0) / 100,
    shippingTitle: f?.metadata?.shippingTitle || "",
    tax: (f?.totalTax || 0) / 100,
    total: (f?.total || 0) / 100,
    couponName: f?.discount?.coupon?.name || "",
    discount: (f?.totalCoupon || 0) / 100
  }), [f]), S = dr(() => {
    if (f) return y();
    const _ = mA(s);
    return l(_, o, c);
  }, [
    f,
    y,
    s,
    l,
    o,
    c
  ]), x = (_) => u(_), b = Bt(() => /* @__PURE__ */ E.jsx(BZe, { cartResults: S, isCompleted: !!f, couponApplied: x, getTotalInvoice: n }), [S, f, n]);
  return /* @__PURE__ */ E.jsxs(
    zn,
    {
      title: "Order Summary",
      extra: !f && g(),
      className: `${t ? `${t} ttg-cart-order-summary ${d}` : `ttg-cart-order-summary ${d}`}`,
      children: [
        f && /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
          /* @__PURE__ */ E.jsxs(At, { justify: "space-between", className: "order-number pt-3", children: [
            /* @__PURE__ */ E.jsx(Oe, { children: "Order Number:" }),
            /* @__PURE__ */ E.jsx(Oe, { children: f.metadata?.zen_cart_order_id || f?.id })
          ] }),
          /* @__PURE__ */ E.jsxs(
            At,
            {
              justify: "space-between",
              className: "order-number border-b-2 border-gray-200 pt-3 pb-4",
              children: [
                /* @__PURE__ */ E.jsx(Oe, { children: "Payment Method:" }),
                /* @__PURE__ */ E.jsx(Oe, { children: f.total === 0 ? "Gift Certificate/Coupon" : f.metadata?.paymentTitle })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ E.jsx(
          zo,
          {
            columns: m,
            dataSource: h,
            pagination: !1,
            footer: b
          }
        )
      ]
    }
  );
}, { Text: GZe } = Gn, Pl = xe.createContext({}), WXe = ({
  stripeKey: e,
  user: t,
  onEditCard: r,
  onCompleteOrder: n,
  cartExpirationDays: a = 5
}) => {
  const i = hA(
    void 0,
    t?.id,
    !0,
    a
  ), {
    localUserCartData: o,
    hasTeamAppGuide: s,
    loadingCartHook: l,
    cartData: c,
    handleCreateCart: u
  } = i, { theme: d, customHooks: { paymentHook: f, addressHook: m } } = ia(), [h, g] = He(!1), [y, S] = He(0), [x, b] = He(!1), [_, $] = He(!1), [w, O] = He(), T = dr(() => lYe(e), [e]), { isQuantityExceedingMax: I } = qd();
  St(() => g(s), [s]), St(() => {
    l || !c || O(c);
  }, [l, c]);
  const P = d !== Tr.Default ? `ttg-cart-checkout-view--skin--${d}` : "", { isLoadingInvoice: D, currentInvoice: B, isOrderProcessed: L } = f, { addressLoading: N } = m, z = dr(() => o?.cartItems || [], [o]);
  St(() => {
    $(!1), z.map((G) => {
      I(G) && $(!0);
    });
  }, [z, I]);
  const F = z.some((G) => G.isPhysical), j = Bt((G) => {
    S(G);
  }, [S]), H = Bt((G) => {
    const V = w && G && { ...w, ...G };
    if (!V || Ote(w, V)) return Promise.resolve(null);
    V.billingAddressId && !V.shippingAddressId && (V.shippingAddressId = V.billingAddressId), V.shippingAddressId || (V.cartShippingCost = void 0), O(V);
    const {
      shippingAddressId: K,
      billingAddressId: Z,
      cartShippingCost: ee,
      couponCode: ae
    } = V;
    return u({
      shippingAddressId: K,
      billingAddressId: Z,
      cartShippingCost: ee,
      couponCode: ae
    });
  }, [u, w]), U = () => /* @__PURE__ */ E.jsx(
    da,
    {
      centered: !0,
      destroyOnClose: !0,
      footer: null,
      title: /* @__PURE__ */ E.jsx("span", { id: "team-app-guide-modal", children: "Notice" }),
      open: h,
      onCancel: () => g(!1),
      children: /* @__PURE__ */ E.jsxs(GZe, { id: "team-app-guide-modal", className: "text-sm text-gray-500 font-normal", children: [
        "You have already purchased Team Application Guide.",
        /* @__PURE__ */ E.jsx("br", {}),
        "If you want to purchase it for someone else, please contact us at",
        /* @__PURE__ */ E.jsx(
          "a",
          {
            href: "mailto:support@workinggenius.com",
            className: "block my-2",
            children: "support@workinggenius.com"
          }
        )
      ] })
    }
  );
  return /* @__PURE__ */ E.jsx(Pl.Provider, { value: {
    cartHook: i,
    userCartData: w,
    updateUserCartData: H,
    loadingPayment: x,
    setLoadingPayment: b,
    exceedsMaxQuantity: _
  }, children: /* @__PURE__ */ E.jsx(At, { id: "checkout-view", className: `ttg-cart-checkout-view  ${P} w-full`, children: /* @__PURE__ */ E.jsx(Oe, { className: "w-full", children: /* @__PURE__ */ E.jsxs(
    Td,
    {
      indicator: /* @__PURE__ */ E.jsx("div", { className: "spin-icon", children: /* @__PURE__ */ E.jsx($Te, {}) }),
      spinning: x || L === !1,
      className: "spin-loading",
      children: [
        /* @__PURE__ */ E.jsx(Ui, { loading: D || l, children: /* @__PURE__ */ E.jsxs(At, { children: [
          /* @__PURE__ */ E.jsx(Oe, { xs: { span: 24, order: 2 }, lg: { span: 14, order: 1 }, children: /* @__PURE__ */ E.jsx(
            kZe,
            {
              user: t,
              stripePromise: T,
              hasPhysicalProducts: F,
              productsWeight: z.reduce((G, V) => G + (V?.weight ?? 0) * V.quantity, 0) / 16,
              onCompleteOrder: n,
              totalInvoice: y,
              loading: N || l
            }
          ) }),
          /* @__PURE__ */ E.jsx(Oe, { xs: { span: 24, order: 1 }, lg: { span: 10, order: 2 }, children: /* @__PURE__ */ E.jsx(
            VZe,
            {
              cartItems: z,
              className: !!B && "ttg-cart-order-summary-completed",
              onEditCard: r,
              getTotalInvoice: j
            }
          ) })
        ] }) }),
        U()
      ]
    }
  ) }) }) });
}, qXe = {
  id: "",
  userId: "",
  cartItems: [
    {
      id: "",
      zenCartProductId: "",
      stripeProductId: "",
      stripePriceId: "",
      quantity: 2,
      subTotal: 12,
      discountTotal: 21,
      tax: 2,
      total: 12,
      isPhysical: !0,
      type: "assessment",
      width: 20,
      height: 20,
      length: 12,
      weight: 23,
      name: "Working Genius Certification - November 4 – 8:30 AM – 12:30 PM PT & November 5 – 8:30 AM – 12:30 PM PT (Session #2)",
      tags: "",
      discountMessage: "",
      product: {
        id: "",
        name: "Working Genius Certification - November 4 – 8:30 AM – 12:30 PM PT & November 5 – 8:30 AM – 12:30 PM PT (Session #2)",
        object: "product",
        active: !1,
        attributes: [],
        created: 1,
        description: "description",
        images: [""],
        livemode: !1,
        metadata: { meta: "meta" },
        packageDimensions: {
          height: 23,
          length: 12,
          weight: 32,
          width: 21
        },
        shippable: !1,
        taxCode: "",
        type: "service",
        updated: 0,
        url: ""
      }
    },
    {
      id: "",
      zenCartProductId: "",
      stripeProductId: "",
      stripePriceId: "",
      quantity: 2,
      subTotal: 12,
      discountTotal: 21,
      tax: 2,
      total: 12,
      isPhysical: !1,
      type: "assessment",
      width: 20,
      height: 20,
      length: 12,
      weight: 23,
      name: "Working Genius Certification - November 4 – 8:30 AM – 12:30 PM PT & November 5 – 8:30 AM – 12:30 PM PT (Session #2)",
      tags: "",
      discountMessage: "",
      product: {
        id: "",
        name: "Working Genius Certification - November 4 – 8:30 AM – 12:30 PM PT & November 5 – 8:30 AM – 12:30 PM PT (Session #1)",
        object: "product",
        active: !1,
        attributes: [],
        created: 1,
        description: "description",
        images: [""],
        livemode: !1,
        metadata: { meta: "meta" },
        packageDimensions: {
          height: 23,
          length: 12,
          weight: 32,
          width: 21
        },
        shippable: !1,
        taxCode: "",
        type: "service",
        updated: 0,
        url: ""
      }
    },
    {
      id: "",
      zenCartProductId: "",
      stripeProductId: "",
      stripePriceId: "",
      quantity: 2,
      subTotal: 12,
      discountTotal: 21,
      tax: 2,
      total: 12,
      isPhysical: !1,
      type: "assessment",
      width: 20,
      height: 20,
      length: 12,
      weight: 23,
      name: "Working Genius Certification - November 4 – 8:30 AM – 12:30 PM PT & November 5 – 8:30 AM – 12:30 PM PT (Session #3)",
      tags: "",
      discountMessage: "",
      product: {
        id: "",
        name: "item",
        object: "product",
        active: !1,
        attributes: [],
        created: 1,
        description: "description",
        images: [""],
        livemode: !1,
        metadata: { meta: "meta" },
        packageDimensions: {
          height: 23,
          length: 12,
          weight: 32,
          width: 21
        },
        shippable: !1,
        taxCode: "",
        type: "service",
        updated: 0,
        url: ""
      }
    },
    {
      id: "",
      zenCartProductId: "",
      stripeProductId: "",
      stripePriceId: "",
      quantity: 2,
      subTotal: 12,
      discountTotal: 21,
      tax: 2,
      total: 12,
      isPhysical: !1,
      type: "assessment",
      width: 20,
      height: 20,
      length: 12,
      weight: 23,
      name: "Working Genius Certification",
      tags: "",
      discountMessage: "",
      product: {
        id: "",
        name: "item",
        object: "product",
        active: !1,
        attributes: [],
        created: 1,
        description: "description",
        images: [""],
        livemode: !1,
        metadata: { meta: "meta" },
        packageDimensions: {
          height: 23,
          length: 12,
          weight: 32,
          width: 21
        },
        shippable: !1,
        taxCode: "",
        type: "service",
        updated: 0,
        url: ""
      }
    }
  ],
  createdAt: /* @__PURE__ */ new Date(),
  updatedAt: /* @__PURE__ */ new Date()
}, KXe = [
  {
    id: "",
    name: "item5",
    object: "product",
    active: !1,
    attributes: [],
    created: 1,
    description: "description",
    images: [""],
    livemode: !1,
    metadata: { meta: "meta" },
    packageDimensions: {
      height: 23,
      length: 12,
      weight: 32,
      width: 21
    },
    shippable: !1,
    taxCode: "",
    type: "service",
    updated: 0,
    url: ""
  },
  {
    id: "",
    name: "item6",
    object: "product",
    active: !1,
    attributes: [],
    created: 1,
    description: "description",
    images: [""],
    livemode: !1,
    metadata: { meta: "meta" },
    packageDimensions: {
      height: 23,
      length: 12,
      weight: 32,
      width: 21
    },
    shippable: !1,
    taxCode: "",
    type: "service",
    updated: 0,
    url: ""
  }
];
export {
  q7e as AccountDetails,
  K7e as AddressDetails,
  rke as AppButton,
  kXe as AppTagsInput,
  Pl as CartContext,
  GXe as CartDetailsView,
  eKe as CartEmptyState,
  VXe as CheckoutProvider,
  WXe as CheckoutView,
  ZTe as ColorGear,
  HXe as DateTimePicker,
  uM as ErrorAlert,
  JZe as ForgotPassword,
  YTe as Icon,
  ETe as Loading,
  XZe as Login,
  BXe as MobileTable,
  jXe as NotFound,
  LXe as P,
  eXe as PaginatedGallery,
  YZe as PublicLayout,
  iC as ReCaptcha,
  Q7e as RegisterFooter,
  QZe as ResetPassword,
  nq as RouteNames,
  oq as SSOButton,
  Mh as SVG,
  ZKe as SidebarCartView,
  Y7e as SignInDetails,
  RXe as SignInWizard,
  ZZe as SortIcon,
  Aee as Span,
  J7e as StepNavigator,
  AXe as SummaryReportPage,
  FXe as TTGTable,
  zXe as TableLoadMore,
  qZe as TestUI,
  Mee as Text,
  NXe as TokenError,
  DXe as TokenHeader,
  PXe as ToolsPage,
  UXe as cartItemsCheckoutMock,
  qXe as cartMock,
  cM as icons,
  HZe as orderCompletedColumns,
  zZe as orderSummaryTableColumns,
  KXe as productsMock,
  ia as useCheckout
};
